/**
 * Created by kosski on 08.09.2016.
 */
+ function () {
  'use strict';
  angular.module('management.services', ['flow', 'filterbox',
    // 'gantt',
    //   'gantt.sortable',
    //   'gantt.movable',
    //   'gantt.drawtask',
    //   'gantt.tooltips',
    //   'gantt.bounds',
    //   'gantt.progress',
    //   'gantt.table',
    //   'gantt.tree',
    //   'gantt.groups',
    //   'gantt.dependencies',
    //   'gantt.overlap',
    //   'gantt.resizeSensor',
    'angularAudioRecorder',
    'consts'
  ]).config(config);

  function config($translatePartialLoaderProvider, $stateProvider, flowFactoryProvider, recorderServiceProvider, consts, MenuItemsProvider) {

    recorderServiceProvider
      .withMp3Conversion(true);

    var menuItems = MenuItemsProvider.initMenuItem('MANAGEMENT')
      .addMenuItem('MANAGEMENT.SERVICE', {
        icon: 'icon-cog-box',
        hide: 'SessionManager.getUserRole() !== "admin"',
        collapse: true,
        component: 'option-folder'
      }).addMenuItem('MANAGEMENT.SERVICE.LIST', {
        state: 'app.contactcenter_management.services.list',
        iconSrc: 'assets/icons/triple-view/glosowe.png'
      }).addMenuItem('MANAGEMENT.SERVICE.PACKETS', {
        state: 'app.contactcenter_management.packets.list',
        iconSrc: 'assets/icons/triple-view/glosowe.png',
        disabled: true
      })
    // var menuItems = {
    //   list: {
    //     name: 'MANAGEMENT.SERVICE.BACK_LIST',
    //     state: 'app.contactcenter_management.services.list',
    //     avatarLetter: 'P',
    //     style: 'wizzard-item'
    //   },
    //   typestep: {
    //     name: 'MANAGEMENT.SERVICE.WIZ.STEPTYPE',
    //     state: 'app.contactcenter_management.services.wizzard.typestep',
    //     hide: 'serviceId>0',
    //     avatarLetter: 'P',
    //     style: 'wizzard-item'
    //   },
    //   partnerstep: {
    //     name: 'MANAGEMENT.SERVICE.WIZ.STEPPARTNER',
    //     state: 'app.contactcenter_management.services.wizzard.partnerstep',
    //     hide: 'SessionManager.getUserRoleId() != authRolesConst.ta || serviceId>0',
    //     avatarLetter: 'P',
    //     style: 'wizzard-item'
    //   },
    //   numberstep: {
    //     name: 'MANAGEMENT.SERVICE.WIZ.STEPNUMBER',
    //     state: 'app.contactcenter_management.services.wizzard.numberstep',
    //     hide: 'serviceId>0',
    //     avatarLetter: 'P',
    //     style: 'wizzard-item'
    //   },
    //   mailstep: {
    //     name: 'MANAGEMENT.SERVICE.WIZ.STEPMAIL',
    //     state: 'app.contactcenter_management.services.wizzard.mailstep',
    //     hide: 'serviceId>0',
    //     avatarLetter: 'P',
    //     style: 'wizzard-item'
    //   },
    //   basicstep: {
    //     name: 'MANAGEMENT.SERVICE.WIZ.STEPBASIC',
    //     state: 'app.contactcenter_management.services.wizzard.basicstep',
    //     style: 'wizzard-item',
    //     avatarLetter: 'P',
    //   },
    //   pointstep: {
    //     name: 'MANAGEMENT.SERVICE.WIZ.STEPPOINT',
    //     state: 'app.contactcenter_management.services.wizzard.pointstep',
    //     style: 'wizzard-item',
    //     avatarLetter: 'P',
    //   },
    //   finalstep: {
    //     name: 'MANAGEMENT.SERVICE.WIZ.STEPFINAL',
    //     state: 'app.contactcenter_management.services.wizzard.finalstep',
    //     style: 'wizzard-item',
    //     avatarLetter: 'P',
    //   },
    //   content: {
    //     name: 'MANAGEMENT.SERVICE.CONTENT',
    //     state: 'app.contactcenter_management.services.wizzard.content',
    //     avatarLetter: 'P',
    //     style: 'wizzard-item'
    //   },
    //   surveys: {
    //     name: 'MANAGEMENT.SERVICE.SURVEYS',
    //     state: 'app.contactcenter_management.services.wizzard.surveys',
    //     hide: 'serviceId<0',
    //     avatarLetter: 'P',
    //     style: 'wizzard-item'
    //   }
    // };
    // var menuItems = MenuItemsProvider.getMenuObj('MANAGEMENT');
    $stateProvider
      .state('app.contactcenter_management.services', {
        parent: 'app.contactcenter_management',
        url: '/services',
        // params: {
        //   keepSearch: true
        //   // startState: function () {
        //   //   return 'app.contactcenter_management.services.list';
        //   // },
        // },
        views: {
          'content@app': {
            template: '<triple-view></triple-view>'
          }
        }
      }).state(menuItems.getMenuItem('MANAGEMENT.SERVICE.LIST').state, {
        url: '/list',
        parent: 'app.contactcenter_management.services',
        statePanelRight: true,
        stateTranslationName: 'MANAGEMENT.SERVICE',
        // params: {
        //   serviceType: null,
        //   serviceId: null
        // },
        views: {
          'sidenav@app.contactcenter_management.services': {
            template: '<services-list></services-list>'
          },
        }
      })
      .state( menuItems.getMenuItem('MANAGEMENT.SERVICE.LIST').state + '.card', {
        url: '/card/:serviceType/:serviceId',
        parent: menuItems.getMenuItem('MANAGEMENT.SERVICE.LIST').state,
        // parent: 'app.contactcenter_management.services',

        // redirectTo: menuItems.typestep.state,
        stateTranslationName: 'MANAGEMENT.SERVICE.CARD',
        params: {
          serviceType: null,
          serviceId: null,
          wizzard: false
        },
        views: {
          'mainContent@app.contactcenter_management.services': {
            template: '<service-card flex> </service-card>'
          }
        }
      })
      .state('app.contactcenter_management.services.wizzard', {
        url: '/wizzard/:serviceType/:serviceId',
        parent: menuItems.getMenuItem('MANAGEMENT.SERVICE.LIST').state,

        // redirectTo: menuItems.typestep.state,
        stateTranslationName: 'MANAGEMENT.SERVICE.WIZ',
        params: {
          startState: function () {
            return 'app.contactcenter_management.services.list';
          },
          doNotShowSidepanel: true
        },
        views: {
          'mainContent@app.contactcenter_management.services': {
            template: '<simple-wizzard flex> </simple-wizzard>'
          }
        }
      })
      .state('app.contactcenter_management.services.list.content', {
        // parent: 'app.contactcenter_management.services.wizzard',
        parent: menuItems.getMenuItem('MANAGEMENT.SERVICE.LIST').state,

        url: '/content/:serviceId',
        stateTranslationName: 'MANAGEMENT.SERVICE.CONTENT',
        statePanelRight: true,
        resolve: {
          contentId: ['$stateParams', function ($stateParams) {
            return $stateParams.serviceId;
          }]
        },
        views: {
          'mainContent@app.contactcenter_management.services': {
            template: '<ta-content flex="100" content-id="$resolve.contentId" content-type="2" content-url="' + consts.serviceContent + '" ng-cloak></ta-content>'
          }
        }
      });
    // .state(menuItems.typestep.state, {
    //   // parent: 'app.contactcenter_management.services.wizzard',
    //   url: '/type',
    //   stateTranslationName: menuItems.typestep.name,
    //   views: {
    //     'mainContent@app.contactcenter_management.services.services': {
    //       template: '<step-type> </step-type>'
    //     }
    //   }
    // }).state(menuItems.partnerstep.state, {
    //   // parent: 'app.contactcenter_management.services',
    //   url: '/partner',
    //   stateTranslationName: menuItems.partnerstep.name,
    //   views: {
    //     'mainContent@app.contactcenter_management.services.services': {
    //       template: '<step-partner> </step-partner>'
    //     }
    //   }
    // }).state(menuItems.numberstep.state, {
    //   // parent: 'app.contactcenter_management.services',
    //   url: '/number',
    //   stateTranslationName: menuItems.numberstep.name,
    //   views: {
    //     'mainContent@app.contactcenter_management.services.services': {
    //       template: '<step-number> </step-number>'
    //     }
    //   }
    // }).state(menuItems.mailstep.state, {
    //   // parent: 'app.contactcenter_management.services',
    //   url: '/mail',
    //   stateTranslationName: menuItems.mailstep.name,
    //   views: {
    //     'mainContent@app.contactcenter_management.services.services': {
    //       template: '<step-mail> </step-mail>'
    //     }
    //   }
    // }).state(menuItems.pointstep.state, {
    //   // parent: 'app.contactcenter_management.services',
    //   url: '/point',
    //   stateTranslationName: menuItems.pointstep.name,
    //   views: {
    //     'mainContent@app.contactcenter_management.services.services': {
    //       template: '<step-point> </step-point>'
    //     }
    //   }
    // }).state(menuItems.basicstep.state, {
    //   // parent: 'app.contactcenter_management.services',
    //   url: '/basic',
    //   stateTranslationName: menuItems.basicstep.name,
    //   views: {
    //     'mainContent@app.contactcenter_management.services.services': {
    //       template: '<step-basic> </step-basic>'
    //     }
    //   }
    // }).state(menuItems.finalstep.state, {
    //   // parent: 'app.contactcenter_management.services',
    //   url: '/final',
    //   stateTranslationName: menuItems.finalstep.name,
    //   views: {
    //     'mainContent@app.contactcenter_management.services.services': {
    //       template: '<step-final> </step-final>'
    //     }
    //   }
    // }).state(menuItems.content.state, {
    //   // parent: 'app.contactcenter_management.services.wizzard',
    //   url: '/content',
    //   stateTranslationName: menuItems.content.name,
    //   statePanelRight: true,
    //   resolve: {
    //     contentId: ['$stateParams', function ($stateParams) {
    //       return $stateParams.serviceId;
    //     }]
    //   },
    //   views: {
    //     'mainContent@app.contactcenter_management.services.services': {
    //       template: '<ta-content flex="100" content-id="$resolve.contentId" content-type="2" content-url="' + consts.serviceContent + '" ng-cloak></ta-content>'
    //     }
    //   }
    // }).state(menuItems.surveys.state, {
    //   // parent: 'app.contactcenter_management.services.wizzard',
    //   url: '/surveys',
    //   stateTranslationName: menuItems.content.name,
    //   statePanelRight: true,
    //   views: {
    //     'mainContent@app.contactcenter_management.services.services': {
    //       template: '<survey-step flex="100" ng-cloak></survey-step>'
    //     }
    //   }
    // })
    // .state('app.contactcenter_management.services.wizzard.surveys.edit', {
    //   // parent: 'app.contactcenter_management.services.wizzard',
    //   url: '/edit',
    //   params: {
    //     survey: null,
    //   },
    //   stateTranslationName: menuItems.content.name,
    //   statePanelRight: true,
    //   views: {
    //     'mainContent@app.contactcenter_management.services.services': {
    //       template: '<survey-edit flex="100" survey="$root.state.params.survey" ng-cloak></survey-edit>'
    //     }
    //   }
    // });


    flowFactoryProvider.defaults = {
      permanentErrors: [500, 501],
      maxChunkRetries: 3,
      chunkRetryInterval: 5000,
      simultaneousUploads: 4
    };
  }
}();

/**
 * Created by kosski on 23.08.2016.
 */
+ function () {
  'use strict';

  angular.module('management.services').component('templateConfig', {
    templateUrl: 'app/main/contactcenter/management/services/component/simplewizzard/components/templateconfig/templateconfig.html',
    require: {
      simpleWizzard: '^^simpleWizzard'
    },
    bindings: {
      choosenTemplate: '<'
      // ,
      // dataLoading:'='
    },
    controllerAs: 'vm',
    controller: controller
  });

  /** @ngInject */
  function controller(DynamicFactory, wizzardService, toastService, $translate) {
    var vm = this;

    vm.defaultFieldClick = defaultFieldClick;
    vm.$onChanges = onChanges;
    vm.$postLink = postLink;
    vm.$onInit = onInit;


    function onInit() {
      vm.specialFields = [];
    }

    function postLink() {
      vm.service = wizzardService.service;
      if (vm.service.serviceID) {
        vm.service.slotsData = JSON.parse(vm.service.applicationString);
        getServiceTemplate(vm.service.templateId);
      }
    }

    function onChanges(changesObj) {
      if (changesObj.choosenTemplate.currentValue && vm.service) {
        vm.dataLoading = true;
        // DynamicFactory.get('servicesRsc', 'GetTemplate')(changesObj.choosenTemplate.currentValue.id).then(function (result) {
        //   vm.templateSource = JSON.parse(result.template);
        //   vm.service.slotsData = angular.copy(vm.templateSource);
        //   buildDynamicForm();
        // }, error);
        getServiceTemplate(changesObj.choosenTemplate.currentValue.id);
      }
    }

    function getServiceTemplate(templateId) {
      DynamicFactory.get('servicesRsc', 'GetTemplate')(templateId).then(function (result) {
        vm.templateSource = JSON.parse(result.template);
        // vm.service.slotsData = angular.copy(vm.templateSource);
        buildDynamicForm();
      }, error);
    }

    function buildDynamicForm() {
      var formConfig = buildConfigForm(vm.templateSource);

      if (vm.service.slotsData) {
        prepareEditedConfig(formConfig);
      } else {
        prepareConfigFields(formConfig);
      }

      _.remove(formConfig, function (item) {
        return item.templateKey.indexOf('new-guid') != -1 || item.templateKey == 'data' || (item.disabledOnEdit == 'hide' && vm.service.serviceID);
      });
      vm.stepConfigs = _.filter(formConfig, function (item) {
        return item.isStep;
      });
      vm.formConfig = _.filter(formConfig, function (item) {
        return !item.isOptional && !item.isStep;
      });
      vm.optionalFormConfig = _.filter(formConfig, function (item) {
        return item.isOptional && !item.isStep;
      });
      console.log('templateConfig | formConfig', vm.formConfig);
      console.log('templateConfig | serviceConfig', vm.service.slotsData);
      // formConfig;

      //   {
      //     "templateKey": "ta-text",
      //     "label": "Czy lubisz placki?",
      //     "fieldId": 1,
      //     "order": 0
      // }

    }

    function prepareEditedConfig(formConfig) {
      formConfig.forEach(function (item) {
        if (item.isOptional) {
          if (getConfigValue(item.fieldId) === item.defaultValue)
            item.hide = true;
        }
        if (item.templateKey.indexOf('new-guid') != -1) {
          var guidValue = getConfigValue(item.fieldId)
          if (isGuid(guidValue)) {
            vm.lastGuid = guidValue;
          }
        }
        if (item.isStep) {
          item.actionGuid = vm.lastGuid;
        }
        if (item.notInConfig) {
          deleteConfigValue(item.fieldId);
        }
      });
    }

    function isGuid(value) {
      var match = value.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i);
      return match != undefined;
    }

    function prepareConfigFields(formConfig) {
      vm.service.slotsData = angular.copy(vm.templateSource);
      formConfig.forEach(function (item) {
        if (item.templateKey == 'data') {
          replaceConfigValue(item.fieldId, vm.service[item.label]);
        } else if (item.templateKey.indexOf('new-guid') != -1) {
          if (item.templateKey[0] != '^') {
            vm.lastGuid = guidGenerator();
          }
          replaceConfigValue(item.fieldId, getConfigValue(item.fieldId).replace(/<(\^?new-guid)>/ig, vm.lastGuid));
        } else {
          if (item.isOptional) {
            item.hide = true;
          }
          if (item.isStep) {
            item.actionGuid = vm.lastGuid;
          }
          if (item.notInConfig) {
            deleteConfigValue(item.fieldId);
          } else {
            replaceConfigValue(item.fieldId, item.defaultValue ? item.defaultValue : '');
          }
        }
      });
    }

    function getConfigValue(path) {
      var schema = vm.service.slotsData; // a moving reference to internal objects within obj
      var pList = path.replace(/\[(\w+)\]/g, '.$1').split('.');
      var len = pList.length;
      for (var i = 0; i < len - 1; i++) {
        var elem = pList[i];
        if (!schema[elem]) schema[elem] = {};
        schema = schema[elem];
      }
      return schema[pList[len - 1]];
    }

    function replaceConfigValue(path, value) {
      var schema = vm.service.slotsData; // a moving reference to internal objects within obj
      var pList = path.replace(/\[(\w+)\]/g, '.$1').split('.');
      var len = pList.length;
      for (var i = 0; i < len - 1; i++) {
        var elem = pList[i];
        if (!schema[elem]) schema[elem] = {};
        schema = schema[elem];
      }

      schema[pList[len - 1]] = value;
    }

    function deleteConfigValue(path) {
      var schema = vm.service.slotsData; // a moving reference to internal objects within obj
      var pList = path.replace(/\[(\w+)\]/g, '.$1').split('.');
      var len = pList.length;
      for (var i = 0; i < len - 1; i++) {
        var elem = pList[i];
        if (!schema[elem]) schema[elem] = {};
        schema = schema[elem];
      }

      delete schema[pList[len - 1]];
    }

    function buildConfigForm(context, contextPath) {
      var paramsArray = [];
      for (var key in context) {
        if (context[key]) {
          var element = context[key];
          if (angular.isString(element)) {
            var newControl = buildControl((contextPath ? contextPath + '.' : '') + key, element);
            if (newControl) {
              paramsArray.push(newControl);
            }
          } else if (angular.isObject(element)) {
            if (angular.isArray(element)) {
              element.forEach(function (elementItem, index) {
                paramsArray = paramsArray.concat(
                  buildConfigForm(elementItem, (contextPath ? contextPath + '.' : '') + key + '[' + index + ']')
                );
              });
            } else {
              paramsArray = paramsArray.concat(buildConfigForm(element, (contextPath ? contextPath : '') + '.' + key));
            }
          }
        }
      }
      return paramsArray;
    }

    function buildControl(key, element) {
      // var paramsArray = [];
      // for(var key in context){
      //   var element = context[key];
      //   if(element && angular.isString(element)){
      var detector = element.match(/<(.*)>/gi);
      if (detector && detector.length > 0) {
        // var templateKey = element.match(/[\<](.*)[\:]/gi)[0];
        var templateKey = element.match(/(?:<)(.*?)(?:\:(?!>)|>)/gi);
        var isStep;
        var notInConfig;
        var disabledOnEdit;
        if (templateKey) {
          templateKey = templateKey[0].substring(1, templateKey[0].length - 1);
          if (templateKey.indexOf('\@') !== -1) {
            templateKey = templateKey.replace('\@', '');
            isStep = true;
          }
          if (templateKey.indexOf('!') !== -1) {
            templateKey = templateKey.replace('!', '');
            notInConfig = true;
          }
          if (templateKey.indexOf('#') !== -1) {
            templateKey = templateKey.replace('#', '');
            if (templateKey.indexOf('#') !== -1) {
              templateKey = templateKey.replace('#', '');
              disabledOnEdit = 'hide';
            } else {
              disabledOnEdit = 'disabled';
            }
          }
        }
        // if(!templateKey){
        //   templateKey = element.match(/<(.*)>/gi);
        // }
        var label = element.match(/:(.*?)(?:\:(?!>)|>)/gi);

        var optional = element.match(/<(.*):(.*):(.*)>/gi);
        var defaultValue;
        if (optional && optional.length > 0) {
          defaultValue = element.match(/(?!.*:(?!\/\/))(.*)(?=>)/gi);
          if (defaultValue[0] == '*') {
            defaultValue[0] = '';
          }

        }
        return {
          templateKey: templateKey ? templateKey : undefined,
          label: label ? label[0].substring(1, label[0].length - 1) : undefined,
          fieldId: key,
          defaultValue: optional ? defaultValue[0] : undefined,
          isOptional: optional ? true : false,
          isStep: isStep,
          notInConfig: notInConfig,
          disabledOnEdit: disabledOnEdit
        };
      }
      //   }
      // }
      // return paramsArray;
    }

    function defaultFieldClick(item) {
      item.hide = !item.hide;
      if (!item.hide) {
        replaceConfigValue(item.fieldId, item.defaultValue ? item.defaultValue : '');
      }
    }

    // function getTemplate() {
    //   DynamicFactory.get('servicesRsc', 'GetTemplateList')().then(function (result) {
    //     vm.templateList = result;
    //   }, error);
    // }

    // function setLoading(isLoading){
    //   if( vm.dataLoading){

    //   }
    // }

    function S4() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }

    function guidGenerator() {
      var guid = (S4() + S4() + '-' + S4() + '-4' + S4().substr(0, 3) + '-' + S4() + '-' + S4() + S4() + S4()).toLowerCase();
      return guid;
    }

    function error(err) {
      toastService.showToast($translate.instant('COMMON.ERROR'), 'error', 4);
    }

  }
}();

/**
 * Created by kosski on 23.08.2016.
 */
+ function () {
  'use strict';

  angular.module('management.services').component('stepType', {
    templateUrl: 'app/main/contactcenter/management/services/component/simplewizzard/components/steptype/steptype.html',
    require: {
      // tripleView: '^tripleView'
      simpleWizzard: '^^simpleWizzard'
    },
    bindings: {
      // service: '=',
      // partners: '<',
      // onUpdate: '&'
      lockTypeChoose:'=',
      typeObj:'='
    },
    controllerAs: 'vm',
    controller: controller
  });

  /** @ngInject */
  function controller(DynamicFactory,  wizzardService, SessionManager, authRolesConst) {
    var vm = this;

    // vm.createFilterFor = createFilterFor;
    // vm.updateBrigeFn = updateBrigeFn;
    vm.selectServiceType = selectServiceType;
    vm.coloredSelectedType = coloredSelectedType;
    // vm.getDisabledKeySteps = getDisabledKeySteps;
    vm.$postLink = postLink;
    vm.$onInit = onInit;
    // function doCheck() {
    //   if (vm.service && !angular.equals(wizzardService.service, vm.service)) {
    //     wizzardService.service = vm.service;
    //   }
    // }

    function onInit() {
      vm.partnerData = [];
      // vm.simulateQuery = false;
      // vm.parentScope = $scope.$parent;
      // vm.servicesType = [];
      // vm.searchText = '';
      // vm.service = {};
      vm.userSession = SessionManager.getUser();

      vm.service = wizzardService.service;
      // vm.$doCheck = doCheck;

      // vm.tripleView.overrideRole(wizzardService.setMenuWizzard());

      DynamicFactory.get('servicesRsc', 'getServiceTypes')().then(function (s) {
        vm.servicesType = s;
        if(vm.service.type){
          vm.typeObj = _.find(vm.servicesType,{type: vm.service.type});
        }
      });

      // vm.tripleView.addMenuItem({
      //   order: 1,
      //   name: 'Dalej',
      //   // icon: 'icon-arrow-right-bold-circle',
      //   // iconSrc: 'assets/icons/triple-view/zapisz.png',
      //   iconSrc:'assets/icons/triple-view/dalej.png',

      //   // unremovable: true,
      //   func: function () {
      //     if (vm.service.type !== undefined) {
      //       if (SessionManager.getUserRoleId() === authRolesConst.ta) {
      //         vm.tripleView.changeState('app.contactcenter_management.services.wizzard.partnerstep');
      //       }
      //       else {
      //         switch (vm.service.type) {
      //           case 'S':
      //             vm.tripleView.changeState('app.contactcenter_management.services.wizzard.numberstep');
      //             break;
      //           case 'I':
      //             vm.tripleView.changeState('app.contactcenter_management.services.wizzard.numberstep');
      //             break;
      //           case 'E':
      //             vm.tripleView.changeState('app.contactcenter_management.services.wizzard.mailstep');
      //             break;
      //           case 'C':
      //             vm.tripleView.changeState('app.contactcenter_management.services.wizzard.basicstep');
      //             break;
      //         }
      //       }
      //     }
      //     else {
      //       toastService.showToast($translate.instant('MANAGEMENT.SERVICE.WIZ.STEPTYPE.CHOOSE_TYPE_SERVICE'), 'error', 4);
      //     }
      //   }
      // });
      // vm.tripleView.setStepControl({
      //   'basicstep':{ disabled: vm.getDisabledKeySteps() },
      //   'finalstep':{ disabled: vm.getDisabledKeySteps() },
      //   'partnerstep':{ disabled: ((wizzardService.service === null || wizzardService.service.type === null)) },
      //   'numberstep':{ hide: ((wizzardService.service === null || wizzardService.service.type === null) || (wizzardService.service && wizzardService.service.type !== 'C' && wizzardService.service.type !== 'I')) },
      //   'mailstep':{ hide: ((wizzardService.service === null || wizzardService.service.type === null) || (wizzardService.service && wizzardService.service.type !== 'E')) }
      // });
    }

    function postLink() {
      // if (!$state.params.serviceId) {
      //   if (wizzardService.service === null) {
      //     wizzardService.service = {};
      //   }
      //   // else{
      //   //   wizzardService.service.serviceID = undefined;
      //   // }
      // }
      vm.service = wizzardService.service;
    }

    // function getDisabledKeySteps() {
    //   var disabled = ((wizzardService.service === null || wizzardService.service.type === null) ||
    //     ((wizzardService.service !== null && !wizzardService.service.premiumNumber)));
    //   return disabled;
    // }

    function setPartnerService() {
      if (SessionManager.getUserRoleId() === authRolesConst.admin && vm.service !== undefined && vm.service.servicePartnerID === undefined) {
        vm.service.servicePartnerID = vm.userSession.partnerId;
      }
    }

    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(item) {
        return (angular.lowercase(item.companyName).match(new RegExp(lowercaseQuery, 'g')) !== null);
      };
    }

    // function updateBrigeFn(valid) {
    //   if (vm.service.hasOwnProperty('serviceID')) {
    //     vm.onUpdate();
    //   } else {
    //     if (valid) {
    //       vm.onUpdate();
    //     }
    //   }
    // }

    function selectServiceType() {
      console.log('stepType |',vm.service.type);
      if(vm.service.type){
        vm.typeObj = _.find(vm.servicesType,{type: vm.service.type});
      }
      // vm.service.type = serviceType.type;
      // vm.service.typename = serviceType.name;
      wizzardService.clearKeyData();
      setPartnerService();
      setMenuWizzard();
    }

    function setMenuWizzard() {
      vm.simpleWizzard.setMenuWizzard();
    }

    function coloredSelectedType(serviceType) {
      if (vm.service !== null && vm.service !== undefined && vm.service.type !== undefined) {
        if (serviceType.type === vm.service.type) {
          return 'selected-type';
        } else {
          return 'not-selected';
        }
      }
    }
  }
}();

/**
 * Created by kosski on 23.08.2016.
 */
+function () {
  'use strict';
  angular.module('management.services').component('stepNumber', {
    templateUrl: 'app/main/contactcenter/management/services/component/simplewizzard/components/stepnumber/stepnumber.html',
    controllerAs: 'vm',
    require: {
      // tripleView: '^tripleView'
      simpleWizzard: '^^simpleWizzard'
    },
    bindings: {
      // service: '=',
      // onUpdate: '&'
      conf:'='
    },
    controller: controller
  });


  /** @ngInject */
  function controller(DynamicFactory, wizzardService) {
    var vm = this;
    vm.wizzardService = wizzardService;
    vm.setNumber = setNumber;
    // vm.$doCheck = doCheck;
    vm.$onInit = onInit;


    // function doCheck() {

    //   if (vm.service && !angular.equals(wizzardService.service, vm.service)) {
    //     wizzardService.service = vm.service;
    //   }
    // }

    function onInit() {
      vm.service = wizzardService.service;
      console.log('init - stepNumber - wizzardService: ', wizzardService.service);

      vm.numerListModel = {};
      vm.numerListModel.partnerId = vm.service.servicePartnerID;
      vm.numerListModel.serviceType = vm.service.type;
      vm.conf.minifiedValue = vm.service.premiumNumber;
      // vm.tripleView.overrideRole(wizzardService.setMenuWizzard());

      // vm.tripleView.addMenuItem({
      //   order: 20,
      //   name: 'Dalej',
      //   // icon: 'icon-arrow-right-bold-circle',
      //   iconSrc:'assets/icons/triple-view/dalej.png',
      //   // unremovable: true,
      //   func: function () {
      //     if (vm.service.premiumNumber === undefined) {
      //       toastService.showToast($translate.instant('MANAGEMENT.SERVICE.WIZ.STEPNUMBER.CHOOSE_NUMBER'), 'error', 4);
      //     }
      //     else {
      //       vm.tripleView.changeState('app.contactcenter_management.services.wizzard.basicstep');
      //     }
      //   }
      // });
      DynamicFactory.get('servicesRsc', 'getNumberList')(vm.numerListModel).then(function (s) {
        vm.numberList = s;
      });
    }

    function setNumber(item) {
      vm.service.premiumNumber = item.number;
      vm.service.selectedNumberId = item.id;
      vm.service.premiumNumberPrefix = item.prefix;
      vm.conf.minifiedValue = vm.service.premiumNumber;

      // vm.tripleView.overrideRole([{ name: 'basicstep', disabled: false }, { name: 'finalstep', disabled: false }]);
    }
  }
}();

/**
 * Created by kosski on 23.08.2016.
 */
+function () {
  'use strict';
  angular.module('management.services').component('stepMail', {
    templateUrl: 'app/main/contactcenter/management/services/component/simplewizzard/components/stepmail/stepmail.html',
    controllerAs: 'vm',
    require: {
      // tripleView: '^tripleView'
      simpleWizzard: '^^simpleWizzard'
    },
    // bindings: {
    //   service: '=',
    //   onUpdate: '&'
    // },
    controller: controller
  });


  /** @ngInject */
  function controller(DynamicFactory, wizzardService) {
    var vm = this;
    vm.wizzardService = wizzardService;
    vm.setMail = setMail;
    vm.$onInit = onInit;
    // function doCheck() {
    //   if(vm.service)
    //   if (vm.service && !angular.equals(wizzardService.service, vm.service)) {
    //     wizzardService.service = vm.service;
    //   }
    // }

    function onInit() {
      vm.service = wizzardService.service;
      // vm.$doCheck = doCheck;
      console.log('init - stepMail - wizzardService: ', wizzardService.service);

      vm.mailListModel = {};
      vm.mailListModel.partnerId = vm.service.servicePartnerID;

      // vm.tripleView.overrideRole(wizzardService.setMenuWizzard());

      // vm.tripleView.addMenuItem({
      //   order: 20,
      //   name: 'Dalej',
      //   // icon: 'icon-arrow-right-bold-circle',
      //   iconSrc:'assets/icons/triple-view/dalej.png',
      //   // unremovable: true,
      //   func: function () {
      //     if (!vm.service.mailBoxId) {
      //       toastService.showToast($translate.instant('MANAGEMENT.SERVICE.WIZ.STEPMAIL.CHOOSE_EMAIL'), 'error', 4);
      //     }
      //     else {
      //       vm.tripleView.changeState('app.contactcenter_management.services.wizzard.basicstep');
      //     }
      //   }
      // });
      DynamicFactory.get('servicesRsc', 'getMailList')(vm.mailListModel).then(function (s) {
        vm.mailList = s;
      });
    }
    function setMail(item) {
      vm.service.mailBoxId = item.id;
      // vm.tripleView.overrideRole([{ name: 'basicstep', disabled: false }, { name: 'finalstep', disabled: false }]);
    }
  }
}();

/**
 * Created by kosski on 23.08.2016.
 */
+function () {
  'use strict';
  angular.module('management.services').component('stepBasic', {
    templateUrl: 'app/main/contactcenter/management/services/component/simplewizzard/components/stepbasic/stepbasic.html',
    controllerAs: 'vm',
    require: {
      // tripleView: '^tripleView'
      simpleWizzard: '^^simpleWizzard'
    },
    // bindings: {
    //   service: '=',
    //   onUpdate: '&'
    // },
    controller: controller
  });


  /** @ngInject */
  function controller(DynamicFactory, $q,  wizzardService, toastService, $translate) {
    var vm = this;

    vm.querySearch = querySearch;
    vm.searchTextChange = searchTextChange;
    vm.selectedItemChange = selectedItemChange;
    vm.wizzardService = wizzardService;
    vm.addTag = addTag;
    vm.changeServiceAvatar = changeServiceAvatar;
    vm.removeTag = removeTag;
    vm.$onInit = onInit;
    vm.$postLink = postLink;
    // vm.$doCheck = doCheck;

    // function doCheck() {
    //   if(vm.service)
    //     if (vm.service && !angular.equals(wizzardService.service, vm.service)) {
    //       wizzardService.service = vm.service;
    //       console.log('wizzardService.service changed!!');
    //     }
    // }

    function onInit() {
      vm.tagsPicker = [];
      // vm.hoursPicker = [];

      vm.files = [];
      vm.selectedItem = '';
      vm.searchText = '';
      vm.removableChips = false;
      vm.conf = {};
      vm.conf.token = 'MANAGEMENT.SERVICE.WIZ.STEPBASIC.TAGS';
      // vm.tripleView.overrideRole(wizzardService.setMenuWizzard());
      vm.chatAvalColors=[
        "#f13543","#5ca668","#dfa440",
        "#81204d","#466ac6","#aab2bd","#757575",
        "#d770ad","#3bafda","#37bc98","#8cc152"];

      vm.chatBsackground=[
        {
          name:'standard',
          url:'assets/images/communicator/chat_tlo.jpg'
        },
        {
          name:'tło ero',
          url:'assets/images/communicator/chat_tlo_ero.jpg'
        },
        {
          name:'tło ezo',
          url:'assets/images/communicator/chat_tlo_ezo.jpg'
        }
      ]

    }
    function setBaseChatSetup(service){

      if(!service.chatBackgroundURL){
        service.chatBackgroundURL=vm.chatBsackground[0].url;
      }
      if(!service.chatMainColor){
        service.chatMainColor=vm.chatAvalColors[0];
      }
      if(!service.chatSecondaryColor){
        service.chatSecondaryColor=vm.chatAvalColors[6];
      }

    }

    function postLink() {
      vm.service = wizzardService.service;
      var dateStart = moment();
      var dateEnd = moment().add('days', 30);
      if (!vm.service.startDate && !vm.service.stopDate) {
        vm.service.startDate = dateStart;
        vm.service.stopDate = dateEnd;
      }
      else {
        vm.service.startDate = moment(vm.service.startDate);
        vm.service.stopDate = moment(vm.service.stopDate);
      }
      console.log('stepbasic | postlink | wizzardService: ', vm.service);

      setBaseChatSetup(vm.service);


        // if($state.params.serviceId && wizzardService.service.readFromList){
        //   loadService($state.params.serviceId, $state.params.serviceType);
        // } else if(wizzardService.service && wizzardService.service.serviceID){
        //   loadService(wizzardService.service.serviceID, wizzardService.service.type);
        // } else {
        //   afterLoadService();
        // }

      // if (wizzardService.service && wizzardService.service.serviceID === parseInt($state.params.serviceId) && !wizzardService.service.readFromList) {
      //   afterLoadService();
      // } else {
      //   var serviceId = $state.params.serviceId ? $state.params.serviceId : vm.service.serviceId;
      //   if (serviceId) {
      //     loadService($state.params.serviceId, $state.params.serviceType);
      //   }
      //   else {
      //     afterLoadService();
      //   }
      // }
    }

    // function loadService(serviceId,type){
    //   wizzardService.loadService(serviceId, type)
    //   .then(function (result) {
    //     vm.service = result;
    //     setBaseChatSetup(vm.service);
    //     // vm.tripleView.overrideRole(wizzardService.setMenuWizzard());
    //     afterLoadService();
    //   });
    // }

    // function afterLoadService() {
    //   getBaseTags();
    //   // if (wizzardService.service) {
    //   //   vm.tripleView.addMenuItem({
    //   //     order: 20,
    //   //     name: 'Dalej',
    //   //     // icon: 'icon-arrow-right-bold-circle',
    //   //     iconSrc:'assets/icons/triple-view/dalej.png',
    //   //     // unremovable: true,
    //   //     func: function () {
    //   //       if (!vm.service.serviceName || !vm.service.startDate || !vm.service.stopDate) {
    //   //         toastService.showToast($translate.instant('MANAGEMENT.SERVICE.WIZ.STEPBASIC.FILL_ALL_FIELDS'), 'error', 4);
    //   //       }
    //   //       else {
    //   //         if (vm.service.type !== 'E') {
    //   //           vm.tripleView.changeState('app.contactcenter_management.services.wizzard.finalstep');
    //   //         }
    //   //         else {
    //   //           vm.tripleView.changeState('app.contactcenter_management.services.wizzard.pointstep');
    //   //         }
    //   //       }
    //   //     }
    //   //   });
    //   // }
    // }
    function querySearch(query) {
      var results = query ? vm.partnerData.filter(vm.createFilterFor(query)) : vm.partnerData;
      return results;
    }

    function searchTextChange(text) {
    }

    function selectedItemChange(item) {
      if (angular.isDefined(item)) {
        vm.service.servicePartnerID = item.partnerID;
        if (vm.service.hasOwnProperty('serviceID')) {
          vm.onUpdate();
        }
      }
    }

    function setPartner() {
      if (vm.service !== undefined) {
        for (var i = 0; i < vm.partnerData.length; i++) {
          if (vm.partnerData[i].partnerID === vm.service.servicePartnerID) {
            vm.selectedPartner = vm.partnerData[i];
            break;
          }
        }
      }
    }

    function changeServiceAvatar(file) {
      vm.parentScope.service.photoUrl = file.contentUrl;
      vm.onUpdate();
    }

    function getBaseTags() {
      DynamicFactory.get('tagsRsc', 'getServiceTags')().then(function (result) {
        vm.baseTags = result;
      }, error);
    }

    function addTag(tag) {
      var defer = $q.defer();
      if (tag) {
        if (tag.tagId !== 'new') {
          // DynamicFactory.get('tagsRsc', 'addTags')(wizzardService.service.serviceID, tag.tagId).then(function (result) {
          //   // vm.parentScope.service.tags.push(tag);
          //   console.log(tag);
          // }, error);
          //return tag;
          defer.resolve(tag);
        } else {
          DynamicFactory.get('tagsRsc', 'addServiceNewTag')(wizzardService.service.serviceID, tag, tag.parentId)
            .then(function (response) {
              tag.tagId = response.tagID;
              tag.value = response.tagID;
              defer.resolve(tag);
            }, error);
         // return tag;
        }
      }
      return defer.promise;
    }

    function removeTag(tag) {
      DynamicFactory.get('tagsRsc', 'deleteServiceTags')(wizzardService.service.serviceID, tag.id).then(function (result) {
        // vm.parentScope.service.tags.push(tag);
        console.log(tag);
      }, error);
    }

    function error(err) {
      toastService.showToast($translate.instant('COMMON.ERROR'), 'error', 4);
    }

  }


}();

/**
 * Created by noope on 29/06/2016.
 */
!(function () {
  'use strict';

  angular.module('contactcenter.reports', ['ngMaterial']).config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, MenuItemsProvider) {


    var menuItems = MenuItemsProvider.initMenuItem('REPORTS')
      .addMenuItem('REPORTS.SMS', {
        iconSrc: 'assets/icons/triple-view/sms1.svg',
        component: 'option-folder'
      })
      .addMenuItem('REPORTS.SMS.LIST', {
        state: 'app.contactcenter_reports.reportstats',
        iconSrc: 'assets/icons/reports/list.svg'
      })
      .addMenuItem('REPORTS.SMS.SESSIONS', {
        state: 'app.contactcenter_reports.reportssessions',
        iconSrc: 'assets/icons/reports/list.svg',
        //hide: 'SessionManager.getUserRole() !== "manager"'
      })
      // .addMenuItem('REPORTS.SMS.TAGS', {
      //   state: 'app.contactcenter_reports.tags',
      //   iconSrc: 'assets/icons/reports/list.svg',
      //   hide: 'SessionManager.getUserRole() !== "manager"'
      // })
      .addMenuItem('REPORTS.SMS.SESSIONSAGGREGATION', {
        state: 'app.contactcenter_reports.sessionaggregation',
        iconSrc: 'assets/icons/reports/list.svg',
        hide: 'SessionManager.getUserRole() !== "manager"'
      })
      .addMenuItem('REPORTS.SMS.UNREALIZEDSESSIONS', {
        state: 'app.contactcenter_reports.unrealizedsessions',
        iconSrc: 'assets/icons/reports/list.svg',
        hide: true //'SessionManager.getUserRole() !== "manager"'
      })
      .addMenuItem('REPORTS.SMS.AGGREGATION', {
        state: 'app.contactcenter_reports.smsaggregation',
        iconSrc: 'assets/icons/reports/aggregation_icon.svg',
        hide: 'true'
      })
      .addMenuItem('REPORTS.CALLS', {
        iconSrc: 'assets/icons/triple-view/glosowe.png',
        component: 'option-folder'
      })
      .addMenuItem('REPORTS.CALLS.LIST', {
        state: 'app.contactcenter_reports.reportStatsCallsList',
        iconSrc: 'assets/icons/reports/list.svg'
      })
      .addMenuItem('REPORTS.CALLS.PERCONSULTANT', {
        state: 'app.contactcenter_reports.reportStatsCallsPerConsultant',
        iconSrc: 'assets/icons/reports/sts.svg'
      })
      .addMenuItem('REPORTS.CALLS.PERSERVICE', {
        state: 'app.contactcenter_reports.reportStatsCallsPerService',
        iconSrc: 'assets/icons/reports/sts.svg',
        hide: 'SessionManager.getUserRole() == "consultant"'
      })
      .addMenuItem('REPORTS.CALLS.PERCC', {
        state: 'app.contactcenter_reports.percontactcenter',
        iconSrc: 'assets/icons/reports/sts.svg',
        hide: 'SessionManager.getUserRole() == "consultant"'
      })
      .addMenuItem('REPORTS.CALLBACK', {
        iconSrc: 'assets/icons/triple-view/calback.svg',
        component: 'option-folder'
      })
      .addMenuItem('REPORTS.CALLBACK.LIST', {
        state: 'app.contactcenter_reports.reportsCallback',
        iconSrc: 'assets/icons/reports/callback_icon.svg',
      })
      .addMenuItem('REPORTS.CALLBACK.AGRPERPARAM', {
        state: 'app.contactcenter_reports.callbackAgregationPerParams',
        iconSrc: 'assets/icons/reports/group_icon.svg'
      })

      .addMenuItem('REPORTS.USERS', {
        iconSrc: 'assets/icons/triple-view/calback.svg',
        component: 'option-folder',
        hide: 'SessionManager.getUserRole() == "consultant"'
      })
      .addMenuItem('REPORTS.USERS.ACTIVITY', {
        state: 'app.contactcenter_reports.userActivity',
        iconSrc: 'assets/icons/reports/callback_icon.svg',
        hide: 'SessionManager.getUserRole() == "consultant"'
      })
      .addMenuItem('REPORTS.USERS.ACTIVITYAUDIT', {
        state: 'app.contactcenter_reports.activityAudit',
        iconSrc: 'assets/icons/reports/callback_icon.svg',
        hide: 'SessionManager.getUserRole() == "consultant"'
      });
    console.log('reports: ', menuItems);
    console.log('menuItemProvider get |', MenuItemsProvider.getMenuObj('REPORTS'));

    $stateProvider
      .state('app.contactcenter_reports', {
        parent: 'app',
        url: '/reports',
        params: {
          menu: menuItems,
          keepSidenavData: true,
          doNotShowSidepanel: false
        },
        resolve: {
          resB: ['tripleviewService', 'chooseDateTime', '$rootScope', function (tripleviewService, chooseDateTime, $rootScope) {
            console.log('contactcenter_reports | resolve');
            tripleviewService.sidenavData.listDate = chooseDateTime.listDate;
            if (!tripleviewService.sidenavData.config)
              tripleviewService.sidenavData.config = {};
            if (!tripleviewService.sidenavData.params) {
              tripleviewService.sidenavData.params = {};
            }
          }]
        },
        views: {
          'content@app': {
            template: '<triple-view do-not-show-sidepanel="$root.state.current.params.doNotShowSidepanel"></triple-view>'
          }
        }
      })
      .state('app.contactcenter_reports.filters', {
        parent: 'app.contactcenter_reports',
        url: '/reports',
        params: {
          menu: menuItems,
          keepSidenavData: true,
          doNotShowSidepanel: false
        },
        views: {
          'sidenav@app.contactcenter_reports': {
            template: '<report-filters></report-filters>'
          }
        }
      })
      .state(menuItems.getMenuItem('REPORTS.SMS.LIST').state, {
        parent: 'app.contactcenter_reports.filters',
        url: '/reportStatsSms',
        statePanelRight: true,
        stateTranslationName: 'REPORTS.SMS.LIST',
        views: {
          'mainContent@app.contactcenter_reports': {
            template: '<report-stats flex></report-stats>'
          }
        }
      })
      .state(menuItems.getMenuItem('REPORTS.SMS.SESSIONS').state, {
        parent: 'app.contactcenter_reports.filters',
        url: '/reportSessions',
        statePanelRight: true,
        stateTranslationName: 'REPORTS.SMS.SESSIONS',
        views: {
          'mainContent@app.contactcenter_reports': {
            template: '<report-sessions flex></report-sessions>'
          }
        }
      })
      // .state(menuItems.getMenuItem('REPORTS.SMS.TAGS').state, {
      //   parent: 'app.contactcenter_reports.filters',
      //   url: '/reportstags',
      //   statePanelRight: true,
      //   stateTranslationName: 'REPORTS.SMS.TAGS',
      //   views: {
      //     'mainContent@app.contactcenter_reports': {
      //       template: '<reports-tags flex></reports-tags>'
      //     }
      //   }
      // })
      .state(menuItems.getMenuItem('REPORTS.SMS.SESSIONSAGGREGATION').state, {
        parent: 'app.contactcenter_reports.filters',
        url: '/sessionsAggregation',
        statePanelRight: true,
        stateTranslationName: 'REPORTS.SMS.SESSIONSAGGREGATION',
        views: {
          'mainContent@app.contactcenter_reports': {
            template: '<sessions-aggregation flex></sessions-aggregation>'
          }
        }
      })
      .state(menuItems.getMenuItem('REPORTS.SMS.UNREALIZEDSESSIONS').state, {
        parent: 'app.contactcenter_reports.filters',
        url: '/unrealizedSessions',
        statePanelRight: true,
        stateTranslationName: 'REPORTS.SMS.UNREALIZEDSESSIONS',
        views: {
          'mainContent@app.contactcenter_reports': {
            template: '<unrealized-sessions flex></unrealized-sessions>'
          }
        }
      })
      .state(menuItems.getMenuItem('REPORTS.SMS.AGGREGATION').state, {
        parent: 'app.contactcenter_reports.filters',
        url: '/smsAggregation',
        statePanelRight: true,
        stateTranslationName: 'REPORTS.SMS.AGGREGATION',
        views: {
          'mainContent@app.contactcenter_reports': {
            template: '<sms-aggregation flex></sms-aggregation>'
          }
        }
      })
      .state(menuItems.getMenuItem('REPORTS.CALLS.LIST').state, {
        parent: 'app.contactcenter_reports.filters',
        url: '/reportStatsCalls',
        statePanelRight: true,
        stateTranslationName: 'REPORTS.CALLS.LIST',
        views: {
          'mainContent@app.contactcenter_reports': {
            template: '<report-stats-calls flex></report-stats-calls>'
          }
        }
      })
      .state(menuItems.getMenuItem('REPORTS.CALLS.PERCONSULTANT').state, {
        parent: 'app.contactcenter_reports.filters',
        url: '/reportStatsCallsPerConsultant',
        statePanelRight: true,
        stateTranslationName: 'REPORTS.CALLS.PERCONSULTANT',
        views: {
          'mainContent@app.contactcenter_reports': {
            template: '<report-stats-calls-per-consultant flex></report-stats-calls-per-consultant>'
          }
        }
      })
      .state(menuItems.getMenuItem('REPORTS.CALLS.PERSERVICE').state, {
        parent: 'app.contactcenter_reports.filters',
        url: '/reportStatsCallsPerService',
        statePanelRight: true,
        stateTranslationName: 'REPORTS.CALLS.PERSERVICE',
        views: {
          'mainContent@app.contactcenter_reports': {
            template: '<report-stats-calls-per-service flex></report-stats-calls-per-service>'
          }
        }
      })
      .state(menuItems.getMenuItem('REPORTS.CALLS.PERCC').state, {
        parent: 'app.contactcenter_reports.filters',
        url: '/percontactcenter',
        statePanelRight: true,
        stateTranslationName: 'REPORTS.CALLBACK.AGRPERPARAM',
        views: {
          'mainContent@app.contactcenter_reports': {
            template: '<percontactcenter flex></percontactcenter>'
          }
        }
      })
      .state(menuItems.getMenuItem('REPORTS.CALLBACK.LIST').state, {
        parent: 'app.contactcenter_reports.filters',
        url: '/reportsCallback',
        statePanelRight: true,
        stateTranslationName: 'REPORTS.CALLBACK',
        views: {
          'mainContent@app.contactcenter_reports': {
            template: '<callbacklist flex style="width:100%"></callbacklist>'
          }
        }
      })
      .state(menuItems.getMenuItem('REPORTS.CALLBACK.AGRPERPARAM').state, {
        parent: 'app.contactcenter_reports.filters',
        url: '/callbackAgregationPerParams',
        statePanelRight: true,
        stateTranslationName: 'REPORTS.CALLBACK.AGRPERPARAM',
        views: {
          'mainContent@app.contactcenter_reports': {
            template: '<callback-perparams-list flex></callback-perparams-list>'
          }
        }
      })
      .state(menuItems.getMenuItem('REPORTS.USERS.ACTIVITY').state, {
        parent: 'app.contactcenter_reports.filters',
        url: '/usersactivity',
        statePanelRight: true,
        stateTranslationName: 'REPORTS.USERS.ACTIVITY',
        views: {
          'mainContent@app.contactcenter_reports': {
            template: '<user-activity flex></user-activity>'
          }
        }
      })
      .state(menuItems.getMenuItem('REPORTS.USERS.ACTIVITYAUDIT').state, {
        parent: 'app.contactcenter_reports.filters',
        url: '/activityaudit',
        statePanelRight: true,
        stateTranslationName: 'REPORTS.USERS.ACTIVITYAUDIT',
        views: {
          'mainContent@app.contactcenter_reports': {
            template: '<activity-audit flex></activity-audit>'
          }
        }
      });
  }
})();

(function() {
    'use strict';

    angular
        .module('contactcenter.reports')
        .component('smsAggregationList', {
            templateUrl: 'app/main/contactcenter/reports/components/reportstatssms/aggregation/aggregationlist/aggregationList.html',
            require: {
                tripleView: '^tripleView'
            },
            controllerAs: 'vm',
            controller: controller,
            bindings: {
                msgAggregationList: '<'
            }
        });

    function controller(SessionManager, authRolesConst) {
        var vm = this;

        vm.messageType = messageType;
        vm.$onInit = onInit;
        vm.$onChanges = onChanges;

        //others
        vm.SessionManager = SessionManager;
        vm.authRolesConst = authRolesConst;

        function onInit() {

        }

        function onChanges(changesObj) {

        }

        function generateDataForChart() {
            vm.reportsData = [];
        }

        function messageType(input) {
            var type = '';
            switch(input) {
                case 'C': type = 'Chat www'; break;
                case 'E': type = 'Email'; break;
                case 'F': type = 'Facebook message'; break;
                case 'M': type = 'MMS'; break;
                case 'S': type = 'SMS'; break;
                case 'T': type = 'Issue Tracker'; break;
                default : type = 'Brak danych'; break; 
            }
            return type;
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('contactcenter.reports')
    .component('callbackPerparamsList', {
      templateUrl: 'app/main/contactcenter/reports/components/callback/callbackperparams/callbackparamslist/callbackperparams.html',
      require: {
        tripleView: '^tripleView'
      },
      controllerAs: 'vm',
      controller: callbackPerparamsList,
      // bindings: {
      //     grupedCallbackAggregation: '<',
      //     reverse: '=',
      //     propertyName: '=',
      //     showDay: '<',
      //     orderRow: '<',
      //     groupParams: '<',
      //     allParams: '<',
      //     sumCount: '<'
      // }
    });

  function callbackPerparamsList(ReportTools, DynamicFactory, ReportsData, donutChart, tripleviewService, SessionManager, authRolesConst) {
    var vm = this;
    vm.$onInit = onInit;

    vm.downloadXLSX = downloadXLSX;

    vm.setPage = setPage;
    vm.pageSize = 10;
    vm.pageNumber = 0;
    vm.groupedByDay = 0;

    function onInit() {
      vm.SessionManager = SessionManager;
      vm.authRolesConst = authRolesConst;
      setTripleView();
      getParamsList();

      getFilteredCallbackOrders();
    }

    function StringToArray(string) {
      var array = [];
      if (string.length > 1) {
        array = string.split(',');
      } else if (string.length == 1) {
        array = string;
      }

      return array;
    }

    function StringToIntArray(string) {
      var array = [];
      if (string.length > 1) {
        array = string.split(',');
      } else if (string.length == 1) {
        array = string;
      }

      array = array.map(function (item) {
        return Number(item);
      });
      return array;
    }

    function getFilteredCallbackOrders() {
      vm.pageNumber = 0;
      vm.showDayColumn = vm.groupedByDay == 1 ? true : false;
      getReport();
      getCharts();
    }

    function getReport() {
      DynamicFactory.get('reportsCosult', 'CallbackParamsAggregation')(vm.getParams()).then(
        function (callbackParamsAggregation) {
          vm.callbackParamsAggregation = [];

          if (callbackParamsAggregation.length > 0) {
            vm.allOccurringDurations = StringToArray(callbackParamsAggregation[0].allOccurringDurations);

            _.forEach(callbackParamsAggregation, function (item, key) {
              var orderedDurations = [];
              var ordersCounts = [];
              var netAmountTotals = [];
              var grossAmountTotals = [];

              orderedDurations = StringToArray(callbackParamsAggregation[key].orderedDurations);
              ordersCounts = StringToArray(callbackParamsAggregation[key].ordersCounts);
              netAmountTotals = StringToArray(callbackParamsAggregation[key].netAmountTotals);
              grossAmountTotals = StringToArray(callbackParamsAggregation[key].grossAmountTotals);

              var tempValuesArray = [];
              var durationFound;

              _.forEach(vm.allOccurringDurations, function (allOccurringDurationsItem, allOccurringDurationsKey) {
                durationFound = false;
                var tempValues = {
                  ordersCount: undefined,
                  netAmount: undefined,
                  grossAmount: undefined,
                }

                var foundDurationId = _.findIndex(orderedDurations, function (orderedDurationsItem) {
                  return allOccurringDurationsItem == orderedDurationsItem;
                });

                if (foundDurationId == -1) {
                  tempValues.ordersCount = '0';
                  tempValues.netAmount = '0';
                  tempValues.grossAmount = '0';
                } else {
                  tempValues.ordersCount = ordersCounts[foundDurationId];
                  tempValues.netAmount = netAmountTotals[foundDurationId];
                  tempValues.grossAmount = grossAmountTotals[foundDurationId];
                }

                tempValuesArray[allOccurringDurationsKey] = tempValues;

                // _.forEach(orderedDurations, function (orderedDurationsItem, orderedDurationsKey) {
                //   if (allOccurringDurationsItem == orderedDurationsItem) {
                //     durationFound = true;
                //     tempValues.ordersCount = ordersCounts[orderedDurationsKey];
                //     tempValues.netAmount = netAmountTotals[orderedDurationsKey];
                //     tempValues.grossAmount = grossAmountTotals[orderedDurationsKey];

                //     tempValuesArray[allOccurringDurationsKey] = tempValues;
                //   }
                // });

                // if (!durationFound) {
                //   tempValues.ordersCount = '0';
                //   tempValues.netAmount = '0';
                //   tempValues.grossAmount = '0';

                //   tempValuesArray[allOccurringDurationsKey] = tempValues;
                // }

              });

              callbackParamsAggregation[key].ValuesAgg = tempValuesArray;
            });

            vm.callbackParamsAggregation = callbackParamsAggregation;
          }
          generatePages();
        },
        function (error) {
          console.log("Problem z pobraniem callback'ów zagregowanych po paramasach");
        });
    }

    function getParamsList() {
      var serviceID = null;
      DynamicFactory.get('reportsCosult', 'ParamList')(serviceID).then(function (paramsList) {
        tripleviewService.sidenavData.paramList = paramsList;
      }, function (error) {
        console.log("Problem z pobranie listy elementów po których można pogrupować raport" + error);
      });
    }

    //#region Chart plugin
    function getCharts() {
      setChartsPlugins();
      //if (tripleviewService.sidenavData.finalDate) setWidthOnChart(tripleviewService.sidenavData.finalDate.date);

      DynamicFactory.get('reportsCosult', 'CallbackParamsAggregationChart')(vm.getParams()).then(
        generateCharts,
        function (error) {
          console.log("Wystapił błąd podczas pobierania liczby zamównionych callback'ów do wyrysowania wykresu");
        });
    }

    function generateCharts(callbackParamsAggregation) {
      var barChartData = [];
      var donutChartData = [];

      ReportsData.resetNextColor();
      if (callbackParamsAggregation.length > 0) {
        //Bar chart
        barChartData.push({
          key: 'callbackParamsAggregation',
          values: generateSeriesValues(callbackParamsAggregation)
        });

        ReportsData.resetNextColor();
        //Donut chart
        donutChartData = generateDonutChartSeries(callbackParamsAggregation);
      }

      vm.mainChart.data = barChartData;
      vm.mainDonutChart.data = donutChartData;
    }

    function generateDonutChartSeries(data) {
      var daily = vm.getParams().Daily;
      var params = vm.getParams().Params;

      if (daily == 0 && !params) { //w przypadku gdy nie wybrano grupowania po dacie ani paramsach na osi X czasy trwania callback'ów
        return generateSeriesWithoutGrouping(data, true);
      } else { //wybrano grupowanie
        var totalAllOfOrders = _.reduce(data, function (totalAll, currentObject) {
          return totalAll + currentObject.ordersTotal;
        }, 0);

        if (daily == 1 && !params) { //grupowanie tylko po dacie
          return generateSeriesGroupedByDate(data, totalAllOfOrders);
        } else { //grupowanie po paramsach
          return generateSeriesGroupedByParams(data, totalAllOfOrders)
        }
      }
    }

    function generateSeriesValues(data) {
      var daily = vm.getParams().Daily;
      var params = vm.getParams().Params;

      if (daily == 0 && !params) { //w przypadku gdy nie wybrano grupowania po dacie ani paramsach na osi X czasy trwania callback'ów
        return generateSeriesWithoutGrouping(data);
      } else {
        if (daily == 1 && !params) { //grupowanie tylko po dacie
          return generateSeriesGroupedByDate(data);
        } else { //grupowanie po paramsach
          return generateSeriesGroupedByParams(data);
        }
      }
    }

    function generateSeriesWithoutGrouping(data, donutChart) {
      var orderedDurations = [];
      var ordersTotals = [];

      orderedDurations = StringToArray(data[0].orderedDurations);
      ordersTotals = StringToIntArray(data[0].ordersTotals);

      var maxCount = _.maxBy(ordersTotals, function (item) {
        return item;
      });

      if (donutChart) {
        //Donut chart
        var totalAllOfOrders = _.reduce(ordersTotals, function (totalAll, value) {
          return totalAll + value;
        }, 0);
      }

      return orderedDurations.map(function (item, key) {
        return {
          color: ReportsData.getNextColor(),//ReportsData.getColorShade('#990000', (ordersTotals[key] / maxCount) * 100),
          x: item + ' MIN',
          y: donutChart ? (ordersTotals[key] / totalAllOfOrders) * 100 : ordersTotals[key]
        }
      });

    }

    function generateSeriesGroupedByParams(data, totalAllOfOrders) {
      var maxCountItem = _.maxBy(data, function (item) {
        return item.ordersTotal;
      });

      return data.map(function (item) {
        if (item.ordersTotal != 0) {
          return {
            color: ReportsData.getNextColor(), //ReportsData.getColorShade('#990000', item.ordersTotal / maxCountItem.ordersTotal * 100),
            x: item.params || 'nieprzypisany',
            y: totalAllOfOrders ? (item.ordersTotal / totalAllOfOrders) * 100 : item.ordersTotal
          }
        } else {
          return {
            color: ReportsData.getNextColor(), //'#990000',
            x: item.params,
            y: 0
          }
        }
      });
    }

    function generateSeriesGroupedByDate(data, totalAllOfOrders) {
      var datesArray = ReportTools.dateInBetween('DD-MM-YYYY', tripleviewService.sidenavData.params);
      var seriesData = [];
      var shadeGrade;

      var maxCountItem = _.maxBy(data, function (item) {
        return item.ordersTotal;
      });

      return datesArray.map(function (date, key) {
        var foundItem = _.find(data, function (item) {
          return item.day == datesArray[key];
        });

        if (foundItem) {
          return {
            color: ReportsData.getNextColor(), //ReportsData.getColorShade('#990000', (foundItem.ordersTotal / maxCountItem.ordersTotal) * 100),
            x: datesArray[key],
            y: totalAllOfOrders ? (foundItem.ordersTotal / totalAllOfOrders) * 100 : foundItem.ordersTotal
          }
        } else {
          return {
            color: ReportsData.getNextColor(), //'#990000',
            x: datesArray[key],
            y: 0
          }
        }
      });
    }

    // function setWidthOnChart(data) {
    //   vm.mainChart.options.chart.width = undefined;
    // }

    function chartValueFormat(d) {
      if (d == 0) {
        return '';
      } else {
        return d.toString();
      }
    }

    function setChartsPlugins() {
      //vm.dateType = ReportsData.dateType;

      var mainChart = angular.copy(ReportsData.defaultChartConf);
      // mainChart.options.chart.color = function color() {
      //   return '#2799f3'; //'#5fd4c4'
      // };

      mainChart.options.chart.height = null;
      mainChart.options.chart.width = null;
      mainChart.options.chart.type = 'discreteBarChart';

      mainChart.options.chart.duration = 0;
      mainChart.options.chart.xAxis = {
        tickFormat: function (d) {
          if (vm.getParams().Daily == 1 && !vm.getParams().Params) {
            var daysTotal = moment.duration(tripleviewService.sidenavData.params.To.diff(tripleviewService.sidenavData.params.From)).asDays();
            var fromToTick = moment.duration(moment(d, 'DD-MM-YYYY').diff(tripleviewService.sidenavData.params.From)).asDays();
            if (daysTotal > 32) {
              if (Math.round(fromToTick) % 8 == 0) {
                return d;
              } else {
                return '';
              }
            }
          }
          return d;
        },
        rotateLabels: -25
      };
      mainChart.options.chart.tooltip = {
        keyFormatter: function (d, i) {
          return d;
        }
      }

      mainChart.options.chart.yAxis = {
        tickFormat: chartValueFormat
      };
      mainChart.options.chart.valueFormat = chartValueFormat;
      mainChart.options.chart.margin = {
        top: 50,
        right: 16,
        bottom: 70,
        left: 61
      };
      vm.mainChart = mainChart;

      //Donut chart
      vm.mainDonutChart = undefined;
      vm.mainDonutChart = ReportsData.defaultDonutChartConf;
      vm.mainDonutChart.options.chart.type = 'pieChart';
      //vm.mainDonutChart.options.chart.duration = 10;
      vm.mainDonutChart.options.chart.height = null;
      vm.mainDonutChart.options.chart.width = null;
      vm.mainDonutChart.options.chart.x = function (d) {
        return d.x;
      };
      //vm.mainDonutChart.options.chart.color = _.map(ReportsData.donutChartColors, 'color');
      vm.mainDonutChart.options.title = {
        enable: false
      };
      vm.mainDonutChart.options.chart.margin = {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      };
      vm.mainDonutChart.options.chart.pie.height = null;
      vm.mainDonutChart.options.chart.pie.width = null;
    }
    //#endregion

    //#region Paging
    function setPage(newPage) {
      vm.pageNumber = newPage;
      getReport();
    }

    function generatePages() {
      vm.reportPages = [];
      if (vm.callbackParamsAggregation.length > 0) {
        var totalPages = Math.ceil(vm.callbackParamsAggregation[0].recordsTotal / vm.pageSize)
        //console.log('reportCallbackOrders | total pages=', totalPages);
        // /vm.reportPages = [];
        for (var i = 0; i < totalPages; i++) {
          vm.reportPages.push(i);
        }
      }
    }
    //#endregion

    //#region TripleView
    function setTripleView() {
      tripleviewService.sidenavData.getConnectData = getFilteredCallbackOrders;

      vm.getParams = ReportTools.configReportParams({
        paramList: true,
      }, currentPage);

      tripleviewService.sidenavData.agregationDate = [];
      tripleviewService.sidenavData.duration = 3;
      tripleviewService.sidenavData.startValue = '';
      tripleviewService.sidenavData.showDays = showDays;
    }

    function currentPage() {
      return {
        PageNumber: vm.pageNumber,
        PageSize: vm.pageSize,
        Params: getParamsId(), //tripleviewService.sidenavData.params.paramID,
        ServiceID: undefined,
        Daily: vm.groupedByDay,
      }
    }

    function showDays() {
      vm.groupedByDay = vm.groupedByDay == 1 ? 0 : 1;
    }

    function getParamsId() {
      var stringID = undefined;
      if (tripleviewService.sidenavData.params.paramID) {
        var paramsArray = angular.copy(tripleviewService.sidenavData.params.paramID);

        if (paramsArray.indexOf('perDay') != -1 || paramsArray[0] === 'perDay') {
          vm.groupedByDay = 1;
          var perDay = paramsArray.pop();
        }

        if (paramsArray.length != 0) {
          stringID = '';

          _.forEach(paramsArray, function (param) {
            stringID += param + ',';
          });

          stringID = stringID.substr(0, stringID.length - 1);
        }
      }

      return stringID;
    }
    //#endregion

    //#region Download .xlsx
    function downloadXLSX() {
      // DynamicFactory.get('reportsCosult', 'DownloadCallbackOrders')(vm.getParams()).then(
      //   function (report) {
      //     downloadReport(report);
      //     console.log("Pobrano plik.");
      //   },
      //   function (error) {
      //     console.log("Problem z pobraniem pliku.", error);
      //   });
    }

    function downloadReport(report) {
      // var blob = new Blob([new Uint8Array(report.data)], {
      //   //type: report.headers('Content-Type')
      // });

      // var anchor = document.createElement('a');
      // anchor.style = "display: none";
      // anchor.href = URL.createObjectURL(blob);
      // anchor.download = 'myFileName.csv';
      // document.body.appendChild(anchor); //For FF
      // anchor.click();
      // //It's better to remove the elem
      // document.body.removeChild(anchor);
    }

    //#endregion





    // var vm = this;

    // //functions
    // vm.sumAllOrders = sumAllOrders;
    // vm.showDays = showDays;
    // vm.$onInit = onInit;
    // vm.$onChanges = onChanges;

    // function onInit() { }
    // function onChanges(changesObj) {
    //     if (changesObj.orderRow) {
    //         generateRow(changesObj.orderRow.currentValue);
    //     }
    // }

    // function sumAllOrders(input) {
    //     return _.sum(input);
    // }

    // function generateRow(row) {
    //     if (showDays()) {
    //         vm.reportsGroup = groupBy(row, 'day');
    //     } else {
    //         vm.reportsGroup = groupBy(row, 'Params');
    //     }

    //     getAllMinutes(row, vm.reportsGroup);
    // }

    // function getAllMinutes(row, params) {
    //     vm.allMinutes = [];
    //     var minutes = groupBy(row, 'minutes');

    //     for (var m in minutes) {
    //         if (minutes.hasOwnProperty(m)) {
    //             var min = _.find(vm.allMinutes, { 'minutes': m });

    //             if (!min) {
    //                 min = { 'minutes': m };
    //                 vm.allMinutes.push(min);
    //             }
    //         }
    //     }
    //     rowPerParams();
    // }

    // function rowPerParams() {
    //     vm.groupedRow = [];
    //     for (var p in vm.reportsGroup) {
    //         if (vm.reportsGroup.hasOwnProperty(p)) {
    //             _.forEach(vm.allMinutes, function (min, key) {
    //                 var noMin = parseInt(min.minutes),
    //                     param = _.find(vm.reportsGroup[p], { 'minutes': noMin }),
    //                     row = {};
    //                 // day = _.find(vm.reportsGroup[p], {'day': });
    //                 if (!showDays()){
    //                     row = _.find(vm.groupedRow, { 'params': p });
    //                 }
    //                 else {
    //                     row = _.find(vm.groupedRow, { 'day': p });
    //                 }


    //                 if (!row) {
    //                     if (!showDays())
    //                         row = { 'params': p, values: [] };
    //                     else
    //                         row = { 'day': p,
    //                                 'params': vm.reportsGroup[p][0].Params,
    //                                 values: [] };

    //                     vm.groupedRow.push(row);
    //                 }

    //                 if (!param) {
    //                     param = { 'minutes': min.minutes,
    //                               'orders': 0 };
    //                 }

    //                 row.values.push(param);
    //             });
    //         }
    //     }
    // }

    // function groupBy(objectArray, property) {
    //     if (!objectArray) return;

    //     var groupedProperty = objectArray.reduce(function (acc, obj) {
    //         var key = obj[property];
    //         if (!acc[key]) {
    //             acc[key] = [];
    //         }
    //         acc[key].push(obj);
    //         return acc;
    //     }, {});

    //     return groupedProperty;
    // }

    // function showDays() {
    //     var day = false;
    //     day = vm.showDay;
    //     return day;
    // }
  }
})();

(function () {
    'use strict';

    angular
        .module('contactcenter.reports')
        .component('callbackAgregationList', {
            templateUrl: 'app/main/contactcenter/reports/components/callback/callbackagregation/callbackagregationlist/callbackagregationlist.html',
            require: {
                tripleView: '^tripleView'
            },
            controllerAs: 'vm',
            controller: callbackAgregationList,
            bindings: {
                callbackAgregationList: '<',
                minutesColumn: '<'
            }
        });

    function callbackAgregationList(SessionManager, authRolesConst) {
        var vm = this;

        //function
        vm.$onInit = onInit;
        vm.$onChanges = onChanges;

        //others
        vm.userInfo = SessionManager.getUser();

        function onInit() {
            console.log('vm.userInfo', vm.userInfo);
            
         }
        function onChanges(changesObj) {
            if (changesObj.callbackAgregationList) {
                if (SessionManager.getUserRoleId() !== authRolesConst.consultant)
                    generateCallbackAggregationList(changesObj.callbackAgregationList.currentValue);
                else
                    ConsultantGenerateCallbackAggregationList(changesObj.callbackAgregationList.currentValue);
            } else if (changesObj.minutesColumn) {
                vm.minutesColumn = changesObj.minutesColumn.currentValue;
            }
        }
        function generateCallbackAggregationList(data) {
            vm.agregationList = [];
            for (var cc in data) {
                if (data.hasOwnProperty(cc)) {
                    var row = _.find(vm.agregationList, { 'consultantId': parseInt(cc) });
                    if (!row) {
                        row = { 'consultantID': cc, value: [] };
                    }

                    if (row.consultantID) {
                        var ordersValue = Object.values(data[cc]),
                            minutesValue = Object.values(vm.minutesColumn);

                        // var value = Object.values(data[cc]), key = Object.keys(data[cc]);
                        // console.log('key:',key, ' velue:', value);

                        var minutesValueLength = minutesValue.length;
                        for (var i = 0; i < minutesValueLength; i++) {
                            var ordersRow = _.find(row.value, { 'minutes': minutesValue[i] });

                            if (!ordersRow)
                                ordersRow = { 'orders': ordersValue[i] };

                            row.value.push(ordersRow);

                        }
                    }

                    if (isNaN(row.consultantID) !== true)
                        vm.agregationList.push(row);
                }
            }
        }

        function ConsultantGenerateCallbackAggregationList(data) {
            vm.ordersCount = [];
            for (var i in data) {
                if (data.hasOwnProperty(i)) {

                    var row = _.find(vm.agregationList, { 'minutes': data[i].minutes });

                    if (!row)
                        row = { 'minutes': data[i].minutes, 'orders': data[i].orderCount };                    

                    if(row.minutes !== undefined || row.orders !== undefined)
                        vm.ordersCount.push(row);
                    
                }
            }
        }
    }
})();
(function() {
  'use strict';

  angular
      .module('management.services')
      .filter('wizzardicon', eavesdropping);

      function eavesdropping() {
          return function(input) {
              if(!input) return '';

              input = input
                  .replace('MANAGEMENT.SERVICE.WIZ.STEPNUMBER.ROUTE_NAME', 'assets/icons/monitoring/out.svg')
                  .replace('CONTACT_CENTER.SIMPLE_BRIDGE_ACTION.CONSULTANTS_LIST_ENDPOINT', '/assets/navigation/users.svg');

                  return input;
          }
      }
})();

(function () {
  'use strict';

  angular
    .module('management.services').component('pointDialog', {
      templateUrl: 'app/main/contactcenter/management/services/component/dialogs/point/point-dialog.html',
      controllerAs: 'vm',
      bindings: {
        paymentService: '=',
        inserted: '='
      },
      controller: PointDialogController
    });


  /** @ngInject */
  function PointDialogController($mdDialog, OrderboxGlue, DynamicFactory, ngNotify, $translate, $scope, $stateParams, SessionManager, toastService) {
    var vm = this;
    vm.saveForm = saveForm;
    vm.closeDialog = closeDialog;
    vm.$onInit = onInit;

    function onInit() {
    }
    function saveForm() {
      if(vm.inserted){
        vm.paymentService.netPrice = vm.paymentService.netPrice*100;
        vm.paymentService.grossPrice = vm.paymentService.grossPrice*100;
        vm.paymentService.isActive = true;
      }
      $mdDialog.hide(vm.paymentService);
    }
    function closeDialog() {
      $mdDialog.hide();
    }

  }
})();

/**
 * Created by noope on 29/06/2016.
 */
! function () {
  'use strict';

  angular
    .module('contactcenter.profilemanagement', [])
    .config(config);

  // config.$inject = ['$stateProvider', '$translatePartialLoaderProvider'];
  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, consts, MenuItemsProvider) {
        // menuContent: ['dashboard-menu', 'nav-status-axis', 'options-menu']

    var menuItems = MenuItemsProvider.initMenuItem('DASHBOARD')
      .addMenuItem('DASHBOARD.STATUS', {
        component: 'nav-status-axis',
        hide: '!SessionManager.isConsultant()',
      })
      .addMenuItem('DASHBOARD.MULTIBARCALLS', {
        component: 'nav-multi-bar',
        hide: '!SessionManager.isConsultant()',
      })
      .addMenuItem('DASHBOARD.AVGBARCALLS', {
        component: 'nav-avg-calls-chart',
        hide: '!SessionManager.isConsultant()',
      })
      .addMenuItem('DASHBOARD.MENU', {
        component: 'dashboard-menu',
        // hide: 'SessionManager.getUserRoleId() != authRolesConst.consultant',
      })
      .addMenuItem('DASHBOARD.SETTINGS', {
        iconSrc: 'assets/icons/triple-view/glosowe.png',
        // component:'nested-menu'
        component: 'option-folder'
      })
      .addMenuItem('DASHBOARD.SETTINGS.GENERAL', {
        state: 'app.contactcenter_dashboard.settings.general',
        iconSrc: 'assets/icons/triple_menu/ogolne.png'
      })
      .addMenuItem('DASHBOARD.SETTINGS.CONTENT', {
        state: 'app.contactcenter_dashboard.settings.content',
        icon: 'icon-image-album'
      })
      .addMenuItem('DASHBOARD.SETTINGS.PARTNERMAILBOX', {
        state: 'app.contactcenter_dashboard.settings.partnermailbox',
        hide: 'SessionManager.getUserRoleId() != authRolesConst.admin',
        isAdditional: true,
        icon: 'icon-email'
      })
      .addMenuItem('DASHBOARD.SETTINGS.USERS', {
        state: 'app.contactcenter_dashboard.settings.users',
        hide: 'SessionManager.getUserRoleId() != authRolesConst.admin',
        isAdditional: true,
        icon: 'icon-account-multiple'
      })
      .addMenuItem('DASHBOARD.SETTINGS.CATEGORIES', {
        state: 'app.contactcenter_dashboard.settings.categories',
        iconSrc: 'assets/icons/triple_menu/kategorie.png',
        isAdditional: true,
        hide: '!SessionManager.portalConsultant()'
      })
      .addMenuItem('DASHBOARD.SETTINGS.COMMUNICATOR_CONFIG', {
        state: 'app.contactcenter_dashboard.settings.communicator_config',
        // hide: '!SessionManager.isConsultant()',
        isAdditional: true,
        iconSrc: 'assets/icons/triple_menu/komunikator.png'
      })
      .addMenuItem('DASHBOARD.SETTINGS.AREAS', {
        state: 'app.contactcenter_dashboard.settings.areas',
        iconSrc: 'assets/icons/triple_menu/Dziedziny.png',
        isAdditional: true,
        hide: '!SessionManager.portalConsultant()'
      })
      .addMenuItem('DASHBOARD.SETTINGS.RATES', {
        state: 'app.contactcenter_dashboard.settings.rates',
        iconSrc: 'assets/icons/triple_menu/Stawki.png',
        isAdditional: true,
        hide: '!SessionManager.portalConsultant()'
      })
      .addMenuItem('DASHBOARD.SETTINGS.TIMESHIFT', {
        state: 'app.contactcenter_dashboard.settings.timeshift',
        iconSrc: 'assets/icons/triple_menu/czas pracy.png',
        hide: '!SessionManager.portalConsultant()'
      })
      .addMenuItem('DASHBOARD.SETTINGS.PARTY', {
        state: 'app.contactcenter_party',
        iconSrc: 'assets/icons/triple_menu/komunikatorb.png'
      })
      .addMenuItem('DASHBOARD.SETTINGS.DESCRIPTION', {
        state: 'app.contactcenter_dashboard.settings.description',
        iconSrc: 'assets/icons/triple_menu/opisy.png',
        isAdditional: true,
        hide: '!SessionManager.portalConsultant()'
      })
      .addMenuItem('DASHBOARD.SETTINGS.CONSULTANT_SERVICES', {
        state: 'app.contactcenter_dashboard.settings.consultantservices',
        iconSrc: 'assets/icons/triple_menu/opisy.png',
        isAdditional: true,
        hide: '!SessionManager.isConsultant()'
      })
      .addMenuItem('DASHBOARD.SETTINGS.PARTNER_CONTENT', {
        state: 'app.contactcenter_dashboard.settings.partner_content',
        iconSrc: 'assets/icons/triple_menu/opisy.png',
        isAdditional: true,
        hide: 'SessionManager.getUserRoleId() != authRolesConst.admin'
      })


    $stateProvider
      .state('app.contactcenter_dashboard.settings', {
        parent: 'app.contactcenter_dashboard',
        url: '/settings',
        params: {
          //jesli bedzie uzywane to do GetService nalezy dodac serviceType
          menu: function () {
            return menuItems;
          }
        },
        views: {
          'content@app': {
            template: '<triple-view do-not-show-sidepanel="true"></triple-view>'
          }
        }
      })
      .state(menuItems.getMenuItem('DASHBOARD.SETTINGS.GENERAL').state, {
        // parent: 'app.contactcenter_dashboard.settings',
        url: '/general',
        stateTranslationName: 'DASHBOARD.SETTINGS.GENERAL',
        params: {

        },
        views: {
          'mainContent@app.contactcenter_dashboard.settings': {
            template: '<settings-general flex></settings-general>'
          }
        }
      })
      .state('app.contactcenter_dashboard.settings.consultantedit', {
        url: '/consultantedit',
        stateTranslationName: 'DASHBOARD.SETTINGS.EDIT',
        params: {
          startState: 'app.contactcenter_dashboard.settings.general',
          consultantId: null
        },
        views: {
          'mainContent@app.contactcenter_dashboard.settings': {
            template: '<consultant-edit  style="width: 100%" personal-Account="true"></consultant-edit>'
          }
        },
        resolve: {}
      })
      .state(menuItems.getMenuItem('DASHBOARD.SETTINGS.CONTENT').state, {
        // parent: 'app.contactcenter_management.services.wizzard',
        url: '/content',
        stateTranslationName: 'DASHBOARD.SETTINGS.CONTENT',
        statePanelRight: true,
        resolve: {
          contentId: ['SessionManager', function (SessionManager) {
            return SessionManager.getUser()['consultantId'];
          }]
        },
        views: {
          'mainContent': {
            template: '<ta-content flex="100" content-id="$resolve.contentId" content-type="3" content-url="' + consts.consultantContent + '" ng-cloak></ta-content>'
          }
        }
      })
      .state(menuItems.getMenuItem('DASHBOARD.SETTINGS.PARTNERMAILBOX').state, {
        parent: 'app.contactcenter_dashboard.settings',
        url: '/partnermail',
        stateTranslationName: 'DASHBOARD.SETTINGS.PARTNERMAILBOX',
        params: {
          // templateKey: 'partnerProfile',
          // defaultAvatar: 'assets/images/icons/partner.png'
        },
        views: {
          'mainContent': {
            template: '<partner-mailbox flex></partner-mailbox>'
          }
        }
      })
      // .state(menuItems.getMenuItem('DASHBOARD.SETTINGS.USERS').state, {
      .state('app.contactcenter_dashboard.settings.users', {
        parent: 'app.contactcenter_dashboard.settings',
        url: '/users',
        stateTranslationName: 'DASHBOARD.SETTINGS.USERS',
        params: {},
        views: {
          'mainContent': {
            template: '<user-list  flex></user-list>' //   !!! kontrlka z profile managmentu !!!!
          }
        }
      })
      .state('app.contactcenter_dashboard.settings.users.edit', {
        parent: 'app.contactcenter_dashboard.settings',
        url: '/users/edit/:userId',
        stateTranslationName: 'MANAGEMENT.CALLCENTERS',
        params: {
          userId: null
        },
        views: {
          'mainContent': {
            template: '<user-edit style="width: 100%"></user-edit>'
          }
        }
      })
      .state(menuItems.getMenuItem('DASHBOARD.SETTINGS.CATEGORIES').state, {
        parent: 'app.contactcenter_dashboard.settings',
        url: '/categories',
        stateTranslationName: 'DASHBOARD.SETTINGS.CATEGORIES',
        params: {
          // templateKey: 'userProfile',
          // keepSidenavData: true
        },
        views: {
          'mainContent': {
            template: '<categories flex></categories>'
          }
          // ,
          // 'sidenav':{
          //   template: '<settings-basic></settings-basic>'
          // }
        }
      })
      .state(menuItems.getMenuItem('DASHBOARD.SETTINGS.COMMUNICATOR_CONFIG').state, {
        parent: 'app.contactcenter_dashboard.settings',
        url: '/communicator_config',
        stateTranslationName: 'DASHBOARD.SETTINGS.COMMUNICATOR_CONFIG',
        params: {
          // templateKey: 'userProfile',
          // keepSidenavData: true
        },
        views: {
          'mainContent': {
            template: '<comunnicator-config flex></comunnicator-config>'
          }
        }
      })
      .state(menuItems.getMenuItem('DASHBOARD.SETTINGS.AREAS').state, {
        parent: 'app.contactcenter_dashboard.settings',
        url: '/areas',
        stateTranslationName: 'DASHBOARD.SETTINGS.AREAS',
        params: {
          // templateKey: 'userProfile',
          // keepSidenavData: true
        },
        views: {
          'mainContent': {
            template: '<areas flex></areas>'
          }
        }
      })
      .state(menuItems.getMenuItem('DASHBOARD.SETTINGS.RATES').state, {
        parent: 'app.contactcenter_dashboard.settings',
        url: '/rates',
        stateTranslationName: 'DASHBOARD.SETTINGS.RATES',
        params: {
          // templateKey: 'userProfile',
          // keepSidenavData: true
        },
        views: {
          'mainContent': {
            template: '<rates flex></rates>'
          }
        }
      })
      .state(menuItems.getMenuItem('DASHBOARD.SETTINGS.TIMESHIFT').state, {
        parent: 'app.contactcenter_dashboard.settings',
        url: '/timeshift',
        stateTranslationName: 'DASHBOARD.SETTINGS.TIMESHIFT',
        params: {
          // templateKey: 'userProfile',
          // keepSidenavData: true
        },
        views: {
          'mainContent': {
            template: '<timeshift flex></timeshift>'
          }
        }
      })
      // .state(menuItems.getMenuItem('DASHBOARD.SETTINGS.RATES').state, {
      //   parent: 'app.contactcenter_dashboard.settings',
      //   url: '/billing',
      //   stateTranslationName: menuItems.billdata.name,
      //   params: {
      //     templateKey: 'partnerProfile',
      //     defaultAvatar: 'assets/images/icons/partner.png'
      //   },
      //   views: {
      //     'mainContent': {
      //       template: '<billing-data flex></billing-data>'
      //     }
      //   }
      // })
      // .state(menuItems.getMenuItem('DASHBOARD.SETTINGS.CONSULTANTS').state, {
      //   parent: 'app.contactcenter_dashboard.settings',
      //   url: '/users',
      //   stateTranslationName: 'DASHBOARD.SETTINGS.CONSULTANTS',
      //   statePanelRight: true,
      //   params: {
      //     templateKey: 'userProfile',
      //     defaultAvatar: 'assets/images/icons/konsultanci.png'
      //   },
      //   views: {
      //     'mainContent': {
      //       template: '<user-list  flex></user-list>' //   !!! kontrlka z managmentu !!!!
      //     }
      //   }
      // })
      .state(menuItems.getMenuItem('DASHBOARD.SETTINGS.DESCRIPTION').state, {
        parent: 'app.contactcenter_dashboard.settings',
        url: '/description',
        stateTranslationName: 'DASHBOARD.SETTINGS.DESCRIPTION',
        params: {
          // templateKey: 'userProfile',
          // keepSidenavData: true
        },
        views: {
          'mainContent': {
            template: '<description flex></description>'
          }
        }
      })
      .state(menuItems.getMenuItem('DASHBOARD.SETTINGS.CONSULTANT_SERVICES').state, {
        url: '/consultantServices',
        stateTranslationName: 'DASHBOARD.SETTINGS.CONSULTANT_SERVICES',
        // statePanelRight: true,
        resolve: {
          contentId: ['SessionManager', function (SessionManager) {
            return SessionManager.getUser()['consultantId'];
          }]
        },
        views: {
          'mainContent': {
            template: '<consultant-Services style="width: 100%"></consultant-Services>'
          }
        }
      })
      .state(menuItems.getMenuItem('DASHBOARD.SETTINGS.PARTNER_CONTENT').state, {
        url: '/partnercontent',
        stateTranslationName: 'DASHBOARD.SETTINGS.PARTNER_CONTENT',
        // statePanelRight: true,
        resolve: {
          partnerId: ['SessionManager', function (SessionManager) {
            return SessionManager.getUser()['partnerId'];
          }]
        },
        views: {
          'mainContent': {
            template: '<ta-content flex="100" content-id="$resolve.partnerId" content-type="1" content-url="' + consts.partnerContent + '" ng-cloak></ta-content>'
          }
        }
      });


  }
}();

(function () {
  'use strict';

  angular.module('contactcenter.profilemanagement').component('jiraIntegrationNew', {
    templateUrl: 'app/main/contactcenter/dashboard/profilemanagement/components/issuetracker/jira/jiraintegration.html',
    bindings: {
      config: "="
    },
    controllerAs: 'vm',
    controller: JiraIntegrationNew
  });

  /* @ngInject */
  function JiraIntegrationNew($scope, jiraService) {
    var vm = this;

    $scope.$on("integrateWithIssueTracker", function (evt, data) {
      jiraService.integrateWithJira();
    });

  }
})();

(function () {
  'use strict';

  angular.module('contactcenter.profilemanagement').service('jiraService', JiraService);

  /* @ngInject */
  function JiraService($q, $window, $interval, $localStorage, $filter, $mdDialog, SessionManager, DynamicFactory, toastService, issueTrackerService, ISSUE_TRACKER_NAME) {
    var vm = this;

    vm.getJiraStatuses = getJiraStatuses;
    vm.OauthDance = OauthDance;
    vm.createIssue = createIssue;
    vm.getIssue = getIssue;
    vm.getIssueTypes = getIssueTypes;
    vm.getProjects = getProjects;
    vm.integrateWithJira = integrateWithJira;

    vm.issueStatuses;

    //#region Integration

    function integrateWithJira(noReconnect) {
      return $q(function (resolve, reject) {
        OauthDance(noReconnect).then(function () {
          getJiraStatuses();
          resolve();
        });
      });
    }

    function OauthDance(noReconnect) {
      return $q(function (resolve, reject) {
        requestToken(noReconnect).then(function (result) {
          if (!result.issueTrackerId)
            result.issueTrackerId = ISSUE_TRACKER_NAME.JIRA;
          issueTrackerService.saveUserCredential(result);
          reloadResource(result.accessToken).then(resolve, function (error) {
            OauthDance().then(resolve, function (error) {
              console.log('Wystąpił blad autoryzacji');
              reject('Wystąpił blad autoryzacji');
            });
          });
        }, reject);
      });
    }

    function reloadResource(token) {
      return $q(function (resolve, reject) {
        DynamicFactory.get('jiraRsc', 'reloadResourcesWithToken')(token).then(
          resolve,
          function (err) {
            $localStorage.userCredential = undefined;
            reject();
          }
        );
      });
    }

    function requestToken(noReconnect) {
      return $q(function (resolve, reject) {
        var credential = issueTrackerService.getUserCredential();
        if (credential) resolve(credential);
        else {
          if (noReconnect) {
            reject();
          } else {
            DynamicFactory.get('jiraRsc', 'getOauthLink')().then(function (result) {
              console.log(result);
              openPopup(result.accessToken).then(resolve, reject);
            });
          }
        }
      });
    }

    function openPopup(accessToken) {
      return $q(function (resolve, reject) {
        var popup = window.open(
          accessToken,
          'JIRA',
          'scrollbars=no,width=1000,height=500'
        );
        popup.focus();
        vm.waiting = $interval(function () {
          if (waitForPopup(popup)) {
            popup.close();
            $interval.cancel(vm.waiting);
            readPopup({
              oauth_verifier: getURLParameter('oauth_verifier', popup.location.href),
              oauth_token: getURLParameter('oauth_token', popup.location.href)
            }).then(resolve, reject);
          }
        }, 1000);
      });
    }

    function waitForPopup(popup) {
      return canAccessPopup(popup) && popup.location.href !== 'about:blank';
    }

    function readPopup(data) {
      return $q(function (resolve, reject) {
        if (data.oauth_verifier !== null) {
          console.log('code is: ' + data.oauth_verifier);

          //...get token, etc.
          if (data.oauth_verifier === 'denied') reject('Autoryzacja nie powiodła się');
          else DynamicFactory.get('jiraRsc', 'getOauthToken')(data).then(function (result) {
            console.log('TOKEN!!! ' + result.accessToken);

            resolve({
              accessToken: result.accessToken,
              userId: SessionManager.getUser().userId
            });

          });
        } else {
          console.log('Error requesting code...');
          reject('Error requesting code...');
        }
      });
    }

    function getURLParameter(name, searchUrl) {
      var results = new RegExp('[?&]' + name + '=([^&#]*)').exec(searchUrl);
      return results[1] || 0;
    }

    function canAccessPopup(popup) {
      var html = null;
      try {
        //try reading document
        var doc = popup.document;
        html = doc.body.innerHTML;
      } catch (err) {
        // do nothing
      }
      return html !== null;
    }

    function getJiraStatuses() {
      return $q(function (resolve, reject) {
        if (vm.issueStatuses) {
          resolve(vm.issueStatuses);
        } else {
          DynamicFactory.get('jiraRsc', 'getStatuses')().then(
            function (result) {
              vm.issueStatuses = result;
              resolve(vm.issueStatuses); //statuses' dictionary form JIRA
            },
            function (err) {
              console.log('Problem z pobraniem statusów JIRA');
              reject(undefined);
            });
        }
      });
    }
    //#endregion

    //#region Issue

    function getIssueTypes(projectId) {
      return $q(function (resolve, reject) {
        DynamicFactory.get('jiraRsc', 'getIssueTypes')({
          projectKey: projectId
        }).then(
          function (result) {
            var issueTypes = [];

            angular.forEach(result, function (value, key) {
              if (angular.isString(result[key])) {
                issueTypes.push({
                  id: key,
                  name: result[key]
                });
              }
            });

            resolve(issueTypes);
          },
          function (error) {
            reject(undefined);
          });
      });
    }

    function getProjects() {
      return $q(function (resolve, reject) {
        DynamicFactory.get('jiraRsc', 'getProjects')().then(
          function (result) {
            resolve(result);
          },
          function (error) {
            reject(undefined);
          });

        //vm.projects = result;
        //vm.issue.fields.project = vm.projects[0];
        //getIssueTypes(vm.issue.fields.project.id);
      });
    }

    function createIssue(issue, sessionId, type, contactId) {
      DynamicFactory.get('jiraRsc', 'createIssue')(issue, sessionId, type, contactId).then(
        function (result) {
          console.log('Issue sended!');
          toastService.showToast('Utworzono nowe zgłoszenie nr: ' + result.id, 'success', 3);
        },
        function (err) {
          toastService.showToast('Wystąpił problem z utworzeniem zgłoszenia', 'error', 3);
        }
      );
    }

    function getIssue(issueId) {
      return $q(function (resolve, reject) {
        DynamicFactory.get('jiraRsc', 'getIssue')(issueId).then(
          function (result) {
            console.log('issue: ', result);
            resolve(result);
            //vm.issue = result;
            // jiraService.getProjects();
          },
          function (error) {
            reject();
            toastService.showToast('Wystąpił problem z pobraniem zgłoszenia nr:' + issueId, 'error', 40);
          });
      });

    }

    //#endregion

    return vm;
  }

})();

(function () {
  'use strict';

  angular.module('contactcenter.profilemanagement').component('bugzillaIntegration', {
    templateUrl: 'app/main/contactcenter/dashboard/profilemanagement/components/issuetracker/bugzilla/bugzillaintegration.html',
    bindings: {
      config: "="
    },
    controllerAs: 'vm',
    controller: BugzillaIntegration
  });

  /**@ngInject */
  function BugzillaIntegration($scope, $localStorage, authRolesConst, SessionManager, bugzillaService, issueTrackerService) {
    var vm = this;

    $scope.$on("integrateWithIssueTracker", function (evt, data) {
      //var integrationSucceed;
      bugzillaService.integrateWithBugzilla().then(function (result) {
        if (result) {
          issueTrackerService.saveUserCredential({
            accessToken: vm.config.apiKey,
            userId: SessionManager.getUser().userId,
            issueTrackerId: vm.config.issueTrackerId
          });

          bugzillaService.reloadResource(vm.config.apiKey);
          //integrationSucceed = true;
        }
      }, function(){
        //integrationSucceed = false;
      });

      //$scope.$emit('integrationCompleted', integrationSucceed)
    });

  }
})();

(function () {
  'use strict';

  angular.module('contactcenter.profilemanagement').service('bugzillaService', BugzillaService);

  /**@ngInject */
  function BugzillaService($q, $timeout, $localStorage, DynamicFactory, toastService) {

    var vm = this;
    //vm.isValidToken = isValidToken;
    vm.integrateWithBugzilla = integrateWithBugzilla;
    vm.reloadResource = reloadResource;
    vm.createIssue = createIssue;
    vm.getIssue = getIssue;
    vm.addCommentToIssue = addCommentToIssue;
    vm.getIssueComments = getIssueComments;
    vm.getProducts = getProducts;

    //#region Integration
    function integrateWithBugzilla() {
      return $q(function(resolve, reject){
        isValidToken("programisci@teleaudio.pl").then(
          function(){
            resolve(true);
        });
      });
    }

    function isValidToken(login) {
      return $q(function (resolve, reject) {

        DynamicFactory.get('bugzillaRsc', 'isValidToken')({
          login: login
        }).then(
          function (result) {
            if (result) {
              resolve(true);
            } else {
              resolve(false);
            }
          },
          function (err) {
            console.log('[BUGZILLA]: Problem ze potwierdzeniem ważności tokena');
            reject(err);
          });
      });
    }

    //#endregion

    //#region Create issue
    function createIssue(issue, sessionId, type, contactId) {
      return $q(function (resolve, reject) {
        DynamicFactory.get('bugzillaRsc', 'createIssue')(issue, sessionId, type, contactId).then(
          function (result) {
            toastService.showToast('Utworzono nowe zgłoszenie nr: ' + result.id, 'success', 3);
          },
          function (error) {
            toastService.showToast('Wystąpił problem z utworzeniem zgłoszenia', 'error', 3);
            reject(undefined);
          });
      });
    }

    function getIssue(issueId) {
      return $q(function (resolve, reject) {
        DynamicFactory.get('bugzillaRsc', 'getIssue')(issueId).then(
          function (issue) {
            resolve(issue);
          },
          function (error) {
            toastService.showToast('Wystąpił problem z pobraniem zgłoszenia nr: ' + issueId, 'error', 3);
            reject(undefined);
          });
      });
    }

    function addCommentToIssue(comment, issueId) {
      return $q(function (resolve, reject) {
        DynamicFactory.get('bugzillaRsc', 'addCommentToIssue')(comment, issueId).then(
          function (result) {
            toastService.showToast('Dodano komentarz nr: ' + result.id + ' do zgłoszenia nr: ' + issueId, 'success', 3);
            resolve(result.id);
          },
          function () {
            toastService.showToast('Wystąpił problem z dodaniem komentarza do zgłoszenia nr: ' + issueId, 'error', 3);
            reject(undefined);
          }
        )
      });
    }

    function getIssueComments(issueId) {
      return $q(function (resolve, reject) {
        DynamicFactory.get('bugzillaRsc', 'getIssueComments')(issueId).then(
          function (comments) {
            resolve(comments);
          },
          function () {
            toastService.showToast('Wystąpił problem z pobraniem komentarzy do zgłoszenia nr: ' + issueId, 'error', 3);
            reject(undefined);
          });
      });
    }

    function getProducts() {
      return $q(function (resolve, reject) {
        if (vm.products) {
          resolve(vm.products);
        } else {
          DynamicFactory.get('bugzillaRsc', 'getProducts')().then(
            function (result) {
              vm.products = result;
              resolve(vm.products);
            },
            function (error) {
              console.log('[BUGZILLA]: Problem z pobraniem produktów');
              reject(undefined);
            });
        }
      });
    }

    function reloadResource(token) {
      return $q(function (resolve, reject) {
        DynamicFactory.get('bugzillaRsc', 'reloadResourcesWithToken')(token).then(
          resolve,
          function (err) {
            console.log('[BUGZILLA]: Problem z przeładowaniem resourców');
            $localStorage.userCredential = undefined;
            reject(err);
          }
        );
      });
    }

    //#endregion




    /*

            function reloadResource(token) {
              return $q(function (resolve, reject) {
                DynamicFactory.get('bugzillaRsc', 'reloadResourcesWithToken').then(
                  function (result) {
                    resolve(result)
                  },
                  function (err) {
                    reject(err)
                  }
                )
              })
            }*/

    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('jira', []);

}());

(function () {
  'use strict';

  angular
    .module('jira')
    .filter('jiraWiki', jiraIssueIconStyle);

  /** @ngInject */
  function jiraIssueIconStyle() {
    var deletionArray = [{
        html: 'html'
      },
      {
        html: 'head'
      },
      {
        html: 'div'
      },
      {
        html: 'meta'
      },
      {
        html: '!'
      },
      {
        html: 'title'
      },
      {
        html: 'o',
        content: true
      },
      {
        html: 'xml',
        content: true
      },
      {
        html: 'style',
        content: true
      }
    ];
    var translateArray = [{
        html: 'h1',
        jira: '.h1',
        jiraClosing: false
      },
      {
        html: 'h2',
        jira: '.h2',
        jiraClosing: false
      },
      {
        html: 'h3',
        jira: '.h3',
        jiraClosing: false
      },
      {
        html: 'h4',
        jira: '.h4',
        jiraClosing: false
      },
      {
        html: 'h5',
        jira: '.h5',
        jiraClosing: false
      },
      {
        html: 'h6',
        jira: '.h6',
        jiraClosing: false
      },
      {
        html: 'blockquote',
        jira: '\n {quote} \n',
        jiraClosing: true
      },
      {
        html: 'br/',
        jira: '\n',
        jiraClosing: false
      },
      {
        html: 'b',
        jira: '*',
        jiraClosing: true
      },
      {
        html: 'em',
        jira: '_',
        jiraClosing: true
      },
      {
        html: 'cite',
        jira: '??',
        jiraClosing: true
      },
      {
        html: 'del',
        jira: '-',
        jiraClosing: true
      },
      {
        html: 'ins',
        jira: '+',
        jiraClosing: true
      },
      {
        html: 'sup',
        jira: '^',
        jiraClosing: true
      },
      {
        html: 'sub',
        jira: '~',
        jiraClosing: true
      },
      {
        html: 'tt',
        jira: '{{',
        jiraClosing: '}}'
      },
      {
        html: 'span',
        jira: '',
        jiraClosing: false
      },
      {
        html: 'p',
        jira: '\n',
        jiraClosing: false
      }, {
        html: 'a',
        jira: '[%alt|%href]',
        jiraClosing: false
      },
      {
        html: 'table',
        jira: '\n',
        jiraClosing: true,
        structure: [{
            html: 'thead',
            jira: '|',
            jiraClosing: true,
            structure: [{
              html: 'tr',
              // jira: '',
              structure: [{
                html: 'th',
                jira: '|',
                jiraClosing: true
              }]
            }]
          },
          {
            html: 'tbody',
            // jira: '|',
            // jiraClosing: true,
            structure: [{
              html: 'tr',
              jira: '|',
              jiraClosing: '|\n',
              structure: [{
                html: 'td',
                // jira: '|',
                jiraClosing: '|'
              }]
            }]
          }
        ]
      }
    ];

    function regexBetween(textScope, tag) {
      var regex = new RegExp('(<' + tag + '(.)+?>)(.*)(</' + tag + '>)', 'igm');

      var result = textScope.match(regex);
      console.log('regexBetween ' + tag + ': ', result, regex);
      if (result !== null) {
        return result[0];
      } else return '';
    }

    function regexGetAttribute(textScope, attr) {
      var regex = new RegExp(attr + '=s)*"(.*?)"', 'ig');

      var result = textScope.match(regex);
      console.log('regexGetAttr' + tag + ': ', result, regex);
      if (result !== null) {
        return result[0];
      } else return '';
    }

    // /(href=\s)*'(.*?)'/gi;
    function simpleReplace(textScope, regexStr, patch) {
      var regex = new RegExp(regexStr, 'ig');
      // console.log(regex);
      return textScope.replace(regex, patch);
    }

    function regexReplace(textScope, translateObj) {
      if (!translateObj.jira) translateObj.jira = '';
      // var regex =new RegExp('<' + translateObj.html + '(.|\n|\r)+?>', 'gm');
      // textScope = textScope.replace(regex,translateObj.jira);
      textScope = simpleReplace(
        textScope,
        '<' + translateObj.html + '(.)*?>',
        translateObj.jira
      );

      var patch = !translateObj.jiraClosing ?
        '' :
        angular.isString(translateObj.jiraClosing) ?
        translateObj.jiraClosing :
        translateObj.jira;
      textScope = simpleReplace(
        textScope,
        '</' + translateObj.html + '(.)*?>',
        patch
      );

      // var regexEnd =new RegExp('<\/' + translateObj.html + '(.|\n|\r)+?>', 'gm');
      // if(translateObj.jiraClosing){
      //   textScope = textScope.replace(regexEnd, angular.isString(translateObj.jiraClosing) ? translateObj.jiraClosing : translateObj.jira);
      // } else {
      //   textScope = textScope.replace(regexEnd, '');
      // }
      return textScope;
    }

    function replacePattern(pattern, attrObj) {
      attrObj.forEach(function (item) {
        pattern = simpleReplace(pattern, '%' + item.attr, item.value);
      });
      return pattern;
    }

    function parseToJira(translateArray, textScope) {
      translateArray.forEach(function (item) {
        var regex = new RegExp(item.html, 'gi');
        var match = textScope.match(regex);

        if (match !== null && match.length > 0) {
          console.log(item.html + ' match:', regex);
          if (item.structure) {
            // var between = regexBetween(textScope, item.html);
            textScope = parseToJira(item.structure, textScope);
          } else if (item.attributes) {
            var occurences = regexBetween(textScope, item.html);
            occurences.forEach(function (scope) {
              var attrObj = item.attributes.map(function (attr) {
                return {
                  value: regexGetAttribute(scope, attr),
                  attr: attr
                };
              });
              textScope = textScope.replace(scope, replacePattern(item.jira, attrObj));
            });
          } else {
            textScope = regexReplace(textScope, item);
          }
        }
      });
      // console.log(textScope);
      return textScope;
    }

    function deleteFormat(deletionArray, textScope) {
      deletionArray.forEach(function (item) {
        if (item.content) {
          var regex = new RegExp(
            '(<' + item.html + '(.)*?>)(.*)(</' + item.html + '>)',
            'igm'
          );

          textScope = textScope.replace(regex, '');
        } else {
          textScope = textScope.replace(
            new RegExp('<' + item.html + '(.)*?>', 'igm'),
            ''
          );
          textScope = textScope.replace(
            new RegExp('</' + item.html + '(.)*?>', 'igm'),
            ''
          );
        }
      });
      return textScope;
    }

    return function (text) {
      // translateArray.forEach(function (item) {
      //   var regex = new RegExp('<' + item.html + '>', 'gm');
      //   text = text.replace(regex, item.jira);
      //   regex = new RegExp('<\/' + item.html + '>', 'gm');
      //   if (item.jiraClosing) {
      //     text = text.replace(regex, angular.isString(item.jiraClosing) ? item.jiraClosing : item.jira);
      //   } else {
      //     text = text.replace(regex, '');
      //   }
      // });
      // var i = /<table(.|\n|\r)+?<\/table>/gm;
      // console.log('source: ',text);
      return parseToJira(
        translateArray,
        deleteFormat(deletionArray, text.replace(/\r?\n|\r/gm, ''))
      );
    };
  }
})();

(function () {
  'use strict';

  angular.module('jira')
    .filter('jiraIssueIconTooltip', jiraIssueIconTooltip)
    .constant('status', {
      NEW: "new",
      TODO: "10000"
    });

  /* @ngInject */
  function jiraIssueIconTooltip(status) {
    return function (statusId, issueStatuses) {
      if (!statusId) return "";

      if (!issueStatuses) {
        statusId = "Wymagana integracja z JIRA w celu pobrania aktualnych statusów zgłoszeń";
      } else {
        if (statusId == status.NEW) statusId = status.TODO;
        angular.forEach(issueStatuses, function (status) {
          if (status.id == statusId) {
            statusId = status.name;
          }
        });
      }
      return statusId;
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('jira')
    .filter('jiraIssueIconStyle', jiraIssueIconStyle);

  /* @ngInject */
  function jiraIssueIconStyle(status) {
    return function (statusId, issueStatuses) {
      if (!statusId) return "icon-jira";

      if (statusId == status.NEW) statusId = status.TODO;
      angular.forEach(issueStatuses, function (status) {
        if (status.id == statusId) {
          if (status.statusCategory.colorName.indexOf('gray') > 0) {
            statusId = 'blue';
          } else {
            statusId = status.statusCategory.colorName;
          }
        }
      });

      return 'ico-type icon-jira ' + statusId + '-800-fg';
    };
  }
})();

+(function () {
  'use strict';

  angular
    .module('bugzilla', [])
    .constant('bugzillaStatus', {
      NEW: "new",
      TODO: "CONFIRMED"
    });

}());

(function () {
  'use strict';

  angular
    .module('bugzilla')
    .filter('bugzillaIssueIconTooltip', BugzillaIssueIconTooltip)

  /* @ngInject */
  function BugzillaIssueIconTooltip(bugzillaStatus) {
    return function (statusId, isIntegrated) {
      if (!statusId) return "";

      if (!isIntegrated) {
        statusId = "Wymagana integracja z BUGZILLA w celu pobrania aktualnych statusów zgłoszeń";
      } else {
        if (statusId == bugzillaStatus.NEW) statusId = bugzillaStatus.TODO;
      }

      return statusId;
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('bugzilla')
    .filter('bugzillaIssueIconStyle', BugzillaIssueIconStyle)

  /* @ngInject */
  function BugzillaIssueIconStyle(bugzillaStatus) {
    return function (statusId) {
      if (!statusId) return "icon-android";

      if (statusId == bugzillaStatus.NEW) statusId = bugzillaStatus.TODO;

      statusId = statusId
        .replace('CONFIRMED', 'blue')
        .replace('IN_PROGRESS', 'yellow')
        .replace('RESOLVED', 'green')

      return 'ico-type icon-android ' + statusId + '-800-fg';
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('contactcenter.reports')
    .component('smsAggregation', {
      templateUrl: 'app/main/contactcenter/reports/components/reportstatssms/aggregation/aggregation.html',
      require: {
        tripleView: '^tripleView'
      },
      controllerAs: 'vm',
      controller: controller
    });

  function controller(DynamicFactory, SessionManager, authRolesConst, tripleviewService, ReportsData, donutChart, $timeout, ReportTools) {
    var vm = this;


    //Resource
    // vm.getReportsSMSMessageListAgregation = DynamicFactory.get('reportsCosult', 'ReportsSMSMessageListAgregation');
    // vm.getCallCenterList = DynamicFactory.get('reportsCosult', 'CallCenterList');
    // vm.getConsultants = DynamicFactory.get('reportsCosult', 'ConsultansGet');

    //others
    vm.SessionManager = SessionManager;
    vm.authRolesConst = authRolesConst;
    // vm.mainChart = ReportsData.defaultChartConf;
    vm.mainDonutChart = donutChart.donutChart;
    vm.pageSize = 10;
    vm.pageNumber = 0;
    vm.chartProp = 'smsMessagesCount';

    vm.$onInit = onInit;


    function onInit() {
      vm.dateType = ReportsData.dateType;
      vm.showChart = true;

      vm.consultantList = [];
      vm.SessionManager = SessionManager;
      vm.authRolesConst = authRolesConst;

      setTripleView();

      getMessageAgregationAsync();

    }

    function setTripleView() {
      tripleviewService.sidenavData.getConnectData = getMessageAgregationAsync;
      // tripleviewService.sidenavData.showChart = showChart;
      // tripleviewService.sidenavData.config = {
      //   tagsAgr: true
      // };
      vm.getParams = ReportTools.configReportParams({
        CallcenterId: SessionManager.getUserRoleId() !== authRolesConst.consultant,
        ConsultantId: SessionManager.getUserRoleId() !== authRolesConst.consultant,
        agreagation: true,
        direction: true,
        msisdn: true,
        // type: true
      }, currentPage);
      tripleviewService.sidenavData.agregationDate = [];
      tripleviewService.sidenavData.duration = 3;
      tripleviewService.sidenavData.startValue = '';
    }

    function currentPage() {
      return {
        StartIndex: (vm.pageSize * vm.pageNumber) + 1,
        PageSize: vm.pageSize
      }
    }

    function getMessageAgregationAsync() {
      vm.pageNumber = 0;
      // ReportTools.getConsultantList().then(function (result) {
      //   vm.filtersConsultants = result;
      //   // getFilterDates();
        getReport();
        getChart();
      // });
    }

    function getReport() {
      DynamicFactory.get('reportsCosult', 'ReportsSMSMessageListAgregation')(vm.getParams()).then(
        function (contactcenterStats) {
          vm.report = angular.copy(contactcenterStats);
          if (vm.report && vm.report.length != 0) {
            vm.tagsColumn = angular.copy(tripleviewService.sidenavData.params.tagsAgr);
            // vm.summary = getSummary();
          }
        },
        function (error) {
          console.log("Problem z pobraniem SMSConnections");
        });
    }

    function getChart() {
      // getFilterDates();
      setChartPlugin();
      if (tripleviewService.sidenavData.finalDate) setWidthOnChart(tripleviewService.sidenavData.finalDate.date);


      DynamicFactory.get('reportsCosult', 'ReportsConnectionsCCAgrForChart')(vm.getParams()).then(
        generateChart,
        function (error) {
          console.log("Wystapił błąd podczas pobierania statystyk wiadomości sms/mms do wyrysowania wykresu");
        });
    }

    function generateChart(contactcenterStats) {
      if (contactcenterStats.length > 0) {
        var chart = [];

        var groupedByDate = _.groupBy(contactcenterStats, 'name');

        var allDates = _.uniq(_.map(contactcenterStats, _.property('ts')));
        for (var key in groupedByDate) {
          var period = groupedByDate[key];

          chart.push({
            color: ReportsData.getNextColor(),
            key: key,
            values: generateSeries(period, allDates)
          });
        }

        vm.mainChart.data = _.sortBy(chart, function (item) {
          return item.values[0].y;
        });
      }
    }

    function generateSeries(period, allDates) {
      var groupedPeriod = _.groupBy(period, 'ts');
      // var res
      return allDates.map(function (item) {
        if (groupedPeriod[item]) {
          return {
            x: item,
            y: groupedPeriod[item][0].quantity || 0
          }
        } else {
          return {
            x: item,
            y: 0
          }
        }
      });
    }


    function setWidthOnChart(data) {
      vm.mainChart.options.chart.width = undefined;
    }



    function setChartPlugin() {
      vm.dateType = ReportsData.dateType;

      var mainChart = angular.copy(ReportsData.defaultChartConf);

      mainChart.options.chart.type = 'multiBarChart';
      mainChart.options.chart.color = _.map(ReportsData.colors, 'color');
      mainChart.options.chart.height = 250;
      mainChart.options.chart.width = null;
      mainChart.options.chart.showLegend = false;
      mainChart.options.chart.stacked = true;
      mainChart.options.chart.xAxis = {
        tickFormat: function (d) {
          return d;
        },
        rotateLabels: -20
      };
      mainChart.options.chart.showControls = false;

      vm.mainChart = mainChart;
    }


    function downloadXLSX() {
      alasql("SELECT contactcenter,tag,quantity,minutes,avgminutes INTO XLSX('" + ("AgregacjePołączenContactCenter_" + moment().format()) + ".xlsx',{headers:true}) FROM ? ", [vm.report]);
    }


    // function showChart() {
    //   vm.showChart = tripleviewService.sidenavData.showMyChart;
    //   if (vm.showChart) {
    //     document.querySelector('.chartForReports').classList.remove('listNoChart');
    //   } else {
    //     document.querySelector('.chartForReports').classList.add('listNoChart');
    //   }
    //   getMessageAgregationAsync();
    // }

    // function getFilterDates() {
    //   if (!tripleviewService.sidenavData.dateFrom && !tripleviewService.sidenavData.dateTo) {
    //     tripleviewService.sidenavData.params.From = tripleviewService.sidenavData.listDate[0].date.from;
    //     tripleviewService.sidenavData.params.To = tripleviewService.sidenavData.listDate[0].date.to;
    //   } else {
    //     tripleviewService.sidenavData.params.From = tripleviewService.sidenavData.dateFrom;
    //     tripleviewService.sidenavData.params.To = tripleviewService.sidenavData.dateTo;
    //   }
    // }

    // function getSummary() {
    //   var result = [];
    //   if (vm.tagsColumn) {
    //     var tagsGrouped = _.groupBy(vm.report, 'tag');
    //     for (var key in tagsGrouped) {
    //       var tagSum = generateSummary(tagsGrouped[key]);
    //       tagSum.tag = key;
    //       result.push(tagSum);
    //     }
    //   } else {
    //     result = [generateSummary(vm.report)];
    //   }
    //   return result;
    // }

    // function generateSummary(period) {
    //   return {
    //     quantity: _.sumBy(period, function (o) {
    //       return o.quantity;
    //     }),
    //     intminutes: ReportTools.formatSecs(_.sumBy(period, function (o) {
    //       return o.secs;
    //     })),
    //     intavg: ReportTools.formatSecs(_.sumBy(period, function (o) {
    //       return o.avgsecs;
    //     }) / period.length)
    //   }
    // }

















































    // function onInit() {
    //     $timeout(function () {
    //         getReportsSMSMessageListAgregationAsync();
    //     }, 500);
    //     setTripleView();
    //     getCallcenterPerManager();
    //     if (SessionManager.getUserRoleId() === authRolesConst.manager) generateConsultantPerContactCenter();
    // }

    // function setChartOptions() {
    //     //normal chart
    //     vm.mainChart.options.chart.type = 'discreteBarChart';
    //     vm.mainChart.options.chart.height = 320;
    //     vm.mainChart.options.chart.color = _.map(ReportsData.colors, 'color');
    //     vm.mainChart.options.chart.valueFormat = function (d) { return d; };
    //     vm.mainChart.options.chart.showXAxis = true;
    //     vm.mainChart.options.chart.yAxis = {
    //         tickFormat: function (d) {
    //             return d;
    //         }
    //     };
    //     // vm.mainChart.options.chart.rotateLabels = 90;

    //     //donut chart
    //     // vm.mainDonutChart.options.chart.type = 'pieChart';
    //     // vm.mainDonutChart.options.chart.color = _.map(donutChart.colors, 'color');
    //     // vm.mainDonutChart.options.title = {
    //     //     enable: false
    //     // }
    //     // vm.mainDonutChart.options.chart
    // }

    // function setTripleView() {
    //     tripleviewService.sidenavData.config = {
    //         type: false,
    //         direction: false,
    //         callcenter: true,
    //         consultantList: true,
    //         agreagation: false,
    //         timeAgr: false,
    //         showChart: false
    //     };
    // }

    // function getReportsSMSMessageListAgregationAsync() {
    //     var raportFromDate, reportToDate;
    //     if (!tripleviewService.sidenavData.dateFrom && !tripleviewService.sidenavData.dateTo) {
    //         raportFromDate = tripleviewService.sidenavData.listDate[0].date.from;
    //         reportToDate = tripleviewService.sidenavData.listDate[0].date.to;
    //     } else {
    //         raportFromDate = tripleviewService.sidenavData.dateFrom;
    //         reportToDate = tripleviewService.sidenavData.dateTo;
    //     }

    //     var direction = tripleviewService.sidenavData.direction,
    //         consultantID = tripleviewService.sidenavData.userID,
    //         callCenterID = tripleviewService.sidenavData.id;

    //     if (!SessionManager.getUserRoleId() === authRolesConst.admin) {
    //         vm.getReportsSMSMessageListAgregation(raportFromDate, reportToDate, userInfo.callCenterId, consultantID, direction, 1, 200).then(function (resource) {
    //             vm.msgAggregationList = resource;
    //             groupDate();
    //         });
    //     } else {
    //         vm.getReportsSMSMessageListAgregation(raportFromDate, reportToDate, callCenterID, consultantID, direction, 1, 200).then(function (resource) {
    //             vm.msgAggregationList = resource;
    //             groupDate();
    //         });
    //     }
    // }

    function groupDate() {
      // vm.reportGroup = [];
      vm.mainChart.data = [];
      vm.mainDonutChart.data = [];
      var reportGroup = _(vm.msgAggregationList)
        .groupBy(function (result) {
          return result['consultantName'];
        })
        .map(function (value, key) {
          if (vm.msgAggregationList.length > 1) {
            vm.countMsg = _.sumBy(value, 'countMsg');
          } else {
            _.forEach(value, function (v) {
              vm.countMsg = v.countMsg;
            });
          }
          return {
            consultant: key,
            count: vm.countMsg
          };
        }).value();

      _.forEach(reportGroup, function (k) {
        var row = _.find(vm.mainChart.data, {
            'consultant': k.consultant
          }),
          donutRow = _.find(vm.mainDonutChart.data, {
            'consultant': k.consultant
          });

        if (!row) {
          row = {
            'consultant': k.consultant,
            values: []
          };
          vm.mainChart.data.push(row);
        }
        row.values.push({
          x: k.consultant,
          y: k.count
        });

        console.log('vm.mainChart.data', k);
        if (!donutRow) {
          donutRow = {
            'key': k.consultant,
            'y': k.count
          };
          vm.mainDonutChart.data.push(donutRow);
        };

        donutRow.values.push(donutRow);
      });
    }

    // function getCallcenterPerManager() {
    //     if (SessionManager.getUserRoleId() === authRolesConst.admin) {
    //         vm.getCallCenterList().then(function (r) {
    //             tripleviewService.sidenavData.callCenterList = r;
    //             generateConsultantPerContactCenter();
    //         });
    //     }
    // }

    // function generateConsultantPerContactCenter() {
    //     if (SessionManager.getUserRoleId() === authRolesConst.admin) {
    //         vm.getConsultants(tripleviewService.sidenavData.id).then(function (r) {
    //             tripleviewService.sidenavData.consultantsPerCC = r;
    //             vm.consultantList = r;
    //         });
    //     } else {
    //         vm.getConsultants(userInfo.callCenterId).then(function (r) {
    //             tripleviewService.sidenavData.consultantsPerCC = r;
    //             vm.consultantList = r;
    //         });
    //     }
    // }

    // function generateDate(date) {
    //     tripleviewService.sidenavData.dateFrom = date.from;
    //     tripleviewService.sidenavData.dateTo = date.to;
    //     setLastDateToAnyDate(date);

    //     tripleviewService.sidenavData.disableDate = date.disabled;
    // }

    // function setLastDateToAnyDate(date) {
    //     var anyDate = _.filter(tripleviewService.sidenavData.listDate, {
    //         'name': 'Dowolna data'
    //     });
    //     _.forEach(anyDate, function (value) {
    //         value.date.from = date.from;
    //         value.date.to = date.to;
    //     });
    // }
  }
})();

(function () {
  'use strict';

  angular
    .module('contactcenter.reports')
    .component('percontactcenter', {
      templateUrl: 'app/main/contactcenter/reports/components/reportstatscalls/percontactcenter/percontactcenter.html',
      controllerAs: 'vm',
      require: {
        tripleView: '^tripleView'
      },
      controller: controller
    });

  function controller(DynamicFactory, tripleviewService, ReportsData, ReportTools, SessionManager, authRolesConst) {
    var vm = this;

    vm.downloadXLSX = downloadXLSX;

    vm.$onInit = onInit;
    vm.pageSize = 1000;



    function onInit() {
      vm.dateType = ReportsData.dateType;
      vm.showChart = true;

      vm.consultantList = [];
      vm.SessionManager = SessionManager;
      vm.authRolesConst = authRolesConst;

      setTripleView();

      getFilteredContactcenterStats();

    }

    function setTripleView() {
      tripleviewService.sidenavData.getConnectData = getFilteredContactcenterStats;
      // tripleviewService.sidenavData.showChart = showChart;
      // tripleviewService.sidenavData.config = {
      //   tagsAgr: true
      // };
      vm.getParams = ReportTools.configReportParams({
        tagsAgr: true
      });
      tripleviewService.sidenavData.agregationDate = [];
      tripleviewService.sidenavData.duration = 3;
      tripleviewService.sidenavData.startValue = '';
    }

    // function currentPage(){
    //   return {
    //     StartIndex: (vm.pageSize * vm.pageNumber) + 1,
    //     PageSize: vm.pageSize
    //   }
    // }

    function getFilteredContactcenterStats() {
      vm.pageNumber = 0;
      // ReportTools.getConsultantList().then(function (result) {
      //   vm.filtersConsultants = result;
      //   // getFilterDates();
        getReport();
        getChart();
      // });
    }

    function getReport() {
      DynamicFactory.get('reportsCosult', 'ReportsConnectionsCCAgr')(vm.getParams({PageSize: vm.pageSize})).then(
        function (contactcenterStats) {
          vm.report = angular.copy(contactcenterStats);
          if (vm.report && vm.report.length != 0) {
            vm.tagsColumn = angular.copy(tripleviewService.sidenavData.params.tagsAgr);
            vm.summary = getSummary();
          }
        },
        function (error) {
          console.log("Problem z pobraniem IVRConnections");
        });
    }

    function getSummary() {
      var result = [];
      if (vm.tagsColumn) {
        var tagsGrouped = _.groupBy(vm.report, 'tag');
        for (var key in tagsGrouped) {
          var tagSum = generateSummary(tagsGrouped[key]);
          tagSum.tag = key;
          result.push(tagSum);
        }
      } else {
        result = [generateSummary(vm.report)];
      }
      return result;
    }

    function generateSummary(period) {
      return {
        quantity: _.sumBy(period, function (o) {
          return o.quantity;
        }),
        intminutes: ReportTools.formatSecs(_.sumBy(period, function (o) {
          return o.secs;
        })),
        intavg: ReportTools.formatSecs(_.sumBy(period, function (o) {
          return o.avgsecs;
        }) / period.length),
        myminutes: _.sumBy(period, function (o) {
          return o.myminutes;
        }),
        orderedminutes: _.sumBy(period, function (o) {
          return o.intminutes;
        }) - _.sumBy(period, function (o) {
          return o.myminutes;
        }),
      }
    }

    function getChart() {
      // getFilterDates();
      setChartPlugin();
      if (tripleviewService.sidenavData.finalDate) setWidthOnChart(tripleviewService.sidenavData.finalDate.date);


      DynamicFactory.get('reportsCosult', 'ReportsConnectionsCCAgrForChart')(vm.getParams()).then(
        generateChart,
        function (error) {
          console.log("Wystapił błąd podczas pobierania statystyk wiadomości sms/mms do wyrysowania wykresu");
        });
    }

    function generateChart(contactcenterStats) {
      if (contactcenterStats.length > 0) {
        var chart = [];

        var groupedByDate = _.groupBy(contactcenterStats, 'name');

        var allDates = _.uniq(_.map(contactcenterStats, _.property('ts')));
        for (var key in groupedByDate) {
          var period = groupedByDate[key];

          chart.push({
            color: ReportsData.getNextColor(),
            key: key,
            values: generateSeries(period, allDates)
          });
        }

        vm.mainChart.data = _.sortBy(chart, function (item) {
          return item.values[0].y;
        });
      }
    }

    function generateSeries(period, allDates) {
      var groupedPeriod = _.groupBy(period, 'ts');
      // var res
      return allDates.map(function (item) {
        if (groupedPeriod[item]) {
          return {
            x: item,
            y: groupedPeriod[item][0].quantity || 0
          }
        } else {
          return {
            x: item,
            y: 0
          }
        }
      });
    }


    function setWidthOnChart(data) {
      vm.mainChart.options.chart.width = undefined;
    }

    // function showChart() {
    //   vm.showChart = tripleviewService.sidenavData.showMyChart;
    //   if (vm.showChart) {
    //     document.querySelector('.chartForReports').classList.remove('listNoChart');
    //   } else {
    //     document.querySelector('.chartForReports').classList.add('listNoChart');
    //   }
    //   getFilteredContactcenterStats();
    // }

    // function getFilterDates() {
    //   if (!tripleviewService.sidenavData.dateFrom && !tripleviewService.sidenavData.dateTo) {
    //     tripleviewService.sidenavData.params.From = tripleviewService.sidenavData.listDate[0].date.from;
    //     tripleviewService.sidenavData.params.To = tripleviewService.sidenavData.listDate[0].date.to;
    //   } else {
    //     tripleviewService.sidenavData.params.From = tripleviewService.sidenavData.dateFrom;
    //     tripleviewService.sidenavData.params.To = tripleviewService.sidenavData.dateTo;
    //   }
    // }

    function setChartPlugin() {
      vm.dateType = ReportsData.dateType;

      var mainChart = angular.copy(ReportsData.defaultChartConf);

      mainChart.options.chart.type = 'multiBarChart';
      mainChart.options.chart.color = _.map(ReportsData.colors, 'color');
      mainChart.options.chart.height = 250;
      mainChart.options.chart.width = null;
      mainChart.options.chart.showLegend = false;
      mainChart.options.chart.stacked = true;
      mainChart.options.chart.xAxis = {
        tickFormat: function (d) {
          return d;
        },
        rotateLabels: -20
      };
      mainChart.options.chart.showControls = false;

      vm.mainChart = mainChart;
    }


    function downloadXLSX() {
      alasql("SELECT contactcenter,tag,quantity,minutes,secs,avgminutes,avgsecs INTO XLSX('" + ("AgregacjePołączenContactCenter_" + moment().format()) + ".xlsx',{headers:true}) FROM ? ", [vm.report]);
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('contactcenter.reports')
    .component('reportStatsCallsPerConsultant', {
      templateUrl: 'app/main/contactcenter/reports/components/reportstatscalls/perconsultant/perconsultant.html',
      controllerAs: 'vm',
      require: {
        tripleView: '^tripleView'
      },
      controller: reportstatscalls
    });

  function reportstatscalls(DynamicFactory, SessionManager, tripleviewService, headerConfig, ReportsData, ReportTools, $filter, authRolesConst, connectionStatisticFuncService) {
    var vm = this;
    vm.timeHtml = timeHtml;
    vm.setPage = setPage;
    vm.changeChart = changeChart;
    vm.downloadXLSX = downloadXLSX;
    vm.$onInit = onInit;

    //other
    vm.currentType = 'MM-YYYY';
    vm.timeChart = 'miesięczny';
    vm.pageSize = 10;
    vm.pageNumber = 0;
    vm.chartProp = 'count';

    function onInit() {
      vm.navBarConfig = headerConfig.navBar;
      vm.dateType = ReportsData.dateType;
      vm.showChart = true;

      vm.consultantList = [];
      vm.SessionManager = SessionManager;
      vm.authRolesConst = authRolesConst;

      setTripleView();
      getFilteredConsultantsCallsStatistics();

    } // the end onInit();

    //#region TripleView

    function setTripleView() {
      tripleviewService.sidenavData.getConnectData = getFilteredConsultantsCallsStatistics;
      // tripleviewService.sidenavData.showChart = showChart;

      vm.getParams = ReportTools.configReportParams({
        CallcenterId:true,
        ConsultantId:true,
        // callcenter: true,
        // consultantList: true,
        agreagation: true,
        timeAgr: true,
        // showChart: true,
        tagsAgr: true
      },currentPage);

      // tripleviewService.sidenavData.config = {
      //   type: false,
      //   direction: false,
      //   callcenter: true,
      //   consultantList: true,
      //   agreagation: true,
      //   timeAgr: true,
      //   showChart: true,
      //   tagsAgr: true
      // };

      tripleviewService.sidenavData.agregationDate = [];
      tripleviewService.sidenavData.duration = 3;
      tripleviewService.sidenavData.startValue = '';
    }
    function currentPage(){
      return {
        AggregationType: vm.SessionManager.getUserRoleId() == vm.authRolesConst.consultant ? 'D' : null,
        StartIndex: (vm.pageSize * vm.pageNumber) + 1,
        PageSize: vm.pageSize
      }
    }

    function chartTimeFormat(d) {
      if (vm.chartProp !== 'count') {
        return ReportTools.formatSecs(d);
      } else return d;
    }

    //#endregion
    function changeChart(prop) {
      vm.chartProp = prop;
      if (SessionManager.getUserRoleId() == authRolesConst.consultant) {
        generateChartForConsultant(vm.chartSource);
      } else {
        generateChart(vm.chartSource);
      }
    }
    //#region Chart Plugin
    function setChartPlugin() {

      vm.dateType = ReportsData.dateType;
      var mainChart = angular.copy(ReportsData.defaultChartConf);
      mainChart.options.chart.type = 'multiBarChart';
      mainChart.options.chart.color = _.map(ReportsData.colors, 'color');
      mainChart.options.chart.height = 250;
      mainChart.options.chart.width = null;
      mainChart.options.chart.showLegend = false;
      mainChart.options.chart.xAxis = {
        tickFormat: function (d) {
          return d;
        },
        rotateLabels: -20
      };
      mainChart.options.chart.valueFormat = chartTimeFormat;
      mainChart.options.chart.yAxis = {
        tickFormat: chartTimeFormat
      };
      mainChart.options.chart.showControls = false;
      vm.mainChart = mainChart;
    }


    function getFilteredConsultantsCallsStatistics() {
      vm.pageNumber = 0;
      if (vm.SessionManager.getUserRoleId() !== vm.authRolesConst.consultant) {
        ReportTools.getConsultantList().then(function (result) {
          vm.filtersConsultants = result;
          getReport();
          getChart();
        });
      } else {
        getReport();
        getChart();
      }
    }

    // function getParams() {
    //   getFilterDates();
    //   var agreagation = vm.SessionManager.getUserRoleId() == vm.authRolesConst.consultant ? 'D' : null;
    //   return {
    //     From: tripleviewService.sidenavData.params.From,
    //     To: tripleviewService.sidenavData.params.To,
    //     AggregationType: agreagation,
    //     CallcenterId: tripleviewService.sidenavData.id,
    //     ConsultantId: tripleviewService.sidenavData.userID,
    //     StartIndex: (vm.pageSize * vm.pageNumber) + 1,
    //     PageSize: vm.pageSize,
    //     tagsAgr: tripleviewService.sidenavData.params.tagsAgr,
    //     Rating: "TOP 20",
    //   }
    // }

    function getReport() {
      DynamicFactory.get('reportsCosult', 'ReportsConnectionsAgr')(vm.getParams()).then(
        function (consultantsCallsStatistics) {
          vm.report = angular.copy(consultantsCallsStatistics.raport);
          if (vm.report && vm.report.length != 0) {
            vm.summary = angular.copy(consultantsCallsStatistics.summary);
            vm.tagsColumn = angular.copy(tripleviewService.sidenavData.params.tagsAgr);
            generatePages()
          }
        },
        function (error) {
          console.log("Problem z pobraniem IVRConnections");
        });
    }

    function getChart() {
      // getFilterDates();
      setChartPlugin();
      if (tripleviewService.sidenavData.finalDate) setWidthOnChart(tripleviewService.sidenavData.finalDate.date);

      // var agreagation = SessionManager.getUserRoleId() == authRolesConst.consultant || tripleviewService.sidenavData.userID ? 'D' : null;

      // var currentAggregationType;
      // if (vm.currentAggregationType == 'MM-YYYY') {
      //   currentAggregationType = 'M';
      // } else if (vm.currentAggregationType == 'DD-MM-YYYY') {
      //   currentAggregationType = 'D';
      // } else if (vm.currentAggregationType == 'HH') {
      //   currentAggregationType = 'H';
      // } else {
      //   currentAggregationType = undefined;
      // }

      DynamicFactory.get('reportsCosult', 'ReportsConnectionsAgrForChart')(vm.getParams({
        Rating: "TOP 20"
      })).then(
        SessionManager.getUserRoleId() == authRolesConst.consultant || tripleviewService.sidenavData.userID ? generateChartForConsultant : generateChart,
        function (error) {
          console.log("Wystapił błąd podczas pobierania statystyk wiadomości sms/mms do wyrysowania wykresu");
        });
    }

    function generateChart(consultantsCallsStats) {
      vm.chartSource = consultantsCallsStats;
      if (consultantsCallsStats.length > 0) {
        var chart = [];
        var groupedByDate = _.groupBy(consultantsCallsStats, 'timePeriod');

        for (var key in groupedByDate) {
          var period = groupedByDate[key];

          chart.push({
            key: key,
            values: generateSeriesForDate(_.reverse(_.sortBy(period, vm.chartProp)))
          })
        }
        vm.mainChart.data = chart;
      }
    }

    function generateSeriesForDate(period) {
      return period.map(function (item) {
        var consultant = findConsultant(vm.filtersConsultants ? vm.filtersConsultants : vm.report, item.consultantId);
        return {
          color: ReportsData.getNextColor(),
          x: consultant.consultantName ? consultant.consultantName : (consultant.alias || consultant.consultantName || (consultant.firstName+' '+consultant.lastName)),
          y: item[vm.chartProp] || 0
        }
      });
    }

    function generateChartForConsultant(consultantsCallsStats) {
      vm.chartSource = consultantsCallsStats;
      var result = connectionStatisticFuncService.groupData(consultantsCallsStats, tripleviewService.sidenavData.params.From, tripleviewService.sidenavData.params.To);

      switch (vm.chartProp) {
        case 'avgSeconds':
          vm.mainChart.data = result.dataAvgSeconds;
          break;
        case 'seconds':
          vm.mainChart.data = result.dataSeconds;
          break;
        default:
        case 'count':
          vm.mainChart.data = result.dataCount;
          break;
      }
    }

    function findConsultant(array, consultantId) {
      var consultantCallsCount = _.find(array, function (item) {
        return item.consultantID == consultantId;
      });

      return consultantCallsCount;
    }


    function setPage(newPage) {
      vm.pageNumber = newPage;
      getReport();
    }

    function generatePages() {
      var totalPages = Math.round(vm.report[0].consultantsTotal / vm.pageSize + 0.5)
      console.log('reportStatsCallsPerConsultant | total pages=', totalPages);
      vm.reportPages = [];
      for (var i = 0; i < totalPages; i++) {
        vm.reportPages.push(i);
      }
    }
    //#endregion


    // function getFilterDates() {
    //   if (!tripleviewService.sidenavData.dateFrom && !tripleviewService.sidenavData.dateTo) {
    //     tripleviewService.sidenavData.params.From = tripleviewService.sidenavData.listDate[0].date.from;
    //     tripleviewService.sidenavData.params.To = tripleviewService.sidenavData.listDate[0].date.to;
    //   } else {
    //     tripleviewService.sidenavData.params.From = tripleviewService.sidenavData.dateFrom;
    //     tripleviewService.sidenavData.params.To = tripleviewService.sidenavData.dateTo;
    //   }
    // }

    function timeHtml(data) {
      return $filter('timer')(data);
    }

    //#endregion

    // var prevCallCenter;

    function setWidthOnChart(data) {
      vm.mainChart.options.chart.width = undefined;
    }

    function downloadXLSX() {
      DynamicFactory.get('reportsCosult', 'ReportsConnectionsAgrExport')(vm.getParams())
      .then(DynamicFactory.get('FileUploadRsc','downloadFile')('ReportsConnectionsAgr.csv'));
        //   function (report) {
        //   var blob = new Blob([new Uint8Array(report.data)], {
        //     type: report.headers('Content-Type')
        //   });
        //   //var URL = window.URL || window.MozURL || window.webkitURL || window.MSURL || window.OURL;

        //   var anchor = document.createElement('a');
        //   anchor.href = URL.createObjectURL(blob);
        //   anchor.download = 'ReportsConnectionsAgr.csv';
        //   document.body.appendChild(anchor); //For FF
        //   anchor.target = '_blank';
        //   anchor.click();
        //   //It's better to remove the elem
        //   document.body.removeChild(anchor);
        // }
      // alasql("SELECT consultantID,callCenterID,minutes,avgminutes,firstName,lastname,[count],c_7s,c_2min,c_7_30,c_30_120 INTO XLSX('" + ("AgregacjePołączeń_" + moment().format()) + ".xlsx',{headers:true}) FROM ? ", [vm.report]);
    }

    // function showChart() {
    //   vm.showChart = tripleviewService.sidenavData.showMyChart;
    //   if (vm.showChart) {
    //     document.querySelector('.chartForReports').classList.remove('listNoChart');
    //   } else {
    //     document.querySelector('.chartForReports').classList.add('listNoChart');
    //   }
    //   getFilteredConsultantsCallsStatistics();
    // }
    //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!


    // function generateSeriesForConsultant(consultant) {
    //   return consultant.map(function (item) {
    //     return {
    //       x: item.timePeriod,
    //       y: item.count || 0
    //     }
    //   });
    // }



    // function getCount(array, timePeriod, consultantId) {
    //   var calls = _.find(array, function (item) {
    //     return item.timePeriod == timePeriod && item.consultantId == consultantId;
    //   });

    //   return calls != undefined ? calls.count : 0;
    // }
    // function findConsultantInRaport(consultantId) {
    //   var consultantCallsCount = _.find(vm.report, function (item) {
    //     return item.consultantID == consultantId;
    //   });

    //   return consultantCallsCount;
    // }

    // function getConsultant(array, consultantId) {
    //   var consultantCallsCount = _.find(array, function (item) {
    //     return item.key == consultantId;
    //   });

    //   return consultantCallsCount;
    // }

    // function getCallcenterPerManager() {
    //   if (SessionManager.getUserRoleId() === authRolesConst.manager || SessionManager.getUserRoleId() === authRolesConst.admin) {
    //     DynamicFactory.get('reportsCosult', 'CallCenterList')().then(function (r) {
    //       tripleviewService.sidenavData.callCenterList = r;
    //     });
    //   }
    //   generateConsultantPerContactCenter();
    // }

    // function generateConsultantPerContactCenter() {
    //   tripleviewService.sidenavData.consultantsPerCC = [];
    //   var callcenterId;
    //   if (SessionManager.getUserRoleId() === authRolesConst.admin) {
    //     callcenterId = tripleviewService.sidenavData.id ? tripleviewService.sidenavData.id : null;
    //   } else {
    //     callcenterId = user.callCenterId;
    //   }
    //   if (SessionManager.getUserRoleId() !== authRolesConst.consultant) {
    //     DynamicFactory.get('reportsCosult', 'ConsultansGet')(callcenterId).then(function (r) {
    //       tripleviewService.sidenavData.consultantsPerCC = r;
    //       vm.consultantList = r;
    //     })
    //   }
    // }
    // function getDataForChart() {

    //   var callCenterId = tripleviewService.sidenavData.id;
    //   var consultantId = tripleviewService.sidenavData.userID;
    //   var raportFromDate;
    //   var reportToDate;

    //   if (!tripleviewService.sidenavData.dateFrom && !tripleviewService.sidenavData.dateTo) {
    //     raportFromDate = tripleviewService.sidenavData.listDate[0].date.from;
    //     reportToDate = tripleviewService.sidenavData.listDate[0].date.to;
    //   } else {
    //     raportFromDate = tripleviewService.sidenavData.dateFrom;
    //     reportToDate = tripleviewService.sidenavData.dateTo;
    //   }

    //   var currentAggregationType;
    //   if (vm.currentAggregationType == 'MM-YYYY') {
    //     currentAggregationType = 'M';
    //   } else if (vm.currentAggregationType == 'DD-MM-YYYY') {
    //     currentAggregationType = 'D';
    //   } else if (vm.currentAggregationType == 'HH') {
    //     currentAggregationType = 'H';
    //   } else {
    //     currentAggregationType = undefined;
    //   }

    //   if (tripleviewService.sidenavData.finalDate) setWidthOnChart(tripleviewService.sidenavData.finalDate.date);
    //   vm.mainChart.data = [];

    //   DynamicFactory.get('reportsCosult', 'ReportsConnectionsAgrForChart')(raportFromDate, reportToDate, consultantId, callCenterId, currentAggregationType, 20).then(
    //     function (consultantsCallsStats) {

    //       if (consultantsCallsStats.length > 0) {
    //         var dateArray = ReportTools.dateInBetween(vm.currentAggregationType, tripleviewService.sidenavData);
    //         if (dateArray.length == 0) {

    //           var fromDate = new Date(raportFromDate);
    //           fromDate = fromDate.toLocaleDateString();
    //           if (fromDate.length == 9) fromDate = '0' + fromDate;

    //           var toDate = new Date(reportToDate);
    //           toDate = toDate.toLocaleDateString();
    //           if (toDate.length == 9) toDate = '0' + toDate;

    //           dateArray.push(fromDate.replace(/\./g, '-') + ' - ' + toDate.replace(/\./g, '-'));
    //         }

    //         var consultantKey = 0;
    //         _.forEach(consultantsCallsStats, function (value, key) {

    //           var consultantId = consultantsCallsStats[key].consultantId;
    //           if (!getConsultant(vm.mainChart.data, consultantId)) {
    //             vm.mainChart.data.push({
    //               key: consultantsCallsStats[key].consultantId,
    //               values: []
    //             });

    //             var callsCount;

    //             _.forEach(dateArray, function (value, key) {
    //               callsCount = getCount(consultantsCallsStats, dateArray[key], consultantId);
    //               var consultant = getConsultant(vm.report,consultantId)
    //               vm.mainChart.data[consultantKey].values.push({
    //                 x: consultant.alias || consultant.consultantName,
    //                 y: callsCount
    //               });
    //             });

    //             consultantKey += 1;
    //           }
    //         });
    //       }
    //     },
    //     function (error) {
    //       console.log("Wystapił błąd podczas pobierania statystyk wiadomości sms/mms do wyrysowania wykresu");
    //     });
    // }
    // function getConsultantsCallsStatistics(sSource, aoData, fnCallback, oSettings) {
    //   var draw = aoData[0].value;
    //   var order = aoData[2].value;
    //   var startIndex = aoData[3].value + 1;
    //   // var pageSize = aoData[4].value;
    //   var pageSize = vm.showChart ? aoData[4].value : 18;

    //   var callCenterId = tripleviewService.sidenavData.id;
    //   var consultantId = tripleviewService.sidenavData.userID;
    //   var raportFromDate;
    //   var reportToDate;

    //   if (!tripleviewService.sidenavData.dateFrom && !tripleviewService.sidenavData.dateTo) {
    //     raportFromDate = tripleviewService.sidenavData.listDate[0].date.from;
    //     reportToDate = tripleviewService.sidenavData.listDate[0].date.to;
    //   } else {
    //     raportFromDate = tripleviewService.sidenavData.dateFrom;
    //     reportToDate = tripleviewService.sidenavData.dateTo;
    //   }

    //   var records = {
    //     'draw': 0,
    //     'recordsTotal': 0,
    //     'recordsFiltered': 0,
    //     'data': []
    //   };

    //   DynamicFactory.get('reportsCosult', 'ReportsConnectionsAgr')(raportFromDate, reportToDate, consultantId, callCenterId, startIndex, pageSize, null).then(
    //     function (consultantsCallsStatistics) {
    //       vm.consultantsCallsStatisticsLength = consultantsCallsStatistics.length;
    //       if (consultantsCallsStatistics.length > 0) {
    //         vm.consultantsCallsStatistics = consultantsCallsStatistics;
    //         vm.report = angular.copy(consultantsCallsStatistics);
    //         records = {
    //           'draw': draw,
    //           'recordsTotal': consultantsCallsStatistics[0].consultantsTotal,
    //           'recordsFiltered': consultantsCallsStatistics[0].consultantsTotal,
    //           'data': consultantsCallsStatistics
    //         };
    //       }

    //       fnCallback(records);
    //     },
    //     function (error) {
    //       fnCallback(records);
    //       console.log("Problem z pobraniem IVRConnections");
    //     });
    // }

    // function setColumns() {
    // 	vm.dtColumns = [
    // 		DTColumnBuilder.newColumn('photoUrl').withTitle('').withOption('defaultContent', "").renderWith(avatarHtml),
    // 		DTColumnBuilder.newColumn('consultantName').withTitle('Imię Nazwisko').withOption('defaultContent', ""),
    // 		DTColumnBuilder.newColumn('consultantID').withTitle('Konsultant ID').withOption('defaultContent', ""),
    // 		DTColumnBuilder.newColumn('callCenterID').withTitle('CC ID').withOption('defaultContent', "---"),
    // 		//DTColumnBuilder.newColumn('date').withTitle('Data').withOption('defaultContent', "").renderWith(dateHtml),
    // 		DTColumnBuilder.newColumn('avgminutes2').withTitle('Średnia').withOption('defaultContent', "").renderWith(timeHtml),
    // 		DTColumnBuilder.newColumn('minutes').withTitle('Minuty').withOption('defaultContent', ""),
    // 		DTColumnBuilder.newColumn('count').withTitle('Ilość').withOption('defaultContent', ""),
    // 		DTColumnBuilder.newColumn(vm.newColumn).withTitle(vm.Duration).withOption('defaultContent', "").renderWith(changeColorColumn)
    // 	];
    // }
    // vm.newColumn = 'c_2min';
    // vm.Duration = '>2min';

    // function setColorForColumn() {
    // 	var color = 'green';

    // 	switch (vm.newColumn) {
    // 		case 'c_7s': color = 'red'; break;
    // 		case 'c_7_30': color = 'orange'; break;
    // 		case 'c_30_120': color = 'lightgreen'; break;
    // 		case 'c_2min': color = 'green'; break;
    // 		default: color = 'black'; break;
    // 	}

    // 	return color;
    // }

    // function convertTimeFromSecToMin(data, type, full, meta) {
    //     return '<span>{{ moment.utc(vm.consultantsCallsStatistics['+ full.consultantID +'].minutes * 1000).format("HH:mm:ss") }}</span>';
    // }

    // function changeColorColumn(data, type, full, meta) {
    // 	return '<span style="color: ' + setColorForColumn() + '">{{ vm.consultantsCallsStatistics[' + full.consultantID + '].' + vm.newColumn + ' }}</span>';
    // }

    // function createdRow(row, data, dataIndex) { //recompiling DataTable after its initialization is over
    // 	$compile(angular.element(row).contents())($scope);
    // }

    /*function dateHtml(data, type, full, meta)
    {
      return $filter('date')(data, 'MM-dd-MM-yyyy HH:mm:ss');
    }*/

    // function avatarHtml(data, type, full, meta) {
    // 	if (!vm.consultantsCallsStatistics[full.consultantID]) {
    //     vm.consultantsCallsStatistics[full.consultantID] = full;

    //   }
    // 	return "<img ng-src='{{vm.consultantsCallsStatistics[" + full.consultantID + "].photoUrl}}' src='assets/icons/communicator/user_avatar.svg' class='md-avatar'>";
    // }

    //#region DataTables Plugin
    // function setDataTablesPlugin() {
    // 	vm.dtInstance = {};

    // 	vm.dtOptions = DTOptionsBuilder.newOptions()
    // 		//.setLoadingTemplate('<img src="images/loading.gif">')
    // 		.withFnServerData(getConsultantsCallsStatistics)
    // 		.withDataProp('data')
    // 		.withOption('processing', true)
    // 		.withOption('serverSide', true)
    // 		.withOption('serverMethod', 'POST')
    // 		.withOption('paging', true)
    // 		.withPaginationType('full_numbers')
    // 		.withOption('bLengthChange', true) //możliwość zmiany elementów na stronie
    // 		.withOption('createdRow', createdRow)
    // 		.withOption('filter', false)
    // 		.withOption('info', false)
    // 		.withOption('scrollY', window.innerHeight - 645)
    // 		.withOption('scrollX', '100%')
    // 		.withOption('scrollCollapse', true)
    // 		.withFixedColumns({
    // 			leftColumns: 0,
    // 			rightColumns: 0
    // 		});

    // 	setColumns();
    // }
    // function showDurationColumn() {
    // 	vm.showDuration = tripleviewService.sidenavData.duration;
    // 	vm.newColumn = 'c_2min';
    // 	vm.Duration = '>2min';
    // 	switch (vm.showDuration) {
    // 		case "0":
    // 			vm.newColumn = 'c_7s';
    // 			vm.Duration = 'mniej niżs 7sec';
    // 			break;
    // 		case "1":
    // 			vm.newColumn = 'c_7_30';
    // 			vm.Duration = 'od 7sec do 30sec';
    // 			break;
    // 		case "2":
    // 			vm.newColumn = 'c_30_120';
    // 			vm.Duration = 'od 30sec do 2min';
    // 			break;
    // 		case "3":
    // 			vm.newColumn = 'c_2min';
    // 			vm.Duration = 'powyżej 2min';
    // 			break;
    // 		default:
    // 			vm.newColumn = 'c_2min';
    // 			vm.Duration = 'powyżej 2min';
    // 			break;
    // 	}
    // 	setColumns();
    // }
    // function changeAggregationType(aggregationType) {
    // 	var previousAggregationType = vm.currentAggregationType;

    // 	vm.currentType = aggregationType;

    // 	if (previousAggregationType == vm.currentAggregationType) vm.currentAggregationType = undefined;
    // 	getDataForChart(vm.currentType);

    // 	if (vm.currentType == 'MM-YYYY') {
    // 		vm.timeChart = 'miesięczny';
    // 	} else if (vm.currentType == 'DD-MM-YYYY') {
    // 		vm.timeChart = 'dzienny';
    // 	} else if (vm.currentType == 'HH') {
    // 		vm.timeChart = 'godzinowy';
    // 	}

    // }

    // function changeRating(rating) {
    // 	vm.currentRating = rating;
    // 	getDataForChart();
    // }

  }
})();

(function () {
  'use strict';

  angular
    .module('contactcenter.reports')
    .component('reportStatsCallsPerService', {
      templateUrl: 'app/main/contactcenter/reports/components/reportstatscalls/perservice/perservice.html',
      controllerAs: 'vm',
      require: {
        tripleView: '^tripleView'
      },
      controller: reportstatscalls
    });

  function reportstatscalls(DynamicFactory, SessionManager, tripleviewService, ReportsData, ReportTools, authRolesConst) {
    var vm = this,
      user = SessionManager.getUser();
    vm.changeChart = changeChart;
    vm.setPage = setPage;
    vm.downloadXLSX = downloadXLSX;
    vm.$onInit = onInit;


    //other
    vm.currentType = 'MM-YYYY';
    vm.timeChart = 'miesięczny';
    vm.pageSize = 10;
    vm.pageNumber = 0;
    vm.chartProp = 'quantity';

    function onInit() {
      vm.dateType = ReportsData.dateType;
      vm.showChart = true;

      vm.consultantList = [];
      vm.SessionManager = SessionManager;
      vm.authRolesConst = authRolesConst;

      setTripleView();

      getFilteredServiceCallsStatistics();
    }

    function getFilteredServiceCallsStatistics() {
      vm.pageNumber = 0;

      vm.tagsColumn = tripleviewService.sidenavData.params.partnerAgr ? angular.copy(tripleviewService.sidenavData.params.tagsAgr) : false;
      vm.partnerColumn = angular.copy(tripleviewService.sidenavData.params.partnerAgr);
      // if (vm.SessionManager.getUserRoleId() !== vm.authRolesConst.consultant) {
      //   ReportTools.getConsultantList().then(function (result) {
      //     vm.filtersConsultants = result;
      //     getReport();
      //     getChart();
      //   });
      // } else {
        getReport();
        getChart();

      // }
    }

    // function getParams(){
    //   getFilterDates();
    //   return {
    //     From: tripleviewService.sidenavData.params.From,
    //     To: tripleviewService.sidenavData.params.To,
    //     ConsultantId: tripleviewService.sidenavData.userID,
    //     CallcenterId: tripleviewService.sidenavData.id,
    //     StartIndex: (vm.pageSize * vm.pageNumber) + 1,
    //     PageSize: vm.pageSize,
    //     tagsAgr: tripleviewService.sidenavData.params.tagsAgr,
    //     partnerAgr : tripleviewService.sidenavData.params.partnerAgr
    //   };
    // }

    function getReport() {
      DynamicFactory.get('reportsCosult', 'ReportsConnectionsServiceAgr')(vm.getParams()).then(
        function (contactcenterStats) {
          vm.report = angular.copy(contactcenterStats.raport);
          vm.summary = angular.copy(contactcenterStats.summary);
          generatePages();
        },
        function (error) {
          console.log("Problem z pobraniem IVRServiceConnections");
        });
    }


    function changeChart(prop) {
      vm.chartProp = prop;
      generateChart(vm.chartSource);
    }

    function getChart() {
      // getFilterDates();
      setChartPlugin();
      if (tripleviewService.sidenavData.finalDate) setWidthOnChart(tripleviewService.sidenavData.finalDate.date);

      DynamicFactory.get('reportsCosult', 'ReportsConnectionsServiceAgrForChart')(vm.getParams()).then(
        generateChart,
        function (error) {
          console.log("Wystapił błąd podczas pobierania statystyk wiadomości sms/mms do wyrysowania wykresu");
        });
    }

    function generateChart(serviceCallsStats) {
      vm.chartSource = serviceCallsStats;
      if (serviceCallsStats.length > 0) {
        var chart = [];
        chart.push({
            key: 'Suma',
            values: generateSeriesForTag(_.reverse(_.sortBy(serviceCallsStats, vm.chartProp)))
          });
        vm.mainChart.data = chart;
      }
    }

    function generateSeriesForTag(tag) {
      return tag.map(function (item) {
        return {
          color: ReportsData.getNextColor(),
          x: vm.partnerColumn ? item.companyName : item.serviceName,
          y: item[vm.chartProp] || 0
        }
      });
    }
    function setWidthOnChart(data) {
      vm.mainChart.options.chart.width = undefined;
    }

    // function showChart() {
    //   vm.showChart = tripleviewService.sidenavData.showMyChart;
    //   if (vm.showChart) {
    //     document.querySelector('.chartForReports').classList.remove('listNoChart');
    //   } else {
    //     document.querySelector('.chartForReports').classList.add('listNoChart');
    //   }
    //   getFilteredContactcenterStats();
    // }

    // function getFilterDates() {
    //   if (!tripleviewService.sidenavData.dateFrom && !tripleviewService.sidenavData.dateTo) {
    //     tripleviewService.sidenavData.params.From = tripleviewService.sidenavData.listDate[0].date.from;
    //     tripleviewService.sidenavData.params.To = tripleviewService.sidenavData.listDate[0].date.to;
    //   } else {
    //     tripleviewService.sidenavData.params.From = tripleviewService.sidenavData.dateFrom;
    //     tripleviewService.sidenavData.params.To = tripleviewService.sidenavData.dateTo;
    //   }
    // }

    function chartTimeFormat(d) {
      if (vm.chartProp !== 'quantity') {
        return ReportTools.formatSecs(d);
      }else return d;
    }

    function setChartPlugin() {
      vm.dateType = ReportsData.dateType;

      var mainChart = angular.copy(ReportsData.defaultChartConf);

      mainChart.options.chart.type = 'multiBarChart';
      mainChart.options.chart.color = _.map(ReportsData.colors, 'color');
      mainChart.options.chart.height = 250;
      mainChart.options.chart.width = null;
      mainChart.options.chart.showLegend = false;
      mainChart.options.chart.stacked = true;

      mainChart.options.chart.xAxis = {
        tickFormat: function (d) {
          return tripleviewService.sidenavData.params.partnerAgr ? d.slice(0,10) +( d.length> 10? '...':'' ): d;
        },
        rotateLabels: -20
      };
      mainChart.options.chart.valueFormat = chartTimeFormat;
      mainChart.options.chart.yAxis = {
        tickFormat:chartTimeFormat
      };
      mainChart.options.chart.valueFormat = chartTimeFormat;
      mainChart.options.chart.showControls = false;

      vm.mainChart = mainChart;
    }

    function setPage(newPage) {
      vm.pageNumber = newPage;
      getReport();
    }

    function generatePages() {
      var totalCount = vm.report[0] ? vm.report[0].totalCount : 0;
      var totalPages = Math.round( totalCount / vm.pageSize + 0.5);
      console.log('reportStatsCallsPerConsultant | total pages=', totalPages);
      vm.reportPages = [];
      for (var i = 0; i < totalPages; i++) {
        vm.reportPages.push(i);
      }
    }


    function setTripleView() {
      tripleviewService.sidenavData.getConnectData = getFilteredServiceCallsStatistics;
      // tripleviewService.sidenavData.showChart = showChart;
      // tripleviewService.sidenavData.config = {
      //   // callcenter: true,
      //   // consultantList: false,
      //   // showChart: true,
      //   CallcenterId:true,
      //   ConsultantId:true,
      //   tagsAgr: true,
      //   partnerServiceAgr: true
      // };
      vm.getParams = ReportTools.configReportParams({
        CallcenterId:true,
        // ConsultantId:true,
        tagsAgr: true,
        partnerAgr: true
      },currentPage);
      tripleviewService.sidenavData.agregationDate = [];
      tripleviewService.sidenavData.duration = 3;
      tripleviewService.sidenavData.startValue = '';
    }

    function currentPage(){
         return {
           StartIndex: (vm.pageSize * vm.pageNumber) + 1,
           PageSize: vm.pageSize
         }
       }

    // function getCount(array, timePeriod, consultantId) {
    //   var calls = _.find(array, function (item) {
    //     return item.timePeriod == timePeriod && item.consultantId == consultantId;
    //   });

    //   return calls != undefined ? calls.count : 0;
    // }

    // function getConsultant(array, consultantId) {
    //   var consultantCallsCount = _.find(array, function (item) {
    //     return item.key == consultantId;
    //   });

    //   return consultantCallsCount;
    // }


    // function downloadXLSX() {
    //   alasql("SELECT date,consultantID,callCenterID,minutes,avgminutes,firstName,lastname,[count],c_7s,c_2min,c_7_30,c_30_120 INTO XLSX('" + ("AgregacjePołączeń_" + moment().format()) + ".xlsx',{headers:true}) FROM ? ", [vm.agregation]);
    // }

    function downloadXLSX() {
      DynamicFactory.get('reportsCosult', 'ReportsConnectionsServiceAgrExport')(vm.getParams())
      .then(function(report){
        var blob = new Blob([new Uint8Array(report.data)], {
          type: report.headers('Content-Type')
        });

        var anchor = document.createElement('a');
        anchor.href = URL.createObjectURL(blob);
        anchor.download = 'ReportsConnectionsServiceAgr.csv';
        document.body.appendChild(anchor); //For FF
        anchor.target = '_blank';
        anchor.click();
        //It's better to remove the elem
        document.body.removeChild(anchor);
      });
      }

    // function showChart() {
    //   vm.showChart = tripleviewService.sidenavData.showMyChart;
    //   if (vm.showChart) {
    //     document.querySelector('.chartForReports').classList.remove('listNoChart');
    //   } else {
    //     document.querySelector('.chartForReports').classList.add('listNoChart');
    //   }
    //   getFilteredServiceCallsStatistics();
    // }
  }
})();

(function () {
	'use strict';

	angular
		.module('contactcenter.reports').controller('transcription', controller);


	/** @ngInject */
	function controller(DynamicFactory, sessionID, $mdDialog, toastService, $timeout) {
		var vm = this;

		vm.$onInit = onInit;
		vm.attachmentUrls = attachmentUrls;
		vm.printTranscription = printTranscription;
		vm.sendMessage = sendMessage;
		vm.showTextarea = showTextarea;
		vm.toggleViewsTags = toggleViewsTags;
		vm.autoSaveTags = autoSaveTags;
		vm.showInfo = showInfo;
		vm.biuldMessageBody = biuldMessageBody;

		vm.sessionID = sessionID;
		vm.closeDialog = closeDialog;
		vm.reportsSessionArray = [];
		vm.sessionDetails = {};
		vm.showWarrning = false;
		vm.sessionInfo = false;
		vm.showTags = false;
		vm.forceReloadTags = false;
		vm.messageWarring = '';

		function onInit() {
			getData();
		}

		function getData() {
			getReportsSession();
			getReportsSessionDetails();
		}

		function getReportsSession() {
			DynamicFactory.get('reportsCosult', 'reportsSession')(sessionID).then(function (data) {
				vm.reportsSessionArray = data;
			});
		}

		function getReportsSessionDetails() {
			DynamicFactory.get('reportsCosult', 'reportsSessionDetails')(sessionID).then(function (data) {
				setSessionDetails(data);
			});
		}

		function setSessionDetails(data) {
			vm.sessionDetails = data;
			setTagsData(data);
		}

		function setTagsData(data) {
			vm.forceReloadTags = false;
			$timeout(function () {
				vm.msgTags = data.tags;
				vm.forceReloadTags = true;
			}, 0);
		}

		function attachmentUrls(t) {
			var imageUrls = t.attachmentUrls;
			var arrFiles = [];
			if (imageUrls) {
				var s = imageUrls.split(';');

				angular.forEach(s, function (v) {
					var fileExtension = getUrlExtension(v);

					if (fileExtension === 'pdf') {
						arrFiles.push({ 'isImg': false, 'file': v });
					} else {
						arrFiles.push({ 'isImg': true, 'file': v });
					}

				});
				return s;
			}
		}

		function closeDialog() {
			$mdDialog.cancel();
		}

		function getUrlExtension(url) {
			return url.split(/\#|\?/)[0].split('.').pop().trim().toLowerCase();
		}

		function printTranscription() {
			window.print();
		}

		function showTextarea() {
			vm.showWarrning = !vm.showWarrning;
		}

		function showInfo() {
			vm.sessionInfo = !vm.sessionInfo;
		}

		function toggleViewsTags() {
			vm.showTags = !vm.showTags;
		}

		function biuldMessageBody() {
			var data = vm.sessionDetails;
			var body =
				'Id: ' + data.id +
				'\nSession Id: ' + data.sessionID +
				'\nStart: ' + data.insertionTime +
				'\nStop: ' + data.finished +
				'\nStatus Id: ' + data.statusId +
				'\nStatus Description: ' + data.statusDesc +
				'\nTags: ' + data.tagsStr +
				'\n\n';

			body += 'Consultant Id: ' + data.consultantID +
				'\nLogin: ' + data.login +
				'\nFirst Name: ' + data.firstName +
				'\nLast name: ' + data.lastName +
				'\nAlias: ' + data.alias + '\n\n';

			body += 'Contact Id: ' + data.contactId +
				'\nContact Name: ' + data.userName +
				'\nFirst Name: ' + data.userEmail +
				'\n\nMessage: ' + vm.messageWarring;

			return body;
		}

		function sendMessage() {
			var msg = {
				Destination: 'M' + vm.sessionI.callCenterID,
				Source: null,
				Body: biuldMessageBody(),
				ReplyTo: null,
				AuthorName: null,
				AuthorPhotoUrl: null
			};
			DynamicFactory.get('InternalMessageRsc', 'Send')(msg).then(function (data) {
				var message = 'Migawka sesji wysłana do grupy managerskiej';
				showToastMessage(message);
				closeAndClearFormWithComments();
			});
		}

		function showToastMessage(message) {
			toastService.showToastAction(message.toUpperCase());
		}

		function closeAndClearFormWithComments() {
			vm.showWarrning = false;
			vm.messageWarring = '';
		}

		function saveMsgTags(tags) {
			DynamicFactory.get('messageSessionRsc', 'addMessageSessionTags')(vm.sessionID, tags).then(
				function (data) { console.log(data); },
				function (err) { console.log(err); }
			);
		}

		function autoSaveTags(model) {
			console.log('autoSaveTags: ' + model);
			saveMsgTags(model);
		}
	}
})();

(function () {
  'use strict';

  angular
    .module('contactcenter.reports')
    .filter('buttonStyle', buttonStyle);

  /* @ngInject */
  function buttonStyle() {
    return function (state, currentState) {
      if (currentState == undefined) return 'ph-16 aggregationButtons md-raised';

      var buttonRaised;

      if(state != currentState) buttonRaised = ' md-raised';

      return 'ph-16 aggregationButtons' + buttonRaised;
    }
  }
})();

(function () {
	'use strict';

	angular
		.module('contactcenter.reports')
		.component('reportsTags', {
			templateUrl: 'app/main/contactcenter/reports/components/reportsessions/reportstags/reportstags.html',
			controllerAs: 'vm',
			require: {
				tripleView: '^tripleView'
			},
			controller: controller
		});


	/** @ngInject */
	function controller(DynamicFactory, SessionManager, tripleviewService, authRolesConst, ReportsData, ReportTools) {
		var vm = this;

		vm.$onInit = onInit;
		vm.pageSize = 10;
		vm.pageNumber = 0;

		vm.SessionManager = SessionManager;
		vm.authRolesConst = authRolesConst;
		vm.downloadXLSX = downloadXLSX;
		vm.setPage = setPage;



		function onInit() {
			vm.tagsColumn = false;
			
			
			
			setTripleView();
			getReport();
			// getFilteredTagsList();
			getReportsSessionsSummary();
		}

		function setTripleView() {
			tripleviewService.sidenavData.getConnectData = getFilteredTagsList;

			vm.getParams = ReportTools.configReportParams({
				CallcenterId: SessionManager.getUserRoleId() !== authRolesConst.consultant,
				ConsultantId: SessionManager.getUserRoleId() !== authRolesConst.consultant,
				agreagation: false,
				direction: false,
				msisdn: false,
				type: false,
				sessionId: false,
				contactName: false,
				tagsAgr: true
			}, currentPage);
		}

		function getFilteredTagsList() {
			vm.pageNumber = 0;
			getReport();
			
			if(tripleviewService.sidenavData.params.tagsAgr) {
				getSummaryReport();	
				vm.summary = [];
			} else {
				getReportsSessionsSummary();	
				vm.summaryPerTags = [];
			}
		}

		function getReport() {
			DynamicFactory.get('reportsCosult', 'reportsSessionsPerConsultantByTags')(vm.getParams())
				.then(function (response) {
					vm.reports = response;
					generatePages();
				});
		}

		function getSummaryReport() {
			
			DynamicFactory.get('reportsCosult', 'reportsSessionsByTagsSummary')(vm.getParams()).then(function (response) {
				vm.summaryPerTags = angular.copy(response);
				vm.tagsColumn = angular.copy(tripleviewService.sidenavData.params.tagsAgr);
				console.log('vm.tagsColumn ===>>  ' + vm.tagsColumn);
			});
		}
		
		function getReportsSessionsSummary() {
			DynamicFactory.get('reportsCosult', 'reportsSessionsSummary')(vm.getParams()).then(function(response) {
				vm.summary = angular.copy(response);
			});
		}
		
		function currentPage() {
			return {
				AggregationType: vm.SessionManager.getUserRoleId() === vm.authRolesConst.consultant ? 'D' : null,
				StartIndex: (vm.pageSize * vm.pageNumber) + 1,
				PageSize: vm.pageSize
			};
		}

		function setPage(newPage) {
			vm.pageNumber = newPage;
			getReport();
		}

		function generatePages() {
			var totalPages = Math.round(vm.reports[0].totalCount / vm.pageSize + 0.5);
			console.log('reportStatsCallsPerConsultant | total pages=', totalPages);
			vm.reportPages = [];
			for (var i = 0; i < totalPages; i++) {
				vm.reportPages.push(i);
			}
		}
		
		function downloadXLSX () {
			DynamicFactory.get('reportsCosult', 'reportsSessionsPerConsultantByTagsExport')(vm.getParams())
				.then(DynamicFactory.get('FileUploadRsc','downloadFile')('ReportsConnectionsAgr.csv'));
		}
	}
})();

(function () {
	'use strict';
	/** @ngInject */

	angular
		.module('contactcenter.reports')
		.component('sessionsAggregation', {
			templateUrl: 'app/main/contactcenter/reports/components/reportsessions/aggregation/sessionAggregation.html',
			controllerAs: 'vm',
			require: {
				tripleView: '^tripleView'
			},
			controller: controller
		});

	function controller(DynamicFactory, SessionManager, authRolesConst, tripleviewService, ReportsData, ReportTools, toastService) {
		var vm = this; // jshint ignore:line
		// var userInfo = SessionManager.getUser();


		vm.changeAgrType = changeAgrType;
		vm.changeChart = changeChart;
		vm.downloadXLSX = downloadXLSX;
		// tripleviewService.sidenavData.showChart = showChart;
		vm.setPage = setPage;
		vm.$onInit = onInit;
		vm.formatSecs = ReportTools;

		vm.timeChart = 'miesięczny';
		vm.pageSize = 10;
		vm.pageNumber = 0;
		vm.chartProp = 'countAll';
		vm.loading = false;


		function onInit() {
			vm.dateType = ReportsData.dateType;
			vm.currentType = vm.dateType[0];
			vm.showChart = true;

			vm.consultantList = [];
			vm.SessionManager = SessionManager;
			vm.authRolesConst = authRolesConst;
			// setAudioPlayer();
			setTripleView();

			getFilteredSessionsList();
		}

		function getFilteredSessionsList() {
			vm.pageNumber = 0;
			vm.report = [];
			getReport();
			getChart();
			vm.tagsColumn = angular.copy(tripleviewService.sidenavData.params.tagsAgr);
			
			
			if (tripleviewService.sidenavData.params.tagsAgr) {
				getSummaryReport();
				getReport();
				vm.summary = [];
			} else {
				getReportsSessionsSummary();
				getReport();
				vm.summaryPerTags = [];
			}
			// }
		}

		function getSummaryReport() {

			DynamicFactory.get('reportsCosult', 'reportsSessionsByTagsSummary')(vm.getParams()).then(function (response) {
				vm.summaryPerTags = angular.copy(response);
				
				console.log('vm.tagsColumn ===>>  ' + vm.tagsColumn);
			});
		}

		function getReportsSessionsSummary() {
			DynamicFactory.get('reportsCosult', 'reportsSessionsSummary')(vm.getParams()).then(function (response) {
				vm.summary = angular.copy(response);
			});
		}

		function getReport() {
			vm.loading = true;
			if (!vm.tagsColumn) {
				DynamicFactory.get('reportsCosult', 'reportsSessionsPerConsultant')(vm.getParams()).then(
					function (report) {
						console.log('report sessions list => ', report);
						vm.report = angular.copy(report);
						vm.loading = false;
						generatePages();
					},
					function (error) {
						console.log("Problem z pobraniem reportsSessions");
						vm.loading = false;
					});
			} else {
				DynamicFactory.get('reportsCosult', 'reportsSessionsPerConsultantByTags')(vm.getParams())
					.then(function (response) {
						vm.report = angular.copy(response);
						vm.loading = false;
						generatePages();
					});
			}

		}

		function changeAgrType(prop) {
			vm.currentType = prop;
			getChart();
		}

		function changeChart(prop) {
			vm.chartProp = prop;
			generateChart(vm.chartSource);
		}


		function getChart() {
			// getFilterDates();
			setChartPlugin();
			if (tripleviewService.sidenavData.finalDate) setWidthOnChart(tripleviewService.sidenavData.finalDate.date);
			DynamicFactory.get('reportsCosult', 'reportsSessionsPerConsultantForChart')(vm.getParams()).then(
				generateChart,
				function (error) {
					console.log("Wystapił błąd podczas pobierania statystyk wiadomości sms/mms do wyrysowania wykresu");
				});
		}

		function generateChart(callsStatistics) {
			vm.chartSource = callsStatistics;
			if (callsStatistics.length > 0) {
				var chart = [];
				var dateArray = ReportTools.dateInBetween(vm.currentType.key, tripleviewService.sidenavData.params);

				chart.push({
					key: 'Agregacje',
					values: generateSeriesForPeriod(_.reverse(_.sortBy(callsStatistics, vm.chartProp)), dateArray)
				});
				vm.mainChart.data = chart;
			}
		}

		function generateSeriesForPeriod(period, dateArray) {
			return _.sortBy(period.map(function (date) {
				var item = _.find(period, {
					login: date.login
				});
				if (item) {
					return {
						color: ReportsData.getNextColor(),
						x: item.login,
						y: item[vm.chartProp] || 0
					}
				} else {
					return {
						x: date,
						y: 0
					}
				}
			}), function (o) {
				return new Date(o.x);
			});
		}

		function setWidthOnChart(data) {
			vm.mainChart.options.chart.width = undefined;
		}



		function chartTimeFormat(d) {
			if (vm.chartProp !== 'count') {
				return d;//ReportTools.formatSecs(d);
			} else return d.toString();
		}

		function setChartPlugin() {
			vm.dateType = ReportsData.dateType;

			var mainChart = angular.copy(ReportsData.defaultChartConf);
			mainChart.options.chart.color = function color() {
				return '#2799f3';
			};
			mainChart.options.chart.height = 250;
			mainChart.options.chart.type = 'discreteBarChart';
			mainChart.options.chart.width = null;
			mainChart.options.chart.showValues = false;

			mainChart.options.chart.xAxis = {
				tickFormat: function (d) {
					if (vm.currentType.value == 'D') {
						var daysTotal = moment.duration(tripleviewService.sidenavData.params.To.diff(tripleviewService.sidenavData.params.From)).asDays();
						var fromToTick = moment.duration(moment(d, 'DD-MM-YYYY').diff(tripleviewService.sidenavData.params.From)).asDays();
						if (daysTotal > 32) {
							if (Math.round(fromToTick) % 8 == 0) {
								return d;
							} else {
								return '';
							}
						}
					}
					return d;
				},
				rotateLabels: -20
			};
			mainChart.options.chart.tooltip = {
				keyFormatter: function (d, i) {
					return d;
				}
			}
			mainChart.options.chart.yAxis = {
				tickFormat: chartTimeFormat
			};
			mainChart.options.chart.valueFormat = chartTimeFormat;
			vm.mainChart = mainChart;
			ReportsData.resetNextColor();

		}


		function setPage(newPage) {
			vm.pageNumber = newPage;
			getReport();
		}

		function generatePages() {
			vm.reportPages = [];
			if (!vm.report[0]) {
				return;
			}
			var totalPages = Math.round(vm.report[0].totalCount / vm.pageSize + 0.5);
			for (var i = 0; i < totalPages; i++) {
				vm.reportPages.push(i);
			}
		}


		function setTripleView() {
			tripleviewService.sidenavData.getConnectData = getFilteredSessionsList;

			vm.getParams = ReportTools.configReportParams({
				CallcenterId: SessionManager.getUserRoleId() !== authRolesConst.consultant,
				ConsultantId: SessionManager.getUserRoleId() !== authRolesConst.consultant,
				agreagation: true,
				direction: false,
				msisdn: false,
				type: false,
				sessionId: false,
				contactName: false,
				tagsAgr: true
			}, currentPage);
		}

		function currentPage() {
			return {
				AggregationType: vm.currentType.value,
				StartIndex: (vm.pageSize * vm.pageNumber) + 1,
				PageSize: vm.pageSize
			};
		}



		function downloadXLSX() {
			if(!vm.tagsColumn) {
				DynamicFactory.get('reportsCosult', 'reportsSessionsPerConsultantExport')(vm.getParams())
				.then(DynamicFactory.get('FileUploadRsc', 'downloadFile')('Sessions_CallcenterId_' + tripleviewService.sidenavData.params.CallcenterId + '.csv'));	
			}
			else {
				DynamicFactory.get('reportsCosult', 'reportsSessionsPerConsultantByTagsExport')(vm.getParams())
				.then(DynamicFactory.get('FileUploadRsc','downloadFile')('ReportsConnectionsAgr.csv'));
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('contactcenter.reports')
		.component('activityAudit', {
			templateUrl: 'app/main/contactcenter/reports/components/consultantChannelsActivity/activityAudit/activityAudit.html',
			require: {
				tripleView: '^tripleView'
			},
			controllerAs: 'vm',
			controller: controller
		});

	function controller(DynamicFactory, tripleviewService, ReportTools, ReportsData) {
		var vm = this;

		vm.$onInit = onInit;
		vm.activeDaily = [];
		
		function onInit() {
			vm.dateType = ReportsData.dateType;
			setTripleView();
			getFilteredReportsUsersActivity();
			// getReportsActiveDailyReport();
		}

		function setTripleView() {
			tripleviewService.sidenavData.getConnectData = getFilteredReportsUsersActivity;
			vm.getParams = ReportTools.configReportParams(
				{
					CallcenterId: true,
					ConsultantId: true,
					callcenter: true,
					activityCountType: true,
					startHour: true
					// consultantList: true,
					// agreagation: true,
					// timeAgr: true,
					// showChart: true,
					// tagsAgr: true
				}
				//   currentPage
			);
			
			tripleviewService.sidenavData.agregationDate = [];
			tripleviewService.sidenavData.duration = 3;
			tripleviewService.sidenavData.startValue = "";
		}

		function getFilteredReportsUsersActivity() {
			ReportTools.getConsultantList().then(function (result) {
				vm.filtersConsultants = result;
				vm.consultantList = _.mapValues(_.groupBy(result, "consultantID"), function (array) {
					return array[0];
				});
				getReportsActiveDailyReport();
			});
		}

		function getReportsActiveDailyReport() {
			DynamicFactory.get('reportsCosult', 'ReportsActiveDailyReport')(vm.getParams()).then(
				function (response) {
					vm.activeDaily = response;
				}
			);
		}
	}
})();

(function () {
  'use strict';

  angular
    .module('contactcenter.reports')
    .component('callbacklist', {
      templateUrl: 'app/main/contactcenter/reports/components/callback/callbacklist/callbacklist.html',
      require: {
        tripleView: '^tripleView'
      },
      controllerAs: 'vm',
      controller: callbacklist
      // bindings: {
      //     propertyName: '=',
      //     reverse: '='
      // }
    });


  /** @ngInject */
  function callbacklist(DynamicFactory, $scope, $compile, $translate, toastService, SessionManager, authRolesConst, $filter, tripleviewService, consts, ReportTools, ReportsData) {
    var vm = this;

    vm.downloadXLSX = downloadXLSX;
    vm.changeAgrType = changeAgrType;
    vm.playRecording = playRecording;

    vm.setPage = setPage;
    vm.$onInit = onInit;
    vm.formatSecs = ReportTools.formatSecs;

    vm.minutesLeft = minutesLeft;
    vm.showCallbackOrderDetails = showCallbackOrderDetails;
    vm.timeChart = 'miesięczny';
    vm.pageSize = 10;
    vm.pageNumber = 0;
    vm.chartProp = 'callbackOrdersCount';
    vm.selectedCallback;

    function onInit() {
      vm.dateType = ReportsData.dateType;
      vm.currentAgrType = vm.dateType[0];

      //vm.consultantList = [];
      vm.SessionManager = SessionManager;
      vm.authRolesConst = authRolesConst;
      setAudioPlayer();
      setTripleView();

      getFilteredCallbackOrders();
    }

    //#region Common
    function minutesLeft(minutes) {
      return minutes < 0 ? 0 : minutes;
    }
    //#endregion

    function getFilteredCallbackOrders() {
      vm.pageNumber = 0;
      if (vm.SessionManager.getUserRoleId() !== vm.authRolesConst.consultant) {
        ReportTools.getConsultantList().then(function (result) {
          vm.filtersConsultants = result;
          getReport();
          getChart();
        });
      } else {
        getReport();
        getChart();
      }
    }

    function getReport() {
      vm.callbackOrderDetails = undefined;

      DynamicFactory.get('reportsCosult', 'CallbackOrdersList')(vm.getParams()).then( //,vm.raportFromDate, vm.reportToDate, vm.pageNumber + 1, vm.pageSize
        function (callbackOrdersList) {
          vm.callbackOrdersList = angular.copy(callbackOrdersList);
          generatePages();
        },
        function (error) {
          console.log("Problem z pobraniem callback'ów");
        });
    }

    function showCallbackOrderDetails(index, guid) {
      vm.callbackOrderDetails = undefined;
      vm.selectedCallback = vm.selectedCallback !== index ? index : undefined;
      if (vm.unique !== guid) {
        vm.unique = guid;
        DynamicFactory.get('reportsCosult', 'CallbackDetails')(guid).then(
          function (callbackOrderDetails) {
            vm.callbackOrderDetails = callbackOrderDetails;
          },
          function (error) {
            console.log("Problem z pobraniem szczegółów callback'a o id: " + guid);
          });
      } else {
        vm.unique = undefined;
      }
    }

    //#region Chart plugin
    function setChartPlugin() {
      vm.dateType = ReportsData.dateType;

      var mainChart = angular.copy(ReportsData.defaultChartConf);
      // mainChart.options.chart.color = function color() {
      //   return '#2799f3'; //'#5fd4c4'
      // };

      mainChart.options.chart.height = 250;
      mainChart.options.chart.type = 'discreteBarChart';
      mainChart.options.chart.width = null;
      mainChart.options.chart.duration = 0;
      mainChart.options.chart.xAxis = {
        tickFormat: function (d) {
          if (vm.currentAgrType.value == 'D') {
            var daysTotal = moment.duration(tripleviewService.sidenavData.params.To.diff(tripleviewService.sidenavData.params.From)).asDays();
            var fromToTick = moment.duration(moment(d, 'DD-MM-YYYY').diff(tripleviewService.sidenavData.params.From)).asDays();
            if (daysTotal > 32) {
              if (Math.round(fromToTick) % 8 == 0) {
                return d;
              } else {
                return '';
              }
            }
          }
          return d;
        },
        rotateLabels: -20
      };

      mainChart.options.chart.tooltip = {
        keyFormatter: function (d, i) {
          return d;
        }
      }

      mainChart.options.chart.yAxis = {
        tickFormat: chartYThickFormat
      };
      mainChart.options.chart.valueFormat = chartValueFormat;
      mainChart.options.chart.margin = {
        bottom: 70,
        left: 58
      };
      mainChart.options.chart.yAxis.axisLabel = SessionManager.getUserRoleId() === authRolesConst.consultant ? $translate.instant('REPORTS.CALLBACK.CHART.Y_AXIS_LABEL.MINUTES') : $translate.instant('REPORTS.CALLBACK.CHART.Y_AXIS_LABEL.COUNT');
      vm.mainChart = mainChart;
      //ReportsData.resetNextColor();
    }

    function getChart() {
      setChartPlugin();
      if (tripleviewService.sidenavData.finalDate) setWidthOnChart(tripleviewService.sidenavData.finalDate.date);

      DynamicFactory.get('reportsCosult', 'CallbackOrdersChart')(vm.getParams()).then(
        generateChart,
        function (error) {
          console.log("Wystapił błąd podczas pobierania liczby zamównionych callback'ów do wyrysowania wykresu");
        });
    }

    function changeAgrType(prop) {
      vm.currentAgrType = prop;
      getChart();
    }

    function generateChart(callbackOrders) {
      vm.chartSource = callbackOrders;
      if (callbackOrders.length > 0) {
        var chart = [];
        var dateArray = ReportTools.dateInBetween(vm.currentAgrType.key, tripleviewService.sidenavData.params);

        chart.push({
          key: 'callbackOrders',
          values: generateSeriesForPeriod(callbackOrders, dateArray) //generateSeriesForPeriod(_.reverse(_.sortBy(callbackOrders, vm.chartProp)), dateArray)
        });

        vm.mainChart.data = chart;
      }
    }

    function generateSeriesForPeriod(data, dateArray) {
      var maxValue = undefined;

      //W widoku konsultanta na wykresie prezentowana jest suma czasu trawania callback'ów
      if (SessionManager.getUserRoleId() === authRolesConst.consultant) {
        var itemMaxDuration = _.maxBy(data, function (item) {
          return item.callbacksDuration;
        });
        maxValue = itemMaxDuration.callbacksDuration;
      } else {
        var itemMaxCount = _.maxBy(data, function (item) {
          return item.callbackOrdersCount;
        });
        maxValue = itemMaxCount.callbackOrdersCount;
      }

      return dateArray.map(function (date) {
        var item = _.find(data, {
          timePeriod: date
        });
        if (item) {
          var value = SessionManager.getUserRoleId() === authRolesConst.consultant ? item.callbacksDuration : item.callbackOrdersCount;
          return {
            color: ReportsData.getColorShade('#278c27', value / maxValue * 100), //czerwony #990000; #2ca02c
            x: item.timePeriod,
            y: value || 0
          }
        } else {
          return {
            color: '#278c27',
            x: date,
            y: 0
          }
        }
      });
    }

    function setWidthOnChart(data) {
      vm.mainChart.options.chart.width = undefined;
    }

    function chartValueFormat(d) {
      if (d == 0) {
        return '';
      } else {
        return SessionManager.getUserRoleId() === authRolesConst.consultant ? $filter('date')(d, 'mm:ss') : d.toString();
      }
    }

    function chartYThickFormat(d) {
      if (d == 0) {
        return '';
      } else {
        return SessionManager.getUserRoleId() === authRolesConst.consultant ? Math.round(d/60000) : d.toString();
      }
    }

    //#endregion

    //#region Paging
    function setPage(newPage) {
      vm.pageNumber = newPage;
      getReport();
    }

    function generatePages() {
      if (vm.callbackOrdersList.length > 0) {
        var totalPages = Math.ceil(vm.callbackOrdersList[0].recordsTotal / vm.pageSize)
        console.log('reportCallbackOrders | total pages=', totalPages);
        vm.reportPages = [];
        for (var i = 0; i < totalPages; i++) {
          vm.reportPages.push(i);
        }
      }
    }
    //#endregion

    //#region TripleView
    function setTripleView() {
      tripleviewService.sidenavData.getConnectData = getFilteredCallbackOrders;

      vm.getParams = ReportTools.configReportParams({
        ConsultantId: true,
        msisdn: true,
      }, currentPage);

      tripleviewService.sidenavData.agregationDate = [];
      tripleviewService.sidenavData.duration = 3;
      tripleviewService.sidenavData.startValue = '';
    }

    function currentPage() {
      return {
        PageNumber: vm.pageNumber,
        PageSize: vm.pageSize,
        AggregationType: vm.currentAgrType.key
      }
    }
    //#endregion

    //#region Audio plugin
    function setAudioPlayer() {
      vm.audio = new Audio();

      vm.audio.onerror = function () {
        vm.audio.pause();
        vm.audio.currentTime = 0.0;
        setTimeout(function () {
          if (vm.consultant.callStatus == 1) {
            loadAudio();
          }
        }, 5000);
        // toastService.showToast('Nie powiodło się odtworzenie nagrania', 'error', 3);
      };
      vm.audio.onloadstart = function () {
        vm.loading = true;
        console.log('reportCallbacks| audio buffering!');
      };
      vm.audio.onloadeddata = function () {
        vm.loading = false;

        vm.currentPlaying.isPlaying = true;
        playAudio();

        console.log('reportCallbacks | audio ready to play!', vm.audio.buffered.end(0), vm.audio.seekable, vm.audio.buffered);
      };
      vm.audio.oncanplay = function () {
        console.log('reportCallBacks | oncanplay!');
      };
    }

    function playAudio() {
      vm.audio.play();
    }

    function pauseAudio() {
      vm.audio.pause();
    }

    function playRecording(call) {
      if (vm.currentPlaying && vm.currentPlaying.isPlaying) {
        vm.currentPlaying.isPlaying = false;
        pauseAudio()
      }
      if (call != vm.currentPlaying) {
        vm.audio.src = consts.recordings + call.guid; //call.bridgeID;
        vm.currentPlaying = call;
        vm.audio.load();
      } else {
        vm.currentPlaying = undefined;
      }
    }

    //#endregion

    //#region Download .xlsx
    function downloadXLSX() {
      DynamicFactory.get('reportsCosult', 'DownloadCallbackOrders')(vm.getParams()).then(
        function (report) {
          downloadReport(report);
          console.log("Pobrano plik.");
        },
        function (error) {
          console.log("Problem z pobraniem pliku.", error);
        });
    }

    function downloadReport(report) {
      var blob = new Blob([new Uint8Array(report.data)], {
        //type: report.headers('Content-Type')
      });

      var anchor = document.createElement('a');
      anchor.style = "display: none";
      anchor.href = URL.createObjectURL(blob);
      anchor.download = 'myFileName.csv';
      document.body.appendChild(anchor); //For FF
      anchor.click();
      //It's better to remove the elem
      document.body.removeChild(anchor);
    }

    //#endregion







    // /** @ngInject */
    // function callbacklist(DynamicFactory, reportsCosult, tripleviewService, SessionManager, authRolesConst, headerConfig, $scope, consts, DTColumnBuilder, DTOptionsBuilder, $timeout) {
    //     var vm = this;
    //     var userInfo = SessionManager.getUser();

    //     //functions
    //     tripleviewService.sidenavData.getConnectData = getCallBackReportsAsync;
    //     // tripleviewService.sidenavData.generateDate = generateDate;
    //     vm.showForwardDetails = showForwardDetails;
    //     tripleviewService.sidenavData.generateConsultantPerContactCenter = generateConsultantPerContactCenter;
    //     tripleviewService.sidenavData.getCallcenterPerManager = getCallcenterPerManager;
    //     // vm.fullTime = fullTime;
    //     vm.playRecording = playRecording;
    //     // vm.sortByForwards = sortByForwards;
    //     vm.$onInit = onInit;

    //     //resource
    //     vm.getCallback = DynamicFactory.get('reportsCosult', 'ReportsCallbackOrders');
    //     vm.callbackDetails = DynamicFactory.get('reportsCosult', 'CallbackDetails');
    //     vm.getConsultant = DynamicFactory.get('reportsCosult', 'Consultant');

    //     //others
    //     vm.loading = true;
    //     vm.state = { selected: undefined };
    //     vm.audio = new Audio();
    //     vm.minutesLeft = minutesLeft;
    //     // vm.secondReverse = false;
    //     // vm.secondPropertyName = '';

    //     function onInit() {
    //         if(SessionManager.getUserRoleId() === authRolesConst.admin) getCallcenterPerManager();
    //         if(SessionManager.getUserRoleId() === authRolesConst.manager || SessionManager.getUserRoleId() === authRolesConst.admin) generateConsultantPerContactCenter();
    //         setTripleView();
    //         getCallBackReportsAsync();

    //     } //the end onInit();

    //     function minutesLeft(minutes) {
    //         return minutes < 0 ? 0 : minutes;
    //     }

    //     function setDataTablesPlugin() {
    //         vm.dtInstance = {};

    //         vm.dtOptions = DTOptionsBuilder.newOptions()
    //             .withFnServerData(getCallBackReportsAsync)
    //             .withDataProp('data')
    //             .withOption('processing', true)
    //             .withOption('serverSide', true)
    //             .withOption('serverMethod', 'POST')
    //             .withOption('paging', true)
    //             .withPaginationType('full_numbers')
    //             .withOption('bLengthChange', true) //możliwość zmiany elementów na stronie
    //             .withOption('createdRow', createdRow)
    //             .withOption('filter', false)
    //             .withOption('info', false)
    //             .withOption('scrollY', window.innerHeight - 645)
    //             .withOption('scrollX', '100%')
    //             .withOption('scrollCollapse', true)
    //             .withFixedColumns({
    //                 leftColumns: 0,
    //                 rightColumns: 0
    //             });

    //         setColumns();
    //     }

    //     // function setColumns() {
    //     //     vm.dtColumns = [
    //     //         DTColumnBuilder.newColumn('id').withTitle('id').withOption('defaultContent', ""),
    //     //         DTColumnBuilder.newColumn('guid').withTitle('guid').withOption('defaultContent', ""),
    //     //         DTColumnBuilder.newColumn('consultantID').withTitle('Konsultant ID').withOption('defaultContent', ""),
    //     //         DTColumnBuilder.newColumn('buyerName').withTitle('Zamawiający').withOption('defaultContent', ""),
    //     //         DTColumnBuilder.newColumn('buyerEmail').withTitle('Email zamawiającego').withOption('defaultContent', ""),
    //     //         DTColumnBuilder.newColumn('buyerMsisdn').withTitle('Nr zamawiającego').withOption('defaultContent', ""),
    //     //         DTColumnBuilder.newColumn('minutes').withTitle('Minuty').withOption('defaultContent', ""),
    //     //         DTColumnBuilder.newColumn('minutesleft').withTitle('Pozostało').withOption('defaultContent', "").renderWith(minutesLeft),//.renderWith(function(){})
    //     //         DTColumnBuilder.newColumn('countDetails').withTitle('przek.').withOption('defaultContent', "")
    //     //     ];
    //     // }

    //     // function minutesLeft(data, type, full, meta) {
    //     //     if (!data) return;

    //     //     var htmlCode = '<span>{{(vm.callbackList[' + full.id + '].minutesleft < 0) ? 0 : vm.callbackList[' + full.id + '].minutesleft}} / {{ vm.callbackList[' + full.id + '].minutes}} min</span>' +
    //     //         ' <div class="border" style="overflow: hidden;" ng-style="{border-color: (vm.callbackList[' + full.id + '].minutes > 31 ? #ff5252)} : (vm.callbackList[' + full.id + '].minutes > 11 && vm.callbackList[' + full.id + '].minutes < 31) ? #311b92 : (vm.callbackList[' + full.id + '].minutes > 5 && vm.callbackList[' + full.id + '].minutes < 11) ? #0277bd : #4caf50">' +
    //     //         '<span class="inside" ng-style="{width: (vm.callbackList[' + full.id + '].minutes - vm.callbackList[' + full.id + '].minutesleft / vm.callbackList[' + full.id + '].minutes) * 100%, background-color: (vm.callbackList[' + full.id + '].minutes > 31) ? #ff5252 : (vm.callbackList[' + full.id + '].minutes > 10 && vm.callbackList[' + full.id + '].minutes < 31) ? #311b92 : (vm.callbackList[' + full.id + '].minutes > 5 && vm.callbackList[' + full.id + '].minutes < 11) ? #0277bd : #4caf50} ">' +

    //     //         '</span>' +
    //     //         '</div>' +
    //     //         '</span>';
    //     // }

    //     function setTripleView() {
    //         // tripleviewService.sidenavData.listDate = chooseDateTime.listDate;
    //         tripleviewService.sidenavData.config = {
    //             type: false,
    //             direction: false,
    //             callcenter: true,
    //             consultantList: false,
    //             agreagation: true,
    //             timeAgr: false,
    //             showChart: false
    //         };
    //     }

    //     // function sortByForwards(secondPropertyName) {
    //     //     vm.secondReverse = (vm.secondPropertyName === secondPropertyName) ? !vm.secondReverse : false;
    //     //     vm.secondPropertyName = secondPropertyName;
    //     // }

    //     function getCallBackReportsAsync(sSource, aoData, fnCallback, oSettings) {
    //         // var draw = aoData[0].value;
    //         // var order = aoData[2].value;
    //         // var startIndex = aoData[3].value + 1;
    //         // var pageSize = aoData[4].value;

    //         var raportFromDate, reportToDate;
    //         if (!tripleviewService.sidenavData.dateFrom && !tripleviewService.sidenavData.dateTo) {
    //             raportFromDate = tripleviewService.sidenavData.listDate[0].date.from;
    //             reportToDate = tripleviewService.sidenavData.listDate[0].date.to;
    //         } else {
    //             raportFromDate = tripleviewService.sidenavData.dateFrom;
    //             reportToDate = tripleviewService.sidenavData.dateTo;
    //         }

    //         var records = {
    //             'draw': 0,
    //             'recordsTotal': 0,
    //             'recordsFiltered': 0,
    //             'data': []
    //         };

    //         vm.loading = true;
    //         // var dateStart = tripleviewService.sidenavData.dateFrom,
    //         //     dateEnd = tripleviewService.sidenavData.dateTo,
    //         var CallcenterID = null;
    //         if (SessionManager.getUserRoleId() !== authRolesConst.consultant) {
    //             CallcenterID = tripleviewService.sidenavData.id ? tripleviewService.sidenavData.id : null;
    //         }
    //         vm.getCallback(CallcenterID, raportFromDate, reportToDate).then(function (resource) {
    //             vm.callbackList = resource;
    //             vm.loading = false;

    //             records = {
    //                 'draw': draw,
    //                 'recordsTotal': resource[0].consultantsTotal,
    //                 'recordsFiltered': resource[0].consultantsTotal,
    //                 'data': resource
    //             };

    //             fnCallback(records);
    //             showErrorMsg();
    //             // getCallcenterPerManager();
    //         });
    //     }

    //     function showForwardDetails(index, guid) {
    //         vm.state.selected = vm.state.selected !== index ? index : undefined;
    //         if (vm.unique !== guid) {
    //             vm.unique = guid;
    //             $timeout(function () {
    //                 vm.callbackDetails(guid).then(function (data) {
    //                     vm.forwardList = data;
    //                 });
    //             }, 500)
    //         } else {
    //             return;
    //         }
    //     }

    //     function getCallcenterPerManager() {
    // 	if (SessionManager.getUserRoleId() !== authRolesConst.consultant) {
    // 		DynamicFactory.get('reportsCosult', 'CallCenterList')().then(function (r) {
    // 			tripleviewService.sidenavData.callCenterList = r;
    // 		});
    // 	}
    // 	generateConsultantPerContactCenter();
    // }

    // function generateConsultantPerContactCenter() {
    // 	tripleviewService.sidenavData.consultantsPerCC = [];
    // 	var callcenterId;
    // 	if (SessionManager.getUserRoleId() === authRolesConst.admin) {
    // 		callcenterId = tripleviewService.sidenavData.id ? tripleviewService.sidenavData.id : null;
    // 	} else {
    // 		callcenterId = userInfo.callCenterId;
    // 	}
    // 	if (SessionManager.getUserRoleId() !== authRolesConst.consultant) {
    // 		DynamicFactory.get('reportsCosult', 'ConsultansGet')(callcenterId).then(function (r) {
    // 			tripleviewService.sidenavData.consultantsPerCC = r;
    // 			vm.consultantList = r;
    // 		})
    // 	}
    // }

    //     // function getCallbackDetails(uniqueidentifier) {

    //     // }

    //     // function addDetailsToPrimaryList(data) {
    //     //     angular.forEach(data, function (value, key) {
    //     //         value.details = vm.forwardList;
    //     //     });
    //     // }

    //     // function fullTime(duration) {
    //     //     var min = Math.floor((duration / 1000 / 60) < 0),
    //     //         sec = Math.floor((duration / 1000) % 60),
    //     //         time;

    //     //     (min < 10) ? min = '0' + min : min;
    //     //     (sec < 10) ? sec = '0' + sec : sec;

    //     //     duration == null ? time = '00:00' : time = min + ':' + sec;

    //     //     return time;
    //     // }

    //     // function generateDate(date) {
    //     //     tripleviewService.sidenavData.dateFrom = date.from;
    //     //     tripleviewService.sidenavData.dateTo = date.to;
    //     //     setLastDateToAnyDate(date);

    //     //     tripleviewService.sidenavData.disableDate = date.disabled;
    //     // }

    //     function setLastDateToAnyDate(date) {
    //         var anyDate = _.filter(tripleviewService.sidenavData.listDate, { 'name': 'Dowolna data' });
    //         _.forEach(anyDate, function (value, key) {
    //             value.date.from = date.from;
    //             value.date.to = date.to;
    //         });
    //     }

    //     function playRecording(stage) {
    //         vm.audio.pause();
    //         if (vm.playedStage) {
    //             vm.playedStage.play = false;
    //         }
    //         if (vm.playedStage !== stage) {
    //             vm.playedStage = stage;
    //             vm.playedStage.play = !vm.playedStage.play;
    //             if (stage.play) {
    //                 vm.audio.src = consts.recordings + stage.guid;
    //                 vm.audio.play();
    //             }
    //         }
    //         vm.audio.onended = function () {
    //             vm.playedStage.play = false;
    //             $scope.$apply();
    //         };
    //     }

    //     // function generateDate(date) {
    //     //     tripleviewService.sidenavData.dateFrom = date.from;
    //     //     tripleviewService.sidenavData.dateTo = date.to;
    //     //     setLastDateToAnyDate(date);
    //     //     tripleviewService.sidenavData.disableDate = date.disabled;
    //     // }

    //     // function setLastDateToAnyDate(date) {
    //     //     var anyDate = _.filter(tripleviewService.sidenavData.listDate, {
    //     //         'name': 'Dowolna data'
    //     //     });
    //     //     _.forEach(anyDate, function (value) {
    //     //         value.date.from = date.from;
    //     //         value.date.to = date.to;
    //     //     });
    //     // }

    //     // function playRecording(index, bridgeID) {
    //     //     var stop = $filter('filter')(vm.forwardList, { isPlaying: true });
    //     //     var url = consts.recordings;
    //     //     var rec = url + bridgeID;
    //     //     vm.audio.src = rec;
    //     //     vm.audio.volume = 0.2;
    //     //     if (vm.audio.currentSrc != rec) {
    //     //         vm.audio.src = rec;
    //     //         vm.audio.play();
    //     //         vm.forwardList[index].isPlaying = true;
    //     //         if (stop.length >= 1) {
    //     //             stop[0].isPlaying = false;
    //     //         }
    //     //     } else if (vm.forwardList[index].isPlaying) {
    //     //         vm.audio.pause();
    //     //         console.log('test');
    //     //         vm.forwardList[index].isPlaying = false;
    //     //     } else {
    //     //         vm.forwardList[index].isPlaying = true;
    //     //         vm.audio.play();
    //     //     }
    //     //     vm.audio.onended = function () {
    //     //         vm.forwardList[index].isPlaying = false;
    //     //         $scope.$apply();
    //     //     };
    //     // }
  }
})();

(function () {
    'use strict';

    angular
        .module('contactcenter.reports')
        .component('callbackAgregation', {
            templateUrl: 'app/main/contactcenter/reports/components/callback/callbackagregation/callbackagregation.html',
            require: {
                tripleView: '^tripleView'
            },
            controllerAs: 'vm',
            controller: callbackAgregation
        });

    function callbackAgregation(DynamicFactory, reportsCosult, tripleviewService, SessionManager, authRolesConst) {
        var vm = this;

        //function
        tripleviewService.sidenavData.getConnectData = getCallbackAgregationAsync;
        vm.$onInit = onInit;
        //resource
        vm.CallbackAggregationAsync = DynamicFactory.get('reportsCosult', 'CallbackAggregation');
        vm.ConsultantCallbackAggregationAsync = DynamicFactory.get('reportsCosult', 'ConsultantCallbackAggregation');
        //others
        vm.minutesColumn = [];

        function onInit() {
            setTripleView();
            getCallbackAgregationAsync();
        }

        function setTripleView() {
            // tripleviewService.sidenavData.listDate = chooseDateTime.listDate;
            // tripleviewService.sidenavData.generateDate = generateDate;
            tripleviewService.sidenavData.config = {};
        }

        function getCallbackAgregationAsync() {
            vm.callbackAgregationList = [];
            var raportFromDate, reportToDate;
            if (!tripleviewService.sidenavData.dateFrom && !tripleviewService.sidenavData.dateTo) {
                raportFromDate = tripleviewService.sidenavData.listDate[0].date.from;
                reportToDate = tripleviewService.sidenavData.listDate[0].date.to;
            } else {
                raportFromDate = tripleviewService.sidenavData.dateFrom;
                reportToDate = tripleviewService.sidenavData.dateTo;
            }
            if (SessionManager.getUserRoleId() !== authRolesConst.consultant) {
                vm.CallbackAggregationAsync(raportFromDate, reportToDate).then(function (r) {
                    vm.callbackAgregationList = r;
                    vm.callbackAgregationListLength = Object.keys(r).length;

                    createColumnForMinutes(r);
                    isValues(r);
                });
            } else {
                vm.ConsultantCallbackAggregationAsync(raportFromDate, reportToDate).then(function (r) {
                    vm.callbackAgregationList = r;
                    vm.callbackAgregationListLength = Object.keys(r).length;
                    createColumnForMinutesForConsultant(r);
                    isValues(r);
                });
            }
        }

        function isValues (e) {
            vm.emptyResponse = true;
            var responseLength =  Object.keys(e).length;

            if(responseLength < 3)
                vm.emptyResponse = true;
            else
                vm.emptyResponse = false;
        }

        function createColumnForMinutes(data) {
            var valueData = Object.values(data);

            for (var i in valueData) {
                if (valueData.hasOwnProperty(i)) {
                    for (var m in valueData[i]) {
                        if (valueData[i].hasOwnProperty(m)) {
                            var column = _.find(vm.minutesColumn, { 'minutes': parseInt(m) });
                            if (!column)
                                column = { 'minutes': parseInt(m) };

                            if (Number.isInteger(column.minutes))
                                vm.minutesColumn.push(column);

                            vm.uniqMinutesColumn = _.uniqBy(vm.minutesColumn, 'minutes');
                        }
                    }
                }
            }
        }

        function createColumnForMinutesForConsultant(data) {
            _.forEach(data, function(v,k) {
                var column = _.find(vm.minutesColumn, {'minutes': v.minutes});

                if (!column)
                    column = { 'minutes': v.minutes };

                vm.minutesColumn.push(column);
                vm.uniqMinutesColumn = _.uniqBy(vm.minutesColumn, 'minutes');
            });
        }

        // function generateDate(date) {
        //     tripleviewService.sidenavData.dateFrom = date.from;
        //     tripleviewService.sidenavData.dateTo = date.to;
        //     setLastDateToAnyDate(date);
        //     tripleviewService.sidenavData.disableDate = date.disabled;
        // }

        // function setLastDateToAnyDate(date) {
        //     var anyDate = _.filter(tripleviewService.sidenavData.listDate, {
        //         'name': 'Dowolna data'
        //     });
        //     _.forEach(anyDate, function (value) {
        //         value.date.from = date.from;
        //         value.date.to = date.to;
        //     });
        // }
    }
})();

(function () {
  'use strict';

  angular
    .module('contactcenter.orderbox', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    $stateProvider.state('app.contactcenter_orderbox', {
      url: '/orderbox',
      stateTranslationName: 'MAIL',
      hideTaHeader: true,
      params: {
        keepSidenavData: true
      },
      views: {
        'content@app': {

          template: '<triple-view></triple-view>'
          //template: '<orderbox></orderbox>'
          // controller: 'OrderBoxController as vm'
        },
        'sidenav@app.contactcenter_orderbox': {
          template:
            '<mail-List></mail-List>'
        }
      },
      resolve: {
      },
      bodyClass: 'mail'
    })
      .state('app.contactcenter_orderbox.threads', {
        url: '/:mailBoxId/:type/:filter',
        hideTaHeader: true,
        stateTranslationName: 'MAIL',

        views: {
          // 'content@app': {
          //   template: '<orderbox></orderbox>'
          // }
          mainContent: {
            template: '<orderbox></orderbox>'
          }
        },
        params: {
          mailBoxId: null,
          type: null,
          filter: null,
          // templateKey: 'mailList'
        },
        bodyClass: 'mail'
      })
      .state('app.contactcenter_orderbox.threads.thread', {
        hideTaHeader: true,
        url: '/:threadId',
        stateTranslationName: 'MAIL',
        bodyClass: 'mail'
      });


    // Translation
    $translatePartialLoaderProvider.addPart('app/main/contactcenter/orderbox');

  }
})();

/**

 */
(function () {
  'use strict';
  angular
    .module('contactcenter.orderbox')
    .component('mailDetailsContentCall', {
      templateUrl: 'app/main/contactcenter/orderbox/componets/maildetails/contentcall/contentcall.html',
      controllerAs: 'vm',
      bindings: {
        data: '<'
      },
      controller: ctrl
    });

  /** @ngInject */
  function ctrl(OrderboxGlue, callInfoBarBridge, $mdDialog, DynamicFactory, toastService, $translate, SessionManager, WebSocketManager, CallStatusConst, $localStorage, callInfoBarService, templateData, $state, communicatorService) {

    var vm = this;

    vm.startBrigeCall = startBrigeCall;
    vm.replyDialog = replyDialog;
    vm.prepairServiceClass = prepairServiceClass;
    // vm.openCaller = openCaller;
    vm.callActive = false;
    vm.callbackLastMinute=false;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.assignConsultantDialog = assignConsultantDialog;


    function onInit() {
      vm.OrderboxGlue = OrderboxGlue;
      vm.callInfoBarService = callInfoBarService;
      vm.userSession = SessionManager.getUser();
      vm.isConsultant = SessionManager.isConsultant();

      WebSocketManager.registerWebSocketMethod('CallOut', 'callBridge', callbackBridge);
      setCallObject();


    }

    function setCallObject() {
      // DynamicFactory.get('profileRsc', 'GetMyConsultant')().then(function (data) {
      //   if (data) {
      //     vm.consultantCall = {
      //       msisdn: $localStorage.hostNumber > 0 ? 'freetdm/2/a/' + $localStorage.hostNumber : data.phone1,
      //       name: data.firstName + ' ' + data.lastName,
      //       age: '',
      //       location: ''
      //     };
      //   }
      // }, function (errr) {

      // });
      vm.clientCall = {
        msisdn: vm.data.buyerMsisdn,
        name: vm.data.buyerName + ' ' + vm.data.buyerSurename,
        age: '',
        location: ''
      };
    }

    function onChanges(changesObj) {
      if (changesObj.data) {
        setCallObject();
      }
    }

    function callbackBridge(data) {
      var msg = JSON.parse(data.Content);
      if (msg.status === CallStatusConst.failed) {
        vm.callActive = false;
        vm.callbackLastMinute=false
        toastService.showToast($translate.instant('MAIL.DETAILS.CONTENTCALL.CALL_ERROR'), 'error', 4);
      } else if (msg.status === CallStatusConst.disconnected) {
        vm.callActive = false;
        vm.callbackLastMinute=false
      } else if (msg.status === CallStatusConst.timeupdate) {
        vm.data.minutesleft = msg.minutesLeft;
        if(msg.minutesLeft==0){
          vm.callbackLastMinute=true;
        }
      }
    }

    function startBrigeCall() {
      // console.log(vm.consultantCall, vm.clientCall);
      DynamicFactory.get('profileRsc', 'GetMyConsultant')().then(function (data) {
        if (data) {
          vm.consultantCall = {
            msisdn: data.phone1,
            name: data.firstName + ' ' + data.lastName,
            age: '',
            location: ''
          };

          if (!vm.consultantCall.msisdn) {
            vm.consultantCall.msisdn = $localStorage.hostNumber > 0 ? 'freetdm/2/a/' + $localStorage.hostNumber : null;
          }

          if (!vm.consultantCall.msisdn) {
            toastService.showToast($translate.instant('MAIL.DETAILS.CONTENTCALL.CALL_NO_CONS_PHONE'), 'error', 4);
            return;
          };

          vm.callActive = true;

          DynamicFactory.get('servicesRsc', 'servicesBundleFlatGet')(vm.data.serviceId).then(function (bundle) {
            bundle = JSON.stringify(bundle);
            callInfoBarBridge.startBrigeCall(vm.consultantCall, vm.clientCall, vm.userSession.consultantId, vm.data.guid, vm.data.minutesleft, vm.data.contactID, vm.data.serviceId, bundle, vm.data.configID, vm.data.managerID, function (res) {
              toastService.showToast($translate.instant(res.resultText), res.resultType, 4);
            }, function () {
              toastService.showToast($translate.instant('MAIL.DETAILS.CONTENTCALL.CALL_ERROR'), 'error', 4);
            });
          }, function (errr) {

          });
        }
      }, function (er) {

      });

    }

    // function openCaller(data) {
    //   if (vm.isConsultant) {
    //     DynamicFactory.get('servicesRsc', 'servicesBundleFlatGet')(data.serviceId).then(function (bundle) {
    //       var smsServiceId, ivrServiceId, chatServiceId, emailServiceId, callbackServiceId, facebookServiceId;
    //       if (bundle) {
    //         smsServiceId = bundle.smsService;
    //         ivrServiceId = bundle.ivrService;
    //         chatServiceId = bundle.chatService;
    //         emailServiceId = bundle.emailService;
    //         callbackServiceId = bundle.callbackService;
    //         facebookServiceId = bundle.facebookService;
    //       }
    //
    //       if (!templateData.created) {
    //         templateData = new templateData();
    //       } else {
    //         // reset ustawien
    //         templateData.clearData();
    //       }
    //
    //       templateData.msisdn = data.buyerMsisdn;
    //       templateData.currentServiceId = data.serviceId;
    //       // templateData.callid = data.guid;
    //       templateData.contactId = data.contactID;
    //       templateData.smsServiceId = smsServiceId;
    //       templateData.ivrServiceId = ivrServiceId;
    //       templateData.chatServiceId = chatServiceId;
    //       templateData.facebookServiceId = facebookServiceId;
    //       templateData.emailServiceId = emailServiceId;
    //       templateData.callbackServiceId = callbackServiceId;
    //       templateData.serviceOrderId = data.id;
    //       templateData.sessionId = data.sessionID;
    //       //templateData.serviceCommunicationParams=clientCall.params;
    //
    //       communicatorService.loadTemplateData(templateData);
    //
    //       $state.go('app.contactcenter_communicator.session', {
    //         type: 'V',
    //         id: data.id
    //       });
    //     }, function (errr) {
    //       console.log(errr);
    //     })
    //   }
    // };

    function openMailModal(ev, content) {
      return $mdDialog.show({
        locals: {
          selectedMail: vm.data
        },
        template: '<md-dialog-content>' + content + '</md-dialog-content>',
        controller: function (selectedMail) {
          this.selectedMail = selectedMail;
        },
        controllerAs: 'vm',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true //,
      })
    }


    function assignConsultantDialog(ev) {
      openMailModal(ev, '<assign-dialog selected-mail="vm.selectedMail"></assign-dialog>')
        .then(function (result) {
          if (result) {
            vm.data = result;
          }
        });
    }

    /**
     * Open reply dialog
     *
     * @param ev
     */
    function replyDialog(ev) {
      console.log('replyDialog');
      $mdDialog.show({
        locals: {
          selectedMail: vm.data
        },
        template: '<md-dialog-content><compose-dialog selected-mail="vm.selectedMail"></compose-dialog></md-dialog-content>',
        controller: function (selectedMail) {
          this.selectedMail = selectedMail;
        },
        controllerAs: 'vm',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true
      });
    }

    function prepairServiceClass(color) {
      if (color) {
        return color.toString().replace('-bg', '-fg').replace('md-', '');
      }
    }

  }
})();

/**
 * Created by akraszewski on 2017-05-26.
 */
(function() {
  'use strict';
  // const mime = require('mime-types')
  // var FileSaver = require('file-saver');
  angular.module('contactcenter.orderbox').component('callbackDetails', {
    templateUrl: 'app/main/contactcenter/orderbox/componets/maildetails/callbackdetails/callbackdetails.html',
    controllerAs: 'vm',
    bindings: {
      guid: '<'
    },
    controller: ctrl
  });

  /** @ngInject */
  function ctrl(DynamicFactory, OrderboxGlue, consts) {
    var vm = this;

    vm.sortBy = sortBy;
    vm.fullTime = fullTime;
    vm.playBridge = playBridge;
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;

    
    function onInit() {
      // vm.OrderboxGlue = OrderboxGlue;
      vm.audio = new Audio();
      vm.consultants = {};
      vm.reverse = true;
    }

    function onChanges(changesObj) {
      if (changesObj.guid.currentValue) {
        getHistory();
      }
    }

    function getHistory() {
      DynamicFactory.get('reportsCosult', 'CallbackDetails')(vm.guid).then(
        function(result) {
          vm.forwardList = result;
          vm.forwardList.forEach(getConsultant);
        }
      );
    }

    function playBridge(stage) {
      vm.audio.pause();
      if(vm.playedStage) {
        vm.playedStage.play = false;
      }
      if(vm.playedStage !== stage){
        vm.playedStage = stage;
        vm.playedStage.play = !vm.playedStage.play;
        if(stage.play){
          vm.audio.src = consts.recordings + stage.guid;
          vm.audio.play();
        }
      }
      // playCallback();
    }

    function getConsultant(order) {
      if (!order.consultantID) return;

      if (!vm.consultants[order.consultantID]) {
        vm.consultants[order.consultantID] = {};
        DynamicFactory.get('ConsultantsRsc', 'getConsultant')(order.consultantID).then(function(result) {
            console.log('consultant Loaded:', result);
            vm.consultants[order.consultantID] =result;
          },
          function(err) {
            console.log('błąd przy pobieraniu konsultanta' + err);
          }
        );
      }
    }





    // function bindConsultant(order, consultant) {
    //   vm.forwardList[vm.forwardList.indexOf(order)].consultant = consultant;
    // }

    function sortBy(propertyName) {
      vm.reverse = (vm.propertyName = propertyName) ? !vm.reverse : false;
      vm.propertyName = propertyName;
    }

    function fullTime(duration) {
      if (!duration) return '00:00';
      var min = Math.floor((duration / 1000 / 60) << 0),
        sec = Math.floor((duration / 1000) % 60);

      min < 10 ? (min = '0' + min) : min;
      sec < 10 ? (sec = '0' + sec) : sec;

      return min + ':' + sec;
    }
    //
  }
})();

/**
 * Created by akraszewski on 2017-05-26.
 */
(function () {
  'use strict';
  angular
    .module('contactcenter.orderbox')
    .component('mailDetailsHeader', {
      templateUrl: 'app/main/contactcenter/orderbox/componets/maildetails/header/header.html',
      controllerAs: 'vm',
      bindings: {
        data: '<'
      },
      controller: ctrl
    });

  /** @ngInject */
  function ctrl(OrderboxGlue, DynamicFactory, $mdDialog, SessionManager, toastService, $stateParams, $q, $scope, authRolesConst) {

    var vm = this;

    vm.toggleService = toggleService;
    vm.replyDialog = replyDialog;
    vm.prepairServiceClass = prepairServiceClass;
    vm.assignConsultantDialog = assignConsultantDialog;
    vm.redirectToConsultant = redirectToConsultant;
    vm.createIssueDialogParams = createIssueDialogParams;

    vm.$onChanges = onChanges;
    vm.$onInit = onInit;

    function onInit() {
      vm.OrderboxGlue = OrderboxGlue;

      vm.notConsutlatn = authRolesConst.consultant !== SessionManager.getUserRoleId();
      vm.currentConsultantID = SessionManager.getUser().consultantId;
    }

    function onChanges(changesObj) {
      vm.data.serviceEditableAllowed = !vm.data.serviceInfo || (vm.data.serviceInfo && !vm.data.serviceInfo.addedBy);

      if (OrderboxGlue.currentService) {
        vm.isSupervised = OrderboxGlue.currentService.supervised;
      }

    }


    function toggleService(mail, service) {

      if (mail.serviceEditableAllowed) {
        if (mail.serviceInfo === undefined) {
          //add
          changeMailSession(mail, service, 'addMailSession');
        } else if (mail.serviceInfo.serviceId === service.serviceID) {
          // vm.data.serviceInfo.serviceId = undefined;
          //odczepienie
        } else {
          //update
          changeMailSession(mail, service, 'updateMailSession');
        }
      } else {
        //powiadomienie że nie da si odczepić
      }
    }

    function prepareSession(mail, service) {
      return {
        MailId: mail.id,
        FromEmail: mail.from.email,
        FromName: mail.from.name,
        HasAttachment: mail.hasAttachments,
        DeliveryDate: mail.date,

        MailParentId: undefined,
        MailBoxId: OrderboxGlue.currentFilter.mailBoxId,
        ServiceId: service.serviceID,
        FolderName: OrderboxGlue.currentFilter.filter,
        FolderValidity: 'xyz' + OrderboxGlue.currentFilter.filter,
        Subject: mail.subject,
        MailSessionId: mail.serviceInfo !== undefined ? mail.serviceInfo.mailSessionId : null
      };
    }

    function changeMailSession(mail, service, operation) {
      var session = prepareSession(mail, service);
      DynamicFactory.get('OrderBoxRsc', operation)(session).then(function (data) {

        if(data.codeOrId===0){
          //ktoś już założył mail sesję

          var tempServiceInfo=JSON.parse(data.additionalData);
          var newServiceInfo={
            mailSessionId:tempServiceInfo.MailSessionId,
            serviceId:tempServiceInfo.ServiceId,
            serviceName:tempServiceInfo.ServiceName,
            serviceDesc:tempServiceInfo.ServiceDesc,
            color:tempServiceInfo.Color,
            addedBy:tempServiceInfo.AddedBy,
            type:tempServiceInfo.Type,
            emailMovedOrDel:tempServiceInfo.EmailMovedOrDel,
          };

          changeMailSessionUpdateView(newServiceInfo)  
          toastService.showToast(data.errorMessage+'. Widok został zakutalizowany', 'warn', 6);

        }else{
          //nowa sesja została założona
          var newServiceInfo = {
            serviceId: service.serviceID,
            serviceName: service.serviceName,
            color: service.color,
            mailSessionId:data.codeOrId,
            addedBy: SessionManager.getUser().userId
          };

          changeMailSessionUpdateView(newServiceInfo)  
          toastService.showToast('Założono sesje', 'success', 4);
        }


      }, function (err) {
        console.log('Error: ' + err);
        toastService.showToast('Bład zakładania sesji email', 'error', 4);
      });
    }

    function changeMailSessionUpdateView(newServiceInfo){
      vm.data.serviceInfo = newServiceInfo;
      vm.data.serviceEditableAllowed = false;

      var listElem = _.find(vm.OrderboxGlue.threads, {
        id: mail.id
      });

      if (listElem) {
        listElem.serviceInfo = newServiceInfo;
      }

    }

    function redirectToConsultant(ev) {
      // RedirectConsultantModal.showDialog(e, OrderboxGlue.currentService.serviceId)
      openMailModal(ev, '<compose-dialog is-forward="true" selected-mail="vm.selectedMail"></compose-dialog>')
        .then(function (res) {
          DynamicFactory.get('OrderBoxRsc', 'setMailSessionConsultant')(res.consultantID, res.serviceInfo.mailSessionId).then(function (data) {
            toastService.showToast('Przypisano do użytkownika' + res.firstName + ' ' + res.lastName, 'success', 4);
          }, function (err) {
            toastService.showToast('Błąd przypisywania do użytkownika: ' + res.firstName + ' ' + res.lastName, 'error', 4);
          });
        });
    }


    function replyDialog(ev) {
      // console.log('replyDialog');
      // $mdDialog.show({
      //   locals: {
      //     selectedMail: vm.data
      //   },
      //   template: '<md-dialog-content><compose-dialog selected-mail="vm.selectedMail"></compose-dialog></md-dialog-content>',
      //   controller: function (selectedMail) {
      //     this.selectedMail = selectedMail;
      //   },
      //   controllerAs: 'vm',
      //   parent: angular.element(document.body),
      //   targetEvent: ev,
      //   clickOutsideToClose: true
      // });
      openMailModal(ev, '<compose-dialog selected-mail="vm.selectedMail"></compose-dialog>');
    }

    function assignConsultantDialog(ev) {
      // $mdDialog.show({
      //   locals: {
      //     selectedMail: vm.data
      //   },
      //   template: '<md-dialog-content><assign-dialog selected-mail="vm.selectedMail"></assign-dialog></md-dialog-content>',
      //   controller: function (selectedMail) {
      //     this.selectedMail = selectedMail;
      //   },
      //   controllerAs: 'vm',
      //   parent: angular.element(document.body),
      //   targetEvent: ev,
      //   clickOutsideToClose: true//,
      //   // onRemoving: function (event, removePromise) {
      //   //   console.log(event, removePromise);
      //   // }
      // })
      openMailModal(ev, '<assign-dialog selected-mail="vm.selectedMail"></assign-dialog>')
        .then(function (result) {
          if (result) {
            vm.data = result;
          }
        });
    }

    function openMailModal(ev, content) {
      var selectedMail = angular.copy(vm.data);
      if(vm.OrderboxGlue.currentMailBoxFolder == 'Sent'){
        var trueFrom = angular.copy(selectedMail.to[0]);
        selectedMail.to = [angular.copy(selectedMail.from)];
        selectedMail.from = trueFrom;
      }
      return $mdDialog.show({
        locals: {
          selectedMail: selectedMail
        },
        template: '<md-dialog-content>' + content + '</md-dialog-content>',
        controller: function (selectedMail) {
          this.selectedMail = selectedMail;
        },
        controllerAs: 'vm',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true //,
        // onRemoving: function (event, removePromise) {
        //   console.log(event, removePromise);
        // }
      })
    }

    function createIssueDialogParams() {
      return $q(function(resolve, reject){
        var issueDialogParams;

        if(vm.data){
          if (vm.data.issueId != undefined) {
            issueDialogParams = {
              issueId: vm.data.issueId
            };
          } else {
            issueDialogParams = {
             //service: vm.data.serviceInfo,
              data: '<br/>' + vm.data.date + ' ' + vm.data.from.name + ' < ' + vm.data.from.email + '> napisał/a: <blockquote>' + vm.data.body + '</blockquote>',
              channelInfo:{
                channelType: vm.data.serviceInfo.type,
                channelSessionId: vm.data.serviceInfo.mailSessionId,
                channelId: vm.data.serviceInfo.serviceId,
                channelConfigId: vm.data.mailBoxID,
                channelName: vm.data.serviceInfo.serviceName
              },
              contactId: vm.data.contactId,
              issueMsgDate: vm.data.date
            };
          }
          resolve(issueDialogParams);
        }
      });
      /*var issueDialogParams;

      if (vm.data.issueId) {
        issueDialogParams = {
          issueId: vm.data.issueId
        };
      } else {
        issueDialogParams = {
          service: vm.data.serviceInfo,
          data: vm.data.serviceInfo.type === 'E' ? '<br/>' + vm.data.date + ' ' + vm.data.from.name + ' < ' + vm.data.from.email + '> napisał/a: <blockquote>' + vm.data.body + '</blockquote>' : '',
          type: vm.data.serviceInfo.type,
          sessionId: vm.data.serviceInfo.type === 'E' ? vm.data.serviceInfo.mailSessionId : vm.data.id,
          contactId: vm.data.contactId
        };
      }

      return issueDialogParams;*/
    }

/*
    function createJiraIssue() {
      if (OrderboxGlue.currentThread.issueId) {
        /* issueTrackerService.openIssueDialog({
           issueId :OrderboxGlue.currentThread.issueId
         });

        jiraIssueService.showIssueCreator({
          issueId: OrderboxGlue.currentThread.issueId
        });
      } else {
        jiraIssueService.showIssueCreator({
          service: vm.data.serviceInfo,
          data: vm.data.serviceInfo.type === 'E' ? '<br/>' + vm.data.date + ' ' + vm.data.from.name + ' < ' + vm.data.from.email + '> napisał/a: <blockquote>' + vm.data.body + '</blockquote>' : '',
          type: vm.data.serviceInfo.type,
          sessionId: vm.data.serviceInfo.type === 'E' ? vm.data.serviceInfo.mailSessionId : vm.data.id,
          contactId: vm.data.contactId
        });
      }
    }
*/
    function prepairServiceClass(color) {
      if (color) {
        return color.toString().replace('-bg', '-fg').replace('md-', '');
      }
    }

  }
})();

/**
 * Created by akraszewski on 2017-05-26.
 */
(function () {
  angular
    .module('contactcenter.orderbox')
    .component('mailDetailsContent', {
      templateUrl: 'app/main/contactcenter/orderbox/componets/maildetails/content/content.html',
      controllerAs: 'vm',
      bindings: {
        data: '<'
      },
      controller: ctrl
    });

  /** @ngInject */
  function ctrl(OrderboxGlue, callInfoBarBridge, $mdDialog, SessionManager) {

    var vm = this;

    vm.startBrigeCall = startBrigeCall;
    vm.replyDialog = replyDialog;
    vm.runForwardDialog = runForwardDialog;
    vm.prepairServiceClass = prepairServiceClass;
    vm.$onInit = onInit;


    function onInit() {
      vm.OrderboxGlue = OrderboxGlue;
      vm.userSession = SessionManager.getUser();

      vm.sample1 = {
        msisdn: "4043",
        name: "Adam",
        age: "29",
        location: "Poznan"
      };
      vm.sample2 = {
        msisdn: "4024",
        name: "Jan",
        age: "30",
        location: "Waw"
      };
    }


    function startBrigeCall(clientCall, clientCall2) {
      callInfoBarBridge.startBrigeCall(clientCall, clientCall2, vm.userSession.consultantId, null, 0, null, null, {}, 0, null);
    };


    /**
     * Open reply dialog
     *
     * @param ev
     */
    function replyDialog(ev) {
      console.log('replyDialog');
      $mdDialog.show({
        locals: {
          selectedMail: vm.data
        },
        template: '<md-dialog-content><compose-dialog selected-mail="vm.selectedMail"></compose-dialog></md-dialog-content>',
        controller: function (selectedMail) {
          this.selectedMail = selectedMail;
        },
        controllerAs: 'vm',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true
      });
    }

    function runForwardDialog($event) {
      $mdDialog.show({
        locals: {
          selectedMail: vm.data
        },
        template: '<md-dialog-content><compose-dialog selected-mail="vm.selectedMail" is-forward="true"></compose-dialog></md-dialog-content>',
        controller: function (selectedMail) {
          this.selectedMail = selectedMail;
        },
        controllerAs: 'vm',
        bindToController: true,
        parent: angular.element(document.body),
        targetEvent: $event,
        clickOutsideToClose: true
      });

    }

    function prepairServiceClass(color) {
      if (color) {
        return color.toString().replace('-bg', '-fg').replace('md-', '');
      }
    }


  }
})();

/**
 * Created by akraszewski on 2017-05-26.
 */
(function () {
  'use strict';
  // const mime = require('mime-types')
  // var FileSaver = require('file-saver');
  angular
    .module('contactcenter.orderbox')
    .component('mailDetailsAttachments', {
      templateUrl: 'app/main/contactcenter/orderbox/componets/maildetails/attachments/attachments.html',
      controllerAs: 'vm',
      bindings: {
        thread: '<'
      },
      controller: ctrl
    });


  /** @ngInject */
  function ctrl(DynamicFactory, OrderboxGlue, consts, SessionManager, $document, $http, mimeTypes, FileSaver) {

    var vm = this;

    vm.download = download;
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;

    function onInit() {
      // vm.OrderboxGlue = OrderboxGlue;
    }

    function onChanges(changesObj) {
      if (changesObj.thread.currentValue.attachments){
        changesObj.thread.currentValue.attachments.forEach(function (attachment) {
          attachment.type = getType(attachment.fileName);
          attachment.isImage = isImage(attachment.fileName);
          attachment.downloadLink = buildLink(attachment,changesObj.thread.currentValue);
        });
      }
    }

    function getFromString(url, regex) {
      var matchUrl = url.match(regex);
      if (matchUrl) {
        var regexResult = matchUrl[0].replace('.', '');
        if (regexResult != null) {
          return regexResult;
        } else {
          return '--';
        }
      }
      else{
        return '--';
      }
    }

    function getType(url) {
      return getFromString(url, /\.[^.]*$/);
    }

    function isImage(url) {
      var type = getFromString(url, /\.(gif|jpg|jpeg|tiff|png)$/i);
      return type !== '--';
    }



    function buildLink(Attachment,thread) {
      return consts.api + SessionManager.getUserRole() + '/imap/getMessageAttachment/' + thread.mailBoxID + '/' + thread.id + '/' + thread.folderName + '/' + Attachment.fileName + '#';
    }

    function b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, {
        type: contentType
      });
      return blob;
    }

    function download(attachment) {
      // _blank
      $http.get(attachment.downloadLink, null, {
        responseType: 'arraybuffer'
      }).then(function (data) {
        var file = b64toBlob(data.data, mimeTypes.getExtension(attachment.fileName));
        //  new Blob([atob(data.data)], {
        //   type: mimeTypes.getExtension(attachment.fileName)
        // });
        // FileSaver.saveAs(file, attachment.fileName);
        var url = window.URL.createObjectURL(file);
        var link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', attachment.fileName);
        var event = document.createEvent('MouseEvents');
        event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
        link.target = '_blank';
        link.dispatchEvent(event);
      });
    }
  }
})();

/**
 *
 */
+function () {
  'use strict';
  angular.module('management.services').component('taCheckbox', {
    templateUrl: 'app/main/contactcenter/management/services/component/tacheckbox/tacheckbox.html',
    controllerAs: 'vm',
    bindings: {
      translation: '<',
      ngModel: '<',
      source: '<',
      outValue:'='
    },
    controller: controller
  });


  /** @ngInject */
  function controller() {
    var vm = this;
    vm.updateModel = updateModel;

    vm.$onInit = init;

    function init() {
    }


    vm.$onChanges = function (changesObj) {

      if(!vm.source2 || (changesObj.source && changesObj.source.currentValue)){
        vm.source2 = [];
        angular.forEach(vm.source, function (e) {
          vm.source2.push({name: e});
        });
      }

      if ((changesObj.ngModel && changesObj.ngModel.currentValue)) {

        var values = vm.ngModel.split(',');

        angular.forEach(values, function (elem) {
          var x=_.find(vm.source2, {name:elem});
          if (x) {
            x.checked = true;
          }
        });

      }
    };

    function updateModel(item) {
      item.checked = !item.checked;
      var checked = _.filter(vm.source2, {checked: true});
      // vm.ngModel = codeList(checked).join(',');
      vm.outValue = codeList(checked).join(',');
      console.log(vm.ngModel);
    }

    function codeElement(elem) {
      return elem.name + '';
    }

    function codeList(list) {
      return list.map(codeElement);
    }



  }
}();

/**
 * Created by kosski on 23.08.2016.
 */
+ function () {
  'use strict';

  angular.module('management.services').component('surveyStep', {
    templateUrl: 'app/main/contactcenter/management/services/component/surveystep/surveystep.html',
    require: {
      tripleView: '^tripleView'
    },
    controllerAs: 'vm',
    controller: controller
  })

  /** @ngInject */
  function controller(DynamicFactory, wizzardService, toastService, $q, $state) {
    var vm = this;

    vm.$postLink = postLink;
    vm.addSurveyClic = addSurveyClic;
    vm.setSurvey = setSurvey;
    vm.sortBy = sortBy;
    vm.$onInit = onInit;

    function onInit() {
      vm.service = wizzardService.service;
      getSurveys();
      // getFormTypes();
    }

    function postLink() {

    }

    function getSurveys() {
      var promises = [];
      promises.push(DynamicFactory.get('surveyRsc', 'getAvaliableSurveys')().then(function (result) {
        vm.avableSurveys = result;
      }));
      promises.push(DynamicFactory.get('surveyRsc', 'getServiceSurveys')(wizzardService.service.serviceID).then(function (result) {
        vm.serviceSurveys = result.map(function (element) {
          return element.id;
        });
      }));
      bindActiveSurveys(promises);

    }

    function bindActiveSurveys(promises) {
      $q.all(promises).then(function (s) {
        vm.avableSurveys.forEach(function (survey) {
          if (vm.serviceSurveys.indexOf(survey.id) != -1)
            survey.bindedToService = true;
        })
      })
    }


    function setSurvey(survey) {
      if (vm.onError) {
        vm.onError = false;
        return;
      }
      var endpointKey = survey.bindedToService ? 'addServiceSurvey' : 'deleteServiceSurvey'
      DynamicFactory.get('surveyRsc', endpointKey)(wizzardService.service.serviceID, survey.id).then(function (result) {
        toastService.showToast($translate.instant(endpointKey === 'addServiceSurvey' ? 'MANAGEMENT.SURVEYS.BIND_SUCCESS' : 'MANAGEMENT.SURVEYS.DELETE_SUCCES'), 'success', 100);
      }, function (err) {
        toastService.showToast($translate.instant('MANAGEMENT.SURVEYS.BIND_ERROR'), 'error', 100);
        survey.bindedToService = !survey.bindedToService;
        vm.onError = true;
      });
    }

    function sortBy(propertyName) {
      vm.reverse = (vm.propertyName = propertyName) ? !vm.reverse : false;
      vm.propertyName = propertyName;
    }

    // function getFormTypes() {
    //   vm.fieldTypes = DynamicFactory.get('templatesRsc', 'getFieldTypes')();
    // }

    function addSurveyClic(survey, $event) {
      vm.editMode = true;

      // $event.stopPropagation();
      // $mdDialog.show({
      //   clickOutsideToClose: true,
      //   controller: 'addSurveyDialogController',
      //   controllerAs: 'vm',
      //   // targetEvent :$event,
      //   // fullscreen: true,
      //   // parent : angular.element('#survey-step'),
      //   focusOnOpen: false,
      //   locals: {
      //     params: {
      //       survey: survey,
      //       fieldTypes: vm.fieldTypes
      //     }
      //   },
      //   targetEvent: event,
      //   templateUrl: 'app/main/contactcenter/management/services/templates/surveyedit.html',
      //   multiple: true
      // }).then(function (survey) {
      //   var endpointKey = survey.id ? 'update' : 'save';
      //   survey.configJSON = '{"config":' + JSON.stringify(survey.configJSON.config) + '}';
      //   DynamicFactory.get('surveyRsc', endpointKey + 'Survey')(survey).then(function (result) {
      //     if (!survey.id) {
      //       survey.id = result.codeOrId;
      //       vm.avableSurveys.push(angular.copy(survey));
      //     }
      //     toastService.showToast('Zmiany zostały zapisane', 'success', 100);
      //     vm.editMode = false;
      //   });
      //   //success
      // }, function (err) {
      //   console.log(err);
      //   //fail
      // });
      $state.go('app.contactcenter_management.services.wizzard.surveys.edit', {
        survey: survey
      });
    }

  }


}();

/**
 * Created by kosski on 08.09.2016.
 */
(function () {
  'use strict';

  angular.module('management.services').component('surveyEdit', {
    templateUrl: 'app/main/contactcenter/management/services/component/surveyedit/surveyedit.html',
    bindings: {
      survey: '='
    },
    require: {
      tripleView: '^tripleView'
    },
    controllerAs: 'vm',
    controller: surveyEdit
  });


  function surveyEdit(DynamicFactory, toastService, $state,wizzardService) {
    var vm = this;


    vm.addField = addField;
    vm.saveEditedField = saveEditedField;
    // vm.fieldTypes = params.fieldTypes;
    vm.deleteField = deleteField;
    vm.editField = editField;
    vm.cancelEditField = cancelEditField;
    vm.saveSurvey = saveSurvey;


    vm.$onInit = onInit;
    vm.$postLink = postLink;

    function onInit() {
      getFormTypes();
      vm.tripleView.addMenuItem({
        order: 20,
        name: 'Dodaj',
        icon: 'icon-content-save',
        class: 'md-accent icon-button-shadow',
        unremovable: false,
        func: saveSurvey
      });
      vm.multiselectConf = {
        token: 'MANAGEMENT.SERVICE.SURVEYS.EDIT.OPTIONS'
      };

    }

    function postLink() {
      if (!vm.survey){
        vm.survey = {
          name: '',
          description: '',
          configJSON: {
            config: []
          }
        };
      }else if (angular.isString(vm.survey.configJSON)){
        vm.survey.configJSON = JSON.parse(vm.survey.configJSON);
      }

      wizzardService.tempEditedSurvey=vm.survey;
    }



    vm.sortableCCOptions = {
      placeholder: 'field',
      stop: function (e, ui) {
        recalculatePriority();
      }
    };

    function getFormTypes() {
      vm.fieldTypes = DynamicFactory.get('templatesRsc', 'getFieldTypes')();
    }

    function recalculatePriority() {
      vm.survey.configJSON.config.forEach(function (field, index) {
        field.order = index;
      });
    }

    function saveSurvey() {
      var surveyToSave = angular.copy(wizzardService.tempEditedSurvey);
      wizzardService.tempEditedSurvey=undefined;
      var endpointKey = surveyToSave.id ? 'update' : 'save';
      surveyToSave.configJSON = '{"config":' + JSON.stringify(surveyToSave.configJSON.config) + '}';
      DynamicFactory.get('surveyRsc', endpointKey + 'Survey')(surveyToSave).then(function (result) {
        toastService.showToast('Zmiany zostały zapisane', 'success', 100);
        vm.tripleView.changeState('app.contactcenter_management.services.wizzard.surveys');
        // if (!surveyToSave.id) {
        //   surveyToSave.id = result.codeOrId;
        //   vm.avableSurveys.push(angular.copy(surveyToSave));
        // }
        // vm.editMode = false;
      });
    }



    function deleteField(field) {
      vm.survey.configJSON.config.splice(vm.survey.configJSON.config.indexOf(field), 1);
    }

    function addField(fieldType) {
      if (!vm.survey.configJSON.config) vm.survey.configJSON.config = [];

      vm.survey.configJSON.config.push({
        label: '',
        type: fieldType.name,
        withSource: fieldType.withSource,
        source: fieldType.withSource ? '' : undefined,
        fieldId: getNewId(vm.survey.configJSON.config.length),
        order: vm.survey.configJSON.config.length,
        editField: true,
        removeable:true
      });
    }

    function getNewId(propsition) {
      var index = _.findIndex(vm.survey.configJSON.config, {
        fieldId: propsition
      });
      if (index !== -1)
        return getNewId(propsition + 1);
      else
        return propsition;
    }

    function editField(field) {
      var editedIndex = _.findIndex(vm.survey.configJSON.config, {
        editField: true
      });
      if (editedIndex !== -1)
        cancelEditField(vm.survey.configJSON.config[editedIndex]);
      field.editField = true;
      vm.editedField = angular.copy(field);
    }

    function cancelEditField(field) {
      var index = vm.survey.configJSON.config.indexOf(field);
      vm.survey.configJSON.config[index] = angular.copy(vm.editedField);
        if(!vm.survey.configJSON.config[index]) {
          deleteField(field);
        }else {
          vm.survey.configJSON.config[index].editField = false;
        }
    }

    function saveEditedField() {
      if (vm.newField) {
        vm.survey.configJSON.push(angular.copy(vm.newField));
      }
      vm.newField = undefined;
    }

  }


})();

/**
 *
 */
+ function () {
  'use strict';
  angular.module('management.services').component('stepPoint', {
    templateUrl: 'app/main/contactcenter/management/services/component/steppoint/steppoint.html',
    controllerAs: 'vm',
    require: {
      tripleView: '^tripleView'
    },
    // bindings: {
    //   service: '=',
    //   onUpdate: '&'
    // },
    controller: controller
  });


  /** @ngInject */
  function controller(DynamicFactory, $rootScope, $mdDialog, $q, $state, $translate, wizzardService, toastService,confirmDialogService) {
    var vm = this;
    vm.wizzardService = wizzardService;
    vm.managePayment = managePayment;
    vm.deletePayment = deletePayment;
    vm.$onInit = onInit;
    // function doCheck() {
    //   if (vm.service && !angular.equals(wizzardService.service, vm.service)) {
    //     wizzardService.service = vm.service; 
    //   }
    // }
    
    function onInit() {
      vm.service = wizzardService.service;
      // vm.$doCheck = doCheck;
      console.log('init - stepMail - wizzardService: ', wizzardService.service);

      vm.mailListModel = {};
      vm.mailListModel.partnerId = vm.service.servicePartnerID;

      vm.tripleView.overrideRole(wizzardService.setMenuWizzard());

      vm.tripleView.addMenuItem({
        order: 20,
        name: 'Dalej',
        // icon: 'icon-arrow-right-bold-circle',
        iconSrc:'assets/icons/triple-view/dalej.png',
        // unremovable: true,
        func: function () {
          vm.tripleView.changeState('app.contactcenter_management.services.wizzard.finalstep');
        }
      });
      // vm.tripleView.addMenuItem({
      //   order: 20,
      //   name: 'Dodaj',
      //   icon: 'icon-plus-circle',
      //   class: 'md-accent icon-button-shadow',
      //   func: function ($event) {
      //     vm.managePayment($event,{serviceId: vm.service.serviceID},true)
      //   }
      // });
      DynamicFactory.get('PaymentRsc', 'getPaymentTypes')(vm.service.serviceID).then(function (s) {
        vm.paymentList = s;
        vm.service.payment = vm.paymentList;
      });
    }

    function managePayment(ev, item, inserted) {
      $mdDialog.show({
        locals: {
          paymentService: item,
          inserted: inserted
        },
        template: '<md-dialog-content><point-dialog payment-service="vm.paymentService" inserted="vm.inserted"></point-dialog></md-dialog-content>',
        controller: function (paymentService) {
          // var vm = this;
          this.paymentService = paymentService;
          this.inserted = inserted;
        },
        controllerAs: 'vm',
        targetEvent: ev,
        clickOutsideToClose: true
      }).then(function (result) {
        if (inserted) {
          if (!vm.service.payment) {
            vm.service.payment = [];
          }
          //vm.paymentList.push(result);
          vm.service.payment.push(result);
        }
      });
    }

    function deletePayment(payment) {
      confirmDialogService.showRecDeleteConfirm().then(function () {
        payment.isActive = false;
        onSuccessDelete()
      },function () {
        onErrorDelete();
        //console.log('You cancelled the dialog.');
      })

    }

    function onSuccessDelete(data) {
      toastService.showToast($translate.instant('COMMON.DELETE_SUCCESS'), 'success', 4);
    }

    function onErrorDelete(e) {
      toastService.showToast($translate.instant('COMMON.DELETE_ERROR'), 'error', 10);
    }

  }
}();

/**
 * Created by kosski on 23.08.2016.
 */
+function () {
  'use strict';
  angular.module('management.services').component('stepPartner', {
    templateUrl: 'app/main/contactcenter/management/services/component/steppartner/steppartner.html',
    controllerAs: 'vm',
    require: {
      tripleView: '^tripleView'
    },
    // bindings: {
    //   service: '=',
    //   onUpdate: '&'
    // },
    controller: controller
  });


  /** @ngInject */
  function controller(DynamicFactory, $rootScope, $mdDialog, $q, $state, $translate, wizzardService, toastService) {
    var vm = this;
    vm.wizzardService = wizzardService;
    vm.setMail = setMail;
    vm.$onInit = onInit;
    vm.$doCheck = doCheck;
    function doCheck() {
        // if (vm.service && !angular.equals(wizzardService.service, vm.service)) {
        //   wizzardService.service = vm.service; 
        // }
      if(vm.previousPartnerId)
        if (!angular.equals(vm.previousPartnerId, vm.service.servicePartnerID)) {
          vm.tripleView.overrideRole(wizzardService.setMenuWizzard());
          vm.previousPartnerId = vm.service.servicePartnerID;
        }
    }
    function onInit() {
      vm.service = wizzardService.service;
      // vm.$doCheck = doCheck;
      console.log('init - stepMail - wizzardService: ', wizzardService.service);

      vm.tripleView.overrideRole(wizzardService.setMenuWizzard());

      vm.tripleView.addMenuItem({
        order: 20,
        name: 'Dalej',
        // icon: 'icon-arrow-right-bold-circle',
        iconSrc:'assets/icons/triple-view/dalej.png',        
        // unremovable: true,
        func: function () {
          if (vm.service.servicePartnerID === undefined) {
            toastService.showToast($translate.instant('MANAGEMENT.SERVICE.WIZ.STEPPARTNER.CHOOSE_PARTNER'), 'error', 4);
          }
          else {
            switch (vm.service.type) {
              case 'S':
                vm.tripleView.changeState('app.contactcenter_management.services.wizzard.numberstep');
                break;
              case 'I':
                vm.tripleView.changeState('app.contactcenter_management.services.wizzard.numberstep');
                break;
              case 'E':
                vm.tripleView.changeState('app.contactcenter_management.services.wizzard.mailstep');
                break;
              case 'C':
                vm.tripleView.changeState('app.contactcenter_management.services.wizzard.basicstep');
                break;
            }
          }
        }
      });
      DynamicFactory.get('partnerRsc', 'GetPartners')().then(function (s) {
        vm.partnersList = s;
      });
    }

    function doCheck() {
      var previousPartnerId;
      this.$doCheck = function () {
        if (!angular.equals(previousPartnerId, vm.service.servicePartnerID)) {
          vm.tripleView.overrideRole(wizzardService.setMenuWizzard());
          previousPartnerId = vm.service.servicePartnerID;
        }
      }
    }
    function setMail(item) {
      vm.service.mailBoxId = item.id;
    }
  }
}();

/**
 * Created by kosski on 08.06.2018.
 */
+ function () {
  'use strict';
  angular.module('management.services').component('simpleWizzard', {
    templateUrl: 'app/main/contactcenter/management/services/component/simplewizzard/simplewizzard.html',
    controllerAs: 'vm',
    require: {
      tripleView: '^tripleView'
    },
    controller: controller
  });


  /** @ngInject */
  function controller(DynamicFactory, wizzardService, toastService, $translate, $state) {
    var vm = this;

    vm.setMenuWizzard = setMenuWizzard;
    vm.setStepControl = setStepControl;
    vm.saveService = saveService;
    vm.templateFormChoosen = templateFormChoosen;
    vm.$onInit = onInit;
    vm.$postLink = postLink;


    function onInit() {
      // vm.saveService = wizzardService.updateService;
      vm.serviceProgress = 0;
    }


    function postLink() {
      loadService($state.params.serviceId, $state.params.serviceType);
      if ($state.params.serviceId) {
        vm.typeChoosen = true;
      }
    }

    function afterLoadService() {
      vm.service = wizzardService.service;

      getTemplateList();

      initStepControl();
      getBaseTags();
    }


    function loadService(serviceId, type) {
      wizzardService.loadService(serviceId, type)
        .then(function (result) {
          // vm.service = result;
          // setBaseChatSetup(vm.service);
          // vm.tripleView.overrideRole(wizzardService.setMenuWizzard());
          afterLoadService();
        });
    }

    function selectTemplate() {
      var templateIndex = _.findIndex(vm.templateList, {
        id: vm.service.templateId
      });
      vm.choosenTemplate = vm.templateList[templateIndex];
    }

    function templateFormChoosen() {
      vm.service.templateId = vm.choosenTemplate.id;
    }

    function saveService() {
      wizzardService.updateService();
      console.log('simpleWizzard | save service comparation: ',vm.service,wizzardService.service ,vm.service==wizzardService.service)
    }

    function changeServiceAvatar(file) {
      vm.parentScope.service.photoUrl = file.contentUrl;
      vm.onUpdate();
    }

    function getBaseTags() {
      DynamicFactory.get('tagsRsc', 'getServiceTags')().then(function (result) {
        vm.baseTags = result;
      }, error);
    }

    function getTemplateList() {
      DynamicFactory.get('servicesRsc', 'GetTemplateList')().then(function (result) {
        vm.templateList = result;
        if (vm.service.serviceID) {
          selectTemplate();
        }
      }, error);
    }

    function error(err) {
      toastService.showToast($translate.instant('COMMON.ERROR'), 'error', 4);
    }

    function setStepControl(controll) {
      // if(!vm.stepControl){
      //   vm.stepControl= {};
      // }
      vm.stepControl = _.merge(vm.stepControl, controll);
    }

    function initStepControl() {
      vm.stepControl = {
        // 'basicstep': {
        //   disabled: vm.getDisabledKeySteps()
        // },
        // 'finalstep': {
        //   disabled: vm.getDisabledKeySteps()
        // },
        'partnerstep': {
          disabled: ((wizzardService.service === null || wizzardService.service.type === null))
        },
        'numberstep': {
          hide: ((wizzardService.service === null || wizzardService.service.type === null) || (wizzardService.service && wizzardService.service.type !== 'C' && wizzardService.service.type !== 'I'))
        },
        'mailstep': {
          hide: ((wizzardService.service === null || wizzardService.service.type === null) || (wizzardService.service && wizzardService.service.type !== 'E'))
        }
      }
    }

    function setMenuWizzard() {
      vm.typeChoosen = true;
      setStepControl({
        'numberstep': {
          hide: (vm.service.type !== 'S' && vm.service.type !== 'I')
        },
        'mailstep': {
          hide: (vm.service.type !== 'E')
        },
        'pointstep': {
          hide: (vm.service.type !== 'E')
        },
        'partnerstep': {
          disabled: false
        }
      });
    }

  }


}();

/**
 * Created by kosski on 23.08.2016.
 */
+function () {
    'use strict';
    angular.module('management.services').component('stepFinal', {
        templateUrl: 'app/main/contactcenter/management/services/component/stepfinal/stepfinal.html',
        controllerAs: 'vm',
        require: {
            tripleView: '^tripleView'
        },
        // bindings: {
        //     service: '='
        //     // onUpdate: '&'
        // },
        controller: controller
    });

    /** @ngInject */
    function controller(DynamicFactory, $timeout, $rootScope, $filter, $scope, $translate, wizzardService) {
        var vm = this;
        vm.MapActionToSlot = MapActionToSlot;
        vm.ChangeTaskSlot = ChangeTaskSlot;
        vm.DeleteSlot = DeleteSlot;
        vm.canAutoWidth = canAutoWidth;
        vm.getColumnWidth = getColumnWidth;
        vm.ActionConfiguration = ActionConfiguration;
        vm.FillActionConfiguration = FillActionConfiguration;
        vm.EditActionConfiguration = EditActionConfiguration;
        vm.DeleteAction = DeleteAction;
        vm.SetActiveAction = SetActiveAction;
        vm.wizzardService = wizzardService;
        vm.getTasksData = getTasksData;
        vm.GetPreAnswerMedia = GetPreAnswerMedia;
        vm.FindPreAnswerMedia = FindPreAnswerMedia;
        vm.AddActionToSelectedSlot = AddActionToSelectedSlot;
        vm.BlockSpecialAction = BlockSpecialAction;
        vm.SetActionClass = SetActionClass;
        vm.BackToDragDrop = BackToDragDrop;
        vm.FillEmptySlot = FillEmptySlot;
        vm.GetCurrentSlotIndex = GetCurrentSlotIndex;
        vm.ManageSpecialActions = ManageSpecialActions;
        vm.SetActiveSlot = SetActiveSlot;
        vm.GetBaseActionList = GetBaseActionList;

        vm.$onInit = onInit;
        vm.$postLink = postLink;

        vm.Loading = false;
        vm.dragDrop = false;
        vm.actionLeftDragDrop = false;
        vm.selectedSlot = null;
        vm.BaseActionList = [];
        vm.CurrentAction = {};
        vm.CurrentSlotIndex = 0;
        vm.preAnswerMedia = null;

        //vm.slotsData = [];
        vm.options = {};

        vm.sortableActionsOptions = {};
        vm.sortableActionsInSlotOptions = {};

        /* Gantt function */
        function canAutoWidth(scale) {
            if (scale.match(/.*?hour.*?/) || scale.match(/.*?minute.*?/)) {
                return false;
            }

            return true;
        }

        function getColumnWidth(widthEnabled, scale, zoom) {
            if (!widthEnabled && vm.canAutoWidth(scale)) {
                return undefined;
            }

            if (scale.match(/.*?week.*?/)) {
                return 150 * zoom;
            }

            if (scale.match(/.*?month.*?/)) {
                return 300 * zoom;
            }

            if (scale.match(/.*?quarter.*?/)) {
                return 500 * zoom;
            }

            if (scale.match(/.*?year.*?/)) {
                return 800 * zoom;
            }

            return 40 * zoom;
        }

        function getTasksData() {
            return wizzardService.service.slotsData[0].tasks;
        }

        /* STEP FINAL */

        function MapActionToSlot(model) {
            var sortableModel = angular.copy(model);
            var guid = guidGenerator();
            
            // $timeout(function () {
                model.Id = guid;
                model.Implementation = sortableModel.assemblyName;
                model.Name = sortableModel.name;
                delete model.assemblyName;
                delete model.config;
                delete model.name;
                delete model.id;
                //vm.ManageSpecialActions(); --w wersji z timeoutem
            // }, 100);
        }
        function ManageSpecialActions() {
            console.log('ManageSpecialActions - tasks: ', vm.getTasksData()[vm.CurrentSlotIndex - 1]);
            if (vm.getTasksData()[vm.CurrentSlotIndex - 1] && vm.getTasksData()[vm.CurrentSlotIndex - 1].actions !== undefined) {
                vm.BlockSpecialAction('ContactCenter.');
                vm.BlockSpecialAction('Processing.ChatInputer');
            }
        }
        function BlockSpecialAction(stringFind) {
            var isSpecialActions = $filter('filter')(vm.getTasksData()[vm.CurrentSlotIndex - 1].actions, { Implementation: stringFind });
            var isDisabled = (isSpecialActions.length > 0);
            angular.forEach(vm.BaseActionList, function (value, key) {
                vm.baseActionElement = vm.BaseActionList[key];
                if (vm.baseActionElement.assemblyName.indexOf(stringFind) > -1) {
                    vm.baseActionElement.disabled = isDisabled;
                }
            });
        }
        function AddActionToSelectedSlot(action) {
            if (action) {
                var sortableModel = angular.copy(action);
                console.log('AddActionToSelectedSlot: ', sortableModel);
                var guid = guidGenerator();
                if (sortableModel == null) {
                    sortableModel = {};
                }
                // if (sortableModel !== null) {
                sortableModel.Id = guid;
                sortableModel.Implementation = sortableModel.assemblyName;
                sortableModel.Name = 'Pre answer media';
                sortableModel.preAnswerMedia = true;
                sortableModel.isActive = false;
                delete sortableModel.assemblyName;
                delete sortableModel.config;
                delete sortableModel.name;
                delete sortableModel.id;
                // }
                if (vm.selectedSlot && vm.selectedSlot.actions) {
                    var preAnswerMediaObj = vm.FindPreAnswerMedia(vm.selectedSlot.actions);
                    if (preAnswerMediaObj === undefined) {
                        //console.log('preAnswerMediaObj: ', preAnswerMediaObj);
                        vm.selectedSlot.actions.unshift(sortableModel);
                    }
                }
            }
        }

        function AddSlot(slot, index) {
            wizzardService.service.slotsData[0].tasks.push({
                name: $translate.instant('MANAGEMENT.SERVICE.WIZ.STEPFINAL.SLOTNR') + ' ' + (index + 1),
                number: (index + 1),
                classes: 'gantt-task-default',
                from: slot.Start,
                to: slot.Stop,
                data: '',
                actions: prepareSlotActions(slot.Actions)
            });
            //vm.service.slotsData = vm.slotsData;
        }

        function prepareSlotActions(actions) {
            actions.forEach(function (item) {
                var actionIndex = vm.BaseActionList.findIndex(function (element) {
                    return element.assemblyName === item.Implementation;
                });
                if (actionIndex !== -1) {
                    var sourceAction = vm.BaseActionList[actionIndex];

                    item.isSpecialControl = sourceAction.isSpecialControl;
                }
            });
            // vm.BaseActionList
            return actions;
        }

        function ChangeTaskSlot(task, orderData) {
            task.model.to = moment(task.model.to).add(7, 'day');
            task.model.classes = 'gantt-task-default';
            //task.model.name = $translate.instant('MANAGEMENT.SERVICE.WIZ.STEPFINAL.SLOTNR')+' ' + orderData;
            task.model.number = orderData;
            task.model.actions = [];
            return task;
        }
        function DeleteSlot(model) {
            //console.log('DeleteSlot: ', model);
            _.remove(wizzardService.service.slotsData[0].tasks, model);
            _.forEach(wizzardService.service.slotsData[0].tasks, function (task) {
                if (task.number > model.number) {
                    task.number = task.number - 1;
                    //task.name = $translate.instant('MANAGEMENT.SERVICE.WIZ.STEPFINAL.SLOTNR')+' ' + task.number;
                    if (vm.selectedSlot === task) {
                        vm.selectedSlot.number = task.number;
                        vm.selectedSlot.name = task.name;
                        vm.CurrentSlotIndex = task.number;
                    }
                }
            });
            if (vm.selectedSlot === model) {
                vm.selectedSlot = null;
            }
            $scope.$apply();
            console.log('vm.sele - DeleteSlot: ', vm.selectedSlot);
            vm.ManageSpecialActions();
            //console.log('vm.slotsData[0].tasks: ', vm.slotsData[0].tasks);
        }

        function ActionConfiguration(actionCfg, actionObj) {
            console.log('ActionConfiguration - actionObj: ', actionObj);
            console.log('ActionConfiguration - actionCfg: ', actionCfg);
            if (actionObj.Parameters === undefined || actionObj.Parameters === null) {
                actionObj.Parameters = {};
                vm.CurrentAction = {};
            }
            vm.CurrentAction = actionObj.Parameters;
            vm.CurrentAction.Id = actionObj.Id;
            vm.CurrentAction.actionId = actionObj.Id;
            vm.CurrentAction.isSpecialControl = actionCfg.isSpecialControl;
            vm.CurrentAction.Name = $translate.instant(actionObj.Name);
            // vm.FillActionConfiguration(actionObj.Parameters);
            vm.currentActionConfig = '';
            if (actionCfg.config.length > 0) {
                vm.currentActionConfig = angular.fromJson(actionCfg.config);
            }
            console.log('ActionConfiguration - vm.CurrentAction: ', vm.CurrentAction);
        }
        function FillActionConfiguration(params) {
            if (params !== undefined) {
                angular.forEach(params, function (value, key) {
                    vm.CurrentAction[key] = value;
                });
            }
        }

        function EditActionConfiguration(indexAction) {
            var action = vm.selectedSlot.actions[indexAction];
            if (action.isActive !== false) {
                console.log('action.Implementation: ', action.Implementation);
                DynamicFactory.get('servicesRsc', 'getActionConfiguration')(action.Implementation, wizzardService.service.type).then(function (s) {
                    console.log('getActionConfiguration: ', s);
                    vm.ActionConfiguration(s, action);
                }, function (e) {
                    console.log('getActionConfiguration - error: ', e);
                });
            }
        }
        function DeleteAction(indexAction) {
            vm.selectedSlot.actions.splice(indexAction, 1);
            vm.ManageSpecialActions();
        }
        function SetActionClass(action) {
            var classes = '';
            if (action.preAnswerMedia) {
                classes += ' action-preanswermedia unsortable';
            }
            if (action.isActive === false) {
                classes += ' action-deactive';
            }
            if (vm.CurrentAction !== null && action.Id === vm.CurrentAction.Id) {
                classes += ' action-selected';
            }
            return classes;
        }
        function SetActiveAction(indexAction) {
            vm.selectedSlot.actions[indexAction].isActive = !vm.selectedSlot.actions[indexAction].isActive;
        }
        function GetPreAnswerMedia(list) {
            var implementation = 'BasicActions.PlayAction, BasicActions';
            var objPreAnswer = $filter('filter')(list, { assemblyName: implementation });
            if (objPreAnswer.length > 0) {
                return objPreAnswer[0];
            }
            return null;
        }
        function FindPreAnswerMedia(list) {
            var implementation = 'BasicActions.PlayAction, BasicActions';
            var objPreAnswer = $filter('filter')(list, { Implementation: implementation, preAnswerMedia: true });
            if (objPreAnswer.length > 0) {
                objPreAnswer[0].preAnswerMedia = true;
                return objPreAnswer[0];
            }
        }
        function BackToDragDrop() {
            vm.CurrentAction = null;
            vm.currentActionConfig = null;
        }
        function initApp(service) {
            console.log('initApp - wizzardService.service.slotsData: ', wizzardService.service.slotsData);
            console.log('initApp - service.applicationString: ', service.applicationString);
            if (service.applicationString !== undefined) {
                if (wizzardService.service.slotsData[0].tasks.length === 0 && service.applicationString) {
                    var appConfig = JSON.parse(service.applicationString).Slots;
                    appConfig.forEach(AddSlot);
                }
            }
            else {
                vm.FillEmptySlot();
            }
            vm.slotsData = wizzardService.service.slotsData;
            console.log('initApp - vm.slotsData: ', wizzardService.service.slotsData);
            if (vm.selectedSlot == null && wizzardService.service.slotsData[0].tasks.length > 0) {
                vm.SetActiveSlot(wizzardService.service.slotsData[0].tasks[0]);
            }
        }
        function setMenuWizzard() {
            vm.tripleView.overrideRole(wizzardService.setMenuWizzard());
        }
        function FillEmptySlot() {
            console.log('FillEmptySlot - wizzardService.service: ', wizzardService.service);
            var dateStart = moment();
            var dateEnd = moment().add('days', 60);
            if (wizzardService.service.startDate != null && wizzardService.service.stopDate != null) {
                dateStart = wizzardService.service.startDate;
                dateEnd = wizzardService.service.stopDate;
            }
            if (wizzardService.service.slotsData[0].tasks.length === 0) {
                var slotEmpty = { Start: dateStart, Stop: dateEnd, Actions: [] };
                AddSlot(slotEmpty, 0);
            }
        }
        function GetCurrentSlotIndex() {
            return _.findIndex(wizzardService.service.slotsData[0].tasks, vm.selectedSlot);
        }
        function SetActiveSlot(slot) {
            _.each(wizzardService.service.slotsData[0].tasks, function (elem) {
                elem.classes === 'gantt-task-focus' ? elem.classes = 'gantt-task-default' : elem;
            });
            vm.currentActionConfig = null;
            vm.CurrentAction = null;
            slot.classes = 'gantt-task-focus';
            vm.selectedSlot = slot;
            vm.CurrentSlotIndex = vm.selectedSlot.number;
            vm.AddActionToSelectedSlot(vm.preAnswerMedia);
            vm.ManageSpecialActions();
        }
        function GetBaseActionList(callback) {
            DynamicFactory.get('servicesRsc', 'availableActions')(wizzardService.service.type).then(function (data) {
                vm.BaseActionListSource = data;
                vm.BaseActionList = angular.copy(vm.BaseActionListSource);
                vm.preAnswerMedia = vm.GetPreAnswerMedia(vm.BaseActionList);
                // vm.AddActionToSelectedSlot(vm.preAnswerMedia);
                // vm.ManageSpecialActions();
                if (callback) {
                    callback();
                }
            });
        }
        function S4() {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        }
        function guidGenerator() {
            var guid = (S4() + S4() + '-' + S4() + '-4' + S4().substr(0, 3) + '-' + S4() + '-' + S4() + S4() + S4()).toLowerCase();
            return guid;
        }

        // function doCheck() {
        //     if(vm.service)
        //       if (vm.service && !angular.equals(wizzardService.service, vm.service)) {
        //         wizzardService.service = vm.service;
        //       }
        //   }

        function postLink() {
            // vm.$doCheck =doCheck;
            vm.service = wizzardService.service;
            console.log('postLink - service: ', vm.service);
            vm.GetBaseActionList(function () {
                initApp(vm.service);
                vm.stepInited = true;
            });

        }
        function onInit() {
            setMenuWizzard();
            vm.CurrentAction = {};
            vm.diffDays = '';
            if (wizzardService.service.slotsData === undefined) {
                wizzardService.service.slotsData = [
                    { name: 'Sloty', height: '70px', sortable: false, classes: 'gantt-row-milestone', tasks: [], data: '' }
                ];
            }
            if (wizzardService.service.startDate != null && wizzardService.service.stopDate != null) {
                vm.diffDays = moment(wizzardService.service.stopDate).diff(moment(wizzardService.service.startDate), 'days');
            }

            vm.fromDate = vm.diffDays ? wizzardService.service.startDate : '';
            vm.toDate = vm.diffDays && vm.diffDays < 60 ? moment(wizzardService.service.startDate).add('days', 60) : '';

            vm.options = {
                scale: 'day',
                width: true,
                zoom: 1,
                autoExpand: 'both',
                taskContent: '{{("MANAGEMENT.SERVICE.WIZ.STEPFINAL.SLOTNR" | translate) +\' \' + task.model.number}} <i class="fa fa-times" unselectable="on"></i>',
                headersFormats: {
                    month: function (column) {
                        return $translate.instant('MANAGEMENT.SERVICE.WIZ.STEPFINAL.MONTHS.' + column.date.format('MMMM').toUpperCase()) + ' ' + column.date.format('YYYY');
                    }
                },
                api: function (ganttApi) {
                    vm.api = ganttApi;
                    vm.api.core.on.ready($scope, function () {
                        vm.api.directives.on.new($scope, function (dName, dScope, dElement, dAttrs, dController) {
                            if (dName === 'ganttTask') {
                                dElement.bind('click', function (event) {
                                    if (event.target.localName === 'i') {
                                        vm.DeleteSlot(dScope.task.model);
                                    }
                                    else {
                                        console.log('vm.selectedSlot: ', vm.selectedSlot);
                                        vm.SetActiveSlot(dScope.task.model);
                                        console.log('data: ', dScope.task.model);
                                        console.log('wizzardService: ', wizzardService.service.slotsData);
                                    }
                                });
                            }
                        });
                        vm.api.tasks.on.add($scope, function (task) {
                            var orderData = vm.getTasksData().length;
                            task = vm.ChangeTaskSlot(task, orderData);
                        });
                    });
                }
            };
            vm.sortableActionsOptions = {
                placeholder: 'action',
                connectWith: '.actions-container',
                items: 'md-list-item:not(.unsortable)',
                cancel: '.unsortable',
                start: function (event, ui) {
                    var actionEmpty = angular.element(document.querySelectorAll('.action-empty'));
                    actionEmpty.addClass('action-empty-plus');
                    vm.actionLeftDragDrop = true;
                    $scope.$apply();
                },
                stop: function (e, ui) {
                    var actionEmpty = angular.element(document.querySelectorAll('.action-empty'));
                    actionEmpty.removeClass('action-empty-plus');
                    vm.actionLeftDragDrop = false;
                    if ($(e.target).hasClass('source') &&
                        ui.item.sortable.droptarget &&
                        e.target !== ui.item.sortable.droptarget[0]) {
                        vm.BaseActionList = angular.copy(vm.BaseActionListSource.slice());
                        //vm.AddActionToSlot(vm.BaseActionListSource[ui.item.sortable.index]);
                    }
                    vm.ManageSpecialActions();
                },
                update: function (e, ui) {
                    // if ($(e.target).hasClass('source') &&
                    //     ui.item.sortable.droptarget &&
                    //     e.target !== ui.item.sortable.droptarget[0]) {
                    //     console.log('MapActionToSlot');
                    //     vm.MapActionToSlot(ui.item.sortable.model); --bylo z timeout'em
                    // }
                },
                deactivate: function (e, ui) {
                    if ($(e.target).hasClass('source') &&
                        ui.item.sortable.droptarget &&
                        e.target !== ui.item.sortable.droptarget[0]) {
                        vm.MapActionToSlot(ui.item.sortable.model);
                    }
                }
            };
            vm.sortableActionsInSlotOptions = {
                connectWith: '.removable-container',
                items: 'md-list-item:not(.unsortable)',
                start: function (event, ui) {
                    vm.dragDrop = true;
                    $scope.$apply();
                },
                stop: function (e, ui) {
                    console.log('sortableActionsInSlotOptions - e: ', e);
                    console.log('sortableActionsInSlotOptions - ui: ', ui);
                    vm.ManageSpecialActions();
                    vm.dragDrop = false;
                },
                update: function (e, ui) {
                    console.log('update - sortableActionsInSlotOptions - e: ', e);
                    if ($(e.target).hasClass('source') &&
                        ui.item.sortable.droptarget &&
                        e.target !== ui.item.sortable.droptarget[0]) {
                        //vm.MapActionToSlot(ui.item.sortable.model);
                    }
                }
            };
            vm.removableActionsInSlotOptions = {
                placeholder: 'action',
                connectWith: '.actions-container',
                items: 'md-list-item:not(.unsortable)'
            };

            // vm.GetBaseActionList();

            vm.tripleView.addMenuItem({
                order: 20,
                name: 'Zapisz',
                iconSrc: 'assets/icons/triple-view/zapisz.png',
                // unremovable: true,
                func: wizzardService.updateService
            });
        }
        $rootScope.$on('$translateChangeSuccess', function () {
            vm.api.columns.generate();
            vm.api.rows.generate();
        });
    }
}();

/**
 * Created by kosski on 23.08.2016.
 */
+function () {
  'use strict';

  angular.module('management.services').component('servicesBasic', {
    templateUrl: 'app/main/contactcenter/management/services/component/servicesbasic/servicesbasic.html',
    require: {
      tripleView: '^tripleView'
    },
    bindings: {
      // service: '=',
      // partners: '<',
      // onUpdate: '&'
    },
    controllerAs: 'vm',
    controller: controller
  });

  /** @ngInject */
  function controller(DynamicFactory, $timeout, $q, $translate, headerConfig, ngNotify, $scope, $state, wizzardService) {
    var vm = this;

    vm.navBarConfig = headerConfig.navBar;
    //vm.navBarConfig.functionAdd = addService;
    // vm.addTag = addTag;
    // vm.removeTag = removeTag;

    // vm.createFilterFor = createFilterFor;
    // vm.updateBrigeFn = updateBrigeFn;
    // vm.querySearch = querySearch;
    // vm.searchTextChange = searchTextChange;
    // vm.selectedItemChange = selectedItemChange;
    // vm.$postLink = postLink;
    vm.$onInit = onInit;
    // vm.$doCheck = doCheck;

    function onInit() {
      console.log("servicesBasic - init");
      vm.partnerData = [];
      vm.simulateQuery = false;
      vm.searchText = '';
      // vm.service = wizzardService.service;
      vm.isArray = angular.isArray;
      vm.conf = {};
      vm.conf.token='MANAGEMENT.SERVICE.WIZ.STEPBASIC.TAGS';
      getBaseTags();
      // DynamicFactory.get('servicesRsc', 'getPartners')().then(function (s) {
      //   vm.partners = s;
      //   vm.partnerData = vm.partners;
      //   setPartner();
      // });
      // $scope.$on('serviceSelection', function (event, data) {
      //   //   console.log("serviceSelection - service: ",vm.service);
      // });
    }

    // function doCheck() {
    //   if (vm.service && !angular.equals(wizzardService.service, vm.service)) {
    //     wizzardService.service= vm.service;
    //     vm.baseTags = [];
    //     vm.baseTags = angular.copy(vm.baseTagsSource);
    //   }
    // }

    function damnDate(date) {
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    }

    // function postLink() {
    // if (vm.service.hasOwnProperty('serviceID')) {
    //   vm.showSave = false;
    //   // vm.service.startDate = moment(vm.service.startDate);
    //   // vm.service.stopDate = moment(vm.service.stopDate);
    // } else {
    //   // vm.service.servicePartnerID = vm.partnerData[0].partnerID;
    //   vm.showSave = true;
    // }
    // }

    // function createFilterFor(query) {
    //   var lowercaseQuery = angular.lowercase(query);
    //   return function filterFn(item) {
    //     return (angular.lowercase(item.companyName).match(new RegExp(lowercaseQuery, 'g')) !== null);
    //   };

    // };

    // function updateBrigeFn(valid) {
    //   if (valid) {
    //     vm.onUpdate();
    //   }
    // }

    // function querySearch(query) {
    //   var results = query ? vm.partnerData.filter(vm.createFilterFor(query)) : vm.partnerData,
    //     deferred;
    //   if (vm.simulateQuery) {
    //     deferred = $q.defer();
    //     $timeout(function () {
    //       deferred.resolve(results);
    //     }, Math.random() * 1000, false);
    //     return deferred.promise;
    //   } else {
    //     return results;
    //   }
    // }

    // function searchTextChange(text) {
    // }

    // function selectedItemChange(item) {
    //   if (angular.isDefined(item)) {
    //     vm.service.servicePartnerID = item.partnerID;
    //     if (vm.service.hasOwnProperty('serviceID')) {
    //       vm.onUpdate();
    //     }
    //   }
    // };

    function setPartner() {
      for (var i = 0; i < vm.partnerData.length; i++) {
        if (vm.partnerData[i].partnerID === vm.service.servicePartnerID) {
          vm.selectedPartner = vm.partnerData[i];
          break;
        }
      }
    }

    function getBaseTags() {
      DynamicFactory.get('tagsRsc', 'getServiceTags')().then(function (result) {
        vm.baseTags = result;
        vm.baseTagsSource = angular.copy(vm.baseTags);
      }, error);
    }

    // function getTags(serviceId) {
    //   // vm.service.tags = [];
    //   DynamicFactory.get('tagsRsc', 'getTags')(serviceId).then(function (result) {
    //     vm.service.tags = result;
    //   }, error);
    // }

    // function addTag(tag) {
    //   if (tag)
    //     if (tag.id !== 'new') {
    //       DynamicFactory.get('tagsRsc', 'addTags')(vm.service.serviceID, tag.id).then(function (result) {
    //         // vm.service.tags.push(tag);
    //         console.log(tag);
    //       }, error);
    //       return tag;
    //     } else {
    //       createTag(tag);
    //       return tag;
    //     }
    // }

    // function createTag(tag) {
    //   DynamicFactory.get('tagsRsc', 'addNewTag')(vm.service.serviceID, tag, tag.parentId)
    //     .then(function (response) {
    //       ngNotify.set('Tag został dodany', 'success');
    //     }, error);
    // }



    // function removeTag(tag) {
    //   DynamicFactory.get('tagsRsc', 'deleteTags')(vm.service.serviceID, tag.id).then(function (result) {
    //     // vm.service.tags.push(tag);
    //     console.log(tag);
    //   }, error);
    // }


    function error(err) {
      ngNotify.set('Coś poszło nie tak...', 'error');
    }

    function addService() {
      wizzardService.service = null;
      $state.go('app.contactcenter_management.services.wizzard');

    }




  }


}();

/**
 * Created by kosski on 08.09.2016.
 */
+ function () {
  'use strict';
  angular.module('management.services').component('servicesList', {
    templateUrl: 'app/main/contactcenter/management/services/component/list/list.html',
    controllerAs: 'vm',
    controller: controller,
    require: {
      tripleView: '^tripleView'
    }
  });
  /** @ngInject */
  function controller(DynamicFactory, ngNotify, $state, $translate, $stateParams, SessionManager, headerConfig, $scope, wizzardService, $filter, $mdDialog, toastService, tripleviewService, confirmDialogService) {
    var vm = this;

    // vm.getData = getData;
    vm.addServiceClic = addServiceClic;
    vm.navBarConfig = headerConfig.navBar;
    //vm.navBarConfig.functionAdd = addServiceClic;
    // vm.chceckService = chceckService;
    vm.selectService = selectService;
    // vm.showService = showService;
    vm.editService = editService;
    vm.editContent = editContent;
    vm.deactivateService = deactivateService;
    vm.activateService = activateService;
    vm.isArray = angular.isArray;
    vm.$onInit = onInit;
    vm.$postLink = postLink;
    vm.cutDesc = cutDesc;
    vm.sortBy = sortBy;
    // var md5 = require('js-md5');


    function onInit() {
      // $scope.$emit('addAction', 'clear');
      console.log('servicesList | init');
      $scope.$on('$stateChangeSuccess', stateChangeSuccess);

      vm.serviceList = [];
      vm.serviceListSource = [];
      vm.conf = {};
      vm.conf.token = 'MANAGEMENT.SERVICE.WIZ.STEPBASIC.TAGS';
      vm.serviceDelete = {};
      vm.showActive = true;
      getData();
      getBaseTags();

      vm.reverse = false;
      vm.propertyName = '';
    }

    function postLink() {
    }

    function stateChangeSuccess(event, toState, toParams, fromState, fromParams) {
      if (toState.name == "app.contactcenter_management.services.list.card") {
        console.log('servicesList | stateChangeSuccess');
        // tripleviewService.sidenavData.class = "p100";
        // vm.serviceList = undefined;
        // loadNewServices();
        changeActiveService();

      }else
      if(fromState.name == 'app.contactcenter_management.services.wizzard'){
        vm.serviceList = undefined;
        loadNewServices();
      }
    }

    function loadNewServices(){
      console.log('servicesList | loadNewServices');

      // if ($stateParams.callcenter) {
        getData();
        // vm.GetServices($stateParams.callcenter).then(function(response) {
        //   vm.serviceList = response;
        //   serviceSelection();
        // });
      // }
    }

    function serviceSelection() {
      // if ($stateParams.serviceId) {
      //   vm.activeService = _.find(vm.serviceList, { serviceID: parseInt($stateParams.serviceId) });
      // } else {
      //   vm.activeService = firstActiveService();
      // }
      changeActiveService();
      selectService(vm.activeService);
    }
    function changeActiveService(){
      if ($stateParams.serviceId) {
        vm.activeService = _.find(vm.serviceList, { serviceID: parseInt($stateParams.serviceId) });
      } else {
        vm.activeService = firstActiveService();
      }
    }
    function firstActiveService() {
      for (var i = 0; i < vm.serviceList.length; i++) {
        var element = vm.serviceList[i];
        if (element.active) {
          return element;
        }
      }
    }

    function getData() {
      // console.log("data: ", $state);
      DynamicFactory.get('servicesRsc', 'GetServices')().then(function (data) {
        vm.serviceList = data;
        vm.serviceListSource = data;
        serviceSelection();
        // cutDesc(data);
        // ngNotify.set('Zalodowano dane - komunikat tymczasowy', 'success');
      }, function (e) {
        vm.serviceList = [];
        // Logger.log.error(e);
        ngNotify.set('Ladowanie danych nie powiodolo sie', 'error');
      });
    }

    function cutDesc(data) {
      if (data) {
        var cutData = data.substring(0, 50);
        if (data.length > 50) {
          return cutData + ' ...';
        } else if (data.length < 50) {
          return data;
        } else {
          return '';
        }
      }
    }

    function selectService(service) {
      $state.transitionTo('app.contactcenter_management.services.list.card', {
        serviceId: service.serviceID,
        serviceType: service.type,
        wizzard: service.simpleWizzard
      });
    }

    function getBaseTags() {
        DynamicFactory.saveGet('tagsRsc', 'getTags')().then(function (result) {
          vm.tagsPicker = result;
        });
    }



    function changeServiceAvatar(userId) {
      return function (photoUrl) {
        DynamicFactory.get('profileRsc', 'PutConsultantPhoto')(photoUrl, userId);
      }
    }

    function addServiceClic() {
      wizzardService.service = null;
      vm.tripleView.clearActions();
      $state.transitionTo('app.contactcenter_management.services.wizzard');
    }

    function copyServiceClic() {
      wizzardService.service = selectedServices();
      vm.tripleView.clearActions();
      if (wizzardService.service && wizzardService.service.serviceID)
        $state.transitionTo('app.contactcenter_management.services.wizzard');
      else {
        toastService.showToast($translate.instant('MANAGEMENT.SERVICE.LIST.COPY_ERROR'), 'error', 10);
      }
    }

    function editService(service) {
      if(service.simpleWizzard){
        $state.go('app.contactcenter_management.services.wizzard', {
          serviceId: service.serviceID,
          serviceType: service.type
        });
      }
    }

    function editContent(id, type) {
      $state.transitionTo('app.contactcenter_management.services.wizzard.content', {
        serviceId: id,
        serviceType: type
      });
    }

    function deactivateService(service) {
      vm.serviceDelete = service;


      confirmDialogService.showRecDeleteConfirm().then(function () {
        console.log('delete: ', service);
        DynamicFactory.get('servicesRsc', 'serviceDeactivate')(service).then(onSuccessDelete, onErrorDelete);
      }, function () {
        //console.log('You cancelled the dialog.');
      });

    }

    function activateService(service) {
      vm.serviceDelete = service;


      confirmDialogService.showRecDeleteConfirm($translate.instant('MANAGEMENT.SERVICE.LIST.RESTORE_QUESTION').replace('{0}', service.serviceName)).then(function () {
        console.log('delete: ', service);
        DynamicFactory.get('servicesRsc', 'serviceActivate')(service).then(function (data) {
          vm.serviceDelete.active = 1;
          toastService.showToast($translate.instant('MANAGEMENT.SERVICE.LIST.RESTORE_SUCESS'), 'success', 4);
        }, function (err) {
          console.log(err);
          toastService.showToast($translate.instant('MANAGEMENT.SERVICE.LIST.RESTORE_ERROR'), 'error', 10);
        });
      }, function () {
        //console.log('You cancelled the dialog.');
      });

    }

    function onSuccessDelete(data) {
      vm.serviceDelete.active = 0;
      toastService.showToast($translate.instant('COMMON.DELETE_SUCCESS'), 'success', 4);
    }

    function onErrorDelete(e) {
      console.log(e);
      toastService.showToast($translate.instant('COMMON.DELETE_ERROR'), 'error', 10);
    }


    // function showService(service) {
    //     $scope.$emit('globalAction', {
    //         eventId: "showService",
    //         data: service
    //     });
    // }

    function damnDate(date) {
      return moment(date);
    }

    function sortBy(propertyName) {
      vm.reverse = (vm.propertyName = propertyName) ? !vm.reverse : false;
      vm.propertyName = propertyName;
    }

  }

}();

(function () {
  "use strict";

  // Creates:
  // MDolega

  angular.module("management.services").component("serviceCard", {
    templateUrl: "app/main/contactcenter/management/services/component/servicecard/servicecard.html",
    controller: Ctrl,
    controllerAs: "vm"
  });

  /**@ngInject */
  function Ctrl(DynamicFactory, $stateParams, $state,toastService, $filter) {
    var vm = this;

    vm.showConsultantCard = showConsultantCard;
    // vm.filterConsultantList = filterConsultantList;
    vm.recalculateModel = recalculateModel;
    vm.saveConsultantsToAction = saveConsultantsToAction;
    vm.discardChanges = discardChanges;
    vm.actionSelected = getActionConsultants;
    vm.editAction = editAction;
    vm.editContent = editContent;
    vm.editService = editService;
    vm.$onDestory = onDestory;
    vm.$onChanges = onChanges;
    vm.$onInit = onInit;

    vm.sortableCCOptions = {
      placeholder: 'consultator',
      items: ".consultator:not(.not-sortable)",
      stop: function (e, ui) {

        recalculateModel();
      }
    };



    function onInit() {
      if ($stateParams.serviceType && $stateParams.serviceId) {
        DynamicFactory.get("servicesRsc", "GetService")($stateParams.serviceId, $stateParams.serviceType).then(function (result) {
          vm.service = result;
          vm.service.applicationString = vm.service.applicationString ? JSON.parse(vm.service.applicationString) : false;
          console.log("serviceCard |", vm.service.applicationString);
          if (vm.service.applicationString) {
            getConsultantActions();
            getConsultants();
          }
        });
      }
    }

    function onChanges(changesObj) {}

    function onDestory() {}

    function editContent() {
      $state.go("app.contactcenter_management.services.list.content", {
        serviceId: $stateParams.serviceId
      });
    }

    function editService() {
      if ($stateParams.wizzard) {
        $state.go("app.contactcenter_management.services.wizzard", {
          serviceId: vm.service.serviceID,
          serviceType: vm.service.type
        });
      }else{
        toastService.showToast('Serwis zmodyfikowany poza aplikacją. Skontaktuj się z usługodawcą.', 'error', 4);
      }
    }

    function saveConsultantsToAction() {
      recalculateModel();
      DynamicFactory.get('serviceActionsRsc', 'setConsultantsAction')({
        actionId: vm.consultantActions[vm.selectedAction || 0].Id,
        consultantsListEndpoint : vm.actionConsultants
      }).then(function () {
        vm.editMode = false;
        // filterConsultantList();
      });
    }
    function discardChanges(){
      vm.editMode = false;
      vm.consultantList = angular.copy(vm.consultantListBackup);
      // filterConsultantList();
    }

    function showConsultantCard(consultant){
      switch(consultant.type){
        case 'C': $state.go('app.contactcenter_management.callcenters.consultants.consultant', {
          callcenter: consultant.callcenterId,
          consultantId: consultant.consultantID
        }); break;
        case 'G':  $state.go("app.contactcenter_management.callcenters.group", {
          groupId: consultant.id,
          callcenter: consultant.callcenterId,
          group: consultant
          // ,  color: color
        })
        default: break;
      }
    }

    function editAction(){
      vm.editMode = true;
      vm.consultantListBackup = angular.copy(vm.consultantList);
      // filterConsultantList();
    }

    function getConsultantActions() {
      vm.consultantActions = _.filter(
        _.flatMap(vm.service.applicationString.Slots, function (o) {
          return o.Actions;
        }),
        function (o) {
          return o.Parameters && (o.Parameters.consultantsListEndpoint || o.Parameters.data);
        }
      );
      console.log("serviceCard | consultantActions", vm.consultantActions);
    }

    function recalculateModel() {
      vm.actionConsultants = [];
      _.filter(vm.consultantList, {
        action: true
      }).forEach(function (item, index) {
        item.priority = index;
        vm.actionConsultants.push(item.type + item.id);
      });
      vm.actionConsultants = vm.actionConsultants.join(',');
      console.log('serviceCard | recalculateModel',vm.actionConsultants)
    }

    function getConsultants() {
      DynamicFactory.get('serviceActionsRsc', 'getGroups')().then(function (result) {
        vm.sourceList = result;
        getActionConsultants();
      });
    }

    function getActionConsultants() {
      if (vm.consultantActions[vm.selectedAction || 0]) {
        DynamicFactory.get('serviceActionsRsc', 'ActionConsultantList')(vm.consultantActions[vm.selectedAction || 0].Id).then(transcludeAction);
      } else {
        console.log('serviceCard | error! no actionGuid');
      }
    }

    function transcludeAction(actionConsultants) {
      vm.consultantList = angular.copy(vm.sourceList);
      vm.consultantsInService = angular.copy(vm.sourceList);

      actionConsultants.forEach(assignConsultant);
      vm.consultantList = _.sortBy(vm.consultantList,['action','priority']);
    }

    function assignConsultant(consultant) {
      var inList = _.find(vm.consultantList, {
        id: consultant.id,
        type: consultant.type
      });

      if (inList) {
        inList.action = true;
        inList.priority = consultant.priority;
      } else {
        consultant.notAvalible = true;
        vm.consultantList.push(consultant);
      }
    }
    function filterConsultantList(){
      vm.consultantsListFiltered = $filter('filter')(
        $filter('filter')(vm.consultantList,{ 'action' : !vm.editMode || vm.sortMode ? true : undefined })
      ,vm.search);
    }
  }
})();

/**
 * Created by kosski on 23.08.2016.
 */
+function () {
    'use strict';
    angular.module('management.services').component('dynamicAction', {
        templateUrl: 'app/main/contactcenter/management/services/component/dynamicaction/dynamicaction.html',
        controllerAs: 'vm',
        bindings: {
            formInfo: '<',
            settings: '='
        },
        controller: consultantsList
    });

    /** @ngInject */
    function consultantsList(DynamicFactory, ResourceBuilder, SessionManager, $q) {
        var vm = this;

        vm.$onInit = onInit;
        vm.$postLink = postLink;
        vm.$onChanges = onChanges;
        vm.$onDestroy = onDestroy;

        function onInit() {

        }

        function postLink() {
            if (vm.settings) {
                if (vm.settings.actionId) {
                    vm.actionId = vm.settings.actionId;
                } else {
                    console.log('Uwaga!! wykryto brak actionId!!');
                }
            }
        }

        function onChanges(changesObj) {
            if (changesObj.formInfo.currentValue) {
                vm.actionFields = [];
                var formInfo = changesObj.formInfo.currentValue;
                for (var key in formInfo) {
                    if (formInfo.hasOwnProperty(key)) {
                        var resolver = prepareResolver(formInfo[key], key);
                        getFieldSource(formInfo[key]).then(resolver,resolver);
                    }
                }
            }
        }

        function onDestroy() {
            vm.actionFields = [];
        }

        function prepareResolver(fieldConfig,key) {
            return function (source) {
                var actionField = source === 'no data' ?
                    {
                        config: fieldConfig
                    }:
                    {
                        config: fieldConfig,
                        // template: template,
                        source: source
                    }

                reserveSettingsField(actionField,key);
            };
        }

        function reserveSettingsField(field, key) {
            DynamicFactory.get('templatesRsc', 'getFieldTemplate')(field.config, key).then(function (template) {
                field.template = template;
                if (!vm.settings.hasOwnProperty(key)) {
                    vm.settings[key] = '';
                }
                vm.actionFields.push(field);
            });
        }

        function getFieldSource(fieldinfo) {
            return $q(function (resolve, reject) {
                if (fieldinfo.OptionsParams) {
                    return fieldinfo.OptionsParams;
                } else if (fieldinfo.Value) {
                    var resource = ResourceBuilder.build(ResourceBuilder.buildEndpoint(fieldinfo.Value, true), {
                        get: {
                            method: 'GET',
                            isArray: true
                        }
                    });
                    var endpointParams = buildqueryParams(ResourceBuilder.getParamNames(fieldinfo.Value));
                    if (endpointParams)
                        resource.get(endpointParams).$promise.then(function (result) {
                            resolve(result);
                        });
                    else
                        resource.get().$promise.then(function (result) {
                            resolve(result);
                        });
                }else
                reject('no data');
            });
        }

        function buildqueryParams(params) {
            // let userSession = SessionManager.getUser();
            var result = undefined;
            params.forEach(function (element) {
                if (!result)
                    result = {};
                result[element] = SessionManager.getUserData(element);
            });
            return result;
        }

        // vm.template = {
        //     name: 'rates',
        //     url: 'rates',
        //     withRole: false,
        //     methods: {
        //         get: {
        //             url: 'rates/:portalId',
        //             method: 'GET',
        //             isArray: true
        //         },
        //         save: {
        //             method: 'POST'
        //         }
        //     }
        // }

    }
}();

/**
 * Created by rpiekarski on 23.08.2016.
 */
+function () {
  'use strict';

  angular.module('management.services').component('taContent', {
    templateUrl: 'app/main/contactcenter/management/services/component/content/content.html',
    controllerAs: 'vm',
    require: {
      tripleView: '^tripleView'
    },
    bindings: {
      contentType: '@',
      contentId: '=',
      contentUrl: '@'
    },
    controller: controller
  });

  /** @ngInject */
  function controller(DynamicFactory, tagsService, toastService, SessionManager, consts, $stateParams, $mdSidenav, $rootScope, wizzardService, headerConfig, confirmDialogService, $timeout, $mdDialog,$scope) {
    var vm = this;

    // vm.CallMeMaybe = CallMeMaybe;
    vm.cancelFile = cancelFile;
    vm.closeMenu = closeMenu;
     vm.getFileName = getFileName;
    vm.getType = getType;
    vm.mouseLeaveHandler = mouseLeaveHandler;
    vm.mouseOverHandler = mouseOverHandler;
    vm.openMenu = openMenu;
    // vm.retryChunk = retryChunk;
    // vm.validate = validate;
    // vm.fileSubmitted = fileSubmitted;
    vm.selectTag = selectTag;
    //rp
    vm.$onInit = onInit;
    vm.$postLink = postLink;
    // vm.flowConfig = flowConfig;
    vm.goToAddContentDialog = goToAddContentDialog;

    function goToAddContentDialog(ev) {
      $mdDialog.show({
        controller: function () {
          return vm;
        },
        controllerAs: 'vm',
        template: '<add-content  style="  height: 800px; width:1000px"  content-Type=' + vm.contentType + ' content-url=' + vm.contentUrl + ' content-Id=' + vm.contentId + '></add-content>',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        onRemoving: function (event, removePromise) {

          // Z tym ifem po zamknięciu dialogu bez dodania obrazka lista jest pusta
          // if (vm.newFileAdded) {
          //   vm.newFileAdded=false;

            //po pobraniu listy pobieramy tagii
            // getBaseTags();
            // $timeout(function () {
              GetContentData();
            // },3000);


          // }
        }

      });
    }


    function onInit() {
      vm.sourceEndpoint = vm.contentType === '2' ? 'getServiceTags' : 'getTags';
      vm.lastIdx = -1;
      vm.menuIsUp = false;
      vm.displayer = [];
      vm.files = [];
      vm.removableChips = false;
      vm.searchText = '';
      vm.selectedItem = '';
      // vm.contentTags = '';
      // vm.tripleView.overrideRole(wizzardService.setMenuWizzard());


      $scope.$on('newFileAdded',function () {
       vm.newFileAdded=true;
      });
    }

    function postLink() {
      // vm.contentId = $state.current.resolve.contentId;
      GetContentData();
      // $rootScope.$on('event:auth-loginConfirmed', function () {
      //   // when we have a new accesstoken, we can resume the flow
      //   vm.Uploader.flow.resume();
      // });
      vm.navBarConfig = headerConfig.navBar;
      // vm.searchFilter = vm.navBarConfig.search;
      changeViewMode();
    }

    function GetContentData() {
      DynamicFactory.get('FileUploadRsc', 'getAttachmentList')(vm.contentType, vm.contentId)
        .then(function (data) {
          data.forEach(function (file) {
            if (file.contentUrl.indexOf(' ') !== -1) {
              file.contentUrl = file.contentUrl.split(' ').join('%20');
            }
            file.fileName=getFileName(file.name);
            file.type = getType(file);
          });
          vm.files = data;
        });
    }


    // function flowConfig() {
    //   if (vm.contentType) {
    //     var flow = DynamicFactory.get('FileUploadRsc', 'LoadContentFlowConfig')(false, {
    //       contentId: vm.contentId,
    //       contentType: vm.contentType
    //     });
    //     return flow;
    //   }
    // }

    function changeViewMode() {
      vm.tripleView.clearActions()
      vm.listMode = !vm.listMode;
      // vm.tripleView.addMenuItem({
      //   order: 1,
      //   name: vm.listMode ? 'List' : 'Grid',
      //   icon: vm.listMode ? 'icon-view-headline' : 'icon-view-module',
      //   class: 'md-accent icon-button-shadow',
      //   func: changeViewMode
      // });
    }

    // function validate(file) {
    //   if (file.size > 300000) {
    //     // ngNotify.set('Plik za duży', 'error');
    //     toastService.showToast('Plik za duży', 'error', 4);
    //
    //     return false;
    //   }
    //   return true;
    // }

    function getFromString(url, regex) {
      var r = url.match(regex);
      var regexResult = null;
      if (r) {
        regexResult = r[0].replace('.', '');
      }
      if (regexResult != null) {
        return regexResult;
      } else {
        return '--';
      }
    }

    function getFileName(url) {
      // var url = file.contentUrl ? file.contentUrl : file.flow.name;
      return getFromString(url, /(([^/]*)\.)/);
    }

    function getType(file) {
      var url='';

      if( file.contentUrl){
        url= file.contentUrl
      }else{
        if(file.flow && file.flow.name){
          url= file.flow.name;
        }
      }

      var extension=getFromString(url, /\.[^.]*$/);

      if(extension.indexOf('/')>0){
        var index=extension.indexOf('/');
        if(index==extension.length-1 && index>0){
          return  extension.substring(0,index);
        }else{
          //w url nie ma rozszeżenia
          return 'brak informacji'
        }

      }else{
        return  extension;
      }

    }

    // function retryChunk(file, flow) {
    //   // Pause the flow and ask a new accesstoken
    //   $rootScope.$broadcast('event:auth-loginRequired');
    //   flow.pause();
    // }

    // function CallMeMaybe($flow, $file, $message) {
    //   toastService.showToast('Plik ' + $file.file.name + ' został przesłany na serwer.', 'success', 10);
    //   var url = vm.contentUrl + vm.contentId + '/' + $message.replace(/\"/g, '');
    //   $timeout(function () {
    //     var index = _.findIndex(vm.files, {
    //       name: $file.file.name,
    //       contentUrl: 'assets/icons/gifczekanie.gif' //odświeżamy plik ktory zostal wlasnie zaladowany
    //     });
    //
    //     if (index !== -1) {
    //       vm.files[index].contentUrl = url;
    //     }
    //     // vm.files.push({
    //     //   name: $file.file.name,
    //     //   contentUrl: url,
    //     //   flow: $file,
    //     //   fileSizeKB: $file.size / 1024,
    //     //   tags: angular.copy($flow.opts.query.tags)
    //     // });
    //   }, 2000);
    // }

    // function fileSubmitted($files, $event, $flow) {
    //   if ($files.some(validate)) {
    //     if (vm.contentTags && vm.contentTags.length > 0) {
    //       confirmDialogService.showConfirm('confirmFileUpload', 'Czy napewno chcesz przesłać kontent z tymi tagami?', {
    //         tagsPicker: vm.contentTags,
    //         contentId: vm.contentId,
    //         sourceEndpoint: vm.sourceEndpoint
    //       }).then(prepareSubmittedFile($files, $flow), function (err) {
    //         console.log(err);
    //         $flow.cancel();
    //       });
    //     } else {
    //       prepareSubmittedFile($files, $flow)(vm.contentTags);
    //     }
    //   }
    // }

    // function prepareSubmittedFile($files, $flow) {
    //   return function (tags) {
    //     if (tags)
    //       $flow.opts.query.tags = tags;
    //     for (var index in $files) {
    //       if (index) {
    //         vm.files.push({
    //           name: $files[index].file.name,
    //           flow: $files[index],
    //           fileSizeKB: Math.round(($files[index].size / 1024)),  //tak żeby wyszły zaookrągle KB
    //           tags: angular.copy($flow.opts.query.tags),
    //           type: getType({'contentUrl': $files[index].file.name}),
    //           contentUrl: 'assets/icons/gifczekanie.gif'
    //         });
    //       }
    //     }
    //     $flow.upload();
    //   };
    // }

    function cancelFile(file) {

      confirmDialogService.showConfirm('confirmFileUpload', 'Czy napewno chcesz chcesz usunąć ten plik?', {}).then(
        function () {
          if (file.flow) {
            file.flow.cancel();
          }

          DynamicFactory.get('FileUploadRsc', 'deleteContent')(vm.contentType, file.contentUrl).then(function (data) {
            var index = vm.files.indexOf(file);
            vm.files.splice(index, 1);
          });
        },
        function () {
        });
    }

      function error(err) {
        toastService.showToast('Coś poszło nie tak...', 'error', 10);
      }

      function getBaseTags() {
        if (vm.contentType === '2') {
          DynamicFactory.saveGet('tagsRsc', vm.sourceEndpoint)(vm.contentId).then(function (result) {
            vm.tagsPicker = result;
          });
        } else {
          vm.tagsPicker = [];
        }
      }


      function openMenu($mdMenu, ev) {
        $mdMenu.open(ev);
        vm.menuIsUp = true;
      }

      function closeMenu($mdMenu, ev) {
        $mdMenu.close(ev);
        vm.menuIsUp = false;
        vm.displayer[vm.lastIdx] = {
          show: false
        };
      }

      function mouseOverHandler(idx) {

        vm.displayer[idx] = {
          show: true
        };

        if (vm.lastIdx !== -1 && vm.lastIdx !== idx) {
          vm.displayer[vm.lastIdx].show = false;
        }

        vm.lastIdx = idx;
      }

      function mouseLeaveHandler(idx) {
        if (!vm.menuIsUp) {
          vm.displayer[idx] = {
            show: false
          };
        }
      }

      function selectTag(chip) {
        if (!vm.contentTags) {
          vm.contentTags = [];
        }
        if (chip.selected) {
          vm.contentTags.push(chip.id);
        } else {
          vm.contentTags.splice(vm.contentTags.indexOf(chip.id), 1);
        }
      }
    }
  }

  ();

/**
 * Created by rpiekarski on 23.08.2016.
 */
+function () {
  'use strict';

  angular.module('management.services').component('addContent', {
    templateUrl: 'app/main/contactcenter/management/services/component/addcontent/addcontent.html',
    controllerAs: 'vm',
    bindings: {
      contentType: '@',
      contentId: '=',
      contentUrl: '@'
    },
    controller: controller
  });

  /** @ngInject */
  function controller(DynamicFactory, tagsService, toastService, SessionManager, $rootScope, headerConfig, confirmDialogService, $timeout, $mdDialog) {
    var vm = this;

    vm.CallMeMaybe = CallMeMaybe;
    vm.cancelFile = cancelFile;
    vm.getFileName = getFileName;
    vm.getType = getType;
    vm.retryChunk = retryChunk;
    vm.validate = validate;
    vm.fileSubmitted = fileSubmitted;
    //rp
    vm.$onInit = onInit;
    vm.flowConfig = flowConfig;
    vm.closeDialog = closeDialog;
    vm.addContentTagBtClick = addContentTagBtClick;


    function closeDialog() {
      angular.forEach(vm.files, function (f) {
        vm.cancelFile(f);
      });

      $mdDialog.hide();
    }

    function addContentTagBtClick() {
      if (vm.contentTags) {
        angular.forEach(vm.files, function (f) {
          DynamicFactory.get('FileUploadRsc', 'contentTagGuidUpdate')(f.fileGuid, vm.contentTags).then(function (data) {

            //czekamy na promisa
            if (vm.files.length > 0) {
              $rootScope.$broadcast('newFileAdded');
            }
            $mdDialog.hide();

          }, function (err) {
            toastService.showToast('Wystapił błąd podczas dodawania tagów: '+err, 'error', 4);
          });
        });
      }else{
        if (vm.files.length > 0) {
          $rootScope.$broadcast('newFileAdded');
        }
        $mdDialog.hide();
      }


    }



    function onInit() {
      vm.sourceEndpoint = vm.contentType === '2' ? 'getServiceTags' : 'getTags';
      vm.lastIdx = -1;
      vm.files = [];
      vm.removableChips = false;
      vm.searchText = '';
      vm.selectedItem = '';
      vm.disableSaveButton=false;
      vm.tagWriteMode=SessionManager.getUserRoleId()!==3;
      getBaseTags();
    }


    function flowConfig() {
      if (vm.contentType) {
        var flow = DynamicFactory.get('FileUploadRsc', 'LoadContentFlowConfig')(false, {
          contentId: vm.contentId,
          contentType: vm.contentType
        });
        return flow;
      }
    }



    function validate(file) {
      if (file.size > 300000) {
        // ngNotify.set('Plik za duży', 'error');
        toastService.showToast('Plik za duży', 'error', 4);

        return false;
      }
      return true;
    }

    function getFromString(url, regex) {
      var r = url.match(regex);
      var regexResult = null;
      if (r) {
        regexResult = r[0].replace('.', '');
      }
      if (regexResult != null) {
        return regexResult;
      } else {
        return '--';
      }
    }

    function getFileName(url) {
      // var url = file.contentUrl ? file.contentUrl : file.flow.name;
      return getFromString(url, /(([^/]*)\.)/);
    }

    function getType(file) {
      var url = file.contentUrl ? file.contentUrl : file.flow.name;

      return getFromString(url, /\.[^.]*$/);
    }

    function retryChunk(file, flow) {
      // Pause the flow and ask a new accesstoken
      $rootScope.$broadcast('event:auth-loginRequired');
      flow.pause();
    }

    function CallMeMaybe($flow, $file, $message) {
      toastService.showToast('Plik ' + $file.file.name + ' został przesłany na serwer.', 'success', 10);
      //var url = vm.contentUrl + vm.contentId + '/' + $message.replace(/\"/g, '');
      var webUrl=$message.replace(/\"/g, '');

      var fileGuid='';
      if (webUrl.indexOf('.') > 0) {
        var contentTypeFolder="";//np: partners/998
        if(vm.contentType=="1"){
          contentTypeFolder="partners/";
        }else if(vm.contentType=="2"){
          contentTypeFolder="services/";
        }else if(vm.contentType=="3"){
          contentTypeFolder="consultants/";
        }else{
          contentTypeFolder="BŁĄD!!!"
        }
        contentTypeFolder=contentTypeFolder+vm.contentId;

        fileGuid =  webUrl.substring(webUrl.indexOf(contentTypeFolder)+1+contentTypeFolder.length,webUrl.lastIndexOf('.'))
      }else{
        //debugger
      }

      $timeout(function () {
        var index = _.findIndex(vm.files, {
          name: $file.file.name,
          contentUrl: 'assets/icons/gifczekanie.gif' //odświeżamy plik ktory zostal wlasnie zaladowany
        });

        if (index !== -1) {
          vm.files[index].contentUrl = webUrl;
          vm.files[index].fileGuid = fileGuid;
        }

        //sprawdzamy czy wszystkie pliki dotarły na serwer, jeśli tak do odblokowujemy przycisk
        var ob=_.find(vm.files,function (e) {
          return angular.isUndefined( e.fileGuid) || e.fileGuid==null;
        });

        if(!ob){
          vm.disableSaveButton=false;
        }

        // vm.files.push({
        //   name: $file.file.name,
        //   contentUrl: url,
        //   flow: $file,
        //   fileSizeKB: $file.size / 1024,
        //   tags: angular.copy($flow.opts.query.tags)
        // });
      }, 3000);
    }

    function fileSubmitted($files, $event, $flow) {
      if ($files.some(validate)) {
        // if (vm.contentTags && vm.contentTags.length > 0) {
        //   confirmDialogService.showConfirm('confirmFileUpload', 'Czy napewno chcesz przesłać kontent z tymi tagami?', {
        //     tagsPicker: vm.contentTags,
        //     contentId: vm.contentId,
        //     sourceEndpoint: vm.sourceEndpoint
        //   }).then(prepareSubmittedFile($files, $flow), function (err) {
        //     console.log(err);
        //     $flow.cancel();
        //   });
        // }else{


        prepareSubmittedFile($files, $flow)(vm.contentTags);
        // }
      }
    }

    function prepareSubmittedFile($files, $flow) {
      return function (tags) {
        if (tags) {
          $flow.opts.query.tags = tags;
        }

        //blokujemy przycisk dodawania kontentu żeby poczekac na ładujące się pliki
        vm.disableSaveButton=true;
        for (var index in $files) {
          if (index) {
            vm.files.push({
              name: $files[index].file.name,
              fileName: vm.getFileName($files[index].file.name),
              flow: $files[index],
              fileSizeKB: Math.round(($files[index].size / 1024)),  //tak żeby wyszły zaookrągle KB
              tags: angular.copy($flow.opts.query.tags),
              type: getType({'contentUrl': $files[index].file.name}),
              contentUrl: 'assets/icons/gifczekanie.gif'
            });
          }
        }
        $flow.upload();
      };
    }

    function cancelFile(file) {
      if (file.flow) {
        file.flow.cancel();
      }
      DynamicFactory.get('FileUploadRsc', 'deleteContent')(vm.contentType, file.contentUrl).then(function (data) {
        var index = vm.files.indexOf(file);
        vm.files.splice(index, 1);
      });
    }


    function error(err) {
      toastService.showToast('Coś poszło nie tak...', 'error', 10);
    }

    function getBaseTags() {
      if (vm.contentType === '2') {
        DynamicFactory.saveGet('tagsRsc', vm.sourceEndpoint)(vm.contentId).then(function (result) {
          vm.tagsPicker = result;
        });
      } else {
        vm.tagsPicker = [];
      }
    }


    // function openMenu($mdMenu, ev) {
    //   $mdMenu.open(ev);
    //   vm.menuIsUp = true;
    // }

    // function closeMenu($mdMenu, ev) {
    //   $mdMenu.close(ev);
    //   vm.menuIsUp = false;
    //   vm.displayer[vm.lastIdx] = {
    //     show: false
    //   };
    // }

    // function mouseOverHandler(idx) {
    //
    //   vm.displayer[idx] = {
    //     show: true
    //   };
    //
    //   if (vm.lastIdx !== -1 && vm.lastIdx !== idx) {
    //     vm.displayer[vm.lastIdx].show = false;
    //   }
    //
    //   vm.lastIdx = idx;
    // }
    //
    // function mouseLeaveHandler(idx) {
    //   if (!vm.menuIsUp) {
    //     vm.displayer[idx] = {
    //       show: false
    //     };
    //   }
    // }

    // function selectTag(chip){
    //   if(!vm.contentTags){
    //     vm.contentTags = [];
    //   }
    //   if(chip.selected){
    //     vm.contentTags.push(chip.id);
    //   }else{
    //     vm.contentTags.splice(vm.contentTags.indexOf(chip.id),1);
    //   }
    // }
  }
}();

(function () {
  'use strict';
  angular
    .module('management.callcenters', [
      'flow',
      'filterbox'
    ])
    .config(config);

  function config($translatePartialLoaderProvider, $stateProvider, flowFactoryProvider) {

    $stateProvider
      .state('app.contactcenter_management.callcenters', {
        parent: 'app.contactcenter_management',
        url: '/callcenters',
        views: {
          'content@app': {
            template: '<triple-view></triple-view>'
          }
        }
      })
      .state('app.contactcenter_management.callcenters.consultants', {
        url: '/:callcenter/consultants',
        statePanelRight: true,
        stateTranslationName: 'MANAGEMENT.CALLCENTERS',
        params: {
          defaultAvatar: 'assets/images/icons/konsultanci.png'
        },
        views: {
          'sidenav': {
            template: '<consultant-list flex></consultant-list>'
          }
        }
      }).state('app.contactcenter_management.callcenters.consultants.consultant', {
        url: '/:consultantId',
        parent: 'app.contactcenter_management.callcenters.consultants',

        stateTranslationName: 'MANAGEMENT.CALLCENTERS',
        params: {
          consultantId: null,
          defaultAvatar: 'assets/images/icons/konsultanci.png'
        },
        views: {
          'mainContent@app.contactcenter_management.callcenters': {
            template: '<consultant-card style="width: 100%"></consultant-card>'
          }
        }
      }).state('app.contactcenter_management.callcenters.consultants.consultant.edit', {
        url: '/edit',
        stateTranslationName: 'MANAGEMENT.CALLCENTERS',
        parent: 'app.contactcenter_management.callcenters.consultants.consultant',
        params: {
          templateKey: 'ccConsultantList',
          defaultAvatar: 'assets/images/icons/konsultanci.png'
        },
        views: {
          'mainContent@app.contactcenter_management.callcenters': {
            template: '<consultant-edit style="width: 100%"></consultant-edit>'
          }
        }
      }).state('app.contactcenter_management.callcenters.consultants.consultant.simpleadd', {
        url: '/simpeadd',
        stateTranslationName: 'MANAGEMENT.CALLCENTERS',
        parent: 'app.contactcenter_management.callcenters.consultants.consultant',
        params: {
          templateKey: 'ccConsultantList',
          defaultAvatar: 'assets/images/icons/konsultanci.png'
        },
        views: {
          'mainContent@app.contactcenter_management.callcenters': {
            template: '<user-simple-add style="width: 100%"></user-simple-add>'
          }
        }
      }).state('app.contactcenter_management.callcenters.groups', {
        url: '/:callcenter/groups',
        parent: 'app.contactcenter_management.callcenters',
        statePanelRight: true,
        stateTranslationName: 'MANAGEMENT.CALLCENTERS',
        params: {
          defaultAvatar: 'assets/images/icons/callcenter.png'
        },
        views: {
          'sidenav': {
            template: '<callcenter-groups></callcenter-groups>'
          }
        }
      }).state('app.contactcenter_management.callcenters.group', {
        url: '/:groupId',
        parent: 'app.contactcenter_management.callcenters.groups',
        stateTranslationName: 'MANAGEMENT.CALLCENTERS.GROUPS.GROUP',
        params: {
          groupId: null,
          group: null,
          defaultAvatar: 'assets/images/icons/callcenter.png'
        },
        views: {
          'mainContent@app.contactcenter_management.callcenters': {
            template: '<callcenter-group></callcenter-group>'
          }
        },
        resolve: {}
      }).state('app.contactcenter_management.callcenters.group.edit', {
        url: '/edit',
        stateTranslationName: 'MANAGEMENT.CALLCENTERS.GROUPS.GROUP',
        parent: 'app.contactcenter_management.callcenters.group',
        params: {
          groupId: null,
          group: null
        },
        views: {
          'mainContent@app.contactcenter_management.callcenters': {
            template: '<group-edit style="width: 100%"></group-edit>'
          }
        },
        resolve: {}
      });
  }
})();

(function () {
  "use strict";

  // Creates:
  // K0sski

  angular.module("management.callcenters").component("groupEdit", {
    templateUrl: "app/main/contactcenter/management/callcenters/components/groupedit/groupedit.html",
    controller: Ctrl,
    controllerAs: "vm",
    require: {
      tripleView: "^tripleView"
    }
  });

  /**@ngInject */
  function Ctrl($q, $stateParams, DynamicFactory, $translate, $state, toastService) {
    var vm = this;
    ////////////////
    //functions

    vm.addTag = addTag;

    vm.saveGroup = saveGroup;
    vm.goToGroupView = goToGroupView;

    //resources

    vm.SaveNewGroupRsc = DynamicFactory.get("GroupRsc", "saveGroup");
    vm.DeleteGroupRsc = DynamicFactory.get("GroupRsc", "deleteGroup");
    vm.UpdateGroupRsc = DynamicFactory.get("GroupRsc", "updateGroup");


    vm.$onInit = function () {
      if ($stateParams.group)
        vm.selectedGroup = $stateParams.group;

      getBaseTags();
    };

    vm.$onChanges = function (changesObj) {};

    vm.$onDestory = function () {};





    function saveGroup() {
      if (vm.selectedGroup.id) {
        vm.selectedGroup.desc = vm.selectedGroup.description;
        vm.UpdateGroupRsc(vm.selectedGroup).then(
          function (response) {

            goToGroupView(vm.selectedGroup);
          },
          function (err) {
            console.log("Bład. Cos poszło nie tak" + err);
            toastService.showToast("Coś poszło nie tak...", "error", 4);
          }
        );
      } else {
        vm
          .SaveNewGroupRsc({
            callCenterId: $stateParams.callcenter,
            groupName: vm.selectedGroup.groupName,
            isActive: true,
            desc: vm.selectedGroup.description,
            tags: vm.selectedGroup.tags
          })
          .then(
            function (response) {
              if (response.status === 1) {
                 vm.selectedGroup.id = response.codeOrId;
                 vm.selectedGroup.quantity = 0;
                 vm.selectedGroup.callCenterID = $stateParams.callcenter;
                 vm.selectedGroup.isActive = true;

              } else {
                console.log("Bład. Cos poszło nie tak");
                toastService.showToast("Coś poszło nie tak...", "error", 4);
              }

              goToGroupView(vm.selectedGroup);
            },
            function (err) {
              console.log("Bład. Cos poszło nie tak" + err);
              toastService.showToast("Coś poszło nie tak...", "error", 4);
            }
          );
      }
    }

    function goToGroupView(selectedGroup) {
      $state.go("app.contactcenter_management.callcenters.group", {
        groupId: vm.selectedGroup.id,
        callcenter: $stateParams.callcenter,
        group: selectedGroup
        // color: color
      });
    }

    function getBaseTags() {
      DynamicFactory.get('tagsRsc', 'getTags')().then(function (result) {
        vm.baseTags = result;
      });
    }

    function addTag(tag) {
      var defer = $q.defer();
      if (tag) {
        if (tag.tagId !== 'new') {
          defer.resolve(tag);
        } else {
          DynamicFactory.get('tagsRsc', 'addNewTag')(tag, tag.parentId)
            .then(function (response) {
              tag.tagId = response.tagID;
              tag.value = response.tagID;
              defer.resolve(tag);
            }, error);
        }
      }
      return defer.promise;
    }

    function error(err) {
      toastService.showToast($translate.instant('COMMON.ERROR'), 'error', 4);
    }
  }
})();

(function () {
	'use strict';

	// Creates:
	// MDolega

	angular
		.module('management.callcenters')
		.component('externalList', {
			templateUrl: 'app/main/contactcenter/management/callcenters/components/externallist/externallist.html',
			controller: Ctrl,
      controllerAs: 'vm',
      bindings:{
        ngModel:'='
      }
		});

	/**@ngInject */
	function Ctrl($scope,DynamicFactory) {

		var vm = this;

    vm.editPhone = editPhone;
    vm.deletePhone = deletePhone;
    vm.addPhone = addPhone;
    vm.getPhoneType = getPhoneType;
    vm.savePhone = savePhone;
    vm.addTag = addTag;
    vm.$postLink = postLink;
    vm.$onInit = onInit;

    function postLink(){
      if(!vm.ngModel){
        vm.ngModel = [];
      }
    }

    function getPhoneTypes() {
      DynamicFactory.get('ConsultantsRsc', 'getPhoneTypes')()
        .then(function (data) {
          vm.phoneTypes = data;
        });
    }

    function onInit() {
      // vm.saveIndicator=sendPhones;
      // vm.currentConsultantId=undefined;
      // if(vm.personalAccount) {
      //   getPhones(null);
      // }
      getPhoneTypes();
      // vm.tempId=0;
      getBaseTags();

    }

    function editPhone(gate){
      gate.edited = true;
      vm.gatewayPhone = angular.copy(gate);
    }
    function savePhone(gate){
      if(gate.edited){
        var e=_.findIndex(vm.ngModel,{id:gate.id});
        // if(angular.isUndefined(e)){
        //   e=_.find(vm.ngModel,{tempId:gate.tempId});
        // }
        vm.ngModel[e]=gate;
        // e.phone=gate.phone;
        // e.typeId=gate.typeId;
        // e.tags = gate.tags;
        vm.gatewayPhone=undefined;
      }else if(gate.added) {
        vm.ngModel.push(angular.copy(vm.gatewayPhone));
        vm.gatewayPhone=undefined;
      }
    }

    function deletePhone(gate){
      gate.deleted=true;
    }

    function addPhone(){
      vm.gatewayPhone = {
        added:true
      };
    }

    function getPhoneType(phoneId){
      if(!vm.phoneTypes) return;
      for(var i=0; i<vm.phoneTypes.length-1;i++){
        if(vm.phoneTypes[i].id===phoneId){
          return vm.phoneTypes[i].name;
        }
      }
    }

    function getBaseTags() {
      DynamicFactory.get('tagsRsc', 'getTags')().then(function (result) {
        vm.baseTags = result;
      });
    }

    function addTag(tag) {
      var defer = $q.defer();
      if (tag) {
        if (tag.tagId !== 'new') {
          defer.resolve(tag);
        } else {
          DynamicFactory.get('tagsRsc', 'addNewTag')(tag, tag.parentId)
            .then(function (response) {
              tag.tagId = response.tagID;
              tag.value = response.tagID;
              defer.resolve(tag);
            }, error);
        }
      }
      return defer.promise;
    }

	}
})();

(function() {
  "use strict";

  // Creates:
  // MDolega

  angular.module("management.callcenters").component("callcenterGroups", {
    templateUrl: "app/main/contactcenter/management/callcenters/components/groups/groups.html",
    // controller:   ['$stateParams', 'DynamicFactory', '$translate', '$state', 'headerConfig', '$mdDialog', 'SessionManager', 'tripleviewService', 'toastService','confirmDialogService',Ctrl],
    controller: Ctrl,
    controllerAs: "vm",
    require: {
      tripleView: "^tripleView"
    }
  });

  /**@ngInject */
  function Ctrl($scope, $q, $stateParams, DynamicFactory, $translate, $state, headerConfig, $mdDialog, SessionManager, tripleviewService, toastService, confirmDialogService) {
    var vm = this;
    ////////////////
    //functions
    vm.printColor = printColor;
    vm.consultantsInGroup = consultantsInGroup;
    vm.addTag = addTag;
    vm.editGroup = editGroup;
    vm.addGroup = addGroup;
    vm.saveGroup = saveGroup;

    vm.deleteGroup = deleteGroup;
    vm.checkGroup = checkGroup;
    vm.sortBy = sortBy;

    //header config
    vm.navBarConfig = headerConfig.navBar;
    //vm.navBarConfig.functionAdd = vm.addGroup;

    //resources
    vm.GetGroups = function(callcenter){
      var defer = $q.defer();

      DynamicFactory.get("GroupRsc", "getGroups")(callcenter).then(defer.resolve,defer.reject);
      cancelLastLoading(defer);
      return defer.promise;

    }
    vm.SaveNewGroupRsc = DynamicFactory.get("GroupRsc", "saveGroup");
    vm.DeleteGroupRsc = DynamicFactory.get("GroupRsc", "deleteGroup");
    vm.UpdateGroupRsc = DynamicFactory.get("GroupRsc", "updateGroup");

    //others
    vm.colours = ["#ed5564", "#26a69a", "#2196f3", "#f8ab59"];

    vm.$onInit = function() {
      vm.reverse = false;
      vm.propertyName = "";
      loadNewGroups()
      // vm.tripleView.addMenuItem({
      //   order: 20,
      //   name: 'Dodaj',
      //   icon: 'icon-plus-circle',
      //   class: 'md-accent',
      //   func: function () {
      //     addGroup();
      //   }
      // });
     vm.listener =  $scope.$on("$stateChangeSuccess", stateChangeSuccess);
    };

    vm.$onChanges = function(changesObj) {};

    vm.$onDestroy = function() {
      vm.listener();
    };

    function stateChangeSuccess(event, toState, toParams, fromState, fromParams) {
      if (toState.name == "app.contactcenter_management.callcenters.groups") {
        console.log('callcenterGroups | stateChangeSuccess');
        // tripleviewService.sidenavData.class = "p100";
        vm.groups = undefined;
        loadNewGroups();
      }else if(fromState.name == "app.contactcenter_management.callcenters.group.edit"){
        vm.groups = undefined;
        loadNewGroups();
      }
    }

    function loadNewGroups(){
      console.log('callcenterGroups | loadNewGroups');

      if ($stateParams.callcenter) {
        vm.GetGroups($stateParams.callcenter).then(function(response) {
          vm.groups = response;
          groupSelection();
        });
      }
    }

    function groupSelection() {
      if ($stateParams.groupId) {
        vm.activeGorup = _.find(vm.groups, { id: parseInt($stateParams.groupId) });
        consultantsInGroup(vm.activeGorup);
      } else {
        consultantsInGroup(firstActiveGorup(), vm.printColor(0));
      }
    }
    function firstActiveGorup() {
      for (var i = 0; i < vm.groups.length; i++) {
        var element = vm.groups[i];
        if (element.isActive) {
          return element;
        }
      }
    }

    function sortBy(propertyName) {
      vm.reverse = (vm.propertyName = propertyName) ? !vm.reverse : false;
      vm.propertyName = propertyName;
    }

    function printColor(index) {
      return index < 4 ? vm.colours[index] : vm.colours[index % 4];
    }

    function consultantsInGroup(group, color) {
      vm.activeGorup = group;
      $state.transitionTo("app.contactcenter_management.callcenters.group", {
        groupId: group.id,
        callcenter: $stateParams.callcenter,
        group: group,
        color: color
      });
    }

    function addGroup(ev) {
      $state.transitionTo('app.contactcenter_management.callcenters.group.edit', {
        callcenter: $stateParams.callcenter
      });
      // getBaseTags();
      // vm.selectedGroup = {};
      // DynamicFactory.get("templatesRsc", "GetTemplate")("group-edit").then(function(template) {
      //   $mdDialog.show({
      //     controller: function() {
      //       return vm;
      //     },
      //     controllerAs: "vm",
      //     template: template,
      //     parent: angular.element(document.body),
      //     targetEvent: ev,
      //     clickOutsideToClose: true
      //   });
      // });
    }

    function editGroup(group, ev) {
      vm.selectedGroup = angular.copy(group);
      DynamicFactory.get("templatesRsc", "GetTemplate")("group-edit").then(function(template) {
        $mdDialog.show({
          controller: function() {
            return vm;
          },
          controllerAs: "vm",
          template: template,
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true
        });
      });
    }

    function saveGroup() {
      if (vm.selectedGroup.id) {
        vm.selectedGroup.desc = vm.selectedGroup.description;
        vm.UpdateGroupRsc(vm.selectedGroup).then(
          function(response) {
            if (response.status === 1) {
              for (var i = 0; i < vm.groups.length; i++) {
                if (vm.groups[i].id === vm.selectedGroup.id) {
                  vm.groups[i] = vm.selectedGroup;
                  break;
                }
              }
            } else {
              console.log("Bład. Cos poszło nie tak");
              toastService.showToast("Coś poszło nie tak...", "error", 4);
            }

            vm.selectedGroup = undefined;
            vm.tripleView.basic = undefined;
            $mdDialog.hide();
          },
          function(err) {
            console.log("Bład. Cos poszło nie tak" + err);
            toastService.showToast("Coś poszło nie tak...", "error", 4);
          }
        );
      } else {
        vm
          .SaveNewGroupRsc({
            partnerId: SessionManager.getUser().partnerId,
            callCenterId: $stateParams.callcenter,
            groupName: vm.selectedGroup.groupName,
            isActive: true,
            desc: vm.selectedGroup.description,
            tags:vm.selectedGroup.tags
          })
          .then(
            function(response) {
              if (response.status === 1) {
                vm.selectedGroup.id = response.codeOrId;
                vm.selectedGroup.quantity = 0;
                vm.selectedGroup.callCenterID = $stateParams.callcenter;
                vm.selectedGroup.isActive = true;

                vm.groups.push(vm.selectedGroup);
              } else {
                console.log("Bład. Cos poszło nie tak");
                toastService.showToast("Coś poszło nie tak...", "error", 4);
              }

              vm.selectedGroup = undefined;
              $mdDialog.hide();
            },
            function(err) {
              console.log("Bład. Cos poszło nie tak" + err);
              toastService.showToast("Coś poszło nie tak...", "error", 4);
            }
          );
      }
    }

    function deleteGroup(group) {
      confirmDialogService.showRecDeleteConfirm($translate.instant("CALLCENTER.GROUP.LIST.DELETE_GROUP_QUESTION").replace("{0}", group.groupName)).then(function() {
        vm
          .DeleteGroupRsc({
            id: group.id
          })
          .then(
            function(response) {
              if (response.status === 1) {
                for (var i = 0; i < vm.groups.length; i++) {
                  if (vm.groups[i].id === group.id) {
                    vm.groups.splice(i, 1);
                    break;
                  }
                }
              } else {
                console.log("Bład. Cos poszło nie tak");
                toastService.showToast("Coś poszło nie tak...", "error", 4);
              }
            },
            function(reason) {
              if (reason.data && reason.data.message) {
                var value = angular.fromJson(reason.data.message);
                if (value.codeOrId == -1) {
                  toastService.showToast($translate.instant("CALLCENTER.GROUP.LIST.ERR_DELETE_GROUP_HAS_ACTION"), "error", 4);
                } else if (value.codeOrId == -2) {
                  toastService.showToast($translate.instant("CALLCENTER.GROUP.LIST.ERR_DELETE_GROUP_HAS_CONSULTANT"), "error", 4);
                }
              } else {
                toastService.showToast("Coś poszło nie tak...", "error", 4);
              }
            }
          );
      });
    }

    function getBaseTags() {
        DynamicFactory.get('tagsRsc', 'getTags')().then(function (result) {
          vm.baseTags = result;
        });
    }
    function addTag(tag) {
      var defer = $q.defer();
      if (tag) {
        if (tag.tagId !== 'new') {
          // DynamicFactory.get('tagsRsc', 'addTags')(wizzardService.service.serviceID, tag.tagId).then(function (result) {
          //   // vm.parentScope.service.tags.push(tag);
          //   console.log(tag);
          // }, error);
          //return tag;
          defer.resolve(tag);
        } else {
          DynamicFactory.get('tagsRsc', 'addNewTag')(tag, tag.parentId)
            .then(function (response) {
              tag.tagId = response.tagID;
              tag.value = response.tagID;
              defer.resolve(tag);
            }, error);
         // return tag;
        }
      }
      return defer.promise;
    }
    function error(err) {
      toastService.showToast($translate.instant('COMMON.ERROR'), 'error', 4);
    }
    function cancelLastLoading(newPromise) {
      if (vm.lastPromise) {
        vm.lastPromise.reject();
      }
      vm.lastPromise = newPromise;
      return newPromise;
    }

    function checkGroup(group) {
      if (vm.selectedGroup && vm.selectedGroup.checked === true) {
        vm.selectedGroup.checked = false;
      }
      if (vm.selectedGroup === group) {
        vm.selectedGroup = undefined;
        vm.tripleView.setSidenavItem(undefined);
        return;
      }
      vm.selectedGroup = group;
      vm.selectedGroup.checked = true;
      tripleviewService.sidenavData = vm.selectedGroup;
      // tripleviewService.sidenavData.photoUrl = vm.selectedGroup.photoUrl ? vm.selectedGroup.photoUrl : '../../../../assets/icons/management/consultant.png';
      tripleviewService.sidenavData.subHeader = vm.selectedGroup.groupName;

      // vm.tripleView.sidenavContent.selectedGroupDesc = group.description;
      // vm.tripleView.setSidenavItem({
      //   name: group.groupName,
      //   date: group.updateTime,
      //   icon: 'callcenter',
      //   templateId: 'callcenterselectedgroup-sidenav.html'
      // });
    }
  }
})();

(function () {
  'use strict';

  // Creates:
  // MDolega

  angular
    .module('management.callcenters')
    .component('callcenterGroup', {
      templateUrl: 'app/main/contactcenter/management/callcenters/components/group/group.html',
      controller: Ctrl,
      controllerAs: 'vm',
      require: {
        tripleView: '^tripleView'
      }
    });

  /**@ngInject */
  function Ctrl($stateParams, $scope, $state, DynamicFactory, $filter, tripleviewService,connectionStatisticFuncService,connectionStatisticCons) {

    var vm = this;
    // vm.sortableOptions = {
    // 	placeholder: 'drop-consultant-area',
    // 	connectWith: '.consultants-container',
    // 	'ui-floating': true,
    // 	start: function (e, ui) {
    // 		vm.consultantMoving = true;
    // 		$scope.$apply();
    // 	},
    // 	// helper: function (event, el) {
    // 	//   return el.clone().addClass('drop-consultant-area');
    // 	// },
    // 	stop: function (e, ui) {
    // 		vm.consultantMoving = false;
    // 	}
    // };

    //functions
    // vm.removeConsultantFromGroup = removeConsultantsFromGroup;
    vm.saveConsultantsToGroup = saveConsultantsToGroup;
    vm.editGroup = editGroup;
    vm.discardChanges = discardChanges;
    vm.selectConsultant = selectConsultant;
    // vm.searchNoInGroup = searchNoInGroup;
    // vm.searchingInGroup = searchingInGroup;

    //resources
    vm.GetConsultantsInGroupRsc = DynamicFactory.get('GroupRsc', 'getConsultantsInGroup');
    vm.GetConsultantsNotInGroupRsc = DynamicFactory.get('GroupRsc', 'getConsultantsNotInGroup');
    vm.addConsultantsToGroupRsc = DynamicFactory.get('GroupRsc', 'addConsultantsToGroup');


    //bottom menu
    // function saveConsultantsToGroup(consultants) {

    // }


    vm.$onInit = function () {
      // tripleviewService.sidenavData.class= 'p200';
      // vm.tripleView.addMenuItem({
      // 	order: 1,
      // 	iconSrc: 'assets/icons/triple-view/zapisz.png',
      // 	name: 'save',
      // 	func:
      // });
      vm.consultantList = [];
      if (!$stateParams.group) {
        //$state.go('app.contactcenter_management.callcenters.list');
      }

      vm.group = $stateParams.group;
      vm.color = $stateParams.color;

      consultantsNotInGroup($stateParams.groupId);
      consultantsInGroup($stateParams.groupId);

      vm.getAgrForChart = DynamicFactory.get('reportsCosult', 'ReportsConnectionsAgrForChart');
      vm.connectionStatisticCons = connectionStatisticCons;
    };

    vm.$onChanges = function (changesObj) {

    };

    vm.$onDestory = function () {

    };


    function discardChanges() {
      vm.consultantList = [];
      vm.consultantsInGroup.forEach(function (item) {
        item.inGroup = true;
      });
      vm.consultantList = vm.consultantList.concat(vm.consultantsInGroup);
      vm.consultantList = vm.consultantList.concat(vm.consultantsNotInGroup);
      vm.editMode = false;
    }

    function editGroup() {
      $state.go('app.contactcenter_management.callcenters.group.edit', {
        callcenter: $stateParams.callcenter,
        groupId: $stateParams.groupId,
        group: vm.group
      });
    }

    function consultantsInGroup(groupId) {
      vm.GetConsultantsInGroupRsc(groupId).then(function (response) {
        vm.consultantsInGroup = angular.copy(response);
        // vm.consultInGroup = vm.consultantsInGroup;
        vm.consultantsInGroup.forEach(function (item) {
          item.inGroup = true;
        });
        vm.consultantList = vm.consultantList.concat(vm.consultantsInGroup);
      });
    }

    function consultantsNotInGroup(groupId) {
      vm.GetConsultantsNotInGroupRsc(groupId).then(function (response) {
        vm.consultantsNotInGroup = angular.copy(response);
        // vm.consutNotInGroup = vm.consultantsNotInGroup;
        // vm.consultantsNotInGroup = _.filter(vm.consultantsNotInGroup,function(o) {
        //   var result = !_.some(vm.consultantsInGroup,{ConsultantID :o.ConsultantID });
        //   console.log('callcenterGroup | consultant: '++'')
        //   return result;
        // });
        vm.consultantList = vm.consultantList.concat(vm.consultantsNotInGroup);
      });
    }

    function selectConsultant(consultant) {

      vm.currentConsultantId=consultant.consultantID;

      getAgregationAsync();


    }

    function getAgregationAsync() {
      var from = new Date(moment().subtract(4, 'days').startOf('day')),
        to = moment().format();

      vm.getAgrForChart({
        From: from,
        To: to,
        ConsultantId : vm.currentConsultantId,
        CallcenterId: $stateParams.callcenter,
        AggregationType : 'D'
      }).then(function (response) {
        vm.chartData = connectionStatisticFuncService.groupData(response);
      });
    }


    function saveConsultantsToGroup() {
      var consultantsID = [];
      // for (var i = 0; i < vm.consultantsInGroup.length; i++) {
      // 	consultantsID.push(vm.consultantsInGroup[i].consultantID);
      // }
      for (var i = 0; i < vm.consultantList.length; i++) {
        if (vm.consultantList[i].inGroup) {
          consultantsID.push(vm.consultantList[i].consultantID);
        }
      }
      vm.addConsultantsToGroupRsc({
        groupId: $stateParams.groupId,
        consultants: consultantsID
      }).then(function (response) {
          vm.consultantList = [];
          consultantsInGroup($stateParams.groupId);
          consultantsNotInGroup($stateParams.groupId);
          vm.editMode = false;
          $state.go("app.contactcenter_management.callcenters.groups", {
            groupId: vm.group.id,
            callcenter: $stateParams.callcenter,
            group: vm.group
            // color: color
          });
        },
        function (reason) {});
    }

  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
/**
 * Created by kosski on 07.09.2016.
 */
+ function () {
  'use strict';
  angular
    .module('app.navigation')
    .service('CallCenterService', CallCenterService);

  /** @ngInject */
  function CallCenterService(DynamicFactory, $q) {
    var _this = {
      getCallCenters: getCallCenters
    };

    function getCallCenters(refresh) {
      var defer = $q.defer();
      if (_this.callcenters && !refresh) {
        defer.resolve(_this.callcenters);
      } else {
        if (_this.lastPromise && !refresh) {
          $q.all([_this.lastPromise]).then(function (result) {
            defer.resolve(_this.callcenters);
          });
        } else {
          _this.lastPromise = DynamicFactory.get('ContactCenterRsc', 'getCallCenters')();

          $q.all([_this.lastPromise]).then(function (data) {
            _this.callcenters = data[0];
            defer.resolve(_this.callcenters);
          });
        }
      }
      return defer.promise;
    }


    // function cancelLastLoading(newPromise) {
    //   if (vm.lastPromise) {
    //     vm.lastPromise.reject();
    //   }
    //   vm.lastPromise = newPromise;
    //   return newPromise;
    // }
    return _this;
  }
}();

(function () {
  'use strict';

  angular
    .module('management.callcenters')
    .component('callcenterMenu', {
      templateUrl: 'app/main/contactcenter/management/callcenters/components/callcentermenu/callcentermenu.html',
      controller: Ctrl,
      controllerAs: 'vm',
      bindings: {
        menuItem: '='
      },
      require: {
        optionsMenu: '^^optionsMenu'
      }
    });

  /*@ngInject */
  function Ctrl(DynamicFactory, $scope, $state, $stateParams, $mdDialog, CallCenterService, toastService, SessionManager,$q) {
    var vm = this;

    vm.selectedCallcenter = undefined;

    //functions
    vm.changeActiveType = changeActiveType;
    vm.addCallcenter = addCallcenter;
    vm.saveNewCallcenter = saveNewCallcenter;
    vm.editCallcenter = editCallcenter;
    vm.addTag = addTag;
    // vm.selectCallcenter = selectCallcenter;
    //header config

    // vm.sortBy = sortBy;
    vm.collapseCallcenter = collapseCallcenter;

    //resources
    vm.GetCallCentersRsc = DynamicFactory.get('ContactCenterRsc', 'getCallCenters');
    vm.UpdateCallCentersRsc = DynamicFactory.get('ContactCenterRsc', 'updateCallCenter');
    vm.AddCallCentersRsc = DynamicFactory.get('ContactCenterRsc', 'addCallCenter');

    vm.$onInit = function () {
      getCallcenters();
      vm.userRole = SessionManager.getUserRoleId();
      vm.listener = $scope.$on("$stateChangeSuccess", stateChangeSuccess);
      vm.reverse = false;
      vm.propertyName = '';
    };
    vm.$onDestroy = function () {
      if(vm.listener)
        vm.listener();
    };


    function stateChangeSuccess(event, toState, toParams, fromState, fromParams) {
      vm.activeState = toState.name;
      if (toState.stateTranslationName.indexOf(vm.menuItem.name) !== -1 && toState.name != fromState.name){
        console.log('callcenterMenu | to state:', toState.name);
        if (vm.activeState && toState.stateTranslationName && toState.stateTranslationName.indexOf(vm.menuItem.name) === -1) {
        vm.activeState = undefined;
        vm.selectedCallcenter = undefined;
          vm.callcenters.forEach(function (item) {
            if (item.collapse)
            item.collapse = false;
          });
        } else {
          if (vm.callcenters)
          setSelections(toState);
        }
      }
      // else{
      //   vm.activeState = undefined;
      // }
    }

    function findCallcenter(ccId) {
      var result = _.find(vm.callcenters, {
        id: parseInt(ccId)
      });

      return result;
    }

    function sortBy(propertyName) {
      vm.reverse = (vm.propertyName = propertyName) ? !vm.reverse : false;
      vm.propertyName = propertyName;
    }

    function getBaseTags() {
      DynamicFactory.get('tagsRsc', 'getTags')().then(function (result) {
        vm.baseTags = result;
      });
    }

    function collapseCallcenter(ev, callcenter) {
      ev.stopPropagation();
      callcenter.collapse = !callcenter.collapse;
    }


    // function selectCallcenter(callcenter, event) {
    //   event.stopPropagation();
    //   if (vm.selectedCallcenter && vm.selectedCallcenter.checked === true) {
    //     vm.selectedCallcenter.checked = false;
    //   }
    //   if (vm.selectedCallcenter === callcenter) {
    //     vm.selectedCallcenter = undefined;
    //     return;
    //   }
    //   vm.selectedCallcenter = callcenter;
    //   vm.selectedCallcenter.checked = true;

    //   callcenter.updateTimeFormated = moment(callcenter.updateTime).format('DD-MM-YYYY HH:mm');
    // };

    function changeActiveType() {
      vm.UpdateCallCentersRsc(vm.currentCallCenter).then(function (response) {
        getCallcenters(true);
      }, function (reason) {
        console.log('changeActiveType reason', reason);
      });
    }

    vm.showConsultants = function (ev, callcenter) {
      ev.stopPropagation();
      if (vm.activeCallCenter && callcenter !== vm.activeCallCenter) {
        vm.activeCallCenter.collapse = false;
      }
      vm.activeCallCenter = callcenter;
      vm.optionsMenu.selectFolder(vm.menuItem.name);
      vm.activeState = 'app.contactcenter_management.callcenters.consultants';

      $state.transitionTo('app.contactcenter_management.callcenters.consultants', {
        callcenter: callcenter.id
      });
    };
    vm.showGroups = function (ev, callcenter) {
      ev.stopPropagation();
      if (vm.activeCallCenter && callcenter !== vm.activeCallCenter) {
        vm.activeCallCenter.collapse = false;
      }
      vm.activeCallCenter = callcenter;
      vm.optionsMenu.selectFolder(vm.menuItem.name);
      vm.activeState = 'app.contactcenter_management.callcenters.group';

      $state.transitionTo('app.contactcenter_management.callcenters.groups', {
        callcenter: callcenter.id
      });
    };



    function getCallcenters(refresh) {
      CallCenterService.getCallCenters(refresh).then(function (data) {
        vm.callcenters = data;
        if (vm.menuItem.filter) {
          vm.callcenters = _.filter(vm.callcenters, vm.menuItem.filter);
          vm.menuItem.isHidden = vm.callcenters.length < 1 && vm.menuItem.hideEmpty;
        }

        if ($state.current.name.indexOf('app.contactcenter_management.callcenters.consultant') != -1 || $state.current.name.indexOf('app.contactcenter_management.callcenters.group') !== -1) {
          setSelections($state.current);
        }
        console.log(vm.callcenters);
      });
    }

    function setSelections(currentState) {
      if (currentState.stateTranslationName)
        vm.optionsMenu.selectFolder(currentState.stateTranslationName);

      vm.activeState = currentState.name;
      if (!vm.activeCallCenter || vm.activeCallCenter.id != parseInt($stateParams.callcenter)) {
        vm.activeCallCenter = findCallcenter($stateParams.callcenter);
        if (vm.activeCallCenter) {
          vm.menuItem.collapse = false;
          vm.activeCallCenter.collapse = true;
        }
      }
    }

    function addCallcenter(ev) {
      getBaseTags();
      vm.currentCallCenter = {};
      DynamicFactory.get('templatesRsc', 'GetTemplate')('callcenter-edit')
        .then(function (template) {
          $mdDialog.show({
            controller: function () {
              return vm;
            },
            controllerAs: 'vm',
            template: template,
            parent: angular.element(document.body),
            targetEvent: ev
          }).then(function (data) {},
            function (err) {}
          );
        });
    }

    function addTag(tag) {
      var defer = $q.defer();
      if (tag) {
        if (tag.tagId !== 'new') {
          defer.resolve(tag);
        } else {
          DynamicFactory.get('tagsRsc', 'addNewTag')(tag, tag.parentId)
            .then(function (response) {
              tag.tagId = response.tagID;
              tag.value = response.tagID;
              defer.resolve(tag);
            }, error);
        }
      }
      return defer.promise;
    }

    function editCallcenter(callCenter, ev) {
      getBaseTags()
      vm.currentCallCenter = angular.copy(callCenter);
      DynamicFactory.get('templatesRsc', 'GetTemplate')('callcenter-edit')
        .then(function (template) {
          $mdDialog.show({
            controller: function () {
              return vm;
            },
            controllerAs: 'vm',
            template: template,
            parent: angular.element(document.body),
            targetEvent: ev
          }).then(function (data) {},
            function (err) {}
          );
        });

    }




    function error(err) {
      toastService.showToast($translate.instant('COMMON.ERROR'), 'error', 4);
    }



    function saveNewCallcenter() {
      if (vm.currentCallCenter.id) {
        if (vm.saveMail)
          vm.saveMail();

        vm.UpdateCallCentersRsc(vm.currentCallCenter).then(function (response) {
          getCallcenters(true);
          toastService.showToast("Zapis zakończony powodzeniem", 'success', 4);
        }, function (reason) {
          console.warn('saveCallcenter WARNING! ', reason);
        });
      } else {
        vm.AddCallCentersRsc(vm.currentCallCenter).then(function (response) {
          vm.currentCallCenter.id = response;
          getCallcenters(true);
          if (vm.saveMail)
            vm.saveMail();
          toastService.showToast("Zapis zakończony powodzeniem", 'success', 4);
        }, function (reason) {
          console.warn('saveCallcenter WARNING! ', reason);
        });
      }
      $mdDialog.hide();
    }
  }
})();

-function () {
  'use strict';
  angular
    .module('contactcenter.profilemanagement')
    .component('userList', {
        templateUrl: 'app/main/contactcenter/dashboard/profilemanagement/components/userlist/userlist.html',
        require: {
          tripleView: '^tripleView'
        },
        bindings: {},
        controllerAs: 'vm',
        controller: 'userListCtrl'
      }
    ).controller('userListCtrl',
    function controller($stateParams, DynamicFactory, toastService, headerConfig, authRolesConst, $mdDialog, SessionManager, $state) {
      var vm = this; // jshint ignore:line

      // vm.deleteUser = deleteUser;
      // vm.addNewUser = addNewUser;
      // vm.editUser = editUser;
      // vm.promotionSwitch = promotionSwitch;
      // vm.saveNewUser = saveNewUser;
      // vm.selectUser = selectUser;
      vm.sortBy = sortBy;
      vm.$onInit = onInit;
      vm.addNewUser = addNewUser;
      vm.editUser = editUser;

      function onInit() {
        vm.authRolesConst = authRolesConst;
        vm.usersList = [];
        vm.filter = {};
        vm.navBarConfig = headerConfig.navBar;
        // vm.userData=undefined;

        setUserList();

        // registerEvent();
        populateRoleSource();
        loadCC();
        vm.reverse = false;
        vm.propertyName = '';
      }

      // function postLink(){
      function sortBy(propertyName) {
        vm.reverse = (vm.propertyName = propertyName)? !vm.reverse: false;
        vm.propertyName = propertyName;
      }

      // }

      function setUserList() {
        vm.userData = SessionManager.getUser();

        DynamicFactory.get('UsersRsc', 'getUsers')(undefined).then(function (data) {
          vm.usersList = data;
        }, function (err) {
        });

      }


      function addNewUser() {
        $state.go('app.contactcenter_dashboard.settings.users.edit');

      }
      function editUser(user) {
        // $state.go('app.contactcenter_dashboard.settings.consultantedit');
        $state.go('app.contactcenter_dashboard.settings.users.edit',{userId:user.id});
      }
      // function registerEvent() {
      //   vm.tripleView.addMenuItem({
      //     order: 20,
      //     name: 'Dodaj',
      //     icon: 'icon-plus-circle',
      //     class: 'md-accent icon-button-shadow',
      //     func: addNewUser
      //   });
      // }


      // function addUser() {
      //
      //   vm.tripleView.showActionBar();
      //   hashPwd(vm.editedUser);
      //   DynamicFactory.get('UsersRsc', 'addUser')(vm.editedUser).then(function (data) {
      //     vm.editedUser.id = data.codeOrId;
      //     vm.editedUser.newRecordMode=false;
      //
      //     vm.editedUser.role=_.find(vm.roleSource, { value:vm.editedUser.roleID}).name;
      //
      //     if (vm.saveMail)
      //       vm.saveMail(data.codeOrId);
      //     SuccesFunc(vm.editedUser);
      //   }, ErrorFunc);
      // }

      // function saveChanges(answer) {
      //   vm.tripleView.showActionBar();
      //   hashPwd(vm.editedUser);
      //
      //   if (vm.saveMail)
      //     vm.saveMail();
      //
      //   DynamicFactory.get('UsersRsc', 'updateUsers')([vm.editedUser])
      //     .then(function (data) {
      //       vm.editedUser.role=_.find(vm.roleSource, { value:vm.editedUser.roleID}).name;
      //
      //         SuccesFunc(vm.editedUser);
      //
      //       }, ErrorFunc);
      // }

      // function editUser(user, ev) {
      //   if (user.id !== 'new') {
      //     vm.userIndex = vm.usersList.indexOf(user);
      //   } else {
      //     vm.userIndex = -1;
      //   }
      //   vm.editedUser = angular.copy(user);
      //
      //   console.log(user);
      //   vm.sourceRoleId =angular.copy( vm.editedUser.roleID);
      //   // vm.tripleView.hideActionBar();
      //   DynamicFactory.get('templatesRsc', 'GetTemplate')('userEdit')
      //     .then(function (template) {
      //       $mdDialog.show({
      //         controller: function () {
      //           return vm;
      //         },
      //         controllerAs: 'vm',
      //         template: template,
      //         parent: angular.element(document.body),
      //         targetEvent: ev
      //       }).then(!vm.editedUser.newRecordMode ? saveChanges : addUser,
      //         function (err) {
      //           console.log('Zapis użytkownika error');
      //           // vm.tripleView.showActionBar();
      //           vm.editedUser = undefined;
      //         }
      //       );
      //     });
      //
      // }


      // function hashPwd(user) {
      //   if (user.pwd)
      //     user.pwd = sha1(user.pwd);
      // }

      // function saveNewUser(myForm) {
      //   if (Object.keys(myForm.$error).length === 0) {
      //     console.log('saveNewUser');
      //     $mdDialog.hide();
      //   }
      // }

      // function SuccesFunc(editedUser) {
      //   updateUserList(editedUser);
      //   toastService.showToast('Zmiany zostały zapisane', 'success', 4);
      // }

      // function addNewUser(ev) {
      //   var empytUser = {
      //     id: 'new',
      //     login: '',
      //     pwd: '',
      //     newRecordMode: true
      //   };
      //
      //   editUser(empytUser, ev);
      // }

      // function deleteUser(user) {
      //   if (user.isactive) {
      //     DynamicFactory.get('UsersRsc', 'deactivateUser')(user.id)
      //       .then(function () {
      //         user.isactive = false;
      //         SuccesFunc()
      //       });
      //   }
      // }

      // function changeUserAvatar(userId) {
      //   return function (photoUrl) {
      //     DynamicFactory.get('profileRsc', 'PutConsultantPhoto')(photoUrl, userId);
      //   }
      // }

      // function updateUserList(user) {
      //   if (vm.userIndex !== -1)
      //     vm.usersList[vm.userIndex] = user;
      //   else
      //     vm.usersList.push(user);
      // }

      // function selectUser(user) {
      //
      //   if (vm.selectedUser && vm.selectedUser.checked === true) {
      //     vm.selectedUser.checked = false;
      //     user.checked = true;
      //   }
      //   if (vm.selectedUser === user) {
      //     vm.selectedUser = undefined;
      //     tripleviewService.sidenavData = {};
      //     return;
      //   }
      //   vm.selectedUser = user;
      //   // vm.selectedUser.checked = !vm.selectedUser.checked;
      //   vm.selectedUser.subHeader = vm.selectedUser.firstName ? vm.selectedUser.firstName : '' + ' ' + vm.selectedUser.lastName ? vm.selectedUser.lastName : '';
      //   vm.selectedUser.avatarCallback = changeUserAvatar(vm.selectedUser.id);
      //   vm.selectedUser.photoUrl = vm.selectedUser.photoUrl;
      //   tripleviewService.sidenavData = vm.selectedUser;
      // }
      //
      // function promotionSwitch(){
      //   if(vm.sourceRoleId === 3){
      //     vm.editedUser.consultantPromotion = vm.editedUser.roleID;
      //   }
      // }


      function populateRoleSource() {
        vm.roleSource = [];

        vm.roleSource.push({
          name: 'Admin',
          value: 1
        });
        vm.roleSource.push({
          name: 'Manager',
          value: 2
        });
        vm.roleSource.push({
          name: 'Consultant',
          value: 3,
          disabled: true
        });
      }

      function loadCC() {
        DynamicFactory.get('ContactCenterRsc', 'getCallCenters')()
          .then(function (result) {
            vm.callcenters = result;
          });
      }


    });
}();

(function() {
  'use strict';
  angular
    .module('contactcenter.profilemanagement')
    .component('settingsMailbox', {
      templateUrl:
        'app/main/contactcenter/dashboard/profilemanagement/components/settingsmailbox/settingsmailbox.html',
      controllerAs: 'vm',
      bindings: {
        uid: '<',
        saveIndicator: '=',
        newRecord:'=',
        resource: '@',
        idName:'@',
        columnOrder: '=',
        personalAccount: "<",
        ngModel: '='
      },
      controller: controller
    });

  /** @ngInject */
  function controller(
    DynamicFactory,
    SessionManager,
    toastService,
    $translate,
    $scope
  ) {
    var vm = this; // jshint ignore:line

    vm.$onChanges = onChanges;
    vm.$postLink = postLink;
    vm.$onInit = onInit;

    function onInit() {
    }

    function postLink() {
      if (vm.ngModel) {
        vm.mailDataSource = angular.copy(vm.ngModel);
        vm.mailData = vm.ngModel;
      }
      // else {
      //   // vm.inited = true;
      //   getMail()
      // }
      vm.saveIndicator = putMail;
    }

    function onChanges(changesObj) {
      if (changesObj.uid && changesObj.uid.currentValue != undefined) {
        getMail();
      }else{
        vm.newRecord = true;
      }
    }

    function ErrorFunc(err) {
      // alert('error');
      toastService.showToast('Nie udało się zapisać zmian w mailbox.', 'error', 4);
    }

    function addMailbox() {
      vm.newRecord = true;
      if(vm.idName){
        vm.mailData = {
          // UserID: vm.uid,
          isActive: true
        };
        vm.mailData[vm.idName] = vm.uid;
      }else{
        vm.mailData = {
          UserID: vm.uid,
          isActive: true
        };
      }

      vm.mailDataSource = angular.copy(vm.mailData);
    }

    // function removeMailbox(mailbox) {
    //   mailbox.isActive = !mailbox.isActive;
    // }

    function getMail() {
      if (!vm.uid) {
        addMailbox();
      }else {
        var userId=undefined;
        // w przypadku ustawień osobistych nie wysyłamy userID bo API wie z jakim userem ma doczynienie
        if(!vm.personalAccount){
          userId =vm.uid;
        }
        DynamicFactory.get(vm.resource, 'getMailBoxes')(userId).then(function(
          data
        ) {
          if (data.length > 0) {
            vm.mailDataSource = angular.copy(data[0]);
            vm.mailData = data[0];
          } else {
            addMailbox();
          }
          // if (vm.mailData.length < 1)
            setTimeout(function(){
              vm.mailboxForm.$setDirty();
            },100);
          //   addMailbox();
        });
      }
    }

    function putMail(newUid,callCenterID) {
      if (vm.mailData)
        if (!angular.equals(vm.mailData, vm.mailDataSource)) {
          if (newUid ) {
            vm.mailData.UserID = newUid;
            vm.mailData.callCenterID = callCenterID;
          }

          if(!vm.mailData.email ){
            vm.mailData.email='';// jakby co to zapisujemy pusty email, a kiedyś dokonfiguruje się
          }

          DynamicFactory.get(vm.resource, 'updateMailBoxes')(vm.mailData).then(
            function(data) {
              toastService.showToast(
                'Pomyślnie zapisano zmiany.',
                'success',
                4
              );
            },
            ErrorFunc
          );
        }
    }
  }
})();

/**
 * Created by kosski on 09.09.2016.
 */
+function () {
  'use strict';

  const clearTimeShifts = [
    '000000000000000000000000', '000000000000000000000000',
    '000000000000000000000000', '000000000000000000000000',
    '000000000000000000000000', '000000000000000000000000',
    '000000000000000000000000'
  ];

  angular.module('contactcenter.profilemanagement').component('timeshift', {
    templateUrl: 'app/main/contactcenter/dashboard/profilemanagement/components/timeshift/timeshift.html',
    controllerAs: 'vm',
    require: {
      tripleView: '^tripleView'
    },
    controller: controller
  });

  /** @ngInject */
  function controller(DynamicFactory, toastService, $state, $timeout, $scope) {
    var vm = this;

    var date = new Date();
    var d = date.getDate();
    var m = date.getMonth();
    var y = date.getFullYear();

    vm.next = next;
    vm.prev = prev;
    vm.selectHour = selectHour;
    vm.mouseDown = mouseDown;
    vm.mouseOver = mouseOver;
    vm.removeClass = removeClass;
    vm.mouseUp = mouseUp;
    vm.saveTime = saveTime;
    vm.clearTime = clearTime;
    vm.loadTimeShifts = loadTimeShifts;
    vm.$postLink = postLink;
    vm.$onInit = onInit;

    function onInit() {
      vm.TimeShifts = [];
      vm.SelectionIsOn = false;
      vm.RecentSelectedList = [];
      vm.LastSelected = '';
      vm.Weeks = new Array(7);
      vm.Hours = new Array(24);
      vm.IsMobile = false;
      vm.TimeShifts = clearTimeShifts;
      registerEvent();
    }

    function registerEvent() {
      vm.tripleView.addMenuItem({
        order: 20,
        name: 'Zapis',
        iconSrc: 'assets/icons/triple-view/zapisz.png',
        func: function () {
          saveTime();
        }
      });
    }

    vm.events = [
      [
        {
            id   : 1,
            title: 'All Day Event',
            start: new Date(y, m, 1),
            end  : null
        }
      ]
    ];

    vm.calendarUiConfig = {
      calendar: {
        editable: true,
        eventLimit: true,
        header: '',
        handleWindowResize: false,
        aspectRatio: 1,
        dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        viewRender: function (view) {
          vm.calendarView = view;
          vm.calendar = vm.calendarView.calendar;
          vm.currentMonthShort = vm.calendar.getDate().format('MMM');
        },
        columnFormat: {
          month: 'ddd',
          week: 'ddd D',
          day: 'ddd M'
        },
        // eventClick        : eventDetail,
         selectable        : true,
         selectHelper      : true
        // select            : select
      }
    };

    function next() {
      vm.calendarView.calendar.next();
    }

    /**
     * Go to previous on current view (week, month etc.)
     */
    function prev() {
      vm.calendarView.calendar.prev();
    }


    function postLink() {
      loadTimeShifts();
    }


    function loadTimeShifts() {
      DynamicFactory.get('TSRsc', 'getTimeShifts')().then(function (suc) {
        if (suc.length > 0) {
          vm.TimeShifts = [];
          suc.forEach(function (e) {
            vm.TimeShifts.push(e.hours);
          });
        }
        else {
          toastService.showToast('Nie masz jeszcze grafika czasu pracy. Wczytano pusty grafik.', 'warn', 4);
          vm.TimeShifts = angular.copy(clearTimeShifts);
        }
        processData(vm.TimeShifts);
      }, function (err) {
        vm.TimeShifts = angular.copy(clearTimeShifts);
        toastService.showToast('Nie udało się wczytać czasu pracy.', 'error', 4);
        error(err, 'TS oninit');
      });
    }

    function setCharAt(str, index, chr) {
      index = index * 1;
      if (index > str.length - 1) return str;
      return str.substr(0, index) + chr + str.substr(index + 1);
    }

    function selectHour(weekday, hour, newVal) {
      vm.TimeShifts[weekday] = setCharAt(vm.TimeShifts[weekday], hour, newVal);
    };
    vm.processData = processData;
    function processData(times) {
      var elements = document.getElementsByClassName("selectable");
      for (var p = 0; p < elements.length; p++) {
        for (var t = 0; t < times.length; t++) {
          for (var i = 0; i < times[t].length; i++) {
            if (times[t][i] === '1') {
              var elem = angular.element(elements[p]);
              if (elem[0].attributes['data-weekday'].value === t + '' && elem[0].attributes['data-hour'].value === i + '') {
                elem.addClass('selected');
              }
            }
          }
        }
      }
    }
    function mouseDown(event) {
      event.preventDefault();
      vm.SelectionIsOn = true;
      var target = angular.element(event.target);
      if (target.hasClass('selected')) {
        target.removeClass('selected');
        selectHour(target[0].attributes['data-weekday'].value, target[0].attributes['data-hour'].value, '0');
      } else {
        target.addClass('selected');
        selectHour(target[0].attributes['data-weekday'].value, target[0].attributes['data-hour'].value, '1');
      }
      target.addClass('recent');
    }
    function mouseOver(event) {
      if (vm.SelectionIsOn) {
        var target = angular.element(event.target);
        if (target.hasClass('selected')) {
          target.removeClass('selected');
          if (vm.LastSelected !== "") {
            angular.element(vm.LastSelected.target).removeClass('selected');
            selectHour(target[0].attributes['data-weekday'].value, target[0].attributes['data-hour'].value, '0');
            vm.LastSelected = event;
          }
        } else {
          target.addClass('selected');
          selectHour(target[0].attributes['data-weekday'].value, target[0].attributes['data-hour'].value, '1');
          removeClass('recent');
          target.addClass('recent');
          vm.LastSelected = event;
        }
      }
    }
    function removeClass(className, callback) {
      angular.forEach(document.getElementsByClassName(className), function (value, key) {
        angular.element(value).removeClass(className);
      });
      if (callback !== undefined) {
        return callback();
      }
    }

    function mouseUp(event) {
      vm.SelectionIsOn = false;
      removeClass('recent');
    }

    function saveTime() {
      DynamicFactory.get('TSRsc', 'saveTimeShifts')({
        Shifts: vm.TimeShifts
      }).then(function (data) {
        toastService.showToast('Twój czas pracy został zaktualizowany pomyślnie.', 'success', 4)
      }
        , function (err) {
          error();
        });
    }

    function clearTime() {
      vm.TimeShifts = clearTimeShifts;
      var data = {
        Shifts: clearTimeShifts
      };
      DynamicFactory.get('TSRsc', 'clearTimeShifts')(data).then(function () {

        toastService.showToast('Twój czas pracy został zresetowany pomyślnie.', 'success', 4);
        $timeout(function () {
          $state.reload();
        }, 1500);
      }, function (e) {
        error(e, 'TS clearTime');
        toastService.showToast('Ups... Coś poszło nie tak.', 'error', 4);

      });
    }




  }


}();

/**
 * Created by kosski on 09.09.2016.
 */
+function () {
  'use strict';
  angular.module('contactcenter.profilemanagement').component('rates', {
    templateUrl: 'app/main/contactcenter/dashboard/profilemanagement/components/rates/rates.html',
    controllerAs: 'vm',
    require: {
      tripleView: '^tripleView'
    },
    controller: controller
  });
  /** @ngInject */
  function controller(DynamicFactory, SessionManager, toastService, $state,$scope) {
    var vm = this;
    vm.toggleItem = toggleItem;
    vm.saveRates = saveRates;
    vm.$postLink = postLink;
    vm.$onInit = onInit;

    function onInit() {
      vm.rateType = [
        { name: 'emailRate', label: 'Mail' },
        { name: 'chatRate', label: 'Chat' },
        { name: 'callBackRate', label: 'Rozmowa telefoniczna' },
        { name: 'videoChatRate', label: 'Video chat' }
      ];
      vm.emailRate = false;
      registerEvent();
    }

    function registerEvent() {
      vm.tripleView.addMenuItem({
        order: 20,
        name: 'Zapis',
        iconSrc: 'assets/icons/triple-view/zapisz.png',
        func: function () {
          saveRates();
        }
      });
    }
    function postLink() {
      DynamicFactory.get('ratesRsc', 'GetPortalRate')()
        .then(function (data) {
          if (data[0]) {
            vm.inputModel = data[0];
            if (vm.inputModel['emailRate']) vm.emailRate = true;
            if (vm.inputModel['chatRate']) vm.chatRate = true;
            if (vm.inputModel['callBackRate']) vm.callBackRate = true;
            if (vm.inputModel['videoChatRate']) vm.videoChatRate = true;
          } else {
            vm.inputModel = {};
          }
        }, Onerror);
    }


    function toggleItem(item) {
      if (vm[item]) {
        vm.inputModel[item] = undefined;
        saveRates();
      }
      else vm.inputModel[item] = 0;
    };

    function saveRates() {
      DynamicFactory.get('ratesRsc', 'SetPortalRate')(vm.inputModel)
        .then(function (data) {
          toastService.showToast('Zmiany zostały zapisane', 'success',4)

        }, Onerror);
    };

    function Onerror(er) {
      toastService.showToast('Ups! coś poszło nie tak :( ', 'error',4)
    }


  }



}();

(function () {
  'use strict';
  angular
    .module('contactcenter.profilemanagement')
    .component('settingsGeneral', {
      templateUrl: 'app/main/contactcenter/dashboard/profilemanagement/components/general/general.html',
      controllerAs: 'vm',
      require: {
        tripleView: '^tripleView'
      },
      controller: controller
    });

  /** @ngInject */
  function controller(DynamicFactory, SessionManager, toastService, $translate, $scope, authRolesConst) {
    var vm = this; // jshint ignore:line

    // vm.getlangs = getlangs;
    vm.saveChanges = saveChanges;
    vm.$onChanges = OnChanges;
    vm.$onInit = onInit;

    function onInit() {
      vm.SessionManager = SessionManager;
      vm.authRolesConst = authRolesConst;
      vm.consultantId=vm.SessionManager.getUser().consultantId;
      vm.userId=vm.SessionManager.getUser().userId;
      getUser();
      // getMail();
      populateRoleSource();
      registerEvent();
    }

    function registerEvent() {
      vm.tripleView.addMenuItem({
        order: 20,
        name: 'Zapis',
        iconSrc: 'assets/icons/triple-view/zapisz.png',
        func: function () {
          saveChanges();
        }
      });
    }

    function OnChanges(changesObj) {
      console.log(changesObj);
    }


    function saveChanges() {
      // putlangs();
      // DynamicFactory.get('profileRsc', 'PutConsultant')(vm.ConsultantData).then(function (suc) {
      // }, ErrorFunc);

      if (vm.saveMail) {
        vm.saveMail();
      }

     /* if (vm.saveJira) {
        vm.saveJira();
      }*/

      if(vm.saveIssueTracker){
        vm.saveIssueTracker();
      }

      putUser();
    }

    function ErrorFunc(err) {
      alert('error');
      toastService.showToast('Nie udało się zapisać zmian.', 'error', 4);
    }


    function getUser() {
      DynamicFactory.get('profileRsc', 'getUser')()
        .then(function (data) {
          data.subHeader = data.firstName ? data.firstName : '' + ' ' + data.lastName ? data.lastName : '';
          data.avatarCallback = DynamicFactory.get('profileRsc', 'PutConsultantPhoto');
          // tripleviewService.sidenavData =
          //   vm.userData = data;
        });
    }

    function putUser() {

      if (Object.keys($scope.userForm.$error).length === 0) {
        if (vm.userData.newPwd && vm.userData.newPwd.length > 0) {
          vm.userData.pwd = sha512(vm.userData.newPwd);
        } else {
          vm.userData.pwd = null;
        }
        DynamicFactory.get('profileRsc', 'PutUser')(vm.userData)
          .then(function (data) {
              toastService.showToast('Pomyślnie zapisano zmiany.', 'success', 4);
            },
            ErrorFunc
          );
      } else {
        toastService.showToast('Przed zapisem uzupełnij poprawnie dane.', 'error', 4);
      }

    }


    function populateRoleSource() {
      vm.roleSource = [];

      vm.roleSource.push({
        name: 'Admin',
        value: 1
      });
      vm.roleSource.push({
        name: 'Manager',
        value: 2
      });

      vm.roleSource.push({
        name: 'Konsultant',
        value: 3
      });

    }


  }

})
();

(function() {
  'use strict';
  angular
    .module('contactcenter.profilemanagement')
    .component('partnerMailbox', {
      templateUrl:
        'app/main/contactcenter/dashboard/profilemanagement/components/partnermailbox/partnermailbox.html',
      controllerAs: 'vm',
      require: {
        tripleView: '^tripleView'
      },
      controller: controller
    });

  /** @ngInject */
  function controller(
    DynamicFactory,
    SessionManager,
    toastService,
    $translate,
    $scope,
    tripleviewService,
    headerConfig,
    $mdDialog
  ) {
    var vm = this; // jshint ignore:line

    vm.activMail = activMail;
    vm.addNewMail = addNewMail;
    vm.saveNewMail = saveNewMail;
    vm.editMail = editMail;
    vm.sortBy = sortBy;
    vm.$onInit = onInit;

    function onInit() {
      vm.navBarConfig = headerConfig.navBar;
      vm.filter = {};
      getMailboxes();
      registerEvent();
      DynamicFactory.get('partnerRsc', 'getPartner')().then(
        function(data) {
          if (data) {
            data.subHeader = data.companyName ? data.companyName : '';
            data.photoProp = 'logoUrl';
            tripleviewService.sidenavData = data;
            // onReady();
          }
        },
        function(errr) {}
      );
    }

    function saveNewMail(myForm) {
      if (Object.keys(myForm.$error).length === 0) {
        console.log('saveNewUser');
        $mdDialog.hide();
      }
    }

    function registerEvent() {
      vm.tripleView.addMenuItem({
        order: 20,
        name: 'Zapis',
        iconSrc: 'assets/icons/triple-view/zapisz.png',
        func: function() {
          // saveChanges();
        }
      });
    }

    function getMailboxes() {
      DynamicFactory.get('partnerRsc', 'getMailBoxes')().then(
        function(data) {
          if (data) {
            vm.mailList = data;
          }
        },
        function(errr) {}
      );
    }

    function addNewMail(ev) {
      var emptyMail = {
        id: 'new',
        newRecordMode: true
      };
      editMail(emptyMail, ev);
    }

    function editMail(mail, ev) {
      if (!mail.newRecordMode) {
        vm.mailIndex = vm.mailList.indexOf(mail);
      } else {
        vm.mailIndex = -1;
      }
      vm.editedMail = angular.copy(mail);

      console.log(mail);

      DynamicFactory.get('templatesRsc', 'GetTemplate')('partnerMail').then(
        function(template) {
          $mdDialog
            .show({
              controller: function() {
                return vm;
              },
              controllerAs: 'vm',
              template: template,
              parent: angular.element(document.body),
              targetEvent: ev
            })
            .then(saveChanges, ErrorFunc);
        }
      );
    }

    function activMail(mail) {
      DynamicFactory.get('partnerRsc', 'updateMailBoxes')(mail).then(function(data) {
        toastService.showToast('Pomyślnie zapisano zmiany.', 'success', 4);
      },
      ErrorFunc);
    }

    function saveChanges(answer) {
      vm.tripleView.showActionBar();
      if (vm.saveMail) vm.saveMail();
      getMailboxes() ;
    }

    function sortBy(propertyName) {
      vm.reverse = (vm.propertyName = propertyName) ? !vm.reverse : false;
      vm.propertyName = propertyName;
    }

    function ErrorFunc(err) {
      toastService.showToast('Nie udało się zapisać zmian.', 'error', 4);
    }
  }
})();

/**
 * Created by kosski on 08.09.2016.
 */
+function () {
  angular.module('contactcenter.profilemanagement').component('description', {
    templateUrl: 'app/main/contactcenter/dashboard/profilemanagement/components/description/description.html',
    controllerAs: 'vm',
    require: {
      tripleView: '^tripleView'
    },
    controller: controller
  });
  /** @ngInject */
  function controller(DynamicFactory, SessionManager, toastService, $translate, $scope) {
    'use strict';
    var vm = this;
    var txt = document.getElementById('descriptionConsultant');
    vm.htmlcontent = "";
    vm.saveChanges = saveChanges;
    vm.$onInit = onInit;
    function saveChanges(portalid) {
      DynamicFactory.get('DescriptionRsc', 'SaveDescription')({
        'PortalId': vm.CurrentUser.portalId,
        'Description': vm.htmlcontent
      }).then(function (suc) {
        success('DESCRIPTION.SERVER_SAVE');
      }, function (err) {
        error('DESCRIPTION.SERVER_ERROR_SAVE');
      });
    };

    function onInit() {
      vm.CurrentUser = SessionManager.getUser();
      console.log('user');
      console.log(vm.CurrentUser);
      DynamicFactory.get('DescriptionRsc', 'GetDescription')(vm.CurrentUser.portalId).then(function (data) {
        if (data[0]) {
          // console.log(data);
          vm.htmlcontent = data[0].description;
        }
        success('DESCRIPTION.SERVER_LOAD');
      }, function (err) {
        error('DESCRIPTION.SERVER_ERROR_LOAD');
      });
      registerEvent();
    }

    function registerEvent() {
      vm.tripleView.addMenuItem({
        order: 20,
        name: 'Zapis',
        iconSrc: 'assets/icons/triple-view/zapisz.png',
        func: function () {
          saveChanges();
        }
      });
    }

    function success(comment) {
      toastService.showToast($translate.instant(comment), 'warn',4);
    }

    function error(comment) {
      toastService.showToast($translate.instant(comment),'error',4);
    }


  }

}();

(function () {
  'use strict';

  angular.module('contactcenter.profilemanagement').component('issueTrackerIntegration', {
    templateUrl: 'app/main/contactcenter/dashboard/profilemanagement/components/issuetracker/issuetrackerintegration.html',
    bindings: {
      saveIndicator: '='
    },
    controllerAs: 'vm',
    controller: IssueTrackerIntegration
  });

  /* @ngInject */
  function IssueTrackerIntegration($scope, $q, $localStorage, DynamicFactory, SessionManager, authRolesConst, issueTrackerService, ISSUE_TRACKER_NAME) {
    var vm = this;

    vm.$onInit = onInit;
    vm.$postLink = postLink;

    vm.issueTrackerConfigs = [];

    vm.ISSUE_TRACKER_NAME = ISSUE_TRACKER_NAME;

    function onInit() {
      vm.integrate = integrate; //integrate function call "integrateWithIssueTracker" function which you have to handle in specific IssueTracker component!!!

      vm.SessionManager = SessionManager;
      vm.authRolesConst = authRolesConst;
      vm.userCredential = issueTrackerService.getUserCredential;
      vm.changeIssueTrackerConfig = changeIssueTrackerConfig;
    }

    function postLink() {
      issueTrackerService.getIssueTrackerConfig().then(
        function (configuration) {
          if (configuration) {
            addConfig(configuration);
            setConfig(configuration);
          }

          issueTrackerService.getIssueTrackers().then(
            function (result) {
              vm.issueTrackers = result;
              vm.selectedIssueTracker = vm.issueTrackers.find(function (issueTrackerItem) {
                return issueTrackerItem.id == vm.issueTrackerConfig.issueTrackerId;
              });
            });

        });

      vm.saveIndicator = updateIssueTrackerConfig;
    }

    /*$scope.$on('integrationCompleted', function (evt, integrationSucceed) {
      if (integrationSucceed) {
        if (SessionManager.getUserRoleId() == authRolesConst.admin)
          issueTrackerService.updateIssueTrackerConfig(vm.issueTrackerConfig);
      }
    });*/

    function integrate() {
      if (vm.issueTrackerConfig) {
        $scope.$broadcast("integrateWithIssueTracker");
        if (SessionManager.getUserRoleId() == authRolesConst.admin)
          issueTrackerService.updateIssueTrackerConfig(vm.issueTrackerConfig);
      }
    }

    function updateIssueTrackerConfig() {
      if (vm.issueTrackerConfig) {
        issueTrackerService.updateIssueTrackerConfig(vm.issueTrackerConfig);
      }
    }

    //#region Auxiliary functions to manage change of issue tracker module into Settings
    function changeIssueTrackerConfig() {
      vm.issueTrackerConfig = vm.issueTrackerConfigs.find(function (configItem) {
        return configItem.issueTrackerId == vm.selectedIssueTracker.id;
      });
      if (!vm.issueTrackerConfig) {
        vm.issueTrackerConfig = {
          issueTrackerId: vm.selectedIssueTracker.id
        };
      }
    }

    function addConfig(config) {
      vm.issueTrackerConfigs.push(config);
    }

    function setConfig(config) {
      vm.issueTrackerConfig = config;
    }
    //#endregion
  }

})();

(function () {
  'use strict';

  angular.module('contactcenter.profilemanagement').service('issueTrackerService', IssueTrackerService);

  function IssueTrackerService($q, $localStorage, $mdDialog, SessionManager, DynamicFactory) {
    var vm = this;

    vm.getIssueTrackers = getIssueTrackers;
    vm.getIssueTrackerConfig = getIssueTrackerConfig;
    vm.updateIssueTrackerConfig = updateIssueTrackerConfig;

    vm.saveUserCredential = saveUserCredential;
    vm.getUserCredential = getUserCredential;

    function getIssueTrackers() {
      return $q(function (resolve, reject) {
        if (vm.issueTrackers)
          resolve(vm.issueTrackers)

        DynamicFactory.get('issueTrackerRsc', 'getIssueTrackers')().then(
          function (result) {
            if (result) {
              vm.issueTrackers = result;
              resolve(vm.issueTrackers);
            }
          },
          function (err) {
            console.log('Problem z pobraniem listy modułów do śledzenia zgłoszeń');
            reject(undefined);
          });
      });
    }

    function getIssueTrackerConfig() {
      return $q(function (resolve, reject) {

        DynamicFactory.get('issueTrackerRsc', 'getIssueTrackerConfig')().then(
          function (result) {
            if (result)
              resolve(result);
          },
          function (err) {
            console.log('Problem z pobraniem konfiguracji modułu do śledzenia zgłoszeń');
            reject(undefined);
          });
      });
    }

    function updateIssueTrackerConfig(configuration) {
      return $q(function (resolve, reject) {
        DynamicFactory.get('issueTrackerRsc', 'setIssueTrackerConfig')(configuration).then(
          function (result) {
            resolve(result);
          },
          function (err) {
            console.log('Problem z zapisem/aktualizacją konfiguracji modułu do śledzenia zgłoszeń');
            reject(err);
          });
      });
    }

    function saveUserCredential(userCredential) {
      $localStorage.userCredential = userCredential;
    }

    function getUserCredential() {
      if ($localStorage.userCredential &&
        $localStorage.userCredential.userId == SessionManager.getUser().userId) {
        return $localStorage.userCredential;
      } else {
        return undefined;
      }
    }

    return vm;
  }
})();

-function () {
  'use strict';
  angular
    .module('contactcenter.profilemanagement')
    .component('consultantServices', {
        templateUrl: 'app/main/contactcenter/dashboard/profilemanagement/components/consultantservices/consultantservices.html',
        require: {
          tripleView: '^tripleView'
        },
        bindings: {},
        controllerAs: 'vm',
        controller: 'consultantServicesCtrl'
      }
    ).controller('consultantServicesCtrl',
    function controller(DynamicFactory,headerConfig) {
      var vm = this; // jshint ignore:line

      vm.$onInit=onInit;

      function onInit() {
        vm.myServiceList=[];
        vm.navBarConfig = headerConfig.navBar;
        DynamicFactory.get('servicesRsc','getConsultantServices')().then(function (data) {
          vm.myServiceList=data;
        },function (err) {
          console.log(err);
        });

      }


    });
}();

/**
 * Created by kosski on 08.09.2016.
 */
+function () {

  angular.module('contactcenter.profilemanagement').component('comunnicatorConfig', {
    templateUrl: 'app/main/contactcenter/dashboard/profilemanagement/components/communicatorconfig/commconfig.html',
    controllerAs: 'vm',
    require: {
      tripleView: '^tripleView'
    },
    controller: controller
  });
  /** @ngInject */
  function controller(CommunicatorConfigRsc, toastService, $translate, SessionManager, $scope) {
    'use strict';
    var vm = this;

    vm.saveChanges = saveChanges;
    vm.changeInUse = changeInUse;
    vm.$postLink = postLink;
    vm.$onInit = onInit;

    function onInit() {
      vm.tempaltesData = {
        communicator: []
      };

      vm.templateCommunicatorSelection = {
        oldTemplateId: undefined,
        newTemplateId: undefined
      };


      registerEvent();
    }

    function registerEvent() {
      vm.tripleView.addMenuItem({
        order: 20,
        name: 'Zapis',
        iconSrc: 'assets/icons/triple-view/zapisz.png',
        func: function () {
          saveChanges();
        }
      });

    }

    function postLink() {
      CommunicatorConfigRsc.getCommunicatorTemplates().then(function (data) {

        // allowedForCommunicator

        angular.forEach(data, function (e) {

          if (e.allowedForCommunicator) {
            e.markup = '<' + e.name + ' setting-Mode="true" ></' + e.name + '>';
            vm.tempaltesData.communicator.push(e);
          }
        });
      }, function (err) {
        toastService.showToast($translate.instant('COMMUNICATOR_CONFIG.DATA_LOADING_ERROR'), {
          type: 'error',
          duration: 500
        });
      });
    };


    function saveChanges() {
      if (vm.templateCommunicatorSelection.oldTemplateId !== vm.templateCommunicatorSelection.newTemplateId) {
        CommunicatorConfigRsc.changeCommunicatorTemplateInUse(vm.templateCommunicatorSelection.oldTemplateId, vm.templateCommunicatorSelection.newTemplateId).then(function (data) {

          // CommunicatorConfigRsc.changeCommunicatorTemplateInUse(oldIdInUsede, template.id).then(function (data) {}
          //czyścimy zmienne session
          SessionManager.clearCommunicatorSessionData();

          toastService.showToast($translate.instant('COMMUNICATOR_CONFIG.SAVE_SUCCESS'), 'success',4);
        }, function (err) {
          toastService.showToast($translate.instant('COMMUNICATOR_CONFIG.SAVE_FAIL'), 'error',4);
          console.log(err);
        });
      }

    };

    function changeInUse(template) {
      var list =   vm.tempaltesData.communicator;
      var templeSelection = vm.templateCommunicatorSelection;


      if (template.inUse === false) {
        templeSelection.newTemplateId = template.id;
        angular.forEach(list, function (e) {
          if (e.inUse === true) {
            templeSelection.oldTemplateId = e.id;
            e.inUse = false;
          }
          else {
            if (e.id === template.id) {
              e.inUse = true;
            }
          }
        });
      }
    }

  }


}();

- function () {
  'use strict';
  angular
    .module('contactcenter.profilemanagement')
    .component('billingData', {
      templateUrl: 'app/main/contactcenter/dashboard/profilemanagement/components/billdata/billdata.html',
      require: {
        tripleView: '^tripleView'
      },
      controllerAs: 'vm',
      controller: controller
    });

  function controller(DynamicFactory, tripleviewService, toastService, $rootScope, SessionManager, authRolesConst) {
    var vm = this; // jshint ignore:line

    //   vm.getlangs = getlangs;
    vm.saveChanges = saveChanges;
    // vm.$OnChanges = OnChanges;
    vm.$onInit = onInit;

    function onInit() {
      vm.SessionManager = SessionManager;
      vm.authRolesConst = authRolesConst;
      vm.ConsultantData = null;
      // getlangs();
      DynamicFactory.get('partnerRsc', 'getPartner')().then(function (data) {
        if (data) {
          data.subHeader = data.companyName ? data.companyName : '';
          data.photoProp = 'logoUrl';
          data.avatarCallback = changeLogo;
          tripleviewService.sidenavData = vm.ConsultantData = data;
          // onReady();
        }
      }, function (errr) {

      });
      registerEvent();
      vm.formDisabled =SessionManager.isConsultant();

    }

    function registerEvent() {
      vm.tripleView.addMenuItem({
        order: 20,
        name: 'Zapis',
        iconSrc: 'assets/icons/triple-view/zapisz.png',
        // unremovable: true,
        func: function () {
          console.log(vm.userData); // 'Data to send'
          saveChanges();
        }
      });
    }


    function changeLogo(url) {
      vm.ConsultantData.logoUrl = url;
    }

    function saveChanges() {
      DynamicFactory.get('partnerRsc', 'updatePartner')(vm.ConsultantData).then(function (suc) {
        if (vm.saveMail)
          vm.saveMail();
        toastService.showToast('Pomyślnie zapisano zmiany.', 'success', 4);
      }, ErrorFunc);
    }



    function ErrorFunc(err) {
      alert('error');
      toastService.showToast('Nie udało się zapisać zmian.', 'error', 4);
    }
  }
}();

/**
 * Created by kosski on 08.09.2016.
 */
+function () {
  'use strict';
  angular.module('contactcenter.profilemanagement').component('categories', {
    templateUrl: 'app/main/contactcenter/dashboard/profilemanagement/components/categories/categories.html',
    controllerAs: 'vm',
    require: {
      tripleView: '^tripleView'
    },
    controller: controller
  });


  /** @ngInject */
  function controller(SessionManager, toastService, $translate, DynamicFactory, $log) {
    var vm = this;

    vm.saveCategory = saveCategory;
    vm.removeFromGroup = removeFromGroup;
    vm.getData = getData;
    vm.$onInit = onInit;

    function onInit() {
      vm.categoryList = [];
      vm.queryFilter = "";
      vm.CurrentUser = SessionManager.getUser();
      getData();
      registerEvent();
    }

    function registerEvent() {
      vm.tripleView.addMenuItem({
        order: 20,
        name: 'Zapis',
        iconSrc: 'assets/icons/triple-view/zapisz.png',
        func: function () {
          saveCategory();
        }
      });
    }

    function getData() {
      DynamicFactory.get('CategoriesRsc', 'getCategories')(vm.CurrentUser.portalId).then(function (data) {
        vm.categoryList = data;
        for (var i = vm.categoryList.length - 1; i >= 0; i--) {
          if (vm.categoryList[i].active === 1 && vm.categoryList[i].main === 0) {
            vm.categoryList[i].inSelectedGroup = true;
          }
          else if (vm.categoryList[i].active === 1 && vm.categoryList[i].main === 1) {
            vm.categoryList[i].inMainGroup = true;
          }
        }
        toastService.showToast($translate.instant('CATEGORIES.LOADED'), 'warn',4);
      }, function (e) {
        vm.categoryList = [];
        $log.error(e);
        toastService.showToast($translate.instant('CATEGORIES.NO_LOADED'), 'error',4);
      });
    }


    function saveCategory() {
      var main = [];
      var selectedL = [];
      angular.forEach(vm.categoryList, function (e) {
        if (e.inMainGroup) {
          main.push(e.id.toString());
        }
        else if (e.inSelectedGroup) {
          selectedL.push(e.id.toString());
        }
      });
      var dataToSend = {
        'Chosen': selectedL,
        'Main': main
      };
      DynamicFactory.get('CategoriesRsc', 'addCategories')(dataToSend).then(function (data) {
        toastService.showToast($translate.instant('CATEGORIES.SAVE_SUCCESS'), 'success',4);
      }, function (e) {
        $log.error(e);
        toastService.showToast($translate.instant('CATEGORIES.NO_ADDED'), 'error',4);
      });
    };
    function removeFromGroup(category) {
      category.inMainGroup = false;
      category.inSelectedGroup = false;
    }


  }

}();

(function () {
  'use strict';
  angular
    .module('contactcenter.profilemanagement')
    .component('settingsBasic', {
      templateUrl: 'app/main/contactcenter/dashboard/profilemanagement/components/basic/basic.html',
      controllerAs: 'vm',
      controller: controller
    });

  /** @ngInject */
  function controller(DynamicFactory, SessionManager, FileUploader, toastService, tripleviewService, $state) {
    var vm = this; // jshint ignore:line
    // vm.getUser = getUser;
    vm.selectedFileChanged = selectedFileChanged;
    vm.setAvatar = setAvatar;
    vm.$onChanges = OnChanges;
    vm.$doCheck = doCheck;
    vm.$onInit = onInit;

    function onInit() {
      // vm.getUser();
      // getPhoto();
    }

    function OnChanges(changesObj) {
      console.log(changesObj);
    }

    function doCheck() {
      if (vm.templateKey !== $state.params.templateKey) {
        vm.templateKey = $state.params.templateKey;
      }
      if (!angular.equals(tripleviewService.sidenavData,vm.sidenavData)) {
        vm.sidenavData  = tripleviewService.sidenavData;
      }
    }

    function changeTemplate() {
      DynamicFactory.get('templatesRsc', 'GetTemplate')(vm.templateKey)
        .then(function (result) {
          //debugger;
          vm.template = result;
        });
    }

    function selectedFileChanged(result) {
      if (angular.isDefined(result) && result.length > 1) {
        DynamicFactory.get('profileRsc', 'PutConsultantPhoto')({
          Photo: result
        }).then(function (suc) {
          SessionManager.updateAvatarURL(result);
          toastService.showToast('Pomyślnie zapisano zmiany.', 'success',4);
        }, ErrorFunc);
      }
    }

    function setAvatar(url) {
      vm.photo.croppedImage = url;
    }

    // function getUser() {
    //   DynamicFactory.get('profileRsc', 'getUser')()
    //     .then(function (data) {
    //       vm.userData = data;
    //       getPhoto();
    //     });
    // }

    // function getPhoto() {
    //   DynamicFactory.get('profileRsc', 'GetMyConsultant')().then(function (data) {
    //     if (data) {
    //       tripleviewService.sidenavData.photoUrl = data.photoUrl;
    //     }
    //   }, function (errr) {

    //   });
    // }

    function ErrorFunc(err) {
      alert('error');
      toastService.showToast('Nie udało się zapisać zmian', 'error',4);
    }
  }
})();

/**
 * Created by kosski on 08.09.2016.
 */
+ function () {
  'use strict';

  angular.module('contactcenter.profilemanagement').component('areas', {
    templateUrl: 'app/main/contactcenter/dashboard/profilemanagement/components/areas/areas.html',
    controllerAs: 'vm',
    require: {
      tripleView: '^tripleView'
    },
    controller: controller
  });
  /** @ngInject */
  function controller(SessionManager, toastService, $translate, $log, DynamicFactory) {
    var vm = this;
    vm.CurrentUser = {};
    vm.areaList = [];
    vm.queryFilter = "";
    vm.getData = function () {
      DynamicFactory.get('AreasRsc', 'getAreas')(vm.CurrentUser.portalId).then(function (data) {
        vm.areaList = data;
        for (var i = vm.areaList.length - 1; i >= 0; i--) {
          if (vm.areaList[i].active === 1 && vm.areaList[i].main === 0) {
            vm.areaList[i].inSelectedGroup = true;
          } else if (vm.areaList[i].active === 1 && vm.areaList[i].main === 1) {
            vm.areaList[i].inMainGroup = true;
          }
        }

        toastService.showToast($translate.instant('AREAS.LOADED'), 'success',4);
      }, function (e) {
        vm.areaList = [];
        $log.error(e);
        toastService.showToast($translate.instant('AREAS.NO_LOADED'), 'error',4);
      });

    };
    vm.saveArea = function () {
      var main = [];
      var selectedL = [];

      angular.forEach(vm.areaList, function (e) {
        if (e.inMainGroup) {
          main.push(e.id.toString());
        } else if (e.inSelectedGroup) {
          selectedL.push(e.id.toString());
        }
      });


      var dataToSend = {
        'PortalId': vm.CurrentUser.portalId,
        'Chosen': selectedL,
        'Main': main
      };

      DynamicFactory.get('AreasRsc', 'addAreas')(dataToSend).then(function (data) {
        toastService.showToast($translate.instant('AREAS.SAVE_SUCCESS'), 'success',4);
      }, function (e) {
        $log.error(e);
        toastService.showToast($translate.instant('AREAS.NO_ADDED'), 'error',4);
      });
    };

    vm.removeFromGroup = function (area) {
      area.inMainGroup = false;
      area.inSelectedGroup = false;
    };

    vm.$onInit = function () {
      vm.CurrentUser = SessionManager.getUser();
      vm.getData();
      registerEvent();
    };

    function registerEvent() {
      vm.tripleView.addMenuItem({
        order: 20,
        name: 'Zapis',
        iconSrc: 'assets/icons/triple-view/zapisz.png',
        func: function () {
          vm.saveArea();
        }
      });
    }

  }
}();

/**
 * Created by kosski on 08.09.2016.
 */
+ function () {
  angular.module('contactcenter.dashboard', []).config(config);

  /** @ngInject */
  function config($stateProvider,MenuItemsProvider) {

    //     !!!!!!!!! Menu przeniesione do profilemanagement !!!!!!!!!!!!!!!

    // var menuItems = MenuItemsProvider.initMenuItem('DASHBOARD')
    //   .addMenuItem('DASHBOARD.LANGUAGE', {
    //     iconSrc: 'assets/icons/triple-view/glosowe.png',
    //     // component:'nested-menu'
    //     component: 'option-folder'
    //   })
    //   .addMenuItem('DASHBOARD.LANGUAGE.PL', {
    //     state: 'app.contactcenter_reports.reportStatsCalls',
    //     iconSrc: 'assets/icons/reports/list.svg'
    //   })
    //   .addMenuItem('DASHBOARD.LANGUAGE.ENG', {
    //     state: 'app.contactcenter_reports.reportStatsCallsPerConsultant',
    //     iconSrc: 'assets/icons/reports/perConsultant.svg'
    //   });


    $stateProvider.state('app.contactcenter_dashboard', {
      url: '/dashboard',
      stateTranslationName: 'DASHBOARD',
      hideTaHeader:true,
      params:{
        needHelp: null
      },
      views: {
        'content@app': {
          template: '<dashboard></dashboard>'
        }
      },
      resolve: {},
      bodyClass: 'dashboard'
    }).state('app.contactcenter_dashboard.party', {
      url: '/party',
      params: {},
      hideTaHeader:true,
      views: {
        'content@app': {

          template: '<party></party>'
        }
      },
      resolve: {
      },
      bodyClass: 'party'
    })
    .state('app.contactcenter_dashboard.partyroom', {
      url: '/party/:room/:preview',
      params: {},
      hideTaHeader:true,
      views: {
        'content@app': {

          template: '<party-room></party-room>'
        }
      },
      resolve: {
      },
      bodyClass: 'party'
    });
  }
}();

(function () {
    'use strict';

    angular
        .module('contactcenter.dashboard')
        .component('msmRow', {
            templateUrl: 'app/main/contactcenter/dashboard/component/messagessessionsmonitoring/msmrow/msmrow.html',
            controllerAs: 'vm',
            controller: msmRowController,
            bindings: {
                session: '=',
                sessionStatus: '<'
            }
        })

    /* @ngInject */
    function msmRowController($interval, $timeout, confirmDialogService, SessionManager, DynamicFactory, $mdDialog) {
        var vm = this;

        vm.timerInterval = undefined;
        vm.userSession = SessionManager.getUser();

        vm.$onInit = onInit;
        vm.$onDestroy = onDestroy;
        vm.$onChanges = onChanges;
        vm.closeSession = closeSession;
        vm.forwardSession = forwardSession;
        // $postLink


        function onInit() {
            // $timeout(function () {
            //     startTimer();
            // }, 100);
        }

        function onChanges(changesObj) {
            console.log('msmRowController - changes: ', vm.session);
        }

        function startTimer() {
            console.log('Timer STARTED for session: ' + vm.session.sessionId);
            vm.timerInterval = $interval(function () {
                // console.log('Timer STARTED for session '+vm.session.sessionId+' insertionTimeDif: '+vm.session.insertionTimeDif);
                if (vm.session.insertionTimeDif !== undefined && vm.session.insertionTimeDif !== null) {
                    vm.session.insertionTimeDif++;
                }
                if (vm.session.finished) {
                    stopTimer();
                }
            }, 1000)
        }

        function stopTimer() {
            $interval.cancel(vm.timerInterval);
            vm.timerInterval = undefined;
            //console.log('Timer STOPED for session: '+vm.session.sessionId);
        }

        function closeSession(session, event) {
            console.log("TCL: closeSession -> session", session);
            event.stopPropagation();
            confirmDialogService
                .showDefaultConfirm([{
                    token: "translate",
                    value: "CONFIRM_LOGOUT"
                },
                {
                    token: "title",
                    value: 'Czy napewno chcesz zamknąć sesje ID=' + session.sessionId + ' ?'
                }
                ])
                .then(
                    function () {
                        sendCleaningMessage(session);
                    },
                    function (err) { }
                );
        }

        function sendCleaningMessage(session) {
            var message = {
                // portalId: vm.userSession.portalId,
                // portalUserID: vm.templateData.portalUserId,
                // prefix: vm.templateData.prefixID,
                // operator: vm.templateData.operator,
                // la: vm.templateData.la,
                // params: vm.templateData.params,
                // //replyToGuid: vm.templateData.direction === 'I' ? vm.templateData.guid : null,
                // callID: vm.templateData.callid,
                // serviceOrderId: vm.templateData.serviceOrderId,
                //attachments: vm.selectedAttachmentList,
                // attachmentUrls: vm.attachmentUrls,
                //fbMessengerID: vm.templateData.fbMessengerID,
                // fbCommentID: vm.templateData.fbCommentID,
                // fbCommentParentID: vm.templateData.fbCommentParentID,
                // communictorType: vm.templateData.communictorType, // ??
                // timeToSend: vm.templateData.timeToSend,//??

                serviceId: session.serviceId,
                contactID: session.contactId,
                partnerID: session.partnerId,
                titile: '',
                type: 'A',
                body: '',
                sessionId: session.sessionGuid,
                direction: 'O',
                authorPhotoUrl: vm.userSession.userImg,
                authorName: vm.userSession.username,
                MMSUrls: [],
                cleningActionReason: 110 //manager
            };

            DynamicFactory.get('ChatPartRsc', 'sendCleaningMessage')(message).then(
                function (data) {

                },
                function (err) {
                    console.log(err);
                }
            );
        }

        function onDestroy() {
            stopTimer();
        }

        function forwardSession(sessionData, event) {
            console.log("TCL: forward -> session", sessionData);
            event.stopPropagation();
            $mdDialog.show({
              locals: {
                session: sessionData
              },
              template: '<md-dialog-content><forward-session session="vm.session"></forward-session></md-dialog-content>',
              controller: function (session) {
                this.session = session;
              },
              controllerAs: 'vm',
              parent: angular.element(document.body),
              targetEvent: event,
              clickOutsideToClose: true//,
              // onRemoving: function (event, removePromise) {
              //   console.log(event, removePromise);
              // }
            })
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('contactcenter.dashboard')
        .component('msmHeader', {
            templateUrl: 'app/main/contactcenter/dashboard/component/messagessessionsmonitoring/msmheader/msmheader.html',
            controllerAs: 'vm',
            controller: msmHeaderController
        })

    /* @ngInject */
    function msmHeaderController(msmGlue,msmFilterConst) {
        var vm = this;
        vm.msmGlue = msmGlue
        vm.msmFilterConst=msmFilterConst;


        //func
        vm.setCurrentFilterMode=setCurrentFilterMode;





        function setCurrentFilterMode(mode){
            msmGlue.setCurrentFilterMode(mode);
        }


    }

})();
(function () {
    'use strict';

    angular
        .module('contactcenter.dashboard')
        .component("msmTable", {
            templateUrl: 'app/main/contactcenter/dashboard/component/messagessessionsmonitoring/msmtable/msmtable.html',
            controllerAs: 'vm',
            controller: msmTableController
        });

    /* @ngInject */
   function msmTableController(msmGlue, msmWebSocketMenager) {
        var vm=this;
        vm.msmGlue=msmGlue;
        vm.msmWebSocketMenager = msmWebSocketMenager;
        vm.showDetails = showDetails;

        vm.msmGlue.currentSession = null;
        vm.openClick = 0;
        vm.$onInit=onInit;
        vm.$onDestroy = onDestroy;



        function onInit(){

            console.log('msmTable onInit');
            msmWebSocketMenager.init();

        }

        function showDetails(session){
            console.log('showDetails - session: ',session);
            vm.msmGlue.currentSession = angular.copy(session);
            vm.openClick++;
        }

        function onDestroy(){
            console.log('msmTable onDestroy');
            msmWebSocketMenager.Destroy(); 
        }
        
    }

})();



(function () {
    'use strict';

    angular
        .module('contactcenter.dashboard')
        .component('msmChat', {
            templateUrl: 'app/main/contactcenter/dashboard/component/messagessessionsmonitoring/msmchat/msmchat.html',
            controllerAs: 'vm',
            controller: msmRowDetailController,
            bindings: {
                session: '=',
                numerAll: '<'
            }
        })

    /* @ngInject */
    function msmRowDetailController($interval, $timeout, templateData, communicatorService) {
        var vm = this;


        vm.$onInit = onInit;
        vm.$onDestroy = onDestroy;
        vm.$onChanges = onChanges;
        vm.templateData = null;
        vm.closeChat=closeChat;
        // $postLink


        function onInit() {
            
        }

        function closeChat(){
            vm.session=undefined;
        }

        function onChanges(changesObj){
			console.log('msmRowDetailController - changes: ', changesObj);
            templateData.clearData();

            templateData.msisdn = "";// data.msisdn;??
            templateData.reservedNumber = templateData.msisdn * 1 === 1;
            templateData.currentServiceId = vm.session.serviceId;
            //templateData.callid = data.callID;
            templateData.contactId = vm.session.contactId;
            // templateData.smsServiceId = smsServiceId;
            // templateData.ivrServiceId = ivrServiceId;
            // templateData.chatServiceId = chatServiceId;
            // templateData.facebookServiceId = facebookServiceId;
            // templateData.emailServiceId = emailServiceId;
            // templateData.callbackServiceId = callbackServiceId;
            templateData.sessionId =  vm.session.sessionGuid;
            //templateData.sessionType = type;
            //templateData.sessionServiceType = data.type;
            //templateData.sessionReservedDate = data.reservedDate;
            templateData.finished = vm.session.finished;
            vm.templateData = templateData;
            $timeout(function () {
                communicatorService.runChat();
            }, 100);
        }

        function onDestroy(){
        }
    }

})();
(function () {
  'use strict';

  angular.module('contactcenter.dashboard').component('consultantsPreviewDetails', {
    templateUrl: 'app/main/contactcenter/dashboard/component/consultantsPreview/consultantsPreviewDetails/consultantsPreviewDetails.html',
    bindings: {
      consultant: '=',
      callStatus: '<',
      selected: '<',
      // audio: '<',
      // currentlyPlayingBridgeId: '<',
      // onPlayback: '&',
      onEavesdropping: '=',
      sendHelp: '=',
      needHelp: '=',
      help: '='
    },
    controllerAs: 'vm',
    controller: ConsultantStatisticsDetails
  });

  function ConsultantStatisticsDetails(DynamicFactory, $q, EVENT_TYPE, consts, confirmDialogService, WebRTCService, communicatorService) {
    var vm = this;
    vm.kickConsultant = kickConsultant;
    vm.startPlayback = startEavesdropping;
    vm.startEavesdropping = startEavesdropping;
    vm.loadConsultantPhones =loadConsultantPhones;
    vm.activateRemote = activateRemote;
    vm.helpStop = helpStop;
    vm.$onChanges = OnChange;
    vm.$onInit = init;
    vm.breakConsultantCall=breakConsultantCall;


    function OnChange(changesObj) {
      if (changesObj.callStatus.currentValue !== undefined) {
        // if (vm.audio && changesObj.callStatus.currentValue === 1)
        //   loadAudio();
        // else {
        // }
        if (vm.audio && !vm.audio.paused) {
          pauseAudio();
        }
      }
    }

    function init() {
      setAudioPlayer();
      // if (vm.consultant.callStatus == 1) {
      //   loadAudio();
      // } else
      // if (vm.consultant.bridgeID && vm.consultant.callStatus == 0) {
      //   loadAudio();
      // }
    }

    // function startPlayback() {
    //   vm.onPlayback({
    //     consultant: vm.consultant
    //   });
    // }


    // function startEavesdroppingOld() {
    //   vm.onEavesdropping({
    //     consultant: vm.consultant
    //   });
    // }

    function startEavesdropping() {
      if (vm.audio.paused) {
        vm.onEavesdropping(pauseAudio);
        loadAudio();
      } else {
        vm.onEavesdropping();
        // pauseAudio();
      }
    }

    function loadAudio() {
      // var callUrl = buildCallUrl(vm.consultant.bridgeID);
      // vm.audio.src = callUrl;
      // vm.audio.load();
      vm.loading = true;

      getCallURL(vm.consultant.callStatus == 1 ? EVENT_TYPE.EAVESDROPPING : EVENT_TYPE.PLAYBACK, vm.consultant.bridgeID).then(function (callUrl) {
        vm.audio.src = callUrl;
        vm.audio.load();
      }, function (error) {
        console.log("Wystąpił problem z pobraniem url nagrania.", error);
      });
    }

    // function loadPlayback() {
    //   getCallURL(EVENT_TYPE.PLAYBACK, vm.consultant.bridgeID).then(function (callUrl) {
    //     // var callUrl = buildCallUrl(consultant.bridgeID);

    //     // if (vm.audio.currentSrc == undefined) {
    //     //   vm.currentlyPlayingBridgeId = consultant.bridgeID;
    //     //   vm.audio.src = callUrl;
    //     //   vm.audio.play();
    //     // } else {
    //     //   if (vm.audio.currentSrc == callUrl) {
    //     //     if (vm.audio.paused) {
    //     //       vm.audio.play();
    //     //     } else {
    //     //       vm.audio.pause();
    //     //       vm.currentlyPlayingBridgeId = undefined;
    //     //     }
    //     //   } else {
    //     //     vm.currentlyPlayingBridgeId = consultant.bridgeID;
    //     vm.audio.src = callUrl;
    //     vm.audio.load();
    //     // vm.audio.play();
    //     // }
    //     // }
    //   }, function (error) {
    //     console.log("Wystąpił problem z pobraniem url nagrania.", error);
    //   });
    // }

    function playAudio() {
      vm.audio.play();
    }

    function pauseAudio() {
      vm.audio.pause();
    }

    // function startEavesdropping(consultant) {
    //   // getCallURL(EVENT_TYPE.EAVESDROPPING, consultant.bridgeID).then(function (callUrl) {
    //   var callUrl = buildCallUrl(consultant.bridgeID);
    //   if (vm.audio.currentSrc == undefined) {
    //     vm.currentlyPlayingBridgeId = consultant.bridgeID;
    //     vm.audio.src = callUrl;
    //     vm.audio.play();
    //   } else {
    //     if (vm.audio.currentSrc == callUrl) {
    //       if (vm.audio.paused) {
    //         vm.currentlyPlayingBridgeId = consultant.bridgeID;
    //         vm.audio.play();
    //       } else {
    //         vm.audio.pause();
    //         vm.currentlyPlayingBridgeId = undefined;
    //       }
    //     } else {
    //       vm.currentlyPlayingBridgeId = consultant.bridgeID;
    //       vm.audio.src = callUrl;
    //       vm.audio.load();
    //       vm.audio.play();
    //     }
    //   }
    //   // }, function (error) {
    //   //   console.log("Wystąpił problem z pobraniem URL rozmowy.", error);
    //   // });
    // }



    //   .addEventListener('waiting', function () {
    //     alert('Buffering');
    // };

    // function startPlayback(consultant) {
    //   getCallURL(EVENT_TYPE.PLAYBACK, consultant.bridgeID).then(function (callUrl) {
    //     // var callUrl = buildCallUrl(consultant.bridgeID);

    //     if (vm.audio.currentSrc == undefined) {
    //       vm.currentlyPlayingBridgeId = consultant.bridgeID;
    //       vm.audio.src = callUrl;
    //       vm.audio.play();
    //     } else {
    //       if (vm.audio.currentSrc == callUrl) {
    //         if (vm.audio.paused) {
    //           vm.audio.play();
    //         } else {
    //           vm.audio.pause();
    //           vm.currentlyPlayingBridgeId = undefined;
    //         }
    //       } else {
    //         vm.currentlyPlayingBridgeId = consultant.bridgeID;
    //         vm.audio.src = callUrl;
    //         vm.audio.load();
    //         vm.audio.play();
    //       }
    //     }
    //   }, function (error) {
    //     console.log("Wystąpił problem z pobraniem url nagrania.", error);
    //   });
    // }


    function setAudioPlayer() {
      vm.audio = new Audio();

      vm.audio.onerror = function () {
        vm.audio.pause();
        vm.audio.currentTime = 0.0;
        setTimeout(function () {
          if (vm.consultant.callStatus == 1) {
            loadAudio();
          }
        }, 5000);
        // toastService.showToast('Nie powiodło się odtworzenie nagrania', 'error', 3);
      };
      vm.audio.onloadstart = function () {
        vm.loading = true;
        console.log('consultantsPreviewDetails | audio buffering!');
      };
      vm.audio.onloadeddata = function () {
        vm.loading = false;
        // setTimeout(function () {
        //   vm.audio.currentTime = vm.audio.buffered.end(0);
        // }, 500);
        if (vm.consultant.callStatus == 1) {
          setTimeout(function () {
            vm.audio.currentTime = vm.audio.buffered.end(0);
          }, 500);
        }
        playAudio();
        // }
        console.log('consultantsPreviewDetails | audio ready to play!', vm.audio.buffered.end(0), vm.audio.seekable, vm.audio.buffered);
      };
      vm.audio.oncanplay = function () {
        console.log('consultantsPreviewDetails | oncanplay!');
      };
    }

    function buildCallUrl(uuid) {
      return 'http://fs02.teleaudio.pl:58008/' + uuid + '.mp3';
    }

    function getCallURL(eventType, bridgeId) {
      return $q(function (resolve, reject) {
        if (eventType == EVENT_TYPE.EAVESDROPPING) {
          DynamicFactory.get('onlineCalls', 'eavesdropp')(bridgeId).then(function (callUrl) {
            resolve(callUrl.uri);
          }, function (error) {
            console.log(error);
            reject(error);
          });
        } else {
          resolve(consts.recordings + bridgeId);
        }
      });
    }

    function helpStop() {
      vm.help.active = false;
      vm.consultant.userHelp = undefined;
      // communicatorService.removeSession(vm.consultant.callID, 'I');
      // WebRTCService.disconnectCall('ev/' + vm.consultant.callID);
    }

    function kickConsultant() {
      confirmDialogService
        .showDefaultConfirm([{
            token: "translate",
            value: "CONFIRM_LOGOUT"
          },
          {
            token: "title",
            value: 'Czy napewno chcesz wylogować tego użytkownika?'
          }
        ])
        .then(
          function () {
            DynamicFactory.get('ConsultantsRsc', 'kickConsultant')(vm.consultant.consultantID).then(function (result) {}, function (err) {})
          },
          function (err) {}
        );
    }


    function breakConsultantCall() {

      confirmDialogService
        .showDefaultConfirm([{
            token: "translate",
            value: "CONFIRM_LOGOUT"
          },
          {
            token: "title",
            value: 'Czy napewno chcesz rozłaczyć połączenie tego użytkownika?'
          }
        ])
        .then(
          function () {
            DynamicFactory.get('OuterPaymentRsc', 'disconnect')(vm.consultant.callID,vm.consultant.bridgeID).then(function (result) {}, function (err) {})
          },
          function (err) {}
        );
    }

    function loadConsultantPhones(){
      if(!vm.phones){
        vm.phonesLoading =true;
        DynamicFactory.get('ConsultantsRsc', 'getPhones')(vm.consultant.consultantID).then(function (result) {
          vm.phonesLoading = false;
          vm.phones =  _.filter(result, function(o){
            return o.typeId == 1 || o.typeId == 2  ;
          });
        }, function (err) {});
      }
    }

    function activateRemote(phone){
      DynamicFactory.get('ConsultantsRsc', 'activateRemote')(vm.consultant.consultantID,phone.phone).then(function (result) {
        // vm.phones = undefined;
      }, function (err) {});
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('contactcenter.dashboard')
    .filter('timer', timer);

  function timer() {
    return function (period,byDots) {
      if (period == undefined) return '';

      var hours = Math.floor((period % (60 * 60 * 24)) / (60 * 60));
      var minutes = Math.floor((period % (60 * 60)) / 60);
      var seconds = Math.floor(period % 60);

      return (hours > 0 ? hours + (byDots ? ':' :"h ") : '') + (minutes > 0 ? minutes + (byDots ? ':' :"m ") : '') + seconds + (byDots ? '' :"s");
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('contactcenter.dashboard')
    .filter('statusIconStyle', statusIconStyle);

  /* @ngInject */
  function statusIconStyle() {
    return function (statusId) {
      if (statusId == undefined) return '';

      var statusIconStyle;

      switch (statusId) {
        case 0:
          statusIconStyle =  '#616161'; //nie aktywny
          break;
        case 1:
          statusIconStyle = '#4CAF50'; // aktywny
          break
        case 2:
          statusIconStyle = '#FFC107'; // przerwa
          break;
      }

      return statusIconStyle;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('contactcenter.dashboard')
    .filter('statusIcon', statusIcon);

  /* @ngInject */
  function statusIcon() {
    return function (statusId) {
      if (statusId == undefined) return '';

      var statusIcon;

      switch (statusId) {
        case 0:
          statusIcon = 'icon-checkbox-blank-circle-outline'; //nie aktywny
          break;
        case 1:
          statusIcon = 'icon-checkbox-marked-circle'; // aktywny
          break
        case 2:
          statusIcon = 'icon-clock' // przerwa
          break;
      }

      return statusIcon;
    }
  }
})();

(function () {
    'use strict';
  
    angular.module('contactcenter.dashboard').component('consultantOcupation', {
      templateUrl: 'app/main/contactcenter/dashboard/component/consultantsPreview/consultantOcupation/consultantOcupation.html',
      bindings: {
        consultant: '=',
        prevServiceId: '=',
        callStatus: '<',
        selected: '<',

        onEavesdropping: '=',
        sendHelp: '=',
        needHelp: '=',
        help: '='
      },
      controllerAs: 'vm',
      controller: ConsultantOcupation
    });
  
    function ConsultantOcupation(DynamicFactory, $q, EVENT_TYPE, consts, confirmDialogService, msmGlue) {
      var vm = this;

      vm.msmGlue = msmGlue;
      vm.kickConsultant = kickConsultant;

      vm.upgradeLevel = upgradeLevel;
      vm.downgradeLevel = downgradeLevel;

      vm.startPlayback = startEavesdropping;
      vm.startEavesdropping = startEavesdropping;
      vm.loadConsultantPhones =loadConsultantPhones;
      vm.activateRemote = activateRemote;
      vm.helpStop = helpStop;
      vm.$onChanges = OnChange;
      vm.$onInit = init;
      vm.breakConsultantCall=breakConsultantCall;
  
  
      function OnChange(changesObj) {
        if (changesObj.callStatus &&  changesObj.callStatus.currentValue !== undefined) {
          if (vm.audio && !vm.audio.paused) {
            pauseAudio();
          }
        }
      }
  
      function init() {
        setAudioPlayer();
      }

      function startEavesdropping() {
        if (vm.audio.paused) {
          vm.onEavesdropping(pauseAudio);
          loadAudio();
        } else {
          vm.onEavesdropping();
          // pauseAudio();
        }
      }
  
      function loadAudio() {
        vm.loading = true;
  
        getCallURL(vm.consultant.callStatus == 1 ? EVENT_TYPE.EAVESDROPPING : EVENT_TYPE.PLAYBACK, vm.consultant.bridgeID).then(function (callUrl) {
          vm.audio.src = callUrl;
          vm.audio.load();
        }, function (error) {
          console.log("Wystąpił problem z pobraniem url nagrania.", error);
        });
      }

      function playAudio() {
        vm.audio.play();
      }
  
      function pauseAudio() {
        vm.audio.pause();
      }
  
      function upgradeLevel () {
        DynamicFactory.get('ConsultantsRsc', 'upgradeLevel')(vm.consultant.service.id, vm.consultant.id)
          .then(function (result) {
            console.log('upgradeLevel:Result ', result );
            vm.msmGlue.updateMonitoringData();
          }, function (err) {});
      }

      function downgradeLevel () {
        DynamicFactory.get('ConsultantsRsc', 'downgradeLevel')(vm.consultant.service.id, vm.consultant.id)
          .then(function (result) {
            console.log('downgradeLevel:Result ', result );
            vm.msmGlue.updateMonitoringData();
          }, function (err) {});
      }

      function setAudioPlayer() {
        vm.audio = new Audio();
  
        vm.audio.onerror = function () {
          vm.audio.pause();
          vm.audio.currentTime = 0.0;
          setTimeout(function () {
            if (vm.consultant.callStatus === 1) {
              loadAudio();
            }
          }, 5000);
          // toastService.showToast('Nie powiodło się odtworzenie nagrania', 'error', 3);
        };
        vm.audio.onloadstart = function () {
          vm.loading = true;
          console.log('consultantsPreviewDetails | audio buffering!');
        };
        vm.audio.onloadeddata = function () {
          vm.loading = false;
          // setTimeout(function () {
          //   vm.audio.currentTime = vm.audio.buffered.end(0);
          // }, 500);
          if (vm.consultant.callStatus == 1) {
            setTimeout(function () {
              vm.audio.currentTime = vm.audio.buffered.end(0);
            }, 500);
          }
          playAudio();
          // }
          console.log('consultantsPreviewDetails | audio ready to play!', vm.audio.buffered.end(0), vm.audio.seekable, vm.audio.buffered);
        };
        vm.audio.oncanplay = function () {
          console.log('consultantsPreviewDetails | oncanplay!');
        };
      }
  
      function buildCallUrl(uuid) {
        return 'http://fs02.teleaudio.pl:58008/' + uuid + '.mp3';
      }
  
      function getCallURL(eventType, bridgeId) {
        return $q(function (resolve, reject) {
          if (eventType == EVENT_TYPE.EAVESDROPPING) {
            DynamicFactory.get('onlineCalls', 'eavesdropp')(bridgeId).then(function (callUrl) {
              resolve(callUrl.uri);
            }, function (error) {
              console.log(error);
              reject(error);
            });
          } else {
            resolve(consts.recordings + bridgeId);
          }
        });
      }
  
      function helpStop() {
        vm.help.active = false;
        vm.consultant.userHelp = undefined;
      }
  
      function kickConsultant() {
        confirmDialogService
          .showDefaultConfirm([{
              token: "translate",
              value: "CONFIRM_LOGOUT"
            },
            {
              token: "title",
              value: 'Czy napewno chcesz wylogować tego użytkownika?'
            }
          ])
          .then(
            function () {
              DynamicFactory.get('ConsultantsRsc', 'kickConsultant')(vm.consultant.id).then(
                function (result) {

                }, 
                function (err) {

                });
            },
              function (err) {
                
              }
          );
      }
  
  
      function breakConsultantCall() {
  
        confirmDialogService
          .showDefaultConfirm([{
              token: "translate",
              value: "CONFIRM_LOGOUT"
            },
            {
              token: "title",
              value: 'Czy napewno chcesz rozłaczyć połączenie tego użytkownika?'
            }
          ])
          .then(
            function () {
              DynamicFactory.get('OuterPaymentRsc', 'disconnect')(vm.consultant.callID,vm.consultant.bridgeID).then(function (result) {}, function (err) {})
            },
            function (err) {}
          );
      }
  
      function loadConsultantPhones(){
        if(!vm.phones){
          vm.phonesLoading =true;
          DynamicFactory.get('ConsultantsRsc', 'getPhones')(vm.consultant.consultantID).then(function (result) {
            vm.phonesLoading = false;
            vm.phones =  _.filter(result, function(o){
              return o.typeId == 1 || o.typeId == 2  ;
            });
          }, function (err) {});
        }
      }
  
      function activateRemote(phone){
        DynamicFactory.get('ConsultantsRsc', 'activateRemote')(vm.consultant.consultantID,phone.phone).then(function (result) {
          // vm.phones = undefined;
        }, function (err) {});
      }
  
    }
  })();
  
/**
 * Created by kosski on 29.03.2017.
 */
(function() {
  "use strict";
  angular.module("optionsMenu", []);
})();

/**
 * Created by kosski on 29.03.2017.
 */
(function () {
  'use strict';

  angular.module('optionsMenu')
    .component('optionFolder', {
      templateUrl: 'app/main/contactcenter/components/optionsmenu/components/optionfolder/optionfolder.html',
      controllerAs: 'vm',
      bindings: {
        arrayStyle: '@',
        menuItem: '<'
      },
      require: {
        optionsMenu: '^^optionsMenu'
      },
      controller: optionFolder
    });

  /** @ngInject */
  function optionFolder($state) {
    var vm = this;

    vm.changeState = changeState;

    vm.$onDestroy = onDestroy;
    vm.$postLink = postLink;
    vm.$onInit = init;
    vm.$onChanges = OnChange;


    function init() {
    }

    function postLink() {
    }

    function OnChange(changesObj){
      var state = $state.get(vm.menuItem.state);

    }

    function changeState($event, menuItem){
      vm.optionsMenu.selectFolder(menuItem.name);
      menuItem.action($event);
    }


    function onDestroy() {

    }



  }

})();

/**
 * Created by kosski on 29.03.2017.
 */
(function () {
  'use strict';

  angular.module('optionsMenu')
    .component('nestedMenu', {
      templateUrl: 'app/main/contactcenter/components/optionsmenu/components/nestedmenu/nestedmenu.html',
      controllerAs: 'vm',
      bindings: {
        arrayStyle: '@',
        menuItem: '<'
      },
      require: {
        optionsMenu: '^^optionsMenu'
      },
      controller: nestedMenu
    });

  /** @ngInject */
  function nestedMenu($state) {
    var vm = this;

    vm.changeState = changeState;

    vm.$onDestroy = onDestroy;
    vm.$postLink = postLink;
    vm.$onInit = init;
    vm.$onChanges = OnChange;

    function init() {
      vm.more=false;
    }

    function postLink() {
      var el=_.find(vm.menuItem.submenu, {isAdditional: true });
      vm.showAdditional=!angular.isUndefined(el);
    }

    function OnChange(changesObj){
      var state = $state.get(vm.menuItem.state);

    }

    function changeState($event, menuItem){
      vm.optionsMenu.selectFolder(menuItem.name);
      menuItem.action($event);
    }


    function onDestroy() {

    }



  }

})();

(function () {
  'use strict';

  angular.module('jira').component('jiraIssue', {
    templateUrl: 'app/main/contactcenter/components/issuetracker/components/jira/jiraissue.html',
    bindings: {
      openIssueDialog: '<',
      issueStatus: '<',
      createIssueDialogParams: '&'
    },
    controllerAs: 'vm',
    controller: JiraIssue
  });

  /* @ngInject */
  function JiraIssue($q, $mdDialog, $filter, $scope, $timeout, $localStorage, toastService, DynamicFactory, jiraService, issueTrackerService) {
    var vm = this;

    vm.$onInit = onInit;

    vm.openIssueDialog = openIssueDialog;
    vm.performAction = performAction;

    vm.jiraService = jiraService;
    vm.getIssueTypesForProject = getIssueTypesForProject;
    vm.updateMessage = updateMessage;
    vm.sendMessage = sendMessage;
    vm.comment;
    vm.answer = answer;
    vm.cancel = cancel;

    function onInit() {
      //integrate with JIRA without reconnection (just reloading resources with access token if access token is available in $localStorage.userCredential)
      jiraService.integrateWithJira(true);
    }

    function performAction() {
      if (vm.openIssueDialog) {
        var userCredential = issueTrackerService.getUserCredential();
        if (!userCredential) {
          jiraService.integrateWithJira().then(function () {
            vm.createIssueDialogParams().then(function (issueDialogParams) {
              vm.issueDialogParams = issueDialogParams;
              if (issueDialogParams.issueId) {
                getIssue(issueDialogParams.issueId);
                vm.uploader = DynamicFactory.get('jiraRsc', 'getUploader')('jira/issue/attachment/' + vm.issueDialogParams.issueId, false);
              } else {
                createIssue();
              }

              openIssueDialog(issueDialogParams);
            });
          }, function (error) {
            console.log('Problem z integracją z JIRA.');
          });
        } else {
          vm.createIssueDialogParams().then(function (issueDialogParams) {
            vm.issueDialogParams = issueDialogParams;
            if (issueDialogParams.issueId) {
              getIssue(issueDialogParams.issueId);
              vm.uploader = DynamicFactory.get('jiraRsc', 'getUploader')('jira/issue/attachment/' + vm.issueDialogParams.issueId, false);
            } else {
              createIssue();
            }

            openIssueDialog(issueDialogParams);
          });
        }
      } else {
        jiraService.integrateWithJira();
      }
    }

    function createIssue() {
      vm.issue = {
        fields: {
          project: {},
          issueType: {}
        }
      };
      vm.issue.fields.summary = vm.issueDialogParams.channelInfo ? vm.issueDialogParams.channelInfo.channelName : '';
      vm.issue.fields.description = vm.issueDialogParams.data ? vm.issueDialogParams.data : '';

      jiraService.getProjects().then(
        function (projects) {
          vm.projects = projects;
          vm.issue.fields.project = projects[0];
          getIssueTypesForProject(vm.issue.fields.project.id);
        });

      vm.channelInfo = vm.issueDialogParams.channelInfo;
      vm.contactId = vm.issueDialogParams.contactId;
      vm.issueMsgDate = vm.issueDialogParams.issueMsgDate;
    }

    function openIssueDialog(params) {

      var replaceContent = [{
          token: 'translate',
          value: 'ISSUE.CONFIRM'
        },
        {
          token: 'title',
          value: params.issueId ? $filter('translate')('MAIL.DETAILS.HEADER.ISSUE_TRACKER.EDIT') : $filter('translate')('MAIL.DETAILS.HEADER.ISSUE_TRACKER.CREATE')
        },
        {
          token: 'type',
          value: params.type
        }
      ];

      DynamicFactory.get('templatesRsc', 'getUniTemplate')(
        'jira-issue-dialog',
        replaceContent
      ).then(function (template) {
          $mdDialog.show({
            scope: $scope,
            preserveScope: true,
            template: template,
            clickOutsideToClose: true,
            fullscreen: false // Only for -xs, -sm breakpoints.
          });
        },

        function () {
          console.log('Dialog nie działa. Brak template: jira-issue-dialog');
        });
    }

    function answer() {
      console.log(vm.issue.fields.description);
      vm.issue.fields.description = $filter('jiraWiki')(vm.issue.fields.description);
      console.log(vm.issue.fields.description);
      jiraService.createIssue(vm.issue, {
        channelInfo: vm.channelInfo,
        issueMsgDate: vm.issueMsgDate,
        contactId: vm.contactId
      });
      $mdDialog.hide();
    }

    function cancel() {
      $mdDialog.cancel();
    }

    //#region Create issue
    function getIssueTypesForProject(projectId) {
      jiraService.getIssueTypes(projectId).then(function (issueTypes) {
        vm.issueTypes = issueTypes;
        vm.issue.fields.issueType = issueTypes[0];
      });
    }
    //#endregion

    //#region Edit issue
    function getIssue(issueId) {
      jiraService.getIssue(issueId).then(
        function (issue) {
          vm.issue = issue;
        },
        function (error) {});
    }

    function sendMessage() {
      DynamicFactory.get('jiraRsc', 'addComment')({
        body: vm.comment,
        issueId: vm.issueDialogParams.issueId + ''
      }).then(function (result) {
        vm.issue.fields.comment.comments.push(result);
        vm.comment = '';
        toastService.showToast('Dodano komentarz do zgłoszenia: ' + vm.issueDialogParams.issueId, 'success', 3);
      });

      if (vm.uploader.queue.length > 0) {
        vm.uploader.uploadAll();
        toastService.showToast('Dodano załącznik/i do zgłoszenia: ' + vm.issueDialogParams.issueId, 'success', 3);
      }
    }

    function updateMessage() {
      vm.comment = '';

      angular.forEach(vm.uploader.queue, function (item) {
        if (vm.comment) {
          vm.comment = vm.comment + "\n[" + item._file.name + " (" + (item._file.size / 1024 / 1024).toFixed(2) + " MB)]"; //$scope.$parent.$parent.vm.replyMessage
        } else {
          vm.comment = "[" + item._file.name + " (" + (item._file.size / 1024 / 1024).toFixed(2) + " MB)]";
        }
      });
    }
    //#endregion

  }
})();

(function () {
  'use strict'

  angular.module('bugzilla').component('bugzillaIssue', {
    templateUrl: 'app/main/contactcenter/components/issuetracker/components/bugzilla/bugzillaissue.html',
    bindings: {
      openIssueDialog: '<',
      issueStatus: '<',
      createIssueDialogParams: '&'
    },
    controllerAs: 'vm',
    controller: BugzillaIssue
  });

  /* @ngInject */
  function BugzillaIssue($q, $filter, $mdDialog, $timeout, $scope, toastService, DynamicFactory, bugzillaService) {
    var vm = this;

    vm.$onInit = onInit;
    vm.$postLink = postLink;

    vm.performAction = performAction;
    vm.getProductComponentsAndVersions = getProductComponentsAndVersions;
    vm.sendMessage = sendMessage;
    vm.comment;
    vm.answer = answer;
    vm.cancel = cancel;

    function onInit() {
      bugzillaService.integrateWithBugzilla().then(
        function () {
          vm.isIntegrated = true;
        });
    }

    function postLink() {
      if (!vm.issue) {
        vm.issue = {
          product: '',
          component: '',
          version: '',
          summary: '',
          description: ''
        };
      }

      if (!vm.comment) {
        vm.comment = '';
      }
    }

    function performAction() {
      if (vm.openIssueDialog) {
        vm.createIssueDialogParams().then(function (issueDialogParams) {
          vm.issueDialogParams = issueDialogParams;
          if (issueDialogParams.issueId != undefined) {
            getIssue(issueDialogParams.issueId);
            vm.uploader = DynamicFactory.get('bugzillaRsc', 'getUploader')('bugzilla/issue/' + vm.issueDialogParams.issueId + '/attachment', false);
          } else {
            getProduct(0);

            vm.issue.summary = issueDialogParams.service ? issueDialogParams.service.serviceName : '';
            vm.issue.description = issueDialogParams.data ? issueDialogParams.data : '';
            vm.issue.op_sys = 'All';
            vm.issue.priority = 'Low';
            vm.issue.platform = 'All';
            vm.issue.severity = 'normal';

            vm.sessionId = issueDialogParams.sessionId;
            vm.type = issueDialogParams.type;
            vm.contactId = issueDialogParams.contactId;
          }

          openIssueDialog(issueDialogParams);
        });
      }
    }

    function openIssueDialog(params) {

      var replaceContent = [{
          token: 'translate',
          value: 'ISSUE.CONFIRM'
        },
        {
          token: 'title',
          value: params.issueId ? $filter('translate')('MAIL.DETAILS.HEADER.ISSUE_TRACKER.EDIT') : $filter('translate')('MAIL.DETAILS.HEADER.ISSUE_TRACKER.CREATE')
        },
        {
          token: 'type',
          value: params.type
        }
      ];

      DynamicFactory.get('templatesRsc', 'getUniTemplate')(
        'bugzilla-issue-dialog',
        replaceContent
      ).then(function (template) {
          $mdDialog.show({
            scope: $scope,
            preserveScope: true,
            template: template,
            clickOutsideToClose: true,
            fullscreen: false // Only for -xs, -sm breakpoints.
          });
        },

        function () {
          console.log('Dialog nie działa. Brak template: bugzilla-issue-dialog');
        });
    }

    function answer() {
      bugzillaService.createIssue(vm.issue, vm.sessionId, vm.type, vm.contactId);
      $mdDialog.hide();
    }

    function cancel() {
      $mdDialog.cancel();
    }

    //#region Create issue
    function getProduct(productId) {
      bugzillaService.getProducts().then(
        function (products) {
          vm.products = products;
          if (vm.products.length > 0) {
            vm.components = vm.products[productId].components;
            vm.versions = vm.products[productId].versions;

            vm.issue.classification = vm.products[productId].classification;
            vm.issue.product = vm.products[productId].name;
            if (vm.components.length > 0) vm.issue.component = vm.components[0].name;
            if (vm.versions.length > 0) vm.issue.version = vm.versions[0].name;
          }
        });
    }

    function getProductComponentsAndVersions(productName) {
      vm.selectedProduct = _.find(vm.products, {
        name: productName
      });
      vm.issue.classification = vm.selectedProduct.classification;
      vm.components = vm.selectedProduct.components;
      vm.issue.component = vm.selectedProduct.components[0].name;
      vm.versions = vm.selectedProduct.versions;
      vm.issue.version = vm.selectedProduct.versions[0].name;
    }

    //#endregion

    //#region Edit issue
    function getIssue(issueId) {
      bugzillaService.getIssue(issueId).then(
        function (result) {
          if (result.bugs.length > 0) {
            vm.issue = result.bugs[0];
            getIssueComments(issueId);
          }
        });
    }

    function getIssueComments(issueId) {
      bugzillaService.getIssueComments(issueId).then(
        function (result) {
          if (result.length > 0) {
            if (result[0].comments.length > 0) {
              vm.issue.description = result[0].comments[0].text;
              vm.issue.comments = result[0].comments;
              vm.issue.comments.splice(0, 1); //Delete first comment from the comments list, which it is usually description of the issue
            }
          }
        });
    }

    function sendMessage() {
      if (vm.uploader.queue.length > 0) {
        vm.uploader.onBeforeUploadItem = function (item) {
          item.formData.push({
            comment: vm.comment
          });
        };

        vm.uploader.uploadAll();
      } else {
        bugzillaService.addCommentToIssue(vm.comment, vm.issueDialogParams.issueId).then(
          function (commentId) {
            vm.issue.comments.push({
              id: commentId,
              text: vm.comment
            });
          });
      }

      vm.comment = '';
    }

    //#endregion

  }

})();

+(function () {
  'use strict';

  /* @ngInject */
  angular
    .module('issueTracker', [
      'jira',
      'bugzilla'
    ])
    .constant('ISSUE_TRACKER_NAME', {
      JIRA: 1,
      BUGZILLA: 2,
      MANTIS: 3
    });
}());

(function () {
  'use strict';

  angular.module('issueTracker')
    .component('attachmentList', {
      templateUrl: 'app/main/contactcenter/components/issuetracker/attachment/attachmentList/attachmentList.html',
      bindings: {
        message: '=',
        uploader: '=',
        issueId: '<',
        updateMessage: '&'
      },
      controllerAs: 'vm',
      controller: AttachmentList
    });

  /* @ngInject */
  function AttachmentList(toastService) {
    var vm = this;

    vm.addAttachmentDialog = addAttachmentDialog;
    vm.deleteFromQueue = deleteFromQueue;
    vm.$onInit = onInit;

    function onInit() {
      setUploader()
    }

    function setUploader() {
      //vm.uploader = DynamicFactory.get('jiraRsc', 'getUploader')('jira/issue/attachment/' + vm.issueId, false);
      vm.filesToUpload = false;

      vm.uploader.onAfterAddingFile = function (item) {
        console.log("Attachment added [file name: " + item._file.name + "; size: " + (item._file.size / 1024 / 1024).toFixed(2) + " MB].");
        vm.filesToUpload = true;
        vm.updateMessage();
      };

      vm.uploader.onCompleteAll = function () {
        vm.uploader.clearQueue();
        //vm.uploader.formData.length = 0;
        vm.filesToUpload = false;
        toastService.showToast('Dodano załącznik do zgłoszenia', 'success', 3);
      }
    }

    function addAttachmentDialog() {
      if (vm.uploader.queue.length <= vm.uploader.queueLimit) {
        angular.element(document).find('#selectFile').trigger('click');
      } else {
        toastService.showToast('Przekroczono liczbę załączników', 'error', 3);
      }
    }

    function deleteFromQueue(item) {
      item.remove();
      if (vm.uploader.queue.length == 0) {
        vm.filesToUpload = false;
      }
      vm.updateMessage();
    }

    /*function updateMessage() {
      vm.message = '';

      angular.forEach(vm.uploader.queue, function (item) {
        if (vm.message) {
          vm.message = vm.message + "\n[" + item._file.name + " (" + (item._file.size / 1024 / 1024).toFixed(2) + " MB)]"; //$scope.$parent.$parent.vm.replyMessage
        } else {
          vm.message = "[" + item._file.name + " (" + (item._file.size / 1024 / 1024).toFixed(2) + " MB)]";
        }
      });
    }*/
  }
})();

(function () {
  'use strict';

  angular.module('issueTracker')
    .component('attachmentDetail', {
      templateUrl: 'app/main/contactcenter/components/issuetracker/attachment/attachmentDetail/attachment.html',
      bindings: {
        item: '<',
        onDelete: '&'
      },
      controllerAs: 'vm',
      controller: AttachmentDetail
    });

  /* @ngInject */
  function AttachmentDetail() {
    var vm = this;

    vm.deleteItem = deleteItem;

    function deleteItem() {
      vm.onDelete({
        item: vm.item
      });
    }
  }

})();

(function() {
  "use strict";

  angular.module("contactcenter.reports").component("userActivity", {
    templateUrl: "app/main/contactcenter/reports/components/useractivity/useractivity.html",
    controllerAs: "vm",
    controller: userActivity
  });

  /** @ngInject */
  function userActivity(tripleviewService, ReportTools, ReportsData, DynamicFactory) {
    var vm = this;
    vm.timeHtml = timeHtml;
    // vm.setPage = setPage;
    vm.changeChart = changeChart;
    vm.downloadXLSX = downloadXLSX;
    vm.$onInit = onInit;
    vm.formatSecs = ReportTools.formatSecs;
    //other
    vm.currentType = "MM-YYYY";
    vm.timeChart = "miesięczny";
    vm.pageSize = 10;
    vm.pageNumber = 0;
    vm.chartProp = "count";

    function onInit() {
      vm.dateType = ReportsData.dateType;
      vm.showChart = true;

      vm.consultantList = [];

      setTripleView();
      getFilteredReportsUsersActivity();
      // vm.consultantList = _.groupBy(tripleviewService.sidenavData.getConsultantList(),'ConsultantId');
    } // the end onInit();

    //#region TripleView

    function setTripleView() {
      tripleviewService.sidenavData.getConnectData = getFilteredReportsUsersActivity;
      vm.getParams = ReportTools.configReportParams(
        {
          CallcenterId: true,
          ConsultantId: true,
          callcenter: true,
          activityCountType: true,
          startHour: true
          // consultantList: true,
          // agreagation: true,
          // timeAgr: true,
          // showChart: true,
          // tagsAgr: true
        },
        currentPage
      );

      tripleviewService.sidenavData.agregationDate = [];
      tripleviewService.sidenavData.duration = 3;
      tripleviewService.sidenavData.startValue = "";
    }
    function currentPage() {
      return {
        // AggregationType: vm.SessionManager.getUserRoleId() == vm.authRolesConst.consultant ? 'D' : null,
        StartIndex: vm.pageSize * vm.pageNumber + 1,
        PageSize: vm.pageSize
      };
    }


    //#endregion
    function changeChart(prop) {
      vm.chartProp = prop;
      generateChart(vm.chartSource);
    }


    function getFilteredReportsUsersActivity() {
      vm.pageNumber = 0;
      // if (vm.SessionManager.getUserRoleId() !== vm.authRolesConst.consultant) {
      ReportTools.getConsultantList().then(function(result) {
        vm.filtersConsultants = result;
        vm.consultantList = _.mapValues(_.groupBy(result, "consultantID"), function(array) {
          return array[0];
        });

        getReport();
        // getChart();
      });
      // } else {
      //   getReport();
      //   getChart();
      // }
    }

    function getReport() {
      DynamicFactory.get("reportsCosult", "ReportsUsersActivity")(vm.getParams()).then(
        function(ReportsUsersActivity) {
          vm.report = angular.copy(ReportsUsersActivity);
          if (vm.report && vm.report.length != 0) {
            // vm.summary = angular.copy(ReportsUsersActivity.summary);
            // vm.tagsColumn = angular.copy(tripleviewService.sidenavData.params.tagsAgr);
            // generatePages();
          }
        },
        function(error) {
          console.log("Problem z pobraniem IVRConnections");
        }
      );
    }

    function generatePages() {
      var totalPages = Math.round(vm.report[0].consultantsTotal / vm.pageSize + 0.5);
      console.log("reportStatsCallsPerConsultant | total pages=", totalPages);
      vm.reportPages = [];
      for (var i = 0; i < totalPages; i++) {
        vm.reportPages.push(i);
      }
    }


    function timeHtml(data) {
      return $filter("timer")(data);
    }


//TODO
    function downloadXLSX() {
      DynamicFactory.get("reportsCosult", "ReportsUsersActivityExport")(vm.getParams()).then(function(report) {
        var blob = new Blob([new Uint8Array(report.data)], {
          type: report.headers("Content-Type")
        });
        //var URL = window.URL || window.MozURL || window.webkitURL || window.MSURL || window.OURL;

        var anchor = document.createElement("a");
        anchor.href = URL.createObjectURL(blob);
        anchor.download = "UserActivityReport.csv";
        document.body.appendChild(anchor); //For FF
        anchor.target = "_blank";
        anchor.click();
        //It's better to remove the elem
        document.body.removeChild(anchor);
      });
      // alasql("SELECT consultantID,callCenterID,minutes,avgminutes,firstName,lastname,[count],c_7s,c_2min,c_7_30,c_30_120 INTO XLSX('" + ("AgregacjePołączeń_" + moment().format()) + ".xlsx',{headers:true}) FROM ? ", [vm.report]);
    }
  }
})();

(function () {
	'use strict';

	angular
		.module('contactcenter.reports')
		.component('reportStats', {
			templateUrl: 'app/main/contactcenter/reports/components/reportstatssms/reportstatssms.html',
			controllerAs: 'vm',
			require: {
				tripleView: '^tripleView'
			},
			controller: controller
		});

	/** @ngInject */
	function controller(DynamicFactory, SessionManager, authRolesConst, tripleviewService, ReportsData, ReportTools, toastService, $mdDialog) {
		var vm = this; // jshint ignore:line
		// var userInfo = SessionManager.getUser();

		//tripleviewService.sidenavData.getConnectData = generateReport;
		//vm.sortBy = sortBy;

		vm.changeAgrType = changeAgrType;
		vm.changeChart = changeChart;
		vm.showHostorySession = showHostorySession;
		vm.downloadXLSX = downloadXLSX;
		// tripleviewService.sidenavData.showChart = showChart;
		vm.setPage = setPage;
		vm.$onInit = onInit;
		vm.formatSecs = ReportTools.formatSecs;
		vm.copyGuid = copyGuid;

		vm.timeChart = 'miesięczny';
		vm.pageSize = 10;
		vm.pageNumber = 0;
		vm.chartProp = 'smsMessagesCount';
		vm.loading = false;



		function onInit() {
			vm.dateType = ReportsData.dateType;
			vm.currentType = vm.dateType[0];
			vm.showChart = true;

			vm.consultantList = [];
			vm.SessionManager = SessionManager;
			vm.authRolesConst = authRolesConst;
			// setAudioPlayer();
			setTripleView();

			getFilteredSMSMessagesList();
		}

		function getFilteredSMSMessagesList() {
			vm.pageNumber = 0;

			// vm.tagsColumn = tripleviewService.sidenavData.params.partnerAgr ? angular.copy(tripleviewService.sidenavData.params.tagsAgr) : false;
			// vm.partnerColumn = angular.copy(tripleviewService.sidenavData.params.partnerAgr);
			// if (vm.SessionManager.getUserRoleId() !== vm.authRolesConst.consultant) {
			//   ReportTools.getConsultantList().then(function (result) {
			//     vm.filtersConsultants = result;
			//     getReport();
			//     getChart();
			//   });
			// } else {
			getReport();
			getChart();

			// }
		}


		function getReport() {
			// getFilterDates();
			// getContactFilter();
			vm.loading = true;
			DynamicFactory.get('reportsCosult', 'GetSmsReport')(vm.getParams()).then(
				function (report) {
					vm.report = angular.copy(report);
					generatePages();
					vm.loading = false;
				},
				function (error) {
					console.log("Problem z pobraniem GetSmsReport");
					vm.loading = false;
				});
		}

		function showHostorySession(event, sessionID) {
			event.stopImmediatePropagation();
			
			$mdDialog.show({
				clickOutsideToClose: true,
				controller: 'transcription',
				controllerAs: 'vm',
				focusOnOpen: false, 
				targetEvent: event,
				templateUrl: 'app/main/contactcenter/reports/components/reportsessions/transcription/transcription.html',
				multiple: true,
				locals:{
					sessionID: sessionID
				}
			});
		}
		
		function cancelDialog() {
			$mdDialog.cancel();
		}

		function changeAgrType(prop) {
			vm.currentType = prop;
			getChart();
		}

		function changeChart(prop) {
			vm.chartProp = prop;
			generateChart(vm.chartSource);
		}


		function getChart() {
			// getFilterDates();
			setChartPlugin();
			if (tripleviewService.sidenavData.finalDate) setWidthOnChart(tripleviewService.sidenavData.finalDate.date);
			DynamicFactory.get('reportsCosult', 'GetSmsMessagesStatisticsForChart')(vm.getParams()).then(
				generateChart,
				function (error) {
					console.log("Wystapił błąd podczas pobierania statystyk wiadomości sms/mms do wyrysowania wykresu");
				});
		}



		function generateChart(callsStatistics) {
			vm.chartSource = callsStatistics;
			if (callsStatistics.length > 0) {
				var chart = [];
				var dateArray = ReportTools.dateInBetween(vm.currentType.key, tripleviewService.sidenavData.params);

				chart.push({
					key: 'połączenia',
					values: generateSeriesForPeriod(_.reverse(_.sortBy(callsStatistics, vm.chartProp)), dateArray)
				});

				vm.mainChart.data = chart;
			}

		}

		function generateSeriesForPeriod(period, dateArray) {
			return _.sortBy(dateArray.map(function (date) {
				var item = _.find(period, {
					timePeriod: date
				});
				if (item) {
					return {
						color: ReportsData.getNextColor(),
						x: item.timePeriod,
						y: item[vm.chartProp] || 0
					}
				} else {
					return {
						x: date,
						y: 0
					}
				}
			}), function (o) {
				return new Date(o.x);
			});
		}

		function setWidthOnChart(data) {
			vm.mainChart.options.chart.width = undefined;
		}



		function chartTimeFormat(d) {
			if (vm.chartProp !== 'count') {
				return ReportTools.formatSecs(d);
			} else return d.toString();
		}

		function setChartPlugin() {
			vm.dateType = ReportsData.dateType;
			// vm.currentType = 'MM-YYYY';

			var mainChart = angular.copy(ReportsData.defaultChartConf);
			mainChart.options.chart.color = function color() {
				return '#2799f3'; //'#5fd4c4'
			};
			mainChart.options.chart.height = 250;
			mainChart.options.chart.type = 'discreteBarChart';
			mainChart.options.chart.width = null;
			mainChart.options.chart.showValues = false;

			mainChart.options.chart.xAxis = {
				tickFormat: function (d) {
					if (vm.currentType.value == 'D') {
						var daysTotal = moment.duration(tripleviewService.sidenavData.params.To.diff(tripleviewService.sidenavData.params.From)).asDays();
						var fromToTick = moment.duration(moment(d, 'DD-MM-YYYY').diff(tripleviewService.sidenavData.params.From)).asDays();
						if (daysTotal > 32) {
							if (Math.round(fromToTick) % 8 == 0) {
								return d;
							} else {
								return '';
							}
						}
					}
					return d; //vm.currentType === 'DD-MM-YYYY' ? d.split('-')[0] : vm.currentType === 'd' ? ReportsData.dayName[d] :
				},
				rotateLabels: -20
			};
			mainChart.options.chart.tooltip = {
				keyFormatter: function (d, i) {
					return d;
				}
			}
			mainChart.options.chart.yAxis = {
				tickFormat: chartTimeFormat
			};
			mainChart.options.chart.valueFormat = chartTimeFormat;
			vm.mainChart = mainChart;
			ReportsData.resetNextColor();

		}


		function setPage(newPage) {
			vm.pageNumber = newPage;
			getReport();
		}

		function generatePages() {
			vm.reportPages = [];
			if (!vm.report[0]) {
				return;
			}
			var totalPages = Math.round(vm.report[0].smsMessagesTotal / vm.pageSize + 0.5)
			console.log('reportStatsCallsPerConsultant | total pages=', totalPages);
			for (var i = 0; i < totalPages; i++) {
				vm.reportPages.push(i);
			}
		}


		function setTripleView() {
			tripleviewService.sidenavData.getConnectData = getFilteredSMSMessagesList;
			// tripleviewService.sidenavData.showChart = showChart;
			// tripleviewService.sidenavData.config = {
			//   consultantList: true,
			//   showChart: true,
			//   // reportSearch : {
			//   //   // objList: result,
			//   //   filter: 'contactId',
			//   //   label: 'REPORTS.CONTACT',
			//   //   format: formatContact,
			//   //   dataProp: 'contactId'
			//   // }
			// };
			vm.getParams = ReportTools.configReportParams({
				CallcenterId: SessionManager.getUserRoleId() !== authRolesConst.consultant,
				ConsultantId: SessionManager.getUserRoleId() !== authRolesConst.consultant,
				agreagation: true,
				direction: true,
				msisdn: SessionManager.getUserRoleId() !== authRolesConst.consultant,
				type: true
			}, currentPage);


			// if (SessionManager.getUserRoleId() === authRolesConst.admin || SessionManager.getUserRoleId() === authRolesConst.manager) {
			//   tripleviewService.sidenavData.config = {
			//     CallcenterId: true,
			//     ConsultantId: true,
			//     // agreagation: true,
			//     // direction: true,
			//     // msisdn: true,
			//     // type: true
			//   };
			// } else {
			//   tripleviewService.sidenavData.config = {
			//     agreagation: true,
			//     direction: true,
			//     msisdn: true,
			//     type: true
			//   };
			// }
		}
		function currentPage() {
			return {
				AggregationType: vm.currentType.value,
				StartIndex: (vm.pageSize * vm.pageNumber) + 1,
				PageSize: vm.pageSize
			};
		}

		function copyGuid(message) {
			if (!message.guid) {
				toastService.showToast('Brak GUID', 'error', 10);
			} else {
				navigator.clipboard.writeText(message.guid).then(function () {
					toastService.showToast('GUID skopiowany', 'success', 10);
					/* clipboard successfully set */
				}, function () {
					toastService.showToast('Nie udało się skopiować GUID', 'error', 10);
					/* clipboard write failed */
				});
			}
		}

		function downloadXLSX() {
			DynamicFactory.get('reportsCosult', 'reportsSmsMessagesExport')(vm.getParams())
				.then(DynamicFactory.get('FileUploadRsc', 'downloadFile')('ReportMessageList.csv'));
			// alasql("SELECT consultantName,id,guid,la,msisdn,type,direction,title,body,attachmentUrls,insertionTime  INTO XLSX('" + ("RaportSMS_" + moment().format()) + ".xlsx',{headers:true}) FROM ? ", [vm.MessagesList]);
		}



























		// function getParams(){
		//   getFilterDates();
		//   return {
		//     From: tripleviewService.sidenavData.params.From,
		//     To: tripleviewService.sidenavData.params.To,
		//     callCenterID: tripleviewService.sidenavData.id,
		//     consultantId: tripleviewService.sidenavData.userID,
		//     direction: tripleviewService.sidenavData.direction,
		//     msisdn: tripleviewService.sidenavData.msisdn || undefined,
		//     pageSize: vm.pageSize,
		//     startIndex:  (vm.pageSize * vm.pageNumber) + 1,
		//     type: tripleviewService.sidenavData.type,
		//     aggregationType: vm.currentType.value
		//   };
		// }
		// function generateChartOld(smsMessagesStatistics) {
		//   vm.smsMessagesStatistics = smsMessagesStatistics;
		//   if (smsMessagesStatistics.length > 0) {
		//     var dateArray = ReportTools.dateInBetween(vm.currentType, tripleviewService.sidenavData);

		//     vm.mainChart.data.push({
		//       key: 'sms/mms',
		//       values: []
		//     });

		//     var messagesCount;

		//     _.forEach(dateArray, function (value, key) {
		//       messagesCount = getCount(smsMessagesStatistics, dateArray[key]);
		//       vm.mainChart.data[0].values.push({
		//         x: dateArray[key],
		//         y: messagesCount
		//       });
		//     });
		//   }

		// }

		// function showChart() {
		//   vm.showChart = tripleviewService.sidenavData.showMyChart;
		//   if (vm.showChart) {
		//     document.querySelector('.chartForReports').classList.remove('listNoChart');
		//   } else {
		//     document.querySelector('.chartForReports').classList.add('listNoChart');
		//   }
		//   getFilteredContactcenterStats();
		// }

		// function getFilterDates() {
		//   if (!tripleviewService.sidenavData.dateFrom && !tripleviewService.sidenavData.dateTo) {
		//     tripleviewService.sidenavData.params.From = tripleviewService.sidenavData.listDate[0].date.from;
		//     tripleviewService.sidenavData.params.To = tripleviewService.sidenavData.listDate[0].date.to;
		//   } else {
		//     tripleviewService.sidenavData.params.From = tripleviewService.sidenavData.dateFrom;
		//     tripleviewService.sidenavData.params.To = tripleviewService.sidenavData.dateTo;
		//   }
		// }

		// function getContactFilter() {
		//   getFilterDates();
		//   if (SessionManager.getUserRoleId() !== authRolesConst.consultant){
		//     DynamicFactory.get('reportsCosult', 'ContactConnectionsList')(tripleviewService.sidenavData.params.From, tripleviewService.sidenavData.params.To).then(function (result) {
		//       tripleviewService.sidenavData.config.reportSearch.objList = result;
		//     });
		//   }
		// }

		// function formatContact(item) {
		//   return item.contactId.toString();
		// }

		// function onInit() {
		// 	vm.showChart = true;
		// 	vm.navBarConfig = headerConfig.navBar;

		// 	setTripleView();
		// 	setDataTablesPlugin();
		// 	setChartPlugin();
		// } // the end onInit();

		// function setTripleView() {
		// 	var user = SessionManager.getUser();

		// 	tripleviewService.sidenavData.getConnectData = getFilteredSMSMessagesList;
		// 	tripleviewService.sidenavData.generateConsultantPerContactCenter = generateConsultantPerContactCenter;
		// 	tripleviewService.sidenavData.getCallcenterPerManager = getCallcenterPerManager;
		// 	// tripleviewService.sidenavData.generateDate = generateDate;
		// 	tripleviewService.sidenavData.errorMsg = '';
		// 	// tripleviewService.sidenavData.listDate = chooseDateTime.listDate;
		// 	tripleviewService.sidenavData.consultantsPerCC = [];
		// 	tripleviewService.sidenavData.showChart = showChart;


		// 	if (SessionManager.getUserRoleId() === authRolesConst.admin) {
		// 		getCallcenterPerManager();
		// 		generateConsultantPerContactCenter();
		// 		tripleviewService.sidenavData.config = {
		// 			type: true,
		// 			direction: true,
		// 			callcenter: true,
		// 			consultantList: true,
		// 			agreagation: true
		// 		};
		// 	} else if (SessionManager.getUserRoleId() === authRolesConst.manager) {
		// 		generateConsultantPerContactCenter();
		// 		tripleviewService.sidenavData.config = {
		// 			type: true,
		// 			direction: true,
		// 			callcenter: true,
		// 			consultantList: true,
		// 			agreagation: true
		// 		};

		// 		tripleviewService.sidenavData.id = user.callCenterId;
		// 	} else {
		// 		tripleviewService.sidenavData.config = {
		// 			type: true,
		// 			direction: true,
		// 			agreagation: true
		// 		};

		// 		tripleviewService.sidenavData.id = user.callCenterId;
		// 		tripleviewService.sidenavData.userID = user.consultantId;
		// 	}
		// }

		//#region Chart Plugin
		// function setChartPlugin() {
		// 	vm.dateType = ReportsData.dateType;
		// 	vm.currentType = 'MM-YYYY';

		// 	vm.mainChart = ReportsData.defaultChartConf;
		// 	vm.mainChart.options.chart.type = 'discreteBarChart';
		// 	vm.mainChart.options.chart.color = function color() {
		// 		return '#2799f3';
		// 	};
		// 	vm.mainChart.options.chart.height = 250;
		// 	vm.mainChart.options.chart.width = null;
		// 	vm.mainChart.options.chart.xAxis = {
		// 		tickFormat: function (d) {
		// 			return d;
		// 		}
		// 	};

		// 	getDataForChart(vm.currentType);
		// }

		// function getDataForChart(key) {
		// 	var aggregationType;

		// 	var callCenterId = tripleviewService.sidenavData.id;
		// 	var consultantId = tripleviewService.sidenavData.userID;

		// 	var raportFromDate;
		// 	var reportToDate;

		// 	if (!tripleviewService.sidenavData.dateFrom && !tripleviewService.sidenavData.dateTo) {
		// 		raportFromDate = tripleviewService.sidenavData.listDate[0].date.from;
		// 		reportToDate = tripleviewService.sidenavData.listDate[0].date.to;
		// 	} else {
		// 		raportFromDate = tripleviewService.sidenavData.dateFrom;
		// 		reportToDate = tripleviewService.sidenavData.dateTo;
		// 	}
		// 	var type = tripleviewService.sidenavData.type;
		// 	var direction = tripleviewService.sidenavData.direction;

		// 	vm.currentType = key;

		// 	if (key == 'MM-YYYY') {
		// 		aggregationType = 'M';
		// 	} else if (key == 'DD-MM-YYYY') {
		// 		aggregationType = 'D';
		// 	} else {
		// 		aggregationType = 'H';
		// 	}

		// 	if (tripleviewService.sidenavData.finalDate) setWidthOnChart(tripleviewService.sidenavData.finalDate.date);
		// 	vm.mainChart.data = [];

		// 	DynamicFactory.get('reportsCosult', 'GetSmsMessagesStatisticsForChart')(raportFromDate, reportToDate, consultantId, callCenterId, type, direction, aggregationType).then(
		// 		function (smsMessagesStatistics) {
		// 			vm.smsMessagesStatistics = smsMessagesStatistics;
		// 			if (smsMessagesStatistics.length > 0) {
		// 				var dateArray = ReportTools.dateInBetween(vm.currentType, tripleviewService.sidenavData);

		// 				vm.mainChart.data.push({
		// 					key: 'sms/mms',
		// 					values: []
		// 				});

		// 				var messagesCount;

		// 				_.forEach(dateArray, function (value, key) {
		// 					messagesCount = getCount(smsMessagesStatistics, dateArray[key]);
		// 					vm.mainChart.data[0].values.push({
		// 						x: dateArray[key],
		// 						y: messagesCount
		// 					});
		// 				});
		// 			}

		// 		},
		// 		function (error) {
		// 			console.log("Wystapił błąd podczas pobierania statystyk wiadomości sms/mms do wyrysowania wykresu");
		// 		});
		// 		headingChart(key);

		// 	//changeLineHeightForDate();
		// }

		// function headingChart(input) {
		// 	vm.timeChart = "miesięczne";
		// 	switch(input) {
		// 		case 'MM-YYYY': vm.timeChart = 'miesięczne'; break;
		// 		case 'DD-MM-YYYY': vm.timeChart = 'dzienne'; break;
		// 		default: vm.timeChart = 'godzinowe'; break;
		// 	}
		// }

		// function getCount(array, timePeriod) {
		// 	var calls = _.find(array, function (item) {
		// 		return item.timePeriod == timePeriod;
		// 	});

		// 	return calls != undefined ? calls.count : 0;
		// }

		// function setWidthOnChart(data) {
		// 	if (vm.currentType == 'DD-MM-YYYY') {
		// 		if (data.id == 2) {
		// 			vm.mainChart.options.chart.width = 4444;
		// 		} else if (data.id == 3) {
		// 			vm.mainChart.options.chart.width = 7777;
		// 		} else {
		// 			vm.mainChart.options.chart.width = null;
		// 		}
		// 		vm.mainChart.options.chart.xAxis = {
		// 			"rotateLabels": 25
		// 		};
		// 	} else {
		// 		vm.mainChart.options.chart.width = null;
		// 		vm.mainChart.options.chart.xAxis = {
		// 			"rotateLabels": 0
		// 		};
		// 	}
		// }

		//#endregion

		//#region DataTables Plugin
		// function setDataTablesPlugin() {
		// 	vm.dtInstance = {};

		// 	vm.dtOptions = DTOptionsBuilder.newOptions()
		// 		//.setLoadingTemplate('<img src="images/loading.gif">')
		// 		.withFnServerData(getSMSMessagesList)
		// 		.withDataProp('data')
		// 		.withOption('processing', true)
		// 		.withOption('serverSide', true)
		// 		.withOption('serverMethod', 'POST')
		// 		.withOption('paging', true)
		// 		.withPaginationType('full_numbers')
		// 		.withOption('bLengthChange', true) //możliwość zmiany elementów na stronie
		// 		.withOption('createdRow', createdRow)
		// 		.withOption('filter', false)
		// 		.withOption('bPaginate', false)
		// 		.withOption('info', false)
		// 		.withOption('scrollY', window.innerHeight)
		// 		.withOption('scrollX', '100%')
		// 		.withOption('scrollCollapse', true)
		// 		.withFixedColumns({
		// 			leftColumns: 0,
		// 			rightColumns: 0
		// 		});

		// 	setColumns();
		// }

		// function getSMSMessagesList(sSource, aoData, fnCallback, oSettings) {
		// 	var draw = aoData[0].value;
		// 	var order = aoData[2].value;
		// 	var startIndex = aoData[3].value + 1;
		// 	var pageSize = vm.showChart ? aoData[4].value : 18;

		// 	var callCenterId = tripleviewService.sidenavData.id;
		// 	var consultantId = tripleviewService.sidenavData.userID;
		// 	var raportFromDate;
		// 	var reportToDate;

		// 	if (!tripleviewService.sidenavData.dateFrom && !tripleviewService.sidenavData.dateTo) {
		// 		raportFromDate = tripleviewService.sidenavData.listDate[0].date.from;
		// 		reportToDate = tripleviewService.sidenavData.listDate[0].date.to;
		// 	} else {
		// 		raportFromDate = tripleviewService.sidenavData.dateFrom;
		// 		reportToDate = tripleviewService.sidenavData.dateTo;
		// 	}

		// 	var type = tripleviewService.sidenavData.type;
		// 	var direction = tripleviewService.sidenavData.direction;

		// 	var records = {
		// 		'draw': 0,
		// 		'recordsTotal': 0,
		// 		'recordsFiltered': 0,
		// 		'data': []
		// 	};

		// 	DynamicFactory.get('reportsCosult', 'GetSmsReport')(raportFromDate, reportToDate, consultantId, callCenterId, type, direction, startIndex, pageSize).then(
		// 		function (smsMessagesList) {
		// 			vm.MessagesList = smsMessagesList;
		// 			if (smsMessagesList.length > 0) {
		// 				vm.smsMessagesList = {};
		// 				records = {
		// 					'draw': draw,
		// 					'recordsTotal': smsMessagesList[0].smsMessagesTotal,
		// 					'recordsFiltered': smsMessagesList[0].smsMessagesTotal,
		// 					'data': smsMessagesList
		// 				};
		// 			}

		// 			fnCallback(records);
		// 		},
		// 		function (error) {
		// 			fnCallback(records);
		// 			console.log("Problem z pobraniem SMSMessages");
		// 		});
		// }

		// function getFilteredSMSMessagesList() {
		// 	getDataForChart(vm.currentType);
		// 	vm.dtInstance.rerender();
		// }

		// function setColumns() {
		// 	vm.dtColumns = [
		// 		DTColumnBuilder.newColumn('type')       .withTitle('Typ').withOption('defaultContent', "").renderWith(typeHtml),
		// 		DTColumnBuilder.newColumn('id')         .withTitle('Id').withOption('defaultContent', ""),
		// 		DTColumnBuilder.newColumn('guid')       .withTitle('Guid').withOption('defaultContent', ""),
		// 		userInfo.roleId != 3 ? DTColumnBuilder  .newColumn('consultantName').withTitle('Imię Nazwisko').withOption('defaultContent', "") : DTColumnBuilder.newColumn('userName').withTitle('userName').withOption('defaultContent', ""),
		// 		userInfo.roleId == 3 ? DTColumnBuilder  .newColumn('time').withTitle('Data').withOption('defaultContent', "").renderWith(dateHtml) : DTColumnBuilder.newColumn('insertionTime').withTitle('Data').withOption('defaultContent', "").renderWith(dateHtml), //insertionTime => time
		// 		DTColumnBuilder.newColumn('la')         .withTitle('La').withOption('defaultContent', "---"),
		// 		DTColumnBuilder.newColumn('msisdn')     .withTitle('msisdn').withOption('defaultContent', ""),
		// 		DTColumnBuilder.newColumn('direction')  .withTitle('Kierunek').withOption('defaultContent', "").renderWith(directionHtml),
		// 		DTColumnBuilder.newColumn('body')     .withTitle('Treść').withOption('defaultContent', "")
		// 	];
		// }

		// function createdRow(row, data, dataIndex) { //recompiling DataTable after its initialization is over
		// 	$compile(angular.element(row).contents())($scope);
		// }

		// function dateHtml(data, type, full, meta) //[start] column
		// {
		// 	return $filter('date')(data, 'dd-MM-yyyy HH:mm:ss');
		// }

		// function typeHtml(data, type, full, meta) {
		// 	if (!vm.smsMessagesList[full.id]) vm.smsMessagesList[full.id] = full;
		// 	return "<img ng-src='{{ vm.smsMessagesList[" + full.id + "].type | typeSms }}' class='typeMessege'>"; //była kalasa md-avatar
		// }

		// function directionHtml(data, type, full, meta) //[bridgeCount] column
		// {
		// 	if (!vm.smsMessagesList[full.id]) vm.smsMessagesList[full.id] = full;
		// 	return "<i ng-style='{ color: (vm.smsMessagesList[" + full.id + "].direction | changeColor) }' class='fa fa-arrow-{{ vm.smsMessagesList[" + full.id + "].direction | direction}}' aria-hidden='true'></i>";
		// }

		// //#endregion

		// var prevCallCenter;

		// function getCallcenterPerManager() {
		// 	if (SessionManager.getUserRoleId() !== authRolesConst.consultant) {
		// 		DynamicFactory.get('reportsCosult', 'CallCenterList')().then(function (r) {
		// 			tripleviewService.sidenavData.callCenterList = r;
		// 		});
		// 	}
		// 	generateConsultantPerContactCenter();
		// }

		// function generateConsultantPerContactCenter() {
		// 	tripleviewService.sidenavData.consultantsPerCC = [];
		// 	var callcenterId;
		// 	if (SessionManager.getUserRoleId() === authRolesConst.admin) {
		// 		callcenterId = tripleviewService.sidenavData.id ? tripleviewService.sidenavData.id : null;
		// 	} else {
		// 		callcenterId = userInfo.callCenterId;
		// 	}
		// 	if (SessionManager.getUserRoleId() !== authRolesConst.consultant) {
		// 		DynamicFactory.get('reportsCosult', 'ConsultansGet')(callcenterId).then(function (r) {
		// 			tripleviewService.sidenavData.consultantsPerCC = r;
		// 			vm.consultantList = r;
		// 		})
		// 	}
		// }

		// function generateDate(date) {
		// 	tripleviewService.sidenavData.dateFrom = date.from;
		// 	tripleviewService.sidenavData.dateTo = date.to
		// 	setLastDateToAnyDate(date);

		// 	/*
		// 	if (vm.onInitCallFlag){
		// 	  vm.onInitCallFlag = false;
		// 	  setDataTablesPlugin();
		// 	  setChartPlugin();
		// 	}*/

		// 	console.log('generateDate');
		// 	console.log('tripleviewService.sidenavData.dateFrom', tripleviewService.sidenavData.dateFrom);
		// 	console.log('tripleviewService.sidenavData.dateTo', tripleviewService.sidenavData.dateTo);


		// 	tripleviewService.sidenavData.disableDate = date.disabled;
		// }

		// function setLastDateToAnyDate(date) {
		// 	var anyDate = _.filter(tripleviewService.sidenavData.listDate, {
		// 		'name': 'Dowolna data'
		// 	});
		// 	_.forEach(anyDate, function (value) {
		// 		value.date.from = date.from;
		// 		value.date.to = date.to;
		// 	});
		// }



		// function showChart () {
		// 	vm.showChart = tripleviewService.sidenavData.showMyChart;
		// 	if(vm.showChart) {
		// 		document.querySelector('.chartForReports').classList.remove('listNoChart');
		// 	} else  {
		// 		document.querySelector('.chartForReports').classList.add('listNoChart');
		// 	}
		// 	getFilteredSMSMessagesList();
		// }
	}
})();

(function() {
	'use strict';

	angular
		.module('contactcenter.reports')
		.component('unrealizedSessions', {
			templateUrl: 'app/main/contactcenter/reports/components/unrealizedsessions/unrealizedsessions.html',
			controllerAs: 'vm',
			require: {
				tripleView: '^tripleView'
			},
			controller: controller
		});

		
		/** @ngInject */
		function controller(DynamicFactory, SessionManager, authRolesConst, tripleviewService, ReportsData, ReportTools) {
			var vm = this;
	
			vm.changeAgrType = changeAgrType;
			vm.changeChart = changeChart;
			vm.showHostorySession = showHostorySession;
			vm.downloadXLSX = downloadXLSX;
			vm.setPage = setPage;
			vm.$onInit = onInit;
			vm.formatSecs = ReportTools.formatSecs;
	
			vm.timeChart = 'miesięczny';
			vm.pageSize = 10;
			vm.pageNumber = 0;
			vm.chartProp = 'smsMessagesCount';
	
	
	
			function onInit() {
				vm.dateType = ReportsData.dateType;
				vm.currentType = vm.dateType[0];
				vm.showChart = true;
	
				vm.consultantList = [];
				vm.SessionManager = SessionManager;
				vm.authRolesConst = authRolesConst;
				setTripleView();
	
				getFilteredSMSMessagesList();
			}
	
			function getFilteredSMSMessagesList() {
				vm.pageNumber = 0;
				getReport();
				getChart();
			}
	
	
			function getReport() {
				// getFilterDates();
				// getContactFilter();
				DynamicFactory.get('reportsCosult', 'GetSmsReport')(vm.getParams()).then(
					function (report) {
						vm.report = angular.copy(report);
						generatePages();
					},
					function (error) {
						console.log("Problem z pobraniem GetSmsReport");
					});
			}
	
			function showHostorySession(event, sessionID) {
				event.stopImmediatePropagation();
				
				$mdDialog.show({
					clickOutsideToClose: true,
					//openFrom : { width: 1000 },
					controller: 'reportsSession',
					controllerAs: 'vm',
					focusOnOpen: false, 
					targetEvent: event,
					templateUrl: 'app/main/contactcenter/reports/components/reportstatssms/reportssession/reportssession.html',
					multiple: true,
					locals:{
						sessionID: sessionID
					}
				});
			}

	
			function changeAgrType(prop) {
				vm.currentType = prop;
				getChart();
			}
	
			function changeChart(prop) {
				vm.chartProp = prop;
				generateChart(vm.chartSource);
			}
	
	
			function getChart() {
				// getFilterDates();
				setChartPlugin();
				if (tripleviewService.sidenavData.finalDate) setWidthOnChart(tripleviewService.sidenavData.finalDate.date);
				DynamicFactory.get('reportsCosult', 'GetSmsMessagesStatisticsForChart')(vm.getParams()).then(
					generateChart,
					function (error) {
						console.log("Wystapił błąd podczas pobierania statystyk wiadomości sms/mms do wyrysowania wykresu");
					});
			}
	
	
	
			function generateChart(callsStatistics) {
				vm.chartSource = callsStatistics;
				if (callsStatistics.length > 0) {
					var chart = [];
					var dateArray = ReportTools.dateInBetween(vm.currentType.key, tripleviewService.sidenavData.params);
	
					chart.push({
						key: 'połączenia',
						values: generateSeriesForPeriod(_.reverse(_.sortBy(callsStatistics, vm.chartProp)), dateArray)
					});
	
					vm.mainChart.data = chart;
				}
	
			}
	
			function generateSeriesForPeriod(period, dateArray) {
				return _.sortBy(dateArray.map(function (date) {
					var item = _.find(period, {
						timePeriod: date
					});
					if (item) {
						return {
							color: ReportsData.getNextColor(),
							x: item.timePeriod,
							y: item[vm.chartProp] || 0
						}
					} else {
						return {
							x: date,
							y: 0
						}
					}
				}), function (o) {
					return new Date(o.x);
				});
			}
	
			function setWidthOnChart(data) {
				vm.mainChart.options.chart.width = undefined;
			}
	
	
	
			function chartTimeFormat(d) {
				if (vm.chartProp !== 'count') {
					return ReportTools.formatSecs(d);
				} else return d.toString();
			}
	
			function setChartPlugin() {
				vm.dateType = ReportsData.dateType;
				// vm.currentType = 'MM-YYYY';
	
				var mainChart = angular.copy(ReportsData.defaultChartConf);
				mainChart.options.chart.color = function color() {
					return '#2799f3'; //'#5fd4c4'
				};
				mainChart.options.chart.height = 250;
				mainChart.options.chart.type = 'discreteBarChart';
				mainChart.options.chart.width = null;
				mainChart.options.chart.showValues = false;
	
				mainChart.options.chart.xAxis = {
					tickFormat: function (d) {
						if (vm.currentType.value == 'D') {
							var daysTotal = moment.duration(tripleviewService.sidenavData.params.To.diff(tripleviewService.sidenavData.params.From)).asDays();
							var fromToTick = moment.duration(moment(d, 'DD-MM-YYYY').diff(tripleviewService.sidenavData.params.From)).asDays();
							if (daysTotal > 32) {
								if (Math.round(fromToTick) % 8 == 0) {
									return d;
								} else {
									return '';
								}
							}
						}
						return d;
					},
					rotateLabels: -20
				};
				mainChart.options.chart.tooltip = {
					keyFormatter: function (d, i) {
						return d;
					}
				}
				mainChart.options.chart.yAxis = {
					tickFormat: chartTimeFormat
				};
				mainChart.options.chart.valueFormat = chartTimeFormat;
				vm.mainChart = mainChart;
				ReportsData.resetNextColor();
	
			}
	
	
			function setPage(newPage) {
				vm.pageNumber = newPage;
				getReport();
			}
	
			function generatePages() {
				vm.reportPages = [];
				if (!vm.report[0]) {
					return;
				}
				var totalPages = Math.round(vm.report[0].smsMessagesTotal / vm.pageSize + 0.5)
				console.log('reportStatsCallsPerConsultant | total pages=', totalPages);
				for (var i = 0; i < totalPages; i++) {
					vm.reportPages.push(i);
				}
			}
	
	
			function setTripleView() {
				tripleviewService.sidenavData.getConnectData = getFilteredSMSMessagesList;
				vm.getParams = ReportTools.configReportParams({
					CallcenterId: SessionManager.getUserRoleId() !== authRolesConst.consultant,
					ConsultantId: SessionManager.getUserRoleId() !== authRolesConst.consultant,
					agreagation: true,
					direction: true,
					msisdn: SessionManager.getUserRoleId() !== authRolesConst.consultant,
					type: true
				}, currentPage);
			}
			function currentPage() {
				return {
					AggregationType: vm.currentType.value,
					StartIndex: (vm.pageSize * vm.pageNumber) + 1,
					PageSize: vm.pageSize
				};
			}
	
			function downloadXLSX() {
				DynamicFactory.get('reportsCosult', 'reportsSmsMessagesExport')(vm.getParams())
					.then(DynamicFactory.get('FileUploadRsc', 'downloadFile')('ReportMessageList.csv'));
				// alasql("SELECT consultantName,id,guid,la,msisdn,type,direction,title,body,attachmentUrls,insertionTime  INTO XLSX('" + ("RaportSMS_" + moment().format()) + ".xlsx',{headers:true}) FROM ? ", [vm.MessagesList]);
			}
		}
})();

(function() {
    'use strict';

    angular
        .module('contactcenter.reports')
        .component('reportStatsChat', {
            templateUrl: 'app/main/contactcenter/reports/components/reportstatschat/reportstatschat.html',
            controllerAs: 'vm',
            controller: reportStatsChat
        })

        /** @ngInject */
        function reportStatsChat(tripleviewService) {
            var vm = this; // jshint ignore:line

            vm.$onInit = onInit;

            function onInit() {
                
                tripleviewService.sidenavData.config = {
                    type: false,
                    direction: false,
                    callcenter: false
                }
            } // the end onInit;
        }
})();
(function() {
    'use strict';

    angular
        .module('contactcenter.reports')
        .component('reportsInfoBox', {
            templateUrl: 'app/main/contactcenter/reports/components/reportsinfobox/reportsinfobox.html',
            controllerAs: 'vm',
			require: {
				tripleView: '^tripleView'
			},
            controller: controller,
            bindings: {
                reportsLength: '<',
                out: '<',
                in: '<'
			}
        });

        /** @ngInject */
        function controller() {
            var vm = this; // jshint ignore:line

            vm.$onInit = onInit;

            function onInit() {
            }
        }

})();
(function () {
  'use strict';

  angular
    .module('contactcenter.reports')
    .component('reportStatsCalls', {
      templateUrl: 'app/main/contactcenter/reports/components/reportstatscalls/reportstatscalls.html',
      controllerAs: 'vm',
      require: {
        tripleView: '^tripleView'
      },
      controller: reportstatscalls
    });

  /** @ngInject */
  function reportstatscalls(DynamicFactory, SessionManager, authRolesConst, tripleviewService, consts, ReportTools, ReportsData) {
    var vm = this;
    // var userInfo = SessionManager.getUser();

    vm.changeAgrType = changeAgrType;
    vm.changeChart = changeChart;
    vm.playRecording = playRecording;
    vm.downloadXLSX = downloadXLSX;
    // tripleviewService.sidenavData.showChart = showChart;
    vm.setPage = setPage;
    vm.$onInit = onInit;
    vm.formatSecs = ReportTools.formatSecs;

    vm.timeChart = 'miesięczny';
    vm.pageSize = 10;
    vm.pageNumber = 0;
    vm.chartProp = 'count';



    function onInit() {
      vm.dateType = ReportsData.dateType;
      vm.currentType = vm.dateType[0];
      vm.showChart = true;

      vm.consultantList = [];
      vm.SessionManager = SessionManager;
      vm.authRolesConst = authRolesConst;
      setAudioPlayer();
      setTripleView();

      getFilteredServiceCallsStatistics();
    }

    function getFilteredServiceCallsStatistics() {
      vm.pageNumber = 0;
      vm.tagsColumn = tripleviewService.sidenavData.params.partnerAgr ? angular.copy(tripleviewService.sidenavData.params.tagsAgr) : false;
      vm.partnerColumn = angular.copy(tripleviewService.sidenavData.params.partnerAgr);
      // if (vm.SessionManager.getUserRoleId() !== vm.authRolesConst.consultant) {
      //   ReportTools.getConsultantList().then(function (result) {
      //     vm.filtersConsultants = result;
      //     getReport();
      //     getChart();
      //   });
      // } else {
        getReport();
        getChart();

      // }
    }

    // function getParams(){
    //   getFilterDates();
    //   return {
    //     From: tripleviewService.sidenavData.params.From,
    //     To: tripleviewService.sidenavData.params.To,
    //     msisdn: tripleviewService.sidenavData.msisdn || undefined,
    //     consultantId: tripleviewService.sidenavData.userID,
    //     callcenterId: tripleviewService.sidenavData.id,
    //     startIndex: (vm.pageSize * vm.pageNumber) + 1,
    //     pageSize: vm.pageSize,
    //     AggregationType: vm.currentType.value
    //   };
    // }


    function getReport() {
      // getFilterDates();
      // getContactFilter();
      DynamicFactory.get('reportsCosult', 'GetConnections')(vm.getParams()).then(
        function (contactcenterStats) {
          vm.report = angular.copy(contactcenterStats);
          vm.resultColumn = angular.copy(tripleviewService.sidenavData.params.showFailed);

          generatePages();
        },
        function (error) {
          console.log("Problem z pobraniem IVRServiceConnections");
        });
    }


    function changeAgrType(prop) {
      vm.currentType = prop;
      getChart();
    }

    function changeChart(prop) {
      vm.chartProp = prop;
      generateChart(vm.chartSource);
    }


    function getChart() {
      // getFilterDates();
      setChartPlugin();
      if (tripleviewService.sidenavData.finalDate) setWidthOnChart(tripleviewService.sidenavData.finalDate.date);

      DynamicFactory.get('reportsCosult', 'GetConnectionsStatisticsForChart')(vm.getParams()).then(
          generateChart,
        function (error) {
          console.log("Wystapił błąd podczas pobierania statystyk wiadomości sms/mms do wyrysowania wykresu");
        });
    }

    function generateChart(callsStatistics) {
      vm.chartSource = callsStatistics;
      if (callsStatistics.length > 0) {
        var chart = [];
        var dateArray = ReportTools.dateInBetween(vm.currentType.key, tripleviewService.sidenavData.params);

        chart.push({
          key: 'połączenia',
          values: generateSeriesForPeriod(_.reverse(_.sortBy(callsStatistics, vm.chartProp)), dateArray)
        });

        vm.mainChart.data = chart;
      }

    }

    function generateSeriesForPeriod(period, dateArray) {
      return _.sortBy(dateArray.map(function (date) {
        var item = _.find(period, {
          timePeriod: date
        });
        if (item) {
          return {
            color: ReportsData.getNextColor(),
            x: item.timePeriod,
            y: item[vm.chartProp] || 0
          }
        } else {
          return {
            x: date,
            y: 0
          }
        }
      }), function (o) {
        return new Date(o.x);
      });
    }

    function setWidthOnChart(data) {
      vm.mainChart.options.chart.width = undefined;
    }

    // function getFilterDates() {
    //   if (!tripleviewService.sidenavData.dateFrom && !tripleviewService.sidenavData.dateTo) {
    //     tripleviewService.sidenavData.params.From = tripleviewService.sidenavData.listDate[0].date.from;
    //     tripleviewService.sidenavData.params.To = tripleviewService.sidenavData.listDate[0].date.to;
    //   } else {
    //     tripleviewService.sidenavData.params.From = tripleviewService.sidenavData.dateFrom;
    //     tripleviewService.sidenavData.params.To = tripleviewService.sidenavData.dateTo;
    //   }
    // }

    function chartTimeFormat(d) {
      if (vm.chartProp !== 'count') {
        return ReportTools.formatSecs(d);
      } else return d.toString();
    }
    function setChartPlugin() {
      vm.dateType = ReportsData.dateType;
      // vm.currentType = 'MM-YYYY';

      var mainChart = angular.copy(ReportsData.defaultChartConf);
      mainChart.options.chart.color = function color() {
        return '#2799f3'; //'#5fd4c4'
      };
      mainChart.options.chart.height = 250;
      mainChart.options.chart.type = 'discreteBarChart';
      mainChart.options.chart.showValues = false;

      mainChart.options.chart.width = null;
      mainChart.options.chart.xAxis = {
        tickFormat: function (d) {
          if(vm.currentType.value == 'D'){
            var daysTotal = moment.duration(tripleviewService.sidenavData.params.To.diff(tripleviewService.sidenavData.params.From)).asDays();
            var fromToTick = moment.duration(moment(d,'DD-MM-YYYY').diff(tripleviewService.sidenavData.params.From)).asDays();
            if(daysTotal > 32){
              if(Math.round(fromToTick) % 8 == 0){
                return d;
              }else{
                return '';
              }
            }
          }
          return d; //vm.currentType === 'DD-MM-YYYY' ? d.split('-')[0] : vm.currentType === 'd' ? ReportsData.dayName[d] :
        },
        rotateLabels: -20
      };
      mainChart.options.chart.tooltip = {
        keyFormatter: function (d, i) {
          return d;
        }
      }
      mainChart.options.chart.yAxis = {
        tickFormat: chartTimeFormat
      };
      mainChart.options.chart.valueFormat = chartTimeFormat;
      vm.mainChart = mainChart;
      ReportsData.resetNextColor();

    }


    function setPage(newPage) {
      pauseAudio();
      vm.pageNumber = newPage;
      getReport();
    }

    function generatePages() {
      var totalCount = vm.report[0] ? vm.report[0].totalCount : 0;
      
      var totalPages = Math.round(totalCount / vm.pageSize + 0.5)
      console.log('reportStatsCallsPerConsultant | total pages=', totalPages);
      vm.reportPages = [];
      for (var i = 0; i < totalPages; i++) {
        vm.reportPages.push(i);
      }
    }


    function setTripleView() {
      tripleviewService.sidenavData.getConnectData = getFilteredServiceCallsStatistics;
      // tripleviewService.sidenavData.showChart = showChart;
      // tripleviewService.sidenavData.config = {
      //   consultantList: true,
      //   // showChart: true,
      //   msisdn:  true
      //   // reportSearch : {
      //   //   // objList: result,
      //   //   filter: 'contactId',
      //   //   label: 'REPORTS.CONTACT',
      //   //   format: formatContact,
      //   //   dataProp: 'contactId'
      //   // }
      // };
      vm.getParams = ReportTools.configReportParams({
        // consultantList: true,
        // showChart: true,
        ConsultantId:true,
        msisdn:  true,
        showFailed: true
        //email: true,
        // reportSearch : {
        //   // objList: result,
        //   filter: 'contactId',
        //   label: 'REPORTS.CONTACT',
        //   format: formatContact,
        //   dataProp: 'contactId'
        // }
      },currentPage);
      tripleviewService.sidenavData.agregationDate = [];
      tripleviewService.sidenavData.duration = 3;
      tripleviewService.sidenavData.startValue = '';
    }

    function currentPage(){
         return {
          AggregationType: vm.currentType.value,
           StartIndex: (vm.pageSize * vm.pageNumber) + 1,
           PageSize: vm.pageSize
         }
       }
    // function getContactFilter() {
    //   getFilterDates();
    //   if (SessionManager.getUserRoleId() !== authRolesConst.consultant){
    //     DynamicFactory.get('reportsCosult', 'ContactConnectionsList')(tripleviewService.sidenavData.params.From, tripleviewService.sidenavData.params.To).then(function (result) {
    //       tripleviewService.sidenavData.config.reportSearch.objList = result;
    //     });
    //   }
    // }

    // function formatContact(item) {
    //   return item.contactId.toString();
    // }

    function setAudioPlayer() {
      vm.audio = new Audio();

      vm.audio.onerror = function () {
        vm.audio.pause();
        vm.audio.currentTime = 0.0;
        setTimeout(function () {
          if (vm.consultant.callStatus == 1) {
            loadAudio();
          }
        }, 5000);
      };
      vm.audio.onloadstart = function () {
        vm.loading = true;
        console.log('reportStatsCalls | audio buffering!');
      };
      vm.audio.onended = function () {
        playRecording(vm.currentPlaying);
        console.log('reportStatsCalls | audio ended!');
      };
      vm.audio.onloadeddata = function () {
        vm.loading = false;
        vm.currentPlaying.isPlaying = true;
        playAudio();
        // }
        console.log('reportStatsCalls | audio ready to play!', vm.audio.buffered.end(0), vm.audio.seekable, vm.audio.buffered);
      };
      vm.audio.oncanplay = function () {
        console.log('reportStatsCalls | oncanplay!');
      };
    }

    function playAudio() {
      vm.audio.play();
    }

    function pauseAudio() {
      vm.audio.pause();
    }

    function playRecording(call) {
      if(vm.currentPlaying && vm.currentPlaying.isPlaying){
        vm.currentPlaying.isPlaying = false;
        pauseAudio()
      }
      if(call != vm.currentPlaying){
        vm.audio.src = consts.recordings + call.bridgeId;
        vm.currentPlaying = call;
        vm.audio.load();
      } else {
        vm.currentPlaying = undefined;
      }

    }

    function downloadXLSX() {
      DynamicFactory.get('reportsCosult', 'ReportsConnectionsExport')(vm.getParams())
      .then(DynamicFactory.get('FileUploadRsc','downloadFile')('ReportsConnections.csv'));
      // alasql("SELECT id,msisdn,serviceName,start,stop,serviceID,time_sec,consultantName,eventName,bridgeId,isPath INTO XLSX('" + ("RaportPołączeń_" + moment().format()) + ".xlsx',{headers:true}) FROM ? ", [vm.report]);
    }








































    // function onInit() {
    //   //vm.loading = true;
    //   //vm.ReportsConnectionsByCallCenterID = DynamicFactory.get('reportsCosult', 'ReportsConnectionsByCallCenterID');
    //   //vm.propertyName = '';
    //   //vm.reverse = false;
    //   //vm.callCenterId = '';
    //   //vm.loaderShow = false;
    //   //vm.isSelected = false;
    //   //vm.getCallReports = false;

    //   //vm.showmsg = false;
    //   //vm.propertyName = '';
    //   vm.showChart = true;
    //   vm.navBarConfig = headerConfig.navBar;
    //   vm.consultantList = [];
    //   vm.showChart = true;
    //   setAudioPlayer();
    //   setTripleView();
    //   setDataTablesPlugin();
    //   setChartPlugin();
    // } // the end onInit;
    // jshint ignore:line

    //#region TripleView

    // function setTripleView() {
    //   var user = SessionManager.getUser();

    //   tripleviewService.sidenavData.getConnectData = getFilteredConnectionsList;

    //   tripleviewService.sidenavData.getCallcenterPerManager = getCallcenterPerManager;
    //   //tripleviewService.sidenavData.generateConsultantPerContactCenter = generateConsultantPerContactCenter;
    //   // tripleviewService.sidenavData.generateDate = generateDate;
    //   tripleviewService.sidenavData.errorMsg = '';

    //   tripleviewService.sidenavData.ccidErrorInput = false;
    //   // tripleviewService.sidenavData.listDate = chooseDateTime.listDate;
    //   tripleviewService.sidenavData.consultantsPerCC = [];

    //   if (SessionManager.getUserRoleId() === authRolesConst.admin) {
    //     generateConsultantPerContactCenter();
    //     getCallcenterPerManager();
    //     tripleviewService.sidenavData.config = {
    //       type: false,
    //       direction: false,
    //       callcenter: true,
    //       consultantList: true,
    //       agreagation: false,
    //       timeAgr: false,
    //       showChart: true
    //     };

    //     vm.isAdmin = true;
    //   } else if (SessionManager.getUserRoleId() === authRolesConst.manager) {
    //     generateConsultantPerContactCenter();
    //     getCallcenterPerManager();
    //     tripleviewService.sidenavData.config = {
    //       type: false,
    //       direction: false,
    //       callcenter: false,
    //       consultantList: true,
    //       agreagation: false,
    //       timeAgr: false,
    //       showChart: true
    //     };

    //     vm.isManager = true;
    //     tripleviewService.sidenavData.id = user.callCenterId;
    //   } else {
    //     tripleviewService.sidenavData.config = {
    //       type: false,
    //       direction: false,
    //       callcenter: false,
    //       consultantList: false,
    //       agreagation: false,
    //       timeAgr: false,
    //       showChart: true
    //     };

    //     vm.isConsultant = true;
    //     tripleviewService.sidenavData.id = user.callCenterId;
    //     tripleviewService.sidenavData.userID = user.consultantId;
    //   }
    // }

    // function generateDate(date) {
    //   tripleviewService.sidenavData.dateFrom = date.from;
    //   tripleviewService.sidenavData.dateTo = date.to;
    //   setLastDateToAnyDate(date);

    //   tripleviewService.sidenavData.disableDate = date.disabled;
    // }

    // function setLastDateToAnyDate(date) {
    //   var anyDate = _.filter(tripleviewService.sidenavData.listDate, {
    //     'name': 'Dowolna data'
    //   });
    //   _.forEach(anyDate, function (value) {
    //     value.date.from = date.from;
    //     value.date.to = date.to;
    //   });
    // }

    //#endregion

    //#region Chart Plugin
    // function setChartPlugin() {
    //   vm.dateType = ReportsData.dateType;
    //   vm.currentType = 'MM-YYYY';

    //   vm.mainChart = ReportsData.defaultChartConf;
    //   vm.mainChart.options.chart.color = function color() {
    //     return '#2799f3'; //'#5fd4c4'
    //   };
    //   vm.mainChart.options.chart.height = 250;
    //   vm.mainChart.options.chart.type = 'discreteBarChart';
    //   vm.mainChart.options.chart.width = null;
    //   vm.mainChart.options.chart.xAxis = {
    //     tickFormat: function (d) {
    //       return d; //vm.currentType === 'DD-MM-YYYY' ? d.split('-')[0] : vm.currentType === 'd' ? ReportsData.dayName[d] :
    //     }
    //   };

    //   getDataForChart(vm.currentType);
    // }

    // function getDataForChart(key) {
    //   var aggregationType;

    //   var callCenterId = tripleviewService.sidenavData.id;
    //   var consultantId = tripleviewService.sidenavData.userID;
    //   var raportFromDate;
    //   var reportToDate;

    //   if (!tripleviewService.sidenavData.dateFrom && !tripleviewService.sidenavData.dateTo) {
    //     raportFromDate = tripleviewService.sidenavData.listDate[0].date.from;
    //     reportToDate = tripleviewService.sidenavData.listDate[0].date.to;
    //   } else {
    //     raportFromDate = tripleviewService.sidenavData.dateFrom;
    //     reportToDate = tripleviewService.sidenavData.dateTo;
    //   }

    //   vm.currentType = key;

    //   if (vm.currentType === 'MM-YYYY') {
    //     aggregationType = 'M';
    //     vm.timeChart = 'miesięczne';
    //   } else if (vm.currentType === 'DD-MM-YYYY') {
    //     aggregationType = 'D';
    //     vm.timeChart = 'dzienne';
    //   } else {
    //     aggregationType = 'H';
    //     vm.timeChart = 'godzinowe';
    //   }

    //   if (tripleviewService.sidenavData.finalDate) setWidthOnChart(tripleviewService.sidenavData.finalDate.date);
    //   vm.mainChart.data = [];

    //   DynamicFactory.get('reportsCosult', 'GetConnectionsStatisticsForChart')(raportFromDate, reportToDate, consultantId, callCenterId, aggregationType).then(
    //     function (callsStatistics) {
    //       vm.callsStatistics = callsStatistics;
    //       if (callsStatistics.length > 0) {

    //         var dateArray = ReportTools.dateInBetween(vm.currentType, tripleviewService.sidenavData);

    //         vm.mainChart.data.push({
    //           key: 'połączenia',
    //           values: []
    //         });

    //         var callsCount;

    //         _.forEach(dateArray, function (value, key) {
    //           callsCount = getCount(callsStatistics, dateArray[key]);
    //           vm.mainChart.data[0].values.push({
    //             x: dateArray[key],
    //             y: callsCount
    //           });
    //         });
    //       }

    //     },
    //     function (error) {
    //       console.log('Nie pobrano statystyk połączeń do wyrysowania wykresu');
    //     });
    // }

    // function getCount(array, timePeriod) {
    //   var calls = _.find(array, function (item) {
    //     return item.timePeriod === timePeriod;
    //   });

    //   return calls !== undefined ? calls.count : 0;
    // }

    // function setWidthOnChart(data) {
    //   if (vm.currentType === 'DD-MM-YYYY') {
    //     if (data.id === 2) {
    //       vm.mainChart.options.chart.width = 4444;
    //     } else if (data.id === 3) {
    //       vm.mainChart.options.chart.width = 7777;
    //     } else {
    //       vm.mainChart.options.chart.width = null;
    //     }
    //     vm.mainChart.options.chart.xAxis = {
    //       "rotateLabels": 25
    //     };
    //   } else {
    //     vm.mainChart.options.chart.width = null;
    //     vm.mainChart.options.chart.xAxis = {
    //       "rotateLabels": 0
    //     };
    //   }
    // }

    //#endregion


    //#region DataTables Plugin
    // function setDataTablesPlugin() {
    //   vm.dtInstance = {};

    //   vm.dtOptions = DTOptionsBuilder.newOptions()
    //     //.setLoadingTemplate('<img src="images/loading.gif">')
    //     .withFnServerData(getConnectionsList)
    //     .withDataProp('data')
    //     .withOption('processing', false)
    //     .withOption('serverSide', true)
    //     .withOption('serverMethod', 'POST')
    //     .withOption('paging', true)
    //     .withPaginationType('full_numbers')
    //     .withOption('bLengthChange', true) //możliwość zmiany elementów na stronie
    //     .withOption('createdRow', createdRow)
    //     .withOption('filter', false)
    //     .withOption('bPaginate', false)
    //     .withOption('info', false)
    //     .withOption('scrollY', window.innerHeight - 645)
    //     .withOption('scrollX', '100%')
    //     .withOption('scrollCollapse', true)
    //     .withFixedColumns({
    //       leftColumns: 0,
    //       rightColumns: 0
    //     });

    //   setColumns();
    // }

    // function getConnectionsList(sSource, aoData, fnCallback, oSettings) {
    //   var draw = aoData[0].value;
    //   var order = aoData[2].value;
    //   var startIndex = aoData[3].value + 1;
    //   // var pageSize = aoData[4].value;
    // 	var pageSize = vm.showChart ? aoData[4].value : 18;


    //   var callCenterId = tripleviewService.sidenavData.id;
    //   var consultantId = tripleviewService.sidenavData.userID;
    //   var raportFromDate;
    //   var reportToDate;

    //   if (!tripleviewService.sidenavData.dateFrom && !tripleviewService.sidenavData.dateTo) {
    //     raportFromDate = tripleviewService.sidenavData.listDate[0].date.from;
    //     reportToDate = tripleviewService.sidenavData.listDate[0].date.to;
    //   } else {
    //     raportFromDate = tripleviewService.sidenavData.dateFrom;
    //     reportToDate = tripleviewService.sidenavData.dateTo;
    //   }

    //   var records = {
    //     'draw': 0,
    //     'recordsTotal': 0,
    //     'recordsFiltered': 0,
    //     'data': []
    //   };

    //   DynamicFactory.get('reportsCosult', 'GetConnections')(raportFromDate, reportToDate, consultantId, callCenterId, startIndex, pageSize).then(
    //     function (connectionsList) {
    //       vm.connectionList = connectionsList;
    //       if (connectionsList.length > 0) {
    //         vm.connectionsList = {};
    //         records = {
    //           'draw': draw,
    //           'recordsTotal': connectionsList[0].callsTotal,
    //           'recordsFiltered': connectionsList[0].callsTotal,
    //           'data': connectionsList
    //         };
    //       }

    //       fnCallback(records);
    //     },
    //     function (error) {
    //       fnCallback(records);
    //       console.log("wystapił błąd podczas pobierania GetConnections");
    //     });
    // }

    // function getFilteredConnectionsList() {
    //   getDataForChart(vm.currentType);
    //   vm.dtInstance.rerender();
    // }

    // function setColumns() {
    //   if (vm.isAdmin) {
    //     setColumnsForAdmin();
    //   } else if (vm.isConsultant) {
    //     setColumnsForConsultant();
    //   } else {
    //     setColumnsForManager();
    //   }
    // }

    // function setColumnsForAdmin() {
    //   vm.dtColumns = [
    //     DTColumnBuilder.newColumn('id').withTitle('Id').withOption('defaultContent', ""),
    //     DTColumnBuilder.newColumn('bridgeID').withTitle('Bridge ID').withOption('defaultContent', ""),
    //     DTColumnBuilder.newColumn('consultantName').withTitle('Imię Nazwisko').withOption('defaultContent', ""),
    //     DTColumnBuilder.newColumn('start').withTitle('Start').withOption('defaultContent', "").renderWith(dateHtml),
    //     DTColumnBuilder.newColumn('msisdn').withTitle('msisdn').withOption('defaultContent', ""),
    //     DTColumnBuilder.newColumn('serviceName').withTitle('Nazwa serwisu').withOption('defaultContent', ""),
    //     DTColumnBuilder.newColumn('time_sec').withTitle('Czas rozmowy').withOption('defaultContent', "").renderWith(timeHtml),
    //     DTColumnBuilder.newColumn(null).withTitle('Odsłuch').withOption('defaultContent', "").renderWith(actionHtml)
    //   ];
    // }

    // function setColumnsForManager() {
    //   vm.dtColumns = [
    //     DTColumnBuilder.newColumn('id').withTitle('Id').withOption('defaultContent', ""),
    //     DTColumnBuilder.newColumn('bridgeID').withTitle('Bridge ID').withOption('defaultContent', ""),
    //     DTColumnBuilder.newColumn('consultantName').withTitle('Imię i nazwisko').withOption('defaultContent', ""),
    //     DTColumnBuilder.newColumn('start').withTitle('Data').withOption('defaultContent', "").renderWith(dateHtml),
    //     DTColumnBuilder.newColumn('msisdn').withTitle('msisdn').withOption('defaultContent', ""),
    //     DTColumnBuilder.newColumn('serviceName').withTitle('Nazwa serwisu').withOption('defaultContent', ""),
    //     DTColumnBuilder.newColumn('time_sec').withTitle('Czas rozmowy').withOption('defaultContent', "").renderWith(timeHtml),
    //     DTColumnBuilder.newColumn(null).withTitle('Odsłuch').withOption('defaultContent', "").notSortable().renderWith(actionHtml)
    //   ];
    // }

    // function setColumnsForConsultant() {
    //   vm.dtColumns = [
    //     DTColumnBuilder.newColumn('id').withTitle('id').withOption('defaultContent', ""),
    //     DTColumnBuilder.newColumn('bridgeID').withTitle('Bridge ID').withOption('defaultContent', ""),
    //     DTColumnBuilder.newColumn('start').withTitle('Data').withOption('defaultContent', "").renderWith(dateHtml),
    //     DTColumnBuilder.newColumn('msisdn').withTitle('msisdn').withOption('defaultContent', ""),
    //     DTColumnBuilder.newColumn('serviceName').withTitle('Nazwa serwisu').withOption('defaultContent', ""),
    //     DTColumnBuilder.newColumn('time_sec').withTitle('Czas rozmowy').withOption('defaultContent', "").renderWith(timeHtml),
    //     DTColumnBuilder.newColumn(null).withTitle('Odsłuch').withOption('defaultContent', "").renderWith(actionHtml)
    //   ];
    // }

    // function createdRow(row, data, dataIndex) { //recompiling DataTable after its initialization is over
    //   $compile(angular.element(row).contents())($scope);
    // }

    // function dateHtml(data, type, full, meta) //[start] column
    // {
    //   return $filter('date')(data, 'dd-MM-yyyy HH:mm:ss');
    // }

    // function actionHtml(data, type, full, meta) //[bridgeCount] column
    // {
    //   full.isPlaying = false;
    //   vm.connectionsList[full.id] = full;

    //   if (!data) {
    //     return "<span class='play play--noRec'>" +
    //       "<img src='assets/icons/reports/close-button.svg' alt=''>" +
    //       "</span>"

    //     ///Dla konsultantów ukrywamy przycisk odgrywania dla CC na 17 piętrze

    //   } else if (data && SessionManager.getUserRoleId() !== authRolesConst.consultant) {
    //     return "<button class='play' ng-click='vm.playRecording(vm.connectionsList[" + full.id + "])'>" +
    //       "<icon>" +
    //       "<img ng-if='!vm.connectionsList[" + full.id + "].isPlaying' src='assets/icons/reports/play-button.svg'>" +
    //       "<img ng-if='vm.connectionsList[" + full.id + "].isPlaying' src='assets/icons/reports/pause-round-button.svg'>" +
    //       "</icon>" +
    //       "<md-tooltip>play/pause</md-tooltip>" +
    //       "</button>"
    //   }
    // }

    // function timeHtml(data, type, full, meta) {
    //   return $filter('timer')(data);
    // }

    //#endregion

    // function getCallcenterPerManager() {
    //   if (SessionManager.getUserRoleId() === authRolesConst.manager || SessionManager.getUserRoleId() === authRolesConst.admin) {
    //     DynamicFactory.get('reportsCosult', 'CallCenterList')().then(function (r) {
    //       tripleviewService.sidenavData.callCenterList = r;
    //       vm.state.id = 0;
    //     });
    //   }
    //   generateConsultantPerContactCenter();
    // }

    // function generateConsultantPerContactCenter() {
    //   tripleviewService.sidenavData.consultantsPerCC = [];
    //   var callcenterId;
    //   if(SessionManager.getUserRoleId() === authRolesConst.admin) {
    //     callcenterId = tripleviewService.sidenavData.id ? tripleviewService.sidenavData.id : null;
    //   } else {
    //     callcenterId = userInfo.callCenterId;
    //   }
    //   if (SessionManager.getUserRoleId() !== authRolesConst.consultant) {
    //     DynamicFactory.get('reportsCosult', 'ConsultansGet')(callcenterId).then(function (r) {
    //       tripleviewService.sidenavData.consultantsPerCC = r;
    //       vm.consultantList = r;
    //     });
    //   }
    // }



    // function showChart () {
    // 	vm.showChart = tripleviewService.sidenavData.showMyChart;
    // 	if(vm.showChart) {
    // 		document.querySelector('.chartForReports').classList.remove('listNoChart');
    // 	} else  {
    // 		document.querySelector('.chartForReports').classList.add('listNoChart');
    // 	}
    // 	getFilteredConnectionsList();
    // }
  }
})();

(function() {
  "use strict";

  angular.module("contactcenter.reports").component("reportFilters", {
    templateUrl: "app/main/contactcenter/reports/components/reportfilters/reportfilters.html",
    controllerAs: "vm",
    // require: {
    //     tripleView: '^tripleView'
    // },
    controller: reportfilters
  });
  /** @ngInject */
  function reportfilters(tripleviewService, SessionManager, authRolesConst, DynamicFactory, $filter, $q) {
    var vm = this; // jshint ignore:line

    tripleviewService.sidenavData.getConsultantList = getConsultantList;

    vm.consultantSearch = consultantSearch;
    vm.getCallcenterPerManager = getCallcenterPerManager;
    vm.generateConsultantPerContactCenter = generateConsultantPerContactCenter;
    vm.selectedItemChange = selectedItemChange;
    vm.SessionManager = SessionManager;
    vm.generateDate = generateDate;
    vm.detectChangeDate = detectChangeDate;
    vm.setAnyDate = setAnyDate;
    vm.authRolesConst = authRolesConst;
    vm.startHourChange = startHourChange;

    vm.$onInit = onInit;

    function onInit() {
      vm.sidenavData = tripleviewService.sidenavData;
      // var preserve = angular.copy(vm.sidenavData.config)
      // vm.sidenavData = {config: preserve};
      // getCallcenterPerManager();
      // if (!tripleviewService.sidenavData.params) {
      //   tripleviewService.sidenavData.params = {};
      // }
      vm.params = tripleviewService.sidenavData.params;

      getConsultantList();
      generateStartHours();
      vm.shiftCountingList = generateShiftCounters();
      // tripleviewService.sidenavData.listDate = chooseDateTime.listDate;
      // console.log('reportStatsCallsPerService |', vm.SessionManager.getUserRoleId() !== vm.authRolesConst.consultant && vm.sidenavData.config.consultantList)
    } // the end onInit

    function generateStartHours() {
      vm.startHours = [];
      for (var i = 0; i <= 24; i++) {
        vm.startHours.push(i);
      }
    }

    function generateShiftCounters() {
      return [
        { token: "Po dacie stop", value: "P" },
        { token: "Po dacie start", value: "T" },
        { token: "Po rzeczywistej dacie aktywności", value: "R" }
      ];
    }

    function startHourChange(hour) {
      tripleviewService.sidenavData.params.startHour = moment()
        .hour(hour)
        .minute(0);
      console.log("reportFilters | start hour set to ", tripleviewService.sidenavData.params.startHour);
    }

    function generateConsultantSearch() {
      vm.consultantSearchConf = {
        objList: vm.consultantList,
        filter: "userID",
        label: "REPORTS.CONSULTANT",
        format: formatConsultant
      };
    }

    function formatConsultant(item) {
      return item.firstName + " " + item.lastName + (item.alias ? "/" + item.alias : "");
    }
    //vm.params.From
    // vm.params.To
    // vm.sidenavData.type
    // vm.sidenavData.direction
    // vm.sidenavData.callcenter
    // vm.sidenavData.agreagation
    // vm.sidenavData.timeAgr
    // vm.sidenavData.showChart
    // vm.sidenavData.tagsAgr
    function generateDate(date) {
      vm.params.From = angular.copy(date.from);
      vm.params.To = angular.copy(date.to);
      setLastToAnyDate(date);
      // vm.sidenavData.disableDate = date.disabled;
      vm.sidenavData.disableDate = false;
    }

    function setLastToAnyDate(date) {
      var anyDate = _.filter(vm.sidenavData.listDate, {
        name: "Dowolna data"
      });
      _.forEach(anyDate, function(value) {
        value.date.from = angular.copy(date.from);
        value.date.to = angular.copy(date.to);
      });
    }

    function setAnyDate() {
      var anyDate = _.filter(vm.sidenavData.listDate, {
        name: "Dowolna data"
      })[0];
      if (vm.sidenavData.finalDate != anyDate) {
        setLastToAnyDate(vm.sidenavData.finalDate.date);
        vm.sidenavData.finalDate.date = anyDate.date;
      }
    }

    function detectChangeDate() {
      if (!moment.isMoment(vm.params.To)) {
        vm.params.To = moment(vm.params.To);
      }
      if (!moment.isMoment(vm.params.From)) {
        vm.params.From = moment(vm.params.From);
      }

      if (vm.params.To && vm.params.From) {
        var momentFrom = moment.isMoment(vm.params.From)
            ? vm.params.From
            : moment(vm.params.From)
                .add(1, "minutes")
                .startOf("day"),
          momentTo = moment.isMoment(vm.params.To)
            ? vm.params.To
            : moment(vm.params.To)
                .add(1, "minutes")
                .startOf("day");
        if (momentTo.isBefore(momentFrom) || momentFrom.isAfter(momentTo) || momentFrom.isSame(momentTo, "day")) {
          // momentTo = momentFrom.endOf('day');
          // momentFrom = momentFrom.startOf('day');
          vm.params.To = angular.copy(momentFrom.endOf("day"));
          vm.params.From = angular.copy(momentFrom.startOf("day"));
        }
        // if(momentFrom.isAfter(momentTo)){
        //   console.log('reportFilters | momentFrom isAfter momentTo switch:', momentFrom, momentTo.startOf('day'))
        //   momentFrom = momentTo.startOf('day');
        //   vm.params.From = momentFrom;
        // }
        // comparteFrom = moment.isMoment(vm.params.From) ? vm.params.From.toISOString() :

        // if(vm.params.To.toISOString() == vm.params.From.toISOString()){
        //   vm.params.To = vm.params.To.endOf('day');
        //   vm.params.From = vm.params.From.startOf('day');
        // }
        // var matchDate = _.find(vm.sidenavData.listDate, _.flow([
        //   _.flow(_.property('date.to'),function(date){
        //     return date.toDateString();
        //   }),
        //   function(dupa){
        //     console.log('dupa',dupa)
        //     return dupa;
        //   },_.partialRight(_.some, To.toDateString()
        //   )
        // ]));
        // var matchDate;
        // for (var i = 0; i < vm.sidenavData.listDate.length; i++) {
        //   var element = vm.sidenavData.listDate[i];
        //   console.log(element.date.to.toDateString(),To.toDateString())
        //   if(element.date.to.toDateString() == To.toDateString()){
        //     matchDate = element;
        //     break;
        //   }
        // }
        // if (matchDate) {
        //   vm.sidenavData.finalDate.date = matchDate;
        //   vm.generateDate(matchDate)

        // }
      }
    }

    function consultantSearch(text) {
      return $filter("filter")(vm.consultantList, {
        $: text
      });
    }

    function getConsultantList(refresh) {
      var defer = $q.defer();
      if (vm.consultantList && !refresh) {
        defer.resolve(vm.consultantList);
      } else {
        if (vm.lastPromise && !refresh) {
          $q.all([vm.lastPromise]).then(function(result) {
            defer.resolve(vm.consultantList);
          });
        } else {
          vm.lastPromise = getCallcenterPerManager();

          $q.all([vm.lastPromise]).then(function(data) {
            vm.consultantList = data[0];
            generateConsultantSearch();
            defer.resolve(vm.consultantList);
          });
        }
      }
      return defer.promise;
    }

    function getCallcenterPerManager() {
      var defer = $q.defer();

      if (SessionManager.getUserRoleId() === authRolesConst.manager || SessionManager.getUserRoleId() === authRolesConst.admin) {
        DynamicFactory.get("reportsCosult", "CallCenterList")().then(function(r) {
          tripleviewService.sidenavData.callCenterList = r;
        });
      }
      generateConsultantPerContactCenter().then(defer.resolve, defer.reject);
      return defer.promise;
    }

    function generateConsultantPerContactCenter() {
      var defer = $q.defer();
      // tripleviewService.sidenavData.consultantsPerCC = [];
      // var callcenterId;
      // if (SessionManager.getUserRoleId() === authRolesConst.admin) {
      //   callcenterId = vm.params.CallcenterId ? vm.params.CallcenterId : null;
      // } else {
      //   callcenterId = SessionManager.getUser().callCenterId;
      // }

      if (SessionManager.getUserRoleId() !== authRolesConst.admin) {
        vm.params.CallcenterId = SessionManager.getUser().callCenterId;
      }

      if (SessionManager.getUserRoleId() !== authRolesConst.consultant) {
        DynamicFactory.get("reportsCosult", "ConsultansGet")(vm.params.CallcenterId).then(function(r) {
          tripleviewService.sidenavData.consultantsPerCC = r;
          vm.consultantList = r;
          defer.resolve(r);
        }, defer.reject);
      }
      return defer.promise;
    }

    function selectedItemChange(consultant) {
      if (consultant) {
        vm.params.ConsultantId = consultant.userID;
      } else {
        vm.params.ConsultantId = undefined;
      }
    }

    function reportSearch(text) {
      return $filter("filter")(vm.sidenavData.config.reportSearch.ObjList, {
        $: text
      });
    }

    function selectedReportItem(selectedObject) {
      return vm.sidenavData.config.reportSearch.filter ? selectedObject[vm.sidenavData.config.reportSearch.filter] : selectedObject;
    }

    function formatReportObj(item) {
      var format = vm.sidenavData.config.reportSearch.format;
      return format ? (angular.isFunction(format) ? format(item) : item[format]) : item;
    }
  }
})();

(function () {
	'use strict';

	angular
		.module('contactcenter.reports')
		.component('reportSessions', {
			templateUrl: 'app/main/contactcenter/reports/components/reportsessions/reportsessions.html',
			controllerAs: 'vm',
			require: {
				tripleView: '^tripleView'
			},
			controller: controller
		});

	/** @ngInject */
	function controller(DynamicFactory, SessionManager, authRolesConst, tripleviewService, ReportsData, ReportTools, toastService, $mdDialog) {
		var vm = this; // jshint ignore:line


		vm.changeAgrType = changeAgrType;
		vm.changeChart = changeChart;
		vm.showHostorySession = showHostorySession;
		vm.downloadXLSX = downloadXLSX; 
		// tripleviewService.sidenavData.showChart = showChart;
		vm.setPage = setPage;
		vm.$onInit = onInit;
		vm.formatSecs = ReportTools;
		vm.copyGuid = copyGuid;
		vm.loading = false;

		vm.timeChart = 'miesięczny';
		vm.pageSize = 10;
		vm.pageNumber = 0;
		vm.chartProp = 'sessionsCount';

		function onInit() {
			vm.dateType = ReportsData.dateType;
			vm.currentType = vm.dateType[0];
			vm.showChart = true;

			vm.consultantList = [];
			vm.SessionManager = SessionManager;
			vm.authRolesConst = authRolesConst;
			// setAudioPlayer();
			setTripleView();

			getFilteredSessionsList();
		}

		function getFilteredSessionsList() {
			vm.pageNumber = 0;
			vm.loading = true;
			getReport();
			getChart();
		}


		function getReport() {
			DynamicFactory.get('reportsCosult', 'reportsSessions2')(vm.getParams()).then(
				function (report) {
					console.log('report sessions list => ', report);
					vm.report = angular.copy(report);
					generatePages();
					vm.loading = false;
				},
				function (error) {
					vm.loading = false;
					console.log("Problem z pobraniem reportsSessions");
				});
		}

		

		function showHostorySession(event, sessionID) {
			event.stopImmediatePropagation();

			$mdDialog.show({
				clickOutsideToClose: true,
				controller: 'transcription',
				controllerAs: 'vm',
				focusOnOpen: false,
				targetEvent: event,
				templateUrl: 'app/main/contactcenter/reports/components/reportsessions/transcription/transcription.html',
				multiple: false,
				locals: {
					sessionID: sessionID
				}
			});
		}

		function changeAgrType(prop) {
			vm.currentType = prop;
			getChart();
		}

		function changeChart(prop) {
			vm.chartProp = prop;
			generateChart(vm.chartSource);
		}


		function getChart() {
			setChartPlugin();
			if (tripleviewService.sidenavData.finalDate) {
				setWidthOnChart(tripleviewService.sidenavData.finalDate.date);
			}
			DynamicFactory.get('reportsCosult', 'ReportsSessions2ForChart')(vm.getParams()).then(
				generateChart,
				function (error) {
					console.log("Wystapił błąd podczas pobierania statystyk wiadomości sms/mms do wyrysowania wykresu");
				});
		}

		function generateChart(callsStatistics) {
			vm.chartSource = callsStatistics;
			if (callsStatistics.length > 0) {
				var chart = [];
				var dateArray = ReportTools.dateInBetween(vm.currentType.key, tripleviewService.sidenavData.params);

				chart.push({
					key: 'połączenia',
					values: generateSeriesForPeriod(_.reverse(_.sortBy(callsStatistics, vm.chartProp)), dateArray)
				});
				vm.mainChart.data = chart;
			}
		}

		function generateSeriesForPeriod(period, dateArray) {
			return _.sortBy(dateArray.map(function (date) {
				var item = _.find(period, {
					timePeriod: date
				});
				if (item) {
					return {
						color: ReportsData.getNextColor(),
						x: item.timePeriod,
						y: item[vm.chartProp] || 0
					}
				} else {
					return {
						x: date,
						y: 0
					}
				}
			}), function (o) {
				return new Date(o.x);
			});
		}

		function setWidthOnChart(data) {
			vm.mainChart.options.chart.width = undefined;
		}



		function chartTimeFormat(d) {
			if (vm.chartProp !== 'count') {
				return d;//ReportTools.formatSecs(d);
			} else return d.toString();
		}

		function setChartPlugin() {
			vm.dateType = ReportsData.dateType;

			var mainChart = angular.copy(ReportsData.defaultChartConf);
			mainChart.options.chart.color = function color() {
				return '#2799f3';
			};
			mainChart.options.chart.height = 250;
			mainChart.options.chart.type = 'discreteBarChart';
			mainChart.options.chart.width = null;
			mainChart.options.chart.showValues = false;

			mainChart.options.chart.xAxis = {
				tickFormat: function (d) {
					if (vm.currentType.value == 'D') {
						var daysTotal = moment.duration(tripleviewService.sidenavData.params.To.diff(tripleviewService.sidenavData.params.From)).asDays();
						var fromToTick = moment.duration(moment(d, 'DD-MM-YYYY').diff(tripleviewService.sidenavData.params.From)).asDays();
						if (daysTotal > 32) {
							if (Math.round(fromToTick) % 8 == 0) {
								return d;
							} else {
								return '';
							}
						}
					}
					return d;
				},
				rotateLabels: -20
			};
			mainChart.options.chart.tooltip = {
				keyFormatter: function (d, i) {
					return d;
				}
			}
			mainChart.options.chart.yAxis = {
				tickFormat: chartTimeFormat
			};
			mainChart.options.chart.valueFormat = chartTimeFormat;
			vm.mainChart = mainChart;
			ReportsData.resetNextColor();

		}


		function setPage(newPage) {
			vm.pageNumber = newPage;
			getReport();
		}

		function generatePages() {
			vm.reportPages = [];
			if (!vm.report[0]) {
				return;
			}
			var totalPages = Math.round(vm.report[0].totalCount / vm.pageSize + 0.5);
			console.log('reportStatsCallsPerConsultant | total pages=', totalPages);
			for (var i = 0; i < totalPages; i++) {
				vm.reportPages.push(i);
			}
		}


		function setTripleView() {
			tripleviewService.sidenavData.getConnectData = getFilteredSessionsList;

			vm.getParams = ReportTools.configReportParams({
				CallcenterId: SessionManager.getUserRoleId() !== authRolesConst.consultant,
				ConsultantId: SessionManager.getUserRoleId() !== authRolesConst.consultant,
				agreagation: true,
				direction: false,
				msisdn: SessionManager.getUserRoleId() !== authRolesConst.consultant,
				type: false,
				sessionId: true,
				contactName: true
			}, currentPage);
		}

		function currentPage() {
			return {
				AggregationType: vm.currentType.value,
				StartIndex: (vm.pageSize * vm.pageNumber) + 1,
				PageSize: vm.pageSize
			};
		}

		function copyGuid(message) {
			if (!message.sessionID) {
				toastService.showToast('Brak GUID', 'error', 10);
			} else {
				navigator.clipboard.writeText(message.sessionID).then(function () {
					toastService.showToast('GUID skopiowany', 'success', 10);
					/* clipboard successfully set */
				}, function () {
					toastService.showToast('Nie udało się skopiować GUID', 'error', 10);
					/* clipboard write failed */
				});
			}
		}



		function downloadXLSX() {
			DynamicFactory.get('reportsCosult', 'reportsSessions2Export')(vm.getParams())
				.then(DynamicFactory.get('FileUploadRsc', 'downloadFile')('Sessions_' + tripleviewService.sidenavData.params.From + '_' + tripleviewService.sidenavData.params.To + '.csv'));
		}
	}
})();

-function () {
  'use strict';
  angular
    .module('contactcenter.reports')
    .component('consultantChanalsActivity', {
      templateUrl: 'app/main/contactcenter/reports/components/consultantChannelsActivity/consultantChannelsActivity.html',
      bindings: {
        currConsultantId: '=',
        personalAccount: '='
      },
      controllerAs: 'vm',
      controller: controller1
    });

  function controller1(DynamicFactory,ReportsData,$translate) {
    var vm = this; // jshint ignore:line

    vm.$onInit = onInit;

    vm.options = {
      chart: {
        type: 'pieChart',
        height: 350,
        noData: $translate.instant('REPORTS.NO_DATA'),

        x: function (d) {
          if('CFS'.includes(d.type)){
          return d.typeLabel +' ('+d.count+' szt.)';
          }else{
             return d.typeLabel +' ('+d.count+' min)';
          }
        },
        y: function (d) {
          return d.count;
        },
        showLabels: true,
        duration: 500,
        donut: true,
        donutRatio: 0.55,
        labelThreshold: 0.01,
        labelSunbeamLayout: true,
        labelType: 'percent',
        pieLabelsOutside: true,
        donutLabelsOutside: true,
        color : _.map(ReportsData.donutChartColors, 'color'),
        legend: {
          width: 200,
          height: 200
          // padding: 50
        },
        legendPosition: 'top'


      }
    };



    function onInit() {
      if(vm.personalAccount){
        vm.currConsultantId=null;
      }
      var formDate=moment().add(-6, 'days').format('YYYY-MM-DD');
      var toDate= moment().format('YYYY-MM-DD');
      DynamicFactory.get('reportsCosult', 'ConsultnatChannelsActivity')(vm.currConsultantId,formDate,toDate ).then(function (data) {
        vm.chartData = data;
        angular.forEach(vm.chartData, function (e) {
          translateLabels(e);
        });
      });

    }

    function translateLabels(data) {
      if (data.type === 'C') {
        data.typeLabel = 'Czat';
      }
      else if (data.type === 'F') {
        data.typeLabel = 'facebook';
      } else if (data.type === 'S') {
        data.typeLabel = 'SMS';
      } else if (data.type === 'I') {
        data.typeLabel = 'Połączenia IN';
      } else if (data.type === 'V') {
        data.typeLabel = 'Callback';
      }

    }


  }
}();

(function ()
{
    'use strict';

    angular
        .module('contactcenter.reports')
        .controller('ContactDialogController', ContactDialogController);

    /** @ngInject */
    function ContactDialogController($mdDialog, Contact, Contacts, User, msUtils)
    {
        var vm = this;

        // Data
        vm.contact = angular.copy(Contact);
        vm.contacts = Contacts;
        vm.user = User;
        vm.newContact = false;
        vm.allFields = false;

        // Methods
        vm.closeDialog = closeDialog;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;

        //////////

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

    }
})();
/**
 * Created by akraszewski on 2017-05-26.
 */
(function () {
  angular
    .module('contactcenter.orderbox')
    .component('outlookView', {
      templateUrl: 'app/main/contactcenter/orderbox/views/outlook/outlookview.html',
      controllerAs: 'vm',
      bindings: {
        threads: '='
      },
      controller: outlookViewController
    });

  /** @ngInject */
  function outlookViewController(orderboxGlueConsts,OrderboxGlue) {

    var vm = this;


    vm.$onInit = onInit;

    function onInit() {
      vm.orderboxGlueConsts = orderboxGlueConsts;
      vm.OrderboxGlue = OrderboxGlue;
    }
  }
})();

/**
 * Created by akraszewski on 2017-05-26.
 */
(function () {
  angular
    .module('contactcenter.orderbox')
    .component('classicView', {
      templateUrl: 'app/main/contactcenter/orderbox/views/classic/classicview.html',
      controllerAs: 'vm',
      bindings: {
        threads: '=',
      },
      controller:  classicViewController
    });

  /** @ngInject */
  function classicViewController(OrderboxGlue,orderboxGlueConsts) {

    var vm = this;


    vm.$onInit = onInit;

    function onInit() {
      vm.orderboxGlueConsts = orderboxGlueConsts;
      vm.OrderboxGlue = OrderboxGlue;
      vm.currentThread = undefined;
    }
  }
})();

(function() {
  "use strict";

  angular.module("contactcenter.orderbox").component("composeCallbackDialog", {
    templateUrl: "app/main/contactcenter/orderbox/dialogs/composecallback/compose-callback-dialog.html",
    controllerAs: "vm",
    bindings: {
      callbackServices: "<"
    },
    controller: ComposeCallbackDialogController
  });

  /** @ngInject */
  function ComposeCallbackDialogController($q, $mdDialog, OrderboxGlue, DynamicFactory, $translate, toastService) {
    var vm = this;

    // vm.CallMeMaybe = CallMeMaybe;
    // vm.cancelFile = cancelFile;
    // vm.closeDialog = closeDialog;
    // vm.getFileName = getFileName;
    // vm.getType = getType;
    // vm.retryChunk = retryChunk;
    // vm.selectFile = selectFile;
    // vm.sendEmailMessage = sendEmailMessage;
    // vm.validate = validate;
    vm.loadPaymentData = loadPaymentData;
    vm.pickPayment = pickPayment;
    // vm.changeForwardRedirectType = changeForwardRedirectType;
    // vm.serviceToForwardChanged = serviceToForwardChanged;
    vm.callbackServiceChanged = callbackServiceChanged;
    vm.saveCallbackRequest = saveCallbackRequest;
    vm.searchContact = searchContact;
    vm.msisdnOnFocus = msisdnOnFocus;
    vm.preferedTimeChanged = preferedTimeChanged;
    vm.togglePreferedTime = togglePreferedTime;
    vm.nextPanePayment = true;
    vm.deleteParam = deleteParam;
    vm.addNewParam = addNewParam;
    vm.$onInit = onInit;

    function onInit() {
      vm.callback = {
        customer: {}
        // ,
        // params:[]
      };
      getCountryCodeList();
      if (angular.isNumber(OrderboxGlue.currentFilter.filter)) {
        vm.serviceFolderMode = true;
        vm.callbackService = _.find(vm.callbackServices, { serviceId: OrderboxGlue.currentFilter.filter });
        loadPaymentData();
      }

      vm.preferedTime = {
        start: moment().add('hours', 1),
        end: moment().add('hours', 3)
      };

      vm.newParam = {};
    }

    function getCountryCodeList(){
      vm.countryList = DynamicFactory.get("CountryListRsc", "get")();
      vm.countryCode = vm.countryList[0];
    }

    // Methods
    //////////

    function closeDialog() {
      $mdDialog.hide();
    }

    function pickPayment(payment) {
      vm.choosenPayment = payment;
      vm.callback.ppId = payment.id;
    }

    function callbackServiceChanged() {
      vm.choosenPayment = undefined;
      vm.callback.ppId = undefined;
      loadPaymentData();
    }

    function loadPaymentData() {
      DynamicFactory.get("PaymentRsc", "getPaymentTypes")(vm.callbackService.serviceId).then(
        function(data) {
          vm.allowedPaymentstypes = data;
          console.log("composeCallbackDialog | loadPaymentData", data);
        },
        function(err) {
          console.log(err);
          toastService.showToast($translate.instant("MAIL.COMPOSE_DIALOG.GET_PAYMENT_TYPE_ERR"), "error", 4);
        }
      );
    }

    function saveCallbackRequest() {
      console.log("composeCallbackDialog | saveCallbackRequest", JSON.stringify(vm.callback));
      return $q(function(resolve,reject){
        DynamicFactory.get("OrderBoxRsc", "SaveCallbackOrder")(vm.callback).then(
          function(data) {
            resolve();
            OrderboxGlue.reloadCurrentFolder();
            closeDialog();
            toastService.showToast("Zamówienie zostało zapisane", "success", 4);
          },
          function(err) {
            resolve();
            toastService.showToast("Zamówienie nie zostało zapisane", "warn", 4);
          }
          );
        });
      // SaveCallbackOrder
    }

    function msisdnOnFocus() {
      vm.contactFromDb = false;
    }

    function searchContact(contactMsisdn) {
      vm.contactFromDb = false;
      if (vm.contactMsisdn !== "" && contactMsisdn.$valid) {
        vm.callback.customer.msisdn = vm.countryCode.dial_code.slice(1, vm.countryCode.dial_code.length) + vm.contactMsisdn.replace(/ /g,'');
        console.log("composeCallbackDialog | searchContact msisdn result", vm.callback.customer.msisdn);
        DynamicFactory.get("ContactPartRsc", "getContactByMsisdn")(vm.contactMsisdn.replace(/ /g,'')).then(function(result) {
          console.log("composeCallbackDialog | searchContact", result);
          if (result && result.msisdn &&(result.email || result.name || result.surname)) {
            vm.contactFromDb = true;
            vm.callback.customer.email = result.email;
            vm.callback.customer.firstName = result.name;
            vm.callback.customer.lastName = result.surname;
          }
        });
      }
    }

    function preferedTimeChanged(start, end) {
      vm.callback.contactTime = start.hour() + "-" + end.hour();
      console.log("composeCallbackDialog | preferedTimeChanged", vm.callback.contactTime);
    }

    function togglePreferedTime() {
      vm.preferedTimeMode = !vm.preferedTimeMode;
      if (!vm.preferedTimeMode) {
        vm.callback.contactTime = undefined;
      }else{
        //debugger
        vm.callback.contactTime = vm.preferedTime.start.hour() + " - " + vm.preferedTime.end.hour();
      }
    }

    function addNewParam() {
      if (!vm.callback.params) {
        vm.callback.params = [];
      }
      if (vm.newParam && vm.newParam.Key) {
        vm.callback.params.push(angular.copy(vm.newParam));
        vm.newParam = {};
      }

      var activeElement = angular.element(document.activeElement)[0];
      console.log("composeCallbackDialog | addNewParam active element", activeElement);

      var inputId = "param-" + (vm.callback.params.length - 1) + "-";

      if (activeElement.id === "new-param-key") {
        inputId += "key";
      } else {
        inputId += "value";
      }
      selectElementId(inputId);
    }

    function selectElementId(value) {
      setTimeout(function() {
        // angular.element
        var element = angular.element(document.getElementById(value));
        // var element = angular.element(document.activeElement)[0].next();
        if(element[0]){
          element[0].focus();
          element[0].select();
        }
      },20);
    }

    function deleteParam(param) {
      _.remove(vm.callback.params,param);
    }
  }
})();

(function () {
  "use strict";

  angular.module("contactcenter.orderbox").component("composeDialog", {
    templateUrl:
      "app/main/contactcenter/orderbox/dialogs/compose/compose-dialog.html",
    controllerAs: "vm",
    bindings: {
      selectedMail: "=",
      isForward: "<",
      toEmail: "="
    },
    controller: ComposeDialogController
  });

  /** @ngInject */
  function ComposeDialogController(
    $mdDialog,
    OrderboxGlue,
    DynamicFactory,
    $translate,
    $scope,
    $stateParams,
    SessionManager,
    toastService
  ) {
    var vm = this;

    vm.CallMeMaybe = CallMeMaybe;
    vm.cancelFile = cancelFile;
    vm.closeDialog = closeDialog;
    vm.getFileName = getFileName;
    vm.getType = getType;
    vm.retryChunk = retryChunk;
    vm.selectFile = selectFile;
    vm.sendEmailMessage = sendEmailMessage;
    vm.validate = validate;
    vm.loadPaymentData = loadPaymentData;
    vm.pickPayment = pickPayment;
    vm.changeForwardRedirectType = changeForwardRedirectType;
    vm.serviceToForwardChanged = serviceToForwardChanged;

    vm.$onInit = onInit;

    function onInit() {
      // Data
      vm.form = {
        from: OrderboxGlue.currentMailBox.emailAddress,
        to: vm.toEmail ? vm.toEmail : ''
      };
      vm.files = [];
      vm.hiddenCC = true;
      vm.hiddenBCC = true;
      vm.flowConfig = flowConfig();
      // If replying
      if (angular.isDefined(vm.selectedMail)) {
        vm.form.to = vm.selectedMail.from.email;
        if (vm.isForward) {
          vm.form.subject = "FW: " + vm.selectedMail.subject;
          vm.CustomRedirect = true;
          vm.form.to = undefined;
        } else {
          vm.form.subject = "RE: " + vm.selectedMail.subject;
        }

        vm.form.body =
          "<br/>" +
          vm.selectedMail.date +
          " " +
          vm.selectedMail.from.name +
          " < " +
          vm.selectedMail.from.email +
          "> napisał/a: <blockquote>" +
          vm.selectedMail.body +
          "</blockquote>";
      }
      vm.allowedPaymentstypes = undefined;
      vm.selectedPayment = undefined;

      //forward

      vm.serviceForForward = [];
      vm.forwardMode = "service";
      vm.sreviceModeOn = true;
      vm.customEmailModeOn = false;
      vm.customEmail = "";
      vm.chosenServiceEmail = undefined;
      if (vm.isForward) {
        loadServiceForForward();
      }

      vm.oldPaymentButtonURL = undefined;

      loadServiceForForward();
    }

    // Methods
    //////////

    function serviceToForwardChanged() {
      if (vm.serviceToForward && !vm.CustomRedirect) {
        vm.form.subject =
          "RE: [sid: " + vm.serviceToForward + "]" + vm.selectedMail.subject;
      } else {
        vm.form.subject = "RE: " + vm.selectedMail.subject;
      }
    }

    //attachments
    function flowConfig() {
      var role = SessionManager.getUserRole();
      // if (vm.contentType) {
      var flow = DynamicFactory.get("FileUploadRsc", "LoadContentFlowConfig")(
        false,
        {},
        role + "/smtp/addAttachment"
      );
      return flow;
      // }
    }

    function validate(file) {
      if (file.size > 300000) {
        toastService.showToast("Plik za duży", "error", 4);
        return false;
      }
      return true;
    }

    function retryChunk(file, flow) {
      // Pause the flow and ask a new accesstoken
      $scope.$broadcast("event:auth-loginRequired");
      flow.pause();
    }

    function CallMeMaybe($flow, $file, $message) {
      toastService.showToast(
        "Plik " + $file.file.name + " został przesłany na serwer.",
        "success",
        4
      );
      var response = JSON.parse($message);
      vm.files.push({
        name: $file.file.name,
        guid: response.attachmentId,
        flow: $file
      });
    }

    function cancelFile(file) {
      if (file.flow) {
        file.flow.cancel();
      }
      var fileIndex = vm.files.indexOf(file);
      if (fileIndex !== -1) vm.files.splice(fileIndex, 1);
    }

    function selectFile(file) {
      vm.selectedFile = file;
      // toggleSidenav('details-sidenav');
    }

    function getFromString(url, regex) {
      var regexResult = url.match(regex)[0].replace(".", "");
      if (regexResult != null) {
        return regexResult;
      } else {
        return "--";
      }
    }

    function getFileName(url) {
      return getFromString(url, /(([^/]*)\.)/);
    }

    function getType(url) {
      return getFromString(url, /\.[^.]*$/);
    }

    function attachmentsGiuds() {
      return vm.files.map(function (item) {
        return item.guid;
      });
    }

    function closeDialog() {
      $mdDialog.hide();
    }

    function sendEmailMessage() {
      if (vm.isForward && !vm.CustomRedirect) {
        vm.serviceForForward.map(function (item) {
          if (item.id === vm.serviceToForward) {
            vm.form.to = item.email;
          }
        });
      }

      var email = {
        mailBoxId: OrderboxGlue.currentMailBox.mailBoxId,
        fromName: vm.form.fromName,
        fromAddress: vm.form.from,
        toName: vm.form.to,
        toAddress: vm.form.to,
        subject: vm.form.subject,
        body: vm.form.body,
        guids: attachmentsGiuds()
      };

      var methodName = undefined;

      if (vm.paymentInfo) {
        methodName = "sendWithPayment";

        email.servicePaymentPointId = vm.paymentInfo.id;
        //email.serviceId = vm.paymentInfo.serviceId;
        email.urlHash = vm.paymentInfo.urlHash;
        email.MailFolder = vm.selectedMail.folderName;
        email.MailId = vm.selectedMail.id;
      } else {
        methodName = "sendEmail";
      }
      DynamicFactory.get("OrderBoxRsc", methodName)(email).then(
        function (data) {
          if (methodName === "sendWithPayment") {
            //ustawianie ikonki na detailsach
            vm.selectedMail.paymentInfo = {};
            //ustawianie ikonki na liście
            var listElem = _.find(OrderboxGlue.threads, {
              id: vm.selectedMail.id * 1
            });

            if (!listElem) {
              listElem = _.find(OrderboxGlue.threads, {
                id: vm.selectedMail.id
              });
            }

            if (listElem) {
              listElem.paymentInfo = {};
            }
          }
          toastService.showToast(
            $translate.instant("MAIL.COMPOSE_DIALOG.MESSAGE_SENT_SUCCESS"),
            "warn",
            4
          );
        },
        function (err) {
          console.log(err);
          toastService.showToast(
            $translate.instant("MAIL.COMPOSE_DIALOG.MESSAGE_SENT_ERR"),
            "error",
            4
          );
        }
      );
      closeDialog();
    }

    function loadPaymentData($mdMenu) {
      if (vm.allowedPaymentstypes) {
        $mdMenu.open();
      }
      else {
        DynamicFactory.get("PaymentRsc", "getPaymentTypes")(vm.selectedMail.serviceInfo.serviceId).then(
          function (data) {
            vm.allowedPaymentstypes = data;
            $mdMenu.open();
          },
          function (err) {
            console.log(err);
            toastService.showToast(
              $translate.instant("MAIL.COMPOSE_DIALOG.GET_PAYMENT_TYPE_ERR"),
              "error",
              4
            );
          }
        );
      }
    }

    function getButtonHtml(urlHash, payment) {
      return (
        '<div><p></p><a href="' +
        urlHash +
        '"><img src="' +
        payment.emailButtonURL +
        '" alt="Kilknij aby zaplacić"></a><p>Jeśli nie widzisz przycisku płatności to kilknij <a href="' +
        urlHash +
        '">tutaj</a></p></div><hr/>'
      );
    }

    function pickPayment(payment) {
      vm.paymentUrlHash = vm.paymentUrlHash
        ? vm.paymentUrlHash
        : guidGenerator();

      addPaymentButton(payment);

      vm.paymentInfo = {};
      vm.paymentInfo.id = payment.id;
      vm.paymentInfo.urlHash = vm.paymentUrlHash;
    }

    function addPaymentButton(payment) {
      var buttonHTML = getButtonHtml(vm.paymentUrlHash, payment);

      if (
        !vm.oldPaymentButtonURL ||
        (vm.oldPaymentButtonURL &&
          vm.form.body.indexOf(vm.oldPaymentButtonURL) === -1)
      ) {
        vm.form.body = buttonHTML + vm.form.body;
      } else {
        var pos = vm.form.body.indexOf(vm.oldPaymentButtonURL);

        vm.form.body =
          vm.form.body.substring(0, pos) +
          payment.emailButtonURL +
          vm.form.body.substring(
            pos + vm.oldPaymentButtonURL.length,
            vm.form.body.length
          );
      }

      vm.oldPaymentButtonURL = payment.emailButtonURL;
    }

    function changeForwardRedirectType() {
      vm.CustomRedirect = !vm.CustomRedirect;
      if (vm.CustomRedirect) vm.form.to = undefined;

      serviceToForwardChanged();
    }

    function S4() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }

    function guidGenerator() {
      var guid = (
        S4() +
        S4() +
        "-" +
        S4() +
        "-4" +
        S4().substr(0, 3) +
        "-" +
        S4() +
        "-" +
        S4() +
        S4() +
        S4()
      ).toLowerCase();
      return guid;
    }

    //FORWARD
    function loadServiceForForward() {
      DynamicFactory.get("OrderBoxRsc", "getMailServiceForForward")().then(
        function (data) {
          vm.serviceForForward = data;
          console.log("serviceForForward", vm.serviceForForward);
        },
        function (err) {
          console.log(err);
        }
      );
    }

    function onModeChange() {
      if (vm.forwardMode === "service") {
        vm.sreviceModeOn = true;
        vm.customEmailModeOn = false;
      } else if (vm.forwardMode === "customEmail") {
        vm.sreviceModeOn = false;
        vm.customEmailModeOn = true;
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('contactcenter.orderbox').component('assignDialog', {
      templateUrl: 'app/main/contactcenter/orderbox/dialogs/assign/assign-dialog.html',
      controllerAs: 'vm',
      bindings: {
        selectedMail: '=',
      },
      controller: AssignDialogController
    });


  /** @ngInject */
  function AssignDialogController($mdDialog, OrderboxGlue, DynamicFactory, $translate, $scope, $stateParams, SessionManager, toastService, mdcDateTimeDialog, callInfoBarBridge, WebSocketManager) {
    var vm = this;
    vm.loadConsultants = loadConsultants;
    vm.consultantClick = consultantClick;
    vm.saveForm = saveForm;
    vm.closeDialog = closeDialog;
    vm.$onInit = onInit;
    vm.openTime = openTime;
    vm.setTime = setTime;
    vm.setCustomTime = setCustomTime;

    function onInit() {
      vm.selectedConsultant = {};
      WebSocketManager.registerWebSocketMethod('CallbackOut', 'CallbackConsultants', onCallback);
      loadConsultants();
      renderTimeArray();
    }
    function onCallback(data) {
      if (data.Content) {
        if (angular.isString(data.Content)) {
          data.Content = JSON.parse(data.Content);
        }
        var cons = _.find(vm.consultantsList,function(e){
          return e.consultantID === data.Content.ConsultantID;
        });
        if(cons){
          cons.callID = data.Content.callID;
        }
        // if ($state.current.name !== 'app.contactcenter_dashboard' && !data.Content.endHelp && data.Content.consultantName && data.Content.consultantName.length > 0) {
        //   toastService.showToastAction(data.Content.consultantName + ' ' + $translate.instant('CALLINFOBAR.NEED_HELP'), 'message', 10, $translate.instant('CALLINFOBAR.START_HELP')).then(function (response) {
        //     if (response === 'ok') {
        //       $state.go('app.contactcenter_dashboard', { 'needHelp': data.Content });
        //     }
        //   });
        // }
      }
    }
    function consultantClick(consultant) {
      vm.schedulerTime = undefined;
      vm.selectedConsultant = consultant;
    }
    function saveForm() {
      if (vm.selectedConsultant && vm.selectedConsultant.consultantID) {
        DynamicFactory.get('OrderBoxRsc', 'callbackConsultantUpdate')({ serviceorderId: vm.selectedMail.id, consultantId: vm.selectedConsultant.consultantID }).then(function (data) {
          vm.selectedMail.consultantID = vm.selectedConsultant.consultantID;
          vm.selectedMail.firstName = vm.selectedConsultant.firstName;
          vm.selectedMail.lastName = vm.selectedConsultant.lastName;
          vm.selectedMail.login = vm.selectedConsultant.login;

          if (vm.schedulerTime){
            DynamicFactory.get('servicesRsc', 'servicesBundleFlatGet')(vm.selectedMail.serviceId).then(function (bundle) {
              bundle = JSON.stringify(bundle);

              vm.consultantCall = {
                msisdn: vm.selectedConsultant.phone1,
                name: vm.selectedConsultant.firstName + ' ' + vm.selectedConsultant.lastName,
                age: '',
                location: ''
              };

              vm.clientCall = {
                msisdn: vm.selectedMail.buyerMsisdn,
                name: vm.selectedMail.buyerName + ' ' + vm.selectedMail.buyerSurename,
                age: '',
                location: ''
              };
              callInfoBarBridge.startBrigeCall(vm.consultantCall, vm.clientCall, vm.selectedConsultant.consultantID, vm.selectedMail.guid, vm.selectedMail.minutesleft, vm.selectedMail.contactID, vm.selectedMail.serviceId, bundle, vm.selectedMail.configID, vm.selectedMail.managerID, function (data) {
                toastService.showToast($translate.instant(data.resultText), data.resultType, 4);
              }, function () {
                toastService.showToast($translate.instant('MAIL.DETAILS.CONTENTCALL.CALL_ERROR'), 'error', 4);
              });
            }, function (errr) {

            });
          }
          else{
            toastService.showToast($translate.instant('MAIL.ASSIGN_DIALOG.SAVE_OK'), 'success', 4);
          }

          $mdDialog.hide(vm.selectedMail);

        }, function (err) {
          console.log(err);
        });
      }
      else {
        toastService.showToast($translate.instant('MAIL.ASSIGN_DIALOG.CHOOSE_CONSULTANT'), 'error', 4);
      }
    }
    function closeDialog() {
      $mdDialog.hide();
    }

    function loadConsultants() {
      vm.loadConsultants = true;
      DynamicFactory.get('OrderBoxRsc', 'callbackActionConsultantList')(vm.selectedMail.serviceInfo.serviceId).then(function (data) {
        vm.consultantsList = data;
        vm.loadConsultants = false;
      }, function (err) {
        console.log(err);
      });
    }
    function openTime($mdMenu, ev) {
      $mdMenu.open(ev);
    }
    function setTime(time, consultant) {
      console.log('setTime: ', time);
      if (time) {
        var result = moment().add(time.toAdd, time.unit);
        if (time.hour) {
          result = result.hours(time.hour).minutes(0);
        }
        vm.schedulerTime = result.format('YYYY-MM-DD HH:mm:ss');
      } else {
        vm.schedulerTime = undefined;
      }
      vm.selectedConsultant = consultant;
    }
    function setCustomTime(consultant) {
      mdcDateTimeDialog.show({
        time: true,
        minDate: moment(),
        todayText: $translate.instant('COMMUNICATOR.CHAT.TODAY'),
        cancelText: $translate.instant('COMMUNICATOR.CHAT.CANCEL')
      }).then(function (date) {
        vm.schedulerTime = moment(date).format('YYYY-MM-DD HH:mm:ss');
        consultantClick(consultant);
      }, function () { });
    }
    function renderTimeArray() {
      vm.timeArray = [];
      vm.timeArray.push({
        toAdd: 0,
        unit: 'h',
        text: $translate.instant('MAIL.ASSIGN_DIALOG.TIME.NOW_DATE')
      });

      // vm.timeArray.push({
      //   toAdd: 1,
      //   unit: 'h',
      //   text: $translate.instant('MAIL.ASSIGN_DIALOG.TIME.IN_1_H')
      // });
      // vm.timeArray.push({
      //   toAdd: 2,
      //   unit: 'h',
      //   text: $translate.instant('MAIL.ASSIGN_DIALOG.TIME.IN_2_H')
      // });

    }
  }
})();

/**
 * Created by akraszewski on 2017-05-26.
 */
(function () {
  'use strict';
  angular
    .module('contactcenter.orderbox')
    .component('mainSidenav', {
      templateUrl: 'app/main/contactcenter/orderbox/componets/mainSidenav/mainsidenav.html',
      controllerAs: 'vm',
      // bindings: {
      //   threads: '='
      // },
      bindings: {
        menuItem: '='
      },
      controller: ctrl
    });

  /** @ngInject */
  function ctrl($scope, $rootScope, OrderboxGlue, $mdDialog, DynamicFactory, $q, orderboxGlueConsts, SessionManager, authRolesConst, toastService, $state, WebSocketManager, MenuManager, tripleviewService) {

    var vm = this;

    // Methods
    vm.loadFolderTitles = loadFolderTitles;
    vm.composeDialog = composeDialog;
    vm.setMailBoxAsActive = setMailBoxAsActive;
    vm.changeMailFolderFilter = changeMailFolderFilter;


    vm.$onInit = onInit;
    vm.$onDestroy = function() {
      vm.listener();
    };


    function onInit() {
      vm.isManager = SessionManager.getUserRoleId() <= authRolesConst.manager;
      vm.isConsultant = SessionManager.isConsultant();
      vm.OrderboxGlue = OrderboxGlue;
      vm.orderboxGlueConsts = orderboxGlueConsts;
      vm.prepairServiceClass = prepairServiceClass;

      vm.listener = $scope.$on("$stateChangeSuccess", stateChangeSuccess);

      vm.mailBoxes = [];
      vm.mailBoxesLoaded = false;

      vm.avaliablePartnerServices = [];
      vm.avaliablePartnerServicesLoaded = false;
      vm.showAvaliablePartnerServices = true;
      vm.showAvaliableUserMailBoxes = true;

      //TEMP do test!!!!
      // var user = SessionManager.getUser();
      // if (user.username === 'AdamWroz') {
      //   vm.activeMBIndex = 3;
      // } else {
        vm.activeMBIndex = 0;
      // }
      //TEMP do test!!!!


      //vm.visibleCallbackDetails = SessionManager.getUserRoleId() <= authRolesConst.manager;
      vm.showCallbackDetails = true;
      vm.callbackFolders = [];
      loadCallBack();

      //nie musimy czekać na załadowanie serwisw
      loadAvaliableUserServices();

      //Ladowanie skrzynek pocztowych
      loadMailBoxes().then(function (data) {
        if (data.length > 0) {
          $rootScope.loadingProgress = vm.OrderboxGlue.loadingProgress = true;



          //Ladowanie folderow pierwszej skrzynki
          loadMailBoxFolders(vm.mailBoxes[vm.activeMBIndex].mailBoxId).then(function (data) {

            // $rootScope.loadingProgress =
            vm.OrderboxGlue.loadingProgress = false;

            //Wyjtek! Przy starcie ustawiamy filtry
            // setCurrentFilterView(vm.mailBoxes[vm.activeMBIndex], orderboxGlueConsts.mailFolderType, data.folders[0].name);

            // //Ladowanie zawrotsci 1 folderu 1 skrzynki
            // loadFolderTitles(vm.mailBoxes[vm.activeMBIndex], orderboxGlueConsts.mailFolderType, data.folders[0].name, data.folders[0].allMessagesCount);

          });

        } else {
          vm.avaliablePartnerServicesLoaded = true;
          vm.showAvaliablePartnerServices = false;
          toastService.showToast('Brak skrzynek pocztowych', 'warn', 4);
        }
      });
      if(vm.isConsultant){
        WebSocketManager.registerWebSocketMethod('ConsultantPhoneUpdate', 'ConsultantPhoneUpdateOrderboxMenu', prepareWebSocket(updateCurrentPhone),buildRegex());
        updateCurrentPhone(SessionManager.getUser());
      }

    }

    function buildRegex() {
      var user = SessionManager.getUser();
      // var partnerId = user.partnerId;
      console.log('regex: ' + '^ccs\\.' + user.partnerId + '\\/' + user.callCenterId + '\\/' + user.consultantId);
      return '^ccs\\.' + user.partnerId + '\\/' + user.callCenterId + '\\/' + user.consultantId;
    }

    function prepareWebSocket(callback) {
      return function (data) {
        if (data.Content) {
          if (angular.isString(data.Content)) {
            data.Content = JSON.parse(data.Content);
          }
          if (callback) {
            callback(data.Content);
          }
        }
      };
    }

    function updateCurrentPhone(data){
      // if(data == undefined){
      //   data = SessionManager.getUser();
      // }
      vm.currentPhone = {
        phone1:data.phone1 || data.phone,
        phoneType: data.phoneType
      }
    }

    function stateChangeSuccess(event, toState, toParams, fromState, fromParams) {
      // vm.currentState = toState.name;
      if (toState.name && toState.stateTranslationName && toState.stateTranslationName.indexOf(vm.menuItem.title) === -1) {
        deactiveAllFrom(vm.callbackFolders);
        deactiveAllFrom(vm.mailBoxes);
        angular.forEach(vm.mailBoxes, function (ele) {
          deactiveAllFrom(ele.folders);
        });
        deactiveAllFrom(vm.avaliablePartnerServices);
      }
    }

    function deactiveAllFrom(list){
      var activeItems = _.filter(list, function(o) { return o.isActive; });
      activeItems.forEach(function(item){
        list[list.indexOf(item)].isActive = false;
      });
    }

    function setMailBoxAsActive(activeteMailbox) {

      if (activeteMailbox.mailBoxId !== OrderboxGlue.currentFilter.mailBoxId) {

        //jeśli mailbox nieaktywny, a rozwinity to niech zostanie rozwiniety
        if (!activeteMailbox.show) {
          activeteMailbox.show = true;
        }

        cleanMailTitles();


        //ladowanie serwisw i folderow
        loadMailBoxFolders(activeteMailbox.mailBoxId).then(function (data) {

          //Ladowanie zawrotsci 1 folderu dla nowego mailbox, rownież otwiera folder
          loadFolderTitles(activeteMailbox, orderboxGlueConsts.mailFolderType, data.folders[0].name, data.folders[0].allMessagesCount);
        });
      } else {

        activeteMailbox.show = !activeteMailbox.show;

        //nic sie nie zmieniło należy wylaczyc aktualny serwos
        if (OrderboxGlue.currentThread) {
          OrderboxGlue.closeThread();
        }
      }
    }


    function setActiveFolderFlag(activeteMailbox, type, folderName) {


      if (activeteMailbox.mailBoxId !== OrderboxGlue.currentFilter.mailBoxId || folderName !== OrderboxGlue.currentFilter.filter || type !== OrderboxGlue.currentFilter.type) {
        OrderboxGlue.currentFilter.type = type;

        var resetAciveProp = function (array) {
          angular.forEach(array, function (ele) {
            ele.isActive = false
          });
        };

        resetAciveProp(vm.mailBoxes);

        angular.forEach(vm.mailBoxes, function (ele) {
          resetAciveProp(ele.folders);
        });

        resetAciveProp(vm.avaliablePartnerServices);
        resetAciveProp(vm.callbackFolders);


        //New object!         // zależnie od typu aktualizacja nowego
        if (type === orderboxGlueConsts.mailFolderType) {
          activeteMailbox.isActive = true;

          vm.OrderboxGlue.currentMailBox = activeteMailbox;

          var activeFolder = _.find(activeteMailbox.folders, {
            name: folderName
          });

          if (activeFolder) {
            activeFolder.isActive = true
          }

        } else if (type === orderboxGlueConsts.serviceFolderType) {

          vm.OrderboxGlue.currentMailBox = activeteMailbox;

          var activeServiceFolder = _.find(vm.avaliablePartnerServices, {
            serviceId: folderName
          });
          activeServiceFolder.isActive = true;
        } else if (type === orderboxGlueConsts.callbackFolderType) {

          var activeCallBackFolder = _.find(vm.avaliablePartnerServices, {
            serviceId: folderName
          });
          if (activeCallBackFolder) {
            activeCallBackFolder.isActive = true;
          } else {
            activeCallBackFolder = _.find(vm.callbackFolders, {
              box: folderName
            });
            if (activeCallBackFolder) {
              activeCallBackFolder.isActive = true;
            }
          }
        }
      }
    }

    function fixMailBoxFolders(folders) {
      var mainFolders = [{
        name: 'SENT',
        icon: 'icon-send'
      },
      {
        name: 'WYSŁANE',
        icon: 'icon-send'
      },
      {
        name: 'INBOX',
        icon: 'icon-email-open'
      }
      ];

      folders = _.reverse(folders);
      angular.forEach(folders, function (ele) {
        angular.forEach(mainFolders, function (ele2) {
          if (ele.name.toUpperCase() === ele2.name) {
            ele.isMain = true;
            ele.icon = ele2.icon;
          }
        })
      });
      return folders;
    }

    /**
     * Open compose dialog
     *
     * @param ev
     */

    function composeDialog(ev) {
      if(vm.isManager && OrderboxGlue.currentFilter.type == vm.orderboxGlueConsts.callbackFolderType){
        composeCallback(ev);
      }else{
        $mdDialog.show({
          locals: {
            selectedMail: undefined
          },
          template: '<compose-dialog selected-mail="vm.selectedMail"></compose-dialog>',
          controller: function (selectedMail) {
            // var vm = this;
            this.selectedMail = selectedMail;
          },
          controllerAs: 'vm',
          targetEvent: ev,
          clickOutsideToClose: true
        });
      }
    }

    function composeCallback(ev){
      // vm.orderboxGlueConsts.callbackFolderType
      // OrderboxGlue.currentFilter.type == vm.orderboxGlueConsts.callbackFolderType

      $mdDialog.show({
        locals: {
          avaliablePartnerServices: vm.avaliablePartnerServices
        },
        template: '<compose-callback-dialog callback-services="vm.avaliablePartnerServices"></compose-callback-dialog>',
        controller: function (avaliablePartnerServices) {
          // var vm = this;
          this.avaliablePartnerServices = avaliablePartnerServices;
        },
        controllerAs: 'vm',
        targetEvent: ev,
        clickOutsideToClose: true
      }).then(function(result){
        console.log('mainsidenav | callback saved');
      });;

    }

    function loadMailBoxes() {
      var defer = $q.defer();
      DynamicFactory.get('OrderBoxRsc', 'getMailBoxes')().then(function (data) {
        vm.mailBoxes = data;
        vm.mailBoxesLoaded = true;
        if (data.length > 0) {
          vm.mailBoxes[vm.activeMBIndex].show = true; //pokarz pierwsz skrzynke
        }
        ;

        angular.forEach(data, function (elem) {
          if (elem.emailAddress.length > 24) {
            elem.emailAddressShort = elem.emailAddress.substr(0, 23) + '...'
          }
          else {
            elem.emailAddressShort = elem.emailAddress;
          }
        });
        defer.resolve(data);
      }, function (err) {
        console.log('Ladowanie skrzynek pocztowych nie powiodlo sie: ' + err);
        defer.reject(err);
      });

      return defer.promise;
    }

    function changeMailFolderFilter(mailbox) {
      if (mailbox.folderFiler === undefined) {
        mailbox.folderFiler = true;
      } else {
        mailbox.folderFiler = undefined;
      }
    }

    function loadMailBoxFolders(mailBoxId) {
      var defer = $q.defer();
      DynamicFactory.get('OrderBoxRsc', 'getMailBoxFolders')(mailBoxId).then(function (data) {
        var mailbox = _.find(vm.mailBoxes, {
          mailBoxId: mailBoxId
        });

        mailbox.folders = fixMailBoxFolders(data.folders);
        mailbox.loaded = true;
        mailbox.connectionStatus = data.connectionStatus;
        mailbox.folderFiler = true; // filtr do pokazywania tylko głwnych katalogw (przełaczany na wszystkie)


        loadMailServicesForMailBox(mailBoxId).then(function (data) {
        });

        defer.resolve(data);
      }, function (err) {
        console.log('Ladowanie katalogw skrzynki pocztowej o id:' + mailBoxId + ' nie powiodlo sie: ' + err);
        defer.reject(err);
      });
      cancelLastLoading(defer);
      return defer.promise;
    }

    function cancelLastLoading(newPromise) {
      if (vm.lastPromise) {
        vm.lastPromise.reject();
      }
      vm.lastPromise = newPromise;
      return newPromise;
    }


    //Ladowane przy okazji ładowania folderw skrzynki pocztowej
    function loadMailServicesForMailBox(mailBoxId) {
      var defer = $q.defer();

      DynamicFactory.get('OrderBoxRsc', 'mailServicesForMailBox')(mailBoxId).then(function (data) {
        //zapis serwisw do zmiennej sesesyjne
        var mailbox = _.find(vm.mailBoxes, {
          mailBoxId: mailBoxId
        });

        mailbox.allowedServices = data;
        vm.OrderboxGlue.currentMailBox = mailbox;

        defer.resolve(data);
      }, function (err) {
        console.log('Ladowanie listy serwisow skrzynki pocztowej o id:' + mailBoxId + ' nie powiodlo sie: ' + err);
        defer.reject(err);
      });

      return defer.promise;
    }



    function loadFolderTitles(mailBox, type, folderName, messagesCount) {
      cancelLastLoading();
      MenuManager.hideMiniMenu = true;
      tripleviewService.hideSidenav = false;

      if ($state.current.name.indexOf('app.contactcenter_orderbox.threads') === -1) {
        $state.go('app.contactcenter_orderbox.threads',{
          mailBoxId: mailBox,
          type: type,
          filter: folderName
        });
      }

      //Usuwa z listy wszystkie pozycje
      cleanMailTitles();

      //zmina aktywnej skrzynki
      setActiveFolderFlag(mailBox, type, folderName);

      //ustawianie filtrow
      setCurrentFilterView(mailBox, type, folderName);


      // Pobranie danych!!!
      var mailBoxId = undefined;
      if (type === 'servicefolder') {
        mailBoxId = 'mailsessions';
        OrderboxGlue.currentService = mailBox;
      } else if (type === 'callbackFolderType') {
        mailBoxId = 'callbacksessions';
        OrderboxGlue.currentService = mailBox;
      } else {
        mailBoxId = mailBox.mailBoxId;
        loadMailServicesForMailBox(mailBoxId)
      }

      // vm.loadingProgress = $rootScope.loadingProgress;

      // Show loader

      OrderboxGlue.setMaxMailboxPages(messagesCount);

      loadFolderTitlesData(mailBoxId, type, folderName);


    }


    function loadFolderTitlesData(mailBoxId, type, folderName) {
      OrderboxGlue.getFolder('getFolder', {
        mailBoxId: mailBoxId,
        type: type,
        folderName: folderName
      });
    }

    //czyścimy liste maili
    function cleanMailTitles() {
      // vm.threads = [];
      OrderboxGlue.cleanMailTitlesData();
    }

    // ustawia view w state.go oraz ustawia currentFilter dla OrderBoxGlue
    function setCurrentFilterView(mailBoxId, type, folderName) {
      OrderboxGlue.setCurrentFilterView(mailBoxId, type, folderName);
    }

    function loadAvaliableUserServices() {
      // console.log('Nie udało sie załadować listy dostepnych serwisow. ' + err);

      DynamicFactory.get('OrderBoxRsc', 'serviceList')().then(function (data) { //mailServiceForUser
        vm.avaliablePartnerServices = data;
        vm.avaliablePartnerServicesLoaded = true;

        vm.showAvaliablePartnerServices = data.length > 0;

      }, function (err) {
        vm.avaliablePartnerServicesLoaded = true;
        console.log('Nie udało sie załadować listy dostepnych serwisow. ' + err);
      });
    }

    function prepairServiceClass(color) {
      if (color) {
        return color.toString().replace('-bg', '-fg').replace('md-', '');
      }
    }

    function loadCallBack() {

      vm.callbackFolders = [];
      vm.consultantId = SessionManager.getUser().consultantId;
      //console.log('SessionManager.getUserRoleId(): ',SessionManager.getUserRoleId());
      //console.log('authRolesConst.manager: ',authRolesConst.manager);
      //console.log('vm.consultantId: ',vm.consultantId);
      if (vm.consultantId > 0) {
        vm.callbackFolders.push({
          name: 'MAIL.MAINSIDENAV.CALLORDER_GROUP_YOURS',
          icon: 'icon-account-outline',
          box: ''//,
        });
      }

      if (SessionManager.getUserRoleId() <= authRolesConst.manager) {
        vm.callbackFolders.push({
          name: 'MAIL.MAINSIDENAV.CALLORDER_GROUP_NEW',
          icon: 'icon-email-open',
          box: 'assignedlistFalse'//,
        });
        vm.callbackFolders.push({
          name: 'MAIL.MAINSIDENAV.CALLORDER_GROUP_ASSIGN',
          icon: 'icon-send',
          box: 'assignedlistTrue'
        });
      }

      vm.callbackFolders.push({
        name: 'MAIL.MAINSIDENAV.CALLORDER_GROUP_DONE',
        icon: 'icon-check-all',
        box: 'callbackListDone',
      });

    }

  }


})();

/**
 * Created by akraszewski on 2017-05-26.
 */
(function () {
  'use strict';
  angular
    .module('contactcenter.orderbox')
    .component('mailListMenu', {
      templateUrl: 'app/main/contactcenter/orderbox/componets/maillistmenu/maillistmenu.html',
      require: {
        mailList: '?^mailList'
      },
      controllerAs: 'vm',
      bindings: {
        currentThread: '=',
        threads: '=',
        statusClickCall: '='
      },
      controller: ctrl
    });

  /** @ngInject */
  function ctrl($scope, OrderboxGlue, DynamicFactory, $q, orderboxGlueConsts) {

    var vm = this;

    vm.$onInit = onInit;

    vm.setPage = setPage;
    vm.closeThread = closeThread;
    vm.setSelectedThreadsFlag = setSelectedThreadsFlag;
    vm.changePaymentStatusFilter = changePaymentStatusFilter;

    function onInit() {
      vm.OrderboxGlue = OrderboxGlue;
      vm.orderboxGlueConsts = orderboxGlueConsts;
      if (vm.mailList) {
        vm.selectThreads = vm.mailList.selectAllThreads;
        vm.deselectThreads = vm.mailList.deselectAllThreads;
        vm.selectThreadsWithiFilters = vm.mailList.selectThreadsWithiFilters;
        vm.toggleSelectThreads = vm.mailList.toggleSelectThreads;
      }
      vm.selectMailModeOn = false;

      vm.checkColor = '#0ea660';
      vm.paymentStatus = 'assets/icons/orderbox/dollar_green.svg';

      vm.showFree = true;
      vm.showPay = true;
    }

    function changePaymentStatusFilter(isFreeClicked, isPayClicked) {
      // //PENDING = 1
      // //REJECTED = 2
      // //CONFIRMED = 4
      // //CANCELED = 8
      // //16  == FREE

      if (isFreeClicked) {
        vm.showFree = !vm.showFree;

        if(vm.showFree){
          vm.checkColor = '#0ea660';
        }else{
          vm.checkColor = '#bbb';
        }
      }

      if (isPayClicked) {
        vm.showPay = !vm.showPay;

        if (vm.showPay) {
          vm.paymentStatus = 'assets/icons/orderbox/dollar_green.svg';
        } else {
          vm.paymentStatus = 'assets/icons/orderbox/dollar_grey.svg';
        }
      }

      if (vm.statusClickCall) {
        vm.statusClickCall({isFree: vm.showFree, pay: vm.showPay});
      }
    }

    // function callbackComplitedFilter() {
    //   if (vm.complited) {
    //     vm.complited = false;
    //     vm.checkColor = '#0ea660';
    //     vm.OrderboxGlue.complitedCallback = true;
    //   } else {
    //     vm.complited = true;
    //     vm.checkColor = '#bbb';
    //     vm.OrderboxGlue.complitedCallback = false;
    //   }
    //   getFolder(vm.OrderboxGlue.complitedCallback);
    // }

    // function getFolder(status) {
    //   OrderboxGlue.getFolder('getFolder', {
    //     type: OrderboxGlue.currentFilter.type,
    //     folderName: OrderboxGlue.currentMailBoxFolder,
    //     status: status,
    //     page: vm.OrderboxGlue.currentPage
    //   });
    // }

    function setSelectedThreadsFlag(flag, value) {
      var selctedThred = vm.threads.filter(function (thread) {
        return thread.selected;
      });

      if (selctedThred.length > 0) {
        angular.forEach(selctedThred, function (thread) {
          setThreadsFlag(thread, flag, value);
        });
      } else {
        setThreadsFlag(vm.currentThread, flag, value);
      }

    }

    function setThreadsFlag(thread, flag, value) {
      if (flag === 'seen') {
        if (value) {
          setMessageSeenStatus(thread, 'read');

        } else {
          setMessageSeenStatus(thread, 'unread');
        }
      } else {
        //inne flagi

      }
    }


    function setMessageSeenStatus(thread, status) {
      // var apiCall = status === 'unread' ? 'markAsUnread' : 'markAsRead';
      // var value = status !== 'unread';
      switch (vm.OrderboxGlue.currentFilter.type) {
        case orderboxGlueConsts.callbackFolderType:
          callSeenStatus('serviceOrderSeenUpdate', thread, {
            id: thread.id,
            status: status !== 'unread'
          });
          break;
        case orderboxGlueConsts.serviceFolderType:
          callSeenStatus('mailSessionSeenUpdate', thread, {
            id: thread.id,
            status: status !== 'unread'
          });
          break;
        default:
        case orderboxGlueConsts.serviceFolderType:
          callSeenStatus(status === 'unread' ? 'markAsUnread' : 'markAsRead', thread, {
            id: thread.id,
            status: true,
            currentMailBoxFolder: OrderboxGlue.currentMailBoxFolder,
            mailBoxId: OrderboxGlue.currentMailBox.mailBoxId
          });
          break;
      }

    }

    function callSeenStatus(apiCall, thread, params) {
      DynamicFactory.get('OrderBoxRsc', apiCall)(params.id, params.status, params.currentMailBoxFolder, params.mailBoxId).then(function (data) {
        changeThread(thread, params.status);
      }, function (err) {
        console.log(err);
      });
    }


    function changeThread(thread, value) {
      if (vm.currentThread && vm.currentThread.id === thread.id) {
        vm.currentThread.seen = value;
      }
      thread.seen = value;
      var curThread = vm.threads.filter(function (th) {
        return th.id === thread.id;
      });
      if (curThread) {
        curThread.seen = value;
      }
    }

    function closeThread() {
      vm.currentThread = undefined;
      OrderboxGlue.closeThread();
    }

    function setPage(pageNumber) {
      OrderboxGlue.getFolder('getFolder', {
        mailBoxId: vm.OrderboxGlue.currentFilter.mailBoxId,
        type: vm.OrderboxGlue.currentFilter.type,
        folderName: vm.OrderboxGlue.currentMailBoxFolder,
        page: pageNumber
      });
    }
  }
})();

/**
 * Created by akraszewski on 2017-05-26.
 */
(function () {
  'use strict';
  angular.module('contactcenter.orderbox')
    .component('mailDetails', {
      templateUrl: 'app/main/contactcenter/orderbox/componets/maildetails/maildetails.html',
      controllerAs: 'vm',
      bindings: {
        currentThread: '<'
      },
      controller: mailDetailsController
    });

  /** @ngInject */
  function mailDetailsController(OrderboxGlue, $scope) {

    var vm = this;

    vm.$onInit = onInit;
    // vm.$onChanges = onChanges;

    function onInit() {
      vm.OrderboxGlue = OrderboxGlue;
    }



    // function onChanges(changesObj) {
    //   if (changesObj.currentThread && changesObj.currentThread.currentValue  )
    //     getThread();
    // }

    // function getThread() {
    //   $scope.$emit('getThreadData', {
    //     mailBoxId: vm.currentThread.mailBoxID,
    //     folderName: vm.currentThread.folderName,
    //     mailId: vm.currentThread.id
    //   });
    // }



    // function getThread() {
    //
    //   //jeśli email jest przeniesiony/usuniety to nawet nie ładuj danych
    //   if (OrderboxGlue.currentFilter.type !== 'callbackFolderType' && !vm.currentThread.emailMovedOrDel) {
    //     // Show loader
    //     $rootScope.loadingProgress = true;
    //
    //     sss(vm.currentThread.mailBoxID, vm.currentThread.folderName, vm.currentThread.id).then(function (data) {
    //       // Assign thread as the current thread
    //
    //       vm.currentThread = data;
    //
    //       // Show loader
    //       $rootScope.loadingProgress = false;
    //
    //       if (vm.currentThread.from) {
    //         if (vm.currentThread.from.length > 0) {
    //           vm.currentThread.from = vm.currentThread.from[0];
    //         }
    //       }
    //
    //       vm.currentThread.read = true;
    //     }, function (err) {
    //       if (err.status === 404) {
    //         vm.currentThread.emailMovedOrDel = true;
    //       }
    //       $rootScope.loadingProgress = false;
    //       console.log(err);
    //     })
    //   }
    //
    // }

  }
})();

/**
 * Created by kosski on 2018-09-27.
 */
(function () {
  'use strict';
  angular
    .module('contactcenter.orderbox')
    .component('mailListFilters', {
      templateUrl: 'app/main/contactcenter/orderbox/componets/maillistfilters/maillistfilters.html',

      controllerAs: 'vm',
      bindings: {
        addIndicator: '=',
        // threads: '=',
        // currentThread: '='
      },
      controller: mailListFilters
    });

  /** @ngInject */
  function mailListFilters($scope, OrderboxGlue, orderboxGlueConsts, MaillistFilters) {

    var vm = this;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$doCheck = doCheck;

    vm.addFilter = addFilter;
    vm.closeFilter = closeFilter;
    vm.generateTimeColors = generateTimeColors;
    vm.getFolder = getFolder;
    vm.setStatusFilter = setStatusFilter;
    // vm.buildFilterConfig = undefined;
    // vm.saveFilter = saveFilter;


    function onInit() {
      vm.OrderboxGlue = OrderboxGlue;
      vm.orderboxGlueConsts = orderboxGlueConsts;
      vm.MaillistFilters = MaillistFilters;
      vm.addIndicator = addFilter;
      vm.buildFilterConfig = MaillistFilters.buildFilterConfig;
      // vm.filtersData = [];
      vm.filters = [];
      initSortFilter();
      initFixedFilter();
      initMailSortFilter();
      $scope.$on('sort-changed', updateFilters);
    }

    function onChanges(changesObj) {

    }

    function doCheck() {
      if (vm.form && vm.form.$dirty) {
        vm.form.$setPristine();
        updateFilters();
        console.log('mailListFilters | update filters');
      }
    }

    function initSortFilter() {
      vm.sortFilter = vm.buildFilterConfig(_.find(MaillistFilters.filterTypes, {
        prop: 'sort'
      }),{sort:{
        column:'creationTime',
        descending:true
      }});
    }
    function initMailSortFilter() {
      vm.sortMailFilter = vm.buildFilterConfig(_.find(MaillistFilters.filterMailTypes, {
        prop: 'sort'
      }),{sort:{
          column:'date',
          descending:true
        }});
    }

    function initFixedFilter() {
      vm.fixedFilter = vm.buildFilterConfig(_.find(MaillistFilters.filterTypes, {
        token: 'MAIL.MAIL_LIST.STATUS'
      }));
    }

    function setStatusFilter(params) {
      vm.fixedFilter.filterData = {
        statusObj: { // takigo propa zadeklarowałem w definicji filetrów
          isFree: params.isFree,
          pay: params.pay
        }
      };
      updateFilters();
    }

    //kiedyś skorzysta z tego filtr przedziałów - minut
    function generateTimeColors(time) {
      if (time <= 5) return '#4caf50';
      else if (time <= 11) return '#0277bd';
      else if (time <= 31) return '#ffd54f';
      else return '#ff5252';
    }

    function updateFilters() {
      var filters = angular.copy(vm.filters);

      if(OrderboxGlue.currentFilter.type===orderboxGlueConsts.callbackFolderType){
        if (vm.sortFilter.filterData && !_.isEmpty(vm.sortFilter.filterData.sort)) {
          filters.push(vm.sortFilter);
        }

        if (vm.fixedFilter.filterData) {
          filters.push(vm.fixedFilter);
        }
      }else {
        if (vm.sortMailFilter.filterData && !_.isEmpty(vm.sortMailFilter.filterData.sort)) {
          filters.push(vm.sortMailFilter);
          MaillistFilters.currentSortMailParams=vm.sortMailFilter.filterData.sort;
        }
      }


      MaillistFilters.updateFilters(filters);

      getFolder();
    }

    function addFilter(filter) {


      if (filter.used) {
        return;
      }
      filter.used = true;
      vm.filters.push(vm.buildFilterConfig(filter));
    }

    function getFolder() {


      OrderboxGlue.getFolder('getFolder', {
        type: OrderboxGlue.currentFilter.type,
        folderName: OrderboxGlue.currentMailBoxFolder,
        mailBoxId:OrderboxGlue.currentFilter.mailBoxId,
        // status: status,
        page: OrderboxGlue.currentPage
      });
    }


    function closeFilter(filter) {

      //zmiana użycia na liście w zmiennej serwisu
      var f = _.find(MaillistFilters.filterTypes, {token: filter.filterType.token});
      f.used = false;

      vm.filters.splice(vm.filters.indexOf(filter), 1);
      updateFilters();

      // vm.newFilter = undefined;
      // vm.filterType = undefined;
      // vm.filterConfig = undefined;
    }

  }
})();

/**
 * Created by akraszewski on 2017-05-26.
 */
(function() {
  "use strict";
  angular.module("contactcenter.orderbox").component("mailList", {
    templateUrl: "app/main/contactcenter/orderbox/componets/maillist/maillist.html",

    controllerAs: "vm",
    bindings: {
      // threads: '=',
      // currentThread: '='
    },
    controller: mailListController
  });

  /** @ngInject */
  function mailListController(OrderboxGlue, orderboxGlueConsts, DynamicFactory, $q, MaillistFilters, authRolesConst, SessionManager, WebSocketManager) {
    var vm = this;

    vm.$onInit = onInit;
    vm.$onDestroy = onDestroy;

    // vm.addFilter = addFilter;
    // vm.closeFilter = closeFilter;
    vm.deselectAllThreads = deselectAllThreads;
    vm.generateTimeColors = generateTimeColors;
    vm.getFolder = getFolder;
    vm.openThread = openThread;
    // vm.saveFilter = saveFilter;
    vm.selectAllThreads = selectAllThreads;
    vm.selectThreadsWithiFilters = selectThreadsWithiFilters;
    vm.toggleSelectThread = toggleSelectThread;
    vm.toggleSelectThreads = toggleSelectThreads;

    function onInit() {
      vm.OrderboxGlue = OrderboxGlue;
      vm.orderboxGlueConsts = orderboxGlueConsts;
      vm.MaillistFilters = MaillistFilters;
      // vm.threads = OrderboxGlue.threads;
      // vm.currentThread = OrderboxGlue.currentThread;
      // if(vm.threads && vm.threads.length>0){
      //   vm.openThread(vm.threads[0]);
      // }

      WebSocketManager.registerWebSocketMethod("Issue", "onIssueUpdateWebhook", onIssueUpdate);
      getConsultantList();
    }

    function onDestroy() {
      WebSocketManager.unregisterWebSocketMethod("Issue", "onIssueUpdateWebhook");
    }

    // function onChanges(changesObj) {
    //   // if (changesObj.threads && changesObj.threads.currentValue  )
    //   //   {
    //   //     vm.openThread(vm.threads[0]);
    //   //   }
    // }

    function onIssueUpdate(issue) {
      vm.threads.forEach(function(thread) {
        if (thread.issueId == issue.Issue.Id) {
          thread.issueStatus = issue.Issue.Fields.Status.Id;
        }
      });
    }

    function toggleSelectThread(thread, event) {
      if (event) {
        event.stopPropagation();
      }
      thread.selected = !thread.selected;

      checkIfSomethingSelected();
    }

    function deselectAllThreads() {
      vm.threads.forEach(function(thread) {
        thread.selected = false;
      });

      //checkIfSomethingSelected();
      vm.OrderboxGlue.someMailsAreSelected = false;
    }

    function selectAllThreads() {
      vm.threads.forEach(function(thread) {
        thread.selected = true;
      });

      checkIfSomethingSelected();
    }

    function selectThreadsWithiFilters(filterName, value) {
      vm.threads.forEach(function(thread) {
        if (thread[filterName] === value) {
          thread.selected = true;
        } else {
          thread.selected = false;
        }
      });

      checkIfSomethingSelected();
    }

    function checkIfSomethingSelected() {
      vm.OrderboxGlue.someMailsAreSelected = getselectedTitles().length > 0;
    }

    function toggleSelectThreads() {
      if (getselectedTitles().length > 0) {
        deselectAllThreads();
      } else {
        selectAllThreads();
      }
    }

    function getselectedTitles() {
      return vm.threads.filter(function(thread) {
        return thread.selected;
      });
    }

    function openThread(thread) {
      // Set the seen status on the thread
      if (!thread.seen) {
        switch (vm.OrderboxGlue.currentFilter.type) {
          case orderboxGlueConsts.callbackFolderType:
            callThreadUpdate("serviceOrderSeenUpdate", {
              id: thread.id
            });
            break;
          case orderboxGlueConsts.serviceFolderType:
            callThreadUpdate("mailSessionSeenUpdate", {
              id: thread.sessionID
            });
            break;

          default:
            callThreadUpdate("markAsRead", {
              id: thread.id,
              currentMailBoxFolder: OrderboxGlue.currentMailBoxFolder,
              mailBoxId: OrderboxGlue.currentMailBox.mailBoxId
            });
            break;
        }
        thread.seen = true;
      }
      vm.currentThread = thread;

      OrderboxGlue.openThread(vm.currentThread);

      OrderboxGlue.getThreadData(null, {
        mailBoxId: vm.currentThread.mailBoxID,
        folderName: vm.currentThread.folderName,
        mailId: vm.currentThread.id
      });
      // $scope.$emit('getThreadData', {
      //   mailBoxId: vm.currentThread.mailBoxID,
      //   folderName: vm.currentThread.folderName,
      //   mailId: vm.currentThread.id
      // });
    }

    function generateTimeColors(time) {
      if (time <= 5) return "#4caf50";
      else if (time <= 11) return "#0277bd";
      else if (time <= 31) return "#ffd54f";
      else return "#ff5252";
    }

    function callThreadUpdate(callName, params) {
      DynamicFactory.get("OrderBoxRsc", callName)(params.id, true, params.currentMailBoxFolder, params.mailBoxId).then(
        function(data) {},
        function(err) {
          console.log(err);
        }
      );
    }

    // function addFilter(filter) {
    //   vm.filterConfig = [{
    //     templateKey: filter.templateKey ? filter.templateKey : undefined,
    //     label: filter.token ? filter.token : undefined,
    //     fieldId: filter.prop,
    //     source: filter.source || undefined,
    //     objValue: filter.objValue
    //     // defaultValue: optional ? defaultValue[0] : undefined,
    //     // isOptional: optional ? true : false,
    //     // isStep: isStep,
    //     // notInConfig: notInConfig,
    //     // disabledOnEdit: disabledOnEdit
    //   }];
    //   vm.filterType = angular.copy(filter);
    //   vm.newFilter = {};
    //   // var fieldInfo = [{
    //   //   token: 'pn',
    //   //   value: filter.prop
    //   // }, {
    //   //   token: 'translate',
    //   //   value: filter.label
    //   // }];
    //   // DynamicFactory.get('templateRsc','getUniTemplate')(filter.templateKey,fieldInfo).then(function(result){
    //   //   vm.settings = {};
    //   //   vm.filterHtml = result;
    //   // });
    // }

    function getFolder() {
      OrderboxGlue.getFolder("getFolder", {
        type: OrderboxGlue.currentFilter.type,
        folderName: OrderboxGlue.currentMailBoxFolder,
        // status: status,
        page: 0
      });
    }

    function getConsultantList(refresh) {
      var defer = $q.defer();
      if (vm.consultantList && !refresh) {
        defer.resolve(vm.consultantList);
      } else {
        if (vm.lastPromise && !refresh) {
          $q.all([vm.lastPromise]).then(function(result) {
            defer.resolve(vm.consultantList);
          });
        } else {
          vm.lastPromise = getCallcenterPerManager();

          $q.all([vm.lastPromise]).then(function(data) {
            vm.consultantList = data[0];
            // generateConsultantSearch();
            defer.resolve(vm.consultantList);
          });
        }
      }
      return defer.promise;
    }

    function getCallcenterPerManager() {
      var defer = $q.defer();

      if (SessionManager.getUserRoleId() === authRolesConst.manager || SessionManager.getUserRoleId() === authRolesConst.admin) {
        DynamicFactory.get("reportsCosult", "CallCenterList")().then(function(r) {
          // tripleviewService.sidenavData.callCenterList = r;
        });
      }
      generateConsultantPerContactCenter().then(defer.resolve, defer.reject);
      return defer.promise;
    }

    function generateConsultantPerContactCenter() {
      var defer = $q.defer();
      // tripleviewService.sidenavData.consultantsPerCC = [];
      // var callcenterId;
      // if (SessionManager.getUserRoleId() === authRolesConst.admin) {
      //   callcenterId = vm.CallcenterId ? vm.CallcenterId : null;
      // } else {
      //   callcenterId = SessionManager.getUser().callCenterId;
      // }

      if (SessionManager.getUserRoleId() !== authRolesConst.admin) {
        vm.CallcenterId = SessionManager.getUser().callCenterId;
      }

      if (SessionManager.getUserRoleId() !== authRolesConst.consultant) {
        DynamicFactory.get("reportsCosult", "ConsultansGet")(vm.CallcenterId).then(function(r) {
          // tripleviewService.sidenavData.consultantsPerCC = r;
          vm.consultantList = _(r)
            .groupBy("consultantID")
            .value();
          defer.resolve(vm.consultantList);
        }, defer.reject);
      }
      return defer.promise;
    }
  }
})();

/**
 * Created by kosski on 07.09.2016.
 */
+function () {
  'use strict';
  angular
    .module('management.users', [])
    .config(config);

  /** @ngInject */
  function config() {
  }
}();

-function () {
  'use strict';
  angular
    .module('management.users')
    .component('userGeneralInfo', {
      templateUrl: 'app/main/contactcenter/management/users/usergeneralinfo/usergeneralinfo.html',
      bindings: {
        currUserId:'<',
        personalAccount:'=',
        editingForbidden:'=',
        noTitle:'='
      },
      controllerAs: 'vm',
      controller: 'userGeneralInfoCtrl'
    }).controller('userGeneralInfoCtrl',
    function controller($mdDialog, DynamicFactory,toastService,$rootScope,$state) {
      var vm = this; // jshint ignore:line

      vm.$onInit = onInit;
      vm.selectedFileChanged = selectedFileChanged;
      vm.editData = editData;
      vm.$onChanges=onChanges;
      vm.changePasswordDialog=changePasswordDialog;
      
      vm.userData={};


      function onInit() {

      }


      function onChanges(obj) {
        if(obj.currUserId ){
          if(obj.currUserId.currentValue) {
            getUserGeneralInfo(vm.currUserId);
          }
        }
      }

      function selectedFileChanged(result) {
        if (angular.isDefined(result) && result.length > 1) {

          DynamicFactory.get('profileRsc', 'PutConsultantPhoto')({
            Photo: result
          },vm.currConsultantId).then(function (suc) {

            var consultant={
              photoUrl:vm.userData.photoUrl,
              firstName:vm.userData.firstName,
              lastName:vm.userData.lastName,
              consultantId:vm.userData.id
            };

            $rootScope.$broadcast('updateEditedConsultantList', {  consultant: consultant} );

            toastService.showToast('Pomyślnie zapisano zmiany.', 'success',4);
          }, ErrorFunc);
        }
      }
      
      function editData() {
        // if(vm.personalAccount){
        //   $state.transitionTo('app.contactcenter_dashboard.settings.consultantedit',{
        // }

        $state.go('app.contactcenter_dashboard.settings.users.edit',{userId:vm.currUserId});
      }

      function changePasswordDialog() {
  
        $mdDialog.show({
          clickOutsideToClose: true,
          controller: 'changePassword',
          controllerAs: 'vm',
          focusOnOpen: false,
          targetEvent: event,
          templateUrl: 'app/main/contactcenter/management/users/changepassword/changepassword.html',
          multiple: false,
          locals: {
            // var:var
            userData:{
              userId:vm.userData.id,
              oldPwd:vm.userData.pwd
            }
          }
        }).then(function(newPassword){
          vm.userData.pwd=newPassword
        },function(cancelMessage){
          console.log(cancelMessage)
        });
      }


      function ErrorFunc(err) {
        alert('error');
        toastService.showToast('Nie udało się zapisać zmian', 'error',4);
      }

      function getUserGeneralInfo(userId) {
       var  method='';

       // jeśli dodamy do mangaging to trzeba  będzie zmienić resroce i metodę
        if(vm.personalAccount){
          method='getMyUserDetails';
        }

        DynamicFactory.get('UsersRsc', method)()
          .then(function (data) {
            vm.userData=data;
            if(vm.userData.longDescription && vm.userData.longDescription.length>300){
              vm.userData.longDescriptionFixed=vm.userData.longDescription.substring(1,300)+'...';
            }
            else{
              vm.userData.longDescriptionFixed=vm.userData.longDescription;
            }

            if(vm.userData.callCentersNames) {
              vm.userData.callCentersNamesArray = vm.userData.groups.split(',');
            }
 
            if(! vm.userData.photoUrl){
              vm.userData.photoUrl='../../../../assets/navigation/avatar.svg';
            }

          });
      }


    }
  );

}();

/**
 * Created by kosski on 07.09.2016.
 */
+function () {
  'use strict';
  angular
    .module('management.consultants', [])
    .config(config);

  /** @ngInject */
  function config() {
  }
}();

- function () {
  'use strict';
  angular
    .module('management.consultants')
    .component('userSimpleAdd', {
      templateUrl: 'app/main/contactcenter/management/users/usersimpleadd/usersimpleadd.html',
      require: {
        tripleView: '^tripleView'
      },
      bindings: {
        // personalAccount: "<"
      },
      controllerAs: 'vm',
      controller: 'userSimpleAddCtrl'
    }).controller('userSimpleAddCtrl',
      function controller($stateParams, SessionManager, authRolesConst, toastService, $rootScope, DynamicFactory, $state, $timeout, $q) {
        var vm = this; // jshint ignore:line

        vm.$onInit = onInit;
        vm.saveChanges = saveChanges;
        vm.cancelSaveChanges = cancelSaveChanges;
        vm.photoUpdate = photoUpdate;

        function onInit() {
          // vm.avatarPhotoUrl='';

        }

        function photoUpdate() {
          // jeśli obrazki są różne to poczekaj 500ms i odśwież minaturę obrazka
          $timeout(function () {
            vm.newUser.photoUrlOld = vm.newUser.photoUrl;
          }, 3000);
        };

        function cancelSaveChanges(userId) {
          // gdy obrazek jest zmieniony, warto poczekac chwilę aż załaduje się na serwer
          var interval = 0;
          if (vm.newUser.photoUrlOld !== vm.newUser.photoUrl) {
            interval = 500;
          }

          $timeout(function () {
            $state.go('app.contactcenter_management.callcenters.consultants.consultant', {
              callcenter: $stateParams.callcenter,
              consultantId: userId
              // consultantId: $stateParams.consultantId
            });
          }, interval);

        }


        function updateConsultantList() {

          var consultant = {
            photoUrl: vm.newUser.photoUrl,
            firstName: vm.newUser.firstName,
            lastName: vm.newUser.lastName,
            newRecordMode: vm.newUser.newRecordMode,
            userID: vm.newUser.userID ? vm.newUser.userID : vm.newUser.id,
            consultantID: vm.newUser.userID ? vm.newUser.userID : vm.newUser.id,
            callCenterID: $stateParams.callcenter // do podmiany na liście
          };


          $rootScope.$broadcast('updateEditedConsultantList', {
            consultant: consultant
          });
        }

        vm.addNewConsultantFunc = function (newConsultantId) {
          var defer = $q.defer();
          vm.newConsultant = {};
          vm.newConsultant.userId = newConsultantId;
          vm.newConsultant.callCenterID = $stateParams.callcenter;
          DynamicFactory.get('ConsultantsRsc', 'addNewConsultant')(vm.newConsultant).then(function (data) {
            vm.newUser.consultantID = data.codeOrId;
            
            addConsulantPhone(newConsultantId).then(function(data2){
              defer.resolve(data);
            },function(err){
              defer.reject(err);
            })

          }, ErrorFunc);

          return defer.promise;
        }

        function addConsulantPhone(newConsultantId) {
          var defer = $q.defer();

          //dodanie tylko telefonu Web RTC
          var phone = {
            added: true,
            inEdit: false,
            name: "webrtc",
            tempId: 1,
            typeId: 4
          };
          DynamicFactory.get('ConsultantsRsc', 'saveConsultantPhone')(phone, newConsultantId, false).then(function (data) {
            console.log('Dodano telefon o nazwie: ' + phone.name);
            defer.resolve(data);

          }, function(err){
            defer.reject(err);
          });
          return defer.promise;
        }


        function saveChanges() {

          if (vm.saveUser) {
            vm.saveUser().then(function (data) {
              if (angular.isDefined(data.userId)) {
                vm.currentConsultantId = data.userId;
              }

              if (vm.addNewConsultantFunc) {
                vm.addNewConsultantFunc(vm.currentConsultantId).then(function (data2) {

                  updateConsultantList();

                  cancelSaveChanges(data.userId);// z saveUser

                  toastService.showToast('Pomyślnie zapisano zmiany.', 'success', 4);

                }, function (err) {
                  toastService.showToast('Zapis nie powiódł się.', 'error', 4);
                });
              }


            });
          }

        }

        function ErrorFunc(data) {
          console.log('Wystapił nieoczekiwany bład przy zapisie consultanta');
          toastService.showToast('Wystąpił nieoczekiwany błąd przy zapisie konsultanta', 'error', 4);
        }


      }
    );

}();

-function () {
  'use strict';
  angular
    .module('management.users')
    .component('userEditComponent', {
      templateUrl: 'app/main/contactcenter/management/users/usereditcomponent/usereditcomponent.html',
      bindings: {
        userId: '<',
        personalAccount: '<',
        saveIndicator: '=',
        createOnlyConsultant:'<',
        editedUser: '=', // za pomocą tego parametru oddajemy zmodyfikowane dane poziom wyżej
        adminMode:'<',
        newRecord:'<',
        bigForm:'='
      },
      controllerAs: 'vm',
      controller: userEditComCtrl
    });
    function userEditComCtrl($stateParams, authRolesConst, toastService, $rootScope, DynamicFactory, $state, $q, $scope, SessionManager) {
      var vm = this; // jshint ignore:line

      vm.$onInit = onInit;
      vm.$onChanges = onChanges;
      vm.promotionSwitch = promotionSwitch;

      function onInit() {
        // vm.adminModeAllowed=undefined;

        vm.saveIndicator = saveUserData;

        if (!vm.personalAccount) {
          initUserData();
        } else {
          vm.currentUserId = undefined;
          loadUserData(null, vm.personalAccount);
        }

        if (vm.adminMode && SessionManager.getUserRoleId() === authRolesConst.admin) {
          vm.adminModeAllowed = true;
          loadCC();
          populateRoleSource();
        }

      }

      function populateRoleSource() {
        vm.roleSource = [];

        vm.roleSource.push({
          name: 'Admin',
          value: 1
        });
        vm.roleSource.push({
          name: 'Manager',
          value: 2
        });
        vm.roleSource.push({
          name: 'Consultant',
          value: 3,
          disabled: true
        });
      }
      function loadCC() {
        DynamicFactory.get('ContactCenterRsc', 'getCallCenters')()
          .then(function (result) {
            vm.callcenters = result;
          });
      }


      function initUserData() {
        // new record mode
        vm.editedUser = {
          newRecordMode: true,
          isActive: true,
          roleID: vm.createOnlyConsultant?3:undefined
        };
      }

      function onChanges(changesObj) {
        if ((changesObj.userId && changesObj.userId.currentValue)) {
          if (!vm.personalAccount) {
            vm.currentUserId = changesObj.userId.currentValue;
            loadUserData(vm.currentUserId, null);
          }
        }
      }
      function promotionSwitch(){
        if(vm.roleIDOld !== vm.editedUser.roleID){
          vm.editedUser.consultantPromotion = vm.editedUser.roleID;
        }else{
          vm.editedUser.consultantPromotion=undefined;
        }
      }

      function loadUserData(userId, personalAccount) {
        var method = '';
        if (personalAccount) {
          method = 'getMyUser';
        } else {
          method = 'getUser';
        }

        DynamicFactory.get('UsersRsc', method)(userId).then(function (data) {
          vm.editedUser = data;
          vm.editedUser.oldpwd = vm.editedUser.pwd; // dla zwykłego usera
          vm.editedUser.photoUrlOld = vm.editedUser.photoUrl; // na potrzeby przeładowania zdjęcia w widoku kartoteki
          vm.editedUser.roleIDOld =angular.copy( vm.editedUser.roleID);

          // jesli użytkownik ma wybrane CC to nie można mu już go zmienić, chyba że zrobią to programości
          if(vm.editedUser.callCenterID) {
            vm.editedUser.callCenterDisabled=true;
          }

            if (vm.editedUser.oldpwd && !personalAccount) {
            vm.editedUser.newPwd = '00000';
          }
          ;
          setTimeout(function () {
            if(vm.bigForm){
              vm.bigForm.$setDirty();
            }
          }, 100);


        }, function (err) {
          console.log(err);
        });

      }

      function hashPwd(user) {
        if (user.newPwd && (user.newPwd !== '00000')) {
          user.pwd = sha512(user.newPwd);
        }
      }


      function saveUserData() {
        var defer = $q.defer();
        hashPwd(vm.editedUser);

        if (vm.editedUser.newRecordMode) {
          DynamicFactory.get('UsersRsc', 'addUser')(vm.editedUser).then(function (data) {
            vm.editedUser.consultantID = data.codeOrId;
            vm.editedUser.userID = data.codeOrId;
            defer.resolve({userId: data.codeOrId});
          }, ErrorFunc);
        } else {

          if (vm.personalAccount) {
            DynamicFactory.get('UsersRsc', 'updateMyUser')(vm.editedUser)
              .then(function (data) {
                defer.resolve({userId: vm.editedUser.consultantID});
              }, ErrorFunc);
          } else {
            DynamicFactory.get('UsersRsc', 'updateUser')(vm.editedUser)
              .then(function (data) {
                defer.resolve({userId: vm.editedUser.consultantID});
              }, ErrorFunc);
          }
        }
        return defer.promise;
      }

      function ErrorFunc(err) {
        console.log('Wystapił nieoczekiwany bład przy zapisie użytkownika: \n' + err.data.message);
        toastService.showToast('Wystąpił nieoczekiwany błąd przy zapisie użytkownika: \n' + err.data.message, 'error', 4);
        // defer.reject();
      }


    }

}();

-function () {
  'use strict';
  angular
    .module('management.users')
    .component('userEdit', {
      templateUrl: 'app/main/contactcenter/management/users/useredit/useredit.html',
      bindings: {
      },
      controllerAs: 'vm',
      controller: controller
    });

    function controller($stateParams, authRolesConst, toastService, $rootScope, DynamicFactory, $state,$timeout) {
      var vm = this; // jshint ignore:line

      vm.$onInit = onInit;
      vm.saveChanges = saveChanges;
      vm.cancelSaveChanges = cancelSaveChanges;
      vm.photoUpdate = photoUpdate;

      function onInit() {
        vm.avatarPhotoUrl='';

        if(parseInt($stateParams.userId)===0){
          vm.currentUserId=undefined;
        }
        else{
          vm.currentUserId=parseInt($stateParams.userId);
        }
      }

      function cancelSaveChanges() {
          // gdy obrazek jest zmieniony, warto poczekac chwilę aż załaduje się na serwer
          var interval=0;
          if(vm.editedUser.photoUrlOld!==vm.editedUser.photoUrl){
            interval=500;
          }

          $timeout(function () {
            $state.go('app.contactcenter_dashboard.settings.users');
          },interval);

      }

      function photoUpdate(){
        // jeśli obrazki są różne to poczekaj 500ms i odśwież minaturę obrazka
        //if(vm.editedUser.photoUrlOld!==vm.editedUser.photoUrl){
        $timeout(function () {
          vm.editedUser.photoUrlOld=vm.editedUser.photoUrl;
        },3000);
        //}
      };


      function saveChanges() {

        if(vm.saveUser){
          vm.saveUser().then(function (data) {

            if (vm.saveMail) {
              vm.saveMail(vm.currentUserId,$stateParams.callcenter);
            }

            cancelSaveChanges();

            toastService.showToast('Pomyślnie zapisano zmiany.', 'success',4);

          });
        }

      }


    }


}();

/**
 * Created by kosski on 08.09.2016.
 */
+function () {
  'use strict';
  angular.module('contactcenter.trademill', []).config(config);

  /** @ngInject */
  function config($translatePartialLoaderProvider, $stateProvider) {
    $stateProvider.state('app.contactcenter_trademill', {
      url: '/trademill',
      stateTranslationName: 'MANAGEMENT.TRADEMILL',
      views: {
        'content@app': {
          template: '<trademill></trademill>'
        }
      },
      resolve: {
      },
      bodyClass: 'trademill'
    });

  }
} ();

/**
 * Created by kosski on 08.09.2016.
 */
+function () {
    'use strict';
    angular.module('contactcenter.trademill').component('timeline', {
        templateUrl: 'app/main/contactcenter/management/trademill/timeline/timeline.html',
        controllerAs: 'vm',
        bindings: {
            // update: '&',
            // loadContent: '&',
            tags: '=',
            showHistory: '=',
            contentTemplate: '@',
            playFeed: '='
        },
        controller: controller
    });

    /** @ngInject */
    function controller($scope, $interval, $rootScope, $timeout, DynamicFactory, lodash) {
        var vm = this;

        // vm.startFeed = startFeed;
        // vm.bulidUpdater = bulidUpdater;
        vm.getThreads = getThreads;
        vm.$doCheck = tagsChange;
        vm.$onDestroy = onDestroy;
        vm.$postLink = postLink;
        vm.$onInit = init;


        function init() {
            vm.messages = [];
            vm.currentPage = 1;
            vm.playFeed = true;
            vm.wHieight = $(document).height() - 180;
        }

        function postLink() {
            getThreads(vm.tags);
        }

        function tagsChange() {
            // console.log('onChanges!!', changesObj);
            if (!arraysEqual(vm.tags,vm.tagsLoaded)) {
                vm.messages = [];
                vm.tagsLoaded = angular.copy(vm.tags);
                vm.getThreads(vm.tags);
            }

        }
        function onDestroy() {
            vm.messages = undefined;
            if (angular.isDefined(vm.stop)) {
                $interval.cancel(vm.stop);
                vm.stop = undefined;
            }
        }

        function arraysEqual(a, b) {
            if (a === b) return true;
            if (a == null || b == null) return false;
            if (a.length != b.length) return false;

            // If you don't care about the order of the elements inside
            // the array, you should sort both arrays here.
            var sA = a.sort();
            var sB = b.sort();
            for (var i = 0; i < sA.length; ++i) {
                if (sA[i] !== sB[i]) return false;
            }
            return true;
        }

        function getThreads(tags) {
            DynamicFactory.get('trademillRsc', 'GetTreadmillByTags')(vm.tags).then(function (result) {
                // var prepared = [];
                vm.messages = result;
                startFeed();
            });
        }

        // function bulidUpdater(tags) {
        //     return DynamicFactory.get('trademillRsc').updateFeedByTags();
        // };

        function updateFeed() {
            var dates = vm.messages.map(function (e) {
                return moment(e.data_out);
            });
            var minDate = lodash.max(dates);

            // var lastDate = moment(minDate,"HH:mm DD-MM-YYYY");
            // var lastDate = Math.max.apply(null, vm.messages.map(function (e) {
            //     return e.data_out;
            // }));
            DynamicFactory.get('trademillRsc', 'updateFeedByTags')
                (vm.tagsLoaded, minDate).then(function (result) {
                    if (result.length > 0) {
                        result.forEach(function (item) {
                            // prepareMessage(item);
                            vm.messages.unshift(item);
                            // vm.messagesSource.unshift(item);
                        });
                        while (vm.messages.length > 100) {
                            vm.messages.pop();
                        }
                    }
                });
        }

        // function prepareMessage(item) {
        //     var din = moment(item.data_in, "YYYY-MM-DDTHH:mm.sss");
        //     var dout = moment(item.data_out, "YYYY-MM-DDTHH:mm.sss");
        //     item.data_in = din.format("HH:mm DD-MM-YYYY");
        //     item.data_out = dout.format("HH:mm DD-MM-YYYY");
        // };

        // vm.prepareMessage = prepareMessage;

        function startFeed() {
            vm.stop = $interval(function () {
                if (vm.playFeed) {
                    updateFeed();
                }
                else if (angular.isDefined(vm.stop)) {
                    $interval.cancel(vm.stop);
                    vm.stop = undefined;
                }
            }, 5000);
        };
    }

}();
// 'app//main//contactcenter//management//trademill//templates//message.template.html'
(function () {
	'use strict';

	angular
		.module('management.users').controller('changePassword', controller);

	/** @ngInject */
	function controller(userData, SessionManager,DynamicFactory, $mdDialog, toastService) {
		var vm = this;

		vm.$onInit = onInit;
		vm.closeDialog = closeDialog;
		vm.userData = undefined;
		vm.newPwdRepeat = undefined;
		vm.oldPasswordChange = oldPasswordChange;
		vm.checkNewPasswordMatch = checkNewPasswordMatch;
		vm.savePassword = savePassword;
		vm.oldPasswordCorrect = false;
		vm.newPasswordMatch = true;
		

		vm.showWarrning = false;

		function onInit() {

			debugger
			vm.userData = userData;
			vm.editedUser = {
				oldPwd: '',
				newPwd: '',
				newPwdRepeat: ''
			}
		}


		function oldPasswordChange() {
			//console.log(sha512(vm.editedUser.oldPwd));
			///console.log(vm.userData.oldPwd);
			vm.oldPasswordCorrect = true;///sha512(vm.editedUser.oldPwd) === vm.userData.oldPwd;
		}

		function checkNewPasswordMatch() {
			vm.newPasswordMatch = vm.editedUser.newPwdRepeat === vm.editedUser.newPwd
		}


		function closeDialog() {
			$mdDialog.cancel('Change password dialog canceled');
		}

		function savePassword() {

			var userPassword={
				OldPassword: sha512(vm.editedUser.oldPwd), //hash
				NewPassword:sha512(vm.editedUser.newPwd),//hash
				UserId:vm.userData.userId,
			}

 
			DynamicFactory.get('UsersRsc', 'changeUserPassword')(userPassword).then(function (data) {
				if(data.status==1){
					toastService.showToast('Zapis powiódł się', 'success', 4);
					SessionManager.setUserPassword(userPassword.NewPassword);
					$mdDialog.hide(userPassword.NewPassword);
				}else if(data.status==0){
					toastService.showToast('Zapis NIE powiódł się. Brakuje uprawień lub hasła są nieodpowiednie', 'error', 4);
				}
			});

 
			return ;
		}

		function ErrorFunc(err) {
			console.log('Wystapił nieoczekiwany bład przy zapisie użytkownika: \n' + err.data.message);
			toastService.showToast('Wystąpił nieoczekiwany błąd przy zapisie użytkownika: \n' + err.data.message, 'error', 4);
		}

	}
})();

/**
 * Created by kosski on 08.09.2016.
 */
+function () {
  'use strict';

  angular.module('contactcenter.trademill').component('trademill', {
    templateUrl: 'app/main/contactcenter/management/trademill/component/trademill.html',
    controllerAs: 'vm',
    controller: controller
  });

  /** @ngInject */
  function controller($scope, DynamicFactory, $q, $mdSidenav, $rootScope, $timeout, ngNotify) {
    var vm = this;

    // vm.addTag = addCallback;
    // vm.removeTag = removeCallback;
    vm.initAnimation = initAnimation;
    vm.addTimeline = addTimeline;
    vm.removeTimeline = removeTimeline;
    vm.$onInit = init;

    function init() {
      vm.timelineOptions = {
        scrollEl: '#content'
      };
      vm.timelines = [];
      vm.timelines.push(new Timeline());
      vm.timelines[0].tags = [];
      getBaseTags();
    }

    function Timeline() {
      var _this = this;
      _this.tags = undefined;
      _this.tagsObj = [];
      _this.play = true;
      _this.removeTag = function (tag) {
        if (_this.tags)
          _this.tags.splice(_this.tags.indexOf(tag), 1);
      };
      _this.addNewTag = function (newTag) {
        if (!_this.tags) _this.tags = [];
        if (angular.isObject(newTag)) {
          _this.tags.push(newTag.id);
        }
      };
    }

    vm.toggleInfo = buildToggler('clientInfo', function (hash) {
      DynamicFactory.get('trademillRsc', 'getCientHistory')(hash).then(function (result) {
        vm.HistoryMessages = result;
      });
    });

    vm.configTimeline = buildToggler("configNav", function (timeline) {
      vm.timelineToConfig = timeline;
    });


    function initAnimation(item) {
      $timeout(2000, function () {
        item.visible = true;
      });
    }

    $scope.$on('sidenavRender', function (ngRepeatFinishedEvent) {
      vm.sidenavLoader = false;
    });

    // $rootScope.$on('$stateChangeSuccess', function () {
    //   vm.timelines.forEach(function (timeline) {
    //     timeline.play = false;
    //   });
    // })
    // function addCallback(timeline) {
    //   return timeline.addNewTag;
    // }
    // function removeCallback(timeline) {
    //   return timeline.removeTag;
    // }
    function addTimeline() {
      if (vm.timelines.length < 3)
        vm.timelines.push(new Timeline());
      else
        ngNotify.set('Nie więcej niż 3 bieżnie!', 'error');
    }

    function removeTimeline(timeline) {
      vm.timelines.splice(vm.timelines.indexOf(timeline), 1);
    }

    function buildToggler(componentId, after) {
      return function (object) {
        vm.HistoryMessages = undefined;
        vm.sidenavLoader = true;
        $mdSidenav(componentId).toggle();
        // trademillRsc.getCientHistory(hash).then(function (result) {
        //   vm.HistoryMessages = result;
        // });
        after(object);
      };
    }

    /*------------------------------------------------------ tags -----------------------------*/
    function getBaseTags() {
      DynamicFactory.get('tagsRsc', 'getTags')().then(function (result) {
        vm.baseTags = result;
      });
    }
  }
}();

(function() {
  'use strict';

  angular
      .module('management.services')
      .filter('formFieldType', formFieldType);

        /** @ngInject */
      function formFieldType(DynamicFactory) {
          return function(input) {
              if(!input) return '';

              var fieldTypes = DynamicFactory.get('templatesRsc', 'getFieldTypes')();

              for(var key in fieldTypes){
                if(fieldTypes[key] && fieldTypes[key].templateKey === input)
                  return fieldTypes[key].name;
              }
          }
      }
})();

-function () {
  'use strict';
  angular
    .module('management.consultants')
    .component('consultantPhones', {
      templateUrl: 'app/main/contactcenter/management/consultants/consultantphones/consultantphones.html',
      bindings: {
        consultantId: '<',
        personalAccount: '<',
        saveIndicator: '='
      },
      controllerAs: 'vm',
      controller: 'consultantPhonesCtrl'
    }).controller('consultantPhonesCtrl',
    function controller(SessionManager, DynamicFactory, toastService, $timeout) {
      var vm = this; // jshint ignore:line

      vm.$onInit = onInit;
      vm.editPhone = editPhone;
      vm.deletePhone = deletePhone;
      vm.addPhone = addPhone;
      vm.savePhone = savePhone;
      vm.getPhoneType = getPhoneType;
      vm.cancelSavePhone = cancelSavePhone;
      vm.$onChanges = onChanges;


      function onInit() {
        vm.phones = [];
        vm.saveIndicator = sendPhones;
        if (vm.personalAccount) {
          vm.currentConsultantId = undefined;
          getPhones(null);
        }
        getPhoneTypes();
        vm.tempId = 0;


      }

      function onChanges(changesObj) {
        if ((changesObj.consultantId && changesObj.consultantId.currentValue)) {
          if (!vm.personalAccount) {
            vm.currentConsultantId = changesObj.consultantId.currentValue;
              getPhones(vm.currentConsultantId);
          }
        }
      }


      function editPhone(phone) {
        angular.forEach(vm.phones, function (e) {
          if (e.inEdit) {
            e.inEdit = false;
          }
        });

        phone.edited = true;
        phone.inEdit = true;
        vm.editedPhone = angular.copy(phone);
      }

      function savePhone(phone) {
        if (!vm.phoneForm.$valid) {
          toastService.showToast('Uzupełnij wymagane pola', 'error', 4);
          return;
        }

        if (phone.edited) {
          var e = _.find(vm.phones, {id: phone.id});
          if (angular.isUndefined(e)) {
            e = _.find(vm.phones, {tempId: phone.tempId});
          }
          e.name = phone.name;
          e.phone = phone.phone;
          e.typeId = phone.typeId;
          e.typeName= vm.getPhoneType(phone.typeId);
          e.inEdit = false;
          vm.editedPhone = undefined;
        } else if (phone.added) {
          vm.editedPhone.inEdit = false;
          vm.phones.push(angular.copy(vm.editedPhone));
          $timeout(function () {
            vm.editedPhone = undefined;
          }, 500);
        }
      }

      function cancelSavePhone(phone) {
        var e = _.find(vm.phones, {id: phone.id});
        if (e) {
          e.inEdit = false;
        }
        vm.editedPhone.inEdit = false;
        $timeout(function () {
          vm.editedPhone = undefined;
        }, 500);
      }

      function deletePhone(phone) {
        phone.deleted = true;
      }

      function addPhone() {
        vm.tempId += 1;
        vm.editedPhone = {
          added: true,
          tempId: vm.tempId,
          inEdit: true
        };
      }

      function sendPhones(userId) {

        angular.forEach(vm.phones, function (phone) {
          if (phone.deleted) {
            DynamicFactory.get('ConsultantsRsc', 'deleteConsultantPhone')(phone.id, vm.currentConsultantId,vm.personalAccount).then(function (data) {
              console.log('Usunięto telefon o id: ' + phone.id);
            });
          } else if (phone.added) {
            //jak nazwa pusta to ustaw default
            if (!phone.name) {
              phone.name = getPhoneType(phone.typeId);
            }

            if(userId){
              vm.currentConsultantId=userId;
            }
            DynamicFactory.get('ConsultantsRsc', 'saveConsultantPhone')(phone, vm.currentConsultantId,vm.personalAccount).then(function (data) {
              console.log('Dodano telefon o nazwie: ' + phone.name);
            });

          } else if (phone.edited) {
            //jak nazwa pusta to ustaw default
            if (!phone.name) {
              phone.name = getPhoneType(phone.typeId);
            }
            DynamicFactory.get('ConsultantsRsc', 'updateConsultantPhone')(phone, vm.currentConsultantId,vm.personalAccount).then(function (data) {
              console.log('Zmieniono telefon o nazwie: ' + phone.name);
            });
          }
        });

      }


      function getPhoneType(phoneId) {
        if (!vm.phoneTypes) return;
        var p=_.find(vm.phoneTypes,{id:phoneId});
        if(p){
          return p.name;
        }else{
         return;
        }


      }


      function getPhoneTypes() {
        DynamicFactory.get('ConsultantsRsc', 'getPhoneTypes')()
          .then(function (data) {
            vm.phoneTypes = data;

            //when phonetype loaded then update type in table
            angular.forEach(vm.phones,function (phone) {
              phone.typeName= vm.getPhoneType(phone.typeId);
            });

          });
      }

      function getPhones(consultantId) {
        DynamicFactory.get('ConsultantsRsc', 'getPhones')(consultantId)
          .then(function (data) {
            vm.phones = data;

            angular.forEach(vm.phones,function (phone) {
              phone.typeName= vm.getPhoneType(phone.typeId);
            });
            if (vm.phones.length > 0) {
              $timeout(function () {
                vm.phoneForm.$setDirty();
              }, 100);
            }
          });
      }


    }
  );

}();

-function () {
  'use strict';
  angular
    .module('management.consultants')
    .component('consultantList', {
      templateUrl: 'app/main/contactcenter/management/consultants/consultantlist/consultantlist.html',
      require: {
        tripleView: '^tripleView'
      },
      // bindings: {
      //   search: "="
      // },
      controllerAs: 'vm',
      controller: 'consultantListCtrl'
    }).controller('consultantListCtrl',
    function controller($scope, $stateParams, DynamicFactory,SessionManager, $state, WebSocketManager, $timeout) {
      var vm = this; // jshint ignore:line

      vm.getStatusName = getStatusName;
      vm.deleteConsultant = deleteConsultant;
      vm.selectConsultant = selectConsultant;
      vm.addNewConsultant = addNewConsultant;
      vm.addNewConsultantSimple = addNewConsultantSimple;
      vm.consultantContent = consultantContent;
      vm.setOnlinefilter = setOnlinefilter;
      vm.sortBy = sortBy;
      vm.$onInit = onInit;
      vm.$onDestroy = onDestroy;
      vm.$postLink = postLink;
      // vm.navBarConfig = headerConfig.navBar;

      function onInit() {
        vm.consultantsList = [];
        vm.availableServices = [];
        vm.filter = {};
        vm.onlineFilterFlag = false;
        vm.onlineFilter = {};
        // tripleviewService.sidenavData.class = "p200";

        // vm.consultantData=undefined;



        WebSocketManager.registerWebSocketMethod('ConsultantStatusUpdate', 'ConsultantStatusUpdate', onStatusUpdate, null);

        $scope.$on('$stateChangeSuccess', stateChangeSuccess);

        $scope.$on('updateEditedConsultantList', updateEditedConsultantListSuccess);
      }

      function postLink() {
        setConsultantList();

        // registerEvent();
        populateRoleSource();
        // loadCC();

        vm.reverse = false;
        vm.propertyName = '';

        DynamicFactory.get('AuthResource', 'GetAvableStatuses')().then(function (data) {
          vm.availableServices = data;
        });
      }


      function updateEditedConsultantListSuccess(event, toState, toParams, fromState, fromParams) {

        var ob = _.find(vm.consultantsList, {consultantID: toState.consultant.consultantID * 1});

        // jeżeli admin dodaje/zmienia konsultnta któr po zmianie trafia do innego callcenter, to usuń go z listy lub nie dodawaj do listy
        if($stateParams.callcenter*1!==toState.consultant.callCenterID*1){
          if(ob){
            vm.consultantsList.split(ob,1);
          }else{
            //nie dodawaj do listy konsultantów bo powinien byc w innej
          }
          // koniec operacji
          return;
        }

        var consultant = toState.consultant;
        $timeout(function () {
          if (ob) {
            ob.photoUrl = consultant.photoUrl;
            ob.firstName = consultant.firstName;
            ob.lastName = consultant.lastName;
          } else {
            vm.consultantsList.push(consultant);
          }
        }, 1500);
      }

      function setOnlinefilter() {
        if (vm.onlineFilterFlag) {
          vm.onlineFilter = {status: 1};
        }
        else {
          vm.onlineFilter = {};
        }
      }

      function stateChangeSuccess(event, toState, toParams, fromState, fromParams) {
        if (toState.name == "app.contactcenter_management.callcenters.consultants") {
          console.log('consultantList | stateChangeSuccess');
          setConsultantList();
        }
      }


      function onStatusUpdate(newStatus) {
        console.log('STATUS konsultanta został zmieniony!');
        if (newStatus.Content) {
          newStatus = JSON.parse(newStatus.Content);

          var consultant = _.find(vm.consultantsList, {consultantID: newStatus.consultantID});
          var status = _.find(vm.availableServices, {id: newStatus.status});
          if (consultant && status) {
            consultant.status = newStatus.status;
            consultant.statusIcon = status.icon;
            consultant.statusColor = status.color;
          }
        }
      }

      function sortBy(propertyName) {
        vm.reverse = (vm.propertyName = propertyName) ? !vm.reverse : false;
        vm.propertyName = propertyName;
      }

      function setConsultantList() {
        vm.consultantData = SessionManager.getUser();
        DynamicFactory.get('ConsultantsRsc', 'getConsultants')(null, $stateParams.callcenter).then(function (response) {
          vm.consultantsList = response.consultants;
          if ($stateParams.consultantId && vm.consultantsList.length > 0) {
            vm.selectedConsultant = _.find(vm.consultantsList, {consultantID: parseInt($stateParams.consultantId)});
          } else {
            // vm.selectedConsultant = vm.consultantsList[0];
            selectConsultant(vm.consultantsList[0]);
          }
        }, function (err) {
        });

      }

      function getStatusName(statusId) {
        for (var i = 0; i < vm.availableServices.length; i++) {
          if (vm.availableServices[i].id == statusId) {
            return vm.availableServices[i].status;
          }
        }
      }


      function addNewConsultant() {
        $state.go('app.contactcenter_management.callcenters.consultants.consultant.edit', {
          callcenter: $stateParams.callcenter,
          consultantId: 0
        });
      }

      function addNewConsultantSimple() {
        $state.go('app.contactcenter_management.callcenters.consultants.consultant.simpleadd', {
          callcenter: $stateParams.callcenter
        });
      }

      function deleteConsultant(consultant) {
        DynamicFactory.get('UsersRsc', 'deactivateUser')(consultant.consultantID)
          .then(SuccesFunc);
      }


      function selectConsultant(consultant) {
        vm.selectedConsultant = consultant;
        $state.go('app.contactcenter_management.callcenters.consultants.consultant', {
          callcenter: $stateParams.callcenter,
          consultantId: consultant.consultantID
        });
      }

      function populateRoleSource() {
        vm.roleSource = [];

        vm.roleSource.push({
          name: 'Konsultant',
          value: 3
        });

      }

      // function loadCC() {
      //   DynamicFactory.get('ContactCenterRsc', 'getCallCenters')()
      //     .then(function (result) {
      //       vm.callcenters = result;
      //     });
      // }

      function consultantContent(consultant) {
        $state.go('app.contactcenter_management.callcenters.consultants.content', {consultantId: consultant.consultantID});
      }

      function onDestroy() {
        WebSocketManager.unregisterWebSocketMethod('ConsultantStatusUpdate');
      }


    }
  );

}();

-function () {
  'use strict';
  angular
    .module('management.consultants')
    .component('consultantGeneralInfo', {
      templateUrl: 'app/main/contactcenter/management/consultants/consultantgeneralinfo/consultantgeneralinfo.html',
      bindings: {
        currConsultant:'<',
        personalAccount:'=',
        editingForbidden:'=',
        noTitle:'='
      },
      controllerAs: 'vm',
      controller: 'consultantGeneralInfoCtrl'
    }).controller('consultantGeneralInfoCtrl',
    function controller(SessionManager,$scope,$mdDialog, $stateParams, DynamicFactory,toastService,$rootScope,$state) {
      var vm = this; // jshint ignore:line

      vm.$onInit = onInit;
      vm.consultantStatuses = {};
      vm.selectedFileChanged = selectedFileChanged;
      vm.editData = editData;
      vm.$onChanges=onChanges;
      vm.goToDetails=goToDetails;
      vm.changePasswordDialog=changePasswordDialog;

      
      function onInit() {

        vm.consultantData={
          average:0
        };

        if (vm.currConsultant.id) {
          getConsultantGeneralInfo(vm.currConsultant.id);
        }

        if($state.current.name==='app.contactcenter_management.callcenters.consultants.consultant'){
          vm.goToDetailsButtonVisable=false;
        }else{
          vm.goToDetailsButtonVisable=true;
        }
      }


      function onChanges(obj) {
        console.log("1generalinfo:onChanges ", obj.currConsultant);
        if(obj.currConsultant.currentValue.id){
            console.log("3generalinfo:onChanges ", obj.currConsultant.currentValue.id);
            getConsultantGeneralInfo(obj.currConsultant.currentValue.id);
          
        }
      }

      function changePasswordDialog(){
        var user=SessionManager.getUser()
 
        $mdDialog.show({
          clickOutsideToClose: true,
          controller: 'changePassword',
          controllerAs: 'vm',
          focusOnOpen: false,
          targetEvent: event,
          templateUrl: 'app/main/contactcenter/management/users/changepassword/changepassword.html',
          multiple: false,
          locals: {
            userData:{
              userId:vm.consultantData.id,
              oldPwd:user.pwd
            }
          }
        });
      }

      function selectedFileChanged(result) {
        if (angular.isDefined(result) && result.length > 1) {

          DynamicFactory.get('profileRsc', 'PutConsultantPhoto')({
            Photo: result
          },vm.currConsultant.id).then(function (suc) {

            var consultant={
              photoUrl:vm.consultantData.photoUrl,
              firstName:vm.consultantData.firstName,
              lastName:vm.consultantData.lastName,
              consultantId:vm.consultantData.id
            };

            $rootScope.$broadcast('updateEditedConsultantList', {  consultant: consultant} );

            toastService.showToast('Pomyślnie zapisano zmiany.', 'success',4);
          }, ErrorFunc);
        }
      }
      function editData() {
        if(vm.personalAccount){
          $state.transitionTo('app.contactcenter_dashboard.settings.consultantedit',{
            consultantId: vm.consultantData.id
          });
        }else {
          $state.transitionTo('app.contactcenter_management.callcenters.consultants.consultant.edit', {
            callcenter: $stateParams.callcenter,
            consultantId: vm.currConsultant.id
          });
        }
      }

function goToDetails() {
  $state.go('app.contactcenter_management.callcenters.consultants.consultant', {
    callcenter: $stateParams.callcenter,
    consultantId: vm.currConsultant.id
  });
}

      function ErrorFunc(err) {
        alert('error');
        toastService.showToast('Nie udało się zapisać zmian', 'error',4);
      }
      function getConsultantGeneralInfo(consultantId) {
       var method='';
        if(vm.personalAccount){
          method='getMyConsultantGeneralData';
        }else{
          method='getConsultantGeneralInfo';
        }

        DynamicFactory.get('ConsultantsRsc', method)(consultantId)
          .then(function (data) {
            vm.consultantData=data;
            if(vm.consultantData.longDescription && vm.consultantData.longDescription.length>300){
              vm.consultantData.longDescriptionFixed=vm.consultantData.longDescription.substring(1,300)+'...';
            }
            else{
              vm.consultantData.longDescriptionFixed=vm.consultantData.longDescription;
            }

            if(vm.consultantData.groups) {
              vm.consultantData.groupsArray = vm.consultantData.groups.split(',');
            }
            if(!vm.consultantData.average){
              vm.consultantData.average=0.0;
            }
            if(! vm.consultantData.photoUrl){
              vm.consultantData.photoUrl='../../../../assets/icons/management/consultant.png';
            }

            DynamicFactory.get('ConsultantsRsc', 'getConsultantLastStatuses')(consultantId)
            .then(function (data) {
              vm.consultantStatuses = data;
              console.log('getConsultantLastStatuses', data);
            });
          });
      }


    }
  );

}();

- function () {
  'use strict';
  angular
    .module('management.consultants')
    .component('consultantEdit', {
      templateUrl: 'app/main/contactcenter/management/consultants/consultantedit/consultantedit.html',
      require: {
        tripleView: '^tripleView'
      },
      bindings: {
        personalAccount: "<"
      },
      controllerAs: 'vm',
      controller: 'consultantEditCtrl'
    }).controller('consultantEditCtrl',
      function controller($stateParams,SessionManager , authRolesConst, toastService, $rootScope, DynamicFactory, $state, $timeout, $q) {
        var vm = this; // jshint ignore:line

        vm.$onInit = onInit;
        vm.saveChanges = saveChanges;
        vm.cancelSaveChanges = cancelSaveChanges;
        vm.photoUpdate = photoUpdate;
        vm.addTag = addTag;
        // vm.getBaseTags =getBaseTags;

        function onInit() {
          // vm.avatarPhotoUrl='';
          getBaseTags();
          vm.userRole = SessionManager.getUserRole();
          if(vm.personalAccount){
            vm.currentConsultantId = true;
          }else if ($stateParams.consultantId) {
            if (vm.personalAccount || parseInt($stateParams.consultantId) === 0) {
              vm.currentConsultantId = parseInt($stateParams.consultantId);
            } else {
              vm.currentConsultantId = parseInt($stateParams.consultantId);
            }
          }
        }

        function photoUpdate() {
          // jeśli obrazki są różne to poczekaj 500ms i odśwież minaturę obrazka
          //if(vm.editedUser.photoUrlOld!==vm.editedUser.photoUrl){
          $timeout(function () {
            vm.editedUser.photoUrlOld = vm.editedUser.photoUrl;
          }, 3000);
          //}
        };

        function cancelSaveChanges(userId) {
          if ($stateParams.consultantId > 0 && !vm.personalAccount) {
            // gdy obrazek jest zmieniony, warto poczekac chwilę aż załaduje się na serwer
            var interval = 0;
            if (vm.editedUser.photoUrlOld !== vm.editedUser.photoUrl) {
              interval = 500;
            }

            $timeout(function () {
              $state.go('app.contactcenter_management.callcenters.consultants.consultant', {
                callcenter: $stateParams.callcenter,
                consultantId: $stateParams.consultantId
              });
            }, interval);

          } else {
            if (vm.personalAccount) {
              $state.go('app.contactcenter_dashboard.settings.general');
            } else {
              $state.go('app.contactcenter_management.callcenters.consultants', {
                callcenter: $stateParams.callcenter,
                consultantId: $stateParams.userId
              });
            }
          }

        }


        function updateConsultantList() {

          var consultant = {
            photoUrl: vm.editedUser.photoUrl,
            firstName: vm.editedUser.firstName,
            lastName: vm.editedUser.lastName,
            userID: vm.editedUser.id,
            consultantID: vm.editedUser.id,
            newRecordMode: vm.editedUser.newRecordMode,
            callCenterID: vm.editedConsultant.callCenterID
          };

          if (!consultant.userID) {
            consultant.userID = vm.editedUser.userID;
            consultant.consultantID = vm.editedUser.consultantID;
          }

          $rootScope.$broadcast('updateEditedConsultantList', {
            consultant: consultant
          });
        }

        function saveChanges() {

          if (vm.saveUser) {
            vm.saveUser().then(function (data) {
              if (angular.isDefined(data.userId)) {
                vm.currentConsultantId = data.userId;
              }
              if (vm.saveConsultant) {
                vm.saveConsultant(vm.currentConsultantId).then(function(data){

                  if (vm.saveMail) {
                    vm.saveMail(vm.currentConsultantId, $stateParams.callcenter);
                  }
                  if (vm.saveConsultantPhones) {
                    vm.saveConsultantPhones(vm.currentConsultantId);
                  }
                  updateConsultantList();
                  cancelSaveChanges(data.userId);
    
                  toastService.showToast('Pomyślnie zapisano zmiany.', 'success', 4);

                },function(err){
                    toastService.showToast('Zapis nie powiódł się.', 'error', 4);
                });
              }




            });
          }

        }
        // vm.getBaseTags = getBaseTags;
        function addTag(tag) {
          var defer = $q.defer();
          if (tag) {
            if (tag.tagId !== 'new') {
              defer.resolve(tag);
            } else {
              DynamicFactory.get('tagsRsc', 'addNewTag')(tag, tag.parentId)
                .then(function (response) {
                  tag.tagId = response.tagID;
                  tag.value = response.tagID;
                  defer.resolve(tag);
                });
            }
          }
          return defer.promise;
        }
        function getBaseTags() {
          DynamicFactory.get('tagsRsc', 'getTags')().then(function (result) {
            vm.baseTags = result;
          });
        }

      }
    );

}();

-function () {
  'use strict';
  angular
    .module('management.consultants')
    .component('consultantEditComponent', {
      templateUrl: 'app/main/contactcenter/management/consultants/consultanteditcomponent/consultanteditcomponent.html',
      bindings: {
        consultantId:'<',
        personalAccount: '<',
        saveIndicator:'=',
        editedConsultant:'=' // za pomocą tego parametru oddajemy zmodyfikowane dane poziom wyżej
      },
      controllerAs: 'vm',
      controller: 'consultantEditComCtrl'
    }).controller('consultantEditComCtrl',
    function controller($stateParams,$q, authRolesConst, toastService, $rootScope, DynamicFactory, $timeout) {
      var vm = this; // jshint ignore:line

      vm.$onInit = onInit;
      vm.$onChanges = onChanges;

      function onInit() {
        // vm.editedConsultant = {};
        vm.saveIndicator=saveConsultantData;

        if (!vm.personalAccount) {
          if(!vm.consultantId)
            initConsultantData();
          loadCC();
        }else{
          vm.currentConsultantId = undefined;
          loadConsultantData(null, vm.personalAccount);
        }

      }


      function initConsultantData() {
        // new record mode
        vm.editedConsultant = {
          callCenterID: $stateParams.callcenter,
          callCenterDisabled: 'true',
          roleID: authRolesConst.consultant,
          newRecordMode: true
        };
      }

      function onChanges(changesObj) {
        if ((changesObj.consultantId && changesObj.consultantId.currentValue)) {
          if (!vm.personalAccount) {

            vm.currentConsultantId = changesObj.consultantId.currentValue;
            loadConsultantData(vm.currentConsultantId, null);
          }
        }
      }


      function loadConsultantData(consultantId, personalAccount) {
        var method='';
        if(personalAccount){
          method='getMyConsultantForEdit';
          consultantId=undefined;
        }else {
          method='getConsultantForEdit';
        }

        DynamicFactory.get('ConsultantsRsc', method)(consultantId).then(function (data) {
          vm.editedConsultant = data;
          $timeout(function(){
            vm.consultantForm.$setDirty();
          },100);
        }, function (err) {
          console.log(err);
        });

      }



      function loadCC() {
        DynamicFactory.get('ContactCenterRsc', 'getCallCenters')()
          .then(function (result) {
            vm.callcenters = result;
          });
      }

      function saveConsultantData(userId) {
        var defer = $q.defer();

        if (vm.editedConsultant.newRecordMode) {
          vm.editedConsultant.userId=userId;
          DynamicFactory.get('ConsultantsRsc', 'addNewConsultant')(vm.editedConsultant).then(function (data) {
            vm.editedConsultant.consultantID = data.codeOrId;
            defer.resolve(data);
          }, ErrorFunc);
        } else {

          if (vm.personalAccount) {
            DynamicFactory.get('ConsultantsRsc', 'updateMyConsultantData')(vm.editedConsultant)
              .then(function (data) {
                defer.resolve(data);
              }, ErrorFunc);
          } else {
            DynamicFactory.get('ConsultantsRsc', 'editConsultant')(vm.editedConsultant)
              .then(function (data) {
                defer.resolve(data);
              }, ErrorFunc);
          }
        }

        return defer.promise;
      }

      function ErrorFunc(data, defer) {
        defer.reject('Wystapił nieoczekiwany bład przy zapisie consultanta');
        console.log('Wystapił nieoczekiwany bład przy zapisie consultanta');
        toastService.showToast('Wystąpił nieoczekiwany błąd przy zapisie konsultanta', 'error', 4);
      }


    }
  );

}();

- function () {
  'use strict';
  angular
    .module('management.consultants')
    .component('consultantCard', {
      templateUrl: 'app/main/contactcenter/management/consultants/consultantcard/consultantcard.html',
      require: {
        tripleView: '^tripleView'
      },
      bindings: {},
      controllerAs: 'vm',
      controller: 'consultantCardCtrl'
    }).controller('consultantCardCtrl',
      function controller($scope, $stateParams, DynamicFactory, connectionStatisticCons, connectionStatisticFuncService) {
        var vm = this; // jshint ignore:line

        vm.$onInit = onInit;

        function onInit() {
          // vm.currentConsultantId
          vm.connectionStatisticCons = connectionStatisticCons;
          vm.chartData = [];
          vm.getAgrForChart = DynamicFactory.get('reportsCosult', 'ReportsConnectionsAgrForChart');

          if ($stateParams.consultantId) {
            vm.currentConsultantId = $stateParams.consultantId;
          }
          getAgregationAsync();
        }


        function getAgregationAsync() {
          var from = new Date(moment().subtract(4, 'days').startOf('day')),
            to = moment().format();

          vm.getAgrForChart({
            From: from,
            To: to,
            ConsultantId : vm.currentConsultantId,
            CallcenterId: $stateParams.callcenter,
            AggregationType : 'D'
          }).then(function (response) {
            vm.chartData = connectionStatisticFuncService.groupData(response);
          });
        }


      }
    );

}();

(function () {
  'use strict';

  angular
    .module('contactcenter.dashboard')
    .component('navMultiBar', {
      templateUrl: 'app/main/contactcenter/dashboard/menucomponents/navmultibar/navmultibar.html',
      controllerAs: 'vm',
      bindings: {
        menuItem: '=',
      },
      controller: Ctrl
    });

  /** @ngInject */
  function Ctrl($scope, DynamicFactory, SessionManager, ReportTools, ReportsData, $interval) {
    var vm = this;

    vm.$onInit = onInit;
    vm.$onDestroy = onDestroy;
    vm.getAgrForChart = DynamicFactory.saveGet('reportsCosult', 'ConsultantReportsConnectionsAgrForChart');

    var timerInterval = $interval(function () {
      renderChart();
    }.bind(vm), 60000);

    function onInit() {
      // WebSocketManager.registerWebSocketMethod('ConsultantStatusUpdate', 'navStatusAxisStatusUpdate', onStatusUpdate);
      // vm.menuItem.isHidden = true;
      configChart();
      renderChart();
      $scope.$on('nav-change', refreshChart);

    }


    function refreshChart(event, data) {
      if (vm.menuItem.name.indexOf(data) !== -1) {
        vm.chartApi.refresh();
        console.log('navMultiBar | chart refresh!');
      }
    }


    function renderChart() {
      var from = new Date(moment().subtract(4, 'days').startOf('day')),
        to = moment().format();
      // ReportsData.resetNextColor();
      vm.dateInBetween = ReportTools.dateInBetween('DD-MM-YYYY', {
        From: from,
        To: to
      });


      vm.dateInBetweenFormated = ReportTools.dateInBetween('DD/MM', {
        From: from,
        To: to
      });


      if (SessionManager.isConsultant()) {
        vm.getAgrForChart({
          From: from,
          To: to,
          AggregationType: 'D'
        }).then(function (response) {
          // var chartData = connectionStatisticFuncService.groupData(response, from, to);
          // chartData.dataCount[0].key = 'Ilość';
          // chartData.dataCount[0].color = 'darkred';

          // chartData.dataSeconds[0].key = 'Minuty';
          // chartData.dataSeconds[0].bar = true;
          if (response.length > 0) {
            if (vm.menuItem.isHidden)
              vm.menuItem.isHidden = false;
            ReportsData.resetNextColor();

            vm.mainChart.data = [{
              key: 'Ilość',
              // color: colorCall(),
              values: agregateConnectionsData(response, 'count')
            }, {
              key: 'Minuty',
              bar: true,
              values: agregateConnectionsData(response, 'seconds', colorCall)
            }];
          } else {
            vm.menuItem.isHidden = true;
          }
        });
      }
    };

    function colorCall() {
      return ReportsData.getNextColor();
    }


    function agregateConnectionsData(callData, propName, colorCall) {
      var reportGroup = _(callData)
        .groupBy('timePeriod')
        .map(function (record, timePeriod) {
          return {
            x: timePeriod,
            y: _.sumBy(record, propName)
            // count: _.sumBy(record, 'count'),
            //  seconds: _.sumBy(record, 'seconds'),
            // avgSeconds:  _.sumBy(record, 'avgSeconds')/record.length
          };
        }).orderBy('timePeriod').value();
      return _.map(vm.dateInBetween, function (value, key) {
        var formatDate = value;
        var dataAll = findReportDataByDate(reportGroup, formatDate, colorCall);
        dataAll.x = moment(dataAll.x, 'DD-MM-YYYY').valueOf();
        return dataAll;
        // chartData.dataCount[0].values.push({
        //   x: data,
        //   y: dataAll.count || 0
        // });

        // chartData.dataSeconds[0].values.push({
        //   x: data,
        //   y: dataAll.seconds || 0
        // });

        // chartData.dataAvgSeconds[0].values.push({
        //   x: data,
        //   y: dataAll.avgSeconds || 0
        // });

      });
    }

    function findReportDataByDate(reportGroup, formatDate, colorCall) {
      var dataAll = _.find(reportGroup, {
        'x': formatDate
      });
      if (!dataAll) {
        dataAll = {
          x: formatDate,
          y: 0
        };
      }
      dataAll.color = colorCall ? colorCall() : undefined;

      return dataAll;
    }

    function onDestroy() {
      // WebSocketManager.unregisterWebSocketMethod('ConsultantStatusUpdate','navStatusAxisStatusUpdate');
      $interval.cancel(timerInterval);
      timerInterval = undefined;
    }

    function configChart() {
      // vm.currentType = 'MM-YYYY';

      var mainChart = angular.copy(ReportsData.defaultChartConf);
      mainChart.options.chart.color = function color() {
        return '#FF5252'; //'#5fd4c4'
      };
      mainChart.options.chart.height = 110;
      mainChart.options.chart.type = 'linePlusBarChart';
      mainChart.options.chart.width = null;
      mainChart.options.chart.showValues = false;
      mainChart.options.chart.focusEnable = false;
      mainChart.options.chart.showLegend = false;
      // mainChart.options.chart.reduceXTicks = false;


      // mainChart.options.chart.x = function (d, i) {
      //   return i;
      // };
      // mainChart.options.chart.y= function(d,i) { return d.x };
      mainChart.options.chart.margin = {
        top: 10,
        bottom: 30,
        right: 20,
        left: 20
      };
      // mainChart.options.chart.tooltip = {
      //   //   valueFormatter: function (d, i) {
      //   //     return d.toString();
      //   //   }
      //   keyFormatter: function (d, i) {
      //     return d.toString();
      //   }
      // };
      mainChart.options.chart.bars = {
        forceY: [0],
        padData: true
      };
      mainChart.options.chart.bars2 = {
        forceY: [0]
      };
      mainChart.options.chart.xAxis = {
        tickFormat: function (d) {
          // if (d) {
          // return d3.time.format('%b-%Y')(new Date(d));
          //  return moment(d).format('DD/MM');
          return '';
          // }
          // var dx = vm.mainChart.data[0].values[d] && vm.mainChart.data[0].values[d].x || 0;
          // if (dx > 0) {
          //   return d3.time.format('%x')(new Date(dx));
          // }
          // return null;
        }
        // rotateLabels: -20,
        // showMaxMin: false,

      };




      // mainChart.options.chart.x2Axis = {
      //   tickFormat: function (d) {
      //     if (d) {
      //       // return d3.time.format('%b-%Y')(new Date(d));
      //       return moment(d).format('DD/MM');
      //     }
      //
      //
      //     // var dx = vm.mainChart.data[0].values[d] && vm.mainChart.data[0].values[d].x || 0;
      //     // return d3.time.format('%b-%Y')(new Date(dx));
      //   },
      //   rotateLabels: -20,
      //   showMaxMin: false
      // };


      mainChart.options.chart.y1Axis = {
        tickFormat: chartTimeFormat,
        axisLabelDistance: 12
      };
      mainChart.options.chart.y2Axis = {
        tickFormat: function (d) {
          return d;
        }
      };
      mainChart.options.chart.y3Axis = {
        tickFormat: chartTimeFormat
      };
      mainChart.options.chart.y4Axis = {
        tickFormat: function (d) {
          return d;
        }
      };
      // mainChart.options.chart.xAxis = {
      //   tickFormat: chartTimeFormat,
      //   rotateLabels: -20
      // };
      // mainChart.options.chart.x2Axis = {
      //   tickFormat: chartTimeFormat,
      //   rotateLabels: -20
      // };
      // mainChart.options.chart.yAxis = {
      //   tickFormat: function (d) {
      //     return d;
      //   }
      // };
      // mainChart.options.chart.y2Axis = {
      //   tickFormat: function (d) {
      //     return d;
      //   }
      // };
      // mainChart.options.chart.valueFormat = chartTimeFormat;
      vm.mainChart = mainChart;
      ReportsData.resetNextColor();
    }

    function chartTimeFormat(d) {
      return ReportTools.formatSecs(d) + ' minut';
    }


  }
})();

(function () {
  'use strict';

  angular
    .module('contactcenter.dashboard')
    .component('navStatusAxis', {
      templateUrl: 'app/main/contactcenter/dashboard/menucomponents/navstatusaxis/navstatusaxis.html',
      controllerAs: 'vm',
      controller: Ctrl
    });

  /** @ngInject */
  function Ctrl(WebSocketManager, DynamicFactory, $interval) {
    var vm = this;


    vm.statusStatistic = [];

    vm.$onInit = onInit;
    vm.$onDestroy = onDestroy;
    vm.renderAxis = renderAxis;


    var timerInterval = $interval(function () {
      renderAxis()
    }.bind(vm), 60000);

    function onInit() {
        WebSocketManager.registerWebSocketMethod('ConsultantStatusUpdate', 'navStatusAxisStatusUpdate', onStatusUpdate);
        vm.renderAxis();

    }
    function renderAxis(){
        DynamicFactory.get('reportsCosult', 'StatusStatistic')().then(function (data) {
            vm.statusStatistic = data;
            var active = _.filter(vm.statusStatistic, function (x) { return x.status === 1; });
            vm.activeTime = _.sumBy(active, function (x) { return x.difference; });
            vm.activeTimeFormat = moment.utc(vm.activeTime*1000).format('HH:mm');

            var breakSumTime = _.filter(vm.statusStatistic, function (x) { return x.status === 2; });
            vm.breakTime = _.sumBy(breakSumTime, function (x) { return x.difference; });
            vm.breakTimeFormat = moment.utc(vm.breakTime*1000).minutes(); //.format('HH:mm:ss');

            if (vm.statusStatistic && vm.statusStatistic.length > 0) {
                vm.timeFromLogin = moment().diff(vm.statusStatistic[0].insertionTime, 'seconds');
                vm.timeFromLoginFormat = moment.utc(moment().diff(vm.statusStatistic[0].insertionTime)).format('HH:mm:ss');
            }
        });
    }
    function onStatusUpdate(data) {
      if (data.Content) {
            vm.renderAxis();
      }
    }
    function onDestroy() {
      WebSocketManager.unregisterWebSocketMethod('ConsultantStatusUpdate','navStatusAxisStatusUpdate');
      $interval.cancel(timerInterval);
      timerInterval = undefined;
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('contactcenter.dashboard')
    .component('navAvgCallsChart', {
      templateUrl: 'app/main/contactcenter/dashboard/menucomponents/navavgcallschart/navavgcallschart.html',
      controllerAs: 'vm',
      bindings: {
        menuItem: '=',
      },
      controller: navAvgCallsChart
    });

  /** @ngInject */
  function navAvgCallsChart($scope, DynamicFactory, SessionManager, ReportTools, ReportsData, $interval) {
    var vm = this;

    vm.$onInit = onInit;
    vm.$onDestroy = onDestroy;
    vm.getAgrForChart = DynamicFactory.saveGet('reportsCosult', 'ConsultantReportsConnectionsAgrForChart');

    var timerInterval = $interval(function () {
      renderChart();
    }.bind(vm), 60000);

    function onInit() {
      // WebSocketManager.registerWebSocketMethod('ConsultantStatusUpdate', 'navStatusAxisStatusUpdate', onStatusUpdate);
      // vm.menuItem.isHidden = true;
      configChart();
      renderChart();
      $scope.$on('nav-change',refreshChart);
    }


    function refreshChart(event,data){
      if(vm.menuItem.name.indexOf(data)!== -1){
        vm.chartApi.refresh();
        console.log('navAvgCallsChart | chart refresh!');
      }
    }

    function renderChart() {
      var from = new Date(moment().subtract(4, 'days').startOf('day')),
        to = moment().format();
      vm.dateInBetween = ReportTools.dateInBetween('DD-MM-YYYY', {
        From: from,
        To: to
      });


      if (SessionManager.isConsultant()) {
        vm.getAgrForChart({
          From: from,
          To: to,
          AggregationType: 'D'
        }).then(function (response) {
          if (response.length > 0) {
            if (vm.menuItem.isHidden)
              vm.menuItem.isHidden = false;
            ReportsData.resetNextColor();

            vm.mainChart.data = [{
              key: 'Minuty',
              values: agregateConnectionsData(response, 'avgSeconds', colorCall)
            }];
          } else {
            vm.menuItem.isHidden = true;
          }
        });
      }
    };

    function colorCall() {
      return ReportsData.getNextColor();
    }


    function agregateConnectionsData(callData, propName, colorCall) {
      var reportGroup = _(callData)
        .groupBy('timePeriod')
        .map(function (record, timePeriod) {
          return {
            x: timePeriod,
            y: _.sumBy(record, propName)
            // count: _.sumBy(record, 'count'),
            //  seconds: _.sumBy(record, 'seconds'),
            // avgSeconds:  _.sumBy(record, 'avgSeconds')/record.length
          };
        }).orderBy('timePeriod').value();
      return _.map(vm.dateInBetween, function (value, key) {
        var formatDate = value;
        var dataAll = findReportDataByDate(reportGroup, formatDate, colorCall);
        dataAll.x = moment(dataAll.x, 'DD-MM-YYYY').valueOf();
        return dataAll;
      });
    }

    function findReportDataByDate(reportGroup, formatDate, colorCall) {
      var dataAll = _.find(reportGroup, {
        'x': formatDate
      });
      if (!dataAll) {
        dataAll = {
          x: formatDate,
          y: 0
        };
      }
      dataAll.color = colorCall ? colorCall() : undefined;

      return dataAll;
    }

    function onDestroy() {
      // WebSocketManager.unregisterWebSocketMethod('ConsultantStatusUpdate','navStatusAxisStatusUpdate');
      $interval.cancel(timerInterval);
      timerInterval = undefined;
    }

    function configChart() {
      // vm.currentType = 'MM-YYYY';

      var mainChart = angular.copy(ReportsData.defaultChartConf);
      mainChart.options.chart.color = function color() {
        return '#FF5252'; //'#5fd4c4'
      };
      mainChart.options.chart.height = 110;
      mainChart.options.chart.type = 'discreteBarChart';
      mainChart.options.chart.width = null;
      mainChart.options.chart.showValues = false;
      mainChart.options.chart.focusEnable = false;
      mainChart.options.chart.showLegend = false;
      mainChart.options.chart.reduceXTicks = false;
      mainChart.options.chart.margin = {
        top: 10,
        bottom: 30,
        right: 20,
        left: 20
      };
      mainChart.options.chart.xAxis = {
        tickFormat: function (d) {
          if (d) {
            return moment(d).format('DD/MM');
          }
        },
        rotateLabels: -20
      };
      mainChart.options.chart.yAxis = {
        tickFormat: chartTimeFormat,
        axisLabelDistance: 12
      };
      mainChart.options.chart.y2Axis = {
        tickFormat: function (d) {
          return d;
        }
      };

      mainChart.options.chart.valueFormat = chartTimeFormat;
      vm.mainChart = mainChart;
      ReportsData.resetNextColor();
    }

    function chartTimeFormat(d) {
      return ReportTools.formatSecs(d) + ' minut';
    }


  }
})();

(function () {
  'use strict';

  angular
    .module('contactcenter.dashboard')
    .component('dashboardButton', {
      templateUrl: 'app/main/contactcenter/dashboard/menucomponents/dashboardbutton/dashboardbutton.html',
      controllerAs: 'vm',
      // bindings: {
      //   list: '=',
      //   type: '='
      // },
      controller: Ctrl
    });

  /** @ngInject */
  function Ctrl($scope, $state) {
    var vm = this;


    vm.goToDashboardState = goToDashboardState;
    vm.$onDestroy = onDestroy;
    vm.$onInit = init;

    function init() {
      vm.listener = $scope.$on("$stateChangeSuccess", stateChangeSuccess);
      // vm.state = $state.current;
    }

    function onDestroy() {
      if(vm.listener)
        vm.listener();
    };

    function stateChangeSuccess(event, toState, toParams, fromState, fromParams) {
      vm.activeState = toState.name;
    }

    function goToDashboardState() {
      var state = 'app.contactcenter_dashboard';
      // if(vm.currentState!==state) {
      if ($state.current.name !== state) {
        $state.go(state);
        vm.currentState = state;
      }
    }

  }
})();

(function () {
  'use strict';
  angular.module('contactcenter.dashboard').component('dashboardMenu', {
    templateUrl: 'app/main/contactcenter/dashboard/menucomponents/dashboardmenu/dashboardmenu.html',
    controllerAs: 'vm',
    controller: ctrl
  });

  /** @ngInject */
  function ctrl($interval, $state, $translate) {

    var vm = this;
    vm.AssignedDate = Date;
    vm.month = moment().format('MMM MMMM');
    vm.day = moment().format('ddd dddd');
    // vm.goToDashboardState = goToDashboardState;
    vm.goToPartyState = goToPartyState;
    vm.$onInit = init;
    vm.changeLanguage = changeLanguage;

    $interval(function () {
      // nothing is required here, interval triggers digest automaticaly
    }, 1000);


    vm.languages = {
      pl: {
        title: "Polish",
        translation: "TOOLBAR.POLISH",
        code: "pl",
        selected: false,
        flag: "pl"
      },
      en: {
        title: "English",
        translation: "TOOLBAR.ENGLISH",
        code: "en",
        selected: false,
        flag: "us"
      }
    };

    function init() {
      vm.currentState = $state.current.name;
      vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
      vm.selectedLanguage.selected = true;
    }

    // function goToDashboardState() {
    //   var state = 'app.contactcenter_dashboard';
    //   // if(vm.currentState!==state) {
    //   if ($state.current.name !== state) {
    //     $state.go(state);
    //     vm.currentState = state;
    //   }
    // }
    function goToPartyState() {
      var state = 'app.contactcenter_dashboard.party';
      // if(vm.currentState!==state) {
      if ($state.current.name !== state) {
        $state.go(state);
        vm.currentState = state;
      }
    }

    function changeLanguage(lang) {
      // vm.selectedLanguage.selected = false;
      // vm.selectedLanguage = lang;
      // vm.selectedLanguage.selected = true;
      // Change the language
      $translate.use(lang.code);
    }
  }

})();

(function () {
    'use strict';
    angular
        .module('contactcenter.dashboard')
        .factory('msgStatsDataChart', ['$translate', msgStatsDataChart]);

    function msgStatsDataChart($translate) {
        var _this = {};

        _this.colors = [
            { color: '#E57373'},
            { color: '#9CCC65'},
            { color: '#558B2F'},
            { color: '#FFAB40'},
            { color: '#FF6E40'}
        ];

        _this.typeMsg = [
            { key: 'S', name: 'SMS' },
            { key: 'C', name: 'CHAT' }
        ];
        _this.defaultChartConf = {
            config: {
                refreshDataOnly: true,
                deepWatchData: true
            },
            options: {
                chart: {
                    type: 'multiBarChart',
                    height: 200,
                    margin: {
                        top: 15,
                        right: 16,
                        bottom: 50,
                        left: 48
                    },
                    clipEdge: true,
                    groupSpacing: 0.3,
                    reduceXTicks: false,
                    stacked: true,
                    duration: 250,
                    showLegend: true,
                    isArea: true,
                    interpolate: 'cardinal',
                    noData: $translate.instant('REPORTS.NO_DATA'),
                    x: function (d) {
                        return d.x;
                    },
                    y: function (d) {
                        return d.y;
                    },
                    yAxis: {
                        tickFormat: function(d) {
                            // console.log('d',d);
                            return d;
                        }
                    },
                    legend: {
                        margin: {
                            top: 1,
                            bottom: 32
                        }
                    },
                    showValues: true,
                    showControls: false,
                    controls: {
                        labels: {
                            grouped: 'Grupuj',
                            stacked: 'Sterta'
                        },
                        margin: {
                            top: 1,
                            bottom: 32
                        }
                    },
                }
            },
            data: [],
            data1: []
        };
        return _this;
    }
})();

(function () {
    'use strict';

    angular
        .module('contactcenter.dashboard')
        .component('reportsMessagesStats', {
            templateUrl: 'app/main/contactcenter/dashboard/component/statisticsmessagesstats/ReportsMessagesStats.html',
            controllerAs: 'vm',
            controller: ReportsMessagesStats,
            bindings: {
                consultantId:'=',
                stats: '<',
                avg: '<'
            }
        })

    function ReportsMessagesStats(DynamicFactory, SessionManager, reportsCosult, authRolesConst, ReportTools, msgStatsDataChart) {
        var vm = this;

        //resources
        vm.reportsMessagesStats = DynamicFactory.get('reportsCosult', 'ReportsMessagesStats');
        //functions
        vm.$onInit = onInit;
        //others


        function onInit() {
          vm.mainChart = msgStatsDataChart.defaultChartConf;
          vm.mainChart.data=[];
          vm.mainChart.data1=[];
          vm.mainChart.options.chart.valueFormat = countFormat;
          vm.mainChart.options.chart.xAxis={
            tickFormat: function(d) {
              moment.locale('pl');

              if(d.length===10 && d[2]==='-' && d[5]==='-')
              {
                return moment(d,'DD-MM-YYYY').format('MMM Do');
              }
              else{
                return d;
              }

            },
            rotateLabels:-20
          };


          vm.currectDate = 'DD-MM-YYYY';
          vm.typeMsg = msgStatsDataChart.typeMsg;

            getMessagesStatsAsync();
        } // the end onInit

        function countFormat(d) {
          return d.toString();
        }

        function getMessagesStatsAsync() {
            vm.reportsMessagesStats(120,vm.consultantId).then(function (r) {
                vm.messagesStatsData = r;
                groupData();
            });
        }

        function groupData() {
            var dateFiveDays = {
                From: new Date(moment().subtract(4, 'days').startOf('day')),
                To: moment().format()
            };
            vm.dateArray = ReportTools.dateInBetween(vm.currectDate, dateFiveDays);

            vm.reportGroup = _(vm.messagesStatsData)
                .groupBy(function (result) {
                    return moment(result['date']).format(vm.currectDate);
                })
                .map(function (value, key) {
                    _.forEach(value, function(v,k) {
                        vm.type = v.type;
                        vm.count = v.msg_count;
                        vm.avg_time = v.avg_time;
                    })
                    return {
                        date: key,
                        type: vm.type,
                        total: vm.count,
                        avg_time: convertAvg(vm.avg_time)
                    }
                }).orderBy('date').value();

            _.forEach(vm.dateArray, function (value, key) {
                var formatDate = value;
                var dataAll = findReportDataByDate(vm.reportGroup, formatDate);

                _.forEach(vm.reportGroup, function(v,k) {
                    var row = _.find(vm.mainChart.data1, {'key': 'avg_time'});
                    if(!row) {
                        row = { key: 'avg_time', values: [] };
                        vm.mainChart.data1.push(row);
                    }

                    var total = dataAll.avg_time ? dataAll.avg_time : 0;
                    row.values.push({ x: formatDate, y: total });
                    vm.lastAvgAnswer = total;
                })

                _.forEach(vm.typeMsg, function (value2, key2) {
                    var row = _.find(vm.mainChart.data, { 'key': value2.name });
                    if (!row) {
                        row = { key: value2.name, values: [] };
                        vm.mainChart.data.push(row);
                    }
                    var dataAllArray = [];
                    dataAllArray.push(dataAll);
                    var total = findTotalByTypeMsg(dataAllArray, value2.key);
                    row.values.push({ x: formatDate, y: total });
                    vm.lastCount = dataAll.total;
                });
            })
        }

        function findReportDataByDate(reportGroup, formatDate) {
            var dataAll = _.find(reportGroup, { 'date': formatDate });
            if (!dataAll) {
                dataAll = { data: [], date: formatDate, total: 0, avg_time: 0 };
            }
            return dataAll;
        }

        function findTotalByTypeMsg(data, type) {
            var total = 0;
            var rowReportGroup = _.find(data, { 'type': type });
            if (rowReportGroup) {
                total = rowReportGroup.total;
            }
            return total;
        }

        function convertAvg(time) {
            var timeArray = time.split(':'),
                changeTime = timeArray[0] + '.' + timeArray[1];
                return changeTime;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('contactcenter.dashboard')
        .component('statusAxis', {
            templateUrl: 'app/main/contactcenter/dashboard/component/statusaxis/statusaxis.html',
            controllerAs: 'vm',
            controller: StatusAxis,
            bindings: {
                consultantId: '=',
                stats: '<',
                avg: '<'
            }
        })

    function StatusAxis(DynamicFactory, SessionManager, reportsCosult, authRolesConst, ReportTools, msgStatsDataChart, WebSocketManager) {
        var vm = this;
        vm.statusStatistic = [];

        vm.$onInit = onInit;
        vm.$onDestroy = onDestroy;
        vm.renderAxis = renderAxis;

        function onInit() {
            WebSocketManager.registerWebSocketMethod('ConsultantStatusUpdate', 'ConsultantStatusUpdateConsultantsStatistics', onStatusUpdate);
            vm.renderAxis();
        }
        function renderAxis(){
            DynamicFactory.get('reportsCosult', 'StatusStatistic')().then(function (data) {
                vm.statusStatistic = data;
                var active = _.filter(vm.statusStatistic, function (x) { return x.status === 1; });
                vm.activeTime = _.sumBy(active, function (x) { return x.difference; });
                vm.activeTimeFormat = moment.utc(vm.activeTime*1000).format('HH:mm:ss');
                
                var breakSumTime = _.filter(vm.statusStatistic, function (x) { return x.status === 2; });
                vm.breakTime = _.sumBy(breakSumTime, function (x) { return x.difference; });
                vm.breakTimeFormat = moment.utc(vm.breakTime*1000).minutes(); //.format('HH:mm:ss');

                if (vm.statusStatistic && vm.statusStatistic.length > 0) {
                    vm.timeFromLogin = moment().diff(vm.statusStatistic[0].insertionTime, 'seconds');
                    vm.timeFromLoginFormat = moment.utc(moment().diff(vm.statusStatistic[0].insertionTime)).format('HH:mm:ss');
                }
            });
        }
        function onStatusUpdate(data) {
          if (data.Content) {
                vm.renderAxis();
          }
        }
        function onDestroy() {
          WebSocketManager.unregisterWebSocketMethod('ConsultantStatusUpdate');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('contactcenter.dashboard')
        .service('msmWebSocketMenager', msmGlue)

    /* @ngInject */
    function msmGlue(WebSocketManager, SessionManager, msmGlue, $filter) {
        var vm = this;
        vm.SessionList = [];
        vm.init = init;
        vm.Destroy = Destroy;
        
        function onCreate() {
            console.log('msmWebSocketMenager - onCreate');
        }
        function init() {
            console.log('msmWebSocketMenager - init');
            WebSocketManager.registerWebSocketMethod(
                'MessageSessionStatusUpdate',
                'statusUpdateArrive',
                wsStatusUpdate,
                SessionManager.buildRegexForCallCenter()
            );

            WebSocketManager.registerWebSocketMethod(
                'ConsultantStatusUpdate',
                'ConsultantStatusUpdateConsultantsStatistics',
                wsConsultantStatusUpdate,
                SessionManager.buildRegexForCallCenter());

        }

        function Destroy() {
            WebSocketManager.unregisterWebSocketMethod('MessageSessionStatusUpdate', 'statusUpdateArrive');
            WebSocketManager.unregisterWebSocketMethod('ConsultantStatusUpdate', 'ConsultantStatusUpdateConsultantsStatistics');
        }


        function wsConsultantStatusUpdate(data) {

            var statusData = JSON.parse(data.Content);
            console.log('onConsultantStatusUpdate - data: ', statusData);

            var sessions = _.filter(msmGlue.SessionList, function (session) {
                return session.consultantId == statusData.consultantID;
            });

            angular.forEach(sessions, function (session) {
                session.consultantStatus = statusData.status
            });
        }

        function wsStatusUpdate(data) {
            vm.data = JSON.parse(data.Content);
            console.log('wsStatusUpdate - data: ', vm.data);

            var session = _.find(msmGlue.SessionList, function (session) {
                return session.sessionGuid == vm.data.message.sessionGuid;
            });
            console.log('wsStatusUpdate - session: ', session);
            if (session) {

                if (session.consultantId == vm.data.message.consultantId) {
                    session.consultantStatus = vm.data.message.consultantStatus
                }

                session.statusDesc = vm.data.message.statusDesc;
                session.statusId = vm.data.message.statusId;
                session.serviceName = vm.data.message.serviceName;
                session.servicePhotoUrl = vm.data.message.servicePhotoUrl;
                if (vm.data.message.serviceId) {
                    session.serviceId = vm.data.message.serviceId;
                }
                if (vm.data.message.statusId >= 100) {
                    session.insertionTimeDif = null;
                    session.finished = moment();
                }
                else if (vm.data.message.statusId >= 3 && vm.data.message.statusId <= 5) {
                    session.consultantFirstName = vm.data.message.consultantFirstName;
                    session.consultantLastName = vm.data.message.consultantLastName;
                    session.consultantLogin = vm.data.message.consultantLogin;
                    session.consultantId = vm.data.message.consultantId;
                    session.consultantPhotoUrl = vm.data.message.consultantPhotoUrl;
                }
                else if (vm.data.message.statusId >= 0 && vm.data.message.statusId <= 2) {
                    session.consultantFirstName = "";
                    session.consultantLastName = "";
                    session.consultantLogin = "";
                    session.consultantId = 0;
                    session.consultantPhotoUrl = "";
                }
                
            }
            else {
                vm.data.message.insertionTimeDT = moment(vm.data.message.insertionTime);
                vm.data.message.insertionTimeDif = moment().diff(vm.data.message.insertionTimeDT, 'seconds');
                if (vm.data.message.statusId >= 100) {
                    vm.data.message.finished = moment();
                }
                msmGlue.SessionList.push(vm.data.message);
            }
            msmGlue.calcFiltersNumbers();
            //kasowanei juz nieaktywnej po 2 min
        }



        onCreate();
    }

})();
(function () {
    'use strict';

    angular
        .module('contactcenter.dashboard')
        .service('msmGlue', msmGlue)
        .constant('msmFilterConst', {
            all: 0,
            active: 1,
            waiting: 2,
            finished: 3
        })

    /* @ngInject */
    function msmGlue(msmFilterConst, $filter, DynamicFactory, $interval, $timeout) {
        var vm = this;
        vm.timerInterval = undefined;
        vm.SessionList = [];

        vm.activeSessions = [];
        vm.waitingSessions = [];
        vm.closedSessions = [];
        vm.waitingPerService = {};

        vm.ServiceList = [];
        vm.consultantsOcupation = {};
        vm.filteredConsultants = [];
        vm.calcFiltersNumbers = calcFiltersNumbers;
        vm.currentFilterMode = 1// 0.  wszystkie, 1. aktywne, 2. oczekujące, 3. zakńczone
        vm.currentSession = null;
        vm.currentConsultant = null
        vm.consultantFilterFunc = null;

        vm.consultantFilterFunc = null;
        vm.updateMonitoringData = LoadMonitoringData;

        vm.showOnBreak = false;
        vm.showOnBreakFilter = {
            status: 1
        }

        vm.filterNumbers = {
            all: 0,
            active: 0,
            waiting: 0,
            finished: 0
        }

        vm.filtersArray = {
            0: function (x) {
                return true;
            },
            1: function (x) {
                return x.statusId != 2 && x.statusId > 0 && x.statusId < 100;
            },
            2: function (x) {
                return x.statusId == 2;
            },
            3: function (x) {
                return x.statusId >= 100;
            }
        }
        vm.filterObject = vm.filtersArray[vm.currentFilterMode];


        //functions
        vm.setCurrentFilterMode = setCurrentFilterMode;
        vm.setFilterNumber = setFilterNumber;





        function onCreate() {
            // CreateMocSessionList();
            // calcFiltersNumbers();
            //LoadMsmData();
            //getConsultantsOcupation()
            LoadMonitoringData();
            vm.timerInterval = $interval(function () {
                checkClosedSession();
            }, 5 * 1000)
        }

        function LoadMonitoringData()
        {
            console.log("LoadMonitoringData");
            if (vm.monitorTimer) {
                $timeout.cancel(vm.monitorTimer);
            }
            console.log("LoadMonitoringData:getCurrentSessions");
            DynamicFactory.get('MsmRsc', 'getCurrentSessions')().then(
                function (response) {

                    vm.SessionList = response.sessions;//_.sortBy(response.sessions, ['-service.id','priority1','priority2','id']);
                    //vm.ServiceList = response.services;
                    
                    vm.activeSessions = _.filter(response.sessions, vm.filtersArray[1]);
                    vm.waitingSessions = _.filter(response.sessions, vm.filtersArray[2]);
                    vm.closedSessions = _.filter(response.sessions, vm.filtersArray[3]);
                    vm.waitingPerService = _.groupBy(vm.waitingSessions, 'serviceId');

                    var favicon = document.getElementById("favicon");
           
                    if(vm.waitingSessions.length === 0) {
                        favicon.setAttribute("href", "/assets/icons/fav/ta.png");
                    }
                    else if(vm.waitingSessions.length > 0 && vm.waitingSessions.length <= 9) {
                        favicon.setAttribute("href", "/assets/icons/fav/" + vm.waitingSessions.length + ".png");
                    }
                    else if(vm.waitingSessions.length > 9) {
                        favicon.setAttribute("href", "/assets/icons/fav/9plus.png");
                    }

                    TransformMsmData(vm.SessionList);
                    calcFiltersNumbers();

                    vm.showOnBreakFilter = {
                        status: (vm.showOnBreak ? "!0" : "1")
                    }
                    console.log("LoadMonitoringData:getConsultantsOcupation");
                    DynamicFactory.get('ConsultantsRsc', 'getConsultantsOcupation')().then(
                        function (response) {
                            vm.consultantsOcupation = response;
                            
                            if (vm.consultantFilterFunc) {
                                var tmp = _.filter(response.consultantEnities, vm.consultantFilterFunc);

                                vm.filteredConsultants = _.sortBy(tmp, ['service.id','priority1','priority2','id']);
                            }
                            else {
                                vm.filteredConsultants = response.consultantEnities;
                            }
        
                            if (vm.currentConsultant) {
                                if (vm.consultantsOcupation && vm.consultantsOcupation.consultantEnities) {
                                    for (var i = 0; i < vm.consultantsOcupation.consultantEnities.length; i++) {
                                        if (vm.consultantsOcupation.consultantEnities[i].id == vm.currentConsultant.id &&
                                            vm.consultantsOcupation.consultantEnities[i].service.id == vm.currentConsultant.service.id) {
                                            vm.currentConsultant = vm.consultantsOcupation.consultantEnities[i];
                                            break;
                                        }
                                    }
                                }
                            }
                            
                            vm.monitorTimer = $timeout(function () {
                                LoadMonitoringData();
                            }, 5000);
                        },
                        function (error) {
                            vm.monitorTimer = $timeout(function () {
                                LoadMonitoringData();
                            }, 5000); 
                        });
                },
                function (error) {
                    vm.monitorTimer = $timeout(function () {
                        LoadMonitoringData();
                    }, 10000);
                });

            

        }

        // function LoadMsmData() {
        //     console.log("LoadMsmData");
        //     DynamicFactory.get('MsmRsc', 'getCurrentSessions')().then(
        //         function (response) {

        //             vm.SessionList = response.sessions;
        //             vm.ServiceList = response.services;

        //             TransformMsmData(vm.SessionList);
        //             calcFiltersNumbers();

        //             if (vm.sessionTimer) {
        //                 $timeout.cancel(vm.sessionTimer);
        //             }
        //             vm.sessionTimer = $timeout(function () {
        //                 LoadMsmData();
        //             }, 10000);
        //         },
        //         function (error) {
        //             vm.sessionTimer = $timeout(function () {
        //                 LoadMsmData();
        //             }, 10000);
        //         });
        // }

        function getConsultantsOcupation() {

            vm.showOnBreakFilter = {
                status: (vm.showOnBreak ? "!0" : "1")
            }
            DynamicFactory.get('ConsultantsRsc', 'getConsultantsOcupation')().then(
                function (response) {
                    vm.consultantsOcupation = response;

                    if (vm.currentConsultant) {
                        if (vm.consultantsOcupation && vm.consultantsOcupation.consultantEnities) {
                            for (var i = 0; i < vm.consultantsOcupation.consultantEnities.length; i++) {
                                if (vm.consultantsOcupation.consultantEnities[i].id == vm.currentConsultant.id &&
                                    vm.consultantsOcupation.consultantEnities[i].service.id == vm.currentConsultant.service.id) {
                                    vm.currentConsultant = vm.consultantsOcupation.consultantEnities[i];
                                    break;
                                }
                            }
                        }
                    }
                },
                function (error) {
                    
                });
        }

        function TransformMsmData(sessionList) {
            angular.forEach(sessionList, function (element) {
                //przeliczamy ile sekund upłyneło od założenia sessji
                element.insertionTimeDT = moment(element.insertionTime);
                element.insertionTimeDif = moment().diff(element.insertionTimeDT, 'seconds');
            });
        }

        function setFilterNumber(fieldNumber, number) {
            if (msmFilterConst.all === fieldNumber) {
                vm.filterNumbers.all = number;
            } else if (msmFilterConst.active === fieldNumber) {
                vm.filterNumbers.active = number;
            } else if (msmFilterConst.waiting === fieldNumber) {
                vm.filterNumbers.waiting = number;
            } else if (msmFilterConst.finished === fieldNumber) {
                vm.filterNumbers.finished = number;
            }

        }

        function setCurrentFilterMode(currentMode) {
            vm.currentFilterMode = currentMode;

            vm.filterObject = vm.filtersArray[currentMode];
        }


        function calcFiltersNumbers() {

            vm.filterNumbers.all = getFilterNumbers(vm.filtersArray[0]);
            vm.filterNumbers.active = getFilterNumbers(vm.filtersArray[1]);
            vm.filterNumbers.waiting = getFilterNumbers(vm.filtersArray[2]);
            vm.filterNumbers.finished = getFilterNumbers(vm.filtersArray[3]);
        }

        function getFilterNumbers(filter) {
            var result = $filter('filter')(vm.SessionList, filter).length || 0;
            return result;
        }

        function checkClosedSession() {
            $filter('filter')(vm.SessionList, function (x) {
                return x.statusId >= 100 && moment().diff(moment(x.finished), 'seconds') >= 58;
            }).map(function (item) {
                return item.toDelete = true;
            });

            $timeout(function () {

                var removedElements = _.remove(vm.SessionList, function (x) {
                    return x.statusId >= 100 && moment().diff(moment(x.finished), 'seconds') >= 60;
                });

                angular.forEach(removedElements, function (e) {
                    if (vm.currentSession && e.sessionGuid == vm.currentSession.sessionGuid) {
                        vm.currentSession = undefined;
                    }
                });

                calcFiltersNumbers();
            }, 2 * 1000);
        }


        onCreate();

    }

})();
(function () {
  'use strict';

  angular
    .module('contactcenter.dashboard').component('forwardSession', {
      templateUrl: 'app/main/contactcenter/dashboard/component/forwardsession/forwardsession.html',
      controllerAs: 'vm',
      bindings: {
        session: '='
      },
      controller: ForwardSessionController
    });


  /** @ngInject */
  function ForwardSessionController($mdDialog, OrderboxGlue, DynamicFactory, $translate, $scope, $stateParams, SessionManager, toastService, mdcDateTimeDialog, callInfoBarBridge, WebSocketManager) {
    var vm = this;
    vm.loadConsultants = loadConsultants;
    vm.consultantClick = consultantClick;
    vm.closeDialog = closeDialog;
    vm.$onInit = onInit;
    vm.openTime = openTime;
    vm.setTime = setTime;
    vm.setCustomTime = setCustomTime;
    vm.consultantsList = [];

    function onInit() {
      vm.selectedConsultant = {};
      loadConsultants();
    }
    function consultantClick(consultant) {
      DynamicFactory.get('MsmRsc', 'forwardSession')(vm.session.sessionGuid, consultant.id).then(function (data) {
        toastService.showToast($translate.instant('MONITORING.FORWARD_DIALOG.FORWARD_OK'), 'success', 4);
        $mdDialog.hide();
      }, function (err) {
        console.log(err);
        toastService.showToast(err.data.message, 'error', 4);
      });
    }
    
    function closeDialog() {
      $mdDialog.hide();
    }

    function loadConsultants() {
      vm.loadConsultants = true;
      // DynamicFactory.get('MsmRsc', 'getConsultantList')(vm.session.serviceId).then(function (data) {
      //   vm.consultantsList = data;
      //   _.remove(vm.consultantsList, function(obj){
      //     return obj.consultantID === vm.session.consultantId || obj.status !== 1;
      //   });
      //   vm.loadConsultants = false;
      // }, function (err) {
      //   console.log(err);
      // });
      DynamicFactory.get('ConsultantsRsc', 'getFwdConsultants')().then(
        function (response) {
          var tmp = response.consultantEnities;
          _.remove(tmp, function(obj){
            return obj.id === vm.session.consultantId;
          });
          
          vm.consultantsList = tmp;
          vm.loadConsultants = false;
        }, 
        function (error) {
          vm.loadConsultants = false;
        });
    }

    function openTime($mdMenu, ev) {
      $mdMenu.open(ev);
    }
    function setTime(time, consultant) {
      console.log('setTime: ', time);
      if (time) {
        var result = moment().add(time.toAdd, time.unit);
        if (time.hour) {
          result = result.hours(time.hour).minutes(0);
        }
        vm.schedulerTime = result.format('YYYY-MM-DD HH:mm:ss');
      } else {
        vm.schedulerTime = undefined;
      }
      vm.selectedConsultant = consultant;
    }
    function setCustomTime(consultant) {
      mdcDateTimeDialog.show({
        time: true,
        minDate: moment(),
        todayText: $translate.instant('COMMUNICATOR.CHAT.TODAY'),
        cancelText: $translate.instant('COMMUNICATOR.CHAT.CANCEL')
      }).then(function (date) {
        vm.schedulerTime = moment(date).format('YYYY-MM-DD HH:mm:ss');
        consultantClick(consultant);
      }, function () { });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('contactcenter.dashboard')
    .component('connectionStatistic', {
      templateUrl: 'app/main/contactcenter/dashboard/component/connectionstatistic/connectionstatistic.html',
      controllerAs: 'vm',
      bindings: {
        chartData: '<',
        mode: '<'
      },
      controller: connectionStatisticCtrl
    });

  /* @ngInject */
  function connectionStatisticCtrl(ReportTools, chartConfig, connectionStatisticCons) {
    var vm = this; // jshint ignore:line
    //function
    vm.$onInit = onInit;



    function onInit() {
      vm.mainChart = new chartConfig();
      vm.connectionStatisticCons = connectionStatisticCons;

      if (vm.mode === connectionStatisticCons.seconds) {
        vm.mainChart.options.chart.yAxis = {
          tickFormat: chartTimeFormat
        };
        vm.mainChart.options.chart.valueFormat = chartTimeFormat;

      } else if (vm.mode === connectionStatisticCons.average) {
        vm.mainChart.options.chart.type = 'discreteBarChart';
        vm.mainChart.options.chart.height = 150;
        vm.mainChart.options.chart.yAxis = {
          tickFormat: chartTimeFormat
        };
        vm.mainChart.options.chart.valueFormat = chartTimeFormat;
      } else if (vm.mode === connectionStatisticCons.count) {
        vm.mainChart.options.chart.yAxis = {
          tickFormat: countFormat
        };
        vm.mainChart.options.chart.valueFormat = countFormat;
      }
    }

    function chartTimeFormat(d) {
      var text = new Date(d * 1000).toISOString().substr(11, 8);
      if (text.substring(0, 3) === '00:') {
        text = text.substring(3, text.length);
      }
      console.log('connectionStatistic | chartTimeFormat', text, ReportTools.formatSecs(d));
      return ReportTools.formatSecs(d);
    }

    function countFormat(d) {
      return d.toString();
    }


  }
})();

/**
 * Created by kosski on 07.09.2016.
 */
+function () {
  'use strict';
  angular
    .module('contactcenter.communicator', [])
    .config(config);


  /** @ngInject */
  function config( $stateProvider) {
    // State
    $stateProvider.state('app.contactcenter_communicator', {
      url: '/communicator',
      params: {
        clientCall: null,
        forceRender:null
      },
      stateTranslationName: 'COMMUNICATOR',
      hideTaHeader:true,
      views: {
        'content@app': {
          template: '<communicator></communicator>'
        }
      },
      resolve: {},
      bodyClass: 'communicator'
    })
    .state('app.contactcenter_internalmessage', {
      url: '/internalmessage',
      params: {
        clientCall: null
      },
      stateTranslationName: 'COMMUNICATOR.INTERNAL',
      hideTaHeader:true,
      views: {
        'content@app': {
          template: '<internal-message></internal-message>'
        }
      },
      resolve: {},
      bodyClass: 'internalmessage'
    });
  }
}();

(function () {
  'use strict';

  angular
    .module('contactcenter.communicator')
    .service('connectionStatisticFuncService', Service);

  /** @ngInject */
  function Service(ReportTools) {
    var vm = {};

    vm.groupData = groupData;
    vm.findReportDataByDate = findReportDataByDate;
    vm.agregateConnectionsData = agregateConnectionsData;
    vm.convertDate = convertDate;

    function onInit() {
      vm.dateFormat = 'DD-MM-YYYY';
    }
    onInit();

    function groupData(callData,dateFrom,dateTo) {
      var dateFiveDays;
      if(!dateFrom){
        dateFiveDays = {
          From: new Date(moment().subtract(4, 'days').startOf('day')),
          To: moment().format()
        }
      }else{
        dateFiveDays ={
          From: dateFrom,
          To: dateTo
        }
      }

      // tworzenie obiektu danych dla wykresu: ilość, sekundy, średnia
      var chartData = {
        dataCount: [{
          key: 'count',
          values: []
        }],
        dataSeconds: [{
          key: 'seconds',
          values: []
        }],
        dataAvgSeconds: [{
          key: 'avgSeconds',
          values: []
        }]
      };
      var dateArray = ReportTools.dateInBetween(vm.dateFormat, dateFiveDays);


      var reportGroup = agregateConnectionsData(callData);


      //dla 5 ostatnich dat napełnienie danych wykresu
      _.forEach(dateArray, function (value, key) {
        var formatDate = value;
        var dataAll = findReportDataByDate(reportGroup, formatDate);
        var data = convertDate(formatDate);

        chartData.dataCount[0].values.push({
          x: data,
          y: dataAll.count || 0
        });

        chartData.dataSeconds[0].values.push({
          x: data,
          y: dataAll.seconds || 0
        });

        chartData.dataAvgSeconds[0].values.push({
          x: data,
          y: dataAll.avgSeconds || 0
        });

      });


      //vm.LastDayValue = vm.reportGroup[vm.reportGroup.length - 1].count;

      return chartData;
    }

    function findReportDataByDate(reportGroup, formatDate) {
      var dataAll = _.find(reportGroup, {'timePeriod': formatDate});
      if (!dataAll) {
        dataAll = {
          data: [],
          timePeriod: formatDate,
          count: 0,
          seconds: 0,
          avgSeconds: 0
        };
      }
      return dataAll;
    }

    // grupowanie, agregowanie i sorotowanie danych z API
    function agregateConnectionsData(callData) {
      return _(callData)
        .groupBy('timePeriod')
        .map(function (record, timePeriod) {
          return {
            timePeriod: timePeriod,
            count: _.sumBy(record, 'count'),
             seconds: _.sumBy(record, 'seconds'),
            avgSeconds:  _.sumBy(record, 'avgSeconds')/record.length
          };
        }).orderBy('timePeriod').value();
    }

    function convertDate(date) {
      var dateArray = date.split('-');
      var shortYear = dateArray[2].substr(2)
      var correctDate = dateArray[0] + '/' + dateArray[1] + '/' + shortYear;
      return correctDate;
    }




    return vm;
  }
})();

(function () {
  'use strict';
  angular
    .module('contactcenter.dashboard').constant('connectionStatisticCons', {
    count: 'count',
    average: 'average',
    seconds: 'seconds'
  });

})();

(function () {
  'use strict';
  angular
    .module('contactcenter.dashboard')
    .factory('chartConfig', ['$translate', chartConfigCode]);

  function chartConfigCode($translate) {
    var chartConfig = function () {
      var _this = this;


      _this.config = {
        refreshDataOnly: true,
        deepWatchData: true
      };
      _this.options = {
        chart: {
          // type: 'discreteBarChart', //multiBarChart
          type: 'discreteBarChart',
          height: 150,
          margin: {
            top: 8,
            right: 16,
            bottom: 50,
            left: 48
          },
          clipEdge: true,
          groupSpacing: 0.3,
          reduceXTicks: false,
          stacked: true,
          duration: 250,
          showLegend: true,
          isArea: true,
          interpolate: 'cardinal',
          showXAxis: true,
          showYAxis: true,
          // useInteractiveGuideline: true,

          noData: $translate.instant('REPORTS.NO_DATA'),
          x: function (d) {
            return d.x;
          },
          y: function (d) {
            return d.y;
          },
          yAxis: {
            tickFormat: function (d) {
              return d.toFixed();
            }
          },
          xAxis: {
              tickFormat: function(d) {
                moment.locale('pl');

                if(d.length===8 && d[2]==='/' && d[5]==='/')
                {
                  return moment(d,'DD/MM/YY').format('MMM Do');
                }
                else{
                  return d;
                }

              },
            rotateLabels:-20
          },
          valueFormat: function (d) {
            return d.toFixed();
          },
          legend: {
            margin: {
              top: 1,
              bottom: 32
            }
          },
          showValues: true,
          showControls: false,
          controls: {
            labels: {
              grouped: 'Grupuj',
              stacked: 'Sterta'
            },
            margin: {
              top: 1,
              bottom: 32
            }
          },
          tooltip: {
            gravity: 's',
            classes: 'gravity-s'
          }
        }
      },

        _this.colors = [
          {color: '#E57373'},
          {color: '#9CCC65'},
          {color: '#558B2F'},
          {color: '#FFAB40'},
          {color: '#FF6E40'}
        ];

      return _this;
    }

    return chartConfig;
  }
})();

/**
 * Created by kosski on 08.09.2016.
 */
+ function () {
  'use strict';

  angular
    .module('contactcenter.dashboard')
    .component('consultantsPreview', {
      templateUrl: 'app/main/contactcenter/dashboard/component/consultantsPreview/consultantsPreview.html',
      controllerAs: 'vm',
      controller: ConsultantStatistics
    })
    .constant('EVENT_TYPE', {
      PLAYBACK: 0,
      EAVESDROPPING: 1
    })
    .constant('CALL_STATUS', {
      RINGING: 'RINGING',
      WAIT4DROP: 'WAIT4DROP',
      DISCONNECTED: 'DISCONNECTED',
      FAILED: 'FAILED',
      WAITING: 'WAITING'
    });

  /* @ngInject */
  function ConsultantStatistics(msmGlue, $filter, $timeout, $scope, $stateParams, SessionManager, DynamicFactory, toastService, CALL_STATUS, $translate) {
    var vm = this;
    //resource
    vm.msmGlue = msmGlue;
    
    //wstrzykniecie do serwisu filtrów
    vm.msmGlue.consultantFilterFunc = filterService;

    vm.$onInit = onInit;
    vm.$onDestroy = onDestroy;

    vm.sortBy = sortBy;

    vm.startEavesdropping = startEavesdropping;
    vm.sendHelp = sendHelp;
    // vm.filterConsultants = filterConsultants;
    vm.toogleFilter = toogleFilter;
    vm.toggleService = toggleService;
    vm.filterService = filterService;
    vm.selectedService = -1;

    vm.currentlyPlayingBridgeId = undefined;
    vm.help = {
      active: false
    };

    vm.showOnBreak = false;
    vm.showOnBreakFilter = {
      status: 1
    }
    vm.onShowOnBreak = getConsultantsOcupation;

    vm.filtersArray = {
      0: {
        external: '!true'
      },
      1: {
        external: '!true',
        state: 1
      },
      2: {
        status: 1,
        external: '!true'
      },
      3: {
        status: 2
      },
      4: {
        external: true,
      }
    }

    vm.changeSelectedConsultant = function (consultant) {
      if (vm.currentConsultantId === consultant.consultantID) {
        // jeśli dwa razy klikamy to znika
        clearConsultantCardInfo();
        return;
      }
      vm.currentConsultantId = consultant.consultantID;
    };

    vm.changeSelectedConsultant2 = function (consultant) {

      if (vm.currentConsultant && (vm.currentConsultant.id === consultant.id && vm.currentConsultant.service.id === consultant.service.id)) {
        // jeśli dwa razy klikamy to znika
        clearConsultantCardInfo2();
        return;
      }
      vm.msmGlue.currentConsultant = consultant;
      vm.currentConsultant = consultant;
      
      //getAgregationAsync();
    };


    function clearConsultantCardInfo() {
      vm.currentConsultantId = undefined;
      vm.chartData = [];
    }

    function clearConsultantCardInfo2() {
      vm.currentConsultant = undefined;
      vm.msmGlue.currentConsultant = undefined;
      vm.chartData = [];
    }

    function toggleService(serviceId) {
      vm.selectedService = serviceId;
      vm.msmGlue.updateMonitoringData();
    }

    function filterService(consultant) {
      // debugger;
      return ((vm.selectedService === -1) || (consultant.service.id === vm.selectedService)) && (consultant.status === 1 || vm.showOnBreak);
    }

    $scope.$on('$destroy', function () {
      // $interval.cancel(theInterval);
      // $interval.cancel(timerInterval);
      $timeout.cancel(vm.ocupationTimer);
      //theInterval = undefined;
      //timerInterval = undefined;
    });

    function onInit() {
      //getConsultantsList();
      //getConsultantsOcupation();
      toogleFilter(2);
      vm.filterNumbers = {
        logged: 0,
        active: 0,
        atbreak: 0,
        all: 0,
        external: 0
      };

      vm.waitingCalls = [];

      //callInfoBarService.globalStopHelpFunc = globalStopHelp;
      // vm.currentConsultantId
      vm.getAgrForChart = DynamicFactory.get('reportsCosult', 'ReportsConnectionsAgrForChart');
      vm.chartData = [];

    }

    // function getConsultantsList() {
    //   vm.consultantData = SessionManager.getUser();

    //   var partnerId, callCenterId;
    //   if ($stateParams.callcenter) {
    //     partnerId = $stateParams.callcenter.partnerID;
    //     callCenterId = $stateParams.callcenter.id;
    //   } else {
    //     partnerId = vm.consultantData.partnerId;
    //     callCenterId = null;
    //   }

    //   DynamicFactory.get('ConsultantsRsc', 'getConsultantsStatistics')(callCenterId).then(
    //     function (response) {
    //       angular.forEach(response.consultantsStatistics, function (e) {
    //         e.eavesdropp = e.callStatus;
    //       });

    //       vm.consultantsList = response.consultantsStatistics;
    //       calcFiltersNumbers();
    //       setNeedHelp();

    //     },
    //     function (error) {

    //     });
    // }

    function getConsultantsOcupation() {
      vm.msmGlue.updateMonitoringData();
    }

    // function ConsultantSync() {
    //   var ccId;
    //   if ($stateParams.callcenter) {
    //     ccId = $stateParams.callcenter.id;
    //   }
    //   DynamicFactory.get('ConsultantsRsc', 'getConsultantsStatistics')(ccId).then(
    //     function (response) {
    //       angular.forEach(response.consultantsStatistics, function (sync) {
    //         var consultant = _.find(vm.consultantsList, function (consultant) {
    //           return consultant.consultantID === sync.consultantID;
    //         });
    //         if (consultant) {
    //           consultant = _.merge(consultant, sync);
    //         } else {
    //           vm.consultantsList.push(sync);
    //         }
    //       });

    //       calcFiltersNumbers();
    //     },
    //     function (error) {

    //     });
    // }

    function toogleFilter(type) {

      clearConsultantCardInfo()

      vm.filterButton = type;
      vm.filterObject = vm.filtersArray[type];

    }


    function calcFiltersNumbers() {
      vm.filterNumbers.all = getFilterNumbers(vm.filtersArray[0]);
      vm.filterNumbers.logged = getFilterNumbers(vm.filtersArray[1]);
      vm.filterNumbers.active = getFilterNumbers(vm.filtersArray[2]);
      vm.filterNumbers.atbreak = getFilterNumbers(vm.filtersArray[3]);
      vm.filterNumbers.external = getFilterNumbers(vm.filtersArray[4]);
      console.log('consultantsPreview | calcFiltersNumbers finished', vm.filterNumbers);
    }

    function getFilterNumbers(filter) {
      var result = $filter('filter')(vm.consultantsList, filter).length || 0;
      console.log('consultantsPreview | getFilterNumbers result=' + result + ' from filterArray=', vm.filtersArray, ' choosen=', filter);
      return result;
    }


    function onDestroy() {
      if (vm.audioPause) {
        vm.audioPause();
      }
      if (vm.helpStop) {
        vm.helpStop();
      }
    }

    //#region WebSocket methods

    function prepareWebSocket(callback) {
      return function (data) {
        if (data.Content) {
          if (angular.isString(data.Content)) {
            data.Content = JSON.parse(data.Content);
          }
          fillTokenInfo(data.Content, decodeToken(data.Token));
          if (callback) {
            callback(data);
          }
        }
      };
    }


    function onCallInUpdate(data) {
      var consultant;
      if (data.Content.consultantID < 0) {
        if (data.Content.status !== CALL_STATUS.RINGING) {
          consultant = findExternal(data);
        }
      } else {
        consultant = findConsultant(data);
      }


      if (data.Content.status != CALL_STATUS.WAITING) {
        if (isWaitingCall(data)) {
          removeWaitingCall(data);
        }
      }


      if (consultant) {

        if (data.Content.status == CALL_STATUS.WAIT4DROP) {

          consultant.callType = 'IN';
          consultant.callStatus = 1;
          consultant.userHelp = undefined;

          consultant = _.merge(consultant, callUpdateObj(data));
        } else if (data.Content.status == CALL_STATUS.DISCONNECTED) {
          consultant.callStatus = 0;
          consultant.eavesdropp = 0;
          consultant.bridgeDuration = undefined;
          consultant.callDuration = undefined;
          consultant.ccServiceName = undefined;
          consultant.serviceName = undefined;
          consultant.callType = undefined;

          if (consultant.consultantID < 0) {
            removeExternal(consultant);
            calcFiltersNumbers();
          }
          cancelHelp(data);
        }
      } else {
        if (data.Content.status == CALL_STATUS.WAITING) {
          addWaitingCall(data);
        }
        //logika kolejki
      }
    }



    function onCallOutUpdate(data) {
      var consultant;
      if (data.Content.consultantID < 0) {
        if (data.Content.status !== CALL_STATUS.RINGING) {
          consultant = findExternal(data);
        }
      } else {
        consultant = findConsultant(data);
      }

      if (consultant) {
        if (data.Content.status == CALL_STATUS.WAIT4DROP) {
          consultant.callType = 'OUT';
          consultant.callStatus = 1;
          consultant.userHelp = undefined;
          consultant = _.merge(consultant, callUpdateObj(data));

        } else if (data.Content.status == CALL_STATUS.DISCONNECTED) {
          consultant.eavesdropp = 0;
          consultant.callStatus = 0;
          consultant.bridgeDuration = undefined;
          consultant.callDuration = undefined;
          consultant.ccServiceName = undefined;
          consultant.serviceName = undefined;
          consultant.callType = undefined;

          if (consultant.consultantID < 0) {
            removeExternal(consultant);
            calcFiltersNumbers();
          }
          cancelHelp(data);
        }
      }
    }

    function callUpdateObj(socket) {
      var bundleID = prepareBundle(socket);
      var result = {
        bridgeID: socket.Content.BridgeID ? socket.Content.BridgeID : socket.Content.bridgeUUID,
        callID: socket.Content.callId,
        serviceID: socket.Content.ccserviceId,
        serviceName: socket.Content.ServiceName,
        contactId: socket.Content.contactId,
        bundleID: bundleID,
        msisdn: socket.Content.ani
      }
      if (socket.Content.startCall) {
        result.callDuration = moment.duration(moment().diff(moment(socket.Content.startCall))).asSeconds();
        result.bridgeDuration = moment.duration(moment().diff(moment(socket.Content.start))).asSeconds();
      }
      return result;
    }

    function addWaitingCall(socket) {
      var isInArray = isWaitingCall(socket);
      if (!isInArray) {
        console.log('consultantsPreview | adding waiting Call', socket.Content);
        vm.waitingCalls.push(socket.Content);
      }
    }

    function removeWaitingCall(socket) {
      var removed = _.remove(vm.waitingCalls, function (savedSocket) {
        return savedSocket.callId == socket.Content.callId;
      });
      console.log('consultantsPreview | removed waiting Calls', removed);
    }

    function isWaitingCall(socket) {
      var result = _.find(vm.waitingCalls, {
        callId: socket.Content.callId
      });

      console.log('consultantsPreview | CALL= ' + socket.Content.callId + ' status=' + socket.Content.status + ' is ' + (result !== undefined ? '' : 'not') + 'waiting call');

      return result !== undefined;
    }




















    function prepareBundle(socket) {
      var bundleID;
      if (socket.Content.ccserviceBundle) {
        socket.Content.ccserviceBundle = JSON.parse(socket.Content.ccserviceBundle);
        bundleID = socket.Content.ccserviceBundle.BundleID;
        if (bundleID === null) {
          bundleID = undefined;
        }
      }
      return bundleID;
    }

    function findExternal(data) {
      var consultant = _.find(vm.consultantsList, {
        callID: data.Content.callId
      })
      if (!consultant && data.Content.status !== CALL_STATUS.FAILED) {
        vm.consultantsList.push(pushExternal(data));
        calcFiltersNumbers();
      }
      return _.find(vm.consultantsList, {
        callID: data.Content.callId
      });
    }

    function removeExternal(consultant) {
      _.remove(vm.consultantsList, function (n) {
        return n.external && n.bridgeID === consultant.bridgeID;
      });
    }

    function pushExternal(data) {
      fillTokenInfo(data.Content, decodeToken(data.Token));
      return {
        external: true,
        alias: data.Content.extCCName + '/' + data.Content.extGroupName,
        callCenterID: data.Content.callCenterId,
        consultantID: data.Content.consultantID,
        userID: data.Content.consultantID,
        lastUpdateStatusDate: data.Content.start,
        state: 1,
        status: 1,
        bridgeID: data.Content.BridgeID,
        callID: data.Content.callId,
        phone1: data.Content.dni
      }
    }

    function onStatusUpdate(data) {
      var consultant = findConsultant(data);

      if (consultant) {
        consultant.status = data.Content.status;
        if (consultant.status == 2) {
          if (!consultant.totalBreakTime) {
            consultant.totalBreakTime = 0;
          }
        }
        //przeliczenie wszystkich liczb w filtrach
        calcFiltersNumbers();
      }
    }

    function onPhoneUpdate(data) {
      var consultant = findConsultant(data);

      if (consultant) {
        consultant.phone1 = data.Content.phone;
        consultant.phoneTypeId = data.Content.phoneType;
        //przeliczenie wszystkich liczb w filtrach
        calcFiltersNumbers();
      }
    }

    function onSTATEUpdate(data) {
      var consultant = findConsultant(data);

      if (consultant) {
        consultant.state = data.Content.state;
        if (consultant.state == 0) {
          // zabawa z czasami TODO!!!!
          consultant.fromLogin = undefined;
        } else {
          // zabawa z czasami TODO!!!!
          consultant.fromLogin = moment().diff(moment(data.Content.lastLogin));
        }
        //przeliczenie wszystkich liczb w filtrach
        calcFiltersNumbers();
      }
    }

    function onSendHelp(data) {
      var consultant = findConsultant(data);
      if (consultant) {
        consultant.callID = data.Content.CallID;
        if (data.Content.endHelp) {
          consultant.userHelp = undefined;
          consultant.needHelp = false;
        }
        else {
          if (data.Content.userHelp) {
            if (consultant.callID == data.Content.CallID) {
              consultant.userHelp = data.Content.userHelp;
              consultant.needHelp = false;
            }
          } else {
            if (consultant.callID == data.Content.CallID) {
              consultant.needHelp = true;
              if (data.Content.consultantName && data.Content.consultantName.length > 0) {
                toastService.showToastAction(data.Content.consultantName + ' ' + $translate.instant('STATISTICS.NEED_HELP'), 'message', 10, $translate.instant('STATISTICS.START_HELP')).then(function (response) {
                  if (response === 'ok') {
                    sendHelp(consultant, function () {
                      consultant.userHelp = undefined;
                      vm.help.active = false;
                    }, vm.help);
                  }
                });
              }
            } else {
              consultant.needHelp = false;
            }
          }
        }
      }
    }




    //#endregion

    function sendHelp(consultant, stopFunc, help) { //callId
      callInfoBarBridge.helpRequest(consultant, stopFunc, help);
    }

    function cancelHelp(data) {
      var consultant = findConsultant(data);
      if (consultant) {
        consultant.needHelp = false;
        consultant.userHelp = undefined;
      }
      if (vm.helpStop) {
        vm.helpStop();
      }
    }

    function globalStopHelp(call) {
      console.log('globalStopHelp call: ', call);
      if (call.params.number) {
        var consultant = findConsultantByCall(call.params.number.replace('ev/', ''));
        if (consultant) {
          consultant.needHelp = false;
          consultant.userHelp = undefined;
        }
      }
    }
    function setNeedHelp() {
      if ($stateParams.needHelp) {
        var consultant = findConsultantByCall($stateParams.needHelp.CallID);
        if (consultant) {
          consultant.needHelp = true;
        }
      }
    }
    //#region consultants list methods



    // function sliceMsisdn(phone1) {
    //   if (phone1) {
    //     var phoneSlice = phone1.split('/'),
    //       number = phoneSlice[phoneSlice.length - 1];
    //   }
    //   return number ? number : '---';
    // }

    // function getRndInteger(min, max) {
    //   return Math.floor(Math.random() * (max - min)) + min;
    // }

    function sortBy(propertyName) {
      vm.reverse = (vm.propertyName = propertyName) ? !vm.reverse : false;
      vm.propertyName = propertyName;
    }

    function fillTokenInfo(status, tokenInfo) {
      status.callCenterId = tokenInfo.callCenterId;
      if (tokenInfo.consultantId)
        status.consultantID = Number(tokenInfo.consultantId);
    }

    function decodeToken(token) {
      var tokenArray = token.match(/\d{1,9}|-\d{1,9}/gim);
      return {
        callCenterId: tokenArray.length > 1 ? tokenArray[1] : undefined,
        consultantId: tokenArray.length > 2 && tokenArray[2] != -1 ? tokenArray[2] : undefined
      }
    }

    function findConsultant(data) {
      return _.find(vm.consultantsList, function (consultant) {
        return consultant.consultantID == data.Content.consultantID;
      });
    }

    function findConsultantByCall(callId) {
      return _.find(vm.consultantsList, function (consultant) {
        return consultant.callID == callId;
      });
    }

    //#endregion


    function startEavesdropping(audioPause) {
      if (vm.helpStop)
        vm.helpStop();

      if (vm.audioPause) {
        vm.audioPause();
      }
      vm.audioPause = audioPause;
    }
  }
}();

/**
 * Created by kosski on 01.09.2018.
 */
(function () {
  'use strict';

  angular.module('taTags', [])
    .component('taTags', {
      templateUrl: 'app/main/contactcenter/components/tamultiselect/tatags/tatags.html',
      controllerAs: 'vm',
      bindings: {
        writeMode: '=',
        selectCallback: '=',
        ngDisabled: '=',
        label: '@',
        customClass: '@',
        tagOverflow: '=',
        contentId: '=',
        sourceAsModel: '=',
        showButton: '=',
        // choosenTags: '=',
        // tagsSource: '=',
        // chooseCallback: '=',
        // removeCallback: '='
        // conf: '=',
        sourceEndpoint: '<',
        ngModel: '=',
        forceReload: '<',
        functionAutosave: '<'
      },
      controller: taTags
    });

  /** @ngInject */
  function taTags($scope, toastService, DynamicFactory, $q, $timeout) {
    var vm = this;

    vm.selectDamn = selectDamn;
    vm.addTag = addTag;
    vm.tagSearch = tagSearch;
    vm.updateModel = updateModel;
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;
    vm.tagsClick = tagsClick;
    vm.changeTags = changeTags;

    vm.$postLink = postLink;

    vm.specialList = null;
    vm.specialSource = null;


    function onInit() {
      vm.searchText = '';

      if (vm.conf) {
        vm.token = vm.conf.token;
      } else if (vm.label) {
        vm.token = vm.label;
      }
      vm.id = $scope.$id;
      $scope.$on('tags-update', getSource);
    }

    function postLink() {
      // if (vm.tagOverflow)
      //   setTimeout(setOverflow, 500);
    }

    function onChanges(changesObj) {
      if (!vm.ngModel)
        vm.ngModel = '';
      getSource();
    }
    function codeSourceAsModel() {
      vm.output = vm.source;
      updateModel();
    }

    function getSource() {
      DynamicFactory.saveGet('tagsRsc', vm.sourceEndpoint || 'getTags')(vm.contentId).then(function (result) {
        vm.source = result;
        if (!vm.ngModel && vm.writeMode && vm.sourceAsModel) {
          codeSourceAsModel();
        } else {
          decodeModel();
        }
        getSource2();
      });
    }
    function getSource2() {
      DynamicFactory.saveGet('tagsRsc', 'getServiceTags')(vm.contentId).then(function (result) {
        vm.source2 = result;
        if (!vm.ngModel && vm.writeMode && vm.sourceAsModel) {
          codeSourceAsModel();
        } else {
          decodeModel();
        }
      });
    }



    function setOverflow() {
      var containerWidth = angular.element(document.getElementById('tags-container-' + $scope.$id))[0].clientWidth;
      var chipsWidth = vm.output.map(function (chip) {
        var divElement = angular.element(document.getElementById('tag-' + chip.tagId + '-' + $scope.$id))[0]
        if (divElement.offsetWidth) {
          return divElement.offsetWidth + 14;
        } else {
          console.log('taTags | brak szerokosci elementu');
        }
      });
      var breakIndex = findBreakIndex(chipsWidth, containerWidth);
      if (breakIndex) {
        vm.output = _.take(vm.output, breakIndex);
        vm.output.push({
          special: '...',
        });
      }
    }

    function findBreakIndex(chipsWidth, containerWidth) {
      for (var i = 0; i < chipsWidth.length; i++) {
        var element = chipsWidth[i];
        if (containerWidth - element - 30 >= 0) {
          containerWidth -= element;
        } else return i;
      }
    }

    function addSelection(newTag) {
      if (noDuplicated(newTag))
        if (angular.isObject(newTag)) {
          return newTag;
        }
    }

    function updateModel() {

      vm.ngModel = codeList(vm.output).join(',');

      if(vm.ngModel.includes('new')){
        // poczekaj na zapis nowego tagu
        return;
      }

      if (vm.tagOverflow)
        setOverflow();
      if (vm.functionAutosave) {
        vm.functionAutosave(vm.ngModel);
      }
    }

    function writeTag(tag) {
      var defer = $q.defer();
      if (tag) {
        if (tag.tagId !== 'new') {
          defer.resolve(tag);
        } else {
          DynamicFactory.get('tagsRsc', 'addNewTag')(tag, tag.parentId)
            .then(function (response) {
              tag.tagId = response.tagID;
              $scope.$root.$broadcast('tags-update');
              defer.resolve(tag);
            }, error);
        }
      }
      return defer.promise;
    }

    function addTag(newTag) {
      if (vm.writeMode && !newTag.tagId) {
        var countParent = (newTag.match(/\#/g) || []).length;
        var parent;

        if (countParent > 0) {
          newTag = newTag.replace(/\#/gi, '');
          parent = getParentId(vm.source.length - countParent);
        }

        var preparedTag = {
          tagId: 'new',
          token: newTag,
          value: newTag,
          parentId: parent
        };
        writeTag(preparedTag).then(function (data) {
          vm.updateModel();
          return data;
        });
        return preparedTag;
      } else {
        return newTag;
      }
    }

    function updateTagId(newId) {
      var newTag = _.find(vm.output, { tagId: 'new' });
      if (newTag) {
        newTag.tagId = newId;
      }
    }

    function getParentId(index) {
      return vm.source[index].tagId;
    }

    function codeElement(elem) {
      return elem.tagId + '';
    }

    function codeList(list) {
      return list.map(codeElement);
    }

    function decodeModel() {
      vm.output = [];
      var output = vm.ngModel.split(',');
      var codedSource = codeList(vm.source);
      output.forEach(function (elem) {
        if (elem !== '') {
          var indexMatch = codedSource.indexOf(elem);
          if (indexMatch !== -1) {
            vm.output.push(vm.source[indexMatch]);
          }
        }
      });
      if (vm.tagOverflow)
        setTimeout(setOverflow, 1000);
    }

    function makeSource(sourceArray) {
      return sourceArray.map(function (item) {
        return {
          tagId: item,
          value: item,
          token: item
        }
      });
    }

    function noDuplicated(newTag) {
      if (vm.output)
        vm.output.forEach(function (tag) {
          if (newTag === tag) {
            return false;
          }
        });
      return true;
    }

    function tagSearch(query) {
      if (!vm.source) return [];
      if (query === '') {
        return vm.source;
      }
      var results = [];
      vm.source.forEach(function (tag) {
        var row = stringifyRow(tag).toLowerCase();
        if (row.indexOf(query.toLowerCase()) !== -1) {
          results.push(tag);
        }
      });
      return results;
    }

    function stringifyRow(obj) {
      var result = '';
      for (var key in obj) {
        if (obj[key])
          result += obj[key];
      }
      return result;
    }

    function selectDamn(chip) {
      if (vm.selectCallback) {
        chip.selected = !chip.selected;
        vm.selectCallback(chip);
      }
    }

    function error(err) {
      toastService.showToast('Coś poszło nie tak...', 'error', 4);
    }

    function tagsClick(event) {
      $timeout(function () {
        var obj = angular.element('#mdSelect-' + vm.id);
        angular.element('#mdSelect-' + vm.id).triggerHandler('click');
      });
      event.preventDefault();
    }

    function onDestroy() {
      console.log('destroy');
    }

    function changeTags() {
      //console.log('changeTags: ',vm.specialList);
      // for(var x in vm.specialList){
      //   //addTag({tagId: vm.specialList[x]});
      //   vm.output += vm.specialList[x]+',';
      // }
      //vm.output = angular.copy(vm.specialList);// vm.output.slice(0, -1);
      updateModel();
    }
  }

})();

/**
 * Created by kosski on 07.09.2016.
 */
+ function () {
  'use strict';
  angular
    .module('taTags')
    .service('tagsService', tagsService);

  /** @ngInject */
  function tagsService(DynamicFactory, $q, md5) {
    var _this = {
      saveGet: saveGet,
      arrayOfResponse: []
    };

    function saveGet(resource, method) {
      return function (params) {
        var defer = $q.defer();

        var path = generatePath(resource, method, params);
        var currentPromise = getPromiseValue(path);

        if(!currentPromise){
          replacePromiseValue(path, {
            factory : DynamicFactory.get(resource, method),
            params : params,
            //pending
            //data
            //promise
          });
          currentPromise = getPromiseValue(path);
          console.log('tagsService | create new pending '+path);
        }

        getTags(path,!currentPromise.pending).then(defer.resolve,defer.reject);


        return defer.promise;
      }
    }


    function getTags(path, refresh) {
      var defer = $q.defer();

      var currentPromise = getPromiseValue(path);

      if (currentPromise.data && !refresh) {
        console.log('tagsService | resolve existing '+path);



        defer.resolve(currentPromise.data);



      } else {
        if (currentPromise.promise && !refresh) {
          console.log('tagsService | add pending '+path);

          replacePromiseValue(path+'.pending', currentPromise.pending + 1);


          $q.all([getPromiseValue(path+'.promise')]).then(function (result) {
            replacePromiseValue(path+'.pending', getPromiseValue(path+'.pending')-1);
            console.log('tagsService | resolve pending '+path,'current queue = '+getPromiseValue(path+'.pending'));

            defer.resolve(currentPromise.data);
          });



        } else {

          replacePromiseValue(path+'.promise', currentPromise.factory(currentPromise.params));
          replacePromiseValue(path+'.pending', 1);
          console.log('tagsService | new pending '+path,'current queue = '+1);

          // _this.lastPromise = DynamicFactory.get('ContactCenterRsc', 'getCallCenters')();

          $q.all([getPromiseValue(path+'.promise')]).then(function (data) {
            // _this.callcenters = data[0];
          replacePromiseValue(path+'.data', data[0]);
          replacePromiseValue(path+'.pending', getPromiseValue(path+'.pending')-1);
          console.log('tagsService | resolve pending '+path,'current queue = '+getPromiseValue(path+'.pending'));

            defer.resolve(getPromiseValue(path+'.data'));
          });



        }
      }
      return defer.promise;
    }


    function generatePath(resource, method, params){
      return resource + '.' + method + '.' + md5.createHash(JSON.stringify(params));
    }

    // function promiseExist(path){
    //   return getPromiseValue(path) === undefined;
    // }

    // function prepareLastPromise(path) {
    //   var promise = getPromiseValue(path);
    //   if(promise){

    //   }
    // }

    function getPromiseValue(path) {
      var schema = _this.arrayOfResponse; // a moving reference to internal objects within obj
      var pList = path.replace(/\[(\w+)\]/g, '.$1').split('.');
      var len = pList.length;
      for (var i = 0; i < len - 1; i++) {
        var elem = pList[i];
        if (!schema[elem]) schema[elem] = {};
        schema = schema[elem];
      }
      return schema[pList[len - 1]];
    }

    function replacePromiseValue(path, value) {
      var schema = _this.arrayOfResponse; // a moving reference to internal objects within obj
      var pList = path.replace(/\[(\w+)\]/g, '.$1').split('.');
      var len = pList.length;
      for (var i = 0; i < len - 1; i++) {
        var elem = pList[i];
        if (!schema[elem]) schema[elem] = {};
        schema = schema[elem];
      }

      schema[pList[len - 1]] = value;
    }





    // function cancelLastLoading(newPromise) {
    //   if (vm.lastPromise) {
    //     vm.lastPromise.reject();
    //   }
    //   vm.lastPromise = newPromise;
    //   return newPromise;
    // }
    return _this;
  }
}();

(function () {
  'use strict';

  angular
    .module('taTags')
    .filter('tagsFilter', tagsFilter);

  /* @ngInject */
  function tagsFilter($filter) {
    return function (objArray, tagSearch, tagSource) {
      if(!tagSearch || tagSearch.length < 2 || (tagSearch.match(/\#/g) || []).length === 0){
        if(tagSearch == '#'){
          return objArray;
        }
        return $filter('filter')(objArray,tagSearch);
      }
      tagSearch = tagSearch.replace(/\#/gi,'');
      var matchedTokens = _.map(_.filter(tagSource, function (tag) {
        return tag.token.toLowerCase().indexOf(tagSearch.toLowerCase()) !== -1;
      }), _.property('tagId'));
      var result = _.filter(objArray, function (obj) {
        var tokenIds = obj.tags ? obj.tags.split(',').map(function(id){
          return parseInt(id);
        }) : [];
        return _.intersection(tokenIds,matchedTokens).length > 0;
      });
      return result;
    }
  }
})();

/**
 * Created by kosski on 08.09.2016.
 */
(function () {
  'use strict';

  angular.module('taFilters', [])
    .component('taFilters', {
      templateUrl: 'app/main/contactcenter/components/tamultiselect/tafilters/tafilters.html',
      controllerAs: 'vm',
      bindings: {
        // chooseCallback: '=',
        // choosenTags: '=',
        // conf: '=',
        // ngDisabled: '=',
        // selectCallback: '=',
        // source: '<',
        // tagOverflow: '=',
        // tagsSource: '=',
        // writeMode: '=',
        customClass: '@',
        label: '@',
        ngModel: '<',
        removeCallback: '='
      },
      controller: taMultiSelect
    });

  /** @ngInject */
  function taMultiSelect($scope, toastService) {
    var vm = this;

    // vm.selectDamn = selectDamn;
    // vm.addTag = addTag;
    // vm.tagSearch = tagSearch;
    // vm.updateModel = updateModel;
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.onRemove = onRemove;
    // vm.$postLink = postLink;


    function onInit() {
      // vm.searchText = '';
      // if(vm.ngDisabled)
      //   decodeModel();
      // vm.output = [];
      // if (vm.conf) {
      //   vm.token = vm.conf.token;
      // } else if (vm.label) {
      //   vm.token = vm.label;
      // }
      // vm.id = $scope.$id;
    }

    // function postLink() {
    //   if (vm.tagOverflow)
    //     setTimeout(setOverflow, 500);
    // }

    function onChanges(changesObj) {
      if (!vm.ngModel)
        vm.ngModel = '';
      // if (changesObj.source && changesObj.source.currentValue) {
      //   // var source = changesObj.source.currentValue;
      //   vm.tags = vm.source;
      // } else {
      //   // vm.tags =[];
      //   if (!vm.source) {
      //     vm.source = makeSource(vm.ngModel.split(','));
      //     vm.tags = vm.source;
      //   }
      //   // vm.tags = vm.ngModel.split(',').map(function(item){
      //   //   return { tagId: item };
      //   // });
      // }
      // decodeModel();
    }

    function onRemove(){
      if(vm.removeCallback){
        vm.removeCallback();
      }
      console.log('taFilters | onRemove');
    }
    // function setOverflow() {
    //   var containerWidth = angular.element(document.getElementById('tags-container-' + $scope.$id))[0].clientWidth;
    //   // console.log('taMultiselect | containerWidth: ', containerWidth);

    //   var chipsWidth = vm.output.map(function (chip) {
    //     var divElement = angular.element(document.getElementById('tag-' + chip.tagId + '-' + $scope.$id))[0]
    //     // console.log('taMultiselect | chip: ','tag-'+chip.tagId+'-'+$scope.$id,divElement)
    //     if (divElement.offsetWidth) {
    //       return divElement.offsetWidth + 14;
    //     } else {
    //       console.log('taMultiselect | brak szerokosci elementu');
    //     }
    //   });
    //   // console.log('taMultiselect | chipsWidth: ', chipsWidth);
    //   var breakIndex = findBreakIndex(chipsWidth, containerWidth);
    //   if(breakIndex){
    //     vm.output = _.take(vm.output,breakIndex);
    //     vm.output.push({
    //       special: '...',
    //     });
    //   }
    // }

    // function findBreakIndex(chipsWidth, containerWidth) {
    //   for (var i = 0; i < chipsWidth.length; i++) {
    //     var element = chipsWidth[i];
    //     if (containerWidth - element - 30 >= 0) {
    //       containerWidth -= element;
    //     } else return i;
    //   }
    // }

    // function addSelection(newTag) {
    //   if (noDuplicated(newTag))
    //     if (angular.isObject(newTag)) {
    //       return newTag;
    //     }
    // }

    // function updateModel() {
    //   vm.ngModel = codeList(vm.output).join(',');
    //   if (vm.tagOverflow)
    //     setOverflow();
    // }

    // function addTag(newTag) {
    //   // if (noDuplicated(newTag))
    //   //     if (angular.isObject(newTag)) {
    //   //         if (angular.isDefined(vm.chooseCallback))
    //   //             vm.chooseCallback(newTag);
    //   //         return newTag;
    //   //     }
    //   //     else {
    //   if (vm.writeMode && !newTag.tagId) {
    //     var preparedTag = {
    //       tagId: 'new',
    //       token: newTag,
    //       value: newTag
    //     };
    //     if (angular.isDefined(vm.writeMode)) {
    //       if (angular.isFunction(vm.writeMode)) {
    //         vm.writeMode(preparedTag).then(function (data) {
    //           //console.log('data: ',data);
    //           vm.updateModel();
    //         });
    //       } else {
    //         vm.updateModel();
    //       }
    //     }
    //     return preparedTag;
    //   } else return newTag;
    //   //return newTag;
    //   // }
    // }

    // function codeElement(elem) {
    //   return elem.token + '';
    // }

    // function codeList(list) {
    //   return list.map(codeElement);
    // }

    // function decodeModel() {
    //   vm.output = [];
    //   var output = vm.ngModel.split(',');
    //   var codedSource = codeList(vm.source);
    //   output.forEach(function (elem) {
    //     if (elem !== '') {
    //       var indexMatch = codedSource.indexOf(elem);
    //       if (indexMatch !== -1) {
    //         vm.output.push(vm.source[indexMatch]);
    //       }
    //     }
    //   });
    // }

    // function makeSource(sourceArray) {
    //   return sourceArray.map(function (item) {
    //     return {
    //       tagId: item,
    //       value: item,
    //       token: item
    //     }
    //   });
    // }

    // function noDuplicated(newTag) {
    //   if (vm.output)
    //     vm.output.forEach(function (tag) {
    //       if (newTag === tag) {
    //         return false;
    //       }
    //     });
    //   return true;
    // }

    // function tagSearch(query) {
    //   if (!vm.source) return [];
    //   if (query === '') {
    //     return vm.source;
    //   }
    //   var results = [];
    //   vm.source.forEach(function (tag) {
    //     var row = stringifyRow(tag).toLowerCase();
    //     if (row.indexOf(query.toLowerCase()) !== -1) {
    //       results.push(tag);
    //     }
    //   });
    //   return results;
    // }

    // function stringifyRow(obj) {
    //   var result = '';
    //   for (var key in obj) {
    //     if (obj[key])
    //       result += obj[key];
    //   }
    //   return result;
    // }

    // function selectDamn(chip) {
    //   if (vm.selectCallback) {
    //     chip.selected = !chip.selected;
    //     vm.selectCallback(chip);
    //   }
    // }

    function error(err) {
      toastService.showToast('Coś poszło nie tak...', 'error', 4);
    }
  }

})();

/**
 * Created by akraszewski on 2016-09-30.
 */

(function () {
  'use strict';
  /** @ngInject */
  function controller() {
    var vm = this;


  }

  angular.module('contactcenter.communicator').component('templateTwo', {
    templateUrl: 'app/main/contactcenter/communicator/templates/templatetwo/templatetwo.html',
    controllerAs: 'vm',
    bindings: {
      templateData: '='
    },
    controller: [controller]
  });
}());

/**
 * Created by akraszewski on 2016-09-29.
 */

(function () {
  'use strict';
  /** @ngInject */
  function controller() {
    var vm = this;


  }

  angular.module('contactcenter.communicator').component('templateThree', {
    templateUrl: 'app/main/contactcenter/communicator/templates/templatethree/templatethree.html',
    controllerAs: 'vm',
    bindings: {
      templateData: '='
    },
    controller: [ controller]
  });
}());

/**
 * Created by akraszewski on 2016-09-29.
 */

(function () {
  'use strict';
  /** @ngInject */
  function controller() {
    var vm = this;

  }

  angular.module('contactcenter.communicator').component('templateOne', {
    templateUrl: 'app/main/contactcenter/communicator/templates/templateone/templateone.html',
    controllerAs: 'vm',
    bindings: {
      templateData: '='
    },
    controller: [controller]
  });
}());

(function () {
  'use strict';

  angular
    .module('contactcenter.communicator')
    .component('sessionTile', {
      templateUrl: 'app/main/contactcenter/communicator/sessionlist/sessiontile/sessiontile.html',
      controllerAs: 'vm',
      bindings: {
        session: "=",
        listType: "="
      },
      controller: Ctrl
    });

  /** @ngInject */
  function Ctrl($mdDialog,$timeout, DynamicFactory,templateData,SessionTagsService, communicatorService, $state, SessionManager, WebSocketManager, $scope, OrderboxGlue, MenuManager) {
    var vm = this;

    vm.openTagContainer = openTagContainer;
    vm.autoSaveTags = autoSaveTags;
    vm.informationDialog = informationDialog;
    vm.composeDialog = composeDialog;
    vm.myStyle = { 'stroke-dashoffset': '380' };
    // vm.session.finishedAccentStart = false; // żeby animacje nie odpalały się przy przeładowaniu strony

    init();

    function init() {
    }


    function saveMsgTags(tags) {

      DynamicFactory.get('messageSessionRsc', 'addMessageSessionTags')(vm.session.sessionID, tags).then(
        function (data) {
          //toastService.showToast('Dodano tagi do sesji', 'success', 3);

          //jeżeli dodaliśmy tag do aktualnie otwartej sessji to odśwież kontrolkę
          if(templateData.sessionId===vm.session.sessionID){
            SessionTagsService.refresChatPartTagsControl(tags);
          }

        },
        function (err) {
          console.log(err);
        }
      );
    }

 

    function autoSaveTags(model) {
      console.log('autoSaveTags: ' + model);
      saveMsgTags(model);
    };


    function openTagContainer(event, s) {
      event.stopPropagation();
      vm.session.finishedAccentStart = true;
      if (s.finishedAccent > 0) {
        s.finishedAccent = 0;
        // _.remove(communicatorService.sessionsClosed, function (n) {
        //   return n.sessionID == vm.session.sessionID;
        // });
      } else {
        s.finishedAccent = 1;
      }
    };


    function informationDialog(event, s) {
      event.stopPropagation();

      $mdDialog.show({
        clickOutsideToClose: true,
        controller: 'sessionInfo',
        controllerAs: 'vm',
        focusOnOpen: false,
        targetEvent: event,
        templateUrl: 'app/main/contactcenter/communicator/sessionlist/sessioninfo/sessioninfo.html',
        multiple: false,
        locals: {
          session: s
        }
      });
    }

    function composeDialog(ev, emailService, contactId) {
      ev.stopPropagation();
      DynamicFactory.get('ServicePartRsc', 'GetServiceDesc')(emailService, null).then(function (emailData) {
        // console.log('emailData: ', emailData);
        DynamicFactory.get('OrderBoxRsc', 'mailServiceGet')(emailData.configID).then(function (mailServiceData) {
          console.log('mailServiceData: ', mailServiceData);
          OrderboxGlue.currentMailBox = mailServiceData;
          DynamicFactory.get('ContactPartRsc', 'getContact')(contactId).then(function (contact) {
            console.log('contact: ', contact);
            $mdDialog.show({
              locals: {
                selectedMail: undefined,
                toEmail: contact.email
              },
              template: '<md-dialog-content><compose-dialog selected-mail="vm.selectedMail" to-email="vm.toEmail"></compose-dialog></md-dialog-content>',
              controller: function (selectedMail, toEmail) {
                // var vm = this;
                this.selectedMail = selectedMail;
                this.toEmail = toEmail;
              },
              controllerAs: 'vm',
              targetEvent: ev,
              clickOutsideToClose: true
            });
          });

        });

      });
    }


    $scope.$on('timer-tick', function (event, args) {
      //console.log(args);
      if (args.millis > 0) {  ///wywalamy puste przebiegi
        vm.counter = args.seconds;
        var l = vm.counter * (vm.max / vm.limit);
        if (l + 1 > vm.max) {
          l = vm.max - 1;
        }
        vm.myStyle = { "stroke-dashoffset": vm.max - l };
      }
    });


  }
})();

(function () {
	'use strict';

	angular
		.module('contactcenter.communicator').controller('sessionInfo', controller);

	/** @ngInject */
	function controller(DynamicFactory, session, $mdDialog, toastService) {
		var vm = this;

		vm.$onInit = onInit;
		vm.closeDialog = closeDialog;
		vm.sendMessage = sendMessage;
		vm.showWarrning = false;
		vm.showTextarea = showTextarea;
		vm.messageWarring = '';
		vm.sessionInfo = {};

		function onInit() {
			getSessionInfo();
		}

		function getSessionInfo() {
			var sessionId = session.sessionID ? session.sessionID : session.sessionId;
			DynamicFactory.get('reportsCosult', 'reportsSessionDetails')(sessionId).then(function (data) {
				vm.sessionInfo = data;
			});
		}

		function closeDialog() {
			$mdDialog.cancel();
		}

		function showTextarea() {
			vm.showWarrning = !vm.showWarrning;
		}
		
		function biuldMessageBody() {
			var body = 'Id: ' + vm.sessionInfo.id + '\nSession Id: ' + vm.sessionInfo.sessionID + '\nStart: ' + vm.sessionInfo.insertionTime + '\nStop: ' + vm.sessionInfo.finished + '\nStatus Id: ' + vm.sessionInfo.statusId + '\nStatus Description: ' + vm.sessionInfo.statusDesc +'\n\n';
			body += 'Consultant Id: ' + vm.sessionInfo.consultantID + '\nLogin: ' + vm.sessionInfo.login + '\nFirst Name: ' + vm.sessionInfo.firstName + '\nLast name: ' + vm.sessionInfo.lastName + '\nAlias: ' + vm.sessionInfo.alias + '\n\n';
			body += 'Contact Id: ' + vm.sessionInfo.contactId + '\nContact Name: ' + vm.sessionInfo.userName + '\nFirst Name: ' + vm.sessionInfo.userEmail + '\n\nMessage: '+ vm.messageWarring;

			return body;
		}

		function sendMessage() {

			var msg = {
				Destination: 'M' + vm.sessionInfo.callCenterID,
				Source: null,
				Body: biuldMessageBody(),
				ReplyTo: null,
				AuthorName: null,
				AuthorPhotoUrl: null
			};
			DynamicFactory.get('InternalMessageRsc', 'Send')(msg).then(function (data) {
				vm.showWarrning = false;
				vm.messageWarring = '';
				toastService.showToastAction('Migawka sesji wysłana do grupy managerskiej');
				$timeout(function () {
					vm.dataLoaded.scroll = true;
				}, 0);
				vm.sendingMessageInProgress = false;
			}, function (err) {
				vm.sendingMessageInProgress = false;
			});
		}
		
		
		
	}
})();

(function () {
  'use strict';

  angular
    .module('contactcenter.communicator')
    .component('activeSession', {
      templateUrl: 'app/main/contactcenter/communicator/menucomponents/activesession/activesession.html',
      controllerAs: 'vm',
      bindings: {
        list: '='
      },
      controller: Ctrl
    });

  /** @ngInject */
  function Ctrl($mdDialog, DynamicFactory, templateData, communicatorService, internalMessageService, SessionManager, $interval) {
    var vm = this;
    vm.showHist=true;

    vm.$onInit = init();

    function init() {
      console.log('ActiveSession init');
      
      vm.communicatorService=communicatorService;
      if(SessionManager.isConsultant()){
        communicatorService.getChatActiveAndHisSession(true);
        $interval( function(){ 
          console.log('prevHist: ',communicatorService.historySession);
          communicatorService.sessionsClosed = angular.copy(communicatorService.historySession);
          communicatorService.getChatActiveAndHisSession(false);
         }, 10*1000);
      }
      
      vm.internalMessageService = internalMessageService;
      if ((SessionManager.getUserRole() === 'consultant' || SessionManager.getUserRole() === 'manager') && !internalMessageService.objectList){
        internalMessageService.getList();
      }


      // REJESTRACJA WEBSOCKET PRZENIESIONA DO communication service

    }

 

  }
})();

/**
 */
+function () {
  'use strict';

  angular.module('contactcenter.communicator').component('internalInfo', {
    templateUrl: 'app/main/contactcenter/communicator/internalmessage/internalinfo/internalinfo.html',
    controllerAs: 'vm',
    controller: controller
  });

  /** @ngInject */
  function controller(communicatorConfig, templateData, internalMessageService, DynamicFactory) {
    var vm = this;

    vm.renderInfo = renderInfo;

    vm.$onInit = function () {
      vm.communicatorObject = undefined;
      vm.consultantsInGroup = undefined;

      internalMessageService.onRunInfo(renderInfo);
      vm.renderInfo();

      vm.configScroll = {
        autoHideScrollbar: false,
        theme: 'minimal-dark',
        advanced: {
          updateOnContentResize: true
        },
        setHeight: 200,
        scrollInertia: 0
      };
    };
    vm.$postLink = function () {

    };
    function renderInfo() {
      vm.consultantsInGroup = undefined;
      vm.communicatorObject = internalMessageService.selectedObject;
      vm.objectType = (vm.communicatorObject.id[0]);
      vm.objectId = (vm.communicatorObject.id).substring(1, vm.communicatorObject.id.length);

      if (vm.objectType === 'G') {
        DynamicFactory.get('GroupRsc', 'consultantsInGroup')(vm.objectId).then(function (data) {
          vm.consultantsInGroup = data;
        }, function (err) {

        });
      }
    };
  }

}();

/**
 */
+function () {
	'use strict';

	angular.module('contactcenter.communicator').component('internalChat', {
		templateUrl: 'app/main/contactcenter/communicator/internalmessage/internalchat/internalchat.html',
		controllerAs: 'vm',
		controller: controller
	});

	/** @ngInject */
	function controller(internalMessageService, DynamicFactory, SessionManager, toastService, $translate, $mdDialog, WebSocketManager, $timeout, $scope) {
		var vm = this;
		vm.renderChat = renderChat;
		vm.answerKeyPress = answerKeyPress;
		vm.sendMessage = sendMessage;
		vm.findGuidAndChangeToOnClick = findGuidAndChangeToOnClick;
		vm.showTranscription=showTranscription;		
		
		vm.sendingMessageInProgress = false;
		vm.showErrorToast = false;
		vm.messsageDialog = '';
		vm.bodyArray = [];


		vm.dataLoaded = {
			chat: false,
			scroll: false
		};

		vm.$onInit = function () {
			vm.colorMain = 'md-green-600-bg';
			vm.colorSecondary = 'md-grey-600-bg';
			internalMessageService.onRunChat(renderChat);
			internalMessageService.onNewMessage(newMessage);
			vm.userSession = SessionManager.getUser();
			vm.dataLoaded.scroll = true;

			vm.renderChat();
		};

		vm.$postLink = function () {

		};

		vm.$onDestroy = function () {
			//vm.dataLoaded.chat = false;
			internalMessageService.clearSession();
		};

		function findGuidAndChangeToOnClick(body) {
			var searchGuid = /(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}/g;

			if (!searchGuid.test(body)) return body;
			var newBody;
			
			var sessionID = body.match(searchGuid); 
			vm.sessionID = sessionID[0];
			var linkOnClick = '<a ng-click=vm.showTranscription("'+sessionID[0]+'")>' + sessionID[0] + '</a>';
			
			newBody = body.replace(searchGuid, linkOnClick);
			// vm.messsageDialog = body;
			//console.log('linkOnClick =>  ', linkOnClick);
			return newBody;

		}
		
		function showTranscription(sessionID) {
			$mdDialog.show({
				clickOutsideToClose: true,
				controller: 'transcription',
				controllerAs: 'vm',
				focusOnOpen: false, 
				targetEvent: event,
				templateUrl: 'app/main/contactcenter/reports/components/reportsessions/transcription/transcription.html',
				multiple: true,
				locals:{
					sessionID: sessionID
				}
			});
		}
 
		function renderChat() {
			vm.dataLoaded.chat = false;
			vm.chatData = internalMessageService.chatData;
			$timeout(function () {
				vm.dataLoaded.chat = true;
			}, 250);
		}
		function newMessage(message) {
			vm.chatData.push(message);
			$timeout(function () {
				vm.dataLoaded.scroll = true;
			}, 0);
			$scope.$apply();
		}

		function sendMessage() {


			if (vm.replyMessage.length === 0) {
				if (!vm.showErrorToast) {
					toastService.showToast($translate.instant('COMMUNICATOR.INTERNAL_CHAT.EMPTY_TEXT'), 'error', 4);
				}
				vm.showErrorToast = true;
				$timeout(function () {
					vm.showErrorToast = false;
				}, 4000);
				return;
			}

			if (vm.sendingMessageInProgress) {
				//żeby nie wysłać tej samej wiadomośc dwa razy
				return;
			} else {
				vm.sendingMessageInProgress = true;
			}

			var lastMsg = _.findLast(vm.chatData, function (x) {
				return x.direction === 'I';
			});

			var msg = {
				Destination: internalMessageService.selectedObject.destination,
				Source: internalMessageService.selectedObject.source,
				Body: vm.replyMessage,
				ReplyTo: lastMsg ? lastMsg.guid : null,
				AuthorName: vm.userSession.username,
				AuthorPhotoUrl: vm.userSession.userImg
			};
			DynamicFactory.get('InternalMessageRsc', 'Send')(msg).then(function (data) {
				vm.replyMessage = '';
				data.authorName = vm.userSession.username;
				// data.authorName = vm.userSession.username?vm.userSession.username.substring(0, 10):null;
				data.authorPhotoUrl = vm.userSession.userImg;
				vm.chatData.push(data);
				internalMessageService.objectListAdd(data);
				$timeout(function () {
					vm.dataLoaded.scroll = true;
				}, 0);
				vm.sendingMessageInProgress = false;
			}, function (err) {
				vm.sendingMessageInProgress = false;
				toastService.showToast($translate.instant('COMMUNICATOR.INTERNAL_CHAT.ERRORSEND'), 'error', 4);
			});
		}
		function answerKeyPress(event) {

			if (vm.replyMessage.trim().length > 0 && event.keyCode === 13 && !event.shiftKey) {
				vm.sendMessage();
			}
		}

	}

}();

(function () {
	"use strict";

	angular
		.module('contactcenter.communicator')
		.service('clusterMap', service);

	/** @ngInject */
	function service(DynamicFactory) {
		var _this = this;


    _this.cache = {};
    _this.detailsCache = {};


		_this.getPOIs = getPOIs;
    _this.getPOI = getPOI;

		function getPOIs (serviceId) {

      var srv = "srv." + serviceId;

			var promise1 = new Promise(function(resolve, reject) {
				if (_this.cache[srv] === undefined) {
					DynamicFactory.get('map', 'mappois')(serviceId).then(function (data) {
						if (data) {
							_this.cache[srv] = data;
							resolve(_this.cache[srv]);
						}
						else
							reject("no data");
					});
				}
				else resolve(_this.cache[srv]);

			});

			return promise1;
		}

    function getPOI (id) {
			// var poi = _this.cache[srv].markers.find(function(el) {
      //   if(el.id === id)
      //     return el;
      // });

      // return  poi;

      var poi = "poi." + id;

      var promise1 = new Promise(function(resolve, reject) {
				if (_this.detailsCache[poi] === undefined) {
					DynamicFactory.get('map', 'poidetails')(id).then(function (data) {
						if (data) {
							_this.detailsCache[poi] = data;
							resolve(_this.detailsCache[poi]);
						}
						else
							reject("no data");
					});
				}
				else resolve(_this.detailsCache[poi]);

			});

			return promise1;
		}

		return _this;
	}
})();

(function () {
  'use strict';

  angular
    .module('contactcenter.communicator').controller('mapDialog', mapDialog);

  /** @ngInject */
  function mapDialog(clusterMap, $mdDialog, $http, leafletData, leafletBoundsHelpers, lngi, lati, session) {
    var vm = this;

    vm.showSearchInput = false;

    vm.$onInit = onInit;
    vm.$onDestroy = onDestory;
    vm.closeDialog = closeDialog;
    vm.goToAddress = goToAddress;
    vm.searchKeyPress = searchKeyPress;
    vm.toggleSertchInput = toggleSertchInput;
    vm.differenceTime = differenceTime;

    vm.session = session;
    vm.current = null
    vm.markers = []
    vm.bounds = []
    vm.geojson = []
    vm.events = {}
    vm.address = {
      lat: lati,
      lng: lngi,
      zoom: 15
    }

    function onInit() {
      getPOIS(vm.session.serviceId || 317);
    }

    function onDestory() {
    }

    var addressPointsToMarkers = function (points) {
      if (points === undefined) return [];

      return points.map(function (ap) {
        return {
          group: ap['group'],
          lat: ap['lat'],
          lng: ap['lng'],
          getMessageScope: function () {
            clusterMap.getPOI(ap.id).then(function (data) {
              vm.current = data;
            });
          },
          message: ap.message,
          compileMessage: false
        };
      });
    };

    // angular.extend($scope, {
    // 	address: {
    // 		lat: lati,
    // 		lng: lngi,
    // 		zoom: 15
    // 	},
    //layers: {
    // baselayers: {
    // 	osm: {
    // 		name: 'OpenStreetMap',
    // 		type: 'xyz',
    // 		url: 'http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
    // 	}
    // },
    // overlays: {
    // 	lm1449148887:
    // 	{
    // 		name: "Liberty Poland S.A.",
    // 		type: "markercluster",
    // 		visible: true
    // 	},
    // 	l459681182: {
    // 		name: "Coltex ST Sp. z o.o.",
    // 		type: "markercluster",
    // 		visible: true
    // 	}
    // }
    //}
    // });

    function getPOIS(serviceId) {
      clusterMap.getPOIs(serviceId).then(function (data) {
        if (data) {
          vm.markers = addressPointsToMarkers(data.markers);
          console.log('vm.markers: ', vm.markers);
        }
      });
    }

    function differenceTime() {
      return clusterMap.difrentsTime();
    }

    function toggleSertchInput() {
      vm.showSearchInput = !vm.showSearchInput;
    }

    function closeDialog() {
      vm.markers = [];

      // leafletData.getMap('mapTag').then(function (map) {
      //   map.off();
      //   map.remove();

        var mapTag = angular.element('#mapTag');
        console.log('mapTag: ', mapTag);
        if (mapTag) {
          mapTag.remove();
        }
        else {
          var dmap = document.getElementById("mapTag");
          console.log('dmap: ', dmap);
          dmap.remove();
        }
        var mapParent = angular.element('.mapdialog');
        console.log('mapParent: ', mapParent);
        if (mapParent) {
          mapParent.remove();
        }
        
        $mdDialog.cancel();
      // });
    }

    function searchKeyPress(event) {
      if (event.keyCode === 13 && !event.shiftKey) {
        goToAddress();
      }
    }

    // leaflet directive code
    function goToAddress() {


      if (vm.searchAddress.length > 0) {
        console.log('findAddress:', vm.searchAddress);

        var xyz = '';
        if (vm.PLSearchIsActive) {
          xyz = 'polska, ';
        }

        $http.get('https://nominatim.openstreetmap.org/search?q=' + xyz + vm.searchAddress + '&format=json&polygon=1&addressdetails=1')
          .then(function (response) {
            var result = response.data;
            console.log('response: ', result);

            if (result.length > 0) {
              leafletData.getMap('mapTag').then(function (map) {


                var bounds = leafletBoundsHelpers.createBoundsFromArray([
                  [result[0].boundingbox[0] * 1, result[0].boundingbox[2] * 1],
                  [result[0].boundingbox[1] * 1, result[0].boundingbox[3] * 1]
                ]);

                vm.bounds = bounds;
                vm.geojson = result[0].polygonpoints;


              });
            }

          }, function (error) {
            console.log('httpERROR', error);
          });

      }
      else {
        console.log('wprowadź adres.');
      }
    }
  }
})();

/**
 * Created by akraszewski on 08.09.2016.
 */
+function () {
  'use strict';

  angular.module('contactcenter.communicator').controller('addAttachmentDialogController', controller);

  /** @ngInject */
  function controller($mdDialog,FileUploadRsc, selectedAttachmentList, currentService,fileSizeLimited, loadedFilesSize, ngNotify, DynamicFactory, consts, SessionManager, $timeout) {
    var vm = this;

    const partnerIndex = 1;
    const serviceIndex = 2;
    const userIndex = 3;

    vm.changeSize = changeSize;
    // vm.getPicSize = getPicSize;
    vm.cancel = cancel;
    vm.chosePic = chosePic;
    vm.FlowConfig = FlowConfig;
    vm.validate = validate;
    vm.CallMeMaybe = CallMeMaybe;
    vm.cancelFile = cancelFile;
    vm.close = close;
    vm.openTag = openTag;
    vm.backToList = backToList;
    vm.toogleTagFilter = toogleTagFilter;


    function init() {
      vm.picSizeNormal = true;
      vm.picSizeLarge = false;
      vm.selectedTabIndex = 0;

      vm.imageListUser = [];
      vm.imageListService = [];
      vm.imageListPartner = [];
      vm.loadedFilesSize = 0;
      vm.maxFilesSize = 300;
      vm.fileSizeLimited=fileSizeLimited;
      vm.userSession = {};
      vm.consultantId = SessionManager.getUser().consultantId;

      // funkcja przyjmująca 1 parametr element
      vm.getReplacmentFileThumbnail=FileUploadRsc.getReplacmentFileThumbnail;

      loadTagListtData();

      angular.forEach(selectedAttachmentList, function (e) {
        increaseFileSizeKB(e);
      });

      vm.filterObject = {
        partner: false,
        service: true,
        user: false
      };

    };

    function toogleTagFilter(type) {
      vm.openedTag = undefined;

      if (type === 1) {
        vm.filterObject = {
          partner: true,
          service: false,
          user: false
        };
      } else if (type === 2) {
        vm.filterObject = {
          partner: false,
          service: true,
          user: false
        };
      } else if (type === 3) {
        vm.filterObject = {
          partner: false,
          service: false,
          user: true
        };
      }
    };


    function loadTagListtData() {
      DynamicFactory.get('FileUploadRsc', 'getContentTags')(1, null).then(handlePartnerRsc); // partnerId brane z API
      DynamicFactory.get('FileUploadRsc', 'getContentTags')(2, currentService).then(handleServiceRsc);
      DynamicFactory.get('FileUploadRsc', 'getContentTags')(3, vm.consultantId).then(handleUserRsc);

    };


    function backToList() {
      vm.openedTag = undefined;
    }

    function openTag(type, tag) {
      loadTagsContent(type, tag);

      vm.openedTag = tag;
      vm.openedTag.name = tag.name;
    }

    function loadTagsContent(type, tag) {
      if (!tag.contents) {
        var id = null;
        if (type === 2) {
          id = currentService;
        } else if (type === 3) {
          id = vm.consultantId;
        }
        ;

        DynamicFactory.get('FileUploadRsc', 'getContentForTag')(type, tag.tagID, id).then(function (data) {
          tag.contents = data;
          checkSelected(tag.contents);
          notAImagePrepare(tag.contents);
        }
        );
      } else {
        checkSelected(tag.contents);
      }
    }

    function handleUserRsc(data) {
      vm.userContetTags = data;
      insertTypeInfo(userIndex, vm.userContetTags);
      notAImagePrepare(vm.userContetTags);
    }

    function handleServiceRsc(data) {
      vm.serviceContetTags = data;
      insertTypeInfo(serviceIndex, vm.serviceContetTags);
      notAImagePrepare(vm.serviceContetTags);
    }

    function handlePartnerRsc(data) {
      vm.partnerContetTags = data;
      insertTypeInfo(partnerIndex, vm.partnerContetTags);
      notAImagePrepare(vm.partnerContetTags);
    }

    function checkSelected(imageList) {
      //przepisywanie wyboru z okna czatu na okno dodawania pliku
      for (var j = 0; j < selectedAttachmentList.length; j++) {
        for (var k = 0; k < imageList.length; k++) {
          if (selectedAttachmentList[j].contentUrl === imageList[k].contentUrl) {
            imageList[k].selected = true;
            break;
          }
        }
      }
    };

    function close() {
      $mdDialog.cancel('cancel');
    }

    function increaseFileSizeKB(pic) {
      vm.loadedFilesSize += pic.fileSizeKB;
      loadedFilesSize.value += pic.fileSizeKB;

    }

    function decreaseFileSizeKB(pic) {
      vm.loadedFilesSize -= pic.fileSizeKB;
      loadedFilesSize.value -= pic.fileSizeKB;
    }

    function insertTypeInfo(type, imageList) {
      imageList.forEach(function (e) {
        e.type = type;
      })
    }

    function notAImagePrepare(imageList) {
      imageList.forEach(function (e) {
        vm.getReplacmentFileThumbnail(e);
      })
    }


  

    function changeSize(option) {
      if (option === 'normal') {
        vm.picSizeNormal = true;
        vm.picSizeLarge = false;
      }
      else if (option === 'large') {
        vm.picSizeNormal = false;
        vm.picSizeLarge = true;
      }

    };


    function cancel() {
      $mdDialog.hide();
    };


    function chosePic(pic, type) {

      pic.selected = !pic.selected;
      if (pic.selected) {
        pic.type = type;
        selectedAttachmentList.push(pic);
        increaseFileSizeKB(pic);
      } else {
        for (var i = 0; i < selectedAttachmentList.length; i++) {
          if (selectedAttachmentList[i].contentUrl == pic.contentUrl) {
            selectedAttachmentList.splice(i, 1);
            decreaseFileSizeKB(pic);
            break;
          }
        }

      }
    };


    function FlowConfig() {
      return DynamicFactory.get('FileUploadRsc', 'LoadContentFlowConfig')(false, {
        ConsultantId: vm.consultantId,
        contentType: 3
      });
    };

    function validate(file) {
      if (file.size > 300000 && vm.fileSizeLimited) {
        ngNotify.set('Plik za duży', 'error');
        return false;
      }
      return true;
    };

    function CallMeMaybe($flow, $file, $message) {
      ngNotify.set('Plik ' + $file.file.name + ' został przesłany na serwer.', 'success');
      // var url = consts.consultantContent + vm.consultantId + '/' + $file.file.name;

      var webUrl=$message.replace(/\"/g, '');
      var fileGuid='';
      if (webUrl.indexOf('.') > 0) {
        var contentTypeFolder="";//np: partners/998
          contentTypeFolder="consultants/";
        contentTypeFolder=contentTypeFolder+vm.consultantId;

        fileGuid =  webUrl.substring(webUrl.indexOf(contentTypeFolder)+1+contentTypeFolder.length,webUrl.lastIndexOf('.'))
      } 


      var noTagContent = _.find(vm.userContetTags, { tagID: -1 });
      if (!noTagContent) {
        var newEmptyTag = {
          tag: '',
          tagID: -1,
          type: 3,
          content: []
        };
        vm.userContetTags.push(newEmptyTag);
        noTagContent = newEmptyTag;
      }

      noTagContent.loadding = true;

      if (!noTagContent.contents) {
        noTagContent.contents = [];
      }

      noTagContent.contents.push({
        name: $file.file.name,
        contentUrl: webUrl,
        loadding: true,
        // flow: $file,
        fileSizeKB: Math.floor($file.file.size / 1024),
        size: { width: 2, height: 1 }
      });

      $timeout(function () {
        noTagContent.loadding = false
        var loadedPic=_.find(noTagContent.contents,{contentUrl:webUrl});
        if(loadedPic){
          loadedPic.loadding = false;
          vm.getReplacmentFileThumbnail(loadedPic);
        }
      }, 3000);

    };

    function cancelFile(file) {
      if (file.flow)
        file.flow.cancel();
      DynamicFactory.get('FileUploadRsc', 'deleteContent')(3, file.contentUrl).then(function (data) {
        var index = vm.imageListUser.indexOf(file);
        vm.imageListUser.splice(index, 1);
      });
    };

    init();

  }

}();


/**
 * Created by akraszewski on 2016-09-29.
 */

(function () {
  'use strict';

  angular.module('contactcenter.communicator').component('surveyPart', {
    templateUrl: 'app/main/contactcenter/communicator/components/surveypart/surveypart.html',
    controllerAs: 'vm',
    bindings: {
      serviceId: '<',
      contactId: '<',
      reservedNumber: "<"
    },
    controller: controller
  });

  /** @ngInject */
  function controller(DynamicFactory, SessionManager, toastService, $translate, $timeout) {

    var vm = this;
    vm.surveyChanged = surveyChanged;
    vm.saveAnswers = saveAnswers;
    vm.$onChanges = onChanges;

    vm.$onInit = function () {
      vm.rollDown = true;
      vm.dataLoaded= {surveys : true};
      vm.error=false;
      vm.userSession = SessionManager.getUser();
      getSurveys();
      // vm.inited = true;

      vm.allwodFormFieldTypes = DynamicFactory.get('templatesRsc', 'getFieldTypes')();

    };


    function onChanges(changesObj) {
      console.log('surveyPart changed!!! ', changesObj);
      // if (vm.inited) {
      vm.rollDown = true;
      getSurveys();
      // }
      // vm.activeSurvey = undefined;
    };

    function getSurveys() {
      if (vm.serviceId) {
        if(!vm.dataLoaded){
          vm.dataLoaded={}
        }
        vm.dataLoaded = {
          surveys: false
        };
        vm.error=false;
        if(vm.reservedNumber){
          vm.rollDown = true;
          vm.dataLoaded.surveys = true;
          console.log('Numer zastrzeżony');
          return;
        }
        DynamicFactory.get('surveyRsc', 'getServiceSurveys')(vm.serviceId).then(function (result) {
          vm.rollDown = false;
          vm.serviceSurveys = result;
          vm.serviceSurveys.forEach(cutSurveyName);

          if (vm.serviceSurveys.length > 0)
            surveyChanged(vm.serviceSurveys[0]);
          // vm.activeSurvey = vm.serviceSurveys[0];
          vm.dataLoaded.surveys = true;


        }, function (err) {
          vm.rollDown = false;
          vm.dataLoaded.surveys = true;
        });
      }
    }

    function cutSurveyName(survey){
      if(survey.name.length > 19)
      survey.name = survey.name.substring(0, 17) + '...';
    }

    function surveyChanged(survey) {
      if (!survey.config) {
        survey.config = JSON.parse(survey.configJSON).config;
      }

      angular.forEach(survey.config, function (f) {
        var t = _.find(vm.allwodFormFieldTypes, function (e) {
          return e.name === f.type;
        });
        if (t) {
          f.templateKey = t.templateKey;
        }
      });


      vm.answers = {};
      loadContactAnswers(survey.config, survey.id);
      vm.activeSurvey = survey;
    }

    function loadContactAnswers(surveyConfig, surveyId, date) {
      DynamicFactory.get('surveyRsc', 'getAnswerSurvey')(surveyId, vm.serviceId, vm.contactId, date).then(function (result) {
        result.forEach(function (answer) {
          if (findInConfig(surveyConfig, answer.fieldID).templateKey === 'ta-number') {
            vm.answers[answer.fieldID] = parseInt(answer.fieldValue);
          } else {
            vm.answers[answer.fieldID] = answer.fieldValue;
          }
        });
      });
    }

    function findInConfig(surveyConfig, fieldId) {
      return _.find(surveyConfig, {
        fieldId: fieldId
      });
    }


    function saveAnswers() {
      DynamicFactory.get('surveyRsc', 'answerSurvey')(vm.activeSurvey.id, vm.serviceId, vm.contactId, prepareAnswers(vm.answers)).then(function (result) {
        toastService.showToast($translate.instant('COMMUNICATOR.SURVEY.NOTIFY_SURVEY_UPDATE_SUCCESS'), 'success', 4);
      }, function (err) {
        toastService.showToast($translate.instant('COMMUNICATOR.SURVEY.NOTIFY_SURVEY_UPDATE_ERROR'), 'error', 4);
      });
      // vm.activeSurvey = undefined;
    }

    function prepareAnswers(answers) {
      var result = [];
      for (var fieldId in answers) {
        result.push({
          fieldId: fieldId,
          fieldValue: answers[fieldId]
        });
      }
      return result;
    }
  }


}());

/**
 * Created by akraszewski on 2016-09-29.
 */

(function () {
  'use strict';

  angular.module('contactcenter.communicator').component('notesPart', {
    templateUrl: 'app/main/contactcenter/communicator/components/notespart/notesPart.html',
    controllerAs: 'vm',
    bindings: {
      currentServiceId: '<',
      contactId: "<",
      reservedNumber: "<",
      colorMain:"=" // żeby nie wołać onChange
    },
    controller:   controller
  });

  /** @ngInject */
  function controller(DynamicFactory, SessionManager, toastService, $translate, $timeout,communicatorService) {
    var vm = this;
    vm.addNewNote = addNewNote;
    vm.getNotes = getNotes;
    vm.noteKeyPress = noteKeyPress;
    vm.changeNote = changeNote;


    vm.$onInit = function () {
      vm.notes = [];
      vm.newNote = '';
      vm.rollDown = true;
      vm.dataLoaded= {contact : true};
      vm.error=false;
      vm.userSession = SessionManager.getUser();
    };

    vm.$onChanges = function (changesObj) {
      console.log('notesPart - changes: ', changesObj);
      vm.dataLoaded = {
        notes: false
      };
      vm.error=false;

      vm.notes = [];
      vm.newNote = '';


      if (changesObj.contactId.currentValue  ) {
        if (vm.userSession === undefined) {
          vm.userSession = SessionManager.getUser();
        }
        vm.rollDown = false;
        getNotes( changesObj.contactId.currentValue)
      }
      else {
        // vm.notes = [];
        // vm.newNote = '';
        // vm.dataLoaded = {
        //   notes: false
        // };
        // $timeout(function () {
          vm.rollDown = true;
          vm.dataLoaded.contact = true;
        // });
      }

    };

    function changeNote() {
        communicatorService.setTypingInProgress(vm.newNote.length > 0);
    }

    // pobranie notatek
    function getNotes(contactId ) {
      vm.notes = [];
      vm.dataLoaded.notes = false;

      if (!contactId) {
        console.log('Brak pcontactId do pobrania notatek dla klienta');
        return;
      }

      if(vm.reservedNumber){
        vm.rollDown = true;
        vm.dataLoaded.notes = true;
        console.log('Numer zastrzeżony');
        return;
      }

      DynamicFactory.get('NotesPartRsc', 'getContactNotes')(contactId).then(function (data) {
        vm.rollDown = false;
        vm.notes = data;
        vm.dataLoaded.notes = true;
      },function (err) {
        vm.dataLoaded.notes = true;
        vm.rollDown = true;
        vm.error=true;
      });
    };

    function addNewNote() {

      if (vm.newNote.trim().length === 0) {
        toastService.showToast($translate.instant('COMMUNICATOR.NOTES.NOTIFY_NO_MESSAGE_TO_SEND'), 'error', 4);
        return;
      }

      var note = {
        contactId:vm.contactId,
        description: vm.newNote,
        serviceId: vm.currentServiceId
      };

      DynamicFactory.get('NotesPartRsc', 'addNewNote')(note).then(function () {
        vm.newNote = '';

        //przeładowanie notatek
        vm.getNotes(vm.contactId)
      })
    }
    function noteKeyPress(event) {
      if (event.keyCode === 13 && !event.shiftKey) {
        vm.addNewNote();
      }
    }
  }


}());

/**
 * Created by akraszewski on 2016-09-29.
 */

(function () {
  'use strict';

  angular.module('contactcenter.communicator').component('servicePart', {
    templateUrl: 'app/main/contactcenter/communicator/components/servicepart/servicePart.html',
    controllerAs: 'vm',
    bindings: {
      serviceId: '<',
      serviceCommunicationParams: '=' // tak żeby nie wplywało na ochange
    },
    controller: controller
  });

  /** @ngInject */
  function controller(DynamicFactory, SessionManager) {
    var vm = this;


    vm.$onInit = function () {
      vm.serviceData = {};
      vm.userSession = {};
      vm.bundleServices = {};
      vm.emailService;

      vm.typeArray = [
        {type: 'C', desc: 'Chat wwww'},
        {type: 'E', desc: 'Email'},
        {type: 'I', desc: 'Głosowy'},
        {type: 'S', desc: 'Chat SMS'},
        {type: 'F', desc: 'FB Messanger'},
        {type: 'K', desc: 'FB komentarz do FunPage'},
        {type: 'V', desc: 'Chat Callback'}
      ];
      vm.rollDown = true;
      vm.dataLoaded = {service: true};
      vm.error = false;

      vm.userSession = SessionManager.getUser();
    };


    vm.$onChanges = function (changesObj) {
      vm.serviceData = [];
      vm.dataLoaded = {
        service: false
      };
      vm.error = false;

      if ((changesObj.serviceId && changesObj.serviceId.currentValue)) {
        vm.rollDown = false;
        if (vm.serviceId) {
          getServiceDetails(vm.serviceId, null)
        }

      } else {
        // nie pobrano wiadomości i chowamy wkurzajace paski
        // $timeout(function () {
        vm.rollDown = true;
        vm.dataLoaded.service = true;
        // });

      }
    };


    function getServiceDetails(serviceId, prefixId) {

      vm.serviceData = [];
      vm.dataLoaded.service = false;

      if (!serviceId && !prefixId) {
        console.log('Brak service Id i prefix Id do danych dla serwisu');
        return;
      }
      console.log('getServiceDetails - serviceId: ', serviceId);
      DynamicFactory.get('ServicePartRsc', 'GetServiceDesc')(serviceId, prefixId).then(function (data) {
        vm.serviceData = data;
        vm.serviceData.typeText = vm.serviceData.type + '  (' + _.find(vm.typeArray, {type: data.type}).desc + ')';
        vm.dataLoaded.service = true;
        vm.rollDown = false;

        if (vm.serviceData.bundleID) {
          DynamicFactory.get('servicesRsc', 'servicesBundleFlatGet2')(vm.serviceData.bundleID).then(function (bundle) {
            if (bundle) {
              vm.emailService = bundle.emailService;

              vm.bundleServices = {
                smsServiceId: bundle.smsService,
                ivrServiceId: bundle.ivrService,
                chatServiceId: bundle.chatService,
                facebookServiceId: bundle.facebookService,
                emailServiceId: bundle.emailService,
                callbackServiceId: bundle.callbackService
              };

              if (vm.bundleServices.smsServiceId) {
                vm.bundleServices.smsService = {loadded: false};
                DynamicFactory.get('servicesRsc', 'firstSmSServiceFromBundle')(vm.bundleServices.smsServiceId).then(function (smsService) {
                  vm.bundleServices.smsService.loadded=true;
                  vm.bundleServices.smsService.Name=smsService.name;
                  vm.bundleServices.smsService.Id=smsService.serviceId;
                  vm.bundleServices.smsService.LA=smsService.la;
                }, function (err) {

                });
              }

            }

          });
        } else {
          console.log('Brak bundle ID...');
        }
      }, function (err) {
        vm.dataLoaded.service = true;
        vm.rollDown = true;
        vm.error = true;
      });

    };


  }


}());

/**
 * Created by akraszewski on 2016-09-29.
 */

(function () {
  'use strict';

  angular.module('contactcenter.communicator').component('morfer', {
    templateUrl: 'app/main/contactcenter/communicator/components/morfer/morfer.html',
    controllerAs: 'vm',
    bindings: {
      area: '<',
      templateData: '='
    },
    controller: controller
  });

  /** @ngInject */
  function controller(communicatorConfig,$mdMenu) {
    var vm = this;

    vm.goToCustomizerPart = goToCustomizerPart;
    vm.mouseOverCustomiserIcon = mouseOverCustomiserIcon;
    vm.changeConfig = changeConfig;

    vm.$onInit = function () {
      vm.allowedParts = undefined;
      vm.showPartsOptionDiv = false;

      if (vm.templateData) {
          vm.allowedParts = communicatorConfig.communicator.AllowedParts;
          vm.partPlacement = communicatorConfig.communicator.PartPlacement;
      }
    };
    vm.$onChange = function(changesObj){
      console.log('morfer - change: ',changesObj);
    };

    function goToCustomizerPart() {
      communicatorConfig.changeConfig( '', vm.area);
    };

    function mouseOverCustomiserIcon() {
      if (vm.templateData) {
        if (!(vm.customizerPartVisable = vm.partPlacement[vm.area] == '' || vm.partPlacement[vm.area] == 'customizer-part')) {
          vm.showPartsOptionDiv = true;
        }
      }
    };

    vm.openMenu = function($mdMenu, ev) {
      $mdMenu.open(ev);
    };

    function changeConfig(part) {

      if(vm.partPlacement[vm.area]===part){
        // part został już wybrany
        return;
      }
      communicatorConfig.changeConfig( part, vm.area);
    };

  }
}());

/**
 * Created by akraszewski on 2016-09-29.
 */

(function () {
  'use strict';

  angular.module('contactcenter.communicator').component('customizerPart', {
    templateUrl: 'app/main/contactcenter/communicator/components/customizerpart/customizerpart.html',
    controllerAs: 'vm',
    bindings: {
      area: '<',
      templateData: '='
    },
    controller: controller
  });

  /** @ngInject */
  function controller(communicatorConfig) {
    var vm = this;
    vm.changeConfig = changeConfig;
    vm.getCssClass = getCssClass;

    vm.$onInit = function () {

        vm.allowedParts = communicatorConfig.communicator.AllowedParts;

    };

    // vm.zm=  '<md-button ng-class=\'vm.getCssClass("")\' class=\'md-raised\' layout=\'row\' layout-align=\'start center\'  ng-click="vm.changeConfig(\'' + e.name + '\')">'
    // +'<md-icon class=\'icon-comment-check-outline\'></md-icon>'
    // +'<span flex translate=\'COMMUNICATOR.CUSTOMIZER.EMPTY\'>BRAK</span>'
    // +'</md-button>';

    function changeConfig(part) {
      communicatorConfig.changeConfig(part, vm.area);
    };


    function getCssClass(part) {
      return communicatorConfig.getCssClass( part, vm.area);
    };

  }


}());

/**
 * Created by akraszewski on 2016-11-30.
 */

(function () {
  'use strict';

  angular.module('contactcenter.communicator').component('mapPart', {
    templateUrl: 'app/main/contactcenter/communicator/components/mappart/mappart.html',
    controllerAs: 'vm',
    bindings: {
      searchAddress: '<'
    },
    controller: controller
  });

  /** @ngInject */
  function controller($mdDialog, $scope, $http, leafletData, leafletBoundsHelpers) {
    // 'use strict';
    var vm = this;
    vm.$onInit = onInit;

    function onInit() {
      vm.PLSearchIsActive = true;
    }


    vm.$onChanges = function (obj) {
      if (obj.searchAddress && obj.searchAddress.currentValue) {
        vm.goToAddress();
      }
    };


    vm.cancel = function () {
      $mdDialog.hide();
    };


    vm.searchKeyPress = function (event) {
      if (event.keyCode === 13 && !event.shiftKey) {
        vm.goToAddress();
      }
    };

    vm.tooglePLSearch = function () {
      vm.PLSearchIsActive = !vm.PLSearchIsActive;
    };

    // leaflet directive
    angular.extend($scope, {
      address: {
        lat: 52,
        lng: 19,
        zoom: 4
      }
      //, bounds: {}
      // ,geojson: {
      //   data: {},
      //   style: {
      //     fillColor: 'green',
      //     weight: 2,
      //     opacity: 1,
      //     color: 'white',
      //     dashArray: '3',
      //     fillOpacity: 0.7
      //   }
      // }
    });

    // leaflet directive code
    vm.goToAddress = function () {


      if (vm.searchAddress.length > 0) {
        console.log('findAddress:', vm.searchAddress);

        var xyz = '';
        if (vm.PLSearchIsActive) {
          xyz = 'polska, ';
        }

        $http.get('https://nominatim.openstreetmap.org/search?q=' + xyz + vm.searchAddress + '&format=json&polygon=1&addressdetails=1')
          .then(function (response) {
            var result = response.data;
            console.log('response: ', result);


            if (result.length > 0) {
              leafletData.getMap('mapTag').then(function (map) {


                var bounds = leafletBoundsHelpers.createBoundsFromArray([
                  [result[0].boundingbox[0] * 1, result[0].boundingbox[2] * 1],
                  [result[0].boundingbox[1] * 1, result[0].boundingbox[3] * 1]
                ]);

                $scope.bounds = bounds;
                $scope.geojson = result[0].polygonpoints;


              });
            }

          }, function (error) {
            console.log('httpERROR', error);
          });

      }

    };


  }

}());




/**
 * Created by akraszewski on 2016-09-29.
 */


(function () {
  'use strict';
  angular.module('contactcenter.communicator').component('contactPart', {
    templateUrl: 'app/main/contactcenter/communicator/components/contactpart/contactPart.html',
    controllerAs: 'vm',
    bindings: {
      contactId: '<',
      contactMapAddress: '=',
      reservedNumber: '<'
    },
    controller: controller
  });

  /** @ngInject */
  function controller(DynamicFactory, toastService, $translate, SessionManager, $timeout,communicatorService, templateData) {
    var vm = this;

    vm.updateContact = updateContact;
    vm.waitAndSave = waitAndSave;
    vm.proccessBirthDate = proccessBirthDate;
    vm.startPhoneChangeing = startPhoneChangeing;
    vm.cancelPhoneChangeing = cancelPhoneChangeing;
    vm.savePhoneChangeing = savePhoneChangeing;
    vm.startEmailChangeing = startEmailChangeing;
    vm.cancelEmailChangeing = cancelEmailChangeing;
    vm.saveEmailChangeing = saveEmailChangeing;
    vm.toogleTab = toogleTab;

    vm.$onInit = function () {
      vm.activeContact = {};
			communicatorService.onRunContact(renderContact);

      vm.rollDown = true;
      vm.dataLoaded = {contact: true};
      vm.error = false;

      vm.changingPhoneNo = false;
      vm.changingEmail = false;

      vm.sexList = [{value: 'F', name: 'Kobieta'}, {value: 'M', name: 'Mężczyzna'}];

      vm.userSession = SessionManager.getUser();


      vm.minAllowedDate = new Date(1901, 1, 1);
      vm.fenixTimer = undefined;

      vm.saveInProgress = false;
      vm.saved = false;


      vm.filterObject = {
        general: true,
        all: false
      };
    };


    function waitAndSave() {
      communicatorService.setTypingInProgress(true);
      vm.saveInProgress = true;
      if (vm.fenixTimer) {
        $timeout.cancel(vm.fenixTimer);
      }
      vm.fenixTimer = $timeout(function () {
        updateContact();
        console.log('zapis kontaktu');
      }, 2000);

    };

    function toogleTab(type) {
      vm.openedTab = undefined;

      if (type === 1) {
        vm.filterObject = {
          general: true,
          all: false
        };
      } else if (type === 2) {
        vm.filterObject = {
          general: false,
          all: true
        };
      }
    };

    function proccessBirthDate() {
      if (vm.activeContact.birthday) {
        if (vm.activeContact.birthday !== vm.activeContact.expectedBirthday) {
          vm.activeContact.expectedBirthday = vm.activeContact.birthday;
          vm.activeContact.age = moment().diff(vm.activeContact.birthday, 'years');
        }
      } else {
        if (vm.activeContact.age != null || vm.activeContact.age !== 0) {
          var today = new Date();
          vm.activeContact.expectedBirthday = new Date(today.getFullYear() - vm.activeContact.age, today.getMonth(), today.getDate());
        }
      }
    }


    vm.$onChanges = function (changesObj) {
      vm.dataLoaded = {
        contact: false
      };
      vm.error = false;
      vm.activeContact = {};

      console.log('contactPart - changes | contactId: ', changesObj.contactId);
      if ((changesObj.contactId && changesObj.contactId.currentValue)) {
        if (vm.userSession === undefined) {
          vm.userSession = SessionManager.getUser();
        }
        vm.rollDown = false;
        //getContactDetails(changesObj.contactId.currentValue) //przeniesione do renderContact!
      }
      else {
        //nie pobrano wiadomości i chowamy wkurzajace paski i pokazujemy ikonke
        //bez timeout nie aktualizuje sie
        // $timeout(function () {
        vm.rollDown = true;
        vm.dataLoaded.contact = true;
        // });
      }
    };

    function updateContact() {

      DynamicFactory.get('ContactPartRsc', 'updateContact')(vm.activeContact).then(function (data) {
        // toastService.showToast($translate.instant('COMMUNICATOR.CLIENT.NOTIFY_CLIENT_UPDATE_SUCCESS'), 'success', 4);
        vm.saveInProgress = false;
        vm.saved = true;
        $timeout(function () {
          vm.saved = false;

          if(vm.contactMapAddress!==vm.activeContact.city) {
            vm.contactMapAddress=vm.activeContact.city;
          }
          communicatorService.setTypingInProgress(false);
        }, 2000);

      }, function (e) {
        toastService.showToast($translate.instant('COMMUNICATOR.CLIENT.NOTIFY_CLIENT_UPDATE_ERROR'), 'error', 4);
      })
    };

    //pobranie bardziej szczegółowych danych kontaktu
    function getContactDetails(contactId) {
      vm.dataLoaded.contact = false;
      vm.activeContact = {};

      if (!contactId) {
        console.log('Brak contactId do pobrania danych szczegółowych dla klienta');
        return;
      }

      if(vm.reservedNumber){
        vm.rollDown = true;
        vm.dataLoaded.contact = true;
        console.log('Numer zastrzeżony');
        return;
      }

      DynamicFactory.get('ContactPartRsc', 'getContact')(contactId).then(function (data) {
          vm.dataLoaded.contact = true;
          vm.rollDown = false;

          vm.activeContact.contactID = contactId;
          vm.activeContact.portalUserId = data.portalUserId;
          if (data.msisdn) {
            vm.activeContact.msisdn = data.msisdn.toString();
          }
          vm.activeContact.name = data.name;
          vm.activeContact.surname = data.surname;
          vm.activeContact.sex = data.sex;

          // vm.activeContact.age = data.age * 1;

          vm.activeContact.msisdn = data.msisdn;
          vm.activeContact.msisdnCoded = encodePhoneNo(data.msisdn);
          vm.activeContact.email = data.email;
          vm.activeContact.emailCoded = encodeEmail(data.email);
          vm.activeContact.wwwAddress = data.wwwAddress;

          vm.activeContact.country = data.country;
          vm.activeContact.county = data.county;
          vm.activeContact.city = data.city;
          vm.activeContact.street = data.street;
          vm.activeContact.houseNo = data.houseNo;
          vm.activeContact.localNo = data.localNo;

          vm.activeContact.workMsisdn = data.workMsisdn;
          vm.activeContact.workEmail = data.workEmail;
          vm.activeContact.job = data.job;
          vm.activeContact.jobPosition = data.jobPosition;


           vm.contactMapAddress=vm.activeContact.city ;

          if (data.birthday) {
            vm.activeContact.birthday = new Date(data.birthday);
            vm.activeContact.age = moment().diff(vm.activeContact.birthday, 'years');
            waitAndSave();
          } else {
            vm.activeContact.birthday = null;
            vm.activeContact.age = data.age * 1;
          }


        }, function (err) {
          //jakby coś nie poszło np routing bo brakuje
          vm.activeContact.portalUserId = vm.portalUserId;
          vm.activeContact.msisdn = vm.msisdn;
          vm.activeContact.email = data.email;
          vm.dataLoaded.notes = true;
          vm.rollDown = true;
          vm.error = true;
        }
      );
    };


    function startPhoneChangeing() {
      vm.activeContact.msisdnCoded = '';
      vm.changingPhoneNo = true;
    }

    function cancelPhoneChangeing() {
      vm.activeContact.msisdnCoded = encodePhoneNo(vm.activeContact.msisdn);
      vm.changingPhoneNo = false;
    }

    function savePhoneChangeing() {

      vm.activeContact.msisdn = vm.activeContact.msisdnCoded;
      vm.changingPhoneNo = false;
      vm.waitAndSave();
      vm.activeContact.msisdnCoded = encodePhoneNo(vm.activeContact.msisdnCoded);
    }


    function startEmailChangeing() {
      vm.activeContact.emailCoded = '';
      vm.changingEmail = true;
    }

    function cancelEmailChangeing() {
      vm.activeContact.emailCoded = encodeEmail(vm.activeContact.email);
      vm.changingEmail = false;
    }

    function saveEmailChangeing() {
      vm.activeContact.email = vm.activeContact.emailCoded;
      vm.changingEmail = false;
      vm.waitAndSave();
      vm.activeContact.emailCoded = encodeEmail(vm.activeContact.emailCoded);
    }


    function encodePhoneNo(phoneNo) {
      if (!phoneNo) {
        return null;
      }
      if (phoneNo.length > 3) {
        return phoneNo.substring(0, phoneNo.length - 3) + '***';
      } else {
        return phoneNo;
      }
    }

    function encodeEmail(email) {
      if (!email) {
        return null;
      }
      var index = email.lastIndexOf('@');
      if (index > 0) {
        return email.substring(0, index + 1) + '*****'
      } else {
        return email;
      }
    }

    function renderContact(){
      console.log('renderContact: ',templateData.contactId)
      getContactDetails(templateData.contactId);
    }
  }


}());

/**
 * Created by akraszewski on 2016-09-29.
 */

(function () {
	'use strict';
	/** @ngInject */

	angular.module('contactcenter.communicator').component('chatPart', {
		templateUrl: 'app/main/contactcenter/communicator/components/chatpart/chatPart.html',
		controllerAs: 'vm',
		bindings: {
			templateData: '='
		},
		controller: controller
	});



	/** @ngInject */
	function controller($scope, DynamicFactory,
		SessionTagsService,
		SessionManager,
		ngNotify,
		$translate,
		MMSHandler,
		$mdDialog,
		$interval,
		WebSocketManager,
		$timeout,
		$q,
		consts,
		communicatorService,
		$sessionStorage, $stateParams,
		mdcDateTimeDialog,
		FileUploadRsc,
		confirmDialogService,
		toastService) {
		var vm = this;

		$scope.emojiMessage = {};


		$scope.image = null;
		$scope.imageFileName = '';

		vm.dropzoneCtrl = null;

		vm.addAttachmentDialog = addAttachmentDialog;
		vm.deleteAttachment = deleteAttachment;
		vm.sendMesgAndGetData = sendMesgAndGetData;
		vm.answerKeyPress = answerKeyPress;
		vm.playEvasdropping = playEvasdropping;
		//vm.createJiraIssue = createJiraIssue;
		//vm.openJiraIssue = openJiraIssue;
		vm.showImageInPopup = showImageInPopup;
		vm.createIssueDialogParams = createIssueDialogParams;
		vm.setSendTime = setSendTime;
		vm.setCustomTime = setCustomTime;
		vm.openSendTime = openSendTime;
		vm.chatSessionEndFn = chatSessionEndFn;
		vm.changeMessageToRepley = changeMessageToRepley;
		vm.saveMsgTags = saveMsgTags;
		vm.consultantId = SessionManager.getUser().consultantId;
		vm.getUrlExtension = getUrlExtension;
		vm.autoSaveTags = autoSaveTags;
		vm.attachmentUrls = '';
		vm.msgTags = '';

		vm.getReplacmentFileThumbnail = FileUploadRsc.getReplacmentFileThumbnail;

		vm.$onInit = function () {
			vm.rollDown = true;
			communicatorService.onRunChat(renderChat);

			WebSocketManager.registerWebSocketMethod(
				'CallChat',
				'chatArrive',
				wsCallsChatArrive,
				SessionManager.buildRegexForCCAndConsExtended()
			);
			WebSocketManager.registerWebSocketMethod(
				'FBStatusChat',
				'fbStatusArrive',
				wsFBStatusArrive,
				SessionManager.buildRegexForCCAndConsExtended()
			);

			if ($stateParams.forceRender) {
				renderChat();
			}
		};

		jQuery('html').pasteImageReader(function (results) {
			sendUploadContent(results);
		});

		function renderChat() {
			vm.selectedService = undefined;
			vm.callID = undefined;
			vm.serviceOrderId = undefined;
			$scope.emojiMessage = {};
			vm.replyToMessage = {};
			vm.selectedAttachmentList = [];

			vm.loadedFilesSize = 0;
			vm.isMaxFilesSize = false;
			vm.maxFilesSize = 300;

			vm.chatSessionProgressInterval = undefined;
			vm.chatSessionStart = undefined;
			vm.chatSessionEnd = undefined;
			vm.sessionProgress = undefined;

			vm.chatData = [];
			vm.rollDown = true;
			vm.dataLoaded = {
				chat: false,
				newMessage: false,
				getNextLoaded: false
			};
			vm.sendingMessageInProgress = false;
			vm.developerLookVisable = false;

			vm.dataLoaded.noMessageToProcess = false;
			vm.userSession = SessionManager.getUser();
			vm.firstLoad = false;
			vm.loadChatDataIntervalInProgress = false;
			vm.sessionGuidOld = undefined;
			vm.sessionGuidToCancel = undefined;

			vm.diffFromLastIncoming = undefined;
			vm.lastMsgIncoming = [];


			vm.audio = new Audio();
			vm.recordList = [];
			vm.servicesType;
			vm.showServicesType = false;
			vm.currentDate = moment();
			vm.timeArray = [];
			vm.communicatorService = communicatorService;
			vm.writingSendTime = moment();

			renderTimeArray();

			communicatorService.onClearChatData(clearChat);

			if (vm.templateData.reservedNumber) {
				vm.rollDown = true;
				return;
			}

			//vm.testFBButton = testFBButton;

			// || vm.templateData.sessionId
			if (vm.templateData.callid || vm.templateData.serviceOrderId) {
				vm.replyToMessage = {};
				vm.replyToMessage.type = 'S';
				vm.replyToMessage.msisdn = vm.templateData.msisdn;
				vm.replyToMessage.serviceID = vm.templateData.smsServiceId;
				if (vm.templateData.sessionId) {
					vm.templateData.currentServiceId = vm.replyToMessage.serviceID;
				}
				vm.replyToMessage.contactID = vm.templateData.contactId;
				vm.callID = vm.templateData.callid;

				if (parseInt(vm.templateData.serviceOrderId) > 0) {
					vm.serviceOrderId = parseInt(vm.templateData.serviceOrderId);
				} else if (parseInt(vm.templateData.callbackServiceId) > 0) {
					vm.serviceOrderId = parseInt(vm.templateData.callbackServiceId);
				} else {
					vm.serviceOrderId = vm.templateData.serviceOrderId;
				}


			}

			//Po odpaleniu komunikatora pobieramy historię do sesji która była ostatnio GetActivity lub pobieramy sesję dla rozmowy która nadeszła


			//AM 200718 - potrzebne rozroznienie na sesje IVR/Order i Text
			if (!vm.templateData.sessionId && !vm.templateData.callid && !vm.templateData.serviceOrderId) {
				getSession(vm.callID, vm.serviceOrderId);
			} else {
				getActivity(vm.templateData.contactId, vm.templateData.currentServiceId, vm.templateData.sessionId);
			}


			if (jQuery('#my-awesome-dropzone').length > 0) {
				vm.dropzoneCtrl = jQuery('#my-awesome-dropzone').get(0).dropzone;
			} else {
				vm.dropzoneCtrl = undefined;
			}
			// }
		};


		vm.$onChanges = function (changesObj) {
			console.log('chatPart - changes: ', vm.templateData.sessionId);
		};

		vm.$onDestroy = function () {

			WebSocketManager.unregisterWebSocketMethod('CallChat', 'chatArrive');
			WebSocketManager.unregisterWebSocketMethod('FBStatusChat', 'fbStatusArrive');

			$interval.cancel(vm.intervalChatLoad);
		};

		function renderTimeArray() {
			vm.timeArray = [];
			vm.timeArray.push({
				toAdd: 3,
				unit: 'h',
				text: $translate.instant('COMMUNICATOR.CHAT.IN_3_H')
			});
			vm.timeArray.push({
				toAdd: 6,
				unit: 'h',
				text: $translate.instant('COMMUNICATOR.CHAT.IN_6_H')
			});
			vm.timeArray.push({
				toAdd: 12,
				unit: 'h',
				text: $translate.instant('COMMUNICATOR.CHAT.IN_12_H')
			});
			vm.timeArray.push({
				toAdd: 1,
				unit: 'd',
				hour: 9,
				text: $translate.instant('COMMUNICATOR.CHAT.IN_1_D')
			});
		}
		// do uzgodnienia po czy potrzebne   AK 180719
		// potrzebne do pobierania sesji dla IVR AM 200718
		function getSession(callID, serviceOrderId) {

			var serviceOrderIdq = serviceOrderId ? serviceOrderId : 0;
			DynamicFactory.get('ChatPartRsc', 'getSession')().then(
				function (data) {
					vm.templateData.sessionType = 'active';
					if (data.sessionID) {
						//setReservedMessages(data.sessionID);
						console.log('runChatSessionTimer getSession');
						runChatSessionTimer(data.reservedDate);
						var contactID;
						if (data.contactID !== undefined) {
							contactID = data.contactID;
						} else {
							contactID = vm.replyToMessage.contactID;
						}
						vm.templateData.currentServiceId = data.serviceID;
						getActivity(contactID, data.serviceID, data.sessionID);

					}
				},
				function (err) {
					console.log(err);
				}
			);
		}


		function playRowCallback(call, audioLink) {
			vm.audio.pause();
			angular.forEach(vm.recordList, function (value) {
				//todo
				value.isPlaying = false;
			});
			if (audioLink) {
				call.isPlaying = true;
				vm.audio.src = audioLink;
				if (vm.audio.paused) {
					vm.audio.play();
					call.isPlaying = true;
				} else {
					vm.audio.pause();
					call.isPlaying = false;
				}
			}
		}

		function stopPlaying(call) {
			playRowCallback(call);
		}

		// <!--Podsłuchy nie są dla Wróżek i Ero, ale będą w pozostałej czesci systemu-->
		function playEvasdropping(call) {
			var elem = _.find(vm.recordList, {
				guid: call.guid
			});
			if (!elem) {
				vm.recordList.push(call);
			}

			if (call.isPlaying) {
				stopPlaying(call);
				call.isPlaying = false;
			} else {
				call.disabledButton = true;
				getAudioURL(call).then(function (result) {
					playRowCallback(call, result);
					call.disabledButton = false;
					call.isPlaying = true;
				});
			}
		}

		function getAudioURL(call) {
			return $q(function (resolve, reject) {
				if (call.guid) {
					// https://socialsharing.teleaudio.pl/recordings/'
					resolve(consts.recordings + call.guid);
				}
			});
		}

		// <!--Podsłuchy nie są dla Wróżek i Ero, ale będą w pozostałej czesci systemu-->

		function runChatSessionTimer(chatSessionStart) {
			console.log('reservation Date: ' + chatSessionStart);

			var sessionDurationS = 60;

			vm.chatSessionStart = chatSessionStart;
			vm.chatSessionEnd = moment(vm.chatSessionStart).add(
				sessionDurationS,
				'seconds'
			);

			vm.chatSessionProgressInterval = $interval(function () {
				//vm.sessionProgress=(counter/sessionDurationS)*100;
				vm.sessionProgress =
					moment().diff(vm.chatSessionStart, 'second') / sessionDurationS * 100;

				if (vm.sessionProgress >= 100) {
					vm.sessionProgress = 100;
					$interval.cancel(vm.chatSessionProgressInterval);
				}
			}, 1000);
		}

		function setChatData(data) {

			var lastMessage;
			if (data.message.guid) {
				lastMessage = data.message
			} else if (data.message.messages.length > 0) {
				lastMessage = data.message.messages[data.message.messages.length - 1];
			} else {
				lastMessage = {};
			}

			vm.replyToMessage.msisdn = data.message.msisdn;
			vm.replyToMessage.serviceID = data.message.serviceID;
			vm.replyToMessage.sessionID = data.message.sessionID;
			vm.replyToMessage.operator = data.message.operator;
			vm.replyToMessage.contactID = data.message.contactID;
			vm.replyToMessage.guid = lastMessage.guid;
			vm.replyToMessage.direction = data.message.direction;

			if (vm.chatData.length > 0) {
				convertAttachmentForBubble(lastMessage);
				var msg = _(vm.chatData).find(function (x) {
					return x.guid === lastMessage.guid;
				});
				if(!msg){
					vm.chatData.push(lastMessage);
				}
			} else {
				getActivity(data.message.contactID, data.message.serviceID, data.message.sessionID);
			}
		}

		function wsCallsChatArrive(data) {

			vm.data = JSON.parse(data.Content);
			if (vm.data.type === 1) {
				//wyswietlamy komunikaty tylko dla biezacej sesji
				if (vm.data.message.sessionID === vm.templateData.sessionId) {
					setChatData(vm.data);
					if (vm.data.message.type === 'F') {
						sendFBAction(vm.data.message, 0); //oznaczenie przeczytanej wiadomosci z FB
					}
				}
			} else if (vm.data.type === 2) {
				if (vm.data.message.sessionID === vm.templateData.sessionId) {
					// vm.templateData.contactId = 0;
					// vm.templateData.contactId = vm.data.message.contactID;

					setChatData(vm.data);
					if (vm.data.message.type === 'F') {
						sendFBAction(vm.data.message, 0); //oznaczenie przeczytanej wiadomosci z FB
					}
				}
			} else if (vm.data.type === 3) {
				if (vm.data.message.sessionID === vm.templateData.sessionId && vm.data.message.finished) {
					vm.communicatorService.setHistorySessionAsFinished(vm.templateData.sessionId);
					getActivity(vm.data.message.contactID, vm.data.message.serviceID, vm.data.message.sessionID);
				}
				if (vm.data.message.sessionID === vm.templateData.sessionId && vm.data.message.isForward == true){
					clearChat();
				}
			}
		}
		/* var testFBStatus = { 'Sequence': 11586, 'Command': 4, 'Token': 'CCS.0/2/17:CallChat', 'Timestamp': '2018-05-18T15:36:38.5230656+02:00', 'Content': '{\'status\':\'READ\',\'guids\':[\'bb80d9ea-71a3-4fca-ac38-a3b8ef0babdc\',\'e62a6d73-d5de-4bdb-86e8-7c25c09dd266\',\'20db38c3-0428-42b4-a745-45a6b45dac63\',\'97e7aafc-803d-4898-80fc-eaefc104fa88\',\'741b6feb-d24a-4ed8-9a33-41e1cae5cfd6\']}' };
		 function testFBButton() {
		   wsFBStatusArrive(testFBStatus);
		 }*/

		function wsFBStatusArrive(data) {
			vm.data = JSON.parse(data.Content);
			(vm.data.guids).forEach(function (element) {
				var msg = _(vm.chatData).find(function (x) {
					return x.guid === element;
				});
				if (msg) {
					msg.fbOutMessageStatus = vm.data.status;
				}
			});
		}

		function clearChat() {
			console.log('ChatPart clearChat');

			vm.templateData.clearData();
			$scope.emojiMessage = {};
			vm.rollDown = true;
			vm.chatData = [];
			vm.replyToMessage = {};
			vm.dataLoaded.newMessage = false;
			vm.dataLoaded.chat = true;
			vm.dataLoaded.noMessageToProcess = true;
			vm.loadChatDataIntervalInProgress = false;
			vm.dataLoaded.getNextLoaded = false;
			vm.firstLoad = true;


			vm.chatSessionProgressInterval = undefined;
			vm.chatSessionStart = undefined;
			vm.chatSessionEnd = undefined;
			vm.sessionProgress = undefined;

			vm.developerLook = undefined;

			vm.loadedFilesSize = 0;
			vm.selectedAttachmentList = [];
			clearTextarea();
			// czyszczenie tego co zostało zapisane w communicator.component.js
			$sessionStorage.commTemplateData = undefined;
		}

		function restartAndGetNext() {
			$scope.emojiMessage = {};
			vm.selectedAttachmentList = [];
			vm.loadedFilesSize = 0;
			if (vm.templateData.sessionType === 'active' && !vm.templateData.callid) {
				console.log('ChatPart restartAndGetNext');

				vm.dataLoaded.chat = false;

				//usuwamy załczniki


				//AK temp

				// vm.chatData = [];
				// clearChat();

				// DynamicFactory.get('CommunicatorServiceRsc', 'GetActiveSessions')().then(function (data) {
				// 	if (data.length > 0) {
				// 		communicatorService.openCommunicator(data[0], vm.templateData.sessionType);
				// 	}
				// }, function (err) {

				// });
			}
		}

		function setServiceType() {
			console.log('setServiceType - selectedService: ', vm.selectedService);
			if (vm.selectedService) {
				vm.replyToMessage.serviceID = vm.selectedService.serviceId;
				vm.replyToMessage.type = vm.selectedService.type;
			}
		}
		$scope.dropzoneConfig = {
			'options': {
				'url': consts.api + 'fileupload/uploadcontent',
				'withCredentials': true,
				'previewTemplate': '<div></div>',
				'headers': {
					'Authorization': 'Bearer ' + SessionManager.getToken()
				},
				'acceptedFiles': 'image/*,.xls,.xlsx,.doc,.docx,.pdf,.txt'
			},
			'eventHandlers': {
				'sending': function (file, xhr, formData) {
					console.log('dropzone sending');
					formData.append('ConsultantId', vm.consultantId);
					formData.append('contentType', 4);
					formData.append('flowFilename', file.upload.filename);
					formData.append('flowIdentifier', file.upload.uuid);
					formData.append('flowTotalSize', file.size);
					formData.append('flowTotalChunks', file.upload.totalChunkCount);
					formData.append('flowTotalSize', file.upload.total);
					formData.append('flowRelativePath', file.name);
				},
				'success': function (file, response) {
					console.log('dropzone success');
					$timeout(function () {
						setAttachmentFromDropzone(file, response);
					}, 500);
					// restartAndGetNext();
				}
			}
		};
		function setAttachmentFromDropzone(file, response) {
			vm.countRes = [];
			var fileUrl = 'http://moderacja.teleaudio.pl/panel/callcenter/contents/consultants/';
			vm.countRes.push(response);

			angular.forEach(vm.countRes, function (e) {
				fileUrl += vm.consultantId + '/droped/' + e;
				// vm.attachmentUrls = fileUrl + ';';
			});

			var data = {
				'contentUrl': fileUrl,
				'name': file.upload.filename,
				'fileGuid': file.upload.uuid,
				'type': 3
			};

			//wyznaczamy miniaturkę jak trzeba
			vm.getReplacmentFileThumbnail(data);

			vm.selectedAttachmentList.push(data);
			//$scope.apply();
		}

		function sendMesgAndGetData() {
			if (vm.sendingMessageInProgress) {
				//żeby nie wysłać tej samej wiadomośc dwa razy
				return;
			} else {
				vm.sendingMessageInProgress = true;
			}

			if (vm.loadedFilesSize > vm.maxFilesSize && vm.isMaxFilesSize) {
				ngNotify.set(
					$translate.instant('COMMUNICATOR.CHAT.TO_BIG_ATTACH'),
					'error'
				);
				return;
			}

			var msgValue = $scope.emojiMessage.messagetext;
			var msgDivValue = jQuery('#messageDiv').html();

			if ((vm.replyToMessage.type !== 'S' && (msgValue === undefined || msgValue === '' || msgDivValue === '')) ||
				(vm.replyToMessage.type === 'S' && (vm.replyMessage === undefined || vm.replyMessage === '' || vm.replyMessage.trim().length === 0))
			) {
				clearTextarea();
				vm.sendingMessageInProgress = false;
				if (vm.selectedAttachmentList.length > 0) {
					if (vm.replyToMessage.type === 'S' || vm.replyToMessage.type === 'M') {
						$scope.emojiMessage.messagetext = '[Brak treści]';
					}
				} else {

					ngNotify.set(
						$translate.instant('COMMUNICATOR.CHAT.NOTIFY_NO_MESSAGE_TO_SEND'),
						'error'
					);
					return;
				}
			}
			setServiceType();

			if (vm.replyToMessage.type === 'A') {
				vm.replyToMessage.type = 'C';
			}

			//send
			if (vm.replyToMessage) {
				console.log('vm.consultantId: ', vm.consultantId);
				//vm.selectedAttachmentList = vm.dropzoneData;
				var message = {
					portalId: vm.userSession.portalId,
					serviceId: vm.replyToMessage.serviceID,
					portalUserID: vm.replyToMessage.portalUserID,
					contactID: vm.replyToMessage.contactID,
					titile: '',
					type: (vm.consultantId > -1 ? vm.replyToMessage.type : 'A'),
					body: vm.replyToMessage.type === 'S' ? vm.replyMessage : $scope.emojiMessage['messagetext'],
					//msisdn: vm.replyToMessage.msisdn, numer telefonu dodajemy w API na podstawie contactID żeby było aktualne
					sessionID: vm.replyToMessage.sessionID,
					prefix: vm.replyToMessage.prefixID,
					operator: vm.replyToMessage.operator,
					la: vm.replyToMessage.la,
					params: vm.replyToMessage.params,
					replyToGuid: vm.replyToMessage.direction === 'I' ? vm.replyToMessage.guid : null,
					direction: 'O',
					callID: vm.templateData.callid,
					serviceOrderId: vm.templateData.serviceOrderId,
					//direction2: 'user',
					attachments: vm.selectedAttachmentList,
					communictorType: vm.templateData.communictorType,
					MMSUrls: [],
					attachmentUrls: vm.attachmentUrls,
					fbMessengerID: vm.replyToMessage.fbMessengerID,
					authorPhotoUrl: vm.userSession.userImg,
					authorName: vm.userSession.username,
					timeToSend: vm.replyToMessage.timeToSend,
					fbCommentID: vm.replyToMessage.fbCommentID,
					fbCommentParentID: vm.replyToMessage.fbCommentParentID
				};
				angular.forEach(message.attachments, function (ele) {
					message.MMSUrls.push(ele.contentUrl);
					message.attachmentUrls += ele.contentUrl + ';';
				});
				var endpointSend = (vm.consultantId > -1 ? 'sendConsultantMessage' : 'sendManagerMessage');
				DynamicFactory.get('ChatPartRsc', endpointSend)(
					message
				).then(
					function (data) {
						vm.templateData.sessionId = data.sessionID;
						if (message.MMSUrls.length > 0 && message.type === 'S') {
							message.type = 'M';
						}
						message.body = data.body;
						message.guid = data.guid;
						message.time = message.timeToSend ? message.timeToSend : moment();
						message.sessionID = data.sessionID;

						convertAttachmentForBubble(message);

						if ((message.body && message.body.length>0) || (message.attachments && message.attachments.length>0)){
							vm.chatData.push(message);
						}
						restartAndGetNext();

						vm.sendingMessageInProgress = false;
						$scope.emojiMessage = {};
						$scope.emojiMessage.messagetext = '';
						$scope.emojiMessage.rawhtml = '';
						$('#messageDiv').text($scope.emojiMessage.rawhtml);
						vm.replyMessage = '';
						communicatorService.setTypingInProgress(false);
					},
					function (err) {
						ngNotify.set(err.data.message, 'error');

						restartAndGetNext();
						clearTextarea();
						vm.sendingMessageInProgress = false;
						communicatorService.setTypingInProgress(false);
					}
				);
			} else {
				ngNotify.set(
					$translate.instant('COMMUNICATOR.CHAT.NOTIFY_NO_MESSAGE_TO_RESPONSE'),
					'error'
				);
				vm.sendingMessageInProgress = false;
			}
		}

		function clearTextarea() {
			jQuery('#messageDiv').text($scope.emojiMessage.messagetext);
		}

		function getMessageSessionInfo(sessionGuid) {
			DynamicFactory.get('messageSessionRsc', 'getInfo')(
				sessionGuid
			).then(
				function (data) {

					SessionTagsService.refresChatPartTagsControl(data.tags)
					
				},
				function (err) {
				});
		}

		//pobranie historii aktywności kontaktu
		function getActivity(contactID, serviceID, sessionID) {

			getMessageSessionInfo(sessionID);

			vm.selectedService = undefined;

			vm.rollDown = false;
			vm.dataLoaded.chat = false;

			if (sessionID && vm.templateData.sessionType === 'active' && vm.templateData.sessionReservedDate) {
				runChatSessionTimer(vm.templateData.sessionReservedDate);
			}

			jQuery('#messageDiv').on('focus', function () {
				var x = jQuery('#my-awesome-dropzone').focus();
				if (x) {
					jQuery('#my-awesome-dropzone').addClass('md-input-has-value');
				} else {
					jQuery('#my-awesome-dropzone').removeClass('md-input-has-value');
				}
			});

			loadChatServiceSetup(serviceID);

			DynamicFactory.get('ChatPartRsc', 'getActvity')(
				contactID,
				serviceID,
				sessionID
			).then(
				function (data) {
					vm.loadChatDataIntervalInProgress = false;

					getIssueIdAndStatus(data.list);

					var list = data.list;
					if (list.length > 0) {

						vm.lastMsgIncoming = angular.copy(list[
							_.findLastIndex(list, function (e) {
								return e.direction === 'I';// && e.type !== 'A';
							})]);

						//nie ostatnia, tylo ostatnia incomming
						if (vm.templateData.callid || vm.templateData.serviceOrderId) {
							//replyToMessage ustawiany na OnInit
							if (!vm.replyToMessage.sessionID) {
								vm.lastMsg = angular.copy(list[
									_.findLastIndex(list, function (e) {
										return (e.type === 'S' || e.type === 'M' || e.type === 'C' || e.type === 'F' || e.type === 'K');
									})]);
								if (vm.lastMsg && vm.lastMsg.direction === 'I') {
									vm.replyToMessage.sessionID = vm.lastMsg.sessionID;
								}
							}
						} else {
							vm.replyToMessage = angular.copy(vm.lastMsgIncoming);
						}

						if (vm.lastMsgIncoming) {
							vm.diffFromLastIncoming = moment().diff(vm.lastMsgIncoming.time, 'minutes');
						}
						if (vm.replyToMessage.type === 'S' || vm.replyToMessage.type === 'M') {
							//powyzej 30 min od ostatniego kontaktu w godz: 22:00-8:00
							//to czas ustawic po 8:00 dnia nastepnego do 23:59:59 lub dnia biezacego po 0:00:00
							if (!vm.diffFromLastIncoming ||
								(vm.diffFromLastIncoming && vm.diffFromLastIncoming >= 30)) {
								vm.fromTimeSend = {
									hour: 8,
									minute: 0
								};
								vm.currentDateTime = moment();
								if (vm.currentDateTime.isAfter(moment({
									hour: 22,
									minute: 0
								}))) {
									vm.replyToMessage.timeToSend = moment(vm.fromTimeSend).add(1, 'days').format('YYYY-MM-DD HH:mm:ss');
								}
								if (vm.currentDateTime.isBefore(moment(vm.fromTimeSend))) {
									vm.replyToMessage.timeToSend = moment(vm.fromTimeSend).format('YYYY-MM-DD HH:mm:ss');
								}
							}
						}


						if (vm.replyToMessage.params) {
							var JSONParams = tryParseJSON(vm.replyToMessage.params);
							if (JSONParams) {
								vm.templateData.serviceCommunicationParams = JSONParams;
							}
						}


						vm.templateData.msisdn = list[list.length - 1].msisdn;
						vm.templateData.portalUserId = list[list.length - 1].portalUserID;
						if (!serviceID) {
							vm.templateData.currentServiceId =
								list[list.length - 1].serviceID;
						} else {
							vm.templateData.currentServiceId = serviceID;
						}
						vm.templateData.currentServicePrefixId =
							list[list.length - 1].prefixID;
						vm.templateData.sessionId = list[list.length - 1].sessionID;
						vm.templateData.contactId = list[list.length - 1].contactID;

						if (
							vm.chatData.length > 0 &&
							vm.chatData.length === list.length &&
							vm.chatData[0].sessionID === list[0].sessionID
						) {
							vm.dataLoaded.chat = true;
							vm.dataLoaded.noMessageToProcess = false;
							return;
						}
						vm.chatData = list;

						vm.dataLoaded.chat = true;


						//setReservedMessages(vm.templateData.sessionId);
						angular.forEach(vm.chatData, function (e) {
							if (e.type === 'I' || e.type === 'V') {

								if (e.direction === 'I' && e.childrenOut.length === 0) {
									e.notRealizedCall = true;
								}
								// var duration =smoment.duration(e.duration);

								if (e.duration) {
									e.duration2 = moment.utc(e.duration).format('HH:mm:ss');
								}

								if (!e.duration && e.childrenOut.length === 1 && !e.childrenOut[0].duration) {
									e.currentCall = true
								}

								if (e.childrenOut.length > 0) {
									angular.forEach(e.childrenOut, function (x) {
										if (x.duration) {
											x.duration2 = moment.utc(x.duration).format('HH:mm:ss');
										}
									});
								}
							}

							//przetwarzanie załączników
							convertAttachmentForBubble(e);

							// petla po wiadomosciach i rozpracowanie URL do załacznikow

							// if (e.type === 'C'  ) {
							//    wiaomości typu chat przeniesione do ng-repeat
							// }

							if (e.type === 'M' && e.direction === 'I') {
								loadMMS(e);
							} else if (e.type === 'M' && e.direction === 'O') {
								if (e.attachmentUrls && e.attachmentUrls.length > 0) {
									e.MMSUrls = e.attachmentUrls.split(';');
								}
							}
						});
					}

					prepareDeveloperLook();

					if (!sessionID) {
						vm.replyToMessage.guid = 'thisMessage';
						// vm.replyToMessage.type = 'S'; //ustawiane na onInit
						vm.isMaxFilesSize = true;
					} else {

						if (!vm.replyToMessage) {
							vm.replyToMessage.guid = 'thisMessage';



							if (vm.templateData.smsServiceId) {
								vm.replyToMessage.type = 'S';
								vm.replyToMessage.serviceID = vm.templateData.smsServiceId;

								DynamicFactory.get('servicesRsc', 'firstSmSServiceFromBundle')(vm.templateData.smsServiceId).then(function (smsService) {
									vm.replyToMessage.la = smsService.la;
								}, function (err) {
									ngNotify.set(
										$translate.instant('COMMUNICATOR.CHAT.NO_SMS_SETUP'),
										'error'
									);
								});
							} else if (vm.templateData.chatServiceId) {
								vm.replyToMessage.type = 'C';
								vm.replyToMessage.serviceID = vm.templateData.chatServiceId;
							} else if (vm.templateData.facebookServiceId) {
								vm.replyToMessage.type = 'F';
								vm.replyToMessage.serviceID = vm.templateData.facebookServiceId;
							}
						} else {
							// vm.replyToMessage.guid = vm.replyToMessage.guid;//data.messageToReply.guid;
							// vm.replyToMessage.type = vm.replyToMessage.type;//data.messageToReply.type;
						}

						vm.isMaxFilesSize = vm.replyToMessage.type === 'S' || vm.replyToMessage.type === 'M';
					}
					buildServiceChange();
				},

				function (er) {
					vm.loadChatDataIntervalInProgress = false;
				}
			);
		}

		function convertAttachmentForBubble(dialog) {
			if (dialog.attachmentUrls !== undefined && dialog.attachmentUrls.length > 0) {
				var arrayOfAttach = dialog.attachmentUrls.split(';');
				if (arrayOfAttach.length > 0 || arrayOfAttach[0] === '') {
					dialog.attachmentUrlsConverted = [];
					arrayOfAttach.forEach(function (element) {
						if (element !== '' && element.length > 0) {
							var attach = {
								contentUrl: element
							};
							//jak trzeba to dodajemy pole 'contentUrlNoImage'
							vm.getReplacmentFileThumbnail(attach);
							dialog.attachmentUrlsConverted.push(attach);
						}
					});
				}
			}
		}

		function buildServiceChange() {
			vm.selectedService = undefined;
			console.log('buildServiceChange - selectedService: ', vm.selectedService);
			console.log('buildServiceChange - templateData.sessionType: ', vm.templateData.sessionType);
			console.log('buildServiceChange - templateData.callid: ', vm.templateData.callid);
			if ((vm.templateData.smsServiceId || vm.templateData.facebookServiceId) &&
				(vm.templateData.callid || vm.templateData.sessionType === 'history')) {
				vm.servicesType = [];
				DynamicFactory.get('ContactPartRsc', 'getContact')(vm.templateData.contactId).then(function (data) {
					if (vm.templateData.smsServiceId && data.msisdn) {
						vm.servicesType.push({
							serviceId: vm.templateData.smsServiceId,
							type: 'S',
							name: 'SMS'
						});
					}
					if (vm.templateData.facebookServiceId && data.fbMessengerID) {
						vm.servicesType.push({
							serviceId: vm.templateData.facebookServiceId,
							type: 'F',
							name: 'FBM'
						});
						vm.replyToMessage.fbMessengerID = data.fbMessengerID;
					}
					findFirstService();
				});
			}
		}

		function findFirstService() {
			vm.selectedService = _(vm.servicesType).find(function (x) {
				return x.serviceId == vm.replyToMessage.serviceID;
			});
			if (!vm.selectedService) {
				vm.selectedService = vm.servicesType[0];
			}
			vm.showServicesType = (vm.servicesType && vm.servicesType.length > 1);
			console.log('findFirstService - selectedService: ', vm.selectedService);
			console.log('findFirstService - showServicesType: ', vm.showServicesType);
		}

		function loadChatServiceSetup(serviceID) {
			DynamicFactory.get('ServicePartRsc', 'LoadChatServiceSetup')(
				serviceID
			).then(
				function (data) {
					vm.templateData.setDefaltChatSetup();
					if (data.chatBackgroundURL) {
						vm.templateData.chatBackgroundURL = data.chatBackgroundURL;
					}
					if (data.chatMainColor && data.chatMainColor.indexOf('md') > -1) {
						vm.templateData.colorMain = data.chatMainColor;
					}
					if (data.chatSecondaryColor && data.chatSecondaryColor.indexOf('md') > -1) {
						vm.templateData.colorSecondary = data.chatSecondaryColor;
					}

					if (vm.templateData.colorMain.indexOf('md-red') > 0) {
						vm.timeToSendButtonColor = 'md-red-900-bg';
					} else {
						vm.timeToSendButtonColor = 'md-blue-900-bg';
					}

				},
				function (err) {
					console.log(err);
					vm.templateData.setDefaltChatSetup();
				});
		}

		function loadMMS(message) {
			message.MMSUrls = [];
			MMSHandler.GetAttachmentCount(message.guid).then(
				function (data) {
					if (data && data.length > 0) {
						var attachIndex = [];
						for (var i = 0; i < data.length; i++) {
							if (data[i] === 'image') {
								attachIndex.push(i);
							}
						}

						for (var j = 0; j < attachIndex.length; j++) {
							MMSHandler.GetAttachment(
								message.guid,
								attachIndex[j],
								'image'
							).then(
								function (data) {
									message.MMSUrls.push(data.data);
								},
								function (er) {
									console.log('Nie załadowano zalacznika o indexie: ' + j);
								}
							);
						}
					}
				},
				function (er) {
					console.log('Nie można zliczyć załczników MMS');
				}
			);
		}

		function addAttachmentDialog(event) {

			$mdDialog.show({
				clickOutsideToClose: true,
				controller: 'addAttachmentDialogController',
				controllerAs: 'vm',
				focusOnOpen: false,
				locals: {
					selectedAttachmentList: vm.selectedAttachmentList,
					currentService: vm.replyToMessage.serviceID,
					fileSizeLimited: vm.replyToMessage.type === 'S' || vm.replyToMessage.type === 'M',
					loadedFilesSize: {
						value: vm.loadedFilesSize
					}
				},
				targetEvent: event,
				templateUrl: 'app/main/contactcenter/communicator/dialogs/addmms/addmms.html',
				multiple: true,
				onRemoving: function (event, removePromise) {
					vm.loadedFilesSize = 0;
					vm.selectedAttachmentList.forEach(function (e) {
						vm.loadedFilesSize += e.fileSizeKB;
					});
				}
			});
		}

		function deleteAttachment(pic) {
			for (var i = 0; i < vm.selectedAttachmentList.length; i++) {
				if (vm.selectedAttachmentList[i].contentUrl == pic.contentUrl) {
					vm.loadedFilesSize -= pic.fileSizeKB;
					vm.selectedAttachmentList.splice(i, 1);
					break;
				}
			}
		}

		function changeMessageToRepley() {
			communicatorService.setTypingInProgress($scope.emojiMessage !== {}); //$scope.emojiMessage.messagetext.length > 0
		}
		/*
		function createJiraIssue() {
		jiraIssueService.showIssueCreator({
		// service: vm.data.serviceInfo,
		data: '<br/>' + 'Rozmowa: ' + formatChatSource(),
		type: vm.replyToMessage.type,
		sessionId: vm.replyToMessage.contactID
		});
		}
		
		function createJiraIssue() {
		jiraIssueService.showIssueCreator({
		// service: vm.data.serviceInfo,
		data: '<br/>' + 'Rozmowa: ' + formatChatSource(),
		type: vm.replyToMessage.type,
		sessionId: vm.replyToMessage.contactID,
		contactId: vm.replyToMessage.contactID
		});
		}
		*/
		function getIssueIdAndStatus(chatMessages) {
			if (chatMessages) {
				var issueTrackerMessage = _.find(chatMessages, function (message) {
					return message.type == 'T';
				});

				if (issueTrackerMessage) {
					vm.issueStatus = issueTrackerMessage.body;
					vm.issueId = issueTrackerMessage.subject;
				} else {
					vm.issueStatus = undefined;
					vm.issueId = undefined;
				}
			}
		}

		function createIssueDialogParams(issueId) {
			return $q(function (resolve, reject) {
				var issueDialogParams;

				if (issueId) {
					issueDialogParams = {
						issueId: issueId
					}
				} else {
					issueDialogParams = {
						//service: vm.replyToMessage.serviceID,
						data: '<br/>' + 'Rozmowa: ' + formatChatSource(),
						// type: vm.replyToMessage.type,
						// sessionId: vm.replyToMessage.sessionID,
						// contactId: vm.replyToMessage.contactID

						channelInfo: {
							channelType: vm.replyToMessage.type,
							channelSessionId: vm.replyToMessage.sessionID,
							channelId: vm.replyToMessage.serviceID,
							channelConfigId: undefined,
							channelName: 'Testowa Nazwa Chatu',
						},
						contactId: vm.replyToMessage.contactID,
						issueMsgDate: vm.replyToMessage.time
					};
				}

				resolve(issueDialogParams);
			});
			//return issueDialogParams;
		}

		function formatChatSource() {
			var date = vm.chatSessionStart;

			return vm.chatData
				.map(function (item) {
					return (
						'<blockquote><b>' +
						(item.userName ? item.userName : 'Konsultant') +
						'</b> : ' +
						item.body +
						(item.attachmentUrls ? '<br>' + item.attachmentUrls.split(';').map(function (attachmentUrl) {
							return 'attachment url: ' + attachmentUrl;
						}).join('<br>') : '') +
						' </blockquote>'
					);
				}).join('');
		}

		/*function openJiraIssue(issueId) {
		  if (issueId) {
			jiraIssueService.showIssueCreator({
			  issueId: issueId
			});
		  }
		}*/



		function sendFBAction(message, status) {
			vm.sendingMessageInProgress = true;
			var fbAction = {
				serviceID: message.serviceID,
				contactID: message.contactID,
				senderAction: status
			};
			DynamicFactory.get('ChatPartRsc', 'sendFBAction')(fbAction).then(
				function (data) {
					vm.sendingMessageInProgress = false;
				},
				function (err) {
					console.log(err);
					vm.sendingMessageInProgress = false;
				}
			);
		}

		function sendWritingMessage(sessionID) {
			DynamicFactory.get('ChatPartRsc', 'sendWritingMessage')(sessionID).then(
				function (data) {

				},
				function (err) {
					console.log(err);
				}
			);
		}

		function setSendTime(time) {
			if (time) {
				var result = moment().add(time.toAdd, time.unit);
				if (time.hour) {
					result = result.hours(time.hour).minutes(0);
				}
				vm.replyToMessage.timeToSend = result.format('YYYY-MM-DD HH:mm:ss');
			} else {
				vm.replyToMessage.timeToSend = undefined;
			}
		}

		function setCustomTime() {
			mdcDateTimeDialog.show({
				time: true,
				minDate: moment(),
				todayText: $translate.instant('COMMUNICATOR.CHAT.TODAY'),
				cancelText: $translate.instant('COMMUNICATOR.CHAT.CANCEL')
			}).then(function (date) {
				vm.replyToMessage.timeToSend = moment(date).format('YYYY-MM-DD HH:mm:ss');
			}, function () { });
		}

		function openSendTime($mdMenu, ev) {
			$mdMenu.open(ev);
		}

		function answerKeyPress(event) {

			setServiceType();
			if (vm.replyToMessage.type === 'C' || vm.replyToMessage.type === 'A' ) {
				vm.writingDiff = moment().diff(vm.writingSendTime, 'seconds');
				// console.log('answerKeyPress - sessionId: ', vm.templateData.sessionId);
				// console.log('vm.writingDiff: ', vm.writingDiff);
				if ($scope.emojiMessage === {} || vm.writingDiff > 5) { //$scope.emojiMessage['messagetext'].length === null || 
					sendWritingMessage(vm.templateData.sessionId);
					vm.writingSendTime = moment();
				}
			}
			if ($scope.emojiMessage === {}) {
				/* rozpoczecie pisania */
				if (vm.replyToMessage.type === 'F') {
					sendFBAction(vm.replyToMessage, 1);
				}
			}

			if (event.keyCode === 13 && !event.shiftKey) {
				vm.sendMesgAndGetData();
			}
		}

		function tryParseJSON(jsonString) {
			try {
				var o = JSON.parse(jsonString);

				// Handle non-exception-throwing cases:
				// Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
				// but... JSON.parse(null) returns null, and typeof null === 'object',
				// so we must check for that, too. Thankfully, null is falsey, so this suffices:
				if (o && typeof o === 'object') {
					return o;
				}
			} catch (e) { }

			return false;
		};
		function prepareDeveloperLook() {
			vm.developerLook = {
				msisdn: vm.templateData.msisdn,
				currentServiceId: vm.templateData.currentServiceId,
				currentServicePrefixId: vm.templateData.currentServicePrefixId,
				sessionId: vm.templateData.sessionId,
				callid: vm.templateData.callid,
				contactId: vm.templateData.contactId,
				smsServiceId: vm.templateData.smsServiceId,
				facebookServiceId: vm.templateData.facebookServiceId,
				ivrServiceId: vm.templateData.ivrServiceId,
				chatServiceId: vm.templateData.chatServiceId,
				emailServiceId: vm.templateData.emailServiceId,
				callbackServiceId: vm.templateData.callbackServiceId,
				serviceOrderId: vm.templateData.serviceOrderId
			};
		}

		function showImageInPopup(url) {
			$mdDialog.show({
				clickOutsideToClose: true,
				template: '<img src="' + url + '" />',
				// locals: {
				// 	loadedFilesSize: {
				// 		value: vm.loadedFilesSize
				// 	}
				// },
				multiple: true
			});
		}

		function chatSessionEndFn(ev) {
			confirmDialogService
				.showConfirm('confirmEndSession', '', { serviceId: vm.replyToMessage.serviceID, sessionId: vm.replyToMessage.sessionID })
				.then(
					function (cleningActionReason) {
						console.log('ChatPart | chatSessionEndFn');



						var message = {
							portalId: vm.userSession.portalId,
							serviceId: vm.replyToMessage.serviceID,
							portalUserID: vm.replyToMessage.portalUserID,
							contactID: vm.replyToMessage.contactID,
							titile: '',
							type: 'A',
							body: '',
							sessionId: vm.replyToMessage.sessionID,
							prefix: vm.replyToMessage.prefixID,
							operator: vm.replyToMessage.operator,
							la: vm.replyToMessage.la,
							params: vm.replyToMessage.params,
							replyToGuid: vm.replyToMessage.direction === 'I' ? vm.replyToMessage.guid : null,
							direction: 'O',
							callID: vm.templateData.callid,
							serviceOrderId: vm.templateData.serviceOrderId,
							attachments: vm.selectedAttachmentList,
							communictorType: vm.templateData.communictorType,
							MMSUrls: [],
							attachmentUrls: vm.attachmentUrls,
							fbMessengerID: vm.replyToMessage.fbMessengerID,
							authorPhotoUrl: vm.userSession.userImg,
							authorName: vm.userSession.username,
							timeToSend: vm.replyToMessage.timeToSend,
							fbCommentID: vm.replyToMessage.fbCommentID,
							fbCommentParentID: vm.replyToMessage.fbCommentParentID,
							cleningActionReason: cleningActionReason.answer?cleningActionReason.answer:cleningActionReason
						};

						DynamicFactory.get('ChatPartRsc', 'sendCleaningMessage')(message).then(
							function (data) {
								// $scope.emojiMessage.messagetext = 'Konsultant zakończył rozmowę';
								// jQuery('#messageDiv').html('Konsultant zakończył rozmowę');

								vm.communicatorService.setHistorySessionAsFinished(vm.templateData.sessionId);

								// DynamicFactory.get('messageSessionRsc', 'addMessageSessionTags')(vm.replyToMessage.sessionID, cleningActionReason.tags).then(
								// 	function (data) {
								// 		getMessageSessionInfo(vm.replyToMessage.sessionID);
								// 	},
								// 	function (err) {
								// 		console.log(err);
								// 	}
								// );

								// $timeout(function () {
								// 	vm.sendMesgAndGetData();
								// }, 200);

							},
							function (err) {
								console.log(err);
							}
						);
					},
					function (err) { }
				);
		}

		function getUrlExtension(url) {
			return url.split(/\#|\?/)[0].split('.').pop().trim().toLowerCase();
		}

		function sendUploadContent(results) {
			var blob = base64toBlob(results.dataURL, results.file.type);

			var file = new File([blob], results.file.name, {
				type: results.file.type,
			});
			vm.dropzoneCtrl.addFile(file);
		}

		function base64toBlob(dataURI, type) {

			var byteString = atob(dataURI.split(',')[1]);
			var ab = new ArrayBuffer(byteString.length);
			var ia = new Uint8Array(ab);

			for (var i = 0; i < byteString.length; i++) {
				ia[i] = byteString.charCodeAt(i);
			}
			return new Blob([ab], { type: type });
		}

		function saveMsgTags(tags) {
			DynamicFactory.get('messageSessionRsc', 'addMessageSessionTags')(vm.replyToMessage.sessionID, tags).then(
				function (data) {
					SessionTagsService.updateSessionTileTags(vm.replyToMessage.sessionID,tags)

				},
				function (err) {
					console.log(err);
				}
			);
		}

		function autoSaveTags(model){
			console.log('autoSaveTags: '+model);
			saveMsgTags(model);
		}
	}
})();

/**
 * Created by akraszewski on 2016-09-29.
 */

(function () {
  'use strict';

  angular.module('contactcenter.communicator').component('categoriesPart', {
    templateUrl: 'app/main/contactcenter/communicator/components/categoriespart/categoriespart.html',
    controllerAs: 'vm',
    bindings: {
      serviceId: '<',
      contactId: '<',
      sessionId: '<',
      sessionGuid: '<'
    },
    controller: controller
  });

  /** @ngInject */
  function controller(DynamicFactory, SessionManager, toastService, $translate, $timeout, $scope) {

    var vm = this;

    vm.$onChanges = onChanges;

    vm.$onInit = function () {
      vm.userSession = SessionManager.getUser();

      if (vm.sessionId) {
        getCategories(vm.sessionId, vm.serviceId);
      }


      // vm.categories = [
      //   {
      //     "id": 1,
      //     "title": "node1",
      //     "isActive": false,
      //     "nodes": [
      //       {
      //         "id": 11,
      //         "title": "node1.1",
      //         "isActive": false,
      //         "nodes": [
      //           {
      //             "id": 111,
      //             "title": "node1.1.1",
      //             "isActive": false,
      //             "nodes": []
      //           }
      //         ]
      //       },
      //       {
      //         "id": 12,
      //         "title": "node1.2",
      //         "isActive": false,
      //         "nodes": []
      //       }
      //     ]
      //   },
      //   {
      //     "id": 2,
      //     "title": "node2",
      //     "isActive": false,
      //     "nodes": [
      //       {
      //         "id": 21,
      //         "title": "node2.1",
      //         "isActive": false,
      //         "nodes": []
      //       },
      //       {
      //         "id": 22,
      //         "title": "node2.2",
      //         "isActive": false,
      //         "nodes": []
      //       }
      //     ]
      //   },
      //   {
      //     "id": 3,
      //     "title": "node3",
      //     "isActive": false,
      //     "nodes": [
      //       {
      //         "id": 31,
      //         "title": "node3.1",
      //         "isActive": false,
      //         "nodes": []
      //       }
      //     ]
      //   }
      // ];

      //getCategories();

      //vm.allwodFormFieldTypes = DynamicFactory.get('templatesRsc', 'getFieldTypes')();
    };

    vm.selectNode = function(node) {
      if (node.nodes && node.nodes.length > 0) {
        return;
      }
      console.log("SelectNode: ", node);
      if (node.isActive) {
        DynamicFactory.get('CategoriesRsc', 'delSessionCategory')(vm.sessionId, node.id).then(function (result) {
          node.isActive = !node.isActive;
          console.log('categories-del-ok:', result);
        }, function (err) {
          console.log('categories-del-error:', err);
        });
      }
      else {
        DynamicFactory.get('CategoriesRsc', 'addSessionCategory')(vm.sessionId, node.id, vm.sessionGuid, node.logicCategoryId).then(function (result) {
          node.isActive = !node.isActive;
          console.log('categories-add-ok:', result);
        }, function (err) {
          console.log('categories-add-error:', err);
        });
      }


    }

    function onChanges(changesObj) {
      console.log('categoriesPart changed!!! ', changesObj);


      if (vm.sessionId) {
        getCategories(vm.sessionId, vm.serviceId);
      }
    };

    function getCategories(sessionId, serviceId) {
      // if (vm.serviceId) {
      //   if(!vm.dataLoaded){
      //     vm.dataLoaded={}
      //   }
      //   vm.error=false;
        DynamicFactory.get('CategoriesRsc', 'getSessionCategories')(sessionId, serviceId).then(function (result) {
          vm.rollDown = false;
          vm.categories = result;

          console.log('categories-ok:', result);
        }, function (err) {
          console.log('categories-error:', err);
        });
      // }
    }

    function logCategory(category){
      console.log('c:', category);

    }

    // function surveyChanged(survey) {
    //   if (!survey.config) {
    //     survey.config = JSON.parse(survey.configJSON).config;
    //   }

    //   angular.forEach(survey.config, function (f) {
    //     var t = _.find(vm.allwodFormFieldTypes, function (e) {
    //       return e.name === f.type;
    //     });
    //     if (t) {
    //       f.templateKey = t.templateKey;
    //     }
    //   });


    //   vm.answers = {};
    //   loadContactAnswers(survey.config, survey.id);
    //   vm.activeSurvey = survey;
    // }

    // function findInConfig(surveyConfig, fieldId) {
    //   return _.find(surveyConfig, {
    //     fieldId: fieldId
    //   });
    // }


    // function saveAnswers() {
    //   DynamicFactory.get('surveyRsc', 'answerSurvey')(vm.activeSurvey.id, vm.serviceId, vm.contactId, prepareAnswers(vm.answers)).then(function (result) {
    //     toastService.showToast($translate.instant('COMMUNICATOR.SURVEY.NOTIFY_SURVEY_UPDATE_SUCCESS'), 'success', 4);
    //   }, function (err) {
    //     toastService.showToast($translate.instant('COMMUNICATOR.SURVEY.NOTIFY_SURVEY_UPDATE_ERROR'), 'error', 4);
    //   });
    //   // vm.activeSurvey = undefined;
    // }

    // function prepareAnswers(answers) {
    //   var result = [];
    //   for (var fieldId in answers) {
    //     result.push({
    //       fieldId: fieldId,
    //       fieldValue: answers[fieldId]
    //     });
    //   }
    //   return result;
    // }
  }


}());

/**
 * Created by noope on 29/06/2016.
 */
! function () {
  'use strict';

  angular
    .module('contactcenter.callsonline', [])
    .config(config);

  //   config.$inject = ['$stateProvider', '$translatePartialLoaderProvider'];
  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider,MenuItemsProvider) {

    var menuItems = MenuItemsProvider.initMenuItem('REPORTS').addMenuItem('REPORTS.REPORTSONLINE',{
      component:'option-folder',
      hide: true
      // hide:'SessionManager.getUserRole() === "consultant"'
    }).addMenuItem('REPORTS.REPORTSONLINE.CALLSONLINESTATS',{
      state: 'app.contactcenter_reports.callsonline',
      iconSrc: 'assets/icons/reports/monitoring_icon.svg',
      hide:'SessionManager.getUserRole() === "consultant"'
    });

    // {
    //   callsOnline: {
    //     name: 'REPORTSONLINE.CALLSONLINESTATS',
    //     state: 'app.contactcenter_callsonline.reportstats',
    //     icon: 'icon-account'
    //   }
    // };

    // .state('app.contactcenter_reports.callsonline', {
    //     parent: 'app',
    //     url: '/monitoring',
    //     params: {
    //       menu: menuItems,
    //       startState: 'REPORTSONLINE.CALLSONLINESTATS',
    //       keepSidenavData: true
    //     },
    //     views: {
    //       'content@app': {
    //         template: '<triple-view></triple-view>'
    //       },
    //       'sidenav@app.contactcenter_reports': {
    //         template: '<sidenav-content avatar-display="show" template-key="$root.state.params.templateKey"></sidenav-content>'
    //       }
    //     }
    //   })
    $stateProvider.state(menuItems.getMenuItem('REPORTS.REPORTSONLINE.CALLSONLINESTATS').state, {
    parent: 'app.contactcenter_reports',
    url: '/callsOnline',
    params: {
      templateKey: 'monitoring',
      defaultAvatar: 'assets/images/icons/polaczenia_online.png',
      doNotShowSidepanel: true
    },
    statePanelRight: true,
    stateTranslationName: 'REPORTSONLINE.CALLSONLINESTATS',
    views: {
      'mainContent': {
        template: '<calls-online flex></calls-online>'
      }
      // ,
      // 'sidenav@app.contactcenter_reports': {
      //   template: '<sidenav-content avatar-display="show" template-key="$root.state.params.templateKey"></sidenav-content>'
      // }
    }
  });
}
}();

(function () {
	'use strict';
	angular
		.module('contactcenter.callsonline')
		.component('callRow', {
			templateUrl: 'app/main/contactcenter/callsonline/components/callrow/callrow.html',
			controllerAs: 'vm',
			bindings: {
				call: '<',
				isCall: '@',
				isHistory: '@',
				last: '<',  // przerywa timer jesli rozmowa nie jest ostatnia
				// dsList: '=',
				// onlOnline: '=',
				first: '=',
				loaded: '=', // lista buforwanych serwisw i konsultantw pobrana przy klikaniu w wiersze managera, przekazywana przez referencj miedzy <call-row>
				playRowCallback: '='
			},
			controller: callsOnline
		});
	/** @ngInject */
	function callsOnline(DynamicFactory, onlineCalls, WebSocketManager, colors, wsstatus, $timeout, tripleviewService, $filter, $document, $q, $scope, consts) {
		var vm = this;

		//methods
		vm.checkStatus = checkStatus;
		vm.checkStatusDisconnected = checkStatusDisconnected;
		vm.clearFailedCall = clearFailedCall;
		vm.displayOnSidenav = displayOnSidenav;
		vm.formatNumber = formatNumber;
		vm.isWaiting = isWaiting;
		vm.playBridge = playBridge;
		vm.playEvasdropping = playEvasdropping;
		vm.stopPlaying = stopPlaying;
		vm.$onInit = onInit;
		vm.$onChanges = onChanges;

		function onInit() {
			//other
			vm.listOnline = [];
			vm.disconnectedList = [];
			if (!vm.loaded.consultants)
				vm.loaded.consultants = [];
			if (!vm.loaded.services)
				vm.loaded.services = [];
			vm.colorsList = colors.listColors;
			vm.momentDate = '';

			vm.consult = {};
			vm.prevObj;
			vm.wsstatus = wsstatus;
			vm.test = [];

			if (vm.isCall && vm.isHistory) {
				$scope.$broadcast('timer-stop');
				console.log('timer stop')
			}

		} //the end $onInit;

		function onChanges(changesObj) {

			if (changesObj.call) {
				if (vm.isCall) {
					vm.beginDate = moment(vm.call.startTimer).format('DD-MM-YYYY');
					vm.momentStartTimer = vm.call.startTimer;
					buildCallObj();
				} else {

					vm.momentStartTimer = moment(vm.call.start);

					buildBridgeObj(changesObj.call.currentValue);
					console.log(changesObj);
				}

			}


			if (changesObj.last && changesObj.last.currentValue === false) {
				$scope.$broadcast('timer-stop');
				console.log('timer stop 2')

			}


			vm.dataReady = true;
		}

		// function formatTimespan(fromDate, toDate) {
		//   var defference = Date.parse(toDate) - Date.parse(fromDate);
		//   if (defference > 0) {
		//     return formatNumber(defference)
		//   } else {
		//     return '00:00';
		//   }
		// }

		function buildCallObj() {
			if (vm.call) {
				vm.rowInfo = {
					callId: vm.call.callId,
					target: vm.call.ServiceName,
					targetId: vm.call.ccserviceId,
					start: moment(vm.call.start, moment.ISO_8601)
				};
				if (vm.call.ccserviceId) {
					getService(vm.call.ccserviceId).then(function (result) {
						vm.rowInfo.targetInfo = result;
						vm.rowInfo.target = result.serviceName;
					});
				}
				console.log('test',vm.rowInfo);
				// if (vm.call.callback) {
					getConsultant(vm.call.consultantId).then(function (result) {
						vm.consult = result;
						vm.rowInfo.target = '';
						vm.rowInfo.target += vm.rowInfo.firstName ? result.firstName : '';
						vm.rowInfo.target += result.lastName ? ' ' + result.lastName : '';
						if (!vm.rowInfo.target) {
							vm.rowInfo.target = 'brak informacji';
						}
					});
				// }

			}
		}


		function buildBridgeObj(bridge) {
      console.log('callRow |', bridge.status);
			if (bridge) {
				vm.rowInfo = {
					status: bridge.status,
					callId: bridge.BridgeID,
					target: bridge.consultantName,
					targetId: vm.rowInfo ? vm.rowInfo.targetId : undefined,
					start: moment(bridge.start, moment.ISO_8601)
				};
				if (bridge.consultantId && bridge.consultantId !== vm.rowInfo.targetId){
          console.log('callRow | get info about consultant=', bridge.consultantId);
					getConsultant(bridge.consultantId).then(function (result) {
            vm.consult = result;
            vm.rowInfo.targetId = bridge.consultantId;
						vm.rowInfo.target = '';
						vm.rowInfo.target += result.firstName ? result.firstName : '';
						vm.rowInfo.target += result.lastName ? ' ' + result.lastName : '';
						if (!vm.rowInfo.target) {
							vm.rowInfo.target = 'brak informacji';
						}
					});
				}
			}
		}

		function getLastStatus() {
			if (vm.call.history.length > 0) {
				return _.last(vm.call.history).status;
			}
			else {
				return null;
			}
		}

		function getService(serviceId) {
			return $q(function (resolve, reject) {
				var service = _.find(vm.loaded.services, {
					serviceID: serviceId
				});
				if (service) {
					resolve(service);
				} else {
					if (!serviceId) reject();
					DynamicFactory.get('servicesRsc', 'GetService')(serviceId, 'I')
						.then(function (result) {
							vm.loaded.services.push(angular.copy(result));
							resolve(result);
						}, function (err) {
							// console.log('błąd przy pobieraniu serwisu' + err);
							reject();
						});
				}
			});
		}

		function getConsultant(consultantId) {
			return $q(function (resolve, reject) {

				var consultant = _.find(vm.loaded.consultants, {
					consultantID: parseInt(consultantId)
				});
				if (consultant) {
					resolve(consultant);
				} else {
					DynamicFactory.get('ConsultantsRsc', 'getConsultant')(consultantId).then(function (result) {
						vm.loaded.consultants.push(angular.copy(result));
						resolve(result);
					}, function (err) {
						// console.log('błąd przy pobieraniu konsultanta' + err);
						reject();
					});
				}
			});
		}

		// function checkStatusCall(event, status) {
		//   event.stopPropagation();
		//   if (status === wsstatus.failed) {
		//     clearFailedCall();
		//   } else if (status === wsstatus.wait4drop) {
		//     // call.isEavesdropp = false;
		//     // vm.call.isEavesdropp = true;{{ vm.rowInfo }}
		//     vm.call.disabledButton = true;
		//     // startEavesdropp(vm.call.callId, status);
		//     // vm.call.isPlaying = true;
		//     getAudioURL(vm.call.callId).then(function (result) {
		//       vm.playRowCallback(vm.call, result);
		//       vm.call.disabledButton = false;
		//       vm.call.waitingForEavesdropping = false;
		//     });
		//   } else if (status === wsstatus.disconnected) {
		//     getAudioURL().then(function (result) {
		//       vm.playRowCallback(vm.call, result);
		//     });
		//     // if (call.fils) {
		//     // playRecording();
		//     // } else {
		//     // 	alert('brak nagrania');
		//     // }
		//   }
		// }


		function playBridge() {
			if (vm.call.isPlaying) {
				stopPlaying();
				vm.call.isPlaying = false;
			} else {
				getAudioURL().then(function (result) {
					vm.playRowCallback(vm.call, result);
					vm.call.isPlaying = true;
				});
			}
		}


		function stopPlaying() {
			vm.playRowCallback(vm.call);
		}

		function playEvasdropping() {
			if (vm.call.isPlaying) {
				stopPlaying();
				vm.call.isPlaying = false;
			} else {
				vm.call.disabledButton = true;
				getAudioURL(vm.call.callId).then(function (result) {
					vm.playRowCallback(vm.call, result);
					vm.call.disabledButton = false;
					vm.call.waitingForEavesdropping = false;
					vm.call.isPlaying = true;
				});
			}
		}

		function getAudioURL(callId) {
			return $q(function (resolve, reject) {
				if (callId) {
					vm.call.waitingForEavesdropping = true;
					DynamicFactory.get('onlineCalls', 'eavesdropp')(callId).then(function (r) {
						resolve(r.uri);
					}, function (err) {
						console.log(err);
						reject(err);
					});
				} else {
					resolve(consts.recordings + vm.rowInfo.callId);
				}
			});
		}


		function clearFailedCall() {
			vm.dataReady = false;
		}

		function checkStatusDisconnected(status) {
			return status === wsstatus.disconnected || status === wsstatus.failed;
		}

		function displayOnSidenav(targetInfo, first) {

			vm.test = targetInfo;
			targetInfo.selected = true;

			if (vm.prevObj) {
				vm.prevObj.selected = false;
			}
			vm.prevObj = targetInfo;
			tripleviewService.sidenavData = {};

			if (first) {
				tripleviewService.sidenavData.consultant = {};
				tripleviewService.sidenavData.premiumNumber = angular.copy(targetInfo.targetInfo);
				tripleviewService.sidenavData.subHeader = angular.copy(targetInfo.target);
			} else {
				var fName = vm.consult.firstName,
					lName = (vm.consult.lastName) ? vm.consult.lastName : '';
				tripleviewService.sidenavData.consultant = angular.copy(vm.consult);
				tripleviewService.sidenavData.premiumNumber = {};
				tripleviewService.sidenavData.subHeader = angular.copy(fName) + ' ' + angular.copy(lName);
			}
		}

		function checkStatus(h) {
			return !(h === wsstatus.ringing || h === wsstatus.waiting || h === wsstatus.queued || h === wsstatus.failed);
		}

		function isWaiting(h) {
			return (h === wsstatus.waiting);
		}


		function formatNumber(number) {
			var sec = Math.floor((number / 1000) % 60),
				min = Math.floor((number / (1000 * 60) % 60));

			if (sec < 10) {
				sec = '0' + sec;
			}
			if (min < 10) {
				min = '0' + min
			}

			// console.log(min, ':', sec);

			return min + ':' + sec;
		}
	}
})();

(function () {
  'use strict';

  /**
   * Main module of the Fuse
   */
  angular
    .module('taapp', [
      'app.core',
      'app.navigation',
      'app.toolbar',
      'consts',
      'ngStorage',
      'angular-toArrayFilter',
      'debounce',
      'ng-file-model',
      'ng-sortable',
      'md.data.table',
      'ngNotify',
      'ngImgCrop',
     // 'vAccordion',
      // 'mdPickers',
      'mdDateTimePicker',
      'nemLogging',
      'ui-leaflet',
      'uiCropper',
      'luegg.directives',
      // 'taLodashWrapper',
      'auth',
      'TA-WebSocket',
      'callInfoBar',
      'sessionManager',
      'contactcenter',
      'monospaced.elastic',
      'ngMaterialDatePicker',
      'ngLodash',
      'angularAudioRecorder',
      'angularFileUpload',
      'ngFileSaver',
      'ui.calendar',
      'ngAnimate',
      'datatables',
      'datatables.fixedcolumns',
      'vAccordion',
      'ng.deviceDetector',
      'ngScrollbars',
      'angular-md5',
      'g1b.datetime-range',
      'cwill747.phonenumber',
      'ngSanitize', 'emojiApp',
      'linkify',
      'angular-web-notification',
      'ui.tree'
      // 'g1b.scroll-events'
     // 'wu.masonry'//,
      // 'cl.paging'
    ]);
})();

(function () {
  'use strict';

  angular
    .module('taapp')
    .factory('adminConsultantsAPI', apiService);

  /** @ngInject */
  function apiService(consts, $http, SessionManager, $resource) {
    var params = {
      partnerId: '@_partnerId',
      callCenterId: '@callCenterId'
    };
    
    return $resource(consts.api + 'admin/consultant/', {}, {
      'list': {
        method: 'GET',
        params: params,
        url: consts.api + 'admin/consultant/list/:partnerId/:callCenterId'
      },
      'add': {
        method: 'POST',
        params: {},
        url: consts.api + 'admin/consultant/add'
      },
      'edit': {
        method: 'POST',
        params: {},
        url: consts.api + 'admin/consultant/edit'
      },
      'changeArchive':{
        method: 'POST',
        params: {},
        url: consts.api + 'admin/consultant/changeArchive'
      },
      'changeActiveConsultant':{
        method: 'POST',
        params: {},
        url: consts.api + 'admin/consultant/changeActiveConsultant'
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('contactcenter.party', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    $stateProvider.state('app.contactcenter_party', {
      url: '/party',
      params: {},
      hideTaHeader:true,
      views: {
        'content@app': {

          template: '<party></party>'
        }
      },
      resolve: {
      },
      bodyClass: 'party'
    })
    .state('app.contactcenter_party.room', {
      url: '/:room/:preview',
      params: {},
      hideTaHeader:true,
      views: {
        'content@app': {

          template: '<party-room></party-room>'
        }
      },
      resolve: {
      },
      bodyClass: 'party'
    })

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/contactcenter/party');

  }
})();

- function () {
  'use strict';
  angular
    .module('contactcenter.party')
    .component('partyRoomsList', {
      templateUrl: 'app/main/contactcenter/party/roomlist/roomlist.html',
      bindings: {},
      controllerAs: 'vm',
      controller: partyRoomsListCtrl
    });
  /** @ngInject */
  function partyRoomsListCtrl($state, DynamicFactory, headerConfig) {
    var vm = this; // jshint ignore:line

    vm.enterRoom = enterRoom;
    vm.$onInit = onInit;
    vm.headerConfig = headerConfig;

    function onInit() {
      DynamicFactory.get('PartyRsc', 'rooms')().then(function (result) {
        vm.roomsList = result;
        console.log('result roomsList:', result);
      });
    }

    function enterRoom(room) {
      room.checked = true;
      //app.contactcenter_dashboard.party
      $state.go('app.contactcenter_dashboard.partyroom', {
        room: room.id
      });
      // $state.go('app.contactcenter_party.room', {
      //   room: room.id
      // });
    }

  }
}();


(function () {
  'use strict';
  angular
    .module('contactcenter.party')
    .component('partyRoom', {
      templateUrl: 'app/main/contactcenter/party/room/room.html',
      controllerAs: 'vm',
      controller: PartyRoomController
    });

  /** @ngInject */
  function PartyRoomController($scope, $rootScope, $document, $mdDialog, $mdMedia, $mdSidenav, DynamicFactory, $q, $localStorage, $translate, $filter, $interval, SessionManager, $state, WebSocketManager, $timeout, partyService, toastService) {
    var vm = this;

    vm.$onInit = onInit;
    vm.$onDestroy = onDestroy;
    vm.getOnlineList = getOnlineList;
    vm.inLoading = false;
    vm.loginToRoom = loginToRoom;
    vm.closeNotif = closeNotif;
    vm.setConsultantPhone = setConsultantPhone;
    /**
     * Initialize
     */
    function onInit() {
      vm.titleConsultants = $translate.instant('ROOM.CONSULTANTS.TITLE');
      vm.titleClients = $translate.instant('ROOM.CLIENTS.TITLE');
      vm.isUserLogin = false;
      //dzwonienie zalezne od listy(!)
      // if (!$state.params.preview) {
      //   vm.loginToRoom();
      // }
      // getOnlineList();

      angular.element(document).ready(function () {
        vm.intervalLoad = $interval(function () { getOnlineList(); }, 1000);
      });
      WebSocketManager.registerWebSocketMethod('CallParty', 'partyArrive', wsRoomCalls);
    }
    function wsRoomCalls(data) {
      var data = JSON.parse(data.Content);
      if (data.method && vm.notif) {
        if (vm.notif.method === data.method) {
          vm.notif.icon = 'ok';
          switch (vm.notif.method) {
            case 'send':
              vm.notif.text = 'Nagranie zakończono pomyślnie';
              break;

            default:
              vm.notif.text = 'Zakończono pomyślnie';
              break;
          }

          $timeout(function () {
            vm.closeNotif();
          }, 1000);
        }
      }
      else if (data.method) {
        switch (data.method) {
          case 'connected':
            setConsultantPhone(data.param);
            break;
          case 'disconnected':
            disconnectedConsultant();
            break;
          case 'failed':
            toastService.showToast($translate.instant('ROOM.FAILED_CONNECT'), 'error', 4);
            break;
          default:
            break;
        }
      }
    }
    function closeNotif() {
      vm.notif = undefined;
    }
    function setConsultantPhone(param) {
      $localStorage.dtNumber = param;
      $localStorage.partyRoomID = $state.params.room;
      DynamicFactory.get('AuthResource', 'setPhoneDt')({ phone: param }).then(function (result) {

      });
    }
    function disconnectedConsultant() {
      $localStorage.partyRoomID = '';
      $localStorage.dtNumber = '';
      DynamicFactory.get('AuthResource', 'setPhoneDt')({ phone: 'freetdm/2/a/' + $localStorage.hostNumber }).then(function (result) {
        
      });
    }
    function loginToRoom() {
      partyService.loginToRoom($state.params.room);
    }
    function onDestroy() {
      $interval.cancel(vm.intervalLoad);
    };
    function getOnlineList() {
      if (!vm.inLoading) {
        vm.inLoading = true;
        DynamicFactory.get('PartyRsc', 'getOnline')({ partyRoomID: $state.params.room })
          .then(function (result) {
            vm.online = result;
            vm.consultants = $filter('filter')(vm.online, { type: 1 });
            vm.clients = $filter('filter')(vm.online, { type: 2 });
            vm.externalCalls = $filter('filter')(vm.online, { type: 3 });
            vm.user = SessionManager.getUser();
            var query = $filter('filter')(vm.consultants, { externalUserID: vm.user.userId });
            if (query != null && query.length > 0) {
              vm.isUserLogin = true;
            }
            else {
              vm.isUserLogin = false;
            }
            vm.inLoading = false;
            // console.log('vm.client: ',vm.clients);
          }, function (err) {
            vm.inLoading = false;
          });
      }
    }
  }
})();


(function () {
  'use strict';
  angular
    .module('contactcenter.party')
    .component('consultantsRoom', {
      templateUrl: 'app/main/contactcenter/party/consultants/consultants.html',
      controllerAs: 'vm',
      controller: ConsultantsRoom
    });

  /** @ngInject */
  function ConsultantsRoom($scope, $rootScope, $document, $mdDialog, $mdMedia, $mdSidenav, DynamicFactory, $q, $localStorage, $interval) {
    var vm = this;


    init();


    /**
     * Initialize
     */
    function init() {
      //$interval(function () { consultantsList(); }, 1000);
       consultantsList();
    }
    function consultantsList() {
      // vm.consultants = [];
      DynamicFactory.get('PartyRsc', 'getConsultants')()
        .then(function (result) {
          vm.consultants = result;
        }, function (err) {

        });
    }
  }
})();


(function () {
  'use strict';
  angular
    .module('contactcenter.party')
    .component('callsRoom', {
      templateUrl: 'app/main/contactcenter/party/calls/calls.html',
      controllerAs: 'vm',
      bindings: {
        calls: '=',
        clients: '=',
        externalCalls: '=',
        titleHeader: '=',
        type: '=',
        loginfn: '=',
        isuserlogin: '=',
        notif: '=',
        closeNotif: '='
      },
      controller: CallsRoom
    });

  /** @ngInject */
  function CallsRoom($scope, $rootScope, $document, $mdDialog, $mdMedia, $mdSidenav, DynamicFactory, $q, $localStorage, $interval, $state, $filter, SessionManager, authRolesConst, partyService) {
    var vm = this;


    vm.$onInit = onInit;
    vm.logOut = logOut;
    /**
     * Initialize
     */
    function onInit() {
      vm.msgList = [];
      vm.hoverList = [];
      vm.isLogin = false;
      //$interval(function () { consultantsList(); }, 1000);

      if (SessionManager.getUserRoleId() === authRolesConst.manager) {
        vm.isManager = true;
      } else {
        vm.isManager = false;
      }
    }
    function logOut() {                
      var user = SessionManager.getUser();
      partyService.logOut(user, false);
    }
  }
})();


(function () {
  'use strict';
  angular
    .module('contactcenter.party')
    .component('callDetails', {
      templateUrl: 'app/main/contactcenter/party/calldetails/calldetails.html',
      controllerAs: 'vm',
      bindings: {
        call: '=',
        clients: '=',
        externalCalls: '=',
        index: '=',
        msglist: '=',
        loginfn: '=',
        notif: '=',
        closeNotif: '=',
        hoverlist: '='
      },
      controller: CallDetails
    });

  /** @ngInject */
  function CallDetails($scope, $rootScope, $document, $mdDialog, $mdMedia, $mdSidenav, DynamicFactory, $q, $localStorage, $interval, $filter, SessionManager, $state, authRolesConst) {
    var vm = this;


    vm.$onInit = onInit;
    vm.sendMsg = sendMsg;
    vm.playMsg = playMsg;
    vm.replayMsg = replayMsg;
    vm.playName = playName;
    vm.msgListShow = msgListShow;
    vm.loginToRoom = loginToRoom;
    vm.showClientPopup = showClientPopup;
    vm.eavesdropp = eavesdropp;
    vm.stopEavesdropp = stopEavesdropp;
    /**
     * Initialize
     */
    function onInit() {
      vm.audio = new Audio();
      vm.user = SessionManager.getUser();
      vm.consultantId = vm.user.consultantId;
      vm.isConnectedWithExternal = false;
      if (vm.call && vm.call.connectedUUID && vm.externalCalls) {
        var query = $filter('filter')(vm.externalCalls, { uuid: vm.call.connectedUUID, type: 3 });
        if (query != null && query.length > 0) {
          vm.isConnectedWithExternal = true;
        }
      }
      if (SessionManager.getUserRoleId() === authRolesConst.manager) {
        vm.isManager = true;
      } else {
        vm.isManager = false;
      }
    }
    function showClientPopup() {
      if (!SessionManager.isConsultant()) {
        return;
      } else {
        vm.currentCall = vm.call;
        vm.currentCall.sendMsg = sendMsg;
        vm.currentCall.playName = playName;
        //vm.notif = { text: 'test2', method: 'send', icon: 'send' };
        DynamicFactory.get('templatesRsc', 'GetTemplate')('client-info')
          .then(function (template) {
            $mdDialog.show({
              controller: ClientInfoDialogController,
              locals: {
                currentCall: vm.currentCall
              },
              controllerAs: 'vm',
              template: template,
              bindToController: true,
              parent: angular.element(document.body)//,
              //targetEvent: ev
            }).then(function (data) {
              //vm.notif = { text: 'test', method: 'send', icon: 'send' };
            },
              function (err) {
              }
              );
          });
      }
    }
    function sendMsg(obj) {
      vm.notif = { text: 'Trwa nagranie wiadomości', method: 'send', icon: 'send' };
      // if (obj) {
      //   obj.isRecord = true;
      // }
      DynamicFactory.get('PartyRsc', 'sendMsg')({ clientUUID: vm.call.uuid, externalUserID: vm.user.userId, partyRoomID: $state.params.room })
        .then(function (result) {
          //$mdDialog.hide();
        }, function (err) {

        });
    }
    function playMsg(msg) {
      vm.notif = { text: 'Odtwarzanie wiadomości', method: 'play', icon: 'playmsg' };
      DynamicFactory.get('PartyRsc', 'playMsg')({ msgGuid: msg.guid, externalUserID: vm.user.userId, partyRoomID: $state.params.room })
        .then(function (result) {
        }, function (err) {

        });
    }
    function replayMsg(msg) {
      vm.notif = { text: 'Trwa nagranie wiadomości', method: 'send', icon: 'send' };
      DynamicFactory.get('PartyRsc', 'sendMsg')({ clientUUID: msg.recordingCall.uuid, externalUserID: vm.user.userId, replayMessage: msg.guid, partyRoomID: $state.params.room })
        .then(function (result) {
        }, function (err) {

        });
    }
    function playName() {
      vm.notif = { text: 'Odtwarzanie imienia', method: 'playname', icon: 'playmsg' };
      DynamicFactory.get('PartyRsc', 'playName')({ UUID: vm.call.uuid, externalUserID: vm.user.userId, partyRoomID: $state.params.room })
        .then(function (result) {
          // $mdDialog.hide();
        }, function (err) {

        });
    }
    function msgListShow() {
      if (vm.user.userId === vm.call.externalUserID) {
        if (vm.msglist[vm.call.uuid]) {
          vm.msglist[vm.call.uuid] = !vm.msglist[vm.call.uuid];
        }
        else {
          vm.msglist[vm.call.uuid] = true;
        }
      }
    }
    function eavesdropp() {
      vm.notif = { text: 'Trwa nasłuch rozmowy', method: 'eavesdropp', icon: 'playmsg', callback: vm.stopEavesdropp };
      DynamicFactory.get('PartyRsc', 'startEavesdropp')(vm.call.uuid)
        .then(function (result) {
          vm.audio.src = result.uri;
          vm.audio.play();
        }, function (err) {
          vm.notif.text = 'Wystąpił problem z nasłuchem';
        });
    }
    function stopEavesdropp() {
      vm.closeNotif();
      vm.audio.pause();
      vm.audio.src = '';
    }
    function loginToRoom() {
      vm.loginfn();
    }


    /** @ngInject */
    function ClientInfoDialogController($scope, $mdDialog) {

    }
  }
})();

(function () {
  'use strict';

  angular
    .module('contactcenter.reports')
    .service('ReportTools', Service);

  /** @ngInject */
  function Service(SessionManager, authRolesConst, DynamicFactory, tripleviewService, $q, chooseDateTime) {
    var _this = this;
    _this.getConsultantList = getConsultantList;
    _this.formatSecs = formatSecs;

    _this.configReportParams = configReportParams;

    function configReportParams(config, currentParams) {
      // if (!tripleviewService.sidenavData.config) {
      //   tripleviewService.sidenavData.config = {};
      // }
      // tripleviewService.sidenavData.listDate = chooseDateTime.listDate;
      // tripleviewService.sidenavData.params = {};
      // tripleviewService.sidenavData.listDate = chooseDateTime.listDate;

      tripleviewService.sidenavData.config = config;
      tripleviewService.sidenavData.config.From = true;
      tripleviewService.sidenavData.config.To = true;
      setDate();
      return function (customParams) {
        var result = currentParams ? currentParams() : {};

        for (var key in tripleviewService.sidenavData.config) {
          if (tripleviewService.sidenavData.config[key]) {
            result[key] = tripleviewService.sidenavData.params[key] || undefined;
          }
        }
        if (customParams)
          return _.merge(result, customParams);
        else
          return result;
      };
    }

    function setDate(){
      if(!tripleviewService.sidenavData.params.From){
        tripleviewService.sidenavData.params.From = tripleviewService.sidenavData.listDate[0].date.from;
        tripleviewService.sidenavData.params.To = tripleviewService.sidenavData.listDate[0].date.to;
      }
    }

    _this.addZero = function (number) {
      return number <= 9 ? '0' + number : number.toString();
    };

    _this.dateInBetween = function (currentType, sideNavData) {
      var dateArray = [];
      var dateBetween = null;

      switch (currentType) {
        case 'HH':
          dateArray = _.range(24).map(function (item) {
            if (item < 10) {
              return '0' + item;
            } else {
              return item.toString();
            }
          });
          break;
        case 'd':
          dateArray = _.range(8);
          break;
        case 'DD-MM-YYYY':
          dateBetween = moment.twix(moment(sideNavData.From).local(), moment(sideNavData.To).local()).iterate('days'); //daty!!!
          break;
          case 'DD/MM':
          dateBetween = moment.twix(moment(sideNavData.From).local(), moment(sideNavData.To).local()).iterate('days'); //daty!!!
          break;
        case 'MM-YYYY':
          dateBetween = moment.twix(sideNavData.From, sideNavData.To).iterate('month'); //daty!!!
          break;
      }
      if (dateBetween) {
        while (dateBetween.hasNext()) {
          dateArray.push(moment(dateBetween.next().toDate()).format(currentType));
        }
      }
      return dateArray;
    };

    function formatSecs(delta) {
      // calculate (and subtract) whole minutes
      var minutes = Math.floor(delta / 60);
      delta -= minutes * 60;

      // what's left is seconds
      var seconds = Math.floor(delta % 60); // in theory the modulus is not required
      return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
    }


    function getCallcenterPerManager() {
      var defer = $q.defer();

      if (SessionManager.getUserRoleId() === authRolesConst.manager || SessionManager.getUserRoleId() === authRolesConst.admin) {
        DynamicFactory.get('reportsCosult', 'CallCenterList')().then(function (r) {
          _this.callCenterList = r;
        });
      }
      generateConsultantPerContactCenter().then(defer.resolve, defer.reject);
      return defer.promise;
    }



    function getConsultantList(refresh) {
      var defer = $q.defer();
      if (_this.consultantList && !refresh) {
        defer.resolve(_this.consultantList);
      } else {
        if (_this.lastPromise && !refresh) {
          $q.all([_this.lastPromise]).then(function (result) {
            defer.resolve(_this.consultantList);
          });
        } else {
          _this.lastPromise = getCallcenterPerManager();

          $q.all([_this.lastPromise]).then(function (data) {
            _this.consultantList = data[0];
            defer.resolve(_this.consultantList);
          });
        }
      }
      return defer.promise;
    }


    function generateConsultantPerContactCenter() {
      var defer = $q.defer();
      tripleviewService.sidenavData.consultantsPerCC = [];
      var callcenterId;
      if (SessionManager.getUserRoleId() === authRolesConst.admin) {
        callcenterId = tripleviewService.sidenavData.id ? tripleviewService.sidenavData.id : null;
      } else {
        callcenterId = SessionManager.getUser().callCenterId;
      }
      if (SessionManager.getUserRoleId() !== authRolesConst.consultant) {
        DynamicFactory.get('reportsCosult', 'ConsultansGet')(callcenterId).then(function (r) {
          tripleviewService.sidenavData.consultantsPerCC = r;
          _this.consultantList = r;
          defer.resolve(r);
        }, defer.reject);
      }
      return defer.promise;
    }

    return _this;
  }
})();

(function() {
    'use strict';

    angular
        .module('app', [])
        .factory('PagerService', PagerService);


        function PagerService() {
            var service = {};
    
            service.GetPager = GetPager;
    
            return service;
    
            function GetPager(totalItems, currentPage, pageSize) {
                currentPage = currentPage || 1;
                pageSize = pageSize || 10;
    
                var totalPages = Math.ceil(totalItems / pageSize);
    
                var startPage, endPage;
                if (totalPages <= 10) {
                    startPage = 1;
                    endPage = totalPages;
                } else {
                    if (currentPage <= 6) {
                        startPage = 1;
                        endPage = 10;
                    } else if (currentPage + 4 >= totalPages) {
                        startPage = totalPages - 9;
                        endPage = totalPages;
                    } else {
                        startPage = currentPage - 5;
                        endPage = currentPage + 4;
                    }
                }
    
                // calculate start and end item indexes
                var startIndex = (currentPage - 1) * pageSize;
                var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);
    
                // create an array of pages to ng-repeat in the pager control
                var pages = _.range(startPage, endPage + 1);
    
                // return object with all pager properties required by the view
                return {
                    totalItems: totalItems,
                    currentPage: currentPage,
                    pageSize: pageSize,
                    totalPages: totalPages,
                    startPage: startPage,
                    endPage: endPage,
                    startIndex: startIndex,
                    endIndex: endIndex,
                    pages: pages
                };
            }
        }
})();
(function () {
    'use strict';

    angular
        .module('contactcenter.reports')
        .factory('donutChart', ['$translate', donutChart]);

    function donutChart($translate) {
        var _this = this;

        _this.colors = [
            { color: "#f36c60" },
            { color: "#f06292" },
            { color: "#ba68c8" },
            { color: "#7986cb" },
            { color: "#91a7ff" },
            { color: "#03a9f4" },
            { color: "#009688" },
            { color: "#12c700" },
            { color: "#aeea00" },
            { color: "#ffd54f" },
            { color: "#ff8f00" },
            { color: "#ff7043" },
            { color: "#8d6e63" },
            { color: "#bdbdbd" },
            { color: "#80cbc4" },
            { color: "#c6ff00" },
            { color: "#ffe0b2" },
            { color: "#8d6e63" },
            { color: "#ffff00" },
            { color: "#ff80ab" }
        ];

        _this.donutChart = {
            options: {
                chart: {
                    type: 'pieChart',
                    height: 300,
                    donut: true,
                    x: function (d) {
                        return d.key;
                    },
                    y: function (d) {
                        return d.y;
                    },
                    showLabels: true,
                    showLegend: false,
                    noData: $translate.instant('REPORTS.NO_DATA'),
                    pie: {
                        dispatch: {},
                        arcsRadius: [],
                        width: 500,
                        height: 500,
                        showLabels: true,
                        title: false,
                        titleOffset: 0,
                        labelThreshold: 0.02,
                        id: 4619,
                        endAngle: false,
                        startAngle: false,
                        padAngle: false,
                        cornerRadius: 0,
                        donutRatio: 0.5,
                        labelsOutside: false,
                        labelSunbeamLayout: false,
                        donut: false,
                        growOnHover: true,
                        pieLabelsOutside: false,
                        donutLabelsOutside: false,
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        labelType: "percent" //key
                    },
                    transitionDuration: 100,
                    legend: {
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: 5,
                            left: 0
                        }
                    },
                    // maxKeyLength: 3
                }
            },

            data: []

        };
        return _this;
    }
})();

(function () {
	'use strict';

	angular
		.module('contactcenter.reports')
		.factory('chooseDateTime', chooseDateTime)

	/** @ngInject */
	function chooseDateTime() {
		var _this = this;


		_this.listDate = [
			{
				name: 'Bieżacy miesiąc',
				date: {
					id: 0,
					from: moment().startOf('month'),
					to: moment().endOf('day'),
					disabled: true
				}
			}, {
				name: 'Poprzedni miesiąc',
				date: {
					id: 1,
					from: moment().subtract(1, 'months').startOf('month').utc(),
					to: moment().subtract(1, 'months').endOf('month').utc(),
					disabled: true
				}
			}, {
				name: 'Ostatnie 3 miesiące',
				date: {
					id: 2,
					from: moment().subtract(3, 'months').startOf('day').utc(),
					to: moment().endOf('day').utc(),
					disabled: true
				}
			}, {
				name: 'Ostatnie pół roku',
				date: {
					id: 3,
					from: moment().subtract(6, 'months').startOf('day').utc(),
					to: moment().endOf('day').utc(),
					disabled: true
				}
			}, {
				name: 'Bieżący tydzień',
				date: {
					id: 4,
					from: moment().startOf('week').add('d', 1).startOf('day').utc(),
					to: moment().endOf('day').utc(),
					disabled: true
				}
			}, {
				name: 'Ostatnie 3 tygodnie',
				date: {
					id: 5,
					from:moment().subtract(3, 'week').startOf('day').utc(),
					to: moment().endOf('day').utc(),
					disabled: true
				}
			}, {
				name: 'Dziś',
				date: {
					id: 6,
					from: moment().startOf('day').utc(),
					to: moment().endOf('day').utc(),
					disabled: true
				}
			}, {
				name: 'Wczoraj',
				date: {
					id: 7,
					from: moment().subtract(1, 'days').startOf('day').utc(),
					to: moment().subtract(1, 'days').endOf('day').utc(),
					disabled: true
				}
			}, {
				name: 'Ostatnie 3 dni',
				date: {
					id: 8,
					from: moment().subtract(3, 'days').startOf('day').utc(),
					to: moment().endOf('day').utc(),
					disabled: true
				}
			}, {
				name: 'Dowolna data',
				date: {
					id: 9,
					from: '',
					to: '',
					disabled: false
				}
			}
		];
		return _this;
	}
})();

(function () {
  'use strict';
  angular
    .module('contactcenter.reports')
    .factory('ReportsData', ['$translate', ReportsData]);

  function ReportsData($translate) {
    var _this = this;

    // _this.colors = [
    //   { color: "#03a9f4", },
    //   { color: "#009688", },
    //   { color: "#12c700", },
    //   { color: "#aeea00", },
    //   { color: "#c6ff00", },
    //   { color: "#ffff00", },
    //   { color: "#ffd54f", },
    //   { color: "#ffe0b2", },
    //   { color: "#bdbdbd", },
    //   { color: "#80cbc4", },
    //   { color: "#7986cb", },
    //   { color: "#8d6e63", },
    //   { color: "#ba68c8", },
    //   { color: "#ff80ab", },
    //   { color: "#f06292", },
    //   { color: "#db8073", },
    //   { color: "#f36c60", },
    //   { color: "#ff7043", },
    //   { color: "#ff8f00", },
    //   { color: "#91a7ff" },
    // ]
    _this.colors = [
      {color: '#2ca02c'},
      {color: '#ffbb78'},
    {
      color: '#ff7f0e'
    },
    {
      color: '#aec7e8'
    },
    {
      color: '#1f77b4'
      },
       {
        color: "#ebaca2"
      }, {
        color: "#dbb680"
      }, {
        color: "#ce9b61"
      }, {
        color: "#b27737"
      }, {
        color: "#9d3c27"
      }, {
        color: "#763713"
      }, {
        color: "#906712"
      }, {
        color: "#595c4e"
      }, {
        color: "#86996e"
      }, {
        color: "#b9c866"
      }, {
        color: "#668e98"
      }, {
        color: "#00602f"
      }, {
        color: "#2f5b49"
      }, {
        color: "#107f87"
      }, {
        color: "#1e3a5f"
      }, {
        color: "#667a8c"
      }, {
        color: "#000049"
      }, {
        color: "#a06492"
      }, {
        color: "#ce94ba"
      }, {
        color: "#bb0061"
      }, {
        color: "#a1354f"
      }, {
        color: "#cb4e61"
      }, {
        color: "#ff555b"
      }, {
        color: "#d62b5b"
      }, {
        color: "#ff738c"
      }, {
        color: "#f3dae4"
      }, {
        color: "#ffd3d4"
      }, {
        color: "#ffc7b0"
      }, {
        color: "#edac7b"
      }, {
        color: "#ffa449"
      }, {
        color: "#ff7518"
      }, {
        color: "#b85958"
      }
    ];

    _this.donutChartColors = [
      { color: "#f36c60" },
      { color: "#f06292" },
      { color: "#ba68c8" },
      { color: "#7986cb" },
      { color: "#91a7ff" },
      { color: "#03a9f4" },
      { color: "#009688" },
      { color: "#12c700" },
      { color: "#aeea00" },
      { color: "#ffd54f" },
      { color: "#ff8f00" },
      { color: "#ff7043" },
      { color: "#8d6e63" },
      { color: "#bdbdbd" },
      { color: "#80cbc4" },
      { color: "#c6ff00" },
      { color: "#ffe0b2" },
      { color: "#8d6e63" },
      { color: "#ffff00" },
      { color: "#ff80ab" }
  ];

    _this.getNextColor = function () {
      if (_this.colorCount == undefined || _this.colors.length <= _this.colorCount + 1) {
        _this.colorCount = -1;
      }
      _this.colorCount = _this.colorCount + 1
      return _this.colors[_this.colorCount].color;
    };

    _this.getColorShade = function (color, shade) {
      if (shade) {
        shade = 100 - Math.round(shade);
        var useHash = false;
        if (color[0] == "#") {
          color = color.slice(1);
          useHash = true;
        }

        var num = parseInt(color, 16);
        var r = (num >> 16) + shade;

        if (r > 255) r = 255;
        else if (r < 0) r = 0;

        var b = ((num >> 8) & 0x00FF) + shade;

        if (b > 255) b = 255;
        else if (b < 0) b = 0;

        var g = (num & 0x0000FF) + shade;

        if (g > 255) g = 255;
        else if (g < 0) g = 0;
        return (useHash ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
      } else {
        return '#a0a0a0';
      }
    };

    _this.resetNextColor = function () {
      _this.colorCount = -1;
    };

    _this.dateType = [
      // { key: 'MI', text: $translate.instant('REPORTS.MINUTES') },
      {
        key: 'MM-YYYY',
        value: 'M',
        text: $translate.instant('REPORTS.MOUTHLY')
      },
      {
        key: 'DD-MM-YYYY',
        value: 'D',
        text: $translate.instant('REPORTS.DAILY')
      },
      {
        key: 'HH',
        value: 'H',
        text: $translate.instant('REPORTS.HOURS')
      }
      // { key: 'd', text: $translate.instant('REPORTS.WEEK') },
    ];

    _this.defaultChartConf = {
      config: {
        refreshDataOnly: true,
        deepWatchData: true
      },
      options: {
        chart: {
          // type: 'discreteBarChart', //multiBarChart
          type: 'multiBarChart',
          height: 250,
          width: 50,
          margin: {
            top: 8,
            right: 16,
            bottom: 50,
            left: 48
          },
          clipEdge: true,
          groupSpacing: 0.5,
          reduceXTicks: false,
          stacked: true,
          duration: 250,
          showLegend: true,
          // useInteractiveGuideline: true,
          noData: $translate.instant('REPORTS.NO_DATA'),
          x: function (d) {
            return d.x;
          },
          y: function (d) {
            return d.y;
          },
          legend: {
            margin: {
              top: 1,
              bottom: 32
            }
          },
          showValues: true,
          showControls: false,
          controls: {
            labels: {
              grouped: 'Grupuj',
              stacked: 'Sterta'
            },
            margin: {
              top: 1,
              bottom: 32
            }
          },
          tooltip: {
            gravity: 's',
            classes: 'gravity-s'
          }
        }
      },
      data: []
    };

    _this.defaultDonutChartConf = {
      options: {
          chart: {
              type: 'pieChart',
              height: 300,
              donut: true,
              x: function (d) {
                  return d.key;
              },
              y: function (d) {
                  return d.y;
              },
              showLabels: true,
              showLegend: false,
              noData: $translate.instant('REPORTS.NO_DATA'),
              pie: {
                  dispatch: {},
                  arcsRadius: [],
                  width: 500,
                  height: 500,
                  showLabels: true,
                  title: false,
                  titleOffset: 0,
                  labelThreshold: 0.02,
                  id: 4619,
                  endAngle: false,
                  startAngle: false,
                  padAngle: false,
                  cornerRadius: 0,
                  donutRatio: 0.5,
                  labelsOutside: false,
                  labelSunbeamLayout: false,
                  donut: false,
                  growOnHover: true,
                  pieLabelsOutside: false,
                  donutLabelsOutside: false,
                  margin: {
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 0
                  },
                  labelType: "percent" //key
              },
              transitionDuration: 100,
              legend: {
                  margin: {
                      top: 0,
                      right: 0,
                      bottom: 5,
                      left: 0
                  }
              },
              // maxKeyLength: 3
          }
      },

      data: []
    };

    _this.dayName = [
      '',
      $translate.instant('REPORTS.DAY.MONDAY'),
      $translate.instant('REPORTS.DAY.TUESDAY'),
      $translate.instant('REPORTS.DAY.WEDNESDAY'),
      $translate.instant('REPORTS.DAY.THURSDAY'),
      $translate.instant('REPORTS.DAY.FRIDAY'),
      $translate.instant('REPORTS.DAY.SATURDAY'),
      $translate.instant('REPORTS.DAY.SUNDAY')
    ];
    return _this;
  }
})();

// https://angulartutorial.blogspot.com/2014/03/rating-stars-in-angular-js-using.html

(function() {
    'use strict';

    angular
      .module('starRating', [])
      .directive('starRating', starRating);

    function starRating() {
      return {
        restrict: 'EA',
        templateUrl :'app/main/contactcenter/directives/starrating/starrating.html',
        scope: {
          ratingValue: '=ngModel',
          max: '=?', // optional (default is 5)
          onRatingSelect: '&?',
          readonly: '=?'
        },
        link: function(scope, element, attributes) {
          if (scope.max == undefined) {
            scope.max = 5;
          }
          updateStars();
          function updateStars() {
            scope.stars = [];
            for (var i = 0; i < scope.max; i++) {
              var newStar = {
                filled: i+1 <= scope.ratingValue,
                // half: i+1.25 <= scope.ratingValue,
                hover: i+1 < scope.hoverValue
              };
              if(!newStar.filled && (i==0 ||scope.stars[i-1].filled)){
                newStar.half =  i+ 0.25 <=scope.ratingValue && scope.ratingValue < i+1;
              }
              scope.stars.push(newStar);
            }
          };
          scope.hoverSelection =  function(index) {
            if (scope.readonly == undefined || scope.readonly === false){
                if(index != -1){
                    scope.hoverValue = index + 1;
                }else{
                    scope.hoverValue = 0;
                }
            }
          };
          scope.toggle = function(ev,index) {
            if (scope.readonly == undefined || scope.readonly === false){
              scope.ratingValue = index + 1;
              ev.stopPropagation();
              scope.onRatingSelect({
                rating: index + 1
              });
            }
          };
          scope.$watch('ratingValue', function(oldValue, newValue) {
            if (newValue || newValue === 0) {
              updateStars();
            }
          });
          scope.$watch('hoverValue', function(oldValue, newValue) {
            if (newValue || newValue === 0) {
              updateStars();
            }
          });
        }
      };
    }
  })();

angular.module('renderLoader', [])
.directive('renderLoader', function ($timeout) {    
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            if (scope.$last === true) {
                
                $timeout(function () {
                    scope.$emit(attr.renderLoader);
                });
            }
        }
    }
});
/**
 * Created by kosski on 08.09.2016.
 */
+function () {
  'use strict';
  angular.module('filterbox', []).directive('filterbox', function () {
    return {
      restrict: 'E',
      replace: true,
      templateUrl : 'app/main/contactcenter/directives/filterbox/filterbox.html',
      scope: {
        filterValue: '=',
        removeFilter:'&'
      }
    };
  })
}();

(function () {
  'use strict';
  angular
    .module('contactcenter.orderbox')
    .service('MaillistFilters', MaillistFilters);


  /** @ngInject */
  function MaillistFilters($translate, SessionManager, authRolesConst, DynamicFactory, $q) {
    var _this = this;
    _this.searchString = "";
    _this.filtersArray = [];
    _this.sortParams = ['creationTime','minutes', 'minutesleft', 'buyerName'];
    _this.sortMailParams = ['date','from.name','to','subject'];
    _this.currentSortMailParams={column: "date",descending: true};// ustawiamy domyślne wartości
    _this.durationParams = [{
      // From: 0,
      To: 5
    }, {
      From: 5,
      To: 10
    }, {
      From: 10,
      To: 15
    }, {
      From: 15,
      To: 20
    }, {
      From: 20,
      To: 30
    }, {
      From: 30,
      To: 40
    }, {
      From: 40,
      To: 60
    }, {
      From: 60
      // ,
      // To:1000000
    }];

    _this.filterMailTypes = [
      {
        token: 'MAIL.MAIL_LIST.SORT',
        templateKey: 'ta-sort',
        prop: 'sort',
        filterPattern: formatSortPattern,
        filterIcon: 'icon-sort',
        querryType: 'sort',
        source: prepareSortValues(_this.sortMailParams),
        formatData: formatSortQuerry,
        objValue: true,
        hide: true
      }];

    _this.filterTypes = [
      {
        token: 'MAIL.MAIL_LIST.SORT',
        templateKey: 'ta-sort',
        prop: 'sort',
        filterPattern: formatSortPattern,
        filterIcon: 'icon-sort',
        querryType: 'sort',
        source: prepareSortValues(_this.sortParams),
        formatData: formatSortQuerry,
        objValue: true,
        hide: true

      }, {
        token: 'MAIL.MAIL_LIST.DATE_BETWEEN',
        templateKey: 'ta-between',
        prop: 'creationTime',
        // filterPattern: '%From - %To',
        filterPattern: formatDatePattern,
        filterIcon: 'icon-calendar-clock',
        querryType: 'between',
        formatData: formatDateQuerry,
        objValue: true,
        noTitle: true
      }, {
        token: 'MAIL.MAIL_LIST.DURATION',
        templateKey: 'ta-filter-select',
        prop: 'minutes',
        filterPattern: '%From - %To',
        // filterPattern: formatBetweenPattern,
        filterIcon: 'icon-clock-fast',
        querryType: 'between',
        formatData: formatBetweenQuerry,
        objValue: true,
        source: prepareBetweenValues(_this.durationParams)
      },
      {
        token: 'MAIL.MAIL_LIST.STATUS',
        hide: true,
        // fixedFilter:true,//filtru nie pokazujemy na liście filtrów
        // templateKey: 'ta-switch',
        filterPattern: '%status',
        prop: 'statusObj',
        querryType: 'filter',
        formatData: formatStatusQuerry
      }
    ];
    if (SessionManager.getUserRoleId() !== authRolesConst.consultant) {
      getConsultantList().then(function (result) {
        _this.filterTypes.push({
          token: 'MAIL.MAIL_LIST.CONSULTANT',
          templateKey: 'ta-singleselect',
          prop: 'consultantID',
          filterPattern: '%ConsultantName',
          // filterPattern: formatBetweenPattern,
          filterIcon: 'icon-account',
          querryType: 'filter',
          // formatData: formatBetweenQuerry,
          // objValue: true,
          // source: result
          source: prepareSelectValues(result, formatConsultant, 'consultantID'),
          // conf: {
          //   objList: result,
          //   filter: 'userID',
          //   label: 'REPORTS.CONSULTANT',
          //   format: formatConsultant
          // }
        });

      });
    }


    getExtraParameters().then(function (result) {
      _this.filterTypes.push({
        token: 'MAIL.MAIL_LIST.PARAMS',
        templateKey: 'ta-params',
        prop: 'param',
        filterPattern: '%ConsultantName',
        // filterPattern: formatBetweenPattern,
        filterIcon: 'icon-account',
        querryType: 'parameter',
        formatData: formatParmsQuerry,
        objValue: true,
        // source: result
        source: prepareSelectValues(result, 'param', 'param'),
        // conf: {
        //   objList: result,
        //   filter: 'userID',
        //   label: 'REPORTS.CONSULTANT',
        //   format: formatConsultant
        // }
      });
    });

    function formatConsultant(item) {
      return item.firstName + ' ' + item.lastName + (item.alias ? '/' + item.alias : '')
    }

    // {
    //   objList: vm.consultantList,
    //   filter: 'userID',
    //   label: 'REPORTS.CONSULTANT',
    //   format: formatConsultant
    // }


    _this.buildFilterConfig = function buildFilterConfig(filter,initData) {
      var filterConfig = [{
        templateKey: filter.templateKey ? filter.templateKey : undefined,
        // label: filter.token ? filter.token : undefined,
        label: '',
        fieldId: filter.prop,
        conf: filter.conf || undefined,
        source: filter.source || undefined,
        objValue: filter.objValue
        // defaultValue: optional ? defaultValue[0] : undefined,
        // isOptional: optional ? true : false,
        // isStep: isStep,
        // notInConfig: notInConfig,
        // disabledOnEdit: disabledOnEdit
      }];
      var filterType = angular.copy(filter);
      return {
        filterConfig: filterConfig,
        filterType: filterType,
        filterData: initData || {}
      };
    };

    function formatSortQuerry(data) {
      var result = {};
      result[data.descending ? '!0' : '0'] = data.column;
      return result;
    }

    function formatSortPattern(data) {
      return $translate.instant('MAIL.MAIL_LIST.MAIL_OBJ.' + data.column.toUpperCase());
    }


    function formatDateQuerry(data) {
      var result = {
        creationTime: (data.From ? data.From.toISOString() : new Date().toISOString()) + ',' + (data.To ? data.To.toISOString() : new Date().toISOString())
      };

      // result[data.sort.descending ? '!0' : '0'] = data.sort.column;
      return result;
    }

    function formatDatePattern(data) {
      return moment(data.From || new Date()).format('DD-MM-YYYY') + ' - ' + moment(data.To || new Date()).format('DD-MM-YYYY');
    }

    function formatBetweenQuerry(data, filterType) {
      var result = {};
      result[filterType.prop] = (data.From || '') + ',' + (data.To || '');
      return result;
    }

    function formatParmsQuerry(data) {
      if (data.name && data.value) {
        var result = {}
        result[data.name] = data.value;
        return result;
      }
    }

    function formatStatusQuerry(data) {
      var status = [];

      if(data){
        if (data.isFree) {
          status.push('FREE');
        }
        if (data.pay) {
          status.push('CONFIRMED');
        }

        if (status.length === 0) {
          status.push('NONE');
        }

        var result = {
          Status: status.join(',')
        };
        return result;
      }else{
        return null
      }

    }

    function prepareSortValues(data) {
      return prepareSelectValues(data, function (item) {
        return $translate.instant('MAIL.MAIL_LIST.MAIL_OBJ.' + item.toUpperCase());
      });

    }


    function prepareSelectValues(data, translateFunc, valueFunc) {
      return data.map(function (item) {
        return {
          Name: translateFunc ? angular.isString(translateFunc) ? item[translateFunc] : translateFunc(item) : item,
          Value: valueFunc ? angular.isString(valueFunc) ? item[valueFunc] : valueFunc() : item
        }
      });
    }


    function prepareBetweenValues(data) {
      return data.map(function (item) {
        return {
          Name: (item.From || '>') + (item.From && item.To ? '-' : '') + (item.To || '<'),
          Value: item
        };
      });
    }


    _this.updateFilters = function (newFilterArray) {
      _this.filtersArray = _.filter(newFilterArray.map(function (item) {
        return addFilter(item.filterData, item.filterType);
      }), undefined);
    };

    _this.addFilter = function (filterData, filterType) {
      var filter = addFilter(filterData, filterType);
      if (filter) {
        _this.filtersArray.push(filter);
      }
    };

    function addFilter(filterData, filterType) {
      // filterData = filterType.formatData ? filterType.formatData(filterData) : filterData;
      var data = filterType.formatData ? filterType.formatData(filterData[filterType.prop], filterType) : filterData;
      if (data) {
        var result = {
          data: data,
          filterString: angular.isFunction(filterType.filterPattern) ?
            filterType.filterPattern(filterData[filterType.prop], filterType.prop) : getFilterString(filterData, filterType),
          filterType: filterType.querryType,
          icon: filterType.filterIcon,
          fixedFilter: filterData.fixedFilter
        };
        return result;
      }
      // _this.filtersArray.push(result);
    }

    _this.generateQuerryString = function () {
      var result = [];
      if (_this.filtersArray.length > 0) {

        var filtersByType = _.groupBy(_this.filtersArray, 'filterType');

        for (var type in filtersByType) {
          if (filtersByType[type]) {
            var buildedFilter = buildFilterType(_.map(filtersByType[type], _.property('data')));
            if (buildedFilter)
              result.push(type + '@' + buildedFilter);
          }
        }
        console.log('MaillistFilters | generated querryString: ' + result.join('*'))
        return result.join('*');
      }
    };


    function buildFilterType(filtersArray) {
      // var mergeObj = {};
      var mergeObj = _.reduce(filtersArray, _.merge, {});

      // filtersArray.forEach(function(filter){
      //   mergeObj = _.merge(mergeObj,filter.data);
      // });
      return stringifyFilter(mergeObj);
      // return filtersArray.map(stringifyFilter)
    }

    function stringifyFilter(filterData) {
      var result = [];

      for (var key in filterData) {
        if (filterData[key]) {
          if (angular.isArray(filterData[key])) {
            filterData[key] = filterData[key].join(',');
          }
          result.push(key + '=' + encodeURIComponent(filterData[key]));
        }
      }
      return result.join(';');
    }

    function getFilterString(filterData, filterType) {
      var result = angular.copy(filterType.filterPattern);
      var matchedParameters = result.match(/\%.[^\ ]+/g)
      if (matchedParameters && matchedParameters.length > 0) {

        if (filterType.objValue) {
          filterData = filterData[filterType.prop];
        }
        for (var key in matchedParameters) {
          // if (filterData[key] != undefined) {
          result = result.replace(new RegExp(matchedParameters[key], 'g'), filterData[matchedParameters[key].replace(/\%|\ /g, '')] || '');
          // }
        }
      }
      return result;
    }

    function getConsultantList(refresh) {
      var defer = $q.defer();
      if (_this.consultantList && !refresh) {
        defer.resolve(_this.consultantList);
      } else {
        if (_this.lastPromise && !refresh) {
          $q.all([_this.lastPromise]).then(function (result) {
            defer.resolve(_this.consultantList);
          });
        } else {
          _this.lastPromise = getCallcenterPerManager();

          $q.all([_this.lastPromise]).then(function (data) {
            _this.consultantList = data[0];
            // generateConsultantSearch();
            defer.resolve(_this.consultantList);
          });
        }
      }
      return defer.promise;
    }

    function getCallcenterPerManager() {
      var defer = $q.defer();

      if (SessionManager.getUserRoleId() !== authRolesConst.consultant) {
        DynamicFactory.get('reportsCosult', 'CallCenterList')().then(function (r) {
          // tripleviewService.sidenavData.callCenterList = r;
        });
      }
      generateConsultantPerContactCenter().then(defer.resolve, defer.reject);
      return defer.promise;
    }

    function generateConsultantPerContactCenter() {
      var defer = $q.defer();
      // tripleviewService.sidenavData.consultantsPerCC = [];
      // var callcenterId;
      // if (SessionManager.getUserRoleId() === authRolesConst.admin) {
      //   callcenterId = _this.CallcenterId ? _this.CallcenterId : null;
      // } else {
      //   callcenterId = SessionManager.getUser().callCenterId;
      // }

      if (SessionManager.getUserRoleId() !== authRolesConst.admin) {
        _this.CallcenterId = SessionManager.getUser().callCenterId;
      }

      if (SessionManager.getUserRoleId() !== authRolesConst.consultant) {
        DynamicFactory.get('reportsCosult', 'ConsultansGet')(_this.CallcenterId).then(function (r) {
          // tripleviewService.sidenavData.consultantsPerCC = r;
          _this.consultantList = r;
          //_(r).groupBy('consultantID').value();
          defer.resolve(_this.consultantList);
        }, defer.reject);
      }
      return defer.promise;
    }

    function getExtraParameters() {
      var defer = $q.defer();
      DynamicFactory.get('reportsCosult', 'ParamList')().then(function (response) {

        //_(r).groupBy('consultantID').value();
        defer.resolve(response);
      }, defer.reject);
      return defer.promise;
    }

    // filtersArray

    return _this;
  }
})();

// /**
//  * Created by kosski on 09.09.2016.
//  */

// +function () {
//     'use strict';

//     angular
//         .module('contactcenter.trademill')
//         .factory('trademillRsc', trademillRsc);

//     const treadmillUrl = '/treadmill/get';
//     const updateFeedUrl = '/treadmill/UpdateFeed/';
//     const getCientHistoryUrl = '/treadmill/getCientHistory/:hash';
//     const tagsUrl = '/CallCenterServices/tags';

//     /** @ngInject */
//     function trademillRsc($resource, consts, $templateCache, SessionManager) {
//         var _this = {};
//         var role = SessionManager.getUserRole();
//         _this.resources = {
//             GetTreadmill: $resource(consts.api + role + treadmillUrl,
//                 {
//                     service: '@service'
//                 },
//                 {
//                     get: {
//                         method: "GET",
//                         isArray: true
//                     }
//                 }),
//             GetTreadmillByTags: $resource(consts.api + role + treadmillUrl,
//                 '@data',
//                 {
//                     post: {
//                         method: "POST",
//                         isArray: true
//                     }
//                 }),
//             updateFeed: $resource(consts.api + role + updateFeedUrl + "/:fromDate",
//                 {
//                     fromData: '@fromDate'
//                 },
//                 {
//                     get: {
//                         method: "GET",
//                         isArray: true
//                     }
//                 }),
//             updateFeedbyTags: $resource(consts.api + role + updateFeedUrl,
//                 '@data',
//                 {
//                     post: {
//                         method: "POST",
//                         isArray: true
//                     }
//                 }),
//             getCientHistory: $resource(consts.api + role + getCientHistoryUrl,
//                 {
//                     hash: '@hash'
//                 }, {
//                     get: {
//                         method: "GET",
//                         isArray: true
//                     }
//                 }),
//             tags: $resource(consts.api + tagsUrl + '/:serviceId',
//                 {
//                     serviceId: '@serviceId',
//                     tagId: '@tagId'
//                 }, {
//                     get: {
//                         method: "GET",
//                         isArray: true
//                     }
//                 })
//         };

//         /* -------------------------------------------- SERVICE PART -------------------------------------------- */
//         _this.GetTreadmill = function () {
//             return _this.resources.GetTreadmill.get().$promise;
//         };

//         _this.GetTreadmillByTags = function (tags) {
//             return _this.resources.GetTreadmillByTags.post({ tags: tags }).$promise;
//         };

//         _this.updateFeed = function (fromData) {
//             return _this.resources.updateFeed.get({ fromDate: fromDate }).$promise;
//         };

//         _this.updateFeedByTags = function (tags, fromDate) {
//             return _this.resources.updateFeed.post({ tags: tags, fromDate: fromDate }).$promise;
//         };

//         _this.getCientHistory = function (hash) {
//             return _this.resources.getCientHistory.get({ hash: hash }).$promise;
//         };

//         _this.getTags = function (serviceId) {
//             return _this.resources.tags.get({ serviceId: serviceId }).$promise;
//         };

//         _this.addTags = function (serviceId, tagId) {
//             return _this.resources.tags.post({ serviceId: serviceId, tagId: tagId }).$promise;
//         };

//         _this.deleteTags = function (serviceId, tagId) {
//             return _this.resources.tags.delete({ serviceId: serviceId, tagId: tagId }).$promise;
//         };

//         return _this;
//     }
// }();

(function () {
  'use strict';

  angular
    .module('management.services')
    .service('wizzardService', Service);

  //   Service.$inject = ['$q', 'SessionManager', 'DynamicFactory', '$sessionStorage'];
  /** @ngInject */
  function Service($q, SessionManager, DynamicFactory, $translate, ngNotify, $state, toastService) {
    var vm = {};
    vm.slotsData = '';

    vm.loadService = loadService;
    vm.updateService = updateService;
    vm.changeMenu = changeMenu;
    // vm.setMenuWizzard = setMenuWizzard;
    vm.clearKeyData = clearKeyData;

    function loadService(serviceId, serviceType) {
      return $q(function (resolve, reject) {
        if (serviceId) {
          DynamicFactory.get('servicesRsc', 'GetService')(serviceId, serviceType).then(function (data) {
            data.startDate = moment(data.startDate);
            data.stopDate = moment(data.stopDate);
            vm.service = data;
            // if()
            // tripleviewService.sidenavData = vm.service;
            // tripleviewService.sidenavData.subHeader = vm.service.serviceName;
            // tripleviewService.sidenavData.avatarCallback = avatarServiceChange;
            resolve(data);
            console.log("loadService - vm.service: ", vm.service);
          }, function (e) {
            reject("error");
            ngNotify.set("Wystąpił błąd podczas pobierania serwisu.", "error");
          });
        } else {
          vm.service = {};
          resolve(vm.service);
        }
      });
    }

    function avatarServiceChange(photoUrl) {
      vm.service.photoUrl = photoUrl;
    }

    function updateService() {
      console.log("wizzardService - updateService()");
      console.log("wizzardService - service: ", vm.service);
      //console.log("wizzardService - vm.slotsData: ", vm.service.slotsData);
      vm.service.slotsDataSend = JSON.stringify(vm.service.slotsData);
      //console.log("wizzardService - vm-service: ", vm.service);
      if (vm.service.hasOwnProperty('serviceID')) {
        //console.log(vm.service);
        if (vm.service.stopDate && vm.service.startDate) {
          DynamicFactory.get('servicesRsc', 'updateService')(vm.service).then(onSuccess, onError);
        }
      } else {
        DynamicFactory.get('servicesRsc', 'saveService')(vm.service).then(onSuccess, onError);
      }
    }

    function changeMenu(menu, serviceID) {
      menu.typestep.ishidden = false;
      if (serviceID > 0) {
        menu.typestep.ishidden = true;
      }
      return menu;
    }

    function onSuccess(data) {
      toastService.showToast($translate.instant('COMMON.UPDATE_SUCCESS'), 'success', 4);
      $state.go('app.contactcenter_management.services.list');
    }

    function onError(e) {
      console.log(e);
      toastService.showToast($translate.instant('COMMON.UPDATE_ERROR'), 'error', 10);
    }

    function setMenuWizzard(tripleView) {
      var overrideRoleTab = [];
      if ($state.current.name === 'app.contactcenter_management.services.wizzard.basicstep' ||
        $state.current.name === 'app.contactcenter_management.services.wizzard.finalstep' ||
        $state.current.name === 'app.contactcenter_management.services.wizzard.content' ||
        $state.current.name === 'app.contactcenter_management.services.wizzard.pointstep') {
        overrideRoleTab = ([{
            name: 'numberstep',
            hide: (((vm.service.type !== 'I' && vm.service.type !== 'S')) || vm.service.serviceID > 0)
          },
          {
            name: 'mailstep',
            hide: ((vm.service.type !== 'E' || vm.service.serviceID > 0))
          },
          {
            name: 'pointstep',
            hide: ((vm.service.type !== 'E'))
          },
          //{ name: 'finalstep', hide: !(vm.service.type === 'S' || vm.service.type === 'I') },
          {
            name: 'basicstep',
            disabled: false
          },
          {
            name: 'finalstep',
            disabled: false
          }
        ]);
      } else if ($state.current.name === 'app.contactcenter_management.services.wizzard.numberstep') {
        overrideRoleTab = ([{
            name: 'basicstep',
            disabled: (vm.service.premiumNumber === undefined)
          },
          {
            name: 'finalstep',
            disabled: (vm.service.premiumNumber === undefined)
          },
          {
            name: 'mailstep',
            hide: true
          },
          {
            name: 'pointstep',
            hide: true
          },
          {
            name: 'numberstep',
            hide: false
          }
          //{ name: 'finalstep', hide: (vm.service.type !== 'S' && vm.service.type !== 'I') }
        ]);
      } else if ($state.current.name === 'app.contactcenter_management.services.wizzard.mailstep') {
        overrideRoleTab = ([{
            name: 'basicstep',
           disabled: (vm.service.premiumNumber === undefined)          },
          {            name: 'finalstep',           disabled: (vm.service.premiumNumber === undefined)          },
          {            name: 'mailstep',            hide: false          },
          {            name: 'pointstep',           hide: false          },
          { name: 'numberstep', hide: true }
          // { name: 'finalstep', hide: (vm.service.type !== 'S' && vm.service.type !== 'I') }
        ]);
      } else if ($state.current.name === 'app.contactcenter_management.services.wizzard.partnerstep') {
        overrideRoleTab = ([{
            name: 'basicstep',
            disabled: (vm.service.premiumNumber === undefined)
          },
          {
            name: 'finalstep',
            disabled: (vm.service.premiumNumber === undefined)
          },
          {
            name: 'numberstep',
            disabled: (vm.service.servicePartnerID === undefined)
          },
          {
            name: 'mailstep',
            disabled: (vm.service.servicePartnerID === undefined)
          },
          {
            name: 'mailstep',
            hide: (vm.service.type !== 'E')
          },
          {
            name: 'pointstep',
            disabled: (vm.service.servicePartnerID === undefined)
          },
          {
            name: 'pointstep',
            hide: (vm.service.type !== 'E')
          },
          {
            name: 'numberstep',
            hide: (vm.service.type !== 'S' && vm.service.type !== 'I')
          }
          // { name: 'finalstep', hide: (vm.service.type !== 'S' && vm.service.type !== 'I') }
        ]);
      }
      //overrideRoleTab.push({ name: 'content', hide: true });
      return overrideRoleTab;
    }

    function clearKeyData() {
      vm.service.premiumNumber = undefined;
      vm.service.selectedNumberId = undefined;
      vm.service.premiumNumberPrefix = undefined;
      vm.service.mailBoxId = undefined;
      vm.service.servicePartnerID = undefined;
    }
    return vm;

  }
})();

(function () {
    'use strict';
    angular
        .module('contactcenter.dashboard')
        .factory('dashboardcharts', ['$translate', dashboardcharts]);

    function dashboardcharts($translate) {

        // _this.colors = [
        //     { color: "#E57373" },
        //     { color: "#9CCC65" },
        //     { color: "#558B2F" },
        //     { color: "#FFAB40" },
        //     { color: "#FF6E40" }
        // ];
        var _this = {};

        _this.defaultChartConf = {
            config: {
                refreshDataOnly: true,
                deepWatchData: true
            },
            options: {
                chart: {
                    type: 'discreteBarChart',
                    height: 150,
                    margin: {
                        top: 8,
                        right: 16,
                        bottom: 50,
                        left: 48
                    },
                    clipEdge: true,
                    groupSpacing: 0.3,
                    reduceXTicks: false,
                    stacked: true,
                    duration: 250,
                    showLegend: true,
                    isArea: true,
                    interpolate: 'cardinal',
                    // showXAxis: false,
                    // showYAxis: false,
                    // useInteractiveGuideline: true,

                    noData: $translate.instant('REPORTS.NO_DATA'),
                    // yAxis: {
                    //     tickFormat: function (d) {
                    //         return d.toFixed(2);
                    //         // var formatTime = d3.time.format("% ");
                    //         // return formatTime(new Date(2012, 0, 1, 0, 0, d));
                    //     }
                    // },
                    x: function (d) {
                        return d.x;
                    },
                    y: function (d) {
                        return d.y;
                    },
                    legend: {
                        margin: {
                            top: 1,
                            bottom: 32
                        }
                    },
                    // valueFormat: function(d) {
                    //     return d.toFixed(2);
                    // },
                    // valueFormat: function (d) {
                    //         var formatTime = d3.time.format('%H:%M:%S');
                    //         return formatTime(new Date('2015', '0', '1', '0', '0', d));
                    // },
                    showValues: true,
                    showControls: false,
                    controls: {
                        labels: {
                            grouped: 'Grupuj',
                            stacked: 'Sterta'
                        },
                        margin: {
                            top: 1,
                            bottom: 32
                        }
                    },
                    // tooltip: {
                    //     gravity: 's',
                    //     classes: 'gravity-s'
                    // }
                }
            },
            data: [],
            data1:[]
        };

        return _this;
    }
})();

/**
 * Created by kosski on 08.09.2016.
 */
+ function () {
  'use strict';
  angular.module('contactcenter.dashboard').component('dashboard', {
    templateUrl: 'app/main/contactcenter/dashboard/component/dashboard.html',
    controllerAs: 'vm',
    controller: controller
  });

  /** @ngInject */
  function controller(SessionManager, authRolesConst, DynamicFactory, reportsCosult, connectionStatisticFuncService, connectionStatisticCons) {
    var vm = this;

    vm.SessionManager = SessionManager;
    vm.authRolesConst = authRolesConst;
    vm.msm_mode=false;
 

    vm.userInfo = SessionManager.getUser();
    vm.finished = function () {
      // Finish callback
      console.log('koniec');
    };

    //function
    vm.$onInit = onInit;

    //resources
    vm.getAgrForChart = DynamicFactory.get('reportsCosult', 'ReportsConnectionsAgrForChart');
    vm.ConsultantReportsConnectionsAgrForChart = DynamicFactory.get('reportsCosult', 'ConsultantReportsConnectionsAgrForChart');

    //other
    vm.chartData = [];

    function onInit() {
      vm.connectionStatisticCons = connectionStatisticCons;
      getAgregationAsync();
      vm.currentMode = SessionManager.getUserRole();
    }

 

    function getAgregationAsync() {
      var from = new Date(moment().subtract(4, 'days').startOf('day')),
        to = moment().format();

      if (SessionManager.getUserRoleId() !== authRolesConst.consultant) {
        vm.getAgrForChart({
          From: from,
          To: to,
          callCenterId: vm.userInfo.callCenterId,
          AggregationType: 'D'
        }).then(function (response) {

          vm.chartData = connectionStatisticFuncService.groupData(response);

        });
      }
      if (SessionManager.isConsultant()) {
        vm.ConsultantReportsConnectionsAgrForChart({
          From: from,
          To: to,
          AggregationType: 'D'
        }).then(function (response) {
          vm.consultantChartData = connectionStatisticFuncService.groupData(response);
        });
      }
    }



  }


}();

-function () {
  'use strict';
  angular
    .module('viewActions',[])
    .component('viewActions', {
      templateUrl: 'app/main/contactcenter/components/viewActions/viewActions.html',
      bindings: {
        saveFunc:'=',
        closeFunc:'=',
        mainForm:'='
      },
      controllerAs: 'vm',
      controller: controller
    });

    function controller() {
      var vm = this; // jshint ignore:line

      vm.$onInit = onInit;


      function onInit() {

      }


    }

}();

/**
 * Created by akraszewski on 2017-01-12.
 */
(function () {
  'use strict';

  angular
    .module('callInfoBar', [])
}());

(function () {
    'use strict';

    angular
      .module('callInfoBar')
      .service('callInfoBarService', Service)

    /** @ngInject */
    function Service() {

      var $self = this;

      $self.onProcessCallNotification = onProcessCallNotification;
      $self.onCurrCallStatusChanged = onCurrCallStatusChanged;
      $self.onGetCurrCall = onGetCurrCall;
      $self.onAddCall = onAddCall;
      $self.onRemoveCurrCall = onRemoveCurrCall;
      $self.onHelpRequest = onHelpRequest;
      $self.onRegisterWebSockets = onRegisterWebSockets;

      $self.processCallNotification = processCallNotification;
      $self.currCallStatusChanged = currCallStatusChanged;
      $self.addCall = addCall;
      $self.getCurrCall = getCurrCall;
      $self.removeCurrCall = removeCurrCall;
      $self.helpRequest = helpRequest;
      $self.registerWebSockets = registerWebSockets;
      
      $self.globalStopHelpFunc = undefined;

      $self.setActive = setActive;

      $self.isActive = false;
      $self.allowedForUser = false;

      $self.setCallerSource = setCallerSource;
      $self.callerIsOpened = false;
      $self.callerSource=0;


      var onProcessCallNotificationFunc;
      var onCurrCallStatusChangedFunc;
      var onAddCallFunc;
      var onGetCurrCallFunc;
      var onRemoveCurrCallFunc;
      var onHelpRequestFunc;
      var onRegisterWebSocketsFunc;


      function setActive(isActive) {
        $self.isActive = isActive;
      }

      function setCallerSource(source,isOpen) {
        // 0 - brak
        // 1 - callinfo bar
        // 2 - orderbox
        // 3 - last contacts
        $self.callerSource=source;
        $self.callerIsOpened=isOpen;
      }


      function onProcessCallNotification(callback) {
        onProcessCallNotificationFunc = callback;
      }

      function processCallNotification(call) {
        if (typeof onProcessCallNotificationFunc !== 'undefined') {
          onProcessCallNotificationFunc(call);
        }
      }



      function onCurrCallStatusChanged(callback) {
        onCurrCallStatusChangedFunc = callback;
      }

      function currCallStatusChanged(call) {
        if (typeof onCurrCallStatusChangedFunc !== 'undefined') {
          onCurrCallStatusChangedFunc(call);
        }
      }


      function onAddCall(callback) {
        onAddCallFunc = callback;
      }
      function addCall(callId) {
        if (typeof onAddCallFunc !== 'undefined') {
          onAddCallFunc(callId);
        }
      }


      function onGetCurrCall(callback) {
        onGetCurrCallFunc = callback;
      }
      function getCurrCall(callId) {
        if (typeof onGetCurrCallFunc !== 'undefined') {
          onGetCurrCallFunc(callId);
        }
      }


      function onRemoveCurrCall(callback) {
        onRemoveCurrCallFunc = callback;
      }
      function removeCurrCall(callId) {
        if (typeof onRemoveCurrCallFunc !== 'undefined') {
          onRemoveCurrCallFunc(callId);
        }
      }

      function onHelpRequest(req) {
        onHelpRequestFunc = req;
      }
      function helpRequest(consultant, stopFunc, help) {
        if (typeof onHelpRequestFunc !== 'undefined') {
          onHelpRequestFunc(consultant, stopFunc, help);
        }
      }

      function onRegisterWebSockets(req) {
        onRegisterWebSocketsFunc = req;
      }
      function registerWebSockets() {
        if (typeof onRegisterWebSocketsFunc !== 'undefined') {
          onRegisterWebSocketsFunc();
        }
      }

    }
  }()
);


(function () {
  'use strict';

  angular
    .module('callInfoBar')
    .component('callInfoBar', {
      templateUrl: 'app/main/contactcenter/components/callinfobar/callinfobar.html',
      controllerAs: 'vm',
      bindings: {},
      controller: callInfoBarCtrl
    });

  /** @ngInject */
  function callInfoBarCtrl(callInfoBarService, $mdDialog, ConsultantsRsc, SessionManager, $q, ContactPartRsc, DynamicFactory, $timeout, callSessionManager, CallStatusConst, $scope, WebSocketManager, callInfoBarBridge, WebRTCService, templateData, toastService, $translate, $interval, communicatorService, $state) {


    var vm = this;
    vm.minimize = minimizeBar;
    vm.open = openBar;
    vm.close = closeBar;
    vm.callForwarding = callForwarding;
    vm.sendHelp = sendHelp;
    vm.answerWebRTC = answerWebRTC;
    vm.checkCode = checkCode;
    vm.showForwardMsg = showForwardMsg;
    vm.stopHelp = stopHelp;
    vm.setMicrophone = setMicrophone;
    vm.helpReceiverMsgCall = helpReceiverMsgCall;
    vm.callinfoBarClicked = callinfoBarClicked;
    vm.stopFunc = undefined;
    vm.paymentWindowOpening = false;

    // vm.prevStatus = '';
    vm.serviceInfo = {};

    vm.$onInit = function () {
      vm.active = false;
      vm.minimized = false;
      vm.currCall = undefined;
      vm.currAudio = '';
      vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];
      vm.userSession = SessionManager.getUser();
      vm.currDate = moment().format('YYYY/MM/DD');
      vm.paymentWindow = paymentWindow;
      vm.paymentPaneChange = paymentPaneChange;
      setCallingAudio();
      //vm.walletInfo = {};


      vm.helpSending = DynamicFactory.get('ConsultantsRsc', 'helpSending');


      callInfoBarService.onGetCurrCall(getCurrCall);
      callInfoBarService.onAddCall(addCurrCall);
      callInfoBarService.onRemoveCurrCall(removeCurrCall);
      callInfoBarService.onCurrCallStatusChanged(currCallStatusChanged);
      callInfoBarService.onProcessCallNotification(callMessageProcess);
      callInfoBarService.onHelpRequest(helpRequestProcess);
      callInfoBarService.onRegisterWebSockets(registerWsMethods);

      callMessageProcess(getCurrCall());
      communicatorService.sessionAddFromCall(getCurrCall());

      if (SessionManager.isConsultant()) {
        WebSocketManager.registerWebSocketMethod('CallIn', 'callArive', callInfoBarService.processCallNotification, SessionManager.buildRegexForConsultant());
        WebSocketManager.registerWebSocketMethod('WalletIn', 'walletArive', walletMessageProcess, SessionManager.buildRegexForConsultant());
        WebSocketManager.registerWebSocketMethod('CallOut', 'callBridge', callInfoBarBridge.showCallNotifications, SessionManager.buildRegexForConsultant());
      }
      reBindHelpSocket(getCurrCall());

      // console.log('callInfoBar init');
      registerWsMethods();

      //WebRTCService.makeCall('4058');
    };

    vm.disconnectCall = function () {
      WebRTCService.disconnectCall(vm.currCall.callID);
    }

    vm.getActiveCall = function () {
      return WebRTCService.getActiveCall();
    }

    function registerWsMethods() {
      if (vm.userSession.roleId === 2) {
        WebSocketManager.registerWebSocketMethod('SendHelp', 'SendHelpConsultantsStatistics', onSendHelp);
        reBindHelpSocket(getCurrCall());
      }
    }

    function buildRegex() {
      var user = SessionManager.getUser();
      // var partnerId = user.partnerId;
      console.log('regex: ' + '^ccs\\.' + user.partnerId + '\\/' + user.callCenterId + '\\/' + user.consultantId);
      return '^ccs\\.' + user.partnerId + '\\/' + user.callCenterId + '\\/' + user.consultantId;
    }
    function onSendHelp(data) {
      if (data.Content) {
        if (angular.isString(data.Content)) {
          data.Content = JSON.parse(data.Content);
        }
        if ($state.current.name !== 'app.contactcenter_dashboard' && !data.Content.endHelp && data.Content.consultantName && data.Content.consultantName.length > 0) {
          toastService.showToastAction(data.Content.consultantName + ' ' + $translate.instant('CALLINFOBAR.NEED_HELP'), 'message', 10, $translate.instant('CALLINFOBAR.START_HELP')).then(function (response) {
            if (response === 'ok') {
              $state.go('app.contactcenter_dashboard', { 'needHelp': data.Content });
            }
          });
        }
      }
    }

    function sendHelp(e, callID) {
      e.stopPropagation();
      vm.helpInProgress = true;
      vm.needHelp = false;
      if (!vm.needHelp) {
        vm.helpSending(callID);
        vm.needHelp = true;
      }
      $timeout(function () {
        vm.helpInProgress = false;
      }, 5000);
    }

    function setNullIfNoValue(value) {
      if (value === 'undefined' || value === 'null') {
        return null;
      } else {
        return value;
      }
    }

    function getCurrCall() {
      if (vm.currCall) {
        return vm.currCall;
      } else {
        return callSessionManager.getCall();
      }
    }

    function addCurrCall(call) {
      vm.needHelp = false;
      var callLocal = {
        dataLoaded: false,
        serviceId: call.ccserviceId ? call.ccserviceId : call.serviceId,
        prefixId: 2,
        status: call.status,
        leg: call.leg,
        clientBase: {
          msisdn: call.ani,
        },
        sdp: call.sdp,
        callID: call.callId ? call.callId : call.callID,
        contactId: call.contactId,
        params: call.params,
        isCallOut: call.isCallOut,
        serviceBundle: call.ccserviceBundle ? JSON.parse(call.ccserviceBundle) : undefined,
        isPremiumDcb: call.isPremiumDcb,
        forwardText: call.forwardText,
        helpSession: call.helpSession,
        ServiceName: call.ServiceName,
        bundleID: call.bundleID,
        BridgeID: call.BridgeID
      };

      if (getCurrCall()) {
        console.log('Bład jedno poczłaczenie juz istnitje');
        return null;
      } else {
        vm.currCall = callLocal;
        callSessionManager.setCall(callLocal);
        return callLocal;
      }
    }

    function saveCurrCall() {
      if (vm.currCall) {
        callSessionManager.clearCallStorage();
        callSessionManager.setCall(vm.currCall);
      } else {
        console.log('Bład! Brak currCall do zapisu!');
      }
    }

    function removeCurrCall() {
      if (vm.currCall) {
        vm.currCall = undefined;
        closeBar();
      }
      return callSessionManager.clearCallStorage();
    }

    function currCallStatusChanged(call) {

      //wywalamy tego ifa bo ktoś mogł odświeżyć stron i wcisnać F5
      // if (getCurrCall().status !== call.status) {

      // konsultant zkonczył rozmowe i nie obsługujemy (nie musimy) automatycznego zakonczenia romozmowy przez klienta
      // if(vm.currCall.status === CallStatusConst.walletChange){
      //   vm.currCall.status = CallStatusConst.wait4drop;
      //   return;
      // }
      if (vm.currCall.status === CallStatusConst.disconnected && vm.currCall.status === call.status && vm.currCall.leg !== call.leg) {
        return;
      }


      vm.currCall.status = call.status;
      vm.currCall.leg = call.leg;
      vm.currCall.contactId = call.contactId;
      vm.currCall.BridgeID = call.BridgeID;

      console.log('CallMessageProcess status: ' + vm.currCall.status);


      saveCurrCall();
      if (vm.currCall.status === CallStatusConst.ringing && vm.currCall.leg === 'A') {
        $timeout(0);
        //do nothing
      }
      else if (vm.currCall.status === CallStatusConst.ringing && vm.currCall.leg === 'B') {
        $timeout(0);
        //do nothing
      }
      else if (vm.currCall.status === CallStatusConst.failedRedirect) {
        //time for see changes
        // $timeout(function () {
        // removeCurrCall();
        // dzieki temu w paseku odświeżj sie dane i nie ma losowego 3-10 sekundowego opoznienia
        // $timeout(0);

        // }, 0);

        toastService.showToast($translate.instant('CALLINFOBAR.FAILED_REDIRECT'), 'error', 4);
      }
      else if (vm.currCall.status === CallStatusConst.wait4drop) {
        console.log('w4r: ', vm.currCall);
        checkForOuterPayment();
        $timeout(function () {
          // if(call.startCall){
          //   vm.currCall.callStartTime = call.startCall; // timer START!!!!
          // }
          // else{
          // if(!vm.currCall){
          //   vm.currCall = getCurrCall();
          // }
          vm.currCall.callStartTime = call.callStartTime; // timer START!!!!
          // }
          vm.currCall.actionId = call.actionId;
          saveCurrCall();
        }, 1000);

      } else if (vm.currCall.status === CallStatusConst.disconnected || vm.currCall.status === CallStatusConst.hangup) {
        vm.currCall.callEndTime = new Date(); // timer STOP!

        vm.currCall.timerStopped = true;
        $timeout(0);

        saveCurrCall();

        //time for see changes
        $timeout(function () {
          removeCurrCall();
          // dzieki temu w paseku odświeżj sie dane i nie ma losowego 3-10 sekundowego opoznienia
          $timeout(0);

        }, 3000);

        WebRTCService.disconnectCall();
        $mdDialog.cancel();
      }
      else if (vm.currCall.status === CallStatusConst.failed) {

        //time for see changes
        $timeout(function () {
          removeCurrCall();
          // dzieki temu w paseku odświeżj sie dane i nie ma losowego 3-10 sekundowego opoznienia
          $timeout(0);

        }, 3000);
      }

      // vm.prevStatus = angular.copy(vm.currCall.status);
    }

    function converCallToCurrCall(callMessage) {
      if (callMessage.ani) {

        callMessage.clientBase = { msisdn: callMessage.ani };

        if (callMessage.status === CallStatusConst.wait4drop) {
          callMessage.callStartTime = callMessage.start;
        }

        // TYLKO połczenie typu call
        if (!callMessage.leg) {
          callMessage.leg = 'B';
        }

        // callMessage.serviceId=undefined;
        // callMessage.prefixId=undefined;
      }

      return callMessage;
    }

    function answerWebRTC(e) {
      e.stopPropagation();
      if (vm.currCall.sdp && vm.currCall.status === CallStatusConst.ringing) {
        WebRTCService.tryTakeCall(vm.currCall.sdp, vm.currCall.wCallID);
      } else if (vm.currCall.status === CallStatusConst.wait4drop) {
        WebRTCService.disconnectCall(vm.currCall.wCallID);
      }
    }
    function checkForOuterPayment() {
      var dialogIsShow = angular.element(document.body).hasClass('md-dialog-is-showing');
      console.log('checkForOuterPayment - dialogIsShow: ', dialogIsShow);
      if (!dialogIsShow && !vm.paymentWindowOpening && vm.currCall.isPremiumDcb) {
        console.log('checkForOuterPayment - vm.currCall: ', vm.currCall);
        vm.paymentWindowOpening = true;
        if (vm.currCall && vm.currCall.clientBase) {
          vm.checkData = {
            identifier: vm.currCall.clientBase.msisdn,
            callUUID: vm.currCall.callID
          };
          DynamicFactory.get('OuterPaymentRsc', 'serviceInfo')(vm.currCall.callID)
            .then(function (response) {
              vm.serviceInfo = response;
              DynamicFactory.get('OuterPaymentRsc', 'check')(vm.checkData)
                .then(function (res) {
                  console.log('checkForOuterPayment: ', res);
                  // vm.currCall.walletInfo = res;
                  vm.currCall.subAccount = res.subAccount;
                  vm.currCall.minutesRemain = Math.floor(res.subAccount / vm.serviceInfo.price, 0);
                  if (!res.checkPayment) {
                    paymentWindow(res, vm.currCall);
                  }
                  vm.paymentWindowOpening = false;
                });
            });
        }
      }
    }


    function paymentPaneChange(paneIndex) {
      console.log('paymentPaneChange: ', paneIndex);
      if (paneIndex === 1) {
        vm.payData = {
          callId: vm.paymentData.callID,// this.call.callId,
          walletUserId: vm.paymentData.walletUserId,// this.call.userWallet.userId,
          buyerMsisdn: vm.paymentData.phone,
          amount: vm.paymentData.amount * 100,
          points: vm.paymentData.amount * 100
        };

        DynamicFactory.get('OuterPaymentRsc', 'start')(vm.payData)
          .then(function (res) {
            console.log('pay res: ', res);
            vm.paymentData.transactionId = res.transactionId;
            vm.paymentData.authToken = res.authToken;
          });
      }
      else if (paneIndex === 2) {
        checkCode();
      }
    }
    function checkCode() {
      vm.paymentData.waitForPayment = true;
      vm.checkData = {
        transactionId: vm.paymentData.transactionId,
        authToken: vm.paymentData.authToken,
        pin: vm.paymentData.code
      };
      DynamicFactory.get('OuterPaymentRsc', 'confirm')(vm.checkData)
        .then(function (res) {
          console.log('check res: ', res);
          if (res.statusCode === 200) {
            vm.maxInterval = 20;
            vm.intervalNo = 0;

            vm.interval = $interval(function () {
              vm.intervalNo++;
              vm.checkData = {
                identifier: vm.currCall.clientBase.msisdn,
                callUUID: vm.currCall.callID
              };
              DynamicFactory.get('OuterPaymentRsc', 'check')(vm.checkData)
                .then(function (checkres) {
                  console.log('confirm: ', checkres);
                  if (checkres.checkPayment) {
                    vm.paymentData.paySuccess = true;
                    vm.paymentData.waitForPayment = false;
                    vm.currCall.subAccount = checkres.subAccount;
                    vm.currCall.minutesRemain = checkres.subAccount / vm.serviceInfo.price;
                    $interval.cancel(vm.interval);
                  }
                  else {
                    if (vm.intervalNo >= vm.maxInterval) {
                      vm.paymentData.paySuccess = false;
                      vm.paymentData.waitForPayment = false;
                      vm.currCall.subAccount = checkres.subAccount;
                      vm.currCall.minutesRemain = checkres.subAccount / vm.serviceInfo.price;
                      $interval.cancel(vm.interval);
                    }
                  }
                });
            }, (3 * 1000));
          }
          else {
            vm.paymentData.paySuccess = false;
            vm.paymentData.waitForPayment = false;
          }
        });
    }
    function closePayment($event) {
      console.log('closePayment: ', $event);
      if (vm.paymentData.paySuccess) {
        // $mdDialog.cancel('cancel');
        startPaymentCall(0, false, $event);
      }
      else {
        toastService.showToast($translate.instant('CALLINFOBAR.PAYMENT.PAYMENT_NOTEND'), 'error', 4);
      }
    }
    function disconnectPaymentCall() {
      DynamicFactory.get('OuterPaymentRsc', 'disconnect')(vm.currCall.callID, vm.currCall.BridgeID)
        .then(function (res) {
          console.log('disconnect ok: ', res);
        });
    }
    function startPaymentCall(seconds, forward, $event) {
      DynamicFactory.get('OuterPaymentRsc', 'startPayment')(vm.currCall.callID, seconds)
        .then(function (res) {
          console.log('startPayment ok: ', res);
          if (forward) {
            vm.callForwarding($event, vm.currCall);
          }
          else {
            $mdDialog.cancel('cancel');
          }
        });
    }

    function paymentWindow(checkModel, currCall) {
      vm.paymentData = {};
      if (checkModel.phone) {
        vm.paymentData.phone = checkModel.phone;
        vm.paymentData.callID = currCall.callID;
        vm.paymentData.walletUserId = checkModel.userId;
      }
      //vm.currentCallCenter = angular.copy(callCenter);
      vm.paymentList = {
        first: {
          amount: 10,
          color: '#438DCC'
        },
        second: {
          amount: 20,
          color: '#E84537'
        },
        third: {
          amount: 30,
          color: '#6D3E96'
        },
        four: {
          amount: 40,
          color: '#F6B600'
        },
        five: {
          amount: 50,
          color: '#44BA56'
        }
      };


      DynamicFactory.get('templatesRsc', 'GetTemplate')('payment-call')
        .then(function (template) {
          $mdDialog.show({
            locals: {
              paymentList: vm.paymentList,
              paymentPaneChange: vm.paymentPaneChange,
              paymentData: vm.paymentData,
              checkCode: vm.checkCode,
              serviceInfo: vm.serviceInfo,
              currCall: currCall,
              closePayment: closePayment,
              disconnectPaymentCall: disconnectPaymentCall,
              startPaymentCall: startPaymentCall
            },
            controller: function (paymentList, paymentPaneChange, paymentData, checkCode, serviceInfo, currCall, closePayment, disconnectPaymentCall, startPaymentCall) {
              this.paymentList = paymentList;
              this.paymentPaneChange = paymentPaneChange;
              this.paymentData = paymentData;
              this.checkCode = checkCode;
              this.serviceInfo = serviceInfo;
              this.currCall = currCall;
              this.closePayment = closePayment;
              this.disconnectPaymentCall = disconnectPaymentCall;
              this.startPaymentCall = startPaymentCall;
            },
            controllerAs: 'vm',
            template: template,
            clickOutsideToClose: false,
            escapeToClose: true,
            parent: angular.element(document.body)//,
            // targetEvent: ev
          }).then(function (data) {
            console.log('window payment close');
          },
            function (err) {
              console.error(err);
            }
          );
        });
    }

    function walletMessageProcess(data) {
      if (!data) {
        //"Start paska i brak callMessage";
        return;

      } else {
        var callMessage;
        if (data.Content) {
          callMessage = JSON.parse(data.Content);
        }
        else {
          callMessage = data;
        }
        if (callMessage.userWalletSubAccount !== undefined) {
          vm.currCall.subAccount = callMessage.userWalletSubAccount;
        }
        if (callMessage.userPremiumMinutesRemain !== undefined) {
          vm.currCall.minutesRemain = callMessage.userPremiumMinutesRemain;
        }
        if (callMessage.lowCash && vm.currCall.status === CallStatusConst.wait4drop) {
          checkForOuterPayment();
        }
      }
    }

    function setCallingAudio() {
      vm.audioCalling = new Audio();
      vm.audioCalling.src = 'https://socialsharing.teleaudio.pl/content/telephone-ring.mp3';

      if (typeof vm.audioCalling.loop == 'boolean') {
        // chyba nie działa w FF
        vm.audioCalling.loop = true;
      }
      else {
        vm.audioCalling.addEventListener('ended', function () {
          this.currentTime = 0;
          this.play();
        }, false);
      }


      vm.audioCalling.onerror = function () {
        //debugger
        vm.audioCalling.pause();
        console.log('AudioCalling | onerror!');

      };
      vm.audioCalling.onloadstart = function () {
        console.log('AudioCalling | onloadstart!');
      };
      vm.audioCalling.onloadeddata = function () {
        console.log('AudioCalling | onloadeddata!');
      };

    }


    function callMessageProcess(data) {

      if (!data) {
        //"Start paska i brak callMessage";
        return;

      } else {

        var callMessage;
        if (data.Content) {
          try {
            callMessage = JSON.parse(data.Content);
          }
          catch (e) {
            callMessage = data.Content;
          }
        }
        else {
          callMessage = data;
        }

        // if(callMessage.contactId)
        //   templateData.contactId = callMessage.contactId;

        if (callMessage.sdp && vm.currCall) {
          //odbieranie polaczenia WebRTC
          vm.currCall.sdp = callMessage.sdp;
          vm.currCall.wCallID = callMessage.callId;


          var promise = vm.audioCalling.play();

          if (promise !== undefined) {
            promise.then(function() {
              // Autoplay started!
            }).catch(function(){
              console.log('UWAGA! Przeglądarka zablokowała Autoplay!');
              // Autoplay was prevented.
            });
          }

          //WebRTCService.takeCall(callMessage.sdp, vm.currCall.callID);
        } else {
          console.log('Nie odgrywamy nagrania')
        }

        if (callMessage && callMessage.status && vm.audioCalling
          && callMessage.status !== 'RINGING') {
          vm.audioCalling.pause();
        }

        converCallToCurrCall(callMessage);

        // tu może być bład!!!
        if (!vm.active) {

          if (callMessage.status !== CallStatusConst.disconnected) {
            openBar();
          } else {
            //pojawia się drugi disconnect i nic nie rób
            return;
          }
        }


        var callLocal = getCurrCall();


        //przypadek odświeżenia strony F5
        if (callLocal && !vm.currCall) {
          vm.currCall = callLocal;
        }
        if (callLocal) {
          if (callMessage.userWalletSubAccount) {
            vm.currCall.subAccount = callMessage.userWalletSubAccount;
          }
          if (callMessage.userPremiumMinutesRemain) {
            vm.currCall.minutesRemain = callMessage.userPremiumMinutesRemain;
          }
          //sprawdzanie czy rozmowa toczy sie z nowym numerem
          if (callMessage.clientBase && vm.currCall.clientBase.msisdn !== callMessage.clientBase.msisdn) {
            console.log('Bład! Jedna rozmowa już trwa');
            return;
          }
          if ((callMessage.status === 'WAIT4DROP' || callMessage.status === 'RINGING') && vm.currCall.callID === undefined) {
            vm.currCall.callID = callMessage.callId;
          }
        }
        else {
          addCurrCall(callMessage);
        }

        currCallStatusChanged(callMessage);

        if (!vm.currCall.clientDataLoaded || !vm.currCall.serviceDataLoaded) {
          getCurrCallDetails(vm.currCall);

          saveCurrCall();
        }

        // if (vm.currCall.sdp) {
        //   //odbieranie polaczenia WebRTC
        //   takeCall(null, vm.currCall.sdp, vm.currCall.callID);
        // }
      }
    }


    function getCurrCallDetails(currCall) {
      $timeout(function () {
        getServiceDetails(currCall).then(function (data) {
          //succes
          getContactDetails(currCall, vm.userSession.partnerId).then(function (data) {
            //succes
            return data;
          }, function (err) {
            //error
          });
        }, function (err) {
          //error
        });
      }, 2000);
    }

    // Uzupełnia dane o kliencie dla obiektu call i zwraca je w obiekcie (bez ich zapisu)
    function getContactDetails(call, partnerId) {

      var def = $q.defer();

      ContactPartRsc.getContact(partnerId, null, call.clientBase.msisdn).then(function (data) {
        call.clientDataLoaded = true;

        call.clientBase.name = data.name;
        call.clientBase.age = data.age;
        call.clientBase.surname = data.surname;

        def.resolve(call);
      }, function (err) {
        def.reject(err);
      });
      return def.promise;
    }

    // Uzupełnia dane o servisie dla obiektu call i zwraca je w obiekcie (bez ich zapisu)
    function getServiceDetails(call) {

      var def = $q.defer();

      DynamicFactory.get('ServicePartRsc', 'GetServiceDesc')(call.serviceId, call.prefixId).then(function (data) {
        call.serviceDataLoaded = true;
        call.serviceData = data;

        if (call.serviceData.serviceDesc) {
          call.serviceData.serviceDescShort = call.serviceData.serviceDesc.substring(0, 120);
          if (call.serviceData.serviceDesc.length > 120) {
            call.serviceData.serviceDescShort += '...';
          }
        }

        def.resolve(call);
      }, function (err) {
        def.reject(err);
      });
      return def.promise;
    }

    function callinfoBarClicked() {
      console.log('Callinfoobar clicked -> openCommunicatorForCallSession');
      communicatorService.openCommunicatorForCallSession(vm.currCall.callID);
    }

    function openBar($event) {
      if (!vm.active) {

        vm.active = true;
        vm.minimized = false;
        callInfoBarService.setActive(vm.active);


      } else {
        if (vm.minimized) {
          vm.minimized = false;
        }
      }
    }

    function minimizeBar($event) {

      $event.stopPropagation();

      vm.active = true;
      callInfoBarService.setActive(vm.active);
      vm.minimized = true;
    }

    function closeBar() {
      vm.active = false;
      callInfoBarService.setActive(vm.active);
      vm.minimized = false;
    }

    function callForwarding($event, currCall) {
      $event.stopPropagation();
      console.log('callForwarding');
      openCallForwardingModal($event, '<service-consultant actionid="' + currCall.actionId + '" callid="' + currCall.callID + '"></service-consultant>')
        // openCallForwardingModal($event, '<assign-dialog></assign-dialog>')
        .then(function (result) {
          if (result) {
            vm.data = result;
          }
        });
    }

    function openCallForwardingModal(ev, content) {
      return $mdDialog.show({
        locals: {
          selectedMail: vm.data
        },
        template: content,
        //template: '<md-dialog-content>' + content + '</md-dialog-content>',
        controller: function (selectedMail) {
          this.selectedMail = selectedMail;
        },
        controllerAs: 'vm',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true //,
      })
    }

    function showForwardMsg(ev, content) {
      toastService.showToast(content.forwardText, 'message', 10);
    }
    function setMicrophone(enabled) {
      if (enabled) {
        WebRTCService.setMicrophone(enabled);
      } else {
        WebRTCService.setMicrophone(!vm.microphoneEnabled);
        vm.microphoneEnabled = !vm.microphoneEnabled;
      }
    }
    function helpRequestProcess(consultant, stopFunc, help) {
      //bridgeUUID
      console.log('consultant: ', consultant);
      var helpUUID = consultant.callID;
      if (consultant.callType === 'OUT') {
        helpUUID = consultant.bridgeID;
      }
      vm.stopFunc = stopFunc;
      var serviceID = consultant.ccServiceID ? consultant.ccServiceID : consultant.serviceID;
      var serviceName = consultant.ccServiceName ? consultant.ccServiceName : consultant.serviceName;

      if (WebRTCService.getActiveCall() === undefined) {
        DynamicFactory.get('PhoneCallRsc', 'callHelp')(helpUUID)
          .then(function (res) {
            if (!res || (res && !res.guid)) {
              WebRTCService.makeCall('ev/' + helpUUID, {
                serviceID: serviceID,
                serviceName: serviceName,
                contactID: consultant.contactId,
                bundleID: consultant.bundleID,
                consultant: consultant.alias ? consultant.alias : (consultant.firstName + ' ' + consultant.lastName),
                consultantID: consultant.consultantID,
                userHelp: vm.userSession.userId,
                callerMsisdn: consultant.msisdn
              }, vm.helpReceiverMsgCall).then(function () {
                WebRTCService.setMicrophone(false);
                help.active = true;
                // vm.currentHelp = consultant.callID;
              }, function (err) {
                toastService.showToast($translate.instant('CALLINFOBAR.ERROR_CHECK_HEADPHONE'), 'error', 4);
              });
            }
            else {
              toastService.showToast($translate.instant('CALLINFOBAR.HELP_MANAGER.EXISTS'), 'error', 4);
            }
          });
      }
      //  else if (WebRTCService.getActiveCall() === false) {
      //   //??czy to wogole sie wywoluje??
      //   communicatorService.removeSession(consultant.callID, 'I');
      //   WebRTCService.disconnectCall('ev/' + consultant.callID);
      // }
    }
    function helpReceiverMsgCall(msg) {
      console.log('helpReceiverMsgCall - msg: ', msg);
      try {
        msg.Content = JSON.parse(msg.Content);
      }
      catch (e) {
      }

      if (msg.Content.detailsRecord && msg.Content.detailsRecord.userHelp
        && parseInt(msg.Content.detailsRecord.userHelp) === vm.userSession.userId) {
        if (msg.Content.status === CallStatusConst.wait4drop) {
          msg.Content.helpSession = true;
          msg.Content.contactId = msg.Content.detailsRecord ? msg.Content.detailsRecord.contactID : msg.Content.contactId;
          msg.Content.bundleID = msg.Content.detailsRecord ? msg.Content.detailsRecord.bundleID : msg.Content.bundleID;
          msg.Content.params = msg.Content.detailsRecord;
          msg.Content.ani = msg.Content.detailsRecord ? msg.Content.detailsRecord.callerMsisdn : null;
          console.log('helpReceiverMsgCall - w4r: ', msg);

          DynamicFactory.get('PhoneCallRsc', 'callHelpInsert')((msg.Content.params.number).replace('ev/', ''), msg.Content.params.consultantID)
            .then(function (res) {

            });

          callInfoBarBridge.addCall(msg);
          communicatorService.sessionAddFromCall(msg);
        }
        else if (msg.Content.status === CallStatusConst.disconnected
          && vm.currCall && vm.currCall.callID === msg.Content.callId) {
          console.log('helpReceiverMsgCall - disconnect: ', msg);
          stopHelp();
        }
      }
    }
    function stopHelp() {
      communicatorService.removeSession(vm.currCall.callID, 'I');
      WebRTCService.disconnectCall(vm.currCall.params.number);

      vm.currCall.status = CallStatusConst.disconnected;
      vm.currCall.callEndTime = new Date(); // timer STOP!
      vm.currCall.timerStopped = true;

      DynamicFactory.get('PhoneCallRsc', 'callHelpUpdate')((vm.currCall.params.number).replace('ev/', ''), vm.currCall.params.consultantID)
        .then(function (res) {

        });

      $timeout(function () {
        callInfoBarService.removeCurrCall(vm.currCall.callID);
        $timeout(0);
      }, 3000);
      if (vm.stopFunc) {
        vm.stopFunc();
      }
      if (callInfoBarService.globalStopHelpFunc) {
        callInfoBarService.globalStopHelpFunc(vm.currCall);
      }
    }
    function reBindHelpSocket(msg) {
      if (msg) {
        var content = msg.Content ? msg.Content : msg;
        if (content.helpSession) {
          WebSocketManager.registerWebSocketMethod('CallOut', 'callBridge', vm.helpReceiverMsgCall);
        }
      }
    }

    vm.myStyle = { "stroke-dashoffset": "440" };

    vm.limit = 60;
    vm.max = 163.3;

    function onInit() {
      vm.timerStarTime = new Date();
    }

    $scope.$on('timer-tick', function (event, args) {
      //console.log(args);
      if (args.millis > 0) {  ///wywalamy puste przebiegi
        vm.counter = args.seconds;
        var l = vm.counter * (vm.max / vm.limit);
        if (l + 1 > vm.max) {
          l = vm.max - 1;
        }
        vm.myStyle = { "stroke-dashoffset": vm.max - l };
      }
    });

  }

})();

(function () {
  'use strict';

  angular
    .module('callInfoBar')
    .service('callInfoBarBridge', Service);

  /** @ngInject */
  function Service(CallStatusConst, callInfoBarService, DynamicFactory, callSessionManager) {

    var $self = this;

    $self.startBrigeCall = startBrigeCall;
    $self.showCallNotifications = showCallNotifications;
    $self.addCall = addCall;
    $self.helpRequest = helpRequest;
    $self.webSocketsRegister = webSocketsRegister;

    oinit();

    function oinit() {
      $self.consultantCall = {};
      $self.clientCall = {};
      $self.consultantId = 0;
    }


    function startBrigeCall(clientCall, clientCall2, consultantId, orderGuid, minutesLeft, contactID, serviceID, bundle, configID, managerID, funcSuccess, funcError) {

      $self.consultantCall = clientCall;
      $self.clientCall = clientCall2;
      $self.consultantId = consultantId;
      $self.orderGuid = orderGuid;
      $self.minutesLeft = minutesLeft;

      // np: {msisdn: "4043", name: "Adam", age: "29", location: "Poznan"}
      DynamicFactory.get('PhoneCallRsc', 'startCallBrige')({ phoneNo: $self.consultantCall.msisdn, consultantId: $self.consultantId, orderGuid: $self.orderGuid, minutesLeft: $self.minutesLeft, serviceID: serviceID }, { phoneNo: $self.clientCall.msisdn, contactID: contactID, bundle: bundle, configID: configID, managerID: managerID }).then(function (data) {
        console.log("Połaczenie tel typu brige start... ");
        if (funcSuccess) {
          funcSuccess(data);
        }
      }, funcError);

    }

    function showCallNotifications(data) {

      var callMessageContent = JSON.parse(data.Content);

      //kolejność defaultowa: ringing,answered,RINGING,WAIT4DROP,DISCONNECTED
      if (callMessageContent.status === CallStatusConst.ringing ||
        callMessageContent.status === CallStatusConst.answered ||
        callMessageContent.status === CallStatusConst.wait4drop ||
        callMessageContent.status === CallStatusConst.disconnected ||
        callMessageContent.status === CallStatusConst.failed) {


        var obj = angular.copy(callMessageContent);// { ani: callMessageContent.ani, status: callMessageContent.status, leg: callMessageContent.leg };
        if (data.Token.indexOf(":CallOut") > -1) {
          obj.ani = callMessageContent.dni?callMessageContent.dni.toLowerCase().replace('freetdm/2/a/0', '').replace('freetdm/2/a/15', '').replace('user/', ''):'';
          obj.dni = callMessageContent.ani;
          obj.isCallOut = true;
          callInfoBarService.processCallNotification(obj);
        }

        if (callMessageContent.leg === "A") {
          console.log('Call Bridge status for constultant: ' + callMessageContent.status);

          if (CallStatusConst.ringing === callMessageContent.status) {
            callInfoBarService.processCallNotification(obj);
          } else if (CallStatusConst.disconnected === callMessageContent.status) {
            //zmiana statusu z hangup na disconnected!!!!!!
            obj.status = CallStatusConst.disconnected;
            callInfoBarService.processCallNotification(obj);
          } else if (CallStatusConst.failed === callMessageContent.status) {
            callInfoBarService.processCallNotification(obj);
          }


        }

        if (callMessageContent.leg === "B") {
          console.log('Call Bridge status for clint: ' + callMessageContent.status);

          if (CallStatusConst.ringing === callMessageContent.status) {
            callInfoBarService.processCallNotification(obj);
          }
          else if (CallStatusConst.wait4drop === callMessageContent.status) {
            obj.start = new Date();// czas startu rozmowy
            callInfoBarService.processCallNotification(obj);
          }
          else if (CallStatusConst.disconnected === callMessageContent.status) {
            //zmiana statusu z hangup na disconnected!!!!!!
            obj.status = CallStatusConst.disconnected;
            callInfoBarService.processCallNotification(obj);
          } else if (CallStatusConst.failed === callMessageContent.status) {
            callInfoBarService.processCallNotification(obj);
          }


        }
      }
      else {
        console.log('Bład! Nieobsługiwany status: ' + callMessageContent.status)
      }

    }

    function addCall(call) {
      callInfoBarService.processCallNotification(call);
    }
    function helpRequest(consultant, stopFunc, help) {
      callInfoBarService.helpRequest(consultant, stopFunc, help);
    }
    function webSocketsRegister(){
      callInfoBarService.registerWebSockets();
    }
  }
}()
);


/**
 * Created by kosski on 29.03.2017.
 */
(function () {
  'use strict';

  angular.module('tripleView', [])
    .component('tripleView', {
      templateUrl: 'app/main/contactcenter/components/tripleview/tripleview.html',
      controllerAs: 'vm',
      bindings: {
        arrayStyle: '@',
        doNotShowSidepanel:'<'
      },
      controller: tripleView
    });

  /** @ngInject */
  function tripleView($state, $scope,  tripleviewService) {
    var vm = this;

    // vm.changeInnerState = changeInnerState;
    // vm.changeMenu = changeMenu;
    // vm.changeState = changeState;
    // vm.giveMeSomeStyle = giveMeSomeStyle;
    // vm.overrideRole = overrideRole;
    // vm.corectClassForMdListItem = corectClassForMdListItem;
    //OBSOLETE W CHUJ
    //vm.setSidenavItem = setSidenavItem;
    vm.addMenuItem = addMenuItem;
    vm.brodcastAction = brodcastAction;
    vm.hideActionBar = hideActionBar;
    vm.showActionBar = showActionBar;
    vm.doSome = doSome;
    vm.goBack = goBack;
    vm.populateStateHistory = populateStateHistory;
    vm.clearActions = clearActions;
    // lifecycle hook's przypisujemy na końcu :)
    vm.$onDestroy = onDestroy;
    vm.$postLink = postLink;
    vm.$onInit = init;
    vm.toogleSidenav = toogleSidenav;

    function init() {
      vm.menu = [];
      vm.statesHistory = [];
      vm.sidenavContent = {};
      vm.tripleviewService = tripleviewService;
      vm.hideActions = true;
      $scope.$on('globalAction', globalAction);
    }

    function postLink() {
      if ($state.params.startState && !vm.inited) {
        vm.paramsState = $state.params;
        changeState($state.params.startState);
      }
      vm.inited = true;
    }

    function toogleSidenav() {
      vm.tripleviewService.toogleSidenav();
    }

    function onDestroy() {
      vm.menu = undefined;
      vm.statesHistory = undefined;
      // tripleviewService.sidenavData = {};
    }

    function changeState(state) {
      // console.log('params state forwarded: ',vm.paramsState);
      if (vm.paramsState) {
        $state.go(state, vm.paramsState);
      } else {
        $state.go(state);
      }
      vm.currentState = state;
    }

    function globalAction(event, eventData) {
      // console.log(eventData);
      if (eventData.eventId) {
        $scope.$broadcast(eventData.eventId, eventData.data);
      }
      $scope.$broadcast('broadcastAction', eventData);
    }




    function clearActions() {
      vm.menu = [];
    }

    function doSome(action) {
      if (action.func) {
        action.func();
      }
      if (action.eventId) {
        brodcastAction(action.eventId);
      }
    }

    function brodcastAction(eventId) {
      $scope.$broadcast(eventId);
    }


    function addMenuItem(item) {
      try {
        if (item.name && item.func) {
          for (var pos in vm.menu) {
            if (vm.menu[pos].name === item.name) {
              console.warn('Tripleview warning: Menu item with ' + item.name + 'already exist.');
              return;
            }
          }
          vm.menu.push(item);
        } else {
          throw 'Invalid menu object properties (name: ' + item.name + ').';
        }
      } catch (e) {
        console.error('Tripleview error: ' + e);
      }
    }

    function goBack() {
      if (vm.statesHistory.length > 0) {
        vm.back = true;
        var state = vm.statesHistory[vm.statesHistory.length - 1];
        $state.go(state.name, state.params);
        vm.statesHistory.pop();
      }
    }

    function populateStateHistory(stateName, stateParams) {
      if (!vm.back) {
        vm.statesHistory.push({
          name: stateName,
          params: stateParams
        });
        if (vm.statesHistory.length > 15) {
          vm.statesHistory.shift();
        }
      } else {
        vm.back = undefined;
      }
    }

    function hideActionBar() {
      vm.hideActions = true;
    }

    function showActionBar() {
      vm.hideActions = false;
    }


    // function stateChangeStart(evt, to, params) {
    //   if (Object.keys(params).length > 1) {
    //     vm.paramsState = angular.copy(params);
    //     // delete vm.paramsState.menu;

    //     delete vm.paramsState.startState;
    //     delete vm.paramsState.templateKey;

    //     // vm.paramsState = ovverideParams(vm.paramsState,params);
    //     vm.paramsState = ovverideParams(params,to.params);
    //     params = vm.paramsState;
    //     // console.log('params state forwarded: ',vm.paramsState);
    //   }
    //   if (params.menu) {
    //     vm.statesJson = params.menu;
    //     evalMenuRoles();
    //   }
    // }


    // function stateChangeSuccess(event, toState, toParams, fromState, fromParams) {
      // vm.menu = $filter('filter')(vm.menu, {
      //   unremovable: true
      // });
      // if (!fromState.redirectTo)
      // //   vm.populateStateHistory(fromState.name, fromParams);
      // vm.currentState = toState.name;
      // if (toState.redirectTo) {
      //   // evt.preventDefault();
      //   $state.go(toState.redirectTo, vm.paramsState, {
      //     location: 'replace'
      //   });
      // }

      // w przypadku gdy kilkamy w nadrzedny state, ktory ma ustawiony StartState co powinno odesłać nas do startState, ale że normalnie robi sie w postLink ktory nie jest wołany bez zmiany state)
      // if(toParams.startState && toParams.startState!== vm.currentState && fromState.parent=== toState.name){
      //   changeState(toParams.startState);
      // }


      // vm.hideActions = true;
      // if (!toParams.keepSidenavData)
      //   tripleviewService.sidenavData = {};

    // }


    // function ovverideParams(oldParams, newParams) {
    //   if (newParams) {
    //     var newParamsKeys = Object.keys(newParams);
    //     newParamsKeys.forEach(function (param) {
    //       if (oldParams[param] && newParams[param]) {
    //         oldParams[param] = newParams[param];
    //       }
    //     });
    //   }
    //   return oldParams;
    // }


    // function evalMenuRoles() {
    //   var param = getLocalParams();
    //   for (var key in vm.statesJson) {
    //     vm.statesJson[key].evalHide = evalRole(vm.statesJson[key].hide, param);
    //     vm.statesJson[key].evalDisabled = evalRole(vm.statesJson[key].disabled, param);
    //     giveMeSomeStyle(vm.statesJson[key]);
    //   }
    //   buildStateArray();
    // }

    // function evalRole(role, param) {
    //   if (angular.isDefined(role)) {
    //     // if (result === null) {
    //     //   return false;
    //     // } else {
    //       if (typeof role == 'boolean') {
    //         return role;
    //       } else {
    //         var result = $scope.$eval(role, param);
    //         return result !== '' ? result : false;
    //       }
    //     // }
    //   } else return false;
    // }

    // function overrideRole(menuPosition) {
    //   //console.log("overrideRole - mp: ",menuPosition);
    //   if (angular.isArray(menuPosition))
    //     menuPosition.forEach(function (menuItem) {
    //       setRolesOf(menuItem);
    //     });
    //   else
    //     setRolesOf(menuPosition);
    //   // vm.stateArray[menuPosition][isDisabled ? 'disabled' : 'hide'] = value ? 'true': 'false';
    //   evalMenuRoles();
    // }

    // function setRolesOf(menuItem) {
    //   if (angular.isDefined(menuItem.hide))
    //     vm.statesJson[menuItem.name].hide = menuItem.hide;
    //   if (angular.isDefined(menuItem.disabled))
    //     vm.statesJson[menuItem.name].disabled = menuItem.disabled;
    // }

    // function getLocalParams() {
    //   var param;
    //   if (vm.paramsState) {
    //     param = angular.copy(vm.paramsState);
    //   } else {
    //     param = {};
    //   }
    //   param.angular = angular;
    //   param.authRolesConst = authRolesConst;
    //   param.SessionManager = SessionManager;
    //   return param;
    // }

    // function giveMeSomeStyle(item) {
    //   item.customStyle = '';
    //   if (vm.arrayStyle) {
    //     item.customStyle += vm.arrayStyle + ' ';
    //   }
    //   if (item.style) {
    //     item.customStyle += item.style;
    //   }
    // }


        // function addAction(event, eventData) {
    //   // console.log('addAction', eventData);
    //   if (eventData === 'clear') {
    //     clearActions();
    //     return;
    //   }
    //   // if (angular.isArray(eventData)) {
    //   //   eventData.forEach(function (item) {
    //   //     loadButton(getButton(item));
    //   //   });
    //   // } else {
    //   //   loadButton(getButton(eventData));
    //   // }
    // }


    // function actionExist(button) {
    //   var result = false;
    //   vm.menu.forEach(function (item) {
    //     if (button.eventId === item.eventId) {
    //       result = true;
    //     }
    //   });
    //   return result;
    // }
    // function setSidenavItem(item) {
    //   //dodać validacje;      vm.basic = item;
    // }


    // function back() {
    //   vm.back = true;
    //   changeState(vm.statesHistory.pop());
    //   if (vm.statesHistory.length === 0){
    //     vm.backButton.hide = true;
    //   }
    // }

    // function getButton(action) {
    //   let result;
    //   if (angular.isString(action)) {
    //     switch (action) {
    //       case 'return':
    //         result = {
    //           eventId: 'return',
    //           func: back,
    //           order: -20,
    //           icon: 'icon-keyboard-return'
    //         };
    //         break;
    //       default:
    //         result = action;
    //     }
    //   } else {
    //     result = action;
    //   }
    //   if (!result.order) {
    //     result.order = vm.menu.length;
    //   }
    //   if (!result.eventId) {
    //     console.log('Przycisk powinien mieć zdefiniowany EventId!!', result);
    //     result.eventId = 'None';
    //   }
    //   return result;
    // }

    // function loadButton(button) {
    //   if (!actionExist(button))
    //     vm.menu.push(button);
    //   else {
    //     console.log('Akcja istnieje: ' + button.eventId);
    //   }
    // }

    // function remember(state) {
    //   if (state) {
    //     // let previosIndex = vm.statesHistory.indexOf(state);
    //     // if (previosIndex !== -1) {
    //     //   vm.statesHistory = vm.statesHistory.splice(previosIndex, 1);
    //     // }
    //     vm.statesHistory.push(state);
    //   }
    // }

    //menu manager
    // function buildStateArray(){
    //   vm.stateArray = Object.values(vm.statesJson);

    // }
    // function corectClassForMdListItem(item) {
    //   var currClass;
    //   currClass = (item.state == vm.currentState ? 'selected' : '') + ' ' + item.customStyle;
    //   item.title ? currClass += ' title' : '';
    //   item.subNavbar ? currClass += ' subNavbar' : '';

    //   return currClass;

    // }

  }

})();

(function() {
    'use strict';

    angular
        .module('tripleView')
        .service('tripleviewService', tripleviewService);

        /** @ngInject */
        function tripleviewService($timeout, chooseDateTime) {
            var vm = {
                sidenavData: {},
                tripleviewData: {},
                hideSidenav: false,
                panelClicked: false,
                toogleSidenav: toogleSidenav
            };
            vm.sidenavData.listDate = chooseDateTime.listDate;
            vm.sidenavData.params = {};





            function toogleSidenav() {
                vm.hideSidenav = !vm.hideSidenav;
                vm.panelClicked = true;
                $timeout(function () {
                  vm.panelClicked = false;
                }, 300);

              }
            return vm;
        }
})();

/**
 * Created by kosski on 08.09.2016.
 */
(function () {
  'use strict';

  angular.module('taSearch', [])
    .component('taSearch', {
      templateUrl: 'app/main/contactcenter/components/tasearch/tasearch.html',
      controllerAs: 'vm',
      bindings: {
        conf: '=',
        source: '<',
        ngModel: '='
      },
      controller: taSearch
    });

  /** @ngInject */
  function taSearch($filter) {
    var vm = this;

    vm.formatReportObj = formatReportObj;
    vm.selectedReportItem = selectedReportItem;
    vm.reportSearch = reportSearch;

    // vm.$onInit = onInit;
    // vm.$onChanges = onChanges;

    // vm.$postLink = postLink;


    // function onInit() {

    // }

    // function postLink() {

    // }

    // function onChanges(changesObj) {

    // }

    function reportSearch(text) {
      return $filter('filter')(vm.conf.objList, {
        $: text
      });
    }

    function selectedReportItem(selectedObject) {
      if(vm.selectedObject !== null){
        vm.ngModel = vm.conf.filter ? vm.selectedObject[vm.conf.filter] : vm.selectedObject;
      }else vm.ngModel = undefined;
      // return vm.selectedObject;
    }

    function formatReportObj(item) {
      var format = vm.conf.format;
      return format ?
        angular.isFunction(format) ? format(item) : item[format] :
        item;
    }

  }

})();

/**
 * Created by kosski on 08.09.2016.
 */
(function () {
  'use strict';

  angular.module('taMultiselect', [])
    .component('taMultiselect', {
      templateUrl: 'app/main/contactcenter/components/tamultiselect/tamultiselect.html',
      controllerAs: 'vm',
      bindings: {
        writeMode: '=',
        selectCallback: '=',
        ngDisabled: '=',
        label: '@',
        customClass: '@',
        tagOverflow: '=',
        // choosenTags: '=',
        // tagsSource: '=',
        // chooseCallback: '=',
        // removeCallback: '='
        conf: '=',
        source: '<',
        ngModel: '='
      },
      controller: taMultiSelect
    });

  /** @ngInject */
  function taMultiSelect($scope, toastService) {
    var vm = this;

    vm.selectDamn = selectDamn;
    vm.addTag = addTag;
    vm.tagSearch = tagSearch;
    vm.updateModel = updateModel;
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;

    vm.$postLink = postLink;


    function onInit() {
      vm.searchText = '';
      // if(vm.ngDisabled)
      //   decodeModel();
      // vm.output = [];
      if (vm.conf) {
        vm.token = vm.conf.token;
      } else if (vm.label) {
        vm.token = vm.label;
      }
      vm.id = $scope.$id;
    }

    function postLink() {
      if (vm.tagOverflow)
        setTimeout(setOverflow, 500);
    }

    function onChanges(changesObj) {
      if (!vm.ngModel)
        vm.ngModel = '';
      if (changesObj.source && changesObj.source.currentValue) {
        // var source = changesObj.source.currentValue;
        vm.tags = vm.source;
      } else {
        // vm.tags =[];
        if (!vm.source) {
          vm.source = makeSource(vm.ngModel.split(','));
          vm.tags = vm.source;
        }
        // vm.tags = vm.ngModel.split(',').map(function(item){
        //   return { tagId: item };
        // });
      }
      decodeModel();
    }

    function setOverflow() {
      var containerWidth = angular.element(document.getElementById('tags-container-' + $scope.$id))[0].clientWidth;
      // console.log('taMultiselect | containerWidth: ', containerWidth);

      var chipsWidth = vm.output.map(function (chip) {
        var divElement = angular.element(document.getElementById('tag-' + chip.tagId + '-' + $scope.$id))[0]
        // console.log('taMultiselect | chip: ','tag-'+chip.tagId+'-'+$scope.$id,divElement)
        if (divElement.offsetWidth) {
          return divElement.offsetWidth + 14;
        } else {
          console.log('taMultiselect | brak szerokosci elementu');
        }
      });
      // console.log('taMultiselect | chipsWidth: ', chipsWidth);
      var breakIndex = findBreakIndex(chipsWidth, containerWidth);
      if(breakIndex){
        vm.output = _.take(vm.output,breakIndex);
        vm.output.push({
          special: '...',
        });
      }
    }

    function findBreakIndex(chipsWidth, containerWidth) {
      for (var i = 0; i < chipsWidth.length; i++) {
        var element = chipsWidth[i];
        if (containerWidth - element - 30 >= 0) {
          containerWidth -= element;
        } else return i;
      }
    }

    function addSelection(newTag) {
      if (noDuplicated(newTag))
        if (angular.isObject(newTag)) {
          return newTag;
        }
    }

    function updateModel() {
      vm.ngModel = codeList(vm.output).join(',');
      if (vm.tagOverflow)
        setOverflow();
    }

    function addTag(newTag) {
      // if (noDuplicated(newTag))
      //     if (angular.isObject(newTag)) {
      //         if (angular.isDefined(vm.chooseCallback))
      //             vm.chooseCallback(newTag);
      //         return newTag;
      //     }
      //     else {
      if (vm.writeMode && !newTag.tagId) {
        var preparedTag = {
          tagId: 'new',
          token: newTag,
          value: newTag
        };
        if (angular.isDefined(vm.writeMode)) {
          if (angular.isFunction(vm.writeMode)) {
            vm.writeMode(preparedTag).then(function (data) {
              //console.log('data: ',data);
              vm.updateModel();
            });
          } else {
            vm.updateModel();
          }
        }
        return preparedTag;
      } else return newTag;
      //return newTag;
      // }
    }

    function codeElement(elem) {
      return elem.token + '';
    }

    function codeList(list) {
      return list.map(codeElement);
    }

    function decodeModel() {
      vm.output = [];
      var output = vm.ngModel.split(',');
      var codedSource = codeList(vm.source);
      output.forEach(function (elem) {
        if (elem !== '') {
          var indexMatch = codedSource.indexOf(elem);
          if (indexMatch !== -1) {
            vm.output.push(vm.source[indexMatch]);
          }
        }
      });
    }

    function makeSource(sourceArray) {
      return sourceArray.map(function (item) {
        return {
          tagId: item,
          value: item,
          token: item
        }
      });
    }

    function noDuplicated(newTag) {
      if (vm.output)
        vm.output.forEach(function (tag) {
          if (newTag === tag) {
            return false;
          }
        });
      return true;
    }

    function tagSearch(query) {
      if (!vm.source) return [];
      if (query === '') {
        return vm.source;
      }
      var results = [];
      vm.source.forEach(function (tag) {
        var row = stringifyRow(tag).toLowerCase();
        if (row.indexOf(query.toLowerCase()) !== -1) {
          results.push(tag);
        }
      });
      return results;
    }

    function stringifyRow(obj) {
      var result = '';
      for (var key in obj) {
        if (obj[key])
          result += obj[key];
      }
      return result;
    }

    function selectDamn(chip) {
      if (vm.selectCallback) {
        chip.selected = !chip.selected;
        vm.selectCallback(chip);
      }
    }

    function error(err) {
      toastService.showToast('Coś poszło nie tak...', 'error', 4);
    }
  }

})();

/**
 * Created by kosski on 08.09.2016.
 */
(function () {
    'use strict';

    angular.module('tagsPicker', [])
        .component('tagsPicker', {
            templateUrl: 'app/main/contactcenter/components/tags/tags.html',
            controllerAs: 'vm',
            bindings: {
                writeMode: '=',
                choosenTags: '=',
                tagsSource: '=',
                chooseCallback: '=',
                removeCallback: '='
            },
            controller: tagsPicker
        });

    /** @ngInject */
    function tagsPicker($mdDialog, toastService) {
        var vm = this;

        vm.addTag = addTag;
        vm.tagSearch = tagSearch;
        vm.$onInit = onInit;
        vm.$postLink = postLink;

        function onInit() {
            vm.searchText = '';
        }

        function postLink() {
            // vm.writeMode = vm.writeModeOptions !== undefined;
            vm.tags = vm.tagsSource;
        }

        function addTag(newTag) {
            if (noDuplicated(newTag))
                if (angular.isObject(newTag)) {
                    if (angular.isDefined(vm.chooseCallback))
                        vm.chooseCallback(newTag);
                    return newTag;
                }
                else {
                    if (vm.writeMode) {
                        var preparedTag = {
                            id: 'new',
                            tag: newTag
                        };
                        showDialog(newTag);
                        return preparedTag;
                    }
                }
        }

        function noDuplicated(newTag) {
            if (vm.choosenTags)
                vm.choosenTags.forEach(function (tag) {
                    if (newTag === tag) {
                        return false;
                    }
                });
            return true;
        }

        function tagSearch(query) {
            if (query === '') {
                return vm.tagsSource;
            }
            var results = [];
            vm.tagsSource.forEach(function (tag) {
                if (tag.tag.indexOf(query) !== -1) {
                    results.push(tag);
                }
            });
            return results;
        }

        function showDialog(newTag) {
            $mdDialog.show({
                locals: {
                    tagsSource: vm.tagsSource
                },
                controller: DialogController,
                templateUrl: 'app//main//contactcenter//management//services//templates//newtag.template.html',
                parent: angular.element(document.body),
                // targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: false // Only for -xs, -sm breakpoints.
            })
                .then(function (answer) {
                    console.log(answer);
                    // vm.service.tags.push(answer);
                    newTag.parentId = answer.id;
                    vm.chooseCallback(newTag);
                }, function () {
                    console.log('You cancelled the dialog.');
                    vm.service.tags.splice(vm.service.tags.indexOf(newTag), 1);
                });
        }

        /** @ngInject */
        function DialogController($scope, $mdDialog, tagsSource) {
            $scope.tagSearch = tagSearch;
            $scope.hide = hide;
            $scope.cancel = cancel;
            $scope.answer = answer;

            $scope.tagsSource = tagsSource;

            function tagSearch(query) {
                var results = [];
                $scope.tagsPicker.forEach(function (tag) {
                    if (tag.tag.indexOf(query) != -1)
                        results.push(tag);
                });
                return results;
            }

            function hide() {
                $mdDialog.hide();
            }
            function cancel() {
                $mdDialog.cancel();
            }
            function answer(answer) {
                $mdDialog.hide(answer);
            }

        }

        function error(err) {
            toastService.showToast('Coś poszło nie tak...', 'error',4);
        }

        // function createTag(tag, parentId) {
        //     // DynamicFactory.get('tagsRsc', 'addNewTag')
        //     vm.chooseCallback(vm.writeModeOptions.serviceId, tag, parentId)
        //         .then(function (response) {
        //             ngNotify.set('Tag został dodany', 'success');
        //         }, error);
        // }


    }

})();

/**
 * Created by kosski on 08.09.2016.
 */
(function () {
    'use strict';

    angular.module('taFile', [])
        .component('taFile', {
            templateUrl: 'app/main/contactcenter/components/tafile/tafile.html',
            controllerAs: 'vm',
            bindings: {
                conf: '=',
                // source: '=',
                ngModel: '='
            },
            controller: taFile
        });

    /** @ngInject */
    function taFile($mdDialog,  toastService, FileUploader, DynamicFactory) {
        var vm = this;

        vm.saveRec = saveRecord;

        vm.$onInit = onInit;
        vm.$postLink = postLink;
        // vm.$doCheck = doCheck;

        function onInit() {
            vm.searchText = '';
            vm.FileUploader = DynamicFactory.get('FileUploadRsc', 'LoadFileUploader')('fileupload/record',true);
            // vm.recordedInput= {};
            vm.FileUploader.onAfterAddingFile  = function (item) {
                console.log('onAfterAddingFile: ',item);
                // console.log('vm.recordedInput: ',vm.recordedInput);
                if(vm.recordedInput){
                    item._file = vm.recordedInput;
                }
            };
            vm.FileUploader.onBeforeUploadItem = function(item) {
              if(vm.recordedInput)
                item._file = vm.recordedInput;
            };
            vm.FileUploader.onSuccessItem = function (fileItem, response, status, headers) {
                console.info('onSuccessItem', fileItem, response, status, headers);
                vm.ngModel = undefined;
                setTimeout(function(){
                  vm.ngModel = response;
                },1000);
            };
        }

        function postLink() {
            if (!vm.ngModel) {
                vm.ngModel = '';
            }
        }

        function saveRecord(event) {
            console.log('saveRecord - event: ', event);
            if (vm.recordedInput) {
                addFile(vm.recordedInput);
            } else {
                selectFile(event);
            }
        }

        function selectFile(event) {
            angular.element(event.currentTarget.parentNode).find('#fileSelect').trigger('click');
        }

        function addFile(file) {
            var newFile = new FileUploader.FileItem(vm.FileUploader, {
                dateModified: 'today',
                size: file.size,
                type: file.type,
                name: file.name
            });
            vm.FileUploader.queue.push(newFile);

            // vm.FileUploader.uploadItem(newFile);
            // vm.ngModel = newFile;
            vm.FileUploader.uploadAll();
            vm.recordNew = undefined;
        }



        function error(err) {
             toastService.showToast('Coś poszło nie tak...', 'error',4);
        }
    }

})();

/**
 * Created by kosski on 01.12.2016.
 */
(function () {
  'use strict'
  angular
    .module('ta-header', [])
    .component('taHeader', {
      bindings: {
        // actionAdd:'=',
        // search:'='
        // stateName:'=',
        // sideMenuFn:'&'
      },
      templateUrl: 'app/main/contactcenter/components/taHeader/taHeader.html',
      controllerAs: 'vm',
      controller: HeaderController
    });

  /* @ngInject */
  function HeaderController($state, headerConfig, $translate, $scope) {
    var vm = this;
    vm.$doCheck = doCheck;
    vm.state = $state;
    vm.headerConfig = headerConfig;


    // vm.$onChanges = function(changesObj){
    //   console.log('taheader changes', changesObj);
    // };

    //ZMIENIĆ!!!!!!
    function doCheck() {
      // console.log('doCheck');
      if (vm.currentRoute !== vm.state.current.stateTranslationName)
        if (vm.state.current.stateTranslationName) {
          getRouteDecode(vm.state.current.stateTranslationName);
          vm.currentRoute = vm.state.current.stateTranslationName;
        }

    }

    function getRouteDecode(tag) {
      vm.routeDecode = '';
      var splitedTag = tag.split('.');
      decodeRoute(splitedTag);
    }

    function decodeRoute(splitedTag) {
      var currentDecode = splitedTag.shift();
      // if (!translationSum) {
      //   translationSum = '';
      // }
      $translate(currentDecode + '.ROUTE_NAME').then(function (decode) {
        vm.routeDecode = vm.routeDecode + decode;
        if (splitedTag.length === 0) {
          // console.log('decode end ' + vm.routeDecode);
          // vm.routeDecode = translationSum;
        } else {
          // console.log(vm.routeDecode);
          vm.routeDecode += '/';
          splitedTag[0] = currentDecode + '.' + splitedTag[0];
          decodeRoute(splitedTag);
        }
      }, function (translationId) {
        console.log('Brak ścieżki :' + translationId);
        if (splitedTag.length !== 0) {
          splitedTag[0] = currentDecode + '.' + splitedTag[0];
          decodeRoute(splitedTag);
        }
      });
    }

    // vm.toggleSidenav = this.sideMenuFn;
    // vm.stateName = this.stateName;
  }

})();

(function () {
  'use strict';

  angular
    .module('ta-header')
    .service('headerConfig', Service);

  /** @ngInject */
  function Service($rootScope) {
    var vm = this;
    vm.navBar = {
      search: undefined,
      functionAdd: undefined
    };

    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
      if (fromParams.keepSearch===undefined || toParams.keepSearch===undefined) {
        vm.navBar.search = undefined;
      }
      vm.navBar.functionAdd = undefined;
    });

    function changeConfig(val) {
      vm.navBar.search = val;
    }

    return {
      changeConfig: changeConfig,
      navBar: vm.navBar
    }
  }
})();


(function () {
  'use strict';
  // const mime = require('mime-types')
  // var FileSaver = require('file-saver');
  angular.module('serviceConsultant', []).component('serviceConsultant', {
    templateUrl: 'app/main/contactcenter/components/serviceconsultant/serviceconsultant.html',
    controllerAs: 'vm',
    bindings: {
      actionid: '@',
      callid: '@'
    },
    controller: ctrl
  });

  /** @ngInject */
  function ctrl(DynamicFactory, OrderboxGlue, consts, $mdDialog, SessionManager, WebSocketManager, CallStatusConst, $translate) {
    var vm = this;
    
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.callForwarding = callForwarding;
    vm.consultantClick = consultantClick;
    vm.msgSelect = msgSelect;
    vm.closeDialog = closeDialog;


    function onInit() {
      // vm.OrderboxGlue = OrderboxGlue;
      vm.consultants = [];
      vm.reverse = true;
      vm.search = '';
      vm.consultantSelected = {};
      vm.msgSelected = {};
      vm.consultantForward = '';
      vm.myConsultant = {};
      vm.forwardList = [];
      vm.user = SessionManager.getUser();
      vm.isCalling = false;
      console.log('user: ',vm.user);
      console.log('init: ', vm.actionid);
      
      WebSocketManager.registerWebSocketMethod('CallIn', 'callInNotif', callInNotif, buildRegex());
      DynamicFactory.get('ConsultantsRsc', 'getMyConsultantGeneralData')(vm.user.consultantId)
      .then(function (data) {
        vm.myConsultant = data;
      });
      DynamicFactory.get('ContactCenterRsc', 'forwardList')()
      .then(function (data) {
        vm.forwardList = data;
        if(vm.forwardList.length===0){
          vm.forwardList.push({id: 0, text: $translate.instant('SERVICE_CONSULTANT.FORWARD_DESC')});
        }
      });
    }

    function callInNotif(call){
      vm.callContent = JSON.parse(call.Content);
      console.log('callInNotif: ',vm.callContent);
      if (vm.callContent.status === CallStatusConst.failedRedirect) {
        console.log('fail')  ;
        vm.isCalling = false;
        //vm.consultantForward = '';
      }
      else if (vm.callContent.status === CallStatusConst.redirect) {
        console.log('redirect')  ;
        vm.isCalling = false;
        //vm.consultantForward = '';
      }
    }

    function buildRegex() {
      var user = vm.user;
      // var partnerId = user.partnerId;
      console.log('regex: ' + '^ccs\\.' + user.partnerId + '\\/' + user.callCenterId + '\\/' + user.consultantId);
      return '^ccs\\.' + user.partnerId + '\\/' + user.callCenterId + '\\/' + user.consultantId;
    }
    function onChanges(changesObj) {
      if (changesObj.actionid.currentValue) {
        getConsultantService();
      }
    }

    function getConsultantService() {
      console.log('vm.actionid: ', vm.actionid);
      DynamicFactory.get('PhoneCallRsc', 'consultantService')(vm.actionid).then(function (data) {
        vm.consultants = data;
      });
    }

    function consultantClick(consultant){
      console.log('consultant: ',consultant);
      vm.msgSelected = vm.forwardList[0];
      vm.consultantForward = consultant;
      vm.consultantSelected = consultant;
    }

    function msgSelect(consultant, msg){
      vm.msgSelected = msg;
      vm.consultantForward = consultant;
    }

    function callForwarding(){
      DynamicFactory.get('PhoneCallRsc', 'consultantForward')(vm.callid, vm.consultantForward.consultantID, vm.msgSelected.text).then(function (data) {
        //vm.consultantForward = consultant;
        vm.isCalling = true;
      });
    }
    function closeDialog() {
      $mdDialog.hide();
    }
    //
  }
})();

/**
 * Created by kosski on 08.09.2016.
 */
(function () {
  'use strict';

  angular.module('sidenavContent', [])
    .component('sidenavContent', {
      transclude: {
        // 'top': '?top',
        // 'main': '?main',
        // 'actions': '?actions'
      },
      templateUrl: 'app/main/contactcenter/components/sidenavcontent/sidenavcontent.html',
      controllerAs: 'vm',
      bindings: {
        bindingDirection: '@',
        templateKey: '<',
        avatarDisplay: '=',
        avatarEdit: '<',
        hideAvatar: '='
        // defaultAvatar:'<'
      },
      controller: Ctrl
    });

  /** @ngInject */
  function Ctrl(DynamicFactory, $state, tripleviewService,SessionManager,authRolesConst) {
    var vm = this;

    vm.$onDestory = onDestory;
    vm.$onChanges = onChanges;
    vm.$doCheck = doCheck;
    vm.$onInit = onInit;

    function onInit() {
      vm.SessionManager = SessionManager;
      vm.authRolesConst = authRolesConst;
      vm.sidenavData = undefined;
      // changeBulbulator();
      vm.avatarBulbulator = true;
    }

    function doCheck() {
      if (!angular.equals(tripleviewService.sidenavData, vm.sidenavData)) {
        // if (vm.bindingDirection === 'out' && vm.sidenavData) {
        //   tripleviewService.sidenavData = vm.sidenavData;
        // } else {
          vm.sidenavData = tripleviewService.sidenavData;
        // }
        readConfigFields();
        changeBulbulator(vm.avatarDisplay);
      }
      changeDefaultAvatar();
    }

    function onChanges(changesObj) {
      if(changesObj.templateKey)
        if (changesObj.templateKey.currentValue && !angular.equals(changesObj.templateKey.currentValue, changesObj.templateKey.previousValue)){
          changeTemplate(changesObj.templateKey.currentValue);
        }


      // if (changesObj.avatarDisplay.currentValue){
      //   // changeBulbulator(changesObj.avatarDisplay.currentValue)
      //   changeBulbulator();
      // }
      // if (changesObj.avatarEdit.currentValue){
      //   // changeBulbulator(changesObj.avatarDisplay.currentValue)
      //   changeBulbulator();
      // }

    }

    function onDestory() {
      vm.sidenavData = undefined;
      vm.dudeIndicator = undefined;
      vm.callMeMaybe = undefined;
      vm.avatarBulbulator = undefined;
    }

    function changeDefaultAvatar(){
      if($state.current.params && $state.current.params.defaultAvatar){
        if(vm.defaultRyj !== $state.current.params.defaultAvatar)
          vm.defaultRyj = $state.current.params.defaultAvatar;
      } else {
        vm.defaultRyj = 'assets/icons/management/services.png';

      }
    }

    function changeBulbulator(avatarDisplay){
      // if (avatarDisplay)
      //   vm.avatarBulbulator = (avatarDisplay === 'show' || (vm.sidenavData && !vm.sidenavData.subHeader));
      // console.log('bulbulator: ',avatarDisplay);

      if(avatarDisplay!==undefined && avatarDisplay || (vm.sidenavData && !vm.sidenavData.subHeader)){
        vm.avatarBulbulator=true;
      }

      //edycja ważniejsza wiec nadpisuje wyświetlanie
      if(vm.avatarEdit!==undefined && vm.avatarEdit){
        vm.avatarBulbulator=false;
      }

    }

    function readConfigFields() {
      if (vm.sidenavData.subHeader)
        vm.dudeIndicator = vm.sidenavData.subHeader;
      else
        vm.dudeIndicator = 'Nie wybrano żadnego elementu';


      if (vm.sidenavData.avatarCallback)
        vm.callMeMaybe = vm.sidenavData.avatarCallback;
      else
        vm.callMeMaybe = undefined;


      if (vm.sidenavData.photoProp)
        vm.photoProp = vm.sidenavData.photoProp;
      else
        vm.photoProp = 'photoUrl';

      if (vm.sidenavData.uploadEndpoint)
          vm.photoProp = vm.sidenavData.uploadEndpoint;

    }

    function changeTemplate(templateKey) {
      if (!templateKey)
        templateKey = 'defaultSidenav';
      DynamicFactory.get('templatesRsc', 'GetTemplate')(templateKey)
        .then(function (result) {
          vm.template = result;
        });
    }

  }

})();



+function () {
    'use strict';
    angular.module('taPartnerslist',[]).component('taPartnerslist', {
        templateUrl: 'app/main/contactcenter/components/partnerslist/partnerslist.html',
        controllerAs: 'vm',
        bindings: {
            ngModel: '=',
            selectedPartner: '='
        },
        controller: partnersList
    });

    /** @ngInject */
    function partnersList() {
        var vm = this;
        //vm.$onInit = Init;
       // vm.$postLink = postLink;
        vm.setPartner = setPartner;

      //  function postLink() {
            // if (!vm.ngModel)
            //     vm.ngModel = '';
            // else {
            //     decodeModel();
            //     recalculatePriority();
            // }
      //  }
        //function Init() {
        //}
        function setPartner(item){
            vm.selectedPartner = item.id;
        }
    }
}();

/**
 * Created by kosski on 29.03.2017.
 */
(function() {
  "use strict";

  angular.module("optionsMenu").component("optionsMenu", {
    templateUrl:
      "app/main/contactcenter/components/optionsmenu/optionsmenu.html",
    controllerAs: "vm",
    bindings: {
      arrayStyle: "@",
      menuItem: "<"
    },
    controller: optionsMenu
  });

  /** @ngInject */
  function optionsMenu($state, $scope,  SessionManager, authRolesConst, tripleviewService,  MenuItemsManager ) {
    var vm = this;
// /MenuManager,
    vm.brodcastAction = brodcastAction;
    vm.collapseItem = collapseItem;
    vm.changeState = changeState;
    vm.doSome = doSome;
    vm.selectFolder = selectFolder;
    vm.giveMeSomeStyle = giveMeSomeStyle;
    vm.overrideRole = overrideRole;
    vm.corectClassForMdListItem = corectClassForMdListItem;
    vm.$onDestroy = onDestroy;
    vm.$postLink = postLink;
    vm.$onInit = init;
    function init() {
      vm.menu = [];
      // vm.statesJson = $state.params.menu;
      vm.currentState = $state.current.name;
      loadMenuItems(MenuItemsManager.getMenu(vm.menuItem.title));
      if (vm.statesJson) {
        evalMenuRoles(vm.statesJson);
        if ($state.current.stateTranslationName)
          selectFolder($state.current.stateTranslationName);
      }

      console.log("OptionsMenu | forState", $state.get(vm.currentState));
      vm.listener = $scope.$on("$stateChangeSuccess", stateChangeSuccess);
      $scope.$on("$stateChangeStart", stateChangeStart);
      vm.$onChanges = OnChange;
    }

    vm.$onDestroy = function() {
      vm.listener();
    };


    function postLink() {}

    function OnChange(changesObj) {
      if (changesObj.menuItem.currentValue) {
        loadMenuItems(
          MenuItemsManager.getMenu(changesObj.menuItem.currentValue.title)
        );
      }
    }

    function onDestroy() {
      // tripleviewService.sidenavData = {};
    }

    function stateChangeStart(evt, to, params,from) {


      console.log('optionsMenu | stateChangeStart',from.name+ '->' +to.name);
      if(to.stateTranslationName.split('.')[0] !== from.stateTranslationName.split('.')[0]){
        tripleviewService.sidenavData = {};
      }

      // vm.currentState = to.name;
      // if (params && Object.keys(params).length > 1) {
      //   vm.paramsState = angular.copy(params);
      // }
    }

    function loadMenuItems(menu) {
      if (menu) {
        vm.statesJson = angular.isArray(menu) ? menu[0] : menu;
      } else {
        vm.statesJson = [];
      }
      evalMenuRoles(vm.statesJson);
    }

    function collapseItem(item) {
      item.collapse = !item.collapse;
    }

    function changeState(state) {
      // MenuManager.hideMiniMenu = true;
      if (vm.currentState !== state) {
        if (vm.paramsState) {
          $state.go(state, vm.paramsState);
        } else {
          $state.go(state);
        }
        vm.currentState = state;
      }
    }

    function selectFolder(menuTree) {
      var splitedName = menuTree.split(".");
      var folderName = splitedName[0] + "." + splitedName[1];
      vm.folderSelected = vm.statesJson.getMenuItem(folderName);
    }
    function stateChangeSuccess(event,toState,toParams,fromState,fromParams) {
      vm.currentState = toState.name;
      if(vm.folderSelected)
        if(toState.stateTranslationName.split('.')[0] !== vm.folderSelected.name.split('.')[0])
          vm.folderSelected= undefined;
      // if (toState.redirectTo) {
      //   $state.go(toState.redirectTo, vm.paramsState, {
      //     location: "replace"
      //   });
      // }

      // w przypadku gdy kilkamy w nadrzedny state, ktory ma ustawiony StartState co powinno odesłać nas do startState, ale że normalnie robi sie w postLink ktory nie jest wołany bez zmiany state)
      // if (
      //   toParams.startState &&
      //   toParams.startState !== vm.currentState &&
      //   fromState.parent === toState.name
      // ) {
      //   changeState(toParams.startState);
      //   return;
      // }

      // vm.hideActions = undefined;
      // if (!toParams.keepSidenavData) tripleviewService.sidenavData = {};
    }

    function parseMenuTemplate(component) {
      var result =
        "<" + component + ' flex menu-item="item"></' + component + ">";
      return result;
    }

    function prepareActionFunction(menuItem) {
      return function(ev) {
        if (ev) ev.stopPropagation();
        if (menuItem.state) changeState(menuItem.state);
        if (menuItem.template) collapseItem(menuItem);
      };
    }

    function evalMenuRoles(menuitemObj) {
      var param = getLocalParams();
      var menuArray = angular.isArray(menuitemObj) ? menuitemObj : menuitemObj.array[0].submenu;
      menuArray.forEach(function(item) {
        item.action = prepareActionFunction(item);
        item.evalHide = evalRole(item.hide, param);
        item.evalDisabled = evalRole(item.disabled, param);
        if(angular.isUndefined(item.isAdditional)) {
          item.isAdditional=false;
        }
        if (item.state && item.state == vm.currentState) {
          item.collapse = true;
        }
        giveMeSomeStyle(item);
        if (item.component) {
          item.template = parseMenuTemplate(item.component);
        }
        if (item.submenu) {
          evalMenuRoles(item.submenu);
        }
      });
      buildStateArray(menuArray);
    }

    function evalRole(role, param) {
      if (angular.isDefined(role)) {
        if (typeof role == "boolean") {
          return role;
        } else {
          var result = $scope.$eval(role, param);
          return result !== "" ? result : false;
        }
      } else return false;
    }

    function overrideRole(menuPosition) {
      if (angular.isArray(menuPosition))
        menuPosition.forEach(function(menuItem) {
          setRolesOf(menuItem);
        });
      else setRolesOf(menuPosition);
      evalMenuRoles();
    }

    function setRolesOf(menuItem) {
      if (angular.isDefined(menuItem.hide))
        vm.statesJson[menuItem.name].hide = menuItem.hide;
      if (angular.isDefined(menuItem.disabled))
        vm.statesJson[menuItem.name].disabled = menuItem.disabled;
    }

    function getLocalParams() {
      var param;
      if (vm.paramsState) {
        param = angular.copy(vm.paramsState);
      } else {
        param = {};
      }
      param.angular = angular;
      param.authRolesConst = authRolesConst;
      param.SessionManager = SessionManager;
      return param;
    }

    function giveMeSomeStyle(item) {
      item.customStyle = "";
      if (vm.arrayStyle) {
        item.customStyle += vm.arrayStyle + " ";
      }
      if (item.style) {
        item.customStyle += item.style;
      }
    }

    function globalAction(event, eventData) {
      if (eventData.eventId) {
        $scope.$broadcast(eventData.eventId, eventData.data);
      }
      $scope.$broadcast("broadcastAction", eventData);
    }

    function doSome(action) {
      if (action.func) {
        action.func();
      }
      if (action.eventId) {
        brodcastAction(action.eventId);
      }
    }

    function brodcastAction(eventId) {
      $scope.$broadcast(eventId);
    }

    function buildStateArray(statesJson) {
      vm.stateArray = statesJson;
    }
    function corectClassForMdListItem(item) {
      var currClass;
      currClass =
        (item.state == vm.currentState ? "selected " : "") + item.customStyle;

      return currClass;
    }
  }
})();

(function () {
  'use strict';
  angular.module('mimes', [])
    .service('mimeTypes', mimes);

  function mimes() {
    var _this = this;
    _this.mimesString = {
      'application/andrew-inset': 'ez',
      'application/applixware': 'aw',
      'application/atom+xml': 'atom',
      'application/atomcat+xml': 'atomcat',
      'application/atomsvc+xml': 'atomsvc',
      'application/bdoc': 'bdoc',
      'application/ccxml+xml': 'ccxml',
      'application/cdmi-capability': 'cdmia',
      'application/cdmi-container': 'cdmic',
      'application/cdmi-domain': 'cdmid',
      'application/cdmi-object': 'cdmio',
      'application/cdmi-queue': 'cdmiq',
      'application/cu-seeme': 'cu',
      'application/dash+xml': 'mpd',
      'application/davmount+xml': 'davmount',
      'application/docbook+xml': 'dbk',
      'application/dssc+der': 'dssc',
      'application/dssc+xml': 'xdssc',
      'application/ecmascript': 'ecma',
      'application/emma+xml': 'emma',
      'application/epub+zip': 'epub',
      'application/exi': 'exi',
      'application/font-tdpfr': 'pfr',
      'application/font-woff': 'woff',
      'application/font-woff2': 'woff2',
      'application/gml+xml': 'gml',
      'application/gpx+xml': 'gpx',
      'application/gxf': 'gxf',
      'application/hyperstudio': 'stk',
      'application/inkml+xml': 'ink',
      'application/ipfix': 'ipfix',
      'application/java-archive': 'jar',
      'application/java-serialized-object': 'ser',
      'application/java-vm': 'class',
      'application/javascript': 'js',
      'application/json': 'json',
      'application/json5': 'json5',
      'application/jsonml+json': 'jsonml',
      'application/ld+json': 'jsonld',
      'application/lost+xml': 'lostxml',
      'application/mac-binhex40': 'hqx',
      'application/mac-compactpro': 'cpt',
      'application/mads+xml': 'mads',
      'application/manifest+json': 'webmanifest',
      'application/marc': 'mrc',
      'application/marcxml+xml': 'mrcx',
      'application/mathematica': 'ma',
      'application/mathml+xml': 'mathml',
      'application/mbox': 'mbox',
      'application/mediaservercontrol+xml': 'mscml',
      'application/metalink+xml': 'metalink',
      'application/metalink4+xml': 'meta4',
      'application/mets+xml': 'mets',
      'application/mods+xml': 'mods',
      'application/mp21': 'm21',
      'application/mp4': 'mp4s',
      'application/msword': 'doc',
      'application/mxf': 'mxf',
      'application/octet-stream': 'bin',
      'application/oda': 'oda',
      'application/oebps-package+xml': 'opf',
      'application/ogg': 'ogx',
      'application/omdoc+xml': 'omdoc',
      'application/onenote': 'onetoc',
      'application/oxps': 'oxps',
      'application/patch-ops-error+xml': 'xer',
      'application/pdf': 'pdf',
      'application/pgp-encrypted': 'pgp',
      'application/pgp-signature': 'asc',
      'application/pics-rules': 'prf',
      'application/pkcs10': 'p10',
      'application/pkcs7-mime': 'p7m',
      'application/pkcs7-signature': 'p7s',
      'application/pkcs8': 'p8',
      'application/pkix-attr-cert': 'ac',
      'application/pkix-cert': 'cer',
      'application/pkix-crl': 'crl',
      'application/pkix-pkipath': 'pkipath',
      'application/pkixcmp': 'pki',
      'application/pls+xml': 'pls',
      'application/postscript': 'ai',
      'application/prs.cww': 'cww',
      'application/pskc+xml': 'pskcxml',
      'application/rdf+xml': 'rdf',
      'application/reginfo+xml': 'rif',
      'application/relax-ng-compact-syntax': 'rnc',
      'application/resource-lists+xml': 'rl',
      'application/resource-lists-diff+xml': 'rld',
      'application/rls-services+xml': 'rs',
      'application/rpki-ghostbusters': 'gbr',
      'application/rpki-manifest': 'mft',
      'application/rpki-roa': 'roa',
      'application/rsd+xml': 'rsd',
      'application/rss+xml': 'rss',
      'application/rtf': 'rtf',
      'application/sbml+xml': 'sbml',
      'application/scvp-cv-request': 'scq',
      'application/scvp-cv-response': 'scs',
      'application/scvp-vp-request': 'spq',
      'application/scvp-vp-response': 'spp',
      'application/sdp': 'sdp',
      'application/set-payment-initiation': 'setpay',
      'application/set-registration-initiation': 'setreg',
      'application/shf+xml': 'shf',
      'application/smil+xml': 'smi',
      'application/sparql-query': 'rq',
      'application/sparql-results+xml': 'srx',
      'application/srgs': 'gram',
      'application/srgs+xml': 'grxml',
      'application/sru+xml': 'sru',
      'application/ssdl+xml': 'ssdl',
      'application/ssml+xml': 'ssml',
      'application/tei+xml': 'tei',
      'application/thraud+xml': 'tfi',
      'application/timestamped-data': 'tsd',
      'application/vnd.3gpp.pic-bw-large': 'plb',
      'application/vnd.3gpp.pic-bw-small': 'psb',
      'application/vnd.3gpp.pic-bw-var': 'pvb',
      'application/vnd.3gpp2.tcap': 'tcap',
      'application/vnd.3m.post-it-notes': 'pwn',
      'application/vnd.accpac.simply.aso': 'aso',
      'application/vnd.accpac.simply.imp': 'imp',
      'application/vnd.acucobol': 'acu',
      'application/vnd.acucorp': 'atc',
      'application/vnd.adobe.air-application-installer-package+zip': 'air',
      'application/vnd.adobe.formscentral.fcdt': 'fcdt',
      'application/vnd.adobe.fxp': 'fxp',
      'application/vnd.adobe.xdp+xml': 'xdp',
      'application/vnd.adobe.xfdf': 'xfdf',
      'application/vnd.ahead.space': 'ahead',
      'application/vnd.airzip.filesecure.azf': 'azf',
      'application/vnd.airzip.filesecure.azs': 'azs',
      'application/vnd.amazon.ebook': 'azw',
      'application/vnd.americandynamics.acc': 'acc',
      'application/vnd.amiga.ami': 'ami',
      'application/vnd.android.package-archive': 'apk',
      'application/vnd.anser-web-certificate-issue-initiation': 'cii',
      'application/vnd.anser-web-funds-transfer-initiation': 'fti',
      'application/vnd.antix.game-component': 'atx',
      'application/vnd.apple.installer+xml': 'mpkg',
      'application/vnd.apple.mpegurl': 'm3u8',
      'application/vnd.apple.pkpass': 'pkpass',
      'application/vnd.aristanetworks.swi': 'swi',
      'application/vnd.astraea-software.iota': 'iota',
      'application/vnd.audiograph': 'aep',
      'application/vnd.blueice.multipass': 'mpm',
      'application/vnd.bmi': 'bmi',
      'application/vnd.businessobjects': 'rep',
      'application/vnd.chemdraw+xml': 'cdxml',
      'application/vnd.chipnuts.karaoke-mmd': 'mmd',
      'application/vnd.cinderella': 'cdy',
      'application/vnd.claymore': 'cla',
      'application/vnd.cloanto.rp9': 'rp9',
      'application/vnd.clonk.c4group': 'c4g',
      'application/vnd.cluetrust.cartomobile-config': 'c11amc',
      'application/vnd.cluetrust.cartomobile-config-pkg': 'c11amz',
      'application/vnd.commonspace': 'csp',
      'application/vnd.contact.cmsg': 'cdbcmsg',
      'application/vnd.cosmocaller': 'cmc',
      'application/vnd.crick.clicker': 'clkx',
      'application/vnd.crick.clicker.keyboard': 'clkk',
      'application/vnd.crick.clicker.palette': 'clkp',
      'application/vnd.crick.clicker.template': 'clkt',
      'application/vnd.crick.clicker.wordbank': 'clkw',
      'application/vnd.criticaltools.wbs+xml': 'wbs',
      'application/vnd.ctc-posml': 'pml',
      'application/vnd.cups-ppd': 'ppd',
      'application/vnd.curl.car': 'car',
      'application/vnd.curl.pcurl': 'pcurl',
      'application/vnd.dart': 'dart',
      'application/vnd.data-vision.rdz': 'rdz',
      'application/vnd.dece.data': 'uvf',
      'application/vnd.dece.ttml+xml': 'uvt',
      'application/vnd.dece.unspecified': 'uvx',
      'application/vnd.dece.zip': 'uvz',
      'application/vnd.denovo.fcselayout-link': 'fe_launch',
      'application/vnd.dna': 'dna',
      'application/vnd.dolby.mlp': 'mlp',
      'application/vnd.dpgraph': 'dpg',
      'application/vnd.dreamfactory': 'dfac',
      'application/vnd.ds-keypoint': 'kpxx',
      'application/vnd.dvb.ait': 'ait',
      'application/vnd.dvb.service': 'svc',
      'application/vnd.dynageo': 'geo',
      'application/vnd.ecowin.chart': 'mag',
      'application/vnd.enliven': 'nml',
      'application/vnd.epson.esf': 'esf',
      'application/vnd.epson.msf': 'msf',
      'application/vnd.epson.quickanime': 'qam',
      'application/vnd.epson.salt': 'slt',
      'application/vnd.epson.ssf': 'ssf',
      'application/vnd.eszigno3+xml': 'es3',
      'application/vnd.ezpix-album': 'ez2',
      'application/vnd.ezpix-package': 'ez3',
      'application/vnd.fdf': 'fdf',
      'application/vnd.fdsn.mseed': 'mseed',
      'application/vnd.fdsn.seed': 'seed',
      'application/vnd.flographit': 'gph',
      'application/vnd.fluxtime.clip': 'ftc',
      'application/vnd.framemaker': 'fm',
      'application/vnd.frogans.fnc': 'fnc',
      'application/vnd.frogans.ltf': 'ltf',
      'application/vnd.fsc.weblaunch': 'fsc',
      'application/vnd.fujitsu.oasys': 'oas',
      'application/vnd.fujitsu.oasys2': 'oa2',
      'application/vnd.fujitsu.oasys3': 'oa3',
      'application/vnd.fujitsu.oasysgp': 'fg5',
      'application/vnd.fujitsu.oasysprs': 'bh2',
      'application/vnd.fujixerox.ddd': 'ddd',
      'application/vnd.fujixerox.docuworks': 'xdw',
      'application/vnd.fujixerox.docuworks.binder': 'xbd',
      'application/vnd.fuzzysheet': 'fzs',
      'application/vnd.genomatix.tuxedo': 'txd',
      'application/vnd.geogebra.file': 'ggb',
      'application/vnd.geogebra.tool': 'ggt',
      'application/vnd.geometry-explorer': 'gex',
      'application/vnd.geonext': 'gxt',
      'application/vnd.geoplan': 'g2w',
      'application/vnd.geospace': 'g3w',
      'application/vnd.gmx': 'gmx',
      'application/vnd.google-apps.document': 'gdoc',
      'application/vnd.google-apps.presentation': 'gslides',
      'application/vnd.google-apps.spreadsheet': 'gsheet',
      'application/vnd.google-earth.kml+xml': 'kml',
      'application/vnd.google-earth.kmz': 'kmz',
      'application/vnd.grafeq': 'gqf',
      'application/vnd.groove-account': 'gac',
      'application/vnd.groove-help': 'ghf',
      'application/vnd.groove-identity-message': 'gim',
      'application/vnd.groove-injector': 'grv',
      'application/vnd.groove-tool-message': 'gtm',
      'application/vnd.groove-tool-template': 'tpl',
      'application/vnd.groove-vcard': 'vcg',
      'application/vnd.hal+xml': 'hal',
      'application/vnd.handheld-entertainment+xml': 'zmm',
      'application/vnd.hbci': 'hbci',
      'application/vnd.hhe.lesson-player': 'les',
      'application/vnd.hp-hpgl': 'hpgl',
      'application/vnd.hp-hpid': 'hpid',
      'application/vnd.hp-hps': 'hps',
      'application/vnd.hp-jlyt': 'jlt',
      'application/vnd.hp-pcl': 'pcl',
      'application/vnd.hp-pclxl': 'pclxl',
      'application/vnd.hydrostatix.sof-data': 'sfd-hdstx',
      'application/vnd.ibm.minipay': 'mpy',
      'application/vnd.ibm.modcap': 'afp',
      'application/vnd.ibm.rights-management': 'irm',
      'application/vnd.ibm.secure-container': 'sc',
      'application/vnd.iccprofile': 'icc',
      'application/vnd.igloader': 'igl',
      'application/vnd.immervision-ivp': 'ivp',
      'application/vnd.immervision-ivu': 'ivu',
      'application/vnd.insors.igm': 'igm',
      'application/vnd.intercon.formnet': 'xpw',
      'application/vnd.intergeo': 'i2g',
      'application/vnd.intu.qbo': 'qbo',
      'application/vnd.intu.qfx': 'qfx',
      'application/vnd.ipunplugged.rcprofile': 'rcprofile',
      'application/vnd.irepository.package+xml': 'irp',
      'application/vnd.is-xpr': 'xpr',
      'application/vnd.isac.fcs': 'fcs',
      'application/vnd.jam': 'jam',
      'application/vnd.jcp.javame.midlet-rms': 'rms',
      'application/vnd.jisp': 'jisp',
      'application/vnd.joost.joda-archive': 'joda',
      'application/vnd.kahootz': 'ktz',
      'application/vnd.kde.karbon': 'karbon',
      'application/vnd.kde.kchart': 'chrt',
      'application/vnd.kde.kformula': 'kfo',
      'application/vnd.kde.kivio': 'flw',
      'application/vnd.kde.kontour': 'kon',
      'application/vnd.kde.kpresenter': 'kpr',
      'application/vnd.kde.kspread': 'ksp',
      'application/vnd.kde.kword': 'kwd',
      'application/vnd.kenameaapp': 'htke',
      'application/vnd.kidspiration': 'kia',
      'application/vnd.kinar': 'kne',
      'application/vnd.koan': 'skp',
      'application/vnd.kodak-descriptor': 'sse',
      'application/vnd.las.las+xml': 'lasxml',
      'application/vnd.llamagraphics.life-balance.desktop': 'lbd',
      'application/vnd.llamagraphics.life-balance.exchange+xml': 'lbe',
      'application/vnd.lotus-1-2-3': '123',
      'application/vnd.lotus-approach': 'apr',
      'application/vnd.lotus-freelance': 'pre',
      'application/vnd.lotus-notes': 'nsf',
      'application/vnd.lotus-organizer': 'org',
      'application/vnd.lotus-screencam': 'scm',
      'application/vnd.lotus-wordpro': 'lwp',
      'application/vnd.macports.portpkg': 'portpkg',
      'application/vnd.mcd': 'mcd',
      'application/vnd.medcalcdata': 'mc1',
      'application/vnd.mediastation.cdkey': 'cdkey',
      'application/vnd.mfer': 'mwf',
      'application/vnd.mfmp': 'mfm',
      'application/vnd.micrografx.flo': 'flo',
      'application/vnd.micrografx.igx': 'igx',
      'application/vnd.mif': 'mif',
      'application/vnd.mobius.daf': 'daf',
      'application/vnd.mobius.dis': 'dis',
      'application/vnd.mobius.mbk': 'mbk',
      'application/vnd.mobius.mqy': 'mqy',
      'application/vnd.mobius.msl': 'msl',
      'application/vnd.mobius.plc': 'plc',
      'application/vnd.mobius.txf': 'txf',
      'application/vnd.mophun.application': 'mpn',
      'application/vnd.mophun.certificate': 'mpc',
      'application/vnd.mozilla.xul+xml': 'xul',
      'application/vnd.ms-artgalry': 'cil',
      'application/vnd.ms-cab-compressed': 'cab',
      'application/vnd.ms-excel': 'xls',
      'application/vnd.ms-excel.addin.macroenabled.12': 'xlam',
      'application/vnd.ms-excel.sheet.binary.macroenabled.12': 'xlsb',
      'application/vnd.ms-excel.sheet.macroenabled.12': 'xlsm',
      'application/vnd.ms-excel.template.macroenabled.12': 'xltm',
      'application/vnd.ms-fontobject': 'eot',
      'application/vnd.ms-htmlhelp': 'chm',
      'application/vnd.ms-ims': 'ims',
      'application/vnd.ms-lrm': 'lrm',
      'application/vnd.ms-officetheme': 'thmx',
      'application/vnd.ms-pki.seccat': 'cat',
      'application/vnd.ms-pki.stl': 'stl',
      'application/vnd.ms-powerpoint': 'ppt',
      'application/vnd.ms-powerpoint.addin.macroenabled.12': 'ppam',
      'application/vnd.ms-powerpoint.presentation.macroenabled.12': 'pptm',
      'application/vnd.ms-powerpoint.slide.macroenabled.12': 'sldm',
      'application/vnd.ms-powerpoint.slideshow.macroenabled.12': 'ppsm',
      'application/vnd.ms-powerpoint.template.macroenabled.12': 'potm',
      'application/vnd.ms-project': 'mpp',
      'application/vnd.ms-word.document.macroenabled.12': 'docm',
      'application/vnd.ms-word.template.macroenabled.12': 'dotm',
      'application/vnd.ms-works': 'wps',
      'application/vnd.ms-wpl': 'wpl',
      'application/vnd.ms-xpsdocument': 'xps',
      'application/vnd.mseq': 'mseq',
      'application/vnd.musician': 'mus',
      'application/vnd.muvee.style': 'msty',
      'application/vnd.mynfc': 'taglet',
      'application/vnd.neurolanguage.nlu': 'nlu',
      'application/vnd.nitf': 'ntf',
      'application/vnd.noblenet-directory': 'nnd',
      'application/vnd.noblenet-sealer': 'nns',
      'application/vnd.noblenet-web': 'nnw',
      'application/vnd.nokia.n-gage.data': 'ngdat',
      'application/vnd.nokia.n-gage.symbian.install': 'n-gage',
      'application/vnd.nokia.radio-preset': 'rpst',
      'application/vnd.nokia.radio-presets': 'rpss',
      'application/vnd.novadigm.edm': 'edm',
      'application/vnd.novadigm.edx': 'edx',
      'application/vnd.novadigm.ext': 'ext',
      'application/vnd.oasis.opendocument.chart': 'odc',
      'application/vnd.oasis.opendocument.chart-template': 'otc',
      'application/vnd.oasis.opendocument.database': 'odb',
      'application/vnd.oasis.opendocument.formula': 'odf',
      'application/vnd.oasis.opendocument.formula-template': 'odft',
      'application/vnd.oasis.opendocument.graphics': 'odg',
      'application/vnd.oasis.opendocument.graphics-template': 'otg',
      'application/vnd.oasis.opendocument.image': 'odi',
      'application/vnd.oasis.opendocument.image-template': 'oti',
      'application/vnd.oasis.opendocument.presentation': 'odp',
      'application/vnd.oasis.opendocument.presentation-template': 'otp',
      'application/vnd.oasis.opendocument.spreadsheet': 'ods',
      'application/vnd.oasis.opendocument.spreadsheet-template': 'ots',
      'application/vnd.oasis.opendocument.text': 'odt',
      'application/vnd.oasis.opendocument.text-master': 'odm',
      'application/vnd.oasis.opendocument.text-template': 'ott',
      'application/vnd.oasis.opendocument.text-web': 'oth',
      'application/vnd.olpc-sugar': 'xo',
      'application/vnd.oma.dd2+xml': 'dd2',
      'application/vnd.openofficeorg.extension': 'oxt',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
      'application/vnd.openxmlformats-officedocument.presentationml.slide': 'sldx',
      'application/vnd.openxmlformats-officedocument.presentationml.slideshow': 'ppsx',
      'application/vnd.openxmlformats-officedocument.presentationml.template': 'potx',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.template': 'xltx',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.template': 'dotx',
      'application/vnd.osgeo.mapguide.package': 'mgp',
      'application/vnd.osgi.dp': 'dp',
      'application/vnd.osgi.subsystem': 'esa',
      'application/vnd.palm': 'pdb',
      'application/vnd.pawaafile': 'paw',
      'application/vnd.pg.format': 'str',
      'application/vnd.pg.osasli': 'ei6',
      'application/vnd.picsel': 'efif',
      'application/vnd.pmi.widget': 'wg',
      'application/vnd.pocketlearn': 'plf',
      'application/vnd.powerbuilder6': 'pbd',
      'application/vnd.previewsystems.box': 'box',
      'application/vnd.proteus.magazine': 'mgz',
      'application/vnd.publishare-delta-tree': 'qps',
      'application/vnd.pvi.ptid1': 'ptid',
      'application/vnd.quark.quarkxpress': 'qxd',
      'application/vnd.realvnc.bed': 'bed',
      'application/vnd.recordare.musicxml': 'mxl',
      'application/vnd.recordare.musicxml+xml': 'musicxml',
      'application/vnd.rig.cryptonote': 'cryptonote',
      'application/vnd.rim.cod': 'cod',
      'application/vnd.rn-realmedia': 'rm',
      'application/vnd.rn-realmedia-vbr': 'rmvb',
      'application/vnd.route66.link66+xml': 'link66',
      'application/vnd.sailingtracker.track': 'st',
      'application/vnd.seemail': 'see',
      'application/vnd.sema': 'sema',
      'application/vnd.semd': 'semd',
      'application/vnd.semf': 'semf',
      'application/vnd.shana.informed.formdata': 'ifm',
      'application/vnd.shana.informed.formtemplate': 'itp',
      'application/vnd.shana.informed.interchange': 'iif',
      'application/vnd.shana.informed.package': 'ipk',
      'application/vnd.simtech-mindmapper': 'twd',
      'application/vnd.smaf': 'mmf',
      'application/vnd.smart.teacher': 'teacher',
      'application/vnd.solent.sdkm+xml': 'sdkm',
      'application/vnd.spotfire.dxp': 'dxp',
      'application/vnd.spotfire.sfs': 'sfs',
      'application/vnd.stardivision.calc': 'sdc',
      'application/vnd.stardivision.draw': 'sda',
      'application/vnd.stardivision.impress': 'sdd',
      'application/vnd.stardivision.math': 'smf',
      'application/vnd.stardivision.writer': 'sdw',
      'application/vnd.stardivision.writer-global': 'sgl',
      'application/vnd.stepmania.package': 'smzip',
      'application/vnd.stepmania.stepchart': 'sm',
      'application/vnd.sun.xml.calc': 'sxc',
      'application/vnd.sun.xml.calc.template': 'stc',
      'application/vnd.sun.xml.draw': 'sxd',
      'application/vnd.sun.xml.draw.template': 'std',
      'application/vnd.sun.xml.impress': 'sxi',
      'application/vnd.sun.xml.impress.template': 'sti',
      'application/vnd.sun.xml.math': 'sxm',
      'application/vnd.sun.xml.writer': 'sxw',
      'application/vnd.sun.xml.writer.global': 'sxg',
      'application/vnd.sun.xml.writer.template': 'stw',
      'application/vnd.sus-calendar': 'sus',
      'application/vnd.svd': 'svd',
      'application/vnd.symbian.install': 'sis',
      'application/vnd.syncml+xml': 'xsm',
      'application/vnd.syncml.dm+wbxml': 'bdm',
      'application/vnd.syncml.dm+xml': 'xdm',
      'application/vnd.tao.intent-module-archive': 'tao',
      'application/vnd.tcpdump.pcap': 'pcap',
      'application/vnd.tmobile-livetv': 'tmo',
      'application/vnd.trid.tpt': 'tpt',
      'application/vnd.triscape.mxs': 'mxs',
      'application/vnd.trueapp': 'tra',
      'application/vnd.ufdl': 'ufd',
      'application/vnd.uiq.theme': 'utz',
      'application/vnd.umajin': 'umj',
      'application/vnd.unity': 'unityweb',
      'application/vnd.uoml+xml': 'uoml',
      'application/vnd.vcx': 'vcx',
      'application/vnd.visio': 'vsd',
      'application/vnd.visionary': 'vis',
      'application/vnd.vsf': 'vsf',
      'application/vnd.wap.wbxml': 'wbxml',
      'application/vnd.wap.wmlc': 'wmlc',
      'application/vnd.wap.wmlscriptc': 'wmlsc',
      'application/vnd.webturbo': 'wtb',
      'application/vnd.wolfram.player': 'nbp',
      'application/vnd.wordperfect': 'wpd',
      'application/vnd.wqd': 'wqd',
      'application/vnd.wt.stf': 'stf',
      'application/vnd.xara': 'xar',
      'application/vnd.xfdl': 'xfdl',
      'application/vnd.yamaha.hv-dic': 'hvd',
      'application/vnd.yamaha.hv-script': 'hvs',
      'application/vnd.yamaha.hv-voice': 'hvp',
      'application/vnd.yamaha.openscoreformat': 'osf',
      'application/vnd.yamaha.openscoreformat.osfpvg+xml': 'osfpvg',
      'application/vnd.yamaha.smaf-audio': 'saf',
      'application/vnd.yamaha.smaf-phrase': 'spf',
      'application/vnd.yellowriver-custom-menu': 'cmp',
      'application/vnd.zul': 'zir',
      'application/vnd.zzazz.deck+xml': 'zaz',
      'application/voicexml+xml': 'vxml',
      'application/widget': 'wgt',
      'application/winhlp': 'hlp',
      'application/wsdl+xml': 'wsdl',
      'application/wspolicy+xml': 'wspolicy',
      'application/x-7z-compressed': '7z',
      'application/x-abiword': 'abw',
      'application/x-ace-compressed': 'ace',
      'application/x-apple-diskimage': 'dmg',
      'application/x-authorware-bin': 'aab',
      'application/x-authorware-map': 'aam',
      'application/x-authorware-seg': 'aas',
      'application/x-bcpio': 'bcpio',
      'application/x-bdoc': 'bdoc',
      'application/x-bittorrent': 'torrent',
      'application/x-blorb': 'blb',
      'application/x-bzip': 'bz',
      'application/x-bzip2': 'bz2',
      'application/x-cbr': 'cbr',
      'application/x-cdlink': 'vcd',
      'application/x-cfs-compressed': 'cfs',
      'application/x-chat': 'chat',
      'application/x-chess-pgn': 'pgn',
      'application/x-chrome-extension': 'crx',
      'application/x-cocoa': 'cco',
      'application/x-conference': 'nsc',
      'application/x-cpio': 'cpio',
      'application/x-csh': 'csh',
      'application/x-debian-package': 'deb',
      'application/x-dgc-compressed': 'dgc',
      'application/x-director': 'dir',
      'application/x-doom': 'wad',
      'application/x-dtbncx+xml': 'ncx',
      'application/x-dtbook+xml': 'dtb',
      'application/x-dtbresource+xml': 'res',
      'application/x-dvi': 'dvi',
      'application/x-envoy': 'evy',
      'application/x-eva': 'eva',
      'application/x-font-bdf': 'bdf',
      'application/x-font-ghostscript': 'gsf',
      'application/x-font-linux-psf': 'psf',
      'application/x-font-otf': 'otf',
      'application/x-font-pcf': 'pcf',
      'application/x-font-snf': 'snf',
      'application/x-font-ttf': 'ttf',
      'application/x-font-type1': 'pfa',
      'application/x-freearc': 'arc',
      'application/x-futuresplash': 'spl',
      'application/x-gca-compressed': 'gca',
      'application/x-glulx': 'ulx',
      'application/x-gnumeric': 'gnumeric',
      'application/x-gramps-xml': 'gramps',
      'application/x-gtar': 'gtar',
      'application/x-hdf': 'hdf',
      'application/x-httpd-php': 'php',
      'application/x-install-instructions': 'install',
      'application/x-iso9660-image': 'iso',
      'application/x-java-archive-diff': 'jardiff',
      'application/x-java-jnlp-file': 'jnlp',
      'application/x-latex': 'latex',
      'application/x-lua-bytecode': 'luac',
      'application/x-lzh-compressed': 'lzh',
      'application/x-makeself': 'run',
      'application/x-mie': 'mie',
      'application/x-mobipocket-ebook': 'prc',
      'application/x-ms-application': 'application',
      'application/x-ms-shortcut': 'lnk',
      'application/x-ms-wmd': 'wmd',
      'application/x-ms-wmz': 'wmz',
      'application/x-ms-xbap': 'xbap',
      'application/x-msaccess': 'mdb',
      'application/x-msbinder': 'obd',
      'application/x-mscardfile': 'crd',
      'application/x-msclip': 'clp',
      'application/x-msdos-program': 'exe',
      'application/x-msdownload': 'exe',
      'application/x-msmediaview': 'mvb',
      'application/x-msmetafile': 'wmf',
      'application/x-msmoney': 'mny',
      'application/x-mspublisher': 'pub',
      'application/x-msschedule': 'scd',
      'application/x-msterminal': 'trm',
      'application/x-mswrite': 'wri',
      'application/x-netcdf': 'nc',
      'application/x-ns-proxy-autoconfig': 'pac',
      'application/x-nzb': 'nzb',
      'application/x-perl': 'pl',
      'application/x-pilot': 'prc',
      'application/x-pkcs12': 'p12',
      'application/x-pkcs7-certificates': 'p7b',
      'application/x-pkcs7-certreqresp': 'p7r',
      'application/x-rar-compressed': 'rar',
      'application/x-redhat-package-manager': 'rpm',
      'application/x-research-info-systems': 'ris',
      'application/x-sea': 'sea',
      'application/x-sh': 'sh',
      'application/x-shar': 'shar',
      'application/x-shockwave-flash': 'swf',
      'application/x-silverlight-app': 'xap',
      'application/x-sql': 'sql',
      'application/x-stuffit': 'sit',
      'application/x-stuffitx': 'sitx',
      'application/x-subrip': 'srt',
      'application/x-sv4cpio': 'sv4cpio',
      'application/x-sv4crc': 'sv4crc',
      'application/x-t3vm-image': 't3',
      'application/x-tads': 'gam',
      'application/x-tar': 'tar',
      'application/x-tcl': 'tcl',
      'application/x-tex': 'tex',
      'application/x-tex-tfm': 'tfm',
      'application/x-texinfo': 'texinfo',
      'application/x-tgif': 'obj',
      'application/x-ustar': 'ustar',
      'application/x-wais-source': 'src',
      'application/x-web-app-manifest+json': 'webapp',
      'application/x-x509-ca-cert': 'der',
      'application/x-xfig': 'fig',
      'application/x-xliff+xml': 'xlf',
      'application/x-xpinstall': 'xpi',
      'application/x-xz': 'xz',
      'application/x-zmachine': 'z1',
      'application/xaml+xml': 'xaml',
      'application/xcap-diff+xml': 'xdf',
      'application/xenc+xml': 'xenc',
      'application/xhtml+xml': 'xhtml',
      'application/xml': 'xml',
      'application/xml-dtd': 'dtd',
      'application/xop+xml': 'xop',
      'application/xproc+xml': 'xpl',
      'application/xslt+xml': 'xslt',
      'application/xspf+xml': 'xspf',
      'application/xv+xml': 'mxml',
      'application/yang': 'yang',
      'application/yin+xml': 'yin',
      'application/zip': 'zip',
      'audio/3gpp': '3gpp',
      'audio/adpcm': 'adp',
      'audio/basic': 'au',
      'audio/midi': 'mid',
      'audio/mp3': 'mp3',
      'audio/mp4': 'm4a',
      'audio/mpeg': 'mpga',
      'audio/ogg': 'oga',
      'audio/s3m': 's3m',
      'audio/silk': 'sil',
      'audio/vnd.dece.audio': 'uva',
      'audio/vnd.digital-winds': 'eol',
      'audio/vnd.dra': 'dra',
      'audio/vnd.dts': 'dts',
      'audio/vnd.dts.hd': 'dtshd',
      'audio/vnd.lucent.voice': 'lvp',
      'audio/vnd.ms-playready.media.pya': 'pya',
      'audio/vnd.nuera.ecelp4800': 'ecelp4800',
      'audio/vnd.nuera.ecelp7470': 'ecelp7470',
      'audio/vnd.nuera.ecelp9600': 'ecelp9600',
      'audio/vnd.rip': 'rip',
      'audio/wav': 'wav',
      'audio/wave': 'wav',
      'audio/webm': 'weba',
      'audio/x-aac': 'aac',
      'audio/x-aiff': 'aif',
      'audio/x-caf': 'caf',
      'audio/x-flac': 'flac',
      'audio/x-m4a': 'm4a',
      'audio/x-matroska': 'mka',
      'audio/x-mpegurl': 'm3u',
      'audio/x-ms-wax': 'wax',
      'audio/x-ms-wma': 'wma',
      'audio/x-pn-realaudio': 'ram',
      'audio/x-pn-realaudio-plugin': 'rmp',
      'audio/x-realaudio': 'ra',
      'audio/x-wav': 'wav',
      'audio/xm': 'xm',
      'chemical/x-cdx': 'cdx',
      'chemical/x-cif': 'cif',
      'chemical/x-cmdf': 'cmdf',
      'chemical/x-cml': 'cml',
      'chemical/x-csml': 'csml',
      'chemical/x-xyz': 'xyz',
      'font/opentype': 'otf',
      'image/bmp': 'bmp',
      'image/cgm': 'cgm',
      'image/g3fax': 'g3',
      'image/gif': 'gif',
      'image/ief': 'ief',
      'image/jpeg': 'jpeg',
      'image/ktx': 'ktx',
      'image/png': 'png',
      'image/prs.btif': 'btif',
      'image/sgi': 'sgi',
      'image/svg+xml': 'svg',
      'image/tiff': 'tiff',
      'image/vnd.adobe.photoshop': 'psd',
      'image/vnd.dece.graphic': 'uvi',
      'image/vnd.djvu': 'djvu',
      'image/vnd.dvb.subtitle': 'sub',
      'image/vnd.dwg': 'dwg',
      'image/vnd.dxf': 'dxf',
      'image/vnd.fastbidsheet': 'fbs',
      'image/vnd.fpx': 'fpx',
      'image/vnd.fst': 'fst',
      'image/vnd.fujixerox.edmics-mmr': 'mmr',
      'image/vnd.fujixerox.edmics-rlc': 'rlc',
      'image/vnd.ms-modi': 'mdi',
      'image/vnd.ms-photo': 'wdp',
      'image/vnd.net-fpx': 'npx',
      'image/vnd.wap.wbmp': 'wbmp',
      'image/vnd.xiff': 'xif',
      'image/webp': 'webp',
      'image/x-3ds': '3ds',
      'image/x-cmu-raster': 'ras',
      'image/x-cmx': 'cmx',
      'image/x-freehand': 'fh',
      'image/x-icon': 'ico',
      'image/x-jng': 'jng',
      'image/x-mrsid-image': 'sid',
      'image/x-ms-bmp': 'bmp',
      'image/x-pcx': 'pcx',
      'image/x-pict': 'pic',
      'image/x-portable-anymap': 'pnm',
      'image/x-portable-bitmap': 'pbm',
      'image/x-portable-graymap': 'pgm',
      'image/x-portable-pixmap': 'ppm',
      'image/x-rgb': 'rgb',
      'image/x-tga': 'tga',
      'image/x-xbitmap': 'xbm',
      'image/x-xpixmap': 'xpm',
      'image/x-xwindowdump': 'xwd',
      'message/rfc822': 'eml',
      'model/iges': 'igs',
      'model/mesh': 'msh',
      'model/vnd.collada+xml': 'dae',
      'model/vnd.dwf': 'dwf',
      'model/vnd.gdl': 'gdl',
      'model/vnd.gtw': 'gtw',
      'model/vnd.mts': 'mts',
      'model/vnd.vtu': 'vtu',
      'model/vrml': 'wrl',
      'model/x3d+binary': 'x3db',
      'model/x3d+vrml': 'x3dv',
      'model/x3d+xml': 'x3d',
      'text/cache-manifest': 'appcache',
      'text/calendar': 'ics',
      'text/coffeescript': 'coffee',
      'text/css': 'css',
      'text/csv': 'csv',
      'text/hjson': 'hjson',
      'text/html': 'html',
      'text/jade': 'jade',
      'text/jsx': 'jsx',
      'text/less': 'less',
      'text/mathml': 'mml',
      'text/n3': 'n3',
      'text/plain': 'txt',
      'text/prs.lines.tag': 'dsc',
      'text/richtext': 'rtx',
      'text/rtf': 'rtf',
      'text/sgml': 'sgml',
      'text/slim': 'slim',
      'text/stylus': 'stylus',
      'text/tab-separated-values': 'tsv',
      'text/troff': 't',
      'text/turtle': 'ttl',
      'text/uri-list': 'uri',
      'text/vcard': 'vcard',
      'text/vnd.curl': 'curl',
      'text/vnd.curl.dcurl': 'dcurl',
      'text/vnd.curl.mcurl': 'mcurl',
      'text/vnd.curl.scurl': 'scurl',
      'text/vnd.dvb.subtitle': 'sub',
      'text/vnd.fly': 'fly',
      'text/vnd.fmi.flexstor': 'flx',
      'text/vnd.graphviz': 'gv',
      'text/vnd.in3d.3dml': '3dml',
      'text/vnd.in3d.spot': 'spot',
      'text/vnd.sun.j2me.app-descriptor': 'jad',
      'text/vnd.wap.wml': 'wml',
      'text/vnd.wap.wmlscript': 'wmls',
      'text/vtt': 'vtt',
      'text/x-asm': 's',
      'text/x-c': 'c',
      'text/x-component': 'htc',
      'text/x-fortran': 'f',
      'text/x-handlebars-template': 'hbs',
      'text/x-java-source': 'java',
      'text/x-lua': 'lua',
      'text/x-markdown': 'markdown',
      'text/x-nfo': 'nfo',
      'text/x-opml': 'opml',
      'text/x-pascal': 'p',
      'text/x-processing': 'pde',
      'text/x-sass': 'sass',
      'text/x-scss': 'scss',
      'text/x-setext': 'etx',
      'text/x-sfv': 'sfv',
      'text/x-suse-ymp': 'ymp',
      'text/x-uuencode': 'uu',
      'text/x-vcalendar': 'vcs',
      'text/x-vcard': 'vcf',
      'text/xml': 'xml',
      'text/yaml': 'yaml',
      'video/3gpp': '3gp',
      'video/3gpp2': '3g2',
      'video/h261': 'h261',
      'video/h263': 'h263',
      'video/h264': 'h264',
      'video/jpeg': 'jpgv',
      'video/jpm': 'jpm',
      'video/mj2': 'mj2',
      'video/mp2t': 'ts',
      'video/mp4': 'mp4',
      'video/mpeg': 'mpeg',
      'video/ogg': 'ogv',
      'video/quicktime': 'qt',
      'video/vnd.dece.hd': 'uvh',
      'video/vnd.dece.mobile': 'uvm',
      'video/vnd.dece.pd': 'uvp',
      'video/vnd.dece.sd': 'uvs',
      'video/vnd.dece.video': 'uvv',
      'video/vnd.dvb.file': 'dvb',
      'video/vnd.fvt': 'fvt',
      'video/vnd.mpegurl': 'mxu',
      'video/vnd.ms-playready.media.pyv': 'pyv',
      'video/vnd.uvvu.mp4': 'uvu',
      'video/vnd.vivo': 'viv',
      'video/webm': 'webm',
      'video/x-f4v': 'f4v',
      'video/x-fli': 'fli',
      'video/x-flv': 'flv',
      'video/x-m4v': 'm4v',
      'video/x-matroska': 'mkv',
      'video/x-mng': 'mng',
      'video/x-ms-asf': 'asf',
      'video/x-ms-vob': 'vob',
      'video/x-ms-wm': 'wm',
      'video/x-ms-wmv': 'wmv',
      'video/x-ms-wmx': 'wmx',
      'video/x-ms-wvx': 'wvx',
      'video/x-msvideo': 'avi',
      'video/x-sgi-movie': 'movie',
      'video/x-smv': 'smv',
      'x-conference/x-cooltalk': 'ice'
    };
    _this.getExtension = function (file) {
      var ext = file.split('.')[1];
      var result;
      for(var key in _this.mimesString)
        if(_this.mimesString[key]===ext){
          result = key;
          break;
        }
        return result;
    };
    return _this;
  }

})();


(function () {
  'use strict';
  angular.module('messageStatus', []).component('messageStatus', {
    templateUrl: 'app/main/contactcenter/components/messagestatus/messagestatus.html',
    controllerAs: 'vm',
    bindings: {
      message: '='
    },
    controller: ctrl
  });

  /** @ngInject */
  function ctrl(DynamicFactory, consts) {
    var vm = this;
    
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;


    function onInit() {
    }

    function onChanges(changesObj) {
    }
  }
})();

/**
 * Created by kosski on 08.09.2016.
 */
(function () {
  'use strict';

  angular.module('mdDateTimePicker', [])
    .component('mdDateTimePicker', {
      templateUrl: 'app/main/contactcenter/components/mddatetimepicker/mddatetimepicker.html',
      controllerAs: 'vm',
      bindings: {
        minDate: '=',
        maxDate: '=',
        dateModel: '=',
        datePlaceholder: '@',
        customStyle: '@',
        ngDisabled: '='
      },
      controller: mdDateTimePicker
    });

  /** @ngInject */
  function mdDateTimePicker(mdcDateTimeDialog, $translate) {
    var vm = this;

    vm.displayDialog = function () {
      var currentLang = $translate.proposedLanguage() || $translate.use();
      mdcDateTimeDialog.show({
        maxDate: angular.isDefined(vm.maxDate) ? vm.maxDate : undefined,
        minDate: angular.isDefined(vm.minDate) ? vm.minDate : undefined,
        time: true,
        currentDate: vm.Date,
        format: 'DD-MM-YYYY HH:mm',
        lang: currentLang,
        cancelText: $translate.instant('DATETIMEPICKER.CANCEL'),
        todayText: $translate.instant('DATETIMEPICKER.TODAY')

      }).then(function (date) {
        var momentDate = moment(date);
        setIsolateDate(momentDate);
        vm.dateModel = momentDate;
        console.log('New Date / Time selected:', date);
      }, function () {
        console.log('Selection canceled');
      });
    };

    function setIsolateDate(momentDate) {
      vm.Date = momentDate.format('DD-MM-YYYY HH:mm');
    }

    // scope.$watch(scope.Date,
    //   function (newValue, oldValue) {
    //     if (newValue && newValue == oldValue) {
    //       ngModel.$setViewValue(scope.oldDate);
    //       ngModel.$render();
    //     }
    //   });
    ////////////////

    vm.$doCheck = function () {
      if (vm.dateModel)
        if (!vm.Date)
          if (angular.isString(vm.dateModel)) {
            setIsolateDate(moment(vm.dateModel));
          }
      else {
        setIsolateDate(vm.dateModel);
      } else vm.$doCheck = function () {};
    };
    vm.onChanges = function (changesObj) {};
    vm.onDestory = function () {};
  }

})();

(function () {
  'use strict';

  angular.module('issueTracker').component('issueTracker', {
    templateUrl: 'app/main/contactcenter/components/issuetracker/issuetracker.html',
    bindings: {
      openIssueDialog: '<',
      issueStatus: '<',
      createIssueDialogParams: '&'
    },
    controllerAs: 'vm',
    controller: IssueTracker
  });

  /* @ngInject */
  function IssueTracker(issueTrackerService, ISSUE_TRACKER_NAME) {
    var vm = this;

    vm.$onInit = onInit;

    vm.ISSUE_TRACKER_NAME = ISSUE_TRACKER_NAME;

    function onInit() {
      if (!vm.issueTrackerConfig) {
        issueTrackerService.getIssueTrackerConfig().then(function (configuration) {
          vm.issueTrackerConfig = configuration;
        });
      }
    }
  }

})();

/**
 * Created by kosski on 23.08.2016.
 */
+function () {
  'use strict';
  angular.module('management.services').component('dynamicForm', {
    templateUrl: 'app/main/contactcenter/components/dynamicform/dynamicform.html',
    controllerAs: 'vm',
    bindings: {
      formConfig: '<',
      settings: '='
    },
    controller: dynamicForm
  });

  /** @ngInject */
  function dynamicForm(DynamicFactory) {
    var vm = this;

    // vm.$onInit = onInit;
    // vm.$postLink = postLink;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;

    // function onInit() {

    // }

    // function postLink() {

    // }

    function onChanges(changesObj) {
      if (changesObj.formConfig.currentValue) {
        vm.actionFields = [];
        if(!angular.isArray(changesObj.formConfig.currentValue)){
          var formConfig = [changesObj.formConfig.currentValue];
        }else{
          var formConfig = changesObj.formConfig.currentValue;
        }
        formConfig.forEach(function (fieldConfig, index) {
          reserveSettingsField(fieldConfig);
        });
      }
    }

    function onDestroy() {
      vm.actionFields = [];
    }

    function reserveSettingsField(field) {
      var parameters = [{
        token: 'pn',
        value: field.fieldId
      }, {
        token: 'translate',
        value: field.label
      }];

      if (field.label) {
        field.translation = field.label;
      }

      if (field.source && angular.isString(field.source)) {
        field.source = field.source.split(',');
      }

      DynamicFactory.get('templatesRsc', 'getUniTemplate')(field.templateKey, parameters).then(function (template) {
        field.template = template;
        if (!getConfigValue(field.fieldId)) {
          replaceConfigValue(field.fieldId,field.objValue ? {} : '')
          // vm.settings[field.fieldId] = '';
        }
        vm.actionFields.push(field);
      });
    }

    function getConfigValue(path){
      var schema = vm.settings;  // a moving reference to internal objects within obj
      var pList = path.replace(/\[(\w+)\]/g, '.$1').split('.');
      var len = pList.length;
      for(var i = 0; i < len-1; i++) {
          var elem = pList[i];
          if( !schema[elem] ) schema[elem] = {};
          schema = schema[elem];
      }
      return schema[pList[len-1]];
    }

    function replaceConfigValue(path,value){
      var schema = vm.settings;  // a moving reference to internal objects within obj
      var pList = path.replace(/\[(\w+)\]/g, '.$1').split('.');
      var len = pList.length;
      for(var i = 0; i < len-1; i++) {
          var elem = pList[i];
          if( !schema[elem] ) schema[elem] = {};
          schema = schema[elem];
      }

      schema[pList[len-1]] = value;
    }



  }
}();

(function () {
  'use strict';


  // Creates: MDolega


  angular
    .module('dialogModule', [])
    .component('dialogComponent', {
      templateUrl: 'app/main/contactcenter/components/dialog/dialog.html',
      controller: Ctrl,
      controllerAs: 'vm',
      transclude: {
        title: '?title',
        footer: '?footer',
        // header: '?header',
        content: 'content'
      },
      bindings: {
        savefunc: '<',
        cancelfunc: '<',
        imagesrc: '<',
        formName: '<',
        dialogTitle: '=',
        dialogHeight: '=',
        smallHeader: '<',
        titleIcon: '<',
        hideFooter: '<',
        showFooter:'='
      }
    });

  /** @ngInject */
  function Ctrl($mdDialog) {
    var vm = this;

    vm.close = close;
    ////////////////

    vm.$onInit = function () {
    };

    vm.$onChanges = function (changesObj) {
    };

    vm.$onDestory = function () {

    };

    function close() {
      // $mdDialog.hide();
      $mdDialog.cancel('cancel');
    }

  }


})();

/**
 * Created by kosski on 23.08.2016.
 */
+ function () {
  'use strict';
  angular.module('taConsultantslist', [])
    .component('taConsultantslist', {
      templateUrl: 'app/main/contactcenter/components/consultantslist/consultantslist.html',
      controllerAs: 'vm',
      bindings: {
        conf: '=',
        // source: '<',
        ngModel: '='
      },
      controller: consultantsList
    });

  /** @ngInject */
  function consultantsList(DynamicFactory, toastService) {
    var vm = this;
    vm.RemoveFromCc = RemoveFromCc;
    vm.addToCC = addToCC;
    vm.searchConsultant = searchConsultant;

    // vm.$postLink = postLink;
    vm.$onInit = InitCallCenter;
    // vm.$onChanges = onChanges;

    /*-------------------------------------------- Callcenter -------------------------------------------- */

    // function postLink() {

    // }



    function InitCallCenter() {
      vm.addConsultatorMode = 0;
      getConsultants();
      vm.sortableCCOptions = {
        placeholder: 'consultator',
        stop: function (e, ui) {
          recalculatePriority();
        }
      };
    }

    // function onChanges(changesObj) {
    //   if (changesObj.source.currentValue) {
    //     var source = changesObj.source.currentValue;
    //     vm.sourceList = angular.copy(source);
    //     if (!vm.ngModel)
    //       vm.ngModel = '';
    //     decodeModel();
    //     recalculatePriority();

    //   }
    // }

    function getConsultants() {
      DynamicFactory.get('serviceActionsRsc', 'getGroups')().then(function (result) {
        vm.sourceList = result;
        vm.source = result;
        // if (!vm.ngModel)
        //   vm.ngModel = '';
        // decodeModel();
        getActionConsultants();
        recalculatePriority();
      });
    }

    function getActionConsultants(){
      if(vm.conf.actionGuid){

        DynamicFactory.get('serviceActionsRsc', 'ActionConsultantList')(vm.conf.actionGuid).then(function (result) {

          // vm.ngModel = result;
          // decodeModel();
          result.forEach(function(item){
            addToCC(item);
          });
        });
      }else{
        console.log('taConsultantslist | error! no actionGuid');
      }
      }

    function addToCC(item) {
      if (!isDuplicated(item.type, item.id)) {
        if(!vm.output){
          vm.output = [];
        }
        vm.output.push(item);
        recalculatePriority();
        onAddToCCSuccess(item.type ? 'Konsultant został zapisany' : 'Grupa została zapisana');
      } else {
        toastService.showToast('Duplikaty nie są dozwolone', 'error', 4);
      }
    }

    function onAddToCCSuccess(message) {
      vm.addConsultatorMode = 0;
      updateModel();
    }

    function RemoveFromCc(Consultant) {
      vm.output.splice(vm.output.indexOf(Consultant), 1);
      updateModel();
    }

    function isDuplicated(type, id) {
      var output = vm.ngModel.split(',');
      return output.indexOf(type + id) === '-1';

    }




    function getGroup(element) {
      var result;
      vm.sourceList.forEach(function (group) {
        group.consultants.forEach(function (consultant) {
          if (consultant.consultantID == element.id)
            result = group.id;
        });
      });
      return result;
    }

    function recalculatePriority() {
      for (var i = 0; i < vm.output.length; i++) {
        vm.output[i].priority = i + 1;
      }
      updateModel();
    }

    function searchConsultant() {
      if (vm.search) {
        var results = [];

        for (var k in vm.consultantsInGroups)
          if (k != '$promise' && k != '$resolved') {
            var filteredConsultants = filterConsultants(vm.search, vm.consultantsInGroups[k]);
            if (filteredConsultants.length > 0) {
              results.push(k);
            }
          }

        var filteredGroups = filterGroups(vm.search, vm.source);
        if (filteredGroups.length > 0)
          for (var i = 0; i < filteredGroups.length; i++) {
            var duplicates = $filter('filter')(results, {
              id: filteredGroups[i].id
            });
            if (duplicates.length == 0)
              results.push(filteredGroups[i]);
          }
        vm.sourceList = results;
      } else vm.sourceList = vm.source;

    }

    function filterGroups(querry) {
      return filterJson(vm.source, querry, ['consultants', 'toJSON', '$get', '$save', '$query', '$remove', '$delete']);
    }

    function filterConsultants(querry, consultantList) {
      return filterJson(consultantList, querry, ['photoUrl']);
    }

    function filterJson(list, querry, fieldExcludes) {
      var results = [];
      var querry = querry.toLowerCase();
      for (var i = 0; i < list.length; i++) {
        var row = list[i];
        var allData = '';
        for (var key in row)
          if (fieldExcludes) {
            if (fieldExcludes.indexOf(key) == -1)
              allData += String(row[key]).toLowerCase();
          } else {
            allData += String(row[key]).toLowerCase();
          }
        allData.toLowerCase();
        if (allData.indexOf(querry) != -1)
          results.push(row);
      }
      return results;
    }

    function updateModel() {
      vm.ngModel = codeList(vm.output).join(',');
    }

    function codeElement(elem) {
      return elem.type + elem.id;
    }

    function codeList(list) {
      return list.map(codeElement);
    }

    function decodeModel() {
      vm.output = [];
      var output = vm.ngModel.split(',');
      var codedSource = codeList(vm.source);
      output.forEach(function (elem) {
        var indexMatch = codedSource.indexOf(elem);
        if (indexMatch !== -1) {
          vm.output.push(vm.source[indexMatch]);

        }
      });
    }
  }



}();

(function () {
  'use strict';

  angular
    .module('avatarCropper', [])
    .component('avatarCropper', {
      templateUrl: 'app/main/contactcenter/components/avatarcropper/avatarcropper.html',
      controller: Ctrl,
      controllerAs: 'vm',
      bindings: {
        ngDisabled: '=',
        dudeName: '<',
        saveCallback: '=',
        fileUploadCall: '@',
        imgUrl: '=',
        defaultImg:'='
      }
    });

  /** @ngInject */
  function Ctrl(DynamicFactory, $scope, toastService) {
    var vm = this;
    vm.saveImage = saveImage;
    vm.selectFile = selectFile;
    // vm.$doCheck = doCheck;
    vm.$onChanges = OnChanges;
    vm.$postLink = setAvatar;
    vm.$onInit = onInit;


    function onInit() {
      vm.SelectedFile = {};
      vm.showAdd=true;
      vm.showCroppingArea = false;
      // vm.imgUrl = '';
      vm.FileUploader = DynamicFactory.get('FileUploadRsc', 'LoadFileUploader')('/', false);
      vm.FileUploader.onAfterAddingFile = function (item) {
        croppingHandler();
      };
      // vm.FileUploader.onSuccessItem = function (fileItem, response, status, headers) {
      //   console.info('onSuccessItem', fileItem, response, status, headers);
      // };
    }


    function OnChanges(changesObj) {
      vm.showCroppingArea = false;
      // console.log(changesObj);
      if (changesObj.dudeName.currentValue)
        setAvatar();
    }

    // function doCheck() {
    //   if(vm.photo.croppedImage !== vm.imgUrl)
    //     setAvatar();
    // }

    function croppingHandler(evt) {
      $scope.$apply(function (vm) {
        var file = angular.element('#fileSelect' + $scope.$id)[0].files[0];
        if (file !== null || file !== undefined) {
          vm.vm.photo = {
            fileType: angular.copy(file.type),
            uplaodedImage: URL.createObjectURL(file),
            croppedImage: ''
          };
          vm.vm.showCroppingArea = true;
        }
      });
    }

    function ErrorFunc(err) {
      alert('error');
      toastService.showToast('Nie udało się zapisać zmian', 'error',4);
    }

    // function selectedFileChanged() {
    //   if (angular.isDefined(vm.userData.photoUrl) && vm.userData.photoUrl.length > 1) {
    //     DynamicFactory.get('profileRsc', 'PutConsultantPhoto')({
    //       Photo: vm.userData.photoUrl
    //     }).then(function (suc) {
    //       SessionManager.updateAvatarURL(vm.userData.photoUrl);
    //     }, ErrorFunc);
    //   }
    // }


    function setAvatar() {
      if (!vm.photo) setPhoto();

      // vm.photo.croppedImage = vm.imgUrl;
    }

    function setPhoto() {
      vm.photo = {
        uplaodedImage: '',
        fileType: '',
        croppedImage: ''
      };
    }

    function selectFile() {
      angular.element('#fileSelect' + $scope.$id).trigger('click');
    }

    function saveImage() {
      console.log(vm.showCroppedImage, vm.photo.fileType);
      vm.showCroppingArea = false;
      // vm.showCroppedImage = true;
      //'savePhoto2'
      DynamicFactory.get('FileUploadRsc', vm.fileUploadCall)(vm.photo.croppedImage.replace('data:' + vm.photo.fileType + ';base64,', ''), vm.photo.fileType)
        .then(function (data) {
          //debugger
          if (data === 'old') {
            //do nothing
          } else {
            vm.imgUrl = data;
            if (vm.saveCallback)
              vm.saveCallback(data);
            // selectedFileChanged();
          }
        });
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('avatarLetter', [])
    .component('avatarLetter', {
      templateUrl: 'app/main/contactcenter/components/avatarletter/avatarletter.html',
      controller: Ctrl,
      controllerAs: 'vm',
      bindings: {
        name: '<',
        index: '<',
        customClass: '@'
      }
    });

  /** @ngInject */
  function Ctrl() {
    var vm = this;
    vm.$onChanges = OnChanges;
    vm.avatarNumber = vm.index;
    vm.printColor = printColor;
    vm.colours = ['#ed5564', '#26a69a', '#2196f3', '#f8ab59'];
    vm.coloursArr = new Array(0);
    vm.coloursArr.push(new MailListItem('A', 'md-light-blue-800-bg'));
    vm.coloursArr.push(new MailListItem('B', 'md-cyan-400-bg'));
    vm.coloursArr.push(new MailListItem('C', 'md-red-300-bg'));
    vm.coloursArr.push(new MailListItem('D', 'md-pink-300-bg'));
    vm.coloursArr.push(new MailListItem('E', 'md-pink-A700-bg'));
    vm.coloursArr.push(new MailListItem('F', 'md-red-300-bg'));
    vm.coloursArr.push(new MailListItem('G', 'md-deep-purple-300-bg'));
    vm.coloursArr.push(new MailListItem('H', 'md-indigo-400-bg'));
    vm.coloursArr.push(new MailListItem('I', 'md-indigo-A200-bg'));
    vm.coloursArr.push(new MailListItem('J', 'md-blue-200-bg'));
    vm.coloursArr.push(new MailListItem('K', 'md-blue-A200-bg'));
    vm.coloursArr.push(new MailListItem('L', 'md-cyan-A700-bg'));
    vm.coloursArr.push(new MailListItem('M', 'md-teal-300-bg'));
    vm.coloursArr.push(new MailListItem('N', 'md-teal-100-bg'));
    vm.coloursArr.push(new MailListItem('O', 'md-green-400-bg'));
    vm.coloursArr.push(new MailListItem('P', 'md-light-green-400-bg'));
    vm.coloursArr.push(new MailListItem('Q', 'md-light-green-800-bg'));
    vm.coloursArr.push(new MailListItem('R', 'md-lime-600-bg'));
    vm.coloursArr.push(new MailListItem('S', 'md-lime-A100-bg'));
    vm.coloursArr.push(new MailListItem('T', 'md-yellow-800-bg'));
    vm.coloursArr.push(new MailListItem('U', 'md-yellow-A700-bg'));
    vm.coloursArr.push(new MailListItem('V', 'md-amber-600-bg'));
    vm.coloursArr.push(new MailListItem('W', 'md-orange-300-bg'));
    vm.coloursArr.push(new MailListItem('X', 'md-orange-A200-bg'));
    vm.coloursArr.push(new MailListItem('Y', 'md-deep-orange-A200-bg'));
    vm.coloursArr.push(new MailListItem('Z', 'md-brown-500-bg'));
    //console.log(' vm.coloursArr: ', vm.coloursArr);

    ////////////////


    function OnChanges(changesObj) {
      if (vm.name || vm.index !== undefined)
        vm.colorClass = printColor(vm.name);
      else
        vm.colorClass = vm.coloursArr[0].color;
    }

    function printColor(name) {
      var colorClass = '';
      if (vm.name) {
        // vm.letter = '';
        if (name && name.length > 0) {
          vm.letter = replacePlChar(name[0]);
        }

        var query = _.filter(vm.coloursArr, function (elem) {
          return elem.letter === vm.letter;
        });
        if (query != null && query.length > 0) {
          colorClass = query[0].color;
        } else {
          colorClass = 'md-deep-orange-900-bg';
        }
      } else {
        // vm.coloursArr[]

        vm.letter = vm.index;
        if (!vm.index) colorClass = vm.coloursArr[0].color;
        colorClass = (vm.index < 4 ? vm.coloursArr[vm.index].color : vm.coloursArr[vm.index % 4].color);
      }

      return colorClass + (vm.customClass ? ' ' + vm.customClass : '') + ' ';
    }

    function replacePlChar(letter) {
      return letter.toUpperCase().replace('Ą', 'A').replace('Ę', 'E').replace('Ó', 'O').replace('Ś', 'S').replace('Ł', 'L').replace('Ż', 'Z').replace('Ź', 'Z').replace('Ć', 'C').replace('Ń', 'N');
    }

    function MailListItem(letter, color) {
      this.letter = letter;
      this.color = color;
    };
  }
})();

(function () {
  'use strict';

  angular
  .module('activityAxis', [])
    .component('activityAxis', {
      templateUrl: 'app/main/contactcenter/components/activityaxis/activityaxis.html',
      controllerAs: 'vm',
      bindings: {
        activityRow: '<',
      },
      controller: Ctrl
    });

  /** @ngInject */
  function Ctrl() {
    var vm = this;


    vm.statusStatistic = [];

    vm.$onInit = onInit;
    // vm.$onDestroy = onDestroy;
    vm.$onChanges = OnChanges;


    // var timerInterval = $interval(function () {
    //   renderAxis()
    // }.bind(vm), 60000);

    function onInit() {
        // WebSocketManager.registerWebSocketMethod('ConsultantStatusUpdate', 'navStatusAxisStatusUpdate', onStatusUpdate);
        // vm.renderAxis();

    }


    function OnChanges(changesObj) {
      if (changesObj.activityRow.currentValue){
        vm.currentRow = angular.copy(changesObj.activityRow.currentValue);
        vm.timeFromLogin = vm.currentRow.razem;
        vm.statusStatistic = [{
          status: '1',
          difference: vm.currentRow.aktywnyZalogowany,
          statusName: 'Aktywny'
        },
        {
          status: 'z-1',
          difference: vm.currentRow.aktywnyNieZalogowany,
          statusName: 'Aktywny zdalnie'
        },{
          status: '2',
          difference: vm.currentRow.przerwaZalogowany,
          statusName: 'Przerwa'
        },
        {
          status: 'z-2',
          difference: vm.currentRow.przerwaNieZalogowany,
          statusName: 'Przerwa zdalnie'
        },{
          status: '0',
          difference: vm.currentRow.nieaktywnyZalogowany,
          statusName: 'Nieaktywny'
        },
        {
          status: 'z-0',
          difference: vm.currentRow.nieaktywnyNieZalogowany,
          statusName: 'Nieaktywny zdalnie'
        }]
      }
    }

    // function renderAxis(){
    //     // DynamicFactory.get('reportsCosult', 'StatusStatistic')().then(function (data) {
    //         vm.statusStatistic = data;
    //         var active = _.filter(vm.statusStatistic, function (x) { return x.status === 1; });
    //         vm.activeTime = _.sumBy(active, function (x) { return x.difference; });
    //         vm.activeTimeFormat = moment.utc(vm.activeTime*1000).format('HH:mm');

    //         var breakSumTime = _.filter(vm.statusStatistic, function (x) { return x.status === 2; });
    //         vm.breakTime = _.sumBy(breakSumTime, function (x) { return x.difference; });
    //         vm.breakTimeFormat = moment.utc(vm.breakTime*1000).minutes(); //.format('HH:mm:ss');

    //         if (vm.statusStatistic && vm.statusStatistic.length > 0) {
    //             vm.timeFromLogin = moment().diff(vm.statusStatistic[0].insertionTime, 'seconds');
    //             vm.timeFromLoginFormat = moment.utc(moment().diff(vm.statusStatistic[0].insertionTime)).format('HH:mm:ss');
    //         }
    //     // });
    // }
    // function onStatusUpdate(data) {
    //   if (data.Content) {
    //         vm.renderAxis();
    //   }
    // }
    // function onDestroy() {
    //   WebSocketManager.unregisterWebSocketMethod('ConsultantStatusUpdate','navStatusAxisStatusUpdate');
    //   $interval.cancel(timerInterval);
    //   timerInterval = undefined;
    // }

  }
})();

(function () {
  'use strict';


  // Creates: Kosski


  angular
    .module('accordionForm', [])
    .component('accordionForm', {
      templateUrl: 'app/main/contactcenter/components/accordionform/accordionform.html',
      controller: Ctrl,
      controllerAs: 'vm',
      transclude: true,
      bindings: {
        onComplete: '=',
        clikcableHeader: '=',
        countInitProgress: '=',
        mainForm: '=',
        onPaneChange: '=',
        // wizzardProgress:'='
      }
    });

  /** @ngInject */
  function Ctrl($scope, $q) {
    var vm = this;


    vm.completeForm = completeForm;
    vm.nextPane = nextPane;
    vm.previousPane = previousPane;
    vm.registerPane = registerPane;
    vm.updateProgress = updateProgress;
    vm.setActivePane = setActivePaneEv;
    vm.$postLink = postLink;
    ////////////////

    vm.$onInit = function () {
      vm.registeredPanes = [];
      vm.paneCals = {};
      // vm.activePaneIndex = 0;
      vm.config = {
        countInitProgress: vm.countInitProgress,
        clikcableHeader: vm.clikcableHeader
        // ,onComplete: vm.onComplete !== undefined
      };




      // $scope.$on('register-pane', registerPane);
      // $scope.$on('next-pane', nextPane);
      // $scope.$on('previous-pane', previousPane);
      // $scope.$on('set-active-pane', setActivePaneEv);
      // $scope.$on('on-complete',completeForm);
    };

    function postLink() {
      // vm.formValid = vm.mainForm.$valid;
    }

    vm.$onChanges = function (changesObj) {};

    vm.$onDestory = function () {

    };

    function registerPane(scopeId, calls) {
      // var scopeId = $scope.$id;
      // angular.element(angular.element('#accordion-form .form-pane')[0]).scope()
      // ev.stopPropagation();
      // vm.registeredPanes.push(obj);
      // vm.registeredPanes.sort();

      // var childrensId = [];
      // var childrensScope = angular.element('#accordion-form .form-pane');
      // // .map(function(index,item){
      // //   var itemScope = angular.element(item).scope()

      // //   return itemScope.$id;
      // // });

      // for(var i=0; i<childrensScope.length; i++){
      //   childrensId.push(angular.element(childrensScope[i]).scope().$id);
      // }

      // console.log('accordionForm | ',childrensId == vm.registeredPanes,childrensId,vm.registeredPanes);
      // var defer  =$q.defer();
      vm.paneCals[scopeId] = calls;
      setTimeout(function () {


        vm.registeredPanes = recalculateRegisteredPanes();
        var paneIndex = vm.registeredPanes.indexOf(scopeId);
        vm.config.lastScope = vm.registeredPanes[vm.registeredPanes.length-1];
        // broadcastPaneRegistration(paneIndex);
        if (paneIndex == 0)
          setActivePane(paneIndex);
      }, 100);
      // return defer.promise;

    }

    function updateProgress(paneId, progress){
      if(!vm.formProgress){
        vm.formProgress = {};
      }
      vm.formProgress[paneId] = progress;
      vm.wizzardProgress = recalculateWizzardProgress();
    }

    function recalculateWizzardProgress(){
      var totalProgress = Object.values(vm.formProgress).reduce(function(sum,value){
        return sum + value;
      });
      return totalProgress / (100* vm.registeredPanes.length);
    }

    function recalculateRegisteredPanes() {
      var childrensId = [];
      var childrensScope = angular.element('#accordion-form-' + $scope.$id + ' .form-pane');

      for (var i = 0; i < childrensScope.length; i++) {
        childrensId.push(angular.element(childrensScope[i]).scope().$id);
      }

      return childrensId;
    }


    // function broadcastPaneRegistration(paneIndex) {
    //   var registrated = {
    //     stepNumber: vm.registeredPanes[paneIndex],
    //     // isLast: paneIndex >= vm.registeredPanes.length - 1,
    //     // isFirst: paneIndex == 0,
    //     // countInitProgress: vm.countInitProgress,
    //     // clikcableHeader: vm.clikcableHeader,
    //     // onComplete: vm.onComplete !== undefined
    //   }
    //   // $scope.$broadcast('pane-registered', vm.registeredPanes);
    //   return registrated;
    // }
    function setActivePaneEv(obj) {
      // if(vm.clikcableHeader){
      setActivePane(vm.registeredPanes.indexOf(obj));
      // vm.activePaneIndex = vm.registeredPanes.indexOf(obj);
      // }
    }

    function onPaneChange(paneIndex){
      if (vm.onPaneChange) {
        if (angular.isFunction(vm.onPaneChange)) {
          vm.onPaneChange(paneIndex);
        } else {
          $scope.$emit('accordionForm - paneChange');
        }
      }
    }

    function setActivePane(paneIndex) {
      onPaneChange(paneIndex);
      var changeSuccess = vm.paneCals[vm.registeredPanes[paneIndex]].activate();
      if(changeSuccess){
        if (vm.activePaneIndex !== undefined) {
          vm.paneCals[vm.registeredPanes[vm.activePaneIndex]].deactivate();
        }
        vm.activePaneIndex = paneIndex;
      }else{

      }

      // $scope.$broadcast('active-pane-change', {
      //   stepNumber: vm.registeredPanes[paneIndex],
      //   previousPane: previousPaneIndex !== undefined ? vm.registeredPanes[previousPaneIndex] : undefined,
      //   // isLast: last,
      //   // isFirst: paneIndex == 0
      // });
    }

    function nextPane() {
      // ev.stopPropagation();
      // if (vm.activePaneIndex + 1 < vm.registeredPanes.length) {
      setActivePane(vm.activePaneIndex + 1);
      // } else if (vm.onComplete) {
      //   vm.onComplete();
      // }
    }

    function previousPane() {
      // ev.stopPropagation();
      if (vm.activePaneIndex !== 0) {
        setActivePane(vm.activePaneIndex - 1);
      }
    }

    function completeForm() {
      if(vm.onComplete){
        vm.formSubmitted = true;
        $q.when(vm.onComplete()).then(function(){
          vm.formSubmitted = false;
        });
      }
    }
  }


})();

/**
 * Created by kosski on 08.09.2016.
 */
(function () {
  'use strict';
  angular.module('accordionForm')
    .directive("paneHelper", [function () {
      return {
        require:  ['ngModel','^^formPane'],
        restrict: 'A',
        link: paneHelper
      };
    }]);
  function paneHelper(scope, element, attributes, controllers) {
    var vm = this;
    // vm.customValidator = function (ngModelValue) {
    //   controllers[1].countFormProgress();
    //   return  ngModelValue;
    // };

    vm.customFormatter = function(ngModelValue) {
      setTimeout(function() {
        controllers[1].countFormProgress();
      }, 100);
      return  ngModelValue;
    };
    // controllers[0].$parsers.push(vm.customValidator);
    controllers[0].$formatters.push(vm.customFormatter);


  }
})();

(function () {
  'use strict';


  // Creates: MDolega


  angular
    .module('accordionForm')
    .component('formPane', {
      templateUrl: 'app/main/contactcenter/components/accordionform/formpane.html',
      controller: Ctrl,
      controllerAs: 'vm',
      transclude: {
        pHeader: '?pHeader',
        pMinified: '?pMinified',
        pContent: 'pContent'
      },
      bindings: {
        onOpen: '=',
        paneIcon: '@',
        showMinified: '=',
        hideContent: '=',
        ngDisabled: '=',
        onNextPane: '=',
        nextPaneCall:'=',
        controlsHide:'='
      },
      require: {
        accordionForm: '^^accordionForm'
      }
    });

  /** @ngInject */
  function Ctrl($scope) {
    var vm = this;

    vm.nextPane = nextPane;
    vm.previousPane = previousPane;
    vm.setActivePane = setActivePane;
    vm.completeForm = completeForm;
    vm.countFormProgress = countFormProgress;
    vm.onFormInit = onFormInit;
    vm.$doCheck = doCheck;
    ////////////////

    vm.$onInit = function () {
      vm.active = false;
      vm.registered = false;

      if(vm.nextPaneCall){
        vm.nextPaneCall = nextPane;
      }
        // $scope.$on('active-pane-change', activePaneChange);
      // $scope.$on('pane-registered', paneRegistered);

    };
    vm.$postLink = function () {
      console.log('formPane |', $scope.$id);
      // $scope.$emit('register-pane', $scope.$id);
      vm.accordionForm.registerPane($scope.$id, {
        activate: activatePane,
        deactivate: deactivatePane
      });
      vm.config = angular.copy(vm.accordionForm.config);
      vm.config.controlsActive = !vm.config.clikcableHeader && !vm.controlsHide;
      vm.registered = true;
    };

    vm.$onChanges = function (changesObj) {};

    vm.$onDestory = function () {
      console.log('pane OnDestroy');
    };

    function doCheck() {
      if (vm.form && vm.form.$dirty && (vm.config.countInitProgress ? true : vm.passed)) {
        vm.form.$setPristine();
        // vm.formCopy = angular.copy(vm.form.$$controls);
        vm.formProgress = countProgress();
        updateProgress()
        console.log('formPane progress |' + $scope.$id, vm.formProgress);
      }
    }

    function countFormProgress() {
      vm.formProgress = countProgress();
      updateProgress();
    }
    // function paneRegistered(ev, obj) {
    //   if (obj.stepNumber == $scope.$id) {
    //     vm.isFirst = obj.isFirst;
    //     vm.isLast = obj.isLast;
    //     vm.config.countInitProgress = obj.countInitProgress;
    //     vm.config.clikcableHeader = obj.clikcableHeader;
    //     vm.config.controlsActive = !obj.clikcableHeader;
    //     vm.onComplete = obj.onComplete;
    //     vm.registered = true;
    //     if (vm.onOpen)
    //       vm.onOpen();
    //   } else if (obj.isLast) {
    //     vm.isLast = false;
    //     if (obj.isFirst)
    //       vm.isFirst = false;
    //   }
    // }



    function onFormInit() {
      if (vm.config.countInitProgress) {
        setTimeout(function () {
          vm.formProgress = countProgress();
          updateProgress();
        }, 500);
      }
    }

    // function activePaneChange(ev, obj) {
    //   if (obj.stepNumber == $scope.$id) {
    //     // vm.isFirst = obj.isFirst;
    //     vm.active = true;
    //     vm.passed = false;
    //     vm.config.clikcableHeader = true;
    //     setTimeout(function() {
    //       vm.formProgress = countProgress();
    //     },500);
    //   } else {
    //     vm.active = false;
    //     if (obj.previousPane !== undefined && obj.previousPane == $scope.$id) {
    //       vm.passed = true;
    //       vm.config.clikcableHeader = true;
    //     }
    //   }
    // }

    function activatePane() {
      if (vm.hideContent) {
        setTimeout(function () {
          vm.passed = true;
          nextPane(true);
          vm.formProgress = countProgress();
          updateProgress();
        }, 500);
        return true;
      }else if (vm.ngDisabled) return false;
      else {
        vm.active = true;
        vm.passed = true;
        vm.config.clikcableHeader = true;

        vm.isFirst = vm.accordionForm.registeredPanes[0] == $scope.$id;
        vm.isLast = vm.accordionForm.config.lastScope == $scope.$id;
        if (!vm.config.countInitProgress)
          setTimeout(function () {
            vm.formProgress = countProgress();
            updateProgress();
          }, 500);
        return true;
      }
    }

    function updateProgress() {
      // if (vm.accordionForm.wizzardProgress !== undefined) {
        vm.accordionForm.updateProgress($scope.$id, vm.formProgress);
      // }
    }

    function deactivatePane() {
      vm.active = false;
      // if (previousPane !== undefined && previousPane == $scope.$id) {
      // vm.passed = true;
      vm.config.clikcableHeader = true;
      // }
    }

    function returnAllRequred(form) {
      var resultArray = [];
      form.$$controls.forEach(function (input) {
        if (input.$error) {
          if (angular.isArray(input.$error.required)) {
            var innerFormCount = returnAllRequred(input)
            resultArray = resultArray.concat(innerFormCount);
          } else if (input.$error.required == true) {
            // requiredTrue++;
            resultArray.push(true);
          } else {
            // requiredFalse++;
            resultArray.push(false);
          }
        }
      });
      return resultArray;
    }

    function countProgress() {
      var requiredTrue = 0;
      var requiredFalse = 0;
      if (!vm.config.countInitProgress && !vm.passed) return 0;
      if (vm.form) {
        if (vm.form.$valid) return 100;
        var requiredArray = returnAllRequred(vm.form);
        requiredTrue = requiredArray.filter(function (item) {
          return item == true;
        }).length;
        requiredFalse = requiredArray.filter(function (item) {
          return item == false;
        }).length;

        vm.eAll = requiredTrue + requiredFalse;
        vm.eRequired = requiredTrue;
        return 100 - ((requiredTrue * 100) / (requiredTrue + requiredFalse));
      } else return 0;
    }

    function setActivePane() {
      if (!vm.ngDisabled && !vm.hideContent)
        if (!vm.active && vm.config.clikcableHeader) {
          // $scope.$emit('set-active-pane',$scope.$id);
          vm.accordionForm.setActivePane($scope.$id);
        }
    }

    function nextPane(valid) {
      if (valid) {
        // $scope.$emit('next-pane');
        onNextPane();
        vm.accordionForm.nextPane();
        vm.config.controlsActive = false;
      }
    }

    function completeForm() {
      // $scope.$emit('on-complete');
      vm.accordionForm.completeForm();
    }

    function previousPane() {
      vm.accordionForm.previousPane();

      // $scope.$emit('previous-pane');
    }

    function onNextPane() {
      if (vm.onNextPane) {
        if (angular.isFunction(vm.onNextPane)) {
          vm.onNextPane();
        } else {
          $scope.$emit('accordionForm - paneChange');
        }
      }
    }
  }


})();

/**
 * Created by akraszewski on 2016-12-22.
 */
(function (angular) {
  'use strict';
  angular.module('contactcenter.communicator')
  .service('SessionTagsService',SessionTagsService)
  
  function SessionTagsService($timeout,templateData,communicatorService) {

    var vm = this;
 
    vm.refresChatPartTagsControl = refresChatPartTagsControl;
    vm.updateSessionTileTags = updateSessionTileTags;
    
    function refresChatPartTagsControl(tags){
      templateData.forceReloadTags = false;
      $timeout(function () {
        templateData.tags = tags;
        templateData.forceReloadTags = true;
      }, 0);
    }

    function updateSessionTileTags(sessionID,tags){
      /// COŚ podobnego wołam w communicatorService w funkcji sessionEndClientFn. Nie mogłem wyołać funkcji stąd bo byłby zapętlenie referencji serwisów

      var sessionToUpdate = _.find(communicatorService.historySession, function (n) {
        return   n.sessionID === sessionID ;
      });
      // może tez być w sessjach akutalnych bo ktoś dodał tag przed zamknięciem
      if(!sessionToUpdate){
        sessionToUpdate = _.find(communicatorService.historySession, function (n) {
          return   n.sessionID === sessionID ;
         });
      }

      //Znaleziono sesji to akutalizacji
      if(sessionToUpdate){
        sessionToUpdate.tags=tags;
        sessionToUpdate.forceReloadTags=false;
        $timeout(function () {
          sessionToUpdate.forceReloadTags = true;
        }, 0);
      }
    }
 
 
    return vm;
 
  };

}(window.angular));



(function () {
  'use strict';

  angular
    .module('contactcenter.communicator')
    .component('sessionList', {
      templateUrl: 'app/main/contactcenter/communicator/sessionlist/sessionlist.html',
      controllerAs: 'vm',
      bindings: {
        list: '=',
        type: '='
      },
      controller: Ctrl
    });

  /** @ngInject */
  function Ctrl($mdDialog, DynamicFactory, templateData, communicatorService, $state, SessionManager, WebSocketManager, $scope, OrderboxGlue, MenuManager) {
    var vm = this;
    vm.openCommunicator = openCommunicator;
    // vm.composeDialog = composeDialog;
    // vm.informationDialog = informationDialog;
    
    vm.myStyle = { 'stroke-dashoffset': '380' };

    vm.limit = 60;
    vm.max = 81.6;

    init();

    function init() {

    }

    

    vm.filterList = function (element) {
      if (vm.type === 'active') {
        //mamy wyfiltrowaną listę i nie trzeba filtrować
        return true;
      }
      else if (vm.type === 'history') {
        return !element.finished;
      }
      else if (vm.type === 'closed') {
        return element.finished;
      }
    }

    function openCommunicator(data) {
      MenuManager.hideMiniMenu = true;
      // 3 parametr to wymuszenie otwarcia nowej sesji nawet jak ktoś zaczął pisać smsa
      
      communicatorService.openCommunicator(data, vm.type, true);
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('contactcenter.communicator')
    .component('internalList', {
      templateUrl: 'app/main/contactcenter/communicator/internallist/internallist.html',
      controllerAs: 'vm',
      bindings: {
        list: '=',
        type: '='
      },
      controller: Ctrl
    });

  /** @ngInject */
  function Ctrl($mdDialog, DynamicFactory, templateData, internalMessageService, $state, SessionManager, WebSocketManager, $scope, OrderboxGlue, MenuManager, $filter) {
    var vm = this;
    vm.openCommunicator = openCommunicator;
    vm.internalMessageService = internalMessageService;

    init();

    function init() {
      vm.availableServices = [];

      DynamicFactory.get('AuthResource', 'GetAvableStatuses')().then(function (data) {
        vm.availableServices = data;
      });

      internalMessageService.onUpdateObjectList(updateObjectList);

      //dla konsultanta inny sposob!?!?
      WebSocketManager.registerWebSocketMethod('ConsultantStatusUpdate', 'ConsultantStatusUpdate', onStatusUpdate, SessionManager.buildRegexForCallCenter());
    }
    function openCommunicator(data) {
      MenuManager.hideMiniMenu = true;
      vm.internalMessageService.setSession(data);
    }
    function updateObjectList(message) {
      console.log('updateObjectList - message: ', message);
      if (SessionManager.getUserRole() === 'consultant') {
        if (message.destination[0] === 'M') {
          message.type = 'M';
        }
      }
      else if (SessionManager.getUserRole() === 'manager') {
        if (message.type === 'M') {
          message.type = 'C';
        }
      }

      var object = _.find(vm.list, function (elem) {
        return elem.destination === message.destination && elem.type === message.type && ((elem.source && elem.source === message.source) || !elem.source);
      });
      if (object) {
        object.lastMessage = moment().format('YYYY-MM-DDTHH:mm:ss.SSS');
        // if(!internalMessageService.selectedObject || object.id !== internalMessageService.selectedObject.id){
        //   object.isNew = true;
        // }
      }
    }
    function onStatusUpdate(newStatus) {
      console.log('STATUS konsultanta został zmieniony!');
      if (newStatus.Content) {
        newStatus = angular.isString(newStatus.Content) ? JSON.parse(newStatus.Content) : newStatus.Content;

        var consultant = _.find(vm.list, {id: 'C'+newStatus.consultantID});
        var status = _.find(vm.availableServices, {id: newStatus.status});
        if (consultant && status) {
          consultant.status = newStatus.status;
          consultant.statusIcon = status.icon;
          consultant.statusColor = status.color;
        }
      }
    }
  }
})();

/**
 */
+function () {
  'use strict';

  angular.module('contactcenter.communicator').component('internalMessage', {
    templateUrl: 'app/main/contactcenter/communicator/internalmessage/internalmessage.html',
    controllerAs: 'vm',
    controller: controller
  });

  /** @ngInject */
  function controller(communicatorConfig, templateData) {
    var vm = this;


    vm.$onInit = function () {

    };

    vm.$postLink = function () {

    };
  }

}();

(function () {
	'use strict';

	angular.module('contactcenter.communicator').component('infobar', {
		templateUrl: 'app/main/contactcenter/communicator/infobar/infobar.html',
		controllerAs: 'vm',
		bindings: {
			templateData: '='
		},
		controller: controller
	});
	/** @ngInject */
	function controller(DynamicFactory, SessionTagsService, communicatorService, toastService, $timeout, $mdDialog, confirmDialogService, SessionManager, templateData, $sessionStorage, communicatorConfig) {
		var vm = this;

		vm.lat = null;
		vm.lng = null;

		vm.historySession = [];
		vm.customerData = [];
		vm.messageWarring = null;
		communicatorService.onRunInfoBar(getContactInfo);
		vm.userSession = SessionManager.getUser();
		vm.informationDialog = informationDialog;
		vm.tagsField = tagsField;
		vm.chatSessionEndFn = chatSessionEndFn;

		vm.forwardSessionFn = forwardSession;

		vm.copyGuid = copyGuid;
		vm.showMapDialog = showMapDialog;
		vm.mapIsEnabled = false;


		vm.$onInit = function () {
			getContactInfo();
			getCurrentPosition();
			getMessageSessionInfo();

			communicatorConfig.onChangeConfig(getCommunicatorConfig);

			getCommunicatorConfig();
		};

		vm.$onChanges = function (changesObj) {
			if (changesObj.templateData && changesObj.templateDate.currentValue) {
				getContactInfo();
			}
		};

		function forwardSession(sessionData, event) {
			
			console.log("TCL: forward -> session", sessionData);

			event.stopPropagation();
			sessionData.sessionGuid = sessionData.sessionId;
			sessionData.consultantId = vm.userSession.consultantId;
			$mdDialog.show({
				locals: {
					session: sessionData
				},
				template: '<md-dialog-content><forward-session session="vm.session"></forward-session></md-dialog-content>',
				controller: function (session) {
					this.session = session;
				},
				controllerAs: 'vm',
				parent: angular.element(document.body),
				targetEvent: event,
				clickOutsideToClose: true//,
				// onRemoving: function (event, removePromise) {
				//   console.log(event, removePromise);
				// }
			})
		}

		function getCurrentPosition() {
			var option = {};
			navigator.geolocation.getCurrentPosition(geoSuccess, geoError, option);
		}


		function getCommunicatorConfig() {
			var conf = $sessionStorage.communicatorCofig.communicator.PartPlacement;
			console.log('conf: ', conf);
			vm.mapIsEnabled = findValueInPartConfig(conf, 'map-part');
		}

		function findValueInPartConfig(list, findVal) {
			// var cl = {};
			for (var property in list) {
				if (list.hasOwnProperty(property)) {
					console.log(list[property]);
					if (list[property] == findVal) {
						return true;
					}
					// if (list[property] === part && property !== area) {
					//   cl.used = true;
					// }
				}
			}
			return false;
		}

		function geoSuccess(position) {
			vm.lat = position.coords.latitude;
			vm.lng = position.coords.longitude;
		}

		function geoError(errorObj) {
			var errorMessage;

			switch (errorObj.code) {
				case errorObj.OERMISSION_DENIED:
					errorMessage = 'Brak pozwolenia na znalezienie lokalizacji.';
					toastService.showToast(errorMessage, 'error', 10);
					break;
				case errorObj.POSITION_UNAVAILABLE:
					errorMessage = 'Brak dostępu do sieci.';
					toastService.showToast(errorMessage, 'error', 10);
					break;
				case errorObj.TIMEOUT:
					errorMessage = 'Przekroczono czas oczekiwania.';
					toastService.showToast(errorMessage, 'error', 10);
					break;
			}

		}

		function getContactInfo() {
			DynamicFactory.get('ContactPartRsc', 'getContact')(vm.templateData.contactId).then(function (response) {
				vm.customerData = response;
			});
		}


		function tagsField() {
			var tagss = angular.copy(vm.templateData.tags);
			confirmDialogService
				.showConfirm('setTags', '', {
					serviceId: vm.templateData.serviceId,
					sessionId: vm.templateData.sessionId,
					tags: tagss
				}).then(function (data) {

					SessionTagsService.refresChatPartTagsControl(data);
					SessionTagsService.updateSessionTileTags(vm.templateData.sessionId, data)

				});
		}

		function informationDialog(event) {
			event.stopPropagation();

			$mdDialog.show({
				clickOutsideToClose: true,
				controller: 'sessionInfo',
				controllerAs: 'vm',
				focusOnOpen: false,
				targetEvent: event,
				templateUrl: 'app/main/contactcenter/communicator/sessionlist/sessioninfo/sessioninfo.html',
				multiple: false,
				locals: {
					session: vm.templateData
				}
			});
		}

		function showMapDialog(e) {
			$mdDialog.show({
				clickOutsideToClose: true,
				controller: 'mapDialog',
				controllerAs: 'vm',
				focusOnOpen: false,
				targetEvent: event,
				templateUrl: 'app/main/contactcenter/communicator/dialogs/mapdialog/mapdialog.html',
				multiple: false,
				locals: {
					lati: vm.lat,
					lngi: vm.lng,
					session: vm.templateData
				},
				onRemoving: function (event, removePromise) {
					// angular.element($document[0].body).removeClass('md-dialog-is-showing');
					// element.remove();
					// angular.element('.md-scroll-mask').remove();

					// if (!options.$destroy) options.origin.focus();
				}
			});
		}

		function copyGuid(message) {
			if (!message) {
				toastService.showToast('Brak GUID', 'error', 10);
			} else {
				navigator.clipboard.writeText(message).then(function () {
					toastService.showToast('GUID skopiowany', 'success', 10);
					/* clipboard successfully set */
				}, function () {
					toastService.showToast('Nie udało się skopiować GUID', 'error', 10);
					/* clipboard write failed */
				});
			}
		}

		function getMessageSessionInfo(sessionGuid) {
			var sessionId = sessionGuid || vm.templateData.sessionId;
			DynamicFactory.get('messageSessionRsc', 'getInfo')(
				sessionId
			).then(
				function (data) {
					vm.msgTags = '';
					vm.forceReloadTags = false;
					vm.historySession = data;
					$timeout(function () {
						vm.msgTags = data.tags;
						vm.forceReloadTags = true;
					}, 0);
				},
				function (err) {
				});
		}

		function chatSessionEndFn(ev) {
			confirmDialogService
				.showConfirm('confirmEndSession', '', {
					serviceId: vm.templateData.serviceId,
					sessionId: vm.templateData.sessionId
				})
				.then(
					function (cleningActionReason) {
						console.log('ChatPart | chatSessionEndFn');



						var message = {
							portalId: vm.userSession.portalId,
							serviceId: vm.templateData.serviceId,
							portalUserID: vm.templateData.portalUserId,
							contactID: vm.templateData.contactId,
							titile: '',
							type: 'A',
							body: '',
							sessionId: vm.templateData.sessionId,
							prefix: vm.templateData.prefixID,
							operator: vm.templateData.operator,
							la: vm.templateData.la,
							params: vm.templateData.params,
							replyToGuid: vm.templateData.direction === 'I' ? vm.templateData.guid : null,
							direction: 'O',
							callID: vm.templateData.callid,
							serviceOrderId: vm.templateData.serviceOrderId,
							attachments: vm.selectedAttachmentList,
							communictorType: vm.templateData.communictorType,
							MMSUrls: [],
							attachmentUrls: vm.attachmentUrls,
							fbMessengerID: vm.templateData.fbMessengerID,
							authorPhotoUrl: vm.userSession.userImg,
							authorName: vm.userSession.username,
							timeToSend: vm.templateData.timeToSend,
							fbCommentID: vm.templateData.fbCommentID,
							fbCommentParentID: vm.templateData.fbCommentParentID,
							cleningActionReason: cleningActionReason.answer ? cleningActionReason.answer : cleningActionReason
						};

						DynamicFactory.get('ChatPartRsc', 'sendCleaningMessage')(message).then(
							function (data) {
								vm.communicatorService.setHistorySessionAsFinished(vm.templateData.sessionId);

								DynamicFactory.get('messageSessionRsc', 'addMessageSessionTags')(vm.templateData.sessionId, cleningActionReason.tags).then(
									function (data) {
										getMessageSessionInfo(vm.templateData.sessionId);
									},
									function (err) {
										console.log(err);
									}
								);
							},
							function (err) {
								console.log(err);
							}
						);
					},
					function (err) { }
				);
		}
	}
})();

(function () {
    'use strict';

    angular
        .module('contactcenter.communicator')
        .filter('msgbodyTransform', msgbodyTransform);

    /** @ngInject */
    function msgbodyTransform() {
        return function (txt) {
            if (txt && txt.length > 0) {
                txt = txt.replace(/\n/g, "<br />");
            }
            return txt;
        };
    }

})();
(function() {
    'use strict';

    angular
        .module('contactcenter.communicator')
        .filter('likeIcons', likeIcons);

    /** @ngInject */
    function likeIcons($translate) {
        return function(txt) {
            if (txt === ':like:') {
                return '<img src="/assets/icons/like.png">';
            } else if (txt === ':likedown:') {
                return '<img src="/assets/icons/likedown.png">';
            }
            return txt;
        };
    }

})();
(function () {
  'use strict';

  angular
    .module('contactcenter.communicator')
    .filter('communicatorDateFilter3', altDateCommunicator);

  /** @ngInject */
  function altDateCommunicator($translate) {
    return function (date) {
      var currentLang = $translate.proposedLanguage() || $translate.use();
      var diff = Date.now() - new Date(date);
      var today = moment();
      var yesterday = moment().subtract(1, 'day');
      var minute = moment().subtract(1, 'minute');
      /**
       * If in a hour
       * e.g. "2 minutes ago"
       */

      return moment(date).format('YYYY-MM-DD HH:mm:ss');

    };
  }

})();

(function ()
{
    'use strict';

    angular
        .module('contactcenter.communicator')
        .filter('communicatorDateFilter2', altDateCommunicator);

    /** @ngInject */
    function altDateCommunicator($translate)
    {
        return function (date)
        {
          var currentLang = $translate.proposedLanguage() || $translate.use();
          var diff = Date.now() - new Date(date);
          var today = moment();
          var yesterday = moment().subtract(1, 'day');
          var minute = moment().subtract(1, 'minute');
          /**
           * If in a hour
           * e.g. "2 minutes ago"
           */
          if (moment(date).isSame(minute, 'day')) {
            return moment(date).lang(currentLang).fromNow();
          }
          /*
           * If in the day
           * e.g. "11:23"
           */
          else if (moment(date).isSame(today, 'day')) {
            return 'dziś ' + moment(date).lang(currentLang).format('HH:mm');
          }
          /*
           * If in yesterday
           * e.g "yesterday 13:25"
           */
          else if (moment(date).isSame(yesterday, 'day')) {
            return 'wczoraj ' + moment(date).lang(currentLang).format('HH:mm');
          }
          /*
           * If more than a week
           * e.g. 03/29/2016
           */
          else {
            return moment(date).format('YYYY-MM-DD HH:mm');
          }

        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('contactcenter.communicator')
        .filter('altDateCommunicator', altDateCommunicator);

    /** @ngInject */
    function altDateCommunicator($translate)
    {
        return function (value)
        {
            var currentLang = $translate.proposedLanguage() || $translate.use();
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).lang(currentLang).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000))
            {
                return 'dziś ' + moment(value).lang(currentLang).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).lang(currentLang).format('dddd HH:mm');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).format('YYYY-MM-DD HH:mm');
            }

        };
    }

})();

(function() {
  'use strict';
  angular.module('contactcenter.communicator').directive('dropzone', function() {
    return function (scope, element, attrs) {
      var config, dropzone;
  
      config = scope[attrs.dropzone];
  
      // create a Dropzone for the element with the given options
      dropzone = new Dropzone(element[0], config.options);
  
      // bind the given event handlers
      angular.forEach(config.eventHandlers, function (handler, event) {
        dropzone.on(event, handler);
      });
    };
  });
})();

(function () {
  'use strict';

  angular
    .module('contactcenter.communicator')
    .component('communicatorSwitch', {
      templateUrl: 'app/main/contactcenter/communicator/communicatorswitch/communicatorswitch.html',
      controllerAs: 'vm',
      // bindings: {
      //   list: '=',
      //   type: '='
      // },
      controller: Ctrl
    });

  /** @ngInject */
  function Ctrl($mdDialog, DynamicFactory, communicatorService, $translate, SessionManager, internalMessageService,authRolesConst, $scope) {
    var vm = this;
    vm.switchChange = switchChange;
    vm.communicatorService = communicatorService;
    vm.internalMessageService = internalMessageService;
    vm.switchVisible = false;
    vm.internalCounter = 0;
    vm.clientCounter = 0;

    init();

    function init() {
      //AK komuniaktor pokazujemy wszystim
      vm.switchVisible = true; //SessionManager.isConsultant() && (SessionManager.getUserRole() === 'consultant' || SessionManager.getUserRole() === 'manager');

      communicatorService.onUpdateSessionList(updateSessionList);
      internalMessageService.onUpdateInternalList(updateInternalList);

      setDefaultSwitch();
      setSwitch();
      internalListCounter();
    }


    function setDefaultSwitch() {
      if(SessionManager.getUserRoleId() === authRolesConst.manager){
        vm.communicatorService.communicatorType = 'internal';

      }else{
        vm.communicatorService.communicatorType = 'client';
      }
    }

    function setSwitch() {
      vm.switch = (vm.communicatorService.communicatorType === 'client');
      vm.title = $translate.instant('COMMUNICATOR.' + vm.communicatorService.communicatorType);
    }

    function switchChange() {
      vm.communicatorService.switchType();
      if(!vm.switch){
        internalMessageService.getList();
      }
      setSwitch();
    }

    function updateInternalList() {
      internalListCounter();
    }

    function internalListCounter(){
      if(vm.internalMessageService.objectList){
        var internalElems = _.filter(vm.internalMessageService.objectList, function (x) {
          return x.isNew === true;
        });
        vm.internalCounter = internalElems ? internalElems.length : 0;
      }
    }

    function updateSessionList() {
      vm.clientCounter = vm.communicatorService.activeSession ? vm.communicatorService.activeSession.length : 0;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('contactcenter.callsonline')
    .filter('statusCallsOnline', statusCallsOnline);

  function statusCallsOnline() {
    return function (input) {
      if (!input) return '';

      input = input
        .replace('QUEUED', '#ff5253')
        .replace('RINGING', '#d9a84c')
        .replace('WAIT4DROP', '#47a84b')
        .replace('DISCONNECTED_CONS', '#e03637')
        .replace('DISCONNECTED', '#e03637')
        // .replace('HANGUP', '#e03637')
        .replace('REDIRECTED', '#bebebe')
        .replace('FAILED_REDIRECT', '#b3b3b3')
        .replace('FAILED', '#b3b3b3')
        .replace('WAITING', '#717171');

      return input
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('contactcenter.callsonline')
        .filter('isplaying', isplaying);

        function isplaying() {
            return function (input) {
                if(!input) return '';

                input = input  
                    .replace('DISCONNECTED', 'pauze')

                    return input;
            } 
        }

})();
(function() {
    'use strict';

    angular
        .module('contactcenter.callsonline')
        .filter('forwarding', forwarding);

        function forwarding() {
            return function(input) {
                if(!input) return '';

                input = input
                    // .replace('QUEUED', 'wychodzace')
                    // .replace('RINGING', 'przekieruj')
                    // .replace('WAIT4DROP', 'przekieruj')
                    // .replace('DISCONNECTED', 'przekieruj')
                    // .replace('REDIRECTED', 'przekieruj')
                    // .replace('FAILED', 'przekieruj')
                    // .replace('WAITING', 'przekieruj')

                    return input
            }
        }
})(); 
(function() {
    'use strict';

    angular
        .module('contactcenter.callsonline')
        .filter('eavesdropping', eavesdropping);

        function eavesdropping() {
            return function(input) {
                if(!input) return '';

                input = input
                    // .replace('QUEUED', 'kolejka.png')
                    .replace('WAIT4DROP', 'podsluch.gif')
                    .replace('DISCONNECTED_CONS', 'play.png')
                    .replace('DISCONNECTED', 'play.png')
                    // .replace('HANGUP', 'play.png')
                    .replace('WAITING', 'kolejka.png')
                    // .replace('REDIRECTED', 'wymieć.png')
                    .replace('FAILED', 'clean.png')
                    .replace('FAILED_REDIRECT', 'clean.png')

                    return input;
            }
        }
})();

(function() {
    'use strict';

    angular
        .module('contactcenter.callsonline')
        .filter('eavesdroppicon', eavesdroppicon);

        function eavesdroppicon() {
            return function(input) {
                if(!input) return '';

                input = input
                    // .replace('QUEUED', 'kolejka')
                    .replace('WAIT4DROP', 'nonepodsluch.png')
                    .replace('DISCONNECTED_CONS', 'play.png')
                    .replace('DISCONNECTED', 'play.png')
                    // .replace('HANGUP', 'play.png')
                    .replace('WAITING', 'kolejka.png')
                    // .replace('REDIRECTED', 'wymieć')
                    .replace('FAILED', 'clean.svg')
                    .replace('FAILED_REDIRECT', 'clean.svg')

                    return input
            }
        }
})();

(function () {
    'use strict';

    angular
        .module('contactcenter.callsonline')
        .factory('colors', colors);

    function colors() {
        return {
            listColors: [
                '#0277BD', 
                '#26C6DA',
                '#E57373',
                '#C2185B',
                '#26C6DA',
                '#9575CD',
                '#5C6BC0',
                '#9FA8DA',
                '#90CAF9',
                '#448AFF',
                '#00B8D4',
                '#4DB6AC',
                '#B2DFDB',
                '#66BB6A',
                '#9CCC65',
                '#558B2F',
                '#C0CA33',
                '#F4FF81',
                '#F9A825',
                '#FFD600',
                '#FFB300',
                '#FFB74D',
                '#FFAB40',
                '#FF6E40',
                '#795548'
            ]
        }
    }
})();





(function(){
    'use strict';

    angular
        .module('contactcenter.callsonline')
        .filter('changeNameStatus', changeNameStatus)

        function changeNameStatus() {
            return function(input) {
                if(!input) return '';

                input = input
                    .replace('QUEUED', 'Kolejka')
                    .replace('RINGING', 'Realizowane')
                    .replace('WAIT4DROP', 'Trwa')
                    .replace('ANSWERED', 'Odebrane')
                    .replace('DISCONNECTED_CONS', 'Rozłaczony')
                    .replace('DISCONNECTED', 'Zakończone')
                    .replace('HANGUP', 'Rozłączone')
                    .replace('FAILED', 'Nieudane')
                    .replace('FAILED_REDIRECT', 'Nieudane')
                    .replace('WAITING', 'Czekaj');


                    return input;
            }
        }
})();

(function () {
  'use strict';
  angular
    .module('contactcenter.callsonline')
    .component('callsOnline', {
      templateUrl: 'app/main/contactcenter/callsonline/components/callsonline.html',
      controllerAs: 'vm',
      controller: callsOnline
    });
  /** @ngInject */
  function callsOnline(onlineCalls, WebRTCService, WebSocketManager, colors, wsstatus, $timeout, tripleviewService, $filter, $document, DynamicFactory) {
    var vm = this;
    vm.playRowCallback = playRowCallback;
    vm.clearFailedCalls = clearFailedCalls;
    vm.$onInit = onInit;
    vm.$onDestroy = onDestroy;

    function onInit() {
      //other
      vm.listOnline = []; // aktualnie trwajce połaczenia
      vm.disconnectedList = []; // połaczenia całkowicie zakoczone, czyli po rozłczeniu na poziomie "call"

      vm.loaded = { // lista buforwanych serwisw i konsultantw pobrana przy klikaniu w wiersze managera, przekazywana przez referencj miedzy <call-row>
        consultants: [],
        services: []
      };

      vm.colorsList = colors.listColors; // lista kolorkow dla call-i

      vm.audio = new Audio();

      LoadCurrentCalls();

      //websocket
      WebSocketManager.registerWebSocketMethod('CallIn', 'callAriveMonitoring', wsCalls);
      WebSocketManager.registerWebSocketMethod('CallOut', 'callAriveOutMonitoring', proccessCallOut);
    } //the end $onInit;
    function onDestroy() {
      WebSocketManager.unregisterWebSocketMethod('CallIn', 'callAriveMonitoring');
      WebSocketManager.unregisterWebSocketMethod('CallOut', 'callAriveOutMonitoring');
    }

    function LoadCurrentCalls() {
      DynamicFactory.get("monitoringRsc", "GetCurrentCalls")().then(function (data) {
        // ---------- temp data -----------
        console.log('dane przybyły');
        console.log(data);
        // ---------- temp data -----------

        angular.forEach(data, function (e) {
          //console.log('aaa '+ e);
          wsCalls(callsFromAPIToWSMessageFormat(e));
        });

        console.log('dane przybyły 2');
      }, function (err) {
        console.error('Wystpił bład poczas ładowania aktualnych połaczen: ' + err);
      });
    }

    function callsFromAPIToWSMessageFormat(call) {
      var status, start, ani, dni, bridgeDuration;

      if (call.inAnswered && !call.outAnswered) {
        //połaczenie ktore trafiło do serwisu ale nie zostało jeszcze przekierowane
        status = wsstatus.answered;
        call.leg = 'A';
      } else if (call.inAnswered && call.outAnswered && !call.outDisconnected) {
        //zostało nawizane połaczenie
        status = wsstatus.wait4drop;
        start = call.outAnswered;

        //// tu trzeba zmiane bo nie ma startu całego colla!

      } else if (!call.inDisconnected && call.outDisconnected) {
        //zostało nawizane połaczenie, jest też roz
        status = wsstatus.disconnected;
        start = call.outDisconnected;
        bridgeDuration = getCallDuration(call.outAnswered, call.outDisconnected);

        //// tu trzeba zmiane bo nie ma startu całego colla!

      } else if (call.inDisconnected && call.outDisconnected) {
        //całkowite zakoczenie połaczenia - takie na razie chyba nie beda przychodzić bo w sumie sa nieaktywne
        status = wsstatus.disconnected;
      }


      if (call.type === 'callback') {
        ani = call.outA_Number;
        if (call.outB_Number.length - 3 > 0) {
          dni = call.outB_Number.substring(0, call.outB_Number.length - 3) + '***';
        } else {
          dni = call.outB_Number;
        }

      } else {
        ani = call.inA_Number;
        dni = call.inB_Number;
      }

      return {
        "status": status,
        "ccserviceId": call.ccServiceId,
        "serviceId": call.serviceID,
        "ccserviceBundle": "",
        "callId": call.parentGUID,
        "ani": ani,
        "dni": dni,
        "leg": call.leg,
        "start": start,
        "BridgeID": call.guid,
        "callCenterId": call.callCenterID,
        "consultantId": call.consultantID,
        "bridgeDuration": bridgeDuration,
        "callback": call.type === 'callback',
        "startCall": call.inAnswered,
        "fromAPI": true
      }

    }

    function callbackToWSMessageFormat(data) {

      var callback = JSON.parse(data.Content);

      var decodedT = decodeToken(data.Token);

      var ani = callback.ani.toLowerCase().replace('freetdm/2/a/0', '').replace('freetdm/2/a/', '').replace('user/', '');
      var dni = callback.dni.toLowerCase().replace('freetdm/2/a/0', '').replace('freetdm/2/a/', '').replace('user/', '');
      var dniReal = dni;

      if (dni.length - 3 > 0) {
        dni = dni.substring(0, dni.length - 3) + '***';
      }

      return {
        "status": callback.status,
        "leg": callback.leg,
        "ccserviceId": callback.ccserviceId,
        "serviceId": '',
        "ccserviceBundle": "",
        "callId": callback.callId,
        "ani": ani,
        "dniReal": dniReal,
        "dni": dni,
        "start": callback.start,
        "BridgeID": callback.bridgeUUID,
        "callCenterId": decodedT.callCenterId,
        "consultantId": decodedT.consultantId,
        "bridgeDuration": null, // bridgeDuration, //?????????
        "callback": true
      }
    }


    function proccessCallOut(data) {
      var callbackData = callbackToWSMessageFormat(data);

      if (callbackData.status !== wsstatus.timeupdate) {
        wsCalls(callbackData)
      } else {
        //skip timeupdate
      }
    }

    function wsCalls(data) {
      if (data.fromAPI || data.callback) {

        data.Content = data;
      } else {

        data.Content = JSON.parse(data.Content);
        fillTokenInfo(data.Content, decodeToken(data.Token));
      }

      console.log('------------ CallID GUID: ' + data.Content.callId + ' status: ' + data.Content.status + ' tel: ' + data.Content.ani);

      if (data.Content.type) return;
      // fillTokenInfo(data.Content, decodeToken(data.Token));

      var callMessage = data;

      vm.currentNotify = callMessage.Content;
      var call = findCall(callMessage.Content.callId);
      if (!call) {
        var disconnectedCall = findInDisconnectedCall(callMessage.Content.callId);
        if (disconnectedCall) {
          console.log('!!!!!!!!!!!!!!Call reborn!!!!!!!!!!!!!');
          if (callMessage.Content.status !== wsstatus.disconnected) {
            call = disconnectedCall;
            registerNewCall(call);

            removeFromDisconnectedList(callMessage.Content.callId);
          } else {
            console.log('!!!!!!!!!!!!!!Call buried alive!!!!!!!!!!!!!');
          }

        } else {
          console.log('!!!!!!!!!!!!!!New Call!!!!!!!!!!!!!');
          call = registerNewCall(biuldNewCall(callMessage.Content));
        }

      }
      updateCall(vm.listOnline.indexOf(call), callMessage.Content);
      if (callMessage.Content.status === wsstatus.disconnected || callMessage.Content.status === wsstatus.redirected) {
        disconnectCall(vm.listOnline.indexOf(call), callMessage.Content.ALegActive);
      }
      console.log('kolory', vm.listOnline);
    }

    function disconnectCall(callIndex, ALegActive) {
      if (!ALegActive) {
        $timeout(function () {
          disconnect(callIndex);
        }, 5000);
      }
    }

    function formatNumber(number) {
      var sec = Math.floor((number / 1000) % 60),
        min = Math.floor((number / (1000 * 60) % 60));

      if (sec < 10) {
        sec = '0' + sec;
      }
      if (min < 10) {
        min = '0' + min
      }

      // console.log(min, ':', sec);

      return min + ':' + sec;
    }


    function notDisconected(callId) {
      return findCallIn(callId, vm.disconnectedList) === undefined;
    }

    function findCallIn(callId, callList) {
      var callIndex = _.findIndex(callList, {
        callId: callId
      });
      if (callIndex !== -1) {
        return callList[callIndex];
      }
    }

    function removeFromDisconnectedList(callID) {
      var index = _.findIndex(vm.disconnectedList, {
        callId: callID
      });
      vm.disconnectedList.splice(index, 1);
    }

    function findInDisconnectedCall(callId) {
      return findCallIn(callId, vm.disconnectedList);
    }

    function findCall(callId) {
      return findCallIn(callId, vm.listOnline);
    }


    // function Call(call) {
    //   this.phoneNo = undefined;

    //   if (call.ani.length > 3 && !call.callback) {
    //     this.phoneNo = call.ani.substring(0, call.ani.length - 3) + '***';
    //   } else {
    //     this.phoneNo = call.ani;
    //   }
    //   this.callId = call.callId;
    //   this.notEavesdropp = true;
    //   this.history = [];
    //   this.startTimer = new Date(); // trzeba dat startu !!! TODO!!!
    //   this.phoneNo = phoneNo;
    //   this.ccserviceId = call.ccserviceId;
    //   this.callback = call.callback;
    //   this.consultantId = call.consultantId;
    //   this.currentStatus = call.status ? call.status : undefined;
    //   this.startCall = call.startCall;
    //   this.party = call.party;

    // }
    // Call.prototype.findStage = function (bridgeId) {
    //   if (this.history.length > 0 && this.history[this.history.length - 1].status == 'FAILED_REDIRECT') {
    //     return -1;
    //   } else return _.findIndex(this.history, {
    //     BridgeID: bridgeId
    //   });
    // };
    // Call.prototype.newCallStage = function (bridge) {
    //   this.history.push(newStatus);
    //   return this.history.indexOf(newStatus);
    // };
    // Call.prototype.lastStatus = function(){
    //   return this.history[this.history.length-1].status;
    // }
    // Call.prototype.lastStage = function(){
    //   return this.history[this.history.length-1];
    // }
    // Call.prototype.historyLength= function(){
    //   return this.history.length;
    // }
    // function updateCall(callIndex, newStatus) {
    //   console.log('callsOnline | updateCall callid=',vm.listOnline[callIndex].callId,'BridgeId = '+newStatus.BridgeID)

    //   if (newStatus.fromAPI) {
    //     if (newStatus.status === wsstatus.disconnected) {
    //       vm.listOnline[callIndex].currentStatus = wsstatus.waiting;
    //     } else {
    //       vm.listOnline[callIndex].currentStatus = newStatus.status;
    //     }
    //   } else {
    //     vm.listOnline[callIndex].party = newStatus.party;
    //   }

    //   var indexColor = vm.listOnline.length % vm.colorsList.length;
    //   // console.log('indexColor', indexColor);
    //   vm.listOnline[0].color = angular.copy(vm.colorsList[indexColor]); //vm.listOnline.length - 1


    //   var brigeIndex = vm.listOnline[callIndex].findStage(newStatus.bridgeId);


    //   //jeśli callback, to może nie być bridga, jeśli użytkownik jest w party/kolejce i ma waiting to może rozłaczyć się wtedy przyjdzie disconnect bez bridga
    //   if (brigeIndex == -1 && (newStatus.callback || (newStatus.status === wsstatus.disconnected && !newStatus.fromAPI))) {
    //     brigeIndex = 0;
    //   }

    //   if (vm.listOnline[callIndex].historyLength() > 0 && vm.listOnline[callIndex].lastStatus() == 'FAILED_REDIRECT') {
    //     console.log('callsOnline | last redirect failed callid=',vm.listOnline[callIndex].callId)
    //     if (newStatus.consultantId != vm.listOnline[callIndex].history[brigeIndex].consultantId) {
    //       console.log('callsOnline | with new consultant callid=',vm.listOnline[callIndex].callId)
    //       brigeIndex = -1;
    //     }
    //   }

    //   if (newStatus.status == wsstatus.disconnected && (vm.listOnline[callIndex].currentStatus == wsstatus.disconnected)||(vm.listOnline[callIndex].currentStatus == wsstatus.disconnected_cons)) {
    //     console.log('callsOnline | ignore disconnect callid=',vm.listOnline[callIndex].callId);
    //   } else {
    //     if (brigeIndex !== -1) {
    //       console.log('callsOnline | update call stage  callid=',vm.listOnline[callIndex].callId);

    //       updateCallStage(callIndex, brigeIndex, newStatus);
    //     } else {
    //       if (newStatus.status === 'WAITING' && vm.listOnline[callIndex].history.length > 0) {
    //         //  zeby wielokrotnie nie dodawać waiting
    //         if (vm.listOnline[callIndex].history[vm.listOnline[callIndex].history.length - 1].status !== 'WAITING') {
    //           console.log('callsOnline | add new call stage callid=',vm.listOnline[callIndex].callId);

    //           brigeIndex = newCallStage(callIndex, newStatus);
    //         }
    //       } else {
    //         console.log('callsOnline | add new call stage callid=',vm.listOnline[callIndex].callId);
    //         brigeIndex = newCallStage(callIndex, newStatus);
    //       }
    //     }
    //   }


    // }
    function biuldNewCall(call) {
      // return new Call(call);
      var phoneNo = undefined;

      //w przypadku callback pokazujemy numer bo to numer serwisu
      if (call.ani.length > 3 && !call.callback) {
        phoneNo = call.ani.substring(0, call.ani.length - 3) + '***';
      } else {
        phoneNo = call.ani;
      }

      return {
        callId: call.callId,
        notEavesdropp: true,
        history: [],
        startTimer: new Date(), // trzeba dat startu !!! TODO!!!
        phoneNo: phoneNo,
        ccserviceId: call.ccserviceId,
        callback: call.callback,
        consultantId: call.consultantId,
        currentStatus: call.status ? call.status : undefined,
        startCall: call.startCall,
        party: call.party
      };
    }

    function registerNewCall(call) {
      vm.listOnline.unshift(call);
      return vm.listOnline[0];
    }


    function updateCall(callIndex, newStatus) {
      console.log('callsOnline | updateCall callid=', vm.listOnline[callIndex].callId, 'BridgeId = ' + newStatus.BridgeID)

      if (newStatus.fromAPI) {
        if (newStatus.status === wsstatus.disconnected) {
          vm.listOnline[callIndex].currentStatus = wsstatus.waiting;
        } else {
          vm.listOnline[callIndex].currentStatus = newStatus.status;
        }
      } else {
        vm.listOnline[callIndex].party = newStatus.party;
      }

      var indexColor = vm.listOnline.length % vm.colorsList.length;
      // console.log('indexColor', indexColor);
      vm.listOnline[0].color = angular.copy(vm.colorsList[indexColor]); //vm.listOnline.length - 1
      var brigeIndex = _.findIndex(vm.listOnline[callIndex].history, {
        BridgeID: newStatus.BridgeID
      });

      //jeśli callback, to może nie być bridga, jeśli użytkownik jest w party/kolejce i ma waiting to może rozłaczyć się wtedy przyjdzie disconnect bez bridga
      if (brigeIndex == -1 && (newStatus.callback || (newStatus.status === wsstatus.disconnected && !newStatus.fromAPI))) {
        brigeIndex = 0;
      }

      if (vm.listOnline[callIndex].history.length > 0 && vm.listOnline[callIndex].history[vm.listOnline[callIndex].history.length - 1].status == 'FAILED_REDIRECT') {
        console.log('callsOnline | last redirect failed callid=', vm.listOnline[callIndex].callId)
        if (newStatus.consultantId != vm.listOnline[callIndex].history[brigeIndex].consultantId) {
          console.log('callsOnline | with new consultant callid=', vm.listOnline[callIndex].callId)
          brigeIndex = -1;
        }
      }

      if (brigeIndex !== -1) {
        console.log('callsOnline | update call stage  callid=', vm.listOnline[callIndex].callId);
        if (newStatus.status == wsstatus.disconnected && (vm.listOnline[callIndex].currentStatus == wsstatus.disconnected) || (vm.listOnline[callIndex].currentStatus == wsstatus.disconnected_cons)) {
          console.log('callsOnline | ignore disconnect callid=', vm.listOnline[callIndex].callId, 'bridgeId='+vm.listOnline[callIndex][bridgeIndex].callId);
        } else {
          updateCallStage(callIndex, brigeIndex, newStatus);
        }
      } else {
        if (newStatus.status === 'WAITING' && vm.listOnline[callIndex].history.length > 0) {
          //  zeby wielokrotnie nie dodawać waiting
          if (vm.listOnline[callIndex].history[vm.listOnline[callIndex].history.length - 1].status !== 'WAITING') {
            console.log('callsOnline | add new call stage callid=', vm.listOnline[callIndex].callId);

            brigeIndex = newCallStage(callIndex, newStatus);
          }
        } else {
          console.log('callsOnline | add new call stage callid=', vm.listOnline[callIndex].callId);
          brigeIndex = newCallStage(callIndex, newStatus);
        }
      }


    }

    function fillTokenInfo(status, tokenInfo) {
      status.callCenterId = tokenInfo.callCenterId;
      status.consultantId = tokenInfo.consultantId;
    }

    function decodeToken(token) {
      var tokenSplit = token.split(':')[0];
      var tokenArray = token.match(/-?\d{1,9}/gim);
      return {
        callCenterId: tokenArray.length > 1 ? tokenArray[1] : undefined,
        consultantId: tokenArray.length > 2 ? tokenArray[2] : undefined
      }
    }

    function newCallStage(callIndex, newStatus) {
      vm.listOnline[callIndex].history.push(newStatus);
      return vm.listOnline[callIndex].history.indexOf(newStatus);
    }

    function updateCallStage(callIndex, brigeIndex, call) {

      if (call.status === wsstatus.disconnected && brigeIndex !== -1) {
        if (vm.listOnline[callIndex].history.length > 0) {
          var lastTalkStart = vm.listOnline[callIndex].history[brigeIndex].talkStart;
          if (lastTalkStart) {
            call.talkStart = lastTalkStart;
          } else {
            call.talkStart = vm.listOnline[callIndex].history[brigeIndex].start;
          }
          call.bridgeDuration = getCallDuration(call.talkStart, call.start);
        } else {
          // call.bridgeDuration=call.bridgeDuration;
        }
      }

      // oznacz że połaczenie rozłczone przez konsultanta
      if (!call.callback && call.status === wsstatus.disconnected && call.leg === 'B') {
        call.status = wsstatus.disconnected_cons;
      } else if (call.callback && call.status === wsstatus.disconnected && call.leg === 'A') {
        call.status = wsstatus.disconnected_cons;
      }

      // -------- update na poziomie call -----------------
      if (call.callback && call.leg === 'B' && (call.status === wsstatus.ringing)) {
        //to pomin zmiane statusu call
      } else {
        vm.listOnline[callIndex].currentStatus = call.status;
      }
      // totalny czas rozmowy a zarazm zatrzymanie timera dla call
      if ((call.status === wsstatus.disconnected || call.status === wsstatus.disconnected_cons) && (call.callId === call.disconnectedUUID || call.party !== true)) {
        vm.listOnline[callIndex].callDuration = getCallDuration(call.startCall, call.start);
      }
      // -------- update na poziomie call -----------------



      // wyjtki do statusow
      //jeśli konsultant odebrał tel to przez chwilę jest status answered a chwilę później ringing od klienta więc zmieniamy ringing na answered
      if (call.callback && call.leg === 'B' && (call.status === wsstatus.ringing)) {
        call.status = wsstatus.answered;
      }

      // przy consultantID=-1 i party, nie zmieniamy info w bridge
      // może przyjść status WAITING i DISCONNECTED
      // consultant ID może być w stringu
      if (call.consultantId == -1 && call.party) {
        var lastDisconnected = vm.listOnline[callIndex].history[brigeIndex];

        if (call.status === wsstatus.waiting) {
          call.status = lastDisconnected.status;
          call.bridgeDuration = lastDisconnected.bridgeDuration;
        } else if (call.status === wsstatus.disconnected) {
          call.BridgeID = lastDisconnected.BridgeID
        }

        call.consultantId = lastDisconnected.consultantId;


      }

      vm.listOnline[callIndex].history[brigeIndex] = call;
    }

    function disconnect(callIndex) {

      if (!(vm.listOnline[callIndex].currentStatus === wsstatus.disconnected || vm.listOnline[callIndex].currentStatus === wsstatus.redirected)) {
        //znaczy tyle że była ładowana historia i na koniec doczytała sie wiadomosc aktualna
        return;
      }

      var indexColor = vm.disconnectedList.length % vm.colorsList.length;
      if (vm.listOnline[callIndex]) {
        if (notDisconected(vm.listOnline[callIndex].callId)) {
          var disconnectedCall = angular.copy(vm.listOnline[callIndex]);
          // disconnectedCall.endTimer = getCallEnd(disconnectedCall);
          disconnectedCall.color = angular.copy(vm.colorsList[indexColor]);
          vm.disconnectedList.unshift(disconnectedCall);
          vm.listOnline.splice(callIndex, 1);
          console.log(disconnectedCall.history.map(function (elem) {
            return moment(elem.start).format('hh:mm');
          }));
        }
      }
    }

    // function getCallEnd(call) {
    //   return call.history[call.history.length - 1].start;
    //
    // }

    function getCallDuration(start, end) {
      return formatTimespan(start, end);
    }

    function formatTimespan(fromDate, toDate) {
      var defference = Date.parse(toDate) - Date.parse(fromDate);
      if (defference > 0) {
        return formatNumber(defference)
      } else {
        return '00:00';
      }
    }

    function clearFailedCalls() {
      var failedCalls = $filter('filter')(vm.disconnectedList, {
        history: {
          status: wsstatus.failed
        }
      });
      angular.forEach(failedCalls, function (value, key) {
        angular.forEach(value.history, function (val, k) {
          if (val.status == wsstatus.failed) {
            value.history.splice(k, 1);
          }
        })
      })

    }

    function playRowCallback(call, audioLink) {
      vm.audio.pause();
      var findPlayRec = $filter('filter')(_.union(vm.disconnectedList, vm.listOnline), {
        isPlaying: true
      });

      //szukanie grajcych nagran poziom nizej
      angular.forEach(vm.listOnline, function (i) {
        angular.forEach(i.history, function (j) {
          if (j.isPlaying === true) {
            findPlayRec.push(j);
          }
        });
      });

      angular.forEach(vm.disconnectedList, function (i) {
        angular.forEach(i.history, function (j) {
          if (j.isPlaying === true) {
            findPlayRec.push(j);
          }
        });
      });

      // prevRecording
      angular.forEach(findPlayRec, function (value, key) {
        if (findPlayRec.length >= 1) {
          value.isPlaying = false;
        }
      });
      if (audioLink) {
        call.isPlaying = true;
        vm.audio.src = audioLink;
        if (vm.audio.paused) {
          vm.audio.play();
          call.isPlaying = true;
        } else {
          vm.audio.pause();
          call.isPlaying = false;
        }
      }
      // playCallback();
    }


  }
})();

(function() {
    'use strict';

    angular.module('Resources', [
        'consts'
    ]);
})();
(function () {
  'use strict';

  angular
    .module('Resources')
    .factory('ResourceBuilder', Resourcebuilder);

  Resourcebuilder.inject = ['$resource', 'SessionManager', 'consts'];

  function Resourcebuilder($resource, SessionManager, consts) {
    var role;
    var methodsDefault = {
      get: {
        method: 'GET',
        isArray: true
      },
      save: {
        method: 'POST',
      },
      post: {
        method: 'POST',
        isArray: true
      }
    };



    function getRole() {
      if (!role) {
        role = SessionManager.getUserRole();
      }
      return role + '/';
    }

    function decodeParams(url) {
      var result = {};
      getParamNames(url).map(function (param) {
        result[param] = '@' + param;
      });
      return result === {} ? undefined : result;
    }

    function getParamNames(url) {
      var params = [];
      var slicedUrl = url.split('/');
      for (var i = slicedUrl.length - 1; i > 0; i--) {
        if (slicedUrl[i].indexOf(':') !== -1) {
          params.push(slicedUrl[i].slice(1));
        } else {
          break;
        }
      }
      return params;
    }

    function buildEndpoint(url, withRole) {
      return consts.api.concat(withRole ? getRole() : '').concat(url);
    }


    function buildAll(sourceArray) {
      var source = angular.copy(sourceArray);
      var result = {};
      for (var i = 0; i < source.length; i++) {
        result[source[i].name] = build(buildEndpoint(source[i].url, source[i].withRole), source[i].methods, source[i].params);
      }
      return result;
    }

    ////////////////
    function build(url, methods, params) {
      if (!params) {
        params = decodeParams(url);
      }
      if (methods) {

        methods = buildMethodBlock(methods,url);
      }
      return $resource(url,
      params || '@send', methods || methodsDefault);

      // return $resource(buildEndpoint(url, withRole),
      //   params || '@send', methods || methodsDefault);
    }

    function buildMethodBlock(methods,baseUrl) {
      var result = {};
      // var methodBuilder = buildMethod(withRole);
      for (var method in methods) {
        if(methods[method]){
          result[method] = buildMethod(methods[method],baseUrl);
        }
      }
      return result;
    }

   function buildMethod(method,baseUrl) {
        if (method.url) {
          method.params = decodeParams(method.url);
          method.url = method.url[0]==='/' ? baseUrl+ method.url : buildEndpoint(method.url, method.withRole);
        }
        return method;
      }


    return {
      build: build,
      buildAll: buildAll,
      getParamNames: getParamNames,
      buildEndpoint:buildEndpoint
    };
  }
})();

(function($) {
    var defaults;
    $.event.fix = (function(originalFix) {
      return function(event) {
        event = originalFix.apply(this, arguments);
        if (event.type.indexOf('copy') === 0 || event.type.indexOf('paste') === 0) {
          event.clipboardData = event.originalEvent.clipboardData;
        }
        return event;
      };
    })($.event.fix);

    defaults = {
      callback: $.noop,
      matchType: /image.*/
    };
    return $.fn.pasteImageReader = function(options) {
      if (typeof options === 'function') {
        options = {
          callback: options
        };
      }
      options = $.extend({}, defaults, options);
      return this.each(function() {
        var $this, element;
        element = this;
        $this = $(this);
        return $this.bind('paste', function(event) {
          var clipboardData, found;
          found = false;
          clipboardData = event.clipboardData;
          
          return Array.prototype.forEach.call(clipboardData.types, function(type, i) {
            var file, reader;
            if (found) {
              return;
            }
            if (type.match(options.matchType) || clipboardData.items[i].type.match(options.matchType)) {
              file = clipboardData.items[i].getAsFile();
              reader = new FileReader();
              reader.onload = function(evt) {
                return options.callback.call(element, {
                  dataURL: evt.target.result,
                  event: evt,
                  file: file,
                  name: file.name
                });
              };
              reader.readAsDataURL(file);
              return found = true;
            }
          });
        });
      });
    };
  })(jQuery);
(function () {
    'use strict';

    angular
        .module('Resources')
        .service('DynamicFactory', DynamicFactory);
    /** @ngInject */
    function DynamicFactory($injector, $cacheFactory, $q, md5) {
      // var _this = {
      //   get : get,
      //   reset : reset,
      //   saveGet: saveGet,
      //   arrayOfResponse: []
      // };

      var _this = this;
      _this.get = get;
      _this.reset = reset;
      _this.saveGet = saveGet;
      _this.arrayOfResponse = [];
        // var _this = this;
        // _this.get = get;
        // _this.reset = reset;

        function initCache() {
            _this.resources = $cacheFactory('resources');
            _this.resources.put("test", true);
        }

        function get(factoryName, resourceName) {
            // console.info('Wywołano akcje: '+ resourceName+ ' z Factory: '+ factoryName);
            if (!_this.resources) {
                initCache();
            }
            if (!_this.resources.get(factoryName)) {
                var f = angular.copy($injector.get(factoryName));
                _this.resources.put(factoryName, f);
            }

            var factory = _this.resources.get(factoryName);

            return resourceName ? factory[resourceName] : factory;

        }
        ///////////////
        function reset() {
            if(_this.resources)
                _this.resources.removeAll();
        }





        //SaveGet
        function saveGet(resource, method) {
          return function (params) {
            var defer = $q.defer();

            var path = generatePath(resource, method, params);
            var currentPromise = getPromiseValue(path);

            if(!currentPromise){
              replacePromiseValue(path, {
                factory : get(resource, method),
                params : params,
                //pending
                //data
                //promise
              });
              currentPromise = getPromiseValue(path);
              //console.log('saveGet | create new pending '+path);
            }

            getTags(path,!currentPromise.pending).then(defer.resolve,defer.reject);
              //!currentPromise.pending
            return defer.promise;
          }
        }


        function getTags(path, refresh) {
          var defer = $q.defer();

          var currentPromise = getPromiseValue(path);

          if (currentPromise.data && !refresh) {
            //console.log('saveGet | resolve existing '+path);
            defer.resolve(currentPromise.data);
          } else {
            if (currentPromise.promise && !refresh) {
              //console.log('saveGet | add pending '+path);
              replacePromiseValue(path+'.pending', currentPromise.pending + 1);
              $q.all([getPromiseValue(path+'.promise')]).then(function (result) {
                replacePromiseValue(path+'.pending', getPromiseValue(path+'.pending')-1);
                //console.log('saveGet | resolve pending '+path,'current queue = '+getPromiseValue(path+'.pending'));

                defer.resolve(currentPromise.data);
              });



            } else {

              replacePromiseValue(path+'.promise', currentPromise.factory(currentPromise.params));
              replacePromiseValue(path+'.pending', 1);
              //console.log('saveGet | new pending '+path,'current queue = '+1);

              // _this.lastPromise = DynamicFactory.get('ContactCenterRsc', 'getCallCenters')();

              $q.all([getPromiseValue(path+'.promise')]).then(function (data) {
                // _this.callcenters = data[0];
              replacePromiseValue(path+'.data', data[0]);
              replacePromiseValue(path+'.pending', getPromiseValue(path+'.pending')-1);
              //console.log('saveGet | resolve pending '+path,'current queue = '+getPromiseValue(path+'.pending'));

                defer.resolve(getPromiseValue(path+'.data'));
              });



            }
          }
          return defer.promise;
        }


        function generatePath(resource, method, params){
          return resource + '.' + method + '.' + md5.createHash(params ? JSON.stringify(params) : 'empty');
        }

        // function promiseExist(path){
        //   return getPromiseValue(path) === undefined;
        // }

        // function prepareLastPromise(path) {
        //   var promise = getPromiseValue(path);
        //   if(promise){

        //   }
        // }

        function getPromiseValue(path) {
          var schema = _this.arrayOfResponse; // a moving reference to internal objects within obj
          var pList = path.replace(/\[(\w+)\]/g, '.$1').split('.');
          var len = pList.length;
          for (var i = 0; i < len - 1; i++) {
            var elem = pList[i];
            if (!schema[elem]) schema[elem] = {};
            schema = schema[elem];
          }
          return schema[pList[len - 1]];
        }

        function replacePromiseValue(path, value) {
          var schema = _this.arrayOfResponse; // a moving reference to internal objects within obj
          var pList = path.replace(/\[(\w+)\]/g, '.$1').split('.');
          var len = pList.length;
          for (var i = 0; i < len - 1; i++) {
            var elem = pList[i];
            if (!schema[elem]) schema[elem] = {};
            schema = schema[elem];
          }

          schema[pList[len - 1]] = value;
        }
        // return _this;

    }
})();

/**
 * Created by akraszewski on 07.09.2016.
 */
+(function(angular) {
  "use strict";
  angular.module("Resources").factory("CommontFunc", CommontFunc);

  /** @ngInject */
  function CommontFunc() {
    var _this = this;

    _this.getMenuItemArray = function(startName) {
      var menuArray = [{
        name:startName
      }];
      menuArray.prototype.addMenuItem = function(token, objMenu) {
        var parsedToken = token.split(".");
        var menuItem = this;

        var subToken = "";
        for (var i = 0; i < parsedToken.length; i++) {
          subToken += "." + parsedToken[i];
          var result = this.getFromArray(subToken, menuItem);
          if (result) {
            menuItem = result;
          } else {
            break;
          }
        }
        objMenu.name = token;
        if(!menuItem.submenu){
          menuItem.submenu = [];
        }
        menuItem.submenu.push(objMenu);
        return this;
      };
      menuArray.prototype.getFromArray = function(subToken, arrayScope) {
        for (var i = 0; i < arrayScope.length; i++) {
          var menuItem = arrayScope[i];
          if (menuItem.name === subToken) {
            return menuItem;
          }
        }
      };
      return menuArray;
    };

    //----------------------------- STRING -------------------------------

    /// zamienia w stringu wszystkie wystąpienia "search" na "replace"
    _this.replaceAll = function(source, search, replacement) {
      // String.prototype.replaceAll = function(search, replacement) {
      //   var target = this;
      //   return target.split(search).join(replacement);
      // };

      return source.split(search).join(replacement);
    };

    /// próbuje przekonwertować string na JSON, jeśli nie wyjdzie to zwraca false, przykładowe użycie:
    //   var json = tryParseJSON(vm.serviceCommunicationParams);
    //   if (json) {
    //     vm.templateData.serviceCommunicationParams = json;
    //   }
    _this.tryParseJSON = function(jsonString) {
      try {
        var o = JSON.parse(jsonString);

        // Handle non-exception-throwing cases:
        // Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
        // but... JSON.parse(null) returns null, and typeof null === "object",
        // so we must check for that, too. Thankfully, null is falsey, so this suffices:
        if (o && typeof o === "object") {
          return o;
        }
      } catch (e) {}

      return false;
    };

    return _this;
  }
})(window.angular);

/**
 * Created by kosski on 25.10.2017
 */

+(function () {
  "use strict";

  angular.module("Resources").factory("jiraRsc", jiraRsc);

  /** @ngInject */
  function jiraRsc(ResourceBuilder, consts, $q, $localStorage, FileUploader, SessionManager) {
    var _this = {};

    _this.newResources = [{
        name: "jira",
        url: "jira",
        withRole: false,
        methods: {
          get: {
            method: "GET"
          },
          save: {
            method: "POST"
          },
          projects: {
            method: "GET",
            url: "/projects",
            isArray: true
          },
          active: {
            url: "/active",
            method: "GET"
          },
          statuses: {
            url: "/statuses",
            method: "GET",
            isArray: true
          }
        }
      },
      {
        name: "partnerJira",
        url: "jira/server",
        withRole: true,
        methods: {
          get: {
            method: "GET"
          },
          save: {
            method: "POST"
          },
          delete: {
            url: "/:jiraId",
            method: "DELETE"
          }
        }
      },
      // {
      //   name: 'server',
      //   url: 'jira/server',
      //   withRole: false,
      //   methods: {
      //     get: {
      //       method: 'GET'
      //     }
      //   }
      // },
      {
        name: "issue",
        url: "jira/issue",
        withRole: false,
        methods: {
          get: {
            url: "/:issueId",
            method: "GET"
          },
          save: {
            method: "POST"
          },
          types: {
            url: "/types",
            method: "GET"
          },
          comment: {
            url: "/comment",
            method: "POST"
          },
          attachment: {
            url: '/attachment',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            transformResponse: function (data) {
              return {
                stringValue: angular.fromJson(data)
              }
            }
          }
        }
      },
      {
        name: "oauth",
        url: "jira/authorization",
        withRole: false,
        methods: {
          start: {
            url: "/start",
            method: "GET"
          },
          complete: {
            url: "/complete/:oauth_verifier/:oauth_token",
            method: "GET"
          }
        }
      }
    ];

    _this.getOauthLink = function () {
      return _this.resources.oauth.start().$promise;
    };
    _this.getOauthToken = function (data) {
      return _this.resources.oauth.complete(data).$promise;
    };

    _this.buildOauth = function (jiraUrl) {
      // var resourceToBuild = {
      //   name: 'oauth',
      //   url: jiraUrl + '/plugins/servlet/oauth',
      //   withRole: false,
      //   methods: {
      //     authorization : {
      //       url: '/authorize',
      //       method: 'GET'
      //     },
      //     accessToken:{
      //       url: '/access-token',
      //       method: 'GET'
      //     }
      //   }
      // };
      // _this.resources['oauth'] = ResourceBuilder.build(jiraUrl + '/plugins/servlet/oauth',{
      //   authorization : {
      //     url: '/authorize',
      //     method: 'GET'
      //   },
      //   accessToken:{
      //     url: '/access-token',
      //     method: 'POST'
      //   },
      //   requestToken:{
      //     url:'/request-token',
      //     method: 'POST',
      //     headers: {
      //       'Access-Control-Allow-Origin':'*',
      //       'Content-Type': 'application/json',
      //       'X-Atlassian-Token': 'nocheck'
      //     }
      //   }
      // },{});
    };

    // _this.jiraAuthorize = function () {
    //   return _this.resources.oauth.authorization().$promise;
    // }

    // _this.jiraRequestToken = function (data) {
    //   return _this.resources.oauth.requestToken(data).$promise;
    // }

    // _this.jiraAccessToken = function (data) {
    //   return _this.resources.oauth.accessToken().$promise;
    // }

    _this.jiraEnable = function () {
      return _this.resources.jira.active().$promise;
    };

    _this.getPartnerJira = function () {
      return _this.resources.partnerJira.get().$promise;
    };

    _this.setPartnerJira = function (model) {
      return _this.resources.partnerJira.save(model).$promise;
    };

    _this.deletePartnerJira = function (jiraId) {
      return _this.resources.partnerJira.delete({
        jiraId: jiraId
      }).$promise;
    };

    _this.getProjects = function () {
      return _this.resources.jira.projects().$promise;
    };

    _this.getStatuses = function () {
      return _this.resources.jira.statuses().$promise;
    };

    _this.getIssue = function (issueId) {
      return _this.resources.issue.get({
        issueId: issueId
      }).$promise;
    };

    _this.createIssue = function (model, extraInfo) {
      return _this.resources.issue.save({
        issue: model,
        extraInfo: extraInfo,
      }).$promise;
    };

    _this.getIssueTypes = function (model) {
      return _this.resources.issue.types(model).$promise;
    };

    _this.addAttachmentToIssue = function (model, issueIdOrKey) {
      return _this.resources.issue.attachment({
        attachments: model,
        issueIdOrKey: issueIdOrKey
      }).$promise;
    };

    _this.addComment = function (model) {
      return _this.resources.issue.comment(model).$promise;
    };

    _this.reloadResourcesWithToken = function (token) {
      return $q(function (resolve, reject) {
        if (!_this.token || _this.token !== token) {
          _this.token = token;
          _this.newResources.forEach(function (resource) {
            for (var key in resource.methods) {
              if (resource.methods[key]) {
                if (resource.methods[key].headers) {
                  resource.methods[key].headers["jira-token"] = token;
                } else {
                  resource.methods[key].headers = {
                    "jira-token": token
                  };
                }
              }
            }
          });
          _this.resources = ResourceBuilder.buildAll(_this.newResources);
        }
        _this.getProjects().then(resolve, reject);
      });
    };

    _this.getUploader = function (endpoint, autoUpload) {
      return new FileUploader({
        // sendAllAtOnceItemsMultipleFileInputs: false,
        url: consts.api + endpoint,
        autoUpload: autoUpload,
        dataType: "json",
        cache: false,
        contentType: "application/json",
        headers: {
          'Authorization': 'Bearer ' + SessionManager.getToken(),
          'jira-token': $localStorage.userCredential.accessToken
        }
      });
    };

    if ($localStorage.userCredential) {
      _this.reloadResourcesWithToken($localStorage.userCredential.accessToken);
    }
    _this.resources = ResourceBuilder.buildAll(_this.newResources);

    return _this;
  }
})();

+(function () {
  'use strict';

  angular.module("Resources").factory("issueTrackerRsc", issueTrackerRsc);

  /** @ngInject */
  function issueTrackerRsc(ResourceBuilder) {
    var _this = {};

    _this.newResources = [{
        name: "issueTrackerConfig",
        url: "issuetracker/server",
        withRole: false,
        methods: {
          get: {
            method: "GET"
          }
        }
      },

      {
        name: "issueTrackerConfigWithRole",
        url: "issuetracker/server",
        withRole: true,
        methods: {
          post: {
            method: "POST"
          },
          delete: {
            method: "DELETE"
          }
        }
      },

      {
        name: "issueTrackers",
        url: "issuetracker",
        withRole: false,
        method: {
          get: {
            method: "GET",
            isArray: true
          }
        }
      }
    ];

    _this.getIssueTrackerConfig = function () {
      return _this.resources.issueTrackerConfig.get().$promise;
    };

    _this.setIssueTrackerConfig = function (model) {
      return _this.resources.issueTrackerConfigWithRole.post(model).$promise;
    };

    _this.deleteIssueTrackerConfig = function () {
      return _this.resources.issueTrackerConfigWithRole.delete().$promise;
    };

    _this.getIssueTrackers = function () {
      return _this.resources.issueTrackers.get().$promise;
    };

    _this.resources = ResourceBuilder.buildAll(_this.newResources);

    return _this;
  }
})();

+(function () {
  'use strict';

  angular.module("Resources").factory("bugzillaRsc", bugzillaRsc);

  /** @ngInject */
  function bugzillaRsc($q, $localStorage, SessionManager, FileUploader, ResourceBuilder, consts) {
    var _this = {};

    _this.newResources = [{
        name: "bugzilla",
        url: "bugzilla",
        withRole: false,
        methods: {
          /* active: {
             method: "GET",
             url: "/active"
           },*/
          version: {
            method: "GET",
            url: "/version"
          },
          validToken: {
            method: "GET",
            url: "/valid_token"
          },
          products: {
            method: "GET",
            url: "/products",
            isArray: true
          }
        }
      },

      {
        name: "issue",
        url: "bugzilla/issue",
        withRole: false,
        methods: {
          get: {
            method: "GET",
            url: "/:bugIdOrAlias"
          },
          create: {
            method: "POST"
          },
          comment: {
            method: "POST",
            url: "/comment"
          },
          comments: {
            method: "GET",
            url: "/:bugIdOrAlias/comments",
            isArray: true
          }
        }
      }

    ];

    /* _this.isBugzillaConfigured = function () {
       return _this.resources.bugzilla.active().$promise;
     };*/

    _this.isValidToken = function (login) {
      return _this.resources.bugzilla.validToken(login).$promise;
    };

    _this.getProducts = function () {
      return _this.resources.bugzilla.products().$promise;
    };

    _this.createIssue = function (model, sessionId, type, contactId) {
      return _this.resources.issue.create({
        issue: model,
        type: type,
        sessionId: sessionId,
        contactId: contactId
      }).$promise;
    };

    _this.getIssue = function (bugIdOrAlias) {
      return _this.resources.issue.get({
        bugIdOrAlias: bugIdOrAlias
      }).$promise;
    };

    _this.addCommentToIssue = function (comment, bugId) {
      return _this.resources.issue.comment({
        comment: comment,
        bugId: bugId
      }).$promise;
    };

    _this.getIssueComments = function (bugIdOrAlias) {
      return _this.resources.issue.comments({
        bugIdOrAlias: bugIdOrAlias
      }).$promise;
    };

    _this.reloadResourcesWithToken = function (token) {
      return $q(function () { //, reject
        if (!_this.token || _this.token !== token) {
          _this.token = token;
          _this.newResources.forEach(function (resource) {
            for (var key in resource.methods) {
              if (resource.methods[key]) {
                if (resource.methods[key].headers) {
                  resource.methods[key].headers["bugzilla-token"] = token;
                } else {
                  resource.methods[key].headers = {
                    "bugzilla-token": token
                  };
                }
              }
            }
          });
          _this.resources = ResourceBuilder.buildAll(_this.newResources);
        }
        //_this.getProjects().then(resolve, reject);        
      });
    };

    _this.getUploader = function (endpoint, autoUpload) {
      return new FileUploader({
        url: consts.api + endpoint,
        autoUpload: autoUpload,
        dataType: "json",
        cache: false,
        contentType: "application/json",
        headers: {
          'Authorization': 'Bearer ' + SessionManager.getToken(),
          'bugzilla-token': $localStorage.userCredential.accessToken
        }
      });
    };

    if ($localStorage.userCredential) {
      _this.reloadResourcesWithToken($localStorage.userCredential.accessToken);
    }
    _this.resources = ResourceBuilder.buildAll(_this.newResources);

    return _this;
  }
})();

/**
 */
+function (angular) {
  'use strict';
  angular
    .module('Resources')
    .factory('PartyRsc', ['$resource', 'consts', 'SessionManager', PartyRsc]);
  /** @ngInject */
  function PartyRsc($resource, consts, SessionManager) {
    var _this = this;

    var role = SessionManager.getUserRole();

    _this.resources = {
      getConsultants: $resource(consts.api + "/common/party/consultants", {}, {
        get: {
          method: 'GET',
          isArray: true
        }
      }),
      getClients: $resource(consts.api + "/common/party/clients", {}, {
        get: {
          method: 'GET',
          isArray: true
        }
      }),
      getOnline: $resource(consts.api + "/common/party/online", "@msgModel", {
        get: {
          method: 'POST',
          isArray: true
        }
      }),
      login: $resource(consts.api + "/common/party/login", "@loginModel", {
        send: {
          method: 'POST'
        }
      }),
      logout: $resource(consts.api + "/common/party/logout", "@logoutModel", {
        send: {
          method: 'POST'
        }
      }),
      sendMsg: $resource(consts.api + "/common/party/sendmsg", "@msgModel", {
        send: {
          method: 'POST'
        }
      }),
      playMsg: $resource(consts.api + "/common/party/playmsg", "@msgModel", {
        send: {
          method: 'POST'
        }
      }),
      playName: $resource(consts.api + "/common/party/playname", "@msgModel", {
        send: {
          method: 'POST'
        }
      }),
      rooms: $resource(consts.api + role + "/party/rooms", {}, {
        get: {
          method: 'GET',
          isArray: true
        }
      }),
      // startEavesdropp: $resource(consts.api + "/common/party/StartEavesdropp/:uuid",  {
      startEavesdropp: $resource(consts.api + "/common/report/StartEavesdropp/:uuid", {
        get: {
          method: 'GET',
          isArray: true
        }
      })
      // ,
      // sendConsultantMessage: $resource(consts.api + "/chatpart/SendConsultantMessage", "@outgoingMsg", {
      //   send: {
      //     method: "POST"
      //   }
      // })
    };


    _this.getConsultants = function () {
      return _this.resources.getConsultants.get().$promise;
    };
    _this.getClients = function () {
      return _this.resources.getClients.get().$promise;
    };
    _this.getOnline = function (msgModel) {
      return _this.resources.getOnline.get(msgModel).$promise;
    };
    _this.login = function (loginModel) {
      return _this.resources.login.send(loginModel).$promise;
    };
    _this.logout = function (logoutModel) {
      return _this.resources.logout.send(logoutModel).$promise;
    };
    _this.playMsg = function (msgModel) {
      return _this.resources.playMsg.send(msgModel).$promise;
    };
    _this.sendMsg = function (msgModel) {
      return _this.resources.sendMsg.send(msgModel).$promise;
    };
    _this.playName = function (msgModel) {
      return _this.resources.playName.send(msgModel).$promise;
    };
    _this.rooms = function () {
      return _this.resources.rooms.get().$promise;
    };
    _this.startEavesdropp = function (uuid) {
      return _this.resources.startEavesdropp.get({ uuid: uuid }).$promise;
    };
    // _this.sendConsultantMessage = function (outgoingMsg) {
    //   return _this.resources.sendConsultantMessage.send(outgoingMsg).$promise;
    // };

    return _this;
  }
}(window.angular);


+function (angular) {
  'use strict';
  angular
    .module('Resources')
    .factory('InternalMessageRsc', InternalMessageRsc);

  /** @ngInject */
  function InternalMessageRsc($resource, consts, SessionManager) {
    var _this = this;
    var role = SessionManager.getUserRole();

    _this.resources = {
      sendMessage: $resource(consts.api  + 'common/internalmessage/send', '@msg', {
        send: {
          method: 'POST'
        }
      }),
      GetObjectList: $resource(consts.api + role  + '/internalmessage/objectList', {}, {
        get: {
          method: 'GET',
          isArray: true
        }
      }),
      List: $resource(consts.api + 'common/internalmessage/list/:destination/:source', {
        destination: '@destination',
        source: '@source'
      }, {
        get: {
          method: 'GET',
          isArray: true
        }
      })
    };
    _this.Send = function (msg) {
      return _this.resources.sendMessage.send(msg).$promise;
    };
    _this.GetObjectList = function () {
      return _this.resources.GetObjectList.get().$promise;
    };
    _this.List = function (destination, source) {
      return _this.resources.List.get({
        destination: destination,
        source: source
      }).$promise;
    };

    return _this;
  }
}(window.angular);

(function () {
  'use strict';

  angular
    .module('Resources')
    .factory('consultantsAPI', apiService);

  /** @ngInject */
  function apiService(consts, $resource, SessionManager) {

    function consultantsList(partnerId, callCenterId) {

      var resource = $resource(consts.api + SessionManager.getUserRole() + "/consultant/list" + "/:partnerId" + "/:callCenterId", {
        partnerId: partnerId,
        callCenterId: callCenterId
      }, {
        list: {
          method: "GET"
        }
      });
      return resource.list().$promise;
    }

    return {
      consultantsList: consultantsList
    }
  }

})();

/**
 * Created by rpiekarski on 07.09.2016.
 */
+function (angular) {
  'use strict';
  angular
    .module('Resources')
    .factory('CommunicatorServiceRsc', CommunicatorServiceRsc);

  /** @ngInject */
  function CommunicatorServiceRsc($resource, consts) {
    var _this = this;

    _this.getServiceInfo = function (serviceId, prefixId) {
      var resource = $resource(consts.api + "CallCenterServices/GetServiceDesc/:serviceId", {
        serviceId: '@serviceId',
        prefixId: 'prefixId'
      }, {
        get: {
          method: "GET"
        }
      });
      return resource.get({
        serviceId: serviceId,
        prefixId: prefixId
      }).$promise;
    };

    _this.patchUser = function () {
      var PatchData = [
        {"op": "replace", "path": "Name", "value": "Mama2"}
      ];
      return $resource(consts.api + "user/updatepatch/1",
        '@PatchData', {
          update: {
            method: "PATCH",
            headers: {'Content-Type': 'application/json-patch+json'}
          }
        }).update(PatchData).$promise;
    };


    _this.GetActiveSessions = function () {
      var resource = $resource(consts.api + 'common/Communicator/GetActiveSessions', {}, {
        get: {
          method: 'GET',
          isArray: true
        }
      });
      return resource.get({}).$promise;
    };

    _this.GetLastSessions = function () {
      var resource = $resource(consts.api + 'common/Communicator/lastsessions', {}, {
        get: {
          method: 'GET',
          isArray: true
        }
      });
      return resource.get({}).$promise;
    };

    _this.GetHistorySessionsConsultant = function () {
      var resource = $resource(consts.api + 'common/Communicator/GetHistorySessionsConsultant', {}, {
        get: {
          method: 'GET',
          isArray: true
        }
      });
      return resource.get({}).$promise;
    };

    _this.GetSessionsInfo = function (sessionId,serviceId,contactId) {

      var resource = $resource(consts.api + 'common/Communicator/GetSessionsInfo/:sessionId/:contactId/:serviceId',
        {
          contactId: contactId,
          serviceId: serviceId,
          sessionId: sessionId
        }, {
          get: {
            method: 'GET'
          }
        });
      return resource.get({}).$promise;
    };

    return _this;
  }
}(window.angular);

/**
 * Created by akraszewski on 2017-04-13.
 */
/**
 * Created by akraszewski on 07.09.2016.
 */
+function (angular) {
  'use strict';
  angular
    .module('Resources')
    .factory('ServicePartRsc',  ServicePartRsc);

  /** @ngInject */
  function ServicePartRsc($resource, consts) {
    var _this = this;

    _this.resources = {

      getDescrption: $resource(consts.api + "common/servicepart/GetServiceDesc/:serviceId/:prefixId", {
        serviceId: 'serviceId',
        prefixId:'prefixId'
      }, {
        get: {
          method: "GET"
        }
      }),
      loadChatServiceSetup: $resource(consts.api + "common/servicepart/loadChatServiceSetup/:serviceId", {
        serviceId: 'serviceId'
      }, {
        get: {
          method: "GET"
        }
      })
    };



    _this.GetServiceDesc = function (serviceId,prefixId) {
      return _this.resources.getDescrption.get({
        serviceId: serviceId,
        prefixId: prefixId
      }).$promise;
    };

    _this.LoadChatServiceSetup = function (serviceId) {
      return _this.resources.loadChatServiceSetup.get({
        serviceId: serviceId,
      }).$promise;
    };
    return _this;
  }
}(window.angular);

/**
 * Created by kosski on 07.09.2016.
 */
+function (angular) {
  'use strict';
  angular
    .module('Resources')
    .factory('PhoneCallRsc', ['$resource', 'consts', 'SessionManager', PhoneCallRsc]);
  /** @ngInject */


  function PhoneCallRsc($resource, consts, SessionManager) {
    var _this = this;

    _this.resources = {
      startCallBrige: $resource(consts.api + '/common/callback/bridge', {}, {
        post: {
          method: 'POST'
        }
      }),
      answerCall: $resource(consts.api + '/common/callinfo/answer', '@obj', {
        post: {
          method: 'POST'
        }
      }),
      sendSDP: $resource(consts.api + '/common/callinfo/send', '@obj', {
        post: {
          method: 'POST'
        }
      }),
      byeCall: $resource(consts.api + '/common/callinfo/bye', '@obj', {
        post: {
          method: 'POST'
        }
      }),
      consultantService: $resource(consts.api + '/common/callinfo/consultantservice/:actionId', {
        actionId: 'actionId'
      }, {
          get: {
            method: 'GET',
            isArray: true
          }
        }),
      consultantForward: $resource(consts.api + '/common/callinfo/consultantForward', '@obj', {
        post: {
          method: 'POST'
        }
      }),
      callHelp: $resource(consts.api + '/common/callinfo/callhelp/:guid', {
        guid: 'guid'
      }, {
          get: {
            method: 'GET'//,
            // isArray: true
          }
        }),
      callHelpInsert: $resource(consts.api + '/common/callinfo/callhelpinsert', '@obj', {
        post: {
          method: 'POST'
        }
      }),
      callHelpUpdate: $resource(consts.api + '/common/callinfo/callhelpupdate', '@obj', {
        post: {
          method: 'POST'
        }
      })
    };


    _this.startCallBrige = function (callFrom, callTo) {
      var user = SessionManager.getUser();

      var obj = {
        dialStringA: callFrom.phoneNo,
        //freetdm/2/a/15
        dialStringB: 'Freetdm/2/a/15' + callTo.phoneNo,
        //dialStringB: callTo.phoneNo,
        NotifyWSToken: 'CCS.' + user.partnerId + '/' + user.callCenterId + '/' + callFrom.consultantId + ':CallOut',
        NotifyCcWSToken: 'CCS.' + user.partnerId + '/' + user.callCenterId + ':CallbackOut',
        UpdateURL: callFrom.orderGuid ? consts.api + 'common/payment/minutesupdate/' + callFrom.orderGuid : '',
        MinutesLeft: callFrom.minutesLeft,
        ServiceID: callFrom.serviceID !== undefined ? callFrom.serviceID : undefined,
        ContactID: callTo.contactID !== undefined ? callTo.contactID : undefined,
        Bundle: callTo.bundle,
        ConfigID: callTo.configID !== undefined ? callTo.configID : undefined,
        OrderGuid: callFrom.orderGuid,
        ManagerID: callTo.managerID !== undefined ? callTo.managerID : undefined,
        ConsultantID: callFrom.consultantId !== undefined ? callFrom.consultantId: undefined
      };
      //console.log('startCallBrige - obj: ',obj);
      return _this.resources.startCallBrige.post(obj).$promise;

    };
    _this.answerCall = function (callID, sdp) {
      var obj = {
        callID: callID,
        sdp: sdp
      };
      //console.log('startCallBrige - obj: ',obj);
      return _this.resources.answerCall.post(obj).$promise;

    };
    _this.sendSDP = function (type, sdp, number, params) {
      var obj = {
        type: type,
        sdp: sdp,
        DialogParams: { UserVariables: params, Destination_number: number }
      };
      //console.log('startCallBrige - obj: ',obj);
      return _this.resources.sendSDP.post(obj).$promise;

    };
    _this.byeCall = function (callID) {
      var obj = {
        callID: callID
      };
      //console.log('startCallBrige - obj: ',obj);
      return _this.resources.byeCall.post(obj).$promise;

    };
    _this.consultantService = function (actionId) {
      return _this.resources.consultantService.get({ actionId: actionId }).$promise;
    };
    _this.consultantForward = function (uuid, consultantId, forwardText) {
      var obj = {
        uuid: uuid,
        consultantId: consultantId,
        forwardText: forwardText
      };
      //console.log('startCallBrige - obj: ',obj);
      return _this.resources.consultantForward.post(obj).$promise;

    };
    _this.callHelp = function (guid) {
      return _this.resources.callHelp.get({ guid: guid }).$promise;
    };
    _this.callHelpInsert = function (guid, consultantID) {
      var obj = {
        callID: guid,
        consultantID: consultantID
      };
      return _this.resources.callHelpInsert.post(obj).$promise;

    };

    _this.callHelpUpdate = function (guid, consultantID) {
      var obj = {
        callID: guid,
        consultantID: consultantID
      };
      return _this.resources.callHelpUpdate.post(obj).$promise;

    };

    return _this;
  }
}(window.angular);

/**
 * Created by akraszewski on 2017-01-04.
 */
+function (angular) {
  'use strict';
  angular
    .module('Resources')
    .factory('PaymentRsc', ['$resource', 'consts','SessionManager', PaymentRscCode]);
  /** @ngInject */


  function PaymentRscCode($resource, consts,SessionManager) {
    var _this = this;
    var role = SessionManager.getUserRole();

    _this.resources = {
      getPaymentTypes: $resource(consts.api + 'common/payment/types/:serviceId', {
        serviceId:'serviceId'
      }, {
        get: {
          isArray: true,
          method: 'GET'
        }
      }),
      pointInsert: $resource(consts.api + 'common/payment/insert', '@point', {
        send: {
          method: 'POST'
        }
      }),
      pointUpdate: $resource(consts.api + 'common/payment/update', '@point', {
        send: {
          method: 'POST'
        }
      }),
      pointChangeActive: $resource(consts.api + 'common/payment/changeactive', '@point', {
        send: {
          method: 'POST'
        }
      })
    };


    _this.getPaymentTypes = function (serviceId) {
      return _this.resources.getPaymentTypes.get({serviceId:serviceId}).$promise;
    };

    _this.pointInsert = function (point) {
      return _this.resources.pointInsert.send(point).$promise;
    };

    _this.pointUpdate = function (point) {
      return _this.resources.pointUpdate.send(point).$promise;
    };

    _this.pointChangeActive = function (point) {
      return _this.resources.pointChangeActive.send(point).$promise;
    };

    return _this;
  }
}(window.angular);

/**
 * Created by kosski on 07.09.2016.
 */
+ function (angular) {
  'use strict';
  angular
    .module('Resources')
    .factory('OrderBoxRsc', OrderBoxRsc);

  /** @ngInject */
  function OrderBoxRsc($resource, consts, SessionManager, $q) {
    var _this = this;

    var role = SessionManager.getUserRole();

    _this.resources = {
      //OrderboxController
      serviceList: $resource(consts.api + role + '/orderbox/servicelist', {}, {
        get: {
          method: 'GET',
          isArray: true
        }
      }),
      serviceOrderSeenUpdate: $resource(consts.api + role + '/orderbox/seenupdate/:orderId/:seen', {
        orderId: 'orderId',
        seen: 'seen'
      }, {
        get: {
          method: 'GET',
          isArray: true
        }
      }),

      //CallbackController
      callbackForServiceList: $resource(consts.api + 'common/callback/yourlist', '@data', {
        get: {
          method: 'GET'
        }
      }),

      callbackListDone: $resource(consts.api + role + '/callback/donelist', '@data', {
        get: {
          method: 'GET'
        }
      }),



      callbackForServiceAssignList: $resource(consts.api + role + '/callback/listassigned/:min/:max/:assigned/:complitedCallback', {
        min: 'min',
        max: 'max',
        assigned: 'assigned',
        // statusFilter: 'statusFilter',
        complitedCallback: 'complitedCallback'
      }, {
        get: {
          method: 'GET'
        }
      }),


      callbackActionConsultantList: $resource(consts.api + role + '/callback/actionconsultantlist/:serviceId', {
        serviceId: 'serviceId'
      }, {
        get: {
          method: 'GET',
          isArray: true
        }
      }),

      callbackConsultantUpdate: $resource(consts.api + role + '/callback/consultantupdate', '@consultantModel', {
        send: {
          method: 'POST'
        }
      }),

      SaveCallbackOrder: $resource(consts.api + role + '/callback/savecallbackorder', '@callbackOrderModel', {
        send: {
          method: 'POST'
        }
      }),

      //MailboxController
      mailServiceFolders: $resource(consts.api + role + '/mailbox/sessionFolderCount', {}, {
        get: {
          method: 'GET',
          isArray: true
        }
      }),
      getMailServiceForForward: $resource(consts.api + role + '/mailbox/mailServiceForForwardList', {}, {
        get: {
          method: 'GET',
          isArray: true
        }
      }),

      setMailSessionConsultant: $resource(consts.api + role + '/mailbox/mailSessionConsultant', '@mailSession', {
        send: {
          method: 'POST'
        }
      }),

      mailSessionsForServiceList: $resource(consts.api + 'common/mailbox/mailSessionsForServiceList', '@mailSessionQuery', {
        send: {
          method: 'POST',
          isArray: true
        }
      }),

      mailSessionSeenUpdate: $resource(consts.api + 'common/mailbox/MailSessionSeenUpdate/:mailsessionId/:seen', {
        mailsessionId: 'mailsessionId',
        seen: 'seen'
      }, {
        get: {
          method: 'GET',
          isArray: true
        }
      }),
      addMailSession: $resource(consts.api + 'common/mailbox/addmailsession', '@session', {
        send: {
          method: 'POST'
        }
      }),

      updateMailSession: $resource(consts.api + 'common/mailbox/updatemailsession', '@session', {
        send: {
          method: 'POST'
        }
      }),
      mailServicesForMailBox: $resource(consts.api + 'common/mailbox/MailServiceForMailBoxList/:mailBoxId', {
        mailBoxId: 'mailBoxId'
      }, {
        get: {
          method: 'GET',
          isArray: true
        }
      }),
      mailServiceGet: $resource(consts.api + 'common/mailbox/MailServiceGet/:id', {
        id: 'id'
      }, {
        get: {
          method: 'GET'
        }
      }),
      // addMailSessionFlag: $resource(consts.api + '/common/mailbox/addmailsessionflag','@session', {
      //   send: {
      //     method: 'POST'
      //   }
      // }),
      // getFlags: $resource(consts.api + 'common/mailbox/flag', {}, {
      //   get: {
      //     method: 'GET',
      //     isArray: true
      //   }
      // }),
      // mailServiceForUser: $resource(consts.api + role + '/mailbox/mailServiceForUserList', {}, {
      //   get: {
      //     method: 'GET',
      //     isArray: true
      //   }
      // }),

      //SmtpController
      sendEmail: $resource(consts.api + role + '/smtp/send', '@newEmail', {
        send: {
          method: 'POST'
        }
      }),

      sendWithPayment: $resource(consts.api + role + '/smtp/sendWithPayment', '@newEmail', {
        send: {
          method: 'POST'
        }
      }),

      //ImapController
      getMailBoxes: $resource(consts.api + role + '/imap/getMailBoxes', {}, {
        get: {
          method: 'GET',
          isArray: true
        }
      }),
      getMailBoxFolders: $resource(consts.api + role + '/imap/getFolders/:mailBoxId', {
        mailBoxId: 'mailBoxId'
      }, {
        get: {
          method: 'GET'
          // isArray: true
        }
      }),
      getTitles: $resource(consts.api + role + '/imap/getTitles/:mailBoxId/:folder/:start/:stop', {
        mailBoxId: 'mailBoxId',
        folder: 'folder',
        start: 'start',
        stop: 'stop'
      }, {
        get: {
          method: 'GET',
          isArray: true
        }
      }),
      getMessage: $resource(consts.api + role + '/imap/getMessage/:mailBoxId/:folder/:id', {
        mailBoxId: 'mailBoxId',
        folder: 'folder',
        id: 'id'
      }, {
        get: {
          method: 'GET'
          // isArray: true
        }
      }),

      attachment: $resource(consts.api + role + '/imap/getMessageAttachment/:mailBoxId/:mailId/:folder/:filename', {
        filename: 'filename',
        folder: 'folder',
        id: 'id',
        mailBoxId: 'mailBoxId'
      }, {
        get: {
          method: 'GET'
        }
      }),
      markAsUnread: $resource(consts.api + role + '/imap/markAsUnread/:mailboxId/:folder/:msgId', {
        method: 'mailboxId',
        folder: 'folder',
        msgId: 'msgId'
      }, {
        set: {
          method: 'GET'
        }
      }),
      markAsRead: $resource(consts.api + role + '/imap/markAsRead/:mailboxId/:folder/:msgId', {
        method: 'mailboxId',
        folder: 'folder',
        msgId: 'msgId'
      }, {
        set: {
          method: 'GET'
        }
      })

      // getOrdersListForFlag: $resource(consts.api + 'common/imap/getTitles/:folder/:start/:stop', {
      //   folder: 'folder',
      //   start: 'start',
      //   stop: 'stop'
      // }, {
      //   get: {
      //     method: 'GET',
      //     isArray: true
      //   }
      // }),
      // getOrdersDetailsForFlag: $resource(consts.api + 'common/imap/getMessage/:folder/:id', {
      //   folder: 'folder',
      //   id: 'id'
      // }, {
      //   get: {
      //     method: 'GET',
      //     isArray: true
      //   }
      // }),

    };


    // _this.getOrdersListForFlag = function (folder, start, stop) {
    //   return _this.resources.getOrdersListForFlag.get({folder: folder, start: start, stop: stop}).$promise;
    // };
    //
    // _this.getOrdersDetailsForFlag = function (folder, id) {
    //   return _this.resources.getOrdersDetailsForFlag.get({folder: folder, id: id}).$promise;
    // };
    _this.MailAttaczment = function (mailBoxId, folder, id, filename) {
      return _this.resources.attachment.get({
        filename: filename,
        folder: folder,
        id: id,
        mailBoxId: mailBoxId
      }).$promise;
    };


    _this.getMailBoxes = function () {
      return _this.resources.getMailBoxes.get().$promise;
    };

    _this.getMailBoxFolders = function (mailBoxId) {
      return _this.resources.getMailBoxFolders.get({
        mailBoxId: mailBoxId
      }).$promise;
    };

    _this.getMailsTitles = function (params) {
      return _this.resources.getTitles.get({
        mailBoxId: params.mailBoxId,
        folder: params.folderName,
        start: params.start,
        stop: params.stop,
        searchString: params.searchString,
        querryString: params.querryString
      }).$promise;
    };

    _this.getMailMessage = function (mailBoxId, folder, id) {
      var defer = $q.defer();
      _this.resources.getMessage.get({
        mailBoxId: mailBoxId,
        folder: folder,
        id: id
      }).$promise.then(function (data) {

        String.prototype.replaceAll = function (search, replacement) {
          var target = this;
          return target.split(search).join(replacement);
        };

        data.body = data.body.replaceAll('\<!--[if gte mso 9]\>', '').replaceAll('\<![endif]--\>', '');

        defer.resolve(data)
      }, function (err) {
        defer.reject(err);
      });
      return defer.promise;

    };

    _this.setMailSessionConsultant = function (consultantId, mailSessionId) {
      return _this.resources.setMailSessionConsultant.send({
        consultantId: consultantId,
        mailSessionId: mailSessionId
      }).$promise;
    };

    _this.mailSessionsForServiceList = function (params) {
      return _this.resources.mailSessionsForServiceList.send({
        ServiceId: params.folderName,
        Start: params.start,
        Stop: params.stop
      }).$promise;
    };

    _this.callbackForServiceList = function (params) {
      return _this.resources.callbackForServiceList.get({
        min: params.start,
        max: params.stop,
        ServiceId: params.folderName,
        searchString: params.searchString,
        querryString: params.querryString,
      }).$promise;
    };

    _this.callbackListDone = function (params) {
      return _this.resources.callbackListDone.get({
        min: params.start,
        max: params.stop,
        ServiceId: params.folderName,
        searchString: params.searchString,
        querryString: params.querryString,
        // statusFilter: params.statusFilter// niepotrzebne
      }).$promise;
    };


    _this.callbackForServiceAssignList = function (params) {
      return _this.resources.callbackForServiceAssignList.get({
        min: params.start,
        max: params.stop,
        assigned: params.assigned,
        searchString: params.searchString,
        querryString: params.querryString,
        complitedCallback: params.complitedCallback
      }).$promise;
    };

    _this.callbackActionConsultantList = function (serviceId) {
      return _this.resources.callbackActionConsultantList.get({
        serviceId: serviceId
      }).$promise;
    };
    _this.callbackConsultantUpdate = function (consultantModel) {
      return _this.resources.callbackConsultantUpdate.send(consultantModel).$promise;
    };
    _this.SaveCallbackOrder = function (CallbackOrderModel) {
      return _this.resources.SaveCallbackOrder.send(CallbackOrderModel).$promise;
    };
    _this.sendEmail = function (newEmail) {
      return _this.resources.sendEmail.send(newEmail).$promise;
    };

    _this.sendWithPayment = function (newEmail) {
      return _this.resources.sendWithPayment.send(newEmail).$promise;
    };

    _this.addMailSession = function (session) {
      return _this.resources.addMailSession.send(session).$promise;
    };
    _this.updateMailSession = function (session) {
      return _this.resources.updateMailSession.send(session).$promise;
    };
    // _this.getFlags = function () {
    //   return _this.resources.getFlags.get().$promise;
    // };


    _this.mailServiceForUser = function () {
      return _this.resources.mailServiceForUser.get().$promise;
    };

    _this.mailServiceFolders = function () {
      return _this.resources.mailServiceFolders.get().$promise;
    };
    _this.serviceList = function () {
      return _this.resources.serviceList.get().$promise;
    };
    _this.serviceOrderSeenUpdate = function (orderId, seen) {
      return _this.resources.serviceOrderSeenUpdate.get({
        orderId: orderId,
        seen: seen
      }).$promise;
    };
    _this.mailSessionSeenUpdate = function (mailsessionId, seen) {
      return _this.resources.mailSessionSeenUpdate.get({
        mailsessionId: mailsessionId,
        seen: seen
      }).$promise;
    };

    _this.mailServicesForMailBox = function (mailBoxId) {
      return _this.resources.mailServicesForMailBox.get({
        mailBoxId: mailBoxId
      }).$promise;
    };

    _this.mailServiceGet = function (id) {
      return _this.resources.mailServiceGet.get({
        id: id
      }).$promise;
    };

    _this.getMailServiceForForward = function () {
      return _this.resources.getMailServiceForForward.get().$promise;
    };


    _this.markAsUnread = function (msgId, isRead, folder, mailboxId) {
      return _this.resources.markAsUnread.set({
        mailboxId: mailboxId,
        folder: folder,
        msgId: msgId
      }).$promise;
    };

    _this.markAsRead = function (msgId, isRead, folder, mailboxId) {
      return _this.resources.markAsRead.set({
        mailboxId: mailboxId,
        folder: folder,
        msgId: msgId
      }).$promise;
    };


    return _this;
  }
}(window.angular);

/**
 * Created by kosski on 07.09.2016.
 */
+function (angular) {
  'use strict';
  angular
    .module('Resources')
    .factory('NotesPartRsc',  NotesPartRsc);

  /** @ngInject */
  function NotesPartRsc($resource, consts) {
    var _this = this;

    _this.resources = {
      getContactNotes: $resource(consts.api  + "common/contactnotepart/:contactId", {
        contactId: '@contactId'
      }, {
          get: {
            method: "GET",
            isArray: true
          }
        }),

      addNewNote: $resource(consts.api  + "common/contactnotepart/Add",
        '@note', {
          update: {
            method: "POST"
          }
        })


    };


    _this.getContactNotes = function (contactId) {
      return _this.resources.getContactNotes.get({
        contactId: contactId
      }).$promise;
    };

    _this.addNewNote = function (note) {
      return _this.resources.addNewNote.update(note).$promise;
    };


    return _this;
  }
}(window.angular);

/**
 * Created by kosski on 07.09.2016.
 */
+function (angular) {
  'use strict';
  angular
    .module('Resources')
    .factory('ContactPartRsc', ContactPartRsc);


  /** @ngInject */
  function ContactPartRsc($resource, consts) {
    var _this = this;

    _this.resources = {
      getContact: $resource(consts.api  + "common/contactpart/:contactId", {
        contactId: '@contactId'
      }, {
        get: {
          method: "GET"
        }
      }),
      getContactByMsisdn: $resource(consts.api  + "common/contactpart/msisdn/:msisdn", {
        msisdn: '@msisdn'
      }, {
        get:{
          url: consts.api  + "common/contactpart/msisdn/:msisdn",
          method:"GET"
        }
      }),
      updateContact: $resource(consts.api  + "common/contactpart/",
        '@contactData', {
          update: {
            method: "PUT"
          }
        })
    };


    _this.getContact = function (contactId) {
      return _this.resources.getContact.get({ contactId: contactId}).$promise;
    };

    _this.getContactByMsisdn = function (msisdn) {
      return _this.resources.getContactByMsisdn.get({ msisdn: msisdn}).$promise;
    };

    _this.updateContact = function (contactData) {
      return _this.resources.updateContact.update(contactData).$promise;
    };


    return _this;
  }
}(window.angular);

/**
 * Created by akraszewski on 2017-01-04.
 */
+function (angular) {
  'use strict';
  angular
    .module('Resources')
    .factory('CommunicatorConfigRsc',  CommunicatorConfigRsc);

  /** @ngInject */
  function CommunicatorConfigRsc($resource, consts) {
    var _this = this;

    _this.resources = {
      getCommunicatorConfig: $resource(consts.api + "common/CommunicatorConfig/GetCommunicatorConfigInUse", {}, {
        get: {
          isArray: true,
          method: "GET"
        }
      }),
      getCommunicatorAllowedParts: $resource(consts.api + "common/CommunicatorConfig/GetCommunicatorAllowedParts", {}, {
        get: {
          method: "GET",
          isArray: true
        }
      }),
      getCommunicatorTemplates: $resource(consts.api +"common/CommunicatorConfig/GetCommunicatorTemplates", {}, {
        get: {
          method: "GET",
          isArray: true
        }
      }),
      saveCommunicatorTemplateConfig: $resource(consts.api + "common/CommunicatorConfig/SaveCommunicatorTemplateConfig", {}, {
        update: {
          method: "POST"
        }
      }),
      changeCommunicatorTemplateInUse: $resource(consts.api + "common/CommunicatorConfig/ChangeCommunicatorTemplateInUse", {}, {
        update: {
          method: "POST"
        }
      })
    };


    _this.getCommunicatorConfig = function () {
      return _this.resources.getCommunicatorConfig.get().$promise;
    };


    _this.getCommunicatorTemplates = function () {
      return _this.resources.getCommunicatorTemplates.get().$promise;
    };

    _this.getCommunicatorAllowedParts = function () {
      return _this.resources.getCommunicatorAllowedParts.get().$promise;
    };

    _this.saveCommunicatorTemplateConfig = function (type, templateId, configJSON) {
      return _this.resources.saveCommunicatorTemplateConfig.update({
        Type: type,
        TemplateID: templateId,
        ConfigurationJSON: JSON.stringify(configJSON)
      }).$promise;
    };

    _this.changeCommunicatorTemplateInUse = function (oldId, currentId) {
      return _this.resources.changeCommunicatorTemplateInUse.update({OldID: oldId, CurrentID: currentId}).$promise;
    };

    return _this;
  }
}(window.angular);

/**
 * Created by akraszewski on 07.09.2016.
 */
+ function(angular) {
    'use strict';
    angular
        .module('Resources')
        .factory('ChatPartRsc', ChatPartRsc);

    /** @ngInject */
    function ChatPartRsc($resource, consts) {
        var _this = this;

        _this.resources = {
            getNext: $resource(consts.api + "common/chatpart/getnext", {}, {
                get: {
                    method: "GET",
                    isArray: true
                }
            }),
            getSession: $resource(consts.api + "common/chatpart/GetSession", {}, {
                get: {
                    method: "GET"
                }
            }),
            getActvity: $resource(consts.api + "common/chatpart/GetActivity/:contactId/:serviceId/:sessionId", {
                contactId: 'contactId',
                serviceId: 'serviceId',
                sessionId: 'sessionId'
            }, {
                get: {
                    method: "GET"
                        // isArray: true
                }
            }),
            sendConsultantMessage: $resource(consts.api + "common/chatpart/SendConsultantMessage", "@outgoingMsg", {
                send: {
                    method: "POST"
                }
            }),
            ///:serviceOrderId/:callId
            getMessageToReply: $resource(consts.api + "common/chatpart/GetMessageToReply/:sessionId", {
                sessionId: 'sessionId',
            }, {
                get: {
                    method: "GET"
                }
            }),
            setReservedMessages: $resource(consts.api + "common/chatpart/SetReservedMessages/:sessionId", {
                sessionId: 'sessionId',
            }, {
                get: {
                    method: "GET",
                    isArray: true
                }
            }),
            setReservedMessage: $resource(consts.api + "common/chatpart/SetReservedMessage/:sessionId", {
                sessionId: 'sessionId',
            }, {
                get: {
                    method: "GET"
                }
            }),
            sendFBAction: $resource(consts.api + "common/chatpart/SendFBAction", "@fbAction", {
                send: {
                    method: "POST"
                }
            }),
            sendWritingMessage: $resource(consts.api + "common/chatpart/SendWritingMessage/:sessionId", {
                sessionId: 'sessionId',
            }, {
                get: {
                    method: "GET"
                }
            }),
            sendCleaningMessage: $resource(consts.api + "common/chatpart/SendCleaningMessage", "@outMsg", {
                send: {
                    method: "POST"
                }
            }),
            sendManagerMessage: $resource(consts.api + "common/chatpart/SendManagerMessage", "@outgoingMsg", {
                send: {
                    method: "POST"
                }
            })
        };


        _this.getNext = function() {
            return _this.resources.getNext.get().$promise;
        };
        _this.getSession = function() {
            return _this.resources.getSession.get({}).$promise;
        };

        _this.getActvity = function(contactId, serviceId, sessionId) {
            return _this.resources.getActvity.get({
                contactId: contactId,
                serviceId: serviceId,
                sessionId: sessionId
            }).$promise;
        };

        _this.sendConsultantMessage = function(outgoingMsg) {
            return _this.resources.sendConsultantMessage.send(outgoingMsg).$promise;
        };
        _this.getMessageToReply = function(sessionId) {
            return _this.resources.getMessageToReply.get({
                sessionId: sessionId
            }).$promise;
        };
        _this.setReservedMessages = function(sessionId) {
            return _this.resources.setReservedMessages.get({
                sessionId: sessionId
            }).$promise;
        };
        _this.setReservedMessage = function(sessionId) {
            return _this.resources.setReservedMessage.get({
                sessionId: sessionId
            }).$promise;
        };

        _this.sendFBAction = function(fbAction) {
            return _this.resources.sendFBAction.send(fbAction).$promise;
        };

        _this.sendWritingMessage = function(sessionId) {
            return _this.resources.sendWritingMessage.get({
                sessionId: sessionId
            }).$promise;
        };
        _this.sendCleaningMessage = function(outMsg) {
            return _this.resources.sendCleaningMessage.send(outMsg).$promise;
        };
        _this.sendManagerMessage = function(outgoingMsg) {
            return _this.resources.sendManagerMessage.send(outgoingMsg).$promise;
        };

        return _this;
    }
}(window.angular);


/**
 * Created by akraszewski on 16.02.2017.
 */
+(function(angular) {
  "use strict";
  angular.module("Resources").factory("CountryListRsc", CountryListRsc);

  /** @ngInject */
  function CountryListRsc() {
    var _this = this;

    _this.get = function(){
      return _this.countryList;
    }

    _this.countryList = [
      {
        name: "Poland",
        dial_code: "+48",
        code: "PL",
        area: 0
      },
      {
        name: "Afghanistan",
        dial_code: "+93",
        code: "AF"
      },
      {
        name: "Aland Islands",
        dial_code: "+358",
        code: "AX"
      },
      {
        name: "Albania",
        dial_code: "+355",
        code: "AL"
      },
      {
        name: "Algeria",
        dial_code: "+213",
        code: "DZ"
      },
      {
        name: "AmericanSamoa",
        dial_code: "+1 684",
        code: "AS"
      },
      {
        name: "Andorra",
        dial_code: "+376",
        code: "AD",
        area: 1
      },
      {
        name: "Angola",
        dial_code: "+244",
        code: "AO"
      },
      {
        name: "Anguilla",
        dial_code: "+1 264",
        code: "AI"
      },
      {
        name: "Antarctica",
        dial_code: "+672",
        code: "AQ"
      },
      {
        name: "Antigua and Barbuda",
        dial_code: "+1268",
        code: "AG"
      },
      {
        name: "Argentina",
        dial_code: "+54",
        code: "AR"
      },
      {
        name: "Armenia",
        dial_code: "+374",
        code: "AM"
      },
      {
        name: "Aruba",
        dial_code: "+297",
        code: "AW"
      },
      {
        name: "Australia",
        dial_code: "+61",
        code: "AU",
        area: 1
      },
      {
        name: "Austria",
        dial_code: "+43",
        code: "AT",
        area: 1
      },
      {
        name: "Azerbaijan",
        dial_code: "+994",
        code: "AZ"
      },
      {
        name: "Bahamas",
        dial_code: "+1 242",
        code: "BS"
      },
      {
        name: "Bahrain",
        dial_code: "+973",
        code: "BH"
      },
      {
        name: "Bangladesh",
        dial_code: "+880",
        code: "BD"
      },
      {
        name: "Barbados",
        dial_code: "+1 246",
        code: "BB"
      },
      {
        name: "Belarus",
        dial_code: "+375",
        code: "BY"
      },
      {
        name: "Belgium",
        dial_code: "+32",
        code: "BE"
      },
      {
        name: "Belize",
        dial_code: "+501",
        code: "BZ"
      },
      {
        name: "Benin",
        dial_code: "+229",
        code: "BJ"
      },
      {
        name: "Bermuda",
        dial_code: "+1 441",
        code: "BM"
      },
      {
        name: "Bhutan",
        dial_code: "+975",
        code: "BT"
      },
      {
        name: "Bolivia, Plurinational State of",
        dial_code: "+591",
        code: "BO"
      },
      {
        name: "Bosnia and Herzegovina",
        dial_code: "+387",
        code: "BA"
      },
      {
        name: "Botswana",
        dial_code: "+267",
        code: "BW"
      },
      {
        name: "Brazil",
        dial_code: "+55",
        code: "BR"
      },
      {
        name: "British Indian Ocean Territory",
        dial_code: "+246",
        code: "IO"
      },
      {
        name: "Brunei Darussalam",
        dial_code: "+673",
        code: "BN"
      },
      {
        name: "Bulgaria",
        dial_code: "+359",
        code: "BG"
      },
      {
        name: "Burkina Faso",
        dial_code: "+226",
        code: "BF"
      },
      {
        name: "Burundi",
        dial_code: "+257",
        code: "BI"
      },
      {
        name: "Cambodia",
        dial_code: "+855",
        code: "KH"
      },
      {
        name: "Cameroon",
        dial_code: "+237",
        code: "CM"
      },
      {
        name: "Canada",
        dial_code: "+1",
        code: "CA"
      },
      {
        name: "Cape Verde",
        dial_code: "+238",
        code: "CV"
      },
      {
        name: "Cayman Islands",
        dial_code: "+ 345",
        code: "KY"
      },
      {
        name: "Central African Republic",
        dial_code: "+236",
        code: "CF"
      },
      {
        name: "Chad",
        dial_code: "+235",
        code: "TD"
      },
      {
        name: "Chile",
        dial_code: "+56",
        code: "CL"
      },
      {
        name: "China",
        dial_code: "+86",
        code: "CN"
      },
      {
        name: "Christmas Island",
        dial_code: "+61",
        code: "CX"
      },
      {
        name: "Cocos (Keeling) Islands",
        dial_code: "+61",
        code: "CC"
      },
      {
        name: "Colombia",
        dial_code: "+57",
        code: "CO"
      },
      {
        name: "Comoros",
        dial_code: "+269",
        code: "KM"
      },
      {
        name: "Congo",
        dial_code: "+242",
        code: "CG"
      },
      {
        name: "Congo, The Democratic Republic of the Congo",
        dial_code: "+243",
        code: "CD"
      },
      {
        name: "Cook Islands",
        dial_code: "+682",
        code: "CK"
      },
      {
        name: "Costa Rica",
        dial_code: "+506",
        code: "CR"
      },
      {
        name: "Cote d'Ivoire",
        dial_code: "+225",
        code: "CI"
      },
      {
        name: "Croatia",
        dial_code: "+385",
        code: "HR"
      },
      {
        name: "Cuba",
        dial_code: "+53",
        code: "CU"
      },
      {
        name: "Cyprus",
        dial_code: "+357",
        code: "CY"
      },
      {
        name: "Czech Republic",
        dial_code: "+420",
        code: "CZ",
        area: 1
      },
      {
        name: "Denmark",
        dial_code: "+45",
        code: "DK"
      },
      {
        name: "Djibouti",
        dial_code: "+253",
        code: "DJ"
      },
      {
        name: "Dominica",
        dial_code: "+1 767",
        code: "DM"
      },
      {
        name: "Dominican Republic",
        dial_code: "+1 849",
        code: "DO"
      },
      {
        name: "Ecuador",
        dial_code: "+593",
        code: "EC"
      },
      {
        name: "Egypt",
        dial_code: "+20",
        code: "EG"
      },
      {
        name: "El Salvador",
        dial_code: "+503",
        code: "SV"
      },
      {
        name: "Equatorial Guinea",
        dial_code: "+240",
        code: "GQ"
      },
      {
        name: "Eritrea",
        dial_code: "+291",
        code: "ER"
      },
      {
        name: "Estonia",
        dial_code: "+372",
        code: "EE",
        area: 1
      },
      {
        name: "Ethiopia",
        dial_code: "+251",
        code: "ET"
      },
      {
        name: "Falkland Islands (Malvinas)",
        dial_code: "+500",
        code: "FK"
      },
      {
        name: "Faroe Islands",
        dial_code: "+298",
        code: "FO"
      },
      {
        name: "Fiji",
        dial_code: "+679",
        code: "FJ"
      },
      {
        name: "Finland",
        dial_code: "+358",
        code: "FI",
        area: 1
      },
      {
        name: "France",
        dial_code: "+33",
        code: "FR",
        area: 1
      },
      {
        name: "French Guiana",
        dial_code: "+594",
        code: "GF"
      },
      {
        name: "French Polynesia",
        dial_code: "+689",
        code: "PF"
      },
      {
        name: "Gabon",
        dial_code: "+241",
        code: "GA"
      },
      {
        name: "Gambia",
        dial_code: "+220",
        code: "GM"
      },
      {
        name: "Georgia",
        dial_code: "+995",
        code: "GE"
      },
      {
        name: "Germany",
        dial_code: "+49",
        code: "DE",
        area: 1
      },
      {
        name: "Ghana",
        dial_code: "+233",
        code: "GH"
      },
      {
        name: "Gibraltar",
        dial_code: "+350",
        code: "GI"
      },
      {
        name: "Greece",
        dial_code: "+30",
        code: "GR"
      },
      {
        name: "Greenland",
        dial_code: "+299",
        code: "GL"
      },
      {
        name: "Grenada",
        dial_code: "+1 473",
        code: "GD"
      },
      {
        name: "Guadeloupe",
        dial_code: "+590",
        code: "GP"
      },
      {
        name: "Guam",
        dial_code: "+1 671",
        code: "GU"
      },
      {
        name: "Guatemala",
        dial_code: "+502",
        code: "GT"
      },
      {
        name: "Guernsey",
        dial_code: "+44",
        code: "GG"
      },
      {
        name: "Guinea",
        dial_code: "+224",
        code: "GN"
      },
      {
        name: "Guinea-Bissau",
        dial_code: "+245",
        code: "GW"
      },
      {
        name: "Guyana",
        dial_code: "+595",
        code: "GY"
      },
      {
        name: "Haiti",
        dial_code: "+509",
        code: "HT"
      },
      {
        name: "Holy See (Vatican City State)",
        dial_code: "+379",
        code: "VA"
      },
      {
        name: "Honduras",
        dial_code: "+504",
        code: "HN"
      },
      {
        name: "Hong Kong",
        dial_code: "+852",
        code: "HK"
      },
      {
        name: "Hungary",
        dial_code: "+36",
        code: "HU"
      },
      {
        name: "Iceland",
        dial_code: "+354",
        code: "IS"
      },
      {
        name: "India",
        dial_code: "+91",
        code: "IN"
      },
      {
        name: "Indonesia",
        dial_code: "+62",
        code: "ID"
      },
      {
        name: "Iran, Islamic Republic of Persian Gulf",
        dial_code: "+98",
        code: "IR"
      },
      {
        name: "Iraq",
        dial_code: "+964",
        code: "IQ"
      },
      {
        name: "Ireland",
        dial_code: "+353",
        code: "IE",
        area: 1
      },
      {
        name: "Isle of Man",
        dial_code: "+44",
        code: "IM"
      },
      {
        name: "Israel",
        dial_code: "+972",
        code: "IL"
      },
      {
        name: "Italy",
        dial_code: "+39",
        code: "IT"
      },
      {
        name: "Jamaica",
        dial_code: "+1 876",
        code: "JM"
      },
      {
        name: "Japan",
        dial_code: "+81",
        code: "JP"
      },
      {
        name: "Jersey",
        dial_code: "+44",
        code: "JE"
      },
      {
        name: "Jordan",
        dial_code: "+962",
        code: "JO"
      },
      {
        name: "Kazakhstan",
        dial_code: "+7 7",
        code: "KZ"
      },
      {
        name: "Kenya",
        dial_code: "+254",
        code: "KE"
      },
      {
        name: "Kiribati",
        dial_code: "+686",
        code: "KI"
      },
      {
        name: "Korea, Democratic People's Republic of Korea",
        dial_code: "+850",
        code: "KP"
      },
      {
        name: "Korea, Republic of South Korea",
        dial_code: "+82",
        code: "KR"
      },
      {
        name: "Kuwait",
        dial_code: "+965",
        code: "KW"
      },
      {
        name: "Kyrgyzstan",
        dial_code: "+996",
        code: "KG"
      },
      {
        name: "Laos",
        dial_code: "+856",
        code: "LA"
      },
      {
        name: "Latvia",
        dial_code: "+371",
        code: "LV",
        area: 1
      },
      {
        name: "Lebanon",
        dial_code: "+961",
        code: "LB"
      },
      {
        name: "Lesotho",
        dial_code: "+266",
        code: "LS"
      },
      {
        name: "Liberia",
        dial_code: "+231",
        code: "LR"
      },
      {
        name: "Libyan Arab Jamahiriya",
        dial_code: "+218",
        code: "LY"
      },
      {
        name: "Liechtenstein",
        dial_code: "+423",
        code: "LI",
        area: 1
      },
      {
        name: "Lithuania",
        dial_code: "+370",
        code: "LT",
        area: 1
      },
      {
        name: "Luxembourg",
        dial_code: "+352",
        code: "LU",
        area: 1
      },
      {
        name: "Macao",
        dial_code: "+853",
        code: "MO"
      },
      {
        name: "Macedonia",
        dial_code: "+389",
        code: "MK"
      },
      {
        name: "Madagascar",
        dial_code: "+261",
        code: "MG"
      },
      {
        name: "Malawi",
        dial_code: "+265",
        code: "MW"
      },
      {
        name: "Malaysia",
        dial_code: "+60",
        code: "MY"
      },
      {
        name: "Maldives",
        dial_code: "+960",
        code: "MV"
      },
      {
        name: "Mali",
        dial_code: "+223",
        code: "ML"
      },
      {
        name: "Malta",
        dial_code: "+356",
        code: "MT"
      },
      {
        name: "Marshall Islands",
        dial_code: "+692",
        code: "MH"
      },
      {
        name: "Martinique",
        dial_code: "+596",
        code: "MQ"
      },
      {
        name: "Mauritania",
        dial_code: "+222",
        code: "MR"
      },
      {
        name: "Mauritius",
        dial_code: "+230",
        code: "MU"
      },
      {
        name: "Mayotte",
        dial_code: "+262",
        code: "YT"
      },
      {
        name: "Mexico",
        dial_code: "+52",
        code: "MX"
      },
      {
        name: "Micronesia, Federated States of Micronesia",
        dial_code: "+691",
        code: "FM"
      },
      {
        name: "Moldova",
        dial_code: "+373",
        code: "MD"
      },
      {
        name: "Monaco",
        dial_code: "+377",
        code: "MC"
      },
      {
        name: "Mongolia",
        dial_code: "+976",
        code: "MN"
      },
      {
        name: "Montenegro",
        dial_code: "+382",
        code: "ME"
      },
      {
        name: "Montserrat",
        dial_code: "+1664",
        code: "MS"
      },
      {
        name: "Morocco",
        dial_code: "+212",
        code: "MA"
      },
      {
        name: "Mozambique",
        dial_code: "+258",
        code: "MZ"
      },
      {
        name: "Myanmar",
        dial_code: "+95",
        code: "MM"
      },
      {
        name: "Namibia",
        dial_code: "+264",
        code: "NA"
      },
      {
        name: "Nauru",
        dial_code: "+674",
        code: "NR"
      },
      {
        name: "Nepal",
        dial_code: "+977",
        code: "NP"
      },
      {
        name: "Netherlands",
        dial_code: "+31",
        code: "NL"
      },
      {
        name: "Netherlands Antilles",
        dial_code: "+599",
        code: "AN"
      },
      {
        name: "New Caledonia",
        dial_code: "+687",
        code: "NC"
      },
      {
        name: "New Zealand",
        dial_code: "+64",
        code: "NZ"
      },
      {
        name: "Nicaragua",
        dial_code: "+505",
        code: "NI"
      },
      {
        name: "Niger",
        dial_code: "+227",
        code: "NE"
      },
      {
        name: "Nigeria",
        dial_code: "+234",
        code: "NG"
      },
      {
        name: "Niue",
        dial_code: "+683",
        code: "NU"
      },
      {
        name: "Norfolk Island",
        dial_code: "+672",
        code: "NF"
      },
      {
        name: "Northern Mariana Islands",
        dial_code: "+1 670",
        code: "MP"
      },
      {
        name: "Norway",
        dial_code: "+47",
        code: "NO",
        area: 1
      },
      {
        name: "Oman",
        dial_code: "+968",
        code: "OM"
      },
      {
        name: "Pakistan",
        dial_code: "+92",
        code: "PK"
      },
      {
        name: "Palau",
        dial_code: "+680",
        code: "PW"
      },
      {
        name: "Palestinian Territory, Occupied",
        dial_code: "+970",
        code: "PS"
      },
      {
        name: "Panama",
        dial_code: "+507",
        code: "PA"
      },
      {
        name: "Papua New Guinea",
        dial_code: "+675",
        code: "PG"
      },
      {
        name: "Paraguay",
        dial_code: "+595",
        code: "PY"
      },
      {
        name: "Peru",
        dial_code: "+51",
        code: "PE"
      },
      {
        name: "Philippines",
        dial_code: "+63",
        code: "PH"
      },
      {
        name: "Pitcairn",
        dial_code: "+872",
        code: "PN"
      },
      {
        name: "Portugal",
        dial_code: "+351",
        code: "PT"
      },
      {
        name: "Puerto Rico",
        dial_code: "+1 939",
        code: "PR"
      },
      {
        name: "Qatar",
        dial_code: "+974",
        code: "QA"
      },
      {
        name: "Romania",
        dial_code: "+40",
        code: "RO"
      },
      {
        name: "Russia",
        dial_code: "+7",
        code: "RU"
      },
      {
        name: "Rwanda",
        dial_code: "+250",
        code: "RW"
      },
      {
        name: "Reunion",
        dial_code: "+262",
        code: "RE"
      },
      {
        name: "Saint Barthelemy",
        dial_code: "+590",
        code: "BL"
      },
      {
        name: "Saint Helena, Ascension and Tristan Da Cunha",
        dial_code: "+290",
        code: "SH"
      },
      {
        name: "Saint Kitts and Nevis",
        dial_code: "+1 869",
        code: "KN"
      },
      {
        name: "Saint Lucia",
        dial_code: "+1 758",
        code: "LC"
      },
      {
        name: "Saint Martin",
        dial_code: "+590",
        code: "MF"
      },
      {
        name: "Saint Pierre and Miquelon",
        dial_code: "+508",
        code: "PM"
      },
      {
        name: "Saint Vincent and the Grenadines",
        dial_code: "+1 784",
        code: "VC"
      },
      {
        name: "Samoa",
        dial_code: "+685",
        code: "WS"
      },
      {
        name: "San Marino",
        dial_code: "+378",
        code: "SM",
        area: 1
      },
      {
        name: "Sao Tome and Principe",
        dial_code: "+239",
        code: "ST"
      },
      {
        name: "Saudi Arabia",
        dial_code: "+966",
        code: "SA"
      },
      {
        name: "Senegal",
        dial_code: "+221",
        code: "SN"
      },
      {
        name: "Serbia",
        dial_code: "+381",
        code: "RS"
      },
      {
        name: "Seychelles",
        dial_code: "+248",
        code: "SC"
      },
      {
        name: "Sierra Leone",
        dial_code: "+232",
        code: "SL"
      },
      {
        name: "Singapore",
        dial_code: "+65",
        code: "SG"
      },
      {
        name: "Slovakia",
        dial_code: "+421",
        code: "SK"
      },
      {
        name: "Slovenia",
        dial_code: "+386",
        code: "SI"
      },
      {
        name: "Solomon Islands",
        dial_code: "+677",
        code: "SB"
      },
      {
        name: "Somalia",
        dial_code: "+252",
        code: "SO"
      },
      {
        name: "South Africa",
        dial_code: "+27",
        code: "ZA"
      },
      {
        name: "South Georgia and the South Sandwich Islands",
        dial_code: "+500",
        code: "GS"
      },
      {
        name: "Spain",
        dial_code: "+34",
        code: "ES"
      },
      {
        name: "Sri Lanka",
        dial_code: "+94",
        code: "LK"
      },
      {
        name: "Sudan",
        dial_code: "+249",
        code: "SD"
      },
      {
        name: "Suriname",
        dial_code: "+597",
        code: "SR"
      },
      {
        name: "Svalbard and Jan Mayen",
        dial_code: "+47",
        code: "SJ"
      },
      {
        name: "Swaziland",
        dial_code: "+268",
        code: "SZ"
      },
      {
        name: "Sweden",
        dial_code: "+46",
        code: "SE",
        area: 1
      },
      {
        name: "Switzerland",
        dial_code: "+41",
        code: "CH"
      },
      {
        name: "Syrian Arab Republic",
        dial_code: "+963",
        code: "SY"
      },
      {
        name: "Taiwan",
        dial_code: "+886",
        code: "TW"
      },
      {
        name: "Tajikistan",
        dial_code: "+992",
        code: "TJ"
      },
      {
        name: "Tanzania, United Republic of Tanzania",
        dial_code: "+255",
        code: "TZ"
      },
      {
        name: "Thailand",
        dial_code: "+66",
        code: "TH"
      },
      {
        name: "Timor-Leste",
        dial_code: "+670",
        code: "TL"
      },
      {
        name: "Togo",
        dial_code: "+228",
        code: "TG"
      },
      {
        name: "Tokelau",
        dial_code: "+690",
        code: "TK"
      },
      {
        name: "Tonga",
        dial_code: "+676",
        code: "TO"
      },
      {
        name: "Trinidad and Tobago",
        dial_code: "+1 868",
        code: "TT"
      },
      {
        name: "Tunisia",
        dial_code: "+216",
        code: "TN"
      },
      {
        name: "Turkey",
        dial_code: "+90",
        code: "TR"
      },
      {
        name: "Turkmenistan",
        dial_code: "+993",
        code: "TM"
      },
      {
        name: "Turks and Caicos Islands",
        dial_code: "+1 649",
        code: "TC"
      },
      {
        name: "Tuvalu",
        dial_code: "+688",
        code: "TV"
      },
      {
        name: "Uganda",
        dial_code: "+256",
        code: "UG"
      },
      {
        name: "Ukraine",
        dial_code: "+380",
        code: "UA"
      },
      {
        name: "United Arab Emirates",
        dial_code: "+971",
        code: "AE"
      },
      {
        name: "United Kingdom",
        dial_code: "+44",
        code: "GB",
        area: 1
      },
      {
        name: "United States",
        dial_code: "+1",
        code: "US"
      },
      {
        name: "Uruguay",
        dial_code: "+598",
        code: "UY"
      },
      {
        name: "Uzbekistan",
        dial_code: "+998",
        code: "UZ"
      },
      {
        name: "Vanuatu",
        dial_code: "+678",
        code: "VU"
      },
      {
        name: "Venezuela, Bolivarian Republic of Venezuela",
        dial_code: "+58",
        code: "VE"
      },
      {
        name: "Vietnam",
        dial_code: "+84",
        code: "VN"
      },
      {
        name: "Virgin Islands, British",
        dial_code: "+1 284",
        code: "VG"
      },
      {
        name: "Virgin Islands, U.S.",
        dial_code: "+1 340",
        code: "VI"
      },
      {
        name: "Wallis and Futuna",
        dial_code: "+681",
        code: "WF"
      },
      {
        name: "Yemen",
        dial_code: "+967",
        code: "YE"
      },
      {
        name: "Zambia",
        dial_code: "+260",
        code: "ZM"
      },
      {
        name: "Zimbabwe",
        dial_code: "+263",
        code: "ZW"
      }
    ];

    return _this;
  }
})(window.angular);

/**
 * Created by akraszewski on 16.02.2017.
 */
+function (angular) {
  'use strict';
  angular
    .module('Resources')
    .factory('FileUploadRsc', FileUploadRsc);


  /** @ngInject */
  function FileUploadRsc(ResourceBuilder, $resource, consts, SessionManager, $q,FileUploader) {
    var _this = this;

    _this.newResources = [
      {
        name: 'content',
        url: 'Fileupload/content',
        withRole: false,
        methods: {
          get: {
            url: '/:type/:id',
            method: 'GET',
            isArray: true
          },
          getContentTags: {
            url: '/getContentTags/:type/:id',
            method: 'GET',
            isArray: true
          },
          getContentForTag: {
            url: '/getContentForTag/:type/:tagId/:id',
            method: 'GET',
            isArray: true
          },

          delete: {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' }
          },

          contentTagGuidUpdate: {
            url: '/tagGuidUpdate',
            method: 'PUT'
          }
        }
      },
      {
        name: 'sendPhotoData',
        url: 'fileupload/SavePhoto',
        withRole: false,
        methods: {
          saveMe: {
            method: 'POST',
            transformResponse: function (data) {
              return { stringValue: angular.fromJson(data) }
            }
          }
        }
      },
      // {
      //   name: 'deleteContent',
      //   url: 'fileupload/deletecontent',
      //   withRole: false,
      //   methods: {
      //     delete: {
      //       method: 'POST',
      //       isArray: true
      //     }
      //   }
      // },
      {
        name: 'record',
        url: 'fileupload/record',
        withRole: false,
        methods: {
          save: {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            transformResponse: function (data) {
              return { stringValue: angular.fromJson(data) }
            }
          }
        }
      }
    ];


    _this.resources = ResourceBuilder.buildAll(_this.newResources);



    _this.saveRecord = function (record, type) {

      var data = {
        Base64: record.replace("data:audio/mp3;base64,", ""),
        Type: type
      };
      return _this.resources.record.save(data).$promise;
    };

    _this.savePhoto2 = function (a, b) {


      var def = $q.defer();

      if (a === '' || b === '') {
        def.resolve('old');
      } else {


        var data = {
          Base64: a,
          Type: b
        };

        _this.sendPhotoData(data).then(function (d) {
          def.resolve(d.stringValue);
        });
      }
      return def.promise;
    };

    _this.savePhoto = function (photo) {
      var def = $q.defer();

      if (angular.isUndefined(photo) || photo === "") {
        def.resolve('old');
      } else {

        var data = {
          Base64: photo.data.replace("data:image/jpeg;base64,", ""),
          Type: photo.type
        };

        _this.sendPhotoData(data).then(function (d) {
          def.resolve(d.stringValue);
        });
      }

      return def.promise;
    };

    _this.sendPhotoData = function (data) {
      return _this.resources.sendPhotoData.saveMe(data).$promise;
    };


    // const partnerIndex=1;
    // const serviceIndex=2;
    // const userIndex=3;

    _this.getAttachmentList = function (type, id) {
      return _this.resources.content.get({ type: type, id: id }).$promise;
    };

    _this.getContentTags= function (type, id) {
      return _this.resources.content.getContentTags({ type: type, id: id }).$promise;
    };
    _this.getContentForTag= function (type,tagId, id) {
      return _this.resources.content.getContentForTag({ type: type, tagId:tagId,id: id }).$promise;
    };


    _this.deleteContent = function (type, url) {
      return _this.resources.content.delete({ type: type, url: url }).$promise;
    };
    _this.contentTagGuidUpdate = function (guid, tags) {
      return _this.resources.content.contentTagGuidUpdate({ guid: guid, tags: tags }).$promise;
    };


    _this.LoadContentFlowConfig = function (singleFile, query, target) {
      if(!target){
        target = 'fileupload/uploadcontent';
      }
      return {
        singleFile: singleFile,
        testChunks: false,
        headers: function (file, chunk, isTest) {
          return {
            'Authorization': 'Bearer ' + SessionManager.getToken()
          }
        },
        target: consts.api + target,
        query: query
      };
    };


    _this.LoadFileUploader = function (endpoint,auto) {
      return new FileUploader({
        // sendAllAtOnceItemsMultipleFileInputs: false,
        url: consts.api + endpoint,
        autoUpload: auto,
        dataType: "json",
        cache: false,
        contentType: "application/json",
        headers: {'Authorization': 'Bearer ' + SessionManager.getToken()}
        // aliases: 'file1,file2,file3,file4,file5,file6'
      });
    };


    _this.downloadFile = function(fileName){
      return function(response){
        var blob = new Blob([new Uint8Array(response.data)], {
          type: response.headers('Content-Type')
        });
        //var URL = window.URL || window.MozURL || window.webkitURL || window.MSURL || window.OURL;

        var anchor = document.createElement('a');
        anchor.href = URL.createObjectURL(blob);
        anchor.download = fileName;
        document.body.appendChild(anchor); //For FF
        anchor.target = '_blank';
        anchor.click();
        //It's better to remove the elem
        document.body.removeChild(anchor);
      }
    }

    _this.getReplacmentFileThumbnail=function (element){
      if(element.contentUrl.endsWith('.txt')){
        element.contentUrlNoImage='assets/images/communicator/file_replacement/txt-text-file-extension-symbol.svg';
      }else if(element.contentUrl.endsWith('.pdf')){
        element.contentUrlNoImage='assets/images/communicator/file_replacement/pdf-file-format-symbol.svg';
      }else if(element.contentUrl.endsWith('.doc')){
        element.contentUrlNoImage='assets/images/communicator/file_replacement/doc-file-format-symbol.svg';
      }else if(element.contentUrl.endsWith('.docx')){
        element.contentUrlNoImage='assets/images/communicator/file_replacement/docx-file-format-symbol.svg';
      }else if(element.contentUrl.endsWith('.csv')){
        element.contentUrlNoImage='assets/images/communicator/file_replacement/csv-file-format-symbol.svg';
      }else if(element.contentUrl.endsWith('.xls')){
        element.contentUrlNoImage='assets/images/communicator/file_replacement/xls-file-format-symbol.svg';
      }else if(element.contentUrl.endsWith('.xlsx')){
        element.contentUrlNoImage='assets/images/communicator/file_replacement/xlsx-file-format.svg';
      }else if(element.contentUrl.endsWith('.ppt')){
        element.contentUrlNoImage='assets/images/communicator/file_replacement/ppt-file-format.svg';
      }else if(element.contentUrl.endsWith('.zip')){
        element.contentUrlNoImage='assets/images/communicator/file_replacement/zip-compressed-files-extension.svg';
      }else if(element.contentUrl.endsWith('.rar')){
        element.contentUrlNoImage='assets/images/communicator/file_replacement/rar-compressed-files-extension.svg';
      }else if(element.contentUrl.endsWith('.avi')){
        element.contentUrlNoImage='assets/images/communicator/file_replacement/avi-compressed-files-extension.svg';
      }else if(element.contentUrl.endsWith('.mp3')){
        element.contentUrlNoImage='assets/images/communicator/file_replacement/mp3-compressed-files-extension.svg';
      } 

    }

    return _this;
  }
}(window.angular);

/**
 * Created by kosski on 07.09.2016.
 */
+function () {
  'use strict';
  angular
    .module('sessionManager', ['Resources','TA-WebSocket'])
    .config(config)
    .run(run);

  /** @ngInject */
  function config($translatePartialLoaderProvider, msNavigationServiceProvider,WebSocketProvider) {
    WebSocketProvider.setAddress('wss://notifs.teleaudio.pl');
    WebSocketProvider.setInterval(30);
  }

  /** @ngInject */
  function run(SessionManager,MenuManager) {
    if(SessionManager.getUserRole())
      MenuManager.initiateMenu();
  }
}();

(function () {
  'use strict';
  angular
    .module('sessionManager')
    .factory('debugInterceptor', interceptor);

  interceptor.$inject = ['$q', '$rootScope','consts'];

  function interceptor($q, $rootScope,consts) {
    var vm = this;

    vm.requestStack = [];

    function getDuplicates(stack) {
      var sortedArr = stack.slice().sort(); // You can define the comparing function here.
      // JS by default uses a crappy string compare.
      // (we use slice to clone the array so the
      // original array won't be modified)
      var results = [];
      for (var i = 0; i < sortedArr.length - 1; i++) {
        if (sortedArr[i + 1] == sortedArr[i]) {
          results.push(sortedArr[i]);
        }
      }
      return results;
    }

    return {
      'request': function (config) {
        if(config.url.indexOf(consts.api) !== -1)
          vm.requestStack.push(config.url);
        return config;
      },
      'responseError': function (rejection) {
        var requestIndex = vm.requestStack.indexOf(rejection.config.url);
        if (requestIndex !== -1) {
          vm.requestStack.splice(requestIndex, 1);
        }
        return $q.reject(rejection);
      },
      'response': function (response) {
        if(consts.api = 'http://localhost:52653/api/'){
          var duplicates = getDuplicates(vm.requestStack);
          if(duplicates.length >0){
            console.log('Interceptor Debug || Many Calls',duplicates);
            duplicates.forEach(function(item){
              vm.requestStack = vm.requestStack.filter(function(element) {
                return element !== item;
              });
          });
          }
        }
        var requestIndex = vm.requestStack.indexOf(response.config.url);
        if (requestIndex !== -1) {
          vm.requestStack.splice(requestIndex, 1);
        }
        return response;
      }
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('sessionManager')
    .factory('authInterceptor', interceptor);

  interceptor.$inject = ['$q', 'SessionManager','consts'];

  function interceptor($q, SessionManager,consts) {

    return {
      'request': function (config) {
        if (config.url.indexOf(consts.api) !== -1)
          if (SessionManager.sessionStatus()) {
            if (SessionManager.getToken() && !config.headers.Authorization) {
              config.headers.Authorization = 'Bearer ' + SessionManager.getToken();
            }
          } else {
            console.log('authInterceptor | sessionStatus false on url='+config.url);
            SessionManager.killSession();
          }
        return config;
      },

      'responseError': function (rejection) {
        if (rejection.status === 401) {
          console.log('authInterceptor | session unauthorized');
          SessionManager.killSession();
        }
        return $q.reject(rejection);
      }
    }
  }
})();

(function() {
  "use strict";

  angular.module("sessionManager").service("AuthService", Service);

  // Service.$inject = ['$q', 'SessionManager', 'DynamicFactory', '$sessionStorage'];
  /** @ngInject */
  function Service($q, $rootScope, SessionManager, DynamicFactory, $sessionStorage, $localStorage, partyService) {
    function userData() {
      return $sessionStorage.userData;
    }

    // function login(username, password, isInternalHost) {

    //   var defer = $q.defer();
    //   var data = 'grant_type=password&username=' + username + '&password=' + password;

    //   DynamicFactory.get('AuthResource', 'querryToken')(data).then(function (response) {

    //     SessionManager.setTokenData(response);

    //     DynamicFactory.get('AuthResource', 'querryLogin')({
    //       username: username,
    //       password: password
    //     }).then(function (response) {
    //       SessionManager.setUserData(response);
    //       // DynamicFactory.get('AuthResource', 'setStatus')(1,isInternalHost ? $localStorage.hostNumber : undefined);
    //       defer.resolve(response);
    //     }, function (reason) {
    //       defer.reject(reason);
    //     });
    //   }, function (reason) {
    //     defer.reject(reason);
    //   });
    //   return defer.promise;
    // }

    function login(username, password, sha512, isInternalHost) {
      var defer = $q.defer();
      var data = "grant_type=password&username=" + username + "&password=" + password;

      DynamicFactory.get("AuthResource", "querryToken")(data).then(
        prepareLoginResponse(defer, {
          username: username,
          password: password
        }),
        function(reason) {
          defer.reject(reason);
        }
      );
      return defer.promise;
    }

    function remoteLogin(remoteToken) {
      var defer = $q.defer();
      // var data = 'grant_type=password&username=' + username + '&password=' + password;

      DynamicFactory.get("AuthResource", "remoteToken")(remoteToken).then(prepareRemoteLogin(defer), function(reason) {
        defer.reject(reason);
      });
      return defer.promise;
    }

    function prepareLoginResponse(defer, loginPostObj) {
      return function(response) {
        SessionManager.setTokenData(response);

        DynamicFactory.get("AuthResource", "querryLogin")(loginPostObj).then(
          function(response) {
            SessionManager.setUserData(response);
            // DynamicFactory.get('AuthResource', 'setStatus')(1,isInternalHost ? $localStorage.hostNumber : undefined);
            defer.resolve(response);
          },
          function(reason) {
            defer.reject(reason);
          }
        );
      };
    }

    function prepareRemoteLogin(defer) {
      return function(response) {
        console.log("AuthService | remote login access granted", response);

        SessionManager.setTokenData({
          access_token: response.bearer,
          expires_in: 86399,
          token_type: "bearer"
        });
        SessionManager.setUserData(response.user);
        defer.resolve(response.user);
      };
    }

    function logout(withoutStateChange) {
      // DynamicFactory.get('', 'changeStatus')(0).then(function (result) {
      var user = SessionManager.getUser();
      partyService.logOut(user, true);
      // if (withoutStateChange) {
      //   console.log("AuthService | logout");
      //   SessionManager.killSession();
      // } else {
        DynamicFactory.get("AuthResource", "changeState")(0).then(function(result) {
          console.log("AuthService | logout");
          SessionManager.killSession();
        });
      // }

      // alert('Consultant is offline now');
      // });
    }

    this.remoteLogin = remoteLogin;
    this.login = login;
    this.logout = logout;
    this.userData = userData;
  }
})();

/**
 * Created by kosski on 07.09.2016.
 */
+ function () {
  'use strict';
  angular
    .module('sessionManager')
    .service('SessionManager', SessionManager);

  /** @ngInject */
  function SessionManager($window, $sessionStorage, $location, WebSocketManager, DynamicFactory, authRolesConst, callSessionManager, callInfoBarService) {
    var loggedUser;
    // const portalId = 1;
    // const callCenterId = 2;
    const noUserMsg = 'Brak danych autoryzacyjnych - Nie zarejestrowano metod nasłuchu Web Socket';
    const loginPath = '/login';

    /**
     * session manaager constructor
     */
    function constructor() {
      loggedUser = $sessionStorage['userData'];

      if (!loggedUser) {
        if ($location.path() !== loginPath && $location.path() != '/') {
          console.log('SessionManager | unauthorized user not in /login path | current path="' + $location.path()+'" - begin redirect');
          $location.path(loginPath);
          // if($location.path() != '/')
          //   $window.location.reload();
        }
      } else {
        initWSS();
      }
    }

    function initWSS() {
      if (loggedUser) {
        var role = getUserRoleId();
        var userName = getUser()['username'];
        var consultantId = getUser()['consultantId'];
        var partnerId = getUser()['partnerId'];
        var ccId = getUser()['callCenterId'];

        if (isConsultant() || role === 2) {
          callInfoBarService.allowedForUser = true;
        }

        WebSocketManager.webSocketInit(userName, role, partnerId, ccId, consultantId)
          .then(function () {
            WebSocketManager.allowedForUser = true;
          }, errorHandler);
      }
    }

    /**
     * return user auth data
     * @returns {*}
     */
    function getUser() {
      return loggedUser['authentication'];
    }

    function portalConsultant(){
      return getUser()['portalId'] !== -1;
    }

    function buildRegexForConsultant() {
      var user = getUser();
      if(user.consultantId===-1) {
        console.log('regex: Error nie zdarza sie...?');
        return 'nie zdarza sie...';
      }else{
        console.log('regex: ' + '^ccs\\.' + user.partnerId + '\\/' + user.callCenterId + '\\/' + user.consultantId);
        return '^ccs\\.' + user.partnerId + '\\/' + user.callCenterId + '\\/' + user.consultantId+'$';
      }
    }

    function buildRegexForManagerAndConsExtended() {
      var user = getUser();
      if(getUserRoleId()===3){
        console.log('regex: ' + '^ccs\\.' + user.partnerId + '\\/' + user.callCenterId + '\\/' + user.consultantId);
        return '^ccs\\.' + user.partnerId + '\\/' + user.callCenterId + '\\/' + user.consultantId+'$';
      }
      else{
        if(user.consultantId===-1){
          //zwykły manager
          console.log('^ccs\\.' + user.partnerId + '\\/' + user.callCenterId + '\\/-1$');
          return '^ccs\\.' + user.partnerId + '\\/' + user.callCenterId + '\\/-1$';
        }else{
          //manager i konsultant
          console.log('^ccs\\.' + user.partnerId + '\\/' + user.callCenterId + '\\/' + user.consultantId+'$|'+'^ccs\\.' + user.partnerId + '\\/' + user.callCenterId + '\\/-1$');
          return '^ccs\\.' + user.partnerId + '\\/' + user.callCenterId + '\\/' + user.consultantId+'$|'+'^ccs\\.' + user.partnerId + '\\/' + user.callCenterId + '\\/-1$';
        }

      }

    }
    function buildRegexForManager() {
      var user = getUser();
      if(getUserRoleId()===2){
        console.log('regex: ' + '^ccs\\.' + user.partnerId + '\\/' + user.callCenterId + '\\/' + user.userId);
        return '^ccs\\.' + user.partnerId + '\\/' + user.callCenterId + '\\/' + user.userId+'$';
      }
      console.log('regex: ' + '^ccs\\.' + user.partnerId + '\\/' + user.callCenterId + '\\/' + user.consultantId);
      return '^ccs\\.' + user.partnerId + '\\/' + user.callCenterId + '\\/' + user.consultantId+'$';
    }

    function buildRegexForCallCenter() {
      var user = getUser();
      console.log('regex: '+'^ccs\\.' + user.partnerId + '\\/' + user.callCenterId);
      return '^ccs\\.' + user.partnerId + '\\/' + user.callCenterId;
    }

    function buildRegexForCCAndConsExtended() {
      var user = getUser();
      if(getUserRoleId()===3){
        console.log('regex: ' + '^ccs\\.' + user.partnerId + '\\/' + user.callCenterId + '\\/' + user.consultantId);
        return '^ccs\\.' + user.partnerId + '\\/' + user.callCenterId + '\\/' + user.consultantId+'$';
      }
      else{
        if(user.consultantId===-1){
          //zwykły manager
          console.log('regex: '+'^ccs\\.' + user.partnerId + '\\/' + user.callCenterId);
      return '^ccs\\.' + user.partnerId + '\\/' + user.callCenterId;
        }else{
          //manager i konsultant
          console.log('^ccs\\.' + user.partnerId + '\\/' + user.callCenterId + '\\/' + user.consultantId+'$|'+'^ccs\\.' + user.partnerId + '\\/' + user.callCenterId + '\\/-1$');
          return '^ccs\\.' + user.partnerId + '\\/' + user.callCenterId + '\\/' + user.consultantId+'$|'+'^ccs\\.' + user.partnerId + '\\/' + user.callCenterId + '\\/-1$';
        }

      }

    }
    function isConsultant(){
      var usr =getUser();
      if(!usr) return false;
      return usr['consultantId'] && usr['consultantId'] !== -1;
    }

    /**
     * update user in storage
     */
    function updateStorage(cb) {
      $sessionStorage['userData'] = loggedUser;
      if (cb) {
        cb();
      }
    }

    /**
     * Pytaj konrada bo to kurwa z dupy jest
     * KK : służy do wyciągnięcia parametru bez uwzględnienia wielkości liter. Używane w dynamicaction.component.js
     * @param field nazwa pola
     * @returns String wartość pola
     */
    function getUserData(field) {
      var user = getUser();

      if (!user) return user;

      for (var key in user) {
        if (key && key.toLowerCase() === field.toLowerCase()) {
          return user[key];
        }
      }
    }

    /**
     * musk rozjebany
     * @returns {*}
     */
    function getUserRole() {
      return authRolesConst.nameOf(getUserRoleId());
    }

    function getUserRoleId() {
      if (!loggedUser) {
        return -99999;
      } else {
        return getUser()['roleId'];
      }
    }

    function updateAvatarURL(url) {
      loggedUser.userImg = url;
      updateStorage();
    }




    /**
     * build up user data and init WSS.
     * @param data
     */
    function setUserData(data) {
      var auth = loggedUser['authentication'];
      if (!auth) {
        auth = data;
      }
      loggedUser['authentication'] = auth;
      setActivePortal();
      updateStorage(initWSS);
    }

    function setTokenData(data) {
      if (!loggedUser) loggedUser = {};
      loggedUser['tokenData'] = data;
      $sessionStorage.sessionExpiration = moment();
      $sessionStorage.sessionExpiration.add(loggedUser['tokenData']['expires_in'], 's');
      updateStorage();
    }

    function getToken() {
      return $sessionStorage['userData'] ? $sessionStorage['userData']['tokenData']['access_token'] : undefined;
    }

    function sessionStatus() {
      return moment($sessionStorage.sessionExpiration) > moment();
    }

    function clearCommunicatorSessionData() {
      if ($sessionStorage.communicatorCofig) {
        $sessionStorage.communicatorCofig = undefined;
      }
    }

    function setActivePortal(portal) {
      if (loggedUser['authentication'].portals) {
        var portalId = loggedUser['authentication'].portals[portal || 0] || -1;
        loggedUser['authentication'].portalId = portalId;
      } else loggedUser['authentication'].portalId = -1;
    }


    /**
     * helper
     */
    function cbKiller() {
      console.log('SessionManager | cbKiller | current path=' + $location.path()+' - begin redirect');
      DynamicFactory.reset();
      clearCommunicatorSessionData();
      callSessionManager.clearCallStorage();
      $location.path('/login');
      $window.location.reload();
    }

    /**
     * killings session like a hitman but junior hitman !
     */
    function killSession() {
      if (loggedUser) {
        WebSocketManager.killWebSocket();
        WebSocketManager.allowedForUser = false;
        loggedUser = undefined;
        console.log('SessionManager | killSession | current path=' + $location.path()+' - begin redirect');

        updateStorage(cbKiller);
      }
    }

    /**
     * error halndler
     * @param err
     */
    function errorHandler(err) {
      //console.log(err);
    }

    function setUserStatus(status,phone,phoneType) {
      loggedUser['authentication'].status = status;
      if(phone){
        loggedUser['authentication'].phone1 = phone;
      }
        if(phoneType){
        loggedUser['authentication'].phoneType = phoneType;
        }
    }

    function setUserPassword(newPassword) {
      if(newPassword){
        loggedUser['authentication'].pwd = newPassword;
      }
    }
 

    function getUserStatus() {
      return loggedUser['authentication'].status;
    }
    constructor();

    return {
      getUser: getUser,
      isConsultant:isConsultant,
      portalConsultant:portalConsultant,
      getUserData: getUserData,
      getUserRole: getUserRole,
      getUserRoleId: getUserRoleId,
      setUserData: setUserData,
      setUserPassword: setUserPassword,
      setTokenData: setTokenData,
      getToken: getToken,
      sessionStatus: sessionStatus,
      clearCommunicatorSessionData: clearCommunicatorSessionData,
      killSession: killSession,
      updateAvatarURL: updateAvatarURL,
      setActivePortal: setActivePortal,
      init: initWSS,
      setUserStatus:setUserStatus,
      getUserStatus:getUserStatus,
      buildRegexForConsultant:buildRegexForConsultant,
      buildRegexForCallCenter:buildRegexForCallCenter,
      buildRegexForManagerAndConsExtended:buildRegexForManagerAndConsExtended,
      buildRegexForManager:buildRegexForManager,
      buildRegexForCCAndConsExtended:buildRegexForCCAndConsExtended
    }
  }
}();

/**
 * Created by rpiekarski on 23.05.2017.
 */
(function () {
  angular.module('sessionManager')
    .constant('authRolesConst', {
    'none': 100,
    'consultant': 3,
    'manager': 2,
    'admin': 1,
    'ta': 0,
    'nameOf': function (id) {
      for (var key in this) {
        if (id === this[key] && 'nameOf' !== key) {
          return key;
        }
      }
    }
  })

}());

/**
 * Created by kosski on 07.09.2016.
 */
+function () {
  'use strict';
  angular
    .module('sessionManager')
    .service('callSessionManager', CallSessionManager).constant("CallStatusConst", {
    waiting: 'WAITING', //only code,
    ringing: 'RINGING',//bridge, callIN
    answered: 'ANSWERED',//bridge,
    connected: 'CONNECTED',// only code?
    wait4drop: 'WAIT4DROP',// bridge, callIN
    disconnected: 'DISCONNECTED',//bridge, callIN
    // hangup: 'HANGUP',//bridge,
    failed: 'FAILED',//bridge,callIN
    timeupdate: 'TIMEUPDATE',//bridge,callIN
    failedRedirect: 'FAILED_REDIRECT',
    walletChange: 'WALLET_CHANGE',
    redirect: 'REDIRECT'
  });

  /** @ngInject */
  function CallSessionManager($sessionStorage) {
    var _this = this;
    _this.setCall = setCall;
    _this.getCall = getCall;
    _this.removeCall = removeCall;
    _this.clearCallStorage = clearCallStorage;

    function setCall(call) {
      if ($sessionStorage.currentCall) {
        console.log("Bład! Aktualnie toczy sie juz rozmowa! Aby dodac nowa usun istniejaca")
      }
      else {
        $sessionStorage.currentCall = call;
      }
    };


    function getCall() {
      console.log('call - currentCall: ',$sessionStorage.currentCall);
      return $sessionStorage.currentCall;
    };

    function removeCall() {
      if ($sessionStorage.currentCall) {
        $sessionStorage.currentCall = undefined;
      }
    };

    function clearCallStorage() {
      removeCall();
    }

    return _this;
  }


}();


(function () {
  'use strict';

  angular
    .module('taapp')
    .service('WebRTCService', Service);

  /**@ngInject */
  function Service(DynamicFactory, WebSocketManager, $q, deviceDetector) {
    var vm = this;
    vm.makeCall = makeCall;
    vm.takeCall = takeCall;
    vm.tryTakeCall = tryTakeCall;
    vm.receiverMsgCall = receiverMsgCall;
    vm.disconnectCall = disconnectCall;
    vm.getActiveCall = getActiveCall;
    vm.setMicrophone = setMicrophone;
    // vm.disconnectFunc;
    // vm.answerFunc;
    vm.connectionToken = '';
    vm.audio = new Audio();
    vm.wsReceiverMsgCall = undefined;

    var peerConnection;
    var connectionInProgress = false;
    var MediaStream;
    var locCallID;

    var configuration = {
      iceServers: [{
        urls: [
          'turn:192.168.10.42:3478?transport=udp',
          'turn:195.8.220.211:3478?transport=udp'
        ],
        username: 'c0mmon',
        credential: 'E3901B11-E4F3-41AA-A9A8-49C7BBDB87F6'
      }]
    };

    function getActiveCall() {
      var isActive = (vm.currAudio && vm.currAudio.length > 0);
      return isActive;
    }

    function getUserMedia(options, onSuccess, onFail) {
      //return $q(function (resolve, reject) {
      var n = navigator;
      switch (deviceDetector.browser) {
        case 'chrome':
          n.getUserMedia = n.getUserMedia || n.webkitGetUserMedia;
          break;
        case 'firefox':
          n.getUserMedia = getMozMedia || n.getUserMedia;
          break;
        case 'opera':
          n.getUserMedia = n.webkitGetUserMedia || n.getUserMedia;
          break;
        default:
          n.getUserMedia = n.getUserMedia || n.webkitGetUserMedia || getMozMedia || n.msGetUserMedia;
          break;
      }
      console.log('getUserMedia', n.getUserMedia);
      return n.getUserMedia(options, onSuccess, onFail);
      //   n.getUserMedia(options, resolve, reject);
      //});
    }

    function getMozMedia(constraints, success, error) {
      if (_.isObject(navigator.mediaDevices) && _.isFunction(navigator.mediaDevices.getUserMedia)) {
        navigator.mediaDevices.getUserMedia(constraints).then(function (stream) {
          success(stream);
        }).catch(function (err) {
          error(err);
        });
      } else if (_.isFunction(navigator.getUserMedia)) {
        navigator.getUserMedia(constraints, success, error);
      } else {
        error(new Error('Failed to request media permissions!'));
      }
    }

    function setMicrophone(enabled) {
      if (MediaStream) {
        console.log('Webrtc | microfophone is set to =' + MediaStream.enabled + 'change to =' + enabled, MediaStream);
        MediaStream.enabled = enabled;
      }
    }

    function makeCall(number, customParams, wsReceiverMsgCall) {
      var defer = $q.defer();
      vm.wsReceiverMsgCall = wsReceiverMsgCall;
      //, answerFunc, disconnectFunc
      console.log('MakeCall');
      // vm.answerFunc = answerFunc;
      // vm.disconnectFunc = disconnectFunc;
      getUserMedia({
        video: false,
        audio: true
      }, function (stream) {
        console.log('Media OK');
        MediaStream = stream.getTracks()[0];
        WebSocketManager.registerWebSocketMethod('CallOut', 'callBridge', vm.receiverMsgCall);
        var token = WebSocketManager.getUserToken() + ':CallOut';
        var params = {
          'token': token,
          'number': number
        };
        params = Object.assign(params, customParams);
        //params.concat(customParams);
        //udp
        //configuration
        peerConnection = new RTCPeerConnection(configuration);
        peerConnection.onaddstream = function (event) {
          console.log('onADDstream', event.stream);
          //vm.currAudio = URL.createObjectURL(event.stream);
          vm.currAudio = event.stream;
          vm.audio.srcObject = vm.currAudio;
          vm.audio.play();
          defer.resolve();
        };
        peerConnection.onremovestream = function (event) {
          console.log('onREMOVEstream', event.stream);
        };
        peerConnection.onsignalingstatechange = function (event) {
          console.log('onicecandidate', event);
          if (event.type == 'CONNECTED') {
            console.log('config', peerConnection.getConfiguration());
            console.log('local STREAM', peerConnection.getLocalStreams());
            console.log('remote STREAM', peerConnection.getRemoteStreams());
          }
        };
        peerConnection.onicecandidate = function (event) {
          console.log('onicecandidate', event);
          if (event.candidate == null) {} else {
            var candidate = event.candidate.candidate;
            if (candidate.indexOf('relay') > 0) {
              window.setTimeout(function () {
                if (!connectionInProgress) {
                  var localSDP = peerConnection.localDescription;
                  console.log('LocalSDP', localSDP);
                  console.log('sendSDP phone: ', number);
                  DynamicFactory.get('PhoneCallRsc', 'sendSDP')(localSDP.type, localSDP.sdp, number, params).then(function (data) {
                    console.log(data);
                    vm.connectionToken = data.token;
                  });
                  connectionInProgress = true;
                }
              }, 1500);
            }
          }
        };
        peerConnection.addStream(stream);
        peerConnection.createOffer().then(function (offer) {
          console.log('OFFER', offer);
          peerConnection.setLocalDescription(offer);
          //post do servera
        });
      }, function (err) {
        console.log('Media failed');
        defer.reject();
      });
      return defer.promise;
    };

    function receiverMsgCall(msg) {
      console.log('receiverMsg: ', msg);
      if (msg.Content) {
        var msgCon = (msg.Content);
        var type = msgCon.type;
        if (vm.wsReceiverMsgCall) {
          vm.wsReceiverMsgCall(msg);
        }
        if (type === 'media' || type === 'answer') {
          var answer = msgCon.sdp;
          console.log('create remote SD=>', answer);
          var frame = {
            type: 'answer',
            sdp: answer
          };
          console.log('frame to SessionDesc=>', frame);
          var remoteSDP = new RTCSessionDescription(frame);
          console.log('remoteSDP=>', 'CREATED');
          // remoteSDP.sdp = answer;
          // remoteSDP.type = 'answer';
          peerConnection.setRemoteDescription(remoteSDP, function () {
            console.log('setRemoteOK', remoteSDP);
          }, function (err) {
            console.log('setRemoteFAILED!!!', err);
          });
        }
        // else if (type === 'answer') {
        //     if (vm.answerFunc) {
        //         vm.answerFunc(msg);
        //     }
        // }
        // else if (type === 'bye') {
        //     if (vm.answerFunc) {
        //         vm.disconnectFunc(msg);
        //     }
        //     disconnectCall(vm.connectionToken);
        // }
      }
    };

    function tryTakeCall(sdp, callID) {
      if (peerConnection) {
        console.log('Już trwa połączenie WebRTC!');
      } else {
        takeCall(sdp, callID);
      }
    }

    function takeCall(sdp, callID) {
      console.log('takeCall');
      locCallID = callID;
      getUserMedia({
        video: false,
        audio: true
      }, function (stream) {
        console.log('Media OK');
        MediaStream = stream.getTracks()[0];
        //udp
        //configuration
        peerConnection = new RTCPeerConnection(configuration);
        peerConnection.onaddstream = function (event) {
          console.log('onADDstream', event.stream);
          //audioControl.src = URL.createObjectURL(event.stream);
          //vm.currAudio = URL.createObjectURL(event.stream);
          vm.currAudio = event.stream;
          vm.audio.srcObject = vm.currAudio;
          vm.audio.play();
        };
        peerConnection.onremovestream = function (event) {
          console.log('onREMOVEstream', event.stream);
        };
        peerConnection.onsignalingstatechange = function (event) {
          console.log('onicecandidate', event);
          if (event.type == 'CONNECTED') {
            console.log('config', peerConnection.getConfiguration());
            console.log('local STREAM', peerConnection.getLocalStreams());
            console.log('remote STREAM', peerConnection.getRemoteStreams());
          }
        };
        peerConnection.onicecandidate = function (event) {
          console.log('onicecandidate', event);
          if (event.candidate == null) {} else {
            var candidate = event.candidate.candidate;
            if (candidate.indexOf('relay') > 0) {
              DynamicFactory.get('PhoneCallRsc', 'answerCall')(callID, event.currentTarget.localDescription.sdp).then(function (data) {
                console.log(data);
              });
            }
          }
        };
        peerConnection.addStream(stream);
        var frame = {
          type: 'offer',
          sdp: sdp
        };
        console.log('frame to SessionDesc=>', frame);
        var remoteSDP = new RTCSessionDescription(frame);
        // remoteSDP.sdp = sdp;
        // remoteSDP.type = 'offer';
        // peerConnection.setLocalDescription(remoteSDP, function () {
        peerConnection.setRemoteDescription(remoteSDP, function () {
          console.log('setRemoteOK', remoteSDP);
          peerConnection.createAnswer().then(function (answer) {
            peerConnection.setLocalDescription(answer);
          });
        }, function (error) {
          //!!!brak obslugi bledow powoduje bledy w Firefox>=61
          console.log('Error: ', error);
        });
      }, function (err) {
        console.log('Uwaga! Wystąpił błąd. Sprawdź podłączenie słuchawek');
        console.log('Media failed');
      });
    };

    function disconnectCall(callID) {
      console.log('disconnectCall');
      if (!locCallID && callID) {
        locCallID = callID;
      }
      WebSocketManager.unregisterWebSocketMethod('CallExt'); //- unbind!?
      console.log('byeCall callId: ', locCallID);
      DynamicFactory.get('PhoneCallRsc', 'byeCall')(locCallID).then(function (data) {
        console.log(data);
        if (peerConnection) {
          peerConnection.close();
          peerConnection = null;
        }
        if (MediaStream) {
          MediaStream.stop();
          MediaStream = null;
        }
        connectionInProgress = false;
        vm.connectionToken = '';
        locCallID = '';
        // vm.disconnectFunc = undefined;
        // vm.answerFunc = undefined;
        vm.audio.pause();
        vm.audio.src = '';
        vm.currAudio = undefined;
        // vm.microphone = undefined;
      });
    };
  }
})();

(function() {
    'use strict';

    angular.module('TA-WebSocket', [

    ]);
})();

(function () {
  'use strict';

  angular
    .module('TA-WebSocket')
    .provider('WebSocket', webSocketProvider);

  function webSocketProvider() {

    var vm = this;

    var test = {};

    var sequence = 0;
    vm.clients = {};
    vm.commands = {
      keepAlive: 1,
      bind: 2,
      message: 4,
      response: 4096
    };
    vm.isBinded = false;
    vm.counterClose = 0;

    return {
      setAddress: function (value) {
        vm.address = value;
      },
      $get: ['$interval', '$q', '$injector', '$timeout', function ($interval, $q, $injector, $timeout) {
        var $rootScope = $injector.get('$rootScope');

        function onMessage(event) {
          sequence++;
          var msg = JSON.parse(event.data);
          if (msg.Token.indexOf(':') >= 0) {
            //console.log(msg.Token);
            //console.log(msg); //treść wiadomości WS

            var token = msg.Token.split(':');

            var callbacks = vm.clients[token[1]];
            // console.log("vm.clients - callbacks: ", vm.clients);
            // console.log("onMessage - callbacks: ", callbacks);
            if (callbacks) {
              for (var i = 0; i < callbacks.length; i++) {
                if (callbacks[i].regex) {
                  if (callbacks[i].regex.test(token[0])) {
                    callbacks[i].fn(msg);
                    $rootScope.$apply();

                  }
                } else {
                  callbacks[i].fn(msg);
                  $rootScope.$apply();
                }
              }
            }
          }
        }

        function sendMessage(command, token, content) {

          var obj = {
            sequence: sequence,
            timestamp: new Date(),
            command: command,
            token: token,
            content: content
          };
          vm.socket.send(JSON.stringify(obj));
        }

        function connect() {
          console.log("connect()");
          console.log("vm.socket: ", vm.socket);
          if (vm.socket != undefined) {
            console.log("vm.socket.readyState: ", vm.socket.readyState);
          }

          var defer = $q.defer();
          vm.trustedClose = false;
          if ((vm.socket) && (vm.socket.readyState === 1)) {
            defer.resolve();//{url: vm.address}
          } 
          else {
            if (vm.address) {
              vm.socket = new WebSocket(vm.address);
              vm.socket.onopen = function (data) {
                console.log('Socket Open Event!', data);
                vm.socket.onmessage = onMessage;
                vm.socket.onclose = onClose;
                defer.resolve(data);
              };
            } else {
              defer.reject({
                message: 'You have to set Web Socket address in module config!'
              });
            }
          }
          return defer.promise;
        }

        function close() {
          stopInterval();
          vm.isBinded = false;
          vm.socket.close();
          vm.trustedClose = true;
        }

        function startInterval() {
          vm.interval = $interval(function () {
            // console.log('vm.socket:',vm.socket);
            sendMessage(vm.commands.keepAlive, vm.bindToken);
          }, (vm.intervalTime || 30) * 1000);
        }

        function stopInterval() {
          if (angular.isDefined(vm.interval)) {
            $interval.cancel(vm.interval);
            vm.interval = undefined;
          }
        }

        function onClose() {
          stopInterval();
          if (!vm.trustedClose) {
            //poprawka przy blokowaniu debuggerem
            if ((vm.socket) && (vm.socket.readyState === 3)) {
              console.log('reconnect');
              close();
              bind(vm.bindToken);
              return;
            }
            //poprawka przy blokowaniu debuggerem
            connect().then(function (data) {
              console.log('onClose - data: ', data);
              console.log('onClose - vm.counterClose: ',vm.counterClose);

              if (!data.url) {
                  if (vm.counterClose < 3) {
                    vm.counterClose++;
                    return $timeout(onClose(), 5000);
                  }
                  else {
                    close();
                    bind(vm.bindToken);
                  }
              }
              vm.reconnect = false;
              console.log('onClose - vm.clients: ', vm.clients);
              for (var cb in vm.clients) {
                //registerCallback();
                console.log(cb);
              }
            })
          }
        }

        function bind(token) {
          var defer = $q.defer();
          connect().then(function (data) {
            console.log('bind - data: ', data);
            sendMessage(vm.commands.bind, token);
            vm.isBinded = true;
            vm.bindToken = token;
            startInterval();
            vm.counterClose = 0;

            defer.resolve(token);
          }, function (err) {
            defer.reject(err);
          });

          return defer.promise;
        }

        function registerCallback(token, callbackName, callback, regex) {
          connect().then(function (data) {
            if (!vm.bindToken) {
              console.err('Register callback failed');
              console.log('Register callback failed');
              return;
            }
            if (!vm.clients[token]) {
              vm.clients[token] = [];
            }

            vm.clients[token].map(function (obj) {
              if (obj.name === callbackName) {
                console.warn('For token: ' + token + ' Callback with name' + callbackName + 'already exist');
                return;
              }
            });
            // if (callback === undefined || callback === null)

            if (callback) {
              vm.clients[token].push({
                name: callbackName,
                fn: callback,
                regex: prepareRegex(regex)
              });
              console.log('For token:' + token + ' New callback registered:  ' + callbackName);
            }
          });
        }

        function prepareRegex(regex) {
          if (!regex) {
            // console.log('it is not a func');
            return;
          } else if (angular.isString(regex))
            return new RegExp(regex, 'i');
          else {
            if (typeof regex === 'RegExp')
              return regex;
          }
        }

        function unregisterCallback(token, callbackName) {
          if (callbackName) {
            if (vm.clients[token]) {
              _.remove(vm.clients[token], {
                name: callbackName
              });
              console.log('WebSocket unregister ' + token + ' : ' + callbackName);

            }
          } else {
            if (vm.clients[token]) {
              delete vm.clients[token];
              console.log('WebSocket unregister ' + token + ' : ***');

            }
          }
        }

        function unregisterALLCallback() {
          if (vm.clients && vm.clients.length > 0) {
            vm.clients.splice(0, vm.clients.length)
          }
        }

        return {
          register: registerCallback,
          unregister: unregisterCallback,
          unregisterALL: unregisterALLCallback,
          bind: bind,
          unbind: close
        };
      }],

      setInterval: function (value) {
        vm.intervalTime = value;
      }
    };

  }
})();

/**
 * Created by akraszewski on 2017-03-13.
 */
(function () {
  "use strict";
  angular.module('TA-WebSocket').service('WebSocketManager', serv);

  /**@ngInject */
  function serv(WebSocket, authRolesConst, $q) {

    var _this = this;
    var token = '';
    _this.unregisterAllMethods = unregisterAllMethods;
    _this.registerWebSocketMethod = registerWebSocketMethod;
    _this.unregisterWebSocketMethod = unregisterWebSocketMethod;

    _this.killWebSocket = killWebSocket;
    _this.webSocketInit = webSocketInit;
    _this.getUserToken = getUserToken;

    _this.webSockedInitiated = false;
    _this.allowedForUser = false;

    var webSocketInitDefer = $q.defer();

    function CheckIfWebSocketReady() {
      return webSocketInitDefer.promise;
    }

    function webSocketInit(userName, userRole, partnerId, callCenterId, consultantId) {

      if (!_this.webSockedInitiated) {

        if (userName) {
          switch (userRole) {
            case authRolesConst.consultant:
              token = 'CCS.' + partnerId + '/' + callCenterId + '/' + consultantId;
              break;
            case authRolesConst.manager:
              token = 'CCS.' + partnerId + '/' + callCenterId;
              break;
            case authRolesConst.admin:
              token = 'CCS.' + partnerId;
              break;
          }
          bindToken(token, webSocketInitDefer);
          console.log(token + ' token binded!');

          // if( consultantId && consultantId!==-1 && userRole!==authRolesConst.consultant){
          //   var token2 = 'CCS.' + partnerId + '/' + callCenterId + '/' + consultantId;
          //   bindToken(token2, webSocketInitDefer);
          //   console.log(token2 + ' consultnat token binded!');
          // }


        } else {
          console.log('Użytkownik musi być zalogowany dopiero wtedy bindujemy websocket');
          webSocketInitDefer.reject();
        }
      } else {
        webSocketInitDefer.resolve();
      }

      return webSocketInitDefer.promise;

    };
    function getUserToken() {
      return token;
    }

    function bindToken(token, defer) {
      WebSocket.bind(token).then(function () {
        console.log('WebSocket binded: ' + token);
        _this.webSockedInitiated = true;
        defer.resolve(token);
      }, function (err) {
        defer.reject(err);
      });
    }

    // wywołanie w session manager
    function killWebSocket() {
      if (_this.webSockedInitiated) {
        //unregister all callback
        unregisterAllMethods();

        WebSocket.unbind();
        console.log('WebSocket unbind');
        _this.webSockedInitiated = false;
      }
    }

    function registerWebSocketMethod(token, callbackName, callback, regex) {
      CheckIfWebSocketReady().then(function (data) {
        if (_this.allowedForUser) {
          WebSocket.register(token, callbackName, callback, regex);
        } else {
          console.log('Przed rejestracj metody WebSocket należy przełczyć flage "allowedForUser"')
        }
      }, function (err) {
        console.log('Nie można zarejestrować callback: ' + callbackName + ' gdyż websoscket nie został zainicjowany')
      });
    }

    function unregisterWebSocketMethod(token,callbackName) {
      WebSocket.unregister(token,callbackName);
    }

    /// ---------------- implementatnions -------------


    function unregisterAllMethods() {
      WebSocket.unregisterALL();
      console.log('WebSocket unregister ALL methodes - done!');
    };
    //--------------- rejstracja metod WebSocket begin-------------

  }

})();

(function () {
  'use strict';

  angular
    .module('taapp')
    .service('confirmDialogService', Service);

  /**@ngInject */
  function Service(DynamicFactory, $mdDialog, $q, $translate) {
    var vm = this;



    vm.showRecDeleteConfirm = function (titleText) {
      return vm.showConfirm('confirmDelete', titleText, null);
    };

    vm.showDefaultConfirm = function (replaceContent, params) {
      var defer = $q.defer();

      var locals = {
        params: {},
        titleText: ''
      };

      if (params)
        locals.params = params;
      if (!replaceContent)
        replaceContent = [{
          token: 'translate',
          value: 'CONFIRM_DEFAULT'
        }];
      DynamicFactory.get('templatesRsc', 'getUniTemplate')('confirmDefault', replaceContent)
        .then(function (template) {
          return $mdDialog.show({
            controller: DialogController,
            locals: locals,
            template: template,
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: false // Only for -xs, -sm breakpoints.
          }).then(function (answer) {
            if (answer)
              defer.resolve(answer);
            else
              defer.resolve();
          }, function () {
            defer.reject();
          })
        }, function () {
          console.log('Dialog nie działa. Brak template: confirmDefault');
          defer.reject();
        });

      return defer.promise;
    }

    vm.showConfirm = function (templateName, titleText, params) {
      if (!titleText || titleText === '') {
        titleText = $translate.instant("CONFIR_DIALOG.DEFAULT_QUESTION");
      }

      var defer = $q.defer();

      var locals = {
        titleText: titleText
      }

      if (params) {
        // var keys = Object.keys(params);
        // for(var key in keys){
        //   if(keys[key])
        //     locals[keys[key]] = params[keys[key]];
        // }
        locals.params = params;
      } else {
        //!!! nie możemy przekazać niezdefiniowanych parametrow!!!
        locals.params = {};

      }

      DynamicFactory.get('templatesRsc', 'GetTemplate')(templateName)
        .then(function (template) {
          return $mdDialog.show({
            controller: DialogController,
            locals: locals,
            template: template,
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: false // Only for -xs, -sm breakpoints.
          }).then(function (answer) {
            if (answer)
              defer.resolve(answer);
            else
              defer.resolve();
          }, function () {
            defer.reject();
          })
        }, function () {
          console.log('Dialog nie działa. Brak template: ' + templateName);
          defer.reject();
        });

      return defer.promise;
    }

  }
  // params
  function DialogController($scope,$timeout, $mdDialog, titleText, params, DynamicFactory, templateData) {
    $scope.cancel = cancel;
    $scope.answer = answer;
    $scope.tagAutoSave = tagAutoSave;
    $scope.titleText = titleText;
    $scope.params = params;

    function cancel() {
      $mdDialog.cancel();
    }

    function answer(answer) {
      if (answer && $scope.tags){
        $mdDialog.hide({ answer: answer, tags: $scope.tags });
      }
      else if (answer && !$scope.tags){
        $mdDialog.hide(answer);
      }
      else{
        $mdDialog.hide();
      }
    }

    function tagAutoSave(tags){
      DynamicFactory.get('messageSessionRsc', 'addMessageSessionTags')(params.sessionId, tags).then(
				function (data) {
          params.forceReloadTags = false;
          $timeout(function () {
            params.forceReloadTags = true;
          }, 0);

				},
				function (err) {
					console.log(err);
				}
			);
    }
  }


})();

(function () {
    'use strict';

    angular
        .module('contactcenter.party')
        .service('partyService', Service);
    /** @ngInject */
    function Service($q, DynamicFactory, $translate, ngNotify, $state, SessionManager, $localStorage,toastService) {
        var vm = {};

        vm.loginToRoom = loginToRoom;
        vm.logOut = logOut;

        function loginToRoom(partyRoomID) {
            var user = SessionManager.getUser();
          if (!$localStorage.hostNumber){
            toastService.showToast($translate.instant('PARTY.CLIENTINFO.CALL_NO_CONS_PHONE'), 'error', 4);
            return
          };

            DynamicFactory.get('PartyRsc', 'login')({ phone1: 'freetdm/2/a/' + $localStorage.hostNumber, externalUserID: user.userId, externalUserName: user.username, partyRoomID: partyRoomID, externalUserAudioUrl: user.audioUrl })
                .then(function (result) {
                }, function (err) {
                });
        }
        function logOut(user, quiet) {
            if ($localStorage.dtNumber && $localStorage.dtNumber.length > 0 && $localStorage.partyRoomID && $localStorage.partyRoomID.length>0) {
                DynamicFactory.get('PartyRsc', 'logout')({ externalUserID: user.userId, partyRoomID: $localStorage.partyRoomID })
                    .then(function (result) {
                        $localStorage.partyRoomID = '';
                        $localStorage.dtNumber = '';
                        if (!quiet) {
                            changeNumber();
                        }
                        else{
                            changeNumber2();
                        }
                    }, function (err) {
                      $localStorage.partyRoomID = '';
                      $localStorage.dtNumber = '';
                        console.log(err);
                    });
            }
            else {
                $localStorage.partyRoomID = '';
            }
        }
        function changeNumber() {
            DynamicFactory.get('AuthResource', 'setPhoneDt')({ phone: 'freetdm/2/a/' + $localStorage.hostNumber }).then(function (result) {
                $state.go('app.contactcenter_party', {});
            });
        }
        function changeNumber2() {
            DynamicFactory.get('AuthResource', 'setPhoneDt')({ phone: 'freetdm/2/a/' + $localStorage.hostNumber }).then(function (result) {
            });
        }
        return vm;
    }
})();


(function () {
  'use strict';
  angular
    .module('contactcenter.party')
    .component('party', {
      templateUrl: 'app/main/contactcenter/party/party.html',
      controllerAs: 'vm',
      controller: PartyController
    });

  /** @ngInject */
  function PartyController($scope, $rootScope, $document, $mdDialog, $mdMedia, $mdSidenav, DynamicFactory, $q) {
    var vm = this;


    init();


    /**
     * Initialize
     */
    function init() {

    }


  }
})();

(function () {
  'use strict';
  angular
    .module('contactcenter.reports')
    .constant('wsstatus', {
      queued: 'QUEUED',
      ringing: 'RINGING',
      wait4drop: 'WAIT4DROP',
      answered: 'ANSWERED',
      disconnected: 'DISCONNECTED',
      disconnected_cons: 'DISCONNECTED_CONS', // rozmowe rozlaczyl konsultant
      redirected: 'REDIRECTED',
      waiting: 'WAITING',  // zalogował sie do party
      failed: 'FAILED',
      timeupdate: 'TIMEUPDATE' //w callback zmniejsza ilość minut do wkorzystnia
    });
})();

(function() {

    angular
        .module('contactcenter.reports')
        .filter('typeSms', typeSms)

        function typeSms() {
            return function(input) {
                if(!input) return '';

                input = input
                    .replace('S', '/assets/icons/reports/sms.png')
                    .replace('M', '/assets/icons/reports/mms.png')
                    .replace('C', '/assets/icons/reports/chat.png')

                return input
            }
        }

})();

(function() {
    'use strict';

    angular
        .module('contactcenter.reports')
        .filter('startFrom', startFrom)

        function startFrom() {
            return function(input, start) {
                input = input || '';
                start = start || '';

                start = parseInt(start);
                
                return input.slice(start);
           }
        }
})();
(function() {
    'use strict';

    angular
        .module('contactcenter.reports')
        .service('ShareData', ShareData);

        function ShareData() {
            return {
                search: ''
            }
        }
})();
(function () {
    'use strict';

    angular
        .module('contactcenter.reports')
        .config(langDatapicker);

    function langDatapicker($mdDateLocaleProvider) {
        $mdDateLocaleProvider.firstDayOfWeek = 1;
        $mdDateLocaleProvider.months = ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'];
        $mdDateLocaleProvider.shortMonths = ['stycz.', 'luty', 'mar.', 'kwiec.', 'maj', 'czerw.', 'lip.', 'sierp.', 'wrzes.', 'pazdz.', 'listop.', 'grudz.'];
        $mdDateLocaleProvider.days = ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'];
        $mdDateLocaleProvider.shortDays = ['nd', 'Pon', 'wt', 'śr', 'czw', 'pt', 'sob'];

        $mdDateLocaleProvider.formatDate = function (date) {
            var m = moment(date);
            return m.isValid() ? m.format('DD-MM-YYYY') : '';
        };

        $mdDateLocaleProvider.parseDate = function (date) {
            var m = moment(date, 'DD-MM-YYYY', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('contactcenter.reports')
        .filter('direction', direction)

        function direction() {
            return function(input) {
                if(!input) return ''
                // input = input || '';

            input = input
                .replace('O', 'right')
                .replace('I', 'left')

            return input;
            }
        }
})();
(function () {
'use strict';
  angular
    .module('contactcenter.reports')
    .filter('changeColor', color)

  function color() {
    return function (input) {
      if (input) {
        input = input
          .replace('O', '#f8ab59')
          .replace('I', '#26A69A')
      } else return '';

      return input;
    }
  }

})();

/**
 * Created by kosski on 08.09.2016.
 */
+function(){
  angular.module('smartFloat', [])
    .directive('smartFloat', function ($filter) {
      var FLOAT_REGEXP_1 = /^\$?\d+.(\d{3})*(\,\d*)$/; //Numbers like: 1.123,56
      var FLOAT_REGEXP_2 = /^\$?\d+,(\d{3})*(\.\d*)$/; //Numbers like: 1,123.56
      var FLOAT_REGEXP_3 = /^\$?\d+(\.\d*)?$/; //Numbers like: 1123.56
      var FLOAT_REGEXP_4 = /^\$?\d+(\,\d*)?$/; //Numbers like: 1123,56

      return {
        require: 'ngModel',
        link: function (scope, elm, attrs, ctrl) {
          ctrl.$parsers.unshift(function (viewValue) {
            if (FLOAT_REGEXP_1.test(viewValue)) {
              ctrl.$setValidity('float', true);
              return parseFloat(viewValue.replace('.', '').replace(',', '.'));
            } else if (FLOAT_REGEXP_2.test(viewValue)) {
              ctrl.$setValidity('float', true);
              return parseFloat(viewValue.replace(',', ''));
            } else if (FLOAT_REGEXP_3.test(viewValue)) {
              ctrl.$setValidity('float', true);
              return parseFloat(viewValue);
            } else if (FLOAT_REGEXP_4.test(viewValue)) {
              ctrl.$setValidity('float', true);
              return parseFloat(viewValue.replace(',', '.'));
            }else {
              ctrl.$setValidity('float', false);
              return undefined;
            }
          });

          ctrl.$formatters.unshift(
            function (modelValue) {
              return $filter('number')(parseFloat(modelValue) , 2);
            }
          );
        }
      };
    });
}();

/**
 * Created by kosski on 08.09.2016.
 */
(function () {
    'use strict';
    angular.module('passVerify', ['ngMessages'])
        .directive("passVerify", [function () {
            return {
                restrict: 'A',
                require: 'ngModel',
                scope: {
                    confrimPass: "=",
                    newPass: "=",
                    oldPass: "="
                },
                link: passVerify
            };
        }]);
    function passVerify(scope, element, attributes, ngModel) {
        var vm = this;

        vm.customValidator = function (ngModelValue) {
            // scope.invalid = vm.validate(ngModelValue);
            if (scope.confrimPass)
            {
                var check = ngModel.$viewValue && ngModel.$viewValue == scope.confrimPass;
                ngModel.$setValidity('confrim', check);
            }

            if (scope.newPass ){
                var check = sha512(ngModel.$viewValue) != scope.oldPass;
                ngModel.$setValidity('diffrentOld', check);
            }
            else
            {
                var check = sha512(ngModel.$viewValue) == scope.oldPass;
                ngModel.$setValidity('diffrentOld', check);
            }

            return ngModelValue;
        };

        ngModel.$parsers.push(vm.customValidator);

        // vm.validate = function (nrb) {

        // };

        scope.$watch(function () {
            return scope.confrimPass
        },
            function () {
                if (scope.confrimPass) {
                        vm.customValidator ();
                }
            });
    }
})();

/**
 * Created by kosski on 11.01.2017.
 */
(function () {
    'use strict';
    angular.module('onerrorsrc', [])
        .directive("onErrorSrc", ['$interval', function ($interval) {
            return {
                restrict: 'A',
                // require: 'ngSrc',
                link: function (scope, element, attrs) {
                    var vm = this;

                    element.bind('error', function () {
                        if (attrs.src != attrs.onErrorSrc) {
                            attrs.$set('src', attrs.onErrorSrc);
                        }
                    });

                    scope.$watch(function () {
                        return attrs.src
                    },
                        function () {
                            if (attrs.src == attrs.onErrorSrc) {
                                scope.interval = $interval(vm.imgReload, 2000);
                                // $timeout(vm.imgReload, 2000);
                            }
                        });

                    vm.imgReload = function () {
                        // attrs.ngSrc = scope.source;
                        if (attrs.src == attrs.onErrorSrc)
                            attrs.$set('src', scope.source);
                        else if (angular.isDefined(scope.interval)) {
                            $interval.cancel(scope.interval);
                            scope.interval = undefined;
                        }
                    };

                    scope.$watch(function () {
                        return attrs.ngSrc
                    },
                        function () {
                            if (attrs.ngSrc)
                                scope.source = attrs.ngSrc;
                            // if (attrs.ngSrc.indexOf("?cb=") == -1)
                        });
                }
            };
        }]);
})();

/**
 * Created by kosski on 08.09.2016.
 */
(function () {
  'use strict';
  angular.module('nipVerify',[])
    .directive("nipVerify", [function () {
      return {
        require: 'ngModel',
        restrict: 'A',
        // scope: {
        //   invalid: "="
        // },
        link: nipVerify
      };
    }]);
  function nipVerify(scope, element, attributes, ngModel) {
    var vm = this;

    vm.customValidator = function (ngModelValue) {

      scope.invalid = vm.validate(ngModelValue);
      ngModel.$setValidity('nipValidator', scope.invalid);

      return ngModelValue;
    };

    ngModel.$parsers.push(vm.customValidator);

    vm.validate = function (nip) {
      var nip_bez_kresek = nip.replace(/-/g, "");
      var reg = /^[0-9]{10}$/;
      if (reg.test(nip_bez_kresek) == false) {
        return false;
      }
      else {
        var dig = ("" + nip_bez_kresek).split("");
        var kontrola = (6 * parseInt(dig[0]) + 5 * parseInt(dig[1]) + 7 * parseInt(dig[2]) + 2 * parseInt(dig[3]) + 3 * parseInt(dig[4]) + 4 * parseInt(dig[5]) + 5 * parseInt(dig[6]) + 6 * parseInt(dig[7]) + 7 * parseInt(dig[8])) % 11;
        if (parseInt(dig[9]) == kontrola)
          return true;
        else
          return false;
      }

    };

  }
})();

/**
 * Created by kosski on 08.09.2016.
 */
(function () {
  'use strict';
  angular.module('ng-file-model', [])
    .directive("ngFileModel", [function () {
      return {
        restrict: 'EA',
        scope: {
          ngFileModel: "="
        },
        link: function (scope, element, attributes) {
          element.bind("change", function (changeEvent) {
            var reader = new FileReader();
            reader.onload = function (loadEvent) {
              scope.$apply(function () {
                scope.ngFileModel = {
                  lastModified: changeEvent.target.files[0].lastModified,
                  lastModifiedDate: changeEvent.target.files[0].lastModifiedDate,
                  name: changeEvent.target.files[0].name,
                  size: changeEvent.target.files[0].size,
                  type: changeEvent.target.files[0].type,
                  data: loadEvent.target.result,
                  fileStream: changeEvent.target.files[0]
                };
              });
            };
            reader.readAsDataURL(changeEvent.target.files[0]);
          });
        }
      };
    }]);
})();

(function () {
  'use strict';
  angular.module('imageonload', [])
    .directive('imageonload', ['$timeout', function ($timeout) {
      return {
        restrict: 'A',
        // require: '^ngSrc',
        link: function (scope, element, attrs) {
          scope.count = 0;
          scope.src = attrs.ngSrc;
          element.bind('load', function () {
            console.log('image is loaded');
          });
          element.bind('error', function () {
            $timeout(function () {
              attrs.src = attrs.ngSrc + '#' + scope.count++;
            }, 5000);
          });
        }
      };
    }]);
})();

/**
 * Created by kosski on 08.09.2016.
 */
+function(){
  angular.module('focusable', [])
    .directive('focusable', function($timeout) {
      return {
        restrict: 'A',
        scope: {
          focusable: '@'
        },
        link: function(scope, elm, attrs) {
          scope.$watch('focusable', function (value) {
            if (value) {
              // timout na 0 żeby nie było problemu z odświeżeniem
              $timeout(function () {
                elm[0].focus();
              });
            }
          });
        }
      };
    });
}();

/**
 * Created by kosski on 28.09.2018.
 */
+function(){

  angular.module('contenteditable',[]).directive('contenteditable', function() {
    return {
      require: 'ngModel',
      link: function(scope, elm, attrs, ctrl) {
        // view -> model
        elm.on('blur', function() {
          ctrl.$setViewValue(ctrl.$viewValue);
        });

        // model -> view
        ctrl.$render = function() {
          // elm.html(ctrl.$viewValue);
        };

        // load init value from DOM
        ctrl.$setViewValue(ctrl.$viewValue);
      }
    };
  });

}();


/**
 * Created by kradam on 28.08.2017.
 */
+function(){

  angular.module('chromeAutofillHack',[]).directive('chromeAutofillHack', function () {
    return {
      require: '^ngModel',
      restrict: 'A',
      priority: 500, // set higher priority then other custom directives
      link: function (scope, element, attrs, ngModelCtrl) {
        ngModelCtrl.$parsers.unshift(function (value) {

          if (!ngModelCtrl.$touched) {
            ngModelCtrl.$setViewValue('');// czyszcznie pola jeśli zmienna
            // ngModelCtrl.$setUntouched(); // to nie daje zamierzanego efektu i komunikat błedu jest nadal widoczny na stsarce formularza
            // ngModelCtrl.$setPristine(); // to nie daje zamierzanego efektu i komunikat błedu jest nadal widoczny na stsarce formularza
            ngModelCtrl.$render();
            console.log(ngModelCtrl);
          }
          return value;

        });
      }
    };
  });

}();


(function(angular){
  "use strict";
angular.module("bindHtmlCompile",[]).directive('bindHtmlCompile', ['$compile', function ($compile) {
        return {
            restrict: 'A',
            // scope:{'bindHtmlCompile':'=' },
            link: function (scope, element, attrs) {
                            // console.log('bindHtmlCompile loaded');
                scope.$watch(
                    // 'bindHtmlCompile'
                    function () {
                    return scope.$eval(attrs.bindHtmlCompile);

                }
                , function (value) {
                    if(value){
                        // In case value is a TrustedValueHolderType, sometimes it
                        // needs to be explicitly called into a string in order to
                        // get the HTML string.
                        console.log('bindHtmlCompile | complile begin');
                        element.html(value && value.toString());
                        // If scope is provided use it, otherwise use parent scope
                        var compileScope = scope;
                        if (attrs.bindHtmlScope) {
                            compileScope = scope.$eval(attrs.bindHtmlScope);
                        }
                        $compile(element.contents())(compileScope);
                    }
                });
            }
        };
    }]);
})(angular);

/**
 * Created by kosski on 08.09.2016.
 */
(function () {
  'use strict';
  angular.module('bankVerify', [])
    .directive("bankVerify", [function () {
      return {
        require: 'ngModel',
        restrict: 'A',
        scope: {
          bankName: "=",
          valid: "="
        },
        link: bankVerify
      };
    }]);
  function bankVerify(scope, element, attributes, ngModel) {
    var vm = this;
    vm.customValidator = function (ngModelValue) {
      if (vm.insideUpdate) vm.insideUpdate = false;
      else
        if (ngModelValue) {
          scope.valid = undefined;

          scope.valid = vm.validate(ngModelValue);
          ngModel.$setValidity('numberValidator', scope.valid);

          if (scope.valid) {
            vm.getbankname();
            var regex = /(\d{2})\s?(\d{4})\s?(\d{4})\s?(\d{4})\s?(\d{4})\s?(\d{4})\s?(\d{4})/
            ngModel.$setViewValue(ngModelValue.replace(regex, "$1 $2 $3 $4 $5 $6 $7"));
            ngModel.$render();
            vm.insideUpdate = true;
          } else
            scope.bankName = undefined;


        }

      return ngModelValue;
    };

    ngModel.$parsers.push(vm.customValidator);

    // scope.$watch(function () {
    //   return scope.valid
    // },
    //   function () {
    //     if (scope.valid)
    //       scope.bankName = undefined;
    //     else
    //       vm.getbankname();
    //   });

    vm.POLBanks = {
      101: { abbreviation: 'NBP', name: 'Narodowy Bank Polski' },
      102: { abbreviation: 'PKO', name: 'Powszechna Kasa Oszczęndności Bank Polski SA' },
      103: { abbreviation: 'BH', name: 'Bank Handlowy w Warszawie SA' },
      105: { abbreviation: 'INGBSK', name: 'ING Ban Śląski SA' },
      106: { abbreviation: 'BPH', name: 'Bank BPH SA' },
      109: { abbreviation: 'BZWBK', name: 'Bank Zachodni WBK SA' },
      113: { abbreviation: 'BGK', name: 'Bank Gospodarstwa Krajowego' },
      114: { abbreviation: 'BRE', name: 'BRE Bank SA' },
      116: { abbreviation: 'MIL', name: 'Bank Millennium SA' },
      122: { abbreviation: 'BHK', name: 'Bank Handlowo - Kredytowy SA' },
      124: { abbreviation: 'PEKAO', name: 'Bank Polska Kasa Opieki SA' },
      128: { abbreviation: 'HSBC', name: 'HSBC Bank Polska SA' },
      130: { abbreviation: 'MERITU', name: 'Meritum Bank ICB SA' },
      132: { abbreviation: 'BPSA', name: 'Bank Pocztowy SA' },
      144: { abbreviation: 'NORDEA', name: 'NORDEA BANK POLSKA SA' },
      147: { abbreviation: 'EBSA', name: 'Euro Bank SA' },
      154: { abbreviation: 'BOS', name: 'Bank Ochrony —rodowiska SA' },
      158: { abbreviation: 'MBBP', name: 'Mercedes-Benz Bank Polska SA' },
      160: { abbreviation: 'BNPPL', name: 'BNP PARIBAS BANK POLSKA SA' },
      161: { abbreviation: 'SGB-BA', name: 'SGB-Bank SA' },
      167: { abbreviation: 'RBSPL', name: 'RBS Bank (Polska) SA' },
      168: { abbreviation: 'IBSA', name: 'INVEST - BANK SA' },
      174: { abbreviation: 'DZPL', name: 'DZ BANK Polska SA' },
      175: { abbreviation: 'RAIFF', name: 'Raiffeisen Bank Polska SA' },
      184: { abbreviation: 'SG', name: 'Societe Generale SA Oddzłał w Polsce' },
      187: { abbreviation: 'PBP', name: 'Polski Bank Przebiorczości SA' },
      188: { abbreviation: 'DBP', name: 'Deutsche Bank Polska SA' },
      189: { abbreviation: 'PEKAOH', name: 'Pekao Bank Hipoteczny SA' },
      191: { abbreviation: 'DBPBC', name: 'Deutsche Bank PBC SA' },
      193: { abbreviation: 'BPSSA', name: 'BANK POLSKIEJ PÓDŁDZIELCZOŚCI SA' },
      194: { abbreviation: 'CABP', name: 'Credit Agricole Bank Polsk SA' },
      195: { abbreviation: 'IDEA', name: 'Idea Bak SA' },
      200: { abbreviation: 'RABO', name: 'Rabobank Polska SA' },
      203: { abbreviation: 'BGŻ', name: 'Bank Gospodrki Żywno˜ciowej' },
      207: { abbreviation: 'FORD', name: 'FCE Bank Polska SA' },
      212: { abbreviation: 'SCB', name: 'Santander Consumer Bank SA' },
      213: { abbreviation: 'VWBANK', name: 'VOLKSWAGEN BANK POLSKA SA' },
      214: { abbreviation: 'FIATBP', name: 'Fiat Bank Polska SA' },
      215: { abbreviation: 'RH-BRE', name: 'BRE Bank Hipoteczny SA' },
      216: { abbreviation: 'TBPSA', name: 'Toyota Bank Polska SA' },
      219: { abbreviation: 'NORDLB', name: 'Bank DnB NORD Polska SA' },
      221: { abbreviation: 'BTMP', name: 'Bank of Tokyo-Mitsubishi UFJ' },
      224: { abbreviation: 'BPFPL', name: 'Banque PSA Finance S' },
      225: { abbreviation: 'SHBPOL', name: 'Svenska Handelsbanken AB SA' },
      227: { abbreviation: 'SYGMA', name: 'Sygma Banque Societe Anonyme' },
      229: { abbreviation: 'BPI', name: 'BPI Bank Polskich Inwestycji' },
      230: { abbreviation: 'RBSNV', name: 'The Royal Ban Scoctland' },
      232: { abbreviation: 'NYKPL', name: 'Nykredit Realkredit A/S SA' },
      235: { abbreviation: 'BNPW', name: 'BNP PARIBAS SA Oddział w Plsce' },
      236: { abbreviation: 'DABAPO', name: 'Danske Bank A/S SA ' },
      237: { abbreviation: 'SEBPL', name: 'Skandinaviska Enskilda Banke' },
      238: { abbreviation: 'BMAIS', name: 'Banco Mais S.A' },
      239: { abbreviation: 'CAIXA', name: 'CAIXABANK, S.A' },
      240: { abbreviation: 'UNIBON', name: 'UNIBON-Sporitelni ' },
      241: { abbreviation: 'ELAVON', name: 'Elavon Financial Services' },
      243: { abbreviation: 'PARBPL', name: 'BNP Paribas Securities ' },
      245: { abbreviation: 'HBEUWA', name: 'HSBC Bank plc (SA) ' },
      247: { abbreviation: 'BESIPL', name: 'Banco Espirito Santo ' },
      248: { abbreviation: 'GNB', name: 'Getin Noble Bank SA' },
      249: { abbreviation: 'ALIOR', name: 'Alior Bank SA' },
      251: { abbreviation: 'AAREAL', name: 'Aareal Bank Aktiengesellschaft' },
      252: { abbreviation: 'CSPL', name: 'CREDIT SUISSE (LUXEMBOURG) ' },
      253: { abbreviation: 'FMBANK', name: 'FM Bank SA' },
      254: { abbreviation: 'CE PLC', name: 'Citibank Europe' },
      255: { abbreviation: 'IKANO', name: 'Ikano Bank GmbH (Sp. z o.o.)' },
      256: { abbreviation: 'NORDAB', name: 'Nordea Bank AB SA ' },
      257: { abbreviation: 'UBSL', name: 'UBS Limited' },
      258: { abbreviation: 'JPMEL', name: 'J.P. Morgan Europe Limited' },
      259: { abbreviation: 'ZUNOPL', name: 'ZUNO BANK AG SA ' },
      260: { abbreviation: 'BOCPL', name: 'Bank of China (Luxembourg)' },
      261: { abbreviation: 'VBLPL', name: 'Vanquis Bank Limitd' },
      262: { abbreviation: 'ICBCPL', name: 'Industrial and Commercial Ba' },
      263: { abbreviation: 'SAXOPL', name: 'Saxo Bank A/S' },
      264: { abbreviation: 'RCIOPL', name: 'RCI Banque ' },
      265: { abbreviation: 'EUROCL', name: 'EUROCLEAR Bank SA/NV' },
      266: { abbreviation: 'ISPBA', name: 'Intesa Sanpaolo S.p.A' }
    };
    vm.validate = function (nrb) {
      nrb = nrb.replace(/[^0-9]+/g, '');
      var Wagi = new Array(1, 10, 3, 30, 9, 90, 27, 76, 81, 34, 49, 5, 50, 15, 53, 45, 62, 38, 89, 17,
        73, 51, 25, 56, 75, 71, 31, 19, 93, 57);

      if (nrb.length == 26) {
        nrb = nrb + "2521";
        nrb = nrb.substr(2) + nrb.substr(0, 2);
        var Z = 0;
        for (var i = 0; i < 30; i++) {
          Z += nrb[29 - i] * Wagi[i];
        }
        if (Z % 97 == 1) {
          return true;
        } else {
          return false;
        }

      } else {
        return false;
      }
    };
    vm.getbankname = function () {
      if (ngModel.$viewValue) {
        var nrb = ngModel.$viewValue.replace(/[^0-9]+/g, '');
        var bankId = nrb.substring(2, 5);
        scope.bankName = undefined;
        for (var value in vm.POLBanks)
          if (value = bankId) {
            scope.bankName = vm.POLBanks[bankId].name;
            break;
          }
      }
    }
  }
})();

/**
 * Created by akraszewski on 2017-05-26.
 */
(function () {
  'use strict';
  angular.module('contactcenter.orderbox')
    .service('OrderboxGlue', OrderboxGlue);

  function OrderboxGlue(DynamicFactory, $q, $rootScope, $state, orderboxGlueConsts, MaillistFilters) {

    var _this = this;

    _this.closeThread = closeThread;
    _this.openThread = openThread;

    _this.cleanMailTitlesData = cleanMailTitlesData;
    _this.setCurrentFilterView = setCurrentFilterView;

    _this.changeView = changeView;
    _this.setMaxMailboxPages = setMaxMailboxPages;

    _this.getFolder = getFolder;
    _this.reloadCurrentFolder = reloadCurrentFolder;
    _this.getThreadData = getThreadData;

    onInit();

    function onInit() {
      _this.myMailAddress = 'pudzianmariush@onet.pl'; //???
      _this.myMailName = 'Adam Wroz (Pudzian Marush)';

      _this.currentFilter = {
        mailBoxId: undefined,
        type: undefined, //
        filter: undefined
      };
      _this.currentMailBox = undefined;
      _this.currentMailBoxFolder = undefined;
      _this.currentThread = undefined; //wymagane do przełaczania widokow classic/outlook
      _this.currentService = undefined;
      _this.currentPage = 0;
      _this.totalMailboxCount = 0;
      _this.loadingThreads = true;
      _this.threads = []; //wymagane do przełaczania widokow classic/outlook

      _this.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];
      _this.maintripleviewServiceListLoaded = false;


      _this.defaultView = undefined;
      _this.currentView = undefined;


      //widok domyślny
      _this.defaultView = orderboxGlueConsts.orderBoxViewMode.outlook;
      _this.currentView = orderboxGlueConsts.orderBoxViewMode.outlook;
      _this.outlookViewOnFire = true;
      _this.classicViewOnFire = undefined;
      _this.complitedCallback = true;

      _this.someMailsAreSelected = false;
    }

    function openThread(thread) {
      _this.currentThread = thread;

      // Update the state without reloading the controller
      $state.go('app.contactcenter_orderbox.threads.thread', {
        threadId: thread.id
      }, {
        notify: false
      });
    }

    function closeThread() {
      _this.currentThread = null;

      // Update the state without reloading the controller
      $state.go('app.contactcenter_orderbox.threads', {
        mailBoxId: _this.currentFilter.mailBoxId,
        type: _this.currentFilter.type,
        filter: _this.currentFilter.filter
      }, {
        notify: false
      });
    }

    function cleanMailTitlesData() {
      _this.threads = [];
      _this.currentThread = undefined;
      _this.currentPage = 0;
      _this.totalMailboxCount = 0;

      _this.currentFilter = {};//???
    }

    function setMaxMailboxPages(messagesCount) {
      if (messagesCount)
        _this.totalMailboxPages = messagesCount % 10 > 0 ? Math.floor(messagesCount / 10) + 1 : Math.floor(messagesCount / 10);
      else
        _this.totalMailboxPages = 1;
    }

    function setCurrentFilterView(mailBoxId, type, name) {


      // Hide loader
      $rootScope.loadingProgress = false;

      //   // Hide the loading screen
      _this.loadingThreads = false;

      //Jeśli ładowanie folderw email zostało przerwane przejściem na inn strone to przerwij zmiane statusu
      if ($state.current.name.indexOf('app.contactcenter_orderbox') === -1) {
        cleanMailTitlesData();
        return;
      }
      // OrderboxGlue.currentFilter.type

      // Set the current filter
      _this.currentFilter = {
        mailBoxId: mailBoxId,
        type: type,
        filter: name
      };


      // Close the current thread if open
      if (_this.currentThread) {
        _this.closeThread();
      }

      $state.go('app.contactcenter_orderbox.threads', {
        mailBoxId: mailBoxId,
        type: type,
        filter: name
      }, {
        notify: false
      });

    }


    function changeView(view) {
      _this.defaultView = view;
      _this.currentView = view;

      if (_this.currentView === orderboxGlueConsts.orderBoxViewMode.classic) {
        _this.classicViewOnFire = true;
        _this.outlookViewOnFire = false;
      } else if (_this.currentView === orderboxGlueConsts.orderBoxViewMode.outlook) {
        _this.classicViewOnFire = false;
        _this.outlookViewOnFire = true;
      }

    }


    // OrderboxGlue.getFolder('getFolder', {
    //   type: OrderboxGlue.currentFilter.type,
    //   folderName: OrderboxGlue.currentMailBoxFolder,
    //   status: status,
    //   page: vm.OrderboxGlue.currentPage
    // });

    function getFolder(event, eventData) {
      $rootScope.loadingProgress = true;
      _this.loadingProgress = true;
      loadFolderTitlesData(eventData.mailBoxId, eventData.type, eventData.folderName, eventData.page).then(function (data) {
        console.log('eventData', eventData);
        if (orderboxGlueConsts.callbackFolderType === eventData.type) {
          _this.setMaxMailboxPages(data.count);
          angular.forEach(data.list, function (ee) {
            if (ee.extraParams) {
              ee.extraParams = JSON.parse(ee.extraParams);
            }
          });
          _this.threads = data.list;
        } else {
          _this.threads = data;
        }

        if (_this.threads && _this.threads.length > 0) {
          openThread(_this.threads[0]);
          getThreadData(null, {
            mailBoxId: _this.threads[0].mailBoxID,
            folderName: _this.threads[0].folderName,
            mailId: _this.threads[0].id
          });
        }

        $rootScope.loadingProgress = false;
        _this.loadingProgress = false;
        _this.setCurrentFilterView(eventData.mailBoxId, eventData.type, eventData.folderName);
        groupByPaiment();
        // console.log('Ladowanie listy emaili skrzynki pocztowej o id:' + eventData.mailBoxId + ' typ folderu: ' + eventData.type + ' i nazwa folderu: ' + eventData.folderName + ' powiodlo sie');
      }, function (err) {
        console.log('Ladowanie listy emaili skrzynki pocztowej o id:' + eventData.mailBoxId + ' typ folderu: ' + eventData.type + ' i nazwa folderu: ' + eventData.folderName + ' nie powiodlo sie: ' + err);
        _this.loadingProgress = false;
      });
    }

    function groupByPaiment() {
      _this.groupThreads = _(_this.threads)
        .groupBy('status')
        .map(function (value, key) {
          console.log(value);
          return {
            status: key,
            buyerEmail: value.buyerEmail,
            id: value.id,
            seen: value.seen
          }
        }).value();
    }

    function reloadCurrentFolder(){
      _this.currentFilter.folderName = _this.currentFilter.folderName || _this.currentFilter.filter;
      getFolder('getFolder',_this.currentFilter);
    }

    function loadFolderTitlesData(mailBoxId, type, folderName, page) {
      // if (deferList) {
      //   deferList.resolve();
      // }
      var deferList = $q.defer();
      cancelLastLoading(deferList);

      if (!page) {
        page = 0;
      }
      _this.currentPage = page;

      var callParams = {};
      var callName = '';
      var callCallback = undefined;

      switch (type) {
        default:
        case orderboxGlueConsts.mailFolderType:
          callName = 'getMailsTitles';
          callParams = {
            mailBoxId: mailBoxId,
            folderName: folderName,
            // page: page
            start: getPageStart(page),
            stop: getPageStop(page),
            querryString: MaillistFilters.generateQuerryString(),
            searchString: MaillistFilters.searchString
          }
          callCallback = function (data) {
            angular.forEach(data, function (elem) {
              if (elem.from) {
                if (elem.from.length > 0) {
                  elem.from = elem.from[0];
                }
              }
            });
            return data;
          }
          break;
        case orderboxGlueConsts.callbackFolderType:

          var assignedValue;
          switch (folderName) {
            case 'assignedlistTrue':
              callName = 'callbackForServiceAssignList';
              assignedValue = true;
              break;
            case 'assignedlistFalse':
              callName = 'callbackForServiceAssignList';
              assignedValue = false;
              break;
            case 'callbackListDone':
              callName = 'callbackListDone';
              break;
            default:
              callName = 'callbackForServiceList';
              break
          }


          callParams = {
            folderName: folderName,
            // page: page
            start: getPageStart(page),
            stop: getPageStop(page),
            querryString: MaillistFilters.generateQuerryString(),
            searchString: MaillistFilters.searchString,
            complitedCallback: _this.complitedCallback,
            assigned: assignedValue
          }
          break;
        case orderboxGlueConsts.serviceFolderType:
          callName = 'mailSessionsForServiceList';
          callParams = {
            folderName: folderName,
            // page: page,
            start: getPageStart(page),
            stop: getPageStop(page),
          }
          break;
        case orderboxGlueConsts.flagFolderType:
          // todo
          break;
      }

      callForFolder(callName, callParams, deferList, callCallback);

      return deferList.promise;
    }

    // function sortEmails(data) {
    //   //console.log(MaillistFilters);
    //   var aa = MaillistFilters.filtersArray[0].data;
    //   if(aa) {
    //     var sortOrder = 'asc';//, 'desc'
    //     angular.forEach(data, function (e) {
    //       e.idOrder = e.id * 1;
    //     });
    //     data = _.orderBy(data, ['idOrder'], ['asc']);
    //   }
    //   return data;
    // }

    function cancelLastLoading(newPromise) {
      if (_this.lastPromise) {
        if (_this.lastPromise.promise.$$state.status === 0) {
          _this.lastPromise.reject();
        }
      }
      _this.lastPromise = newPromise;
      return newPromise;
    }


    function getPageStart(page) {
      //W API indexujemy od zera
      // return page === 0 ? 0 : (page * 10) ;
      return (page * 10);
    }

    function getPageStop(page) {
      return getPageStart(page) + 10 - 1;
    }

    function callForFolder(callName, params, resolver, callback) {
      DynamicFactory.get('OrderBoxRsc', callName)(params).then(function (data) {
        if (resolver.promise.$$state.status !== 2) {
          _this.currentMailBoxFolder = params.folderName;
          if (callback) {
            data = callback(data);
          }
          //sortowanie na liście maillist.html

          resolver.resolve(data);
        }
      }, function (err) {
        resolver.reject(err);
      });
    }

    function getThreadData(event, eventData) {

      $rootScope.loadingProgress = true;
      if (eventData.mailBoxId && eventData.folderName) {
        _this.loadingProgress = true;
      } else {
        //callbackw nie trzeba �adowac
        _this.loadingProgress = false;
        $rootScope.loadingProgress = false;
      }

      loadThreadData(eventData.mailBoxId, eventData.folderName, eventData.mailId).then(function (data) {
        // var newCurrentThread = _.merge(vm.OrderboxGlue.currentThread,data);
        console.log('merge CurrentThread', _this.currentThread.id == data.id);
        if (_this.currentThread.id == data.id) {
          _this.currentThread = _.merge(_this.currentThread, data);
        } else {
          _this.currentThread = data;
        }

        if (_this.currentThread.from) {
          if (_this.currentThread.from.length > 0) {
            _this.currentThread.from = _this.currentThread.from[0];
          }
        }
        _this.currentThread.read = true;

        _this.loadingProgress = false;
        $rootScope.loadingProgress = false;
      }, function (err) {
        _this.loadingProgress = false;
        $rootScope.loadingProgress = false;
        if (err && err.status === 404) {
          _this.currentThread.emailMovedOrDel = true;
        }
      });
    }

    function loadThreadData(mailBoxId, folderName, mailId) {

      var deferDetails = $q.defer();
      cancelLastLoading(deferDetails);
      if (mailBoxId && folderName && mailId)
        DynamicFactory.get('OrderBoxRsc', 'getMailMessage')(mailBoxId, folderName, mailId).then(function (data) {
          if (deferDetails.promise.$$state.status !== 2)
            deferDetails.resolve(data);
        }, function (err) {
          deferDetails.reject(err);
        });
      return deferDetails.promise;
    }

    function cancelLastLoading(newPromise) {
      if (_this.lastPromise) {
        if (_this.lastPromise.promise.$$state.status === 0) {
          _this.lastPromise.reject();
        }
      }
      _this.lastPromise = newPromise;
      return newPromise;
    }

    return _this;
  }
})();

(function () {
  'use strict';
  angular.module('contactcenter.orderbox').constant('orderboxGlueConsts', {

    mailFolderType: 'mailfolder',
    serviceFolderType: 'servicefolder',
    flagFolderType: 'flag',
    logicFolderType: 'logicfolder',
    labelFolderType: 'labelfolder',
    callbackFolderType: 'callbackFolderType',


    mailSessions: 'mailsessions',
    callbackSessions: 'callbacksessions',


    messageType: {
      email: "email",
      call: "call"
    },

    orderBoxViewMode: {
      outlook: 'outlook',
      classic: 'classic'
    }

  });
})();

/**
 * Created by akraszewski on 2017-05-26.
 */
(function () {
  'use strict';
  angular
    .module('contactcenter.orderbox')
    .component('orderbox', {
      templateUrl: 'app/main/contactcenter/orderbox/orderbox.html',
      controllerAs: 'vm',
      controller: OrderBoxController
    });

  /** @ngInject */
  function OrderBoxController($scope, $rootScope, $document, $mdDialog, $mdMedia, $mdSidenav, OrderboxGlue, orderboxGlueConsts, DynamicFactory, $q, tripleviewService) {
    var vm = this;
    var deferList;
    var deferDetails;

    vm.toggleSidenav = toggleSidenav;


    init();


    /**
     * Initialize
     */
    function init() {

      vm.orderboxGlueConsts = orderboxGlueConsts;
      vm.OrderboxGlue = OrderboxGlue;

      //reset danych
      OrderboxGlue.cleanMailTitlesData();

      vm.selectedThreads = [];

      vm.isSelected = OrderboxGlue.isSelected;
      tripleviewService.sidenavData.orderboxGlue = vm.OrderboxGlue;
      tripleviewService.sidenavData.class = 'orderbox-sidenav p200';
      $scope.$on('getThreadData', getThreadData);
    }

    function groupByPaiment() {
      vm.groupThreads = _(vm.threads)
        .groupBy('status')
        .map(function (value, key) {
          console.log(value);
          return {
            status: key,
            buyerEmail: value.buyerEmail,
            id: value.id,
            seen: value.seen
          }
        }).value();
    }

    function getFolder(event, eventData) {
      vm.OrderboxGlue.getFolder(event, eventData);

    }

    function getThreadData(event, eventData) {

      $rootScope.loadingProgress = true;
      if (eventData.mailBoxId && eventData.folderName) {
        vm.OrderboxGlue.loadingProgress = true;
      }
      else {
        //callbackw nie trzeba �adowac
        vm.OrderboxGlue.loadingProgress = false;
        $rootScope.loadingProgress = false;
      }

      loadThreadData(eventData.mailBoxId, eventData.folderName, eventData.mailId).then(function (data) {
        // var newCurrentThread = _.merge(vm.OrderboxGlue.currentThread,data);
        console.log('merge CurrentThread', vm.OrderboxGlue.currentThread.id == data.id);
        if (vm.OrderboxGlue.currentThread.id == data.id) {
          vm.OrderboxGlue.currentThread = _.merge(vm.OrderboxGlue.currentThread, data);
        } else {
          vm.OrderboxGlue.currentThread = data;
        }

        if (vm.OrderboxGlue.currentThread.from) {
          if (vm.OrderboxGlue.currentThread.from.length > 0) {
            vm.OrderboxGlue.currentThread.from = vm.OrderboxGlue.currentThread.from[0];
          }
        }
        vm.OrderboxGlue.currentThread.read = true;

        vm.OrderboxGlue.loadingProgress = false;
        $rootScope.loadingProgress = false;
      }, function (err) {
        vm.OrderboxGlue.loadingProgress = false;
        $rootScope.loadingProgress = false;
        if (err.status === 404) {
          vm.currentThread.emailMovedOrDel = true;
        }
      });
    }

    function loadThreadData(mailBoxId, folderName, mailId) {

      var deferDetails = $q.defer();
      cancelLastLoading(deferDetails);
      if (mailBoxId && folderName && mailId)
        DynamicFactory.get('OrderBoxRsc', 'getMailMessage')(mailBoxId, folderName, mailId).then(function (data) {
          if (deferDetails.promise.$$state.status !== 2)
            deferDetails.resolve(data);
        }, function (err) {
          deferDetails.reject(err);
        });
      return deferDetails.promise;
    }

    function cancelLastLoading(newPromise) {
      if (vm.lastPromise) {
        if (vm.lastPromise.promise.$$state.status === 0)
          vm.lastPromise.reject();
      }
      vm.lastPromise = newPromise;
      return newPromise;
    }

    // Watch screen size to change view modes
    $scope.$watch(function () {
      return $mdMedia('xs');
    }, function (current, old) {
      if (angular.equals(current, old)) {
        return;
      }

      if (current) {
        vm.OrderboxGlue.currentView = vm.orderboxGlueConsts.orderBoxViewMode.classic
      }
    });

    $scope.$watch(function () {
      return $mdMedia('gt-xs');
    }, function (current, old) {
      if (angular.equals(current, old)) {
        return;
      }

      if (current) {
        if (vm.OrderboxGlue.defaultView === vm.orderboxGlueConsts.orderBoxViewMode.outlook) {
          vm.OrderboxGlue.currentView = vm.orderboxGlueConsts.orderBoxViewMode.outlook;
        }
      }
    });


    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }


  }
})();

/**
 * Created by akraszewski on 2016-12-22.
 */
(function (angular) {
  'use strict';
  angular.module('contactcenter.communicator').service('templateData', function () {

    // var templateData = function (type,callerSource) {
    var vm = this;
    vm.setDefaltChatSetup = setDefaltChatSetup;
    // vm.created = true;
    // vm.communictorType = type; // communicator/caller
    // vm.callerSource = callerSource;

    // part communication parameters

    vm.msisdn = undefined;
    vm.portalUserId = undefined;
    vm.currentServiceId = undefined;
    vm.currentServicePrefixId = undefined;
    vm.sessionId = undefined;
    vm.callid = undefined;
    vm.contact = undefined;
    vm.contactMapAddress = undefined;
    vm.smsServiceId = undefined;
    vm.ivrServiceId = undefined;
    vm.chatServiceId = undefined;
    vm.facebookServiceId = undefined;
    vm.emailServiceId = undefined;
    vm.callbackServiceId = undefined;
    vm.serviceOrderId = undefined;
    vm.serviceCommunicationParams = undefined;
    vm.sessionHistory = undefined;
    vm.sessionType = undefined;//active/hist
    vm.sessionServiceType = undefined;//S/C/I/V/F
    vm.sessionReservedDate = undefined;
    vm.reservedNumber = undefined;
    vm.finished = undefined;
    vm.serviceId = undefined;
    vm.messageSessionId = undefined;
    vm.tags=undefined;
    vm.forceReloadTags=undefined;


    function setDefaltChatSetup() {
      vm.colorMain = 'md-red-A700-bg';
      vm.colorSecondary = 'md-grey-600-bg';

      //1.	
      // vm.colorMain = 'md-red-800-bg';
      // vm.colorSecondary = 'md-red-A100-bg';
      //2.	
      // vm.colorMain = 'md-deep-purple-600-bg';
      // vm.colorSecondary = 'md-deep-purple-100-bg';
      //3.	
      // vm.colorMain = 'md-pink-600-bg';
      // vm.colorSecondary = 'md-pink-200-bg';
      //4.	
      // vm.colorMain = 'md-blue-500-bg';
      // vm.colorSecondary = 'md-blue-A100-bg';
      //5.	
      // vm.colorMain = 'md-green-600-bg';
      // vm.colorSecondary = 'md-green-100-bg';

      vm.chatBackgroundURL = 'assets/images/communicator/chat_tlo_ero.jpg';
    }

    // vm.$onInit=function () {
    //   setDefaltChatSetup();
    // };


    vm.clearData = function () {
      // AK 2018.07.17 na razie komentujemy
      // vm.communictorType = type; // communicator/caller
      // vm.callerSource = callerSource;
      vm.created = true;

      vm.msisdn = undefined;
      vm.portalUserId = undefined;
      vm.currentServiceId = undefined;
      vm.currentServicePrefixId = undefined;
      vm.sessionId = undefined;
      vm.callid = undefined;
      vm.contactId = undefined;
      vm.contactMapAddress = undefined;
      vm.smsServiceId = undefined;
      vm.ivrServiceId = undefined;
      vm.chatServiceId = undefined;
      vm.emailServiceId = undefined;
      vm.facebookServiceId = undefined;
      vm.callbackServiceId = undefined;
      vm.serviceOrderId = undefined;
      vm.serviceCommunicationParams = undefined;
      vm.sessionHistory = undefined;
      vm.sessionType = undefined;//active/hist
      vm.sessionServiceType = undefined;//S/C/I/V/F
      vm.sessionReservedDate = undefined;
      vm.reservedNumber = undefined;
      vm.finished = undefined;
      vm.serviceId = undefined;
      vm.messageSessionId = undefined;
      vm.tags=undefined;
      vm.forceReloadTags=undefined;

    };

    //onInit
    setDefaltChatSetup();

    return vm;
    // };

    // return templateData;
  });

}(window.angular));



(function () {
  'use strict';

  angular
    .module('contactcenter.communicator')
    .service('internalMessageService', Service);

  /** @ngInject */
  function Service($q, DynamicFactory, templateData, $state, WebSocketManager, SessionManager, MenuManager, $sessionStorage, toastService, $translate, AuthService) {
    var vm = {};
    vm.init = init;
    vm.getList = getList;
    vm.setSession = setSession;
    vm.loadChat = loadChat;
    vm.onRunChat = onRunChat;
    vm.onRunInfo = onRunInfo;
    vm.onNewMessage = onNewMessage;
    vm.onUpdateObjectList = onUpdateObjectList;
    vm.onUpdateInternalList = onUpdateInternalList;
    vm.clearSession = clearSession;
    vm.objectListAdd = objectListAdd;

    vm.serviceInit = false;
    vm.objectList = undefined;
    vm.chatData = undefined;
    vm.selectedObject = undefined;
    vm.search = undefined;
    vm.toastActive = false;

    function init() {
      vm.commMenu = MenuManager.findMenuItem('COMMUNICATOR');
      if (AuthService.userData() && !vm.serviceInit) {
        vm.internalActive = (SessionManager.getUserRole() === 'consultant' || SessionManager.getUserRole() === 'manager');
        if (vm.internalActive) {
          console.log('internalMessageService init');

          if ($sessionStorage.internalChatObject && $state.current.name === 'app.contactcenter_internalmessage') {
            setSession($sessionStorage.internalChatObject);
          }
          vm.getList();

          WebSocketManager.registerWebSocketMethod(
            'ChatInternal',
            'chatArrive',
            wsCallsChatArrive,
            SessionManager.buildRegexForManagerAndConsExtended()
          );

          if(SessionManager.getUserRole() === 'manager'){
            WebSocketManager.registerWebSocketMethod(
              'ChatInternal',
              'chatArrive',
              wsCallsChatArrive,
              SessionManager.buildRegexForManager()
            );
          }

          vm.serviceInit = true;
        }
      }
    }


    function onRunChat(func) {
      if (func) {
        vm.runChat = func;
      }
    }

    function onRunInfo(func) {
      if (func) {
        vm.runInfo = func;
      }
    }

    function onNewMessage(func) {
      if (func) {
        vm.newMessage = func;
      }
    }

    function onUpdateObjectList(func) {
      if (func) {
        vm.updateObjectList = func;
      }
    }

    function onUpdateInternalList(func) {
      if (func) {
        vm.updateInternalList = func;
      }
    }

    function getList() {
      DynamicFactory.get('InternalMessageRsc', 'GetObjectList')().then(function (data) {
        var newObjects = _.filter(vm.objectList, function (x) {
          return x.isNew === true;
        });
        vm.objectList = data;
        
        //read from old list
        if (newObjects) {
          for (var i = 0; i < newObjects.length; i++) {
            var newObject = newObjects[i];
            var foundObject = _.find(vm.objectList,function(x){
              return x.id === newObject.id;
            });
            if(foundObject){
              foundObject.isNew = newObject.isNew;
            }
          }
        }
        //read from old list
      }, function (err) {});
    }

    function setSession(data) {
      data.isNew = false;
      $sessionStorage.internalChatObject = data;
      vm.chatData = undefined;
      vm.selectedObject = data;
      vm.commMenu.showAlert = undefined;
      loadChat();
    }

    function loadChat() {
      DynamicFactory.get('InternalMessageRsc', 'List')(vm.selectedObject.destination, vm.selectedObject.source).then(function (data) {
        vm.chatData = data;
        if ($state.current.name !== 'app.contactcenter_internalmessage') {
          if (vm.updateInternalList) {
            vm.updateInternalList();
          }
          $state.go('app.contactcenter_internalmessage');
        } else {
          vm.runChat();
          vm.runInfo();
          vm.updateInternalList();
        }
      }, function (err) {});
    }

    function wsCallsChatArrive(data) {
      vm.data = JSON.parse(data.Content);

      var session = _.find(vm.objectList, function (el) {
        return el.id === (vm.data.Type === 'G' ? vm.data.Destination : vm.data.Source);
      });
      if (session) {
        session.isNew = false;
      }
      if (vm.selectedObject &&
        ((vm.data.Source === vm.selectedObject.destination && vm.data.Type !== 'G') ||
          (vm.data.Destination === vm.selectedObject.destination && vm.data.Type === 'G')
        )) {
        var msg = {
          destination: vm.data.Destination,
          source: vm.data.Source,
          body: vm.data.Body,
          authorName: vm.data.AuthorName,
          authorPhotoUrl: vm.data.AuthorPhotoUrl,
          direction: 'I'
        };
        //nie pokazywac wiadomosci autora takiego samego jak zalogowany
        //|| SessionManager.getUserRole() === 'consultant')
        if (vm.data.Author !== SessionManager.getUser().userId) {
          vm.newMessage(msg);
        }
      } else {
        session.isNew = true;
        vm.commMenu.showAlert = '/assets/icons/warning.png';
        if (!vm.toastActive) {
          vm.toastActive = true;
          toastService.showToastAction($translate.instant('COMMUNICATOR.INTERNAL_CHAT.MESSAGE_FROM') + ' ' + vm.data.AuthorName + ': ' + vm.data.Body.substring(0, 15) + '...', 'message', 10, $translate.instant('COMMUNICATOR.INTERNAL_CHAT.OPEN')).then(function (response) {
            vm.toastActive = false;
            if (response === 'ok') {
              vm.setSession(session);
            }
          });
        }
      }
      if (vm.updateObjectList) {
        vm.updateObjectList(session);
      }
      if (vm.updateInternalList) {
        vm.updateInternalList();
      }
    }

    function clearSession() {
      $sessionStorage.internalChatObject = undefined;
      vm.chatData = undefined;
      vm.selectedObject = undefined;
      vm.serviceInit = false;
    }

    function objectListAdd(message) {
      vm.updateObjectList(message);
    }

    init();

    return vm;
  }
})();

/**
 * Created by akraszewski on 2016-12-22.
 */
(function (angular) {
  "use strict";
  angular.module('contactcenter.communicator').service("communicatorConfig",  serv);

  /** @ngInject */
  function serv($sessionStorage, DynamicFactory, $q) {
    var vm = this;
    vm.onChangeConfig = onChangeConfig;

    //PartPlacement zawiera ustawienia dla poszczegolnych obszarow: area[kolumna,wiersz]: wybrany part
    //service-part- kampania/serwis
    //notes-part- notatki
    //chat-part- Chat
    //client-part- Klient
    //map-part- Mapa

    function initFields() {
      vm.communicator = {
        PartPlacement: undefined,//{area00: "notes-part-", area10: "chat-part", area20: "", area01: "", area11: ""…}
        TemplateID: undefined,
        TemplateName: undefined,
        AllowedParts: undefined,
      };

    }

    vm.$onInit = function () {
      initFields();
    };


    vm.loadData = function () {
      var defer = $q.defer();

      initFields();

      if (!$sessionStorage.communicatorCofig) {

        DynamicFactory.get('CommunicatorConfigRsc', 'getCommunicatorConfig')().then(function (data) {

          var config = {
            communicator: {
              // PartPlacement: undefined,
              // TemplateID: undefined,
              // TemplateName: undefined,
              // AllowedParts: undefined,
            }
          };

          angular.forEach(data, function (e) {
              config.communicator.PartPlacement = JSON.parse(e.configurationJSON);
              config.communicator.TemplateID = e.templateID;
              config.communicator.TemplateName = e.name;
          });


          DynamicFactory.get('CommunicatorConfigRsc','getCommunicatorAllowedParts')().then(function (data) {

            config.communicator.AllowedParts = [];

            angular.forEach(data, function (e) {
              if (e.allowedForCommunicator === true) {
                config.communicator.AllowedParts.push(e);
              }
            });

            addButtonTag(config.communicator.AllowedParts);

            $sessionStorage.communicatorCofig = config;

            vm.communicator.PartPlacement = $sessionStorage.communicatorCofig.communicator.PartPlacement;
            vm.communicator.TemplateID = $sessionStorage.communicatorCofig.communicator.TemplateID;
            vm.communicator.TemplateName = $sessionStorage.communicatorCofig.communicator.TemplateName;
            vm.communicator.AllowedParts = $sessionStorage.communicatorCofig.communicator.AllowedParts;


            defer.resolve();

          }, function (err) {
            defer.reject(err);
          });
        }, function (err) {
          defer.reject(err);
        });
      }
      else {
        vm.communicator.PartPlacement = $sessionStorage.communicatorCofig.communicator.PartPlacement;
        vm.communicator.TemplateID = $sessionStorage.communicatorCofig.communicator.TemplateID;
        vm.communicator.TemplateName = $sessionStorage.communicatorCofig.communicator.TemplateName;
        vm.communicator.AllowedParts = $sessionStorage.communicatorCofig.communicator.AllowedParts;


        defer.resolve();
      }
      return defer.promise;
    };

    function addButtonTag(list) {
      angular.forEach(list, function (e) {

        // var markup = '<md-button  ng-class="vm.getCssClass(\'' + e.name + '\')" class=\'md-raised\' layout=\'row\' layout-align=\'start center\' ng-click="vm.changeConfig(\'' + e.name + '\')">'
        //   //+ '<md-icon class="' + e.icon + '"></md-icon>'
        //   + '<img src="assets/icons/'+e.icon+'.png">'
        //   + '<span flex translate="' + e.translationPath + '">translate</span>'
        //   + '</md-button>';


        var markup = '<div  ng-class="vm.getCssClass(\'' + e.name + '\')" layout=\'row\' layout-align=\'start center\'  ng-click="vm.changeConfig(\'' + e.name + '\')">'
          +'<img class=\'button-icon\' src="assets/icons/communicator/'+e.icon +'_color.svg"/>'
          +'<div class="button-text"><span flex translate="' + e.translationPath + '">translate</span></div>'
          +'</div>';

        e.markup = markup;
      });
    }




    // wołane w customizer part
    vm.getCssClass = function getCssClass(part, area) {
      var list = vm.communicator.PartPlacement;

      var cl = {};
      for (var property in list) {
        if (list.hasOwnProperty(property)) {
          if (list[property] === part && property !== area) {
            cl.used = true;
          }
        }
      }
      return cl;
    };


    vm.changeConfig = function (part, area) {
      var list = vm.communicator.PartPlacement;

      if (list[area] === part) {
        list[area] = '';
      }
      else {
        list[area] = part;

        for (var property in list) {
          if (list.hasOwnProperty(property)) {
            if (list[property] === part && property != area) {
              list[property] = '';
            }
          }
        }
      }

      var templeId = vm.communicator.TemplateID;
      //Zapis WS
      DynamicFactory.get('CommunicatorConfigRsc', 'saveCommunicatorTemplateConfig')('communicator', templeId, list).then(function () {
        // console.log('Zapis ustawien komunikatora powiodl sie');
      });
      if(vm.changeConfigCallBack){
        vm.changeConfigCallBack();
      }
    }

    vm.clearCommunicatorSessionData = function () {
      if ($sessionStorage.communicatorCofig) {
        $sessionStorage.communicatorCofig = undefined;
      }
    };

    function onChangeConfig(func) {
      if (func) {
        vm.changeConfigCallBack = func;
      }
    }

  }

}(window.angular));

(function () {
  'use strict';

  angular
    .module('contactcenter.communicator')
    .service('CommunicatorWPNService', Service);

  /** @ngInject */
  function Service(AplicationActiveService, webNotification) {
    var vm = this;
    vm.webPushNotificationChatMessageArrive = webPushNotificationChatMessageArrive


    function webPushNotificationChatMessageArrive(body,author,attachmentUrls) {
      if (!AplicationActiveService.isHidden) {
        //karta jest aktywna więc nie inforumujemy
        return;
      }

      // var body = _WSMessage.body;
      // var author = _WSMessage.userName;
      // var attachmentUrls = _WSMessage.attachmentUrls;

      var notificationBody = '';
      if (body.length < 20) {
        notificationBody = author + ': ' + body
      } else if (body.length >= 20) {
        notificationBody = author + ': ' + body.substring(0, 20) + '...';
      } else if (attachmentUrls) {
        notificationBody = author + ': [wysłał plik]';
      }

      webNotification.showNotification('Masz nową widomość', {
        body: notificationBody,
        icon: 'my-icon.ico',
        onClick: function onNotificationClicked() {
          console.log('Notification clicked.');
        },
        autoClose: 10000 //auto close the notification after 10 seconds (you can manually close it via hide function)
      }, function onShow(error, hide) {
        if (error) {
          window.alert('Unable to show notification: ' + error.message);
        } else {
          console.log('Notification Shown.');

          setTimeout(function hideNotification() {
            console.log('Hiding notification....');
            hide(); //manually close the notification (you can skip this if you use the autoClose option)
          }, 5000);
        }
      });
    }



    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('contactcenter.communicator')
    .service('communicatorService', Service);

  /** @ngInject */
  function Service($q, DynamicFactory, CommunicatorWPNService, templateData, $state, WebSocketManager, SessionManager, MenuManager, $filter, callSessionManager, CallStatusConst,
    confirmDialogService, toastService, $timeout) {
    var vm = {};
    var guidExpression = /(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}/g;


    vm.openCommunicator = openCommunicator;
    vm.onClearChatData = onClearChatData;
    vm.getChatActiveAndHisSession = getChatActiveAndHisSession;
    vm.onRunChat = onRunChat;
    vm.onRunContact = onRunContact;
    vm.onRunInfoBar = onRunInfoBar;
    vm.onUpdateSessionList = onUpdateSessionList;
    vm.sessionAddFromCall = sessionAddFromCall;
    vm.setTypingInProgress = setTypingInProgress;
    vm.openCommunicatorForCallSession = openCommunicatorForCallSession;
    vm.setHistorySessionAsFinished = setHistorySessionAsFinished;
    vm.closeUnclosedSessions = closeUnclosedSessions;
    vm.countUnclosedSessions = countUnclosedSessions;
    vm.clearUnclosedSessions = clearUnclosedSessions;
    vm.sessionEndClientFn = sessionEndClientFn;


    vm.activeSession = [];
    vm.historySession = [];
    vm.sessionsClosed = [];
    vm.findSession = findSession;
    vm.removeSession = removeSession;
    vm.switchType = switchType;
    vm.communicatorType = '';
    vm.userSession = {};
    vm.sessionEndTagOpen = false;
    vm.currentSessionSelect = {};
    vm.numberTryReserved = 1;

    function init() {
      vm.communicatorType = 'client';
      vm.typingInProgress = false;
      vm.userSession = SessionManager.getUser();

      if (!SessionManager.isConsultant() || $state.current.name === 'app.contactcenter_internalmessage') {
        vm.communicatorType = 'internal';
      }
      vm.commMenu = MenuManager.findMenuItem('COMMUNICATOR');

      if (SessionManager.isConsultant()) {
        registerActiveSessionWebSockets();
      }
    }


    function onClearChatData(func) {
      if (func) {
        jQuery('#messageDiv').text('');
        vm.clearChatData = func;
      }
    }

    function setTypingInProgress(typing) {
      vm.typingInProgress = typing;
    }


    function onRunChat(func) {
      if (func) {
        vm.runChat = func;
      }
    }
    function onRunContact(func) {
      if (func) {
        vm.runContact = func;
      }
    }
    function onRunInfoBar(func) {
      if (func) {
        vm.runInfoBar = func;
      }
    }

    function onUpdateSessionList(func) {
      if (func) {
        vm.updateSessionList = func;
      }
    }




    function openCommunicatorForCallSession(callID) {

      //to blokuje callbacki
      // var activeCallSesssion= _.find(vm.activeSession,{callID:callID,type:'I'});
      var activeCallSesssion = _.find(vm.activeSession, { callID: callID });
      if (activeCallSesssion) {
        openCommunicator(activeCallSesssion, 'active', true);
      }

    }

    function openCommunicator(data, type, forceOpen) {


      if (!forceOpen && vm.typingInProgress) {
        //ktos rozpoczął pisać widomość/notatkę/zmienił kontakt, więc przejście do kolejnej sesji tylko na rządanie
        return;
      } else {
        //zrzucamy flagę
        vm.typingInProgress = false;
      }

      DynamicFactory.get('servicesRsc', 'servicesBundleFlatGet')(data.serviceID).then(function (bundle) {
        var smsServiceId, ivrServiceId, chatServiceId, emailServiceId, callbackServiceId, facebookServiceId;
        if (bundle) {
          smsServiceId = bundle.smsService;
          ivrServiceId = bundle.ivrService;
          chatServiceId = bundle.chatService;
          emailServiceId = bundle.emailService;
          callbackServiceId = bundle.callbackService;
          facebookServiceId = bundle.facebookService;
        }

        if (vm.clearChatData) {
          console.log('clearChatData');
          vm.clearChatData();
        } else {
          templateData.clearData();
        }

        templateData.msisdn = data.msisdn;
        templateData.reservedNumber = data.msisdn * 1 === 1;
        templateData.currentServiceId = data.serviceID;
        templateData.callid = data.callID;
        templateData.contactId = data.contactID;
        templateData.smsServiceId = smsServiceId;
        templateData.ivrServiceId = ivrServiceId;
        templateData.chatServiceId = chatServiceId;
        templateData.facebookServiceId = facebookServiceId;
        templateData.emailServiceId = emailServiceId;
        templateData.callbackServiceId = callbackServiceId;
        templateData.sessionId = data.sessionID;
        templateData.sessionType = type;
        templateData.sessionServiceType = data.type;
        templateData.sessionReservedDate = data.reservedDate;
        templateData.finished = data.finished;
        templateData.messageSessionId = data.messageSessionId;
        templateData.serviceId = data.serviceID;
        templateData.tags = data.tags;

        console.log('CommunicatorService templateData: ', templateData);
        //id: data.type === 'I' || data.type === 'V' ? data.callID : data.sessionID

        vm.currentSessionSelect = data;
        setActiveSession(data);

        // zdejmujemy info o nowej sesji wiadmości/połączenia
        vm.commMenu.showAlert = undefined;

        if ($state.current.name !== 'app.contactcenter_communicator') {

          //jeśli wchodzimy z innego state niż komunikator to trzeba przeładowąć dane
          $state.go('app.contactcenter_communicator', { forceRender: true });
        } else {
          vm.runChat();
          if (vm.runContact) {
            vm.runContact();
          }
          if (vm.runInfoBar) {
            vm.runInfoBar();
          }
        }

      }, function (errr) {
        console.error(errr);
      });
    }

    function setActiveSession(session) {
      angular.forEach(vm.activeSession, function (s) {
        s.isActive = false;
      });
      angular.forEach(vm.historySession, function (s) {
        s.isActive = false;
      });

      var sessionToChange = _.find(vm.activeSession, function (n) {
        return (n.callID && n.callID === session.callID && n.type === session.type) || (n.sessionID && n.sessionID === session.sessionID && n.type === session.type);
      });

      if (!sessionToChange) {
        sessionToChange = _.find(vm.historySession, function (n) {
          return (n.callID && n.callID === session.callID && n.type === session.type) || (n.sessionID && n.sessionID === session.sessionID && n.type === session.type);
        });
      }

      if (sessionToChange) {
        sessionToChange.isActive = true;
      }
    }

    function findSession(callId, type) {
      var session = _.find(vm.activeSession, function (n) {
        return n.callID === callId && n.type === type;
      });
      return session;
    }

    function removeSession(callId, type) {
      var oldSession = findSession(callId, type);
      if (oldSession) {
        _.remove(vm.activeSession, oldSession);

        var histSession = _.find(vm.historySession, function (n) {
          return n.contactID === oldSession.contactID && n.bundleID === oldSession.bundleID;
        });
        if (histSession) {
          _.remove(vm.historySession, histSession);
        }


        vm.historySession.push(oldSession);
        if (vm.updateSessionList) {
          vm.updateSessionList();
        }
      }
    }

    function registerActiveSessionWebSockets() {
      if (SessionManager.isConsultant()) {
        console.log('ActiveSession regex: ', SessionManager.buildRegexForConsultant());
        WebSocketManager.registerWebSocketMethod(
          "CallChat",
          "chatArriveActiveSessions",
          wsCallsChatArrive,
          SessionManager.buildRegexForConsultant()
        );


        WebSocketManager.registerWebSocketMethod(
          'CallIn',
          'callAriveActiveSessions',
          callIn,
          SessionManager.buildRegexForConsultant()
        );
        WebSocketManager.registerWebSocketMethod(
          'CallOut',
          'callBridgeActiveSessions',
          callOut,
          SessionManager.buildRegexForConsultant()
        );

        // WebSocketManager.registerWebSocketMethod(
        //   'CallOut',
        //   'callBridge',
        //   callWsOut
        // );

      }
    }

    function activeFilterFunc(item) {
      return ((item.status === 4 || item.status === 3) && item.messageToReply > 0);
    }

    function inactiveFilterFunc(item) {
      return !((item.status === 4 || item.status === 3) && item.messageToReply > 0);
    }

      function getChatActiveAndHisSession(autoSelect) {
      
        DynamicFactory.get('CommunicatorServiceRsc', 'GetLastSessions')().then(function (data) {
          vm.activeSession = _.filter(data, activeFilterFunc);
          vm.historySession = _.filter(data, inactiveFilterFunc);
  
          angular.forEach(vm.activeSession, function (value, key) {
            value.containsGuid = guidExpression.test(value.contactEmail);
            console.log('EXPR value.containsGuid: ', value.containsGuid);
          });
          vm.sessionAddFromCall(callSessionManager.getCall());
  
          if (vm.activeSession.length > 0) {
            vm.commMenu.showAlert = '/assets/icons/warning.png';
          } else {
            vm.activeSession = [];
          }
  
          if (vm.updateSessionList) {
            vm.updateSessionList();
          }
  
          if (autoSelect) {
            selectIfYouCan();
          }
          else {
            console.log('getActive select: ', vm.currentSessionSelect);
            if (vm.currentSessionSelect) {
              setActiveSession(vm.currentSessionSelect);
  
              //getSessionDetails(vm.currentSessionSelect);
              
            }
          }
  
        }, function (err) {
        });
  
    }


    function setHistorySessionAsFinished(sessionID) {

      //aby ukryć div do wysyłania wiadomości ale tylko tej atukalnie otwartej!
      if (templateData.sessionId === sessionID) {
        templateData.finished = Date.now();
      }

      // angular.forEach(vm.historySession, function (value, key) {
      //     value.containsGuid = guidExpression.test(value.contactEmail);
      //     console.log('EXPR value.containsGuid: ',value.containsGuid);
      // });

      //zamiany na session list
      var histSession = _.find(vm.historySession, function (n) {
        return n.sessionID === sessionID;
      });

      if (histSession) {
        histSession.finished = Date.now();
      }
    }


    function wsCallsChatArrive(data) {

      vm.data = JSON.parse(data.Content);
      console.log('wsCallsChatArrive data: ', vm.data);
      if (vm.data.type === 1) {
        //nowa wiadomosc
        vm.commMenu.showAlert = '/assets/icons/warning.png';

        if (vm.data.message.type !== 'A') {
          messageToReplyCounterIncr(vm.data.message.sessionID);

          CommunicatorWPNService.webPushNotificationChatMessageArrive(vm.data.message.body, vm.data.message.userName, vm.data.message.attachmentUrls)
        }

        setReservedMessages(vm.data.message.sessionID);
      }
      else if (vm.data.type === 2) {
        //nowa sesja
        vm.data.message.ccserviceBundle = JSON.parse(vm.data.message.ccserviceBundle);

        setReservedMessages(vm.data.message.sessionID);

        var messageCurrent = angular.copy(vm.data.message);
        // console.log('messageCurrent: ',messageCurrent);
        // console.log('EXPR contactemail valid: ',guidExpression.test(messageCurrent.contactEmail));
        // messageCurrent.containsGuid = guidExpression.test(messageCurrent.contactEmail);

        //AN
        getSessionDetails(messageCurrent);

      }
      else if (vm.data.type === 3) {
        //zamkniecie sesji


        vm.commMenu.showAlert = undefined;
        vm.currentSessionToDel = _.find(vm.activeSession, function (n) {
          return n.sessionID === vm.data.message.sessionID;
        });
        _.remove(vm.activeSession, function (n) {
          return n.sessionID === vm.data.message.sessionID;
        });
        if (vm.data.message.isReply === true) {
          var bundleID;
          if (vm.data.message.ccserviceBundle) {
            vm.data.message.ccserviceBundle = JSON.parse(vm.data.message.ccserviceBundle);
            bundleID = vm.data.message.ccserviceBundle.BundleID;
            if (bundleID === null) {
              bundleID = undefined;
            }
          }

          var histSession = _.find(vm.historySession, function (n) {
            return n.contactID === vm.data.message.contactID && ((n.ccserviceBundle !== undefined && n.ccserviceBundle.BundleID === bundleID) || n.bundleID === bundleID);
          });
          if (histSession) {
            _.remove(vm.historySession, histSession);
            vm.data.message.name = histSession.name;
          }

          if (vm.currentSessionToDel) {
            vm.historySession.push(vm.currentSessionToDel);
          }
          else {
            // vm.data.message.containsGuid = guidExpression.test(vm.data.message.contactEmail);
            // console.log('EXPR vm.data.message.containsGuid: ',vm.data.message.containsGuid);
            vm.historySession.push(vm.data.message);
          }
        }
        if (vm.data.message.isForward === true) {
          _.remove(vm.historySession, function (n) {
            return n.sessionID === vm.data.message.sessionID;
          });
        }
        //jeśli jesteśmy w komunikatorze i zostanie odebrana sesja którą się aktualnie zajmujemy, 
        //to ustaw kolejną aktywną lub pozostaw na tej same
        if (vm.data.message.sessionID === templateData.sessionId) {
          // w przypadku gdy ktoś nie zdąrzył napisać wiadomości/notatki to porzuamy ten fakt
          //zdejmujemy flagę typing, bo jak nie ma aktywnych sesji to kolejna nie zostanie zaznaczona
          setTypingInProgress(false);

          // w zależności od ustawienia na serwisie przeskocz do kolejnej sesji

          var histSession = _.find(vm.historySession, function (n) {
            return n.sessionID === vm.data.message.sessionID;
          });

          if (histSession && !vm.data.message.nextSessionAfterReplay) {
            histSession.isActive = true;
          } else {
            selectIfYouCan();
          }
        }

        //jesli klient przerwał rozmowę
        if (vm.data.message.status && vm.data.message.status.trim() === '120') {
          vm.setHistorySessionAsFinished(vm.data.message.sessionID);
          $timeout(function () {
            vm.sessionEndClientFn(vm.data.message.serviceID, vm.data.message.sessionID);

            // DynamicFactory.get('messageSessionRsc', 'getInfo')(
            //   vm.data.message.sessionID
            // ).then(
            //   function (data) {

            //     SessionTagsService.updateSessionTileTags(vm.data.message.sessionID,data.tags)
            //   },
            //   function (err) {
            //   });

          }, 200);
        }


        if (vm.updateSessionList) {
          vm.updateSessionList();
        }

      }
    }

    function getSessionDetails(messageCurrent) {

      DynamicFactory.get('CommunicatorServiceRsc', 'GetSessionsInfo')(messageCurrent.sessionID, messageCurrent.serviceID, messageCurrent.contactID).then(function (data) {
        messageCurrent.name = data.name;
        messageCurrent.surname = data.surname;
        messageCurrent.city = data.city;
        messageCurrent.serviceName = data.serviceName;

        //jeśli aktywną sesja była sesja historyczna i wpadnie nam nowa wiadomość to ustaw flagę żeby zaznaczyć sesję aktywną
        if (messageCurrent.sessionID === templateData.sessionId) {
          messageCurrent.isActive = true;
        }

        console.log('messageCurrent: ', messageCurrent);
        //new: usuwanie sesji z tym samym contactID ale innym sessionID
        _.remove(vm.activeSession, function (n) {
          return n.sessionID !== messageCurrent.sessionID && n.contactID === messageCurrent.contactID;
        });
        //new: usuwanie sesji z tym samym contactID ale innym sessionID
        vm.activeSession.push(messageCurrent);


        if (vm.updateSessionList) {
          vm.updateSessionList();
        }

        vm.commMenu.showAlert = '/assets/icons/warning.png';
        _.remove(vm.historySession, function (n) {
          return n.sessionID === messageCurrent.sessionID || n.contactID === messageCurrent.contactID;
        });

        //pokazujemy akcję bo tam mamy info że klient zalogował się
        // if (vm.data.message.type !== 'A') {

        var body = ''
        var author = ''
        var attachmentUrls = ''
        if (vm.data.message.messages && vm.data.message.messages.length) {
          body = vm.data.message.messages[vm.data.message.messages.length - 1].body;
          author = vm.data.message.messages[vm.data.message.messages.length - 1].userName;
          attachmentUrls = vm.data.message.messages[vm.data.message.messages.length - 1].attachmentUrls;
        }

        CommunicatorWPNService.webPushNotificationChatMessageArrive(body, author, attachmentUrls)
        // }

        // jeśli w sesjach jest tylko jedna sesja to zrób ją aktywną
        if (vm.activeSession.length === 1) {
          //ustaw pierwszą z brzega aktywną
          if ($state.current.name === 'app.contactcenter_communicator') {

            if (!templateData.sessionId) {
              openCommunicator(vm.activeSession[0], 'active');
            }
          }
        }

      }, function (err) {
      });

    }

    function messageToReplyCounterIncr(sessionID) {
      // powiększ licznik 
      var session = _.find(vm.activeSession, function (n) {
        return n.sessionID == sessionID;
      });
      if (session) {
        if (session.messageToReply) {
          session.messageToReply++
        } else {
          session.messageToReply = 1;
        }
      }
    }

    function sessionEndClientFn(serviceId, sessionId) {

      var sessionToClose = _.find(vm.activeSession, function (n) {
        return n.sessionID == sessionId;
      });

      if (!sessionToClose) {
        sessionToClose = _.find(vm.historySession, function (n) {
          return n.sessionID == sessionId;
        });
      } else {

      }
      if (sessionToClose) {
        sessionToClose.finishedAccentStart = true; // tak żeby animacje pokazywały się tylko po przyjściu web socket a nie odświezaniu strony
        sessionToClose.finishedAccent = 1;
        sessionToClose.finished = Date.now();
        DynamicFactory.get('messageSessionRsc', 'getInfo')(sessionId).then(function (data) {
          sessionToClose.tags = data.tags;

          sessionToClose.forceReloadTags = false;
          $timeout(function () {
            sessionToClose.forceReloadTags = true;
          }, 0);
          //vm.sessionsClosed.push(sessionToClose);

        }, function (err) {
          console.log(err)
        });

      }


    }

    function selectIfYouCan() {
      if (vm.activeSession.length > 0) {
        //ustaw pierwszą z brzega aktywną
        if ($state.current.name === 'app.contactcenter_communicator') {
          openCommunicator(vm.activeSession[0], 'active');
        }
      } else {
        if (vm.clearChatData) {
          vm.clearChatData();
        }
      }
    }

    function callIn(data) {
      console.log('activeSession - callIn: ', JSON.parse(data.Content));
      callArrive(JSON.parse(data.Content), 'I');
    }

    function callOut(data) {
      console.log('activeSession - callOut: ', JSON.parse(data.Content));
      callArrive(JSON.parse(data.Content), 'V');
    }

    // function callWsOut(data) {
    //   console.log('activeSession - callWsOut: ', data.Content);
    //   // callArrive(data.Content, 'I'); //WsOut = sesja pomocowa
    // }

    var sessionInfoDefers = [];

    function callArrive(content, type) {
      if (content.type) {
        return;
      }

      var bundleID;


      if (content.status === 'WAIT4DROP') {
        var contactId = content.contactId;
        if (content.detailsRecord && content.detailsRecord.contactID) {
          contactId = content.detailsRecord.contactID;
        }
        var emailService = null;

        if (content.ccserviceBundle) {
          content.ccserviceBundle = JSON.parse(content.ccserviceBundle);
          emailService = content.ccserviceBundle.emailService;
          bundleID = content.ccserviceBundle.BundleID;
          if (bundleID === null) {
            bundleID = undefined;
          }
        }
        var reservedDate = content.start ? content.start : content.startCall;
        var reservedDateM = moment(reservedDate);
        var diff = moment().diff(reservedDateM);
        if (diff <= 0) {
          reservedDate = Date.now();
        }
        reservedDate = moment(reservedDate).format('YYYY-MM-DDTHH:mm:ss.SSS');
        var session = {
          bundleID: bundleID,
          type: type,
          serviceName: content.ServiceName,
          reservedDate: reservedDate,
          callID: content.callId,
          serviceID: content.ccserviceId ? content.ccserviceId : content.serviceId,
          contactID: contactId,
          msisdn: content.ani,
          emailService: emailService,
          party: content.party
        };
        console.log('callArrive - session: ', session);
        var sessionIs = _.find(vm.activeSession, function (n) {
          return n.callID === content.callId && n.type === type;
        });
        if (sessionIs) {
          _.remove(vm.activeSession, sessionIs);
        }


        GetSessionsInfoPromise(session.callID, session.serviceID, session.contactID).then(function (data) {
          session.name = data.name;
          session.surname = data.surname;
          session.city = data.city;
          session.serviceName = data.serviceName;
          vm.activeSession.push(session);
          if (vm.updateSessionList) {
            vm.updateSessionList();
          }

          // jeśli w sesjach jest tylko jedna sesja to zrób ją aktywną
          if (vm.activeSession.length === 1) {
            //ustaw pierwszą z brzega aktywną

            if ($state.current.name !== 'app.contactcenter_communicator') {
              //jeśli konsultant jest poza komunikatorem i wpada do niego połaczenie, to nie urochamiaj z automatu komunikatora
              // ale oznacz wykrzynikiem
              vm.commMenu.showAlert = '/assets/icons/warning.png';
              return;
            } else {
              openCommunicator(vm.activeSession[0], 'active');
            }
          }

        }, function (err) {
        });


      }
      else if (content.status === CallStatusConst.disconnected || content.status === CallStatusConst.failedRedirect) {

        CancelSessionsInfoPromise(content.callId, true);

        if (content.ccserviceBundle) {
          content.ccserviceBundle = JSON.parse(content.ccserviceBundle);
          bundleID = content.ccserviceBundle.BundleID;
          if (bundleID === null) {
            bundleID = undefined;
          }
        }
        var oldSession = _.find(vm.activeSession, function (n) {
          return n.callID === content.callId && n.type === type;
        });
        if (oldSession) {

          // jeśli mamy zaznaczoną sesję historyczną, to nie zaznaczaj rozmowy która właśnie się skończyła
          var hs = _.find(vm.historySession, function (n) {
            return n.isActive;
          });

          if (!hs) {
            selectIfYouCan();
          }

          _.remove(vm.activeSession, oldSession);

          var histSession = _.find(vm.historySession, function (n) {
            return n.contactID === content.contactId && n.bundleID === bundleID;
          });
          if (histSession) {
            _.remove(vm.historySession, histSession);
          }

          vm.historySession.push(oldSession);
          //vm.historySession = $filter('orderBy')(vm.historySession,'reservedDate',true);
          if (vm.updateSessionList) {
            vm.updateSessionList();
          }
        }
      }
    }

    function GetSessionsInfoPromise(callID, serviceID, contactID) {

      var defer = $q.defer();
      DynamicFactory.get('CommunicatorServiceRsc', 'GetSessionsInfo')(callID, serviceID, contactID).then(function (data) {
        CancelSessionsInfoPromise(callID);
        defer.resolve(data);
      }, function (err) {
        CancelSessionsInfoPromise(callID);
        defer.reject(err);
      });

      sessionInfoDefers.push({ defer: defer, callID: callID });
      console.log('sessionInfoDefers added, defersArrayLength' + sessionInfoDefers.length);

      return defer.promise;
    };

    function CancelSessionsInfoPromise(callID, forceReject) {

      var deferObj = _.find(sessionInfoDefers, { callID: callID });

      if (deferObj) {
        if (forceReject && deferObj.defer.promise.$$state.status !== 2) {
          deferObj.defer.reject();
          console.log('sessionInfoDefers reject callID: ' + callID);
        };
        _.remove(sessionInfoDefers, { callID: callID });
        console.log('sessionInfoDefers removed callID: ' + callID);
      }
    };


    // active session Functions  END
    function switchType() {
      if (vm.communicatorType === 'client') {
        vm.communicatorType = 'internal';
      }
      else {
        vm.communicatorType = 'client';
      }
    }

    function countUnclosedSessions() {
      var histFinishedSession = _.filter(vm.historySession, function (n) {
        return !n.finished;
      });

      return vm.activeSession.length + histFinishedSession.length;
    }

    function clearUnclosedSessions() {
      console.log('Hist session cleared');
      _.remove(vm.historySession, function (n) {
        return !n.finished;
      });
      //czyścimy chatpart
      if (vm.clearChatData) {
        vm.clearChatData();
      }
    }

    function closeUnclosedSessions() {

      if (countUnclosedSessions() > 0) {
        var histFinishedSession = _.filter(vm.historySession, function (n) {
          return !n.finished;
        });

        angular.forEach(histFinishedSession, function (session) {
          console.log('Hist session closing: ' + session.sessionId);
          simpleSessionClose(session);
        });

        angular.forEach(vm.activeSession, function (session) {
          console.log('Active session closing: ' + session.sessionId);
          simpleSessionClose(session);
        });
      }
    }

    function simpleSessionClose(session) {
      var message = {
        portalId: session.portalId,
        serviceId: session.serviceID,
        portalUserID: session.portalUserID,
        contactID: session.contactID,
        titile: '',
        type: 'A',
        body: '',
        sessionId: session.sessionID,
        prefix: session.prefixID,//brak?
        operator: session.operator,
        la: session.la,//brak?
        params: session.params,//brak?
        replyToGuid: null,//brak?
        direction: 'O',
        callID: session.callid,
        serviceOrderId: session.serviceOrderId,//brak?
        attachments: null,
        communictorType: session.communictorType,//brak?
        MMSUrls: [],
        attachmentUrls: null,
        fbMessengerID: session.fbMessengerID,//brak?
        authorPhotoUrl: vm.userSession.userImg,
        authorName: vm.userSession.username,
        timeToSend: session.timeToSend,//brak?
        fbCommentID: session.fbCommentID,//brak?
        fbCommentParentID: session.fbCommentParentID//brak?
      };

      DynamicFactory.get('ChatPartRsc', 'sendCleaningMessage')(message).then(
        function (data) {
          setHistorySessionAsFinished(session.sessionID);
          console.log('Session closed: ' + session.sessionID)
        },
        function (err) {
          console.log(err);
        }
      );
    }

    function sessionAddFromCall(msg) {
      console.log('sessionAddFromCall - msg: ', msg);
      if (msg) {
        var content = msg.Content ? msg.Content : msg;
        if (content.helpSession && content.status !== CallStatusConst.disconnected) {
          if (!vm.findSession(content.callId, 'I')) {
            var session = {
              type: 'I',
              reservedDate: content.callStartTime ? content.callStartTime : new Date(),
              callID: content.callId ? content.callId : content.callID,
              serviceID: content.serviceId,
              serviceName: content.detailsRecord ? content.detailsRecord.serviceName : content.ServiceName,
              contactID: content.detailsRecord ? content.detailsRecord.contactID : content.contactId,
              bundleID: content.detailsRecord ? content.detailsRecord.bundleID : content.bundleID,
              msisdn: (content.detailsRecord && content.detailsRecord.callerMsisdn) ? content.detailsRecord.callerMsisdn : content.clientBase.msisdn,
            };
            console.log('sessionAddFromCall - session: ', session);
            vm.activeSession.push(session);
          }
        }
      }
    }

    function setReservedMessages(sessionID) {
      vm.numberTryReserved = 1;
      setReservedMessagesTrying(sessionID);
    }

    function setReservedMessagesTrying(sessionID) {
      DynamicFactory.get('ChatPartRsc', 'setReservedMessages')(sessionID).then(
        function (data) {

        },
        function (err) {
          console.log('setReservedMessages '+vm.numberTryReserved+' error:',err);
          if(vm.numberTryReserved<3){
            vm.numberTryReserved++;
            $timeout(function () {
              setReservedMessagesTrying(sessionID);
            },vm.numberTryReserved*1000)
          }
          else{
            toastService.showToast('Problem z połączniem i potwierdzeniem sesji '+sessionID, 'error', 10);
          }
        }
      );
    }

    init();

    return vm;
  }
})();

/**
 * Created by kosski on 07.09.2016.
 */
+function () {
  'use strict';

  angular.module('contactcenter.communicator').component('communicator', {
    templateUrl: 'app/main/contactcenter/communicator/communicator.html',
    controllerAs: 'vm',
    controller: controller
  });

  /** @ngInject */
  function controller(communicatorConfig, templateData) {
    var vm = this;
    

    vm.$onInit = function () {


      vm.templateMarkup = undefined;
      vm.templateData = templateData;
      
      // reset ustawien
      communicatorConfig.loadData().then(function () {
        vm.templateMarkup = '<infobar template-data="vm.templateData"></infobar><' + communicatorConfig.communicator.TemplateName + ' setting-Mode="false" template-data="vm.templateData" ></' + communicatorConfig.communicator.TemplateName + '>';
      });
    };

    vm.$postLink = function () {

    };
  }
}();

// /**
//  * Created by kosski on 07.09.2016.
//  */
// +function () {
//   'use strict';
//   const tokenUrl = 'token';
//   const obtainUrl = 'account/ObtainLocalAccessToken';
//   const registerUrl = 'account/registerexternal';
//   const accountUrl = 'Account/Login';
//   angular
//     .module('auth.login')
//     .factory('LoginRsc', LoginRsc);

//   /** @ngInject */
//   function LoginRsc($resource, SessionManager, consts, $log, $q, $sessionStorage) {
//     var _this = {};

//     _this.tokenResrource = $resource(consts.api + tokenUrl, '@data',
//       {
//         query: {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
//         }
//       });

//     _this.loginResource = $resource(consts.api + accountUrl, '@data',
//       {
//         query: {
//           method: 'POST'
//         }
//       });

//     _this.querryToken = function (data) {
//       return _this.tokenResrource.query(data).$promise;
//     };

//     _this.querryLogin = function (data) {
//       return _this.loginResource.query(data).$promise;
//     };

//     _this.loginUser = function (params) {
//       return $q(function (resolve, reject) {
//         var data = "grant_type=password&username=" + params.username + "&password=" + params.password;
//         _this.querryToken(data).then(
//           _resolved,
//           _error
//         );
//         function _resolved(data) {
//           $sessionStorage.authentication = {
//             username: params.username,
//             token: data.access_token,
//             token_expire:new Date(new Date().getTime() + 30*60000)
//           };
//           _this.querryLogin({
//             username: params.username,
//             password: params.password
//           }).then(
//             _setUserAndResolve,
//             _error
//             );
//           function _setUserAndResolve(suc) {
//             console.log(suc);
//             $sessionStorage.authentication.userId = suc.userID;
//             $sessionStorage.authentication.partnerId = suc.partnerId;
//             $sessionStorage.authentication.img = suc.img;
//             $sessionStorage.authentication.roleId = suc.roleID;
//             if(suc.roleID){
//               SessionManager.setup(suc.roleID).then(function(){
//                 resolve(true);
//               },function(){
//                 reject(false);
//               });
//             }else{
//               resolve(true);
//             }
//           }
//         }

//         function _error(err) {
//           $sessionStorage.authentication = {};
//           $log.error(err);
//           reject(err);
//         }
//       });
//     };
//     return _this;
//   }
// } ();

(function ()
{
    'use strict';

    angular
        .module('auth.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.auth_login', {
            url      : '/login?guid',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth_login': {
                    templateUrl: 'app/main/auth/login/login.html',
                    controller : 'LoginController as vm'
                }
            },
            bodyClass: 'login'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/auth/login');
    }

})();

(function() {
  "use strict";

  angular.module("auth.login").controller("LoginController", LoginController);
  /** @ngInject */
  function LoginController(AuthService, $stateParams, ngNotify, $state, MenuManager, SessionManager, authRolesConst, $localStorage, $http, internalMessageService) {
    var vm = this;
    vm.activated = false;
    vm.internalcc = {};
    vm.changeLocalNumber = changeLocalNumber;
    vm.tryUnable = tryUnable;
    vm.internalMessageService = internalMessageService;

    activate();

    function activate() {
      vm.counter = 0;
      console.log("LoginController | start ", $stateParams);

      $http
        .get("https://localip.teleaudio.pl/api/address")
        .then(function(res) {
          vm.isInternalHost = true;
          $localStorage.hostInfo = res.data;
          if ($localStorage.hostNumber) {
            vm.internalcc.phone = $localStorage.hostNumber;
            vm.internalcc.phoneDisable = true;
          }
        })
        .then(function() {
          // "complete" code here
          if ($stateParams.guid) {
            vm.activated = true;
            $localStorage.hostNumber = vm.internalcc.phone;
            AuthService.remoteLogin($stateParams.guid).then(completeLogin,rejectLogin);
          }
        });
    }

    function changeLocalNumber() {
      $localStorage.hostNumber = parseInt(vm.internalcc.phone);
      vm.internalcc.phoneDisable = true;
      vm.counter = 0;
    }

    function tryUnable() {
      vm.counter++;
      if (vm.counter > 3) {
        vm.internalcc.phoneDisable = false;
      }
    }

    vm.logIn = function(valid) {
      if (valid) {
        vm.activated = true;
        $localStorage.hostNumber = vm.internalcc.phone;

        AuthService.login(vm.form.login, sha512(vm.form.password), vm.isInternalHost).then(completeLogin,rejectLogin);
      }
    };

    function completeLogin(response) {
      MenuManager.initiateMenu();
      //vm.internalMessageService.init();

      if (SessionManager.isConsultant()) {
        $state.go("app.contactcenter_communicator");
      } else if (SessionManager.getUserRoleId() === authRolesConst.manager) {
        $state.go("app.contactcenter_dashboard");
      } else if (!SessionManager.isConsultant()) {
        $state.go("app.contactcenter_management.services");
      }
    }

    function rejectLogin(reason) {
      vm.activated = false;
      ngNotify.set("Niepoprawne dane logowania.", {
        type: "error",
        position: "bottom",
        duration: 1000
      });
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('app.core',
      [
        'ngAnimate',
        'ngAria',
        'ngCookies',
        'ngMessages',
        'ngResource',
        'ngSanitize',
        'ngMaterial',
        'angular-chartist',
        'chart.js',
        'datatables',
        'gridshore.c3js.chart',
        'nvd3',
        'pascalprecht.translate',
        'timer',
        'ui.router',
        'textAngular',
        'ui.sortable',
        'ng-sortable',
        'xeditable',
        'moment-picker'
      ]);
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msStepper', msStepperDirective)
        .directive('msStepperStep', msStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element   : element,
                scope     : scope,
                form      : form,
                stepNumber: scope.step || (vm.steps.length + 1),
                stepTitle : scope.stepTitle
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            // Hide all steps
            for ( var i = 0; i < vm.steps.length; i++ )
            {
                vm.steps[i].element.hide();
            }

            // Show the current step
            vm.steps[vm.currentStepNumber - 1].element.show();
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure
            // we will land to a one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure
            // we will land to a one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msStepperDirective()
    {
        return {
            restrict        : 'A',
            require         : ['form', 'msStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msStepper'],
            priority: 1000,
            scope   : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?',
                hideStep    : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Chat',
                        'icon'       : 'icon-hangouts',
                        'state'      : 'app.chat',
                        'badge'      : {
                            'content': 13,
                            'color'  : '#09d261'
                        },
                        'weight'     : 5,
                        'children'   : [],
                        '_id'        : 'chat',
                        '_path'      : 'apps.chat',
                        'uisref'     : 'app.chat',
                        'hasShortcut': true
                    }, {
                        'title'      : 'Contacts',
                        'icon'       : 'icon-account-box',
                        'state'      : 'app.contacts',
                        'weight'     : 10,
                        'children'   : [],
                        '_id'        : 'contacts',
                        '_path'      : 'apps.contacts',
                        'uisref'     : 'app.contacts',
                        'hasShortcut': true
                    }, {
                        'title'      : 'Notes',
                        'icon'       : 'icon-lightbulb',
                        'state'      : 'app.notes',
                        'weight'     : 11,
                        'children'   : [],
                        '_id'        : 'notes',
                        '_path'      : 'apps.notes',
                        'uisref'     : 'app.notes',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null,
                _flatNavigation = [];

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = [];
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    })
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {

            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {

            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {

            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }

    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });

            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {

        // Default configuration
        var defaultConfiguration = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }
                var offset = moment(val).utcOffset();
                var date = new Date(moment(val).add(offset, 'm'));
                return date;
            }
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            return defaultConfiguration;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require: 'ngModel',
            link   : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.unshift(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.unshift(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {

                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    var refTop = Math.min.apply(Math, referenceArr);

                    var column = referenceArr.indexOf(refTop);

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});

                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }

                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        }

    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                }
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
!(function() {
  "use strict";
  angular.module("app.navigation").provider("MenuItems", function menuItems() {
    var _this = this;
    _this.menuArray = {};
    _this.initMenuItem = initMenuItem;
    _this.getMenuItemArray = getMenuItemArray;
    _this.getMenuObj = getMenuObj;

    function getMenuItemArray(startName) {
      return new MenuArray(startName);
    }

    function MenuArray(startName) {
      this.array = [
        {
          name: startName
        }
      ];
    }

    // function getMenuItemArray(startName) {

    MenuArray.prototype.addMenuItem = function(token, objMenu) {
      var menuItem = this.getMenuItem(token);
      objMenu.name = token;
      if (!menuItem.submenu) {
        menuItem.submenu = [];
      }
      menuItem.submenu.push(objMenu);
      return this;
    };
    MenuArray.prototype.getFromSubmenu = function(subToken, menuScope) {
      if (menuScope.submenu) {
        for (var i = 0; i < menuScope.submenu.length; i++) {
          var menuItem = menuScope.submenu[i];
          if (menuItem.name === subToken) {
            return menuItem;
          }
        }
      }
    };

    MenuArray.prototype.getMenuItem = function(token) {
      var parsedToken = token.split(".");
      var menuItem = this.array[0];

      var subToken = parsedToken[0];
      for (var i = 1; i < parsedToken.length; i++) {
        subToken += "." + parsedToken[i];
        var result = this.getFromSubmenu(subToken, menuItem);
        if (result) {
          menuItem = result;
        } else {
          break;
        }
      }
      return menuItem;
    };

    function initMenuItem(startName) {
      if (!_this.menuArray[startName]) {
        _this.menuArray[startName] = getMenuItemArray(startName);
      }
      return _this.menuArray[startName];
    }
    function addMenuItem(token, objMenu) {
      var parsedToken = token.split(".");
      getMenuObj(parsedToken[0]).addMenuItem(token, objMenu);
    }
    function getMenuObj(startName) {
      return _this.menuArray[startName];
    }
    _this.$get= ["$q", function menuItemFactory($q) {
        return _this;
      }
    ];
    return _this;
    // }
  });
})();

/**
 * Created by akraszewski on 2017-03-13.
 */
(function () {
    "use strict";
    angular.module('app.navigation').service('MenuItemsManager', serv);

    /**@ngInject */
    function serv(MenuItems) {

      var _this = this;

      _this.getMenu = function(startName){
        return MenuItems.getMenuObj(startName);
      };

      _this.reconfigureMenuItem = function(token,objmenu){
        // MenuItemsProvider.getMenuObj(startName);
      };

      return _this;
    }

  })();

(function () {
    'use strict';

    angular
        .module("app.navigation")
        .component('navContainer', {
            templateUrl: 'app/navigation/navcontainer/navcontainer.html',
            controllerAs: 'vm',
            bindings: {
                addonClass: '='
            },
            controller: navContainer
        });
    /** @ngInject */
    function navContainer(MenuManager, $rootScope, $state,$mdMedia) {
        var vm = this;

        vm.MenuManager = MenuManager;
        vm.loadNavigationContent = loadNavigationContent;

        function loadNavigationContent(state) {
            MenuManager.loadNavigationContent(state);
        }
        loadNavigationContent();
        
        MenuManager.renderMenu($mdMedia('gt-md'), false);
    }
})();
/**
 * Created by kosski on 09.09.2016.
 */

+ function () {
  'use strict';
  const consultantsGetUrl = 'admin/consultant/list/';
  const ConsultantActiveSwitchUrl = 'CallCenterConsultants/ChangeActive';
  const consultantUpdateUrl = 'CallCenterConsultants/Update';
  const consultantAddUrl = 'CallCenterConsultants/Save';

  angular
    .module('Resources')
    .factory('UsersRsc', FactoryBuilder);

  /** @ngInject */
  function FactoryBuilder(ResourceBuilder) {
    var _this = this;
    var resource = [{
        name: 'mail',
        url: 'users/mail',
        withRole: true,
        methods: {
          get: {
            url: '/:uid',
            method: 'GET',
            isArray: true
          },
          update: {
            method: 'PUT'
          }
        }
      },
      {
        name: 'users',
        url: 'users',
        withRole: true,
        methods: {
          get: {
            url: '/list/:ccId',
            method: 'GET',
            withRole: true,
            isArray: true
          },
          update: {
            method: 'PUT'
          },
          changeUserPassword: {
            method: 'POST',
            url:'common/users/ChangeUserPassword',
          },
          getById: {
            method: 'GET',
            url:'/:userId'
          },
          getMyUser: {
            method: 'GET',
            url:'common/users',
            withRole:false
          },
          getMyUserDetails: {
            method: 'GET',
            url:'common/users/GetMyUserDetails',
            withRole:false
          },
          updateMyUser: {
            method: 'PUT',
            url:'common/users',
            withRole:false
          },
          save: {
            method: 'POST'
          },
          delete: {
            url: '/:userId',
            method: 'DELETE'
          },
          rollback: {
            url: 'consultant/rollback',
            method: 'PUT'
          }
        }
      }
    ];

    _this.resource = ResourceBuilder.buildAll(resource);

    _this.getUsers = function (ccId) {
      return _this.resource.users.get({
        ccId: ccId,
      }).$promise;
    };

    _this.getUser = function (userId) {
      return _this.resource.users.getById({
        userId: userId,
      }).$promise;
    };
    _this.getMyUser = function () {
      return _this.resource.users.getMyUser().$promise;
    };

    _this.getMyUserDetails = function () {
      return _this.resource.users.getMyUserDetails().$promise;
    };
    
    _this.updateMyUser = function (users) {
      return _this.resource.users.updateMyUser(users).$promise;
    };

    _this.addUser = function (user) {
      return _this.resource.users.save(user).$promise;
    };

    _this.updateUser = function (user) {
      return _this.resource.users.update(user).$promise;
    };

    _this.changeUserPassword = function (userPasswordModel) {
      return _this.resource.users.changeUserPassword(userPasswordModel).$promise;
    };
    

    _this.deactivateUser = function (userId) {
      return _this.resource.users.delete({
        userId: userId
      }).$promise;
    };

    _this.getMailBoxes = function (uId) {
      return _this.resource.mail.get({
        uid: uId
      }).$promise;
    };

    _this.updateMailBoxes = function (users) {
      return _this.resource.mail.update(angular.isArray(users) ? users : [users]).$promise;
    };

    return _this;
  }
}();

/**
 * Created by kosski on 09.09.2016.
 */

+(function () {
    'use strict';

    angular
        .module('Resources')
        .factory('trademillRsc', trademillRsc);

    /** @ngInject */
    function trademillRsc($resource, consts, $templateCache, SessionManager, ResourceBuilder) {
        var _this = {};
        var role = SessionManager.getUserRole();


        _this.newResources = [
            // {
            //     name: 'GetTreadmillByTags',
            //     url: 'treadmill/get',
            //     withRole: true,
            //     methods: {
            //         post: {
            //             method: 'POST',
            //             isArray: true
            //         }
            //     }
            // },
             {
                name: 'feed',
                url: 'treadmill/feed',
                withRole: true,
                methods: {
                    post: {
                        method: 'POST',
                        isArray: true
                    },
                    update: {
                        method: 'PUT',
                        isArray: true
                    }
                }
            }, {
                name: 'getCientHistory',
                url: 'treadmill/getCientHistory/:hash',
                withRole: true,
                methods: {
                    get: {
                        method: 'GET',
                        isArray: true
                    }
                }
            }
        ];



        _this.resources = ResourceBuilder.buildAll(_this.newResources);
        // {
        // GetTreadmill: $resource(consts.api + role + treadmillUrl,
        //     {
        //         service: '@service'
        //     },
        //     {
        //         get: {
        //             method: "GET",
        //             isArray: true
        //         }
        //     }),
        // GetTreadmillByTags: $resource(consts.api + role + treadmillUrl,
        //     '@data',
        //     {
        //         post: {
        //             method: "POST",
        //             isArray: true
        //         }
        //     }),
        // updateFeed: $resource(consts.api + role + updateFeedUrl + "/:fromDate",
        //     {
        //         fromData: '@fromDate'
        //     },
        //     {
        //         get: {
        //             method: "GET",
        //             isArray: true
        //         }
        //     }),
        // updateFeedbyTags: $resource(consts.api + role + updateFeedUrl,
        //     '@data',
        //     {
        //         post: {
        //             method: "POST",
        //             isArray: true
        //         }
        //     }),
        // getCientHistory: $resource(consts.api + role + getCientHistoryUrl,
        //     {
        //         hash: '@hash'
        //     }, {
        //         get: {
        //             method: "GET",
        //             isArray: true
        //         }
        //     }),
        // tags: $resource(consts.api + tagsUrl + '/:serviceId',
        //     {
        //         serviceId: '@serviceId',
        //         tagId: '@tagId'
        //     }, {
        //         get: {
        //             method: "GET",
        //             isArray: true
        //         }
        //     })
        // };

        /* -------------------------------------------- SERVICE PART -------------------------------------------- */
        // _this.GetTreadmill = function () {
        //     return _this.resources.GetTreadmill.get().$promise;
        // };

        _this.GetTreadmillByTags = function (tags) {
            return _this.resources.feed.post({ tags: tags }).$promise;
        };

        // _this.updateFeed = function (fromDate) {
        //     return _this.resources.updateFeed.get({ fromDate: fromDate }).$promise;
        // };

        _this.updateFeedByTags = function (tags, fromDate) {
            return _this.resources.feed.update({ tags: tags, fromDate: fromDate }).$promise;
        };

        _this.getCientHistory = function (hash) {
            return _this.resources.getCientHistory.get({ hash: hash }).$promise;
        };

        // _this.getTags = function (serviceId) {
        //     return _this.resources.tags.get({ serviceId: serviceId }).$promise;
        // };

        // _this.addTags = function (serviceId, tagId) {
        //     return _this.resources.tags.save({ serviceId: serviceId, tagId: tagId }).$promise;
        // };

        // _this.deleteTags = function (serviceId, tagId) {
        //     return _this.resources.tags.delete({ serviceId: serviceId, tagId: tagId }).$promise;
        // };

        return _this;
    }
})();

/**
 * Created by kosski on 09.09.2016.
 */

+function () {
  'use strict';
  // const clearShiftsUrl = 'common/consultant/TimeShifts';
  // const getShiftsUrl = 'common/consultant/TimeShifts/';
  // const saveTimeShifts = 'common/consultant/TimeShifts';

  angular
    .module('Resources')
    .factory('TSRsc', TSRsc);


  /** @ngInject */
  function TSRsc(ResourceBuilder, consts) {
    var _this = {};

    var resource = [
      {
        name: 'timeshifts',
        url: 'common/consultant/TimeShifts',
        withRole: false,
        methods: {
          get: {
            method: 'GET',
            isArray: true
          },
          save: {
            method: 'POST'
          },
          update: {
            method: 'PUT'
          }
        }
      }
    ];
    _this.resource = ResourceBuilder.buildAll(resource);


    _this.getTimeShifts = function () {
      // var resource = $resource(consts.api + getShiftsUrl,
      //   {},
      //   {
      //     get: {
      //       method: "GET",
      //       isArray: true
      //     }
      //   });
      return _this.resource.timeshifts.get().$promise;
    };
    _this.saveTimeShifts = function (saveData) {
      // var resource = $resource(consts.api + saveTimeShifts,
      //   '@saveData');
      return _this.resource.timeshifts.save(saveData).$promise;
    };
    _this.clearTimeShifts = function (processData) {
      // var resource = $resource(consts.api + clearShiftsUrl,
      //   '@processData', {
      //     update: {
      //       method: "PUT"
      //     }
      //   });
      return _this.resource.timeshifts.update(processData).$promise;
    };
    return _this;
  }
}();

/**
 * Created by kosski on 09.09.2016.
 */

+ function () {
  'use strict';

  angular
    .module('Resources')
    .factory('templatesRsc', templatesRsc);


  /** @ngInject */
  function templatesRsc($templateCache, $sce, $templateRequest, $q) {
    var _this = {};

    _this.Action = Action;
    _this.GetTemplate = getTemplate;
    _this.getFieldTemplate = getFieldTemplate;
    _this.getUniTemplate = getUniTemplate;
    _this.getFieldTypes = getFieldTypes;
    _this.templates = [
      // {
      //   key: 'partnerProfile',
      //   url: 'app/main/contactcenter/dashboard/profilemanagement/templates/partnerprofile.html'
      // }, {
      //   key: 'partnerMail',
      //   url: 'app/main/contactcenter/dashboard/profilemanagement/templates/partnermail.html'
      // }, {
      //   key: 'userProfile',
      //   url: 'app/main/contactcenter/dashboard/profilemanagement/components/userlist/template/userprofile.html'
      // }, {
      //   key: 'userEdit',
      //   url: 'app/main/contactcenter/dashboard/profilemanagement/components/userlist/template/useredit.html'
      // },{
      //   key: 'consultantEdit',
      //   url: 'app/main/contactcenter/management/callcenters/components/consultantlist/template/consultantedit.html'
      // },
        {
        key: 'reportFilters',
        url: 'app/main/contactcenter/reports/template/reportservice.html'
      },
      {
        key: 'monitoring',
        url: 'app/main/contactcenter/callsonline/template/monitoring.html'
      },
      {
        key: 'serviceView',
        url: 'app/main/contactcenter/management/services/templates/serviceview.html'
      }, {
        key: 'confirmDelete',
        url: 'app/main/services/confirmDialog/templates/confirmdelete.html'
      }, {
        key: 'confirmFileUpload',
        url: 'app/main/services/confirmDialog/templates/confirmfileupload.html'
      }, {
        key: 'confirmDefault',
        url: 'app/main/services/confirmDialog/templates/confirmDefault.html'
      }, {
        key: 'confirmBreakSessionBehavior',
        url: 'app/toolbar/confirmBreakSessionBehavior.html'
      }, {
        key: 'confirmEndSession',
        url: 'app/main/contactcenter/communicator/dialogs/confirmEndSession/confirmEndSession.html'
      }, {
        key: 'setTags',
        url: 'app/main/contactcenter/communicator/dialogs/setTags/setTags.html'
      }, {
        key: 'ta-text',
        label: 'Pole tekstowe',
        url: 'app/main/contactcenter/management/services/templates/tatext.html',
        fieldIcon: 'icon-note-text'
      }, {
        key: 'ta-number',
        label: 'Pole typu liczba',
        url: 'app/main/contactcenter/management/services/templates/tanumber.html',
        fieldIcon: 'icon-numeric'
      }, {
        key: 'ta-date',
        label: 'Pole typu data',
        url: 'app/main/contactcenter/management/services/templates/tadate.html',
        fieldIcon: 'icon-calendar'
      },{
        key: 'ta-between',
        label: 'Pole typu data',
        url: 'app/main/contactcenter/management/services/templates/tabetween.html',
        fieldIcon: 'icon-calendar-clock'
      },{
        key: 'ta-sort',
        label: 'Sortowanie',
        url: 'app/main/contactcenter/management/services/templates/tasort.html',
        fieldIcon: 'icon-sort'
      },{
        key: 'ta-params',
        label: 'Sortowanie',
        url: 'app/main/contactcenter/management/services/templates/taparams.html',
        fieldIcon: 'icon-sort'
      },{
        key: 'ta-search',
        label: 'Sortowanie',
        url: 'app/main/contactcenter/management/services/templates/tasearch.html',
        fieldIcon: 'icon-sort'
      },{
        key: 'ta-singleselect',
        label: 'Lista rozwijana',
        url: 'app/main/contactcenter/management/services/templates/taselect.html',
        fieldIcon: 'icon-wunderlist',
        withSource: true
      }, {
        key: 'ta-filter-select',
        label: 'Lista rozwijana',
        url: 'app/main/contactcenter/management/services/templates/filterselect.html',
        fieldIcon: 'icon-wunderlist',
        withSource: true
      },{
        key: 'ta-radio',
        label: 'Jednokrotny wybór',
        url: 'app/main/contactcenter/management/services/templates/taradio.html',
        fieldIcon: 'icon-radiobox-marked',
        withSource: true
      }, {
        key: 'ta-checkbox',
        label: 'Wielokrotny wybór',
        template: '<ta-checkbox ng-model="vm.settings[%pn]" out-value="vm.settings[%pn]" source="field.source" translation="field.translation"  ></ta-checkbox>',
        fieldIcon: 'icon-checkbox-marked-outline',
        withSource: true
      },
      // {
      //   key: 'consultant-details',
      //   url: 'app/main/contactcenter/management/callcenters/components/consultantlist/template/consultantdetails.html'
      // },
      // {
      //   key: 'callcenter-details',
      //   url: 'app/main/contactcenter/management/callcenters/templates/callcenterdetails.html'
      // },
      {
        key: 'callcenter-edit',
        url: 'app/main/contactcenter/management/callcenters/templates/callcenteredit.html'
      },
      // {
      //   key: 'group-details',
      //   url: 'app/main/contactcenter/management/callcenters/templates/groupdetails.html'
      // }, {
      //   key: 'group-edit',
      //   url: 'app/main/contactcenter/management/callcenters/templates/groupedit.html'
      // },
      {
        key: 'client-info',
        url: 'app/main/contactcenter/party/templates/clientinfo.html'
      }, {
        key: 'jira-issue-dialog',
        url: 'app/main/contactcenter/components/issueTracker/components/jira/issueDialog/jiraissuedialog.html'
      }, {
        key: 'bugzilla-issue-dialog',
        url: 'app/main/contactcenter/components/issueTracker/components/bugzilla/issueDialog/bugzillaissuedialog.html'
      }, {
        key: 'mailList',
        url: 'app/main/contactcenter/orderbox/template/itemslist.html'
      },
      {
        key: 'payment-call',
        url: 'app/main/contactcenter/templates/paymentcall.html'
      },
      //  {
      //   key: 'ccGroupList',
      //   url: 'app/main/contactcenter/management/callcenters/templates/groupslist.html'
      // }, {
      //   key: 'ccConsultantList',
      //   url: 'app/main/contactcenter/management/consultants/templates/consultantslist.html'
      // },
      {
        key: 'default',
        template: '<%ft conf="field" ng-model="vm.settings.%pn"></%ft>'
      }, {
        key: 'defaultSidenav',
        template: 'brak templatki'
      }
    ];

    function init() {
      _this.promList = [];
      _this.templates.forEach(function (element) {
        if (element.template) {
          cacheItBebe(element.key)(element.template);
        } else {
          _this.promList.push(templateRequest(element.url, element.key));
        }
      });
      console.log('Templates Loaded!');
    }

    init();

    function templateRequest(templateDir, key) {
      var url = $sce.getTrustedResourceUrl(templateDir);
      var promise = $templateRequest(url)
        .then(cacheItBebe(key),
          function (err) {
            cacheItBebe('defaultSidenav');
          });
      return promise;
    }

    function cacheItBebe(key) {
      return function (template) {
        $templateCache.put(key, template);
      }
    }


    function Action(id, condition, name, params, start, stop, type, url) {
      this.id = id;
      this.condition = condition;
      this.name = name;
      this.params = params;
      this.start = start;
      this.stop = stop;
      this.type = type;
      this.url = url;
    }

    function getTemplate(type) {
      // var template = $templateCache.get(type.toLowerCase());
      return $q(function (resolve, reject) {
        if ($templateCache.get(type)) {
          resolve($templateCache.get(type));
        }
        $q.all(_this.promList).then(function (s) {
          if ($templateCache.get(type)) {
            resolve($templateCache.get(type));
          } else {
            var result = $templateCache.get('default')
            result = result.replace(/%ft/g, type.toLowerCase());

            resolve(result);
          }
        })
      });
    }

    function getFieldTemplate(fieldinfo, keyName) {
      return $q(function (resolve, reject) {
        buildTemplate(fieldinfo, keyName).then(function (result) {
          resolve(result);
        });
      });
    }

    function buildTemplate(fieldinfo, keyName) {
      return $q(function (resolve, reject) {
        getTemplate(fieldinfo.Type.toLowerCase()).then(function (result) {
          if (fieldinfo.Type) {
            result = result.replace(/%ft/g, fieldinfo.Type.toLowerCase());
          }
          if (fieldinfo.token) {
            result = result.replace(/%translate/g, fieldinfo.token);
          }
          if (keyName) {
            if (angular.isArray(keyName)) {
              keyName.forEach(function (parameter) {
                result = result.replace(new Regex('/%' + parameter.token + '/g'), parameter.value);
              });
            } else {
              result = result.replace(/%pn/g, keyName);
            }
          }
          resolve(result);
        });
      });
    }

    function getUniTemplate(templateName, fieldinfo) {
      return $q(function (resolve, reject) {
        buildUniTemplate(templateName, fieldinfo).then(function (result) {
          resolve(result);
        });
      });
    }

    function buildUniTemplate(templateName, fieldinfo) {
      return $q(function (resolve, reject) {
        getTemplate(templateName).then(function (result) {
          fieldinfo.forEach(function (parameter) {
            var regex = new RegExp('%' + parameter.token, 'g');
            result = result.replace(regex, parameter.value);
          });
          resolve(result);
        });
      });
    }

    function getFieldTypes() {


      var formTemplates = _.filter(_this.templates, function (element) {
        return element.fieldIcon !== undefined;
      });


      return formTemplates.map(function (element, index) {
        if (element.fieldIcon) {
          return {
            name: capitalizeFirstLetter(element.key.replace('ta-', '')),
            fieldIcon: element.fieldIcon,
            label: element.label,
            templateKey: element.key,
            withSource: element.withSource
          };
        };
      });
    }

    function capitalizeFirstLetter(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }

    return _this;
  }
}();

/**
 * Created by kosski on 09.09.2016.
 */

+function () {
  'use strict';

  angular
    .module('Resources')
    .factory('tagsRsc', tagsRsc);

  const tagsUrl = 'CallCenterServices/tags';

  /** @ngInject */
  function tagsRsc(ResourceBuilder) {
    var _this = {};
    // _this.newResources = {
    //   tags: $resource(consts.api + tagsUrl + '/:serviceId/:tagId',
    //     {
    //       serviceId: '@serviceId',
    //       tagId: '@tagId'
    //     }, {
    //       get: {
    //         method: 'GET',
    //         isArray: true
    //       },
    //       post: {
    //         method: 'POST',
    //         params: '@data'
    //       },
    //       put: {
    //         method: 'PUT',
    //         params: '@data'
    //       },
    //       delete: {
    //         method: 'DELETE',
    //         headers: { 'Content-Type': 'application/json' }
    //       }
    //     })
    //   // tags: $resource(consts.api + tagsUrl,
    //   //   '@data',
    //   //   {
    //   //     post: {
    //   //       method: 'POST'
    //   //     },
    //   //     put: {
    //   //       method: 'PUT'
    //   //     }
    //   //   })
    // };

    _this.newResources = [
      {
        name: 'tags',
        url: 'tags',
        withRole: true,
        methods: {
          get: {
            method: 'GET',
            isArray: true
          },
          put: {
            method: 'PUT',
          }
        }
      },
      {
        name: 'serviceTags',
        url: 'ccservices/tags',
        withRole: true,
        methods: {
          get: {
            url: '/:serviceId',
            method: 'GET',
            isArray: true
          },
          post: {
            method: 'POST',
          },
          put: {
            method: 'PUT',
          },
          delete: {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' }
          }
        }
      },
      {
        name: 'serviceTagsAll',
        url: 'ccservices/tagsall',
        withRole: true,
        methods: {
          get: {
            url: '/:serviceId',
            method: 'GET',
            isArray: true
          }
        }
      }
    ];


    _this.resources = ResourceBuilder.buildAll(_this.newResources);


    _this.getTags = function () {
      return _this.resources.tags.get().$promise;
    };
    _this.addNewTag = function (tag, parentId) {
      return _this.resources.tags.put({tagId: tag.tagId, token: tag.token, tag: tag.token, parentId: parentId }).$promise;
    };


    _this.getServiceTags = function (serviceId) {
      return _this.resources.serviceTags.get({ serviceId: serviceId }).$promise;
    };
    _this.addServiceTags = function (serviceId, tagId) {
      return _this.resources.serviceTags.post({ serviceId: serviceId, tagId: tagId }).$promise;
    };

    _this.deleteServiceTags = function (serviceId, tagId) {
      return _this.resources.serviceTags.delete({ serviceId: serviceId, tagId: tagId }).$promise;
    };

    _this.addServiceNewTag = function (serviceId, tag, parentId) {
      return _this.resources.serviceTags.put({ serviceId: serviceId, tagId: tag.tagId, token: tag.token, tag: tag.token, parentId: parentId }).$promise;
    };

    _this.getServiceTagsAll = function (serviceId) {
      return _this.resources.serviceTagsAll.get({ serviceId: serviceId }).$promise;
    };

    return _this;
  }
}();

/**
 * Created by kosski on 09.09.2016.
 */

+ function () {
  'use strict';

  angular
    .module('Resources')
    .factory('surveyRsc', surveyRsc);

  /** @ngInject */
  function surveyRsc(ResourceBuilder, consts) {
    var _this = {};

    _this.newResources = [{
      name: 'surveyMgt',
      url: 'CCSurveys',
      withRole: true,
      methods: {
        get: {
          url: '/:surveyId',
          method: 'GET',
          isArray: true
        },
        save: {
          method: 'POST',
        },
        update: {
          method: 'PUT',
        },
        getList: {
          method: 'GET',
          isArray: true
        },
        // ,
        // delete: {
        //   method: 'DELETE',
        //   headers: { 'Content-Type': 'application/json' }
        // }
      }
    }, {
      name: 'answer',
      url: 'common/SurveyPart/answer',
      withRole: false,
      methods: {
        get:{
          url:'/:serviceId/:surveyId/:contactId/:date',
          method: 'GET',
          isArray: true
        },
        save: {
          method: 'POST',
        }
      }
    }, {
      name: 'surveyService',
      url: 'SurveyService/:serviceId/:surveyId',
      withRole: true,
      methods: {
        get: {
          url: 'common/SurveyPart/SurveyService/:serviceId',
          method: 'GET',
          withRole: false,
          isArray: true
        },
        add: {
          method: 'POST',
        },
        delete: {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json'
          }
        }
      }
    }];

    _this.resources = ResourceBuilder.buildAll(_this.newResources);

    _this.getAvaliableSurveys = function () {
      return _this.resources.surveyMgt.getList({
      }).$promise;
    };

    _this.saveSurvey = function (survey) {
      return _this.resources.surveyMgt.save(survey).$promise;
    };

    _this.updateSurvey = function (survey) {
      return _this.resources.surveyMgt.update(survey).$promise;
    };



    // _this.getSurvey = function (surveyId) {
    //   return _this.resources.survey.get({ //chyba jest nie używane AK 1711114
    //     surveyId: surveyId
    //   }).$promise;
    // };



    _this.getServiceSurveys = function (serviceId) {
      return _this.resources.surveyService.get({
        serviceId: serviceId
      }).$promise;
    };

    _this.addServiceSurvey = function (serviceId, surveyId) {
      return _this.resources.surveyService.add({
        serviceId: serviceId,
        surveyId: surveyId
      }).$promise;
    };

    _this.deleteServiceSurvey = function (serviceId, surveyId) {
      return _this.resources.surveyService.delete({
        serviceId: serviceId,
        surveyId: surveyId
      }).$promise;
    };



    _this.answerSurvey = function (surveyId, serviceId, contactId, answers) {
      return _this.resources.answer.save({
        surveyId: surveyId,
        serviceId: serviceId,
        contactId: contactId,
        answers: answers
      }).$promise;
    };
    _this.getAnswerSurvey = function (surveyId, serviceId, contactId, date) {
      return _this.resources.answer.get({
        surveyId: surveyId,
        serviceId: serviceId,
        contactId: contactId,
        date: date
      }).$promise;
    };
    return _this;
  }
}();

/**
 * Created by kosski on 07.09.2016.
 */
+function () {
  'use strict';
  const tokenUrl = 'token';
  const obtainUrl = 'account/ObtainLocalAccessToken';
  const registerUrl = 'account/registerexternal';
  const accountUrl = 'Account/Login';
  const activityUrl = 'Account/changeactive/:active';
  angular
    .module('Resources')
    .factory('AuthResource', LoginRsc);

  /** @ngInject */
  function LoginRsc(ResourceBuilder, $q, DynamicFactory) {
    var _this = {};
    _this.resource = [{
      name: 'status',
      url: 'common/consultant/status',
      withRole: false,
      methods: {
        get: {
          method: 'GET',
          isArray: true
        },
        setStatus: {
          // url: '/:status/:phoneNumer',
          method: 'PUT'
        }
      }
    },
    {
      name: 'status2',
      url: 'common/consultant',
      withRole: false,
      methods: {
        setStatus2: {
          url: '/status2',
          method: 'PUT'
        }
      }
    },
    {
      name: 'state',
      url: 'common/consultant/state',
      withRole: false,
      methods: {
        setState: {
          url: '/:isLogin',
          method: 'PUT'
        }
      }
    }, {
      name: 'phone',
      url: 'common/consultant/phone',
      withRole: false,
      methods: {
        query: {
          method: 'POST'
        }
      }
    },{
      name: 'phonedt',
      url: 'common/consultant/phonedt',
      withRole: false,
      methods: {
        query: {
          method: 'POST'
        }
      }
    }, {
      name: 'token',
      url: 'token',
      withRole: false,
      methods: {
        query: {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      }
    }, {
      name: 'remoteToken',
      url: 'Account/RemoteLogin',
      withRole: false,
      methods: {
        get: {
          method: 'GET'
        }
      }

    }, {
      name: 'login',
      url: 'Account/Login',
      withRole: false,
      methods: {
        query: {
          method: 'POST'
        }
      }
    }];

    _this.resouces = ResourceBuilder.buildAll(_this.resource);

    _this.GetAvableStatuses = function () {
      return _this.resouces.status.get().$promise;
    };

    _this.setStatus = function (status, phoneNumer,sessionBehavior,services) {
      return $q(function (resolve, reject) {
        _this.resouces.status.setStatus({
          status: status,
          phoneNumber: phoneNumer,
          sessionBehavior:sessionBehavior,
          service:services
        }).$promise.then(function (result) {
          console.log('Consultant is now: ', status === 1 ? 'Online' : 'Offline');
          resolve(result);
        }, function (err) {
          console.log('Consultant status error');
          reject(err);
        });
      });
    };

    _this.setStatus2 = function (status, phoneNumer,sessionBehavior,services) {
      return $q(function (resolve, reject) {
        _this.resouces.status2.setStatus2({
          status: status,
          phoneNumber: phoneNumer,
          sessionBehavior:sessionBehavior,
          services:services
        }).$promise.then(function (result) {
          console.log('Consultant is now: ', status === 1 ? 'Online' : 'Offline');
          resolve(result);
        }, function (err) {
          console.log('Consultant status error');
          reject(err);
        });
      });
    };


    _this.querryToken = function (data) {
      return _this.resouces.token.query(data).$promise;
    };

    _this.querryLogin = function (data) {
      return _this.resouces.login.query(data).$promise;
    };

    _this.remoteToken = function (data) {
      return _this.resouces.remoteToken.get({guid:data}).$promise;
    };

    _this.setPhone = function (data) {
      return _this.resouces.phone.query(data).$promise;
    };

    _this.setPhoneDt = function (data) {
      return _this.resouces.phonedt.query(data).$promise;
    };


    _this.changeStatus = function (active) {
      return _this.resouces.get({
        active: active
      }).$promise;
    };

    _this.changeState = function (isLogin) {
      return _this.resouces.state.setState({
        isLogin: isLogin
      }).$promise;
    };
    return _this;
  }
}();

/**
 * Created by kosski on 09.09.2016.
 */

+ function () {
  'use strict';

  angular
    .module('Resources')
    .factory('servicesRsc', servicesRsc);

  /** @ngInject */
  function servicesRsc(ResourceBuilder, $resource, consts, $templateCache, $sce, $templateRequest, $q) {
    var _this = {};

    _this.newResources = [{
        name: 'service',
        url: 'ccservices/service',
        withRole: true,
        methods: {
          get: {
            url: '/:serviceId/:serviceType',
            method: 'GET'
          },
          querry: {
            url: 'ccservices/services',
            method: 'GET',
            withRole: true,
            isArray: true
          },
          post: {
            method: 'POST',
            isArray: true
          },
          update: {
            method: 'PUT'
          },
          save: {
            method: 'POST'
          }
        }
      },
      {
        name: 'template',
        url: 'ccservices/template',
        withRole: true,
        methods: {
          get: {
            url: '/:templateId',
            method: 'GET'
          },
          list: {
            // url: '/list',
            method: 'GET',
            isArray: true
          }
        }
      },
      {
        name: 'actions',
        url: 'appaction/actions',
        withRole: true,
        methods: {
          get: {
            url: '/:applicationId',
            method: 'GET'
          },
          save: {
            method: 'POST',
            isArray: true
          }
        }
      },
      {
        name: 'guid',
        url: 'appaction/guid',
        withRole: true,
        methods: {
          get: {
            method: 'GET'
          }
        }
      },
      // {
      //   name: 'serviceBasic',
      //   url: 'ccservices/serviceBasic/:serviceId',
      //   withRole: true,
      //   methods: {
      //     get: {
      //       method: 'GET'
      // }
      //   }
      // },
      {
        name: 'availableActions',
        url: 'common/ccservices/availableActions/:serviceType',
        withRole: false,
        methods: {
          get: {
            method: 'GET',
            isArray: true
          }
        }
      },
      {
        name: 'firstSmSServiceFromBundle',
        url: 'common/ccservices/firstSmSServiceFromBundle/:serviceID',
        withRole: false,
        methods: {
          get: {
            method: 'GET'
          }
        }
      },
      {
        name: 'servicesBundleFlatGet',
        url: 'common/ccservices/servicesBundleFlatGet/:serviceID',
        withRole: false,
        methods: {
          get: {
            method: 'GET'
          }
        }
      },
      {
        name: 'servicesBundleFlatGet2',
        url: 'common/ccservices/servicesBundleFlatGet2/:bundleID',
        withRole: false,
        methods: {
          get: {
            method: 'GET'
          }
        }
      },
      {
        name: 'getServiceTypes',
        url: 'common/ccservices/getServiceTypes',
        withRole: false,
        methods: {
          get: {
            method: 'GET',
            isArray: true
          }
        }
      }, {
        name: 'getConsultantServices',
        url: 'common/ccservices/getConsultantServices',
        withRole: false,
        methods: {
          get: {
            method: 'GET',
            isArray: true
          }
        }
      },{
        name: 'getConsultantServicesAll',
        url: 'common/ccservices/getConsultantServicesAll',
        withRole: false,
        methods: {
          get: {
            method: 'GET',
            isArray: true
          }
        }
      },
      {
        name: 'getActionConfiguration',
        url: 'common/ccservices/getActionConfiguration',
        withRole: false,
        methods: {
          post: {
            method: 'POST'
          }
        }
      },
      {
        name: 'getNumberList',
        url: 'ccservices/getNumberList',
        withRole: true,
        methods: {
          post: {
            method: 'POST',
            isArray: true
          }
        }
      },
      {
        name: 'getMailList',
        url: 'ccservices/getMailList',
        withRole: true,
        methods: {
          post: {
            method: 'POST',
            isArray: true
          }
        }
      },
      {
        name: 'serviceDeactivate',
        url: 'ccservices/serviceDeactivate',
        withRole: true,
        methods: {
          post: {
            method: 'POST'
          }
        }
      },
      {
        name: 'serviceActivate',
        url: 'ccservices/serviceActivate',
        withRole: true,
        methods: {
          post: {
            method: 'POST'
          }
        }
      }
    ];

    _this.resources = ResourceBuilder.buildAll(_this.newResources);

    _this.resource = {

      getPartners: $resource(consts.api + "Client/UserPartners/", {}, {
        get: {
          method: "GET",
          isArray: true
        }
      }),

    };

    /*------------------------------MODELS---------------------------------------------- */
    _this.ServiceItem = function (id, name, number,
      email, price, service,
      priority, type, startDate,
      endDate, startTime, endTime,
      partnerId, userId, reservationID,
      serviceCountry, serviceDesc, dniId, photoUrl, slotsDataSend, tags, premiumNumberPrefix,
      mailBoxId, pattern, color, payment, chatBackgroundURL, chatMainColor, chatSecondaryColor,templateId) {
      this.ServiceId = id || null;
      this.ServiceName = name || "";
      this.PremiumNumber = number || "";
      this.Email = email || "";
      this.Price = price || 0;
      this.StartDate = startDate || null;
      this.StartTime = startTime || 0;
      this.ServicePartnerId = partnerId || 0;
      this.UserId = userId || null;
      this.StopDate = endDate || null;
      this.EndTime = endTime || 0;
      this.Priority = priority || null;
      this.Type = type || null;
      this.ReservationID = reservationID || null;
      this.ServiceCountry = serviceCountry || "";
      this.ServiceDesc = serviceDesc || "";
      this.DniID = dniId || null;
      this.photoUrl = photoUrl || "";
      this.slotsDataSend = slotsDataSend || "";
      this.tags = tags || "";
      this.premiumNumberPrefix = premiumNumberPrefix || "";
      this.mailBoxId = mailBoxId || null;
      this.pattern = pattern || "";
      this.color = color || "";
      this.payment = payment || null;

      this.chatBackgroundURL = chatBackgroundURL || "";
      this.chatMainColor = chatMainColor || "";
      this.chatSecondaryColor = chatSecondaryColor || "";
      if(templateId){
        this.templateId = templateId;
      }

    };

    _this.ActionConfigurationItem = function (assemblyName, serviceType) {
      this.AssemblyName = assemblyName;
      this.ServiceType = serviceType;
    };

    _this.NumberListItem = function (partnerId, serviceType) {
      this.partnerId = partnerId;
      this.serviceType = serviceType;
    };
    _this.MailListItem = function (partnerId, callCenterId, userId) {
      this.partnerId = partnerId;
      this.callCenterId = callCenterId;
      this.userId = userId;
    };
    /* -------------------------------------------- SERVICE PART -------------------------------------------- */
    _this.GetService = function (serviceId, serviceType) {
      return _this.resources.service.get({
        serviceId: serviceId,
        serviceType: serviceType
      }).$promise;
    };

    // _this.serviceBasic = function (serviceId) {
    //   return _this.resources.serviceBasic.get({ serviceId: serviceId }).$promise;
    // };

    _this.availableActions = function (serviceType) {
      return _this.resources.availableActions.get({
        serviceType: serviceType
      }).$promise;
    };

    _this.firstSmSServiceFromBundle = function (serviceID) {
      return _this.resources.firstSmSServiceFromBundle.get({
        serviceID: serviceID
      }).$promise;
    };

    _this.servicesBundleFlatGet = function (serviceID) {
      return _this.resources.servicesBundleFlatGet.get({
        serviceID: serviceID
      }).$promise;
    };

    _this.servicesBundleFlatGet2 = function (bundleID) {
      return _this.resources.servicesBundleFlatGet2.get({
        bundleID: bundleID
      }).$promise;
    };

    _this.getServiceTypes = function () {
      return _this.resources.getServiceTypes.get().$promise;
    };

    _this.getConsultantServices = function () {
      return _this.resources.getConsultantServices.get().$promise;
    };
    _this.getConsultantServicesAll = function () {
      return _this.resources.getConsultantServicesAll.get().$promise;
    };

    _this.getActionConfiguration = function (assemblyName, serviceType) {
      var data = new _this.ActionConfigurationItem(assemblyName, serviceType);
      return _this.resources.getActionConfiguration.post(data).$promise;
    };
    _this.getNumberList = function (numberList) {
      var data = new _this.NumberListItem(numberList.partnerId, numberList.serviceType);
      return _this.resources.getNumberList.post(data).$promise;
    };

    _this.getMailList = function (mailList) {
      var data = new _this.MailListItem(mailList.partnerId, null, null);
      return _this.resources.getMailList.post(data).$promise;
    };

    _this.GetServices = function () {
      return _this.resources.service.querry().$promise;
    };

    _this.saveService = function (service) {
      var data = new _this.ServiceItem(
        service.serviceID, service.serviceName, service.premiumNumber,
        service.email, service.unitPrice, service.serviceName,
        service.priority, service.type, service.startDate,
        service.stopDate, service.hourStart, service.hourStop,
        service.servicePartnerID, service.userId, service.reservationTypeID,
        service.serviceCountry, service.serviceDesc, service.dniConfigID, "",
        service.slotsDataSend, service.tags, service.premiumNumberPrefix, service.mailBoxId, service.pattern, service.color,
        service.payment, service.chatBackgroundURL, service.chatMainColor, service.chatSecondaryColor,service.templateId
      );
      return _this.resources.service.save(data).$promise;

    };


    _this.updateService = function (service) {
      // var _this = this;
      var data = new _this.ServiceItem(
        service.serviceID, service.serviceName, service.premiumNumber,
        service.email, service.unitPrice, service.serviceName,
        service.priority, service.type, service.startDate,
        service.stopDate, service.hourStart, service.hourStop,
        service.servicePartnerID, service.userId, service.reservationTypeID,
        service.serviceCountry, service.serviceDesc, service.dniConfigID, service.photoUrl,
        service.slotsDataSend, service.tags, service.premiumNumberPrefix, service.mailBoxId, service.pattern, service.color,
        service.payment, service.chatBackgroundURL, service.chatMainColor, service.chatSecondaryColor
      );
      return _this.resources.service.update(data).$promise;
    };

    _this.serviceDeactivate = function (service) {
      var data = new _this.ServiceItem(
        service.serviceID, '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''
      );
      return _this.resources.serviceDeactivate.post(data).$promise;
    };

    _this.serviceActivate = function (service) {
      var data = new _this.ServiceItem(
        service.serviceID, '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''
      );
      return _this.resources.serviceActivate.post(data).$promise;
    };

    _this.getPartners = function () {
      return _this.resource.getPartners.get().$promise;
    };

    _this.GetApplication = function (applicationId) {
      return _this.resources.actions.get({
        applicationId: applicationId
      }).$promise;
    };

    _this.PutJson = function (data) {
      return _this.resources.actions.save(data).$promise;
    };

    _this.GetGuid = function () {
      return _this.resources.guid.get().$promise;
    };

    _this.GetTemplate = function (templateId) {
      return _this.resources.template.get({
        templateId: templateId
      }).$promise;
    };

    _this.GetTemplateList = function () {
      return _this.resources.template.list().$promise;
    };

    return _this;
  }
}();

/**
 * Created by kosski on 09.09.2016.
 */

+function () {
    'use strict';

    angular
        .module('Resources')
        .factory('serviceActionsRsc', serviceActionsRsc);

    // const contentUrl = 'cc/content/';
    // const deletecontentUrl = 'cc/deletecontent';
    const ActionConsultantListUrl = 'ActionCallCenter/';
    const ConsultantDeleteUrl = 'ActionCallCenter/ConsultantDelete';
    const ConsultantInsertUrl = 'ActionCallCenter/ConsultantInsert';
    const GroupDeleteUrl = 'ActionCallCenter/GroupDelete';
    const GroupInsertUrl = 'ActionCallCenter/GroupInsert';
    const getCallCenterGroupsUrl = 'ActionCallCenter/CallcenterGroups';
    const getConsultantsOfGroupsUrl = 'ActionCallCenter/getConsultantsOfGroups';
    // const GetConsultantsInUrl = 'CallCenterGroups/GetConsultantsIn/';

    /** @ngInject */
    function serviceActionsRsc(ResourceBuilder) {
        var _this = {};

        _this.newResources = [
            {
                name: 'consultants',
                url: 'serviceactions/callcenter/consultants',
                withRole: true,
                methods: {
                    get: {
                        url: '/:actionId',
                        method: 'GET',
                        isArray: true
                    },
                    save: {
                        method: 'POST'
                    },
                    delete: {
                        method: 'DELETE',
                        headers: { 'Content-Type': 'application/json' }
                    }
                }
            },
            {
                name: 'groups',
                url: 'serviceactions/callcenter/group',
                withRole: true,
                methods: {
                    get: {
                        url: '/:callCenterID',
                        method: 'GET',
                        isArray: true
                    },
                    save: {
                        method: 'POST'
                    },
                    delete: {
                        method: 'DELETE',
                        headers: { 'Content-Type': 'application/json' }
                    }
                }
            },
            {
                name: 'getConsultantsOfGroups',
                url: 'serviceactions/callcenter/getConsultantsOfGroups',
                withRole: true,
                methods: {
                    query: {
                        method: 'POST',
                        isArray: true
                    }
                }
            },
            {
                name: 'setConsultantsAction',
                url: 'serviceactions/callcenter',
                withRole: true,
                methods: {
                    query: {
                        method: 'POST'
                    }
                }
            }
        ];



        _this.resources = ResourceBuilder.buildAll(_this.newResources);

        // _this.resource = {
        // ActionConsultantList: $resource(consts.api + ActionConsultantListUrl + ':actionId',
        //     {
        //         actionId: '@actionId'
        //     }, {
        //         get: {
        //             method: "GET",
        //             isArray: true
        //         }
        //     }),
        // GetConsultantsIn: $resource(consts.api + GetConsultantsInUrl + ':groupId',
        //     { groupId: '@groupId' },
        //     {
        //         get: {
        //             method: "GET",
        //             isArray: true
        //         }
        //     }),
        // GetConsultantsInGroups: $resource(consts.api + getConsultantsOfGroupsUrl,
        //     '@data', {
        //         save: {
        //             method: "POST"
        //         }
        //     }),
        // ConsultantInsert: $resource(consts.api + ConsultantInsertUrl,
        //     '@data', {
        //         save: {
        //             method: "POST"
        //         }
        //     }),
        // ConsultantDelete: $resource(consts.api + ConsultantDeleteUrl,
        //     '@data', {
        //         save: {
        //             method: "POST"
        //         }
        //     }),
        // GroupInsert: $resource(consts.api + GroupInsertUrl,
        //     '@data', {
        //         save: {
        //             method: "POST"
        //         }
        //     }),
        // GroupDelete: $resource(consts.api + GroupDeleteUrl,
        //     '@data', {
        //         save: {
        //             method: "POST"
        //         }
        //     }),
        // };

        _this.ActionConsultantList = function (actionId) {
            return _this.resources.consultants.get({
                actionId: actionId
            }).$promise;
        };

        _this.getGroups = function (callCenterID) {
            return _this.resources.groups.get({
                callCenterID: callCenterID
            }).$promise;
        };

        // _this.GetConsultantsIn = function (groupId) {
        //     return _this.resource.GetConsultantsIn.get({ groupId: groupId }).$promise;
        // };

        _this.GetConsultantsInGroups = function (data) {
            return _this.resources.getConsultantsOfGroups.query(data).$promise;
        };

        _this.setConsultantsAction = function (data) {
          return _this.resources.setConsultantsAction.query(data).$promise;
        };

        _this.ConsultantInsert = function (consultantId, priority, actionId, userId) {
            var data = {
                consultantId: consultantId,
                priority: priority,
                actionId: actionId,
                userId: userId
            };
            return _this.resources.consultants.save(data).$promise;
        };

        _this.ConsultantDelete = function (consultantId, actionId) {
            var data = {
                consultantId: consultantId,
                actionId: actionId
            };
            return _this.resources.consultants.delete(data).$promise;
        };

        _this.GroupInsert = function (groupId, priority, actionId, userId) {
            var data = {
                groupId: groupId,
                priority: priority,
                actionId: actionId,
                userId: userId
            };
            return _this.resources.groups.save(data).$promise;
        };

        _this.GroupDelete = function (groupId, actionId) {
            var data = {
                groupId: groupId,
                actionId: actionId
            };
            return _this.resources.groups.delete(data).$promise;
        };



        return _this;
    }
}();

(function () {

  'use strict';

  angular
    .module('Resources')
    .factory('reportsCosult', reportsCosult);
  /** @ngInject */
  function reportsCosult(ResourceBuilder) {
    var _this = {};

    var resource = [{
      name: 'smslist',
      url: 'Reports/reportsSmsMessages',
      withRole: true,
      methods: {
        save: {
          method: 'POST',
          isArray: true
        }
      }
    },
    {
      name: 'ReportsSMSMessageListAgregation',
      url: 'Reports/ReportsSMSMessageListAgregation',
      withRole: true,
      methods: {
        save: {
          method: 'POST',
          isArray: true
        }
      }
    },
    {
      name: 'reportsSessions2ForChart',
      url: 'Reports/reportsSessions2ForChart',
      withRole: true,
      methods: {
        get: {
          method: 'POST',
          isArray: true
        }
      }
    },
    {
      name: 'smsMessagesForChart',
      url: 'Reports/reportsSmsMessagesForChart',
      withRole: true,
      methods: {
        get: {
          method: 'POST',
          isArray: true
        }
      }
    },
    {
      name: 'connections',
      url: 'Reports/reportsIVRConnections',
      withRole: true,
      methods: {
        save: {
          method: 'POST',
          isArray: true
        }
      }
    },
    {
      name: 'connectionsForChart',
      url: 'Reports/reportsConnectionsForChart',
      withRole: true,
      methods: {
        get: {
          method: 'POST',
          isArray: true
        }
      }
    },
    {
      name: 'ReportsConnectionsByCallCenterID',
      url: 'Reports/ReportsConnectionsByCallCenterID',
      withRole: true,
      methods: {
        save: {
          method: 'POST',
          isArray: true
        }
      }
    },
    {
      name: 'CallbackOrdersList',
      url: 'Reports/callbacksOrders/list',
      withRole: true,
      methods: {
        get: {
          method: 'POST',
          isArray: true
        }
      }
    },
    {
      name: 'CallbackOrdersChart',
      url: 'Reports/callbacksOrders/list/chart',
      withRole: true,
      methods: {
        get: {
          method: 'POST',
          isArray: true
        }
      }
    },
    {
      name: 'DownloadCallbackOrders',
      url: 'Reports/callbacksOrders/list/download',
      withRole: true,
      methods: {
        get: {
          method: 'POST',
          responseType: 'arraybuffer',
          transformResponse: function (data) {
            return {
              data: data,
            }
          },
        }
      }
    },
    {
      name: 'CallbackDetails',
      url: 'Reports/CallbackDetails',
      withRole: true,
      methods: {
        get: {
          url: '/:uniqueidentifier',
          method: 'GET',
          isArray: true
        }
      }
    },
    {
      name: 'CallbackAggregation',
      url: 'Reports/CallbackAggregation',
      withRole: true,
      methods: {
        save: {
          method: 'POST',
          isArray: false
        }
      }
    },
    // {
    //     name: 'AdminCallbackAggregation',
    //     url: 'admin/Reports/CallbackAggregation',
    //     withRole: false,
    //     methods: {
    //         save: {
    //             method: 'POST',
    //             isArray: false
    //         }
    //     }
    // },
    {
      name: 'ConsultantCallbackAggregation',
      url: 'consultant/Reports/CallbackAggregation',
      withRole: false,
      methods: {
        save: {
          method: 'POST',
          isArray: true
        }
      }
    },
    {
      name: 'ReportsConnectionsServiceAgr',
      url: 'Reports/ReportsConnectionsServiceAgr',
      withRole: true,
      methods: {
        save: {
          method: 'POST'
        }
      }
    },
    {
      name: 'ReportsConnectionsServiceAgrExport',
      url: 'Reports/ReportsConnectionsServiceAgrExport',
      withRole: true,
      methods: {
        save: {
          method: 'POST',
          responseType: 'arraybuffer',
          transformResponse: function (data, headersGetter) {
            return {
              data: data,
              headers: headersGetter
            }
          }
        }
      }
    },
    {
      name: 'ReportsConnectionsServiceAgrForChart',
      url: 'Reports/ReportsConnectionsServiceAgrForChart',
      withRole: true,
      methods: {
        save: {
          method: 'POST',
          isArray: true
        }
      }
    },
    {
      name: 'CallbackParamsAggregation',
      url: 'Reports/callbacksOrders/paramsAggregation',
      withRole: true,
      methods: {
        get: {
          method: 'POST',
          isArray: true
        }
      }
    },
    {
      name: 'CallbackParamsAggregationChart',
      url: 'Reports/callbacksOrders/paramsAggregation/chart',
      withRole: true,
      methods: {
        get: {
          method: 'POST',
          isArray: true
        }
      }
    },
    {
      name: 'ReportsConnectionsAgr',
      url: 'Reports/ReportsConnectionsAgr',
      withRole: true,
      methods: {
        save: {
          method: 'POST'
        }
      }
    },
    {
      name: 'ReportsConnectionsExport',
      url: 'Reports/reportsIVRConnectionsExport',
      withRole: true,
      methods: {
        save: {
          method: 'POST',
          responseType: 'arraybuffer',
          transformResponse: function (data, headersGetter) {
            return {
              data: data,
              headers: headersGetter
            }
          }
        }
      }
    },
    {
      name: 'reportsSmsMessagesExport',
      url: 'Reports/reportsSmsMessagesExport',
      withRole: true,
      methods: {
        save: {
          method: 'POST',
          responseType: 'arraybuffer',
          transformResponse: function (data, headersGetter) {
            return {
              data: data,
              headers: headersGetter
            }
          }
        }
      }
    },
    {
      name: 'reportsSessions2Export',
      url: 'Reports/reportsSessions2Export',
      withRole: true,
      methods: {
        save: {
          method: 'POST',
          responseType: 'arraybuffer',
          transformResponse: function (data, headersGetter) {
            return {
              data: data,
              headers: headersGetter
            }
          }
        }
      }
    },
    {
      name: 'ReportsConnectionsAgrExport',
      url: 'Reports/ReportsConnectionsAgrExport',
      withRole: true,
      methods: {
        save: {
          method: 'POST',
          responseType: 'arraybuffer',
          transformResponse: function (data, headersGetter) {
            return {
              data: data,
              headers: headersGetter
            }
          }
        }
      }
    },
    {
      name: 'ReportsConnectionsAgrForChart',
      url: 'Reports/ReportsConnectionsAgrForChart',
      withRole: true,
      methods: {
        get: {
          method: 'POST',
          isArray: true
        }
      }
    }, {
      name: 'ConsultantReportsConnectionsAgrForChart',
      url: 'consultant/Reports/ReportsConnectionsAgrForChart',
      withRole: false,
      methods: {
        get: {
          method: 'POST',
          isArray: true
        }
      }
    },
    {
      name: 'ReportsConnectionsCCAgr',
      url: 'Reports/ReportsConnectionsCCAgr',
      withRole: true,
      methods: {
        save: {
          method: 'POST',
          isArray: true
        }
      }
    },
    {
      name: 'ReportsConnectionsCCAgrForChart',
      url: 'Reports/ReportsConnectionsCCAgrForChart',
      withRole: true,
      methods: {
        get: {
          method: 'POST',
          isArray: true
        }
      }
    },
    {
      name: 'ConsultantReportsConnectionsAgr',
      url: 'consultant/Reports/ReportsConnectionsAgr',
      withRole: false,
      methods: {
        save: {
          method: 'POST',
          isArray: true
        }
      }
    },
    {
      name: 'CallCenterList',
      url: 'Reports/CallCenterList',
      withRole: true,
      methods: {
        get: {
          method: 'GET',
          isArray: true
        }
      }
    },
    {
      name: 'ConsultansGet',
      url: 'Reports/ConsultantsGet',
      withRole: true,
      methods: {
        save: {
          method: 'POST',
          isArray: true
        }
      }
    },
    {
      name: 'ReportsMessagesStats',
      url: 'consultant/Reports/ReportsMessagesStats',
      withRole: false,
      methods: {
        get: {
          method: 'GET',
          isArray: true
        }
      }
    },
    {
      name: 'ReportsMessagesStatsWithRole',
      url: 'Reports/ReportsMessagesStats/:hours/:consultantId',
      withRole: true,
      methods: {
        get: {
          method: 'GET',
          isArray: true
        }
      }
    },
    {
      name: 'ConsultnatChannelsActivity',
      url: 'Reports/ConsultnatChannelsActivity/:fromDate/:toDate',
      withRole: true,
      methods: {
        get: {
          method: 'GET',
          isArray: true
        }
      }
    },
    {
      name: 'ConsultnatChannelsActivityForManagement',
      url: 'Reports/ConsultnatChannelsActivity/:consultantId/:fromDate/:toDate',
      withRole: true,
      methods: {
        get: {
          method: 'GET',
          isArray: true
        }
      }
    },
    {
      name: 'ParamList',
      url: 'Reports/ParamList',
      withRole: false,
      methods: {
        save: {
          method: 'POST',
          isArray: true
        }
      }
    },
    {
      name: 'CallCenterMinutes',
      url: 'admin/Reports/CallCenterMinutes',
      withRole: false,
      methods: {
        save: {
          method: 'POST',
          isArray: true
        }
      }
    },
    {
      name: 'ContactConnectionsList',
      url: 'Reports/ContactConnectionsList',
      withRole: true,
      methods: {
        save: {
          method: 'POST',
          isArray: true
        }
      }
    },
    {
      name: 'StatusStatistic',
      url: 'consultant/Reports/StatusStatistic',
      withRole: false,
      methods: {
        get: {
          method: 'GET',
          isArray: true
        }
      }
    },
    {
      name: 'ReportsUsersActivity',
      url: 'Reports/ReportsUsersActivity',
      withRole: true,
      methods: {
        save: {
          method: 'POST',
          isArray: true
        }
      }
    },
    {
      name: 'ReportsUsersActivityExport',
      url: 'Reports/ReportsUsersActivityExport',
      withRole: true,
      methods: {
        save: {
          method: 'POST',
          responseType: 'arraybuffer',
          transformResponse: function (data, headersGetter) {
            return {
              data: data,
              headers: headersGetter
            }
          }
        }
      }
    },
    {
      name: 'reportsSession',
      url: 'Reports/reportsSession/:sessionId',
      withRole: true,
      methods: {
        get: {
          method: 'GET',
          isArray: true
        }
      }
    },
    // {
    //   name: 'reportsSessionDetails',
    //   url: 'Reports/reportsSessionDetails/:sessionId',
    //   withRole: true,
    //   methods: {
    //     get: {
    //       method: 'GET',
    //       isArray: false
    //     }
    //   }
    // },
    {
      name: 'reportsSessions2',
      url: 'Reports/reportsSessions2',
      withRole: true,
      methods: {
        save: {
          method: 'POST',
          isArray: true
        }
      }
    },
    {
      name: 'consultantReportsSessions2',
      url: 'Reports/reportsSessions2',
      withRole: true,
      methods: {
        save: {
          method: 'POST',
          isArray: true
        }
      }
    },
    {
      name: 'reportsSessionsPerConsultant',
      url: 'manager/Reports/reportsSessionsPerConsultant',
      withRole: false,
      methods: {
        save: {
          method: 'POST',
          isArray: true
        }
      }
    },
    {
      name: 'reportsSessionsPerConsultantForChart',
      url: 'manager/Reports/reportsSessionsPerConsultantForChart',
      withRole: false,
      methods: {
        save: {
          method: 'POST',
          isArray: true
        }
      }
    },
    {
      name: 'reportsSessionsPerConsultantExport',
      url: 'manager/Reports/reportsSessionsPerConsultantExport',
      withRole: false,
      methods: {
        save: {
          method: 'POST',
          responseType: 'arraybuffer',
          transformResponse: function (data, headersGetter) {
            return {
              data: data,
              headers: headersGetter
            }
          }
        }
      }
    },
    {
      name: 'reportsSessionDetails',
      url: 'consultant/Reports/reportsSessionDetails/:sessionId',
      withRole: false,
      methods: {
        get: {
          method: 'GET',
          isArray: false
        }
      }
    },
    {
      name: 'reportsSessionsPerConsultantByTags',
      url: 'manager/Reports/reportsSessionsPerConsultantByTags',
      withRole: false,
      methods: {
        save: {
          method: 'POST',
          isArray: true
        }
      }
    },
    {
      name: 'reportsSessionsSummary',
      url: 'manager/Reports/reportsSessionsSummary',
      withRole: false,
      methods: {
        save: {
          method: 'POST',
          isArray: true
        }
      }
    },
    {
      name: 'reportsSessionsByTagsSummary',
      url: 'manager/Reports/reportsSessionsByTagsSummary',
      withRole: false,
      methods: {
        save: {
          method: 'POST',
          isArray: true
        }
      }
    },
    {
      name: 'reportsSessionsPerConsultantByTagsExport',
      url: 'manager/Reports/reportsSessionsPerConsultantByTagsExport',
      withRole: false,
      methods: {
        save: {
          method: 'POST',
          responseType: 'arraybuffer',
          transformResponse: function (data, headersGetter) {
            return {
              data: data,
              headers: headersGetter
            }
          }
        }
      }
    },
    {
      name: 'ReportsActiveDailyReport',
      url: 'manager/Reports/ReportsActiveDailyReport',
      withRole: false,
      methods: {
        save: {
          method: 'POST',
          isArray: true
        }
      }
    }
    ];

    _this.resource = ResourceBuilder.buildAll(resource);

    _this.GetSmsReport = function (data) {
      return _this.resource.smslist.save(data).$promise;
    };
    _this.ReportsSMSMessageListAgregation = function (datefrom, dateto, callCenterID, consultantId, direction, startIndex, pageSize) {
      return _this.resource.ReportsSMSMessageListAgregation.save({
        From: datefrom,
        To: dateto,
        callCenterID: callCenterID,
        consultantId: consultantId,
        direction: direction,
        startIndex: startIndex,
        pageSize: pageSize
      }).$promise;
    };
    _this.GetSmsMessagesStatisticsForChart = function (data) {
      return _this.resource.smsMessagesForChart.get(data).$promise;
    };

    _this.ReportsSessions2ForChart = function (data) {
      return _this.resource.reportsSessions2ForChart.get(data).$promise;
    };

    _this.GetConnections = function (data) { //, page, limit
      return _this.resource.connections.save(data).$promise; //, Page:page, Limit:limit
    };
    _this.ContactConnectionsList = function (dateFrom, dateTo) { //, page, limit
      return _this.resource.ContactConnectionsList.save({
        From: dateFrom,
        To: dateTo,
      }).$promise; //, Page:page, Limit:limit
    };
    _this.GetConnectionsStatisticsForChart = function (params) {
      return _this.resource.connectionsForChart.get(params).$promise;
    };
    _this.ReportsConnectionsByCallCenterID = function (userid, datefrom, dateto, callCenterID) {
      return _this.resource.ReportsConnectionsByCallCenterID.save({
        UserID: userid,
        From: datefrom,
        To: dateto,
        callCenterID: callCenterID
      }).$promise;
    };
    _this.CallbackOrdersList = function (data) {
      return _this.resource.CallbackOrdersList.get(data).$promise;
    };

    _this.CallbackOrdersChart = function (data) {
      return _this.resource.CallbackOrdersChart.get(data).$promise;
    };

    _this.CallbackDetails = function (uniqueidentifier) {
      return _this.resource.CallbackDetails.get({
        uniqueidentifier: uniqueidentifier
      }).$promise;
    };

    _this.DownloadCallbackOrders = function (data) {
      return _this.resource.DownloadCallbackOrders.get(data).$promise;
    }

    _this.CallbackAggregation = function (DateStart, DateEnd) {
      return _this.resource.CallbackAggregation.save({
        DateStart: DateStart,
        DateEnd: DateEnd
      }).$promise;
    };
    // _this.AdminCallbackAggregation = function (DateStart, DateEnd) {
    //     return _this.resource.AdminCallbackAggregation.save({ DateStart: DateStart, DateEnd: DateEnd }).$promise;
    // };
    _this.ConsultantCallbackAggregation = function (DateStart, DateEnd) {
      return _this.resource.ConsultantCallbackAggregation.save({
        DateStart: DateStart,
        DateEnd: DateEnd
      }).$promise;
    };
    _this.CallbackParamsAggregation = function (data) {
      return _this.resource.CallbackParamsAggregation.get(data).$promise;
    };
    _this.CallbackParamsAggregationChart = function (data) {
      return _this.resource.CallbackParamsAggregationChart.get(data).$promise;
    };
    _this.ReportsConnectionsAgr = function (data) {
      return _this.resource.ReportsConnectionsAgr.save(data).$promise;
    };
    _this.ReportsConnectionsAgrExport = function (data) {
      return _this.resource.ReportsConnectionsAgrExport.save(data).$promise;
    };
    _this.ReportsConnectionsServiceAgr = function (data) {
      return _this.resource.ReportsConnectionsServiceAgr.save(data).$promise;
    };
    _this.ReportsConnectionsServiceAgrExport = function (data) {
      return _this.resource.ReportsConnectionsServiceAgrExport.save(data).$promise;
    };
    _this.ReportsConnectionsServiceAgrForChart = function (data) {
      return _this.resource.ReportsConnectionsServiceAgrForChart.save(data).$promise;
    };
    _this.ReportsConnectionsAgrForChart = function (data) {
      return _this.resource.ReportsConnectionsAgrForChart.get(data).$promise;
    };
    _this.ConsultantReportsConnectionsAgrForChart = function (data) {
      return _this.resource.ConsultantReportsConnectionsAgrForChart.get(data).$promise;
    };
    _this.CallCenterList = function () {
      return _this.resource.CallCenterList.get().$promise;
    };
    _this.ConsultansGet = function (callcenterId) {
      return _this.resource.ConsultansGet.save({
        callcenterId: callcenterId
      }).$promise;
    };
    _this.ReportsMessagesStats = function (hours, consultantId) {
      if (consultantId) {
        return _this.resource.ReportsMessagesStatsWithRole.get({
          hours: hours,
          consultantId: consultantId
        }).$promise;
      } else {
        return _this.resource.ReportsMessagesStats.get({
          hours: hours
        }).$promise;
      }
    };

    _this.ConsultnatChannelsActivity = function (consultantId, fromDate, toDate) {
      if (consultantId) {
        return _this.resource.ConsultnatChannelsActivityForManagement.get({
          consultantId: consultantId,
          fromDate: fromDate,
          toDate: toDate
        }).$promise;
      } else {
        return _this.resource.ConsultnatChannelsActivity.get({
          fromDate: fromDate,
          toDate: toDate
        }).$promise;
      }
    };
    _this.ParamList = function (serviceID) {
      return _this.resource.ParamList.save({
        serviceID: serviceID
      }).$promise;
    };
    _this.CallCenterMinutes = function (From, To, callCenterID) {
      return _this.resource.CallCenterMinutes.save({
        From: From,
        To: To,
        callCenterID: callCenterID
      }).$promise;
    };
    _this.StatusStatistic = function () {
      return _this.resource.StatusStatistic.get().$promise;
    };

    _this.ReportsConnectionsCCAgrForChart = function (data) {
      return _this.resource.ReportsConnectionsCCAgrForChart.get(data).$promise;
    };
    _this.ReportsConnectionsCCAgr = function (data) {
      return _this.resource.ReportsConnectionsCCAgr.save(data).$promise;
    };
    _this.ReportsUsersActivity = function (data) {
      return _this.resource.ReportsUsersActivity.save(data).$promise;
    };
    _this.ReportsUsersActivityExport = function (data) {
      return _this.resource.ReportsUsersActivityExport.save(data).$promise;
    };

    _this.ReportsConnectionsExport = function (data) {
      return _this.resource.ReportsConnectionsExport.save(data).$promise;
    };

    _this.reportsSmsMessagesExport = function (data) {
      return _this.resource.reportsSmsMessagesExport.save(data).$promise;
    };

    _this.reportsSession = function (sessionId) {
      return _this.resource.reportsSession.get({
        sessionId: sessionId
      }).$promise;
    };

    // _this.reportsSessionDetails = function (sessionId) {
    //   return _this.resource.reportsSessionDetails.get({
    //     sessionId: sessionId
    //   }).$promise;
    // };

    _this.reportsSessions2 = function (data) {
      return _this.resource.reportsSessions2.save(data).$promise;
    };

    _this.reportsSessions2Export = function (data) {
      return _this.resource.reportsSessions2Export.save(data).$promise;
    };

    _this.reportsSessionsPerConsultant = function (data) {
      return _this.resource.reportsSessionsPerConsultant.save(data).$promise;
    };

    _this.reportsSessionsPerConsultantForChart = function (data) {
      return _this.resource.reportsSessionsPerConsultantForChart.save(data).$promise;
    };

    _this.reportsSessionsPerConsultantExport = function (data) {
      return _this.resource.reportsSessionsPerConsultantExport.save(data).$promise;
    };

    _this.reportsSessionDetails = function (sessionId) {
      return _this.resource.reportsSessionDetails.get({
        sessionId: sessionId
      }).$promise;
    };

    _this.reportsSessionsPerConsultantByTags = function (data) {
      return _this.resource.reportsSessionsPerConsultantByTags.save(data).$promise;
    };

    _this.reportsSessionsSummary = function (data) {
      return _this.resource.reportsSessionsSummary.save(data).$promise;
    };

    _this.reportsSessionsByTagsSummary = function (data) {
      return _this.resource.reportsSessionsByTagsSummary.save(data).$promise;
    };

    _this.reportsSessionsPerConsultantByTagsExport = function (data) {
      return _this.resource.reportsSessionsPerConsultantByTagsExport.save(data).$promise;
    };
    
    _this.ReportsActiveDailyReport = function (data) {
      return _this.resource.ReportsActiveDailyReport.save(data).$promise;
    };

    return _this;
  }
})();

/**
 * Created by kosski on 09.09.2016.
 */

+function () {
  'use strict';
  const GetPortalRateUrl = 'rates/:portalId';
  const SetPortalRateUrl = 'rates';

  angular
    .module('Resources')
    .factory('ratesRsc', ratesRsc);


  /* @ngInject */
  function ratesRsc(ResourceBuilder, consts) {
    var _this = {};

    // _this.resources = {
    //   GetPortalRate: $resource(consts.api + GetPortalRateUrl + ':portalId',
    //     { portalId: '@portalId' },
    //     {
    //       get: {
    //         method: "GET",
    //         isArray: true
    //       }
    //     }),
    //   SetPortalRate: $resource(consts.api + SetPortalRateUrl,
    //     '@params',
    //     {
    //       save: {
    //         method: "POST"
    //       }
    //     })
    // };

    var resource = [
      {
        name: 'rates',
        url: 'rates',
        withRole: false,
        methods: {
          get: {
            url: '/:portalId',
            method: 'GET',
            isArray: true
          },
          save: {
            method: 'POST'
          }
        }
      }
    ];
    _this.resource = ResourceBuilder.buildAll(resource);



    _this.GetPortalRate = function () {
      // var _this = this;
      // var resource = $resource(consts.api + GetPortalRateUrl + ':portalId',
      //   { portalId: '@portalId' },
      //   {
      //     get: {
      //       method: "GET",
      //       isArray: true
      //     }
      //   });
      return _this.resource.rates.get({ portalId: 1 }).$promise;
    };

    _this.SetPortalRate = function (model) {
      // var _this = this;

      var data = {
        portalId: 1,
        emailRate: model['emailRate'],
        chatRate: model['chatRate'],
        callBackRate: model['callBackRate'],
        videoChatRate: model['videoChatRate'],
      };

      // var resource = $resource(consts.api + SetPortalRateUrl,
      //   '@params',
      //   {
      //     save: {
      //       method: "POST"
      //     }
      //   });
      return _this.resource.rates.save(data).$promise;
    };

    return _this;
  }
} ();

+ function () {
  'use strict';

  angular
    .module('Resources')
    .factory('partnerRsc', partnerRsc);

  /** @ngInject */
  function partnerRsc(ResourceBuilder, $resource, consts, $templateCache, $sce, $templateRequest, $q) {
    var _this = {};

    _this.newResources = [{
      name: 'mail',
      url: 'partner/mail',
      withRole: true,
      methods: {
        get: {
          method: 'GET',
          isArray: true
        },
        update: {
          method: 'PUT'
        }
      }
    }, {
      name: 'partner',
      url: 'partner',
      withRole: true,
      methods: {
        get: {
          url: '/:partnerId',
          method: 'GET',
        },
        update: {
          method: 'PUT'
        },
        list: {
          url: '/list',
          method: 'GET',
          isArray: true
        }
      }
    }];

    _this.resources = ResourceBuilder.buildAll(_this.newResources);


    /* -------------------------------------------- PARTNER PART -------------------------------------------- */
    _this.GetPartners = function () {
      return _this.resources.partner.list().$promise;
    };

    _this.getPartner = function (pid) {
      return _this.resources.partner.get(pid).$promise;
    };

    _this.updatePartner = function (pid) {
      return _this.resources.partner.update(pid).$promise;
    };

    _this.getMailBoxes = function () {
      return _this.resources.mail.get().$promise;
    };

    _this.updateMailBoxes = function (users) {
      return _this.resources.mail.update(angular.isArray(users) ? users : [users]).$promise;
    };

    return _this;
  }
}();

/**
 */

+(function () {
  'use strict';
  angular
    .module('Resources')
    .factory('OuterPaymentRsc', ['ResourceBuilder', 'consts', OuterPaymentRsc])
  /** @ngInject */
  function OuterPaymentRsc(ResourceBuilder, consts) {
    var _this = this;

    var resource = [{
      name: 'outer',
      url: 'outer/payment',
      withRole: false,
      methods: {
        post: {
          url: '/start',
          method: 'POST'//,
          // isArray: true
        },
        check: {
          url: '/check',
          method: 'POST'//,
          // isArray: true
        },
        confirm: {
          url: '/confirm',
          method: 'POST'//,
          // isArray: true
        },
        service: {
          url: '/serviceinfo/:serviceId',
          method: 'GET'//,
          // isArray: true
        },
        disconnect: {
          url: '/disconnect/:uuid/:bridgeId',
          method: 'GET'//,
          // isArray: true
        },
        startPayment: {
          url: '/startPayment/:uuid/:seconds',
          method: 'GET'//,
          // isArray: true
        }
      }
    }];
    _this.resource = ResourceBuilder.buildAll(resource);

    _this.start = function (data) {
      return _this.resource.outer.post(data).$promise;
    };
    _this.check = function (data) {
      return _this.resource.outer.check(data).$promise;
    };
    _this.confirm = function (data) {
      return _this.resource.outer.confirm(data).$promise;
    };
    _this.serviceInfo = function (serviceId) {
      return _this.resource.outer.service({ serviceId: serviceId }).$promise;
    };
    _this.disconnect = function (uuid, bridgeId) {
      return _this.resource.outer.disconnect({ uuid: uuid, bridgeId: bridgeId }).$promise;
    };
    _this.startPayment = function (uuid, seconds) {
      return _this.resource.outer.startPayment({ uuid: uuid, seconds: seconds }).$promise;
    };

    return _this;
  }
})()

/**
 * Created by kosski on 09.09.2016.
 */

+(function () {
    'use strict';
 
  
    angular
      .module('Resources')
      .factory('MsmRsc', ['ResourceBuilder', 'consts', FactoryBuilder]);
  
    /** @ngInject */
    function FactoryBuilder(ResourceBuilder, consts) {
      var _this = this;
      var resource = [
        {
          name: 'monitoring',
          url: 'monitoring',
          withRole: true,
          methods: {

            getMsmData: {
              url: '/getMessageSesssionMonitoringData',
              method: 'GET',
              withRole: true,
              isArray: false
            },
            getCurrentSessions: {
              url: '/cursessions',
              method: 'GET',
              withRole: true,
              isArray: false
            }

          }
        },
        {
          name: 'consultantList',
          url: 'monitoring/actionConsultantList/:serviceId',
          withRole: true,
          methods: {
            get: {
              method: 'GET',
              isArray: true
            }
          }
        },
        {
          name: 'forwardSession',
          url: 'monitoring/forwardSession',
          withRole: true,
          methods: {
            post: {
              method: 'POST',
            }
          }
        }
      ];
  
      _this.resource = ResourceBuilder.buildAll(resource);
  
  
 
      _this.getMessageSesssionMonitoringData = function () {
        return _this.resource.monitoring.getMsmData().$promise;
      };
  
      _this.getCurrentSessions = function () {
        return _this.resource.monitoring.getCurrentSessions().$promise;
      };

      _this.getConsultantList = function (serviceId) {
        return _this.resource.consultantList.get({serviceId: serviceId}).$promise;
      };

      _this.forwardSession = function (sessionId, consultantId) {
        return _this.resource.forwardSession.post({sessionID: sessionId, consultantID: consultantId}).$promise;
      };
  

  
      return _this;
    }
  })();
  
/**
 * Created by kosski on 09.09.2016.
 */

+function () {
  'use strict';

  angular
    .module('Resources')
    .factory('monitoringRsc', monitoringRsc);

  /** @ngInject */
  function monitoringRsc(ResourceBuilder) {
    var _this = {};


    _this.newResources = [
      {
        name: 'monitoring',
        url: 'monitoring/getCurrentCalls',
        withRole: true,
        methods: {
          get: {
            method: 'GET',
            isArray: true
          }
        }
      }
    ];


    _this.resources = ResourceBuilder.buildAll(_this.newResources);

    _this.GetCurrentCalls = function () {
      return _this.resources.monitoring.get().$promise;
    };


    return _this;
  }
}();

/**
 * Created by kosski on 09.09.2016.
 */

+function () {
  'use strict';

  angular
    .module('Resources')
    .factory('messageSessionRsc', messageSessionRsc);

  const messageSessionUrl = 'CallCenterServices/messagesession';

  /** @ngInject */
  function messageSessionRsc(ResourceBuilder) {
    var _this = {};
    

    _this.newResources = [
      {
        name: 'messageSession',
        url: 'common/messagesession',
        withRole: false,
        methods: {
          get: {
            url: '/:guid',
            method: 'GET',
            isArray: false
          }
        }
      },
      {
        name: 'messageSessionTags',
        url: 'common/messagesession/tags',
        withRole: false,
        methods: {
          post: {
            method: 'POST',
          }
        }
      }
    ];


    _this.resources = ResourceBuilder.buildAll(_this.newResources);

    _this.getInfo = function (sessionGuid) {
      return _this.resources.messageSession.get({guid: sessionGuid}).$promise;
    };

    _this.addMessageSessionTags = function (sessionID, tags) {
      return _this.resources.messageSessionTags.post({ sessionID: sessionID, tags: tags }).$promise;
    };

    return _this;
  }
}();

(function () {

	'use strict';

	angular
		.module('Resources')
		.factory('map', reportsCosult);
	/** @ngInject */
	function reportsCosult(ResourceBuilder) {
		var _this = {}

		var resource = [
			{
				name: 'mappois',
				url: 'common/mappart/getpois2/:serviceId',
				withRole: false,
				methods: {
					get: {
						method: "GET",
						isArray: false
					}
				}
      },
      {
				name: 'poidetails',
				url: 'common/mappart/poidetails/:poiId',
				withRole: false,
				methods: {
					get: {
						method: "GET",
						isArray: false
					}
				}
			}
		];

		_this.resource = ResourceBuilder.buildAll(resource);
		_this.mappois = function (serviceId) {
			return _this.resource.mappois.get({
        serviceId: serviceId
      }).$promise;
		};

    _this.poidetails = function (poiId) {
			return _this.resource.poidetails.get({
        poiId: poiId
      }).$promise;
    };

		return _this;
	}
})();

/**
 * Created by akraszewski on 14.09.2016.
 */

+(function () {
  'use strict';
  angular
    .module('Resources')
    .factory('GroupRsc', ['ResourceBuilder', 'consts', FactoryBuilder])
  /** @ngInject */
  function FactoryBuilder(ResourceBuilder, consts) {
    var _this = this;
    var resource = [
      {
        name: 'grups',
        url: 'CCGroups',
        withRole: true,
        methods: {
          get: {
            url: '/:callCenterID',
            method: 'GET',
            isArray: true
          },
          save: {
            method: 'POST'
          },
          update: {
            method: 'PUT'
          },
          delete: {
            method: 'DELETE'
          }
        }
      }, {
        name: 'consultants',
        url: 'CCGroups/consultants',
        withRole: true,
        methods: {
          get: {
            url: '/:groupId',
            method: 'GET',
            isArray: true
          },
          save: {
            method: 'POST'
          },
          update: {
            method: 'PUT'
          },
          delete: {
            method: 'DELETE'
          }
        }
      }, {
        name: 'consultantsNotIn',
        url: 'CCGroups/ConsultantsNotIn/:groupId',
        withRole: true,
        methods: {
          get: {
            method: 'GET',
            isArray: true
          }
        }
      },
      {
        name: 'addConsultantsToGroup',
        url: 'CCGroups/addconsultants',
        withRole: true,
        methods: {
          save: {
            method: 'POST'
          }
        }
      },{
        name: 'consultantsInGroup',
        url: 'common/group/consultantsGroup/:groupId',
        withRole: false,
        methods: {
          get: {
            method: 'GET',
            isArray: true
          }
        }
      }
    ];
    _this.resource = ResourceBuilder.buildAll(resource);

    // _this.getCallCenters = function (partnerId) {
    //   var resource = $resource(baseUrl + getCallCentersUrl,
    //     { partnerId: '@partnerId' }, {
    //       get: {
    //         method: 'GET',
    //         isArray: true
    //       }
    //     })
    //   return resource.get({ partnerId: partnerId }).$promise;
    // }

    _this.getGroups = function (callCenterID) {
      // var resource = $resource(baseUrl + getCallCenterGroupsUrl,
      //   {
      //     partnerId: '@partnerId',
      //     callCenterID: '@callCenterID'
      //   }, {
      //     get: {
      //       method: 'GET',
      //       isArray: true
      //     }
      //   })
      return _this.resource.grups.get({
        callCenterID: callCenterID
      }).$promise;
    }

    _this.getConsultantsInGroup = function (groupId) {
      // var resource = $resource(baseUrl + getConsultantInUrl,
      //   { groupId: '@groupId' }, {
      //     get: {
      //       method: 'GET',
      //       isArray: true
      //     }
      //   })
      return _this.resource.consultants.get({ groupId: groupId }).$promise;
    }

    _this.getConsultantsNotInGroup = function (groupId) {
      // var resource = $resource(baseUrl + getConsultantNotInUrl,
      //   { groupId: '@groupId' }, {
      //     get: {
      //       method: 'GET',
      //       isArray: true
      //     }
      //   })
      return _this.resource.consultantsNotIn.get({ groupId: groupId }).$promise;
    }
    _this.addConsultantToGroup = function (consultantGroup) {
      // var resource = $resource(baseUrl + addConsultantToGroupUrl,
      //   '@consultantGroup', {
      //     update: {
      //       method: 'PUT'
      //     }
      //   })
      return _this.resource.consultants.save(consultantGroup).$promise;
    }
    _this.removeConsultantFromGroup = function (consultantGroup) {
      //debugger;
      // var resource = $resource(baseUrl + removeConsultantFromGroupUrl,
      //   '@consultantGroup', {
      //     update: {
      //       method: 'PUT'
      //     }
      //   })
      return _this.resource.consultants.delete(consultantGroup).$promise;
    }

    _this.updateConsultantInGroup = function (consultantGroup) {
      // var resource = $resource(baseUrl + updateConsultantInGroupUrl,
      //   '@consultantGroup', {
      //     update: {
      //       method: 'PUT'
      //     }
      //   })
      return _this.resource.consultants.update(consultantGroup).$promise;
    }

    _this.updateGroup = function (group) {
      // var resource = $resource(baseUrl + updateGroupUrl,
      //   '@group', {
      //     update: {
      //       method: 'PUT'
      //     }
      //   })
      return _this.resource.grups.update(group).$promise;
    }
    _this.saveGroup = function (group) {

      // group.id = group.id === 'new' ? null : group.id;
      // var resource = $resource(baseUrl + addGroupUrl,
      //   '@group', {
      //     save: {
      //       method: 'POST'
      //     }
      //   })
      return _this.resource.grups.save(group).$promise;
    }

    _this.deleteGroup = function(group){

      return _this.resource.grups.delete(group).$promise;

    }

    _this.addConsultantsToGroup = function(group){
      return _this.resource.addConsultantsToGroup.save(group).$promise;
    }

    _this.consultantsInGroup = function(groupId){
      return _this.resource.consultantsInGroup.get({ groupId: groupId }).$promise;
    }



    return _this;
  }
})();

/**
 * Created by kosski on 09.09.2016.
 */

+function () {
  'use strict';
  const ConsultantPhotoUrl = 'common/consultant/photo';
  const ConsultantUrl = 'common/consultant';
  const UserUrl = 'common/consultant/user';
  const languagesURL = 'common/consultant/languages';

  angular
    .module('Resources')
    .factory('profileRsc', TSRsc);


  /** @ngInject */
  function TSRsc(ResourceBuilder, consts, $q) {
    var _this = {};
    _this.resource = [{
      name: 'consultant',
      url: 'common/consultant',
      withRole: false,
      methods: {
        get: {
          method: 'GET'
        },
        // put: {
        //   method: 'PUT'
        // },
        photo: {
          url: '/photo',
          method: 'PUT'
        }
      }
    }, {
      name: 'user',
      url: 'common/users',
      withRole: false,
      methods: {
        get: {
          method: 'GET'
        },
        put: {
          method: 'PUT'
        }
      }
    }, {
      name: 'languages',
      url: 'common/consultant/languages',
      withRole: false,
      methods: {
        get: {
          method: 'GET'
        },
        put: {
          method: 'PUT'
        }
      }
    }, {
      name: 'details',
      url: 'common/consultant/details',
      withRole: false,
      methods: {
        get: {
          method: 'GET'
        },
        put: {
          method: 'PUT'
        }
      }
    }];

    _this.resouces = ResourceBuilder.buildAll(_this.resource);

    /* -------------------------- PROFILE PART ------------------------------------*/
    _this.GetMyConsultant = function () {
      return _this.resouces.consultant.get().$promise;
    };

    _this.PutConsultant = function (cd) {
      return _this.resouces.consultant.put(cd).$promise;
    };

    _this.PutConsultantPhoto = function (photo, userId) {
      return _this.resouces.consultant.photo({
        userId: userId,
        Photo: photo.Photo
      }).$promise;
    };

    _this.getUser = function () {
      return _this.resouces.user.get().$promise;
    };

    _this.PutUser = function (model) {
      return _this.resouces.user.put(model).$promise;
    };

    _this.getLanguages = function () {
      return _this.resouces.languages.get().$promise;
    };

    _this.putLanguages = function (model) {
      return _this.resouces.languages.put(model).$promise;
    };

    _this.getConsultantDetails = function () {
      return _this.resouces.details.get().$promise;
    };

    _this.putConsultantDetails = function (model) {
      return _this.resouces.details.put(model).$promise;
    };


    /* -------------------------- END PROFILE PART ------------------------------------*/

    return _this;
  }
}();

/**
 * Created by kosski on 09.09.2016.
 */

+function () {
  'use strict';

  angular
    .module('Resources')
    .factory('extrasidemenuRsc', extrasideRsc);

  /** @ngInject */
  function extrasideRsc(ResourceBuilder) {
    var _this = {};

    _this.newResources = [
      {
        name: 'extrasidemenu',
        url: 'extrasidemenu',
        withRole: false,
        methods: {
          getLastConsultantConnections: {
            url: '/getLastConsultantConnections',
            method: 'GET',
            isArray: true
          },
          getLastConsultantContacts: {
            url: '/getLastConsultantContacts',
            method: 'GET',
            isArray: true
          }
        }
      }
    ];


    _this.resources = ResourceBuilder.buildAll(_this.newResources);

    _this.getLastConsultantConnections = function () {
      return _this.resources.extrasidemenu.getLastConsultantConnections().$promise;
    };

    _this.getLastConsultantContacts = function () {
      return _this.resources.extrasidemenu.getLastConsultantContacts().$promise;
    };


    return _this;
  }
}();

/**
 * Created by kosski on 09.09.2016.
 */

+function () {
  'use strict';
  const GetDescriptionUrl = 'common/consultant/description/:portalId';
  const SaveDescriptionUrl = 'CallCenterConsultants/description';

  angular
    .module('Resources')
    .factory('DescriptionRsc', TSRsc);


  /** @ngInject */
  function TSRsc(ResourceBuilder, consts) {
    var _this = {};

    var resource = [
      {
        name: 'description',
        url: 'common/consultant/description',
        withRole: false,
        methods: {
          get: {
            url: '/:portalId',
            method: 'GET',
            isArray: true
          },
          save: {
            method: 'POST'
          }
        }
      },
    ]

    _this.resource = ResourceBuilder.buildAll(resource);

    _this.GetDescription = function (portalId) {
      // var resource = $resource(consts.api + GetDescriptionUrl,
      //   { portalId: '@portalId' }, {
      //     get: {
      //       method: "GET",
      //       isArray: true
      //     }
      //   });
      return _this.resource.description.get({ portalId: portalId }).$promise;
    };

    _this.SaveDescription = function (send) {
      // var _this = this;
      // var resource = $resource(consts.api + SaveDescriptionUrl,
      //   '@send', {
      //     save: {
      //       method: "POST"
      //     }
      //   });
      return _this.resource.description.save(send).$promise;
    };
    /* -------------------------- END DESCRIPTION PART ------------------------------------*/

    return _this;
  }
}();

/**
 * Created by kosski on 09.09.2016.
 */

+(function () {
  'use strict';
  const consultantsGetUrl = 'admin/consultant/list/';
  const ConsultantActiveSwitchUrl = 'CallCenterConsultants/ChangeActive';
  const consultantUpdateUrl = 'CallCenterConsultants/Update';
  const consultantAddUrl = 'CallCenterConsultants/Save';

  angular
    .module('Resources')
    .factory('ConsultantsRsc', ['ResourceBuilder', 'consts', FactoryBuilder]);

  /** @ngInject */
  function FactoryBuilder(ResourceBuilder, consts) {
    var _this = this;
    var resource = [
      {
        name: 'consultants',
        url: 'consultant',
        withRole: true,
        methods: {
          get: {
            url: '/list/:callCenterId',
            method: 'GET'
          },
          statistics: {
            url: '/list/statistics',
            method: 'GET',
          },
          upgrade: {
            url: '/upgrade/:serviceId/:consultantId',
            method: 'GET',
          },
          downgrade: {
            url: '/downgrade/:serviceId/:consultantId',
            method: 'GET',
          },
          getbyId: {
            url: '/:userId',
            method: 'GET'
          },
          kick:{
            url: '/kick/:cid',
            method: 'GET'
          },
          activateRemote:{
            url: '/activateRemote/:cid/:phoneNumber',
            method: 'GET'
          },
          getConsultantForEdit: {
            url: '/getConsultantForEdit/:consultantId',
            method: 'GET',
            withRole: true
          },
          getConsultantGeneralInfo: {
            url: 'consultant/getConsultantGeneralInfo/:consultantId',
            method: 'GET',
            withRole: true
          },

          addNew: {
            method: 'POST'
          },
          update: {
            method: 'PUT'
          },
          delete: {
            method: 'DELETE'
          },
          rollback: {
            url: '/rollback',
            method: 'PUT'
          },
        }
      },
      {
        name: 'myConsultant',
        withRole: false,
        url: 'common/consultant',
        methods: {
          updateMyConsultantData: {
            method: 'PUT',
            url: '/updateMyConsultantData'
          },
          getMyConsultantGeneralData: {
            method: 'GET',
            url: '/getMyConsultantGeneralData'
          },
          getMyConsultantForEdit: {
            method: 'GET',
            url: '/getMyConsultantForEdit'
          }
        }
      },
      {
        name: 'phones',
        url: 'common/consultant/phone',
        methods: {
          get: {
            // url: '/list/:partnerId/:callCenterId',
            method: 'GET',
            isArray: true
          },
          list: {
            url: 'common/consultant/phoneTypes',
            method: 'GET',
            isArray: true
          },
          save: {
            method: 'PUT'
          },
          update: {
            method: 'POST'
          },
          delete: {
            url: '/:phoneId',
            method: 'DELETE'
          }
        }
      },
      {
        name: 'phonesWithRole',
        url: 'consultant',
        withRole: true,
        methods: {
          get: {
            url: '/phone/:consultantId',
            method: 'GET',
            isArray: true
          },
          list: {
            url: '/phoneTypes',
            method: 'GET',
            isArray: true
          },
          save: {
            url: '/phone',
            method: 'PUT'
          },
          update: {
            url: '/phone',
            method: 'POST'
          },
          delete: {
            url: '/phone/:phoneId/:consultantId',
            method: 'DELETE'
          }
        }
      },
      {
        name: 'helpSending',
        withRole: false,
        url: 'common/callinfo/HelpSending',
        methods: {
          save: {
            method: 'POST',
            isArray: true
          }
        }
      },
      {
        name: 'monitoring',
        url: 'monitoring',
        withRole: true,
        methods: {
          consocupation: {
            url: '/consocupation',
            method: 'GET',
          },
          conslist: {
            url: '/conslist',
            method: 'GET',
          },
          conslaststatuses: {
            url: '/consstatuses/:consultantId',
            method: 'GET',
          }
        }
      }
    ];

    _this.resource = ResourceBuilder.buildAll(resource);


    _this.getConsultant = function (userId) {
      return _this.resource.consultants.getbyId({
        userId: userId
      }).$promise;
    };

    _this.kickConsultant = function (cid) {
      return _this.resource.consultants.kick({
        cid: cid
      }).$promise;
    };

    _this.activateRemote = function (cid,phone) {
      return _this.resource.consultants.activateRemote({
        cid: cid,
        phoneNumber: phone
      }).$promise;
    };

    _this.getConsultantGeneralInfo = function (consultantId) {
      return _this.resource.consultants.getConsultantGeneralInfo({
        consultantId: consultantId
      }).$promise;
    };
    _this.getConsultantForEdit = function (consultantId) {
      return _this.resource.consultants.getConsultantForEdit({
        consultantId: consultantId
      }).$promise;
    };

    _this.addNewConsultant = function (newConsultant) {
      return _this.resource.consultants.addNew(newConsultant).$promise;
    };

    _this.editConsultant = function (consultant) {
      return _this.resource.consultants.update(consultant).$promise;
    };


    // myConsultant Endpoints
    _this.updateMyConsultantData = function (consultant) {
      return _this.resource.myConsultant.updateMyConsultantData(consultant).$promise;
    };
    _this.getMyConsultantGeneralData = function () {
      return _this.resource.myConsultant.getMyConsultantGeneralData().$promise;
    };
    _this.getMyConsultantForEdit = function () {
      return _this.resource.myConsultant.getMyConsultantForEdit().$promise;
    };
    // myConsultant Endpoints


    _this.getConsultants = function (partnerId, callCenterId) {
      return _this.resource.consultants.get({
        callCenterId: callCenterId
      }).$promise;
    };

    _this.getConsultantsStatistics = function (callCenterId) {
      return _this.resource.consultants.statistics({
        callCenterId: callCenterId
      }).$promise;
    };

    _this.upgradeLevel = function (serviceId, consultantId) {
      return _this.resource.consultants.upgrade({
        serviceId: serviceId,
        consultantId: consultantId
      }).$promise;
    };

    _this.downgradeLevel = function (serviceId, consultantId) {
      return _this.resource.consultants.downgrade({
        serviceId: serviceId,
        consultantId: consultantId
      }).$promise;
    };

    _this.getConsultantsOcupation = function () {
      return _this.resource.monitoring.consocupation().$promise;
    };

    _this.getFwdConsultants = function () {
      return _this.resource.monitoring.conslist().$promise;
    };

    _this.getConsultantLastStatuses = function (consultantId) {
      return _this.resource.monitoring.conslaststatuses({consultantId: consultantId}).$promise;
    };

    _this.getPhoneTypes = function () {
      return _this.resource.phones.list().$promise;
    };

    _this.getPhones = function (consultantId) {
      if (consultantId) {
        return _this.resource.phonesWithRole.get({consultantId: consultantId}).$promise;
      } else {
        return _this.resource.phones.get().$promise;
      }
    };

    _this.saveConsultantPhone = function (model, consultantId,personalAccount) {
      if (personalAccount) {
        return _this.resource.phones.save(model).$promise;
      } else {
        model.consultantId = consultantId;
        return _this.resource.phonesWithRole.save(model).$promise;
      }
    };

    _this.updateConsultantPhone = function (model, consultantId,personalAccount) {
      if (personalAccount) {
        return _this.resource.phones.update(model).$promise;
      } else {
        model.consultantId = consultantId;
        return _this.resource.phonesWithRole.update(model).$promise;
      }
    };

    _this.deleteConsultantPhone = function (phoneId, consultantId,personalAccount) {
      if (personalAccount) {
        return _this.resource.phones.delete({phoneId: phoneId}).$promise;
      } else {
        return _this.resource.phonesWithRole.delete({phoneId: phoneId, consultantId: consultantId}).$promise;
      }
    };


    _this.helpSending = function (callID) {
      return _this.resource.helpSending.save({
        callID: callID
      }).$promise;
    };

    return _this;
  }
})();

/**
 * Created by kosski on 09.09.2016.
 */

+function () {
  'use strict';
  const getCategoriesUrl = 'categories/:portalId';
  const saveCategoriesUrl = 'categories';

  angular
    .module('Resources')
    .factory('CategoriesRsc', FactoryBuilder);


  /** @ngInject */
  function FactoryBuilder(ResourceBuilder, consts) {
    var _this = {};
    var resource = [
      {
        name: 'categories',
        url: 'categories',
        withRole: false,
        methods: {
          get: {
            url: '/:portalId',
            method: 'GET',
            isArray: true
          },
          save: {
            method: 'POST'
          }
        }
      },
      {
        name: 'sessioncategories',
        url: 'common/Communicator/sessioncategories',
        withRole: false,
        methods: {
          get: {
            url: '/:sessionId/:serviceId',
            method: 'GET',
            isArray: true
          }
        }
      },
      {
        name: 'addcategory',
        url: 'common/Communicator/addcategory',
        withRole: false,
        methods: {
          get: {
            url: '/:sessionId/:categoryId/:sessionGuid/:logicCatId',
            method: 'GET',
            isArray: false
          }
        }
      },
      {
        name: 'delcategory',
        url: 'common/Communicator/delcategory',
        withRole: false,
        methods: {
          get: {
            url: '/:sessionId/:categoryId',
            method: 'GET',
            isArray: false
          }
        }
      }
    ]
    _this.resource = ResourceBuilder.buildAll(resource);

    _this.getCategories = function (portalId) {
      return _this.resource.categories.get({
          portalId: portalId
        }).$promise;
    };

    _this.getSessionCategories = function (sessId, srvId) {
      return _this.resource.sessioncategories.get({
          sessionId: sessId,
          serviceId: srvId
        }).$promise;
    };

    _this.addSessionCategory = function (sessId, catId, sessGuid, lcatId) {
      return _this.resource.addcategory.get({
          sessionId: sessId,
          categoryId: catId,
          sessionGuid: sessGuid,
          logicCatId: lcatId
        }).$promise;
    };

    _this.delSessionCategory = function (sessId, catId) {
      return _this.resource.delcategory.get({
          sessionId: sessId,
          categoryId: catId
        }).$promise;
    };

    _this.addCategories = function (send) {
      // return $resource(consts.api + saveCategoriesUrl,
      //   '@send', {
      //     save: {
      //       method: "POST"
      //     }
      //   })
        return _this.resource.categories.save(send).$promise;
    };
    return _this;
  }
}();

(function () {

    'use strict';

    angular
        .module('Resources')
        .factory('onlineCalls', callsOnline);

    /** @ngInject */
    function callsOnline(ResourceBuilder) {
        var _this = {};

        var resource = [
            {
                name: 'eavesdropp',
                // url: 'Reports/StartEavesdropp',

                // url: 'Reports/StartEavesdropp/:uuid',
                // withRole: true,

                url: 'Reports/StartEavesdropp/:uuid',
                withRole: false,
                methods: {
                    get: {
                        method: 'GET'//,
                        //isArray: true
                    }
                }
            }
        ];
        _this.resource = ResourceBuilder.buildAll(resource);

        _this.eavesdropp = function (uuid) {
            return _this.resource.eavesdropp.get({ uuid: uuid }).$promise;
        }

        return _this;
    }
})();

/**
 * Created by akraszewski on 14.09.2016.
 */

+(function () {
  'use strict';
  angular
    .module('Resources')
    .factory('ContactCenterRsc', ['ResourceBuilder', 'consts', ContactCenterRsc])
  /** @ngInject */
  function ContactCenterRsc(ResourceBuilder, consts) {
    var _this = this;

    var resource = [{
      name: 'callcenters',
      url: 'CallCenter',
      withRole: true,
      methods: {
        get: {
          // url: 'CallCenter/:partnerId',
          method: 'GET',
          isArray: true
        },
        save: {
          method: 'POST'
        },
        update: {
          method: 'PUT'
        }
      }
    }, {
      name: 'mail',
      url: 'CallCenter/mail',
      withRole: true,
      methods: {
        get: {
          url: '/:callCenterId',
          method: 'GET',
          isArray: true
        },
        update: {
          method: 'PUT'
        }
      }
    }, {
      name: 'forward',
      url: 'common/CallCenter/ForwardList',
      withRole: false,
      methods: {
        get: {
          method: 'GET',
          isArray: true
        }
      }
    }];
    _this.resource = ResourceBuilder.buildAll(resource);

    _this.getCallCenters = function () {
      return _this.resource.callcenters.get().$promise;
    }

    _this.addCallCenter = function (cc) {
      return _this.resource.callcenters.save(cc).$promise;
    }

    _this.updateCallCenter = function (cc) {
      return _this.resource.callcenters.update(cc).$promise;
    }

    _this.getMailBoxes = function (ccId) {
      return _this.resource.mail.get({
        callCenterId: ccId
      }).$promise;
    };

    _this.updateMailBoxes = function (mailbox) {
      return _this.resource.mail.update(angular.isArray(mailbox) ? mailbox : [mailbox]).$promise;
    };

    _this.forwardList = function (ccId) {
      return _this.resource.forward.get().$promise;
    };

    return _this;
  }
})()

/**
 * Created by kosski on 09.09.2016.
 */

+function () {
  'use strict';
  const getAreasUrl = 'CallCenterAreas/:portalId';
  const saveAreasUrl = 'CallCenterAreas';

  angular
    .module('Resources')
    .factory('AreasRsc', FactoryBuilder);

  /** @ngInject */
  function FactoryBuilder(ResourceBuilder, consts) {
    var _this = {};

    var resource = [
      {
        name: 'areas',
        url: 'CallCenterAreas',
        withRole: false,
        methods: {
          get: {
            url: '/:portalId',
            method: 'GET',
            isArray: true
          },
          save: {
            method: 'POST'
          }
        }
      }
    ];
    _this.resource = ResourceBuilder.buildAll(resource);

    _this.getAreas = function (portalId) {
      // return $resource(consts.api + getAreasUrl, {
      //   portalId: '@portalId'
      // }, {
      //   get: {
      //     method: "GET",
      //     isArray: true
      //   }
      // })
      return _this.resource.areas.get({ portalId: portalId }).$promise;
    };



    _this.addAreas = function (send) {
      // return $resource(consts.api + saveAreasUrl,
      //   '@send', {
      //     save: {
      //       method: "POST"
      //     }
      //   })
      return _this.resource.areas.save(send).$promise;
    };


    return _this;
  }
}();

(function () {
  'use strict';

  angular
    .module('taapp')
    .service('toastService', Service);

  /**@ngInject */
  function Service($mdToast) {
    var vm = this;
    var last = {
      bottom: true,
      top: false,
      left: false,
      right: true
    };

    vm.toastPosition = angular.extend({}, last);

    ////////////////
    vm.getToastPosition = function () {
      sanitizePosition();

      return Object.keys(vm.toastPosition)
        .filter(function (pos) {
          return vm.toastPosition[pos];
        })
        .join(' ');
    };

    function sanitizePosition() {
      var current = vm.toastPosition;
      if (current.bottom && last.top) {
        current.top = false;
      }
      if (current.top && last.bottom) {
        current.bottom = false;
      }
      if (current.right && last.left) {
        current.left = false;
      }
      if (current.left && last.right) {
        current.right = false;
      }
      last = angular.extend({}, current);
    }

    vm.showToast = function (message, styleClass, time) {
      var pinTo = vm.getToastPosition();
      var toastClass = styleClass ? styleClass : '';
      $mdToast.show(
        $mdToast.simple()
        .textContent(message)
        .position(pinTo)
        .hideDelay(time ? time*1000 : 3000)
        .toastClass(toastClass)
      );
    };

    vm.showToastAction = function (message, styleClass, time, action) {
      var pinTo = vm.getToastPosition();
      var toastClass = styleClass ? styleClass : '';
      return $mdToast.show(
        $mdToast.simple()
        .textContent(message)
        .action(action)
        .position(pinTo)
        .hideDelay(time ? time*1000 : 3000)
        .toastClass(toastClass)
      );
    };

  }


})();

(function () {
  'use strict';

  angular
    .module('taapp')
    .service('AplicationActiveService', Service);

  /** @ngInject */
  function Service() {
    var vm = {};
    vm.init = init;
    vm.isHidden=false;


    function init() {
    }

    init();

    return vm;
  }
})();

/**
 * Created by akraszewski on 2016-11-22.
 */
(function (angular,$) {
  'use strict';
  angular
    .module('MMSmgt',[])
    .factory('MMSHandler', MMSHandler);

  /**@ngInject */
  function MMSHandler($q) {
    var _this=this;
    const mmsHandlerUrl='https://srmapi.teleaudio.pl/mms/';
   // const mmsHandlerUrl='http://srm.teleaudio.pl:8015/universal/UniversalMmsAttachmentsHandler.ashx';
    //const mmsHandlerUrl='https://content.teleaudio.pl/universal/UniversalMmsAttachmentsHandler.ashx';

    // _this.GetAttachmentCount=function (guid) {
    //   var def=$q.defer();
    //
    //   var MMSResolver = $resource(mmsHandlerUrl,
    //   {}, {
    //       get: {
    //         method: "GET",
    //         headers: {}
    //       }
    //     });
    //   MMSResolver.get({MMSInfo: true, Guid: guid}).$promise.then(function (data) {
    //     var temp = data.split('\n');
    //     var result = [];
    //     for (var i = 0; i < temp.length; i++) {
    //       if (temp[i].indexOf("ContentLocation") != -1) {
    //         if (temp[i].indexOf("text/plain") != -1) {
    //           result.push("text");
    //         } else if (temp[i].indexOf("image/jpeg") != -1) {
    //           result.push("image");
    //         } else if (temp[i].indexOf("application/smil")) {
    //           result.push("smil");
    //         }
    //       }
    //     }
    //     def.resolve(result);
    //   },function (e) {
    //     def.reject(e)
    //   });
    //
    //   return def.promise;
    // };

    _this.GetAttachmentCount= function (guid) {
      var def = $q.defer();
      $.get(mmsHandlerUrl + "?MMSInfo=true&Guid=" + guid).done(function (data) {
        var temp = data.split('\n');
        var result = [];
        for (var i = 0; i < temp.length; i++) {
          if (temp[i].indexOf("ContentLocation") != -1) {
            if (temp[i].indexOf("text/plain") != -1) {
              result.push("text");
            } else if ((temp[i].indexOf("image/jpeg") != -1) || temp[i].indexOf("image/png") != -1) {
              result.push("image");
            } else if (temp[i].indexOf("application/smil")) {
              result.push("smil");
            }
          }
        }
        def.resolve(result);
      }).fail(function (e) {
        def.reject(e);
      });
      return def.promise;
    };

    _this.GetAttachment = function (guid, id, type) {
        var def = $q.defer();
        var url = mmsHandlerUrl+ "?Guid=" + guid + "&AttachmentNum=" + id;
        switch (type) {
          case "text":
            $.get(url).done(function (data) {
              def.resolve({
                type: "text",
                data: data.trim()
                //info: ""
              });
            }).fail(function (e) {
              def.reject(e);
            });
            break;
          case "image":
            def.resolve({
              type: "image",
              data: url.trim()
              //info: ""
            });
            break;
          case "video":
            def.resolve({
              type: "video",
              data: url.trim()
              //info: ""
            });
            break;
          case "smil":
            $.get(url).done(function (data) {
              def.resolve({
                type: "smil",
                data: data
                //info: ""
              });
            }).fail(function (e) {
              def.reject(e);
            });
            break;
        }

        return def.promise;
      };


    return _this;


    //   GetMMS: function (guid) {
    //     var def = $q.defer();
    //     $.get(taconfig.mmsHandlerUrl + "?MMSInfo=true&Guid=" + guid).done(function (data) {
    //       var temp = data.split('\n');
    //       var result = "{ ";
    //       result += "\"stringify\" : \"\", ";
    //       var attatchments = [];
    //       for (var i = 0; i < temp.length; i++) {
    //         if (temp[i].indexOf(":") === -1) continue;
    //         if (temp[i].indexOf("ContentLocation") !== -1) {
    //           var attachType = temp[i].indexOf("application/smil") !== -1 ? "smil" :
    //             temp[i].indexOf("image/jpeg") !== -1 ? "image" :
    //               temp[i].indexOf("video/3gpp") !== -1 ? "video" : "text";
    //           attatchments.push({
    //             type: attachType,
    //             info: temp[i],
    //             data: ""
    //           });
    //           continue;
    //         }
    //         var row = temp[i].split(":");
    //
    //         var fieldName = row[0].replace(" ", "").replace(" ", "");
    //
    //
    //

  }
})(window.angular,$);

(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart
        ('app/toolbar');
    }
})();

(function () {
  'use strict';

  angular
    .module("app.toolbar").component('statusChange', {
      templateUrl: 'app/toolbar/statuschange/status-change.html',
      controllerAs: 'vm',
      bindings: {
        selectedMail: '=',
      },
      controller: StatusChangeController
    });


  /** @ngInject */
  function StatusChangeController($mdDialog, DynamicFactory, SessionManager, toastService, $localStorage) {
    var vm = this;
    vm.srvSwitch = false;
    vm.saveForm = saveForm;
    vm.closeDialog = closeDialog;
    vm.$onInit = onInit;
    vm.serviceClick = serviceClick;
    vm.userStatusOptions = [];
    vm.userSession = {};
    vm.statusSelected = {};
    vm.servicesList = [];
    vm.servicesSelected = [];
    vm.servicesTypeSelected = 0;
    vm.selectedNoneWarn = false;

    function onInit() {
      console.log('statusChange init');
      vm.selectedConsultant = {};
      vm.userSession = SessionManager.getUser();
      GetListServices();
      GetAvableStatuses();
    }

    function GetListServices() {
      DynamicFactory.get('servicesRsc', 'getConsultantServicesAll')().then(function (data) {
        vm.servicesList = data;
      }, function (err) {
        console.log(err);
      });
    }


    function GetAvableStatuses(status) {
      DynamicFactory.get("AuthResource", "GetAvableStatuses")().then(function (
        res
      ) {
        if ($localStorage.hostNumber) {
          var superStatus = angular.copy(getStatusByType(res, 1));
          superStatus.name = 'Biuro TA ' + $localStorage.hostNumber;
          superStatus.typeId = 0;
          superStatus.activeOnLogout = false;
          if (superStatus.phone) {
            superStatus.phone = $localStorage.hostNumber;
            res.unshift(superStatus);
          } else {
            superStatus.phone = $localStorage.hostNumber;
            res[res.indexOf(getStatusByType(res, 1))] = superStatus;
          }
        }
        var partitionedStatuses = _.groupBy(res, function (status) {
          return status.id;
        });

        vm.userStatusOptions = [];
        for (var statusIdKey in partitionedStatuses) {
          if (statusIdKey) {
            vm.userStatusOptions.push({
              status: partitionedStatuses[statusIdKey][0],
              subStatuses: partitionedStatuses[statusIdKey].length > 1 ? partitionedStatuses[statusIdKey] : undefined
            });
          }
        }

        vm.statusSource = angular.copy(res);
        vm.userStatus = getStatusByType(
          vm.statusSource,
          vm.userSession.status,
          vm.userSession.phone1
        );
        if(vm.userStatusOptions[1].subStatuses){
          vm.statusSelected = JSON.stringify(vm.userStatusOptions[1].subStatuses[0]);
        }
        else{
          vm.statusSelected = JSON.stringify(vm.userStatusOptions[1].status);
        }
        console.log('status select: ',vm.statusSelected)
        console.log('status: ', vm.userStatusOptions);
      });
    }
    function getStatusByType(statusList, statusId, phone) {
      for (var i = 0; i < statusList.length; i++) {
        if (statusList[i].id == statusId) {
          if (phone && statusId === 1) {
            if (phone.indexOf(statusList[i].phone) !== -1) {
              return statusList[i];
            }
          } else {
            return statusList[i];
          }
        }
      }
      if (phone.length === 16 && statusId === 1) {
        var superStatus = findSuperStatus(statusList);
        if (superStatus) {
          setUserStatus(superStatus);
          return superStatus;
        } else {
          superStatusNotFound(statusList);
        }
      }
    }
    function serviceClick(item, ev) {
      console.log('serviceClick: ', item, ev);
      var idx = vm.servicesSelected.indexOf(item);
      if (idx > -1) {
        vm.servicesSelected.splice(idx, 1);
      }
      else {
        vm.servicesSelected.push(item);
      }
      console.log('servicesSelected: ',vm.servicesSelected);
    }
    function saveForm() {
      var status = JSON.parse(vm.statusSelected);
      var serviceIds = _.map(vm.servicesSelected, 'serviceID');
      var servicesStr = serviceIds.join(',');
      if(servicesStr.length===0){
        servicesStr = null;
      }
      var selectedServices = [];
      for (var i = 0; i < vm.servicesList.length; i++) {
        console.log(i+':', vm.servicesList[i]);
        if (vm.servicesList[i].selectedLevel > 0) {
          selectedServices.push({
            id: vm.servicesList[i].serviceID,
            level: ((vm.servicesList[i].selectedLevel) === 1 ? 0 : 200)
          });  
        }
      }
      console.log('selectedServices: ', selectedServices);

      if (vm.srvSwitch && selectedServices.length <= 0) {
        vm.selectedNoneWarn = true;
        return;
      }

      DynamicFactory.get('AuthResource', 'setStatus2')(
        status.id,
        status.id === 1 ? status.phone : undefined,
        null,
        selectedServices
      ).then(function (result) {
        vm.userStatus = status;
        SessionManager.setUserStatus(status.id, status.phone, status.typeId);
        closeDialog();

      }, function (err) {
        toastService.showToast(err.data.message, 'error', 4);
      });
    }
    function closeDialog() {
      $mdDialog.hide(JSON.parse(vm.statusSelected));
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('sessionManager')
    .factory('loaderInterceptor', interceptor);

  interceptor.$inject = ['$q', '$rootScope','consts'];

  function interceptor($q, $rootScope,consts) {
    var vm = this;

    vm.requestStack = [];
    return {
      'request': function (config) {
        vm.requestStack.push(config.url);
        if (!$rootScope.loadingProgress) {
          $rootScope.loadingProgress = true;
        }

        return config;
      },

      'responseError': function (rejection) {
        var requestIndex = vm.requestStack.indexOf(rejection.config.url);
        if (requestIndex !== -1) {
          vm.requestStack.splice(requestIndex, 1);
        }

        if (vm.requestStack.length < 1) {
          $rootScope.loadingProgress = false;
        }
        return $q.reject(rejection);
      },
      'response': function (response) {

        var requestIndex = vm.requestStack.indexOf(response.config.url);
        if (requestIndex !== -1) {
          vm.requestStack.splice(requestIndex, 1);
        }

        if (vm.requestStack.length < 1) {
          $rootScope.loadingProgress = false;
        }

        return response;
      }
    };
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseTheming', fuseThemingProvider);

    /** @ngInject */
    function fuseThemingProvider()
    {
        // Inject Cookies Service
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        var registeredPalettes,
            registeredThemes;

        // Methods
        this.setRegisteredPalettes = setRegisteredPalettes;
        this.setRegisteredThemes = setRegisteredThemes;

        //////////

        /**
         * Set registered palettes
         *
         * @param _registeredPalettes
         */
        function setRegisteredPalettes(_registeredPalettes)
        {
            registeredPalettes = _registeredPalettes;
        }

        /**
         * Set registered themes
         *
         * @param _registeredThemes
         */
        function setRegisteredThemes(_registeredThemes)
        {
            registeredThemes = _registeredThemes;
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getRegisteredPalettes: getRegisteredPalettes,
                getRegisteredThemes  : getRegisteredThemes,
                setActiveTheme       : setActiveTheme,
                setThemesList        : setThemesList,
                themes               : {
                    list  : {},
                    active: {
                        'name' : '',
                        'theme': {}
                    }
                }
            };

            return service;

            //////////

            /**
             * Get registered palettes
             *
             * @returns {*}
             */
            function getRegisteredPalettes()
            {
                return registeredPalettes;
            }

            /**
             * Get registered themes
             *
             * @returns {*}
             */
            function getRegisteredThemes()
            {
                return registeredThemes;
            }

            /**
             * Set active theme
             *
             * @param themeName
             */
            function setActiveTheme(themeName)
            {
                // If theme does not exist, fallback to the default theme
                if ( angular.isUndefined(service.themes.list[themeName]) )
                {
                    // If there is no theme called "default"...
                    if ( angular.isUndefined(service.themes.list.default) )
                    {
                        $log.error('You must have at least one theme named "default"');
                        return;
                    }

                    $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                    // Otherwise set theme to default theme
                    service.themes.active.name = 'default';
                    service.themes.active.theme = service.themes.list.default;
                    $cookies.put('selectedTheme', service.themes.active.name);

                    return;
                }

                service.themes.active.name = themeName;
                service.themes.active.theme = service.themes.list[themeName];
                $cookies.put('selectedTheme', themeName);
            }

            /**
             * Set available themes list
             *
             * @param themeList
             */
            function setThemesList(themeList)
            {
                service.themes.list = themeList;
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes, fuseThemingProvider) {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies) {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if (customTheme) {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette) {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName) {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
        // Store generated PALETTES and THEMES objects from $mdThemingProvider
        // in our custom provider, so we can inject them into other areas
        fuseThemingProvider.setRegisteredPalettes($mdThemingProvider._PALETTES);
        fuseThemingProvider.setRegisteredThemes($mdThemingProvider._THEMES);

    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        'default'  : {
            primary   : {
                name: 'grey',
                hues: {
                    'default': '900',
                    'hue-1'  : '800',
                    'hue-2'  : '700',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'red',
                hues: {
                    'default': 'A200',
                    'hue-1'  : 'A400',
                    'hue-2'  : 'A700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'red'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '200',
                    'hue-2'  : '200',
                    'hue-3'  : '50'
                }
            }
        },
         'defaultSRC'  : {
            primary   : {
                name: 'fuse-pale-blue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'red'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'pink': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'blue'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'teal'     : {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'deep-orange'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-pale-blue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            var registeredThemes = fuseTheming.getRegisteredThemes();
            var registeredPalettes = fuseTheming.getRegisteredPalettes();

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;
        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // Set active theme
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions()
    {
        return {
            restrict   : 'E',
            scope      : {
                panelOpen: '=?'
            },
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        backdropEl = angular.element('<div class="ms-theme-options-backdrop"></div>');

                    // Panel open status
                    scope.panelOpen = scope.panelOpen || false;

                    /**
                     * Toggle options panel
                     */
                    function toggleOptionsPanel()
                    {
                        if ( scope.panelOpen )
                        {
                            closeOptionsPanel();
                        }
                        else
                        {
                            openOptionsPanel();
                        }
                    }

                    function openOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = true;

                        // Add open class
                        iElement.addClass('open');

                        // Append the backdrop
                        bodyEl.append(backdropEl);

                        // Register the event
                        backdropEl.on('click touch', closeOptionsPanel);
                    }

                    /**
                     * Close options panel
                     */
                    function closeOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = false;

                        // Remove open class
                        iElement.removeClass('open');

                        // De-register the event
                        backdropEl.off('click touch', closeOptionsPanel);

                        // Remove the backdrop
                        backdropEl.remove();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsPanel = toggleOptionsPanel;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($q, $log, $resource)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate)
    {
        return {
            restrict: 'E',
            compile : function (element, attr)
            {
                var code;
                //No attribute? code is the content
                if ( !attr.code )
                {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr)
                {

                    if ( attr.code )
                    {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code)
                    {
                        if ( code )
                        {
                            if ( shouldInterpolate )
                            {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function ()
                            {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent)
                    {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line)
                        {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line)
                        {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate($translate)
    {
        return function (value)
        {
            var currentLang = $translate.proposedLanguage() || $translate.use();
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).lang(currentLang).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).lang(currentLang).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).lang(currentLang).format('dddd HH:mm');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).format('YYYY-MM-DD HH:mm');
            }

        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function() {
  "use strict";

  angular
    .module("app.navigation")
    .controller("NavigationController", NavigationController);

  /** @ngInject */
  function NavigationController($scope, MenuManager) {
    var vm = this;

    // Data
    vm.MenuManager = MenuManager;
    vm.bodyEl = angular.element("body");
    vm.folded = false;
    vm.broadcastNavChange = broadcastNavChange;
    vm.msScrollOptions = {
      suppressScrollX: true
    };
    // MenuManager.loadNavigationContent();

    vm.defaultMenuContent = ["options-menu"];

    // Methods
    vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
    /**
     * Toggle folded status
     */
    function toggleMsNavigationFolded() {
      vm.folded = !vm.folded;
    }

    // Close the mobile menu on $stateChangeSuccess
    $scope.$on("$stateChangeSuccess", function() {
      vm.bodyEl.removeClass("ms-navigation-horizontal-mobile-menu-active");
    });

    $scope.$on('toogle-sidenav',function(){
      if(!MenuManager.hideSidenav){
        broadcastNavChange(MenuManager.currentMenu.title);
      }
    });


    function broadcastNavChange(menuName){
      setTimeout(function(){
        $scope.$broadcast('nav-change',menuName);
      },1500);
    }

  }
})();

/**
 * Created by kosski on 07.09.2016.
 */
+ function () {
  'use strict';
  angular
    .module('app.navigation')
    .service('MenuManager', MenuManager);

  /** @ngInject */
  function MenuManager(msNavigationService, SessionManager, authRolesConst, $rootScope, $state, $timeout, MenuItems) {
    var _this = {
      addMenuItem: addMenuItem,
      removeMenuItem: removeMenuItem,
      initiateMenu: initiateMenu,
      loadNavigationContent: loadNavigationContent,
      renderMenu: renderMenu,
      findMenuItem: findMenuItem,
      toogleMiniMenu: toogleMiniMenu,
      toogleSidenav: toogleSidenav,
      hideSidenavPane: hideSidenavPane,
      showSidenavPane: showSidenavPane,
      menuItems: [],
      currentMenu: null,
      template: '',
      hideMiniMenu: false,
      miniMenuClicked: false,
      hideSidenav: false,
      panelClicked: false
    };

    // $rootScope.$on('$stateChangeStart', stateChangeStart);
    var defaultMenuContent = ['options-menu'];

    var menuItems = [{
        title: 'DASHBOARD',
        tooltip: 'Dashboard',
        icon: '/assets/icons/mainmanu/home-dashboard.svg',
        // icon: 'menu-dashbord',
        navTemplate: '<dashboard-button flex="100"></dashboard-button>',
        state: 'app.contactcenter_dashboard',
        class: 'hide-title tooltip-toggle tt-dashboard',
        // stateOpen: true,
        // menuContent: ['dashboard-menu', 'nav-status-axis', 'options-menu']
      },
      {
        title: 'COMMUNICATOR',
        tooltip: 'Komunikator',
        // translate: 'MENU.COMMUNICATOR',
        navTemplate: '<communicator-switch></communicator-switch>',
        navClass: 'nav-communicator',
        icon: '/assets/navigation/speech-bubble.svg',
        // icon: 'menu-communicator',
        state: 'app.contactcenter_communicator;app.contactcenter_internalmessage',
        class: 'only-communicator hide-title tooltip-toggle tt-communicator',
        menuContent: ['active-session'] //,
        //showAlert: 'url',
        // puff: function () {
        //   return !SessionManager.isConsultant();
        // }
      },
      // {
      //   title: 'COMMUNICATOR',
      //   tooltip:'Komunikator',
      //   // translate: 'MENU.COMMUNICATOR',
      //   navTemplate:'<communicator-switch></communicator-switch>',
      //   icon: '/assets/navigation/speech-bubble.svg',
      //   // icon: 'menu-communicator',
      //   state: 'app.contactcenter_internalmessage',
      //   class: 'only-communicator hide-title tooltip-toggle tt-communicator',
      //   menuContent: ['active-session'],
      //   //showAlert: 'url',
      //   puff: function () {
      //     return SessionManager.isConsultant();
      //   }
      // },
      {
        title: 'MAIL',
        tooltip: 'ORDERBOX',
        icon: '/assets/navigation/email.svg',
        // icon: 'menu-orderbox',
        state: 'app.contactcenter_orderbox',
        class: 'hide-title tooltip-toggle tt-dashboard',
        menuContent: ['main-sidenav']
      },
      // {
      //   title: 'PARTY',
      //   icon: 'menu-party',
      //   state: 'app.contactcenter_party',
      //   class:'hide-title tooltip-toggle tt-dashboard',

      //   puff: function () {
      //     return SessionManager.getUserRoleId() < authRolesConst.manager;
      //   }
      // },
      {
        title: 'MANAGEMENT',
        tooltip: 'Zarządzanie',
        icon: '/assets/navigation/tools.svg',
        // icon: 'menu-managment',
        group: true,
        // class:'hide-title tooltip-toggle tt-dashboard',
        state: 'app.contactcenter_management',
        puff: function () {
          return SessionManager.getUserRoleId() > authRolesConst.manager;
        }
      },
      // {
      //   title: 'MENU.MANAGEMENT.SERVICES',
      //   icon: 'icon-server-network',
      //   weight: 1,
      //   state: 'app.contactcenter_management.services.list',
      //   class:'hide-title tooltip-toggle tt-dashboard',
      //   puff: function () {
      //     return SessionManager.getUserRoleId() >= authRolesConst.manager;
      //   }
      // },
      // {
      //   title: 'MENU.MANAGEMENT.CALLCENTERS',
      //   icon: 'icon-account-multiple',
      //   weight: 1,
      //   state: 'app.contactcenter_management.callcenters.list',
      //   class:'hide-title tooltip-toggle tt-dashboard',
      //   puff: function () {
      //     return SessionManager.getUserRoleId() > authRolesConst.manager;
      //   }
      // },
      // // {
      // //   title: 'MENU.MANAGEMENT.GROUPS',
      // //   icon: 'icon-account-multiple',
      // //   weight: 1,
      // //   state: 'app.contactcenter_groups',
      // //   puff: function () {
      // //     return SessionManager.getUserRoleId() >= authRolesConst.manager;
      // //   }
      // // },
      // {
      //   title: 'MENU.MANAGEMENT.TRADEMILL',
      //   icon: 'icon-rss-box',
      //   weight: 1,
      //   state: 'app.contactcenter_trademill',
      //   class:'hide-title tooltip-toggle tt-dashboard',
      //   puff: function () {
      //     return SessionManager.getUserRoleId() > authRolesConst.manager;
      //   }
      // },
      {
        title: 'REPORTS',
        tooltip: 'Raporty',
        icon: '/assets/navigation/bar-chart.svg',
        // icon: 'menu-reports',
        // weight: 1,
        state: 'app.contactcenter_reports',
        class: 'hide-title tooltip-toggle tt-dashboard'
        //,
        // puff: function () {
        //   return SessionManager.getUserRoleId() > authRolesConst.manager;
        // }
      }
      // ,{
      //   title: 'REPORTSONLINE',
      //   icon: 'menu-activeCalls',
      //   // weight: 1,
      //   state: 'app.contactcenter_callsonline',
      //   class:'hide-title tooltip-toggle tt-dashboard',
      //   puff: function () {
      //     return SessionManager.getUserRoleId() > authRolesConst.manager;
      //   }
      // }


      // app.contactcenter_raports
      //,
      // {
      //   title: 'MENU.MANAGEMENT.CONSULTANTS',
      //   icon: 'icon-rss-box',
      //   weight: 1,
      //   state: 'app.contactcenter_management.consultants.list',
      //   puff: function () {
      //     return SessionManager.getUserRoleId() >= authRolesConst.manager;
      //   }
      // }
    ];


    // function stateChangeStart(evt, to, params){
    //   console.log('MenuManager | state change detect!',to,params);

    //   loadNavigationContent(to.name);
    // }

    // function loadNavigationContent(name){

    //   // var state = _.find(menuItems, {
    //   //   state: name ? name : $rootScope.state.current.name
    //   // });
    //   name = name ? name : $rootScope.state.current.name;
    //   var state;
    //   for (var index = 0; index < menuItems.length; index++) {
    //     var element = menuItems[index];
    //     if(name.indexOf(element.state)){
    //       state = element;
    //       break;
    //     }
    //   }

    //   if(state){
    //     if(state.menuContent){
    //       _this.template = parseMenuTemplate(state.menuContent);
    //     }else{
    //       _this.template = parseMenuTemplate(defaultMenuContent);
    //     }
    //   }
    // }

    function loadNavigationContent(state) {
      // var state = _.find(menuItems, {
      //   state: name ? name : $rootScope.state.current.name
      // });
      // name = name ? name : $rootScope.state.current.name;
      // var state;
      // MenuManager.initiateMenu();
      // console.log('loadNav  _this.hideMiniMenu: ', _this.hideMiniMenu);
      if (!state) {
        for (var index = 0; index < menuItems.length; index++) {
          var element = menuItems[index];
          if (element.state.indexOf(';')) {
            var states = element.state.split(';');
            for (var sIndex = 0; sIndex < states.length; sIndex++) {
              var sElement = states[sIndex];
              if ($rootScope.state.current.name.indexOf(sElement) !== -1) {
                state = element;
                break;
              }
            }
          } else {
            if ($rootScope.state.current.name.indexOf(element.state) !== -1) {
              state = element;
              break;
            }
          }
        }
      }


      if (!state.template) {
        if (state.menuContent) {
          state.template = parseMenuTemplate(
            state.menuContent
          );
        } else {
          state.template = parseMenuTemplate(defaultMenuContent);
        }
      }
      if (state.stateOpen) {
        $state.go(state.state);
      }
      if (_this.currentMenu && _this.currentMenu.state.indexOf(state.state) === -1) {
        _this.hideMiniMenu = false;
      } else {
        if (_this.hideSidenav) {
          toogleMiniMenu();
        }
      }
      _this.currentMenu = state;
    }

    function parseMenuTemplate(componentArray) {
      var result = "";
      componentArray.forEach(function (component) {
        result +=
          "<" +
          component +
          ' flex menu-item="menuItem"></' +
          component +
          ">";
      });
      return result;
    }

    function addMenuItem(menuItem) {
      if (!menuItem.puff || (menuItem.puff && !menuItem.puff())) {
        var key = menuItem.title.slice(menuItem.title.indexOf('.') + 1)
          .replace(/\.TITLE/gi, '');
        // console.log('menu.manager -> add menuItem with key : '+ key);

        _this.menuItems.push(menuItem);
        // msNavigationService.saveItem(key, menuItem);
      }
    }

    function removeMenuItem(viewTitle) {
      msNavigationService.deleteItem(viewTitle);
    };

    function initiateMenu() {
      // console.log($rootScope.state,$state);
      // loadNavigationContent($rootScope.state.current.name);
      var roleId = SessionManager.getUserRole();
      if (_this.menuItems.length != menuItems.length) {
        _this.menuItems = [];
        if (roleId !== authRolesConst.None) {
          menuItems.forEach(addMenuItem);
        }
      }
    }

    function findMenuItem(title) {
      return _.find(menuItems, function (o) {
        return o.title === title
      });
    }

    function toogleMiniMenu() {
      _this.hideMiniMenu = !_this.hideMiniMenu;
      _this.miniMenuClicked = true;
      $timeout(function () {
        _this.miniMenuClicked = false;
      }, 300);
    }

    function toogleSidenav() {
      console.log('toogleSidenav');
      setNavMenu();

      _this.hideSidenav = !_this.hideSidenav;
      _this.panelClicked = true;
      $timeout(function () {
        _this.panelClicked = false;
      }, 300);
      // _this.toogleMiniMenu();

    }

    function hideSidenavPane(resize) {
      setNavMenu();
      _this.hideSidenav = true;
      _this.hideMiniMenu = true;
    }

    function showSidenavPane(resize) {
      if (resize) {
        setNavMenu();
      }
      _this.hideSidenav = false;
      _this.hideMiniMenu = false;
    }

    function renderMenu(media, resize) {
      console.log('renderMenu: ', media);
      if (!media) {
        hideSidenavPane(resize);
      } else {
        showSidenavPane(resize);
      }
    }
    return _this;
  }

  function setNavMenu() {
    var navMenu = angular.element(document.querySelector('#nav-menu'));
    var navMenuContent = navMenu.find('nav-container');

    var navAbsolute = angular.element(document.querySelector('#nav-absolute'));
    var navAbsoluteContent = navAbsolute.find('nav-container');

    if (navMenuContent && navMenuContent.length > 0) {
      navAbsolute.append((navMenuContent));
    } else if (navAbsoluteContent && navAbsoluteContent.length > 0) {
      navMenu.append((navAbsoluteContent));
    }
  }
}();

(function () {
    'use strict';

    angular
        .module('taapp')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope, $state, msUtils, MenuManager, callInfoBarService, internalMessageService) {
        var vm = this;
        vm.state = $state;
        vm.animateActivate = false;
        vm.MenuManager = MenuManager;
        vm.$onInit = onInit;
        vm.callInfoBarService = callInfoBarService;
        vm.internalMessageService = internalMessageService;
        function onInit() {
            var browserInfo = msUtils.detectBrowser();
            if (browserInfo && browserInfo.browser !== 'firefox') {
                vm.animateActivate = true;
            }
            vm.internalMessageService.init();
        }


        vm.$onDestroy = function () {
            vm.internalMessageService.clearSession();
        };
        vm.toogleSidenav = function () {
            vm.MenuManager.toogleSidenav();
            if (!vm.MenuManager.hideMiniMenu) {
                vm.MenuManager.toogleMiniMenu();
            }
          $scope.$broadcast('toogle-sidenav');

        };

        vm.toogleMiniMenu = function () {
            vm.MenuManager.toogleMiniMenu();
        };

        //console.log("MainController - loaded");
        //console.log("state: ",$state.current);

        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event) {
            if (event.targetScope.$id === $scope.$id) {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
        // $scope.$on("$stateChangeSuccess", stateChangeSuccess);
        // function stateChangeSuccess(event,toState,toParams,fromState,fromParams) {
        //     vm.MenuManager.hideMiniMenu = true;
        //     tripleviewService.hideSidenav = false;
        //   }
    }
})();

(function () {
  "use strict";

  angular
    .module("app.toolbar")
    .controller("ToolbarController", ToolbarController);

  /** @ngInject */
  function ToolbarController(DynamicFactory, communicatorService, $mdDialog, $rootScope, $scope, $q, $state, $timeout, $mdSidenav, $translate, confirmDialogService, msNavigationService, SessionManager, AuthService, $localStorage, WebSocketManager, toastService) {
    var vm = this;

    // Data
    $rootScope.global = {
      search: ""
    };
    vm.userSession = {};

    vm.bodyEl = angular.element("body");

    // [
    //   {
    //     'title': 'Online',
    //     'icon': 'icon-checkbox-marked-circle',
    //     'color': '#4CAF50'
    //   },
    //   {
    //     'title': 'Away',
    //     'icon': 'icon-clock',
    //     'color': '#FFC107'
    //   },
    //   {
    //     'title': 'Do not Disturb',
    //     'icon': 'icon-minus-circle',
    //     'color': '#F44336'
    //   },
    //   {
    //     'title': 'Invisible',
    //     'icon': 'icon-checkbox-blank-circle-outline',
    //     'color': '#BDBDBD'
    //   },
    //   {
    //     'title': 'Offline',
    //     'icon': 'icon-checkbox-blank-circle-outline',
    //     'color': '#616161'
    //   }
    // ];
    vm.languages = {
      pl: {
        title: "Polish",
        translation: "TOOLBAR.POLISH",
        code: "pl",
        flag: "pl"
      },
      en: {
        title: "English",
        translation: "TOOLBAR.ENGLISH",
        code: "en",
        flag: "us"
      }
    };
    vm.toastVisible = false;

    // Methods
    vm.toggleSidenav = toggleSidenav;
    vm.logout = logout;
    vm.changeLanguage = changeLanguage;
    vm.setUserStatus = setUserStatus;
    vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
    vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
    vm.search = search;
    vm.searchResultClick = searchResultClick;

    //////////

    init();

    /**
     * Initialize
     */
    function init() {
      // Select the first status as a default
      WebSocketManager.registerWebSocketMethod('ConsultantStatusUpdate', 'ConsultantStatusUpdateToolbar', onStatusUpdate, buildRegex());
      WebSocketManager.registerWebSocketMethod('ConsultantPhoneUpdate', 'ConsultantPhoneUpdateToolbar', onPhoneUpdate, buildRegex());
      WebSocketManager.registerWebSocketMethod('ConsultantLogOUT', 'ConsultantLogOUTToolbar', onSTATEUpdate, buildRegex());

      if (SessionManager.isConsultant()) {
        //debugger;
        GetAvableStatuses();
      } else {
        notifyChangeState();
      }
      // window.onbeforeunload = $scope.unloadMessage;
      // $scope.setConfirmUnload(true);
      // Get the selected language directly from angular-translate module setting
      vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
      vm.messageToReply = 0;
      vm.messageToReplyOld = 0;
      vm.isConsultant = false;
      if (SessionManager.isConsultant()) {
        vm.isConsultant = true;
        WebSocketManager.registerWebSocketMethod(
          "CallChat",
          "msgArrive",
          wsCallsMsgArrive,
          SessionManager.buildRegexForConsultant()
        );
        getSessionMessage();
      }
      vm.userSession = SessionManager.getUser();
      console.log('ToolbarController | userSession', vm.userSession);

      vm.SessionManager = SessionManager;
      if (SessionManager.isConsultant()) {
        $scope.$on("statusUpdate", GetAvableStatuses);
      }
    }

    function buildRegex() {
      var user = SessionManager.getUser();
      // var partnerId = user.partnerId;
      console.log('regex: ' + '^ccs\\.' + user.partnerId + '\\/' + user.callCenterId + '\\/' + user.consultantId);
      return '^ccs\\.' + user.partnerId + '\\/' + user.callCenterId + '\\/' + user.consultantId;
    }

    function onStatusUpdate(data) {
      if (data.Content) {
        if (angular.isString(data.Content))
          data.Content = JSON.parse(data.Content);

        // var consultant = findConsultant(data);

        // if (consultant) {
        //   consultant.status = data.Content.status;
        //   if (consultant.status == 2) {
        //     if (!consultant.totalBreakTime) {
        //       consultant.totalBreakTime = 0;
        //     }
        //   }
        //   //przeliczenie wszystkich liczb w filtrach
        //   calcFiltersNumbers();
        // }
        if (data.Content.status == 0) {
          vm.statusMemo = angular.copy(vm.userSession);
        }
        vm.userSession.status = data.Content.status;
        vm.userStatus = getStatusByType(
          vm.statusSource,
          vm.userSession.status,
          vm.userSession.phone1
        );
      }
    }

    function onPhoneUpdate(data) {
      if (data.Content) {
        if (angular.isString(data.Content))
          data.Content = JSON.parse(data.Content);

        // var consultant = findConsultant(data);

        // if (consultant) {
        //   consultant.phone1 = data.Content.phone;
        //   consultant.phoneTypeId = data.Content.phoneType;
        //   //przeliczenie wszystkich liczb w filtrach
        //   calcFiltersNumbers();
        // }
        if (data.Content.phoneType == 0) {
          vm.userStatus = _.find(vm.statusSource, {
            typeId: 0
          });
          vm.userSession.phone1 = vm.userStatus.phone;
        } else {
          vm.userSession.phone1 = data.Content.phone;
          vm.userStatus = getStatusByType(
            vm.statusSource,
            vm.userSession.status,
            vm.userSession.phone1
          );
        }
      }
    }

    function onSTATEUpdate(data) {
      if (data.Content) {
        if (angular.isString(data.Content))
          data.Content = JSON.parse(data.Content);
        if (data.Content.state == 0 && vm.userSession.userId == data.Content.consultantID) {
          //wylogowanie tylko w wypadku wysłania rozkazu managera
          if (data.Content.managerId) {
            WebSocketManager.unregisterWebSocketMethod('ConsultantLogOUT', 'ConsultantLogOUTToolbar');

            console.log('ToolbarController | onSTATEUpdate logout');
            // if(vm.enableKick){
            // vm.logout(true);
            AuthService.logout(true);
            // }else{
            //   console.log('ToolbarController | onSTATEUpdate ignoreLogout');
            // }

          } else {
            notifyChangeState();
          }
        }
      }
    }

    function GetAvableStatuses(status) {
      DynamicFactory.get("AuthResource", "GetAvableStatuses")().then(function (
        res
      ) {
        //debugger;
        if ($localStorage.hostNumber) {
          var superStatus = angular.copy(getStatusByType(res, 1));
          superStatus.name = 'Biuro TA ' + $localStorage.hostNumber;
          superStatus.typeId = 0;
          superStatus.activeOnLogout = false;
          if (superStatus.phone) {
            superStatus.phone = $localStorage.hostNumber;
            res.unshift(superStatus);
          } else {
            superStatus.phone = $localStorage.hostNumber;
            res[res.indexOf(getStatusByType(res, 1))] = superStatus;
          }
        }
        var partitionedStatuses = _.groupBy(res, function (status) {
          return status.id;
        });

        vm.userStatusOptions = [];
        for (var statusIdKey in partitionedStatuses) {
          if (statusIdKey) {
            vm.userStatusOptions.push({
              status: partitionedStatuses[statusIdKey][0],
              subStatuses: partitionedStatuses[statusIdKey].length > 1 ? partitionedStatuses[statusIdKey] : undefined
            });
          }
        }


        console.log('ToolbarController', partitionedStatuses);
        console.log('ToolbarController - userStatusOptions: ', vm.userStatusOptions);
        // if ($localStorage.hostNumber) {
        //   var superStatus = angular.copy(getStatusByType(res, 1));
        //   superStatus.phone = $localStorage.hostNumber;
        //   superStatus.name = "Biuro TA";
        //   superStatus.activeOnLogout = false;
        //   // if (res[1].phone) {
        //   res.unshift(superStatus);
        //   // } else {
        //   //   res[1] = superStatus;
        //   // }
        //   vm.userStatusOptions = res;
        // } else {
        //   vm.userStatusOptions = res;
        //   // vm.userStatus =
        //   // setUserStatus(vm.userStatusOptions[1]);
        // }
        vm.statusSource = angular.copy(res);
        vm.userStatus = getStatusByType(
          vm.statusSource,
          vm.userSession.status,
          vm.userSession.phone1
        );
        notifyChangeState();

        // vm.userStatus = vm.userStatusOptions[1];
      });
    }

    function notifyChangeState() {
      console.log('changing user state to 1');
      DynamicFactory.get("AuthResource", "changeState")(1).then(function (result) {
        // setUserStatus(vm.statusMemo ? vm.statusMemo.status : vm.userSession.status, vm.statusMemo ? vm.statusMemo.phone1 : vm.userSession.phone1);
        console.log('consultant user changed');
      });
    }

    function getStatusByType(statusList, statusId, phone) {
      for (var i = 0; i < statusList.length; i++) {
        if (statusList[i].id == statusId) {
          if (phone && statusId === 1) {
            if (phone.indexOf(statusList[i].phone) !== -1) {
              return statusList[i];
            }
          } else {
            return statusList[i];
          }
        }
      }
      if (phone.length === 16 && statusId === 1) {
        // var superStatus = _.find(statusList, {
        //   typeId: 0
        // });
        var superStatus = findSuperStatus(statusList);
        if (superStatus) {
          setUserStatus(superStatus);
          return superStatus;
        } else {
          superStatusNotFound(statusList);
          // var offlineStatus = _.find(statusList, {
          //   id: 0
          // });
          // setUserStatus(offlineStatus);
          // return offlineStatus;
        }
      }
    }


    function findSuperStatus(statusList) {
      return _.find(statusList, {
        typeId: 0
      });
    }

    function superStatusNotFound(statusList) {
      var offlineStatus = _.find(statusList, {
        id: 0
      });
      setUserStatus(offlineStatus);
      toastService.showToast("Stanowisko nie posiada przypisanego numeru telefonu \n Nie można być Aktywnym na tej maszynie",
        "warn",
        vm.timeShow
      );
      return offlineStatus;
    }

    function getSessionMessage() {
      DynamicFactory.get("ChatPartRsc", "getSession")(null).then(
        function (data) {
          if (data.sessionID) {
            getMessageToReply(data.sessionID);
          }
        },
        function (err) {
          console.log(err);
        }
      );
    }

    function getMessageToReply(sessionID) {
      DynamicFactory.get("ChatPartRsc", "getMessageToReply")(sessionID).then(
        function (data) {
          vm.messageToReply = data.messageToReply;
          vm.messageToReplyOld = angular.copy(vm.messageToReply);
          //showNotifMsg();
        },
        function (err) {
          console.log(err);
        }
      );
    }

    function wsCallsMsgArrive(data) {
      vm.data = JSON.parse(data.Content);
      if (vm.data.type === 1) {
        vm.messageToReply = vm.messageToReply + 1;
        vm.messageToReplyOld = angular.copy(vm.messageToReply);
        // if (vm.data.message.type !== 'A') {
        //   showNotifMsg();
        // }
      } else if (vm.data.type === 2) {
        var msgList = vm.data.message.messages;
        if (msgList && msgList.length > 0) {
          var lastMsg = msgList[msgList.length - 1];
          if (lastMsg.type === 'A') { // nie pokazywac alertu gdy akcja
            vm.messageToReply = vm.data.message.messageToReply;
            vm.messageToReplyOld = angular.copy(vm.messageToReply);
            return;
          }
        }
        // if (vm.messageToReplyOld !== vm.data.message.messageToReply) {
        //   showNotifMsg();
        // }
        vm.messageToReply = vm.data.message.messageToReply;
        vm.messageToReplyOld = angular.copy(vm.messageToReply);
      } else if (vm.data.type === 3) {
        vm.messageToReplyOld = angular.copy(vm.messageToReply);
        vm.messageToReply = 0;
      }
    }

    function showNotifMsg() {
      if (!vm.toastVisible) {
        vm.timeShow = 4;
        vm.toastVisible = true;
        toastService.showToast(
          $translate.instant("TOOLBAR.NEW_MESSAGE"),
          "warn",
          vm.timeShow
        );
        $timeout(function () {
          vm.toastVisible = false;
        }, vm.timeShow * 1000);
      }
    }
    // $scope.$on('onUnload', function (e) {
    //    DynamicFactory.get('AuthResource', 'setStatus')(0);

    //     console.log('leaving page'); // Use 'Preserve Log' option in Console

    // });

    // $scope.unloadMessage = function() {
    //   DynamicFactory.get('AuthResource', 'setStatus')(0);
    //     return 'You have unsaved changes';
    // }
    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    /**
     * Sets User Status
     * @param status
     */
    function setUserStatus(ev, status) {
      console.log('setUserStatus: ', status)
      // if(status.id === vm.userStatus.id){
      //   if ($localStorage.dtNumber && $localStorage.dtNumber.length > 0) {
      //     DynamicFactory.get('AuthResource', 'setPhone')({
      //       number: status.phone
      //     }).then(function(result) {
      //       vm.userStatus = status;
      //       SessionManager.setUserStatus(vm.userStatus.id);
      //     });
      //   }
      // }else{

      setSessionBehaviorForBreakTime(status).then(function (sessionBehavior) {
        if (status.id == 1) {
          console.log('open modal');
          openStatusModal(ev, '<status-change status-data="status"></status-change>')
            .then(function (result) {
              if (result) {
                console.log('session: ', result);
                console.log('userStatusOptions: ', vm.userStatusOptions);
                vm.userStatus = result;
                console.log('userStat: ', vm.userStatusOptions);
                if (vm.userStatusOptions && vm.userStatusOptions[1]) {
                  vm.userStatusOptions[1].status.name = result.name;
                }
                console.log('userStat: ', vm.userStatusOptions);
              }
            });
        }
        else {
          DynamicFactory.get("AuthResource", "setStatus")(
            status.id,
            status.id === 1 ? status.phone : undefined,
            sessionBehavior
          ).then(function (result) {
            vm.userStatus = status;
            SessionManager.setUserStatus(status.id, status.phone, status.typeId);
            // if ($localStorage.dtNumber && $localStorage.dtNumber.length > 0) {
            //   DynamicFactory.get('AuthResource', 'setPhone')({
            //     number: $localStorage.dtNumber
            //   }).then(function(result) {});
            // }

            //jeżeli wybrano zakończenie sesji to zakończ sesję po ustawieniu stautsu przerwy

            if (status.id == 2 || status.id == 0) {
              if (sessionBehavior == 3) {
                communicatorService.closeUnclosedSessions()

              }
              else if (sessionBehavior == 2) {
                communicatorService.clearUnclosedSessions()
              }
            }

          }, function (err) {

            //console.log('err setStatus: ',err.data.message);
            toastService.showToast(err.data.message, 'error', 4);
          });
        }
      }, function (err) {
        //uzytkownik w cofirmie wybrał brak zmiany statusa
      });


      // }
    }

    function openStatusModal(ev, content) {
      return $mdDialog.show({
        locals: {
          statusData: vm.data
        },
        template: '<md-dialog-content>' + content + '</md-dialog-content>',
        controller: function (statusData) {
          this.statusData = statusData;
        },
        controllerAs: 'vm',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true //,
      })
    }


    function setSessionBehaviorForBreakTime(status) {
      var defer = $q.defer();

      var currentStatus = SessionManager.getUserStatus()
      var numberOfUncloseSessions = communicatorService.countUnclosedSessions();
      //var showConfirmAfterStatusChang = (status.id == 2 || status.id == 0) && currentStatus != status.id && !((currentStatus == 2 && status.id == 0)) || (currentStatus == 0 && status.id == 2);
      var showConfirmAfterStatusChang = (status.id == 0 && currentStatus != status.id); //komunikat ma sie pojawic tylko gdy jest wybrany status NIEAKTYWNY

      if (showConfirmAfterStatusChang && numberOfUncloseSessions > 0) {
        confirmDialogService
          .showConfirm('confirmBreakSessionBehavior', 'GO_FOR_BREAK_CONFIRM.SESSION_BEHAVOIR_QUESTION',
            {
              option1: 'GO_FOR_BREAK_CONFIRM.CANCEL',
              option2: 'GO_FOR_BREAK_CONFIRM.FORWARD',
              option3: 'GO_FOR_BREAK_CONFIRM.CLOSE_SESSIONS'
            })
          .then(function (value) {
            console.log('confirmBreakSessionBehavior: value: ' + value);
            defer.resolve(value);
          }, function (err) {
            console.log('confirmBreakSessionBehavior: value: brak zmiany statusu');
            defer.reject();
          }
          );
      } else {
        //dla innych statusów niz NIEAKTYWNY nic nie robimy
        defer.resolve(0);
      }

      return defer.promise;
    }



    /**
     * Logout Function
     */
    function logout(activeLogout) {
      // Do logout here..
      WebSocketManager.unregisterWebSocketMethod('ConsultantLogOUT', 'ConsultantLogOUTToolbar');
      if (vm.userStatus && !activeLogout && vm.userStatus.id == 1) {
        confirmDialogService
          .showDefaultConfirm([{
            token: "translate",
            value: "CONFIRM_LOGOUT"
          },
          {
            token: "title",
            value: 'Nie można pozostać aktynym po wylogowaniu na numerze "' +
              vm.userStatus.name +
              '".\r\n Czy chcesz się wylogować nieaktywnym ?'
          }
          ])
          .then(
            function () {
              console.log('ToolbarController | AuthService logout activeLogout=true');
              AuthService.logout();
            },
            function (err) { }
          );
      } else {
        console.log('ToolbarController | AuthService logout activeLogout=false');
        AuthService.logout();
      }
      // SessionManager.killSession();
    }

    /**
     * Change Language
     */
    function changeLanguage(lang) {
      vm.selectedLanguage = lang;
      // Change the language
      $translate.use(lang.code);
    }

    /**
     * Toggle horizontal mobile menu
     */
    function toggleHorizontalMobileMenu() {
      vm.bodyEl.toggleClass("ms-navigation-horizontal-mobile-menu-active");
    }

    /**
     * Toggle msNavigation folded
     */
    function toggleMsNavigationFolded() {
      msNavigationService.toggleFolded();
    }

    /**
     * Search action
     *
     * @param query
     * @returns {Promise}
     */
    function search(query) {
      var navigation = [],
        flatNavigation = msNavigationService.getFlatNavigation(),
        deferred = $q.defer();

      // Iterate through the navigation array and
      // make sure it doesn't have any groups or
      // none ui-sref items
      for (var x = 0; x < flatNavigation.length; x++) {
        if (flatNavigation[x].uisref) {
          navigation.push(flatNavigation[x]);
        }
      }

      // If there is a query, filter the navigation;
      // otherwise we will return the entire navigation
      // list. Not exactly a good thing to do but it's
      // for demo purposes.
      if (query) {
        navigation = navigation.filter(function (item) {
          if (
            angular.lowercase(item.title).search(angular.lowercase(query)) > -1
          ) {
            return true;
          }
        });
      }

      // Fake service delay
      $timeout(function () {
        deferred.resolve(navigation);
      }, 1000);

      return deferred.promise;
    }

    /**
     * Search result click action
     *
     * @param item
     */
    function searchResultClick(item) {
      // If item has a link
      if (item.uisref) {
        // If there are state params,
        // use them...
        if (item.stateParams) {
          $state.go(item.state, item.stateParams);
        } else {
          $state.go(item.state);
        }
      }
    }
  }
})();

/**
 * @file_name lodash.module.
 * @author    kosski {@link https://www.linkedin.com/in/ninjarafal}
 * @copyright Copyright (c) 2016, TELEAUDIO DWA
 * @license      The MIT License {@link http://opensource.org/licenses/MIT}
 */
(function () {
  'use strict';

  angular
    .module('taLodashWrapper', []);

})();

/**
 * @file_name lodash.constant.
 * @author    kosski {@link https://www.linkedin.com/in/ninjarafal}
 * @copyright Copyright (c) 2016, TELEAUDIO DWA
 * @license      The MIT License {@link http://opensource.org/licenses/MIT}
 */
  (function () {
    'use strict';

    angular
      .module('taLodashWrapper')
      .factory('Lodash', taLodash);

    taLodash.$inject = ['$window'];

    /* @ngInject */
    function taLodash($window) {
      return $window._;
    }

  })();

/**
 * @file_name lodash.run.
 * @author    kosski {@link https://www.linkedin.com/in/ninjarafal}
 * @copyright Copyright (c) 2016, TELEAUDIO DWA
 * @license      The MIT License {@link http://opensource.org/licenses/MIT}
 */
(function () {
  'use strict';

  angular
    .module('taLodashWrapper').run(taLodashRun);

  taLodashRun.$inject = ['$rootScope', '$window'];

  /* @ngInject */
  function taLodashRun ($rootScope, $window) {
    //rocket magic
    $rootScope._ = $window._;
  }

})();



/**
 * @file_name lodash.constant.
 * @author    kosski {@link https://www.linkedin.com/in/ninjarafal}
 * @copyright Copyright (c) 2016, TELEAUDIO DWA
 * @license      The MIT License {@link http://opensource.org/licenses/MIT}
 */
(function () {
  'use strict';
  angular
    .module('taLodashWrapper').constant('_', window._);
  // angular
  //   .module('taapp').constant('consts', {
  //   api: 'https://ccapi.teleaudio.pl/api/'
  // });
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, $translateProvider, $provide, fuseConfigProvider) {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        // uiGmapgoogle-maps configuration
        // uiGmapGoogleMapApiProvider.configure({
        //     //    key: 'your api key',
        //     v: '3.exp',
        //     libraries: 'weather,geometry,visualization'
        // });

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'app/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('pl');
        $translateProvider.useSanitizeValueStrategy('sanitizeParameters');

        // Text Angular options
        $provide.decorator('taOptions', [
            '$delegate', function (taOptions) {
                taOptions.toolbar = [
                    ['bold', 'italics', 'underline', 'ul', 'ol', 'quote']
                ];

                taOptions.classes = {
                    focussed: 'focussed',
                    toolbar: 'ta-toolbar',
                    toolbarGroup: 'ta-group',
                    toolbarButton: 'md-button',
                    toolbarButtonActive: 'active',
                    disabled: '',
                    textEditor: 'form-control',
                    htmlEditor: 'form-control'
                };

                return taOptions;
            }
        ]);

        // Text Angular tools
        $provide.decorator('taTools', [
            '$delegate', function (taTools) {
                taTools.quote.iconclass = 'icon-format-quote';
                taTools.bold.iconclass = 'icon-format-bold';
                taTools.italics.iconclass = 'icon-format-italic';
                taTools.underline.iconclass = 'icon-format-underline';
                taTools.strikeThrough.iconclass = 'icon-format-strikethrough';
                taTools.ul.iconclass = 'icon-format-list-bulleted';
                taTools.ol.iconclass = 'icon-format-list-numbers';
                taTools.redo.iconclass = 'icon-redo';
                taTools.undo.iconclass = 'icon-undo';
                taTools.clear.iconclass = 'icon-close-circle-outline';
                taTools.justifyLeft.iconclass = 'icon-format-align-left';
                taTools.justifyCenter.iconclass = 'icon-format-align-center';
                taTools.justifyRight.iconclass = 'icon-format-align-right';
                taTools.justifyFull.iconclass = 'icon-format-align-justify';
                taTools.indent.iconclass = 'icon-format-indent-increase';
                taTools.outdent.iconclass = 'icon-format-indent-decrease';
                taTools.html.iconclass = 'icon-code-tags';
                taTools.insertImage.iconclass = 'icon-file-image-box';
                taTools.insertLink.iconclass = 'icon-link';
                taTools.insertVideo.iconclass = 'icon-filmstrip';

                return taTools;
            }
        ]);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars': false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile': true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();

(function () {
  "use strict";

  angular.module("taapp").run(runBlock);

  /** @ngInject */
  function runBlock(
    $rootScope,
    $timeout,
    $state,
    ResourceBuilder,
    SessionManager,
    $http,
    $mdMedia,
    MenuManager
  ) {

    // Activate loading indicator
    var stateChangeStartEvent = $rootScope.$on("$stateChangeStart", function () {
      $rootScope.loadingProgress = true;
    });

    // De-activate loading indicator
    var stateChangeSuccessEvent = $rootScope.$on(
      "$stateChangeSuccess",
      function () {
        $timeout(function () {
          $rootScope.loadingProgress = false;
        });
      }
    );

    // Store state in the root scope for easy access
    $rootScope.state = $state;

    // Cleanup
    $rootScope.$on("$destroy", function () {
      stateChangeStartEvent();
      stateChangeSuccessEvent();
    });


    $http.get("app/version.json").then(function (data) {
      $rootScope.version = data.data.version;
    });

    // Old compatibility code, no longer needed.
    var xmlhttp;
    if (window.XMLHttpRequest) { // Mozilla, Safari, IE7+ ...
      xmlhttp = new XMLHttpRequest();
    } else if (window.ActiveXObject) { // IE 6 and older
      xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
    }

    var initMenu = false;
    $rootScope.$watch(function () { return $mdMedia('gt-md'); }, function (media) {
      // console.log('gt-md: ',media);
      if(initMenu){
        MenuManager.renderMenu(media, true);
      }
      initMenu = true;
    });

    function logoutUser(token) {

      // xmlhttp = new XMLHttpRequest();
      // xmlhttp.channel.loadFlags |= Components.interfaces.nsIRequest.LOAD_BYPASS_CACHE;
      xmlhttp.open(
        "PUT",
        ResourceBuilder.buildEndpoint("common/consultant/state/0", false),
        false
      ); //the false is for making the call synchronous
      xmlhttp.setRequestHeader("Content-type", "application/json");
      xmlhttp.setRequestHeader("Authorization", "Bearer " + token);
      xmlhttp.send(null);
      // SessionManager.setUserStatus(0);
    }

    angular.element(window).bind("beforeunload", function (event) {
      var token = SessionManager.getToken();
      if (token) {
        logoutUser(token);
        var s = "Zamykanie okna przeglądarki bez wylogowania jest niezalecane";
        return s;
      }
    });
  }
})();

(function ()
{
    'use strict';

    angular
        .module('taapp')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);

        // $urlRouterProvider.otherwise('/login');
        $urlRouterProvider.otherwise(function($injector, $location){
          console.log('urlRouterProvider | url invalid',$location.path());
          $location.path('/login');
      });
        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: 'app/navigation/layouts/vertical-navigation/vertical-navigation.html',
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl:'app/toolbar/layouts/vertical-navigation/toolbar.html',
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: 'app/navigation/layouts/vertical-navigation/navigation.html',
                        controller : 'NavigationController as vm'
                    }
                }
            });
    }

})();

(function () {
  'use strict';

  angular
    .module('taapp')
    .controller('IndexController', IndexController);

  /** @ngInject */
  function IndexController(fuseTheming,callInfoBarService, AplicationActiveService,AuthService, WebSocketManager,SessionManager) {
    var vm = this;
    // Data
    vm.themes = fuseTheming.themes;
    vm.callInfoBarService = callInfoBarService;
    vm.WebSocketManager = WebSocketManager;

    // vm.$onDestroy = function () {
    //   console.log()
    //   AuthService.logout();
    // };
    //////////
    vm.$onInit=onInit;
    function onInit(){
      document.addEventListener('visibilitychange', handleVisibilityChange, false);
    }

    function handleVisibilityChange() {
      AplicationActiveService.isHidden=document.hidden;
      console.log('Aplikacja jest ukyta: ' + document.hidden);
    }


  }
})();

(function () {
  'use strict';
      angular
        .module('consts',[]).constant('consts', {
        api: 'http://localhost:52653/api/',
        //api: 'https://ccapi-dev.teleaudio.pl/api/',
        //api: 'https://ccapi.teleaudio.pl/api/',
        consultantContent:'http://moderacja.teleaudio.pl/panel/callcenter/contents/consultants/',
        partnerContent:'http://moderacja.teleaudio.pl/panel/callcenter/contents/partners/',
        serviceContent:'http://moderacja.teleaudio.pl/panel/callcenter/contents/services/',
        callCenter:'http://moderacja.teleaudio.pl/panel/callcenter/',
        recordings:'https://socialsharing.teleaudio.pl/recordings/'
      });
      // angular
          //   .module('taapp').constant('consts', {
      //   api: 'https://ccapi.teleaudio.pl/api/'
      // });
})();

(function () {
    'use strict';

    angular
        .module('taapp')
        .config(config);

    /** @ngInject */
    function config($httpProvider, $localStorageProvider, $qProvider,consts, $compileProvider) {
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('loaderInterceptor');
        if(consts.api.indexOf('localhost:52653')!==-1){
          $httpProvider.interceptors.push('debugInterceptor');
        }
        // else{
        //   $compileProvider.debugInfoEnabled(false);
        // }
        $localStorageProvider.setKeyPrefix('contactCenter');
        // $translateProvider.useSanitizeValueStrategy('sanitize');
          $qProvider.errorOnUnhandledRejections(true);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('taapp')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        /**
         * Here you can find all the definitions that the Demo Project requires
         *
         * If you wish to use this method, you can create your API definitions
         * in a similar way.
         */

        /*
         api.dashboard = {
         project  : $resource(api.baseUrl + 'dashboard/project/data.json'),
         server   : $resource(api.baseUrl + 'dashboard/server/data.json'),
         analytics: $resource(api.baseUrl + 'dashboard/analytics/data.json')
         };

         api.cards = $resource(api.baseUrl + 'cards/cards.json');

         api.fileManager = {
         documents: $resource(api.baseUrl + 'file-manager/documents.json')
         };

         api.ganttChart = {
         tasks: $resource(api.baseUrl + 'gantt-chart/tasks.json'),
         timespans : $resource(api.baseUrl + 'gantt-chart/timespans.json')
         };

         api.icons = $resource('assets/icons/selection.json');

         api.invoice = $resource(api.baseUrl + 'invoice/invoice.json');

         api.mail = {
         inbox: $resource(api.baseUrl + 'mail/inbox.json')
         };

         api.profile = {
         timeline    : $resource(api.baseUrl + 'profile/timeline.json'),
         about       : $resource(api.baseUrl + 'profile/about.json'),
         photosVideos: $resource(api.baseUrl + 'profile/photos-videos.json')
         };

         api.quickPanel = {
         activities: $resource(api.baseUrl + 'quick-panel/activities.json'),
         contacts  : $resource(api.baseUrl + 'quick-panel/contacts.json'),
         events    : $resource(api.baseUrl + 'quick-panel/events.json'),
         notes     : $resource(api.baseUrl + 'quick-panel/notes.json')
         };

         api.search = {
         classic : $resource(api.baseUrl + 'search/classic.json'),
         mails   : $resource(api.baseUrl + 'search/mails.json'),
         users   : $resource(api.baseUrl + 'search/users.json'),
         contacts: $resource(api.baseUrl + 'search/contacts.json')
         };

         api.scrumboard = {
         boardList: $resource(api.baseUrl + 'scrumboard/boardList.json'),
         board    : $resource(api.baseUrl + 'scrumboard/boards/:id.json')
         };

         api.tables = {
         employees   : $resource(api.baseUrl + 'tables/employees.json'),
         employees100: $resource(api.baseUrl + 'tables/employees100.json')
         };

         api.timeline = {
         page1: $resource(api.baseUrl + 'timeline/page-1.json'),
         page2: $resource(api.baseUrl + 'timeline/page-2.json'),
         page3: $resource(api.baseUrl + 'timeline/page-3.json')
         };

         api.todo = {
         tasks: $resource(api.baseUrl + 'todo/tasks.json'),
         tags : $resource(api.baseUrl + 'todo/tags.json')
         };
         */

        return api;
    }

})();

/**
 * Created by kosski on 14.11.2016.
 */
+function () {
  angular.module('contactcenter.directives', [
    'nipVerify',
    'bankVerify',
    'bindHtmlCompile',
    'filterbox',
    'passVerify',
    'onerrorsrc',
    'renderLoader',
    'imageonload',
    'focusable',
    'chromeAutofillHack',
    'starRating',
    'contenteditable'
  ]);
} ();

/**
 * Created by kosski on 08.09.2016.
 */
+ function () {
  'use strict';
  angular.module('contactcenter.management', ['management.services',
    'management.callcenters',
    'contactcenter.trademill',
    'management.consultants',
    'management.users'
  ]).config(config);

  /** @ngInject */
  function config($translatePartialLoaderProvider, $stateProvider, MenuItemsProvider) {

    var menuItems = MenuItemsProvider.initMenuItem('MANAGEMENT')
      // .addMenuItem('MANAGEMENT.SERVICE', {
      //   icon: 'icon-cog-box',
      //   hide:'SessionManager.getUserRole() !== "admin"',
      //   collapse: true,
      //   component: 'option-folder'
      // }).addMenuItem('MANAGEMENT.SERVICE.LIST', {
      //   state: 'app.contactcenter_management.services.list',
      //   iconSrc: 'assets/icons/triple-view/glosowe.png'
      // }).addMenuItem('MANAGEMENT.SERVICE.PACKETS', {
      //   state: 'app.contactcenter_management.packets.list',
      //   iconSrc: 'assets/icons/triple-view/glosowe.png',
      //   disabled: true
      // })
    // .addMenuItem('MANAGEMENT.SERVICE.IVR',{
    //   state: 'app.contactcenter_management.services.list.call',
    //   iconSrc: 'assets/icons/triple-view/glosowe.png'
    //   // icon: 'icon-account'
    // }).addMenuItem('MANAGEMENT.SERVICE.SMS',{
    //   state: 'app.contactcenter_management.services.list.sms',
    //   iconSrc: 'assets/icons/triple-view/sms.png'
    //   // icon: 'icon-account'
    // }).addMenuItem('MANAGEMENT.SERVICE.CHAT',{
    //   state: 'app.contactcenter_management.services.list.chat',
    //   iconSrc: 'assets/icons/triple-view/chat.png'
    // }).addMenuItem('MANAGEMENT.SERVICE.EMAIL',{
    //   state: 'app.contactcenter_management.services.list.email',
    //   iconSrc: 'assets/icons/triple-view/email.png'
    // })
    .addMenuItem('MANAGEMENT.CALLCENTERS', {
      icon: 'icon-people',
      component: 'callcenter-menu',
      previewVisible: true,
      showAdd: true,
      filter: {
        'type': 'CC'
      }
    }).addMenuItem('MANAGEMENT.EXTERNAL_CALLCENTERS', {
      icon: 'icon-people',
      component: 'callcenter-menu',
      hide:'SessionManager.getUserRole() !== "admin"',
      hideEmpty: true,
      filter: {
        'type': 'EXT'
      }
    });
    // .addMenuItem('MANAGEMENT.IMPORTED_CALLCENTERS',{
    //   // state: 'app.contactcenter_management.callcenters.list',
    //   icon: 'icon-people',
    //   component:'callcenter-menu'
    // })
    $stateProvider.state('app.contactcenter_management', {
      parent: 'app',
      url: '/managment',
      params: {
        menu: menuItems,
        defaultAvatar: 'assets/images/icons/serwisy.png'
      }
      // views: {
      //   'content@app': {
      //     template: '<triple-view  do-not-show-sidepanel="$root.state.current.params.doNotShowSidepanel"></triple-view>'
      //   }
      // }
    });
    //state(menuItems.getMenuItem('MANAGEMENT.SERVICE.IVR').state, {
    //   url: '/call',
    //   params: {
    //     defaultAvatar: 'assets/icons/management/icon-i.png',
    //     type: 'I',
    //     editAvatar: 'show'
    //   },
    //   statePanelRight: true,
    //   // stateIconActionAdd: 'assets/images/icons/services-add.png',
    //   stateTranslationName: 'MANAGEMENT.SERVICE.IVR',
    //   views: {
    //     'mainContent': {
    //       template: '<services-list></services-list>'
    //     },
    //   }
    // }).state(menuItems.getMenuItem('MANAGEMENT.SERVICE.SMS').state, {
    //   url: '/sms',
    //   params: {
    //     menu: menuItems,
    //     defaultAvatar: 'assets/icons/management/icon-s.png',
    //     type: 'S',
    //     editAvatar: 'show'
    //   },
    //   statePanelRight: true,
    //   // stateIconActionAdd: 'assets/icons/services-add.png',
    //   stateTranslationName: 'MANAGEMENT.SERVICE.SMS',
    //   views: {
    //     'mainContent': {
    //       template: '<services-list></services-list>'
    //     },
    //   }
    // }).state(menuItems.getMenuItem('MANAGEMENT.SERVICE.CHAT').state, {
    //   url: '/chat',
    //   params: {
    //     menu: menuItems,
    //     defaultAvatar: 'assets/icons/management/icon-c.png',
    //     type: 'C',
    //     editAvatar: 'show'
    //   },
    //   statePanelRight: true,
    //   // stateIconActionAdd: 'assets/icons/services-add.png',
    //   stateTranslationName: 'MANAGEMENT.SERVICE.CHAT',
    //   views: {
    //     'mainContent': {
    //       template: '<services-list></services-list>'
    //     },
    //   }
    // }).state(menuItems.getMenuItem('MANAGEMENT.SERVICE.EMAIL').state, {
    //   url: '/email',
    //   params: {
    //     menu: menuItems,
    //     defaultAvatar: 'assets/icons/management/icon-e.png',
    //     type: 'E',
    //     editAvatar: 'show'
    //   },
    //   statePanelRight: true,
    //   // stateIconActionAdd: 'assets/icons/services-add.png',
    //   stateTranslationName: 'MANAGEMENT.SERVICE.EMAIL',
    //   views: {
    //     'mainContent': {
    //       template: '<services-list></services-list>'
    //     },
    //   }
    // });
  }
}();

/**
 * Created by akraszewski on 2017-04-18.
 */


+function () {
  'use strict';
  angular
    .module('contactcenter.components', [
      'avatarLetter',
      'callInfoBar',
      'issueTracker',
      'dialogModule',
      'mdDateTimePicker',
      'sidenavContent',
      'ta-header',
      'taConsultantslist',
      'taFile',
      'taMultiselect',
      'taPartnerslist',
      'tagsPicker',
      'tripleView',
      'avatarCropper',
      'mimes',
      'serviceConsultant',
      'optionsMenu',
      'messageStatus',
      'accordionForm',
      'viewActions',
      'taSearch',
      'taTags',
      'taFilters',
      'activityAxis'
    ])
    .config(config);

  /** @ngInject */
  function config() {
  }
}();

/**
 * Created by kosski on 07.09.2016.
 */
+function () {
  'use strict';
  angular
    .module('contactcenter', [
      'contactcenter.communicator',
      'contactcenter.management',
      'contactcenter.dashboard',
      'contactcenter.directives',
      'contactcenter.components',
      'contactcenter.profilemanagement',
      'MMSmgt',
      'contactcenter.orderbox',
      'contactcenter.party',
      'contactcenter.reports',
      'contactcenter.callsonline',
      'Resources'
    ])
    .config(config);

  /** @ngInject */
  function config() {
  }
}();

/**
 * Created by kosski on 07.09.2016.
 */
+function(){
  'use strict';
  angular
    .module('auth', [
      'auth.login'
    ])
    .config(config);

  /** @ngInject */
  function config($translatePartialLoaderProvider,msNavigationServiceProvider)
  {

  }
}();

angular.module("taapp").run(["$templateCache", function($templateCache) {$templateCache.put("app/toolbar/confirmBreakSessionBehavior.html","<md-dialog aria-label=\"%translate\" class=\"remove\"><md-toolbar class=\"remove__msg\"><div class=\"md-toolbar-tools\">\n<md-icon md-font-icon=\"icon-alert-circle\"></md-icon><h2 class=\"w-500\">{{titleText | translate}}</h2></div></md-toolbar>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\" class=\"remove__buttons\"><md-button \nng-click=\"cancel(1)\" class=\"remove__buttons__no\">{{params.option1 | translate}}</md-button><md-button \nng-click=\"answer(2)\" class=\"remove__buttons__yes\">{{params.option2 | translate}}</md-button><md-button \nng-click=\"answer(3)\" class=\"remove__buttons__yes\">{{params.option3 | translate}}</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar\" ui-view=\"toolbar\"></md-toolbar><div id=\"horizontal-navigation\" class=\"md-whiteframe-1dp\" \nui-view=\"navigation\"></div><div id=\"content-container\" flex layout=\"column\"><md-content id=\"content\" \nclass=\"animate-slide-left md-background md-hue-1\" ms-scroll ui-view=\"content\" flex></md-content></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" \nms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" \nms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav \nid=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll \nui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-panel\" layout=\"row\" layout-align=\"start start\"><div \nclass=\"ms-theme-options-panel-button md-primary-bg\" ng-click=\"toggleOptionsPanel()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><div class=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option\"><div \nclass=\"option-title\">Layout Style:</div><md-radio-group layout=\"column\" ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button value=\"verticalNavigation\">Vertical Navigation</md-radio-button>\n<md-radio-button value=\"verticalNavigationFullwidthToolbar\">Vertical Navigation with Fullwidth Toolbar\n</md-radio-button><md-radio-button value=\"verticalNavigationFullwidthToolbar2\">\nVertical Navigation with Fullwidth Toolbar 2</md-radio-button><md-radio-button value=\"horizontalNavigation\">\nHorizontal Navigation</md-radio-button><md-radio-button value=\"contentOnly\">Content Only</md-radio-button>\n<md-radio-button value=\"contentWithToolbar\">Content with Toolbar</md-radio-button></md-radio-group></div><md-divider>\n</md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group layout=\"row\" \nlayout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button value=\"boxed\">\nBoxed</md-radio-button><md-radio-button value=\"wide\">Wide</md-radio-button></md-radio-group></div><md-divider>\n</md-divider><div class=\"theme-option\"><div class=\"option-title\">Color Palette:</div><md-menu-item \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"theme\"><md-button class=\"md-raised theme-button\" \naria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"themeName\"><span><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" md-font-icon=\"icon-palette\">\n</md-icon><span>{{themeName}}</span></span></md-button></md-menu-item></div></div></div>");
$templateCache.put("app/navigation/navcontainer/navcontainer.html","<div ng-if=\"!vm.MenuManager.currentMenu.navTemplate\" layout=\"row\" layout-align=\"start center\" \nclass=\"h-40 p-10 menu-name\" translate=\"{{vm.MenuManager.currentMenu.title+\'.ROUTE_NAME\'}}\"></div><div \nng-if=\"vm.MenuManager.currentMenu.navTemplate\" layout=\"row\" layout-align=\"start center\" class=\"menu-name\" \nng-class=\"vm.MenuManager.currentMenu.navClass\" bind-html-compile=\"vm.MenuManager.currentMenu.navTemplate\"></div><div \nflex class=\"nav-container\" ng-class=\"vm.MenuManager.currentMenu.navClass\"><div layout=\"column\" \nlayout-align=\"start stretch\" class=\"template-content scrollable {{::vm.addonClass}}\" ng-if=\"menuItem.template\" \nng-hide=\"vm.MenuManager.currentMenu.title != menuItem.title\" ng-repeat=\"menuItem in vm.MenuManager.menuItems\" \nbind-html-compile=\"::menuItem.template\" ms-scroll></div></div>");
$templateCache.put("app/toolbar/statuschange/status-change.html","<dialog-component id=\"status-dialog\" dialog-title=\"\'TOOLBAR.STATUS_DIALOG.TITLE\'\"><content layout=\"column\" \nlayout-align=\"start stretch\" class=\"content\"><div class=\"container\" style=\"padding: 10px\"><div layout=\"row\" \nstyle=\"max-height: 50vh; height: 100%\"><div flex=\"50\" \nstyle=\"margin-right: 5px; padding: 5px;background-color: #F6F6F6;border-radius: 5px\"><div class=\"nav-title\" \nstyle=\"font-size:14px;align-self: center; margin-bottom: 10px; padding-bottom: 5px; border-bottom: 1px solid #666666;width:100%\">\nKanał głosowy</div><md-radio-group ng-model=\"vm.statusSelected\"><md-radio-button \nng-if=\"vm.userStatusOptions && vm.userStatusOptions[1].subStatuses\" value=\"{{status}}\" \nng-repeat=\"status in vm.userStatusOptions[1].subStatuses\">{{status.name}}</md-radio-button><md-radio-button \nng-if=\"vm.userStatusOptions && !vm.userStatusOptions[1].subStatuses && vm.userStatusOptions[1] && vm.userStatusOptions[1].status\" \nvalue=\"{{vm.userStatusOptions[1].status}}\">\n{{vm.userStatusOptions[1].status.name?vm.userStatusOptions[1].status.name:vm.userStatusOptions[1].status.status}}\n</md-radio-button></md-radio-group></div><div flex=\"50\" layout=\"column\" \nstyle=\"margin-left: 5px; padding: 5px;background-color: #F6F6F6;border-radius: 5px\"><div layout=\"row\" \nstyle=\"font-size:14px;align-self: center; margin-bottom: 10px; padding-bottom: 5px; border-bottom: 1px solid #666666;width:100%\">\n<div style=\"font-weight: 600\">Wszystkie serwisy</div><md-switch ng-model=\"vm.srvSwitch\" style=\"margin:-6px 10px\">\n</md-switch><div style=\"font-weight: 600\" ng-style=\"vm.srvSwitch&&{\'color\':\'#FE6869\'}\">Tylko wybrane</div></div><div \nng-if=\"vm.srvSwitch\" style=\"margin-bottom: 5px\" class=\"services-list\" flex ms-scroll layout=\"column\" \nng-style=\"(vm.selectedNoneWarn===true)&&{\'border\':\'2px solid #CD5C5C\',\'border-radius\':\'5px\'}||{\'border\':\'2px solid #F6F6F6\'}\">\n<div flex=\"100\" layout=\"row\" ng-repeat=\"service in vm.servicesList\" \nstyle=\"min-height: 36px;align-items: center;font-size: 16px\"><div flex=\"10\"><img src=\"{{service.photoUrl}}\" alt=\"\" \nstyle=\"max-width: 32px\"></div><div flex=\"50\">{{service.serviceName}}</div><div layout=\"row\"><md-icon \nng-click=\"$event.stopPropagation();service.selectedLevel=1\" md-font-icon=\"icon-numeric-1-box-multiple-outline\" \nclass=\"level-marker\" style=\"color: #3F3F3F\" \nng-style=\"service.selectedLevel===1&&{\'font-weight\':\'600\',\'color\':\'#2ab982\'}\"></md-icon><md-icon \nng-click=\"$event.stopPropagation();service.selectedLevel=2\" md-font-icon=\"icon-numeric-2-box-multiple-outline\" \nclass=\"level-marker\" style=\"color: #5F5F5F\" \nng-style=\"service.selectedLevel===2&&{\'font-weight\':\'600\',\'color\':\'#2ab982\'}\"></md-icon><md-icon \nng-if=\"service.selectedLevel\" ng-click=\"$event.stopPropagation();service.selectedLevel=null\" \nmd-font-icon=\"icon-close-circle-outline\" class=\"level-marker\" style=\"color: #CD5C5C\"></md-icon></div></div></div><div \nng-if=\"!vm.srvSwitch\" flex layout=\"row\" style=\"text-align: center;line-height: 24px\"><div \nstyle=\"min-width: 42px;padding-top: 10px\"><md-icon md-font-icon=\"icon-comment-alert-outline\" \nstyle=\"color: #CD5C5C;font-size: 42px\"></md-icon></div><div>Wybrano obsługę na wszystkich serwisach tekstowych...</div>\n</div></div></div></div><md-dialog-actions layout=\"row\"><div ng-if=\"vm.srvSwitch&&vm.selectedNoneWarn\" \nstyle=\"color: #CD5C5C\">Wybierz minimum jeden projekt wskazując priorytet 1 lub 2...</div><div flex layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"save-button\" ng-click=\"vm.saveForm()\" aria-label=\"Save\"><md-icon \nmd-font-icon=\"icon-check-circle\" style=\"color: #2ab982\"></md-icon><span translate=\"TOOLBAR.STATUS_DIALOG.ACTIVATE\" \ntranslate-attr-aria-label=\"TOOLBAR.STATUS_DIALOG.ACTIVATE\">Aktywny</span></md-button></div></md-dialog-actions>\n</content></dialog-component>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"48\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div>\n<div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">{{result.description}}\n</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"start center\" flex><div class=\"shortcuts\" layout=\"row\" \nlayout-align=\"start center\" ms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" \nng-sortable=\"MsShortcuts.sortableOptions\"><div ng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" \nui-sref=\"{{shortcut.uisref}}\"><md-icon ng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\">\n</md-icon><div ng-if=\"!shortcut.icon\" class=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip \nmd-direction=\"bottom\">{{shortcut.title}}</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s20\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"40\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" class=\"{{result.icon}}\">\n</i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">{{result.title}}</div>\n</div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" ng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon>\n</div></div></div></div></md-menu-content></md-menu></div>");
$templateCache.put("app/main/auth/login/login.html","<div id=\"login\" layout=\"row\" layout-align=\"end\"><div id=\"login-intro\" flex hide show-gt-sm layout=\"row\" \nlayout-align=\"start end\"><div layout=\"row\" layout-align=\"start center\"><img class=\"logo-img\" \nsrc=\"../../../../assets/images/backgrounds/loginlogo.png\" alt=\"ta\"></div></div><div id=\"login-form-wrapper\" \nclass=\"flex-scrollable\" ms-scroll><div id=\"login-form\" style=\"height: 100%\"><div class=\"logo\" hide-gt-sm><img \nsrc=\"assets/images/logos/logo.gif\" alt=\"TA\"></div><div class=\"description\" translate=\"LOGIN.DESCRIPTION\">\nSed mollis velit facilisis facilisis viverra</div><div layout=\"column\" layout-align=\"space-between center\" \nstyle=\"height: 90%\"><form name=\"loginForm\" novalidate ng-submit=\"vm.logIn(loginForm.$valid)\" autocomplete=\"off\"><h1 \nstyle=\"color: gray; font-weight: 500; margin-bottom: 40px\">{{\"LOGIN.TITLE\" | translate}}</h1><md-input-container \nclass=\"md-block\" ng-if=\"!vm.activated\"><label for=\"password\">{{\"LOGIN.LOGIN\" | translate}}</label><input type=\"text\" \nname=\"login\" ng-model=\"vm.form.login\" required style=\"border-bottom: 1px solid black\" autocomplete=\"off\"><div \nng-messages=\"loginForm.login.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float ng-if=\"!vm.activated\"><label for=\"password\">\n{{\"LOGIN.PASSWORD\" | translate}}</label><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" required \nstyle=\"border-bottom: 1px solid black\" autocomplete=\"off\"><div ng-messages=\"loginForm.password.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div>\n</div></md-input-container><div ng-if=\"vm.activated\" layout=\"column\" layout-align=\"center center\"><md-progress-circular\n ng-disabled=\"!vm.activated\" md-diameter=\"96\"></md-progress-circular></div><div layout=\"row\" layout-align=\"end center\">\n<md-button type=\"submit\" class=\"md-raised md-primary login-button\" aria-label=\"LOG IN\" \nng-disabled=\"vm.activated || loginForm.$invalid || loginForm.$pristine\" translate=\"LOGIN.LOG_IN\" \ntranslate-attr-aria-label=\"LOGIN.LOG_IN\">LOG IN</md-button></div></form><form ng-submit=\"vm.changeLocalNumber()\" \nlayout=\"row\"><md-input-container class=\"md-block\" md-no-float ng-if=\"vm.isInternalHost\" flex=\"80\"><label for=\"telefon\">\nStanowisko</label><input type=\"text\" name=\"telefon\" ng-model=\"vm.internalcc.phone\" placeholder=\"Nr telefonu\" required \nng-disabled=\"vm.internalcc.phoneDisable\"></md-input-container><md-input-container flex=\"10\" class=\"md-block\" \nmd-no-float ng-if=\"vm.isInternalHost\"><md-button type=\"submit\" class=\"md-primary submit-button\" \naria-label=\"button-label\" style=\"margin: 0; height: 41px; cursor: pointer\" ng-disabled=\"vm.internalcc.phoneDisable\" \nng-if=\"!vm.internalcc.phoneDisable\"><md-icon md-font-icon=\"icon-check\"></md-icon></md-button></md-input-container>\n</form><span class=\"version\" flex=\"20\">v. {{ $root.version }} </span><span class=\"unable\" ng-click=\"vm.tryUnable()\">\n</span></div></div></div></div>");
$templateCache.put("app/main/contactcenter/communicator/communicator.html","<div id=\"communicator\" class=\"page-layout carded layout-row\" ng-class=\"{\'activeSession\': vm.templateData.sessionId}\">\n<div class=\"template-placeholder\" bind-html-compile=\"vm.templateMarkup\"></div></div>");
$templateCache.put("app/main/contactcenter/orderbox/orderbox.html","<div id=\"mail\" class=\"page-layout carded left-sidenav\" layout=\"column\"><div layout=\"column\" flex><mail-details \nflex=\"100\" class=\"content thread-detail\" current-thread=\"vm.OrderboxGlue.currentThread\" ms-scroll flex></mail-details>\n</div></div>");
$templateCache.put("app/main/contactcenter/party/party.html","<div id=\"party\" class=\"page-layout carded left-sidenav\" layout=\"row\" layout-align=\"center stretch\"><div class=\"top-bg\">\n<div class=\"header\" layout=\"row\" layout-align=\"left left\"><span class=\"icon\"><img alt=\"Communicator\" \nsrc=\"assets/icons/communicator.png\"> </span><span class=\"text\" translate=\"PARTY.ROOMS_NAME\">Pokoje</span></div></div>\n<div class=\"template-placeholder\" layout=\"column\"><party-rooms-list flex=\"100\" \nstyle=\"box-shadow: 0px 4px 5px -2px rgba(0, 0, 0, 0.2), 0px 7px 10px 1px rgba(0, 0, 0, 0.14), 0px 2px 16px 1px rgba(0, 0, 0, 0.12)\">\n</party-rooms-list></div></div>");
$templateCache.put("app/main/contactcenter/templates/paymentcall.html","<dialog-component id=\"payment-call\" show-footer=\"true\" cancelfunc=\"vm.closePayment\" \nsavefunc=\"vm.currentCallCenter.id ? vm.changeActiveType :vm.saveNewCallcenter\" \ndialog-title=\"\'CALLINFOBAR.PAYMENT.TITLE\'\"><content flex layout=\"column\" layout-align=\"start stretch\" class=\"content\" \nstyle=\"max-height: 50vh; height: 100%\"><div flex=\"85\" layout=\"row\"><div flex=\"15\" class=\"payment-bar\" layout=\"column\">\n<span translate=\"CALLINFOBAR.PAYMENT.TITLE\" class=\"title\">Płatność</span><label class=\"titlemin\" \ntranslate=\"CALLINFOBAR.PAYMENT.SERVICE\">Serwis</label><span class=\"name\">{{vm.currCall.serviceData.serviceName}}</span>\n<label class=\"titlemin\" translate=\"CALLINFOBAR.PAYMENT.PHONE\">Telefon</label><span class=\"name\">\n{{vm.currCall.clientBase.msisdn}}</span><label class=\"titlemin\" translate=\"CALLINFOBAR.PAYMENT.ACCOUNT\">Stan konta\n</label><span class=\"name big\">{{vm.currCall.subAccount/100.00}} PLN</span><label class=\"titlemin\" \ntranslate=\"CALLINFOBAR.PAYMENT.PRICE\">Kwota za 1min połączenia</label><span class=\"name\">\n{{vm.serviceInfo.price/100.00}} PLN</span><label class=\"titlemin\" translate=\"CALLINFOBAR.PAYMENT.MINIMUM\">\nMinimalna kwota</label><span class=\"name\">{{vm.serviceInfo.minimum/100.00}} PLN</span></div><div flex=\"85\" \nlayout=\"column\"><div class=\"info-bar\"><div><img class=\"icon-help\" src=\"/assets/icons/help_big.svg\"><label class=\"text\">\nSerwis płatny. Opłata za 1 min połączenia wynosi {{vm.serviceInfo.price/100.00}} PLN</label></div></div><accordion-form\n flex=\"90\" main-form=\"vm.formValid\" on-complete=\"vm.saveNewCallcenter\" clikcable-header=\"vm.currentCallCenter.id\" \ncount-init-progress=\"vm.currentCallCenter.id\" on-pane-change=\"vm.paymentPaneChange\"><form-pane \npane-icon=\"/assets/icons/wifi.svg\"><p-header><p><span flex translate=\"CALLINFOBAR.PAYMENT.NUMBER_PHONE\">Numer telefonu\n</span></p></p-header><p-content layout=\"column\" layout-align=\"start stretch\"><md-input-container \nclass=\"md-icon-float md-block name-field\"><label translate=\"CALLINFOBAR.PAYMENT.PHONE\">Telefon</label><input \nng-model=\"vm.paymentData.phone\" name=\"name\" type=\"text\" required pattern=\"[0-9]{9}\"></md-input-container>\n<md-input-container><md-radio-group ng-model=\"vm.paymentData.amount\" \nng-change=\"vm.paymentData.amount=vm.paymentData.amount*1\" layout=\"row\" layout-align=\"start center\"><md-radio-button \nng-repeat=\"payment in vm.paymentList\" value=\"{{payment.amount}}\" class=\"center-type-btn\" \nstyle=\"border-color: {{payment.color}}; color: {{payment.color}}\"><div layout=\"column\" layout-align=\"start stretch\">\n<span>{{payment.amount}} PLN</span></div></md-radio-button></md-radio-group></md-input-container><md-input-container \nclass=\"md-icon-float md-block name-field\"><label translate=\"CALLINFOBAR.PAYMENT.AMOUNT\">Kwota</label><input \nng-model=\"vm.paymentData.amount\" name=\"name\" type=\"number\" required min=\"0\" max=\"200\"></md-input-container></p-content>\n</form-pane><form-pane pane-icon=\"/assets/icons/card.svg\"><p-header><p translate=\"CALLINFOBAR.PAYMENT.TITLE\">Płatność\n</p></p-header><p-content><md-input-container class=\"md-icon-float md-block name-field\"><label \ntranslate=\"CALLINFOBAR.PAYMENT.CODE\">Kod jednorazowy</label><input ng-model=\"vm.paymentData.code\" name=\"name\" \ntype=\"text\" required></md-input-container></p-content></form-pane><form-pane pane-icon=\"/assets/icons/invoice.svg\">\n<p-header><p translate=\"CALLINFOBAR.PAYMENT.CONFIRMED\">Potwierdzenie</p></p-header><p-content><div \nng-if=\"vm.paymentData.waitForPayment\" class=\"waiting\"><md-progress-circular class=\"md-accent\" md-diameter=\"40\" \nmd-mode=\"indeterminate\"></md-progress-circular>Prosze czekać na potwierdzenie.</div><div \nng-if=\"!vm.paymentData.waitForPayment\"><span ng-if=\"vm.paymentData.paySuccess\">Płatność <span class=\"success\">UDANA\n</span>, zamknij okno.</span> <span ng-if=\"!vm.paymentData.paySuccess\">Płatność <span class=\"fail\">NIEUDANA</span>\n, rozłącz połączenie albo cofnij się do kroku 1</span></div></p-content></form-pane></accordion-form></div></div>\n</content><footer layout=\"row\"><div class=\"operator-buttons pt-8 pb-8\"><md-radio-group layout=\"row\" \nlayout-align=\"start center\"><md-radio-button ng-if=\"vm.paymentData.paySuccess\" \nclass=\"center-type-btn action-button forward-button\" ng-click=\"vm.startPaymentCall(20, true, $event)\"><div \nlayout=\"row\" layout-align=\"start stretch\"><md-icon class=\"mr-8\" flex md-svg-src=\"/assets/icons/fast-forward.svg\" \naria-label=\"group\"></md-icon><span>Przekieruj</span></div></md-radio-button><md-radio-button \nng-if=\"vm.paymentData.paySuccess\" class=\"center-type-btn action-button wallet-button\" \nng-click=\"vm.startPaymentCall(0, false, $event)\"><div layout=\"row\" layout-align=\"start stretch\"><md-icon class=\"mr-8\" \nflex md-svg-src=\"/assets/icons/wallet.svg\" aria-label=\"group\"></md-icon><span>Realizuj</span></div></md-radio-button>\n<md-radio-button ng-if=\"!vm.paymentData.paySuccess\" class=\"center-type-btn action-button phone-button\" \nng-click=\"vm.disconnectPaymentCall()\"><div layout=\"row\" layout-align=\"start stretch\"><md-icon class=\"mr-8\" flex \nmd-svg-src=\"/assets/icons/phone.svg\" aria-label=\"group\"></md-icon><span>Rozłącz</span></div></md-radio-button>\n</md-radio-group></div></footer></dialog-component>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<div layout=\"column\" layout-align=\"start stretch\" class=\"navigation-content right-shadow\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp md-primary-bg\" ui-view=\"toolbar\"></md-toolbar><div class=\"ms-navigation\"><ul>\n<li ng-repeat=\"node in ::vm.MenuManager.menuItems track by $index\" class=\"ms-navigation-node hide-title\"><div \nclass=\"ms-navigation-item\"><a class=\"ms-navigation-button\" \nng-class=\"{\'active md-accent-bg\': node==vm.MenuManager.currentMenu}\" \nng-click=\"vm.MenuManager.loadNavigationContent(node); vm.broadcastNavChange(node.title);\"><md-icon flex \nmd-svg-src=\"{{node.icon}}\" ng-if=\"::node.icon\" class=\"icon s16 cc-menu-icon\"></md-icon><div \nclass=\"icon s10 cc-menu-icon alert-icon\" ng-if=\"node.showAlert\"><img ng-src=\"{{::node.showAlert}}\"></div></a></div>\n<md-tooltip md-direction=\"top\">{{node.tooltip}}</md-tooltip></li></ul></div><div id=\"nav-menu\" flex><nav-container \nclass=\"nav-container\" addon-class=\"\'my-switch-animation\'\"></nav-container></div><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-image\"><img src=\"../../../../assets/images/logos/logo.png\" alt=\"\"> <span \nclass=\"logo-name\">Contact Center</span><div class=\"version\">v. {{ $root.version }}</div></span></div></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" \nng-class=\"{\'mainOpened\':!vm.MenuManager.hideSidenav, \'mainClosed\':vm.MenuManager.hideSidenav, \'openedMini\': !vm.MenuManager.hideMiniMenu, \'closedMini\': vm.MenuManager.hideMiniMenu}\" \nflex><div class=\"vertical-navigation-container\" layout=\"row\" \nng-class=\"{\'opened\':!vm.MenuManager.hideSidenav, \'closed\':vm.MenuManager.hideSidenav}\"><div id=\"vertical-navigation\" \nflex layout=\"column\"><md-sidenav md-is-locked-open=\"true\" md-component-id=\"navigation\" ui-view=\"navigation\">\n</md-sidenav></div><div class=\"ethereal-div\" ng-if=\"!vm.MenuManager.hideSidenav && !vm.MenuManager.panelClicked\"><img \nclass=\"arrow-icon\" src=\"assets/icons/mainmanu/left_white.png\" ng-click=\"vm.toogleSidenav()\"></div><div \nclass=\"ethereal-div\" ng-if=\"vm.MenuManager.hideSidenav && !vm.MenuManager.panelClicked\"><img class=\"arrow-icon\" \nsrc=\"assets/icons/mainmanu/right_black.png\" ng-click=\"vm.toogleSidenav()\"></div></div><div id=\"nav-absolute\" \nng-class=\"{\'opened\':!vm.MenuManager.hideSidenav, \'closed\':vm.MenuManager.hideSidenav, \'openedMini\': !vm.MenuManager.hideMiniMenu, \'closedMini\': vm.MenuManager.hideMiniMenu}\">\n</div><div class=\"minimenu-line\" ng-if=\"vm.MenuManager.hideMiniMenu && !vm.MenuManager.miniMenuClicked\" \nng-class=\"{\'opened\':!vm.MenuManager.hideSidenav, \'closed\':vm.MenuManager.hideSidenav, \'openedMini\': !vm.MenuManager.hideMiniMenu, \'closedMini\': vm.MenuManager.hideMiniMenu}\">\n</div><div id=\"content-container\" flex layout=\"column\" layout-align=\"start stretch\"><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar\" ui-view=\"toolbar\"></md-toolbar><div id=\"horizontal-navigation\" layout=\"row\" \nlayout-align=\"start end\" flex hide-gt-sm><div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal>\n</ms-navigation-horizontal></div></div><ta-header></ta-header><div id=\"content-container\" flex layout=\"column\"><div \nclass=\"page-layout simple right-sidenav inner-sidenav\" ng-class=\"{\'triple-view\':vm.state.current.stateTriple===true}\" \nlayout=\"row\"><md-content id=\"content\" class=\"md-background md-hue-1\" \nng-class=\"{\'animate-slide-left\':vm.animateActivate===true}\" ms-scroll ui-view=\"content\" flex></md-content></div></div>\n</div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div ng-cloak layout=\"row\" layout-align=\"space-between center\" class=\"ta-menu-fix\"><div flex layout=\"row\" \nlayout-align=\"start center\"><div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleHorizontalMobileMenu()\" aria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\">\n</md-icon></md-button></div><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\" \nstyle=\"background: white !important\"><img src=\"../../../../assets/images/logos/logo_small.png\" alt=\"\"> <span>\nContact Center</span><div class=\"version\">v. {{ $root.version }}</div></span></div></div><md-progress-circular \nid=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"50\">\n</md-progress-circular><div layout=\"row\" layout-align=\"start center\"><div id=\"message-menu\" class=\"message-to-reply\" \nng-if=\"vm.messageToReply>0 && vm.isConsultant\" ui-sref=\"app.contactcenter_communicator\"><md-button><div layout=\"row\">\n<md-icon md-font-icon=\"icon-message\"></md-icon><div class=\"number\">({{vm.messageToReply}})</div></div></md-button>\n</div><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\" ng-if=\"vm.userSession\"><img \nng-if=\"vm.userSession.userImg\" md-menu-align-target class=\"avatar\" ng-src=\"{{vm.userSession.userImg}}\"> <img \nng-if=\"!vm.userSession.userImg\" md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm hide-xs>{{vm.userSession.username }}</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm hide-xs></md-icon></div></md-button><md-menu-content \nwidth=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.contactcenter_settings.general\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button translate=\"MENU.SETTINGS\">Ustawienia</md-button>\n</md-menu-item><md-menu-item class=\"md-indent\" ng-if=\"vm.SessionManager.isConsultant()\"><md-icon md-font-icon \nng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.status}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-disabled=\"status === vm.userStatus\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions |orderBy:\'typeId\'\"><md-icon md-font-icon=\"{{status.icon}}\" \nng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">\n{{status.status}} {{status.name? \' na \'+status.name:\'\'}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout(vm.userStatus.activeOnLogout)\">Wyloguj</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n</div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div ng-cloak layout=\"row\" layout-align=\"space-between center\" class=\"ta-menu-fix\"><div layout=\"row\" \nlayout-align=\"start center\" flex><md-menu-bar id=\"user-menu\"><md-menu flex=\"100\" class=\"user-status-menu\" \nid=\"user-status-menu\" md-position-mode=\"target-left bottom\" md-offset=\"-100 0\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" class=\"button-layout\" layout-align=\"space-between center\"><div flex=\"20\"><div class=\"avatar-wrapper\" \nng-if=\"vm.userSession\"><img ng-if=\"vm.userSession.userImg\" md-menu-align-target class=\"avatar\" \nng-class=\"{\'status-mask\': vm.userStatus}\" ng-src=\"{{vm.userSession.userImg}}\"><div ng-if=\"!vm.userSession.userImg\" \nclass=\"avatar default-avatar\" ng-class=\"{\'status-mask\': vm.userStatus }\"><md-icon flex \nmd-svg-src=\"/assets/navigation/avatar.svg\" aria-label=\"avatar\"></md-icon></div><md-icon ng-if=\"vm.userStatus\" \nmd-font-icon=\"icon-checkbox-blank-circle\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon>\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"60\"></md-progress-circular></div></div><span flex=\"70\" class=\"username\" hide-sm hide-xs>\n{{vm.userSession.username }}</span><md-icon flex=\"10\" md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm \nhide-xs></md-icon></div></md-button><md-menu-content class=\"black-menu\"><md-menu-item ng-if=\"vm.userStatusOptions\" \nclass=\"status md-indent\" ng-disabled=\"status === vm.userStatus\" ng-repeat=\"status in vm.userStatusOptions\"><md-button \nclass=\"md-indent\" ng-click=\"vm.setUserStatus(event,status.status)\" layout=\"row\"><md-icon \nng-if=\"status.status.icon[0] != \'/\'\" md-font-icon=\"{{status.status.icon}}\" \nng-style=\"{\'color\':  status.status.id==vm.userStatus.id ? status.status.color : \'\' }\" class=\"icon\"></md-icon><md-icon \nng-if=\"status.status.icon[0] == \'/\'\" md-svg-src=\"{{status.status.icon}}\" \nng-style=\"{\'color\':  status.status.id==vm.userStatus.id ? status.status.color : \'\' }\" class=\"icon\"></md-icon><p flex>\n{{::status.status.status}} {{status.status.name }}</p></md-button></md-menu-item><md-menu-item \nclass=\"status md-indent\"><md-button ng-click=\"vm.logout(vm.userStatus.activeOnLogout)\"><md-icon flex=\"20\" \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon>Wyloguj</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\r\n             ng-class=\"{\'active md-accent-bg\': vm.isActive}\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-class=\"{\'active md-accent-bg\': vm.isActive}\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\r\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\r\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/main/contactcenter/callsonline/components/callsonline.html","<div class=\"monitoring\"><div class=\"monitoring__thead\" flex=\"100\" layout=\"row\" layout-align=\"space-between stretch\"><p \nflex=\"10\" flex-gt-lg=\"10\" translate=\"REPORTSONLINE.CALLSONLINESTATS.FORWARDING\">Przekierowanie</p><p flex=\"30\">Call Id\n</p><p flex=\"15\" flex-gt-lg=\"25\" translate=\"REPORTSONLINE.CALLSONLINESTATS.ID\">Serwis / Konsultant ID</p><p flex=\"10\" \ntranslate=\"REPORTSONLINE.CALLSONLINESTATS.TIME\">Start / czas</p><p flex=\"10\">Status / opcje</p></div><md-list \nclass=\"monitoring__tbody\"><md-list-item class=\"monitoring__tbody__serviceRow\" layout=\"column\" \nlayout-align=\"space-between stretch\" ng-repeat=\"c in vm.listOnline track by c.callId\" \nng-style=\"{\'border-color\':(c.color)}\" first=\"$first\"><call-row flex call=\"c\" bridge=\"c.history[c.history.length-1]\" \nis-call=\"{{true}}\" loaded=\"vm.loaded\" \nng-class=\"{nieudanePolaczenie: c.history[c.history.length-1].status === \'FAILED\', selected: c.selected === true}\">\n</call-row><call-row flex ng-repeat=\"h in c.history | filter: { status:\'!QUEUED\'} \" call=\"h\" last=\"$last\" \nloaded=\"vm.loaded\" play-row-callback=\"vm.playRowCallback\" \nng-class=\"{nieudanePolaczenie: h.status === \'FAILED\', selected: c.selected==true}\"></call-row></md-list-item>\n<md-list-item class=\"monitoring__tbody__disconnectedRow\" layout=\"column\" layout-align=\"start stretch\" \nng-repeat=\"c in vm.disconnectedList track by c.callId\" ng-style=\"{\'border-color\':(c.color)}\"><call-row flex call=\"c\" \nis-call=\"{{true}}\" is-history=\"{{true}}\" loaded=\"vm.loaded\" \nng-class=\"{nieudanePolaczenie: h.status === \'FAILED\', selected: c.selected==true}\"></call-row><call-row flex \nng-repeat=\"h in c.history   | filter: { status:\'!QUEUED\'}\" call=\"h\" is-history=\"{{true}}\" last=\"$last\" \nloaded=\"vm.loaded\" ng-class=\"{nieudanePolaczenie: h.status === \'FAILED\', selected: c.selected==true}\" \nplay-row-callback=\"vm.playRowCallback\"></call-row></md-list-item></md-list></div>");
$templateCache.put("app/main/contactcenter/callsonline/template/monitoring.html","<div ng-if=\"vm.sidenavData.consultant\" style=\"color: grey\"><div class=\"p-20\" style=\"height: 100%; width: 100%\"><div \nng-if=\"vm.sidenavData\" layout=\"column\" layout-align=\"start start\" id=\"sidenav-consultant-details\" \nclass=\"base-sidenav-view\"><div ng-if=\"vm.sidenavData.consultant.consultantID\">consultant ID: <strong>\n{{vm.sidenavData.consultant.consultantID}}</strong></div><div ng-if=\"vm.sidenavData.consultant.firstName\">\nImię i nazwisko: <strong>{{vm.sidenavData.consultant.firstName}} {{vm.sidenavData.consultant.lastName}}</strong></div>\n<div ng-if=\"vm.sidenavData.consultant.phone1\">Phone 1: <strong>{{vm.sidenavData.consultant.phone1}}</strong></div><div \nng-if=\"vm.sidenavData.consultant.isActive\">Aktywny: <strong>{{vm.sidenavData.consultant.isActive}}</strong></div><div \nng-if=\"vm.sidenavData.consultant.updateTime\">Data aktualizacji: <strong>\n{{vm.sidenavData.consultant.updateTime | date: \'dd-MM-yyyy HH:mm\'}}</strong></div></div></div><div \nng-if=\"vm.sidenavData.premiumNumber\" style=\"height: 100%; width: 100%; padding: 0 20px\"><div layout=\"column\" \nclass=\"base-sidenav-view\"><div ng-if=\"vm.sidenavData.premiumNumber.serviceName\">serwis: <strong>\n{{vm.sidenavData.premiumNumber.serviceName}}</strong></div><div ng-if=\"vm.sidenavData.premiumNumber.serviceID\">\nserwis id: <strong>{{vm.sidenavData.premiumNumber.serviceID}}</strong></div><div \nng-if=\"vm.sidenavData.premiumNumber.dniID\">dniId: <strong>{{vm.sidenavData.premiumNumber.dniID}}</strong></div><div \nng-if=\"vm.sidenavData.premiumNumber.start\">czas: <strong>\n{{vm.sidenavData.premiumNumber.start | amDateFormat:\'YYYY-MM-DD HH:mm:ss\'}}</strong></div></div></div></div>");
$templateCache.put("app/main/contactcenter/components/accordionform/accordionform.html","<form name=\"vm.mainForm\" id=\"accordion-form-{{$id}}\" ng-cloack class=\"accordion-form\" \nng-class=\"{ \'inited\': vm.activePaneIndex !== undefined }\" ng-transclude></form><div layout=\"row\" \nlayout-align=\"end center\"><md-progress-circular ng-if=\"vm.formSubmitted\" md-diameter=\"24px\"></md-progress-circular>\n<md-button ng-if=\"vm.onComplete && !vm.formSubmitted\" class=\"md-icon-button complete-btn\" \nng-disabled=\"vm.wizzardProgress < 1\" ng-click=\"vm.completeForm()\"><md-icon \nmd-svg-src=\"/assets/icons/down-arrow-in-small-circle.svg\" aria-label=\"ok\"></md-icon><md-tooltip>Zapisz zmiany\n</md-tooltip></md-button></div>");
$templateCache.put("app/main/contactcenter/components/accordionform/formpane.html","<div class=\"form-pane\" ng-class=\"{active : vm.active, \'last\': vm.accordionForm.config.lastScope == $id}\" \nlayout=\"column\" layout-align=\"start stretch\"><div class=\"pane-up\" \nng-class=\"{\'clickable-header\': vm.config.clikcableHeader && !vm.ngDisabled && !vm.hideContent, \'disabled\': vm.ngDisabled }\" \nlayout=\"column\" layout-align=\"start start\" ng-click=\"vm.setActivePane()\"><div flex class=\"header\" layout=\"row\" \nlayout-align=\"start center\"><div layout=\"row\" layout-align=\"center center\" class=\"step-header\"><div \nclass=\"step-circle\"><md-icon ng-if=\"vm.formProgress == 100\" class=\"icon-completed\" \nmd-font-icon=\"icon-checkbox-marked-circle\" aria-label=\"previous\"></md-icon><md-progress-circular class=\"progress\" \nmd-mode=\"determinate\" value=\"{{vm.formProgress}}\"></md-progress-circular><md-icon class=\"circle\" \nmd-svg-src=\"/assets/icons/circle-shape-outline.svg\" aria-label=\"previous\"></md-icon><md-icon ng-if=\"vm.paneIcon\" \nclass=\"pane-icon\" md-svg-src=\"{{::vm.paneIcon}}\" aria-label=\"previous\"></md-icon></div></div><div flex=\"80\" \nclass=\"content-header\" ng-transclude=\"pHeader\"></div></div><div class=\"pane-minifed\" layout=\"row\" \nlayout-align=\"start stretch\"><div class=\"step-minified w-0\"></div><md-truncate ng-if=\"!vm.active || vm.showMinified\" \nclass=\"minifed-content\" ng-transclude=\"pMinified\"></md-truncate></div></div><form ng-cloack ng-if=\"vm.registered\" \nclass=\"pane-wrapper\" name=\"vm.form\" novalidate=\"novalidate\" autocomplete=\"off\"><div ng-init=\"vm.onFormInit()\" \nng-show=\"vm.active && !vm.hideContent\" ng-keyup=\"$event.keyCode == 13 ? vm.nextPane(vm.form.$valid) : null\" \nlayout=\"row\" layout-align=\"start stretch\" class=\"pane\"><div class=\"step-pane w-0\"></div><div flex=\"80\" \nclass=\"content-pane\" layout=\"column\" layout-align=\"start start\"><div flex ng-transclude=\"pContent\"></div><div flex \nlayout=\"row\" layout-align=\"start center\" class=\"content-action h-50\"><div flex ng-if=\"vm.config.controlsActive\" \nlayout=\"row\" layout-align=\"start center\"><md-button ng-if=\"!vm.isFirst\" class=\"md-icon-button\" \nng-click=\"vm.previousPane()\"><md-icon md-svg-src=\"/assets/icons/left-arrow-inside-a-circle.svg\" aria-label=\"previous\">\n</md-icon><md-tooltip>Poprzedni krok</md-tooltip></md-button><md-button ng-hide=\"vm.isLast\" class=\"md-icon-button\" \nng-disabled=\"!vm.form.$valid\" ng-click=\"vm.nextPane(vm.form.$valid)\"><md-icon md-svg-src=\"/assets/icons/next-page.svg\" \naria-label=\"ok\"></md-icon><md-tooltip>Nastepny krok</md-tooltip></md-button></div></div></div></div></form></div>");
$templateCache.put("app/main/contactcenter/components/avatarcropper/avatarcropper.html","<input id=\"{{\'fileSelect\'+$id}}\" nv-file-select uploader=\"vm.FileUploader\" style=\"display:none\" type=\"file\" \naccept=\"image/*\"><div layout=\"column\" layout-align=\"center center\" class=\"avatar-cropper\" style=\"position: relative\">\n<div flex layout=\"row\" layout-align=\"center center\" class=\"avatar-result\" ng-hide=\"vm.showCroppingArea\" \nstyle=\"position: relative\"><img ng-if=\"vm.imgUrl\" class=\"md-avatar-rect\" \nng-src=\"{{vm.photo.croppedImage ? vm.photo.croppedImage : vm.imgUrl}}\" imageonload> <img \nng-if=\"!vm.imgUrl && vm.defaultImg\" class=\"md-avatar-rect\" ng-src=\"{{vm.defaultImg}}\" imageonload><div \nng-if=\"!vm.imgUrl && !vm.defaultImg\" class=\"default-avatar\"><img class=\"md-avatar-rect\" imageonload \nng-class=\"{\'def-avatar-bg\':true}\"><md-icon class=\"def-avatar-icon\" md-svg-src=\"/assets/navigation/avatar.svg\">\n</md-icon></div><md-button flex ng-show=\"vm.showAdd && !vm.ngDisabled\" ng-click=\"vm.selectFile()\" \nclass=\"md-primary md-icon-button avatar-button\" type=\"button\" aria-label=\"Upload\"><md-icon class=\"icon-overrider\" \nmd-font-icon=\"icon-plus-circle\"></md-icon><md-tooltip md-direction=\"bottom\">Zmień Avatar</md-tooltip></md-button></div>\n<ui-cropper flex ng-if=\"vm.showCroppingArea\" class=\"cropping-area\" result-image-quality=\"1.0\" \nimage=\"vm.photo.uplaodedImage\" area-type=\"circle\" result-image=\"vm.photo.croppedImage\"></ui-cropper><div \nclass=\"save-button\" ng-show=\"vm.showCroppingArea\" layout=\"column\" layout-align=\"center stretch\"><md-button flex=\"100\" \nng-click=\"vm.saveImage()\" class=\"md-primary md-button\" type=\"button\" aria-label=\"Save\"><img \nng-src=\"assets/icons/save-white.png\"><md-tooltip md-direction=\"bottom\">Zmień Avatar</md-tooltip></md-button></div>\n</div>");
$templateCache.put("app/main/contactcenter/components/activityaxis/activityaxis.html","<div class=\"nav-status-axis\" style=\"height: 100%\"><div class=\"axis\" style=\"height: 100%\"><div \ntitle=\"{{s.statusName}} - {{s.differenceTime}}\" alt=\"{{s.statusName}}\" class=\"status status-{{s.status}}\" \nstyle=\"min-width: {{s.difference?(s.difference/vm.timeFromLogin)*100:0}}%;width: {{s.difference?(s.difference/vm.timeFromLogin)*100:0}}%\" \nng-repeat=\"s in vm.statusStatistic\" style=\"height: 100%\"></div></div></div>");
$templateCache.put("app/main/contactcenter/components/avatarletter/avatarletter.html","<div flex layout=\"row\" layout-align=\"center center\" class=\"avatar-icon\" ng-class=\"vm.colorClass\" \nstyle=\"max-height: inherit\"><span>{{vm.letter | uppercase}}</span></div>");
$templateCache.put("app/main/contactcenter/components/callinfobar/callinfobar.html","<div class=\"info-call-bar cib\" \nng-class=\"{\'cib-active\':vm.active,\'cib-not-active\':!vm.active,\'cib-minimized\':vm.minimized,\'cib-double\':vm.css.activeClass.two,\'cib-triple\':vm.css.activeClass.three}\" \nlayout=\"row\" layout-align=\"start center\" ng-click=\"vm.callinfoBarClicked($event)\" ng-cloak><div class=\"background\">\n</div><div lavout=\"column\" flex layout-align=\"start center\" class=\"details-container\"><div class=\"details-row\" \nlayout=\"row\" layout-align=\"space-between center\"><div flex-gt-lg=\"25\" flex-lg=\"45\" layout=\"row\" \nlayout-align=\"space-around center\" class=\"client-box animateCallInfoBar call-status-box\"><div flex=\"20\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"avatar\" ng-class=\"vm.currCall.status | lowercase\"><img \nng-src=\"assets/icons/monitoring/status/{{vm.currCall.status}}.svg\" alt=\"{{vm.currCall.status}}\"></div><div \nclass=\"status details\" style=\"color:#77C480\" ng-class=\"vm.currCall.status | lowercase\" \ntranslate=\"{{\'CALLINFOBAR.STATUS.\'+vm.currCall.status}}\">{{vm.currCall.status | lowercase}}</div><div \nclass=\"call-status\"><div class=\"counterdown\" style=\"position: relative;width:56px;height:56px\"><span \nstyle=\"position: absolute;top:-1px;left:-1px;width:58px;height:58px;border-radius:50%;box-shadow:0px 0px 4px 0px #aaa; background-color:#fff\">\n</span> <svg xmlns=\"http://www.w3.org/2000/svg\"><g><title>Layer 1</title><circle id=\"circle\" ng-style=\"vm.myStyle\" \nclass=\"circle_animation\" r=\"26\" cy=\"28\" cx=\"28\" stroke-width=\"4\" stroke=\"#77C480\" fill=\"#EAEAEA\"/></g></svg><timer \nclass=\"call-timer\" ng-class=\"{\'call-timer-on\':!vm.currCall.timerStopped,\'call-timer-off\':vm.currCall.timerStopped}\" \ninterval=\"1000\" start-time=\"vm.currCall.callStartTime\" end-time=\"vm.currCall.callEndTime\" \nstyle=\"position: absolute;left:50%;top:50%;transform:translate(-50%,-50%)\"><span>{{minutes}}:{{sseconds}}</span>\n</timer></div></div></div><div class=\"service-info\"><div flex layout=\"column\" layout-align=\"space-between start\"><div \nflex layout-align=\"start center\" layout=\"row\"><span class=\"details bold\">{{vm.currCall.serviceData.serviceName}}</span>\n</div><div flex><div flex layout-align=\"start center\" layout=\"row\" ng-show=\"vm.currCall.serviceDataLoaded\"><span \nclass=\"details\" style=\"color:#878789; font-weight:300\">{{vm.currCall.serviceData.premiumNumber}}</span></div></div>\n</div></div><div class=\"service-box\"><div flex-gt-lg=\"5\" flex-lg=\"20\" layout=\"column\" \nng-show=\"vm.currCall.status===\'WAIT4DROP\' || vm.currCall.status===\'DISCONNECTED\' \"><div class=\"date details bold\">\n{{vm.currDate}}</div><timer class=\"call-timer\" \nng-class=\"{\'call-timer-on\':!vm.currCall.timerStopped,\'call-timer-off\':vm.currCall.timerStopped}\" interval=\"1000\" \nstart-time=\"vm.currCall.callStartTime\" end-time=\"vm.currCall.callEndTime\"><span class=\"details\" \nng-hide=\"vm.currCall.status===\'DISCONNECTED\' \" style=\"color:#878789; font-weight:300\">\n{{hhours}}:{{mminutes}}:{{sseconds}}</span> <span class=\"details\" ng-show=\"vm.currCall.status===\'DISCONNECTED\' \" \nstyle=\"color:#878789; font-weight:300\">{{hhours}}:{{mminutes}}:{{sseconds}}</span></timer></div></div></div><div \nflex-gt-lg=\"{{vm.currCall.subAccount >= 0?20:10}}\" flex-lg=\"{{vm.currCall.subAccount >= 0?25:10}}\" layout=\"row\" \nclass=\"call-status-box animateCallInfoBar\"><div class=\"icon\" ng-show=\"vm.currCall.clientBase\" \nstyle=\"background-color: #fff; box-shadow:rgb(170, 170, 170) 0px 0px 4px 0px inset\"><img \nng-show=\"vm.currCall.clientBase.msisdn || vm.currCall.clientBase.name\" src=\"assets/icons/user.svg\"></div><div \nflex=\"50\" layout=\"column\" style=\"font-weight: 600\"><div ng-if=\"vm.currCall.helpSession\" flex \nlayout-align=\"center start\" layout=\"column\"><span class=\"details bold\" style=\"white-space:nowrap; margin: 0\"><div \ntranslate=\"{{\'CALLINFOBAR.HELP\'}}\"></div>{{vm.currCall.params.consultant}} </span><span class=\"details\" \nstyle=\"white-space:nowrap; margin: 0; color:#878789; font-weight:300\"></span></div><div \nng-if=\"!vm.currCall.helpSession\" flex layout-align=\"center start\" layout=\"column\"><span class=\"details bold\" \nstyle=\"margin: 0\">{{vm.currCall.clientBase.msisdn.slice(0, -3)+\'***\'}}</span> <span class=\"details\" \nstyle=\"white-space:nowrap; margin: 0; color:#878789; font-weight:300\">\n{{vm.currCall.clientBase.name+\' \'+vm.currCall.clientBase.surname}}</span></div></div><div flex=\"50\" layout=\"column\" \nstyle=\"font-weight: 600\"><div flex ng-if=\"vm.currCall.subAccount >= 0\" class=\"walletinfo\" layout-align=\"center start\" \nlayout=\"column\"><span class=\"details\">Stan konta</span> <span class=\"details green bold\" style=\"margin: 0\">\n{{vm.currCall.subAccount/100.00}} PLN / <span class=\"minutes-remain\" \nng-class=\"{\'minutes-alert\':vm.currCall.minutesRemain<=1}\">{{vm.currCall.minutesRemain}} min.</span></span></div></div>\n<div flex=\"20\"><div layout-align=\"start center\" layout=\"row\" ng-show=\"vm.currCall.clientDataLoaded\"><span \nng-show=\"vm.currCall.clientBase.age\" class=\"details bold margin\">{{vm.currCall.clientBase.age}} lat</span></div></div>\n</div><div><div flex ng-hide=\"vm.currCall.serviceDataLoaded\"><md-progress-circular md-diameter=\"40px\" \nclass=\"md-accent\"></md-progress-circular></div></div><div flex=\"10\" \nng-if=\"(vm.currCall.sdp || vm.currCall.status===\'WAIT4DROP\') && !vm.currCall.helpSession\" layout=\"row\" \nlayout-align=\"space-around center\" class=\"call-status-buttonAction animateCallInfoBar\"><button ng-if=\"vm.currCall.sdp\" \nng-click=\"vm.answerWebRTC($event)\"><md-tooltip ng-if=\"vm.currCall.status === \'RINGING\'\" md-direction=\"bottom\">\nOdbierz połączenie</md-tooltip><md-tooltip \nng-if=\"vm.currCall.status === \'WAIT4DROP\' || vm.currCall.status === \'DISCONNECTED\'\" md-direction=\"bottom\">\nRozłącz połączenie</md-tooltip><img class=\"buttonAction__circle\" src=\"assets/icons/monitoring/circle.png\"> <img \nsrc=\"assets/icons/call-answer.svg\" style=\"width: 15px\" ng-if=\"vm.currCall.status === \'RINGING\'\"> <img \nsrc=\"assets/icons/end-call.svg\" style=\"width: 15px\" \nng-if=\"vm.currCall.status === \'WAIT4DROP\' || vm.currCall.status === \'DISCONNECTED\'\"></button> <button \nng-disabled=\"vm.helpInProgress\" ng-click=\"vm.sendHelp($event, vm.currCall.callID)\" \nng-if=\"vm.currCall.status===\'WAIT4DROP\'\"><md-tooltip md-direction=\"bottom\">Pomoc</md-tooltip><img \nclass=\"buttonAction__circle\" src=\"assets/icons/monitoring/circle.png\"> <img class=\"icon\" ng-if=\"!vm.needHelp\" \nsrc=\"assets/icons/help.svg\"> <img class=\"icon\" ng-if=\"vm.needHelp\" src=\"assets/icons/activeHelp.svg\"></button> <button \nng-click=\"vm.showForwardMsg($event,vm.currCall)\" ng-if=\"vm.currCall.forwardText\"><md-tooltip md-direction=\"bottom\">\nWiadomość z przekierowania</md-tooltip><img class=\"buttonAction__circle\" src=\"assets/icons/monitoring/circle.png\"> <i \nclass=\"fa fa-envelope\"></i></button> <button ng-click=\"vm.callForwarding($event,vm.currCall)\" \nng-if=\"vm.currCall.status===\'WAIT4DROP\' && !vm.currCall.isCallOut\"><md-tooltip md-direction=\"bottom\">Przekieruj\n</md-tooltip><img class=\"buttonAction__circle\" src=\"assets/icons/monitoring/circle.png\"> <i class=\"fa fa-forward\"></i>\n</button></div><div flex=\"10\" ng-if=\"(vm.currCall.sdp || vm.currCall.status===\'WAIT4DROP\') && vm.currCall.helpSession\" \nlayout=\"row\" layout-align=\"space-around center\" class=\"call-status-buttonAction animateCallInfoBar\"><md-button \nclass=\"md-icon-button ani-button small\" ng-click=\"$event.stopPropagation();vm.stopHelp()\"><md-icon class=\"circle\" \nmd-svg-src=\"/assets/icons/circle-button.svg\"></md-icon><md-icon class=\"icon-action\" \nmd-svg-src=\"/assets/navigation/cancel.svg\" style=\"color: red\"></md-icon><md-tooltip>Zakończ pomoc</md-tooltip>\n</md-button><md-button class=\"md-icon-button ani-button small\" ng-click=\"$event.stopPropagation();vm.setMicrophone()\">\n<md-icon class=\"circle\" md-svg-src=\"/assets/icons/circle-button.svg\"></md-icon><md-icon class=\"icon-action\" \nng-if=\"!vm.microphoneEnabled\" md-svg-src=\"/assets/navigation/microphone.svg\" style=\"color: green\"></md-icon><md-icon \nclass=\"icon-action\" ng-if=\"vm.microphoneEnabled\" md-svg-src=\"/assets/navigation/microphone-muted.svg\" \nstyle=\"color: red\"></md-icon><md-tooltip>{{vm.microphoneEnabled ? \'Wyłącz\' : \'Włącz\'}} mikrofon</md-tooltip>\n</md-button></div></div></div></div>");
$templateCache.put("app/main/contactcenter/components/consultantslist/consultantslist.html","<div flex class=\"md-white-bg switch-animation pt-10 h-450\" ng-switch=\"vm.addConsultatorMode\"><div flex layout=\"column\" \nlayout-align=\"start stretch\" ng-switch-when=\"0\"><div layout=\"row\" class=\"md-background-bg h-50\" \nlayout-align=\"space-between center\"><h2 flex=\"90\" class=\"md-accent-fg\">Konsultanci/Grupy zapisane w Akcji</h2>\n<md-button flex class=\"md-icon-button md-accent\" aria-label=\"Dodaj grupę do akcji\" \nng-click=\"vm.addConsultatorMode = 1;\"><md-icon md-font-icon=\"icon-plus\" class=\"orange-900-fg s30\"></md-icon><md-tooltip\n md-direction=\"bottom\">Dodaj konsultanta/grupę</md-tooltip></md-button></div><md-content flex layout=\"row\"><div \nclass=\"grey-600-fg\" flex layout=\"column\" layout-align=\"center center\" ng-if=\"!vm.output || vm.output.length<1\"><h2 \nflex>Brak konsultantów!</h2><div flex layout=\"row\"><h3 flex>Aby dodać kliknij ikonke<md-icon md-font-icon=\"icon-plus\" \nclass=\"orange-900-fg s30\"></md-icon></h3></div></div><md-list flex ng-if=\"vm.output.length>0\" \nui-sortable=\"vm.sortableCCOptions\" ng-model=\"vm.output\" class=\"md-dense h-350\" ms-scroll><md-list-item \nclass=\"consultator consultant-header\" ng-repeat=\"consultator in vm.output\" md-item-size=\"20\" layout=\"row\" \nlayout-align=\"space-between center\" layout-margin layout-padding><md-icon flex=\"10\" ng-if=\"consultator.type == \'C\'\" \nmd-font-icon=\"icon-account\" aria-label=\"label\" class=\"snumber md-accent\"><md-tooltip md-direction=\"right\">Konsultant\n</md-tooltip></md-icon><md-icon flex=\"10\" ng-if=\"consultator.type == \'G\'\" md-font-icon=\"icon-account-multiple\" \naria-label=\"label\" class=\"snumber md-accent\"><md-tooltip md-direction=\"right\">Grupa</md-tooltip></md-icon><h1 \nflex=\"10\">{{consultator.priority}}</h1><p flex=\"50\" class=\"md-subhead\">\n{{consultator.login.length>0? consultator.name+\'(\'+consultator.login+\')\':consultator.name}}</p><md-button flex \nclass=\"md-icon-button md-primary\" aria-label=\"Usuń grupę z akcji\" ng-click=\"vm.RemoveFromCc(consultator)\"><md-icon \nmd-font-icon=\"{{ consultator.type == \'G\' ? \'icon-minus\' : \'icon-account-minus\' }}\" class=\"md-accent-fg s30\"></md-icon>\n<md-tooltip md-direction=\"bottom\">Usuń {{consultator.type == \'G\' ? \'grupę\' : \'konsultanta\'}} z akcji</md-tooltip>\n</md-button></md-list-item></md-list></md-content></div><div ng-switch-when=\"1\"><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"h-50\"><md-input-container md-scroll-shrink flex=\"90\" class=\"h-5 pb-10\">\n<label>Szukaj</label><input style=\"border-bottom: 0px\" ng-model=\"vm.search\" ng-change=\"vm.searchConsultant();\" \ntype=\"text\" debounce=\"1500\"></md-input-container><md-button flex class=\"md-icon-button md-accent\" aria-label=\"Cofnij\" \nng-click=\"vm.addConsultatorMode = 0;\"><md-icon md-font-icon=\"icon-cancel s35\"></md-icon></md-button></div><md-divider>\n</md-divider><md-content flex layout=\"column\" layout-align=\"center stretch\"><md-list flex \nui-sortable=\"vm.sortableCCOptions\" ng-model=\"vm.output\" class=\"md-dense h-350\" ms-scroll><md-list-item \nclass=\"consultator consultant-header\" ng-repeat=\"consultator in vm.sourceList\" md-item-size=\"20\" layout=\"row\" \nlayout-align=\"space-between center\" layout-margin layout-padding><md-icon flex=\"10\" ng-if=\"consultator.type == \'C\'\" \nmd-font-icon=\"icon-account\" aria-label=\"label\" class=\"snumber md-accent\"><md-tooltip md-direction=\"right\">Konsultant\n</md-tooltip></md-icon><md-icon flex=\"10\" ng-if=\"consultator.type == \'G\'\" md-font-icon=\"icon-account-multiple\" \naria-label=\"label\" class=\"snumber md-accent\"><md-tooltip md-direction=\"right\">Grupa</md-tooltip></md-icon><p flex=\"50\" \nclass=\"md-subhead\">{{consultator.login.length>0? consultator.name+\'(\'+consultator.login+\')\':consultator.name}}</p>\n<md-button flex class=\"md-icon-button md-primary\" aria-label=\"Usuń grupę z akcji\" ng-click=\"vm.addToCC(consultator)\">\n<md-icon md-font-icon=\"icon-plus\" class=\"md-accent-fg s30\"></md-icon><md-tooltip md-direction=\"bottom\">\nDodaj {{consultator.type == \'G\' ? \'grupę\' : \'konsultanta\'}} do akcji</md-tooltip></md-button></md-list-item></md-list>\n</md-content></div></div>");
$templateCache.put("app/main/contactcenter/components/dialog/dialog.html","<div class=\"dialog-cc\" layout=\"column\" layout-align=\"space-around stretch\"><div flex class=\"dialog-header\" \nng-class=\"{\'dialog-header-small\':vm.smallHeader}\" layout=\"column\" layout-align=\"start stretch\"><div flex \nclass=\"header p-5\" layout=\"row\" layout-align=\"space-between start\"><md-icon ng-if=\"vm.titleIcon!==undefined\" \nclass=\"title-icon {{vm.titleIcon}}\"></md-icon><div flex translate=\"{{vm.dialogTitle}}\">Tytuł okna...</div><md-button \ntype=\"submit\" class=\"md-primary md-icon-button\" ng-click=\"vm.cancelfunc ? vm.cancelfunc() : vm.close()\"><md-icon \nmd-font-icon=\"icon-cancel\" class=\"icon\"></md-icon></md-button></div></div><div flex ng-transclude=\"content\" \nclass=\"white-bg dialog-content\" layout=\"column\" layout-align=\"start stretch\" ms-scroll></div><footer \nng-transclude=\"footer\" ng-show=\"vm.showFooter\" flex=\"grow\" class=\"bottom-bar\" layout=\"row\" layout-align=\"end center\">\n</footer></div>");
$templateCache.put("app/main/contactcenter/components/mddatetimepicker/mddatetimepicker.html","<md-button ng-if=\"!vm.ngDisabled\" aria-label=\"Ustaw datę\" class=\"md-icon-button\" ng-click=\"vm.displayDialog()\"><md-icon\n md-font-icon=\"icon-calendar-clock\"></md-icon></md-button><md-input-container><input name=\"vm.datePlaceholder\" \ntype=\"text\" ng-model=\"vm.Date\" ng-disabled=\"vm.ngDisabled\" ng-click=\"vm.displayDialog()\" \nplaceholder=\"{{vm.datePlaceholder}}\"></md-input-container>");
$templateCache.put("app/main/contactcenter/components/dynamicform/dynamicform.html","<div layout=\"column\" layout-align=\"start stretch\"><div ng-if=\"!field.hide\" flex \nng-repeat=\"field in vm.actionFields | orderBy: \'order\'\" bind-html-compile=\"field.template\" layout=\"column\" \nlayout-align=\"start stretch\"></div></div>");
$templateCache.put("app/main/contactcenter/components/issuetracker/issuetracker.html","<jira-issue ng-if=\"vm.issueTrackerConfig.issueTrackerId == vm.ISSUE_TRACKER_NAME.JIRA\" \nopen-issue-dialog=\"vm.openIssueDialog\" issue-status=\"vm.issueStatus\" \ncreate-issue-dialog-params=\"vm.createIssueDialogParams()\"></jira-issue><bugzilla-issue \nng-if=\"vm.issueTrackerConfig.issueTrackerId == vm.ISSUE_TRACKER_NAME.BUGZILLA\" open-issue-dialog=\"vm.openIssueDialog\" \nissue-status=\"vm.issueStatus\" create-issue-dialog-params=\"vm.createIssueDialogParams()\"></bugzilla-issue><mantis-issue \nng-if=\"vm.issueTrackerConfig.issueTrackerId == vm.ISSUE_TRACKER_NAME.MANTIS\"></mantis-issue>");
$templateCache.put("app/main/contactcenter/components/messagestatus/messagestatus.html","<div class=\"container\"><div class=\"status-box handled\" ng-if=\"vm.message.handled\" title=\"Handled\" alt=\"Handled\"></div>\n<div class=\"status-box reserved\" ng-if=\"vm.message.reserved\" title=\"Reserved\" alt=\"Reserved\"></div><div \nclass=\"status-box dequeued\" ng-if=\"vm.message.dequeued\" title=\"Dequeued\" alt=\"Dequeued\"></div><div \nclass=\"status-box queued\" ng-if=\"vm.message.queued\" title=\"Queued\" alt=\"Queued\"></div><div class=\"status-box taken\" \nng-if=\"vm.message.taken\" title=\"Taken\" alt=\"Taken\"></div></div>");
$templateCache.put("app/main/contactcenter/components/optionsmenu/optionsmenu.html","<md-list class=\"option-menu\"><md-list-item ng-if=\"item.template\" ng-cloak layout=\"row\" \nng-repeat=\"item in ::vm.stateArray | filter: {evalHide: \'false\' }\" ng-hide=\"item.evalHide || item.isHidden\" \nng-class=\"{\'selected\': item.state == vm.currentState , \'folder-selected\': vm.folderSelected == item }\" \nbind-html-compile=\"item.template\"></md-list-item></md-list>");
$templateCache.put("app/main/contactcenter/components/sidenavcontent/sidenavcontent.html","<md-content class=\"form-placeholder main-container\" layout=\"column\" layout-align=\"start start\" \nbind-html-compile=\"vm.template\" ms-scroll></md-content>");
$templateCache.put("app/main/contactcenter/components/serviceconsultant/serviceconsultant.html","<dialog-component id=\"service-consultant\" dialog-title=\"\'SERVICE_CONSULTANT.TITLE\'\"><content layout=\"row\" \nlayout-align=\"start stretch\" class=\"content\"><div class=\"container\"><div layout=\"column\" \nstyle=\"max-height: 50vh; height: 100%\"><div flex=\"10\" class=\"input-bar\" layout=\"row\" layout-fill \nlayout-align=\"space-between start\"><p></p><div layout=\"row\"><div class=\"search-container\" flex=\"85\"><md-input-container\n md-no-float><input type=\"text\" ng-model=\"vm.search\"></md-input-container></div><div flex=\"15\"><img \nclass=\"search-icon\" src=\"/assets/icons/search.png\"></div></div></div><div flex ms-scroll layout-fill \nclass=\"consultants-container scrollable scrollable-list\"><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"table-header\"><p class=\"text\" flex=\"70\">{{\"SERVICE_CONSULTANT.CONSULTANT\" | translate}}</p><p class=\"text\" \nflex=\"30\">{{\"SERVICE_CONSULTANT.LOGIN_FROM_CHANNEL\" | translate}}</p></div><div flex layout=\"column\" \nng-repeat=\"consultant in vm.consultants | filter: vm.search\" class=\"consultant consultant-item\" \nng-class=\"{\'selected\':consultant === vm.consultantSelected}\"><div flex=\"100\" layout=\"row\" \nlayout-align=\"space-between center\" ng-click=\"vm.consultantClick(consultant)\"><div flex=\"70\" layout=\"row\" \nlayout-align=\"center center\"><div flex=\"10\" class=\"consultant-avatar\" layout=\"row\" layout-align=\"start center\"><img \nng-if=\"consultant.photoUrl\" class=\"avatar\" alt=\"{{ consultant.firstName }}\" ng-src=\"{{ consultant.photoUrl }}\"><div \nng-if=\"!consultant.photoUrl\" class=\"noAwatar\" layout=\"column\" layout-align=\"center center\"><md-icon flex \nmd-svg-src=\"/assets/navigation/avatar.svg\" aria-label=\"avatar\"></md-icon></div></div><div flex=\"90\" \nclass=\"consultant-name pl-16\">\n{{consultant.consultantID}} / {{consultant.alias?consultant.alias:(consultant.firstName+\' \'+consultant.lastName)}}\n</div></div><div flex=\"30\" layout=\"row\" layout-align=\"center center\"><div flex=\"55\" class=\"consultant-fromlogin\">\n<strong><timer ng-if=\"consultant.lastLoginDate\" flex start-time=\"consultant.lastLoginDate\" interval=\"1000\">\n{{hhours}}h {{mminutes}}m {{sseconds}}s</timer></strong></div><div flex=\"45\" layout=\"row\" layout-align=\"center center\">\n<img class=\"phonetype\" \nng-hide=\"consultant.phoneTypeId == 5 || consultant.phoneTypeId == 6 || consultant.phoneTypeId == 0\" \nng-src=\"assets/icons/dashboard/phonetype/{{ consultant.phoneTypeId }}_{{ consultant.callStatus }}.svg\"> <img \nclass=\"phonetype\" ng-if=\"consultant.phoneTypeId == 5 || consultant.phoneTypeId == 6 || consultant.phoneTypeId == 0\" \nng-src=\"assets/icons/dashboard/phonetype/{{ consultant.phoneTypeId }}.svg\"><p class=\"\" \nng-if=\"consultant.phone1!==\'---\'\" ng-style=\"{ color: consultant.callStatus == 1 ? \'green\' : \'black\' }\">\n{{consultant.phone1}}</p></div></div></div><div flex=\"100\" layout=\"row\" class=\"consultant-message pt-24 pb-24\" \nng-if=\"vm.consultantSelected === consultant\"><div flex=\"10\"></div><div flex=\"90\" layout=\"row\"><div class=\"message\" \nalt=\"{{msg.text}}\" title=\"{{msg.text}}\" ng-class=\"{\'selected\': vm.msgSelected === msg}\" \nng-repeat=\"msg in vm.forwardList | limitTo: 3\" ng-click=\"vm.msgSelect(consultant, msg)\">{{msg.text}}</div></div></div>\n</div></div><div class=\"consultant-forward\" layout=\"row\"><div flex=\"100\" class=\"content\" \nng-if=\"vm.consultantForward && !vm.isCalling\" layout=\"row\"><div flex=\"95\" class=\"consultant-info\" layout=\"row\"><div \nclass=\"text\">{{\"SERVICE_CONSULTANT.FROM_CONSULTANT\" | translate}}</div><div class=\"bold text\">\n{{vm.myConsultant.id}} / {{vm.myConsultant.alias?vm.myConsultant.alias:(vm.myConsultant.firstName+\' \'+vm.myConsultant.lastName)}}\n</div><div class=\"text\">{{\"SERVICE_CONSULTANT.TO_CONSULTANT\" | translate}}</div><div class=\"text\"><div class=\"avatar\">\n<img ng-if=\"vm.consultantForward.photoUrl\" class=\"avatar\" alt=\"{{ vm.consultantForward.firstName }}\" \nng-src=\"{{ vm.consultantForward.photoUrl }}\"><div ng-if=\"!vm.consultantForward.photoUrl\" class=\"noAwatar\" \nlayout=\"column\" layout-align=\"center center\"><md-icon flex md-svg-src=\"/assets/navigation/avatar.svg\" \naria-label=\"avatar\"></md-icon></div></div></div><div class=\"bold text\">\n{{vm.consultantForward.consultantID}} / {{vm.consultantForward.alias?vm.consultantForward.alias:(vm.consultantForward.firstName+\' \'+vm.consultantForward.lastName)}}\n</div></div><div flex=\"5\"><md-button class=\"consultant-item-button md-icon-button\" \nng-click=\"vm.callForwarding(consultant);\" aria-label=\"play button\"><img class=\"circleButton\" \nsrc=\"assets/icons/monitoring/circle.png\"> <i class=\"fa fa-forward\"></i></md-button></div></div><div class=\"content\" \nng-if=\"vm.isCalling\" layout=\"row\"><div class=\"text\">{{\"SERVICE_CONSULTANT.CALLING_TO\" | translate}}</div><div \nclass=\"text\"><div class=\"avatar\"><img ng-if=\"vm.consultantForward.photoUrl\" class=\"avatar avatar-anim\" \nalt=\"{{ vm.consultantForward.firstName }}\" ng-src=\"{{ vm.consultantForward.photoUrl }}\"><div \nng-if=\"!vm.consultantForward.photoUrl\" class=\"noAwatar\" layout=\"column\" layout-align=\"center center\"><md-icon flex \nmd-svg-src=\"/assets/navigation/avatar.svg\" aria-label=\"avatar\"></md-icon></div></div></div><div class=\"bold text\">\n{{vm.consultantForward.consultantID}} / {{vm.consultantForward.alias?vm.consultantForward.alias:(vm.consultantForward.firstName+\' \'+vm.consultantForward.lastName)}}\n</div></div><div class=\"empty content\" layout=\"row\" ng-if=\"!vm.consultantForward\"><div class=\"text\">\n{{\"SERVICE_CONSULTANT.SELECT_CONSULTANT\" | translate}}</div><div class=\"bold text\">\n{{\"SERVICE_CONSULTANT.FORWARD\" | translate}}</div></div></div></div></div></content></dialog-component>");
$templateCache.put("app/main/contactcenter/components/partnerslist/partnerslist.html","<div layout=\"column\" class=\"partner-list\"><div layout=\"column\"><div flex=\"100\" class=\"input-bar header-table\" \nlayout=\"row\" layout-align=\"space-between center\"><div flex=\"80\" flex-offset=\"5\"><label \ntranslate=\"TAPARTNERSLIST.PARTNERS\">Partnerzy</label></div><md-input-container class=\"search\" flex=\"20\" md-no-float \nlayout=\"row\"><i class=\"fa fa-search\" aria-hidden=\"true\"></i> <input placeholder=\"Search for anyone\" type=\"text\" \nng-model=\"vm.search\" translate translate-attr-placeholder=\"TAHEADER.SEARCH\"></md-input-container></div><md-content \nms-scroll class=\"partnerlist-container scrollable-list\"><div ng-repeat=\"item in vm.ngModel | filter: vm.search\" \nclass=\"partner partner-item\" ng-class=\"item.id==vm.selectedPartner?\'selected-partner\':\'\'\" \nng-click=\"vm.setPartner(item)\"><div flex=\"100\" layout=\"row\" layout-align=\"start center\"><div flex=\"80\" flex-offset=\"5\">\n{{item.companyName}}</div><div flex=\"20\"></div></div></div></md-content></div></div>");
$templateCache.put("app/main/contactcenter/components/tafile/tafile.html","<label translate=\"{{vm.conf.label}}\"></label><div layout=\"row\" ng-if=\"!vm.recordNew\" layout-align=\"start center\"><audio\n flex ng-if=\"vm.ngModel\" class=\"audio-player\" controls><source ng-src=\"{{vm.ngModel}}\" class=\"audio-src\"></audio>\n<md-button ng-click=\"vm.recordNew = true;\" class=\"md-fab md-mini md-primary\"><md-icon md-font-icon=\"icon-upload\">\n</md-icon><md-tooltip md-direction=\"bottom\">Upload</md-tooltip></md-button></div><div layout=\"row\" \nng-if=\"vm.recordNew\" layout-align=\"start center\"><md-button ng-click=\"vm.saveRec($event)\" ng-disabled=\"\" \nclass=\"md-fab md-mini md-primary\"><md-icon ng-if=\"!vm.recordedInput\" md-font-icon=\"icon-upload\"></md-icon><md-icon \nng-if=\"vm.recordedInput\" md-font-icon=\"icon-content-save\"></md-icon><md-tooltip md-direction=\"bottom\">Upload\n</md-tooltip></md-button><md-input-container ng-hide=\"vm.linkMode\" flex><label>Link</label><input \nng-model=\"vm.ngModel\" type=\"text\"></md-input-container><input id=\"fileSelect\" ng-if=\"vm.FileUploader\" type=\"file\" \nng-model=\"vm.file\" style=\"display: none\" nv-file-select uploader=\"vm.FileUploader\"><ng-audio-recorder flex \nlayout=\"row\" id=\"audioInput\" show-player=\"true\" audio-model=\"vm.recordedInput\" auto-start=\"false\" \non-record-start=\"vm.linkMode = true;\"><div flex layout=\"row\" layout-align=\"start center\" ng-if=\"recorder.isAvailable\">\n<md-button class=\"md-icon-button md-fab md-mini md-primary\" ng-disabled=\"recorder.status.isRecording\" \naria-label=\"Dodaj grupę do akcji\" ng-click=\"recorder.startRecord();\"><md-icon md-font-icon=\"icon-microphone-dots\">\n</md-icon><md-tooltip md-direction=\"bottom\">Nagrywaj</md-tooltip></md-button><md-button \nclass=\"md-icon-button md-fab md-mini md-primary\" ng-disabled=\"recorder.status.isRecording === false\" \naria-label=\"Dodaj grupę do akcji\" ng-click=\"recorder.stopRecord();\"><md-icon md-font-icon=\"icon-microphone-off\">\n</md-icon><md-tooltip md-direction=\"bottom\">Stop</md-tooltip></md-button><ng-audio-recorder-analyzer flex \nclass=\"audio-recorder\"></ng-audio-recorder-analyzer></div><div ng-if=\"!recorder.isAvailable\">\nMessage for users when recording is not possible.</div></ng-audio-recorder></div>");
$templateCache.put("app/main/contactcenter/components/taHeader/taHeader.html","<div ng-if=\"!vm.state.current.hideTaHeader\" class=\"ta-header header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"100\" layout=\"row\" layout-align=\"space-between center\"><div flex \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"{{vm.state.current.stateIcon}}\" class=\"s24\"></md-icon></span><span class=\"logo-text\">{{vm.routeDecode}}\n</span></div><div flex ng-show=\"vm.state.current.statePanelRight\" class=\"search-input-wrapper\" layout=\"row\" \nlayout-align=\"end start\"><label for=\"search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container\n flex=\"60\" md-no-float class=\"m-0\"><input id=\"search\" placeholder=\"Search for anyone\" type=\"text\" \nng-model=\"vm.headerConfig.navBar.search\" translate translate-attr-placeholder=\"TAHEADER.SEARCH\"></md-input-container>\n<md-button class=\"md-icon-button\" aria-label=\"button-label\" ng-show=\"vm.headerConfig.navBar.functionAdd\" \nng-click=\"vm.headerConfig.navBar.functionAdd();\"><img ng-src=\"{{vm.state.current.stateIconActionAdd}}\"></md-button>\n</div></div></div>");
$templateCache.put("app/main/contactcenter/components/tasearch/tasearch.html","<md-autocomplete ng-if=\"vm.conf\" class=\"consultant-search\" ng-disabled=\"!vm.conf.objList\" \nmd-selected-item=\"vm.selectedObject\" md-selected-item-change=\"vm.selectedReportItem(vm.selectedObject)\" \nmd-search-text=\"vm.searchReport\" md-items=\"item in vm.reportSearch(vm.searchReport)\" \nplaceholder=\"{{ vm.conf.label | translate }}\" md-item-text=\"vm.formatReportObj(item)\"><md-item-template><span \nmd-highlight-text=\"vm.searchReport\" md-highlight-flags=\"^i\">{{ vm.formatReportObj(item)}}</span></md-item-template>\n<md-not-found>Nie znaleziono :(</md-not-found></md-autocomplete>");
$templateCache.put("app/main/contactcenter/components/tags/tags.html","<md-chips ng-model=\"vm.choosenTags\" name=\"tags\" md-transform-chip=\"vm.addTag($chip)\" md-require-match=\"!vm.writeMode\" \nmd-on-remove=\"vm.removeCallback($chip);\"><md-autocomplete md-selected-item=\"vm.chips\" md-search-text=\"vm.searchText\" \nmd-items=\"tag in vm.tagSearch(vm.searchText)\" md-item-text=\"tag.tag\" placeholder=\"Tag\"><md-item-template><span \nmd-highlight-text=\"vm.searchText\">{{tag.tag}}</span></md-item-template></md-autocomplete><md-chip-template><strong>\n#{{$chip.tag}}</strong></md-chip-template></md-chips>");
$templateCache.put("app/main/contactcenter/components/tamultiselect/tamultiselect.html","<div id=\"tags-container-{{$id}}\" layout=\"column\" layout-align=\"start stretch\"><md-chips flex \nclass=\"{{vm.customClass ? vm.customClass: \'black small\'}}\" ng-cloak \nng-keyup=\"$event.keyCode == 13 ? $event.stopPropagation() : null\" ng-model=\"vm.output\" readonly=\"vm.ngDisabled\" \nmd-on-add=\"vm.updateModel();\" md-transform-chip=\"vm.addTag($chip)\" md-on-remove=\"vm.updateModel();\" name=\"tags\" \nmd-on-select=\"vm.selectDamn($chip)\" md-require-match=\"!vm.writeMode\"><md-autocomplete md-selected-item=\"vm.chips\" \nmd-search-text=\"vm.searchText\" md-items=\"tag in vm.tagSearch(vm.searchText)\" placeholder=\"{{vm.token | translate}}\" \nmd-autoselect=\"true\"><md-item-template><span ng-if=\"tag.token\" md-highlight-text=\"vm.searchText\">\n{{tag.token | translate}}</span> <span ng-if=\"!tag.token\" md-highlight-text=\"vm.searchText\">{{tag.tagId}}</span>\n</md-item-template></md-autocomplete><md-chip-template id=\"tag-{{::$chip.tagId}}-{{::vm.id}}\" \nng-class=\"{\'specjal\': $chip.special, \'selected\': $chip.selected }\"><span ng-if=\"$chip.token\">\n#{{$chip.token |translate}}</span> <span ng-if=\"!$chip.token && !$chip.special\">#{{$chip.tagId}}</span> <span \nng-if=\"$chip.special\">{{$chip.special}}</span></md-chip-template></md-chips></div>");
$templateCache.put("app/main/contactcenter/components/viewActions/viewActions.html","<div flex layout=\"row\" layout-align=\"start center\" class=\"editor-header\"><div flex class=\"header-input\"></div><div \nlayout=\"row\" layout-align=\"start center\" class=\"header-actions\"><md-button ng-click=\"vm.saveFunc()\" \nclass=\"md-button md-raised button-size action-button button-save\" ng-disabled=\"!vm.mainForm.$valid\" \ntranslate=\"VIEWACTIONS.SAVE_BT\">Zapisz</md-button><md-button ng-click=\"vm.closeFunc()\" \nclass=\"md-raised button-size action-button button-cancel\" layout=\"column\" layout-align=\"center center\"><img \nclass=\"close-img\" src=\"../../../../../assets/icons/management/letter-x.svg\" alt=\"\"></md-button></div></div>");
$templateCache.put("app/main/contactcenter/components/tripleview/tripleview.html","<div layout=\"row\" class=\"triple-view\"><div class=\"thin-div\" ng-show=\"vm.tripleviewService.hideSidenav\"></div><div \nng-if=\"!vm.doNotShowSidepanel\" layout=\"column\" class=\"md-sidenav-container {{vm.tripleviewService.sidenavData.class}}\" \nng-class=\"{\'opened\':!vm.tripleviewService.hideSidenav, \'closed\':vm.tripleviewService.hideSidenav}\"><md-sidenav \nng-show=\"!vm.tripleviewService.hideSidenav\" ui-view=\"sidenav\" class=\"sidenav details-sidenav md-white-bg\" \nmd-is-locked-open=\"true\" md-component-id=\"sidenav\" ms-sidenav-helper></md-sidenav><div class=\"ethereal-div\" \nng-if=\"!vm.tripleviewService.hideSidenav && !vm.tripleviewService.panelClicked\"><img class=\"arrow-icon\" \nsrc=\"assets/icons/mainmanu/left_white.png\" ng-click=\"vm.toogleSidenav()\"></div><div class=\"ethereal-div\" \nng-if=\"vm.tripleviewService.hideSidenav && !vm.tripleviewService.panelClicked\"><img class=\"arrow-icon\" \nsrc=\"assets/icons/mainmanu/right_black.png\" ng-click=\"vm.toogleSidenav()\"></div></div><div layout=\"column\" flex>\n<md-content flex ui-view=\"mainContent\" class=\"center content center-sidenav scrollable\" layout=\"column\" \nlayout-align=\"center stretch\" ms-scroll></md-content><div ng-hide=\"vm.hideActions\" layout=\"row\" \nlayout-align=\"space-between center\" class=\"action-placeholder\"><div><md-button ng-if=\"vm.statesHistory.length > 0\" \nclass=\"md-icon-button\" type=\"submit\" aria-label=\"\" ng-click=\"vm.goBack()\"><img \nng-src=\"assets/icons/triple-view/wroc.png\"></md-button></div><div layout=\"row\"><div \nng-repeat=\"item in vm.menu  | orderBy:\'order\'\" ng-click=\"item.func($event)\"><md-button type=\"submit\" \nclass=\"{{item.class ? item.class + \' \' : \'\'}}md-icon-button\" aria-label=\"\"><md-icon ng-if=\"item.icon\" \nmd-font-icon=\"{{item.icon}}\" class=\"icon\"></md-icon><img ng-if=\"item.iconSrc\" ng-src=\"{{item.iconSrc}}\">\n {{item.icon || item.iconSrc ? \'\': item.name}}</md-button></div></div></div></div></div>");
$templateCache.put("app/main/contactcenter/dashboard/component/dashboard.html","<div id=\"dashboard\" layout=\"column\" fxlayoutalign=\"start stretch\"><div flex=\"noshrink\" \nng-if=\"vm.SessionManager.getUserRoleId() !== vm.authRolesConst.consultant && vm.SessionManager.isConsultant()\" \nclass=\"dashboard-choose\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised\" \nng-class=\"{\'md-accent\': vm.currentMode==\'manager\'}\" ng-click=\"vm.currentMode=\'manager\'\">Manager</md-button><md-button \nclass=\"md-raised\" ng-class=\"{\'md-accent\': vm.currentMode==\'consultant\'}\" ng-click=\"vm.currentMode=\'consultant\'\">\nKonsultant</md-button></div><div layout=\"row\" layout-align=\"end center\" class=\"swich-mode-buttons\"><div \nclass=\"mode-button calls-mode\" ng-class=\"{\'not-active-mode\':vm.msm_mode}\"><span>KONSULTANCI</span></div><md-switch \nng-model=\"vm.msm_mode\" ng-class=\"{\'md-checked\':vm.lala}\"></md-switch><div class=\"mode-button messages-mode\" \nng-class=\"{\'not-active-mode\':!vm.msm_mode}\"><span>SESJE</span></div></div><div flex=\"grow\" \nng-if=\"vm.currentMode==\'manager\' && vm.SessionManager.getUserRoleId() !== vm.authRolesConst.consultant\" \nlayout=\"column\" style=\"max-height: calc(100% - 35px) !important\"><div flex class=\"manager-widget-cont\"><msm-table \nng-if=\"vm.msm_mode\"></msm-table><consultants-preview ng-if=\"!vm.msm_mode\"></consultants-preview></div></div><div \nflex=\"grow\" ng-if=\"vm.currentMode==\'consultant\' && vm.SessionManager.isConsultant()\" layout=\"column\"><div layout=\"row\" \nlayout-align=\"space-between center\"><connection-statistic class=\"callChart\" \nchart-data=\"vm.consultantChartData.dataCount\" mode=\"vm.connectionStatisticCons.count\"></connection-statistic>\n<connection-statistic class=\"callChart\" chart-data=\"vm.consultantChartData.dataSeconds\" \nmode=\"vm.connectionStatisticCons.seconds\"></connection-statistic><connection-statistic class=\"callChart\" \nchart-data=\"vm.consultantChartData.dataAvgSeconds\" mode=\"vm.connectionStatisticCons.average\"></connection-statistic>\n</div><div layout=\"row\" layout-align=\"space-between center\"><reports-messages-stats \nstyle=\"margin-top:10px; display: block; width: 50%; margin-right: 10px\" stats=\"true\"></reports-messages-stats>\n<reports-messages-stats style=\"margin-top:10px; display: block; width: 50%\" avg=\"true\"></reports-messages-stats></div>\n<div layout=\"row\" layout-align=\"space-between center\"><status-axis \nstyle=\"margin-top:10px; display: block; width: 50%; margin-right: 10px\" stats=\"true\"></status-axis></div></div></div>");
$templateCache.put("app/main/contactcenter/communicator/communicatorswitch/communicatorswitch.html","<div layout=\"row p-10\"><div flex=\"{{vm.switchVisible?45:75}}\" layout=\"row\" layout-align=\"start center\" \nclass=\"h-40 p-10 menu-name\" ng-class=\"{\'isActive\':vm.communicatorService.communicatorType === \'internal\'}\"><div \ntranslate=\"COMMUNICATOR.internal\"></div></div><div flex=\"25\" layout=\"row\" layout-align=\"center center\"><div \nclass=\"internal pr-8\" ng-class=\"{\'isActive\':vm.communicatorService.communicatorType === \'internal\'}\">\n{{vm.internalCounter}}</div><md-switch ng-if=\"vm.switchVisible\" ng-model=\"vm.switch\" ng-change=\"vm.switchChange()\">\n</md-switch><div ng-if=\"vm.switchVisible\" class=\"client\" \nng-class=\"{\'isActive\':vm.communicatorService.communicatorType === \'client\'}\">{{vm.clientCounter}}</div></div><div \nng-if=\"vm.switchVisible\" flex=\"30\" layout=\"row\" layout-align=\"start center\" class=\"h-40 p-10 menu-name menu-right\" \nng-class=\"{\'isActive\':vm.communicatorService.communicatorType === \'client\'}\"><div class=\"title\" \ntranslate=\"COMMUNICATOR.client\"></div></div></div><div ng-if=\"vm.communicatorService.communicatorType === \'internal\'\" \nflex class=\"search search-panel\" layout=\"row\" layout-align=\"end end\"><div class=\"search-container\" flex=\"70\">\n<md-input-container class=\"search\"><input name=\"search\" ng-model=\"vm.internalMessageService.search\" type=\"text\">\n</md-input-container></div><div flex=\"15\"><img class=\"search-icon\" src=\"/assets/icons/search.png\"></div></div>");
$templateCache.put("app/main/contactcenter/communicator/infobar/infobar.html","<div class=\"infobar\" id=\"infobar\" layout=\"row\" layout-align=\"space-between center\" ng-if=\"vm.templateData.sessionId\">\n<div class=\"infobar__wrapperInfo\" layout=\"row\" layout-align=\"flex-start center\" ng-if=\"vm.templateData.sessionId\"><div \nclass=\"infobar__wrapperInfo__info\" layout=\"column\"><span class=\"infobar__wrapperInfo__info__key\">sesja:</span><p \nclass=\"infobar__wrapperInfo__info__value\" style=\"text-transform: uppercase\"><span \nng-if=\"vm.templateData.messageSessionId\">{{ vm.templateData.messageSessionId }}</span> <span \nng-if=\"!vm.templateData.messageSessionId\">Brak ID</span></p></div><div class=\"infobar__wrapperInfo__info\" \nlayout=\"column\"><span class=\"infobar__wrapperInfo__info__key\">guid:</span><p class=\"infobar__wrapperInfo__info__value\" \nstyle=\"text-transform: uppercase\"><span ng-if=\"vm.templateData.sessionId\">{{ vm.templateData.sessionId }} <span><img \nclass=\"copyGuid\" src=\"assets/icons/copy.svg\" ng-click=\"vm.copyGuid(vm.templateData.sessionId)\"><md-tooltip \nmd-direction=\"bottom\">Copy guid</md-tooltip></span></span><span ng-if=\"!vm.templateData.sessionId\">Brak ID</span></p>\n</div><div class=\"infobar__wrapperInfo__info\" layout=\"column\"><span class=\"infobar__wrapperInfo__info__key\">klient:\n</span><p class=\"infobar__wrapperInfo__info__value\"><span ng-if=\"vm.customerData.name\">{{ vm.customerData.name }}\n</span> <span ng-if=\"!vm.customerData.name\">Brak danych</span></p></div><div class=\"infobar__wrapperInfo__info\" \nlayout=\"column\"><span class=\"infobar__wrapperInfo__info__key\">e-mail:</span><p \nclass=\"infobar__wrapperInfo__info__value\"><span ng-if=\"vm.customerData.email\">{{ vm.customerData.email }}</span> <span \nng-if=\"!vm.customerData.email\">Brak danych</span></p></div></div><div class=\"infobar__events\"><div \nclass=\"infobar__events__eventButtons\" ng-if=\"vm.templateData.sessionId && !vm.mapIsEnabled\"><div \nng-if=\"!vm.mapIsEnabled\" class=\"infobar__events__eventButtons__button\" layout=\"row\"><div class=\"button\" \nng-click=\"vm.showMapDialog($event)\"><img src=\"/assets/icons/placeholder.svg\" alt=\"\" style=\"width: 18px\"></div></div>\n</div><div class=\"infobar__events__eventButtons\" ng-if=\"vm.templateData.sessionId\"><div \nclass=\"infobar__events__eventButtons__button\" layout=\"row\"><div class=\"button\" ng-click=\"vm.informationDialog($event)\">\n<img src=\"/assets/icons/information_black.svg\" alt=\"\" style=\"width: 18px\"></div><div class=\"button\" \nng-click=\"vm.tagsField()\"><img src=\"assets/icons/hashtag.svg\" alt=\"\" style=\"width: 15px\"></div><div class=\"button\" \nng-click=\"vm.forwardSessionFn(vm.templateData,$event)\" ng-if=\"!vm.templateData.finished\"><img \nsrc=\"assets/icons/forward-session2.svg\" alt=\"\" style=\"width: 18px\"></div><div class=\"button\" \nng-click=\"vm.chatSessionEndFn($event)\" ng-if=\"!vm.templateData.finished\"><img src=\"assets/icons/delete.svg\" alt=\"\" \nstyle=\"width: 13px\"></div></div></div></div></div>");
$templateCache.put("app/main/contactcenter/communicator/internallist/internallist.html","<div class=\"session-content\" layout=\"column\" layout-align=\"start stretch\"><div class=\"session\" \nng-class=\"{\'selected\':s.id === vm.internalMessageService.selectedObject.id, \'new-message\':s.isNew && s.isNew === true}\" \nlayout=\"row\" \nng-repeat=\"s in vm.list | filter: vm.internalMessageService.search | orderBy:[\'priorytet\',\'!lastMessage\',\'-lastMessage\']\" \nng-click=\"vm.openCommunicator(s)\"><div flex=\"25\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"avatar-wrapper\"><img flex ng-if=\"s.photoUrl\" md-menu-align-target class=\"avatar status-mask\" \nng-src=\"{{s.photoUrl}}\"><div ng-if=\"!s.photoUrl && s.type!==\'G\'\" class=\"avatar default-avatar\" \nng-class=\"{\'status-mask\':s.type===\'C\'}\"><md-icon flex md-svg-src=\"/assets/navigation/avatar.svg\" aria-label=\"avatar\">\n</md-icon></div><div ng-if=\"!s.photoUrl && s.type===\'G\'\" class=\"avatar default-avatar\"><md-icon flex \nmd-svg-src=\"/assets/navigation/group.svg\" aria-label=\"avatar\"></md-icon></div><md-icon ng-if=\"s.type===\'C\'\" \nmd-font-icon=\"icon-checkbox-blank-circle\" ng-style=\"{\'color\':s.statusColor }\" class=\"icon status\"></md-icon></div>\n</div><div flex=\"75\" layout=\"column\" class=\"info\" layout-align=\"start stretch\"><div layout=\"row\" class=\"row\" \nng-if=\"s.type===\'C\'\"><div flex=\"100\" class=\"text main-title\">{{s.id.substring(1,s.id.length)}} {{s.alias}}</div></div>\n<div layout=\"row\" class=\"row\" ng-if=\"s.type!==\'C\'\"><div flex=\"100\" class=\"text main-title\">\n{{s.id.substring(1,s.id.length)}} {{s.name}}</div></div><div layout=\"row\" class=\"row\" ng-if=\"s.type===\'C\'\"><div \nflex=\"100\" class=\"text sub-title\">{{s.name}}</div></div><div layout=\"row\" class=\"row\"><div flex=\"100\" \nclass=\"text tags\"><ta-multiselect flex=\"33\" ng-if=\"s.tags\" custom-class=\"small black\" ng-disabled=\"true\" \nwrite-mode=\"false\" ng-model=\"s.tags\" tag-overflow=\"s.tags\"></ta-multiselect></div></div></div></div></div>");
$templateCache.put("app/main/contactcenter/communicator/internalmessage/internalmessage.html","<div layout=\"row\" class=\"main full-height\"><div flex=\"80\" class=\"chat p-8\"><internal-chat></internal-chat></div><div \nflex=\"20\" class=\"info p-8\"><internal-info></internal-info></div></div>");
$templateCache.put("app/main/contactcenter/communicator/sessionlist/sessionlist.html","<div id=\"session-list\" layout=\"column\" layout-align=\"start start\"><div style=\"width: 100%\" \nng-repeat=\"s in vm.list | filter:vm.filterList | orderBy: [\'-reservedDate\']\" ng-click=\"vm.openCommunicator(s)\">\n<session-tile session=\"s\" list-type=\"vm.type\"></session-tile></div></div>");
$templateCache.put("app/main/contactcenter/directives/filterbox/filterbox.html","<div class=\"md-toolbar-tools\" layout-padding=\"10\" layout=\"row\" flex><md-icon flex=\"5\" md-font-icon=\"icon-magnify\">\n</md-icon><form flex=\"90\"><md-input-container style=\"width: 100%\"><label translate=\"MANAGEMENT.SERVICE.LIST.SEARCH\">\n</label><input class=\"md-24\" style=\"margin-bottom: -48px\" ng-model=\"filterValue\"></md-input-container></form><div \nflex=\"5\"><button class=\"md-icon-button md-button md-ink-ripple\" type=\"button\" ng-click=\"removeFilter()\" \naria-label=\"close\"><i class=\"material-icons icon icon-close md-24\"></i></button></div></div>");
$templateCache.put("app/main/contactcenter/directives/starrating/starrating.html","<ul ng-if=\"stars\" class=\"star-rating\" ng-class=\"{readonly: readonly}\" ng-mouseleave=\"hoverSelection(-1)\"><li \nng-repeat=\"star in stars\" class=\"star\" ng-click=\"toggle($event,$index)\" ng-mouseover=\"hoverSelection($index)\"><md-icon \nng-if=\"star.hover\" md-svg-src=\"/assets/navigation/star-on.svg\" class=\"icon hover star-button\"></md-icon><md-icon \nng-if=\"::star.filled\" md-svg-src=\"/assets/navigation/star-on.svg\" class=\"icon filled star-button\"></md-icon><md-icon \nng-if=\"::star.half\" md-svg-src=\"/assets/navigation/star-half.svg\" class=\"icon half star-button\"></md-icon><md-icon \nmd-svg-src=\"/assets/navigation/star-on.svg\" class=\"icon star-bg star-button\"></md-icon></li></ul>");
$templateCache.put("app/main/contactcenter/orderbox/template/itemslist.html","<div class=\"sidenav-mail\"><div class=\"header search-header\" layout=\"row\" layout-align=\"start center\">\n<md-input-container flex><input flex name=\"search\" ng-model=\"vm.sidenavData.orderboxGlue.search\" type=\"text\">\n</md-input-container><img src=\"/assets/icons/search.png\"></div><mail-list \ncurrent-thread=\"vm.sidenavData.orderboxGlue.currentThread\" groupthreads=\"vm.sidenavData.groupThreads\" \nthreads=\"vm.sidenavData.orderboxGlue.threads\"></mail-list></div>");
$templateCache.put("app/main/contactcenter/party/calldetails/calldetails.html","<div class=\"call-consultant\" ng-if=\"!vm.call && vm.consultantId>-1\" ng-click=\"vm.loginToRoom();\" \nng-class=\"{\'isManager\': vm.isManager}\"><div class=\"img empty\"></div></div><div class=\"call-active\" \nng-if=\"vm.call.connectedUUID\" ng-class=\"{\'consultant\':vm.call.type===1 , \'client\':vm.call.type===2}\"><img \nsrc=\"../assets/icons/out.png\" ng-if=\"vm.isConnectedWithExternal\"> <svg ng-if=\"!vm.isConnectedWithExternal\" \nversion=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" \ny=\"0px\" viewBox=\"0 380 841.9 1190.6\" style=\"enable-background:new 0 0 841.9 1190.6\" xml:space=\"preserve\" \nng-mouseleave=\"vm.hoverlist[vm.call.uuid]=false\" ng-mouseover=\"vm.hoverlist[vm.call.uuid]=true\"><style type=\"text/css\">\n.st0 {\r\n                fill: {{vm.call.color}};\r\n            }</style><g><path class=\"st0\" \nd=\"M453.5,740.1L453.5,740.1c-14.3,6.8-31.4,0.6-38.2-13.6l-67.6-142.5c-6.8-14.3-0.6-31.4,13.6-38.2h0\r\n		c14.3-6.8,31.4-0.6,38.2,13.6l67.6,142.5C473.9,716.1,467.8,733.3,453.5,740.1z\"/>\n<path class=\"st0\" \nd=\"M381.7,785.7L381.7,785.7c-10.6,11.7-28.8,12.5-40.5,1.9L224.4,681.5c-11.7-10.6-12.5-28.8-1.9-40.5l0,0\r\n		c10.6-11.7,28.8-12.5,40.5-1.9l116.8,106.1C391.5,755.8,392.3,774,381.7,785.7z\"/>\n<path class=\"st0\" \nd=\"M341.6,861L341.6,861c-4.7,15.1-20.8,23.6-35.9,18.9L155,833.1c-15.1-4.7-23.6-20.8-18.9-35.9h0\r\n		c4.7-15.1,20.8-23.6,35.9-18.9l150.7,46.8C337.8,829.8,346.3,845.9,341.6,861z\"/>\n</g></svg></div><div flex layout=\"row\" layout-align=\"start start\" class=\"call-msg\" \nng-if=\"vm.call.type===1 && vm.call.listMsg.length>0 && (vm.consultantId>-1 && ((vm.isManager && !vm.call.connectedUUID) || !vm.isManager))\" \nng-class=\"{\'loginuser\':vm.user.userId === vm.call.externalUserID}\" ng-click=\"vm.msgListShow()\"><div class=\"icon\" \nng-class=\"{\'hover-mouse\':vm.hoverlist[vm.call.uuid]}\" ng-mouseleave=\"vm.hoverlist[vm.call.uuid]=false\" \nng-mouseover=\"vm.hoverlist[vm.call.uuid]=true\"></div><div class=\"count\" flex-offset=\"5\">{{vm.call.listMsg.length}}\n</div></div><div class=\"call-eavesdropp\" ng-if=\"vm.call.type===1 && vm.call.connectedUUID && vm.isManager\" \nng-class=\"{\'hover-mouse\':vm.hoverlist[vm.call.uuid]}\" ng-mouseleave=\"vm.hoverlist[vm.call.uuid]=false\" \nng-mouseover=\"vm.hoverlist[vm.call.uuid]=true\" ng-click=\"vm.eavesdropp()\"></div><div class=\"call-msglist\" \nng-if=\"vm.call.type===1 && vm.call.listMsg.length>0\" ng-show=\"vm.msglist[vm.call.uuid]\"><div class=\"header\"><md-icon \nmd-font-icon=\"icon-close s35\" ng-click=\"vm.msglist[vm.call.uuid]=false\"></md-icon></div><div class=\"msg\" flex \nlayout=\"row\" ng-repeat=\"msg in vm.call.listMsg | orderBy:\'date\':true\"><div class=\"avatar\"><svg version=\"1.1\" \nid=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" \nviewBox=\"0 0 248.349 248.349\" style=\"enable-background:new 0 0 248.349 248.349\" xml:space=\"preserve\"><g><g><path \nstyle=\"fill:{{msg.recordingCall.color}}\" \nd=\"M9.954,241.305h228.441c3.051,0,5.896-1.246,7.805-3.416c1.659-1.882,2.393-4.27,2.078-6.723\r\n			c-5.357-41.734-31.019-76.511-66.15-95.053c-14.849,14.849-35.348,24.046-57.953,24.046s-43.105-9.197-57.953-24.046\r\n			C31.09,154.65,5.423,189.432,0.071,231.166c-0.315,2.453,0.424,4.846,2.078,6.723C4.058,240.059,6.903,241.305,9.954,241.305z\"/>\n<path style=\"fill:{{msg.recordingCall.color}}\" \nd=\"M72.699,127.09c1.333,1.398,2.725,2.73,4.166,4.019c12.586,11.259,29.137,18.166,47.309,18.166\r\n			s34.723-6.913,47.309-18.166c1.441-1.289,2.834-2.622,4.166-4.019c1.327-1.398,2.622-2.828,3.84-4.329\r\n			c9.861-12.211,15.8-27.717,15.8-44.6c0-39.216-31.906-71.116-71.116-71.116S53.059,38.95,53.059,78.16\r\n			c0,16.883,5.939,32.39,15.8,44.6C70.072,124.262,71.366,125.687,72.699,127.09z\"/>\n</g></g></svg></div><div class=\"details\" flex layout=\"column\"><div class=\"number\">{{msg.recordingCall.number}}</div>\n<div class=\"date\"><span class=\"text\" translate=\"CALLDETAILS.MESSAGE\">Wiadomość</span> {{msg.date | altDate}}</div>\n</div><div class=\"icon play\" ng-click=\"vm.playMsg(msg)\"></div><div class=\"icon record\" ng-click=\"vm.replayMsg(msg)\">\n</div></div></div><div class=\"call-consultant\" ng-if=\"vm.call.type===1\" \nng-class=\"{\'loginuser\':vm.user.userId === vm.call.externalUserID, \'isManager\': vm.isManager}\"><div class=\"img\"></div>\n<div class=\"name\">{{vm.call.externalUserName}}</div></div><div class=\"call-client\" \nng-class=\"{\'hover-mouse\':vm.hoverlist[vm.call.uuid], \'isManager\': vm.isManager}\" ng-if=\"vm.call.type===2\" \nng-mouseleave=\"vm.hoverlist[vm.call.uuid]=false\" ng-mouseover=\"vm.hoverlist[vm.call.uuid]=true\" \nng-click=\"vm.showClientPopup()\"><svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" \nxmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 248.349 248.349\" \nstyle=\"enable-background:new 0 0 248.349 248.349\" xml:space=\"preserve\"><g><g><path style=\"fill:{{vm.call.color}}\" \nd=\"M9.954,241.305h228.441c3.051,0,5.896-1.246,7.805-3.416c1.659-1.882,2.393-4.27,2.078-6.723\r\n			c-5.357-41.734-31.019-76.511-66.15-95.053c-14.849,14.849-35.348,24.046-57.953,24.046s-43.105-9.197-57.953-24.046\r\n			C31.09,154.65,5.423,189.432,0.071,231.166c-0.315,2.453,0.424,4.846,2.078,6.723C4.058,240.059,6.903,241.305,9.954,241.305z\"/>\n<path style=\"fill:{{vm.call.color}}\" \nd=\"M72.699,127.09c1.333,1.398,2.725,2.73,4.166,4.019c12.586,11.259,29.137,18.166,47.309,18.166\r\n			s34.723-6.913,47.309-18.166c1.441-1.289,2.834-2.622,4.166-4.019c1.327-1.398,2.622-2.828,3.84-4.329\r\n			c9.861-12.211,15.8-27.717,15.8-44.6c0-39.216-31.906-71.116-71.116-71.116S53.059,38.95,53.059,78.16\r\n			c0,16.883,5.939,32.39,15.8,44.6C70.072,124.262,71.366,125.687,72.699,127.09z\"/>\n</g></g></svg><div class=\"number\">{{vm.call.number}}</div></div>");
$templateCache.put("app/main/contactcenter/party/consultants/consultants.html","<div id=\"consultants-room\"><md-toolbar class=\"navigation-header md-primary-bg\" layout=\"row\" \nlayout-align=\"start center\"><div layout=\"row\" layout-align=\"center center\"><div class=\"icon-container\"><img \nclass=\"ico\" src=\"assets/icons/icon-account-box1.png\"></div><span class=\"header-part\" \ntranslate=\"ROOM.CONSULTANTS.TITLE\">Konsultanci</span></div></md-toolbar><div flex layout=\"column\" class=\"content\">\n<md-content flex ms-scroll><div class=\"padding-frame\"><div class=\"consultants padding-frame\" flex=\"100\" layout=\"row\">\n<call-details ng-repeat=\"c in vm.consultants\" call=\"c\"></call-details></div></div></md-content></div></div>");
$templateCache.put("app/main/contactcenter/party/calls/calls.html","<div id=\"calls-room\" ng-class=\"vm.type\"><md-toolbar class=\"navigation-header md-primary-bg\" layout=\"row\" \nlayout-align=\"start center\"><div layout=\"row\" flex=\"100\" layout-align=\"space-between center\"><div class=\"title\" \nflex=\"25\" layout=\"row\"><div class=\"icon-container\"><img class=\"ico\" src=\"assets/icons/icon-account-box1.png\"></div><div\n class=\"header-part\">{{vm.titleHeader}}</div></div><div class=\"logout-container\" \nng-show=\"vm.isuserlogin && vm.type===\'consultants\'\" ng-click=\"vm.logOut()\"><img class=\"ico\" \nsrc=\"assets/icons/logout.png\"></div></div></md-toolbar><div flex layout=\"column\" class=\"content\"><md-content flex \nms-scroll><div class=\"padding-frame border-frame\"><div class=\"calls padding-frame\" flex=\"100\" layout=\"row\" \nlayout-align=\"start start\"><call-details ng-if=\"vm.type===\'consultants\' && !vm.isuserlogin\" loginfn=\"vm.loginfn\">\n</call-details><call-details ng-repeat=\"c in vm.calls\" call=\"c\" index=\"$index\" clients=\"vm.clients\" \nexternal-calls=\"vm.externalCalls\" msglist=\"vm.msgList\" hoverlist=\"vm.hoverList\" notif=\"vm.notif\" \nclose-notif=\"vm.closeNotif\"></call-details></div></div></md-content></div></div>");
$templateCache.put("app/main/contactcenter/party/roomlist/roomlist.html","<md-content flex layout=\"column\" id=\"users-list\" class=\"scrollable users-list\" ms-scroll><section \nstyle=\"width: 100%; height: 100%\"><md-subheader class=\"md-primary base-subheader\" style=\"padding: 30px 46px\"><div flex \nlayout=\"row\" layout-align=\"start center\"><div flex=\"10\" flex-gt-lg=\"5\"></div><div flex=\"30\" flex-gt-lg=\"20\" \ntranslate=\"ROOM.ROOM_NAME\">Nazwa pokoju</div><div flex=\"20\" flex-gt-lg=\"20\" translate=\"ROOM.PHONE_NO\">Numer telefonu\n</div><div flex translate=\"ROOM.DESCRIPTION\">Opis</div></div></md-subheader><md-list id=\"room-list\" class=\"base-list\" \nflex style=\"min-height: 100% !important\"><md-list-item ng-if=\"vm.consult? true : room.roleID!==3\" layout=\"row\" \nlayout-align=\"start center\" ng-click=\"vm.enterRoom(room);\" flex \nng-repeat=\"room in vm.roomsList | filter: vm.navBarConfig.search | filter: vm.filter\" aria-label=\"room\" \nng-class=\"{ \'selected\' : room.checked }\" style=\"padding: 0!important\"><div flex=\"10\" flex-gt-lg=\"5\"><avatar-letter \nclass=\"avatar-list avatar-list-letter\" name=\"room.name\"></avatar-letter></div><div flex=\"30\" flex-gt-lg=\"20\"><strong>\n{{::room.name}}</strong></div><div flex=\"20\" flex-gt-lg=\"20\"><p>{{::room.phoneNo}}</p></div><div flex layout=\"row\" \nlayout-align=\"start center\" style=\"line-height: 1.3333\">{{::room.description}}<div class=\"icon-container\"></div></div>\n</md-list-item></md-list></section></md-content>");
$templateCache.put("app/main/contactcenter/party/templates/clientinfo.html","<dialog-component id=\"client-info\" dialog-title=\"\'PARTY.CLIENTINFO.TITLE\'\" dialog-height=\"\'h-150\'\"><header flex=\"100\" \nlayout=\"column\" layout-align=\"space-between stretch\" layout-fill><div flex layout=\"row\" layout-align=\"start center\">\n<div flex-offset=\"20\" flex=\"30\"></div></div><div class=\"avatar-placeholder\" flex layout=\"row\" \nlayout-align=\"center center\"><div class=\"call-client h-120\"><svg version=\"1.1\" id=\"Capa_1\" \nxmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" \nviewBox=\"0 0 248.349 248.349\" style=\"enable-background:new 0 0 248.349 248.349\" xml:space=\"preserve\"><g><g><path \nstyle=\"fill:{{vm.currentCall.color}}\" \nd=\"M9.954,241.305h228.441c3.051,0,5.896-1.246,7.805-3.416c1.659-1.882,2.393-4.27,2.078-6.723\n			c-5.357-41.734-31.019-76.511-66.15-95.053c-14.849,14.849-35.348,24.046-57.953,24.046s-43.105-9.197-57.953-24.046\n			C31.09,154.65,5.423,189.432,0.071,231.166c-0.315,2.453,0.424,4.846,2.078,6.723C4.058,240.059,6.903,241.305,9.954,241.305z\"/>\n<path style=\"fill:{{vm.currentCall.color}}\" \nd=\"M72.699,127.09c1.333,1.398,2.725,2.73,4.166,4.019c12.586,11.259,29.137,18.166,47.309,18.166\n			s34.723-6.913,47.309-18.166c1.441-1.289,2.834-2.622,4.166-4.019c1.327-1.398,2.622-2.828,3.84-4.329\n			c9.861-12.211,15.8-27.717,15.8-44.6c0-39.216-31.906-71.116-71.116-71.116S53.059,38.95,53.059,78.16\n			c0,16.883,5.939,32.39,15.8,44.6C70.072,124.262,71.366,125.687,72.699,127.09z\"/>\n</g></g></svg></div></div><span ng-show=\"vm.currentCall.number\" flex=\"50\" class=\"m-5 h-20\" \nstyle=\"font-size: 20px;text-align:center;line-height:0px;color: rgba(255, 255, 255, 0.7)\"><span \ntranslate=\"PARTY.CLIENTINFO.NR\">Nr.</span> {{ vm.currentCall.number}}</span></header><content layout=\"column\" \nms-scroll class=\"content\"><div flex layout=\"row\" layout-align=\"center center\" class=\"padding border-bottom\"><div \nng-if=\"!vm.currentCall.isRecord\" class=\"label\" flex=\"80\" flex-offset=\"5\" translate=\"PARTY.CLIENTINFO.SEND_MSG\">\nWyślij wiadomość</div><div ng-if=\"vm.currentCall.isRecord\" class=\"label\" flex=\"80\" flex-offset=\"5\" \ntranslate=\"PARTY.CLIENTINFO.SEND_INPROGRESS\">Trwa nagranie...</div><div flex=\"20\"><div class=\"icon record\" \nng-click=\"vm.currentCall.sendMsg(vm.currentCall)\"></div></div></div><div flex layout=\"row\" \nlayout-align=\"center center\" class=\"padding\"><div class=\"label\" flex=\"80\" flex-offset=\"5\" \ntranslate=\"PARTY.CLIENTINFO.PLAY_NAME\">Odsłuchaj imię</div><div flex=\"20\"><div class=\"icon listening\" \nng-click=\"vm.currentCall.playName()\"></div></div></div></content></dialog-component>");
$templateCache.put("app/main/contactcenter/party/room/room.html","<div id=\"party-room\" class=\"page-layout carded layout-row\"><div class=\"top-bg\"><div class=\"header\" layout=\"row\" \nlayout-align=\"left left\"><span class=\"icon\"><img alt=\"Communicator\" src=\"assets/icons/communicator.png\"> </span><span \nclass=\"text\" translate=\"ROOM.ROUTE_NAME\">Pokój</span></div></div><div class=\"template-placeholder\" layout=\"column\"><div\n flex=\"75\" class=\"template-schema\"><calls-room calls=\"vm.consultants\" clients=\"vm.clients\" \ntitle-header=\"vm.titleConsultants\" type=\"\'consultants\'\" loginfn=\"vm.loginToRoom\" isuserlogin=\"vm.isUserLogin\" \nnotif=\"vm.notif\" close-notif=\"vm.closeNotif\" external-calls=\"vm.externalCalls\"></calls-room></div><div flex=\"25\" \nclass=\"template-schema\"><calls-room calls=\"vm.clients\" title-header=\"vm.titleClients\" type=\"\'clients\'\" \nnotif=\"vm.notif\"></calls-room></div></div></div><div class=\"message-box\" ng-if=\"vm.notif\" flex layout=\"column\" \nlayout-align=\"center center\"><div flex=\"90\" layout=\"row\" layout-align=\"center center\"><div class=\"icon\"><img \nng-src=\"{{\'assets/icons/\'+vm.notif.icon+\'.png\'}}\"></div><div class=\"text\">{{vm.notif.text}}</div></div><div flex=\"10\" \nclass=\"cancel\" ng-if=\"vm.notif.callback\"><div class=\"button\" ng-click=\"vm.notif.callback()\" translate=\"ROOM.CANCEL\">\nPrzerwij</div></div></div>");
$templateCache.put("app/main/contactcenter/reports/template/reportservice.html","<div class=\"sidenav-list\" style=\"overflow-x: hidden\"><div class=\"wrapperFilters\" layout=\"column\" \nlayout-align=\"start stretch\"><div flex class=\"reportSidenav mt-20\" layout=\"column\" layout-align=\"start stretch\">\n<md-input-container flex layout=\"row\"><md-button class=\"md-icon-button calendar-button\"><img \nsrc=\"assets/icons/data.png\"></md-button><md-select flex class=\"ml-10 mr-30\" ng-model=\"vm.sidenavData.finalDate.date\" \nng-change=\"vm.sidenavData.generateDate(vm.sidenavData.finalDate.date)\" placeholder=\"Wybierz daty\" \nng-disabled=\"form.fID.$viewValue.length > 0\" ng-class=\"{\'disabled\': form.fID.$viewValue.length > 0}\" name=\"chooseDate\">\n<md-option ng-repeat=\"d in vm.sidenavData.listDate\" ng-value=\"d.date\" ng-selected=\"$index == 0\" title=\"{{d.name}}\" \nalt=\"{{d.name}}\" style=\"margin-top: 0\">{{ d.name }}</md-option></md-select></md-input-container><md-input-container \nflex><label style=\"color: #ababab !important\">{{ \"REPORTS.FROM\" | translate }}</label><md-datepicker \nng-class=\"{errorInput: vm.sidenavData.dateFrom == undefined}\" ng-model=\"vm.sidenavData.dateFrom\" \nng-disabled=\"vm.sidenavData.disableDate\" required></md-datepicker></md-input-container><md-input-container flex><label \nstyle=\"color: #ababab !important\">{{ \"REPORTS.TO\" | translate }}</label><md-datepicker \nng-class=\"{errorInput: vm.sidenavData.dateTo == null}\" layout=\"row\" ng-model=\"vm.sidenavData.dateTo\" \nng-disabled=\"vm.sidenavData.disableDate\" required></md-datepicker></md-input-container></div><h3 flex \nclass=\"errorMessage\">{{ vm.sidenavData.errorMsg }}</h3><div class=\"wrapperFilters\" style=\"margin: 0 auto; width: 83%\">\n<md-input-container class=\"reportSidenav\" flex ng-if=\"vm.sidenavData.config.paramList\"><label>Grupowanie</label>\n<md-select ng-model=\"vm.sidenavData.paramID\" multiple=\"multiple\" flex><md-optgroup label=\"Parametry\" flex><md-option \nng-value=\"param.id\" ng-repeat=\"param in vm.sidenavData.paramList\">{{param.param}}</md-option><md-option value=\"perDay\" \nng-click=\"vm.sidenavData.showDays()\">Data</md-option></md-optgroup></md-select></md-input-container></div>\n<md-input-container flex layout=\"column\" ng-if=\"vm.sidenavData.config.type\" class=\"ph-20 no-margin\"><h3 \nstyle=\"color: #ababab !important\">{{ \"REPORTS.SMS.TYPE\" | translate }}</h3><md-radio-group \nng-model=\"vm.sidenavData.type\"><md-radio-button style=\"color: #ababab\">{{ \"REPORTS.ALL\" | translate }}\n</md-radio-button><md-radio-button value=\"S\" style=\"color: #ababab\">SMS</md-radio-button><md-radio-button value=\"M\" \nstyle=\"color: #ababab\">MMS</md-radio-button><md-radio-button value=\"C\" style=\"color: #ababab\">CHAT</md-radio-button>\n</md-radio-group></md-input-container><md-input-container flex layout=\"column\" ng-if=\"vm.sidenavData.config.direction\" \nclass=\"ph-20 no-margin\"><h3 style=\"color: #ababab !important\">{{ \"REPORTS.SMS.DIRECTION\" | translate }}</h3>\n<md-radio-group ng-model=\"vm.sidenavData.direction\"><md-radio-button style=\"color: #ababab\">\n{{ \"REPORTS.ALL\" | translate }}</md-radio-button><md-radio-button value=\"I\" style=\"color: #ababab\">Inbound\n</md-radio-button><md-radio-button value=\"O\" style=\"color: #ababab\">Outbound</md-radio-button></md-radio-group>\n</md-input-container><div layout=\"column\" layout-align=\"start stretch\" class=\"mh-35\"><md-input-container flex \nng-if=\"vm.SessionManager.getUserRoleId() == vm.authRolesConst.admin\" ng-show=\"vm.sidenavData.config.callcenter\"><label \nstyle=\"color: #ababab !important\">Call Center</label><md-select flex=\"100\" ng-model=\"vm.sidenavData.id\" \nng-change=\"vm.sidenavData.getCallcenterPerManager()\"><md-option ng-value=\"\"><em>{{ \"REPORTS.ALL\" | translate }}</em>\n</md-option><md-option ng-repeat=\"state in vm.sidenavData.callCenterList\" ng-value=\"state.id\">\n{{ state.callCenterName }}</md-option></md-select></md-input-container><p flex ng-if=\"vm.sidenavData.ccidError\" \nclass=\"errorMessage\">{{vm.sidenavData.ccidError}}</p><md-input-container flex ms-scroll \nng-if=\"vm.SessionManager.getUserRoleId() !== vm.authRolesConst.consultant && vm.sidenavData.config.consultantList\">\n<label style=\"color: #ababab !important\">{{ \"REPORTS.CONSULTANT\" | translate }}</label><md-select \nng-model=\"vm.sidenavData.userID\" ng-change=\"vm.sidenavData.generateConsultantPerContactCenter()\"><md-option \nng-value=\"null\"><em>{{ \"REPORTS.ALL\" | translate }}</em></md-option><md-option \nng-repeat=\"state in vm.sidenavData.consultantsPerCC\" ng-value=\"state.userID\">{{ state.firstName }} {{ state.lastName }}\n</md-option></md-select></md-input-container><md-autocomplete md-selected-item=\"vm.sidenavData.userID\" \nmd-search-text=\"vm.searchText\" md-items=\"tag in vm.tagSearch(vm.searchText)\" \nplaceholder=\"{{ \'REPORTS.CONSULTANT\' | translate }}\" md-autoselect=\"true\"><md-item-template>\n{{ state.firstName }} {{ state.lastName }}{{ consultant.alias ? \'/\'+ consultant.alias :\'\'}}</md-item-template>\n<md-not-found>Nie znaleziono :(</md-not-found></md-autocomplete><md-autocomplete \nng-disabled=\"vm.sidenavData.consultantsPerCC\" md-no-cache=\"ctrl.noCache\" md-selected-item=\"ctrl.selectedItem\" \nmd-search-text=\"ctrl.searchText\" md-selected-item-change=\"ctrl.selectedItemChange(item)\" \nmd-items=\"item in ctrl.querySearch(ctrl.searchText)\" md-item-text=\"item.display\" md-min-length=\"0\" \nplaceholder=\"What is your favorite US state?\"><md-item-template><span md-highlight-text=\"ctrl.searchText\" \nmd-highlight-flags=\"^i\">{{item.display}}</span></md-item-template></md-autocomplete></div><div flex \nclass=\"showOrHideChart\" ng-if=\"vm.sidenavData.config.showChart\"><md-input-container layout=\"column\"><md-switch \nng-model=\"vm.sidenavData.showMyChart\" ng-click=\"vm.sidenavData.showChart()\"><span style=\"color:#ababab\">Ukryj wykres\n</span></md-switch></md-input-container></div><md-button class=\"buttonFilter\" \nng-click=\"vm.sidenavData.getConnectData()\">{{ \"REPORTS.FILTERS\" | translate }}<md-tooltip md-direction=\"bottom\">\nFiltruj raporty</md-tooltip></md-button></div></div>");
$templateCache.put("app/main/services/confirmDialog/templates/confirmDefault.html","<md-dialog aria-label=\"%translate\" class=\"remove\"><md-toolbar class=\"remove__msg\"><div class=\"md-toolbar-tools\">\n<md-icon md-font-icon=\"icon-alert-circle\"></md-icon><h2 class=\"w-500\">%title</h2></div></md-toolbar><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\" class=\"remove__buttons\"><md-button ng-click=\"cancel()\" \nclass=\"remove__buttons__no\" translate=\"%translate.NO\">%translate</md-button><md-button ng-click=\"answer()\" \nclass=\"remove__buttons__yes\" translate=\"%translate.YES\">%translate</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/services/confirmDialog/templates/confirmdelete.html","<md-dialog aria-label=\"Utwórz tag\" class=\"remove\"><md-toolbar class=\"remove__msg\"><div class=\"md-toolbar-tools\">\n<md-icon md-font-icon=\"icon-alert-circle\"></md-icon><h2>{{titleText}}</h2></div></md-toolbar><md-dialog-actions \nlayout=\"row\" class=\"remove__buttons\"><md-button ng-click=\"cancel()\" class=\"remove__buttons__no\" \ntranslate=\"CONFIR_DIALOG.NO\">Nie</md-button><md-button ng-click=\"answer()\" class=\"remove__buttons__yes\" \ntranslate=\"CONFIR_DIALOG.YES\">Tak, usuń</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/services/confirmDialog/templates/confirmfileupload.html","<md-dialog aria-label=\"Utwórz tag\" class=\"remove\"><md-dialog-content><md-toolbar class=\"remove__msg h-200\" \nlayout=\"column\" layout-align=\"start stretch\"><div layout=\"column\" class=\"md-toolbar-tools\"><md-icon \nmd-font-icon=\"icon-alert-circle\"></md-icon><h2>{{titleText}}</h2><ta-tags flex ng-disabled=\"true\" \ncustom-class=\"big white\" ng-model=\"params.tagsPicker\" source-endpoint=\"params.sourceEndpoint\" \ncontent-id=\"params.contentId\" label=\"Tagi dla kontentu\"></ta-tags></div></md-toolbar></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"remove__buttons\"><md-button flex ng-click=\"cancel()\" \nclass=\"remove__buttons__no\" translate=\"CONFIR_UPLOAD_DIALOG.NO\">Nie</md-button><md-button flex \nng-click=\"answer(params.tagsPicker)\" class=\"remove__buttons__yes\" translate=\"CONFIR_UPLOAD_DIALOG.YES\">Tak, Przeslij\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\">\n{{step.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div>\n</md-button></div></div><div class=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/main/contactcenter/callsonline/components/callrow/callrow.html","<div ng-if=\"vm.dataReady\" layout=\"row\" layout-align=\"space-between center\" \nng-class=\"{nieudanePolaczenie: vm.rowInfo.status === vm.wsstatus.failed, selected: vm.rowInfo.selected === true }\" \nng-click=\"vm.displayOnSidenav(vm.rowInfo, vm.isCall)\" class=\"callsonline\"><div flex=\"10\" flex-gt-lg=\"10\" \nclass=\"col callsonline__col\"><p flex class=\"col-from-status\" style=\"margin:0; width:15px\"><span class=\"col-statusIcon\" \nng-if=\"vm.isCall\"><img ng-if=\"!vm.call.callback && !vm.call.party\" src=\"assets/icons/monitoring/out.svg\" alt=\"in\"> <img\n ng-if=\"vm.call.callback && !vm.call.party\" src=\"assets/icons/monitoring/in.svg\" alt=\"out\"> <img ng-if=\"vm.call.party\" \nsrc=\"assets/icons/monitoring/party.svg\" alt=\"pary-line\"></span></p></div><div flex=\"30\" class=\"col col-from\"><div><div \nclass=\"col-from-info\" ng-if=\"vm.isCall\"><p class=\"firstRow\">{{ vm.rowInfo.callId }}</p></div><div \nclass=\"col-from-info\" ng-if=\"!vm.isCall\"><p class=\"nextRow\">{{ vm.rowInfo.callId }}</p></div></div></div><div \nflex=\"15\" flex-gt-lg=\"25\"><div layout=\"column\"><p ng-if=\"vm.call && vm.isCall\" class=\"firstRow\">\n{{ vm.rowInfo.target }} / {{ vm.rowInfo.targetId }}</p><p ng-if=\"vm.call && !vm.isCall\" class=\"nextRow\">\n{{ vm.rowInfo.target }} / {{ vm.rowInfo.targetId }}</p></div></div><div flex=\"10\" class=\"col\" \nlayout-align=\"start center\"><div ng-if=\"vm.isCall\"><p class=\"firstRow\">{{ vm.beginDate }} / <span \nng-if=\"!vm.call.callback && vm.call.callDuration\">{{vm.call.callDuration}}</span><timer class=\"small-timer\" \nng-if=\"!vm.call.callback && !vm.call.callDuration\" flex start-time=\"vm.call.startCall\" interval=\"1000\">\n{{mminutes}}:{{sseconds}}</timer></p></div><div ng-if=\"!vm.isCall\"><p class=\"nextRow\">\n{{ vm.call.start | date:\"dd/MM/yyyy\" }} / <span \nng-if=\"vm.rowInfo.status=== vm.wsstatus.disconnected || vm.rowInfo.status=== vm.wsstatus.disconnected_cons\">\n{{vm.call.bridgeDuration}}</span><timer \nng-if=\"(vm.rowInfo.status===vm.wsstatus.ringing || vm.rowInfo.status===vm.wsstatus.wait4drop ||vm.rowInfo.status===vm.wsstatus.answered)\" \nflex start-time=\"vm.momentStartTimer\" interval=\"1000\">{{mminutes}}:{{sseconds}}</timer></p></div></div><div flex=\"10\" \nclass=\"col\" ng-if=\"vm.isCall\"><md-button disabled=\"true\" class=\"col-inBox col-button\" \nng-if=\"vm.call.party && vm.call.currentStatus ===vm.wsstatus.waiting\" style=\"width: 50px\"><img \nng-src=\"assets/icons/monitoring/status/{{vm.call.currentStatus }}.svg\" class=\"callStats party\"></md-button></div><div \nflex=\"10\" class=\"col\" ng-if=\"!vm.isCall\"><img \nng-if=\"!((vm.rowInfo.status===vm.wsstatus.waiting && !vm.call.party) || vm.rowInfo.status===vm.wsstatus.disconnected || vm.rowInfo.status===vm.wsstatus.disconnected_cons )\" \nclass=\"callStats\" ng-src=\"assets/icons/monitoring/status/{{ vm.rowInfo.status }}.svg\" alt=\"{{ vm.rowInfo.status }}\"> \n<img ng-if=\"vm.rowInfo.status===vm.wsstatus.disconnected || vm.rowInfo.status===vm.wsstatus.disconnected_cons\" \nclass=\"callStats\" ng-src=\"assets/icons/monitoring/status/{{ vm.rowInfo.status }}.png\" alt=\"\"> <img \nng-if=\"vm.rowInfo.status===vm.wsstatus.waiting && !vm.call.party\" class=\"callStats\" \nng-src=\"assets/icons/monitoring/status/QUEUED.svg\" alt=\"QUEUED\"><div class=\"buttonOptions\" \nstyle=\"display: inline-block\"><img \nng-if=\"!vm.isHistory && vm.rowInfo.status == vm.wsstatus.wait4drop || vm.rowInfo.status=== vm.wsstatus.disconnected || vm.rowInfo.status=== vm.wsstatus.disconnected_cons || vm.rowInfo.status == vm.wsstatus.failed\" \nclass=\"buttonOptions__circle\" src=\"assets/icons/monitoring/circle.png\"><md-button ng-disabled=\"vm.call.disabledButton\" \nclass=\"col-inBox col-button\" ng-if=\"!vm.isHistory && vm.rowInfo.status == vm.wsstatus.wait4drop\" \nng-click=\"vm.playEvasdropping();\"><img ng-if=\"vm.call.waitingForEavesdropping\" \nsrc=\"assets/icons/monitoring/gifczekanie.gif\"> <img ng-if=\"vm.call.isPlaying && !vm.call.waitingForEavesdropping\" \nng-src=\"assets/icons/monitoring/{{vm.rowInfo.status | eavesdropping}}\"> <img \nng-if=\"!vm.call.isPlaying && !vm.call.waitingForEavesdropping\" \nng-src=\"assets/icons/monitoring/{{vm.rowInfo.status | eavesdroppicon}}\"></md-button><md-button \nng-disabled=\"vm.call.disabledButton\" class=\"col-inBox col-button\" \nng-if=\"vm.rowInfo.status=== vm.wsstatus.disconnected || vm.rowInfo.status=== vm.wsstatus.disconnected_cons\" \nng-click=\"vm.playBridge();\"><img ng-if=\"!vm.call.isPlaying\" ng-src=\"assets/icons/monitoring/play.svg\"> <img \nng-if=\"vm.call.isPlaying\" ng-src=\"assets/icons/monitoring/pause.svg\"></md-button><md-button \nng-disabled=\"vm.call.disabledButton\" class=\"col-inBox col-button\" ng-if=\"vm.rowInfo.status == vm.wsstatus.failed\" \nng-click=\"vm.clearFailedCall();\"><img ng-src=\"assets/icons/monitoring/{{vm.rowInfo.status | eavesdroppicon}}\">\n</md-button></div></div></div>");
$templateCache.put("app/main/contactcenter/components/tamultiselect/tafilters/tafilters.html","<div id=\"tags-container-{{$id}}\" layout=\"column\" layout-align=\"start stretch\"><md-chips flex \nclass=\"{{vm.customClass ? vm.customClass: \'black small\'}}\" ng-cloak ng-model=\"vm.ngModel\" readonly=\"true\" \nmd-removable=\"true\" name=\"tags\" md-on-remove=\"vm.onRemove()\"><md-chip-template><md-icon md-font-icon=\"{{$chip.icon}}\" \naria-label=\"label\" class=\"s\"></md-icon><span>{{$chip.filterString}}</span></md-chip-template></md-chips></div>");
$templateCache.put("app/main/contactcenter/components/tamultiselect/tatags/tatags.html","<div id=\"tags-container-{{$id}}\" layout=\"column\" layout-align=\"start stretch\"><div flex layout=\"row\"><div flex>\n<md-chips id=\"mdChipsTag-{{$id}}\" class=\"{{vm.customClass ? vm.customClass: \'black small\'}}\" ng-cloak \nng-keyup=\"$event.keyCode == 13 ? $event.stopPropagation() : null\" ng-model=\"vm.output\" readonly=\"vm.ngDisabled\" \nmd-on-add=\"vm.updateModel();\" md-transform-chip=\"vm.addTag($chip)\" md-on-remove=\"vm.updateModel();\" name=\"tags\" \nmd-on-select=\"vm.selectDamn($chip)\" md-require-match=\"!vm.writeMode\" ng-class=\"{\'with-button\': vm.showButton}\">\n<md-autocomplete md-selected-item=\"vm.chips\" md-search-text=\"vm.searchText\" \nmd-menu-container-class=\"{{vm.customClass ? vm.customClass: \'black small\'}}\" \nclass=\"{{vm.customClass ? vm.customClass: \'black small\'}}\" md-items=\"tag in vm.tagSearch(vm.searchText)\" \nplaceholder=\"{{vm.token | translate}}\" md-autoselect=\"true\"><md-item-template><span ng-if=\"tag.token\" \nmd-highlight-text=\"vm.searchText\">{{tag.token | translate}}</span> <span ng-if=\"!tag.token\" \nmd-highlight-text=\"vm.searchText\">{{tag.tagId}}</span></md-item-template></md-autocomplete><md-chip-template \nid=\"tag-{{::$chip.tagId}}-{{::vm.id}}\" ng-click=\"!vm.writeMode ? vm.selectDamn($chip) : $event.stopPropagation() \" \nng-class=\"{\'specjal\': $chip.special, \'not-selected\': !$chip.selected }\"><span ng-if=\"$chip.token\">\n#{{$chip.token |translate}}</span> <span ng-if=\"!$chip.token && !$chip.special\">#{{$chip.tagId}}</span> <span \nng-if=\"$chip.special\">{{$chip.special}}</span></md-chip-template></md-chips></div><div ng-if=\"vm.showButton\" \nclass=\"button-placeholder\" ng-class=\"vm.customClass ? vm.customClass: \'black small\'\" layout=\"column\" \nlayout-align=\"end center\"><md-select id=\"mdSelect-{{$id}}\" ng-model=\"vm.output\" \nng-model-options=\"{trackBy: \'$value.tagId\' }\" ng-change=\"vm.changeTags()\" multiple=\"multiple\"><md-optgroup \nclass=\"footer-tags\"><md-option ng-value=\"tag\" ng-repeat=\"tag in vm.source2\"><span ng-if=\"tag.token\">\n{{tag.token | translate}}</span> <span ng-if=\"!tag.token\">{{tag.tag}}</span></md-option></md-optgroup></md-select>\n</div></div></div>");
$templateCache.put("app/main/contactcenter/dashboard/component/connectionstatistic/connectionstatistic.html","<div id=\"connection-statistic\" class=\"widget\" layout=\"column\"><div layout=\"column\"><div \nng-if=\"vm.mode===vm.connectionStatisticCons.count\" class=\"h3 secondary-text pb-8\" \nstyle=\"padding: 25px; padding-bottom: 0\">{{ \"STATISTICS.COUNT\" | translate }}</div><div \nng-if=\"vm.mode===vm.connectionStatisticCons.average\" class=\"h3 secondary-text pb-8\" \nstyle=\"padding: 25px; padding-bottom: 0\">{{ \"STATISTICS.AVERAGE\" | translate }}</div><div \nng-if=\"vm.mode===vm.connectionStatisticCons.seconds\" class=\"h3 secondary-text pb-8\" \nstyle=\"padding: 25px; padding-bottom: 0\">{{ \"STATISTICS.MINUTES\" | translate }}</div><div \nclass=\"font-size-32 line-height-32 pb-16\" style=\"padding: 0 25px\">{{ vm.LastDayValue }}</div><div><nvd3 \nclass=\"remove-x-lines\" config=\"vm.mainChart.config\" options=\"vm.mainChart.options\" data=\"vm.chartData\"></nvd3></div>\n</div></div>");
$templateCache.put("app/main/contactcenter/dashboard/component/forwardsession/forwardsession.html","<dialog-component id=\"forward-session\" dialog-title=\"\'MONITORING.FORWARD_DIALOG.TITLE\'\"><content layout=\"column\" \nlayout-align=\"start stretch\" class=\"content\"><div class=\"container\"><div layout=\"column\" \nstyle=\"max-height: 50vh; height: 100%\"><div flex=\"5\" class=\"input-bar\" layout=\"row\" layout-fill \nlayout-align=\"space-between start\"><p></p><md-input-container md-no-float><input placeholder=\"Search for anyone\" \ntype=\"text\" ng-model=\"vm.search\" translate translate-attr-placeholder=\"TAHEADER.SEARCH\"></md-input-container></div><div\n flex ms-scroll layout-fill class=\"consultants-container scrollable scrollable-list\"><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"table-header ph-10\"><div flex=\"90\" layout=\"row\" layout-align=\"start center\">\n<p class=\"text\" flex=\"30\">{{\"MONITORING.FORWARD_DIALOG.CONSULTANT\" | translate}}</p><p class=\"text\" flex=\"10\">Poziom\n</p><p class=\"text\" flex=\"30\">Serwis</p><p class=\"text\" flex=\"10\">Sesje</p><p class=\"text\" flex=\"20\">Ost. zm. statusu\n</p></div><p class=\"text\" flex=\"10\"></p></div><div ng-if=\"vm.loadConsultants\" flex layout=\"row\" \nlayout-align=\"center center\" class=\"consultant consultant-item\"><md-progress-circular></md-progress-circular></div><div\n ng-if=\"!vm.consultantsList || (vm.consultantList && vm.consultantsList.length===0)\">Brak konsultantów</div><div \nng-if=\"vm.consultantsList && vm.consultantsList.length>0\" flex layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"consultant in vm.consultantsList | filter: vm.search\" class=\"consultant consultant-item\" \nng-class=\"vm.selectedConsultant && vm.selectedConsultant.consultantID == consultant.consultantID ? \'selected\':\'\'\"><div \nflex=\"90\" layout=\"row\" layout-align=\"start center\"><div flex=\"30\" class=\"row\" layout=\"row\" style=\"align-items: center\">\n<div layout=\"column\" layout-align=\"center center\" class=\"avatar-place\" style=\"width:42px;align-items:flex-start\"><div \nclass=\"column avatar-list\"><div class=\"image\"><img ng-if=\"consultant.avatar\" alt=\"{{ consultant.name }}\" \nng-src=\"{{ consultant.avatar }}\"><div ng-if=\"!consultant.avatar\" class=\"noAwatar\" layout=\"column\" \nlayout-align=\"center center\"><md-icon flex md-svg-src=\"/assets/navigation/avatar.svg\" aria-label=\"avatar\"></md-icon>\n</div></div><div class=\"avatar-status-container\"><img flex \nng-src=\"/assets/icons/dashboard/consultant_status/circular-shape-{{consultant.status}}.svg\" aria-label=\"avatar\"></div>\n</div></div><div style=\"width:42px\">{{ consultant.id }}</div><div>{{ consultant.name }}</div></div><div flex=\"10\">\n<md-icon ng-if=\"consultant.priority1<200&&consultant.priority2<200\" md-font-icon=\"icon-numeric-1-box-multiple-outline\" \nclass=\"level-marker\" style=\"color: #2AB982\"></md-icon><md-icon \nng-if=\"(consultant.priority1>=200||consultant.priority2>=200)\" md-font-icon=\"icon-numeric-2-box-multiple-outline\" \nclass=\"level-marker\" style=\"color: #5F5F5F\"></md-icon></div><div flex=\"30\" class=\"row\" layout=\"row\" \nstyle=\"align-items: center\"><div class=\"column avatar-list\" layout-align=\"start center\" \nstyle=\"width:42px;align-items:flex-start\"><div class=\"image\"><img ng-src=\"{{ consultant.service.photoUrl }}\"></div>\n</div><div class=\"column other\">{{ consultant.service.name }}</div></div><div flex=\"10\"><div \nstyle=\"background-color: #CD5C5C;border-radius: 50%;width: 30px;height: 30px;max-width: 30px;max-height: 30px;text-align: center;line-height: 30px;color: #efefef\">\n{{ consultant.sessions.length }}</div></div><div ng-if=\"consultant.lastStatusUpdate\" flex=\"20\" \nstyle=\"line-height: 30px\">{{ consultant.lastStatusUpdate | date:\'yyyy-MM-dd HH:mm:ss\' }}</div></div><div flex=\"10\" \nlayout=\"row\" class=\"icon-place\" layout-align=\"end center\"><md-icon class=\"check\" \nmd-svg-src=\"/assets/icons/forward-session2.svg?v=1.0.2\" ng-click=\"vm.consultantClick(consultant)\" \nng-class=\"{\'green\':( vm.selectedConsultant && vm.selectedConsultant.consultantID == consultant.consultantID)}\">\n</md-icon></div></div></div></div></div></content></dialog-component>");
$templateCache.put("app/main/contactcenter/dashboard/component/consultantsPreview/consultantsPreview.html","<div id=\"consultantsPreview\" flex class=\"easy-content\" layout=\"column\" layout-align=\"center center\"><div flex \nlayout=\"row\" layout-align=\"space-between center\" style=\"width:100%;height: 148px;max-height: 148px; padding:16px\"><div \nflex layout=\"row\" ng-repeat=\"service in vm.msmGlue.consultantsOcupation.services\" \nstyle=\"flex:1; height: 100%; background-color: #f6f6f6;border-radius: 5px; padding: 10px;max-width: 292px\" \nng-style=\"{\'border\': \'2px solid rgb({{service.color}})\'}\"><div><div class=\"column avatar-list\" \nlayout-align=\"start center\" style=\"width:42px; height: 42px;align-items:flex-start\"><div class=\"image\" \nstyle=\"margin-right: 10px\"><img ng-src=\"{{ service.photoUrl }}\"></div></div><div \nstyle=\"font-size:16px;width:24px;height: 24px;text-align: center;padding-top: 0px;margin: 3px 0; background-color: lightgrey;border-radius: 50px;border: 2px solid #4aa356\">\n{{service.activeConsultants}}</div><div \nstyle=\"font-size:14px;width:24px;height: 24px;text-align: center;padding-top: 1px;margin: 3px 0; background-color: lightgrey;border-radius: 50px;border: 2px solid #ffcc00\">\n{{service.consultantsOnBreak}}</div></div><div flex layout=\"column\"><div flex layout=\"row\"><div><div \nstyle=\"font-size: larger;color:#666666\">{{service.id}}</div><div \nstyle=\"font-size: larger;font-weight: bold;color:#666666\">{{service.name}}</div></div></div><div class=\"column other\" \nflex layout=\"row\" style=\"align-self: center;width:160px;max-height: 20px; margin-bottom: 2px\"><div class=\"other\" \nflex=\"15\" \nstyle=\"font-size:15px;text-align: center;background-color: #c6c6c6;margin-right: 2px;border-radius: 4px;border: 1px solid #00db00\" \nng-style=\"(service.sessionsOnActiveCount>(service.activeConsultants*service.sessionsPerConsultant))&&{\'background-color\':\'#CD5C5C\', \'color\':\'white\'}\">\n{{ service.sessionsOnActiveCount }}</div><div class=\"other\" flex=\"70\" \nstyle=\"background-color:#2ab982;height:20px;padding:2px;border-radius:5px\"><div \nng-if=\"(service.activeConsultants*service.sessionsPerConsultant) > 0\" \nstyle=\"background-color:indianred;height: 16px;border-radius:4px\" \nng-style=\"{\'width\':\'{{(service.sessionsOnActiveCount<(service.activeConsultants*service.sessionsPerConsultant))?service.sessionsOnActiveCount/(service.activeConsultants*service.sessionsPerConsultant)*100:100}}%\'}\">\n</div></div><div class=\"other\" flex=\"15\" \nstyle=\"font-size:15px;text-align: center;background-color: #c6c6c6;margin-left: 2px;border-radius: 4px;border: 1px solid #db2c00\">\n{{ service.activeConsultants*service.sessionsPerConsultant }}</div></div><div class=\"column other\" flex layout=\"row\" \nstyle=\"align-self: center;width:160px;max-height: 20px; margin-top: 2px\" \nng-style=\"((service.consultantsOnBreak*service.sessionsPerConsultant) <= 0)&&{\'opacity\': \'0.2\'}\"><div class=\"other\" \nflex=\"15\" \nstyle=\"font-size:14px;text-align: center;background-color: #c6c6c6;margin-right: 2px;border-radius: 4px;border: 1px solid #00db00\">\n{{ service.sessionsOnBreakCount }}</div><div class=\"other\" flex=\"70\" \nstyle=\"background-color:#ffcc00;height:20px;padding:2px;border-radius:5px\"><div \nng-if=\"(service.consultantsOnBreak*service.sessionsPerConsultant) > 0\" \nstyle=\"background-color:indianred;height: 16px;border-radius:4px\" \nng-style=\"{\'width\':\'{{service.sessionsOnBreakCount/(service.consultantsOnBreak*service.sessionsPerConsultant)*100}}%\'}\">\n</div></div><div class=\"other\" flex=\"15\" \nstyle=\"font-size:14px;text-align: center;background-color: #c6c6c6;margin-left: 2px;border-radius: 4px;border: 1px solid #db2c00\">\n{{ service.consultantsOnBreak*service.sessionsPerConsultant }}</div></div></div><div flex layout=\"column\" \nstyle=\"max-width: 66px\" ng-style=\"!vm.msmGlue.waitingPerService[service.id]&&{\'opacity\':\'.4\'}\"><div flex=\"40\" \nlayout=\"column\" layout-align=\"start center\"><md-icon md-svg-src=\"assets/icons/waiting.svg\" \nstyle=\"width:48px;height:48px\" alt=\"Przekieruj sesje\" title=\"Przekieruj sesje\"></md-icon></div><div flex=\"60\" \nlayout=\"column\" layout-align=\"center center\"><div \nstyle=\"font-size:20px;width:32px;height: 32px;text-align: center;padding-top: 0px;margin: 3px 0; background-color: lightgrey;border-radius: 50px;border: 2px solid #CD5C5C\" \nng-style=\"!vm.msmGlue.waitingPerService[service.id]&&{\'border\': \'2px solid #2ab982\'}\">\n{{vm.msmGlue.waitingPerService[service.id].length||0}}</div></div></div></div></div><div class=\"filters header\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title-text\" translate=\"STATISTICS.TITLE\">\nPodgląd aktywności konsultantów</span><div layout=\"row\" layout-align=\"center center\"><div layout-align=\"center center\" \nlayout=\"row\" class=\"filter-button all-filter\" ng-click=\"vm.toggleService(-1);\" \nng-class=\"{\'active\':vm.selectedService === -1}\"><span class=\"filter-badge all-badge\" style=\"font-size: 16px\">\n{{ vm.msmGlue.consultantsOcupation.totalConsultants }}</span><div class=\"filter-label\">Wszystkie</div></div><div \nng-repeat=\"service in vm.msmGlue.consultantsOcupation.services\" layout-align=\"center center\" layout=\"row\" \nclass=\"filter-button all-filter\" ng-click=\"vm.toggleService(service.id);\" \nng-class=\"{\'active\':vm.selectedService === service.id }\"><span class=\"filter-badge\" style=\"font-size: 16px\" \nng-style=\"{\'border\': \'2px solid rgb({{service.color}})\'}\">{{ service.activeConsultants + service.consultantsOnBreak }}\n</span><div class=\"filter-label\">{{service.name}}</div></div></div></div><md-list flex \nclass=\"consultant-list-content pt-0\" style=\"max-height: 40px;overflow: hidden\"><md-list-item class=\"h-40\"><div \nflex=\"100\" layout=\"row\" layout-align=\"flex-start center\" style=\"align-items: center\"><div \nstyle=\"width:25px;height:48px\"></div><div flex=\"25\"><div flex layout=\"row\" style=\"width: 100%;align-items: center\"><div\n style=\"margin-right: 10px\">Konsultant</div><md-switch style=\"margin:0 !important\" ng-model=\"vm.showOnBreak\" \nng-change=\"vm.onShowOnBreak()\"></md-switch></div></div><div flex=\"5\">Proj.</div><div flex=\"10\">Zamk.</div><div \nflex=\"15\">Ost.zmiana statusu</div><div flex=\"10\">Sloty</div><div flex=\"5\"></div><div flex=\"15\">Statusy</div><div \nstyle=\"width: 10px\"></div><div flex=\"10\">Akcje</div></div></md-list-item></md-list><md-list ms-scroll flex \nclass=\"consultant-list-content pt-0\"><md-divider></md-divider><div \nng-repeat=\"consultant in vm.msmGlue.filteredConsultants\" \nng-style=\"((($index>0)&&(vm.msmGlue.filteredConsultants[$index - 1].service.id!==consultant.service.id))&&{\'border-top\':\'6px solid white\'})||(((consultant.priority1>=200||consultant.priority2>=200)&&(vm.msmGlue.filteredConsultants[$index - 1].priority1<200&&vm.msmGlue.filteredConsultants[$index - 1].priority2<200 ))&&{\'border-top\':\'1px solid white\'})\">\n<consultant-ocupation consultant=\"consultant\" \nprev-service-id=\"vm.msmGlue.consultantsOcupation.consultantEnities[$index - 1].service.id\" \ncall-status=\"consultant.callStatus\" on-eavesdropping=\"(vm.startEavesdropping)\" send-help=\"vm.sendHelp\" \nneed-help=\"vm.needHelp\" help=\"vm.help\" ng-click=\"vm.changeSelectedConsultant2(consultant)\" \nselected=\"vm.currentConsultant.id===consultant.id && vm.currentConsultant.service.id===consultant.service.id\"></div>\n</md-list><div ng-if=\"vm.msmGlue.currentConsultant\" layout=\"row\" layout-align=\"center cetner\" \nclass=\"consultant-card-cont\" style=\"height: 184px;min-height: 184px;max-height: 184px\"><consultant-general-info \nflex=\"30\" personal-account=\"false\" no-title=\"true\" editing-forbidden=\"true\" \ncurr-consultant=\"vm.msmGlue.currentConsultant\"></consultant-general-info><div flex=\"70\" \nstyle=\"height: 100%;background-color: #F2F2F2\"><md-list flex ms-scroll class=\"consultant-list-content pt-0\">\n<md-list-item class=\"h-40\"><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"sessions-header md-list-item-text\"><div class=\"text\" flex=\"5\" ng-click=\"vm.sortBy(\'id\')\">ID</div><div \nclass=\"text\" flex=\"10\">Kontakt</div><div class=\"text\" flex=\"30\">Status</div><div class=\"text\" flex=\"20\">Początek</div>\n<div class=\"text\" flex=\"20\">Ostatnia aktywność</div></div></md-list-item><md-divider></md-divider><md-list-item \nng-repeat=\"session in vm.msmGlue.currentConsultant.sessions \" class=\"consultantList md-no-proxy\" \nlayout-align=\"space-between center\" flex aria-label=\"consultant\" \nstyle=\"padding: 0 15px !important;background-color: #FCFCFC;opacity: 1\"><div class=\"row\" flex=\"100\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"text\" flex=\"5\">{{session.id}}</div><div class=\"text\" flex=\"10\">\n{{session.contactName}}</div><div class=\"text\" flex=\"30\"><md-icon ng-if=\"session.statusID===3\" style=\"color:#21b4c7\" \nmd-font-icon=\"icon-account-box-outline\"></md-icon><md-icon ng-if=\"session.statusID===4\" style=\"color:#CD5C5C\" \nmd-font-icon=\"icon-comment-alert-outline\"></md-icon><md-icon ng-if=\"session.statusID===5\" style=\"color:#2AB982\" \nmd-font-icon=\"icon-clock\"></md-icon><span ng-if=\"session.statusID===3\" style=\"color:#000000\">Przydzielono konsultanta\n</span> <span ng-if=\"session.statusID===4\" style=\"color:#000000\">Wymagana odpowiedź</span> <span \nng-if=\"session.statusID===5\" style=\"color:#000000\">Oczekiwanie na wiadomość</span></div><div class=\"text\" flex=\"20\">\n{{session.started | date:\'yyyy-MM-dd HH:mm:ss\'}}</div><div class=\"text\" flex=\"20\">\n{{session.updated | date:\'yyyy-MM-dd HH:mm:ss\'}}</div></div></md-list-item></md-list></div></div></div>");
$templateCache.put("app/main/contactcenter/dashboard/component/statusaxis/statusaxis.html","<div class=\"statusAxis widget\" ng-if=\"vm.stats\"><div layout=\"column\" flex><div layout=\"row\" \nlayout-align=\"space-between center\"><div><div class=\"h3 secondary-text pb-8\" \nstyle=\"padding: 25px; padding-bottom: 0;color:#4CAF50\">Czas aktywności</div><div \nclass=\"font-size-32 line-height-32 pb-16\" style=\"padding: 0 25px\">{{ vm.activeTimeFormat }}</div></div><div><div \nclass=\"h3 secondary-text pb-8\" style=\"padding: 25px; padding-bottom: 0;color: #FFC107\">Na przerwie</div><div \nclass=\"font-size-32 line-height-32 pb-16\" style=\"padding: 0 25px\">{{ vm.breakTimeFormat }} min.</div></div></div><div \nstyle=\"padding: 25px\"><div class=\"axis\"><div title=\"{{s.statusName}} - {{s.differenceTime}}\" \nalt=\"{{s.statusName}} - {{s.differenceTime}}\" class=\"status status-{{s.status}}\" \nstyle=\"min-width: {{s.difference?(s.difference/vm.timeFromLogin)*100:0}}%;width: {{s.difference?(s.difference/vm.timeFromLogin)*100:0}}%\" \nng-repeat=\"s in vm.statusStatistic\"></div></div></div></div></div><div \nstyle=\"background-color: #fff;box-shadow:0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12)\" \nng-if=\"vm.avg\"><div layout=\"column\" flex></div></div>");
$templateCache.put("app/main/contactcenter/dashboard/component/statisticsmessagesstats/ReportsMessagesStats.html","<div class=\"reportsMessagesStats widget\" ng-if=\"vm.stats\"><div layout=\"column\" flex><div \nclass=\"h3 secondary-text pb-8\" style=\"padding: 25px; padding-bottom: 0\">Ilość Wiadomości</div><div \nclass=\"font-size-32 line-height-32 pb-16\" style=\"padding: 0 25px\">{{ vm.lastCount ? vm.lastCount : \'0\' }}</div><div>\n<nvd3 class=\"remove-x-lines\" config=\"vm.mainChart.config\" options=\"vm.mainChart.options\" data=\"vm.mainChart.data\">\n</nvd3></div></div></div><div class=\"widget\" ng-if=\"vm.avg\"><div layout=\"column\" flex><div \nclass=\"h3 secondary-text pb-8\" style=\"padding: 25px; padding-bottom: 0\">Średni czas odpowiedzi</div><div \nclass=\"font-size-32 line-height-32 pb-16\" style=\"padding: 0 25px\">{{ vm.lastAvgAnswer ? vm.lastAvgAnswer : \'0\' }}</div>\n<div><nvd3 class=\"remove-x-lines\" config=\"vm.mainChart.config\" options=\"vm.mainChart.options\" \ndata=\"vm.mainChart.data1\"></nvd3></div></div></div>");
$templateCache.put("app/main/contactcenter/dashboard/profilemanagement/templates/partnermail.html","<form name=\"Form1\" novalidate=\"novalidate\" autocomplete=\"off\"><dialog-component savefunc=\"vm.saveNewMail\" \nform-name=\"Form1\" dialog-title=\"vm.editedMail.newRecordMode ? \'PARTNERMAILBOX.NEW_TITLE\':\'PARTNERMAILBOX.EDIT_TITLE\'\">\n<header flex=\"100\" layout=\"column\" layout-align=\"center center\" layout-fill><img flex class=\"w-130 h-130\" \nng-src=\"assets/icons/management/icon-e.png\"> <span class=\"avatar-name text-center\">{{vm.editedMail.name}}</span>\n</header><content layout=\"column\" layout-align=\"start stretch\" ms-scroll style=\"padding: 0\"><settings-mailbox \nng-model=\"vm.editedMail\" save-indicator=\"vm.saveMail\" resource=\"partnerRsc\" id-name=\"PartnerID\" column-order=\"true\" \nclass=\"userListModal\"></settings-mailbox></content></dialog-component></form>");
$templateCache.put("app/main/contactcenter/dashboard/profilemanagement/templates/partnerprofile.html","<main layout-align=\"start stretch\" class=\"p-20\"><md-input-container class=\"m-5\"><label \ntranslate=\"BILLDATA.COMPANYNAME\"></label><input ng-disabled=\"true\" ng-model=\"vm.sidenavData.companyName\" type=\"text\">\n</md-input-container><md-input-container class=\"m-5\"><label translate=\"BILLDATA.FULLCOMPANYNAME\"></label><input \nng-disabled=\"true\" ng-model=\"vm.sidenavData.fullCompanyName\" type=\"text\"></md-input-container><md-input-container \nclass=\"m-5\"><label translate=\"BILLDATA.ADDRESS\"></label><input ng-disabled=\"true\" ng-model=\"vm.sidenavData.address\" \ntype=\"text\"></md-input-container><md-input-container class=\"m-5\"><label translate=\"BILLDATA.NIP\"></label><input \nng-disabled=\"true\" ng-model=\"vm.sidenavData.taxID\" type=\"text\"></md-input-container><md-input-container class=\"m-5\">\n<label translate=\"BILLDATA.CITY\"></label><input ng-disabled=\"true\" ng-model=\"vm.sidenavData.city\" type=\"text\">\n</md-input-container><md-input-container class=\"m-5\"><label translate=\"BILLDATA.POSTAL\"></label><input \nng-disabled=\"true\" ng-model=\"vm.sidenavData.postalCode\" type=\"email\"></md-input-container><md-input-container \nclass=\"m-5\"><label translate=\"BILLDATA.WEBSITE\"></label><input ng-disabled=\"true\" ng-model=\"vm.sidenavData.website\" \ntype=\"email\"></md-input-container></main>");
$templateCache.put("app/main/contactcenter/dashboard/menucomponents/dashboardbutton/dashboardbutton.html","<div layout=\"row\" layout-align=\"space-between center\" \nng-class=\"{\'isActive\': vm.activeState == \'app.contactcenter_dashboard\'}\"><div flex layout=\"row\" \nlayout-align=\"start center\" class=\"h-40 p-10 menu-name\" \nng-class=\"{\'isActive\': vm.activeState == \'app.contactcenter_dashboard\'}\"><div translate=\"DASHBOARD.ROUTE_NAME\"></div>\n</div><md-button class=\"md-icon-button\" ng-click=\"vm.goToDashboardState()\" \nng-disabled=\"vm.activeState == \'app.contactcenter_dashboard\'\"><md-icon md-font-icon=\"icon-view-dashboard\"></md-icon>\n</md-button></div>");
$templateCache.put("app/main/contactcenter/dashboard/menucomponents/navavgcallschart/navavgcallschart.html","<div class=\"wrapperChart nav-axis\"><div style=\"padding: 5px\" layout=\"row\" layout-align=\"center center\"><span>\nŚredni czas rozmów</span></div><div class=\"chart\"><nvd3 class=\"remove-x-lines remove-zero-line remove-y-lines\" \nconfig=\"vm.mainChart.config\" options=\"vm.mainChart.options\" data=\"vm.mainChart.data\" api=\"vm.chartApi\"></nvd3></div>\n</div>");
$templateCache.put("app/main/contactcenter/dashboard/menucomponents/dashboardmenu/dashboardmenu.html","<md-content ms-scroll id=\"dashboardmenu\"><div layout=\"column\" layout-align=\"center center\" \nclass=\"dashboard-button-container\"></div><div class=\"header calendar mb-10\" layout=\"row\" layout-align=\"center center\">\n<div flex=\"50\" class=\"block left\" layout=\"column\" layout-align=\"center end\"><div>{{vm.month}}</div><div class=\"time\">\n{{vm.AssignedDate.now() | date:\'HH\'}}</div><div>{{vm.AssignedDate.now() | date:\'dd\'}}</div></div><div flex=\"50\" \nclass=\"block right\" layout=\"column\" layout-align=\"center start\"><div>{{vm.AssignedDate.now() | date:\'yyyy\'}}</div><div \nclass=\"time\">{{vm.AssignedDate.now() | date:\'mm\'}}</div><div>{{vm.day}}</div></div></div><div \nclass=\"language-container\"><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><span>Język</span><div \nclass=\"toggle-switch\" layout=\"row\"><span class=\"false-value\">Polski</span><md-switch ng-model=\"vm.lang\" \nng-true-value=\"\'en\'\" ng-false-value=\"\'pl\'\" ng-change=\"vm.changeLanguage(vm.languages[vm.lang])\">Angielski</md-switch>\n</div></div></div></md-content>");
$templateCache.put("app/main/contactcenter/dashboard/menucomponents/navstatusaxis/navstatusaxis.html","<div class=\"nav-status-axis nav-axis\" layout=\"column\" layout-align=\"start stretch\"><div class=\"mt-20 mh-10\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"font-size-24 pb-5\" style=\"color:#4CAF50\">\n{{ vm.activeTimeFormat }}<md-tooltip>Czas aktywności</md-tooltip></div><div class=\"font-size-24 pb-5\" \nstyle=\"color: #FFC107\">{{ vm.breakTimeFormat }} m<md-tooltip>Przerwy</md-tooltip></div></div><div \nclass=\"axis ph-10 mb-20\"><div title=\"{{s.statusName}} - {{s.differenceTime}}\" \nalt=\"{{s.statusName}} - {{s.differenceTime}}\" class=\"status status-{{s.status}}\" \nstyle=\"min-width: {{s.difference?(s.difference/vm.timeFromLogin)*100:0}}%;width: {{s.difference?(s.difference/vm.timeFromLogin)*100:0}}%\" \nng-repeat=\"s in vm.statusStatistic\"></div></div></div>");
$templateCache.put("app/main/contactcenter/dashboard/menucomponents/navmultibar/navmultibar.html","<div ng-hide=\"vm.hideChart\" class=\"wrapperChart nav-axis\"><div style=\"padding: 5px\" layout=\"row\" \nlayout-align=\"center center\"><span>Ilość/czas rozmów </span></div><div class=\"chart\"><nvd3 \nclass=\"offset-x-labels remove-x-lines remove-y-lines\" config=\"vm.mainChart.config\" options=\"vm.mainChart.options\" \ndata=\"vm.mainChart.data\" api=\"vm.chartApi\"></nvd3></div><div class=\"custom-xaxis\" layout=\"row\" \nlayout-align=\"center center\"><div ng-repeat=\"d in vm.dateInBetweenFormated\" class=\"xaxis-item rotate\">{{d}}</div></div>\n</div>");
$templateCache.put("app/main/contactcenter/communicator/dialogs/addmms/addmms.html","<div id=\"mms-dialog\" class=\"easy-content\" layout=\"column\" layout-align=\"center center\"><div class=\"filters header\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title-text\" \ntranslate=\"COMMUNICATOR.ADD_ATT_DIALOG.TITLE\">Dodawanie złączników</span><div layout=\"row\" \nlayout-align=\"center center\"><div layout-align=\"center center\" layout=\"row\" class=\"filter-button all-filter\" \nng-click=\"vm.toogleTagFilter(1)\" \nng-class=\"{\'filter-button-not-active\':!vm.filterObject.partner,\'filter-button-active\':vm.filterObject.partner}\"><div \ntranslate=\"COMMUNICATOR.ADD_ATT_DIALOG.PARTNER_TAB\" class=\"filter-label\">Organizacja</div></div><div \nlayout-align=\"center center\" layout=\"row\" class=\"filter-button logged-filter\" ng-click=\"vm.toogleTagFilter(2)\" \nng-class=\"{\'filter-button-not-active\':!vm.filterObject.service,\'filter-button-active\':vm.filterObject.service}\"><div \ntranslate=\"COMMUNICATOR.ADD_ATT_DIALOG.SERWICE_TAB\" class=\"filter-label\">Serwis</div></div><div \nlayout-align=\"center center\" layout=\"row\" class=\"filter-button active-filter\" ng-click=\"vm.toogleTagFilter(3)\" \nng-class=\"{\'filter-button-not-active\':!vm.filterObject.user,\'filter-button-active\':vm.filterObject.user}\"><div \ntranslate=\"COMMUNICATOR.ADD_ATT_DIALOG.USER_TAB\" class=\"filter-label\">Własne</div></div></div></div><div \nclass=\"addMMSContainer\" flex layout=\"column\" flow-init=\"vm.FlowConfig()\" flow-name=\"vm.Uploader\" \nflow-file-added=\"vm.validate($file)\" flow-files-submitted=\"$flow.upload()\" \nflow-file-success=\"vm.CallMeMaybe($flow, $file, $message)\" flow-file-retry=\"vm.retryChunk($file,$flow)\"><div flex=\"10\" \nclass=\"file-size-limit-bar\" layout=\"row\" layout-align=\"start center\"><div flex=\"40\" layout=\"row\" \nlayout-align=\"center center\" style=\"height: 100%\"><div flex ng-click=\"vm.changeSize(\'normal\')\" layout=\"row\" \nlayout-align=\"center center\" class=\"size-button-container\" ng-class=\"{\'selected\':vm.picSizeNormal}\"><md-icon \nmd-font-icon=\"icon-drag-horizontal\"></md-icon></div><div flex ng-click=\"vm.changeSize(\'large\')\" layout=\"row\" \nlayout-align=\"center center\" class=\"size-button-container\" ng-class=\"{\'selected\':vm.picSizeLarge}\"><md-icon \nmd-font-icon=\"icon-view-module\"></md-icon></div><div flex ng-if=\"vm.filterObject.user\" layout=\"row\" \nlayout-align=\"center center\" class=\"size-button-container\"><button type=\"file\" flow-btn flow-drop \nflow-attrs=\"{accept:\'image/*\'}\" class=\"add-content-bt\"><md-icon md-font-icon=\"icon-plus\"></md-icon></button></div>\n</div><div flex ng-show=\"vm.fileSizeLimited\" class=\"warning-and-size\" layout=\"column\" layout-align=\"center center\"><div\n ng-show=\"vm.loadedFilesSize>vm.maxFilesSize\" class=\"counter-exceeded\"><span \ntranslate=\"COMMUNICATOR.ADD_ATT_DIALOG.TOBIG_ATTACH\">Załacznik jest za duży jak na jeden MMS i MMS nie zostanie wysłany\n</span></div><div layout=\"row\" layout-align=\"center center\" class=\"progress-linear\"><md-progress-linear flex \nmd-mode=\"determinate\" value=\"{{(vm.loadedFilesSize/vm.maxFilesSize)*100}}\" \nng-class=\"{\'md-warn\':vm.loadedFilesSize>vm.maxFilesSize}\"></md-progress-linear><span>\n{{vm.loadedFilesSize+\'/\'+vm.maxFilesSize+\'KB\'}}</span></div></div></div><div class=\"partner-content\" \nng-if=\"vm.filterObject.partner\"><md-content ng-if=\"!vm.openedTag\" layout=\"row\" layout-wrap ms-scroll \nclass=\"content-hight\"><div class=\"tile folder\" ng-repeat=\"tag in vm.partnerContetTags\" layout=\"column\" \nlayout-align=\"space-between center\" ng-click=\"vm.openTag(1,tag)\" \nng-class=\"{\'big-tile\':vm.picSizeLarge,\'normal-tile\':vm.picSizeNormal}\"><div class=\"tile-in\" layout=\"column\" \nlayout-align=\"center center\"><img ng-if=\"!tag.contentUrlNoImage\" ng-src=\"{{tag.contentUrl}}\"> <img \nng-if=\"tag.contentUrlNoImage\" ng-src=\"{{tag.contentUrlNoImage}}\"></div><div class=\"folder-name\">{{tag.tag}}</div></div>\n</md-content><div ng-if=\"vm.openedTag\" class=\"openedTag\"><md-button ng-click=\"vm.backToList()\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><span>{{vm.openedTag.tag}}</span></div><md-content \nng-if=\"vm.openedTag\" layout=\"row\" layout-wrap ms-scroll class=\"content-hight\"><md-card class=\"tile\" \nng-repeat=\"pic in vm.openedTag.contents\" ng-click=\"vm.chosePic(pic, 1)\" \nng-class=\"{\'picSelected\':pic.selected,\'big-tile\':vm.picSizeLarge,\'normal-tile\':vm.picSizeNormal}\"><div class=\"tile-in\" \nlayout=\"column\" layout-align=\"center center\"><img ng-if=\"!pic.contentUrlNoImage\" ng-src=\"{{pic.contentUrl}}\"> <img \nng-if=\"pic.contentUrlNoImage\" ng-src=\"{{pic.contentUrlNoImage}}\"></div></md-card></md-content></div><div \nclass=\"service-content\" ng-if=\"vm.filterObject.service\"><md-content ng-if=\"!vm.openedTag\" layout=\"row\" layout-wrap \nms-scroll class=\"content-hight\"><div class=\"tile folder\" ng-repeat=\"tag in vm.serviceContetTags\" layout=\"column\" \nlayout-align=\"space-between center\" ng-click=\"vm.openTag(2,tag)\" \nng-class=\"{\'big-tile\':vm.picSizeLarge,\'normal-tile\':vm.picSizeNormal}\"><div class=\"tile-in\" layout=\"column\" \nlayout-align=\"center center\"><img ng-if=\"!tag.contentUrlNoImage\" ng-src=\"{{tag.contentUrl}}\"> <img \nng-if=\"tag.contentUrlNoImage\" ng-src=\"{{tag.contentUrlNoImage}}\"></div><div class=\"folder-name\">{{tag.tag}}</div></div>\n</md-content><div ng-if=\"vm.openedTag\" class=\"openedTag\"><md-button ng-click=\"vm.backToList()\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><span>{{vm.openedTag.tag}}</span></div><md-content \nng-if=\"vm.openedTag\" layout=\"row\" layout-wrap ms-scroll class=\"content-hight\"><div class=\"tile\" \nng-repeat=\"pic in vm.openedTag.contents\" ng-click=\"vm.chosePic(pic, 2)\" \nng-class=\"{\'picSelected\':pic.selected,\'big-tile\':vm.picSizeLarge,\'normal-tile\':vm.picSizeNormal}\"><div class=\"tile-in\" \nlayout=\"column\" layout-align=\"center center\"><img ng-if=\"!pic.contentUrlNoImage\" ng-src=\"{{pic.contentUrl}}\"> <img \nng-if=\"pic.contentUrlNoImage\" ng-src=\"{{pic.contentUrlNoImage}}\"></div></div></md-content></div><div \nclass=\"user-content\" ng-if=\"vm.filterObject.user\"><md-content ng-if=\"!vm.openedTag\" layout=\"row\" layout-wrap ms-scroll \nclass=\"content-hight\"><div class=\"tile folder\" ng-repeat=\"tag in vm.userContetTags\" layout=\"column\" \nlayout-align=\"space-between center\" ng-click=\"vm.openTag(3,tag)\" \nng-class=\"{\'big-tile\':vm.picSizeLarge,\'normal-tile\':vm.picSizeNormal}\"><div class=\"adding-photo-to-tag\" \nng-if=\"tag.loadding\"><md-icon md-font-icon=\"icon-plus-one\"></md-icon></div><div class=\"tile-in\" layout=\"column\" \nlayout-align=\"center center\"><img ng-if=\"!tag.contentUrlNoImage\" ng-src=\"{{tag.contentUrl}}\"> <img \nng-if=\"tag.contentUrlNoImage\" ng-src=\"{{tag.contentUrlNoImage}}\"></div><div class=\"folder-name\">{{tag.tag}}</div></div>\n</md-content><div ng-if=\"vm.openedTag\" class=\"openedTag\"><md-button ng-click=\"vm.backToList()\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><span>{{vm.openedTag.tag}}</span></div><md-content \nng-if=\"vm.openedTag\" layout=\"row\" layout-wrap ms-scroll class=\"content-hight\"><md-card class=\"tile\" \nng-repeat=\"pic in vm.openedTag.contents\" ng-click=\"vm.chosePic(pic, 3)\" \nng-class=\"{\'picSelected\':pic.selected,\'big-tile\':vm.picSizeLarge,\'normal-tile\':vm.picSizeNormal}\"><div class=\"tile-in\" \nlayout=\"column\" layout-align=\"center center\"><img ng-if=\"!pic.loadding && !pic.contentUrlNoImage\" \nng-src=\"{{pic.contentUrl}}\"> <img ng-if=\"!pic.loadding && pic.contentUrlNoImage\" ng-src=\"{{pic.contentUrlNoImage}}\">\n<md-icon ng-if=\"pic.loadding\" md-svg-src=\"/assets/icons/communicator/loadding.svg\"></md-icon></div></md-card>\n</md-content></div></div><div class=\"ok-button-container\" layout=\"column\" layout-align=\"center end\"><md-button \nng-click=\"vm.close()\" class=\"ok-button\">OK</md-button></div></div>");
$templateCache.put("app/main/contactcenter/communicator/dialogs/mapdialog/mapdialog.html","<div class=\"mapdialog\"><div class=\"mapdialog__events\"><div class=\"mapdialog__events__buttons\"><div \nclass=\"mapdialog__events__buttons__search\" ng-class=\"{\'visible\': vm.showSearchInput}\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"bt-pointer search-bt\" ng-click=\"vm.toggleSertchInput()\"></md-icon>\n<md-input-container><label>Search</label><input ng-keypress=\"vm.searchKeyPress($event)\" class=\"md-24 find-loc-bt\" \nng-model=\"vm.searchAddress\"></md-input-container></div><div class=\"mapdialog__events__buttons__close\" \nng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" class=\"s24\"></md-icon></div></div></div><div \nng-if=\"vm.markers\" class=\"mapdialog__map\"><leaflet markers=\"vm.markers\" id=\"mapTag\" event-broadcast=\"vm.events\" \nlf-center=\"vm.address\" bounds=\"vm.bounds\" height=\"100%\"></leaflet><div ng-if=\"vm.current\" \nclass=\"mapdialog__map__legend\"><div class=\"mapdialog__map__legend__n\"><b>{{ vm.current.name }}</b></div><div \nclass=\"mapdialog__map__legend__addr\">{{ vm.current.address }}</div><div class=\"mapdialog__map__legend__addr\">\n{{ vm.current.zipCode }} {{ vm.current.city }}</div><div>tel: <b>{{ vm.current.phone }}</b>, fax: <b>\n{{ vm.current.fax }}</b></div><div>e-mail: <b>{{ vm.current.email }}</b></div><div ng-if=\"vm.current.link\">www: <a \nhref=\"{{ vm.current.link }}\" target=\"_blank\">{{ vm.current.link }}</a></div><div \nng-repeat=\"(key, value) in vm.current.hours\" class=\"mapdialog__map__legend__h\">{{key}}: <b>{{value}}</b></div></div>\n</div></div>");
$templateCache.put("app/main/contactcenter/communicator/dialogs/confirmEndSession/confirmEndSession.html","<md-dialog aria-label=\"%translate\" class=\"remove\"><md-toolbar class=\"remove__msg\"><div class=\"md-toolbar-tools\">\n<md-icon md-font-icon=\"icon-alert-circle\"></md-icon><h2 class=\"w-500\">\n{{\"COMMUNICATOR.CONFIRM_END_SESSION_DIALOG.TITLE\" | translate}}</h2></div></md-toolbar><div class=\"remove-tags\">\n<ta-tags flex custom-class=\"medium transparent\" write-mode=\"true\" ng-model=\"tags\" label=\"Wpisz tagi dla sesji\" \nsource-endpoint=\"\'getServiceTagsAll\'\" function-autosave=\"tagAutoSave\" content-id=\"params.serviceId\" show-button=\"true\">\n</ta-tags></div><md-dialog-actions layout=\"row\" layout-align=\"space-between center\" class=\"remove__buttons\" \nstyle=\"padding-left: 0;min-width: 680px\"><div class=\"vertical flip-container\" \nontouchstart=\"this.classList.toggle(\'hover\')\"><div class=\"flipper\"><div class=\"front\"><md-button ng-click=\"cancel()\" \nclass=\"remove__buttons__no\">NIE CHCĘ ZAMYKAĆ</md-button></div><div class=\"back\"><md-button ng-click=\"cancel()\" \nclass=\"remove__buttons__no\">{{\"COMMUNICATOR.CONFIRM_END_SESSION_DIALOG.CANCEL\" | translate}}</md-button></div></div>\n</div><div class=\"vertical flip-container\" ontouchstart=\"this.classList.toggle(\'hover\')\"><div class=\"flipper\"><div \nclass=\"front\"><md-button ng-click=\"answer(100)\" class=\"remove__buttons__yes\">PROBLEM ROZWIĄZANY</md-button></div><div \nclass=\"back\"><md-button ng-click=\"answer(100)\" class=\"remove__buttons__yes\">\n{{\"COMMUNICATOR.CONFIRM_END_SESSION_DIALOG.CLOSE\" | translate}}</md-button></div></div></div><div \nclass=\"vertical flip-container\" ontouchstart=\"this.classList.toggle(\'hover\')\"><div class=\"flipper\"><div class=\"front\">\n<md-button ng-click=\"answer(101)\" class=\"remove__buttons__yes\">BRAK AKTYWNOŚCI</md-button></div><div class=\"back\">\n<md-button ng-click=\"answer(101)\" class=\"remove__buttons__yes\">\n{{\"COMMUNICATOR.CONFIRM_END_SESSION_DIALOG.CLOSE\" | translate}}</md-button></div></div></div></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/contactcenter/communicator/dialogs/setTags/setTags.html","<md-dialog aria-label=\"%translate\" class=\"remove\"><md-toolbar class=\"remove__msg\"><div class=\"md-toolbar-tools\">\n<md-icon md-font-icon=\"icon-alert-circle\"></md-icon><h2 class=\"w-500\">Otaguj sesje</h2></div></md-toolbar><div \nclass=\"remove-tags\"><ta-tags flex custom-class=\"medium transparent\" write-mode=\"true\" ng-model=\"params.tags\" \nlabel=\"Wpisz tagi dla sesji\" source-endpoint=\"\'getServiceTagsAll\'\" function-autosave=\"tagAutoSave\" \nforce-reload=\"params.forceReloadTags\" content-id=\"params.serviceId\" show-button=\"true\"></ta-tags></div>\n<md-dialog-actions layout=\"row\" layout-align=\"center center\" class=\"remove__buttons\" \nstyle=\"padding-left: 0;min-width: 680px\"><div class=\"vertical flip-container\"><div><div class=\"front\"><md-button \nng-click=\"answer(params.tags)\" class=\"remove__buttons__yes\">OK</md-button></div><div class=\"back\"><md-button \nng-click=\"answer(1)\" class=\"remove__buttons__yes\">{{\"COMMUNICATOR.CLIENT_END_DIALOG.CLOSE\" | translate}}</md-button>\n</div></div></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/contactcenter/communicator/dialogs/messagetointernamchat/messageToInternalChat.html","<md-dialog aria-label=\"%translate\" class=\"remove\"><md-toolbar class=\"remove__msg\"><div class=\"md-toolbar-tools\">\n<md-icon md-font-icon=\"icon-alert-circle\"></md-icon><h2 class=\"w-500\">Napisz wiadomość do menagera</h2></div>\n</md-toolbar><div class=\"remove-tags\"><md-input-container><label>Message</label><input name=\"message\" \nng-model=\"message\"></md-input-container></div><md-dialog-actions layout=\"row\" layout-align=\"space-between center\" \nclass=\"remove__buttons\" style=\"padding-left: 0;min-width: 680px\"><div class=\"vertical flip-container\" \nontouchstart=\"this.classList.toggle(\'hover\')\"><div class=\"flipper\"><div class=\"front\"><md-button ng-click=\"cancel()\" \nclass=\"remove__buttons__no\">NIE CHCĘ WYSYŁAĆ</md-button></div><div class=\"back\"><md-button ng-click=\"cancel()\" \nclass=\"remove__buttons__no\">{{\"COMMUNICATOR.CONFIRM_END_SESSION_DIALOG.CANCEL\" | translate}}</md-button></div></div>\n</div><div class=\"vertical flip-container\" ontouchstart=\"this.classList.toggle(\'hover\')\"><div class=\"flipper\"><div \nclass=\"front\"><md-button class=\"remove__buttons__yes\">wyślij</md-button></div></div></div></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/contactcenter/communicator/components/categoriespart/categoriespart.html","<div layout=\"column\" id=\"surveys-container\" class=\"easy-content\"><md-toolbar class=\"header md-primary-bg\" layout=\"row\" \nlayout-align=\"start center\" ng-class=\"{\'reserved-number\':vm.reservedNumber}\"><div flex=\"100\" class=\"h-50\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\"><img class=\"ico-ico\" \nsrc=\"assets/icons/communicator/folder.svg\"></div><span class=\"header-part\">KATEGORIE</span></div></md-toolbar><span \nng-if=\"vm.error\" class=\"errorMesg\" translate=\"COMMUNICATOR.ERROR_WHEN_PART_LOADED\">Wystapił bład</span><md-content \nflex class=\"empty-content\" ng-show=\"vm.rollDown\" ms-scroll layout=\"column\" layout-align=\"center center\"><img \nclass=\"gigant-ico\" src=\"assets/icons/communicator/folder.svg\"></md-content><div flex layout=\"column\" \nng-hide=\"vm.rollDown\" class=\"content\"><md-content flex ms-scroll><div class=\"without-session\"></div><script \ntype=\"text/ng-template\" id=\"nodes_renderer.html\">\n<div ui-tree-handle class=\"tree-node tree-node-content\" ng-class=\"{selected: item.isActive}\" >\n          <a ng-if=\"item.nodes && item.nodes.length > 0\" data-nodrag ng-click=\"toggle(this)\"><span\n              class=\"folder-icon fa\"\n              ng-class=\"{\n                \'fa-folder-o\': collapsed,\n                \'fa-folder-open\': !collapsed\n              }\" ></span></a>\n          <span ng-click=\"vm.selectNode(item)\">\n            <span ng-if=\"item.level===2\"\n                style=\"font-size:.8em;color:#999;margin-right:3px\">#</span>{{item.title}}</span>\n        </div>\n        <ol ui-tree-nodes=\"\" ng-model=\"item.nodes\" ng-class=\"{closed: collapsed}\">\n          <li ng-repeat=\"item in item.nodes\" ui-tree-node data-collapsed=!item.expand ng-include=\"\'nodes_renderer.html\'\">\n          </li>\n        </ol>\n</script><div ui-tree data-drag-enabled=\"false\" id=\"tree-root\"><ol ui-tree-nodes ng-model=\"vm.categories\"><li \nng-repeat=\"item in vm.categories\" ui-tree-node data-collapsed=\"!item.expand\" ng-include=\"\'nodes_renderer.html\'\"></li>\n</ol></div><div ng-if=\"vm.activeSurvey\" layout=\"column\" layout-align=\"start stretch\"><dynamic-form flex \nclass=\"pl-10 pr-10 mt-20\" ng-if=\"vm.activeSurvey.config && vm.contactId\" form-config=\"vm.activeSurvey.config\" \nsettings=\"vm.answers\"></dynamic-form></div></md-content></div></div>");
$templateCache.put("app/main/contactcenter/communicator/components/chatpart/chatPart.html","<div layout=\"column\" id=\"chatpart\" class=\"easy-content\"><md-toolbar class=\"header md-primary-bg\" layout=\"row\" \nlayout-align=\"space-between center\" ng-class=\"{\'reserved-number\':vm.templateData.reservedNumber}\"><div layout=\"row\" \nlayout-align=\"center center\"><div class=\"icon-container\"><img class=\"ico-ico\" \nsrc=\"assets/icons/communicator/speech_bubble.svg?v=1.0.1\"></div><span class=\"header-part\" \ntranslate=\"COMMUNICATOR.CHAT.TITLE\">CHAT</span> <span class=\"header-part\" style=\"margin-left: 10px\" \nng-if=\"vm.templateData.reservedNumber\" translate=\"COMMUNICATOR.RESERVEDNUMBER\">reserved Number</span><md-icon \nmd-font-icon=\"icon-worker\" class=\"ico-dev\" ng-click=\"vm.developerLookVisable=!vm.developerLookVisable\"></md-icon>\n<md-icon md-font-icon=\"icon-lock-outline\" class=\"ico-dev\" ng-if=\"vm.communicatorService.typingInProgress\"><md-tooltip>\nSesja zawiera niezapisane/niewysłane dane</md-tooltip></md-icon><div style=\"width: 1px;height: 1px\"><md-tooltip \nmd-visible=\"vm.developerLookVisable\" md-z-index=\"1000\">{{vm.developerLook|json}}</md-tooltip></div></div><div \nclass=\"session-progress\" ng-show=\"false\"><div layout=\"row\" layout-align=\"space-between center\" \nng-show=\"vm.chatSessionStart\"><div class=\"border\"><div class=\"inside\" ng-style=\"{\'width\':vm.sessionProgress+\'%\'}\">\n</div></div></div></div></md-toolbar><md-content flex class=\"empty-content\" ng-show=\"vm.rollDown\" ms-scroll \nlayout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\" style=\"height: 100%\">\n<span ng-if=\"!vm.templateData.reservedNumber\" translate=\"COMMUNICATOR.NOTIFY_NO_MESSAGE_TO_PROCESS\" \nstyle=\"margin-bottom: 40px; color: rgba(128, 128, 128, 0.52)\">No Message to Process</span> <span \nng-if=\"vm.templateData.reservedNumber\" translate=\"COMMUNICATOR.RESERVED_NUMBER_MSG\" \nstyle=\"margin-bottom: 40px; color: rgba(128, 128, 128, 0.52)\">Reserved number</span> <img class=\"gigant-ico\" \nsrc=\"assets/icons/communicator/speech_bubble.svg?v=1.0.1\"></div></md-content><div flex layout=\"column\" \nng-hide=\"vm.rollDown\" class=\"chat-content\"><md-content flex layout=\"column\" ms-scroll scroll-glue \nclass=\"chat-md-content\" style=\"background-image:url(\'{{vm.templateData.chatBackgroundURL}}\')\"><div \nclass=\"chat-messages\" flex layout-fill><div layout=\"row\" layout-align=\"start start\" ng-repeat=\"dialog in vm.chatData\" \nclass=\"message-row\" \nng-class=\"{\'contact\': dialog.direction === \'I\',\n           \'user\': dialog.direction !== \'I\',\n           \'md-padding\': dialog.type!==\'A\',\n          \'old-session\':dialog.sessionID!==vm.templateData.sessionId\n          }\">\n<div class=\"avatar-container\" ng-if=\"dialog.type!==\'A\'\" layout=\"column\" layout-align=\"center center\"><div \nng-if=\"dialog.direction ===\'I\'\" class=\"avatar avatar-svg\" ng-class=\"vm.templateData.colorMain\"></div><div \nclass=\"author-name\" ng-if=\"dialog.userName\">{{dialog.userName}}</div></div><div layout=\"column\" \nng-if=\"dialog.direction ===\'O\' && dialog.type!==\'A\'\" layout-align=\"center center\" class=\"avatar-container\"><img \nng-if=\"dialog.authorPhotoUrl\" class=\"avatar\" ng-src=\"{{dialog.authorPhotoUrl}}\"><div ng-if=\"!dialog.authorPhotoUrl\" \nclass=\"avatar avatar-svg\"></div><div class=\"author-name\" ng-if=\"dialog.authorName\">{{dialog.authorName | limitTo: 10}}\n</div></div><div layout=\"column\" class=\"bubble\" \nng-class=\"dialog.direction===\'I\'?vm.templateData.colorSecondary:vm.templateData.colorMain\" ng-if=\"dialog.type===\'S\'\">\n<div class=\"time date-text\" ng-bind-html=\"dialog.time\"></div><div layout=\"row\" flex><md-icon class=\"ico-chat\" \ntitle=\"SMS\" alt=\"SMS\" md-svg-src=\"assets/icons/communicator/SMS.svg?v=1.0.1\"></md-icon><div class=\"content\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"message\">{{dialog.body}}</div></div></div></div><div \nlayout=\"column\" class=\"bubble\" \nng-class=\"dialog.direction===\'I\'?vm.templateData.colorSecondary:vm.templateData.colorMain\" ng-if=\"dialog.type===\'E\'\">\n<div class=\"time date-text\">{{ dialog.time | communicatorDateFilter3 }}</div><div layout=\"row\" flex><i \nclass=\"icon-email s20\"></i><div class=\"content\" layout=\"row\" flex layout-align=\"start center\"><div flex \nclass=\"message\">{{dialog.body}}</div></div></div></div><div layout=\"column\" class=\"bubble\" \nng-class=\"dialog.direction===\'I\'?vm.templateData.colorSecondary:vm.templateData.colorMain\" ng-if=\"dialog.type===\'C\'\">\n<div class=\"time date-text\">{{ dialog.time | communicatorDateFilter3 }}</div><div layout=\"row\" flex><md-icon \nclass=\"ico-chat\" title=\"Chat\" alt=\"Chat\" md-svg-src=\"assets/icons/communicator/chat.svg?v=1.0.1\"></md-icon><div \nlayout=\"column\" flex><div layout=\"row\" layout-align=\"start center\" class=\"chatmsg\"><div ng-show=\"dialog.body\" \nclass=\"message-text\" ng-bind-html=\"dialog.body | colonToCode  | linkify | likeIcons | msgbodyTransform\"></div></div>\n<md-content class=\"img-msg-container\" ms-scroll ng-if=\"dialog.attachmentUrls.length>0\" \nng-style=\"{\'background-color\':dialog.direction===\'I\'?vm.templateData.colorSecondary:vm.templateData.colorMain}\"><div \nng-repeat=\"attachment in dialog.attachmentUrlsConverted track by $index\"><img ng-if=\"!attachment.contentUrlNoImage\" \nclass=\"message-img\" ng-click=\"vm.showImageInPopup(attachment.contentUrl);\" ng-src=\"{{attachment.contentUrl}}\"> <a \nclass=\"downloadDoc message-img\" ng-href=\"{{ attachment.contentUrl }}\" ng-if=\"attachment.contentUrlNoImage\" \ntarget=\"_blank\" layout=\"column\" layout-align=\"start center\"><img ng-src=\"{{attachment.contentUrlNoImage}}\" \nalt=\"iconDownloadDoc\"></a></div></md-content></div></div></div><div layout=\"row\" class=\"action-msg\" \nng-class=\"dialog.direction===\'I\'?vm.templateData.colorSecondary:vm.templateData.colorMain\" ng-if=\"dialog.type===\'A\'\">\n<div layout=\"column\" flex><div layout=\"row\" layout-align=\"center center\"><div flex=\"50\" layout=\"row\" \nclass=\"time date-text\"><div><md-icon class=\"ico\" aria-label=\"Action\" \nmd-svg-src=\"assets/icons/communicator/action_msg.svg?v=1.0.1\"></md-icon></div><div>\n{{dialog.time | communicatorDateFilter3}}</div></div><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div \nng-show=\"dialog.body\" class=\"message-text\">{{dialog.body}}</div></div></div></div></div><div layout=\"column\" \nclass=\"bubble\" ng-class=\"dialog.direction===\'I\'?vm.templateData.colorSecondary:vm.templateData.colorMain\" \nng-if=\"dialog.type===\'F\' || dialog.type===\'K\'\"><div class=\"time date-text\">{{ dialog.time | communicatorDateFilter3 }}\n</div><div layout=\"row\" flex><md-icon class=\"ico-chat\" title=\"FB Messanger\" alt=\"FB Messanger\" \nmd-svg-src=\"assets/icons/facebook-messenger-logo_w.svg?v=1.0.1\"></md-icon><div layout=\"column\" flex><div \nlayout=\"column\" layout-align=\"start start\" class=\"chatmsg\"><div ng-show=\"dialog.body\" class=\"message-text\" \nng-bind-html=\"dialog.body\"></div><div class=\"message-fbstatus\" \nng-show=\"dialog.direction===\'O\' && dialog.fbOutMessageStatus\">\n{{ (\'COMMUNICATOR.CHAT.FBM_\'+dialog.fbOutMessageStatus) | translate }}</div></div><md-content \nclass=\"img-msg-container\" ms-scroll ng-if=\"dialog.attachmentUrls.length>0\" \nng-style=\"{\'background-color\':dialog.direction===\'I\'?vm.templateData.colorSecondary:vm.templateData.colorMain}\"><img \nclass=\"message-img\" ng-repeat=\"picUrl in dialog.attachmentUrls.split(\';\') track by $index\" ng-src=\"{{picUrl}}\">\n</md-content></div></div></div><div layout=\"row\" class=\"bubble\" \nng-class=\"dialog.direction===\'I\'?vm.templateData.colorSecondary:vm.templateData.colorMain\" ng-if=\"dialog.type===\'M\'\">\n<md-icon class=\"ico-chat\" md-svg-src=\"assets/icons/communicator/MMS.svg?v=1.0.1\"></md-icon><div layout=\"column\" flex>\n<div layout=\"row\" layout-align=\"start start\"><div class=\"time date-text\">{{dialog.time | communicatorDateFilter3}}\n</div><div class=\"message-title\">{{dialog.subject}}</div></div><div ng-show=\"dialog.body\" class=\"message-text\">\n{{dialog.body}}</div><md-content class=\"img-msg-container\" ms-scroll ng-if=\"dialog.MMSUrls.length>0\" \nng-class=\"dialog.direction===\'I\'?vm.templateData.colorSecondary:vm.templateData.colorMain\"><img class=\"message-img\" \nng-repeat=\"picUrl in dialog.MMSUrls track by $index\" ng-src=\"{{picUrl}}\"></md-content></div></div><div layout=\"column\" \nclass=\"bubble\" ng-class=\"dialog.direction===\'I\'?vm.templateData.colorSecondary:vm.templateData.colorMain\" \nng-if=\"dialog.type===\'T\'\"><div class=\"time date-text\">{{dialog.time | communicatorDateFilter3}}</div><div layout=\"row\" \nflex><issue-tracker layout=\"row\" layout-align=\"start center\" style=\"margin-right: 8px\" issue-status=\"vm.issueStatus\">\n</issue-tracker><div layout=\"row\" layout-align=\"start center\">\n{{\"COMMUNICATOR.CHAT.ISSUE_ID\" | translate}} {{vm.issueId}}</div></div></div><div layout=\"column\" \nclass=\"bubble extended-minwidth\" \nng-class=\"dialog.direction===\'I\'?vm.templateData.colorSecondary:vm.templateData.colorMain\" \nng-if=\"dialog.type===\'I\' || dialog.type===\'V\'\"><div class=\"time date-text\">{{dialog.time | altDateCommunicator}}</div>\n<div ng-show=\"dialog.direction===\'I\'\" layout=\"row\" layout-align=\"start top\"><md-icon class=\"ico-chat\" \nmd-svg-src=\"assets/icons/communicator/call_in.svg?v=1.0.1\"></md-icon><div layout=\"column\" layout-align=\"start center\" \nlayout-fill><div ng-if=\"dialog.type===\'V\'\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"margin-bottom: 10px\" layout-fill><span flex=\"75\" translate=\"COMMUNICATOR.CHAT.INCOMMING_MESSAGE\" \nclass=\"font-italic\">Incomming call</span><div flex=\"25\" class=\"time\" layout=\"row\" layout-align=\"end center\"><span>\n{{dialog.duration2}}</span></div></div><div ng-if=\"dialog.type===\'I\'\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"margin-bottom: 10px\" layout-fill><span flex=\"100\" translate=\"COMMUNICATOR.CHAT.INCOMMING_MESSAGE\" \nclass=\"font-italic\">Incomming call</span></div><div class=\"in-outgoing-call\" layout=\"row\" layout-fill \nlayout-align=\"space-between center\" ng-show=\"dialog.currentCall\"><div flex=\"75\" class=\"font-italic\"><span>\nRozmowa aktualnie trwa...</span></div></div><div class=\"in-outgoing-call\" layout=\"row\" layout-fill \nlayout-align=\"space-between center\" ng-show=\"dialog.notRealizedCall\"><div flex=\"75\" class=\"font-italic\"><span>\nPołaczenie niezrealizowane</span></div></div><div class=\"in-outgoing-call\" layout=\"row\" layout-fill \nlayout-align=\"space-between center\" \nng-show=\"dialog.childrenOut.length>0 && !dialog.notRealizedCall && !dialog.currentCall\" \nng-repeat=\"child in dialog.childrenOut\"><div flex=\"15\"><div class=\"image\"><img ng-if=\"child.authorPhotoUrl\" \nng-src=\"{{ child.authorPhotoUrl }}\"><div ng-if=\"!child.authorPhotoUrl\" class=\"noAvatar\" layout=\"column\" \nlayout-align=\"center center\"><md-icon flex md-svg-src=\"/assets/navigation/avatar.svg?v=1.0.1\" aria-label=\"avatar\">\n</md-icon></div></div></div><div flex=\"30\" class=\"font-italic call-desc-text\"><span>{{child.authorName}}</span></div>\n<div flex=\"30\" class=\"time\" layout=\"row\" layout-align=\"center center\"><span>{{child.duration2}}</span></div><div \nflex=\"25\" ng-click=\"vm.playEvasdropping(child);\" style=\"cursor: pointer\" flex=\"15\" layout=\"row\" \nlayout-align=\"end center\"></div></div></div></div><div ng-show=\"dialog.direction===\'O\'\" layout=\"row\" flex \nlayout-align=\"space-between center\"><md-icon class=\"ico-chat\" \nmd-svg-src=\"assets/icons/communicator/call_out.svg?v=1.0.1\"></md-icon><span ng-if=\"dialog.duration\" flex=\"50\" \ntranslate=\"COMMUNICATOR.CHAT.OUTGOING_MESSAGE\" class=\"font-italic\">Outgoing call</span> <span ng-if=\"!dialog.duration\" \nflex=\"50\" translate=\"COMMUNICATOR.CHAT.CURRENT_OUTGOING_MESSAGE\" class=\"font-italic\">Rozmowa aktualnie trwa...</span>\n<div flex=\"20\" class=\"time\" layout=\"row\" layout-align=\"center center\"><span>{{dialog.duration2}}</span></div><div \nng-click=\"vm.playEvasdropping(dialog);\" style=\"cursor: pointer\" flex=\"15\"></div></div></div></div></div></md-content>\n<div class=\"chat-footer\" layout=\"column\"><div layout=\"row\" layout-align=\"center center\" class=\"no-sms-setup\" \nng-if=\"!vm.templateData.smsServiceId &&  (vm.templateData.sessionServiceType ===\'I\' ||  vm.templateData.sessionServiceType ===\'V\')\">\n<span translate=\"COMMUNICATOR.CHAT.NO_SMS_SETUP\">Brak konfiguracji serwisu SMS. Nie można wysyłać wiadmości</span>\n</div><div ng-if=\"vm.templateData.finished\" layout=\"column\" layout-align=\"center center\" \nclass=\"session-end-placeholder\"><span translate=\"COMMUNICATOR.CHAT.SESSION_ENDED\">\nSesja została zakończona - nie można wysyłać wiadomości</span><div class=\"tags-placeholder\" layout=\"row\"><div \nflex=\"100\"><ta-tags flex custom-class=\"medium black\" write-mode=\"true\" ng-model=\"vm.templateData.tags\" \nforce-reload=\"vm.templateData.forceReloadTags\" label=\"Wpisz tagi dla sesji\" source-endpoint=\"\'getServiceTagsAll\'\" \ncontent-id=\"vm.templateData.currentServiceId\" show-button=\"true\" function-autosave=\"vm.autoSaveTags\"></ta-tags></div>\n</div></div><div layout=\"column\" \nng-if=\"!vm.templateData.finished && !(!vm.templateData.smsServiceId &&  (vm.templateData.sessionServiceType ===\'I\' ||  vm.templateData.sessionServiceType ===\'V\'))\">\n<form flex ng-submit=\"vm.sendMesgAndGetData()\" class=\"reply-form\" layout=\"row\" layout-align=\"start center\"><div \nlayout=\"row\" layout-align=\"start center\"><issue-tracker ng-show=\"false\" layout=\"row\" layout-align=\"start center\" \nstyle=\"padding-bottom: 8px; padding-top: 8px; padding-left: 8px\" issue-status=\"vm.issueStatus\" \nopen-issue-dialog=\"true\" create-issue-dialog-params=\"vm.createIssueDialogParams(vm.issueId)\"></issue-tracker><md-icon \nclass=\"action-btn\" ng-if=\"vm.consultantId > -1\" md-svg-src=\"assets/icons/communicator/attached.svg\" \naria-label=\"Add attachment\" ng-click=\"vm.addAttachmentDialog($event)\"><md-tooltip><span \ntranslate=\"COMMUNICATOR.CHAT.ADDATTACH\">Dodaj złacznik</span></md-tooltip></md-icon><div class=\"send-time\" \nng-if=\"vm.consultantId > -1\"><md-menu><md-icon class=\"action-btn\" ng-disable=\"vm.sendingMessageInProgress\" \nng-click=\"vm.openSendTime($mdMenu, $event)\" alt=\"{{vm.replyToMessage.timeToSend}}\" \nmd-svg-src=\"/assets/icons/communicator/clock-with-white-face.svg?v=1.0.2\"><md-tooltip><span \ntranslate=\"COMMUNICATOR.CHAT.DELAYED_SENDING\">Wysyłka z opóźnieniem</span></md-tooltip></md-icon><md-menu-content \nwidth=\"4\" class=\"send-time-menu\"><md-menu-item><md-button ng-click=\"vm.setSendTime(null)\"><span \ntranslate=\"COMMUNICATOR.CHAT.NOW_DATE\"></span></md-button></md-menu-item><md-menu-item \nng-repeat=\"time in vm.timeArray\"><md-button ng-click=\"vm.setSendTime(time)\">{{time.text}}</md-button></md-menu-item>\n<md-menu-divider></md-menu-divider><md-menu-item><md-button ng-click=\"vm.setCustomTime()\"><span \ntranslate=\"COMMUNICATOR.CHAT.CUSTOM_DATE\"></span></md-button></md-menu-item></md-menu-content></md-menu></div></div>\n<div ng-if=\"vm.showServicesType\"><md-select class=\"services-type\" ng-model=\"vm.selectedService\"><md-option \nng-repeat=\"s in vm.servicesType\" ng-value=\"s\">{{s.name}}</md-option></md-select></div><div class=\"msg-type\" \nng-if=\"!vm.showServicesType && (vm.replyToMessage.type===\'S\' || vm.replyToMessage.type===\'F\') && (vm.templateData.callid || vm.templateData.sessionType === \'history\')\">\n<md-chip>{{vm.replyToMessage.type===\'S\'?\'SMS\':vm.replyToMessage.type===\'F\'?\'FBM\':\'\'}}</md-chip></div>\n<md-input-container ng-if=\"vm.replyToMessage.type !== \'S\'\" flex md-no-float class=\"fallback dropzone\" \nid=\"my-awesome-dropzone\" dropzone=\"dropzoneConfig\"><div id=\"emojiWrapper\" emoji-form emoji-message=\"emojiMessage\" \nng-keypress=\"vm.answerKeyPress($event)\"><label translate=\"COMMUNICATOR.REPLY_PLACEHOLDER\">Wprowadź treść odpowiedzi\n</label><textarea id=\"messageInput\" msd-elastic rows=\"1\" md-no-autogrow aria-label=\"reply box\" \nng-model=\"emojiMessage.messagetext\" focusable=\"{{vm.dataLoaded.chat}}\" ng-change=\"vm.changeMessageToRepley()\">\n              </textarea><div id=\"emojibtn\"><i class=\"icon icon-emoji\"></i></div></div></md-input-container>\n<md-input-container ng-if=\"vm.replyToMessage.type === \'S\'\" flex md-no-float class=\"fallback dropzone\" \nid=\"my-awesome-dropzone\" dropzone=\"dropzoneConfig\"><label translate=\"COMMUNICATOR.REPLY_PLACEHOLDER\">\nWprowadź treść odpowiedzi</label><textarea msd-elastic rows=\"1\" md-no-autogrow aria-label=\"reply box\" \nng-keypress=\"vm.answerKeyPress($event)\" ng-model=\"vm.replyMessage\" focusable=\"{{vm.dataLoaded.chat}}\" \nng-change=\"vm.changeMessageToRepley()\">\n              </textarea></md-input-container><div><md-button \nclass=\"md-fab md-fab-mini\" type=\"submit\" aria-label=\"Send message\" ng-disable=\"vm.sendingMessageInProgress\" \nng-class=\"vm.templateData.colorMain\"><img class=\"ico-chat send-bt\" \nsrc=\"assets/icons/communicator/send_msg.svg?v=1.0.1\"></md-button></div></form><div class=\"file-size-limit-bar\" \nng-if=\"vm.isMaxFilesSize\"><div class=\"warning-and-size\" layout=\"row\" layout-align=\"end center\" \nng-class=\"{\'counter-exceeded\':vm.loadedFilesSize>vm.maxFilesSize}\"><span ng-show=\"vm.loadedFilesSize>vm.maxFilesSize\" \ntranslate=\"COMMUNICATOR.ADD_ATT_DIALOG.TOBIG_ATTACH\">Załacznik jest za duży jak na jeden MMS i MMS nie zostanie wysłany\n</span> <span>{{vm.loadedFilesSize+\'/\'+vm.maxFilesSize+\'KB\'}}</span></div><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{(vm.loadedFilesSize/vm.maxFilesSize)*100}}\" ng-class=\"{\'md-warn\':vm.loadedFilesSize>vm.maxFilesSize}\">\n</md-progress-linear></div><div class=\"box-attachment\" ms-scroll scroll-glue layout-align=\"start center\" layout=\"row\">\n<div ng-repeat=\"pic in vm.selectedAttachmentList\" class=\"little-attachment\" layout-align=\"center center\" \nng-click=\"vm.deleteAttachment(pic)\"><img ng-if=\"!pic.contentUrlNoImage\" ng-src=\"{{pic.contentUrl}}\" err-src> <img \nng-if=\"pic.contentUrlNoImage\" ng-src=\"{{pic.contentUrlNoImage}}\"><div class=\"play\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></div></div></div></div></div></div></div>");
$templateCache.put("app/main/contactcenter/communicator/components/morfer/morfer.html","<div layout=\"column\" id=\"morfer\"><div class=\"customizer-icon\" \nng-hide=\"vm.partPlacement[vm.area]==\'\'||vm.partPlacement[vm.area]==\'customizer-part\'\"><md-menu><md-icon flex \nclass=\"icon-cog bt-pointer\" aria-label=\"\" ng-click=\"vm.openMenu($mdMenu, $event)\"></md-icon><md-menu-content width=\"4\" \nstyle=\"min-width: 156px\"><md-menu-item ng-repeat=\"item in vm.allowedParts\" ng-click=\"vm.changeConfig(item.name)\" \nstyle=\"height: 30px;min-height:30px\"><md-button ng-disabled=\"vm.partPlacement[vm.area]===item.name\" \nstyle=\"height: 30px;line-height: 30px\"><md-icon md-svg-icon=\"{{\'assets/icons/communicator/\'+item.icon+\'_color.svg\'}}\" \nmd-menu-align-target></md-icon><span>{{item.translationPath+\'_LITTLE\' | translate}}</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div><customizer-part \nng-if=\"vm.partPlacement[vm.area]==\'\'||vm.partPlacement[vm.area]==\'customizer-part\'\" area=\"vm.area\" class=\"full-height\" \ntemplate-data=\"vm.templateData\">></customizer-part><contact-part ng-if=\"vm.partPlacement[vm.area]==\'contact-part\'\" \nclass=\"full-height\" contact-map-address=\"vm.templateData.contactMapAddress\" contact-id=\"vm.templateData.contactId\" \nreserved-number=\"vm.templateData.reservedNumber\"></contact-part><chat-part \nng-if=\"vm.partPlacement[vm.area]==\'chat-part\'\" class=\"full-height\" template-data=\"vm.templateData\"></chat-part>\n<map-part ng-if=\"vm.partPlacement[vm.area]==\'map-part\'\" search-address=\"vm.templateData.contactMapAddress\" \nclass=\"full-height\"></map-part><notes-part ng-if=\"vm.partPlacement[vm.area]==\'notes-part\'\" class=\"full-height\" \ncontact-id=\"vm.templateData.contactId\" reserved-number=\"vm.templateData.reservedNumber\" \ncolor-main=\"vm.templateData.colorMain\"></notes-part><service-part ng-if=\"vm.partPlacement[vm.area]==\'service-part\'\" \nclass=\"full-height\" service-id=\"vm.templateData.currentServiceId\" \nservice-communication-params=\"vm.templateData.serviceCommunicationParams\"></service-part><survey-part \nng-if=\"vm.partPlacement[vm.area]==\'survey-part\'\" class=\"full-height\" service-id=\"vm.templateData.currentServiceId\" \ncontact-id=\"vm.templateData.contactId\" reserved-number=\"vm.templateData.reservedNumber\"></survey-part><categories-part \nng-if=\"vm.partPlacement[vm.area]==\'categories-part\'\" class=\"full-height\" service-id=\"vm.templateData.currentServiceId\" \ncontact-id=\"vm.templateData.contactId\" session-id=\"vm.templateData.messageSessionId\" \nsession-guid=\"vm.templateData.sessionId\"></categories-part></div>");
$templateCache.put("app/main/contactcenter/communicator/components/mappart/mappart.html","<div layout=\"column\" id=\"map-container\" class=\"easy-content\"><md-toolbar class=\"header md-primary-bg\" layout=\"row\" \nlayout-align=\"start center\"><div layout=\"row\" layout-align=\"center center\"><div class=\"icon-container\"><img \nclass=\"ico-ico\" src=\"assets/icons/communicator/placeholder.svg\"></div><span class=\"header-part\" \ntranslate=\"COMMUNICATOR.MAP.TITLE\">Lokalizacje</span></div></md-toolbar><div id=\"mapdiv\" flex><leaflet bounds=\"bounds\" \nid=\"mapTag\" geojson=\"geojson\" lf-center=\"address\" height=\"100%\"></leaflet></div><div flex=\"15\" layout=\"row\" \nclass=\"search-padding\" layout-align=\"center center\"><div class=\"pl-button\" layout=\"column\" \nlayout-align=\"center center\" ng-class=\"{\'pl-active\':vm.PLSearchIsActive}\" ng-click=\"vm.tooglePLSearch()\"><span>PL\n</span><md-tooltip md-direction=\"top\"><span ng-if=\"vm.PLSearchIsActive\" translate=\"COMMUNICATOR.MAP.SEARCH_PL\"></span> \n<span ng-if=\"!vm.PLSearchIsActive\" translate=\"COMMUNICATOR.MAP.SEARCH_WORLD\"></span></md-tooltip></div>\n<md-input-container flex><label translate=\"COMMUNICATOR.MAP.SEARCH_ADDRESS\"></label><input \nng-keypress=\"vm.searchKeyPress($event)\" class=\"md-24 find-loc-bt\" ng-model=\"vm.searchAddress\"></md-input-container>\n<md-icon md-font-icon=\"icon-magnify\" class=\"bt-pointer search-bt\" ng-click=\"vm.goToAddress()\"></md-icon></div></div>");
$templateCache.put("app/main/contactcenter/communicator/components/customizerpart/customizerpart.html","<div layout=\"column\" id=\"customizer\" class=\"easy-content\"><md-content flex ms-scroll=\"\" layout=\"column\" \nlayout-align=\"center center\"><div ng-repeat=\"item in vm.allowedParts\" bind-html-compile=\"item.markup\" \nclass=\"cosumizer-button\"></div></md-content></div>");
$templateCache.put("app/main/contactcenter/communicator/components/contactpart/contactPart.html","<div layout=\"column\" id=\"contact-container\" class=\"easy-content\"><div class=\"tabs header\" layout=\"row\" \nlayout-align=\"end center\" ng-class=\"{\'reserved-number\':vm.reservedNumber}\"><div style=\"width: 100%\"><div layout=\"row\" \nlayout-align=\"start center\" style=\"width: 100%\"><span class=\"header-part\" ng-if=\"vm.reservedNumber\" \ntranslate=\"COMMUNICATOR.RESERVEDNUMBER\">reserved Number</span></div><div class=\"edit-save-icon\" \nlayout-align=\"end center\" layout=\"row\"><div ng-show=\"vm.saveInProgress && !vm.saved\"><i class=\"fa fa-pencil\" \naria-hidden=\"true\"></i></div><div ng-show=\"!vm.saveInProgress && vm.saved\"><i class=\"fa fa-check\" aria-hidden=\"true\">\n</i></div></div></div><div layout=\"row\" layout-align=\"center center\" class=\"tab-div\"><div layout-align=\"center center\" \nlayout=\"row\" class=\"tab-button general-tab\" ng-click=\"vm.toogleTab(1)\" \nng-class=\"{\'tab-button-not-active\':!vm.filterObject.general,\'tab-button-active\':vm.filterObject.general}\"><div \ntranslate=\"COMMUNICATOR.CLIENT.TITLE_GENERAL\" class=\"tab-label\">Ogólne</div></div><div layout-align=\"center center\" \nlayout=\"row\" class=\"tab-button all-tab\" ng-click=\"vm.toogleTab(2)\" \nng-class=\"{\'tab-button-not-active\':!vm.filterObject.all,\'tab-button-active\':vm.filterObject.all}\"><div \ntranslate=\"COMMUNICATOR.CLIENT.TITLE_ALL\" class=\"tab-label\">Wszystkie</div></div></div></div><div \nng-hide=\"vm.dataLoaded.contact\" layout=\"column\" layout-align=\"center center\"><md-progress-linear md-mode=\"query\" \nng-disabled=\"vm.dataLoaded.contact\"></md-progress-linear></div><span ng-if=\"vm.error\" class=\"errorMesg\" \ntranslate=\"COMMUNICATOR.ERROR_WHEN_PART_LOADED\">Wystapił bład</span><md-content flex class=\"empty-content\" \nng-if=\"vm.rollDown\" ms-scroll layout=\"column\" layout-align=\"center center\"><img class=\"gigant-ico\" \nsrc=\"assets/icons/communicator/head.svg\"></md-content><md-content flex class=\"content\" \nng-if=\"!vm.rollDown && vm.filterObject.general\" ms-scroll><form name=\"contactForm\" class=\"md-inline-form\" novalidate>\n<div class=\"field-group general-group\"><div class=\"group-label\" flex layout=\"row\" layout-align=\"center center\"><span \ntranslate=\"COMMUNICATOR.CLIENT.GROUP_GENERAL\">Ogólne</span></div><div layout=\"row\"><md-input-container flex \nclass=\"lower-input side-margin\"><label translate=\"COMMUNICATOR.CLIENT.NAME\">Name</label><input \nng-model=\"vm.activeContact.name\" type=\"text\" ng-change=\"vm.waitAndSave()\"></md-input-container></div>\n<md-input-container flex class=\"lower-input side-margin\"><label translate=\"COMMUNICATOR.CLIENT.SURNAME\">Surname</label>\n<input ng-model=\"vm.activeContact.surname\" type=\"text\" ng-change=\"vm.waitAndSave()\"></md-input-container>\n<md-input-container flex class=\"lower-input side-margin\"><label translate=\"COMMUNICATOR.CLIENT.SEX\">Płeć</label>\n<md-select ng-model=\"vm.activeContact.sex\" ng-change=\"vm.waitAndSave()\"><md-option><em>----</em></md-option><md-option \nng-repeat=\"sex in vm.sexList\" ng-value=\"sex.value\">{{sex.name}}</md-option></md-select></md-input-container>\n<md-input-container flex class=\"birthday-picker side-margin\"><label translate=\"COMMUNICATOR.CLIENT.BIRTHDATE\">\ndata urodzenia</label><md-datepicker ng-model=\"vm.activeContact.birthday\" md-open-on-focus class=\"picker\" \nng-change=\"vm.proccessBirthDate(); vm.waitAndSave()\"></md-datepicker></md-input-container><md-input-container flex \nclass=\"lower-input side-margin\"><label translate=\"COMMUNICATOR.CLIENT.AGE\">Age</label><input \nng-model=\"vm.activeContact.age\" type=\"number\" min=\"0\" ng-change=\"vm.proccessBirthDate(); vm.waitAndSave()\">\n</md-input-container><md-input-container flex class=\"lower-input side-margin\"><label \ntranslate=\"COMMUNICATOR.CLIENT.CITY\">Miasto</label><input ng-model=\"vm.activeContact.city\" type=\"text\" \nng-change=\"vm.waitAndSave()\"></md-input-container></div></form></md-content><md-content flex class=\"content\" \nng-if=\"!vm.rollDown && vm.filterObject.all\" ms-scroll><form name=\"contactForm\" class=\"md-inline-form\" novalidate><div \nclass=\"field-group general-group\"><div class=\"group-label\" flex layout=\"row\" layout-align=\"center center\"><span \ntranslate=\"COMMUNICATOR.CLIENT.GROUP_GENERAL\">Ogólne</span></div><div layout=\"row\"><md-input-container flex \nclass=\"lower-input side-margin\"><label translate=\"COMMUNICATOR.CLIENT.NAME\">Name</label><input \nng-model=\"vm.activeContact.name\" type=\"text\" ng-change=\"vm.waitAndSave()\"></md-input-container></div>\n<md-input-container flex class=\"lower-input side-margin\"><label translate=\"COMMUNICATOR.CLIENT.SURNAME\">Surname</label>\n<input ng-model=\"vm.activeContact.surname\" type=\"text\" ng-change=\"vm.waitAndSave()\"></md-input-container>\n<md-input-container flex class=\"lower-input side-margin\"><label translate=\"COMMUNICATOR.CLIENT.SEX\">Płeć</label>\n<md-select ng-model=\"vm.activeContact.sex\" ng-change=\"vm.waitAndSave()\"><md-option><em>----</em></md-option><md-option \nng-repeat=\"sex in vm.sexList\" ng-value=\"sex.value\">{{sex.name}}</md-option></md-select></md-input-container>\n<md-input-container flex class=\"birthday-picker side-margin\"><label translate=\"COMMUNICATOR.CLIENT.BIRTHDATE\">\ndata urodzenia</label><md-datepicker ng-model=\"vm.activeContact.birthday\" md-min-date=\"vm.minAllowedDate\" \nmd-open-on-focus class=\"picker\" ng-change=\"vm.proccessBirthDate(); vm.waitAndSave()\"></md-datepicker>\n</md-input-container><md-input-container flex class=\"lower-input side-margin\"><label \ntranslate=\"COMMUNICATOR.CLIENT.AGE\">Age</label><input ng-model=\"vm.activeContact.age\" type=\"number\" min=\"0\" \nng-change=\"vm.proccessBirthDate(); vm.waitAndSave()\"></md-input-container></div><div class=\"contact-group field-group\">\n<div class=\"group-label\" flex layout=\"row\" layout-align=\"center center\"><span \ntranslate=\"COMMUNICATOR.CLIENT.GROUP_CONTACT_DATA\">Dane kontaktowe</span></div><div layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-phone smaller-icon\"></md-icon><md-input-container flex \nclass=\"lower-input side-margin\"><label translate=\"COMMUNICATOR.CLIENT.PHONE\">Telefon</label><input \nng-model=\"vm.activeContact.msisdnCoded\" type=\"text\" ng-disabled=\"!vm.changingPhoneNo\"></md-input-container><md-icon \nmd-font-icon=\"icon-lock-unlocked smaller-icon change-secret-field\" ng-hide=\"vm.changingPhoneNo\" \nng-click=\"vm.startPhoneChangeing()\"><md-tooltip md-direction=\"Top\">Zmień</md-tooltip></md-icon><md-icon \nmd-font-icon=\"icon-cancel smaller-icon cancel-secret-field\" ng-show=\"vm.changingPhoneNo\" \nng-click=\"vm.cancelPhoneChangeing()\"><md-tooltip md-direction=\"Top\">Anuluj</md-tooltip></md-icon><md-icon \nmd-font-icon=\"icon-content-save smaller-icon save-secret-field\" ng-show=\"vm.changingPhoneNo\" \nng-click=\"vm.savePhoneChangeing()\"><md-tooltip md-direction=\"Top\">Zapisz</md-tooltip></md-icon></div><div layout=\"row\">\n<md-icon md-font-icon=\"icon-email smaller-icon\"></md-icon><md-input-container flex class=\"lower-input side-margin\">\n<label translate=\"COMMUNICATOR.CLIENT.EMAIL\">Email</label><input ng-model=\"vm.activeContact.emailCoded\" type=\"text\" \nng-disabled=\"!vm.changingEmail\"></md-input-container><md-icon \nmd-font-icon=\"icon-lock-unlocked smaller-icon change-secret-field\" ng-hide=\"vm.changingEmail\" \nng-click=\"vm.startEmailChangeing()\"><md-tooltip md-direction=\"Top\">Zmień</md-tooltip></md-icon><md-icon \nmd-font-icon=\"icon-cancel smaller-icon cancel-secret-field\" ng-show=\"vm.changingEmail\" \nng-click=\"vm.cancelEmailChangeing()\"><md-tooltip md-direction=\"Top\">Anuluj</md-tooltip></md-icon><md-icon \nmd-font-icon=\"icon-content-save smaller-icon save-secret-field\" ng-show=\"vm.changingEmail\" \nng-click=\"vm.saveEmailChangeing()\"><md-tooltip md-direction=\"Top\">Zapisz</md-tooltip></md-icon></div><div layout=\"row\">\n<md-icon md-font-icon=\"icon-cloud smaller-icon\"></md-icon><md-input-container flex class=\"lower-input side-margin\">\n<label translate=\"COMMUNICATOR.CLIENT.WWW\">Strona WWW</label><input ng-model=\"vm.activeContact.wwwAddress\" type=\"text\" \nng-change=\"vm.waitAndSave()\"></md-input-container></div></div><div class=\"address-group field-group\"><div \nclass=\"group-label\" flex layout=\"row\" layout-align=\"center center\"><span translate=\"COMMUNICATOR.CLIENT.GROUP_ADDRESS\">\nAdres</span></div><md-input-container flex class=\"lower-input side-margin\"><label \ntranslate=\"COMMUNICATOR.CLIENT.COUNTRY\">Kraj</label><input ng-model=\"vm.activeContact.country\" type=\"text\" \nng-change=\"vm.waitAndSave()\"></md-input-container><md-input-container flex class=\"lower-input side-margin\"><label \ntranslate=\"COMMUNICATOR.CLIENT.COUNTY\">Wojewdztwo</label><input ng-model=\"vm.activeContact.county\" type=\"text\" \nng-change=\"vm.waitAndSave()\"></md-input-container><md-input-container flex class=\"lower-input side-margin\"><label \ntranslate=\"COMMUNICATOR.CLIENT.CITY\">Miasto</label><input ng-model=\"vm.activeContact.city\" type=\"text\" \nng-change=\"vm.waitAndSave()\"></md-input-container><md-input-container flex class=\"lower-input side-margin\"><label \ntranslate=\"COMMUNICATOR.CLIENT.STREET\">Ulica</label><input ng-model=\"vm.activeContact.street\" type=\"text\" \nng-change=\"vm.waitAndSave()\"></md-input-container><md-input-container flex class=\"lower-input side-margin\"><label \ntranslate=\"COMMUNICATOR.CLIENT.HOUSENO\">Numer budynku</label><input ng-model=\"vm.activeContact.houseNo\" type=\"text\" \nng-change=\"vm.waitAndSave()\"></md-input-container><md-input-container flex class=\"lower-input side-margin\"><label \ntranslate=\"COMMUNICATOR.CLIENT.LOKALNO\">Nr lokalu</label><input ng-model=\"vm.activeContact.localNo\" type=\"text\" \nng-change=\"vm.waitAndSave()\"></md-input-container></div><div class=\"work-group field-group\"><div class=\"group-label\" \nflex layout=\"row\" layout-align=\"center center\"><span translate=\"COMMUNICATOR.CLIENT.GROUP_JOB\">Praca</span></div>\n<md-input-container flex class=\"lower-input side-margin\"><label translate=\"COMMUNICATOR.CLIENT.JOB\">Zawod</label><input\n ng-model=\"vm.activeContact.job\" type=\"text\" ng-change=\"vm.waitAndSave()\"></md-input-container><md-input-container \nflex class=\"lower-input side-margin\"><label translate=\"COMMUNICATOR.CLIENT.JOB_POSITION\">Stanowisko</label><input \nng-model=\"vm.activeContact.jobPosition\" type=\"text\" ng-change=\"vm.waitAndSave()\"></md-input-container></div></form>\n</md-content></div>");
$templateCache.put("app/main/contactcenter/communicator/components/notespart/notesPart.html","<div layout=\"column\" id=\"notes-container\" class=\"easy-content\"><md-toolbar class=\"header md-primary-bg\" layout=\"row\" \nlayout-align=\"start center\" ng-class=\"{\'reserved-number\':vm.reservedNumber}\"><div layout=\"row\" \nlayout-align=\"center center\"><div class=\"icon-container\"><img class=\"ico-ico\" src=\"assets/icons/communicator/edit.svg\">\n</div><span class=\"header-part\" translate=\"COMMUNICATOR.NOTES.TITLE\">Notes</span> <span class=\"header-part\" \nstyle=\"margin-left: 10px\" ng-if=\"vm.reservedNumber\" translate=\"COMMUNICATOR.RESERVEDNUMBER\">reserved Number</span>\n</div></md-toolbar><span ng-if=\"vm.error\" class=\"errorMesg\" translate=\"COMMUNICATOR.ERROR_WHEN_PART_LOADED\">\nWystapił bład</span><md-content flex class=\"empty-content\" ng-show=\"vm.rollDown\" ms-scroll layout=\"column\" \nlayout-align=\"center center\"><img class=\"gigant-ico\" src=\"assets/icons/communicator/edit.svg\"></md-content><div flex \nlayout=\"column\" ng-hide=\"vm.rollDown\" class=\"content\"><md-content flex ms-scroll><div ng-hide=\"vm.dataLoaded.notes\">\n<md-progress-linear md-mode=\"query\" ng-disabled=\"vm.dataLoaded.notes\"></md-progress-linear></div><div \nid=\"contactNotes\"><md-list class=\"note-list\"><md-list-item ng-repeat=\"note in vm.notes | orderBy:\'-insertionTime\'\" \nclass=\"note-row\"><div flex><div layout=\"row\" layout-align=\"space-around center\" flex class=\"note-row-header\"><div flex \nclass=\"note-date\">{{note.insertionTime | date:\'yyyy-MM-dd HH:mm\'}}</div><div flex class=\"note-author\" layout=\"row\" \nlayout-align=\"end center\"><span>{{note.nameToDisplay}}</span></div></div><div flex class=\"note-row-body\">\n{{note.description}}</div></div></md-list-item></md-list></div></md-content><form class=\"reply-form note-form\" \nlayout=\"row\" layout-align=\"start center\"><md-input-container class=\"note-new\" flex md-no-float style=\"margin: 0px\">\n<label translate=\"COMMUNICATOR.NOTES.NEW_NOTES\">Nowa notatka</label><textarea md-no-autogrow ng-model=\"vm.newNote\" \naria-label=\"note box\" rows=\"1\" ng-keypress=\"vm.noteKeyPress($event)\" ng-change=\"vm.changeNote()\">\n                        </textarea></md-input-container><md-button class=\"md-fab md-fab-mini note-send-bt\" \ntype=\"submit\" aria-label=\"Send message\" translate ng-class=\"vm.colorMain\" ng-click=\"vm.addNewNote()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></form></div></div>");
$templateCache.put("app/main/contactcenter/communicator/components/surveypart/surveypart.html","<div layout=\"column\" id=\"surveys-container\" class=\"easy-content\"><md-toolbar class=\"header md-primary-bg\" layout=\"row\" \nlayout-align=\"start center\" ng-class=\"{\'reserved-number\':vm.reservedNumber}\"><div flex=\"100\" class=\"h-50\" layout=\"row\" \nlayout-align=\"start center\"><div flex=\"15\" class=\"icon-container\"><img class=\"ico-ico\" \nsrc=\"assets/icons/communicator/clipboard.svg\"></div><span ng-if=\"!vm.contactId\" class=\"header-part\">ANKIETY</span>\n<md-tabs ng-if=\"vm.contactId\" flex class=\"survey-tab mr-55\" md-autoselect md-swipe-content><md-tab \nng-repeat=\"survey in vm.serviceSurveys\" md-on-select=\"vm.surveyChanged(survey)\" label=\"{{::survey.name}}\"></md-tab>\n<md-tab ng-if=\"!vm.activeSurvey\" label=\"Brak ankiet\"></md-tab></md-tabs></div></md-toolbar><span ng-if=\"vm.error\" \nclass=\"errorMesg\" translate=\"COMMUNICATOR.ERROR_WHEN_PART_LOADED\">Wystapił bład</span><md-content flex \nclass=\"empty-content\" ng-show=\"vm.rollDown\" ms-scroll layout=\"column\" layout-align=\"center center\"><img \nclass=\"gigant-ico\" src=\"assets/icons/communicator/clipboard.svg\"></md-content><div flex layout=\"column\" \nng-hide=\"vm.rollDown\" class=\"content\"><md-content flex ms-scroll><div ng-if=\"(!vm.dataLoaded.surveys) && vm.contactId\">\n<md-progress-linear md-mode=\"query\"></md-progress-linear></div><div ng-if=\"!vm.activeSurvey\" layout=\"column\" \nlayout-align=\"center stretch\"><span flex>Brak dostępnych ankiet</span></div><div ng-if=\"vm.activeSurvey\" \nlayout=\"column\" layout-align=\"start stretch\"><dynamic-form flex class=\"pl-10 pr-10 mt-20\" \nng-if=\"vm.activeSurvey.config && vm.contactId\" form-config=\"vm.activeSurvey.config\" settings=\"vm.answers\">\n</dynamic-form><div flex ng-if=\"!vm.contactId\" layout=\"column\" layout-align=\"start stretch\"><span>\nNajperw zapisz kontakt</span></div></div></md-content><md-button type=\"submit\" \nclass=\"md-icon-button save-button bt-pointer md-accent-fg save-bt\" ng-click=\"vm.saveAnswers()\" \nng-disabled=\"!vm.contactId\"><img src=\"assets/icons/triple-view/zapisz.png\"></md-button></div></div>");
$templateCache.put("app/main/contactcenter/communicator/components/servicepart/servicePart.html","<div layout=\"column\" id=\"service-content\" class=\"easy-content\"><md-toolbar class=\"header md-primary-bg\" layout=\"row\" \nlayout-align=\"start center\"><div layout=\"row\" layout-align=\"center center\"><div class=\"icon-container\"><img \nclass=\"ico-ico\" src=\"assets/icons/communicator/settings.svg\"></div><span class=\"header-part\" \ntranslate=\"COMMUNICATOR.SERVICE.TITLE\">Service</span></div></md-toolbar><span ng-if=\"vm.error\" class=\"errorMesg\" \ntranslate=\"COMMUNICATOR.ERROR_WHEN_PART_LOADED\">Wystapił bład</span><md-content flex class=\"empty-content\" \nng-show=\"vm.rollDown\" ms-scroll layout=\"column\" layout-align=\"center center\"><img class=\"gigant-ico\" \nsrc=\"assets/icons/communicator/settings.svg\"></md-content><md-content flex class=\"content\" ms-scroll layout=\"column\" \nng-hide=\"vm.rollDown\"><div ng-hide=\"vm.dataLoaded.service\"><md-progress-linear md-mode=\"query\" \nng-disabled=\"vm.dataLoaded.notes\"></md-progress-linear></div><div layout=\"row\"><div flex=\"50\" layout=\"column\"><div \nclass=\"info-line\"><div class=\"title\" translate=\"COMMUNICATOR.SERVICE.TYPE\">Typ</div><div class=\"info\">\n{{vm.serviceData.typeText}}</div></div><div class=\"info-line\"><div class=\"title\" translate=\"COMMUNICATOR.SERVICE.NAME\">\nNazwa</div><div class=\"info\">{{vm.serviceData.serviceName}}</div></div></div><div flex=\"50\" \nng-if=\"vm.serviceData.photoUrl\"><img alt=\"{{vm.serviceData.serviceName}}\" ng-src=\"{{vm.serviceData.photoUrl}}\"></div>\n</div><div class=\"info-line\" ng-if=\"vm.serviceData.serviceDesc\"><div class=\"title\" \ntranslate=\"COMMUNICATOR.SERVICE.DESCRIPTION\">Opis</div><div class=\"info\">{{vm.serviceData.serviceDesc}}</div></div><div\n class=\"info-line\" ng-if=\"vm.bundleServices.smsService.loadded\"><div class=\"title\" \ntranslate=\"COMMUNICATOR.SERVICE.SMS_SERVICE.TITLE\">Powiązany serwis SMS</div><div class=\"info\" layout=\"row\"><span \ntranslate=\"COMMUNICATOR.SERVICE.SMS_SERVICE.NAME\" style=\"margin-right: 10px\">Nazwa serwisu</span> <span>\n{{vm.bundleServices.smsService.Name}}</span></div><div class=\"info\" layout=\"row\"><span \ntranslate=\"COMMUNICATOR.SERVICE.SMS_SERVICE.LA\" style=\"margin-right: 10px\">LA: </span><span>\n{{vm.bundleServices.smsService.LA}}</span></div></div><div class=\"info-line\" ng-if=\"vm.serviceCommunicationParams\"><div\n class=\"param-containter\"><div ng-repeat=\"(key,value) in vm.serviceCommunicationParams\">{{key+\' : \'+value}}</div></div>\n</div></md-content></div>");
$templateCache.put("app/main/contactcenter/communicator/menucomponents/activesession/activesession.html","<div id=\"active-session\"><div ng-show=\"vm.communicatorService.communicatorType === \'client\'\"><div class=\"empty\" \nlayout=\"column\" layout-align=\"space-between center\" \nng-if=\"vm.communicatorService.activeSession.length === 0 && vm.communicatorService.historySession.length === 0\">\n<md-icon class=\"gigant-ico\" md-svg-src=\"assets/navigation/silence.svg\"></md-icon><label \ntranslate=\"COMMUNICATOR.EMPTY_SESSION\">Brak sesji</label></div><session-list \nlist=\"vm.communicatorService.activeSession\" type=\'\"active\"\'></session-list><div style=\"padding: 5px\"></div>\n<session-list list=\"vm.communicatorService.historySession\" type=\'\"history\"\'></session-list><div \nclass=\"communication-history\" layout=\"row\" layout-align=\"center center\" ng-click=\"vm.showHist=!vm.showHist;\"><md-icon \nclass=\"clock-icon\" md-svg-src=\"/assets/icons/communicator/clock-hist-sessions.svg\"></md-icon><span flex \ntranslate=\"COMMUNICATOR.ACTIVE_SESSION.CLOSED_SESSIONS\">HISTORIA KOMUNIKACJI</span><div flex=\"20\" \nclass=\"arrow-containner\"><i class=\"arrow-icon icon-chevron-up\" ng-show=\"vm.showHist\"></i> <i \nclass=\"arrow-icon icon-chevron-down\" ng-hide=\"vm.showHist\"></i></div></div><div ng-show=\"vm.showHist\"><session-list \nlist=\"vm.communicatorService.historySession\" type=\'\"closed\"\'></session-list></div></div><div \nng-show=\"vm.communicatorService.communicatorType === \'internal\'\"><internal-list \nlist=\"vm.internalMessageService.objectList\" type=\'\"active\"\'></internal-list></div></div>");
$templateCache.put("app/main/contactcenter/communicator/internalmessage/internalchat/internalchat.html","<div layout=\"column\" class=\"easy-content full-height\"><md-toolbar class=\"header md-primary-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"center center\"><div class=\"icon-container\"><img \nclass=\"ico-ico\" src=\"assets/icons/communicator/speech_bubble.svg?v=1.0.1\"></div><span class=\"header-part\" \ntranslate=\"COMMUNICATOR.CHAT.TITLE\">CHAT</span></div></md-toolbar><div flex layout=\"column\" class=\"chat-content\">\n<md-content flex class=\"empty-content full-height\" ng-show=\"!vm.chatData || (vm.chatData && vm.chatData.length === 0)\" \nms-scroll layout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\" \nstyle=\"height: 100%\"><span translate=\"COMMUNICATOR.NOTIFY_NO_MESSAGE_TO_PROCESS\" \nstyle=\"margin-bottom: 40px; color: rgba(128, 128, 128, 0.52)\">No Message to Process</span> <img class=\"gigant-ico\" \nsrc=\"assets/icons/communicator/speech_bubble.svg?v=1.0.1\"></div></md-content><md-content \nng-show=\"vm.chatData && vm.chatData.length>0\" flex layout=\"column\" ms-scroll scroll-glue=\"vm.dataLoaded.scroll\" \nclass=\"chat-md-content\"><div class=\"chat-messages\" flex layout-fill><div layout=\"row\" layout-align=\"start start\" \nng-repeat=\"dialog in vm.chatData\" class=\"md-padding message-row\" \nng-class=\"dialog.direction === \'I\' ? \'contact\' : \'user\'\"><div layout=\"column\" layout-align=\"center center\" \nclass=\"avatar-container\"><img ng-if=\"dialog.authorPhotoUrl\" class=\"avatar\" ng-src=\"{{dialog.authorPhotoUrl}}\"><div \nng-if=\"!dialog.authorPhotoUrl\" class=\"avatar avatar-svg\"></div><div class=\"author-name\" ng-if=\"dialog.authorName\">\n{{dialog.authorName}}</div></div><div layout=\"column\" class=\"bubble bubble-{{dialog.direction}}\" \nng-class=\"dialog.direction===\'I\'?vm.colorSecondary:vm.colorMain\"><div class=\"time date-text\">\n{{dialog.insertionTime | communicatorDateFilter2}}</div><div layout=\"row\" flex><div class=\"content\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"message\" bind-html-compile=\"vm.findGuidAndChangeToOnClick(dialog.body)\"></div>\n</div></div></div></div></div></md-content><div class=\"chat-footer\" layout=\"column\"><div layout=\"column\"><form flex \nng-submit=\"vm.sendMessage()\" class=\"reply-form\" layout=\"row\" layout-align=\"start center\"><md-input-container flex \nmd-no-float><label translate=\"COMMUNICATOR.REPLY_PLACEHOLDER\">Wprowadź treść odpowiedzi</label><textarea msd-elastic \nmd-no-autogrow ng-model=\"vm.replyMessage\" aria-label=\"reply box\" rows=\"1\" focusable=\"{{vm.dataLoaded.chat}}\" \nng-keypress=\"vm.answerKeyPress($event)\">\r\n                      </textarea></md-input-container><div><md-button \nclass=\"md-fab md-fab-mini\" type=\"submit\" aria-label=\"Send message\" ng-class=\"vm.colorMain\"><img \nclass=\"ico-chat send-bt\" src=\"assets/icons/communicator/send_msg.svg?v=1.0.1\"></md-button></div></form></div></div>\n</div></div>");
$templateCache.put("app/main/contactcenter/communicator/internalmessage/internalinfo/internalinfo.html","<div layout=\"column\" class=\"easy-content full-height\"><md-toolbar class=\"header md-primary-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"center center\"><div class=\"icon-container\"><img \nclass=\"ico-ico\" src=\"assets/icons/communicator/speech_bubble.svg?v=1.0.1\"></div><span class=\"header-part\" \ntranslate=\"COMMUNICATOR.INTERNAL_INFO.TITLE\">INFO</span></div></md-toolbar><div flex layout=\"column\" \nlayout-align=\"space-between center\" class=\"content p-16\" ng-if=\"vm.communicatorObject\"><div class=\"basic-info\"><div \nclass=\"avatar-wrapper\"><img flex ng-if=\"vm.communicatorObject.photoUrl\" md-menu-align-target class=\"avatar\" \nng-src=\"{{vm.communicatorObject.photoUrl}}\"><div ng-if=\"!vm.communicatorObject.photoUrl\" class=\"avatar default-avatar\">\n<md-icon flex md-svg-src=\"/assets/navigation/avatar.svg\" aria-label=\"avatar\"></md-icon></div><div class=\"name pt-8\">\n{{vm.communicatorObject.name}}</div><div class=\"status-con pt-8\" ng-if=\"vm.objectType===\'C\'\">\n{{vm.communicatorObject.status && vm.communicatorObject.status === 1 ? \'online\':\'offline\'}}</div></div></div><div \nclass=\"consultants pt-8\" ng-if=\"vm.consultantsInGroup\"><div class=\"title pb-8\" \ntranslate=\"COMMUNICATOR.INTERNAL_INFO.CONSULTANTS\">Konsultanci</div><div class=\"con-content\" ng-scrollbars \nng-scrollbars-config=\"vm.configScroll\"><div layout=\"row\" layout-align=\"start center\" class=\"consultant pb-8\" \nng-repeat=\"con in vm.consultantsInGroup\"><div class=\"avatar-wrapper\"><img flex ng-if=\"con.photoUrl\" \nmd-menu-align-target class=\"avatar\" ng-src=\"{{con.photoUrl}}\"><div ng-if=\"!con.photoUrl\" class=\"avatar default-avatar\">\n<md-icon flex md-svg-src=\"/assets/navigation/avatar.svg\" aria-label=\"avatar\"></md-icon></div></div><div \nclass=\"name pl-8\">{{con.alias?con.alias:(con.firstName+\' \'+con.lastName)}}</div></div></div></div></div></div>");
$templateCache.put("app/main/contactcenter/communicator/sessionlist/sessioninfo/sessioninfo.html","<div id=\"sessionInfo\" class=\"sessionInfo\"><div class=\"sessionInfo__header\"><div class=\"closeDialog\" \nng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" class=\"s24\"></md-icon></div><div \nclass=\"sessionInfo__header__nav\"><div class=\"sessionInfo__header__nav__item\" ng-click=\"vm.showTextarea();\"><img \nsrc=\"assets/icons/worker.svg\" alt=\"\"></div></div></div><md-content ng-if=\"vm.showWarrning\"><div><form \nclass=\"formWarring\"><md-input-container class=\"md-block\"><label>Uwagi</label><textarea ng-model=\"vm.messageWarring\" \nrows=\"1\" md-select-on-focus></textarea><md-button class=\"sendToMagaresButton\" type=\"submit\" \nng-click=\"vm.sendMessage();\"><img src=\"assets/icons/communicator/send_msg.svg?v=1.0.1\" alt=\"\"></md-button>\n</md-input-container></form></div></md-content><div class=\"sessionInfo__body\"><div class=\"sessionInfo__body__details\">\n<h3>Dane sesji</h3><ul><li>Id: <span>{{vm.sessionInfo.session.id}}</span></li><li>Id Sesji: <span>\n{{vm.sessionInfo.session.sessionID }}</span></li><li>Nazwa Serwisu: <span>{{ vm.sessionInfo.session.serviceName }}\n</span></li><li>Id Serwisu: <span>{{ vm.sessionInfo.session.serviceID }}</span></li><li>Status: <span>\n{{ vm.sessionInfo.session.statusId }} ({{ vm.sessionInfo.session.statusDesc }})</span></li><li>Start: <span>\n{{ vm.sessionInfo.session.insertionTime }}</span></li><li>Stop: <span>{{ vm.sessionInfo.session.finished }}</span></li>\n</ul></div><hr><div class=\"sessionInfo__body__details\"><h3>Kategoryzacja</h3><ul><li \nng-repeat=\"item in vm.sessionInfo.categories\">{{ item }}</li></ul></div><hr><div class=\"sessionInfo__body__details\">\n<h3>Dane konsultanta</h3><ul><li>Id Konsultanta: <span>{{ vm.sessionInfo.session.consultantID }}</span></li><li>Alias: \n<span>{{vm.sessionInfo.session.alias}}</span></li><li>Imię i nazwisko: <span>\n{{ vm.sessionInfo.session.firstName }} {{ vm.sessionInfo.session.lastName }}</span></li><li>Login: <span>\n{{ vm.sessionInfo.session.login }}</span></li></ul></div><hr><div class=\"sessionInfo__body__details\"><h3>Dane klienta\n</h3><ul><li>Id kontaktu: <span>{{ vm.sessionInfo.session.contactId }}</span></li><li>Nazwa: <span>\n{{ vm.sessionInfo.session.userName }}</span></li><li>E-mail: <span>{{ vm.sessionInfo.session.userEmail }}</span></li>\n</ul></div></div></div>");
$templateCache.put("app/main/contactcenter/communicator/sessionlist/sessiontile/sessiontile.html","<div id=\"session-tile\" layout=\"row\"><div layout=\"row\" layout-align=\"start start\" class=\"session\" \nng-class=\"{\'selected\':vm.session.isActive,\n        \'session-C\':vm.session.type===\'C\',\n        \'session-A\':vm.session.type===\'A\',\n        \'session-I\':vm.session.type===\'I\',\n        \'session-V\':vm.session.type===\'V\',\n        \'session-S\':vm.session.type===\'S\',\n        \'session-F\':vm.session.type===\'F\',\n        \'session-active\':vm.listType===\'active\',\n        \'session-history\':vm.listType===\'history\'||vm.listType===\'closed\',\n        \'closed\': vm.session.finishedAccentStart && vm.session.finishedAccent>0,\n        \'opened\':vm.session.finishedAccentStart && !vm.session.finishedAccent>0,\n        \'openedfast\':vm.session.finishedAccentStartFast && vm.session.finishedAccent>0\n      }\">\n<div flex=\"5\" class=\"type\" layout=\"column\" layout-align=\"start stretch\"><div class=\"icon party\" \nng-if=\"vm.session.party\"><i class=\"icon s24 cc-menu-icon menu-party\"></i></div><md-icon \nng-if=\"::(vm.session.type===\'I\'||vm.session.type===\'V\') && !vm.session.party\" \nmd-svg-src=\"/assets/navigation/phone-call.svg\" class=\"icon\"></md-icon><md-icon \nng-if=\"::(vm.session.type===\'S\'||vm.session.type===\'C\'||vm.session.type===\'A\')  && !vm.session.party\" \nmd-svg-src=\"/assets/navigation/speech-bubble-3.svg\" class=\"icon\"></md-icon><md-icon \nng-if=\"::vm.session.type===\'F\' && !vm.session.party\" md-svg-src=\"/assets/icons/facebook-messenger-logo.svg\" \nclass=\"icon\"></md-icon><div class=\"counterdown\" \nng-if=\"vm.listType===\'active\' && (vm.session.type===\'I\'||vm.session.type===\'V\')\" \nstyle=\"position: relative;width:27px;height:25px\"><span class=\"radius\" \nstyle=\"position: absolute;top:0px;left:0px;height:26px\"></span> <svg xmlns=\"http://www.w3.org/2000/svg\"><g><title>\nLayer 1</title><circle id=\"circle\" ng-style=\"vm.myStyle\" class=\"circle_animation\" r=\"12\" cy=\"12\" cx=\"16\" \nstroke-width=\"2\" stroke=\"#fff\" fill=\"#555555\"/></g></svg><timer class=\"call-timer\" \nng-class=\"{\'call-timer-on\':!vm.currCall.timerStopped,\'call-timer-off\':vm.currCall.timerStopped}\" interval=\"1000\" \nstart-time=\"vm.session.reservedDate\" style=\"position: absolute;left:45%;top:50%;transform:translate(-50%,-50%)\"><span>\n{{minutes}}:{{sseconds}}</span></timer></div><div class=\"messageToReply radius\" \nng-if=\"vm.listType===\'active\' && vm.session.messageToReply && (vm.session.type===\'S\'||vm.session.type===\'C\'||vm.session.type===\'A\'||vm.session.type===\'F\')\">\n<span>{{vm.session.messageToReply}}</span></div><div ng-if=\"vm.session.finished\"><md-icon \nng-if=\"vm.session.status===100\" style=\"color:#2AB982AA\" md-font-icon=\"icon-account-check\"><md-tooltip>\nZak. Problem rozwiązany</md-tooltip></md-icon><md-icon ng-if=\"vm.session.status===101\" style=\"color:#21b4c7AA\" \nmd-font-icon=\"icon-account-remove\"><md-tooltip>Zak. Brak Aktywności</md-tooltip></md-icon><md-icon \nng-if=\"vm.session.status==110\" style=\"color:#CD5C5CAA\" md-font-icon=\"icon-account-alert\"><md-tooltip>\nZak. przez manager-a</md-tooltip></md-icon><md-icon ng-if=\"vm.session.status===120\" style=\"color:#FFCC01AA\" \nmd-font-icon=\"icon-comment-remove-outline\"><md-tooltip>Zakończone przez klienta</md-tooltip></md-icon></div></div><div \nflex=\"85\" layout=\"column\" class=\"info\" style=\"max-width: 208px\"><div layout=\"row\" class=\"row\"><div flex=\"100\" \nclass=\"text session-id important-text\">\n{{\'Kontakt: \'+vm.session.contactID+(vm.session.name?\' / \'+vm.session.name+\' \'+vm.session.surname:\'\')}}</div></div><div \nlayout=\"row\" class=\"row\"><div flex=\"100\" class=\"text\">{{\'Serwis: \'+vm.session.serviceID+\' / \'+vm.session.serviceName}}\n</div></div><div layout=\"row\" class=\"row\"><div flex=\"100\" class=\"text\">{{vm.session.reservedDate | altDate}}</div>\n</div></div><div layout=\"column\" class=\"action\" layout-align=\"end start\" style=\"width: 36px\"><img \nng-if=\"(vm.session.ccserviceBundle.emailService || vm.session.emailService) && vm.session.containsGuid==false\" \nclass=\"icon email\" src=\"/assets/navigation/email_b.svg\" \nng-click=\"vm.composeDialog($event,vm.session.emailService?vm.session.emailService:vm.session.ccserviceBundle.emailService,vm.session.contactID)\">\n <img class=\"icon\" src=\"/assets/icons/information.svg\" ng-click=\"vm.informationDialog($event, vm.session)\"></div></div>\n<div class=\"session-finished-Accent\" \nng-class=\"{\'opened\': vm.session.finishedAccentStart && vm.session.finishedAccent>0,\n        \'openedfast\': vm.session.finishedAccentStartFast && vm.session.finishedAccent>0,\n        \'closed\':vm.session.finishedAccentStart && !vm.session.finishedAccent>0 \n  }\">\n<div class=\"title-bar\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-svg-src=\"/assets/navigation/speech-bubble-3.svg\" class=\"icon-type icon\"></md-icon><div flex class=\"title-div\" \nlayout=\"row\" layout-align=\"start center\"><span flex=\"50\">Zamknięto:</span> <span flex=\"30\">{{vm.session.name}}</span>\n<md-icon flex=\"20\" md-svg-src=\"/assets/icons/communicator/end_session_ok.svg\" class=\"icon-ok icon\" \nng-click=\"vm.openTagContainer($event, vm.session)\"></md-icon></div></div><div class=\"content-div\" layout=\"column\"><div \nclass=\"text\">{{\'Guid: \'+vm.session.sessionID}}</div><div class=\"text\">\n{{\'Kontakt: \'+vm.session.contactID + \', Sesja: \'+vm.session.messageSessionId}}</div><div class=\"tag-div\"><ta-tags flex \ncustom-class=\"small white2\" write-mode=\"true\" ng-model=\"vm.session.tags\" label=\"Wpisz tagi dla sesji\" \nsource-endpoint=\"\'getServiceTagsAll\'\" content-id=\"vm.session.serviceID\" show-button=\"true\" \nforce-reload=\"vm.session.forceReloadTags\" function-autosave=\"vm.autoSaveTags\"></ta-tags></div></div></div></div>");
$templateCache.put("app/main/contactcenter/communicator/templates/templateone/templateone.html","<div layout=\"row\" id=\"template-one\" class=\"template-schema\"><div flex=\"25\" class=\"column1\" layout=\"column\"><div \nflex=\"50\" class=\"row1\"><morfer area=\"\'area00\'\" template-data=\"vm.templateData\"></morfer></div><div flex=\"50\" \nclass=\"row2\"><morfer area=\"\'area01\'\" template-data=\"vm.templateData\"></morfer></div></div><div flex=\"50\" \nclass=\"column2\" layout=\"column\"><div flex=\"70\" class=\"row1\"><morfer area=\"\'area10\'\" template-data=\"vm.templateData\">\n</morfer></div><div flex=\"30\" class=\"row2\"><morfer area=\"\'area11\'\" template-data=\"vm.templateData\"></morfer></div>\n</div><div flex=\"25\" class=\"column3\" layout=\"column\"><div flex=\"50\" class=\"row1\"><morfer area=\"\'area20\'\" \ntemplate-data=\"vm.templateData\"></morfer></div><div flex=\"50\" class=\"row2\"><morfer area=\"\'area21\'\" \ntemplate-data=\"vm.templateData\"></morfer></div></div></div>");
$templateCache.put("app/main/contactcenter/communicator/templates/templatethree/templatethree.html","<div layout=\"row\" id=\"template-three\" class=\"template-schema\"><div flex=\"50\" class=\"column1\" layout=\"column\"><div \nflex=\"50\" class=\"row1\"><morfer area=\"\'area00\'\" template-data=\"vm.templateData\"></morfer></div><div flex=\"50\" \nclass=\"row2\"><morfer area=\"\'area01\'\" template-data=\"vm.templateData\"></morfer></div></div><div flex=\"50\" \nclass=\"column2\" layout=\"column\"><div flex=\"100\" class=\"row1\"><morfer area=\"\'area10\'\" template-data=\"vm.templateData\">\n</morfer></div></div></div>");
$templateCache.put("app/main/contactcenter/communicator/templates/templatetwo/templatetwo.html","<div layout=\"row\" id=\"template-two\" class=\"template-schema\"><div flex=\"30\" class=\"column1\" layout=\"column\"><div \nflex=\"50\" class=\"row1\"><morfer area=\"\'area00\'\" template-data=\"vm.templateData\"></morfer></div><div flex=\"50\" \nclass=\"row2\"><morfer area=\"\'area01\'\" template-data=\"vm.templateData\"></morfer></div></div><div flex=\"40\" \nclass=\"column2\" layout=\"column\"><div flex class=\"row1\"><morfer area=\"\'area10\'\" template-data=\"vm.templateData\">\n</morfer></div></div><div flex=\"30\" class=\"column3\" layout=\"column\"><div flex=\"50\" class=\"row1\"><morfer \narea=\"\'area20\'\" template-data=\"vm.templateData\"></morfer></div><div flex=\"50\" class=\"row2\"><morfer area=\"\'area21\'\" \ntemplate-data=\"vm.templateData\"></morfer></div></div></div>");
$templateCache.put("app/main/contactcenter/management/callcenters/templates/callcenterdetails.html","<main layout=\"column\" ng-if=\"vm.sidenavData\" class=\"base-sidenav-view\"><md-input-container flex \nng-if=\"vm.sidenavData.callCenterName\"><label>Nazwa</label><input ng-disabled=\"true\" \nng-model=\"vm.sidenavData.callCenterName\" type=\"text\"></md-input-container><md-input-container flex \nng-if=\"vm.sidenavData.updateTime\"><label>Data aktualizacji</label><input ng-disabled=\"true\" \nng-model=\"vm.sidenavData.updateTimeFormated\" type=\"text\"></md-input-container></main>");
$templateCache.put("app/main/contactcenter/management/callcenters/templates/callcenteredit.html","<dialog-component id=\"callcenter-edit\" savefunc=\"vm.currentCallCenter.id ? vm.changeActiveType :vm.saveNewCallcenter\" \ndialog-title=\"vm.currentCallCenter.id ? \'CALLCENTER.EDIT_DIALOG.EDIT_TITLE\':\'CALLCENTER.EDIT_DIALOG.NEW_TITLE\'\">\n<content layout=\"column\" layout-align=\"start stretch\" class=\"content\"><accordion-form main-form=\"vm.formValid\" \non-complete=\"vm.saveNewCallcenter\" clikcable-header=\"vm.currentCallCenter.id\" \ncount-init-progress=\"vm.currentCallCenter.id\"><form-pane pane-icon=\"/assets/icons/name-tag.svg\"><p-header><p>\nPodstawowe informacje</p></p-header><p-minified>{{vm.currentCallCenter.callCenterName}}</p-minified><p-content \nlayout=\"column\" layout-align=\"start stretch\"><md-input-container class=\"md-icon-float md-block name-field\"><label>Nazwa\n</label><input ng-model=\"vm.currentCallCenter.callCenterName\" name=\"name\" ng-disabled=\"vm.currentCallCenter.id\" \ntype=\"text\" required></md-input-container><md-input-container><label style=\"margin-bottom: 30px\">\nWybierz typ call center:</label><md-radio-group ng-model=\"vm.currentCallCenter.type\" \nng-disabled=\"vm.currentCallCenter.id\" layout=\"row\" layout-align=\"start center\" required><md-radio-button flex=\"33\" \nvalue=\"CC\" class=\"center-type-btn callcenter\" \nng-class=\"{\'no-selection\': !vm.currentCallCenter.type , \'not-selected\': vm.currentCallCenter.type && vm.currentCallCenter.type!=\'CC\' }\">\n<div layout=\"column\" layout-align=\"start stretch\"><md-icon flex md-svg-src=\"/assets/navigation/group.svg\" \naria-label=\"group\"></md-icon><span flex translate=\"CALLCENTER.EDIT_DIALOG.CC_TYPE\"></span></div></md-radio-button>\n<md-radio-button flex=\"33\" value=\"EXT\" class=\"center-type-btn external\" \nng-class=\"{\'no-selection\': !vm.currentCallCenter.type , \'not-selected\': vm.currentCallCenter.type && vm.currentCallCenter.type!=\'EXT\' }\">\n<div layout=\"column\" layout-align=\"start stretch\"><md-icon flex md-svg-src=\"/assets/icons/external-link.svg\" \naria-label=\"group\"></md-icon><span flex translate=\"CALLCENTER.EDIT_DIALOG.EXT_TYPE\"></span></div></md-radio-button>\n<md-radio-button flex=\"33\" value=\"IMP\" class=\"center-type-btn import\" ng-disabled=\"true\" \nng-class=\"{\'no-selection\': !vm.currentCallCenter.type , \'not-selected\': vm.currentCallCenter.type && vm.currentCallCenter.type!=\'IMP\' }\">\n<div layout=\"column\" layout-align=\"start stretch\"><md-icon flex md-svg-src=\"/assets/icons/import.svg\" \naria-label=\"group\"></md-icon><span flex translate=\"CALLCENTER.EDIT_DIALOG.IMP_TYPE\"></span></div></md-radio-button>\n</md-radio-group></md-input-container></p-content></form-pane><form-pane pane-icon=\"/assets/icons/price-tag.svg\">\n<p-header><p translate=\"CALLCENTER.EDIT_DIALOG.TAGS\">Tagi</p></p-header><p-minified><ta-multiselect flex \nng-disabled=\"true\" write-mode=\"false\" ng-model=\"vm.currentCallCenter.tags\"></ta-multiselect></p-minified><p-content>\n<ta-multiselect custom-class=\"big white\" write-mode=\"vm.addTag\" ng-model=\"vm.currentCallCenter.tags\" \nsource=\"vm.baseTags\"></ta-multiselect></p-content></form-pane><form-pane ng-if=\"vm.currentCallCenter.type==\'EXT\'\" \npane-icon=\"/assets/icons/access-point.svg\"><p-header><p translate=\"CALLCENTER.EDIT_DIALOG.GATEWAY\">Brama dostępu</p>\n</p-header><p-minified>{{gateway.phone}}</p-minified><p-content><external-list \nng-model=\"vm.currentCallCenter.externals\"></external-list></p-content></form-pane><form-pane \nng-if=\"vm.currentCallCenter.type == \'CC\'\" pane-icon=\"/assets/navigation/mail.svg\"><p-header><p \ntranslate=\"PROFILE.TITLE2\">Konfiguracja Email</p></p-header><p-content><md-button ng-show=\"vm.noMailbox\" \nclass=\"md-raised\" ng-click=\"vm.noMailbox = false\">Dodaj skrzynkę</md-button><settings-mailbox ng-hide=\"vm.noMailbox\" \nuid=\"vm.currentCallCenter.id\" save-indicator=\"vm.saveMail\" resource=\"ContactCenterRsc\" id-name=\"CallCenterID\" \ncolumn-order=\"true\" ng-if=\"vm.userRole <= 1\" new-record=\"vm.noMailbox\"></settings-mailbox></p-content></form-pane>\n</accordion-form></content></dialog-component>");
$templateCache.put("app/main/contactcenter/management/callcenters/templates/consultantslist.html","<div class=\"sidenav-list\"><div class=\"header search-header\" layout=\"row\" layout-align=\"start center\">\n<md-input-container flex><input flex=\"85\" name=\"search\" ng-model=\"vm.search\" type=\"text\"> <img \nsrc=\"/assets/icons/search.png\"></md-input-container></div><consultant-list search=\"vm.search\"></consultant-list></div>");
$templateCache.put("app/main/contactcenter/management/callcenters/templates/groupdetails.html","<main layout=\"column\" ng-if=\"vm.sidenavData\" class=\"base-sidenav-view\"><md-input-container flex \nng-if=\"vm.sidenavData.callCenterName\"><label translate=\"CALLCENTER.GROUP.DETAILS.NAME\">Nazwa</label><input \nng-disabled=\"true\" ng-model=\"vm.sidenavData.groupName\" type=\"text\"></md-input-container><md-input-container flex \nng-if=\"vm.sidenavData.quantity\"><label translate=\"CALLCENTER.GROUP.DETAILS.CONS_NUMBER\">Liczba konsultantów</label>\n<input ng-disabled=\"true\" ng-model=\"vm.sidenavData.quantity\" type=\"text\"></md-input-container><md-input-container flex \nng-if=\"vm.sidenavData.updateTime\"><label translate=\"CALLCENTER.GROUP.DETAILS.UPDATE_DATE\">Data aktualizacji</label>\n<input ng-disabled=\"true\" ng-model=\"vm.sidenavData.updateTime | date: \'dd-MM-yyyy HH:mm\'\" type=\"text\">\n</md-input-container></main>");
$templateCache.put("app/main/contactcenter/management/callcenters/templates/groupedit.html","<dialog-component \ndialog-title=\"vm.selectedGroup.id?\'CALLCENTER.GROUP.EDIT_DIALOG.EDIT_TITLE\':\'CALLCENTER.GROUP.EDIT_DIALOG.NEW_TITLE\'\">\n<content><accordion-form on-complete=\"vm.saveGroup\"><form-pane step-number=\"0\"><p-header><p \ntranslate=\"CALLCENTER.GROUP.EDIT_DIALOG.NAME\">Nazwa</p></p-header><p-minified>{{vm.selectedGroup.groupName}}\n</p-minified><p-content><md-input-container class=\"md-icon-float md-block\"><label \ntranslate=\"CALLCENTER.GROUP.EDIT_DIALOG.NAME\">Nazwa</label><input ng-model=\"vm.selectedGroup.groupName\" type=\"text\" \nrequired></md-input-container></p-content></form-pane><form-pane step-number=\"1\"><p-header><p \ntranslate=\"CALLCENTER.GROUP.EDIT_DIALOG.DESC\">Opis grupy</p></p-header><p-minified>{{vm.selectedGroup.description}}\n</p-minified><p-content><md-input-container class=\"md-icon-float md-block\"><label \ntranslate=\"CALLCENTER.GROUP.EDIT_DIALOG.DESC\">Opis grupy</label><textarea ng-model=\"vm.selectedGroup.description\" \nmd-maxlength=\"900\" cols=\"5\" md-select-on-focus></textarea></md-input-container></p-content></form-pane><form-pane \nstep-number=\"2\"><p-header><p translate=\"CALLCENTER.GROUP.EDIT_DIALOG.TAGS\">Tagi</p></p-header><p-minified>\n<ta-multiselect flex ng-disabled=\"true\" write-mode=\"false\" ng-model=\"vm.selectedGroup.tags\"></ta-multiselect>\n</p-minified><p-content><ta-multiselect write-mode=\"vm.addTag\" ng-model=\"vm.selectedGroup.tags\" source=\"vm.baseTags\">\n</ta-multiselect></p-content></form-pane></accordion-form></content></dialog-component>");
$templateCache.put("app/main/contactcenter/management/callcenters/templates/groupslist.html","<div class=\"sidenav-list\" layout=\"column\"><div class=\"header search-header\" layout=\"row\" layout-align=\"end center\">\n<md-input-container flex=\"80\"><input flex=\"85\" name=\"search\" ng-model=\"vm.search\" type=\"text\"> <img \nsrc=\"/assets/icons/search.png\"></md-input-container></div><callcenter-groups flex search=\"vm.search\">\n</callcenter-groups></div>");
$templateCache.put("app/main/contactcenter/management/consultants/consultantcard/consultantcard.html","<div layout=\"column\" id=\"consultant-card\"><div layout=\"row\" layout-align=\"center center\"><consultant-general-info \nflex=\"70\" personal-account=\"false\" curr-consultant-id=\"vm.currentConsultantId\"></consultant-general-info><div \nflex=\"30\"><consultant-chanals-activity curr-consultant-id=\"vm.currentConsultantId\" personal-account=\"false\">\n</consultant-chanals-activity></div></div><div layout=\"row\" layout-align=\"none\"><div flex=\"50\" layout=\"column\" \nclass=\"easy-content left\"><md-toolbar class=\"header md-primary-bg\" layout=\"row\" layout-align=\"start center\"><div \nlayout=\"row\" layout-align=\"center center\" style=\"margin-left: 20px\"><div class=\"icon-container\"></div><span \nclass=\"header-part\" translate=\"CONSULTANTCARD.MESSAGE_STAT\">Statysytyki wiadomości</span></div></md-toolbar><div \nlayout=\"column\" flex><reports-messages-stats consultant-id=\"vm.currentConsultantId\" stats=\"true\">\n</reports-messages-stats><div flex></div><reports-messages-stats consultant-id=\"vm.currentConsultantId\" avg=\"true\">\n</reports-messages-stats></div></div><div flex=\"50\" layout=\"column\" class=\"easy-content right\"><md-toolbar \nclass=\"header md-primary-bg\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"center center\" \nstyle=\"margin-left: 20px\"><div class=\"icon-container\"></div><span class=\"header-part\" \ntranslate=\"CONSULTANTCARD.CALL_STAT\">Statysytyki połączeń</span></div></md-toolbar><connection-statistic \nstyle=\"width: 100%\" class=\"callChart\" chart-data=\"vm.chartData.dataCount\" mode=\"vm.connectionStatisticCons.count\">\n</connection-statistic><connection-statistic style=\"width: 100%\" class=\"callChart\" \nchart-data=\"vm.chartData.dataSeconds\" mode=\"vm.connectionStatisticCons.seconds\"></connection-statistic>\n<connection-statistic style=\"width: 100%\" class=\"callChart\" chart-data=\"vm.chartData.dataAvgSeconds\" \nmode=\"vm.connectionStatisticCons.average\"></connection-statistic></div></div></div>");
$templateCache.put("app/main/contactcenter/management/consultants/consultantedit/consultantedit.html","<div id=\"consultant-edit\" layout=\"column\" layout-align=\"center center\"><view-actions save-func=\"vm.saveChanges\" \nclose-func=\"vm.cancelSaveChanges\" main-form=\"vm.mainForm\"></view-actions><div flex class=\"form-container\" \nlayout=\"column\"><content><accordion-form ng-show=\"vm.editedUser\" on-complete=\"vm.saveChanges\" \nclikcable-header=\"vm.currentConsultantId\" count-init-progress=\"vm.currentConsultantId\" main-form=\"vm.mainForm\">\n<form-pane show-minified=\"true\" pane-icon=\"assets/icons/management/consultants/add-button.svg\"><p-minified><img \nng-src=\"{{vm.editedUser.photoUrlOld}}\" class=\"hack-avatar-step-icon\"></p-minified><p-header><p \ntranslate=\"CONSULTANTEDIT.CONSULTANT_PHOTO\">Zdjęcie konsultanta</p></p-header><p-content><p class=\"avatar-instruction\">\nKliknij w poniższy prostokąt \"+\" i wybierz zdjęcie aby przejść do kolejnego korku</p><div class=\"avatar-conainer\">\n<avatar-cropper flex layout=\"row\" img-url=\"vm.editedUser.photoUrl\" file-upload-call=\"savePhoto2\" \nsave-callback=\"vm.photoUpdate\" style=\"display:block;text-align:center\"></avatar-cropper></div><input pane-helper \nname=\"avatarUrl\" type=\"text\" ng-model=\"vm.editedUser.photoUrl\" style=\"display:none\"></p-content></form-pane><form-pane \npane-icon=\"assets/icons/management/consultants/busines-card.svg\"><p-header><p translate=\"CONSULTANTEDIT.GENERAL\">\nDane ogólne</p></p-header><p-minified><div layout=\"column\"><div><span translate=\"CONSULTANTEDIT.LOGIN\">Login: </span>\n<span>{{vm.editedUser.login}}</span></div><div><span translate=\"CONSULTANTEDIT.NAME\">Imię: </span><span>\n{{vm.editedUser.firstName}}</span></div><div><span translate=\"CONSULTANTEDIT.SURNAME\">Nazwisko: </span><span>\n{{vm.editedUser.lastName}}</span></div></div></p-minified><p-content><user-edit-component \nuser-id=\"vm.currentConsultantId\" new-record=\"!vm.currentConsultantId\" personal-account=\"vm.personalAccount\" \nsave-indicator=\"vm.saveUser\" edited-user=\"vm.editedUser\" create-only-consultant=\"true\"></user-edit-component>\n</p-content></form-pane><form-pane ng-if=\"vm.userRole != \'consultant\'\" pane-icon=\"/assets/icons/price-tag.svg\">\n<p-header><p translate=\"CALLCENTER.EDIT_DIALOG.TAGS\">Tagi</p></p-header><p-minified><ta-multiselect \nng-if=\"vm.editedConsultant.tags\" flex ng-disabled=\"true\" write-mode=\"false\" ng-model=\"vm.editedConsultant.tags\">\n</ta-multiselect></p-minified><p-content><ta-multiselect ng-if=\"vm.editedConsultant\" custom-class=\"big white\" \nwrite-mode=\"vm.addTag\" ng-model=\"vm.editedConsultant.tags\" source=\"vm.baseTags\"></ta-multiselect></p-content>\n</form-pane><form-pane pane-icon=\"assets/icons/management/consultants/call-center.svg\"><p-header><p \ntranslate=\"CONSULTANTEDIT.CONSULTANT_DATA\">Dane konsultanta</p></p-header><p-minified><div layout=\"column\"><div><span \ntranslate=\"CONSULTANTEDIT.ALIAS\">Alis: </span><span>{{vm.editedConsultant.alias}}</span></div></div></p-minified>\n<p-content><consultant-edit-component consultant-id=\"vm.currentConsultantId\" personal-account=\"vm.personalAccount\" \nsave-indicator=\"vm.saveConsultant\" edited-consultant=\"vm.editedConsultant\"></consultant-edit-component></p-content>\n</form-pane><form-pane pane-icon=\"assets/icons/management/consultants/phone-call.svg\"><p-header><p \ntranslate=\"CONSULTANTEDIT.CONS_PHONES\">Telefony konsultanta</p></p-header><p-minified>\n{{vm.editedConsultant.firstName +\' \'+vm.editedConsultant.lastName}}</p-minified><p-content><consultant-phones \nconsultant-id=\"vm.currentConsultantId\" personal-account=\"vm.personalAccount\" save-indicator=\"vm.saveConsultantPhones\">\n</consultant-phones></p-content></form-pane><form-pane \npane-icon=\"assets/icons/management/consultants/email_mailbox.svg\"><p-header><p translate=\"CONSULTANTEDIT.MAILBOX_DATA\">\nSkrzynka pocztowa</p></p-header><p-minified>{{vm.editedConsultant.firstName +\' \'+vm.editedConsultant.lastName}}\n</p-minified><p-content><md-button ng-show=\"vm.noMailbox\" class=\"md-raised\" ng-click=\"vm.noMailbox = false\">\nDodaj skrzynkę</md-button><settings-mailbox ng-if=\"vm.currentConsultantId != undefined\" ng-hide=\"vm.noMailbox\" \nuid=\"vm.currentConsultantId\" new-record=\"vm.noMailbox\" personal-account=\"vm.personalAccount\" resource=\"UsersRsc\" \nsave-indicator=\"vm.saveMail\" column-order=\"true\" class=\"userListModal\"></settings-mailbox></p-content></form-pane>\n</accordion-form></content></div></div>");
$templateCache.put("app/main/contactcenter/management/consultants/consultantgeneralinfo/consultantgeneralinfo.html","<div layout=\"column\" id=\"consultant-general-info\" class=\"easy-content\"><md-toolbar ng-if=\"!vm.noTitle\" \nclass=\"header md-primary-bg\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"center center\">\n<div class=\"icon-container\"></div><span class=\"header-part\" translate=\"CONSULTANT.GENERAL_INFO.TITLE\">Karta konsultanta\n</span></div></md-toolbar><div layout=\"column\" layout-align=\"center center\" class=\"general-content\" \nng-class=\"{\'fixed-height\':!vm.noTitle}\"><div flex layout=\"row\" layout-align=\"center start\" class=\"main-row\"><div \nclass=\"avatar-area\" layout=\"column\" layout-align=\"start stretch\"><div><avatar-cropper \nng-disabled=\"vm.editingForbidden\" flex img-url=\"vm.consultantData.photoUrl\" file-upload-call=\"savePhoto2\" \nsave-callback=\"vm.selectedFileChanged\" dude-name=\"vm.consultantData.login\" default-img=\"vm.defaultImg\" \nng-click=\"vm.goToDetails()\"></avatar-cropper><div \nstyle=\"width: 48px;position: fixed;bottom: 54px;background-color: #ffffffbb;border-radius: 50%;left: 117px\"><img \nsrc=\"{{vm.currConsultant.service.photoUrl}}\" alt=\"\"></div></div><div ng-click=\"vm.goToDetails()\" layout=\"column\" \nlayout-align=\"center center\"><div style=\"font-size: 16px;font-weight: 600;text-align: center\">\n{{vm.consultantData.firstName+\' \'+vm.consultantData.lastName }}</div></div></div><div flex layout=\"column\" \nclass=\"description-area\"><div ng-if=\"vm.consultantStatuses.firstLogin\" flex layout=\"column\" \nlayout-align=\"center center\" class=\"login-row\"><div flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-login\" style=\"margin-right: 2px\"></md-icon><span class=\"login-date\">\n{{vm.consultantStatuses.firstLogin | date:\'yyyy-MM-dd HH:mm:ss\'}}</span></div><span class=\"login-label\">\n{{vm.consultantStatuses.loggedIn}}</span></div><div ng-if=\"vm.consultantStatuses.lastActivation\" flex layout=\"column\" \nlayout-align=\"center center\" class=\"login-row\"><div flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-svg-src=\"/assets/icons/status/activeicon.svg\" style=\"margin-right: 2px;color:#4caf50\"></md-icon><span \nclass=\"login-date\">{{vm.consultantStatuses.lastActivation | date:\'yyyy-MM-dd HH:mm:ss\'}}</span></div><span \nclass=\"login-label\">{{vm.consultantStatuses.active}}</span></div><div ng-if=\"vm.consultantStatuses.lastBreak\" flex \nlayout=\"column\" layout-align=\"center center\" class=\"login-row\"><div flex layout=\"row\" layout-align=\"start center\">\n<md-icon md-svg-src=\"/assets/icons/status/break.svg\" style=\"margin-right: 2px;color:#d89f00\"></md-icon><span \nclass=\"login-date\">{{vm.consultantStatuses.lastBreak | date:\'yyyy-MM-dd HH:mm:ss\'}}</span></div><span \nclass=\"login-label\">{{vm.consultantStatuses.onBreak}}</span></div></div></div></div></div>");
$templateCache.put("app/main/contactcenter/management/consultants/consultanteditcomponent/consultanteditcomponent.html","<div id=\"consultant-edit-component\"><form action=\"\" name=\"vm.consultantForm\"><md-input-container \nng-if=\"vm.editedConsultant.newRecordMode\" flex class=\"ml-25 instead-icon\"><label translate=\"CONSULTANTEDIT.CC\">\nContact Center</label><md-select ng-disabledse=\"vm.editedConsultant.callCenterDisabled\" \nng-model=\"vm.editedConsultant.callCenterID\"><md-option ng-disabled=\"true\"><em>None</em></md-option><md-option \nng-repeat=\"cc in vm.callcenters\" ng-value=\"cc.id\">{{cc.callCenterName}}</md-option></md-select></md-input-container>\n<md-input-container class=\"ml-25 md-icon-float md-block instead-icon\"><label>Alias</label><input \nng-model=\"vm.editedConsultant.alias\" type=\"text\"></md-input-container><md-input-container \nclass=\"ml-25 md-icon-float md-block instead-icon\"><label>Krótki opis</label><textarea \nng-model=\"vm.editedConsultant.shortDescription\" type=\"text\" rows=\"1\">\n    </md-input-container>\n    <md-input-container\n class=\"ml-25 md-icon-float md-block instead-icon\">\n      <label>Opis</label>\n      <textarea \nng-model=\"vm.editedConsultant.description\" type=\"text\" rows=\"1\">\n    </md-input-container>\n  </form>\n</div>");
$templateCache.put("app/main/contactcenter/management/consultants/consultantlist/consultantlist.html","<div id=\"consultant-list-mgt\"><div class=\"sidenav-list\" layout=\"column\"><div class=\"header search-header\" layout=\"row\" \nlayout-align=\"start center\"><md-input-container flex><input flex name=\"search\" ng-model=\"vm.search\" type=\"text\">\n</md-input-container><img src=\"/assets/icons/search.png\"></div><div class=\"md-primary base-subheader\" layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-icon-button ani-button md-accent\" aria-label=\"button-label\" \nng-click=\"vm.addNewConsultant()\"><md-icon class=\"circle\" md-svg-src=\"/assets/icons/spinner-circle.svg\" \naria-label=\"previous\"></md-icon><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip>Dodaj nowego konsultanta\n</md-tooltip></md-button><md-button class=\"md-icon-button ani-button md-accent\" aria-label=\"button-label\" \nng-click=\"vm.addNewConsultantSimple()\"><md-icon class=\"circle\" style=\"color: green\" \nmd-svg-src=\"/assets/icons/spinner-circle.svg\" aria-label=\"previous\"></md-icon><md-icon md-font-icon=\"icon-plus\" \nstyle=\"color: green\"></md-icon><md-tooltip>Dodaj nowego konsultanta (uproszczony)</md-tooltip></md-button></div>\n<md-content class=\"content center-sidenav\" layout=\"column\" flex ms-scroll><md-list class=\"base-list service-list\" flex>\n<md-list-item flex \nng-repeat=\"consultant in vm.consultantsList | filter: vm.search | filter:vm.onlineFilter | orderBy:vm.propertyName:vm.reverse track by consultant.consultantID\" \naria-label=\"consultant\" ng-class=\"{ \'selected\' : vm.selectedConsultant == consultant }\"><div layout-fill flex \nclass=\"md-list-item-text\" layout=\"row\" layout-align=\"start space-between\" ng-click=\"vm.selectConsultant(consultant);\">\n<div flex class=\"avatar-list p-5\" layout=\"row\" layout-align=\"center center\"><div class=\"avatar-wrapper\"><img flex \nng-if=\"::consultant.photoUrl\" md-menu-align-target class=\"avatar status-mask\" ng-src=\"{{::consultant.photoUrl}}\"><div \nng-if=\"::!consultant.photoUrl\" class=\"avatar default-avatar status-mask\"><md-icon flex \nmd-svg-src=\"/assets/navigation/avatar.svg\" aria-label=\"avatar\"></md-icon></div><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle\" ng-style=\"{\'color\':consultant.statusColor }\" class=\"icon status\"></md-icon>\n</div></div><div flex=\"70\" class=\"consultant-data\" layout=\"column\" layout-align=\"start stretch\" class=\"row\"><div \nflex=\"33\" class=\"name\"><span ng-if=\"::!consultant.alias\">{{::consultant.firstName}} {{::consultant.lastName}}</span> \n<span ng-if=\"::consultant.alias\">{{::consultant.alias}}</span></div><star-rating flex=\"33\" \nng-model=\"consultant.average\" max=\"6\" readonly=\"true\"></star-rating><ta-multiselect flex=\"33\" \nng-if=\"::consultant.tags\" custom-class=\"small black\" ng-disabled=\"true\" write-mode=\"false\" ng-model=\"consultant.tags\" \ntag-overflow=\"true\"></ta-multiselect></div></div></md-list-item></md-list></md-content></div></div>");
$templateCache.put("app/main/contactcenter/management/consultants/templates/consultantslist.html","<div class=\"sidenav-list\" layout=\"column\"><div class=\"header search-header\" layout=\"row\" layout-align=\"start center\">\n<md-input-container flex><input flex=\"85\" name=\"search\" ng-model=\"vm.search\" type=\"text\"> <img \nsrc=\"/assets/icons/search.png\"></md-input-container></div><consultant-list flex search=\"vm.search\"></consultant-list>\n</div>");
$templateCache.put("app/main/contactcenter/management/consultants/consultantphones/consultantphones.html","<md-content id=\"consultnat-phones\"><div layout=\"column\" layout-align=\"start stretch\"><md-subheader \nid=\"service-list-subheader\" class=\"md-primary base-subheader\" layout=\"column\" layout-align=\"center space-between\"><div \nflex=\"100\" layout=\"row\" layout-align=\"start center\"><div flex=\"20\" ng-click=\"vm.sortBy(\'typeId\')\" \nstyle=\"cursor: pointer\">Typ</div><div flex=\"35\" ng-click=\"vm.sortBy(\'name\')\" style=\"cursor: pointer\">Nazwa</div><div \nflex=\"35\" ng-click=\"vm.sortBy(\'phone\')\" style=\"cursor: pointer\">Numer</div></div></md-subheader><md-list \nclass=\"base-list\" flex><md-list-item ng-show=\"!phone.deleted\" class=\"md-white-bg phone-row\" \nng-class=\"{\'inEdit-mode\':phone.inEdit}\" ng-repeat=\"phone in vm.phones | orderBy:vm.propertyName:vm.reverse\"><div \nlayout=\"row\" layout-align=\"space-between center\" flex><div flex=\"20\" class=\"name\"><strong>{{ phone.typeName}}</strong>\n</div><div flex=\"35\" class=\"name\"><strong>{{phone.name}}</strong></div><div flex=\"35\" class=\"name\"><strong \nng-show=\"phone.typeId !== 4\">{{phone.phone}}</strong></div><div flex=\"10\" layout=\"row\" layout-align=\"end center\"><div \nclass=\"icon-container\" ng-show=\"phone.inEdit\"><md-icon md-font-icon=\"icon-sleep\"></md-icon><md-tooltip \nmd-direction=\"top\">W trakcie edycji</md-tooltip></div><div class=\"icon-container\" ng-show=\"!phone.inEdit\"><img \nsrc=\"../../../../assets/icons/edycja.png\" ng-click=\"vm.editPhone(phone);$event.stopPropagation();\"><md-tooltip \nmd-direction=\"top\">Edycja</md-tooltip></div><div class=\"icon-container\" ng-show=\"!phone.inEdit\"><md-icon \nmd-font-icon=\"icon-trash\" ng-click=\"vm.deletePhone(phone);$event.stopPropagation();\"></md-icon><md-tooltip \nmd-direction=\"top\">Usuń</md-tooltip></div></div></div></md-list-item><form action=\"\" name=\"vm.phoneForm\"><md-list-item \nlayout=\"row\" layout-align=\"space-between center\" flex class=\"md-white-bg\" class=\"p-0\"><div ng-hide=\"vm.editedPhone\" \nflex layout=\"row\" layout-align=\"center center\"><md-button flex class=\"md-icon-button\" \nng-click=\"vm.addPhone();$event.stopPropagation();\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div \nng-show=\"vm.editedPhone.inEdit && vm.editedPhone\" flex layout=\"row\" layout-align=\"space-around center\">\n<md-input-container flex=\"20\"><label translate=\"CONSULTANT_PHONES.TEL_TYPE\">Typ</label><md-select \nng-model=\"vm.editedPhone.typeId\" ng-required=\"vm.editedPhone\"><md-option ng-repeat=\"type in vm.phoneTypes\" \nng-value=\"type.id\">{{type.name}}</md-option></md-select></md-input-container><div \nng-show=\"vm.editedPhone.typeId !== 4\" flex=\"90\" layout=\"row\" layout-align=\"space-around center\" class=\"pt-25\">\n<md-input-container flex=\"35\"><label translate=\"CONSULTANT_PHONES.TEL_NAME\">Nazwa</label><input \nng-model=\"vm.editedPhone.name\" type=\"text\" ng-required=\"vm.editedPhone\"></md-input-container><md-input-container \nflex=\"35\"><label translate=\"CONSULTANT_PHONES.TEL_NUMBER\">Numer</label><input ng-model=\"vm.editedPhone.phone\" \ntype=\"text\" ng-required=\"vm.editedPhone && vm.editedPhone.typeId!==4\"></md-input-container><div flex=\"10\" layout=\"row\" \nlayout-align=\"end center\"><div class=\"icon-container\"><md-icon md-font-icon=\"icon-content-save\" \nng-click=\"vm.savePhone(vm.editedPhone);$event.stopPropagation();\"></md-icon><md-tooltip md-direction=\"top\">Zapisz\n</md-tooltip></div><div class=\"icon-container\"><md-icon md-font-icon=\"icon-cancel\" \nng-click=\"vm.cancelSavePhone(vm.editedPhone);$event.stopPropagation();\"></md-icon><md-tooltip md-direction=\"top\">Anuluj\n</md-tooltip></div></div></div><div ng-show=\"vm.editedPhone.typeId === 4\" flex=\"90\" layout=\"row\" \nlayout-align=\"space-around center\" class=\"pt-25\"><md-input-container flex=\"40\"><label \ntranslate=\"CONSULTANT_PHONES.TEL_NAME\">Nazwa</label><input ng-model=\"vm.editedPhone.name\" type=\"text\">\n</md-input-container><div flex=\"10\" flex-offset=\"50\" layout=\"row\" layout-align=\"end center\"><div \nclass=\"icon-container\"><md-icon md-font-icon=\"icon-content-save\" \nng-click=\"vm.savePhone(vm.editedPhone);$event.stopPropagation();\"></md-icon><md-tooltip md-direction=\"top\">Zapisz\n</md-tooltip></div><div class=\"icon-container\"><md-icon md-font-icon=\"icon-cancel\" \nng-click=\"vm.cancelSavePhone(vm.editedPhone);$event.stopPropagation();\"></md-icon><md-tooltip md-direction=\"top\">Anuluj\n</md-tooltip></div></div></div></div></md-list-item></form></md-list></div></md-content>");
$templateCache.put("app/main/contactcenter/management/services/templates/base.html","<!DOCTYPE html><div flow-init><div flow-prevent-drop flow-drag-enter=\"style={border: \'5px solid green\'}\" \nflow-drag-leave=\"style={}\" ng-style=\"style\"><h1>Flow Basic ASP.NET Example</h1><hr class=\"soften\"><div class=\"row\"><div\n class=\"col-md-6\"><h2>Inputs:</h2><input type=\"file\" flow-btn> <input type=\"file\" flow-btn flow-directory \nng-show=\"$flow.supportDirectory\"></div><div class=\"col-md-6\"><h2>Buttons:</h2><span class=\"btn\" flow-btn><i \nclass=\"fa fa-file\"></i>Upload File</span> <span class=\"btn\" flow-btn flow-directory ng-show=\"$flow.supportDirectory\"><i\n class=\"fa fa-folder-open\"></i> Upload Folder</span></div></div><hr class=\"soften\"><h2>Transfers:</h2><p><a \nclass=\"btn btn-sm btn-success\" ng-click=\"$flow.resume()\">Upload</a> <a class=\"btn btn-sm btn-danger\" \nng-click=\"$flow.pause()\">Pause</a> <a class=\"btn btn-sm btn-info\" ng-click=\"$flow.cancel()\">Cancel</a> <span \nclass=\"label label-info\">Size: {{$flow.getSize()}}</span> <span class=\"label label-info\">\nIs Uploading: {{$flow.isUploading()}}</span></p><table class=\"table table-hover table-bordered table-striped\" \nflow-transfers><thead><tr><th>#</th><th>Name</th><th>Size</th><th>Relative Path</th><th>Unique Identifier</th><th>\n#Chunks</th><th>Progress</th><th>Paused</th><th>Uploading</th><th>Completed</th><th>Settings</th></tr></thead><tbody>\n<tr ng-repeat=\"file in transfers\"><td>{{$index+1}}</td><td>{{file.name}}</td><td>{{file.size}}</td><td>\n{{file.relativePath}}</td><td>{{file.uniqueIdentifier}}</td><td>{{file.chunks.length}}</td><td>{{file.progress()}}</td>\n<td>{{file.paused}}</td><td>{{file.isUploading()}}</td><td>{{file.isComplete()}}</td><td><div class=\"btn-group\"><a \nclass=\"btn btn-xs btn-primary\" ng-click=\"file.pause()\" ng-hide=\"file.paused\">Pause </a><a \nclass=\"btn btn-xs btn-primary\" ng-click=\"file.resume()\" ng-show=\"file.paused\">Resume </a><a \nclass=\"btn btn-xs btn-danger\" ng-click=\"file.cancel()\">Cancel </a><a class=\"btn btn-xs btn-info\" \nng-click=\"file.retry()\" ng-show=\"file.error\">Retry</a></div></td></tr></tbody></table><hr class=\"soften\"><div \nclass=\"alert\" flow-drop flow-drag-enter=\"class=\'alert-success\'\" flow-drag-leave=\"class=\'\'\" ng-class=\"class\">\nDrag And Drop your file here</div></div></div><div class=\"row\" flow-init=\"{singleFile: true}\" \nflow-files-submitted=\"$flow.upload()\" flow-file-success=\"vm.CallMeMaybe($flow, $file, $message)\"><div \nclass=\"col-sm-12\"><table><tr class=\"drop-area\" type=\"file\" flow-btn flow-drop flow-attrs=\"{accept:\'audio/*\'}\"><td>\n<span>Przeciągnij i upuść pliki tutaj aczkolwiek możesz też kliknąć tutaj.</span><p ng-repeat=\"file in $flow.files\">\n{{$index+1}} {{file.name}} {{file.msg}}</p></td></tr></table></div></div><div flow-init><div flow-prevent-drop \nflow-drag-enter=\"style={border: \'5px solid green\'}\" flow-drag-leave=\"style={}\" ng-style=\"style\"><div class=\"row\"><div \nclass=\"col-md-6\"><table><tr class=\"drop-area\" type=\"file\" flow-btn flow-drop flow-drag-enter=\"class=\'alert-success\'\" \nflow-drag-leave=\"class=\'\'\" ng-class=\"class\"><td><span>\nPrzeciągnij i upuść pliki tutaj aczkolwiek możesz też kliknąć tutaj.</span></td></tr></table></div><div \nclass=\"col-md-6\"><h2>Przyciski:</h2><span class=\"btn\" flow-btn><i class=\"fa fa-file\"></i>Upload File</span> <span \nclass=\"btn\" flow-btn flow-directory ng-show=\"$flow.supportDirectory\"><i class=\"fa fa-folder-open\"></i> Upload Folder\n</span></div></div><hr class=\"soften\"><h2>Przesłane pliki:</h2><p><a class=\"btn btn-sm btn-success\" \nng-click=\"$flow.resume()\">Prześlij</a> <a class=\"btn btn-sm btn-danger\" ng-click=\"$flow.pause()\">Zatrzymaj</a> <a \nclass=\"btn btn-sm btn-info\" ng-click=\"$flow.cancel()\">Anuluj</a> <span class=\"label label-info\">\nRozmiar: {{$flow.getSize()}}</span> <span class=\"label label-info\">Przesyłany: {{$flow.isUploading()}}</span></p><table\n class=\"table table-hover table-bordered table-striped\" flow-transfers><thead><tr><th>#</th><th>Nazwa pliku</th><th>\nRozmiar</th><th>Stan</th><th>Zatrzymany</th><th>Wgrywany</th><th>Zakończono</th><th>Akcje</th></tr></thead><tbody><tr \nng-repeat=\"file in transfers\"><td>{{$index+1}}</td><td>{{file.name}}</td><td>{{file.size}}</td><td>\n{{vm.GetProgressStatus(file.progress())}}</td><td><span ng-show=\"file.paused\">Tak</span><span ng-hide=\"file.paused\">Nie\n</span></td><td><span ng-show=\"file.isUploading()\">Tak</span><span ng-hide=\"file.isUploading()\">Nie</span></td><td>\n<span ng-show=\"file.isComplete()\">Tak</span><span ng-hide=\"file.isComplete()\">Nie</span></td><td><div \nclass=\"btn-group\"><a class=\"btn btn-xs btn-primary\" ng-click=\"file.pause()\" ng-hide=\"file.paused\">Zatrzymaj </a><a \nclass=\"btn btn-xs btn-primary\" ng-click=\"file.resume()\" ng-show=\"file.paused\">Wznow </a><a \nclass=\"btn btn-xs btn-danger\" ng-click=\"file.cancel()\">Anuluj </a><a class=\"btn btn-xs btn-info\" \nng-click=\"file.retry()\" ng-show=\"file.error\">Ponow</a></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/contactcenter/management/services/templates/callcenter.html","<!DOCTYPE html><div flex class=\"md-white-bg switch-animation h-450\" ng-if=\"vm.CurrentAction.id.length > 0\" \nng-switch=\"vm.addConsultatorMode\" ng-init=\"vm.InitCallCenter()\"><div flex layout=\"column\" layout-align=\"start stretch\" \nng-switch-when=\"0\"><div layout=\"row\" class=\"md-background-bg h-50\" layout-align=\"space-between center\"><h2 flex=\"90\" \nclass=\"md-accent-fg\">Konsultanci/Grupy zapisane w Akcji</h2><md-button flex class=\"md-icon-button md-accent\" \naria-label=\"Dodaj grupę do akcji\" ng-click=\"vm.addConsultatorMode = 1;\"><md-icon md-font-icon=\"icon-plus\" \nclass=\"orange-900-fg s30\"></md-icon><md-tooltip md-direction=\"bottom\">Dodaj konsultanta/grupę</md-tooltip></md-button>\n</div><md-content flex layout=\"row\"><div class=\"grey-600-fg\" flex layout=\"column\" layout-align=\"center center\" \nng-if=\"vm.CurrentAction.consultantList.length<1\"><h2 flex>Brak konsultantów!</h2><div flex layout=\"row\"><h3 flex>\nAby dodać kliknij ikonke<md-icon md-font-icon=\"icon-plus\" class=\"orange-900-fg s30\"></md-icon></h3></div></div><md-list\n flex ng-if=\"vm.CurrentAction.consultantList.length>0\" ui-sortable=\"vm.sortableCCOptions\" \nng-model=\"vm.CurrentAction.consultantList\" class=\"md-dense h-350\" ms-scroll><md-list-item \nclass=\"consultator consultant-header\" ng-repeat=\"consultator in vm.CurrentAction.consultantList\" md-item-size=\"20\" \nlayout=\"row\" layout-align=\"space-between center\" layout-margin layout-padding><md-icon flex=\"10\" \nng-if=\"consultator.type == \'C\'\" md-font-icon=\"icon-account\" aria-label=\"label\" class=\"snumber md-accent\"><md-tooltip \nmd-direction=\"right\">Konsultant</md-tooltip></md-icon><md-icon flex=\"10\" ng-if=\"consultator.type == \'G\'\" \nmd-font-icon=\"icon-account-multiple\" aria-label=\"label\" class=\"snumber md-accent\"><md-tooltip md-direction=\"right\">\nGrupa</md-tooltip></md-icon><h1 flex=\"10\">{{consultator.priority}}</h1><p flex=\"50\" class=\"md-subhead\">\n{{consultator.login.length>0? consultator.name+\'(\'+consultator.login+\')\':consultator.name}}</p><md-button flex \nng-if=\"consultator.type == \'G\'\" class=\"md-icon-button md-primary\" aria-label=\"Usuń grupę z akcji\" \nng-click=\"vm.RemoveGroupFromCc(consultator)\"><md-icon md-font-icon=\"icon-minus\" class=\"md-accent-fg s30\"></md-icon>\n<md-tooltip md-direction=\"bottom\">Usuń grupę z akcji</md-tooltip></md-button><md-button flex \nng-if=\"consultator.type == \'C\'\" class=\"md-icon-button md-primary\" aria-label=\"Usuń konsultanta z akcji\" \nng-click=\"vm.RemoveConsultantFromCc(consultator)\"><md-icon md-font-icon=\"icon-account-minus\" class=\"md-accent-fg s30\">\n</md-icon><md-tooltip md-direction=\"bottom\">Usuń konsultanta z akcji</md-tooltip></md-button></md-list-item></md-list>\n</md-content></div><div ng-switch-when=\"1\"><div layout=\"row\" layout-align=\"space-between center\" class=\"h-50\">\n<md-input-container md-scroll-shrink flex=\"90\" class=\"h-5 pb-10\"><label>Szukaj</label><input \nstyle=\"border-bottom: 0px\" ng-model=\"vm.search\" ng-change=\"vm.searchConsultant();\" type=\"text\" debounce=\"1500\">\n</md-input-container><md-button flex class=\"md-icon-button md-accent\" aria-label=\"Cofnij\" \nng-click=\"vm.addConsultatorMode = 0;\"><md-icon md-font-icon=\"icon-cancel s35\"></md-icon></md-button></div><md-divider>\n</md-divider><md-content flex layout=\"column\" layout-align=\"center stretch\"><v-accordion flex \nclass=\"vAccordion--usrtree\"><v-pane ng-repeat=\"group in vm.callCenterGroups\" ng-cloak><v-pane-header inactive><div \nflex layout=\"row\" layout-align=\"space-around center\" class=\"grey-900-fg\"><div flex=\"80\" layout=\"row\" \nng-click=\"$pane.toggle(); vm.loadConsultants(group);\"><md-icon flex-offset=\"10\" flex=\"20\" \nmd-font-icon=\"icon-account-multiple\" aria-label=\"Grupa\" class=\"s30 md-accent-fg\"></md-icon><span flex=\"70\"><strong>\n{{group.groupName}}</strong></span></div><md-button class=\"md-icon-button md-primary\" \naria-label=\"Dodaj grupę do akcji\" ng-click=\"vm.AddGroupToCc(group)\"><md-icon md-font-icon=\"icon-account-multiple-plus\" \nclass=\"md-accent-fg s30\"></md-icon><md-tooltip md-direction=\"bottom\">Dodaj grupę do akcji</md-tooltip></md-button>\n</div></v-pane-header><v-pane-content><div layout=\"row\" layout-align=\"center center\"><md-progress-circular flex \nng-show=\"!group.consultants\" md-mode=\"indeterminate\"></md-progress-circular><md-list class=\"md-dense\" flex>\n<md-list-item ng-repeat=\"consultant in group.consultants\" layout-align=\"space-around center\" md-item-size=\"10\"><span \nflex-offset=\"10\" flex=\"10\"><md-icon md-font-icon=\"icon-account\" class=\"md-accent-fg s30\"></md-icon><md-tooltip \nmd-direction=\"left\">{{consultant.consultantID}}</md-tooltip></span><div class=\"h2\"><strong>{{ consultant.priority }}.\n</strong></div><h3 flex=\"50\">{{consultant.firstName + \' \' + consultant.lastName}}</h3><md-button flex=\"10\" \nclass=\"md-icon-button md-primary\" aria-label=\"Dodaj grupę do akcji\" \nng-click=\"vm.AddConsultantToCc(consultant,group.id)\"><md-icon md-font-icon=\"icon-account-plus\" \nclass=\"md-accent-fg s30\"></md-icon><md-tooltip md-direction=\"bottom\">Dodaj konsultanta do akcji</md-tooltip>\n</md-button></md-list-item></md-list></div></v-pane-content></v-pane></v-accordion></md-content></div></div>");
$templateCache.put("app/main/contactcenter/management/services/templates/dtmf.html","<!DOCTYPE html><div layout=\"row\" ng-init=\"vm.dtmfInit()\"><md-input-container><label>Ilość cyfr</label><input \nng-model=\"vm.CurrentAction.maxdigit\" type=\"number\" debounce=\"1000\" ng-change=\"vm.SaveDTMF()\" required>\n</md-input-container><md-input-container><label>Cyfry przerywające</label><input ng-model=\"vm.CurrentAction.digitmask\" \ntype=\"number\" debounce=\"1000\" ng-change=\"vm.SaveDTMF()\" required></md-input-container><md-input-container><label>\nCzas oczekiwania</label><input ng-model=\"vm.CurrentAction.maxtime\" type=\"number\" debounce=\"1000\" \nng-change=\"vm.SaveDTMF()\" required></md-input-container><md-input-container><label>Czas bezczynności</label><input \nng-model=\"vm.CurrentAction.iddelay\" type=\"number\" debounce=\"1000\" ng-change=\"vm.SaveDTMF()\" required>\n</md-input-container></div>");
$templateCache.put("app/main/contactcenter/management/services/templates/filterselect.html","<md-input-container class=\"ta-filter-select\"><label translate=\"%translate\">%translate</label><md-select \nng-model=\"vm.settings.%pn\"><md-option ng-disabled=\"true\" style=\"height:30px\"><em>None</em></md-option><md-option \nstyle=\"height:30px\" ng-repeat=\"state in field.source\" ng-value=\"state.Value ? state.Value : state\" \ntranslate=\"{{state.token}}\">{{state.Name ? state.Name : state}}</md-option></md-select></md-input-container>");
$templateCache.put("app/main/contactcenter/management/services/templates/ivr.html","<!DOCTYPE html><div class=\"row\"><div class=\"col-sm-12\"><select class=\"form-control ta-select\" \nng-model=\"vm.CurrentAction.Start\" ng-options=\"h as h for h in vm.HoursPicker\"></select><select \nclass=\"form-control ta-select\" ng-model=\"vm.CurrentAction.Stop\" ng-options=\"h as h for h in vm.HoursPicker\"></select>\n</div></div>");
$templateCache.put("app/main/contactcenter/management/services/templates/newtag.template.html","<md-dialog aria-label=\"Utwórz tag\"><form ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2>Nowy Tag</h2></div>\n</md-toolbar><md-dialog-content><p>Wybierz tag dziedziczny</p><md-select ng-model=\"choosenTag\"><md-option \nng-repeat=\"tag in tagsSource\" ng-value=\"tag\">{{tag.tag}}</md-option></md-select></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-click=\"cancel()\">Anuluj</md-button><md-button ng-click=\"answer(choosenTag)\">Utwórz\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/contactcenter/management/services/templates/play.html","<!DOCTYPE html><div flex layout=\"column\" flow-init=\"vm.FlowConfig()\" flow-name=\"vm.playUploader\" \nflow-files-submitted=\"$flow.upload()\" flow-file-success=\"vm.CallMeMaybe($flow, $file, $message)\" \nflow-file-retry=\"vm.retryChunk($file,$flow)\"><div layout=\"row\" layout-align=\"space-around center\"><md-input-container>\n<label>Ilość cyfr</label><input ng-model=\"vm.CurrentAction.maxdigit\" type=\"number\" debounce=\"1000\" required>\n</md-input-container><md-input-container><label>Cyfry przerywające</label><input ng-model=\"vm.CurrentAction.digitmask\" \ntype=\"number\" debounce=\"1000\" required></md-input-container></div><md-table-pagination md-page-select \nmd-limit=\"vm.Table.Limit\" md-page=\"vm.Table.CurrentPage\" md-total=\"{{vm.ServiceList.length}}\" \nmd-limit-options=\"vm.Table.LimitOptions\"></md-table-pagination><md-table-container><table data-md-table><thead md-head \nmd-order=\"orderer\"><tr md-row><th md-column md-order-by=\"serviceID\"><span>Id</span></th><th md-column \nmd-order-by=\"name\"><span>Nazwa</span></th><th md-column md-order-by=\"premiumNumber\"><span>Status</span></th><th><span>\nAkcje</span></th></tr></thead><tbody md-body><tr md-row md-select=\"c\" class=\"md-row\" \ndata-ng-repeat=\"file in $flow.files | toArray:false | orderBy:orderer| filter: vm.Table.QueryFilter  | limitTo: vm.Table.Limit: (vm.Table.CurrentPage - 1) * vm.Table.Limit \">\n<td md-cell>{{$index+1}}</td><td md-cell>{{file.name}}</td><td md-cell>{{file.msg}}</td><td md-cell></td></tr></tbody>\n</table></md-table-container><div flex layout=\"column\" layout-align=\"center center\" class=\"drop-area border h-150\" \ntype=\"file\" flow-btn flow-drop flow-attrs=\"{accept:\'audio/*\'}\"><audio flex ng-show=\"vm.CurrentAction.url.length > 0\" \nclass=\"audio-player\" controls><source src=\"{{CurrentAction.url}}\" class=\"audio-src\"></audio><p flex><span \nng-class=\"(CurrentAction.url.length == 0) ? \'grey-800-fg\':\'\'\">Przeciągnij i upuść pliki bądź kliknij tutaj.</span></p>\n</div></div>");
$templateCache.put("app/main/contactcenter/management/services/templates/record.html","<!DOCTYPE html><div class=\"row\"><div class=\"col-sm-12\"><select class=\"form-control ta-select\" \nng-model=\"CurrentAction.Start\" ng-options=\"h as h for h in HoursPicker\"></select><select \nclass=\"form-control ta-select\" ng-model=\"CurrentAction.Stop\" ng-options=\"h as h for h in HoursPicker\"></select></div>\n</div>");
$templateCache.put("app/main/contactcenter/management/services/templates/sendmsg.html","<!DOCTYPE html><div class=\"row\"><div class=\"col-sm-12\"><select class=\"form-control ta-select\" \nng-model=\"CurrentAction.Start\" ng-options=\"h as h for h in HoursPicker\"></select><select \nclass=\"form-control ta-select\" ng-model=\"CurrentAction.Stop\" ng-options=\"h as h for h in HoursPicker\"></select></div>\n</div>");
$templateCache.put("app/main/contactcenter/management/services/templates/sendnotify.html","<!DOCTYPE html><div class=\"row\"><div class=\"col-sm-12\"><select class=\"form-control ta-select\" \nng-model=\"CurrentAction.Start\" ng-options=\"h as h for h in HoursPicker\"></select><select \nclass=\"form-control ta-select\" ng-model=\"CurrentAction.Stop\" ng-options=\"h as h for h in HoursPicker\"></select></div>\n</div>");
$templateCache.put("app/main/contactcenter/management/services/templates/serviceview.html","<main layout=\"column\" ng-if=\"vm.sidenavData\" class=\"base-sidenav-view\"><md-input-container flex \nng-if=\"vm.sidenavData.serviceName\"><label translate=\"MANAGEMENT.SERVICE.LIST.NAME\">Nazwa serwisu</label><input \nng-disabled=\"true\" ng-model=\"vm.sidenavData.serviceName\" type=\"text\"></md-input-container><md-input-container flex \nng-if=\"vm.sidenavData.premiumNumber\"><label translate=\"MANAGEMENT.SERVICE.LIST.PREMIUM_NUMBER\">Numer premium</label>\n<input ng-disabled=\"true\" ng-model=\"vm.sidenavData.premiumNumber\" type=\"text\"></md-input-container><md-input-container \nflex ng-if=\"vm.sidenavData.mail\"><label translate=\"MANAGEMENT.SERVICE.LIST.NOTIF_EMAIL\">Mail</label><input \nng-disabled=\"true\" ng-model=\"vm.sidenavData.mail\" type=\"text\"></md-input-container><div class=\"date-preview\" flex \nng-if=\"vm.sidenavData.startDate\" layout=\"column\"><label class=\"key\" translate=\"MANAGEMENT.SERVICE.WIZ.STEPBASIC.START\">\n</label><span class=\"value\">{{vm.sidenavData.startDate | amDateFormat:\'YYYY-MM-DD HH:mm:ss\'}}</span></div><div \nclass=\"date-preview\" flex ng-if=\"vm.sidenavData.stopDate\" layout=\"column\"><label class=\"key\" \ntranslate=\"MANAGEMENT.SERVICE.WIZ.STEPBASIC.STOP\"></label><span class=\"value\">\n{{vm.sidenavData.stopDate | amDateFormat:\'YYYY-MM-DD HH:mm:ss\'}}</span></div><md-input-container flex \nng-if=\"vm.sidenavData.serviceDesc\"><label translate=\"MANAGEMENT.SERVICE.LIST.DESC\">Opis</label><textarea \nng-disabled=\"true\" ng-model=\"vm.sidenavData.serviceDesc\" type=\"text\"></textarea></md-input-container>\n<md-input-container flex ng-if=\"vm.sidenavData.prefixes\"><label translate=\"MANAGEMENT.SERVICE.LIST.PREFIXES\">Prefixy\n</label><textarea ng-disabled=\"true\" ng-model=\"vm.sidenavData.prefixes\" type=\"text\"></textarea></md-input-container>\n</main>");
$templateCache.put("app/main/contactcenter/management/services/templates/story.html","<!DOCTYPE html><div class=\"row\"><div class=\"col-sm-12\"><select class=\"form-control ta-select\" \nng-model=\"CurrentAction.Start\" ng-options=\"h as h for h in HoursPicker\"></select><select \nclass=\"form-control ta-select\" ng-model=\"CurrentAction.Stop\" ng-options=\"h as h for h in HoursPicker\"></select></div>\n</div>");
$templateCache.put("app/main/contactcenter/management/services/templates/tabetween.html","<div layout=\"row\" layout-align=\"start center\" class=\"ta-between\"><div flex=\"50\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"data-label\">{{ \"REPORTS.FROM2\" | translate }}</div><md-input-container>\n<md-datepicker ng-class=\"{errorInput: vm.settings.%pn.From == undefined}\" ng-model=\"vm.settings.%pn.From\" required>\n</md-datepicker></md-input-container></div><div flex=\"50\" layout=\"row\" layout-align=\"center center\"><div \nclass=\"data-label\">{{ \"REPORTS.TO2\" | translate }}</div><md-input-container><md-datepicker \nng-class=\"{errorInput: vm.settings.%pn.To == null}\" layout=\"row\" ng-model=\"vm.settings.%pn.To\" required>\n</md-datepicker></md-input-container></div></div>");
$templateCache.put("app/main/contactcenter/management/services/templates/tadate.html","<md-date-time-picker layout=\"row\" date-placeholder=\"%translate\" date-model=\"vm.settings.%pn\"></md-date-time-picker>");
$templateCache.put("app/main/contactcenter/management/services/templates/tanumber.html","<md-input-container class=\"md-block\" flex><label translate=\"%translate\">%translate</label><input type=\"number\" \nng-model=\"vm.settings.%pn\" type=\"number\" step=\"0.01\"></md-input-container>");
$templateCache.put("app/main/contactcenter/management/services/templates/taparams.html","<div layout=\"row\" layout-align=\"start center\" class=\"ta-params\"><md-input-container flex=\"50\"><label \ntranslate=\"%translate\">%translate</label><md-select ng-model=\"vm.settings.%pn.name\"><md-option style=\"height: 30px\" \nng-repeat=\"state in field.source\" ng-value=\"state.Value ? state.Value : state\" translate=\"{{state.token}}\">\n{{state.Name ? state.Name : state}}</md-option><md-option ng-disabled=\"true\" style=\"height: 30px\"><em>None</em>\n</md-option></md-select></md-input-container><md-input-container flex=\"50\"><label translate=\"%translate\">%translate\n</label><input type=\"text\" ng-model=\"vm.settings.%pn.value\" \nng-model-options=\"{ debounce: {\n      \'default\': 1000, \'blur\': 0 } }\"></md-input-container></div>");
$templateCache.put("app/main/contactcenter/management/services/templates/taradio.html","<label class=\"pb-20\">%translate</label><md-radio-group ng-if=\"field.source\" ng-model=\"vm.settings.%pn\"><md-radio-button\n ng-repeat=\"state in field.source\" value=\"{{state.Value ? state.Value : state}}\"><span ng-if=\"state.token\">\n{{state.token |translate}} </span><span ng-if=\"!state.token\">{{state}}</span></md-radio-button></md-radio-group>");
$templateCache.put("app/main/contactcenter/management/services/templates/tasearch.html","<ng-form name=\"vm.taSearchForm\"><ta-search conf=\"field.conf\" ng-model=\"vm.settings.%pn\" \nng-change=\"$emit(\'sort-changed\')\"></ta-search></ng-form>");
$templateCache.put("app/main/contactcenter/management/services/templates/taselect.html","<md-input-container class=\"ta-singleselect\"><label translate=\"%translate\">%translate</label><md-select \nng-model=\"vm.settings.%pn\"><md-option ng-disabled=\"true\" style=\"height:30px\"><em>None</em></md-option><md-option \nstyle=\"height:30px\" ng-repeat=\"state in field.source\" ng-value=\"state.Value ? state.Value : state\" \ntranslate=\"{{state.token}}\">{{state.Name ? state.Name : state}}</md-option></md-select></md-input-container>");
$templateCache.put("app/main/contactcenter/management/services/templates/tasort.html","<div layout=\"row\" layout-align=\"start center\"><md-input-container flex><label translate=\"%translate\">%translate</label>\n<md-select ng-model=\"vm.settings.%pn.column\"><md-option ng-repeat=\"state in field.source\" \nng-value=\"state.Value ? state.Value : state\" translate=\"{{state.token}}\">{{state.Name ? state.Name : state}}\n</md-option></md-select></md-input-container><div class=\"common-actions\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.settings.%pn.descending =!vm.settings.%pn.descending; $emit(\'sort-changed\')\">\n<md-icon ng-if=\"!vm.settings.%pn.descending\" md-font-icon=\"icon-sort-ascending\"></md-icon><md-icon \nng-if=\"vm.settings.%pn.descending\" md-font-icon=\"icon-sort-descending\"></md-icon><md-tooltip \nng-if=\"vm.settings.%pn.descending\">Sortuj malejąco</md-tooltip><md-tooltip ng-if=\"!vm.settings.%pn.descending\">\nSortuj rosnące</md-tooltip></md-button></div></div>");
$templateCache.put("app/main/contactcenter/management/services/templates/tatext.html","<md-input-container flex><label translate=\"%translate\">%translate</label><input type=\"text\" ng-model=\"vm.settings.%pn\">\n</md-input-container>");
$templateCache.put("app/main/contactcenter/management/users/changepassword/changepassword.html","<div id=\"changePassword\" class=\"changePassword\"><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"closeDialogX\"><div class=\"closeDialog\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</div></div><div flex class=\"title\">Zmiana hasła</div></div><md-content ng-form=\"vm.userForm\" layout=\"column\" \nlayout-align=\"start start\"><md-input-container><input type=\"password\" placeholder=\"Stare hasło\" \nng-change=\"vm.oldPasswordChange()\" autocomplete=\"new-password\" ng-model=\"vm.editedUser.oldPwd\"></md-input-container>\n<md-input-container><input type=\"password\" placeholder=\"Nowe hasło\" required ng-model=\"vm.editedUser.newPwd\" \nng-change=\"vm.checkNewPasswordMatch()\"></md-input-container><md-input-container><input type=\"password\" required \nplaceholder=\"Powtórz nowe hasło\" ng-model=\"vm.editedUser.newPwdRepeat\" ng-change=\"vm.checkNewPasswordMatch()\">\n</md-input-container><label ng-if=\"!vm.newPasswordMatch\" style=\"color: red\">Nowe hasła nie są zgodne</label>\n</md-content><div class=\"ok-button-container\" layout=\"column\" layout-align=\"center end\"><md-button \nng-click=\"vm.savePassword()\" ng-disabled=\"!vm.userForm.$valid || !vm.newPasswordMatch || !vm.oldPasswordCorrect\" \nng-class=\"{\'disbabled\': !vm.userForm.$valid || !vm.newPasswordMatch || !vm.oldPasswordCorrect}\" class=\"ok-button\">\nZapisz</md-button></div></div>");
$templateCache.put("app/main/contactcenter/management/users/useredit/useredit.html","<div id=\"user-edit\" layout=\"column\" layout-align=\"center center\"><view-actions save-func=\"vm.saveChanges\" \nclose-func=\"vm.cancelSaveChanges\" main-form=\"vm.mainForm\"></view-actions><div flex class=\"form-container\" \nlayout=\"column\"><content><accordion-form ng-show=\"vm.editedUser\" on-complete=\"vm.saveChanges\" \nclikcable-header=\"vm.currentConsultantId\" count-init-progress=\"vm.currentConsultantId\" main-form=\"vm.mainForm\">\n<form-pane show-minified=\"true\" pane-icon=\"assets/icons/management/consultants/add-button.svg\"><p-minified><img \nng-src=\"{{vm.editedUser.photoUrlOld}}\" class=\"hack-avatar-step-icon\"></p-minified><p-header><p \ntranslate=\"USEREDIT.USER_PHOTO\">Zdjęcie użytkownika</p></p-header><p-content><p class=\"avatar-instruction\">\nKliknij w poniższy prostokąt \"+\" i wybierz zdjęcie aby przejść do kolejnego korku</p><div class=\"avatar-conainer\">\n<avatar-cropper flex layout=\"row\" img-url=\"vm.editedUser.photoUrl\" file-upload-call=\"savePhoto2\" \nsave-callback=\"vm.photoUpdate\" style=\"display:block;text-align:center\"></avatar-cropper></div><input name=\"avatarUrl\" \ntype=\"text\" ng-model=\"vm.editedUser.photoUrl\" style=\"display:none\"></p-content></form-pane><form-pane \npane-icon=\"assets/icons/management/consultants/busines-card.svg\"><p-header><p translate=\"USEREDIT.GENERAL\">Dane ogólne\n</p></p-header><p-minified><div layout=\"column\"><div><span translate=\"USEREDIT.LOGIN\">Login: </span><span>\n{{vm.editedUser.login}}</span></div><div><span translate=\"USEREDIT.NAME\">Imię: </span><span>{{vm.editedUser.firstName}}\n</span></div><div><span translate=\"USEREDIT.SURNAME\">Nazwisko: </span><span>{{vm.editedUser.lastName}}</span></div>\n</div></p-minified><p-content><user-edit-component user-id=\"vm.currentUserId\" new-record=\"!vm.currentUserId\" \npersonal-account=\"vm.personalAccount\" save-indicator=\"vm.saveUser\" edited-user=\"vm.editedUser\" admin-mode=\"true\">\n</user-edit-component></p-content></form-pane><form-pane \npane-icon=\"assets/icons/management/consultants/email_mailbox.svg\"><p-header><p translate=\"USEREDIT.MAILBOX_DATA\">\nSkrzynka pocztowa</p></p-header><p-minified></p-minified><p-content><settings-mailbox uid=\"vm.currentUserId\" \nnew-record=\"!vm.currentUserId\" resource=\"UsersRsc\" save-indicator=\"vm.saveMail\" column-order=\"true\" \nclass=\"userListModal\"></settings-mailbox></p-content></form-pane></accordion-form></content></div></div>");
$templateCache.put("app/main/contactcenter/management/users/usergeneralinfo/usergeneralinfo.html","<div layout=\"column\" id=\"user-general-info\" class=\"easy-content\"><md-toolbar ng-if=\"!vm.noTitle\" \nclass=\"header md-primary-bg\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"center center\">\n<div class=\"icon-container\"></div><span class=\"header-part\" translate=\"USER.GENERAL_INFO.TITLE\">Karta użytkownika\n</span></div></md-toolbar><div layout=\"column\" layout-align=\"center center\" class=\"general-content\" \nng-class=\"{\'fixed-height\':!vm.noTitle}\"><div flex layout=\"row\" layout-align=\"center start\" class=\"main-row\"><div \nclass=\"avatar-area\" layout=\"column\" layout-align=\"start stretch\"><avatar-cropper ng-disabled=\"vm.editingForbidden\" \nflex img-url=\"vm.userData.photoUrl\" file-upload-call=\"savePhoto2\" save-callback=\"vm.selectedFileChanged\" \ndude-name=\"vm.userData.login\" default-img=\"vm.defaultImg\"></avatar-cropper><div layout=\"column\" \nlayout-align=\"center center\"><md-button ng-if=\"!vm.editingForbidden\" ng-click=\"vm.editData()\" \nclass=\"edit-button md-raised md-buttons\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>Edytuj</md-button><md-button \nng-if=\"!vm.editingForbidden\" ng-click=\"vm.changePasswordDialog()\" class=\"edit-button md-raised md-buttons\">Zmiana hasła\n</md-button></div></div><div flex layout=\"column\" class=\"description-area\"><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"name-and-stars-row\"><div class=\"name-container\">\n{{vm.userData.firstName+\' \'+vm.userData.lastName +\' (\'+vm.userData.login +\')\'}}</div><div layout=\"column\" \nlayout-align=\"center\" class=\"star-div\"><star-rating ng-model=\"vm.userData.average\" max=\"6\" readonly=\"true\">\n</star-rating><div style=\"margin-right: 15px;    text-align: center\">{{vm.userData.average | number :2}}</div></div>\n</div><div layout=\"row\" layout-align=\"start center\" class=\"login-row\"><span class=\"login-label\" \ntranslate=\"USER.GENERAL_INFO.LOGINDATE\">Logowanie: </span><span class=\"login-date\">\n{{vm.userData.lastLoginDate | date:\'yyyy-MM-dd\'}}</span> <span class=\"login-time\">\n{{vm.userData.lastLoginDate | date:\'HH-mm\'}}</span></div><div class=\"description-row\">\n{{vm.userData.longDescriptionFixed}}</div><div class=\"call-center-row\"><div class=\"g-header\" \ntranslate=\"USER.GENERAL_INFO.CC_TITLE\">Callcenters:</div><div class=\"g-values\" layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div class=\"call-center\">{{vm.userData.callCenterNames}}</div></div></div>\n</div></div><div class=\"tagi-row\" layout=\"row\" layout-align=\"center center\"><div flex=\"30\"></div><div flex=\"70\"></div>\n</div></div></div>");
$templateCache.put("app/main/contactcenter/management/users/usereditcomponent/usereditcomponent.html","<div id=\"user-edit-component\"><form action=\"\" name=\"vm.bigForm\"><div flex><md-switch ng-model=\"vm.editedUser.isActive\" \naria-label=\"IsActive\" class=\"normal-swith\"><span style=\"color: #8f8f8f\" translate=\"USEREDIT.ACTIVE\">\nUżytkownik jest aktywny</span></md-switch></div><input type=\"text\" name=\"login\" \nstyle=\"height: 0px;width: 0px;padding: 0px;     border: 0px\"> <input type=\"password\" name=\"password\" \nstyle=\"height: 0px;width: 0px;padding: 0px;     border: 0px\"><div layout=\"row\"><md-icon md-font-icon=\"icon-account\">\n</md-icon><md-input-container flex><label translate=\"USEREDIT.NAME\">Imię</label><input \nng-model=\"vm.editedUser.firstName\" type=\"text\" required name=\"consultantName\"><div \nng-messages=\"Form1.consultantName.$error\" role=\"alert\"><div ng-message=\"required\" translate=\"USEREDIT.ERROR.REQUIRED\">\nPlease enter a value for this field.</div></div></md-input-container></div><div layout=\"row\"><md-input-container flex \nclass=\"ml-25\"><label translate=\"USEREDIT.SURNAME\">Nazwisko</label><input ng-model=\"vm.editedUser.lastName\" type=\"text\" \nrequired name=\"consultantSurname\"><div ng-messages=\"Form1.consultantSurname.$error\" role=\"alert\"><div \nng-message=\"required\" translate=\"USEREDIT.ERROR.REQUIRED\">Please enter a value for this field.</div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container flex class=\"ml-25\"><label translate=\"USEREDIT.LOGIN\">\nLogin</label><input ng-model=\"vm.editedUser.login\" type=\"text\" name=\"consultantLogin\" required \nng-disabled=\"!vm.editedUser.newRecordMode\"><div ng-messages=\"Form1.consultantLogin.$error\" role=\"alert\"><div \nng-message=\"required\" translate=\"USEREDIT.ERROR.REQUIRED\">Please enter a value for this field.</div></div>\n</md-input-container></div><div layout=\"row\"><md-icon md-font-icon=\"icon-email\"></md-icon><md-input-container flex>\n<label translate=\"USEREDIT.EMAIL\">Email</label><input ng-model=\"vm.editedUser.email\" name=\"consultantEmail\" required \ntype=\"email\"><div ng-messages=\"Form1.consultantEmail.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"USEREDIT.ERROR.REQUIRED\">Please enter a value for this field.</div><div ng-message=\"email\" \ntranslate=\"USEREDIT.ERROR.EMAIL\">This field must be a valid email address.</div></div></md-input-container></div><div \nlayout=\"row\" ng-hide=\"vm.personalAccount\" ng-form=\"userForm1\"><md-icon md-font-icon=\"icon-lock-outline\"></md-icon>\n<md-input-container flex><label translate=\"USEREDIT.NEWPWD\">Hasło</label><input ng-model=\"vm.editedUser.newPwd\" \ntype=\"password\" name=\"consultantPassword\" required autocomplete=\"off\" ng-required=\"vm.editedUser.newRecordMode\"><div \nng-messages=\"userForm1.consultantPassword.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"USEREDIT.ERROR.REQUIRED\">Please enter a value for this field.</div></div></md-input-container></div><div \nlayout=\"row\" ng-if=\"vm.personalAccount\" ng-form=\"userForm\"><md-input-container flex><label>\nAby ustawić nowe hasło wprowadź stare...</label><input name=\"oldPwd\" ng-model=\"vm.editedUser.oldPwd\" type=\"password\" \npass-verify new-pass=\"false\" old-pass=\"vm.editedUser.pwd\" style=\"box-shadow: 0 0 0 1000px white inset\"><div \nng-messages=\"userForm.oldPwd.$error\" role=\"alert\"><div ng-message=\"diffrentOld\">Nieprawidłowe hasło</div></div>\n</md-input-container><md-input-container ng-if=\"vm.editedUser.oldPwd.length > 0\" flex><label \ntranslate=\"PROFILE.NEWPWD\">Nowe hasło</label><input name=\"newPwd\" ng-model=\"vm.editedUser.newPwd\" type=\"password\" \npass-verify new-pass=\"true\" old-pass=\"vm.editedUser.pwd\" confrim-pass=\"vm.newPwdRepeat\" autocomplete=\"off\"><div \nng-messages=\"userForm.newPwd.$error\" role=\"alert\"><div ng-message=\"confrim\">Hasła różnią się</div><div \nng-message=\"diffrentOld\">Nowe hasło musi być inne niż poprzednie</div></div></md-input-container><md-input-container \nng-if=\"vm.editedUser.oldPwd.length > 0\" flex><label translate=\"PROFILE.NEWPWDR\">Powtórz nowe hasło</label><input \nng-model=\"vm.newPwdRepeat\" type=\"password\"></md-input-container></div><div layout=\"row\" ng-if=\"vm.adminModeAllowed\">\n<md-icon><img class=\"role-icon\" src=\"assets/icons/profilemanagement/maska.svg\" \nstyle=\"width:24px;height:24px;color:#333\"></md-icon><md-input-container flex><label translate=\"USEREDIT.ROLE\">Rola\n</label><md-select ng-model=\"vm.editedUser.roleID\" ng-change=\"vm.promotionSwitch()\" required><md-option \nng-disabled=\"true\"><em>None</em></md-option><md-option ng-repeat=\"role in vm.roleSource\" ng-value=\"role.value\" \nng-disabled=\"role.disabled\">{{role.name}}</md-option></md-select><div ng-if=\"vm.consultantPromotion\" role=\"alert\"><div \ntranslate=\"USEREDIT.PROMOTION\">Ten konsultant zostanie awansowany</div></div></md-input-container></div><div \nlayout=\"row\" ng-if=\"vm.adminModeAllowed\"><md-input-container flex class=\"ml-25\"><div><label translate=\"USEREDIT.CC\">\nContact Center</label><span style=\"font-size: 12px\" ng-if=\"vm.editedUser.callCenterDisabled\">\n(Ten użytkownik został założony w wskazanym CC i nie można tego zmienić)</span></div><md-select \nng-disabled=\"vm.editedUser.callCenterDisabled\" ng-model=\"vm.editedUser.callCenterID\" \nng-required=\"vm.editedUser.roleID===vm.authRolesConst.manager\"><md-option ng-disabled=\"true\"><em>None</em></md-option>\n<md-option ng-repeat=\"cc in vm.callcenters\" ng-value=\"cc.id\">{{cc.callCenterName}}</md-option></md-select>\n</md-input-container></div></form></div>");
$templateCache.put("app/main/contactcenter/management/users/usersimpleadd/usersimpleadd.html","<div id=\"user-simple-add\" layout=\"column\" layout-align=\"center center\"><view-actions save-func=\"vm.saveChanges\" \nclose-func=\"vm.cancelSaveChanges\" main-form=\"vm.userEditForm\"></view-actions><div flex class=\"form-container\" \nlayout=\"column\"><div><h4><p translate=\"USER_SIMPE_ADD.USER_PHOTO\">1. Zdjęcie konsultanta</p></h4><div><p \nclass=\"avatar-instruction\">Kliknij w poniższy prostokąt \"+\" i wybierz zdjęcie aby przejść do kolejnego korku</p><div \nclass=\"avatar-conainer\"><avatar-cropper flex layout=\"row\" img-url=\"vm.newUser.photoUrl\" file-upload-call=\"savePhoto2\" \nsave-callback=\"vm.photoUpdate\" style=\"display:block;text-align:center\"></avatar-cropper></div><input name=\"avatarUrl\" \ntype=\"text\" ng-model=\"vm.newUser.photoUrl\" style=\"display:none\"></div></div><div><h4><p \ntranslate=\"USER_SIMPE_ADD.GENERAL\">2. Dane ogólne</p></h4><div><user-edit-component big-form=\"vm.userEditForm\" \nuser-id=\"vm.currentConsultantId\" new-record=\"true\" personal-account=\"vm.personalAccount\" save-indicator=\"vm.saveUser\" \nedited-user=\"vm.newUser\" create-only-consultant=\"true\"></user-edit-component></div></div></div></div>");
$templateCache.put("app/main/contactcenter/management/trademill/component/trademill.html","<div layout=\"row\"><md-button aria-label=\"ADD\" class=\"md-primary\" ng-click=\"vm.addTimeline();\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button><div flex layout=\"column\" ng-repeat=\"timeline in vm.timelines\"><div \nlayout=\"row\"><tags-picker flex write-mode=\"false\" tags-source=\"vm.baseTags\" choosen-tags=\"timeline.tagsObj\" \nremove-callback=\"timeline.removeTag\" choose-callback=\"timeline.addNewTag\"></tags-picker><md-button flex=\"10\" \naria-label=\"REMOVE\" class=\"md-primary\" ng-click=\"vm.removeTimeline(timeline);\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon></md-button></div><timeline ng-if=\"timeline.tags\" flex layout-fill show-history=\"vm.toggleInfo\" \ntags=\"timeline.tags\" play-feed=\"timeline.play\" \ncontent-template=\"app//main//contactcenter//management//trademill//templates//message.template.html\"></timeline></div>\n</div><md-sidenav class=\"md-sidenav-right\" md-component-id=\"clientInfo\" md-disable-backdrop md-whiteframe=\"4\" \nstyle=\"width: 40%; max-width: inherit\"><md-toolbar class=\"md-theme-indigo\"><h1 class=\"md-toolbar-tools\">\nHistoria klienta</h1></md-toolbar><md-content layout=\"column\" layout-align=\"center stretch\" layout-margin><div flex \nlayout=\"row\" layout-align=\"center stretch\"><md-progress-circular flex ng-show=\"vm.sidenavLoader\" \nmd-mode=\"indeterminate\"></md-progress-circular></div><ms-card flex class=\"trademill-item\" \nng-repeat=\"item in vm.HistoryMessages\" render-loader=\"sidenavRender\" \ntemplate=\"\'app//main//contactcenter//management//trademill//templates//message.template.html\'\" ng-model=\"item\">\n</ms-card></md-content></md-sidenav>");
$templateCache.put("app/main/contactcenter/management/trademill/templates/message.template.html","<div ng-click=\"vm.openModal(card)\" class=\"mb-5\" class=\"text-center\"><div layout=\"row\" class=\"h-100\"><div flex=\"20\" \nlayout=\"column\" layout-align=\"center center\"><p><md-icon flex md-font-icon=\"icon-server-network\" aria-label=\"label\" \nclass=\"snumber\"></md-icon><md-icon flex md-font-icon=\"icon-arrow-left-bold\" aria-label=\"label\" class=\"snumber\">\n</md-icon></p></div><p flex=\"80\" layout=\"row\" layout-align=\"center center\">{{card.body_in}}</p></div><div layout=\"row\" \nclass=\"mb-5\"><div flex=\"20\" layout=\"column\" layout-align=\"center center\"><p><md-icon flex \nmd-font-icon=\"icon-server-network\" aria-label=\"label\" class=\"snumber\"></md-icon><md-icon flex \nmd-font-icon=\"icon-arrow-right-bold\" aria-label=\"label\" class=\"snumber\"></md-icon></p><md-icon \nmd-font-icon=\"icon-account\" aria-label=\"label\" class=\"snumber\"></md-icon><p flex style=\"margin-top: 0px\">\n{{card.consultantID}}</p></div><p flex=\"80\" layout=\"row\" layout-align=\"center center\">{{card.body_out}}</p></div></div>\n<md-button aria-label=\"button-label\" class=\"md-primary md-raised\" ng-click=\"this.showOut=!this.showOut\"><md-icon \nmd-font-icon=\"icon-arrow-down-bold-circle\"></md-icon></md-button><div ng-show=\"this.showOut\" class=\"toggle-div\"><div \nlayout=\"row\" layout-align=\"center center\"><p flex><md-icon md-font-icon=\"icon-arrow-right-bold\" aria-label=\"label\" \nclass=\"snumber\"></md-icon>{{card.lA}}</p><p flex><md-icon md-font-icon=\"icon-filter\" aria-label=\"label\" \nclass=\"snumber\"></md-icon>{{card.prefix}}</p></div><div layout=\"row\" style=\"padding-left:15px;padding-right:15px\">\n{{card.opis}}</div></div>");
$templateCache.put("app/main/contactcenter/management/trademill/timeline/timeline.html","<div md-virtual-repeat-container layout=\"row\" layout-align=\"end center\" id=\"timeline\" \nclass=\"timeline-left hidden-scrollbar\" ng-style=\"{\'height\': vm.wHieight+\'px\' }\"><div flex class=\"ms-timeline-item\" \nlayout=\"row\" layout-align=\"center space-between\" md-virtual-repeat=\"item in vm.messages | orderBy: \'date_out\'\"><div \nclass=\"timeline-card\" flex=\"50\"><ms-card class=\"trademill-item\" template=\"vm.contentTemplate\" ng-model=\"item\">\n</ms-card></div><div flex=\"10\" class=\"timeline-point\" layout-align=\"center center\"><md-button flex \nclass=\"md-fab md-accent-bg\" aria-label=\"Historia\" ng-click=\"vm.showHistory(item.msisdn)\"><md-icon \nng-if=\"item.type == \'S\'\" md-font-icon=\"icon-message-text\"></md-icon><md-icon ng-if=\"item.type == \'M\'\" \nmd-font-icon=\"icon-tooltip-image\"></md-icon></md-button></div><div class=\"timeline-detail\" layout=\"column\" \nlayout-align=\"center start\" flex=\"10\"><div flex class=\"time\"><md-icon md-font-icon=\"icon-clock\"></md-icon>\n{{item.data_in | date:\'yyyy-MM-dd HH:mm\'}}</div><div flex class=\"event\"><md-icon md-font-icon=\"icon-message-draw\">\n</md-icon>{{item.data_out | date:\'yyyy-MM-dd HH:mm\'}}</div></div></div></div>");
$templateCache.put("app/main/contactcenter/orderbox/componets/maildetails/maildetails.html","<div class=\"mail-content\" layout=\"column\"><div ng-if=\"!vm.currentThread && vm.OrderboxGlue.outlookViewOnFire\" \nclass=\"no-thread-selected\" layout=\"column\" layout-align=\"center center\" flex><md-icon md-font-icon=\"icon-email\" \nclass=\"s120 grey-400-fg\"></md-icon></div><div ng-if=\"vm.currentThread\"><mail-details-header data=\"vm.currentThread\">\n</mail-details-header><mail-details-content data=\"vm.currentThread\" \nng-if=\"vm.OrderboxGlue.currentFilter.type!==\'callbackFolderType\'\"></mail-details-content><mail-details-content-call \ndata=\"vm.currentThread\" ng-if=\"vm.OrderboxGlue.currentFilter.type===\'callbackFolderType\'\"></mail-details-content-call>\n<mail-details-attachments thread=\"vm.currentThread\" ng-if=\"vm.OrderboxGlue.currentFilter.type!==\'callbackFolderType\'\">\n</mail-details-attachments></div></div>");
$templateCache.put("app/main/contactcenter/orderbox/componets/maillist/maillist.html","<div class=\"sidenav-mail\"><div class=\"header search-header\" layout=\"row\" layout-align=\"start center\">\n<md-input-container flex><input flex name=\"search\" ng-model=\"vm.MaillistFilters.searchString\" debounce=\"1000\" \nng-change=\"vm.getFolder()\" type=\"text\"></md-input-container><div style=\"height: 20px;width: 20px\"><img \nsrc=\"/assets/icons/search.png\"><md-tooltip><span translate=\"MAIL.MAIL_LIST.TOOLTIP_SEARCH\">Wyszukaj</span></md-tooltip>\n</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open()\"><md-icon \nmd-svg-src=\"assets/icons/orderbox/funnel.svg\" style=\"height: 20px;width: 20px;min-height: 20px;min-width: 20px\">\n</md-icon><md-tooltip><span translate=\"MAIL.MAIL_LIST.TOOLTIP_ADDFILTR\">Dodaj filtr</span></md-tooltip></md-button>\n<md-menu-content width=\"4\" style=\"min-width: 156px\"><md-menu-item ng-if=\"!filter.hide\" \nng-repeat=\"filter in vm.MaillistFilters.filterTypes\" ng-click=\"vm.addFilter(filter)\" \nstyle=\"height: 30px;min-height:30px\"><md-button style=\"height: 30px;line-height: 30px\" ng-disabled=\"filter.used\">\n<md-icon md-font-icon=\"{{filter.filterIcon}}\" md-menu-align-target></md-icon><span>{{ filter.token | translate}}</span>\n</md-button></md-menu-item></md-menu-content></md-menu></div><mail-list-filters add-indicator=\"vm.addFilter\">\n</mail-list-filters><div ng-if=\"vm.OrderboxGlue.outlookViewOnFire ? true : !vm.OrderboxGlue.currentThread\" \nclass=\"content thread-list scrollable\" ms-scroll layout=\"column\"><div class=\"no-threads-or-loading\" \nng-if=\"vm.OrderboxGlue.threads.length === 0 && vm.OrderboxGlue.currentFilter.type === \'mailfolder\'\"><span \ntranslate=\"MAIL.MAIL_LIST.NO_MESSAGES_IN\">Brak wiadomości w </span>\'{{vm.OrderboxGlue.currentFilter.filter}}\'</div><div\n class=\"no-threads-or-loading\" \nng-if=\"vm.OrderboxGlue.threads.length === 0 && vm.OrderboxGlue.currentFilter.type !== \'mailfolder\'\"><span \ntranslate=\"MAIL.MAIL_LIST.NO_MESSAGES\">Brak wiadomości</span></div><div class=\"no-threads-or-loading\" layout=\"column\" \nlayout-align=\"center center\" ng-if=\"!vm.OrderboxGlue.threads && vm.OrderboxGlue.loadingThreads\"><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><div>Loading your mails...</div>\n</div><div class=\"thread {{thread.status}}\" md-ink-ripple \nng-if=\"!vm.OrderboxGlue.loadingThreads && vm.OrderboxGlue.currentFilter.type!=\'callbackFolderType\'\" \nng-repeat=\"thread in vm.OrderboxGlue.threads\n         | filter: vm.OrderboxGlue.search\n         | filter: global.search\n         | orderBy: vm.MaillistFilters.currentSortMailParams.column:vm.MaillistFilters.currentSortMailParams.descending\" \nng-click=\"vm.openThread(thread)\" \nng-class=\"{\'unread\': !thread.seen, \'current-thread\': $root.state.params.threadId == thread.id }\" layout=\"row\" \nlayout-align=\"start start\"><md-checkbox class=\"no-label\" ng-checked=\"thread.selected\" \nng-click=\"vm.toggleSelectThread(thread, $event)\" aria-label=\"{{thread.selected ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox><img class=\"avatar\" ng-if=\"thread.from.avatar\" alt=\"{{thread.from.name}}\" \nng-src=\"{{thread.from.avatar}}\"><avatar-letter ng-if=\"!thread.from.avatar\" \nname=\"thread.from.name.length>0?thread.from.name[0]:thread.from.email[0]\"></avatar-letter><div class=\"info\" flex \nlayout=\"column\"><div class=\"name\" layout=\"row\" layout-align=\"start center\"><span class=\"text-truncate from-Name\">\n{{thread.from.name.length>0?thread.from.name:thread.from.email}}</span><div ng-if=\"thread.hasAttachments\"><md-icon \nmd-font-icon=\"icon-paperclip\" class=\"ico-type has-attachment\"></md-icon></div><div ng-if=\"thread.emailMovedOrDel\">\n<md-icon md-font-icon=\"fa fa-exclamation-triangle\" class=\"ico-type movedOrDel\"></md-icon></div><div \nng-if=\"thread.paymentInfo\" class=\"payment-sent ico-type\"><div ng-if=\"thread.paymentInfo.statusID!==3\"><md-tooltip>\n<span>Wysłana prośba o płatność</span></md-tooltip><img src=\"/assets/icons/orderbox/payment_sent.png\" alt=\"\"></div><div\n ng-if=\"thread.paymentInfo.statusID===3\"><md-tooltip><span>Zamówienie opłacone</span></md-tooltip><img \nsrc=\"/assets/icons/payment_sent_green.png\" alt=\"\"></div></div><issue-tracker ng-if=\"thread.issueStatus\" \nissue-status=\"thread.issueStatus\"></issue-tracker></div><div class=\"time\">{{thread.date | altDate}}</div><div \nclass=\"subject text-truncate\">{{thread.subject}}</div></div><div layout=\"column\" layout-align=\"space-between end\"><div \nclass=\"service\" ng-if=\"thread.serviceInfo.serviceId\"><span class=\"dot\" ng-class=\"thread.serviceInfo.color\"></span>\n {{thread.serviceInfo.serviceName}}</div></div></div><div class=\"thread {{thread.status}}\" md-ink-ripple \nng-if=\"!vm.OrderboxGlue.loadingThreads && vm.OrderboxGlue.currentFilter.type==\'callbackFolderType\'\" \nng-repeat=\"thread in vm.OrderboxGlue.threads | filter: vm.OrderboxGlue.search | filter: global.search\" \nng-click=\"vm.openThread(thread)\" \nng-class=\"{\'unread\': !thread.seen, \'current-thread\': vm.OrderboxGlue.currentThread === thread, \'selected\': thread.selected}\" \nlayout=\"row\" layout-align=\"start start\"><md-checkbox class=\"no-label\" ng-checked=\"thread.selected\" \nng-click=\"vm.toggleSelectThread(thread, $event)\" aria-label=\"{{thread.selected ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox><avatar-letter \nname=\"(thread.buyerName+\' \'+thread.buyerSurename).length>1?(thread.buyerName+\' \'+thread.buyerSurename):thread.buyerEmail\">\n</avatar-letter><div class=\"info\" flex layout=\"column\"><div class=\"name callback\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"text-truncate from-Name\">\n{{(thread.buyerName+\' \'+thread.buyerSurename).length>1?(thread.buyerName+\' \'+thread.buyerSurename):thread.buyerEmail}}\n</span><div ng-if=\"thread.status===\'CONFIRMED\'\"><img class=\"dolar-ico\" src=\"assets/icons/orderbox/dollar_green.svg\">\n<md-tooltip><span translate=\"MAIL.MAIL_LIST.TOOLTIP_NOT_FREE_PAYID\">Płatny - opłacony</span></md-tooltip></div><div \nng-if=\"thread.status===\'PENDING\'\"><img class=\"dolar-ico\" src=\"assets/icons/orderbox/dollar_grey.svg\"><md-tooltip><span \ntranslate=\"MAIL.MAIL_LIST.TOOLTIP_NOT_FREE_NOT_PAYID\">Płatny - nieopłacony</span></md-tooltip></div></div><div \nclass=\"subject callback\" layout=\"row\" layout-align=\"start center\"><b class=\"mr-10\">{{thread.buyerMsisdn}}</b>\n {{thread.buyerEmail}}</div><div class=\"time\"><b>{{thread.creationTime | date: \'yyyy-MM-dd\'}}</b>\n {{thread.creationTime | date: \'HH:mm\'}}</div></div><div layout=\"column\" layout-align=\"start stretch\"><div flex \nlayout=\"row\" layout-align=\"start stretch\" class=\"call-progress\" \nng-show=\"thread.minutes && thread.minutes>=thread.minutesleft && thread.minutesleft>0\"><div class=\"w-20\"><div \nng-show=\"thread.bridgedCount + thread.bridgeFailedCount > 0\" layout=\"row\" layout-align=\"center center\" class=\"badge\">\n{{thread.bridgedCount + thread.bridgeFailedCount}}</div><md-tooltip><span \ntranslate=\"MAIL.MAIL_LIST.TOOLTIP_BRIDGES_COUNT\">Ilość połączeń</span></md-tooltip></div><div flex layout=\"column\" \nlayout-align=\"start stretch\" class=\"call-progress pl-10\"><div flex class=\"minutes-left\"><span \ntranslate=\"MAIL.MAIL_LIST.MINUTES_LEFT\">pozostało </span><b>\n{{(thread.minutesleft>0) ? thread.minutesleft +\' min\' : \'0\'}}</b></div><div flex class=\"border\" \nng-style=\"{\'border-color\': vm.generateTimeColors(thread.minutes)}\"><div class=\"inside\" \nng-style=\"{\'width\':((thread.minutes-(thread.minutesleft>0?thread.minutesleft:\'0\')) / thread.minutes)*100+\'%\', \'background-color\': vm.generateTimeColors(thread.minutes)}\">\n</div></div></div></div><div ng-if=\"thread.consultantID\" flex layout=\"row\" layout-align=\"start stretch\" \nclass=\"attached-consultant\"><img ng-src=\"{{vm.consultantList[thread.consultantID][0].photoUrl}}\" \nsrc=\"assets/icons/communicator/user_avatar.svg\" class=\"badge\"><md-tooltip><span \ntranslate=\"MAIL.MAIL_LIST.TOOLTIP_CONSULTANT_ASSIGNED\">Konsultant przpisany</span></md-tooltip><span \nclass=\"consultant-name\">\n{{ vm.consultantList[thread.consultantID][0].alias ? vm.consultantList[thread.consultantID][0].alias : vm.consultantList[thread.consultantID][0].firstName}}\n</span></div><div flex class=\"call-complete\" layout=\"row\" ng-show=\"thread.minutes && thread.minutesleft<=0\"><i \nclass=\"fa fa-check\" aria-hidden=\"true\"></i></div><div flex class=\"service\" \nng-if=\"thread.serviceInfo.serviceId && (!vm.OrderboxGlue.currentFilter.filter || vm.OrderboxGlue.currentFilter.filter===\'assignedlist\')\" \nng-class=\"thread.serviceInfo.color\">{{thread.serviceInfo.serviceName}}</div></div></div></div></div>");
$templateCache.put("app/main/contactcenter/orderbox/componets/maillistfilters/maillistfilters.html","<form ng-cloack name=\"vm.form\" novalidate=\"novalidate\" autocomplete=\"off\"><div ng-repeat=\"filter in vm.filters\" \nclass=\"filter-setter filter-header\" layout=\"row\" layout-align=\"space-between center\"><div \nng-if=\"filter.filterType.token && !filter.filterType.noTitle\" flex=\"20\" class=\"filter-label\" \ntranslate=\"{{filter.filterType.token}}\">{{filter.filterType.token}}</div><dynamic-form flex \nform-config=\"filter.filterConfig\" settings=\"filter.filterData\"></dynamic-form><div class=\"common-actions\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-icon-button ani-button small\" ng-click=\"vm.closeFilter(filter)\">\n<md-icon class=\"circle\" md-svg-src=\"/assets/icons/circle-button.svg\"></md-icon><md-icon class=\"icon-action\" \nmd-svg-src=\"/assets/icons/management/letter-x.svg\"></md-icon><md-tooltip>Usuń filtr</md-tooltip></md-button></div>\n</div><mail-list-menu ng-if=\"vm.OrderboxGlue.outlookViewOnFire\" current-thread=\"vm.OrderboxGlue.currentThread\" \nthreads=\"vm.OrderboxGlue.threads\" status-click-call=\"vm.setStatusFilter\"></mail-list-menu><div \nclass=\"filter-setter filter-header\" layout=\"row\" layout-align=\"space-between center\"><div \nng-if=\"vm.sortFilter.filterType.token && !vm.sortFilter.filterType.noTitle\" flex=\"20\" class=\"filter-label\" \ntranslate=\"{{vm.sortFilter.filterType.token}}\">{{vm.sortFilter.filterType.token}}</div><dynamic-form \nng-if=\"vm.OrderboxGlue.currentFilter.type===vm.orderboxGlueConsts.callbackFolderType\" flex \nform-config=\"vm.sortFilter.filterConfig\" settings=\"vm.sortFilter.filterData\"></dynamic-form><dynamic-form \nng-if=\"vm.OrderboxGlue.currentFilter.type===vm.orderboxGlueConsts.mailFolderType\" flex \nform-config=\"vm.sortMailFilter.filterConfig\" settings=\"vm.sortMailFilter.filterData\"></dynamic-form></div></form>");
$templateCache.put("app/main/contactcenter/orderbox/componets/mainSidenav/mainsidenav.html","<div class=\"compose-button\"><md-button \nng-if=\"!vm.isManager || vm.OrderboxGlue.currentFilter.type != vm.orderboxGlueConsts.callbackFolderType\" \nclass=\"md-accent md-raised\" aria-label=\"compose\" ng-click=\"vm.composeDialog($event)\" \ntranslate=\"MAIL.MAINSIDENAV.COMPOSE\">COMPOSE</md-button><md-button \nng-if=\"vm.isManager && vm.OrderboxGlue.currentFilter.type == vm.orderboxGlueConsts.callbackFolderType\" \nclass=\"md-green-500-bg md-raised\" aria-label=\"compose\" ng-click=\"vm.composeDialog($event)\" \ntranslate=\"MAIL.MAINSIDENAV.COMPOSE_CALLBACK\">COMPOSE</md-button></div><md-content ms-scroll class=\"content\" flex><div \nclass=\"navigation-simple option-menu navigation-left\" layout=\"column\"><div \nng-if=\"vm.avaliablePartnerServices && vm.avaliablePartnerServices.length > 0\" \nclass=\"group folder-group service-sector right-shadow\" \nng-class=\"{\'active\':(vm.avaliablePartnerServices | filter : {\'isActive\':true}).length>0}\"><div \nclass=\"group-header option-header custom-header\" \nng-click=\"vm.showAvaliablePartnerServices=!vm.showAvaliablePartnerServices\" layout=\"row\" \nlayout-align=\"space-between center\"><p translate=\"MAIL.MAINSIDENAV.SERVICE_GROUP_TITLE\"></p><div \nclass=\"arrow-containner\"><i class=\"icon icon-chevron-down\" ng-show=\"vm.showAvaliablePartnerServices\"></i> <i \nclass=\"icon icon-chevron-up\" ng-hide=\"vm.showAvaliablePartnerServices\"></i></div></div><div \nng-hide=\"vm.avaliablePartnerServicesLoaded\" layout-align=\"center center\" layout=\"column\"><md-progress-circular \nmd-diameter=\"60px\" class=\"md-accent\"></md-progress-circular></div><div \nng-show=\"vm.showAvaliablePartnerServices && vm.avaliablePartnerServicesLoaded\" class=\"option-content\"><ul \nclass=\"option-submenu\" layout=\"column\"><li layout=\"column\" layout-align=\"start stretch\" \nng-class=\"{\'selected\':service.isActive}\" aria-label=\"inboxes\" ng-repeat=\"service in vm.avaliablePartnerServices\" \nng-click=\"vm.loadFolderTitles(service,(service.type===\'E\'?vm.orderboxGlueConsts.serviceFolderType:vm.orderboxGlueConsts.callbackFolderType),service.serviceId,service.allMessagesCount)\">\n<div layout=\"row\" layout-align=\"space-between center\" class=\"submenu-header\"><md-icon flex=\"10\" \nng-if=\"::service.type===\'E\'\" md-font-icon=\"icon-email\" class=\"s16\" ng-class=\"vm.prepairServiceClass(service.color)\">\n</md-icon><md-icon flex=\"10\" ng-if=\"::service.type===\'V\'\" md-font-icon=\"icon-phone\" class=\"s16\" \nng-class=\"vm.prepairServiceClass(service.color)\"></md-icon><span flex>{{ service.serviceName }}</span></div></li></ul>\n</div></div><div class=\"group folder-group mailbox-sector right-shadow\" \nng-class=\"{\'active\':(vm.mailBoxes | filter : {\'isActive\':true}).length>0}\"><div \nclass=\"group-header option-header custom-header\" \nng-click=\"vm.showAvaliableUserMailBoxes=!vm.showAvaliableUserMailBoxes\" layout=\"row\" \nlayout-align=\"space-between center\"><p translate=\"MAIL.MAINSIDENAV.MAILBOX_GROUP_TITLE\"></p><div \nclass=\"arrow-containner\"><i class=\"icon icon-chevron-down\" ng-show=\"vm.showAvaliableUserMailBoxes\"></i> <i \nclass=\"icon icon-chevron-up\" ng-hide=\"vm.showAvaliableUserMailBoxes\"></i></div></div><div ng-hide=\"vm.mailBoxesLoaded\" \nlayout-align=\"center center\" layout=\"row\"><md-progress-circular md-diameter=\"60px\" class=\"md-accent\">\n</md-progress-circular></div><div ng-show=\"vm.mailBoxesLoaded && vm.showAvaliableUserMailBoxes\" class=\"option-content\">\n<ul class=\"menu-list option-submenu\"><li layout=\"column\" layout-align=\"start stretch\" class=\"mailbox\" \nng-repeat=\"mailbox in vm.mailBoxes\" ng-click=\"vm.setMailBoxAsActive(mailbox,orderboxGlueConsts.mailFolderType,null)\">\n<div layout=\"row\" layout-align=\"space-between center\" class=\"submenu-header\"><img flex=\"10\" ng-show=\"mailbox.userID\" \nsrc=\"assets/icons/orderbox/personal_mb.svg\" alt=\"\" class=\"mailbox-type-icon\"> <img flex=\"10\" \nng-show=\"!mailbox.userID && mailbox.callCenterID \" src=\"assets/icons/orderbox/callcenter_mb.svg\" alt=\"\" \nclass=\"mailbox-type-icon\"> <img flex=\"10\" \nng-show=\"!mailbox.userID && !mailbox.callCenterID && mailbox.partnerID !== undefined \" \nsrc=\"assets/icons/orderbox/partner_mb.svg\" alt=\"\" class=\"mailbox-type-icon\"> <span flex>{{::mailbox.emailAddressShort}}\n</span><div flex=\"20\" class=\"arrow-containner\"><i class=\"icon icon-chevron-up\" ng-show=\"mailbox.show\"></i> <i \nclass=\"icon icon-chevron-down\" ng-hide=\"mailbox.show\"></i></div></div><div ng-if=\"mailbox.connectionStatus===\'Error\'\" \nclass=\"loading-error\"><span translate=\"MAIL.MAINSIDENAV.MB_LOADING_ERROR\">Bład podczas ładowania...</span></div><div \nng-hide=\"!mailbox.show || mailbox.loaded\" layout-align=\"center center\" layout=\"row\"><md-progress-circular \nmd-diameter=\"30px\" class=\"md-accent\"></md-progress-circular></div><div ng-show=\"mailbox.show && mailbox.loaded\" \nflex=\"80\" layout=\"column\" layout-align=\"center stretch\" class=\"menu-list option-content mailbox-folder-list\"><ul \nclass=\"option-submenu\" layout=\"column\"><li class=\"sub-item pl-25\" aria-label=\"inboxes\" \nng-repeat=\"folder in mailbox.folders | filter:{\'isMain\':mailbox.folderFiler}\" \nng-click=\"vm.loadFolderTitles(mailbox,vm.orderboxGlueConsts.mailFolderType,folder.name,folder.allMessagesCount);$event.stopPropagation();\" \nng-class=\"{\'selected\': folder.isActive}\"><div class=\"submenu-header\" layout=\"row\" layout-align=\"space-between center\">\n<md-icon flex=\"10\" md-font-icon=\"{{ folder.icon }}\" class=\"s16\"></md-icon><span flex>{{ folder.name }}</span></div>\n</li></ul><div class=\"more-less mr-25\" ng-click=\"vm.changeMailFolderFilter(mailbox);$event.stopPropagation();\" \nlayout=\"row\" layout-align=\"end start\"><i class=\"icon icon-plus\" ng-show=\"mailbox.folderFiler!==undefined\"></i> <i \nclass=\"icon icon-minus\" ng-show=\"mailbox.folderFiler===undefined\"></i></div></div></li></ul></div></div><div \nclass=\"group folder-group callorder-sector right-shadow\" \nng-class=\"{\'active\':(vm.callbackFolders | filter : {\'isActive\':true}).length>0}\"><div \nclass=\"group-header custom-header option-header\" layout=\"row\" layout-align=\"space-between center\" \nng-if=\"!vm.visibleCallbackDetails\"><p translate=\"MAIL.MAINSIDENAV.CALLORDER_GROUP_TITLE\" \nng-click=\"vm.loadFolderTitles(vm.orderboxGlueConsts.callbackSessions,vm.orderboxGlueConsts.callbackFolderType,null,vm.callbackFolders[0].count)\">\n</p><div class=\"current-phone\" layout=\"row\" ng-if=\"vm.isConsultant\"><md-icon class=\"mr-10\" \nmd-svg-src=\"assets/icons/dashboard/phonetype/{{ vm.currentPhone.phoneType }}.svg\"></md-icon><p \nng-if=\"vm.currentPhone.phoneType !== 4\">{{vm.currentPhone.phone1}}</p></div></div><div \nclass=\"menu-list option-content\" layout=\"column\" ng-if=\"vm.showCallbackDetails \"><ul class=\"option-submenu\" \nlayout=\"column\"><li layout=\"column\" layout-align=\"start stretch\" ng-repeat=\"folder in vm.callbackFolders\" \nng-class=\"{\'selected\':folder.isActive}\" aria-label=\"inboxes\" \nng-click=\"vm.loadFolderTitles(vm.orderboxGlueConsts.callbackSessions,vm.orderboxGlueConsts.callbackFolderType,folder.box,folder.count)\">\n<div layout=\"row\" layout-align=\"start center\" class=\"submenu-header\"><md-icon flex=\"10\" \nmd-font-icon=\"{{ folder.icon }}\" class=\"s16\"></md-icon><p flex translate=\"{{ folder.name }}\"></p></div></li></ul></div>\n</div></div></md-content>");
$templateCache.put("app/main/contactcenter/orderbox/componets/maillistmenu/maillistmenu.html","<div id=\"mail-list-menu\" class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\" flex=\"100\"><div ng-if=\"!(vm.currentThread && vm.OrderboxGlue.classicViewOnFire)\">\n<md-checkbox class=\"no-label\" aria-label=\"{{vm.OrderboxGlue.someMailsAreSelected ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"vm.OrderboxGlue.someMailsAreSelected\" \nng-click=\"vm.toggleSelectThreads(); vm.selectMailModeOn = !vm.selectMailModeOn;\"></md-checkbox><md-menu \nclass=\"select-menu\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"Filters\" translate \ntranslate-attr-aria-label=\"MAIL.FILTERS\"><i class=\"icon icon-chevron-down\"></i></md-button><md-menu-content width=\"3\" \nclass=\"black-menu\"><md-menu-item><md-button ng-click=\"vm.selectThreads();\" aria-label=\"All\" \ntranslate=\"MAIL.MAIL_LIST_MENU.ALL\" translate-attr-aria-label=\"MAIL.MAIL_LIST_MENU.ALL\">All</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.deselectThreads();\" aria-label=\"None\" translate=\"MAIL.MAIL_LIST_MENU.NONE\" \ntranslate-attr-aria-label=\"MAIL.MAIL_LIST_MENU.NONE\">None</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.selectThreadsWithiFilters(\'seen\', true)\" aria-label=\"Read\" translate=\"MAIL.MAIL_LIST_MENU.READ\" \ntranslate-attr-aria-label=\"MAIL.MAIL_LIST_MENU.READ\">Read</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.selectThreadsWithiFilters(\'seen\', false)\" aria-label=\"Unread\" translate=\"MAIL.MAIL_LIST_MENU.UNREAD\" \ntranslate-attr-aria-label=\"MAIL.MAIL_LIST_MENU.UNREAD\">Unread</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div layout=\"row\" layout-align=\"start center\" ng-if=\"vm.currentThread && vm.OrderboxGlue.classicViewOnFire\">\n<md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" ng-click=\"vm.closeThread()\" translate \ntranslate-attr-aria-label=\"MAIL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button></div><div \nng-show=\"vm.currentThread || vm.OrderboxGlue.someMailsAreSelected\" hide show-gt-xs><div class=\"after-select-menu\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"divider-vertical\"></div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"MAIL.MAIL_LIST_MENU.MORE\" translate \ntranslate-attr-aria-label=\"MAIL.MAIL_LIST_MENU.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\" class=\"black-menu\"><md-menu-item><md-button \nng-click=\"vm.setSelectedThreadsFlag(\'seen\', true)\"><span translate=\"MAIL.MAIL_LIST_MENU.MARK_AS_SEEN\">Mark as seen\n</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.setSelectedThreadsFlag(\'seen\', false)\"><span \ntranslate=\"MAIL.MAIL_LIST_MENU.MARK_AS_UNSEEN\">Mark as unseen</span></md-button></md-menu-item></md-menu-content>\n</md-menu></div></div><div flex><div flex layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.OrderboxGlue.currentFilter.type===vm.orderboxGlueConsts.callbackFolderType && vm.OrderboxGlue.currentFilter.filter!==\'callbackListDone\'\">\n<div class=\"filter-button-container\" ng-click=\"vm.changePaymentStatusFilter(false,true)\"><div><img class=\"dolar-ico\" \nng-src=\"{{vm.paymentStatus}}\"><md-tooltip ng-if=\"vm.showPay\"><span translate=\"MAIL.MAIL_LIST_MENU.NOT_SHOW_PAY\">\nNie pokazuj płatnych</span></md-tooltip><md-tooltip ng-if=\"!vm.showPay\"><span translate=\"MAIL.MAIL_LIST_MENU.SHOW_PAY\">\nPokaż płatne</span></md-tooltip></div></div><div class=\"filter-button-container\" \nng-click=\"vm.changePaymentStatusFilter( true,false)\"><span class=\"free-button\" \nng-style=\"{\'color\': vm.checkColor,\'border-color\':vm.checkColor}\">free</span><md-tooltip ng-if=\"vm.showFree\"><span \ntranslate=\"MAIL.MAIL_LIST_MENU.NOT_SHOW_FREE\">Nie pokazuj darmowych</span></md-tooltip><md-tooltip \nng-if=\"!vm.showFree\"><span translate=\"MAIL.MAIL_LIST_MENU.SHOW_FREE\">Pokaż darmowe</span></md-tooltip></div></div>\n</div><div layout=\"row\" layout-align=\"start center\"><span class=\"page-info\" hide-sm>{{vm.OrderboxGlue.currentPage+1}} \n<span translate=\"MAIL.MAIL_LIST_MENU.OF\">z</span>\n {{vm.OrderboxGlue.totalMailboxPages ? vm.OrderboxGlue.totalMailboxPages : 1}}</span><md-button \nclass=\"md-icon-button arrow\" ng-disabled=\"0 > vm.OrderboxGlue.currentPage-1\" \nng-click=\"vm.setPage(vm.OrderboxGlue.currentPage-1);\" aria-label=\"Previous\" translate \ntranslate-attr-aria-label=\"MAIL.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span \ntranslate=\"MAIL.PREVIOUS\">Previous</span></md-tooltip></md-button><md-button class=\"md-icon-button arrow\" \nng-disabled=\"vm.OrderboxGlue.currentPage+1 >= vm.OrderboxGlue.totalMailboxPages\" \nng-click=\"vm.setPage(vm.OrderboxGlue.currentPage+1);\" aria-label=\"Next\" translate \ntranslate-attr-aria-label=\"MAIL.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span \ntranslate=\"MAIL.NEXT\">Next</span></md-tooltip></md-button></div></div></div>");
$templateCache.put("app/main/contactcenter/orderbox/dialogs/assign/assign-dialog.html","<dialog-component id=\"assign-dialog\" dialog-title=\"\'SERVICE_CONSULTANT.TITLE\'\"><content layout=\"column\" \nlayout-align=\"start stretch\" class=\"content\"><div class=\"container\"><div layout=\"column\" \nstyle=\"max-height: 50vh; height: 100%\"><div flex=\"5\" class=\"input-bar\" layout=\"row\" layout-fill \nlayout-align=\"space-between start\"><p></p><md-input-container md-no-float><input placeholder=\"Search for anyone\" \ntype=\"text\" ng-model=\"vm.search\" translate translate-attr-placeholder=\"TAHEADER.SEARCH\"></md-input-container></div><div\n flex ms-scroll layout-fill class=\"consultants-container scrollable scrollable-list\"><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"table-header ph-10\"><div flex=\"90\" layout=\"row\" layout-align=\"start center\">\n<p class=\"text\" flex=\"50\">{{\"MAIL.ASSIGN_DIALOG.CONSULTANT\" | translate}}</p><p class=\"text\" flex=\"50\">\n{{\"MAIL.ASSIGN_DIALOG.LOGIN_FROM_CHANNEL\" | translate}}</p></div><p class=\"text\" flex=\"10\"></p></div><div \nng-if=\"vm.loadConsultants\" flex layout=\"row\" layout-align=\"center center\" class=\"consultant consultant-item\">\n<md-progress-circular></md-progress-circular></div><div flex layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"consultant in vm.consultantsList | filter: vm.search\" class=\"consultant consultant-item\" \nng-class=\"vm.selectedConsultant && vm.selectedConsultant.consultantID == consultant.consultantID ? \'selected\':\'\'\" \nng-init=\"consultant.showPlus=false\" ng-mouseover=\"consultant.showPlus=true\" ng-mouseleave=\"consultant.showPlus=false\">\n<div flex=\"90\" layout=\"row\" layout-align=\"start center\"><div flex=\"10\" class=\"consultant-avatar\" layout=\"row\" \nlayout-align=\"start center\"><img class=\"md-avatar\" ng-class=\"{\'active-call\':consultant.callID}\" \nng-if=\"consultant.photoUrl\" alt=\"{{consultant.firstName}}\" ng-src=\"{{consultant.photoUrl}}\"><avatar-letter \nng-class=\"{\'active-call\':consultant.callID}\" ng-if=\"!consultant.photoUrl\" name=\"consultant.firstName\"></avatar-letter>\n</div><div flex=\"40\"><strong class=\"consultant-name\">\n{{consultant.login}} ({{consultant.firstName}} {{consultant.lastName}})</strong></div><div flex=\"50\" layout=\"row\" \nlayout-align=\"start center\"><div flex=\"30\" class=\"consultant-fromlogin\"><strong><timer \nng-if=\"consultant.lastLoginDate\" flex start-time=\"consultant.lastLoginDate\" interval=\"1000\">\n{{hhours}}h {{mminutes}}m {{sseconds}}s</timer></strong></div><div flex=\"70\" layout=\"row\" layout-align=\"start center\">\n<img class=\"phonetype\" \nng-hide=\"consultant.phoneTypeId == 5 || consultant.phoneTypeId == 6 || consultant.phoneTypeId == 0\" \nng-src=\"assets/icons/dashboard/phonetype/{{ consultant.phoneTypeId }}_{{ consultant.callStatus }}.svg\"> <img \nclass=\"phonetype\" ng-if=\"consultant.phoneTypeId == 5 || consultant.phoneTypeId == 6 || consultant.phoneTypeId == 0\" \nng-src=\"assets/icons/dashboard/phonetype/{{ consultant.phoneTypeId }}.svg\"><p class=\"\" \nng-if=\"consultant.phone1!==\'---\'\" ng-style=\"{ color: consultant.callStatus == 1 ? \'green\' : \'black\' }\">\n{{consultant.phone1}}</p></div></div></div><div flex=\"10\" layout=\"row\" class=\"icon-place\" layout-align=\"end center\">\n<md-icon class=\"check\" md-svg-src=\"/assets/icons/assign_consultant.svg?v=1.0.2\" \nng-click=\"vm.consultantClick(consultant)\" \nng-class=\"{\'green\':( vm.selectedConsultant && vm.selectedConsultant.consultantID == consultant.consultantID)}\">\n</md-icon><div flex layout=\"row\" class=\"icon-place\"><md-menu class=\"time-icon\" \nng-if=\"(consultant.status == 1 && consultant.phoneTypeId == 4) || consultant.phoneTypeId !== 4\"><md-icon \nclass=\"clock-bt\" \nng-class=\"{\'green\':(vm.schedulerTime && vm.selectedConsultant && vm.selectedConsultant.consultantID == consultant.consultantID)}\" \nmd-svg-src=\"/assets/icons/communicator/big-circular-clock.svg?v=1.0.2\" ng-click=\"vm.openTime($mdMenu, $event)\">\n</md-icon><md-menu-content width=\"4\" class=\"send-time-menu\"><md-menu-item ng-repeat=\"time in vm.timeArray\"><md-button \nng-click=\"vm.setTime(time, consultant)\">{{time.text}}</md-button></md-menu-item><md-menu-divider></md-menu-divider>\n<md-menu-item><md-button ng-click=\"vm.setCustomTime(consultant)\"><span translate=\"MAIL.ASSIGN_DIALOG.TIME.CUSTOM_DATE\">\n</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></div></div></div></div><md-dialog-actions \nlayout=\"row\"><div flex layout=\"row\" layout-align=\"end center\"><md-button class=\"save-button\" ng-click=\"vm.saveForm()\" \naria-label=\"Save\"><img src=\"assets/icons/triple-view/zapisz.png\"> <span translate=\"MAIL.ASSIGN_DIALOG.SAVE\" \ntranslate-attr-aria-label=\"MAIL.ASSIGN_DIALOG.SAVE\">Save</span></md-button></div></md-dialog-actions></content>\n</dialog-component>");
$templateCache.put("app/main/contactcenter/orderbox/dialogs/composecallback/compose-callback-dialog.html","<dialog-component id=\"compose-callback-dialog\" savefunc=\"vm.saveCallbackRequest\" \ndialog-title=\"\'MAIL.COMPOSE_CALLBACK_DIALOG.TITLE\'\"><content layout=\"column\" layout-align=\"start stretch\" \nclass=\"p-20 scrollable\" ms-scroll style=\"height: 100%\"><accordion-form main-form=\"vm.formValid\" \non-complete=\"(vm.saveCallbackRequest)\"><form-pane pane-icon=\"assets/icons/management/consultants/phone-call.svg\" \nhide-content=\"vm.serviceFolderMode\"><p-header><p>Serwis</p></p-header><p-minified>{{ vm.callbackService.serviceName }}\n</p-minified><p-content layout=\"column\" layout-align=\"start stretch\"><md-input-container flex=\"95\" class=\"md-block to\">\n<label translate=\"MAIL.COMPOSE_CALLBACK_DIALOG.CALLBACK_SERVICE\">To</label><md-select name=\"callbac-service\" \nng-model=\"vm.callbackService\" ng-change=\"vm.callbackServiceChanged()\" placeholder=\"Wybierz serwis\" aria-label=\"\" \nrequired><md-option ng-value=\"service\" \nng-repeat=\"service in vm.callbackServices | filter:{type:\'V\'} | orderBy: \'name\'\">({{ service.serviceId }}) <span \nng-if=\"service.serviceName\">({{ service.serviceName }})</span></md-option></md-select></md-input-container></p-content>\n</form-pane><form-pane next-pane-call=\"vm.nextPanePayment\" controls-hide=\"true\" \npane-icon=\"assets/icons/orderbox/dollar_green.svg\"><p-header><p>Płatność</p></p-header><p-minified \nng-if=\"vm.choosenPayment\">{{ vm.choosenPayment.title }} (Cena: {{ vm.choosenPayment.grossPrice / 100 }} PLN)\n</p-minified><p-content layout=\"column\" layout-align=\"start stretch\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"add-payment\"><md-menu class=\"payment-button\" flex=\"25\"><md-button \n[ngclass]=\"{ \'md-accent\': vm.choosenPayment }\" id=\"btn-add-payment\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-coin\"></md-icon><span ng-if=\"vm.choosenPayment\">\n{{ vm.choosenPayment.title }} (Cena: {{ vm.choosenPayment.grossPrice / 100 }} PLN)</span> <span \nng-if=\"!vm.choosenPayment\">Dodaj płatność</span></md-button><md-menu-content width=\"4\" \nng-mouseleave=\"$mdMenu.close() scrollable\" ms-scroll><md-menu-item ng-repeat=\"payment in vm.allowedPaymentstypes\">\n<md-button ng-click=\"vm.pickPayment(payment); vm.nextPanePayment(true);\">\n{{ payment.title }} (Cena: {{ payment.grossPrice / 100 }} PLN)</md-button></md-menu-item><md-menu-item \nng-show=\"vm.allowedPaymentstypes.length===0\"><md-button ng-disable=\"true\"><span \ntranslate=\"MAIL.COMPOSE_DIALOG.NO_PAYMENT_TO_PIC\"></span></md-button></md-menu-item></md-menu-content></md-menu></div>\n<input pane-helper name=\"payment\" type=\"text\" ng-model=\"vm.callback.ppId\" style=\"display:none\" required></p-content>\n</form-pane><form-pane pane-icon=\"/assets/icons/name-tag.svg\"><p-header><p>Dane kontaktowe</p></p-header><p-minified \nng-if=\"vm.callback.customer.msisdn\" layout=\"column\" layout-align=\"start stretch\"><p>{{ vm.callback.customer.msisdn }}\n</p><p ng-if=\"vm.callback.customer.email\">{{ vm.callback.customer.email }}</p><p \nng-if=\"vm.callback.customer.firstName\">{{ vm.callback.customer.firstName }}</p><p \nng-if=\"vm.callback.customer.lastName\">{{ vm.callback.customer.lastName }}</p></p-minified><p-content layout=\"column\" \nlayout-align=\"start stretch\"><form name=\"contactForm\" layout=\"column\" layout-align=\"start stretch\"><div layout=\"row\" \nclass=\"customer-callback\" layout-align=\"space-around center\"><div flex=\"50\" layout=\"column\"><div flex layout=\"row\">\n<md-input-container flex=\"35\" class=\"m-0 mt-15\"><md-select flex=\"15\" name=\"country\" ng-model=\"vm.countryCode\" \nclass=\"country-codes-list\" placeholder=\"Wybierz kraj\"><md-option ng-value=\"item\" ng-repeat=\"item in vm.countryList\">\n<div layout=\"row\"><div class=\"code\" style=\"margin-right:10px\">{{ item.dial_code }}</div>{{ item.name }}</div>\n</md-option></md-select></md-input-container><md-input-container class=\"m-0 mt-15\"><label \ntranslate=\"MAIL.COMPOSE_CALLBACK_DIALOG.MSISDN\">MSISDN</label><input name=\"contactMsisdn\" ng-model=\"vm.contactMsisdn\" \nphone-number country-code=\"vm.countryCode.code\" ng-change=\"vm.searchContact(contactForm.contactMsisdn)\" \nng-focus=\"vm.msisdnOnFocus()\" type=\"text\"></md-input-container></div><md-input-container class=\"m-0\"><label \ntranslate=\"MAIL.COMPOSE_CALLBACK_DIALOG.EMAIL\">EMAIL</label><input ng-model=\"vm.callback.customer.email\" type=\"email\">\n</md-input-container></div><div flex=\"40\" layout=\"column\"><md-input-container class=\"m-0 mt-15\"><label \ntranslate=\"MAIL.COMPOSE_CALLBACK_DIALOG.FIRST_NAME\">FIRST_NAME</label><input ng-model=\"vm.callback.customer.firstName\" \ntype=\"text\"></md-input-container><md-input-container class=\"m-0\"><label \ntranslate=\"MAIL.COMPOSE_CALLBACK_DIALOG.LAST_NAME\">LAST_NAME</label><input ng-model=\"vm.callback.customer.lastName\" \ntype=\"text\"></md-input-container></div></div><p ng-if=\"vm.contactFromDb\" class=\"md-warn-fg\">\n{{ \"MAIL.COMPOSE_CALLBACK_DIALOG.CONTACT_WARN\" | translate }}</p></form></p-content></form-pane><form-pane \npane-icon=\"/assets/icons/name-tag.svg\"><p-header><p>Informacje dodatkowe</p></p-header><p-minified></p-minified>\n<p-content layout=\"column\" layout-align=\"start stretch\"><div class=\"prefered-time\" layout=\"row\"><div flex \nng-if=\"vm.preferedTimeMode\" class=\"toggle-anim\" layout=\"row\"><time-range start=\"vm.preferedTime.start\" \nend=\"vm.preferedTime.end\" on-change=\"vm.preferedTimeChanged(vm.preferedTime.start, vm.preferedTime.end)\"></time-range>\n</div><md-button class=\"mode-button\" ng-click=\"vm.togglePreferedTime();\"><span ng-if=\"!vm.preferedTimeMode\">\nPreferowane godziny</span><md-icon ng-if=\"vm.preferedTimeMode\" md-font-icon=\"icon-trash\"></md-icon></md-button></div>\n<md-input-container class=\"m-0 mt-15\"><label translate=\"MAIL.COMPOSE_CALLBACK_DIALOG.ANNOTATION\">Annotation</label>\n<input ng-model=\"vm.callback.customer.annotation\" type=\"text\"></md-input-container></p-content></form-pane><form-pane \npane-icon=\"/assets/icons/parameters.svg\"><p-header><p>Parametry</p></p-header><p-minified></p-minified><p-content \nlayout=\"column\" layout-align=\"start stretch\"><div ng-if=\"vm.callback.params\" layout=\"column\" \nlayout-align=\"start stretch\" class=\"mh-20 kay-value-row\"><div ng-repeat=\"param in vm.callback.params\" layout=\"row\" \nlayout-align=\"start center\"><md-input-container flex=\"75\" class=\"m-0\"><label \ntranslate=\"MAIL.COMPOSE_CALLBACK_DIALOG.KEY\">KEY</label><input id=\"param-{{ $index }}-key\" \nname=\"param-{{ $index }}-key\" ng-model=\"param.Key\" type=\"text\" required></md-input-container><h1 class=\"pb-20\">=</h1>\n<md-input-container flex=\"75\" class=\"m-0\"><label translate=\"MAIL.COMPOSE_CALLBACK_DIALOG.VALUE\">VALUE</label><input \npane-helper id=\"param-{{ $index }}-value\" name=\"param-{{ $index }}-value\" ng-model=\"param.Value\" type=\"text\" required>\n</md-input-container><div flex=\"20\"><md-button class=\"md-icon-button\" ng-click=\"vm.deleteParam(param);\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></div></div></div><div layout=\"row\" layout-align=\"start center\" \nclass=\"mh-20\"><md-input-container flex=\"75\" class=\"m-0\"><label translate=\"MAIL.COMPOSE_CALLBACK_DIALOG.KEY\">KEY</label>\n<input pane-helper id=\"new-param-key\" ng-model=\"vm.newParam.Key\" ng-change=\"vm.addNewParam();\" debounce=\"1000\" \ntype=\"text\"></md-input-container><h1 class=\"pb-20\">=</h1><md-input-container flex=\"75\" class=\"m-0\"><label \ntranslate=\"MAIL.COMPOSE_CALLBACK_DIALOG.VALUE\">VALUE</label><input id=\"new-param-value\" ng-model=\"vm.newParam.Value\" \ntype=\"text\" ng-disabled=\"!vm.newParam.Key\" ng-required=\"vm.newParam.Key\"></md-input-container><div flex=\"20\"></div>\n</div></p-content></form-pane></accordion-form></content></dialog-component>");
$templateCache.put("app/main/contactcenter/orderbox/dialogs/compose/compose-dialog.html","<form id=\"mail-dialog\" class=\"md-inline-form\" flow-init=\"vm.flowConfig\" flow-name=\"vm.Uploader\" \nflow-file-added=\"vm.validate($file)\" flow-files-submitted=\"$flow.upload()\" \nflow-file-success=\"vm.CallMeMaybe($flow, $file, $message)\" flow-file-retry=\"vm.retryChunk($file,$flow)\" ng-cloak>\n<dialog-component id=\"add-content-dialog\" show-footer=\"true\" \ndialog-title=\"\'MAIL.COMPOSE_DIALOG.\' +(vm.isForward ? \'FORWARD_MESSAGE\' : vm.selectedMail ? \'REPLY_MESSAGE\' : \'NEW_MESSAGE\')\">\n<content layout=\"column\" layout-align=\"start stretch\" class=\"p-20 scrollable\" ms-scroll \nstyle=\"max-height: 50vh; height: 100%\"><md-input-container class=\"md-block\"><label \ntranslate=\"MAIL.COMPOSE_DIALOG.FROM\">From</label><input ng-model=\"vm.form.from\" type=\"email\" disabled=\"disabled\">\n</md-input-container><md-input-container ng-if=\"!vm.isForward\" class=\"md-block to\" \nng-class=\"{\'hidden-cc\': vm.hiddenCC, \'hidden-bcc\': vm.hiddenBCC}\"><label translate=\"MAIL.COMPOSE_DIALOG.TO\">To</label>\n<input ng-model=\"vm.form.to\" type=\"email\" ng-disabled=\"vm.selectedMail\"></md-input-container><div flex layout=\"row\" \nng-if=\"vm.isForward\" layout-align=\"center center\"><md-input-container ng-if=\"!vm.CustomRedirect && vm.isForward\" \nflex=\"95\" class=\"md-block to\"><label translate=\"MAIL.COMPOSE_DIALOG.TO\">To</label><md-select \nng-model=\"vm.serviceToForward\" ng-change=\"vm.serviceToForwardChanged()\" placeholder=\"Wybierz serwis\" aria-label=\"\">\n<md-option ng-value=\"{{service.id}}\" ng-repeat=\"service in vm.serviceForForward | orderBy: \'name\'\" \nng-if=\"service.email!==vm.form.from\">{{service.name}} <span ng-if=\"service.email\">({{ service.email }})</span>\n</md-option></md-select></md-input-container><md-input-container ng-if=\"vm.CustomRedirect && vm.isForward\" flex=\"95\" \nclass=\"md-block to\"><label translate=\"MAIL.COMPOSE_DIALOG.TO\">To</label><input ng-model=\"vm.form.to\" type=\"email\">\n</md-input-container><span flex=\"5\"><md-button class=\"md-icon-button\" aria-label=\"\" \nng-click=\"vm.changeForwardRedirectType()\"><md-tooltip md-direction=\"top\">Przekieruj <span ng-if=\"vm.CustomRedirect\">\nna serwis</span> <span ng-if=\"!vm.CustomRedirect\">na email</span></md-tooltip><md-icon icon md-font-icon=\"icon-cog\" \nstyle=\"width: 24px; height: 24px\"></md-icon></md-button></span></div><md-input-container class=\"md-block\"><label \ntranslate=\"MAIL.COMPOSE_DIALOG.SUBJECT\">Subject</label><input ng-model=\"vm.form.subject\" type=\"text\" \nng-disabled=\"vm.isForward\"></md-input-container><div class=\"add-payment\" ng-if=\"vm.selectedMail.serviceInfo.serviceId\">\n<div ng-show=\"vm.selectedMail.paymentInfo && vm.selectedMail.paymentInfo.statusID!==4\" class=\"current-payment\">\nProśba o płatność została wysłana. Status płatności to: {{vm.selectedMail.paymentInfo.statusID}}</div><div \nng-hide=\"vm.selectedMail.paymentInfo && vm.selectedMail.paymentInfo.statusID!==4\" layout=\"row\" \nlayout-align=\"end center\"><md-menu flex=\"25\"><md-button id=\"btn-add-payment\" \nng-mouseenter=\"vm.loadPaymentData($mdMenu);\"><md-icon md-font-icon=\"icon-coin\"></md-icon><span>Dodaj płatność</span>\n</md-button><md-menu-content width=\"4\" ng-mouseleave=\"$mdMenu.close()\" ms-scroll><md-menu-item \nng-repeat=\"payment in vm.allowedPaymentstypes\"><md-button \nng-click=\"vm.selectedPaymentId = payment.id; vm.pickPayment(payment)\">\n{{payment.title}} (Cena: {{(payment.grossPrice/100)}} PLN)</md-button></md-menu-item><md-menu-item \nng-show=\"vm.allowedPaymentstypes.length===0\"><md-button ng-disable=\"true\"><span \ntranslate=\"MAIL.COMPOSE_DIALOG.NO_PAYMENT_TO_PIC\"></span></md-button></md-menu-item></md-menu-content></md-menu></div>\n</div><text-angular ng-model=\"vm.form.body\"></text-angular><div class=\"attachment-list\"><div class=\"attachment\" \nlayout=\"row\" layout-align=\"space-between center\" ng-repeat=\"file in vm.files\"><div><span class=\"filename\">\n{{::vm.getFileName(file.name)}}</span> <span class=\"size\">{{file.fileSizeKB === \'\' ? \'-\': file.fileSizeKB}} KB</span>\n</div><md-button class=\"md-icon-button\" aria-label=\"Delete attachment\" translate \ntranslate-attr-aria-label=\"MAIL.COMPOSE_DIALOG.DELETE_ATTACHMENT\"><md-icon md-font-icon=\"icon-close\" class=\"s16\">\n</md-icon></md-button></div></div></content><footer layout=\"row\"><div flex layout=\"row\" layout-align=\"end center\">\n<md-button flow-btn class=\"md-icon-button\" aria-label=\"Attach file\" \ntranslate-attr-aria-label=\"MAIL.COMPOSE_DIALOG.ATTACH_FILE\"><md-icon md-font-icon=\"icon-paperclip\"></md-icon>\n<md-tooltip><span translate=\"MAIL.COMPOSE_DIALOG.ATTACH_FILE\"></span></md-tooltip></md-button><md-button \nng-click=\"vm.sendEmailMessage()\" class=\"send-button md-accent md-raised\" aria-label=\"Send\"><md-icon \nmd-font-icon=\"icon-send s16\" style=\"margin-top: 5px\"></md-icon><span translate=\"MAIL.COMPOSE_DIALOG.SEND\" \ntranslate-attr-aria-label=\"MAIL.COMPOSE_DIALOG.SEND\">Send</span></md-button></div></footer></dialog-component></form>");
$templateCache.put("app/main/contactcenter/orderbox/views/classic/classicview.html","<div flex=\"100\" layout=\"row\" class=\"h-65\"><mail-list-menu flex=\"95\" ng-if=\"vm.OrderboxGlue.classicViewOnFire\" \ncurrent-thread=\"vm.OrderboxGlue.currentThread\" threads=\"vm.OrderboxGlue.threads\"></mail-list-menu><div flex=\"5\" \nlayout=\"row\" layout-align=\"end center\" id=\"mail-list-menu\" class=\"toolbar\"><md-menu class=\"settings-menu\"><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"Settings\" translate \ntranslate-attr-aria-label=\"MAIL.SETTINGS\"><md-icon md-font-icon=\"icon-cog\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button \nng-click=\"vm.OrderboxGlue.changeView(vm.orderboxGlueConsts.orderBoxViewMode.classic)\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\" ng-if=\"!vm.OrderboxGlue.classicViewOnFire\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" ng-if=\"vm.OrderboxGlue.classicViewOnFire\"></md-icon><span \ntranslate=\"MAIL.CLASSIC_VIEW\">Classic View</span></md-button></md-menu-item><md-menu-item hide-xs><md-button \nng-click=\"vm.OrderboxGlue.changeView(vm.orderboxGlueConsts.orderBoxViewMode.outlook)\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\" ng-if=\"!vm.OrderboxGlue.outlookViewOnFire\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" ng-if=\"vm.OrderboxGlue.outlookViewOnFire\"></md-icon><span \ntranslate=\"MAIL.OUTLOOK_VIEW\">Outlook View</span></md-button></md-menu-item></md-menu-content></md-menu></div></div>\n<div class=\"content-wrapper\" layout=\"column\" flex><mail-list class=\"content thread-list\" \nng-if=\"!vm.OrderboxGlue.currentThread\" current-thread=\"vm.OrderboxGlue.currentThread\" threads=\"vm.threads\" ms-scroll \nflex></mail-list><mail-details class=\"content thread-detail\" ng-if=\"vm.OrderboxGlue.currentThread\" \ncurrent-thread=\"vm.OrderboxGlue.currentThread\" ms-scroll flex></mail-details></div>");
$templateCache.put("app/main/contactcenter/orderbox/views/outlook/outlookview.html","<div class=\"content-wrapper\" layout=\"row\" flex><div flex=\"100\" layout=\"column\" layout-align=\"start stretch\"><div \nflex=\"100\" layout=\"row\" layout-align=\"end center\" id=\"mail-list-menu\" class=\"toolbar\"><md-menu class=\"settings-menu\">\n<md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"Settings\" translate \ntranslate-attr-aria-label=\"MAIL.SETTINGS\"><md-icon md-font-icon=\"icon-cog\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button \nng-click=\"vm.OrderboxGlue.changeView(vm.orderboxGlueConsts.orderBoxViewMode.classic)\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\" ng-if=\"!vm.OrderboxGlue.classicViewOnFire\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" ng-if=\"vm.OrderboxGlue.classicViewOnFire\"></md-icon><span \ntranslate=\"MAIL.CLASSIC_VIEW\">Classic View</span></md-button></md-menu-item><md-menu-item hide-xs><md-button \nng-click=\"vm.OrderboxGlue.changeView(vm.orderboxGlueConsts.orderBoxViewMode.outlook)\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\" ng-if=\"!vm.OrderboxGlue.outlookViewOnFire\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" ng-if=\"vm.OrderboxGlue.outlookViewOnFire\"></md-icon><span \ntranslate=\"MAIL.OUTLOOK_VIEW\">Outlook View</span></md-button></md-menu-item></md-menu-content></md-menu></div>\n<mail-details flex=\"100\" class=\"content thread-detail\" current-thread=\"vm.OrderboxGlue.currentThread\" ms-scroll flex>\n</mail-details></div></div>");
$templateCache.put("app/main/contactcenter/reports/components/consultantChannelsActivity/consultantChannelsActivity.html","<div layout=\"column\" id=\"consultant-channels-activity\" class=\"easy-content\"><md-toolbar class=\"header md-primary-bg\" \nlayout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"center center\" style=\"margin-left: 20px\"><div \nclass=\"icon-container\"></div><span class=\"header-part\" translate=\"CONSULTANT_CHANALS_ACTIVITY.TITLE\">\nAktywność na kanałach</span></div></md-toolbar><div class=\"char-div\"><div class=\"no-data-container\" \nng-if=\"vm.chartData.length === 0\" layout=\"column\" layout-align=\"center center\"><div class=\"no-Data\"><img \nsrc=\"assets/icons/database.svg\" alt=\"\"><p>brak danych</p></div></div><nvd3 options=\"vm.options\" data=\"vm.chartData\" \nng-if=\"vm.chartData.length !== 0\"></nvd3></div></div>");
$templateCache.put("app/main/contactcenter/reports/components/reportfilters/reportfilters.html","<div class=\"sidenav-list\" style=\"overflow-x: hidden\" layout=\"column\" layout-align=\"space-between stretch\"><div \nclass=\"wrapperFilters\" layout=\"column\" layout-align=\"start stretch\"><div flex class=\"reportSidenav mt-20\" \nlayout=\"column\" layout-align=\"start stretch\"><md-input-container flex layout=\"row\"><md-button \nclass=\"md-icon-button calendar-button\"><img src=\"assets/icons/data.png\"></md-button><md-select flex \nclass=\"ml-10 mr-30\" ng-model=\"vm.sidenavData.finalDate.date\" \nng-change=\"vm.generateDate(vm.sidenavData.finalDate.date)\" placeholder=\"Wybierz daty\" \nng-disabled=\"form.fID.$viewValue.length > 0\" ng-class=\"{\'disabled\': form.fID.$viewValue.length > 0}\" name=\"chooseDate\">\n<md-option ng-repeat=\"d in vm.sidenavData.listDate\" ng-value=\"d.date\" ng-selected=\"$index == 0\" title=\"{{d.name}}\" \nalt=\"{{d.name}}\" style=\"margin-top: 0\">{{ d.name }}</md-option></md-select></md-input-container><md-input-container \nflex><label style=\"color: #ababab !important\">{{ \"REPORTS.FROM\" | translate }}</label><md-datepicker \nng-class=\"{errorInput: vm.sidenavData.params.From == undefined}\" ng-model=\"vm.sidenavData.params.From\" \nng-click=\"vm.setAnyDate()\" ng-disabled=\"vm.sidenavData.disableDate\" ng-change=\"vm.detectChangeDate()\" required>\n</md-datepicker></md-input-container><md-input-container flex><label style=\"color: #ababab !important\">\n{{ \"REPORTS.TO\" | translate }}</label><md-datepicker ng-class=\"{errorInput: vm.sidenavData.params.To == null}\" \nlayout=\"row\" ng-model=\"vm.sidenavData.params.To\" ng-click=\"vm.setAnyDate()\" ng-change=\"vm.detectChangeDate()\" \nng-disabled=\"vm.sidenavData.disableDate\" required></md-datepicker></md-input-container></div><h3 flex \nclass=\"errorMessage\">{{ vm.sidenavData.errorMsg }}</h3><div style=\"margin: 0 auto; width: 83%\"><md-input-container \nclass=\"reportSidenav\" flex ng-if=\"vm.sidenavData.config.paramList\"><label>Grupowanie</label><md-select \nng-model=\"vm.sidenavData.params.paramID\" multiple=\"multiple\" flex><md-optgroup label=\"Parametry\" flex><md-option \nng-value=\"param.id\" ng-repeat=\"param in vm.sidenavData.paramList\">{{param.param}}</md-option><md-option value=\"perDay\" \nng-click=\"vm.sidenavData.showDays()\">Data</md-option></md-optgroup></md-select></md-input-container></div>\n<md-input-container flex layout=\"column\" ng-if=\"vm.sidenavData.config.type\" class=\"ph-20 no-margin\"><h3 \nstyle=\"color: #ababab !important\">{{ \"REPORTS.SMS.TYPE\" | translate }}</h3><md-radio-group \nng-model=\"vm.sidenavData.params.type\"><md-radio-button style=\"color: #ababab\">{{ \"REPORTS.ALL\" | translate }}\n</md-radio-button><md-radio-button value=\"S\" style=\"color: #ababab\">SMS</md-radio-button><md-radio-button value=\"M\" \nstyle=\"color: #ababab\">MMS</md-radio-button><md-radio-button value=\"C\" style=\"color: #ababab\">CHAT</md-radio-button>\n</md-radio-group></md-input-container><md-input-container flex layout=\"column\" ng-if=\"vm.sidenavData.config.direction\" \nclass=\"ph-20 no-margin\"><h3 style=\"color: #ababab !important\">{{ \"REPORTS.SMS.DIRECTION\" | translate }}</h3>\n<md-radio-group ng-model=\"vm.sidenavData.params.direction\"><md-radio-button style=\"color: #ababab\">\n{{ \"REPORTS.ALL\" | translate }}</md-radio-button><md-radio-button value=\"I\" style=\"color: #ababab\">Inbound\n</md-radio-button><md-radio-button value=\"O\" style=\"color: #ababab\">Outbound</md-radio-button></md-radio-group>\n</md-input-container><div layout=\"column\" layout-align=\"start stretch\" class=\"mh-30\"><md-input-container flex \nng-if=\"vm.SessionManager.getUserRoleId() == vm.authRolesConst.admin\" ng-show=\"vm.sidenavData.config.CallcenterId\">\n<label style=\"color: #ababab !important\">Call Center</label><md-select flex=\"100\" \nng-model=\"vm.sidenavData.params.CallcenterId\" ng-change=\"vm.getCallcenterPerManager()\"><md-option ng-value=\"\"><em>\n{{ \"REPORTS.ALL\" | translate }}</em></md-option><md-option ng-repeat=\"state in vm.sidenavData.callCenterList\" \nng-value=\"state.id\">{{ state.callCenterName }}</md-option></md-select></md-input-container><md-input-container flex \nng-show=\"vm.sidenavData.config.startHour\"><label style=\"color: #ababab !important\">Godzina początka zmiany</label>\n<md-select flex=\"20\" ng-model=\"vm.startHour\" ng-change=\"vm.startHourChange(vm.startHour)\"><md-option \nng-repeat=\"hour in vm.startHours\" ng-selected=\"$first\" ng-value=\"hour\">{{ hour }}</md-option></md-select>\n</md-input-container><md-input-container flex ng-show=\"vm.sidenavData.config.activityCountType\"><label \nstyle=\"color: #ababab !important\">Zasada liczenia zmiany</label><md-select flex=\"100\" \nng-model=\"vm.sidenavData.params.activityCountType\"><md-option ng-repeat=\"countType in vm.shiftCountingList\" \nng-selected=\"$first\" ng-value=\"countType.value\">{{ countType.token }}</md-option></md-select></md-input-container><p \nflex ng-if=\"vm.sidenavData.ccidError\" class=\"errorMessage\">{{vm.sidenavData.ccidError}}</p><md-input-container \nng-if=\"vm.sidenavData.config.msisdn\"><label>MSISDN</label><input ng-model=\"vm.sidenavData.params.msisdn\">\n</md-input-container><md-input-container ng-if=\"vm.sidenavData.config.sessionId\"><label>Guid sesji</label><input \nng-model=\"vm.sidenavData.params.sessionId\"></md-input-container><md-input-container \nng-if=\"vm.sidenavData.config.contactName\"><label>Kontakt</label><input ng-model=\"vm.sidenavData.params.contactName\">\n</md-input-container><ta-search \nng-if=\"vm.SessionManager.getUserRoleId() !== vm.authRolesConst.consultant && vm.sidenavData.config.ConsultantId\" \nconf=\"vm.consultantSearchConf\" ng-model=\"vm.sidenavData.params.ConsultantId\"></ta-search><ta-search \nng-if=\"vm.sidenavData.config.reportSearch\" class=\"mt-20\" conf=\"vm.sidenavData.config.reportSearch\" \nng-model=\"vm.params[vm.sidenavData.config.reportSearch.dataProp]\"></ta-search></div><div flex class=\"showOrHideChart\" \nng-if=\"vm.sidenavData.config.partnerAgr\"><md-input-container layout=\"row\"><span \nstyle=\"color:#ababab; line-height: 60px; margin-right: 10px\">Serwis</span><md-switch \nng-model=\"vm.sidenavData.params.partnerAgr\"><span style=\"color:#ababab\">Partner</span></md-switch></md-input-container>\n</div><div flex class=\"showOrHideChart\" \nng-if=\"vm.sidenavData.config.tagsAgr && (vm.sidenavData.params.partnerAgr || !vm.sidenavData.config.partnerAgr)\">\n<md-input-container layout=\"column\"><md-switch ng-model=\"vm.sidenavData.params.tagsAgr\"><span style=\"color:#ababab\">\nGrupuj po Tagach</span></md-switch></md-input-container></div><div flex class=\"showOrHideChart\" \nng-if=\"vm.sidenavData.config.showFailed\"><md-input-container layout=\"column\"><md-switch \nng-model=\"vm.sidenavData.params.showFailed\"><span style=\"color:#ababab\">Pokaż wszystkie połączenia</span></md-switch>\n</md-input-container></div></div><div flex class=\"button-container\"><md-button class=\"buttonFilter\" \nng-click=\"vm.sidenavData.getConnectData()\">{{ \"REPORTS.FILTERS\" | translate }}<md-tooltip md-direction=\"bottom\">\nFiltruj raporty</md-tooltip></md-button></div></div>");
$templateCache.put("app/main/contactcenter/reports/components/reportsinfobox/reportsinfobox.html","<div flex layout=\"row\" layout-align=\"end center\"><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"20\"><ms-widget-front class=\"p-16\"><div class=\"pb-24\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><img class=\"reports-icon\" \nsrc=\"/assets/icons/phone-with-left-arrow.png\" alt=\"all-sms\"></div><div class=\"pb-24\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"h2\" style=\"color:#26a69a\">{{vm.in}}</div><div class=\"h2 secondary-text pl-8\" \nstyle=\"color:#26a598\">/ {{vm.reportsLength}}</div></div></div></ms-widget-front></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\"><ms-widget-front class=\"p-16\"><div \nclass=\"pb-24\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><img \nclass=\"reports-icon\" src=\"/assets/icons/phone-with-right-arrow.png\" alt=\"all-sms\"></div><div class=\"pb-24\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"h2\" style=\"color:#f8ab59\">{{vm.out}}</div><div \nclass=\"h2 secondary-text pl-8\" style=\"color:#f7b772\">/ {{vm.reportsLength}}</div></div></div></ms-widget-front>\n</ms-widget></div>");
$templateCache.put("app/main/contactcenter/reports/components/reportsessions/reportsessions.html","<div class=\"report-container\"><div class=\"chartForReports\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"pt-8\"><md-button class=\"ph-16 aggregationButtons\" ng-repeat=\"type in vm.dateType\" \nng-click=\"vm.changeAgrType(type)\" ng-disabled=\"vm.currentType.key == type.key\">{{type.text}}</md-button></div><div \nclass=\"pt-8\"><md-button ng-if=\"vm.SessionManager.getUserRoleId() !== vm.authRolesConst.consultant\" \nng-click=\"vm.downloadXLSX()\"><p class=\"text\">Exportuj</p></md-button></div></div><div class=\"wrapperChart\"><div \nclass=\"chart\"><nvd3 class=\"h-250 remove-x-lines\" id=\"showcase-fixedcolumns\" config=\"vm.mainChart.config\" \noptions=\"vm.mainChart.options\" data=\"vm.mainChart.data\"></nvd3></div></div></div><md-list class=\"report-table\">\n<md-list-item class=\"table-header md-2-line\"><div class=\"md-list-item-text\" layout=\"row\" \nlayout-align=\"space-between center\"><span flex=\"4\">Id</span> <span flex=\"4\">Kont. Id</span> <span flex=\"10\">Kontakt\n</span> <span flex=\"10\">Serwis</span><span flex=\"4\">Kons. Id</span> <span flex=\"10\">Kons. Login</span> <span flex=\"10\">\nStart</span> <span flex=\"10\">Koniec</span> <span flex=\"10\">Tagi</span> <span flex=\"15\">Status</span><span flex=\"3\">\nTranskr.</span></div></md-list-item><div class=\"table-body\" ms-scroll ng-if=\"vm.report && vm.report.length > 0\">\n<md-list-item class=\"md-2-line md-no-proxy\" ng-repeat=\"message in vm.report\"><div class=\"md-list-item-text\" \nlayout=\"row\" layout-align=\"space-between center\" ng-click=\"vm.copyGuid(message)\"><span flex=\"4\">{{message.id}}</span> \n<span flex=\"4\">{{message.contactId}}</span> <span flex=\"10\">{{message.userName}}</span> <span flex=\"10\">\n{{message.serviceName}}</span> <span flex=\"4\">{{message.consultantID}}</span> <span flex=\"10\">{{message.login}}</span>\n<span flex=\"10\">{{message.insertionTime | date: \'dd-MM-yyyy HH:mm:ss\'}}</span> <span flex=\"10\">\n{{message.finished | date: \'dd-MM-yyyy HH:mm:ss\'}}</span> <span flex=\"10\"><ta-multiselect ng-if=\"message.tags\" flex \ncustom-class=\"small white\" ng-disabled=\"true\" write-mode=\"false\" ng-model=\"message.tags\"></ta-multiselect></span><span \nflex=\"15\">{{message.statusId}}({{message.statusDesc}})</span><span flex=\"3\" \nng-click=\"vm.showHostorySession($event, message.sessionID)\" class=\"iconList\"><img src=\"assets/icons/list.svg\" \nalt=\"list\"></span></div></md-list-item></div><div ng-if=\"vm.reportPages && vm.reportPages.length>1\" \nclass=\"paginator mt-5\" ng-class=\"{\'report-sticky\': vm.summary.length >1 }\" layout=\"row\" layout-align=\"end center\">\n<md-button ng-click=\"vm.setPage(0);\" ng-disabled=\"vm.pageNumber == 0\">{{ \"REPORTS.PAGER.FIRST\" | translate }}\n</md-button><md-button ng-click=\"vm.setPage(vm.pageNumber - 1);\" ng-disabled=\"vm.pageNumber == 0\">\n{{ \"REPORTS.PAGER.PREVIOUS\" | translate }}</md-button>{{ vm.reportPages[vm.pageNumber - 1] > 0 ? \'...\':\'\'}}<md-button \nng-if=\"page >= vm.pageNumber -1 && page <= vm.pageNumber +1\" ng-class=\"{\'current\': vm.pageNumber == page }\" \nng-repeat=\"page in vm.reportPages\" ng-click=\"vm.setPage(page);\" ng-disabled=\"vm.pageNumber == page\">{{page + 1}}\n</md-button>{{vm.reportPages.length > vm.pageNumber + 2 ? \'...\':\'\'}}<md-button \nng-click=\"vm.setPage(vm.pageNumber + 1);\" ng-disabled=\"vm.pageNumber == vm.reportPages[vm.reportPages.length-1]\">\n{{ \"REPORTS.PAGER.NEXT\" | translate }}</md-button><md-button \nng-click=\"vm.setPage(vm.reportPages[vm.reportPages.length-1]);\" \nng-disabled=\"vm.pageNumber == vm.reportPages[vm.reportPages.length-1]\">{{ \"REPORTS.PAGER.LAST\" | translate }}\n</md-button></div></md-list></div><div class=\"noData\" ng-if=\"!vm.loading && (!vm.report || vm.report.length === 0)\">\n<div class=\"noData__icon\"><img src=\"assets/icons/database.svg\" alt=\"\"><p>brak danych</p></div></div>\n<md-progress-circular class=\"md-accent progressCircual\" md-diameter=\"100\" md-mode=\"indeterminate\" ng-if=\"vm.loading\">\n</md-progress-circular>");
$templateCache.put("app/main/contactcenter/reports/components/reportstatschat/reportstatschat.html","<h1>raporty chatu</h1>");
$templateCache.put("app/main/contactcenter/reports/components/reportstatscalls/reportstatscalls.html","<div class=\"chartForReports\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"pt-8\"><md-button \nclass=\"ph-16 aggregationButtons\" ng-repeat=\"type in vm.dateType\" ng-click=\"vm.changeAgrType(type)\" \nng-disabled=\"vm.currentType.key == type.key\">{{ type.text }}</md-button></div><div class=\"pt-8\"><md-button \nng-if=\"vm.SessionManager.getUserRoleId() !== vm.authRolesConst.consultant\" ng-click=\"vm.downloadXLSX()\"><p \nclass=\"text\">Exportuj</p></md-button></div></div><div class=\"wrapperChart\"><div class=\"chart\"><nvd3 \nclass=\"h-250 remove-x-lines\" id=\"showcase-fixedcolumns\" config=\"vm.mainChart.config\" options=\"vm.mainChart.options\" \ndata=\"vm.mainChart.data\"></nvd3></div></div></div><md-list class=\"report-table\"><md-list-item \nclass=\"table-header md-2-line\"><div class=\"md-list-item-text\" layout=\"row\" layout-align=\"space-between center\"><span \nng-if=\"vm.SessionManager.getUserRoleId() !== vm.authRolesConst.consultant\" flex=\"30\" layout=\"row\" \nlayout-align=\"start center\"><span flex=\"10\"></span> <span flex=\"20\">ID</span> <span flex>Imię Nazwisko/Alias</span> \n</span><span ng-if=\"vm.SessionManager.getUserRoleId() === vm.authRolesConst.consultant\" class=\"w-40\"></span> <span \nflex=\"20\" layout=\"row\" layout-align=\"start center\"><span flex=\"30\">Id Serwisu</span> <span flex=\"70\">Nazwa Serwisu\n</span> </span><span ng-if=\"vm.resultColumn\" flex=\"5\">Rezultat</span> <span flex=\"10\">Data</span> <span flex=\"5\">\nKontakt</span> <span flex=\"5\">MSISDN</span> <span flex=\"5\">Czas</span> <span flex=\"5\">Odsłuch</span></div>\n</md-list-item><div class=\"table-body\" ms-scroll><md-list-item class=\"md-2-line\" ng-repeat=\"consultant in vm.report\">\n<div class=\"md-list-item-text\" layout=\"row\" layout-align=\"space-between center\"><span \nng-if=\"::vm.SessionManager.getUserRoleId() !== vm.authRolesConst.consultant\" flex=\"30\" layout=\"row\" \nlayout-align=\"start center\"><div flex=\"10\"><img ng-if=\"consultant.photoUrl\" ng-src=\"{{ consultant.photoUrl }}\" \nsrc=\"assets/icons/communicator/user_avatar.svg\" class=\"md-avatar\"><md-icon ng-if=\"consultant.consultantID < 0\" \nmd-svg-src=\"/assets/icons/external-link.svg\" class=\"md-avatar\"></md-icon></div><span flex=\"20\">\n{{ consultant.consultantID }}</span> <span flex>{{ consultant.consultant }}</span> </span><span \nng-if=\"::vm.SessionManager.getUserRoleId() === vm.authRolesConst.consultant\" class=\"avatar-wrapper\"><img \nclass=\"avatar\" ng-class=\"{\'status-mask\': consultant.servicePhotoUrl}\" alt=\"{{::consultant.serviceName}}\" \nng-src=\"{{::consultant.servicePhotoUrl ? consultant.servicePhotoUrl : \'/assets/icons/management/icon-I.png\'}}\"> <img \nng-if=\"consultant.servicePhotoUrl\" class=\"icon status\" alt=\"{{::consultant.serviceName}}\" \nsrc=\"/assets/icons/management/icon-I.png\"> </span><span flex=\"20\" layout=\"row\" layout-align=\"start center\"><span \nflex=\"30\">{{ consultant.serviceId }}</span> <span flex=\"70\">{{ consultant.serviceName }}</span> </span><span \nng-if=\"vm.resultColumn\" flex=\"5\" ng-switch=\"consultant.eventName\"><md-icon style=\"color:#b7b7b7\" \nng-switch-when=\"NOANSWER\" md-svg-src=\"assets/icons/reports/connection-noanswer.svg\"></md-icon><md-icon \nstyle=\"color:#f9bb64\" ng-switch-when=\"BUSY\" md-svg-src=\"assets/icons/reports/connection-busy.svg\"></md-icon><md-icon \nstyle=\"color:#6ad572\" ng-switch-when=\"CONNECTED\" md-svg-src=\"assets/icons/reports/connection-success.svg\"></md-icon>\n<md-icon style=\"color:#e16c6c\" ng-switch-default md-svg-src=\"assets/icons/reports/connection-uknown.svg\"></md-icon>\n<md-tooltip>{{ consultant.eventName ? consultant.eventName : \'UKNOWN\' }}</md-tooltip></span><span flex=\"10\">\n{{ consultant.start | date: \"dd-MM-yyyy HH:mm:ss\" }}</span> <span flex=\"5\">{{ consultant.contactID }}</span> <span \nflex=\"5\">{{ consultant.msisdn }}</span> <span flex=\"5\">{{ consultant.minutes }}</span> <span flex=\"5\"><md-button \nng-if=\"consultant.isPath != 0\" class=\"md-icon-button play\" ng-disabled=\"vm.loading\" \nng-click=\"vm.playRecording(consultant)\"><md-icon ng-if=\"!consultant.isPlaying\" \nmd-svg-src=\"assets/icons/reports/play-button.svg\"></md-icon><md-icon ng-if=\"consultant.isPlaying\" \nmd-svg-src=\"assets/icons/reports/pause-round-button.svg\"></md-icon><md-tooltip>play/pause</md-tooltip></md-button>\n</span></div></md-list-item></div><div ng-if=\"vm.reportPages && vm.reportPages.length>1\" class=\"paginator mt-5\" \nng-class=\"{\'report-sticky\': vm.summary.length >1 }\" layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"vm.setPage(0);\" ng-disabled=\"vm.pageNumber == 0\">{{ \"REPORTS.PAGER.FIRST\" | translate }}</md-button>\n<md-button ng-click=\"vm.setPage(vm.pageNumber - 1);\" ng-disabled=\"vm.pageNumber == 0\">\n{{ \"REPORTS.PAGER.PREVIOUS\" | translate }}</md-button>{{ vm.reportPages[vm.pageNumber - 1] > 0 ? \"...\" : \"\" }}\n<md-button ng-if=\"page >= vm.pageNumber -1 && page <= vm.pageNumber +1\" ng-class=\"{\'current\': vm.pageNumber == page }\" \nng-repeat=\"page in vm.reportPages\" ng-click=\"vm.setPage(page);\" ng-disabled=\"vm.pageNumber == page\">{{ page + 1 }}\n</md-button>{{ vm.reportPages.length > vm.pageNumber + 2 ? \"...\" : \"\" }}<md-button \nng-click=\"vm.setPage(vm.pageNumber + 1);\" ng-disabled=\"vm.pageNumber == vm.reportPages[vm.reportPages.length-1]\">\n{{ \"REPORTS.PAGER.NEXT\" | translate }}</md-button><md-button \nng-click=\"vm.setPage(vm.reportPages[vm.reportPages.length-1]);\" \nng-disabled=\"vm.pageNumber == vm.reportPages[vm.reportPages.length-1]\">{{ \"REPORTS.PAGER.LAST\" | translate }}\n</md-button></div></md-list><div class=\"noData\" ng-if=\"vm.connectionList.length === 0\"><div class=\"noData__icon\"><img \nsrc=\"assets/icons/database.svg\" alt=\"\"><p>brak danych</p></div></div>");
$templateCache.put("app/main/contactcenter/reports/components/reportstatssms/popup.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><div name=\"contactForm\" class=\"md-inline-form\"><md-toolbar \nclass=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">id: {{vm.contact.id}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle\" \nflex layout=\"column\" layout-align=\"center center\"><div layout=\"column\" class=\"wrapperImage\" \nlayout-align=\"center center\" style=\"width: 155px;height: 155px\"><div \nng-class=\"{wrapperImage__imageMms: vm.contact.attachmentUrls.length > 1}\"><img \nng-src=\"{{(vm.contact.attachmentUrls.length >= 1 && vm.contact.attachmentUrls[0] !== \'\')? vm.contact.attachmentUrls[0] : \'/assets/icons/reports/sms.png\'}}\" \nonerror=\"this.src=\'/assets/icons/eye.png\'\" class=\"md-avatar avatar contact-avatar huge\" \nalt=\"{{vm.contact.attachmentUrls}}\"></div><div \nng-class=\"{wrapperImage__imageMms: vm.contact.attachmentUrls.length > 1}\" ng-if=\"vm.contact.attachmentUrls.length > 1\">\n<img ng-src=\"{{vm.contact.attachmentUrls[1]}}\" onerror=\"this.src=\'/assets/icons/eye.png\'\" \nclass=\"md-avatar avatar contact-avatar huge\" alt=\"{{vm.contact.attachmentUrls}}\"></div></div></div></md-toolbar>\n<md-dialog-content ms-scroll style=\"width: 100%\"><div class=\"md-icon-float md-block\"><span class=\"popupSpan\">Treść SMS\n</span><p>{{ vm.contact.body }}</p></div><div class=\"md-icon-float md-block\"><span class=\"popupSpan\">Guid</span><p>\n{{ vm.contact.guid }}</p></div><div class=\"md-icon-float md-block\"><span class=\"popupSpan\">Time</span><p>\n{{ vm.contact.insertionTime | date:\"yyyy/MM/dd : HH:mm:ss\" }}</p></div><div class=\"md-icon-float md-block\"><span \nclass=\"popupSpan\">Telefon</span><p>{{ vm.contact.msisdn | lowercase}}</p></div><div class=\"md-icon-float md-block\">\n<span class=\"popupSpan\">La</span><p>{{ vm.contact.la }}</p></div><div class=\"md-icon-float md-block\"><span \nclass=\"popupSpan\">Direction</span><p>{{ vm.contact.direction }}</p></div><div class=\"md-icon-float md-block\"><span \nclass=\"popupSpan\">Type</span><p>{{ vm.contact.type }}</p></div></md-dialog-content></div></md-dialog>");
$templateCache.put("app/main/contactcenter/reports/components/reportstatssms/reportstatssms.html","<div class=\"report-container\"><div class=\"chartForReports\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"pt-8\"><md-button class=\"ph-16 aggregationButtons\" ng-repeat=\"type in vm.dateType\" \nng-click=\"vm.changeAgrType(type)\" ng-disabled=\"vm.currentType.key == type.key\">{{type.text}}</md-button></div><div \nclass=\"pt-8\"><md-button ng-if=\"vm.SessionManager.getUserRoleId() !== vm.authRolesConst.consultant\" \nng-click=\"vm.downloadXLSX()\"><p class=\"text\">Exportuj</p></md-button></div></div><div class=\"wrapperChart\"><div \nclass=\"chart\"><nvd3 class=\"h-250 remove-x-lines\" id=\"showcase-fixedcolumns\" config=\"vm.mainChart.config\" \noptions=\"vm.mainChart.options\" data=\"vm.mainChart.data\"></nvd3></div></div></div><md-list class=\"report-table\">\n<md-list-item class=\"table-header md-2-line\"><div class=\"md-list-item-text\" layout=\"row\" \nlayout-align=\"space-between center\"><span ng-if=\"vm.SessionManager.getUserRoleId() !== vm.authRolesConst.consultant\" \nflex=\"20\" layout=\"row\" layout-align=\"start center\"><span flex=\"10\"></span> <span flex=\"10\">ID</span> <span flex>\nImię Nazwisko/Alias</span> </span><span flex=\"5\" \nng-if=\"vm.SessionManager.getUserRoleId() === vm.authRolesConst.consultant\"></span> <span flex=\"20\" layout=\"row\" \nlayout-align=\"start center\"><span flex=\"30\">Id Serwisu</span> <span flex=\"70\">Nazwa Serwisu</span> </span><span \nflex=\"5\">Typ/Kierunek</span> <span flex=\"10\">Data</span> <span flex=\"5\">LA</span> <span flex=\"10\">MSISDN</span> <span \nflex=\"15\">Treść</span> <span flex=\"5\" ng-if=\"vm.SessionManager.getUserRoleId() === vm.authRolesConst.manager\">\nTranskrypcja</span></div></md-list-item><div class=\"table-body\" ms-scroll ng-if=\"vm.report && vm.report.length > 0\">\n<md-list-item class=\"md-2-line md-no-proxy\" ng-repeat=\"message in vm.report\"><div class=\"md-list-item-text\" \nlayout=\"row\" layout-align=\"space-between center\" ng-click=\"vm.copyGuid(message)\"><span \nng-if=\"::vm.SessionManager.getUserRoleId() !== vm.authRolesConst.consultant\" flex=\"20\" layout=\"row\" \nlayout-align=\"start center\"><div flex=\"10\"><img ng-if=\"message.photoUrl\" ng-src=\"{{message.photoUrl}}\" \nsrc=\"assets/icons/communicator/user_avatar.svg\" class=\"md-avatar\"><md-icon ng-if=\"message.consultantID < 0\" \nmd-svg-src=\"/assets/icons/external-link.svg\" class=\"md-avatar\"></md-icon></div><span flex=\"10\">{{message.consultantId}}\n</span> <span flex>{{message.consultantName}}</span> </span><span flex=\"5\" \nng-if=\"::vm.SessionManager.getUserRoleId() === vm.authRolesConst.consultant\" layout=\"row\" layout-align=\"start center\">\n<div class=\"avatar-wrapper\"><img ng-if=\"::message.servicePhotoUrl\" class=\"avatar status-mask\" \nalt=\"{{::message.serviceName}}\" ng-src=\"{{::message.servicePhotoUrl}}\"> <img ng-if=\"::!message.servicePhotoUrl\" \nclass=\"avatar\" ng-src=\"/assets/icons/management/icon-{{::message.type}}.png\"> <img ng-if=\"message.servicePhotoUrl\" \nclass=\"icon status\" alt=\"{{::message.serviceName}}\" src=\"/assets/icons/management/icon-I.png\"></div></span><span \nflex=\"20\" layout=\"row\" layout-align=\"start center\"><span flex=\"30\">{{message.serviceId}}</span> <span flex=\"70\">\n{{message.serviceName}}</span> </span><span ng-cloak flex=\"5\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"avatar-wrapper\"><md-icon class=\"md-avatar\" md-svg-src=\"/assets/icons/management/icon-{{::message.type}}.svg\" \naria-label=\"group\"><md-tooltip md-direction=\"top\">{{message.guid || \'Brak GUID\' }}</md-tooltip></md-icon><md-icon \nclass=\"icon status\" md-font-icon=\"icon-arrow-{{::message.direction | direction}}-bold\" \nng-style=\"{ color: (message.direction | changeColor)}\" aria-label=\"group\"><md-tooltip md-direction=\"top\">\n{{message.direction== \'I\' ? \'Przychodząca\' : \'Wychodząca\' }}</md-tooltip></md-icon></div><md-icon \nng-if=\"message.replyTo\" class=\"md-icon-18 md-accent\" md-svg-src=\"/assets/icons/reports/letter-r.svg\"><md-tooltip \nmd-direction=\"top\">{{message.replyTo || \'Brak GUID\' }}</md-tooltip></md-icon></span><span flex=\"10\">\n{{message.insertionTime | date: \'dd-MM-yyyy HH:mm:ss\'}}</span> <span flex=\"5\">{{message.la}}</span> <span flex=\"10\">\n{{message.msisdn}}</span> <span flex=\"15\">{{message.body}}</span> <span flex=\"5\" \nng-click=\"vm.showHostorySession($event, message.sessionID)\" class=\"iconList\" \nng-if=\"vm.SessionManager.getUserRoleId() === vm.authRolesConst.manager\"><img src=\"assets/icons/list.svg\" alt=\"list\">\n</span></div></md-list-item></div><div ng-if=\"vm.reportPages && vm.reportPages.length>1\" class=\"paginator mt-5\" \nng-class=\"{\'report-sticky\': vm.summary.length >1 }\" layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"vm.setPage(0);\" ng-disabled=\"vm.pageNumber == 0\">{{ \"REPORTS.PAGER.FIRST\" | translate }}</md-button>\n<md-button ng-click=\"vm.setPage(vm.pageNumber - 1);\" ng-disabled=\"vm.pageNumber == 0\">\n{{ \"REPORTS.PAGER.PREVIOUS\" | translate }}</md-button>{{ vm.reportPages[vm.pageNumber - 1] > 0 ? \'...\':\'\'}}<md-button \nng-if=\"page >= vm.pageNumber -1 && page <= vm.pageNumber +1\" ng-class=\"{\'current\': vm.pageNumber == page }\" \nng-repeat=\"page in vm.reportPages\" ng-click=\"vm.setPage(page);\" ng-disabled=\"vm.pageNumber == page\">{{page + 1}}\n</md-button>{{vm.reportPages.length > vm.pageNumber + 2 ? \'...\':\'\'}}<md-button \nng-click=\"vm.setPage(vm.pageNumber + 1);\" ng-disabled=\"vm.pageNumber == vm.reportPages[vm.reportPages.length-1]\">\n{{ \"REPORTS.PAGER.NEXT\" | translate }}</md-button><md-button \nng-click=\"vm.setPage(vm.reportPages[vm.reportPages.length-1]);\" \nng-disabled=\"vm.pageNumber == vm.reportPages[vm.reportPages.length-1]\">{{ \"REPORTS.PAGER.LAST\" | translate }}\n</md-button></div></md-list></div><div class=\"noData\" ng-if=\"!vm.loading && (!vm.report || vm.report.length === 0)\">\n<div class=\"noData__icon\"><img src=\"assets/icons/database.svg\" alt=\"\"><p>brak danych</p></div></div>\n<md-progress-circular class=\"md-accent progressCircual\" md-diameter=\"100\" md-mode=\"indeterminate\" ng-if=\"vm.loading\">\n</md-progress-circular>");
$templateCache.put("app/main/contactcenter/reports/components/unrealizedsessions/unrealizedsessions.html","<h1>test</h1>");
$templateCache.put("app/main/contactcenter/reports/components/useractivity/useractivity.html","<div class=\"report-container\"><div class=\"chartForReports\"><div layout=\"row\" layout-align=\"end center\" \nclass=\"button-row\"><md-button class=\"aggregationButtons md-raised\" \nng-if=\"vm.SessionManager.getUserRoleId() !== vm.authRolesConst.consultant\" ng-click=\"vm.downloadXLSX()\"><p \nclass=\"text\">Exportuj</p></md-button></div></div><md-list class=\"report-table\"><md-list-item \nclass=\"table-header md-2-line\"><div class=\"md-list-item-text\" layout=\"row\" layout-align=\"space-between center\"><span \nflex=\"30\" layout=\"row\" layout-align=\"start center\"><span flex=\"15\"></span> <span flex=\"20\">ID</span> <span flex=\"75\">\nImię Nazwisko/Alias</span> </span><span flex=\"10\">Data aktywacji</span> <span flex=\"10\">Data dezaktywacji</span> <span \nflex=\"5\">Czas zalogowania</span> <span flex=\"5\">Przerwa</span> <span flex=\"40\"></span></div></md-list-item><div \nclass=\"table-body\" ms-scroll><md-list-item class=\"md-2-line\" ng-repeat=\"consultant in vm.report\"><div \nclass=\"md-list-item-text\" layout=\"row\" layout-align=\"space-between center\"><span flex=\"30\" layout=\"row\" \nlayout-align=\"start center\"><div flex=\"15\"><img ng-src=\"{{vm.consultantList[consultant.consultantID].photoUrl}}\" \nsrc=\"assets/icons/communicator/user_avatar.svg\" class=\"md-avatar\"></div><span flex=\"20\">{{consultant.consultantID}}\n</span> <span flex=\"75\">\n{{vm.consultantList[consultant.consultantID].firstName}} {{vm.consultantList[consultant.consultantID].lastName}} {{ vm.consultantList[consultant.consultantID].alias ? \'/\'+ vm.consultantList[consultant.consultantID].alias :\'\'}}\n</span> </span><span flex=\"10\">{{consultant.start | date:\'yyyy-MM-dd HH:mm\'}}</span> <span flex=\"10\">\n{{consultant.stop | date:\'yyyy-MM-dd HH:mm\'}}</span> <span flex=\"5\">\n{{vm.formatSecs(consultant.przerwaNieZalogowany + consultant.przerwaZalogowany + consultant.aktywnyZalogowany + consultant.aktywnyNieZalogowany)}}\n</span> <span flex=\"5\">{{vm.formatSecs(consultant.przerwaZalogowany + consultant.przerwaNieZalogowany)}}</span> <span \nflex=\"40\" class=\"activityAxis\" style=\"position: relative\"><activity-axis activity-row=\"consultant\"></activity-axis>\n</span></div></md-list-item></div><md-divider></md-divider><div ng-if=\"vm.reportPages && vm.reportPages.length>1\" \nclass=\"paginator mt-5\" ng-class=\"{\'report-sticky\': vm.summary.length >1 }\" layout=\"row\" layout-align=\"end center\">\n<md-button ng-click=\"vm.setPage(0);\" ng-disabled=\"vm.pageNumber == 0\">{{ \"REPORTS.PAGER.FIRST\" | translate }}\n</md-button><md-button ng-click=\"vm.setPage(vm.pageNumber - 1);\" ng-disabled=\"vm.pageNumber == 0\">\n{{ \"REPORTS.PAGER.PREVIOUS\" | translate }}</md-button>{{ vm.reportPages[vm.pageNumber - 1] > 0 ? \'...\':\'\'}}<md-button \nng-if=\"page >= vm.pageNumber -1 && page <= vm.pageNumber +1\" ng-class=\"{\'current\': vm.pageNumber == page }\" \nng-repeat=\"page in vm.reportPages\" ng-click=\"vm.setPage(page);\" ng-disabled=\"vm.pageNumber == page\">{{page + 1}}\n</md-button>{{vm.reportPages.length > vm.pageNumber + 2 ? \'...\':\'\'}}<md-button \nng-click=\"vm.setPage(vm.pageNumber + 1);\" ng-disabled=\"vm.pageNumber == vm.reportPages[vm.reportPages.length-1]\">\n{{ \"REPORTS.PAGER.NEXT\" | translate }}</md-button><md-button \nng-click=\"vm.setPage(vm.reportPages[vm.reportPages.length-1]);\" \nng-disabled=\"vm.pageNumber == vm.reportPages[vm.reportPages.length-1]\">{{ \"REPORTS.PAGER.LAST\" | translate }}\n</md-button></div></md-list><div class=\"noData\" ng-if=\"vm.report && vm.report.length === 0\"><div class=\"noData__icon\">\n<img src=\"assets/icons/database.svg\" alt=\"\"><p>brak danych</p></div></div></div>");
$templateCache.put("app/main/contactcenter/components/issuetracker/attachment/attachmentDetail/attachment.html","<div flex layout=\"row\" layout-align=\"center center\" class=\"h-25 white-text\"><div flex layout=\"row\" \nlayout-align=\"center center\">{{vm.item.file.name}}</div><div flex layout=\"row\" layout-align=\"center center\">\n{{vm.item.file.size/1024/1024|number:2}} MB</div><div flex layout=\"row\" layout-align=\"center center\"><md-button \nflex=\"20\" layout=\"row\" class=\"md-accent md-icon-mini\" aria-label=\"Remove attachment\" ng-click=\"vm.deleteItem(item)\">\n<md-icon md-font-icon=\"icon-trash\" class=\"bt-pointer\"></md-icon></md-button></div></div>");
$templateCache.put("app/main/contactcenter/components/issuetracker/attachment/attachmentList/attachmentlist.html","<div layout=\"row\" layout-align=\"space-between center\"><div><span class=\"font-size-10\" style=\"color: white\">\n{{\"ISSUE.ATTACHMENT.LABEL\" | translate}}</span></div><div><md-button class=\"md-icon-mini md-accent\" \naria-label=\"Add attachment\" ng-click=\"vm.addAttachmentDialog()\"><md-icon md-font-icon=\"icon-paperclip\" \nclass=\"bt-pointer\"></md-icon></md-button><input id=\"selectFile\" ng-if=\"vm.uploader\" type=\"file\" style=\"display: none\" \nnv-file-select uploader=\"vm.uploader\"></div></div><div ng-if=\"vm.filesToUpload\" style=\"margin-bottom: 10px\"><div flex \nlayout=\"row\" layout-align=\"center center\" class=\"h-30 white-text text-semibold\"><div flex layout=\"row\" \nlayout-align=\"center center\" white-text>{{\"ISSUE.ATTACHMENT.FILE_NAME_HEADER\" | translate}}</div><div flex \nlayout=\"row\" layout-align=\"center center\" white-text>{{\"ISSUE.ATTACHMENT.FILE_SIZE_HEADER\" | translate}}</div><div \nflex layout=\"row\" layout-align=\"center center\" white-text>{{\"ISSUE.ATTACHMENT.ACTION_HEADER\" | translate}}</div></div>\n<attachment-detail ng-repeat=\"item in vm.uploader.queue\" item=\"item\" on-delete=\"vm.deleteFromQueue(item)\" flex \nlayout=\"row\" layout-align=\"center center\"></attachment-detail></div>");
$templateCache.put("app/main/contactcenter/components/issuetracker/components/bugzilla/bugzillaissue.html","<md-button class=\"md-icon-button\" style=\"padding: 0px; margin: 0px; height: 24px; width: 24px; min-height: 24px\" \nng-click=\"vm.performAction()\"><md-icon md-font-icon=\"icon-android\" aria-label=\"android\" \nclass=\"{{vm.issueStatus | bugzillaIssueIconStyle}}\"></md-icon><md-tooltip ng-if=\"vm.openIssueDialog\"><span \nng-if=\"vm.issueStatus\">{{\"MAIL.DETAILS.HEADER.ISSUE_TRACKER.EDIT\" | translate}}</span> <span ng-if=\"!vm.issueStatus\">\n{{\"MAIL.DETAILS.HEADER.ISSUE_TRACKER.CREATE\" | translate}}</span></md-tooltip><md-tooltip ng-if=\"!vm.openIssueDialog\">\n<span>{{vm.issueStatus | bugzillaIssueIconTooltip : vm.isIntegrated}}</span></md-tooltip></md-button>");
$templateCache.put("app/main/contactcenter/components/issuetracker/components/jira/jiraissue.html","<md-button class=\"md-icon-button\" style=\"padding: 0px; margin: 0px; height: 24px; width: 24px; min-height: 24px\" \nng-click=\"vm.performAction()\"><md-icon md-font-icon=\"icon-jira\" \nclass=\"{{vm.issueStatus | jiraIssueIconStyle : vm.jiraService.issueStatuses}}\"></md-icon><md-tooltip \nng-if=\"vm.openIssueDialog\"><span ng-if=\"vm.issueStatus\">{{\"MAIL.DETAILS.HEADER.ISSUE_TRACKER.EDIT\" | translate}}</span>\n <span ng-if=\"!vm.issueStatus\">{{\"MAIL.DETAILS.HEADER.ISSUE_TRACKER.CREATE\" | translate}}</span></md-tooltip>\n<md-tooltip ng-if=\"!vm.openIssueDialog\"><span>{{vm.issueStatus | jiraIssueIconTooltip : vm.jiraService.issueStatuses}}\n</span></md-tooltip></md-button>");
$templateCache.put("app/main/contactcenter/components/optionsmenu/components/nestedmenu/nestedmenu.html","<ul ng-hide=\"vm.menuItem.collapsed\" class=\"option-submenu\" ng-if=\"::(vm.menuItem.submenu)\"><li layout=\"column\" \nlayout-align=\"start stretch\" ng-disabled=\"subItem.evalDisabled\" \nng-repeat=\"subItem in ::vm.menuItem.submenu | filter: {evalHide: \'false\', isAdditional: false }\" \nng-click=\"vm.changeState($event, subItem);\" ng-hide=\"subItem.ishidden\" \nng-class=\"{\'selected\': vm.optionsMenu.currentState.indexOf(subItem.state) !== -1 }\" ng-include=\"\'nested-menu.html\'\">\n</li></ul><ul ng-hide=\"vm.menuItem.collapsed\" class=\"option-submenu\" ng-if=\"vm.menuItem.submenu && vm.more\"><li \nlayout=\"column\" layout-align=\"start stretch\" ng-disabled=\"subItem.evalDisabled\" \nng-repeat=\"subItem in ::vm.menuItem.submenu | filter: {evalHide: \'false\', isAdditional: true }\" \nng-click=\"vm.changeState($event, subItem);\" ng-hide=\"subItem.ishidden\" \nng-class=\"{\'selected\': vm.optionsMenu.currentState.indexOf(subItem.state) !== -1 }\" ng-include=\"\'nested-menu.html\'\">\n</li></ul><div class=\"more-less\" ng-click=\"vm.more=!vm.more;\" ng-show=\"vm.showAdditional\" layout=\"row\" \nlayout-align=\"end start\"><md-icon ng-show=\"vm.more\" md-font-icon=\"icon-chevron-up\"></md-icon><md-icon \nng-show=\"!vm.more\" md-font-icon=\"icon-chevron-down\"></md-icon></div><script type=\"text/ng-template\" \nid=\"nested-menu.html\">\n<!-- <div flex=\"100\" layout=\"row\" layout-align=\"start stretch\"> -->\n    <div flex=\"100\" layout=\"row\" layout-align=\"start center\"  class=\"submenu-header icon-column\">\n        <md-icon ng-if=\"::subItem.icon\" md-font-icon=\"{{::subItem.icon}}\" class=\"icon\"></md-icon>\n        <img ng-if=\"::(!subItem.icon && !subItem.iconSrc.endsWith(\'.svg\'))\" src=\"{{::subItem.iconSrc}}\" class=\"icon\">\n        <md-icon ng-if=\"::(!subItem.icon && subItem.iconSrc.endsWith(\'.svg\'))\" md-svg-src=\"{{::subItem.iconSrc}}\" class=\"icon\"></md-icon>\n      <p translate=\"{{::subItem.name+\'.ROUTE_NAME\'}}\">\n        {{::subItem.name}}\n      </p>\n    </div>\n    <div ng-if=\"::(submenu.submenu)\" flex=\"80\" layout=\"column\" layout-align=\"center stretch\"\n      class=\"option-content\" >\n      <ul ng-hide=\"subItem.collapsed\" class=\"option-submenu\">\n        <li layout=\"row\" class=\"pl-20\" ng-disabled=\"subItem.evalDisabled\" ng-repeat=\"subItem in ::submenu.submenu | filter: {evalHide: \'false\' }\" ng-click=\"vm.changeState($event, subItem);\"\n          ng-hide=\"subItem.ishidden\" ng-class=\"{\'selected\': vm.optionsMenu.currentState.indexOf(subItem.state) !== -1 }\" ng-include=\"\'nested-menu.html\'\">\n        </li>\n      </ul>\n    </div>\n  <!-- </div> -->\n</script>");
$templateCache.put("app/main/contactcenter/components/optionsmenu/components/optionfolder/optionfolder.html","<div layout=\"column\" layout-align=\"start stretch\" class=\"{{::vm.menuItem.customStyle}}\"><p flex class=\"option-header\" \ntranslate=\"{{::vm.menuItem.name+\'.ROUTE_NAME\'}}\">{{::vm.menuItem.name}}</p><nested-menu flex class=\"option-content\" \nmenu-item=\"vm.menuItem\"></nested-menu></div>");
$templateCache.put("app/main/contactcenter/dashboard/component/consultantsPreview/consultantOcupation/consultantOcupation.html","<md-list-item class=\"consultantList md-no-proxy\" layout-align=\"space-between center\" flex aria-label=\"consultant\" \nstyle=\"padding: 0 !important\" \nng-style=\"(vm.consultant.priority1>=200||vm.consultant.priority2>=200)&&{\'filter\':\'grayscale(.5)\',\'background-color\':\'rgb({{vm.consultant.service.color}} / 25%)\'}||{\'background-color\':\'rgb({{vm.consultant.service.color}} / 25%)\'}\" \nng-class=\"{\'give-opacity\':!vm.consultant.status,\'selected\':vm.selected}\"><div class=\"row\" flex=\"100\" layout=\"row\" \nlayout-align=\"flex-start center\" style=\"align-items: center\"><div style=\"width: 25px;height: 48px\"><md-icon \nng-if=\"vm.consultant.priority1<200&&vm.consultant.priority2<200\" \nng-click=\"$event.stopPropagation();vm.kickConsultant()\" md-font-icon=\"icon-numeric-1-box-outline\" class=\"level-marker\" \nstyle=\"color: #4F4F4F\"></md-icon><md-icon ng-if=\"vm.consultant.priority1>=200||vm.consultant.priority2>=200\" \nng-click=\"$event.stopPropagation();vm.kickConsultant()\" md-font-icon=\"icon-numeric-2-box-outline\" class=\"level-marker\" \nstyle=\"color: #7F7F7F\"></md-icon></div><div flex=\"25\" class=\"row\" layout=\"row\" style=\"align-items: center\"><div \nlayout=\"column\" layout-align=\"center center\" class=\"avatar-place\" style=\"width:42px;align-items:flex-start\"><div \nclass=\"column avatar-list\"><div class=\"image\"><img ng-if=\"vm.consultant.avatar\" alt=\"{{ vm.consultant.name }}\" \nng-src=\"{{ vm.consultant.avatar }}\"><div ng-if=\"!vm.consultant.avatar\" class=\"noAwatar\" layout=\"column\" \nlayout-align=\"center center\"><md-icon flex md-svg-src=\"/assets/navigation/avatar.svg\" aria-label=\"avatar\"></md-icon>\n</div></div><div class=\"avatar-status-container\"><img flex \nng-src=\"/assets/icons/dashboard/consultant_status/circular-shape-{{vm.consultant.status}}.svg\" aria-label=\"avatar\">\n</div></div></div><div style=\"width:42px\">{{ vm.consultant.id }}</div><div>{{ vm.consultant.name }}</div></div><div \nflex=\"5\" class=\"row\" layout=\"row\" style=\"align-items: center\"><div class=\"column avatar-list\" \nlayout-align=\"start center\" style=\"width:42px;align-items:flex-start\"><div class=\"image\"><img \nng-src=\"{{ vm.consultant.service.photoUrl }}\"></div></div></div><div flex=\"10\" style=\"line-height: 30px\"><div \nstyle=\"color:#CD5C5D;font-weight: 600;padding:2px;background-color: #FDFDFD; max-width: 34px;text-align: center;border-radius: 50%\">\n{{ vm.consultant.closedCount }}</div></div><div ng-if=\"vm.consultant.lastStatusUpdate\" flex=\"15\" \nstyle=\"line-height: 30px\">{{ vm.consultant.lastStatusUpdate | date:\'yyyy-MM-dd HH:mm:ss\' }}</div><div \nclass=\"column other\" flex=\"10\" layout=\"row\" style=\"align-self: center\"><div class=\"other\" flex=\"15\" \nstyle=\"text-align: center;background-color: #c6c6c6;margin-right: 2px;border-radius: 4px;border: 1px solid #00db00\" \nng-style=\"(vm.consultant.sessions.length>vm.consultant.service.sessionsPerConsultant)&&{\'background-color\':\'#CD5C5C\', \'color\':\'white\'}\">\n{{ vm.consultant.sessions.length }}</div><div class=\"other\" flex=\"70\" \nstyle=\"height:20px;padding:2px;border-radius:5px\" \nng-style=\"(vm.consultant.status !== 1)&&{\'background-color\': \'#ffcc00\'}||{\'background-color\': \'#2ab982\'}\"><div \nstyle=\"background-color:indianred;height: 16px;border-radius:4px\" \nng-style=\"{\'width\':\'{{(vm.consultant.sessions.length<vm.consultant.service.sessionsPerConsultant)?(vm.consultant.sessions.length/vm.consultant.service.sessionsPerConsultant*100):100}}%\'}\">\n</div></div><div class=\"other\" flex=\"15\" \nstyle=\"text-align: center;background-color: #c6c6c6;margin-left: 2px;border-radius: 4px;border: 1px solid #db2c00\">\n{{ vm.consultant.service.sessionsPerConsultant }}</div></div><div flex=\"5\"></div><div class=\"column avatar-list\" \nflex=\"15\" style=\"align-self: center\"><md-icon style=\"color:#CD5C5C\" md-font-icon=\"icon-comment-alert-outline\" \nng-style=\"vm.consultant.reservedCount && {\'opacity\':\'1\'} || {\'opacity\':\'0.3\'}\" aria-label=\"Wymagana odpowiedź\">\n</md-icon><span ng-style=\"vm.consultant.reservedCount && {\'opacity\':\'1\'} || {\'opacity\':\'0.3\'}\">\n{{vm.consultant.reservedCount}}</span><md-icon style=\"color:#2AB982;margin-left: 10px\" md-font-icon=\"icon-clock\" \nng-style=\"vm.consultant.answeredCount && {\'opacity\':\'1\'} || {\'opacity\':\'0.3\'}\" aria-label=\"Oczekiwanie na wiadomość\">\n</md-icon><span ng-style=\"vm.consultant.answeredCount && {\'opacity\':\'1\'} || {\'opacity\':\'0.3\'}\">\n{{vm.consultant.answeredCount}}</span><md-icon style=\"color:#21b4c7;margin-left: 10px\" \nmd-font-icon=\"icon-account-box-outline\" \nng-style=\"(vm.consultant.sessions.length-vm.consultant.answeredCount-vm.consultant.reservedCount) && {\'opacity\':\'1\'} || {\'opacity\':\'0.3\'}\" \naria-label=\"Przydzielono konsultanta\"></md-icon><span \nng-style=\"(vm.consultant.sessions.length-vm.consultant.answeredCount-vm.consultant.reservedCount) && {\'opacity\':\'1\'} || {\'opacity\':\'0.3\'}\">\n{{vm.consultant.sessions.length - vm.consultant.answeredCount - vm.consultant.reservedCount}}</span></div><div \nstyle=\"width: 10px\"></div><div flex=\"10\" layout=\"row\"><div class=\"column avatar-list button-logout\" \nstyle=\"margin-right: 4px\"><md-icon ng-click=\"$event.stopPropagation();vm.kickConsultant()\" md-font-icon=\"icon-logout\" \nstyle=\"color: #CD5C5C; cursor: pointer;text-align: center;font-size: 18px;line-height: 16px;font-weight: 600\" \nalt=\"Wyloguj konsultanta\" title=\"Wyloguj konsultanta\"></md-icon></div><div class=\"column avatar-list button-level\">\n<md-icon ng-if=\"vm.consultant.priority1<200&&vm.consultant.priority2<200\" \nng-click=\"$event.stopPropagation();vm.downgradeLevel()\" md-font-icon=\"icon-chevron-double-down\" \nstyle=\"color: #2AB982; cursor: pointer;text-align: center;font-size: 18px;line-height: 16px;font-weight: 600\" \nalt=\"Zdegraduj konsultanta\" title=\"Zdegraduj konsultanta\"></md-icon><md-icon \nng-if=\"vm.consultant.priority1>=200||vm.consultant.priority2>=200\" \nng-click=\"$event.stopPropagation();vm.upgradeLevel()\" md-font-icon=\"icon-chevron-double-up\" \nstyle=\"color: #2AB982; cursor: pointer;text-align: center;font-size: 18px;line-height: 16px;font-weight: 600\" \nalt=\"Promuj konsultanta\" title=\"Promuj konsultanta\"></md-icon></div></div></div></md-list-item>");
$templateCache.put("app/main/contactcenter/dashboard/component/consultantsPreview/consultantsPreviewDetails/consultantsPreviewDetails.html","<md-list-item class=\"consultantList md-no-proxy\" layout=\"row\" layout-align=\"space-between center\" flex \naria-label=\"consultant\" style=\"border-bottom: none !important;padding: 0 15px !important\" \nng-class=\"{\'give-opacity\':!vm.consultant.state,\'selected\':vm.selected}\"><div class=\"row\" flex=\"100\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"5\" layout=\"column\" layout-align=\"center center\" class=\"avatar-place\">\n<div class=\"column avatar-list\"><div class=\"image\" ng-class=\"{\'image-is-calling\':vm.consultant.callStatus == 1}\"><img \nng-if=\"vm.consultant.photoUrl\" alt=\"{{ vm.consultant.firstName }}\" ng-src=\"{{ vm.consultant.photoUrl }}\"><div \nng-if=\"!vm.consultant.photoUrl\" class=\"noAwatar\" layout=\"column\" layout-align=\"center center\"><md-icon flex \nmd-svg-src=\"/assets/navigation/avatar.svg\" aria-label=\"avatar\"></md-icon></div></div><div \nclass=\"avatar-status-container\"><img flex \nng-src=\"/assets/icons/dashboard/consultant_status/circular-shape-{{vm.consultant.status}}.svg\" aria-label=\"avatar\">\n</div></div></div><div ng-hide=\"vm.consultant.external\" ng-hide=\"vm.consultant.external\" class=\"column name\" flex=\"5\" \nlayout=\"column\" layout-align=\"center start\"><p>{{ vm.consultant.consultantID }}</p></div><div class=\"column name\" \nflex=\"15\"><p ng-if=\"!vm.consultant.alias\">{{ vm.consultant.firstName }} {{ vm.consultant.lastName }}</p><p \nng-if=\"vm.consultant.alias\">{{ vm.consultant.alias }}</p></div><div class=\"column name\" flex=\"10\" flex=\"row\" \nlayout-align=\"start center\"><img class=\"phoneType\" \nng-if=\"(!(vm.consultant.phoneTypeId == 5 || vm.consultant.phoneTypeId == 6 || vm.consultant.phoneTypeId == 0))\" \nng-src=\"assets/icons/dashboard/phonetype/{{ vm.consultant.phoneTypeId }}_{{ vm.consultant.callStatus }}.svg\"> <img \nclass=\"phoneType\" \nng-if=\"vm.consultant.phoneTypeId == 5 || vm.consultant.phoneTypeId == 6 || vm.consultant.phoneTypeId == 0\" \nng-src=\"assets/icons/dashboard/phonetype/{{ vm.consultant.phoneTypeId }}.svg\"><p \nng-class=\"{ \'numberPhone\': vm.consultant.phoneTypeId !== undefined }\" ng-if=\"vm.consultant.phoneSliced!==\'---\'\" \nng-style=\"{ color: vm.consultant.callStatus == 1 ? \'green\' : \'black\' }\">{{ vm.consultant.phone1 }}</p><div \nng-if=\"!vm.consultant.phone1\" class=\"no-value center\"></div></div><div ng-hide=\"vm.consultant.external\" \nclass=\"column name\" flex=\"10\"><p class=\"group-format\" ng-if=\"vm.consultant.groups\">{{ vm.consultant.groups }}</p></div>\n<div ng-hide=\"vm.consultant.external\" class=\"column other\" flex=\"10\"><span ng-if=\"vm.consultant.fromLogin\">\n{{ vm.consultant.fromLogin | timer }}</span><div ng-if=\"!vm.consultant.fromLogin\" class=\"no-value\"></div></div><div \nng-hide=\"vm.consultant.external\" class=\"column other\" flex=\"10\"><span ng-if=\"vm.consultant.fromLastCall\">\n{{ vm.consultant.fromLastCall | timer }}</span><div ng-if=\"!vm.consultant.fromLastCall\" class=\"no-value\"></div></div>\n<div class=\"column other\" flex=\"10\"><span ng-if=\"vm.consultant.ccServiceName || vm.consultant.serviceName\">\n{{ vm.consultant.ccServiceName ? vm.consultant.ccServiceName : vm.consultant.serviceName }}</span><div \nng-if=\"!(vm.consultant.ccServiceName || vm.consultant.serviceName)\" class=\"no-value\"></div></div><div \nclass=\"column other\" flex=\"10\" layout=\"row\"><span ng-if=\"vm.consultant.callDuration\">\n{{ vm.consultant.callDuration | timer }}</span><div ng-if=\"!vm.consultant.callDuration\" class=\"no-value\"></div><span \nng-if=\"vm.consultant.callDuration && vm.consultant.bridgeDuration\">/</span> <span ng-if=\"vm.consultant.bridgeDuration\">\n{{ vm.consultant.bridgeDuration | timer }}</span></div><div ng-hide=\"vm.consultant.external\" class=\"column other\" \nflex=\"10\"><span ng-if=\"vm.consultant.totalBreakTime\">{{ vm.consultant.totalBreakTime | timer }}</span><div \nng-if=\"!vm.consultant.totalBreakTime\" class=\"no-value\"></div></div></div><div class=\"buttons\" flex=\"10\" layout=\"row\" \nlayout-align=\"end center\"><div ng-if=\"vm.consultant.callStatus == 1 && !vm.help.active && !vm.consultant.userHelp\" \nlayout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button ani-button small\" \nng-class=\"{\'loading\': vm.loading}\" ng-disabled=\"vm.loading\" \nng-click=\"$event.stopPropagation();vm.startEavesdropping()\"><md-icon class=\"circle\" \nmd-svg-src=\"/assets/icons/circle-button.svg\"></md-icon><md-icon style=\"color:#68ad55\" ng-if=\"vm.audio.paused\" \nmd-svg-src=\"/assets/icons/reports/ear-sound-anim.svg\"></md-icon><md-icon ng-if=\"!vm.audio.paused\" \nstyle=\"color:#e03636\" md-svg-src=\"/assets/icons/monitoring/pause.svg\"></md-icon><md-tooltip ng-if=\"vm.audio.paused\">\nPodsłuch rozmowy</md-tooltip><md-tooltip ng-if=\"!vm.audio.paused\">Przerwij podsłuch</md-tooltip></md-button><div \nng-hide=\"vm.consultant.external\" class=\"ani-button-group\" ng-class=\"{\'active\' : vm.help.active}\"><div \nclass=\"group-trigger\"><md-button class=\"md-icon-button ani-button small\" \nng-class=\"{\'pulsator\': vm.consultant.needHelp}\" \nng-click=\"$event.stopPropagation();vm.sendHelp(vm.consultant,vm.helpStop,vm.help)\"><md-icon class=\"circle\" \nmd-svg-src=\"/assets/icons/circle-button.svg\"></md-icon><img class=\"status-button\" ng-src=\"assets/icons/Help.svg\">\n<md-tooltip>Pomoc</md-tooltip></md-button></div></div></div><div \nng-if=\"vm.consultant.callStatus == 0 && vm.consultant.bridgeID\" layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button ani-button small\" ng-class=\"{\'loading\': vm.loading}\" ng-disabled=\"vm.loading\" \nng-click=\"$event.stopPropagation();vm.startPlayback()\"><md-icon class=\"circle\" \nmd-svg-src=\"/assets/icons/circle-button.svg\"></md-icon><img class=\"status-button\" ng-if=\"vm.audio.paused\" \nng-src=\"assets/icons/monitoring/play.svg\"> <img class=\"status-button\" ng-if=\"!vm.audio.paused\" \nng-src=\"assets/icons/monitoring/pause.svg\"><md-tooltip>Odtwórz ostatnią rozmowę</md-tooltip></md-button></div><md-menu \nng-show=\"vm.consultant.status == 0\" class=\"extra-buttons mr-10\"><md-button aria-label=\"Aktywuj użytkownika zdalnie\" \nclass=\"md-icon-button ani-button small\" ng-click=\"$event.stopPropagation();$mdMenu.open();vm.loadConsultantPhones()\">\n<md-icon class=\"circle\" md-svg-src=\"/assets/icons/circle-button.svg\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-account-check\"></md-icon><md-tooltip>Zdalna aktywacja</md-tooltip></md-button><md-menu-content>\n<md-menu-item class=\"status md-indent\" ng-repeat=\"phone in vm.phones |orderBy:\'typeId\'\"><md-button \nng-click=\"vm.activateRemote(phone)\"><span>{{::phone.name}}</span></md-button></md-menu-item><md-menu-item \nng-if=\"!vm.phonesLoading && (vm.phones && vm.phones.length < 1)\">Brak numerów</md-menu-item><md-menu-item \nng-if=\"vm.phonesLoading\"><md-progress-circular class=\"md-accent\" md-diameter=\"20\" md-mode=\"indeterminate\">\n</md-progress-circular></md-menu-item></md-menu-content></md-menu><md-menu ng-hide=\"vm.consultant.external\" \nclass=\"extra-buttons\"><md-button aria-label=\"Więcej opcji\" class=\"md-icon-button extra-trigger\" \nng-click=\"$event.stopPropagation();$mdMenu.open()\"><md-icon md-menu-origin md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content><md-menu-item ng-if=\"vm.consultant.callStatus == 1\" layout=\"row\" \nlayout-align=\"start center\"><md-button ng-click=\"$event.stopPropagation(); vm.breakConsultantCall()\"><md-icon \nmd-svg-src=\"/assets/icons/call-end.svg\" style=\"color: red\"></md-icon>Rozłącz rozmowę</md-button></md-menu-item>\n<md-menu-item ng-if=\"vm.consultant.state || vm.consultant.status\" layout=\"row\" layout-align=\"start center\"><md-button \nng-click=\"$event.stopPropagation();vm.kickConsultant()\"><md-icon md-svg-src=\"/assets/icons/status/logout.svg\" \nstyle=\"color: red\"></md-icon>Wyloguj konsultanta</md-button></md-menu-item></md-menu-content></md-menu></div>\n</md-list-item>");
$templateCache.put("app/main/contactcenter/dashboard/component/messagessessionsmonitoring/msmchat/msmchat.html","<div id=\"msm-chat\"><div class=\"close-button-div\"><div class=\"close-button\" ng-click=\"vm.closeChat()\"><img \nsrc=\"assets/icons/delete.svg\" alt=\"\" style=\"width: 13px\"></div></div><chat-part template-data=\"vm.templateData\">\n</chat-part></div>");
$templateCache.put("app/main/contactcenter/dashboard/component/messagessessionsmonitoring/msmrow/msmrow.html","<div id=\"msm-row\"><md-list-item ng-class=\"{\'blink-1\':vm.session.toDelete}\" style=\"padding-bottom: 0 !important\" \nng-style=\"(vm.session.level>=200)&&{\'filter\':\'grayscale(.5)\',\'background-color\':\'rgb({{vm.session.color}} / 25%)\'}||{\'background-color\':\'rgb({{vm.session.color}} / 25%)\'}\">\n<div class=\"type-bar type-{{vm.session.lastInMessageType}}\"></div><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"table-row md-list-item-text\"><div layout=\"row\" \nlayout-align=\"flex-start center\" style=\"width: 100%;align-items: center\"><div class=\"field\" flex=\"5\" \nng-click=\"vm.sortBy(\'id\')\">{{vm.session.sessionId}}</div><div flex=\"5\" class=\"row field\" layout=\"row\" \nstyle=\"align-items: center\"><div class=\"column avatar-container\" layout-align=\"start center\" \nstyle=\"width:42px;align-items:flex-start\"><div class=\"image\"><img ng-src=\"{{ vm.session.servicePhotoUrl }}\"></div>\n</div></div><div class=\"text\" flex=\"25\"><md-icon ng-if=\"vm.session.statusId<3\" style=\"color:#FFCC01\" \nmd-font-icon=\"icon-arrow-right-bold-circle-outline\"></md-icon><md-icon ng-if=\"vm.session.statusId===3\" \nstyle=\"color:#21b4c7\" md-font-icon=\"icon-account-box-outline\"></md-icon><md-icon ng-if=\"vm.session.statusId===4\" \nstyle=\"color:#CD5C5C\" md-font-icon=\"icon-comment-alert-outline\"></md-icon><md-icon ng-if=\"vm.session.statusId===5\" \nstyle=\"color:#2AB982\" md-font-icon=\"icon-clock\"></md-icon><md-icon ng-if=\"vm.session.statusId===100\" \nstyle=\"color:#42403f\" md-font-icon=\"icon-account-check\"></md-icon><md-icon ng-if=\"vm.session.statusId===101\" \nstyle=\"color:#42403f\" md-font-icon=\"icon-account-remove\"></md-icon><md-icon ng-if=\"vm.session.statusId===110\" \nstyle=\"color:#42403f\" md-font-icon=\"icon-account-alert\"></md-icon><md-icon ng-if=\"vm.session.statusId===120\" \nstyle=\"color:#42403f\" md-font-icon=\"icon-comment-remove-outline\"></md-icon><span ng-if=\"vm.session.statusId<3\" \nstyle=\"color:#000000\">Zakolejkowano</span> <span ng-if=\"vm.session.statusId===3\" style=\"color:#000000\">\nPrzydzielono konsultanta</span> <span ng-if=\"vm.session.statusId===4\" style=\"color:#000000\">Wymagana odpowiedź</span> \n<span ng-if=\"vm.session.statusId===5\" style=\"color:#000000\">Oczekiwanie na wiadomość</span> <span \nng-if=\"vm.session.statusId===100\" style=\"color:#000000\">Zak. Problem rozwiązany</span> <span \nng-if=\"vm.session.statusId===101\" style=\"color:#000000\">Zak. Brak Aktywności</span> <span \nng-if=\"vm.session.statusId===110\" style=\"color:#000000\">Zak. przez manager-a</span> <span \nng-if=\"vm.session.statusId===120\" style=\"color:#000000\">Zakończone przez klienta</span></div><span class=\"field\" \nflex=\"15\">{{vm.session.contactId}} {{vm.session.userName | limitTo: 10 }}</span><div flex=\"25\" class=\"row field\" \nlayout=\"row\" style=\"align-items: center\"><div style=\"align-self: flex-start;margin-top: -8px\"><md-icon \nng-if=\"vm.session.level<200\" md-font-icon=\"icon-numeric-1-box-outline\" class=\"level-marker\" \nstyle=\"color: #4F4F4F;font-size: 18px\"></md-icon><md-icon ng-if=\"vm.session.level>=200\" \nmd-font-icon=\"icon-numeric-2-box-outline\" class=\"level-marker\" style=\"color: #7F7F7F;font-size: 18px\"></md-icon></div>\n<div layout=\"column\" layout-align=\"center center\" class=\"avatar-place\" style=\"width:42px;align-items:flex-start\"><div \nclass=\"avatar-container\" style=\"display: flex\"><div class=\"image\"><img ng-if=\"vm.session.consultantPhotoUrl\" \nalt=\"{{ vm.session.consultantName }}\" ng-src=\"{{ vm.session.consultantPhotoUrl }}\"><div \nng-if=\"!vm.session.consultantPhotoUrl\" class=\"noAwatar\" layout=\"column\" layout-align=\"center center\"><md-icon flex \nmd-svg-src=\"/assets/navigation/avatar.svg\" aria-label=\"avatar\"></md-icon></div></div><div \nclass=\"avatar-status-container\"><img flex \nng-src=\"/assets/icons/dashboard/consultant_status/circular-shape-{{vm.session.consultantStatus}}.svg\" \naria-label=\"avatar\"></div></div></div><div style=\"width:42px\">{{ vm.session.consultantId }}</div><div>\n{{ vm.session.consultantName }}</div></div><div class=\"field\" flex=\"10\"><div ng-if=\"!vm.session.finished\">\n{{ vm.session.insertionTimeDif | timer}}</div></div><div class=\"field\" flex=\"10\" layout=\"row\" \nstyle=\"min-width: 60px;text-align: center\"><div ng-if=\"vm.session.statusId<100\" class=\"forward-button round-button\" \nng-click=\"vm.forwardSession(vm.session,$event)\"><md-icon md-svg-src=\"assets/icons/forward-session2.svg\" \nalt=\"Przekieruj sesje\" title=\"Przekieruj sesje\"></md-icon></div><div ng-if=\"vm.session.statusId<100\" \nclass=\"close-button round-button\" ng-click=\"vm.closeSession(vm.session,$event)\" style=\"border: 2px solid #CD5C5D\">\n<md-icon style=\"color: #CD5C5D;line-height: 25px;font-weight: 600\" md-font-icon=\"icon-close\" alt=\"Zamknij sesje\" \ntitle=\"Zamknij sesje\"></md-icon></div></div></div></div></md-list-item></div>");
$templateCache.put("app/main/contactcenter/dashboard/component/messagessessionsmonitoring/msmheader/msmheader.html","<div id=\"msm-header\"><div class=\"easy-content\" \nstyle=\"box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12)\">\n<div class=\"filters header\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title-text\" \ntranslate=\"MSM_HEADER.TITLE\">Podgląd sesji wiadomości</span><div layout=\"row\" layout-align=\"center center\"><div \nlayout-align=\"center center\" layout=\"row\" class=\"filter-button\" \nng-click=\"vm.setCurrentFilterMode(vm.msmFilterConst.all);\" \nng-class=\"{\'active\':vm.msmGlue.currentFilterMode === vm.msmFilterConst.all}\"><span class=\"filter-badge all-badge\" \nstyle=\"font-size: 16px\">{{ vm.msmGlue.filterNumbers.all}}</span><div translate=\"MSM_HEADER.SHOW_ALL\" \nclass=\"filter-label\">Wszystkie</div></div><div layout-align=\"center center\" layout=\"row\" class=\"filter-button\" \nng-click=\"vm.setCurrentFilterMode(vm.msmFilterConst.active);\" \nng-class=\"{\'active\':vm.msmGlue.currentFilterMode === vm.msmFilterConst.active}\"><span \nclass=\"filter-badge active-badge\" style=\"font-size: 16px\">{{ vm.msmGlue.filterNumbers.active }}</span><div \ntranslate=\"MSM_HEADER.ONLY_ACTIVE\" class=\"filter-label\">Aktywne</div></div><div layout-align=\"center center\" \nlayout=\"row\" class=\"filter-button\" ng-click=\"vm.setCurrentFilterMode(vm.msmFilterConst.waiting); \" \nng-class=\"{\'active\':vm.msmGlue.currentFilterMode === vm.msmFilterConst.waiting}\"><span \nclass=\"filter-badge waiting-badge\" style=\"font-size: 16px\">{{ vm.msmGlue.filterNumbers.waiting }}</span><div \ntranslate=\"MSM_HEADER.ONLY_WAITING\" class=\"filter-label\">Oczekujące</div></div><div layout-align=\"center center\" \nlayout=\"row\" class=\"filter-button\" ng-click=\"vm.setCurrentFilterMode(vm.msmFilterConst.finished); \" \nng-class=\"{\'active\':vm.msmGlue.currentFilterMode === vm.msmFilterConst.finished}\"><span \nclass=\"filter-badge finished-badge\" style=\"font-size: 16px\">{{ vm.msmGlue.filterNumbers.finished }}</span><div \ntranslate=\"MSM_HEADER.ONLY_FINISHED\" class=\"filter-label\">Zakończone</div></div></div></div></div></div>");
$templateCache.put("app/main/contactcenter/dashboard/component/messagessessionsmonitoring/msmtable/msmtable.html","<div id=\"msm-table\" \nstyle=\"background-color: #FFFFFF;border-radius: 10px;box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12)\">\n<div flex layout=\"row\" layout-align=\"space-between center\" \nstyle=\"width:100%;height: 148px;max-height: 148px; padding:16px\"><div flex layout=\"row\" \nng-repeat=\"service in vm.msmGlue.consultantsOcupation.services\" \nstyle=\"flex:1; height: 100%; background-color: #f6f6f6;border-radius: 5px; padding: 10px;max-width: 292px\" \nng-style=\"{\'border\': \'2px solid rgb({{service.color}})\'}\"><div><div class=\"column avatar-list\" \nlayout-align=\"start center\" style=\"width:42px; height: 42px;align-items:flex-start\"><div class=\"image\" \nstyle=\"margin-right: 10px\"><img ng-src=\"{{ service.photoUrl }}\"></div></div><div \nstyle=\"font-size:16px;width:24px;height: 24px;text-align: center;padding-top: 0px;margin: 3px 0; background-color: lightgrey;border-radius: 50px;border: 2px solid #4aa356\">\n{{service.activeConsultants}}</div><div \nstyle=\"font-size:14px;width:24px;height: 24px;text-align: center;padding-top: 1px;margin: 3px 0; background-color: lightgrey;border-radius: 50px;border: 2px solid #ffcc00\">\n{{service.consultantsOnBreak}}</div></div><div flex layout=\"column\"><div flex layout=\"row\"><div><div \nstyle=\"font-size: larger;color:#666666\">{{service.id}}</div><div \nstyle=\"font-size: larger;font-weight: bold;color:#666666\">{{service.name}}</div></div></div><div class=\"column other\" \nflex layout=\"row\" style=\"align-self: center;width:160px;max-height: 20px; margin-bottom: 2px\"><div class=\"other\" \nflex=\"15\" \nstyle=\"font-size:15px;text-align: center;background-color: #c6c6c6;margin-right: 2px;border-radius: 4px;border: 1px solid #00db00\" \nng-style=\"(service.sessionsOnActiveCount>(service.activeConsultants*service.sessionsPerConsultant))&&{\'background-color\':\'#CD5C5C\', \'color\':\'white\'}\">\n{{ service.sessionsOnActiveCount }}</div><div class=\"other\" flex=\"70\" \nstyle=\"background-color:#2ab982;height:20px;padding:2px;border-radius:5px\"><div \nng-if=\"(service.activeConsultants*service.sessionsPerConsultant) > 0\" \nstyle=\"background-color:indianred;height: 16px;border-radius:4px\" \nng-style=\"{\'width\':\'{{(service.sessionsOnActiveCount<(service.activeConsultants*service.sessionsPerConsultant))?service.sessionsOnActiveCount/(service.activeConsultants*service.sessionsPerConsultant)*100:100}}%\'}\">\n</div></div><div class=\"other\" flex=\"15\" \nstyle=\"font-size:15px;text-align: center;background-color: #c6c6c6;margin-left: 2px;border-radius: 4px;border: 1px solid #db2c00\">\n{{ service.activeConsultants*service.sessionsPerConsultant }}</div></div><div class=\"column other\" flex layout=\"row\" \nstyle=\"align-self: center;width:160px;max-height: 20px; margin-top: 2px\" \nng-style=\"((service.consultantsOnBreak*service.sessionsPerConsultant) <= 0)&&{\'opacity\': \'0.2\'}\"><div class=\"other\" \nflex=\"15\" \nstyle=\"font-size:15px;text-align: center;background-color: #c6c6c6;margin-right: 2px;border-radius: 4px;border: 1px solid #00db00\">\n{{ service.sessionsOnBreakCount }}</div><div class=\"other\" flex=\"70\" \nstyle=\"background-color:#ffcc00;height:20px;padding:2px;border-radius:5px\"><div \nng-if=\"(service.consultantsOnBreak*service.sessionsPerConsultant) > 0\" \nstyle=\"background-color:indianred;height: 16px;border-radius:4px\" \nng-style=\"{\'width\':\'{{service.sessionsOnBreakCount /(service.consultantsOnBreak*service.sessionsPerConsultant)*100}}%\'}\">\n</div></div><div class=\"other\" flex=\"15\" \nstyle=\"font-size:15px;text-align: center;background-color: #c6c6c6;margin-left: 2px;border-radius: 4px;border: 1px solid #db2c00\">\n{{ service.consultantsOnBreak*service.sessionsPerConsultant }}</div></div></div><div flex layout=\"column\" \nstyle=\"max-width: 66px\" ng-style=\"!vm.msmGlue.waitingPerService[service.id]&&{\'opacity\':\'.4\'}\"><div flex=\"40\" \nlayout=\"column\" layout-align=\"start center\"><md-icon md-svg-src=\"assets/icons/waiting.svg\" \nstyle=\"width:48px;height:48px\" alt=\"Przekieruj sesje\" title=\"Przekieruj sesje\"></md-icon></div><div flex=\"60\" \nlayout=\"column\" layout-align=\"center center\"><div \nstyle=\"font-size:20px;width:32px;height: 32px;text-align: center;padding-top: 0px;margin: 3px 0; background-color: lightgrey;border-radius: 50px;border: 2px solid #CD5C5C\" \nng-style=\"!vm.msmGlue.waitingPerService[service.id]&&{\'border\': \'2px solid #2ab982\'}\">\n{{vm.msmGlue.waitingPerService[service.id].length||0}}</div></div></div></div></div><div flex layout=\"row\"><div \nclass=\"session-list-table\" \nstyle=\"box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12)\" \nflex=\"vm.msmGlue.currentSession?70:100\"><msm-header></msm-header><md-list flex class=\"session-list-content pt-0\" \nstyle=\"max-height: 40px\"><md-list-item class=\"h-40\"><div layout=\"row\" layout-align=\"flex-start center\" \nclass=\"table-header md-list-item-text\" style=\"width: 100%;align-items: center\"><div class=\"text\" flex=\"5\" \nng-click=\"vm.sortBy(\'id\')\">{{ \"MSM_TABLE.SESSION_ID\" | translate }}</div><div class=\"text\" flex=\"5\">\n{{ \"MSM_TABLE.SERVICE_NAME\" | translate }}</div><div class=\"text\" flex=\"25\">{{ \"MSM_TABLE.STATUS_DESC\" | translate }}\n</div><div class=\"text\" flex=\"15\">{{ \"MSM_TABLE.CONTACT_FULLNAME\" | translate }}</div><div class=\"text\" flex=\"25\">\n{{ \"MSM_TABLE.CONSULTANT_LOGIN\" | translate }}</div><div class=\"text\" flex=\"10\">\n{{ \"MSM_TABLE.INSERTATION_TIME\" | translate }}</div><div class=\"text\" flex=\"10\">{{ \"STATISTICS.ACTIONS\" | translate }}\n</div></div></md-list-item></md-list><md-list ms-scroll flex class=\"session-list-content pt-0\" \nstyle=\"max-height: calc(100% - 78px)\"><md-divider></md-divider><div ng-if=\"vm.msmGlue.currentFilterMode===0\" \nng-repeat=\"session in vm.msmGlue.SessionList | orderBy:[\'serviceId\',\'consultantId\']\" \nng-style=\"(($index>0)&&(vm.msmGlue.SessionList[$index - 1].serviceId!==session.serviceId))&&{\'border-top\':\'6px solid white\'}\">\n<msm-row session=\"session\" ng-click=\"vm.showDetails(session)\" \nng-class=\"{\'selectedSession\':(vm.msmGlue.currentSession && vm.msmGlue.currentSession.sessionId === session.sessionId)}\">\n</msm-row></div><div ng-if=\"vm.msmGlue.currentFilterMode===1\" \nng-repeat=\"session in vm.msmGlue.activeSessions | orderBy:[\'serviceId\',\'consultantId\']\" \nng-style=\"(($index>0)&&(vm.msmGlue.activeSessions[$index - 1].serviceId!==session.serviceId))&&{\'border-top\':\'6px solid white\'}\">\n<msm-row session=\"session\" ng-click=\"vm.showDetails(session)\" \nng-class=\"{\'selectedSession\':(vm.msmGlue.currentSession && vm.msmGlue.currentSession.sessionId === session.sessionId)}\">\n</msm-row></div><div ng-if=\"vm.msmGlue.currentFilterMode===2\" \nng-repeat=\"session in vm.msmGlue.waitingSessions | orderBy:[\'serviceId\',\'sessionId\']\" \nng-style=\"(($index>0)&&(vm.msmGlue.waitingSessions[$index - 1].serviceId!==session.serviceId))&&{\'border-top\':\'6px solid white\'}\">\n<msm-row session=\"session\" ng-click=\"vm.showDetails(session)\" \nng-class=\"{\'selectedSession\':(vm.msmGlue.currentSession && vm.msmGlue.currentSession.sessionId === session.sessionId)}\">\n</msm-row></div><div ng-if=\"vm.msmGlue.currentFilterMode===3\" \nng-repeat=\"session in vm.msmGlue.closedSessions | orderBy:[\'serviceId\',\'consultantId\']\" \nng-style=\"(($index>0)&&(vm.msmGlue.closedSessions[$index - 1].serviceId!==session.serviceId))&&{\'border-top\':\'6px solid white\'}\">\n<msm-row session=\"session\" ng-click=\"vm.showDetails(session)\" \nng-class=\"{\'selectedSession\':(vm.msmGlue.currentSession && vm.msmGlue.currentSession.sessionId === session.sessionId)}\">\n</msm-row></div></md-list></div><div flex=\"30\" class=\"chat-preview\" ng-if=\"vm.msmGlue.currentSession\"><msm-chat \nid=\"communicator\" session=\"vm.msmGlue.currentSession\" numer-all=\"vm.openClick\"></msm-chat></div></div></div>");
$templateCache.put("app/main/contactcenter/dashboard/profilemanagement/components/areas/areas.html","<md-content id=\"areas\" flex=\"100\" layout=\"row\" layout-lt-md=\"column\" layout-wrap=\"\" layout-fill=\"\" \nlayout-align=\"start start\"><div flex class=\"md-whiteframe-2dp lists-fixer\" layout-margin=\"10\"><md-toolbar layout=\"row\" \nclass=\"md-hue-3 reset-content\"><div class=\"md-toolbar-tools\"><span translate=\"AREAS.AREAS_TITLE\">Areas</span></div>\n</md-toolbar><filterbox filter-value=\"vm.queryFilter\"></filterbox><md-content class=\"category-container-right\" \nstyle=\"margin-left: 0px\" layout-fill ms-scroll><md-list flex><md-subheader class=\"md-no-sticky\"><div flex layout=\"row\" \nlayout-align=\"end\"><div flex=\"75\"></div><div flex=\"25\" layout-align=\"space-around\" layout=\"row\"><span \ntranslate=\"AREAS.MAIN\">Main </span><span translate=\"AREAS.SELECTED\">Selected</span></div></div></md-subheader>\n<md-list-item ng-repeat=\"area in vm.areaList | filter: vm.queryFilter\" class=\"eagle-shadow\" \nng-class=\"{\'border-selected\':area.inSelectedGroup,\'border-main\':area.inMainGroup}\"><div class=\"md-list-item-text\" \nlayout=\"row\" flex layout-align=\"space-around center\"><span flex=\"75\">{{area.name}}</span><div flex=\"25\" layout=\"row\" \nlayout-align=\"space-around\"><div flex layout-align=\"center\" layout=\"row\"><md-checkbox ng-model=\"area.inMainGroup\" \nng-click=\"area.inSelectedGroup=false\" aria-label=\"b\"></md-checkbox></div><div flex layout-align=\"center\" layout=\"row\">\n<md-checkbox ng-model=\"area.inSelectedGroup\" ng-click=\"area.inMainGroup=false\" aria-label=\"a\"></md-checkbox></div>\n</div></div></md-list-item></md-list></md-content></div><div flex-gt-md=\"48\" flex-lt-md=\"100\" \nclass=\"md-whiteframe-2dp lists-fixer\" layout-margin=\"10\"><md-toolbar layout=\"row\" class=\"md-hue-3 reset-content\"><div \nclass=\"md-toolbar-tools\"><span translate=\"AREAS.YOUR_AREAS_TITLE\">Your areas</span></div></md-toolbar><md-content \nclass=\"category-container-left\" layout-fill ms-scroll><md-list flex><md-subheader class=\"md-no-sticky\" \ntranslate=\"AREAS.MAIN\">Main</md-subheader><div ng-if=\"(vm.areaList |filter:{\'inMainGroup\':true}).length==0\" \nstyle=\"text-align: center\" translate=\"AREAS.NO_MAIN_AREA\">No main area selected</div><md-list-item \nng-repeat=\"area in vm.areaList |filter:{\'inMainGroup\':true}\" class=\"eagle-shadow border-main\"><div flex \nclass=\"md-list-item-text\" layout=\"row\" layout-align=\"center stretch\"><div flex=\"85\" layout=\"row\" \nlayout-align=\"start center\"><span>{{area.name}}</span></div><div flex=\"15\" layout=\"row\" layout-align=\"end center\">\n<md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"vm.removeFromGroup(area)\"><md-icon \nmd-font-icon=\"icon-cancel\" class=\"category-remove2 pointer\"></md-icon></md-button></div></div></md-list-item>\n<md-divider></md-divider><md-subheader class=\"md-no-sticky\" translate=\"AREAS.SELECTED\">Selected</md-subheader><div \nng-if=\"(vm.areaList |filter:{\'inSelectedGroup\':true}).length==0\" style=\"text-align: center\" \ntranslate=\"AREAS.NO_SELECTED_AREA\">No area selected</div><md-list-item \nng-repeat=\"area in vm.areaList |filter:{\'inSelectedGroup\':true}\" class=\"eagle-shadow border-selected\"><div flex \nclass=\"md-list-item-text\" layout=\"row\" layout-align=\"end center\"><div flex=\"85\" layout=\"row\" \nlayout-align=\"start center\"><span>{{area.name}}</span></div><div flex=\"15\" layout=\"row\" layout-align=\"end center\">\n<md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"vm.removeFromGroup(area)\"><md-icon \nmd-font-icon=\"icon-cancel\" class=\"category-remove2 pointer\"></md-icon></md-button></div></div></md-list-item></md-list>\n</md-content></div></md-content>");
$templateCache.put("app/main/contactcenter/dashboard/profilemanagement/components/basic/basic.html","<sidenav-content template-key=\"vm.templateKey\"><top layout=\"column\" layout-align=\"center stretch\"><avatar-cropper flex \nimg-url=\"vm.sidenavData.photoUrl\" file-upload-call=\"savePhoto2\" save-callback=\"vm.selectedFileChanged\" \ndude-name=\"vm.sidenavData.firstName\"></avatar-cropper></top></sidenav-content>");
$templateCache.put("app/main/contactcenter/dashboard/profilemanagement/components/billdata/billdata.html","<md-content flex layout=\"column\" style=\"font-size: 1.6rem\" ng-class=\"{\'disabled-input\': vm.formDisabled }\"><div \nlayout=\"row\" layout-align=\"start center\" class=\"h-65 mb-40 descriptionHeader\" \nstyle=\"border-bottom: 1px solid rgba(0,0,0,.12)\"><h3 flex class=\"md-title\" translate=\"BILLDATA.TITLE\">Areas</h3>\n<md-divider md-inset></md-divider></div><div class=\"pl-60 pr-60\"><div flex layout=\"row\" \nlayout-align=\"space-between stretch\"><md-input-container class=\"mr-15\" flex><label translate=\"BILLDATA.COMPANYNAME\">\nNazwa Firmy</label><input ng-disabled=\"vm.formDisabled\" ng-model=\"vm.ConsultantData.companyName\" type=\"text\">\n</md-input-container><md-input-container class=\"ml-15\" flex><label translate=\"BILLDATA.WEBSITE\">Adres strony www\n</label><input ng-disabled=\"vm.formDisabled\" ng-model=\"vm.ConsultantData.website\" type=\"text\"></md-input-container>\n</div><div flex layout=\"row\" layout-align=\"space-between stretch\"><md-input-container flex><label \ntranslate=\"BILLDATA.ADDRESS\">Adres</label><input ng-disabled=\"vm.formDisabled\" ng-model=\"vm.ConsultantData.address\" \ntype=\"text\"></md-input-container></div><div flex layout=\"row\" layout-align=\"space-between stretch\"><md-input-container \nclass=\"mr-15\" flex><label translate=\"BILLDATA.POSTAL\">Kod pocztowy</label><input ng-disabled=\"vm.formDisabled\" \npattern=\"[0-9]{2}-[0-9]{3}\" ng-model=\"vm.ConsultantData.postalCode\" type=\"text\"></md-input-container>\n<md-input-container class=\"ml-15\" flex><label translate=\"BILLDATA.CITY\">Miasto</label><input \nng-disabled=\"vm.formDisabled\" ng-model=\"vm.ConsultantData.city\" type=\"text\"></md-input-container></div><div flex \nlayout=\"row\" layout-align=\"space-between stretch\"><md-input-container class=\"mr-15\" flex><label \ntranslate=\"BILLDATA.FULLCOMPANYNAME\">Pełna nazwa firmy</label><input ng-disabled=\"vm.formDisabled\" \nng-model=\"vm.ConsultantData.fullCompanyName\" type=\"text\"></md-input-container><md-input-container class=\"ml-15\" flex>\n<label translate=\"BILLDATA.NIP\">NIP</label><input ng-disabled=\"vm.formDisabled\" ng-model=\"vm.ConsultantData.taxID\" \nnip-verify type=\"text\"><div ng-messages=\"profileForm.taxID.$error\" role=\"alert\"><div ng-message=\"nipValidator\" \ntranslate=\"BILLDATA.NUMBERVAL\">Nieprawidłowy numer NIP</div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between stretch\"><md-input-container class=\"mr-15\" flex><label translate=\"BILLDATA.NBANK\">Nr konta\n</label><input ng-model=\"vm.ConsultantData.accountNumber\" bank-verify bank-name=\"vm.ConsultantData.bank\" \nvalid=\"vm.bankValidator\" type=\"text\"><div ng-messages=\"profileForm.accountNumber.$error\" role=\"alert\"><div \nng-message=\"numberValidator\" translate=\"BILLDATA.NUMBERVAL\">Nieprawidłowy numer konta</div></div></md-input-container>\n<md-input-container class=\"ml-15\" flex><label translate=\"BILLDATA.BNAME\">Nazwa banku</label><input \nng-model=\"vm.ConsultantData.bank\" ng-disabled=\"vm.bankValidator\" type=\"text\"></md-input-container></div></div>\n</md-content>");
$templateCache.put("app/main/contactcenter/dashboard/profilemanagement/components/categories/categories.html","<md-content id=\"categories\" flex layout=\"row\" layout-lt-md=\"column\" layout-wrap=\"\" layout-fill=\"\" \nlayout-align=\"start start\"><div flex class=\"md-whiteframe-2dp lists-fixer\" layout-margin=\"10\" ms-scroll><md-toolbar \nlayout=\"row\" class=\"md-hue-3 reset-content\"><div class=\"md-toolbar-tools\"><span translate=\"CATEGORIES.CAT_TITLE\">\nCategories</span></div></md-toolbar><filterbox filter-value=\"vm.queryFilter\"></filterbox><md-content \nclass=\"category-container-right\" style=\"margin-left: 0px\"><md-list flex><md-subheader class=\"md-no-sticky\"><div flex \nlayout=\"row\" layout-align=\"end\"><div flex=\"75\"></div><div flex=\"25\" layout-align=\"space-around\" layout=\"row\"><span>\nGłowne </span><span>Wybrane</span></div></div></md-subheader><md-list-item \nng-repeat=\"cat in vm.categoryList | filter: vm.queryFilter\" class=\"eagle-shadow\" \nng-class=\"{\'border-selected\':cat.inSelectedGroup,\'border-main\':cat.inMainGroup}\"><div class=\"md-list-item-text\" \nlayout=\"row\" flex layout-align=\"space-around center\"><span flex=\"75\">{{cat.category}}</span><div flex=\"25\" \nlayout=\"row\" layout-align=\"space-around\"><div flex layout-align=\"center\" layout=\"row\"><md-checkbox \nng-model=\"cat.inMainGroup\" ng-click=\"cat.inSelectedGroup=false\" aria-label=\"b\"></md-checkbox></div><div flex \nlayout-align=\"center\" layout=\"row\"><md-checkbox ng-model=\"cat.inSelectedGroup\" ng-click=\"cat.inMainGroup=false\" \naria-label=\"a\"></md-checkbox></div></div></div></md-list-item></md-list></md-content></div><div flex-gt-md=\"48\" \nflex-lt-md=\"100\" class=\"md-whiteframe-2dp lists-fixer\" layout-margin=\"10\" ms-scroll><md-toolbar layout=\"row\" \nclass=\"md-hue-3 reset-content\"><div class=\"md-toolbar-tools\"><span translate=\"CATEGORIES.YOUR_CAT_TITLE\">Your Category\n</span></div></md-toolbar><md-content class=\"category-container-left\"><md-list flex><md-subheader class=\"md-no-sticky\" \ntranslate=\"CATEGORIES.MAIN\">Main</md-subheader><div ng-if=\"(vm.categoryList |filter:{\'inMainGroup\':true}).length==0\" \nstyle=\"text-align: center\" translate=\"CATEGORIES.NO_MAIN_CAT\">No main category selected</div><md-list-item \nng-repeat=\"cat in vm.categoryList |filter:{\'inMainGroup\':true}\" class=\"eagle-shadow border-main\"><div flex \nclass=\"md-list-item-text\" layout=\"row\" layout-align=\"center stretch\"><div flex=\"85\" layout=\"row\" \nlayout-align=\"start center\"><span>{{cat.category}}</span></div><div flex=\"15\" layout=\"row\" layout-align=\"end center\">\n<md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"vm.removeFromGroup(cat)\"><md-icon \nmd-font-icon=\"icon-cancel\" class=\"category-remove2 pointer\"></md-icon></md-button></div></div></md-list-item>\n<md-divider></md-divider><md-subheader class=\"md-no-sticky\" translate=\"CATEGORIES.SELECTED\">Selected</md-subheader><div\n ng-if=\"(vm.categoryList |filter:{\'inSelectedGroup\':true}).length==0\" style=\"text-align: center\" \ntranslate=\"CATEGORIES.NO_SELECTED_CAT\">No category selected</div><md-list-item \nng-repeat=\"cat in vm.categoryList |filter:{\'inSelectedGroup\':true}\" class=\"eagle-shadow border-selected\"><div flex \nclass=\"md-list-item-text\" layout=\"row\" layout-align=\"end center\"><div flex=\"85\" layout=\"row\" \nlayout-align=\"start center\"><span>{{cat.category}}</span></div><div flex=\"15\" layout=\"row\" layout-align=\"end center\">\n<md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"vm.removeFromGroup(cat)\"><md-icon \nmd-font-icon=\"icon-cancel\" class=\"category-remove2 pointer\"></md-icon></md-button></div></div></md-list-item></md-list>\n</md-content></div></md-content>");
$templateCache.put("app/main/contactcenter/dashboard/profilemanagement/components/communicatorconfig/commconfig.html","<div id=\"commconfig\" layout=\"column\"><div class=\"istruction\"><h3 class=\"heading\"><span \ntranslate=\"COMMUNICATOR_CONFIG.CLICK_AND_CHOSE_COMMUNICATOR\">Kliknij i wybierz dostpny szablon komunikatora</span></h3>\n</div><div layout=\"row\" layout-wrap><div ng-repeat=\"t in vm.tempaltesData.communicator\" \nng-class=\"{\'in-use\':t.inUse==true}\" style=\"background-color: #f5f5f5\" class=\"templatePreview\" \nng-click=\"vm.changeInUse(t)\" bind-html-compile=\"t.markup\"></div></div><div layout-align=\"start start\" layout=\"row\">\n<md-button type=\"button\" ng-click=\"vm.saveChanges()\" class=\"md-raised md-primary\" aria-label=\"save\" \ntranslate=\"COMMUNICATOR_CONFIG.SAVE_BTT\" style=\"width: 20%;margin-left:40%\">Save changes</md-button></div></div>");
$templateCache.put("app/main/contactcenter/dashboard/profilemanagement/components/description/description.html","<div class=\"descriptionHeader\"><span translate=\"DESCRIPTION.MAIN_LABEL\"></span></div><md-card class=\"description\" \nlayout=\"column\" layout-padding=\"10\"><md-card-content><text-angular ng-model=\"vm.htmlcontent\"></text-angular>\n</md-card-content><md-card-actions layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.saveChanges()\" \nclass=\"md-raised md-primary\" aria-label=\"Zapisz zmiany\">Zapisz zmiany</md-button></md-card-actions></md-card>");
$templateCache.put("app/main/contactcenter/dashboard/profilemanagement/components/consultantservices/consultantservices.html","<md-content flex layout=\"column\" id=\"my-services\" class=\"scrollable\" ms-scroll><section style=\"width: 100%\">\n<md-subheader class=\"md-primary base-subheader\"><div flex=\"100\" layout=\"row\" layout-align=\"start center\"><div \nflex=\"10\" translate=\"CONSULTANT_SERVICES.SERVICE_ID\">Service Id</div><div flex=\"10\" \ntranslate=\"CONSULTANT_SERVICES.SERVICE_TYPE\">Typ</div><div flex=\"20\" translate=\"CONSULTANT_SERVICES.SERVICE_NAME\">\nService name</div></div></md-subheader><md-list class=\"base-list service-list\" flex><md-list-item \nng-repeat=\"s in vm.myServiceList | filter: vm.navBarConfig.search\"><div flex=\"100\" layout=\"row\" \nlayout-align=\"start center\" class=\"row\"><div flex=\"10\">{{s.serviceID}}</div><div flex=\"10\">{{s.type}}</div><div \nflex=\"20\">{{s.serviceName}}</div></div></md-list-item></md-list></section></md-content>");
$templateCache.put("app/main/contactcenter/dashboard/profilemanagement/components/issuetracker/issuetrackerintegration.html","<div class=\"wrapperHeader\" layout=\"row\" layout-align=\"start center\"><h2 flex md-truncate>\n{{\"INTEGRATION.TITLE\" | translate}}</h2></div><div flex class=\"p-15 inputs\" layout=\"column\" \nlayout-align=\"stretch space-between\"><div flex layout=\"row\" layout-align=\"space-between center\"><div flex=\"50\" \nlayout=\"row\" layout-align=\"start center\"><div flex><span>{{\"INTEGRATION.DESCRIPTION\" | translate}}:</span></div><div \nflex><md-input-container><label>{{\"INTEGRATION.ISSUETRACKER\" | translate}}</label><md-select \nng-disabled=\"vm.SessionManager.getUserRoleId() !== vm.authRolesConst.admin\" ng-model=\"vm.selectedIssueTracker\" \nng-change=\"vm.changeIssueTrackerConfig()\" class=\"md-no-underline\" placeholder=\"Wybierz moduł\"><md-option \nng-value=\"issueTracker\" ng-repeat=\"issueTracker in vm.issueTrackers track by issueTracker.id\">{{issueTracker.name}}\n</md-option></md-select></md-input-container></div></div><div flex><div flex layout=\"column\" \nlayout-align=\"center stretch\"><md-button class=\"md-raised md-primary\" type=\"button\" \nng-disabled=\"vm.userCredential() && vm.selectedIssueTracker.id === vm.userCredential().issueTrackerId || !vm.selectedIssueTracker.id\" \nng-click=\"vm.integrate()\">\n{{vm.userCredential() && vm.selectedIssueTracker.id === vm.userCredential().issueTrackerId && \'Zintegrowany\' || \'Integruj\'}}\n</md-button></div></div></div><div ng-show=\"vm.SessionManager.getUserRoleId() === vm.authRolesConst.admin\">\n<jira-integration-new flex ng-if=\"vm.selectedIssueTracker.id == vm.ISSUE_TRACKER_NAME.JIRA\" \nconfig=\"vm.issueTrackerConfig\"></jira-integration-new><bugzilla-integration flex \nng-if=\"vm.selectedIssueTracker.id == vm.ISSUE_TRACKER_NAME.BUGZILLA\" config=\"vm.issueTrackerConfig\">\n</bugzilla-integration></div></div>");
$templateCache.put("app/main/contactcenter/dashboard/profilemanagement/components/general/general.html","<div id=\"profile-mgt-general\"><div layout=\"row\" layout-align=\"center center\" ng-if=\"vm.SessionManager.isConsultant()\">\n<consultant-general-info style=\"margin: 15px\" flex=\"70\" personal-account=\"true\" curr-consultant-id=\"vm.consultantId\">\n</consultant-general-info><div flex=\"30\"><consultant-chanals-activity curr-consultant-id=\"vm.consultantId\" \npersonal-account=\"true\"></consultant-chanals-activity></div></div><div layout=\"row\" layout-align=\"start center\" \nng-if=\"!vm.SessionManager.isConsultant()\"><user-general-info style=\"margin: 15px\" flex=\"50\" curr-user-id=\"vm.userId\" \npersonal-account=\"true\"></user-general-info></div><issue-tracker-integration ng-if=\"false\" class=\"settingsJiraGeneral\" \nsave-indicator=\"vm.saveIssueTracker\"></issue-tracker-integration></div>");
$templateCache.put("app/main/contactcenter/dashboard/profilemanagement/components/rates/rates.html","<div layout=\"column\" layout-align=\"start center\" ng-cloak><md-card flex><md-toolbar class=\"md-primary\"><div \nclass=\"md-toolbar-tools\"><h2 class=\"md-flex\">Stawki</h2></div></md-toolbar><md-card-title><md-card-title-text><span \nclass=\"md-headline\">Ustaw stawki za swoje usługi</span></md-card-title-text></md-card-title><md-card-content><div \nlayout=\"column\"><div layout=\"row\" layout-align=\"start center\" ng-repeat=\"rate in vm.rateType\"><md-checkbox flex \nng-model=\"vm[rate.name]\" ng-click=\"vm.toggleItem(rate.name)\">{{rate.label}}</md-checkbox><md-input-container flex \nng-show=\"vm[rate.name]\"><input type=\"number\" step=\"0.1\" ng-model=\"vm.inputModel[rate.name]\" \nng-model-options=\"{ debounce: 1000 }\" ng-change=\"vm.saveRates()\" placeholder=\"\" aria-label=\"{{rate.label}}\">\n</md-input-container></div></div></md-card-content></md-card></div>");
$templateCache.put("app/main/contactcenter/dashboard/profilemanagement/components/partnermailbox/partnermailbox.html","<md-content flex layout=\"column\" id=\"mails-list\" class=\"scrollable mails-list\" ms-scroll><section style=\"width: 100%\">\n<md-subheader class=\"md-primary base-subheader\" style=\"padding: 0 30px\"><div flex=\"90\" layout=\"row\" \nlayout-align=\"start center\"><div flex=\"10\"></div><div flex=\"20\" style=\"cursor:pointer\" ng-click=\"vm.sortBy(\'name\')\" \ntranslate=\"PARTNERMAILBOX.DESC\">Nazwa skrzynki</div><div flex=\"20\" style=\"cursor:pointer\" \nng-click=\"vm.sortBy(\'email\')\" translate=\"PARTNERMAILBOX.EMAIL\">Email</div></div><div flex=\"10\"></div></md-subheader>\n<md-list class=\"base-list\" flex><md-list-item layout=\"row\" layout-align=\"center space-between\" flex \nng-repeat=\"mail in vm.mailList | filter: vm.navBarConfig.search | orderBy:vm.propertyName:vm.reverse track by mail.id\" \naria-label=\"mail\" ng-class=\"{ \'selected\' : mail.checked }\"><div flex=\"90\" layout=\"row\" layout-align=\"start center\" \nclass=\"row\"><div class=\"avatar-list\" flex=\"10\"><img ng-src=\"assets/icons/management/icon-e.png\"></div><div flex=\"20\" \nclass=\"name\"><span ng-if=\"mail.name\">{{mail.name}}</span></div><div flex=\"20\" class=\"other\"><span ng-if=\"mail.email\">\n{{::mail.email}}</span></div></div><div flex=\"10\" layout=\"row\" layout-align=\"end center\" class=\"icon-container\" \nstyle=\"margin-top: 13px\"><img src=\"../../../../assets/icons/edycja.png\" ng-click=\"vm.editMail(mail)\" class=\"edit-btn\">\n<md-tooltip md-direction=\"top\">Edycja</md-tooltip></div></md-list-item></md-list></section></md-content><md-button \nclass=\"md-fab icon-add\" aria-label=\"button-label\" ng-click=\"vm.addNewMail($event)\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button>");
$templateCache.put("app/main/contactcenter/dashboard/profilemanagement/components/settingsmailbox/settingsmailbox.html","<div layout=\"row\" layout-align=\"start center\"><md-switch ng-if=\"vm.mailData.id\" ng-model=\"vm.mailData.isActive\" \nmd-invert aria-label=\"IsActive\"><span translate=\"PROFILE.MB_ACTIVE\">Aktywna</span></md-switch></div><form \nname=\"vm.mailboxForm\" class=\"inputs\" layout=\"column\" layout-align=\"stretch space-between\" layout-fill><input \ntype=\"text\" name=\"login\" style=\"height: 0px;width: 0px;padding: 0px;     border: 0px\"> <input type=\"password\" \nname=\"password\" style=\"height: 0px;width: 0px;padding: 0px;     border: 0px\"><div ng-if=\"!vm.newRecord\" \nng-init=\"vm.mailboxForm.$setDirty()\"></div><div layout-gt-md=\"{{vm.columnOrder ? \'column\' : \'row\'}}\" \nlayout-md=\"column\" layout-align=\"space-between stretch\"><div flex ng-class=\"{\'mr-20\': !vm.columnOrder}\" \nlayout=\"column\" layout-align=\"space-between stretch\"><div flex layout=\"row\" class=\"h-80\"><md-icon \nmd-font-icon=\"icon-email\"></md-icon><md-input-container flex><label translate=\"PROFILE.MAILNAME\"></label><input \nng-model=\"vm.mailData.name\" ng-required=\"!vm.newRecord\" type=\"text\"></md-input-container></div><div flex layout=\"row\" \nclass=\"h-80\"><md-icon md-font-icon=\"icon-account\"></md-icon><md-input-container flex><label \ntranslate=\"PROFILE.MAILOGIN\"></label><input ng-model=\"vm.mailData.emailLogin\" ng-required=\"!vm.newRecord\" type=\"text\">\n</md-input-container></div><div flex layout=\"row\" class=\"withoutIcon h-80\"><md-input-container flex><label \ntranslate=\"PROFILE.IMAPADD\"></label><input ng-model=\"vm.mailData.imapAddress\" ng-required=\"!vm.newRecord\" type=\"text\">\n</md-input-container></div><div flex layout=\"row\" class=\"withoutIcon h-80\"><md-input-container flex><label \ntranslate=\"PROFILE.STMPADD\"></label><input ng-model=\"vm.mailData.smtpAddress\" ng-required=\"!vm.newRecord\" type=\"text\">\n</md-input-container></div></div><div flex ng-class=\"{\'ml-20\': !vm.columnOrder}\" layout=\"column\" \nlayout-align=\"space-between stretch\"><div flex layout=\"row\" class=\"withoutIcon h-80\"><md-input-container flex><label \ntranslate=\"PROFILE.EMAIL\"></label><input ng-model=\"vm.mailData.email\" ng-required=\"!vm.newRecord\" type=\"email\">\n</md-input-container></div><div flex layout=\"row\" class=\"h-80\"><md-icon md-font-icon=\"icon-lock-outline\"></md-icon>\n<md-input-container flex><label translate=\"PROFILE.MAILPWD\"></label><input ng-model=\"vm.mailData.emailPwd\" \nng-required=\"!vm.newRecord\" type=\"password\"></md-input-container></div><div flex layout=\"row\" class=\"withoutIcon h-80\">\n<md-input-container flex><label translate=\"PROFILE.IMAPPORT\"></label><input ng-model=\"vm.mailData.imapPort\" \nng-required=\"!vm.newRecord\" type=\"number\"></md-input-container></div><div flex layout=\"row\" class=\"withoutIcon h-80\">\n<md-input-container flex><label translate=\"PROFILE.STMPPORT\"></label><input ng-model=\"vm.mailData.smtpPort\" \nng-required=\"!vm.newRecord\" type=\"number\"></md-input-container></div></div></div></form>");
$templateCache.put("app/main/contactcenter/dashboard/profilemanagement/components/userlist/userlist.html","<md-content flex layout=\"column\" id=\"users-list\" class=\"scrollable users-list\" ms-scroll><section style=\"width: 100%\">\n<md-subheader class=\"md-primary base-subheader\" style=\"padding: 0 30px\"><div flex=\"100\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"10\"></div><div flex=\"20\" style=\"cursor:pointer\" \nng-click=\"vm.sortBy(\'lastName\')\" translate=\"USEREDIT.FULLNAME\">Imię i nazwisko/Rola</div><div flex=\"10\" \nstyle=\"cursor:pointer\" ng-click=\"vm.sortBy(\'id\')\" translate=\"USEREDIT.ID\">Id</div><div flex=\"10\" \nstyle=\"cursor:pointer\" ng-click=\"vm.sortBy(\'login\')\" translate=\"USEREDIT.LOGIN\">Login</div><div flex=\"10\" \nstyle=\"cursor:pointer\" ng-click=\"vm.sortBy(\'email\')\" translate=\"USEREDIT.EMAIL\">Email</div><div flex=\"20\"><md-switch \nng-model=\"vm.consult\" ng-change=\"vm.consult\" aria-label=\"IsActive\" style=\"margin-left: -10px\"><span \nstyle=\"color: #8f8f8f\" translate=\"USEREDIT.SHOW_CONSULTATS\">Pokaż konsultantów</span></md-switch></div>\n<md-input-container flex=\"20\"><md-select ng-if=\"vm.callcenters.length > 1\" ng-model=\"vm.filter.callCenterID\" \nstyle=\"text-align:center\"><md-option ng-value=\"undefined\">Contact Center</md-option><md-option \nng-repeat=\"cc in vm.callcenters\" ng-value=\"cc.id\">{{cc.callCenterName}}</md-option></md-select></md-input-container>\n</div></md-subheader><md-list class=\"base-list service-list\" flex><md-list-item \nng-if=\"vm.consult? true : user.roleID!==3\" layout=\"row\" layout-align=\"center space-between\" flex \nng-repeat=\"user in vm.usersList | filter: vm.navBarConfig.search | filter: vm.filter | orderBy:vm.propertyName:vm.reverse track by user.id\" \naria-label=\"user\" ng-class=\"{ \'selected\' : user.checked }\"><div flex=\"100\" layout=\"row\" layout-align=\"start center\" \nclass=\"row\" ng-click=\"vm.selectUser(user);\"><div class=\"avatar-list\" flex=\"10\"><img ng-if=\"user.photoUrl\" \nalt=\"{{user.firstName}}\" ng-src=\"{{user.photoUrl}}\"><avatar-letter class=\"avatar-list-letter\" ng-if=\"!user.photoUrl\" \nname=\"user.firstName\"></avatar-letter></div><div flex=\"20\" class=\"name\"><strong>{{user.firstName}} {{user.lastName}}\n</strong> <span style=\"display: block; font-size: 14px\">{{user.role}}</span></div><div flex=\"10\" class=\"other\"><span \nng-if=\"user.id\">{{::user.id}}</span></div><div flex=\"10\" class=\"other\"><span ng-if=\"user.login\">{{::user.login}}</span>\n</div><div flex=\"10\" class=\"other\"><span ng-if=\"user.email\">{{::user.email}}</span></div><div flex=\"35\"></div><div \nflex=\"5\" layout=\"row\" layout-align=\"end space-between\" style=\"margin-top: 13px\"><div class=\"icon-container\"><img \nsrc=\"../../../../assets/icons/edycja.png\" ng-click=\"vm.editUser(user)\" class=\"edit-btn\"><md-tooltip md-direction=\"top\">\nEdycja</md-tooltip></div></div></div></md-list-item></md-list></section></md-content><md-button \nclass=\"md-fab icon-add\" aria-label=\"button-label\" ng-click=\"vm.addNewUser()\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button>");
$templateCache.put("app/main/contactcenter/dashboard/profilemanagement/components/timeshift/timeshift.html","<div id=\"calendar\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header\" \nng-class=\"vm.currentMonthShort\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"header-top\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-text\">Tygodniowy harmonogram pracy</span></div><div \nclass=\"header-bottom\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button arrow\" \nng-click=\"vm.calendar.prev()\" aria-label=\"Previous\" translate translate-attr-aria-label=\"CALENDAR.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><div class=\"title\">{{vm.calendarView.title}}</div><md-button \nclass=\"md-icon-button arrow\" ng-click=\"vm.next()\" aria-label=\"Next\" translate \ntranslate-attr-aria-label=\"CALENDAR.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div>\n</div><div class=\"content\"><div id=\"calendarView\" ui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.events\" \ncalendar=\"main\"></div></div></div><div id=\"timeshift\" class=\"padding-horizontal-50 pt-30\"><md-content layout-padding>\n<table class=\"personal-calendar\" style=\"border-collapse: collapse\"><thead><tr><td \nclass=\"unselectable unselectable--allDay\"><span>all-day</span></td><td class=\"unselectable\" \nng-repeat=\"week in vm.Weeks track by $index\"><span ng-show=\"$index === 0\"><span \ntranslate=\"TIMESHIFTS.WEEKDAYS.SHORT_MONDAY\"></span> </span><span ng-show=\"$index === 1\"><span \ntranslate=\"TIMESHIFTS.WEEKDAYS.SHORT_TUESDAY\"></span> </span><span ng-show=\"$index === 2\"><span \ntranslate=\"TIMESHIFTS.WEEKDAYS.SHORT_WEDNESDAY\"></span> </span><span ng-show=\"$index === 3\"><span \ntranslate=\"TIMESHIFTS.WEEKDAYS.SHORT_THURSDAY\"></span> </span><span ng-show=\"$index === 4\"><span \ntranslate=\"TIMESHIFTS.WEEKDAYS.SHORT_FRIDAY\"></span> </span><span ng-show=\"$index === 5\"><span \ntranslate=\"TIMESHIFTS.WEEKDAYS.SHORT_SATURDAY\"></span> </span><span ng-show=\"$index === 6\"><span \ntranslate=\"TIMESHIFTS.WEEKDAYS.SHORT_SUNDAY\"></span></span></td></tr></thead><tbody><tr \nng-repeat=\"hour in vm.Hours track by $index\"><td class=\"unselectable unselectable--hours\"><span><span \nng-if=\"$index <= 9\">0</span>{{$index}}:00</span></td><td data-hour=\"{{$parent.$index}}\" data-weekday=\"{{$index}}\" \nclass=\"selectable\" ng-mousedown=\"vm.mouseDown($event)\" ng-mouseover=\"vm.mouseOver($event)\" \nng-mouseup=\"vm.mouseUp($event)\" ng-repeat=\"week in vm.Weeks track by $index\"></td></tr></tbody></table><div \nlayout=\"row\" layout-align=\"end center\" flex><span flex></span><md-button class=\"md-raised md-primary\" \nng-click=\"vm.saveTime()\" aria-label=\"save\" translate=\"TIMESHIFTS.SAVE_CHANGES\"></md-button><md-button \nclass=\"md-raised md-warn\" ng-click=\"vm.clearTime()\" aria-label=\"clear\" translate=\"TIMESHIFTS.CLEAR_CHANGES\">\n</md-button></div></md-content></div></div>");
$templateCache.put("app/main/contactcenter/management/callcenters/components/callcentermenu/callcentermenu.html","<div layout=\"column\" layout-align=\"start stretch\" class=\"{{vm.menuItem.customStyle}}\"><div flex layout=\"row\" \nlayout-align=\"space-between center\" class=\"option-header\"><p layout=\"row\" layout-align=\"start center\" \ntranslate=\"{{::vm.menuItem.name+\'.ROUTE_NAME\'}}\">{{::vm.menuItem.name}}</p><md-button \nng-if=\"::(vm.menuItem.showAdd && vm.userRole <= 1)\" class=\"md-icon-button ani-button md-accent\" \naria-label=\"button-label\" ng-click=\"vm.addCallcenter($event)\"><md-icon class=\"circle\" \nmd-svg-src=\"/assets/icons/spinner-circle.svg\" aria-label=\"previous\"></md-icon><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button></div><div class=\"option-content\"><ul ng-hide=\"vm.menuItem.collapsed\" \nclass=\"option-submenu callcenter-submenu pl-0\"><li layout=\"column\" layout-align=\"start stretch\" \nng-repeat=\"callcenter in vm.callcenters\" ng-click=\"vm.collapseCallcenter($event,callcenter);\"><div flex=\"100\" \nclass=\"submenu-header\" layout=\"row\" layout-align=\"space-between center\"><p flex=\"70\">{{::callcenter.callCenterName}}\n</p><div flex=\"30\" layout=\"row\" layout-align=\"start center\" class=\"icon-container\"><md-button ng-if=\"vm.userRole<=1\" \nflex=\"50\" class=\"md-icon-button\" ng-click=\"vm.editCallcenter(callcenter);\"><md-icon class=\"collapse-icon\" \nmd-svg-src=\"/assets/icons/edit.svg\"></md-icon></md-button><md-icon flex=\"50\" class=\"collapse-icon\" \nng-if=\"!callcenter.collapse && vm.menuItem.previewVisible\" md-font-icon=\"icon-chevron-right\"></md-icon><md-icon \nflex=\"50\" class=\"collapse-icon\" ng-if=\"callcenter.collapse && vm.menuItem.previewVisible\" \nmd-font-icon=\"icon-chevron-down\"></md-icon></div></div><div ng-if=\"::vm.menuItem.previewVisible\" \nng-hide=\"!callcenter.collapse\" flex=\"100\" layout=\"column\" layout-align=\"start stretch\" class=\"submenu-content\"><ul \nclass=\"option-submenu pl-0\"><li class=\"submenu-header pl-20\" layout=\"row\" layout-align=\"space-between center\" \nng-click=\"vm.showGroups($event, callcenter);\" \nng-disabled=\"vm.activeCallCenter == callcenter && \'app.contactcenter_management.callcenters.group\'== vm.activeState\" \nng-class=\"{ \'selected\' : vm.activeCallCenter == callcenter && vm.activeState.indexOf(\'app.contactcenter_management.callcenters.group\')!= -1}\">\n<md-icon md-svg-src=\"/assets/navigation/user.svg\" class=\"icon\"></md-icon><p flex translate=\"CALLCENTER.LIST.GROUPS\">\n</p></li><li class=\"submenu-header pl-20\" layout=\"row\" layout-align=\"space-between center\" \nng-click=\"vm.showConsultants($event, callcenter);\" \nng-disabled=\"vm.activeCallCenter == callcenter && \'app.contactcenter_management.callcenters.consultants\'== vm.activeState\" \nng-class=\"{ \'selected\' : vm.activeCallCenter == callcenter &&  vm.activeState.indexOf(\'app.contactcenter_management.callcenters.consultants\')!= -1}\">\n<md-icon md-svg-src=\"/assets/navigation/users.svg\" class=\"icon\"></md-icon><p flex \ntranslate=\"CALLCENTER.LIST.CONSULTANTS\"></p></li></ul></div></li></ul></div></div>");
$templateCache.put("app/main/contactcenter/management/callcenters/components/externallist/externallist.html","<md-list class=\"base-list\" flex><md-list-item ng-if=\"vm.gatewayPhone ? vm.gatewayPhone.id != gate.id : true\" \nlayout=\"row\" layout-align=\"space-between center\" flex class=\"md-white-bg\" \nng-repeat=\"gate in vm.ngModel | orderBy:vm.propertyName:vm.reverse\"><div flex=\"20\" class=\"name\"><strong>\n{{ ::vm.getPhoneType(gate.typeId)}}</strong></div><div flex=\"35\" class=\"name\"><strong ng-show=\"gate.typeId !== 4\">\n{{gate.gatewayPhone}}</strong></div><div flex=\"35\" class=\"name\"><ta-multiselect ng-if=\"gate.tags\" write-mode=\"false\" \ncustom-class=\"small white\" ng-disabled=\"true\" tag-overflow=\"item.tags\" ng-model=\"gate.tags\" source=\"vm.baseTags\">\n</ta-multiselect></div><div flex=\"10\" layout=\"row\" layout-align=\"end center\"><div class=\"icon-container\"><img \nsrc=\"../../../../assets/icons/edycja.png\" ng-click=\"vm.editPhone(gate);$event.stopPropagation();\"><md-tooltip \nmd-direction=\"top\">Edycja</md-tooltip></div><div class=\"icon-container\"><md-icon md-font-icon=\"icon-trash\" \nng-click=\"vm.deletePhone(gate);$event.stopPropagation();\"></md-icon><md-tooltip md-direction=\"top\">Usuń</md-tooltip>\n</div></div></md-list-item><md-list-item layout=\"row\" layout-align=\"space-between center\" flex class=\"md-white-bg\" \nclass=\"p-0\"><div ng-hide=\"vm.gatewayPhone\" flex layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button ani-button md-accent\" aria-label=\"button-label\" \nng-click=\"vm.addPhone();$event.stopPropagation();\"><md-icon class=\"circle\" \nmd-svg-src=\"/assets/icons/spinner-circle.svg\" aria-label=\"previous\"></md-icon><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button></div></md-list-item></md-list><md-divider class=\"mv-20\" ng-show=\"vm.gatewayPhone\"></md-divider>\n<div ng-show=\"vm.gatewayPhone\" flex layout=\"row\" layout-align=\"space-around start\"><div flex=\"35\" layout=\"column\">\n<md-input-container><label translate=\"CALLCENTER.EDIT_DIALOG.TEL_TYPE\">Typ</label><md-select \nng-model=\"vm.gatewayPhone.typeId\"><md-option ng-repeat=\"type in vm.phoneTypes\" ng-value=\"type.id\">{{type.name}}\n</md-option></md-select></md-input-container></div><div ng-if=\"vm.gatewayPhone\" flex=\"75\" layout=\"column\" \nlayout-align=\"start stretch\"><md-input-container ng-if=\"vm.gatewayPhone.typeId && vm.gatewayPhone.typeId !== 4\" \nflex=\"35\"><label translate=\"CALLCENTER.EDIT_DIALOG.TEL_NUMBER\">Numer</label><input \nng-model=\"vm.gatewayPhone.gatewayPhone\" type=\"text\"></md-input-container><ta-multiselect ng-if=\"vm.gatewayPhone\" \nlabel=\"CALLCENTER.EDIT_DIALOG.TAGS\" write-mode=\"vm.addTag\" new-tags=\"true\" ng-model=\"vm.gatewayPhone.tags\" \nsource=\"vm.baseTags\"></ta-multiselect></div><div flex=\"10\" layout=\"column\" layout-align=\"cener center\" \nclass=\"icon-container\"><md-icon md-font-icon=\"icon-content-save\" \nng-click=\"vm.savePhone(vm.gatewayPhone);$event.stopPropagation();\"></md-icon><md-tooltip md-direction=\"top\">Zapisz\n</md-tooltip></div></div>");
$templateCache.put("app/main/contactcenter/management/callcenters/components/group/group.html","<div flex layout=\"row\" layout-align=\"start center\" class=\"editor-header\"><div flex layout=\"row\" \nlayout-align=\"end center\" class=\"header-input\"><md-input-container flex=\"33\"><input name=\"search\" ng-model=\"vm.search\" \ntype=\"text\"></md-input-container><img src=\"/assets/icons/search.png\"></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"header-actions\"><md-button ng-if=\"vm.editMode\" \nng-click=\"vm.saveConsultantsToGroup()\" class=\"md-button md-raised action-button button-size button-save\">Zapisz\n</md-button><md-button ng-if=\"vm.editMode\" ng-click=\"vm.discardChanges()\" \nclass=\"md-raised button-size action-button button-cancel\"><md-icon md-font-icon=\"icon-close\" aria-label=\"group\">\n</md-icon></md-button><md-button ng-if=\"!vm.editMode\" class=\"md-icon-button ani-button\" aria-label=\"button-label\" \nng-click=\"vm.editMode = true;\"><md-icon class=\"circle\" md-svg-src=\"/assets/icons/spinner-circle.svg\" \naria-label=\"previous\"></md-icon><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button \nng-if=\"!vm.editMode\" ng-click=\"vm.editGroup()\" class=\"md-icon-button\"><md-icon md-svg-src=\"/assets/icons/edit.svg\" \naria-label=\"group\"></md-icon></md-button></div></div><md-content layout=\"column\" layout-align=\"start stretch\" \nclass=\"mt-65 group-container\"><div layout=\"row\" class=\"group-info\" layout-align=\"start stretch\"><div \nclass=\"avatar-container\"><md-icon md-svg-src=\"/assets/navigation/group.svg\" aria-label=\"group\"></md-icon></div><div \nflex layout=\"column\" layout-align=\"start stretch\" class=\"group-data\"><div layout=\"row\" \nlayout-align=\"space-between start\"><span flex=\"50\" class=\"group-name\">{{vm.group.groupName}}</span><ta-multiselect \nflex=\"50\" ng-disabled=\"true\" custom-class=\"big white right\" ng-model=\"vm.group.tags\"></ta-multiselect></div><div \nlayout=\"row\" layout-align=\"space-between start\" class=\"pv-5\"><span flex=\"20\" class=\"group-quantity\">\n{{vm.group.quantity +\' \'}} {{\'CALLCENTER.GROUP.CONSULTANTS.QUANTITY\' | translate}}</span><div flex=\"20\" layout=\"row\" \nlayout-align=\"end start\"><span>Ocena: </span><span class=\"rate\">{{item.rating ? item.rating :\'0\'}}</span></div></div>\n<div layout=\"row\" layout-align=\"start start\" class=\"pv-10\"><span>\nOstatnia modyfikacja : {{vm.group.updateTime | date :\'yyyy-MM-dd HH:mm\'}}</span></div><div layout=\"row\" \nlayout-align=\"start start\" class=\"group-description\"><span>{{vm.group.description }}</span></div></div></div>\n<md-divider class=\"mt-20\"></md-divider><div ng-if=\"vm.consultantsInGroup.length < 1 && !vm.editMode\" layout=\"column\" \nlayout-align=\"center center\" flex ms-scroll><div class=\"m-40 gray-info\" layout=\"column\" layout-align=\"start center\">\n<md-icon flex class=\"big-icon gray-info\" md-svg-src=\"/assets/navigation/group.svg\" aria-label=\"group\"></md-icon><span \nclass=\"gray-info\">Brak konsultantów</span></div><div layout=\"row\" layout-align=\"center center\"><md-button \nng-if=\"!vm.editMode\" class=\"md-icon-button ani-button\" aria-label=\"button-label\" ng-click=\"vm.editMode = true;\">\n<md-icon class=\"circle\" md-svg-src=\"/assets/icons/spinner-circle.svg\" aria-label=\"previous\"></md-icon><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button><span>Dodaj konsultantów do grupy</span></div></div><div layout=\"row\" \nlayout-align=\"center center\" flex ms-scroll><md-list ng-if=\"vm.consultantList &&  vm.consultantList.length>0\" \nclass=\"base-list service-list\" flex layout-fill><md-list-item layout=\"row\" layout-align=\"space-between stretch\" \nng-repeat=\"consultant in vm.consultantList | filter: vm.search | filter:{ \'inGroup\' : vm.editMode ? undefined : true } | orderBy:\'priority\'\" \naria-label=\"consultant\" \nng-class=\"{\'choseable\' : vm.editMode,\'consultant-selected\':vm.currentConsultantId===consultant.consultantID}\"><div \nflex layout=\"row\" layout-align=\"start center\" \nng-click=\"vm.editMode ? consultant.inGroup = !consultant.inGroup : vm.selectConsultant(consultant)\"><div flex=\"5\">\n<md-checkbox ng-show=\"vm.editMode\" ng-disabled=\"!vm.editMode\" class=\"no-label\" ng-checked=\"consultant.inGroup\" \naria-label=\"{{consultant.inGroup ? \'Deselect\' : \'Select\'}}\"></md-checkbox></div><div class=\"avatar-list p-5\" \nlayout=\"row\" layout-align=\"center center\"><div class=\"avatar-wrapper\"><img flex ng-if=\"consultant.photoUrl\" \nmd-menu-align-target class=\"avatar status-mask\" ng-src=\"{{consultant.photoUrl}}\"><div ng-if=\"!consultant.photoUrl\" \nclass=\"avatar default-avatar status-mask\"><md-icon flex md-svg-src=\"/assets/navigation/avatar.svg\" aria-label=\"avatar\">\n</md-icon></div><md-icon md-font-icon=\"icon-checkbox-blank-circle\" ng-style=\"{\'color\':consultant.statusColor }\" \nclass=\"icon status\"></md-icon></div></div><div flex class=\"consultant-data\" layout=\"column\" \nlayout-align=\"start stretch\" class=\"row\" ng-click=\"vm.selectConsultant(consultant);\"><div flex=\"33\" class=\"name\"><span \nng-if=\"!consultant.alias\">{{consultant.firstName}} {{consultant.lastName}}</span> <span ng-if=\"consultant.alias\">\n{{consultant.alias}} ({{consultant.firstName}} {{consultant.lastName}})</span></div><star-rating flex=\"33\" \nng-model=\"consultant.average\" max=\"6\" readonly=\"true\"></star-rating></div></div><div flex layout=\"row\" \nlayout-align=\"end start\" style=\"height: 100%\"><ta-multiselect ng-if=\"consultant.tags\" custom-class=\"small white right\" \nng-disabled=\"true\" write-mode=\"false\" ng-model=\"consultant.tags\"></ta-multiselect></div></md-list-item></md-list></div>\n<div ng-if=\"vm.currentConsultantId\" layout=\"row\" layout-align=\"center cetner\" class=\"consultant-card-cont\">\n<consultant-general-info flex=\"60\" personal-account=\"false\" no-title=\"true\" editing-forbidden=\"true\" \ncurr-consultant-id=\"vm.currentConsultantId\"></consultant-general-info><connection-statistic flex=\"40\" \nchart-data=\"vm.chartData.dataAvgSeconds\" mode=\"vm.connectionStatisticCons.average\"></connection-statistic></div>\n</md-content>");
$templateCache.put("app/main/contactcenter/management/callcenters/components/groupedit/groupedit.html","<div layout=\"column\" layout-align=\"start stretch\"><view-actions save-func=\"vm.saveGroup\" close-func=\"vm.goToGroupView\" \nmain-form=\"vm.mainForm\"></view-actions><div layout=\"column\" layout-align=\"start stretch\" class=\"editor-content mt-55\">\n<accordion-form flex clikcable-header=\"vm.selectedGroup.id\" count-init-progress=\"vm.selectedGroup.id\" \nmain-form=\"vm.mainForm\"><form-pane pane-icon=\"/assets/icons/name-tag.svg\"><p-header><p \ntranslate=\"CALLCENTER.GROUP.EDIT_DIALOG.NAME\">Nazwa</p></p-header><p-minified>{{vm.selectedGroup.groupName}}\n</p-minified><p-content><md-input-container class=\"md-icon-float md-block\"><label \ntranslate=\"CALLCENTER.GROUP.EDIT_DIALOG.NAME\">Nazwa</label><input ng-model=\"vm.selectedGroup.groupName\" type=\"text\" \nrequired></md-input-container></p-content></form-pane><form-pane pane-icon=\"/assets/icons/santa-list.svg\"><p-header><p \ntranslate=\"CALLCENTER.GROUP.EDIT_DIALOG.DESC\">Opis grupy</p></p-header><p-minified>{{vm.selectedGroup.description}}\n</p-minified><p-content><form name=\"dupa\"><md-input-container class=\"md-icon-float md-block\"><label \ntranslate=\"CALLCENTER.GROUP.EDIT_DIALOG.DESC\">Opis grupy</label><textarea ng-model=\"vm.selectedGroup.description\" \nmd-maxlength=\"900\" cols=\"5\" md-select-on-focus required></textarea></md-input-container></form></p-content></form-pane>\n<form-pane pane-icon=\"/assets/icons/price-tag.svg\"><p-header><p translate=\"CALLCENTER.GROUP.EDIT_DIALOG.TAGS\">Tagi</p>\n</p-header><p-minified><ta-multiselect flex ng-disabled=\"true\" write-mode=\"false\" ng-model=\"vm.selectedGroup.tags\">\n</ta-multiselect></p-minified><p-content><ta-multiselect custom-class=\"big white\" write-mode=\"vm.addTag\" \nng-model=\"vm.selectedGroup.tags\" source=\"vm.baseTags\"></ta-multiselect></p-content></form-pane><form-pane \nng-if=\"!vm.selectedGroup.id\" pane-icon=\"/assets/icons/info-sign.svg\"><p-header><p \ntranslate=\"CALLCENTER.GROUP.EDIT_DIALOG.SUM\">Podsumowanie</p></p-header><p-content>\nKliknij przycisk zapisz aby zachować zmiany</p-content></form-pane></accordion-form></div></div>");
$templateCache.put("app/main/contactcenter/management/callcenters/components/groups/groups.html","<div class=\"sidenav-list\" layout=\"column\"><div class=\"header search-header\" layout=\"row\" layout-align=\"end center\">\n<md-input-container flex><input flex name=\"search\" ng-model=\"vm.search\" type=\"text\"></md-input-container><img \nsrc=\"/assets/icons/search.png\"></div><div class=\"md-primary base-subheader\" layout=\"row\" layout-align=\"end center\">\n<md-button class=\"md-icon-button ani-button md-accent\" aria-label=\"button-label\" ng-click=\"vm.addGroup()\"><md-icon \nclass=\"circle\" md-svg-src=\"/assets/icons/spinner-circle.svg\" aria-label=\"previous\"></md-icon><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><md-content layout=\"column\" flex ms-scroll><md-list \nng-if=\"vm.groups\" class=\"base-list\" flex><md-list-item flex \nng-repeat=\"item in vm.groups | filter: vm.search | filter: { isActive: true } | orderBy:vm.propertyName:vm.reverse track by item.id\" \naria-label=\"callcenter\" ng-class=\"{ \'selected\' : vm.activeGorup == item }\"><div layout-fill flex \nclass=\"md-list-item-text\" layout=\"row\" layout-align=\"start space-around\" \nng-click=\"vm.consultantsInGroup(item, vm.printColor($index))\"><div flex=\"20\" layout=\"column\" \nlayout-align=\"start center\" class=\"consultant-avatar avatar-list\"><avatar-letter index=\"item.quantity\" class=\"mt-5\">\n</avatar-letter></div><div flex layout=\"column\" layout-align=\"start stretch\" class=\"row\"><div flex class=\"h-15 mb-5\">\n<span>{{::item.groupName}}</span></div><div flex class=\"other\"><star-rating flex=\"33\" ng-model=\"item.average\" max=\"6\" \nreadonly=\"true\"></star-rating></div><div flex class=\"other\"><ta-multiselect flex ng-if=\"item.tags\" \ncustom-class=\"small black\" ng-disabled=\"true\" write-mode=\"false\" ng-model=\"item.tags\" tag-overflow=\"item.tags\">\n</ta-multiselect></div></div></div></md-list-item></md-list></md-content></div>");
$templateCache.put("app/main/contactcenter/management/consultants/consultantlist/template/consultantdetails.html","<div class=\"p-20\" style=\"height: 100%; width: 100%\"><div ng-if=\"vm.sidenavData\" layout=\"column\" \nlayout-align=\"start start\" id=\"sidenav-consultant-details\" class=\"base-sidenav-view\"><div ng-if=\"vm.sidenavData.login\">\nLogin: <strong>{{vm.sidenavData.login}}</strong></div><div ng-if=\"vm.sidenavData.firstName\">Imię i nazwisko: <strong>\n{{vm.sidenavData.firstName+\' \'+vm.sidenavData.lastName}}</strong></div><div ng-if=\"vm.sidenavData.phone1\">Phone 1: \n<strong>{{vm.sidenavData.phone1}}</strong></div><div ng-if=\"vm.sidenavData.isactive\">Aktywny: <strong>\n{{vm.sidenavData.isactive}}</strong></div><div ng-if=\"vm.sidenavData.updateTime\">Data aktualizacji: <strong>\n{{vm.sidenavData.updateTime | date: \'dd-MM-yyyy HH:mm\'}}</strong></div></div></div>");
$templateCache.put("app/main/contactcenter/management/consultants/consultantlist/template/consultantedit.html","<form name=\"Form1\" novalidate=\"novalidate\" autocomplete=\"off\"><dialog-component savefunc=\"vm.saveNewConsultant\" \nform-name=\"Form1\" \ndialog-title=\"vm.editedConsultant.newRecordMode ? \'CONSULTANTEDIT.NEW_TITLE\':\'CONSULTANTEDIT.EDIT_TITLE\'\"><header \nflex=\"100\" layout=\"column\" layout-align=\"space-between stretch\" layout-fill><avatar-cropper flex layout=\"row\" \nimg-url=\"vm.editedConsultant.photoUrl\" file-upload-call=\"savePhoto2\" save-callback=\"vm.selectedFileChanged\" \ndude-name=\"vm.editedConsultant.firstName\" style=\"display:block;text-align:center\"></avatar-cropper><span \nng-show=\"vm.editedConsultant.firstName\" flex=\"50\" class=\"m-5 h-20\" \nstyle=\"font-size: 20px;text-align:center;line-height:0px;color: rgba(255, 255, 255, 0.7)\">\n{{ vm.editedConsultant.firstName }}</span><md-input-container flex><md-switch ng-model=\"vm.editedConsultant.isactive\" \naria-label=\"IsActive\"><span translate=\"CONSULTANTEDIT.ACTIVE\">Aktywny</span></md-switch></md-input-container></header>\n<content layout=\"column\" layout-align=\"start stretch\" class=\"add-consultant-dialog\" class=\"scrollable\" ms-scroll><input\n type=\"text\" name=\"login\" style=\"height:0\"> <input type=\"password\" name=\"password\" style=\"height:0\"><div flex \nlayout=\"row\"><md-icon md-font-icon=\"icon-account\"></md-icon><md-input-container flex><label \ntranslate=\"CONSULTANTEDIT.NAME\">Imię</label><input ng-model=\"vm.editedConsultant.firstName\" type=\"text\" required \nname=\"consultantName\"><div ng-messages=\"Form1.consultantName.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"CONSULTANTEDIT.ERROR.REQUIRED\">Please enter a value for this field.</div></div></md-input-container></div>\n<md-input-container flex class=\"ml-25 instead-icon\"><label translate=\"CONSULTANTEDIT.SURNAME\">Nazwisko</label><input \nng-model=\"vm.editedConsultant.lastName\" type=\"text\" required name=\"consultantSurname\"><div \nng-messages=\"Form1.consultantSurname.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"CONSULTANTEDIT.ERROR.REQUIRED\">Please enter a value for this field.</div></div></md-input-container><div \nflex layout=\"row\"><md-input-container flex class=\"ml-25 instead-icon\"><label translate=\"CONSULTANTEDIT.LOGIN\">Login\n</label><input ng-model=\"vm.editedConsultant.login\" type=\"text\" name=\"consultantLogin\" required \nng-disabled=\"!vm.editedConsultant.newRecordMode\"><div ng-messages=\"Form1.consultantLogin.$error\" role=\"alert\"><div \nng-message=\"required\" translate=\"CONSULTANTEDIT.ERROR.REQUIRED\">Please enter a value for this field.</div></div>\n</md-input-container></div><div flex layout=\"row\"><md-icon md-font-icon=\"icon-email\"></md-icon><md-input-container \nflex><label translate=\"CONSULTANTEDIT.EMAIL\">Email</label><input ng-model=\"vm.editedConsultant.email\" \nname=\"consultantEmail\" required type=\"email\"><div ng-messages=\"Form1.consultantEmail.$error\" role=\"alert\"><div \nng-message=\"required\" translate=\"CONSULTANTEDIT.ERROR.REQUIRED\">Please enter a value for this field.</div><div \nng-message=\"email\" translate=\"CONSULTANTEDIT.ERROR.EMAIL\">This field must be a valid email address.</div></div>\n</md-input-container></div><div flex layout=\"row\"><md-icon md-font-icon=\"icon-lock-outline\"></md-icon>\n<md-input-container flex><label translate=\"CONSULTANTEDIT.NEWPWD\">Hasło</label><input \nng-model=\"vm.editedConsultant.pwd\" type=\"password\" name=\"consultantPassword\" required autocomplete=\"off\" \nng-required=\"{{vm.editedConsultant.newRecordMode}}\"><div ng-messages=\"Form1.consultantPassword.$error\" role=\"alert\">\n<div ng-message=\"required\" translate=\"CONSULTANTEDIT.ERROR.REQUIRED\">Please enter a value for this field.</div></div>\n</md-input-container></div><md-input-container ng-if=\"vm.editedConsultant.newRecordMode\" flex \nclass=\"ml-25 instead-icon\"><label translate=\"CONSULTANTEDIT.CC\">Contact Center</label><md-select \nng-disabled=\"vm.editedConsultant.callCenterDisabled\" ng-model=\"vm.editedConsultant.callCenterID\"><md-option \nng-disabled=\"true\"><em>None</em></md-option><md-option ng-repeat=\"cc in vm.callcenters\" ng-value=\"cc.id\">\n{{cc.callCenterName}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-icon-float md-block instead-icon\"><label>Alias</label><input ng-model=\"vm.editedConsultant.alias\" \ntype=\"text\"></md-input-container><md-input-container class=\"md-icon-float md-block instead-icon\"><label>Telefon 1\n</label><input ng-model=\"vm.editedConsultant.phone1\" type=\"text\"></md-input-container><md-input-container \nclass=\"md-icon-float md-block instead-icon\"><label>Telefon 2</label><input ng-model=\"vm.editedConsultant.phone2\" \ntype=\"text\"></md-input-container><md-input-container class=\"md-icon-float md-block instead-icon\"><label>Telefon sms\n</label><input ng-model=\"vm.editedConsultant.smsPhone\" type=\"text\"></md-input-container><md-input-container \nclass=\"md-icon-float md-block instead-icon\"><label>Opis</label><textarea \nng-model=\"vm.editedConsultant.detailedDescription\" type=\"text\" rows=\"1\">\n      </md-input-container>\n      \n<md-input-container class=\"md-icon-float md-block instead-icon\">\n        <label>Krótki opis</label>\n        <textarea \nng-model=\"vm.editedConsultant.description\" type=\"text\" rows=\"1\">\n      </md-input-container>\n\n      <settings-mailbox \nuid=\"vm.editedConsultant.userID\" save-indicator=\"vm.saveMail\" resource=\"UsersRsc\" column-order=\"true\" \nclass=\"userListModal\"></settings-mailbox>\n    </content>\n  </dialog-component>\n</form>");
$templateCache.put("app/main/contactcenter/management/services/component/addcontent/addcontent.html","<dialog-component id=\"add-content-dialog\" dialog-title=\"\'ADDCONTENT.TITLE\'\" cancelfunc=\"vm.closeDialog\"><content \nid=\"add-content\" layout=\"column\" layout-align=\"space-between stretch\" class=\"content\"><accordion-form \nmain-form=\"vm.formValid\" clikcable-header=\"true\"><form-pane show-minified=\"true\" \npane-icon=\"assets/icons/management/consultants/add-button.svg\"><p-minified></p-minified><p-header><p \ntranslate=\"ADDCONTENT.ADD_FILES\">Wybierz pliki</p></p-header><p-content><md-content class=\"file-content\" \nflow-init=\"vm.flowConfig()\" flow-name=\"vm.Uploader\" flow-file-added=\"vm.validate($file)\" \nflow-files-submitted=\"vm.fileSubmitted($files, $event, $flow)\" \nflow-file-success=\"vm.CallMeMaybe($flow, $file, $message)\" flow-file-retry=\"vm.retryChunk($file,$flow)\" flex flow-drop \nms-scroll layout=\"row\"><md-list flex class=\"files-list\"><md-subheader><md-list-item><span flex=\"10\"></span> <span \ntranslate=\"MANAGEMENT.SERVICE.CONTENT.NAME\" flex=\"30\"></span> <span translate=\"MANAGEMENT.SERVICE.CONTENT.TYPE\" \nflex=\"10\"></span> <span translate=\"MANAGEMENT.SERVICE.CONTENT.SIZE\" flex=\"10\"></span><div flex=\"40\" layout=\"row\" \nlayout-align=\"center center\"><span translate=\"MANAGEMENT.SERVICE.CONTENT.ACTIONS\" class=\"list__actions\"></span><div \nclass=\"upload-file-div\"><md-button class=\"md-icon-button ani-button upload\" aria-label=\"button-label\" flow-btn \nflow-attrs=\"{accept:\'image/*\'}\"><md-icon class=\"circle\" md-svg-src=\"/assets/icons/spinner-circle.svg\" \naria-label=\"previous\"></md-icon><md-icon md-font-icon=\"icon-upload\"></md-icon><md-tooltip><span \ntranslate=\"ADDCONTENT.CHOOSE_FILES.ADD\">Wybierz pliki</span></md-tooltip></md-button></div></div></md-list-item>\n</md-subheader><md-divider></md-divider><md-list-item ng-repeat=\"file in vm.files \" \nng-class=\"{\'selected\' : vm.selectedFile === file}\"><span flex=\"10\"><img ng-src=\"{{file.contentUrl}}\" \nsrc=\"assets/icons/communicator/user_avatar.svg\" class=\"md-avatar\"> </span><span flex=\"30\">{{file.fileName}}</span> \n<span flex=\"10\">{{file.type}}</span> <span flex=\"10\">{{file.fileSizeKB === \'\' ? \'-\': file.fileSizeKB}} KB</span><div \nflex=\"40\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-button md-icon-button\" \nng-click=\"vm.cancelFile(file);\"><md-icon class=\"icon-overrider\" md-menu-origin md-font-icon=\"icon-trash\"></md-icon>\n</md-button><md-button class=\"md-button md-icon-button\" ng-if=\"file.flow && !file.flow.paused && !file.contentUrl\" \nng-click=\"file.flow.pause(); \"><md-icon class=\"icon-overrider\" md-menu-origin md-font-icon=\"icon-pause-circle-outline\">\n</md-icon></md-button><md-button class=\"md-button md-icon-button\" ng-if=\"file.flow && file.flow.paused\" \nng-click=\"file.flow.resume();\"><md-icon class=\"icon-overrider\" md-menu-origin md-font-icon=\"icon-backup-restore\">\n</md-icon></md-button><md-button class=\"md-button md-icon-button\" ng-if=\"file.flow && file.flow.error\" \nng-click=\"file.flow.retry();\"><md-icon class=\"icon-overrider\" md-menu-origin md-font-icon=\"icon-backup-restore\">\n</md-icon></md-button></div><md-divider></md-divider></md-list-item></md-list></md-content></p-content></form-pane>\n<form-pane pane-icon=\"assets/icons/management/consultants/busines-card.svg\"><p-header><p \ntranslate=\"ADDCONTENT.ADD_TAGS\">Dodaj ewentualne tagii</p></p-header><p-minified></p-minified><p-content><ta-tags \nflex=\"100\" custom-class=\"big black\" write-mode=\"vm.tagWriteMode\" ng-model=\"vm.contentTags\" content-id=\"vm.contentId\" \nlabel=\"Tagi dla kontentu\"></ta-tags></p-content></form-pane></accordion-form><div layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-icon-button complete-btn\" ng-disabled=\"vm.disableSaveButton\" \nng-click=\"vm.addContentTagBtClick()\"><md-icon md-svg-src=\"/assets/icons/down-arrow-in-small-circle.svg\" \naria-label=\"ok\"></md-icon><md-tooltip>Zapisz zmiany</md-tooltip></md-button></div></content></dialog-component>");
$templateCache.put("app/main/contactcenter/management/services/component/content/content.html","<div id=\"file-manager\" class=\"page-layout simple right-sidenav\" layout=\"row\" ng-cloak><div class=\"center\" \nlayout=\"column\" flex><div layout=\"row\" layout-align=\"start center\" class=\"editor-header\"><div ng-if=\"!vm.tagMode\" flex \nlayout=\"row\" layout-align=\"end center\" class=\"header-input\"><md-input-container flex=\"33\"><input name=\"search\" \nng-model=\"vm.search\" type=\"text\"></md-input-container><img src=\"/assets/icons/search.png\"></div><div \nng-if=\"vm.tagMode\" flex layout=\"row\" layout-align=\"start center\" class=\"header-input\"><ta-tags flex=\"100\" \ncustom-class=\"big black\" write-mode=\"true\" ng-model=\"vm.contentTags\" source-endpoint=\"vm.sourceEndpoint\" \nsource-as-model=\"vm.contentType === \'2\'\" content-id=\"vm.contentId\" label=\"Tagi dla kontentu\"></ta-tags></div><div \nlayout=\"row\" layout-align=\"start center\" class=\"header-actions\"><md-button ng-if=\"vm.listMode\" class=\"md-icon-button\" \nng-click=\"(vm.listMode = !vm.listMode)\" aria-label=\"view type\" translate \ntranslate-attr-aria-label=\"MANAGEMENT.SERVICE.CONTENT.GRID_VIEW\"><md-icon md-font-icon=\"icon-view-module\"></md-icon>\n<md-tooltip><span translate=\"MANAGEMENT.SERVICE.CONTENT.GRID_VIEW\">Grid View</span></md-tooltip></md-button><md-button \nng-if=\"!vm.listMode\" class=\"md-icon-button\" aria-label=\"view type\" ng-click=\"(vm.listMode = !vm.listMode)\" translate \ntranslate-attr-aria-label=\"MANAGEMENT.SERVICE.CONTENT.LIST_VIEW\"><md-icon md-font-icon=\"icon-view-headline\"></md-icon>\n<md-tooltip><span translate=\"MANAGEMENT.SERVICE.CONTENT.LIST_VIEW\">List View</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button ani-button upload\" aria-label=\"button-label\" ng-click=\"vm.goToAddContentDialog()\"><md-icon \nclass=\"circle\" md-svg-src=\"/assets/icons/spinner-circle.svg\" aria-label=\"previous\"></md-icon><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip><span translate=\"MANAGEMENT.SERVICE.CONTENT.ADD\">Przeslij kontent</span>\n</md-tooltip></md-button></div></div><md-content ng-if=\"vm.listMode\" class=\"content\" flex ms-scroll layout-fill>\n<md-list class=\"list_\"><md-subheader><md-list-item><span flex=\"5\"></span> <span \ntranslate=\"MANAGEMENT.SERVICE.CONTENT.NAME\" class=\"list__filename\"></span> <span hide-xs \ntranslate=\"MANAGEMENT.SERVICE.CONTENT.TAGS\" class=\"list__chips\"></span> <span hide show-gt-sm \ntranslate=\"MANAGEMENT.SERVICE.CONTENT.TYPE\" class=\"list__type\"></span> <span hide-xs \ntranslate=\"MANAGEMENT.SERVICE.CONTENT.SIZE\" class=\"list__kb\"></span> <span \ntranslate=\"MANAGEMENT.SERVICE.CONTENT.ACTIONS\" class=\"list__actions\"></span></md-list-item></md-subheader><md-divider>\n</md-divider><md-list-item ng-repeat=\"file in vm.files | tagsFilter : vm.search : vm.tagsPicker\" \nng-class=\"{\'selected\' : vm.selectedFile === file}\"><span flex=\"5\"><img ng-src=\"{{file.contentUrl}}\" \nsrc=\"assets/icons/communicator/user_avatar.svg\" class=\"md-avatar\"> </span><span class=\"list__filename\">\n{{file.fileName}}</span><div class=\"list__chips\" hide show-gt-sm><ta-tags flex=\"100\" ng-if=\"file.tags\" \nng-disabled=\"true\" custom-class=\"small white\" ng-model=\"file.tags\" content-id=\"vm.contentId\"></ta-tags><span \nng-if=\"!file.tags\"></span></div><span class=\"list__type\" hide-xs>{{file.type}}</span> <span class=\"list__kb\" hide-xs>\n{{file.fileSizeKB === \'\' ? \'-\': file.fileSizeKB}} KB</span> <span class=\"list__actions\"><md-button \nclass=\"md-button md-icon-button\" ng-click=\"vm.cancelFile(file);\"><md-icon class=\"icon-overrider\" md-menu-origin \nmd-font-icon=\"icon-trash\"></md-icon></md-button></span><md-divider></md-divider></md-list-item></md-list></md-content>\n<div ng-if=\"!vm.listMode\" flow-drop class=\"content-grid\" ms-scroll><div \nng-repeat=\"file in vm.files | tagsFilter : vm.search : vm.tagsPicker\"><img ng-mouseenter=\"vm.mouseOverHandler($index)\" \nng-src=\"{{file.contentUrl}}\" alt=\"{{file.name}}\"><div ng-mouseleave=\"vm.mouseLeaveHandler($index)\" \nclass=\"icon_wrapper\" ng-if=\"vm.displayer[$index].show\"><md-menu><md-button aria-label=\"Image Menu\" \nclass=\"md-icon-button btn-over\" ng-click=\"vm.openMenu($mdMenu,$event)\"><md-icon class=\"icon-overrider\" md-menu-origin \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item><md-button \nng-click=\"vm.closeMenu($mdMenu,$event);\"><span translate>MANAGEMENT.SERVICE.CONTENT.DELETE_IMAGE</span></md-button>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item ng-click=\"vm.closeMenu($mdMenu,$event);\"><span \ntranslate>MANAGEMENT.SERVICE.CONTENT.CANCEL_UPLOAD</span></md-menu-item><md-menu-divider></md-menu-divider>\n<md-menu-item ng-click=\"vm.closeMenu($mdMenu,$event);\"><span translate>MANAGEMENT.SERVICE.CONTENT.PAUSE_UPLOAD</span>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item ng-click=\"vm.closeMenu($mdMenu,$event);\"><span \ntranslate>MANAGEMENT.SERVICE.CONTENT.RESUME_UPLOAD</span></md-menu-item><md-menu-divider></md-menu-divider>\n<md-menu-item ng-click=\"vm.closeMenu($mdMenu,$event);\"><span translate>MANAGEMENT.SERVICE.CONTENT.RETRY_UPLOAD</span>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></div>");
$templateCache.put("app/main/contactcenter/management/services/component/dynamicaction/dynamicaction.html","<div layout=\"column\"><div flex ng-repeat=\"field in vm.actionFields\" bind-html-compile=\"field.template\"></div></div>");
$templateCache.put("app/main/contactcenter/management/services/component/list/list.html","<div class=\"sidenav-list\" layout=\"column\"><div class=\"header search-header\" layout=\"row\" layout-align=\"end center\">\n<md-input-container flex><input flex name=\"search\" ng-model=\"vm.search\" type=\"text\"></md-input-container><img \nsrc=\"/assets/icons/search.png\"></div><div class=\"md-primary base-subheader\" layout=\"row\" layout-align=\"end center\">\n<md-button class=\"md-icon-button ani-button md-accent\" aria-label=\"button-label\" ng-click=\"vm.addServiceClic()\">\n<md-icon class=\"circle\" md-svg-src=\"/assets/icons/spinner-circle.svg\" aria-label=\"previous\"></md-icon><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><md-content flex layout=\"column\" ms-scroll><md-list \nclass=\"base-list\" flex><md-list-item \nng-show=\"(service.active===1 && vm.showActive) || (service.active===0 && !vm.showActive)\" flex \nng-repeat=\"service in vm.serviceList  | tagsFilter : vm.search : vm.tagsPicker | orderBy:vm.propertyName:vm.reverse track by service.serviceID\" \naria-label=\"service\" class=\"md-no-proxy\" ng-class=\"{ \'selected\' : vm.activeService ==service }\"><div layout-fill \nlayout=\"row\" layout-align=\"space-between center\" class=\"row md-list-item-text\" ng-click=\"vm.selectService(service)\">\n<div layout=\"column\" layout-align=\"center center\" class=\"consultant-avatar avatar-list\"><span class=\"avatar-wrapper\" \nng-if=\"::service.photoUrl\"><img class=\"avatar status-mask\" alt=\"{{::service.serviceName}}\" \nng-src=\"{{service.photoUrl}}\"> <img class=\"icon status\" alt=\"{{::service.serviceName}}\" \nng-src=\"{{\'/assets/icons/management/icon-\'+service.type+\'.png\'}}\"> </span><span ng-if=\"::!service.photoUrl\"><img \nalt=\"{{::service.serviceName}}\" ng-src=\"{{\'../../../../assets/icons/management/icon-\'+service.type+\'.png\'}}\"></span>\n</div><div flex layout=\"column\" layout-align=\"start stretch\" class=\"row\"><div flex class=\"h-15 mb-5\"><strong>\n{{::service.serviceName}}</strong></div><div flex class=\"other\"><ta-tags flex ng-if=\"::service.tags\" \ncustom-class=\"small black\" ng-disabled=\"true\" ng-model=\"service.tags\" tag-overflow=\"true\"></ta-tags></div><div flex \nclass=\"other\"><span>{{::service.startDate | date:\'yyyy-MM-dd\'}} - {{::service.stopDate | date:\'yyyy-MM-dd\'}}</span>\n</div></div></div></md-list-item></md-list></md-content></div>");
$templateCache.put("app/main/contactcenter/management/services/component/servicecard/servicecard.html","<div flex layout=\"row\" layout-align=\"start center\" class=\"editor-header\"><div flex layout=\"row\" \nlayout-align=\"end center\" class=\"header-input\"><md-input-container flex=\"33\"><input name=\"search\" ng-model=\"vm.search\" \ntype=\"text\"></md-input-container><img src=\"/assets/icons/search.png\"></div><div ng-if=\"!vm.editMode\" layout=\"row\" \nlayout-align=\"start center\" class=\"header-actions\"><md-button ng-if=\"vm.editMode\" \nng-click=\"vm.saveConsultantsToService()\" class=\"md-button md-raised action-button button-size button-save\">Zapisz\n</md-button><md-button ng-if=\"vm.editMode\" ng-click=\"vm.discardChanges()\" \nclass=\"md-raised button-size action-button button-cancel\"><md-icon md-font-icon=\"icon-close\" aria-label=\"service\">\n</md-icon></md-button><md-button ng-if=\"!vm.editMode\" class=\"md-icon-button ani-button\" aria-label=\"button-label\" \nng-click=\"vm.editAction();\"><md-icon class=\"circle\" md-svg-src=\"/assets/icons/spinner-circle.svg\" \naria-label=\"previous\"></md-icon><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button \nng-if=\"!vm.editMode\" ng-click=\"vm.editService()\" class=\"md-icon-button\"><md-icon md-svg-src=\"/assets/icons/edit.svg\" \naria-label=\"service\"></md-icon></md-button><md-button ng-if=\"!vm.editMode\" ng-click=\"vm.editContent()\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-image-album\" aria-label=\"service\"></md-icon></md-button></div><div \nng-if=\"vm.editMode\" layout=\"row\" layout-align=\"start center\" class=\"header-actions\"><md-button \nng-click=\"vm.saveConsultantsToAction()\" class=\"md-button md-raised action-button button-size button-save\">Zapisz\n</md-button><md-button ng-click=\"vm.discardChanges()\" class=\"md-raised button-size action-button button-cancel\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"group\"></md-icon></md-button></div></div><md-content layout=\"column\" \nlayout-align=\"start stretch\" class=\"mt-65\"><div layout=\"row\" class=\"service-info\" layout-align=\"start stretch\"><div>\n<div class=\"avatar-wrapper\"><div ng-if=\"!vm.service.photoUrl\" class=\"avatar-container\"><md-icon \nmd-svg-src=\"/assets/navigation/settings.svg\" aria-label=\"service\"></md-icon></div><img ng-cloack \nng-if=\"vm.service.photoUrl\" class=\"avatar-container avatar status-mask\" ng-src=\"{{vm.service.photoUrl}}\"> <img \nng-if=\"vm.service.photoUrl\" class=\"icon status\" alt=\"{{::vm.service.serviceName}}\" \nng-src=\"{{\'/assets/icons/management/icon-\'+vm.service.type+\'.png\'}}\"></div></div><div flex layout=\"column\" \nlayout-align=\"start stretch\" class=\"service-data\"><div layout=\"row\" layout-align=\"space-between start\"><span flex=\"50\" \nclass=\"service-name\">{{vm.service.serviceName}}</span><ta-tags ng-if=\"vm.service.tags\" flex=\"50\" ng-disabled=\"true\" \ncustom-class=\"big white right\" ng-model=\"vm.service.tags\"></ta-tags></div><div layout=\"row\" \nlayout-align=\"space-between start\" class=\"pv-5\"><span flex=\"20\" class=\"service-quantity\">\n{{vm.service.quantity +\' \'}} {{\'CALLCENTER.GROUP.CONSULTANTS.QUANTITY\' | translate}}</span></div><div layout=\"row\" \nlayout-align=\"start start\" class=\"service-description\"><span>{{vm.service.serviceDesc }}</span></div></div></div>\n<md-divider class=\"mt-20\"></md-divider><div layout=\"row\" layout-align=\"space-between center\"><md-tabs flex \nmd-selected=\"vm.selectedAction\" md-stretch-tabs=\"auto\"><md-tab ng-repeat=\"action in vm.consultantActions\" \nlabel=\"{{action.Name | translate}} {{$index + 1}}\" md-on-select=\"vm.actionSelected();\" ng-disabled=\"vm.editMode\">\n</md-tab></md-tabs><md-switch md-invert ng-if=\"vm.editMode\" ng-model=\"vm.sortMode\"><span style=\"color:#ababab\">\nKonsultanci w grupie</span></md-switch></div><div ng-if=\"vm.consultantsInService.length < 1 && !vm.editMode\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"m-40 gray-info\" layout=\"column\" layout-align=\"start center\">\n<md-icon flex class=\"big-icon gray-info\" md-svg-src=\"/assets/navigation/service.svg\" aria-label=\"service\"></md-icon>\n<span class=\"gray-info\">Brak konsultantów</span></div><div layout=\"row\" layout-align=\"center center\"><md-button \nng-if=\"!vm.editMode\" class=\"md-icon-button ani-button\" aria-label=\"button-label\" ng-click=\"vm.editMode = true;\">\n<md-icon class=\"circle\" md-svg-src=\"/assets/icons/spinner-circle.svg\" aria-label=\"previous\"></md-icon><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button><span>Dodaj konsultantów do grupy</span></div></div><div layout=\"row\" \nlayout-align=\"center center\"><md-list ng-if=\"vm.consultantList &&  vm.consultantList.length>0\" \nclass=\"base-list service-list\" ui-sortable=\"vm.sortableCCOptions\" ng-model=\"vm.consultantList\" flex ms-scroll>\n<md-list-item layout=\"row\" layout-align=\"space-between stretch\" \nng-repeat=\"consultant in vm.consultantList | filter: vm.search | filter:{ \'action\' : !vm.editMode || vm.sortMode ? true : undefined }\" \naria-label=\"consultant\" class=\"md-no-proxy consultator\" \nng-class=\"{\'choseable\' : vm.editMode, \'not-sortable\': !vm.editMode}\"><div flex layout=\"row\" \nlayout-align=\"start center\" \nng-click=\"(vm.editMode || consultant.type==\'X\') ? undefined : vm.showConsultantCard(consultant)\"><div flex=\"5\">\n<md-checkbox ng-show=\"vm.editMode\" ng-disabled=\"!vm.editMode\" class=\"no-label\" ng-checked=\"consultant.action\" \nng-model=\"consultant.action\" ng-change=\"vm.recalculateModel()\" \naria-label=\"{{consultant.action ? \'Deselect\' : \'Select\'}}\"></md-checkbox></div><div class=\"avatar-list p-5\" \nlayout=\"row\" layout-align=\"center center\"><div ng-if=\"::consultant.type == \'C\'\" class=\"avatar-wrapper\"><img flex \nng-if=\"::consultant.photoUrl\" md-menu-align-target class=\"avatar status-mask\" ng-src=\"{{::consultant.photoUrl}}\"><div \nng-if=\"::!consultant.photoUrl\" class=\"avatar default-avatar status-mask\"><md-icon flex \nmd-svg-src=\"/assets/navigation/avatar.svg\" aria-label=\"avatar\"></md-icon></div><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle\" ng-style=\"{\'color\':consultant.statusColor }\" class=\"icon status\"></md-icon>\n</div><span class=\"avatar-wrapper only-icon\" layout=\"row\" layout-align=\"center center\" \nng-if=\"::consultant.type == \'G\'\"><md-icon flex md-svg-src=\"/assets/navigation/group.svg\" aria-label=\"group\"></md-icon>\n</span><span class=\"avatar-wrapper only-icon\" layout=\"row\" layout-align=\"center center\" \nng-if=\"::consultant.type == \'X\'\"><md-icon flex md-svg-src=\"/assets/icons/external-link.svg\" aria-label=\"group\">\n</md-icon></span></div><div flex class=\"consultant-data\" layout=\"column\" layout-align=\"start stretch\" class=\"row\" \nng-click=\"vm.selectConsultant(consultant);\"><div flex=\"33\" class=\"name\"><span ng-if=\"::!consultant.alias\">\n{{::consultant.name}}</span></div><star-rating ng-if=\"::consultant.average\" flex=\"33\" ng-model=\"consultant.average\" \nmax=\"6\" readonly=\"true\"></star-rating></div></div><div flex layout=\"row\" layout-align=\"end start\" style=\"height: 100%\">\n<ta-multiselect ng-if=\"::consultant.tags\" custom-class=\"small white right\" ng-disabled=\"true\" write-mode=\"false\" \nng-model=\"consultant.tags\"></ta-multiselect><div></div></div></md-list-item></md-list></div></md-content>");
$templateCache.put("app/main/contactcenter/management/services/component/servicesbasic/servicesbasic.html","<sidenav-content><top layout=\"column\" layout-align=\"center center\"><div flex=\"100\" layout=\"row\"><img flex=\"100\" \nclass=\"md-avatar\" ng-if=\"vm.service.photoUrl\" ng-src=\"{{vm.service.photoUrl}}\" ng-click=\"vm.changeAvatar()\" \nlayout-padding> <img flex=\"100\" class=\"md-avatar\" ng-if=\"!vm.service.photoUrl && vm.service.type\" alt=\"no image\" \nsrc=\"../../../../assets/icons/icon-{{vm.service.type}}.png\" layout-padding> <img flex=\"100\" class=\"md-avatar\" \nng-if=\"!vm.service.photoUrl && !vm.service.type\" alt=\"no image\" src=\"../../../../assets/icons/management/services.png\" \nlayout-padding></div><div flex=\"100\" layout=\"row\"><span flex=\"100\" ng-if=\"vm.service && !vm.isArray(vm.service)\" \nclass=\"avatar-name\">{{vm.service.serviceName}}</span> <span flex=\"100\" ng-if=\"vm.isArray(vm.service)\" \nclass=\"avatar-name\">{{ \'Wybrano \'+vm.services.length+\' serwisy\'}}</span> <span flex=\"100\" ng-if=\"!vm.service\" \nclass=\"avatar-name\">Nie wybrano żadnego serwisu</span></div></top><main layout=\"column\" layout-align=\"center stretch\" \nng-if=\"vm.service\" ng-hide=\"vm.isArray(vm.service)\"><md-input-container class=\"paula-input\" flex><label \ntranslate=\"MANAGEMENT.SERVICE.WIZ.STEPBASIC.NAME\">Nazwa</label><input ng-disabled=\"true\" \nng-model=\"vm.service.serviceName\" ng-change=\"vm.onUpdate()\"></md-input-container><md-input-container \nng-if=\"vm.service.type===\'S\' || vm.service.type===\'I\'\" class=\"paula-input\" flex><label \ntranslate=\"MANAGEMENT.SERVICE.WIZ.STEPNUMBER.NUMBER_PREMIUM\">Numer Premium</label><input ng-disabled=\"true\" \nng-model=\"vm.service.premiumNumber\"></md-input-container><md-input-container ng-if=\"vm.service.type===\'E\'\" \nclass=\"paula-input\" flex><label translate=\"MANAGEMENT.SERVICE.WIZ.STEPMAIL.EMAIL_ADDRESS\">Email</label><input \nng-disabled=\"true\" ng-model=\"vm.service.mail\" debounce=\"1000\"></md-input-container><md-input-container \nclass=\"paula-input\" flex ng-hide=\"true\"><input ng-disabled=\"true\" ng-model=\"vm.service.serviceID\"></md-input-container>\n<div class=\"paula-input date-preview\" flex layout=\"column\"><label class=\"description\" \ntranslate=\"MANAGEMENT.SERVICE.WIZ.STEPBASIC.START\"></label><span class=\"value\">\n{{vm.service.startDate | amDateFormat:\'YYYY-MM-DD HH:mm:ss\'}}</span></div><div class=\"paula-input date-preview\" flex \nlayout=\"column\"><label class=\"description\" translate=\"MANAGEMENT.SERVICE.WIZ.STEPBASIC.STOP\"></label><span \nclass=\"value\">{{vm.service.stopDate | amDateFormat:\'YYYY-MM-DD HH:mm:ss\'}}</span></div><md-input-container>\n<ta-multiselect conf=\"vm.conf\" write-mode=\"true\" ng-model=\"vm.service.tags\" source=\"vm.baseTags\"></ta-multiselect>\n</md-input-container></main></sidenav-content>");
$templateCache.put("app/main/contactcenter/management/services/component/simplewizzard/simplewizzard.html","<view-actions save-func=\"vm.saveService\" close-func=\"vm.goToServiceView\" main-form=\"vm.mainForm\"></view-actions><div \nlayout=\"column\" layout-align=\"start stretch\" class=\"mt-55\"><accordion-form ng-if=\"vm.service\" main-form=\"vm.mainForm\" \nclikcable-header=\"vm.service.serviceID\" count-init-progress=\"vm.service.serviceID\" \nwizzard-progress=\"vm.serviceProgress\"><form-pane on-next-pane=\"vm.setMenuWizzard\" hide-content=\"vm.service.serviceID\" \npane-icon=\"assets/icons/reports/group_icon.svg\"><p-header><span>Typ serwisu</span></p-header><p-minified><div \nng-if=\"vm.serviceType\" class=\"service-type-btn\" layout=\"column\" layout-align=\"center center\"><div><avatar-letter \nname=\"vm.serviceType.name\"></avatar-letter></div><span class=\"title\">{{vm.serviceType.name}}</span></div></p-minified>\n<p-content layout=\"column\" layout-align=\"start stretch\"><step-type lock-type-choose=\"vm.typeChoosen\" \ntype-obj=\"vm.serviceType\"></step-type></p-content></form-pane><form-pane pane-icon=\"/assets/icons/name-tag.svg\">\n<p-header><p>Podstawowe Informacje o serwisie</p></p-header><p-minified></p-minified><p-content layout=\"column\" \nlayout-align=\"start stretch\"><step-basic></step-basic></p-content></form-pane><form-pane ng-if=\"!vm.service.serviceID\" \npane-icon=\"/assets/icons/management/set-square.svg\"><p-header><span>Szblon Serwisu</span></p-header><p-minified>\n</p-minified><p-content layout=\"column\" layout-align=\"start stretch\"><md-input-container><label class=\"custom-label\" \ntranslate=\"MANAGEMENT.SERVICE.WIZ.TEMPLATE\">Wybierz szablon serwisu</label><md-select name=\"choosenTemplate\" \nng-model=\"vm.choosenTemplate\" ng-change=\"vm.templateFormChoosen()\" required><md-option ng-value=\"template\" \nng-repeat=\"template in vm.templateList | filter:{ serviceType: vm.service.type }\">{{template.name}}</md-option>\n</md-select></md-input-container><p>{{vm.choosenTemplate.description}}</p></p-content></form-pane><template-config \nchoosen-template=\"vm.choosenTemplate\"></template-config><form-pane ng-if=\"!vm.service.serviceID\" \npane-icon=\"/assets/icons/info-sign.svg\"><p-header><p translate=\"CALLCENTER.GROUP.EDIT_DIALOG.SUM\">Podsumowanie</p>\n</p-header><p-content>Kliknij przycisk zapisz aby zachować zmiany</p-content></form-pane></accordion-form></div>");
$templateCache.put("app/main/contactcenter/management/services/component/stepfinal/stepfinal.html","<!DOCTYPE html><div ng-if=\"vm.stepInited\" layout=\"row\" layout-align=\"start start\" ng-cloak><div flex layout=\"column\">\n<div flex=\"55\" layout=\"column\"><md-toolbar style=\"background-color: transparent\"><div \nclass=\"padding-form md-toolbar-tools\"><span flex class=\"grey-600-fg title-section\"><label \ntranslate=\"MANAGEMENT.SERVICE.WIZ.STEPFINAL.SLOTS\">Sloty</label></span></div></md-toolbar><md-content \nid=\"chart-container\" class=\"padding-form\" flex layout=\"column\"><div flex layout-fill id=\"gantt\" gantt \ndata=\"vm.slotsData\" view-scale=\"vm.options.scale\" auto-expand=\"vm.options.autoExpand\" \ncolumn-width=\"vm.getColumnWidth(vm.options.width, vm.options.scale, vm.options.zoom)\" api=\"vm.options.api\" \ntask-content=\"vm.options.taskContent\" headers-formats=\"vm.options.headersFormats\" from-date=\"vm.fromDate\" \nto-date=\"vm.toDate\"><gantt-tree enabled=\"false\"></gantt-tree><gantt-table enabled=\"false\"></gantt-table><gantt-groups>\n</gantt-groups><gantt-bounds></gantt-bounds><gantt-progress></gantt-progress><gantt-sortable></gantt-sortable>\n<gantt-movable enabled=\"!vm.options.readOnly\"></gantt-movable><gantt-draw-task></gantt-draw-task><gantt-overlap>\n</gantt-overlap><gantt-resize-sensor></gantt-resize-sensor><gantt-dependencies enabled=\"false\" read-only=\"true\">\n</gantt-dependencies></div></md-content></div><hr class=\"space-hr\"><div flex layout=\"row\" ng-if=\"vm.selectedSlot\">\n<md-toolbar flex=\"50\" style=\"background-color: transparent\"><div class=\"padding-form md-toolbar-tools\"><span flex \nclass=\"grey-600-fg title-section\"><label translate=\"MANAGEMENT.SERVICE.WIZ.STEPFINAL.ACTION_FOR_SLOT\">\nAkcje dla slotu nr.</label>{{vm.CurrentSlotIndex}}</span></div></md-toolbar><md-toolbar ng-if=\"vm.currentActionConfig\" \nflex=\"50\" style=\"background-color: transparent\"><div class=\"md-toolbar-tools action-title\"><span flex \nclass=\"grey-600-fg\"><label translate=\"MANAGEMENT.SERVICE.WIZ.STEPFINAL.EDIT_ACTION\">Edycja akcji</label>\n{{vm.CurrentAction.Name}}</span></div></md-toolbar></div><div class=\"action-slot padding-form\" flex=\"40\" layout=\"row\" \nng-if=\"vm.selectedSlot\"><div ng-if=\"!vm.currentActionConfig\" flex=\"20\" layout=\"column\" \nlayout-align=\"space-between center\"><md-list ng-if=\"vm.BaseActionList\" layout=\"column\" \nlayout-align=\"space-between left\" ui-sortable=\"vm.sortableActionsOptions\" ng-model=\"vm.BaseActionList\" \nclass=\"md-dense actions-container source\"><md-list-item flex class=\"md-1-line padded action\" \nng-repeat=\"action in vm.BaseActionList\" ng-model=\"action\" layout-margin ng-hide=\"!action.name\" \nng-class=\"action.disabled?\'action-disabled unsortable\':\'\'\"><div flex>{{action.name | translate}}</div></md-list-item>\n</md-list><md-list layout=\"column\" layout-align=\"top left\" ui-sortable=\"vm.removableActionsInSlotOptions\" \nng-model=\"vm.removedSlot\" class=\"md-dense removable-container destination\"><md-list-item flex=\"\" \nclass=\"md-1-line padded action layout-margin md-no-proxy flex action-empty unsortable\" layout-margin=\"\" \nrole=\"listitem\"><div flex=\"\" class=\"ng-binding flex\"><label translate=\"MANAGEMENT.SERVICE.WIZ.STEPFINAL.DROP_ACTION\">\nPrzeciągnij aby skasować</label></div></md-list-item></md-list></div><div ng-if=\"vm.currentActionConfig\" flex=\"10\" \nclass=\"back-placeholder\" layout=\"column\" layout-align=\"center start\"><div ng-click=\"vm.BackToDragDrop()\" \nalt=\"Powrót do dostępnych akcji\" title=\"Powrót do dostępnych akcji\"><i class=\"fa fa-chevron-left\" aria-hidden=\"true\">\n</i></div></div><div ng-if=\"!vm.currentActionConfig\" flex=\"50\" class=\"info-placeholder\" layout=\"column\" \nlayout-align=\"start center\"><p ng-if=\"!vm.selectedSlot.actions[0].isActive && vm.service.type === \'I\'\" \nclass=\"label-padding\"><label translate=\"MANAGEMENT.SERVICE.WIZ.STEPFINAL.ACTIVE_PREANSWER\">\nAktywuj akcję Pre answer media</label></p><p ng-if=\"vm.selectedSlot.actions[0].isActive && vm.service.type === \'I\'\" \nclass=\"label-padding\"><label translate=\"MANAGEMENT.SERVICE.WIZ.STEPFINAL.UNCHECK_PREANSWER\">\nOdznacz akcję Pre answer media</label></p><p ng-if=\"vm.service.type !== \'I\'\"></p><p \nng-if=\"!vm.actionLeftDragDrop && !vm.dragDrop\"><label \ntranslate=\"MANAGEMENT.SERVICE.WIZ.STEPFINAL.CHOOSE_ACTION_FOR_SLOT_NO\">Wybierz akcję dla slotu nr.</label>\n{{vm.CurrentSlotIndex}}</p><p ng-if=\"!vm.dragDrop && vm.actionLeftDragDrop\"><label \ntranslate=\"MANAGEMENT.SERVICE.WIZ.STEPFINAL.DRAG_ACTION_ON_RIGHT\">Przeciągnij akcję na pole po prawej str.</label></p>\n<p ng-if=\"vm.dragDrop\"><label translate=\"MANAGEMENT.SERVICE.WIZ.STEPFINAL.DRAG_ACTION_ON_TOP_DOWN\">\nPrzeciągnij wybraną akcję w górę lub w dół.</label></p><p></p></div><div flex=\"30\" \nng-class=\"vm.currentActionConfig?\'border-slot\':\'\'\"><md-list layout=\"column\" layout-align=\"top left\" \nui-sortable=\"vm.sortableActionsInSlotOptions\" ng-model=\"vm.selectedSlot.actions\" \nclass=\"md-dense actions-container destination\" style=\"height: 100%\"><md-list-item flex class=\"md-1-line padded action\" \nng-class=\"vm.SetActionClass(action)\" ng-repeat=\"action in vm.selectedSlot.actions\" layout-margin><div \nclass=\"down-arrow\"><i class=\"fa fa-caret-down\" aria-hidden=\"true\"></i></div><div flex \nng-click=\"vm.EditActionConfiguration($index)\">{{action.Name | translate}} <span class=\"delete-action\" \nng-click=\"vm.DeleteAction($index)\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></span></div><div \nclass=\"check-action\" ng-if=\"action.preAnswerMedia\"><i class=\"fa fa-check-circle-o\" \nng-click=\"vm.SetActiveAction($index)\" aria-hidden=\"true\"></i></div></md-list-item><md-list-item flex=\"\" \nclass=\"md-1-line padded action layout-margin md-no-proxy flex action-empty unsortable\" style=\"float: left\" \nlayout-margin=\"\" role=\"listitem\"><div flex=\"\" class=\"ng-binding flex\"></div></md-list-item></md-list></div><md-content \nng-if=\"vm.currentActionConfig\" flex=\"60\" layout=\"row\" id=\"dynamic_form\" class=\"dynamic-form\" ms-scroll><dynamic-action \nflex=\"100\" form-info=\"vm.currentActionConfig\" settings=\"vm.CurrentAction\"></dynamic-action></md-content></div></div>\n</div>");
$templateCache.put("app/main/contactcenter/management/services/component/steppartner/steppartner.html","<div layout=\"column\" layout-align=\"space-around start\" flex=\"grow\"><md-toolbar class=\"toolbar-header\" \nstyle=\"background-color: transparent\"><div class=\"padding-form md-toolbar-tools\"><span flex \nclass=\"grey-600-fg title-section\"><label translate=\"MANAGEMENT.SERVICE.WIZ.STEPPARTNER.ROUTE_NAME\">Partner</label>\n</span></div><hr></md-toolbar><div layout=\"row\" class=\"padding-form service\" layout-align=\"start center\"><avatar-letter\n flex=\"5\" flex-offset=\"30\" class=\"avatar\" name=\"vm.service.typename\"></avatar-letter><div flex=\"95\" class=\"name\">\n{{vm.service.typename}}</div></div><ta-partnerslist ng-model=\"vm.partnersList\" \nselected-partner=\"vm.service.servicePartnerID\"></ta-partnerslist></div>");
$templateCache.put("app/main/contactcenter/management/services/component/steppoint/steppoint.html","<div layout=\"column\" layout-align=\"space-around start\" flex=\"grow\"><md-toolbar class=\"toolbar-header\" \nstyle=\"background-color: transparent\"><div class=\"padding-form md-toolbar-tools\"><span flex \nclass=\"grey-600-fg title-section\"><label translate=\"MANAGEMENT.SERVICE.WIZ.STEPPOINT.ROUTE_NAME\">Skrzynka e-mailowa\n</label></span></div></md-toolbar><div layout=\"column\" class=\"paymentlist\"><div layout=\"column\"><div flex=\"100\" \nclass=\"input-bar header-table\" layout=\"row\" layout-align=\"space-between center\"><div flex=\"20\" flex-offset=\"5\"><label \ntranslate=\"MANAGEMENT.SERVICE.WIZ.STEPPOINT.TYPE\">Typ</label></div><div flex=\"55\"><label \ntranslate=\"MANAGEMENT.SERVICE.WIZ.STEPPOINT.DESC\">Opis</label></div><div flex=\"5\"><label \ntranslate=\"MANAGEMENT.SERVICE.WIZ.STEPPOINT.PRICE_NET\">Netto</label></div><div flex=\"5\"><label \ntranslate=\"MANAGEMENT.SERVICE.WIZ.STEPPOINT.PRICE_GROSS\">Brutto</label></div><div flex=\"5\"><label \ntranslate=\"MANAGEMENT.SERVICE.WIZ.STEPPOINT.MINUTES\">Minuty</label></div><div flex=\"10\" md-no-float layout=\"row\"></div>\n</div><md-content ms-scroll class=\"paymentlist-container scrollable-list\"><div \nng-repeat=\"item in vm.service.payment  | filter: { isActive: \'true\' } \" class=\"mail mail-item\"><div flex=\"100\" \nlayout=\"row\" layout-align=\"start center\"><div flex=\"20\" flex-offset=\"5\">{{item.title}}</div><div flex=\"55\">\n{{item.desc}}</div><div flex=\"5\">{{item.netPrice/100}}</div><div flex=\"5\">{{item.grossPrice/100}}</div><div flex=\"5\">\n{{item.minutes}}</div><div flex=\"10\" layout=\"row\" layout-align=\"center center\"><div class=\"icon-container\"><md-icon \nmd-font-icon=\"icon-pencil-box-outline\" ng-click=\"vm.managePayment($event,item,false)\"></md-icon><md-tooltip \nmd-direction=\"top\">Edycja</md-tooltip></div><div class=\"icon-container\"><md-icon md-font-icon=\"icon-delete\" \nng-click=\"vm.deletePayment(item)\"></md-icon><md-tooltip md-direction=\"top\">Skasuj</md-tooltip></div></div></div></div>\n</md-content></div></div></div><md-button class=\"md-fab icon-add\" aria-label=\"button-label\" \nng-click=\"vm.managePayment($event,{serviceId: vm.service.serviceID},true)\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button>");
$templateCache.put("app/main/contactcenter/management/services/component/surveyedit/surveyedit.html","<form name=\"Form1\" novalidate=\"novalidate\" autocomplete=\"off\"><div layout=\"column\" layout-align=\"start stretch\" \nstyle=\"padding: 0\"><div flex layout=\"column\" layout-align=\"start stretch\" class=\"h-180 ml-10 mr-20\"><md-input-container\n flex><label translate=\"MANAGEMENT.SERVICE.SURVEYS.EDIT.NAME\">Nazwa ankiety</label><input ng-model=\"vm.survey.name\" \ntype=\"text\" name=\"surveyName\" required ng-disabled=\"vm.survey.id\"><div ng-messages=\"Form1.surveyName.$error\" \nrole=\"alert\"><div ng-message=\"required\" translate=\"MANAGEMENT.SERVICE.SURVEYS.EDIT.ERROR.REQUIRED\">\nPlease enter a value for this field.</div></div></md-input-container><md-input-container flex><label>Opis</label>\n<textarea ng-model=\"vm.survey.description\"></textarea></md-input-container></div><div flex layout=\"row\" \nlayout-align=\"start center\" class=\"descriptionHeader h-50\" \nstyle=\"border-bottom: 1px solid rgba(0,0,0,.12);margin-bottom:10px\"><h3 flex class=\"md-title\" \ntranslate=\"MANAGEMENT.SERVICE.SURVEYS.EDIT.LIST\" md-truncate>Dane ogólne</h3></div><md-list ms-scroll \nclass=\"survey-edit\" ui-sortable=\"sortableCCOptions\"><md-list-item class=\"field\" layout=\"column\" \nlayout-align=\"center stretch\" ng-repeat=\"field in vm.survey.configJSON.config\"><div flex layout=\"row\" \nlayout-align=\"space-between center\" class=\"h-70\" ng-hide=\"field.editField\"><span flex=\"10\">{{field.order + 1}}</span>\n<div flex=\"50\">{{field.label}}</div><div flex=\"20\">{{ field.templateKey | formFieldType}}</div><div flex=\"30\" \nlayout=\"row\" layout-align=\"end center\"><md-button ng-if=\"field.removeable\" class=\"md-icon-button\" \nng-click=\"vm.deleteField(field)\"><md-icon md-menu-origin md-font-icon=\"icon-trash\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.editField(field);\"><div class=\"icon-container\"><img \nsrc=\"../../../../assets/icons/edycja.png\"></div></md-button></div></div><div ng-show=\"field.editField\" layout=\"column\" \nlayout-align=\"start stretch\"><div flex layout=\"row\" layout-align=\"space-between center\" class=\"mt-20\"><div flex=\"10\" \nlayout-align=\"start center\"><md-button flex ng-click=\"vm.cancelEditField(field)\" aria-label=\"cancel\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-cancel\"></md-icon></md-button></div><md-input-container flex=\"80\" \nclass=\"mt-40\"><label translate=\"MANAGEMENT.SERVICE.SURVEYS.EDIT.FIELD_NAME\">Pytanie</label><input \nng-model=\"field.label\" type=\"text\" name=\"userLogin\" required></md-input-container><div flex=\"10\" \nlayout-align=\"end center\"><md-button ng-click=\"field.editField = false;\" flex aria-label=\"cancel\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-content-save\"></md-icon></md-button></div></div><div flex \nlayout=\"row\" class=\"h-50\" ng-if=\"field.withSource || field.source\"><ta-multiselect flex write-mode=\"true\" \nng-model=\"field.source\" conf=\"vm.multiselectConf\"></ta-multiselect></div></div><md-divider></md-divider></md-list-item>\n</md-list></div><md-fab-speed-dial ng-cloak class=\"md-scale icon-add\" style=\"box-shadow: none !important\" \nng-if=\"vm.fieldTypes\" ng-hide=\"vm.newField\" flex md-open=\"vm.dialOpen\" md-direction=\"up\" layout=\"column\" \nlayout-align=\"start center\"><md-fab-trigger><md-button aria-label=\"menu\" class=\"md-fab md-warn\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></md-fab-trigger><md-fab-actions><div \nng-repeat=\"field in vm.fieldTypes\" ng-click=\"vm.addField(field);\" layout=\"row\" layout-align=\"start center\"><md-button \naria-label=\"field.name\" class=\"md-fab md-raised md-mini\"><md-tooltip md-direction=\"right\" md-visible=\"false\">\n{{field.label}}</md-tooltip><md-icon md-font-icon=\"{{field.fieldIcon}}\" aria-label=\"field.name\"></md-icon></md-button>\n</div></md-fab-actions></md-fab-speed-dial></form>");
$templateCache.put("app/main/contactcenter/management/services/component/tacheckbox/tacheckbox.html","<div><label translate=\"{{vm.translation}}\">{{vm.translation}}</label><div ng-repeat=\"item in vm.source2\"><md-checkbox \nng-checked=\"item.checked\" ng-click=\"vm.updateModel(item)\">{{item.name ? item.name : item}}</md-checkbox></div></div>");
$templateCache.put("app/main/contactcenter/management/services/component/surveystep/surveystep.html","<md-content id=\"survey-step\" flex class=\"content center-sidenav scrollable\" layout=\"column\" \nlayout-align=\"center stretch\" ms-scroll><section style=\"width: 100%\"><md-subheader id=\"service-list-subheader\" \nclass=\"md-primary base-subheader\" layout=\"column\" layout-align=\"center space-between\"><div flex=\"90\" layout=\"row\" \nlayout-align=\"start center\"><div flex=\"10\" ng-click=\"vm.sortBy(\'type\')\" style=\"cursor: pointer\"></div><div flex=\"20\" \nng-click=\"vm.sortBy(\'serviceName\')\" style=\"cursor: pointer\">Nazwa</div><div flex=\"20\" \nng-click=\"vm.sortBy(\'startDate\')\" style=\"cursor: pointer\">Daty</div><div flex=\"35\" ng-click=\"vm.sortBy(\'serviceDesc\')\" \nstyle=\"cursor: pointer\">Opis</div></div></md-subheader><md-list class=\"base-list\" flex><md-list-item layout=\"row\" \nlayout-align=\"space-between center\" flex class=\"md-white-bg\" style=\"padding:0 !important\" \nng-repeat=\"survey in vm.avableSurveys | filter: vm.navBarConfig.search | orderBy:vm.propertyName:vm.reverse\"><div \nflex=\"10\" layout=\"row\" layout-align=\"center center\" class=\"avatar-list\"><avatar-letter class=\"avatar-list\" \nname=\"survey.name\"></avatar-letter></div><div flex=\"20\" class=\"name\"><strong>{{::survey.name}}</strong></div><div \nflex=\"20\" class=\"other\"><span>{{::survey.modificationTime | date:\'yyyy-MM-dd\'}}</span></div><div flex=\"40\" \nclass=\"other\"><span>{{:: vm.cutDesc(survey.description)}}</span></div><div flex=\"20\" layout=\"row\" \nlayout-align=\"end center\"><div class=\"icon-container\"><img src=\"../../../../assets/icons/edycja.png\" \nng-click=\"vm.addSurveyClic(survey,$event);$event.stopPropagation();\"><md-tooltip md-direction=\"top\">Edycja</md-tooltip>\n</div><md-switch ng-model=\"survey.bindedToService\" ng-change=\"vm.setSurvey(survey);\" md-invert \naria-label=\"Aktywna na serwisie\"><md-tooltip md-direction=\"left\">Aktywna na serwisie</md-tooltip></md-switch></div>\n</md-list-item></md-list></section></md-content><md-button ng-show=\"!vm.editMode\" class=\"md-fab icon-add\" \naria-label=\"button-label\" ng-click=\"vm.addSurveyClic();\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>");
$templateCache.put("app/main/contactcenter/orderbox/componets/maildetails/attachments/attachments.html","<div class=\"thread-attachments\"><div class=\"title\"><span translte=\"MAIL.ATTACHMENTS.TITLE\">Załączniki</span>\n ({{vm.thread.attachments.length}})</div><div ng-if=\"vm.thread.attachments\" class=\"attachment-list\" layout-wrap \nlayout=\"row\"><md-content class=\"attachment\" layout=\"row\" ng-repeat=\"attachment in vm.thread.attachments\"><div \nclass=\"p-20 preview\" layout=\"row\" layout-align=\"center center\"><md-icon ng-if=\"attachment.isImage === \'--\'\" \nmd-font-icon=\"icon-file-document\"></md-icon><md-icon ng-if=\"attachment.isImage !== \'--\'\" md-font-icon=\"icon-picture\">\n</md-icon></div><div layout=\"column\"><div class=\"size\">{{attachment.size}}</div><a class=\"md-accent-color link\" \nng-click=\"vm.download(attachment)\" translate=\"MAIL.ATTACHMENTS.DOWNLOAD\">Download</a></div></md-content></div></div>");
$templateCache.put("app/main/contactcenter/orderbox/componets/maildetails/callbackdetails/callbackdetails.html","<div class=\"history-container\"><b><div class=\"history-title p-10\" translate=\"CALLBACKDDETAILS.TITLE\">REALIZACJA</div>\n<md-divider></md-divider></b><md-subheader class=\"md-primary base-subheader\"><div class=\"h-50\" layout=\"row\" \nlayout-align=\"start center\"><div flex=\"85\" layout=\"row\" layout-align=\"start center\"><div flex=\"35\" \nstyle=\"cursor:pointer\" ng-click=\"vm.sortBy(\'tried\')\" translate=\"CALLBACKDDETAILS.DATE\">Data</div><div flex=\"25\" \nstyle=\"cursor:pointer\" ng-click=\"vm.sortBy(\'duration\')\" translate=\"CALLBACKDDETAILS.DURATION\">Długosć</div><div \nflex=\"40\" style=\"cursor:pointer\" ng-click=\"vm.sortBy(\'consultantId\')\" translate=\"CALLBACKDDETAILS.CONSULTANT\">\nKonsultant</div></div><div flex=\"15\" translate=\"CALLBACKDDETAILS.RECORD\" style=\"text-align: center\">Nagranie</div>\n</div></md-subheader><md-list class=\"callback-history-list\"><md-list-item layout=\"row\" \nlayout-align=\"center space-between\" flex class=\"callback-item\" \nng-repeat=\"stage in vm.forwardList | orderBy:vm.tried:vm.reverse\"><div flex=\"85\" layout=\"row\" \nlayout-align=\"start center\" class=\"row\"><div flex=\"35\" class=\"other\"><span>{{::stage.tried | date:\'dd-MM-yyyy HH:mm\'}}\n</span></div><div flex=\"25\" class=\"other\"><span>{{::vm.fullTime(stage.duration)}}min.</span></div><div flex=\"40\" \nlayout=\"column\" class=\"name\"><span ng-if=\"vm.consultants[stage.consultantID]\">\n{{vm.consultants[stage.consultantID].login}}</span> <span ng-if=\"vm.consultants[stage.consultantID]\">\n({{vm.consultants[stage.consultantID].firstName}} {{vm.consultants[stage.consultantID].lastName}})</span> <span \nng-if=\"!vm.consultants[stage.consultantID]\">{{stage.consultantID}}</span></div></div><div flex=\"15\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"callback-item-button md-icon-button\" ng-click=\"vm.playBridge(stage);\" \nng-disabled=\"!stage.recordPath\" aria-label=\"play button\"><img class=\"circleButton\" \nsrc=\"assets/icons/monitoring/circle.png\"> <img ng-if=\"stage.recordPath && !stage.play\" \nng-src=\"assets/icons/monitoring/play.svg\"> <img ng-if=\"stage.recordPath && stage.play\" \nng-src=\"assets/icons/monitoring/pause.svg\"> <img ng-if=\"!stage.recordPath\" \nng-src=\"assets/icons/orderbox/close-button.svg\"></md-button></div></md-list-item></md-list></div>");
$templateCache.put("app/main/contactcenter/orderbox/componets/maildetails/content/content.html","<div id=\"thread-content\"><div class=\"info\" layout=\"row\" layout-align=\"space-between start\"><div layout=\"column\" \nlayout-align=\"start start\"><div layout=\"row\" layout-align=\"start start\"><div><img ng-if=\"vm.data.from.avatar\" \nalt=\"{{vm.data.from.name}}\" ng-src=\"{{vm.data.from.avatar}}\" class=\"avatar\"><avatar-letter \nng-if=\"!vm.data.from.avatar\" name=\"vm.data.from.name.length>0?vm.data.from.name[0]:vm.data.from.email[0]\">\n</avatar-letter></div><div layout=\"column\" layout-align=\"start start\"><div class=\"name\">\n{{vm.data.from.name.length>0?vm.data.from.name:vm.data.from.email}}</div><div class=\"to\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"to-text\" translate=\"MAIL.DETAILS.CONTENT.TO\">to</div><div>\n{{vm.data.to[0].name.length>0?vm.data.to[0].name:vm.data.to[0].email}}</div></div><div class=\"service\" layout=\"row\" \nlayout-align=\"start center\" ng-class=\"vm.prepairServiceClass(vm.data.serviceInfo.color)\"><div>\n{{vm.data.serviceInfo.serviceName}}</div></div></div></div><a class=\"toggle-details md-accent-color\" \nng-hide=\"vm.selectedMailShowDetails\" ng-click=\"vm.selectedMailShowDetails = !vm.selectedMailShowDetails\" \ntranslate=\"MAIL.DETAILS.CONTENT.SHOW_DETAILS\">Show Details </a><a class=\"toggle-details md-accent-color\" \nng-show=\"vm.selectedMailShowDetails\" ng-click=\"vm.selectedMailShowDetails = !vm.selectedMailShowDetails\" \ntranslate=\"MAIL.DETAILS.CONTENT.HIDE_DETAILS\">Hide Details</a><div ng-show=\"vm.selectedMailShowDetails\" \nclass=\"details\" layout=\"row\" layout-align=\"start start\"><div layout=\"column\"><span class=\"title\" \ntranslate=\"MAIL.DETAILS.CONTENT.FROM\">From:</span> <span class=\"title\" translate=\"MAIL.DETAILS.CONTENT.TO2\">To:</span> \n<span class=\"title\" translate=\"MAIL.DETAILS.CONTENT.DATE\">Date:</span></div><div layout=\"column\"><span class=\"detail\">\n{{vm.data.from.email}}</span> <span class=\"detail\">{{vm.data.to[0].email}}</span> <span class=\"detail\">\n{{vm.data.date | altDate}}</span></div></div></div><md-menu><md-button aria-label=\"More\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\" translate translate-aria-label=\"MAIL.DETAILS.CONTENT.MORE\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \naria-label=\"Reply\" translate-aria-label=\"MAIL.DETAILS.CONTENT.FORWARD_TO\" ng-click=\"vm.runForwardDialog($event)\">\n<md-icon md-font-icon=\"icon-reply\"></md-icon><span translate=\"MAIL.DETAILS.CONTENT.FORWARD_TO\">Prześlij do</span>\n</md-button></md-menu-item></md-menu-content></md-menu></div><md-button class=\"md-raised md-primary call-button\" \nng-if=\"vm.data.type===\'call\'\" ng-click=\"vm.startBrigeCall(vm.sample1,vm.sample2)\"><md-icon md-font-icon=\"fa fa-phone\">\n</md-icon><span translate=\"MAIL.DETAILS.CONTENT.CALL_BUTTON\">Rozpocznij rozmow</span></md-button><div \nng-bind-html=\"vm.data.body\"></div><div ng-show=\"vm.data.emailMovedOrDel\" class=\"emailMovedOrDel\" layout=\"row\" \nlayout-align=\"center center\"><span translate=\"MAIL.DETAILS.CONTENT.MESSAGE_MOVED_OR_DEL\">\nWiadomość została usunięta lub przeniesiona do innego katalogu</span></div></div>");
$templateCache.put("app/main/contactcenter/orderbox/componets/maildetails/contentcall/contentcall.html","<div id=\"thread-content\"><div class=\"info\" layout=\"row\" layout-align=\"space-between start\"><div class=\"basic\" \nlayout=\"column\" layout-align=\"start start\"><div class=\"basic\" layout=\"row\" layout-align=\"start start\"><div>\n<avatar-letter \nname=\"(vm.data.buyerName+\' \'+vm.data.buyerSurename).length>1?(vm.data.buyerName+\' \'+vm.data.buyerSurename):vm.data.buyerEmail\">\n</avatar-letter></div><div layout=\"column\" layout-align=\"start start\" flex=\"80\"><div class=\"name\" \nng-class=\"{\'name-link\':vm.isConsultant}\" ng-click=\"vm.openCaller(vm.data)\">\n{{(vm.data.buyerName+\' \'+vm.data.buyerSurename).length>1?(vm.data.buyerName+\' \'+vm.data.buyerSurename):vm.data.buyerEmail}}\n</div><div class=\"service\" layout=\"row\" layout-align=\"start center\" \nng-class=\"vm.prepairServiceClass(vm.data.serviceInfo.color)\"><div>{{vm.data.serviceInfo.serviceName}}</div></div></div>\n<div layout=\"row\" layout-align=\"end end\" flex=\"20\"><div class=\"communicator\" ng-click=\"vm.openCaller(vm.data)\" \nng-if=\"vm.isConsultant\"><i class=\"icon s18 menu-communicator\"></i><md-tooltip><span \ntranslate=\"MAIL.DETAILS.CONTENTCALL.COMMUNICATOR\">Przypisz</span></md-tooltip></div></div></div><div \nng-show=\"vm.selectedMailShowDetails\" class=\"details\" layout=\"row\" layout-align=\"start start\"></div></div></div><div \nclass=\"call-place\" layout=\"row\" layout-align=\"space-between start\"><div class=\"title\"><div><span \nng-if=\"vm.data.status === \'FREE\'\">THIS IS FREE</span> CALLBACK</div><div style=\"margin-top: 20px\"><div \nng-repeat=\"par in vm.data.extraParams  \"><span ng-if=\"par.Key!==\'ccid\' && par.Key!==\'bg\' && par.Key!==\'avatar\'\">\n{{par.Key+\' : \'+par.Value}}</span></div></div></div><div class=\"actions\" layout=\"column\" layout-align=\"center center\">\n<div class=\"remained\" ng-show=\"vm.data.minutesleft===0\"><span ng-show=\"!vm.callbackLastMinute\" \ntranslate=\"MAIL.DETAILS.CONTENTCALL.CALL_FINISHED\">Rozmowa zrealizowana</span> <span ng-show=\"vm.callbackLastMinute\" \ntranslate=\"MAIL.DETAILS.CONTENTCALL.LAST_MINUTE\">Ostatnia minuta połaczenia</span></div><div class=\"remained\" \nng-hide=\"vm.data.minutesleft===0\" layout=\"row\" layout-align=\"center center\"><span class=\"title2\">\n{{\'MAIL.DETAILS.CONTENTCALL.REMAINED\' | translate}} {{vm.data.minutesleft>0?vm.data.minutesleft:0}} z {{vm.data.minutes}} {{\'MAIL.DETAILS.CONTENTCALL.MIN\' | translate}}\n</span></div><md-button \nng-if=\"vm.userSession.consultantId===vm.data.consultantID && vm.data.minutesleft>0 && (vm.data.status === \'CONFIRMED\' || vm.data.status === \'FREE\')\" \nclass=\"md-raised md-primary call-button\" ng-click=\"vm.startBrigeCall()\" \nng-disabled=\"vm.callActive || vm.callInfoBarService.isActive\"><md-icon md-font-icon=\"icon-phone-incoming\"></md-icon>\n<span>CALLBACK</span></md-button><div layout=\"column\" layout-align=\"center center\" \nng-if=\"vm.userSession.consultantId!==vm.data.consultantID && vm.data.minutesleft>0 && (vm.data.status === \'CONFIRMED\' || vm.data.status === \'FREE\')\">\n<span class=\"assign-to\" ng-show=\"vm.data.login\">\n{{\'MAIL.DETAILS.CONTENTCALL.ASSIGN_TO\' | translate}} {{vm.data.firstName}} {{vm.data.lastName}} ({{vm.data.login}})\n</span><md-button class=\"md-raised md-primary call-button call-button\" ng-click=\"vm.assignConsultantDialog($event)\">\n<md-icon md-font-icon=\"icon-phone-incoming\"></md-icon><span ng-if=\"vm.data.login\" \ntranslate=\"MAIL.DETAILS.CONTENTCALL.CHANGE_ASSIGMENT\">zmie przypisanie</span> <span ng-if=\"!vm.data.login\" \ntranslate=\"MAIL.DETAILS.CONTENTCALL.SET_ASSIGMENT\">przypisz</span></md-button></div><div \nng-if=\"vm.data.status !== \'CONFIRMED\' && vm.data.status !== \'FREE\'\"><span \ntranslate=\"MAIL.DETAILS.CONTENTCALL.NOT_CONFIRMED\">Płatność niepotwierdzona</span></div></div></div><div \nclass=\"annotation\" ng-bind-html=\"vm.data.buyerAnnotation\"></div><callback-details guid=\"vm.data.guid\">\n</callback-details></div>");
$templateCache.put("app/main/contactcenter/orderbox/componets/maildetails/header/header.html","<div id=\"thread-header\"><div class=\"start\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"service-icon\"><md-icon ng-if=\"vm.data.serviceInfo.type===\'E\'\" md-font-icon=\"icon-email\" class=\"s18\" \nng-class=\"vm.prepairServiceClass(vm.data.serviceInfo.color)\"></md-icon><md-icon ng-if=\"vm.data.serviceInfo.type===\'V\'\" \nmd-font-icon=\"icon-phone-incoming\" class=\"s18\" ng-class=\"vm.prepairServiceClass(vm.data.serviceInfo.color)\"></md-icon>\n</div></div><div class=\"subject\" flex>{{vm.data.subject}}</div><div class=\"actions\" layout=\"row\" \nlayout-align=\"space-between center\"><div \nng-if=\"vm.OrderboxGlue.currentFilter.type===\'callbackFolderType\' && vm.data.consultantID > 0 && vm.data.consultantID!==vm.currentConsultantID\" \nstyle=\"margin-right: 20px\"><span translate=\"MAIL.DETAILS.HEADER.ASSIGN_TO\">Przypisane do</span>\n {{vm.data.firstName}} {{vm.data.lastName}} ({{vm.data.login}})</div><div flex><md-menu \nng-if=\"vm.OrderboxGlue.currentFilter.type!==\'callbackFolderType\'\"><md-button class=\"md-icon-button\" \naria-label=\"Services labels\" translate translate-attr-aria-label=\"MAIL.DETAILS.HEADER.SERVICES_LABEL\" \nng-click=\"$mdOpenMenu($event)\"><img class=\"icon\" src=\"assets/icons/orderbox/pin_service.svg\"><md-tooltip><span \ntranslate=\"MAIL.DETAILS.HEADER.SERVICES_LABEL\">Przypnij serwis</span></md-tooltip></md-button><md-menu-content \nclass=\"thread-labels-toggle-list\" width=\"3\"><md-list><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"MAIL.DETAILS.HEADER.SERVICES_BUTTON\">Przypnij do:</span> <i class=\"fa fa-lock\" aria-hidden=\"true\" \nng-hide=\"vm.data.serviceEditableAllowed\"></i></md-subheader><md-list-item \nng-repeat=\"service in vm.OrderboxGlue.currentMailBox.allowedServices\" ng-click=\"vm.toggleService(vm.data,service)\"><div\n layout=\"row\" layout-align=\"start center\"><div class=\"w-10 h-10 mr-16\" ng-class=\"service.color\"></div><div>\n{{service.serviceName}}</div></div><md-icon md-font-icon=\"icon-checkbox-blank-outline\" class=\"md-secondary\" \nng-if=\"vm.data && !vm.data.serviceInfo.serviceId===service.serviceID\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-marked\" class=\"md-accent md-secondary\" \nng-if=\"vm.data && vm.data.serviceInfo.serviceId===service.serviceID\"></md-icon></md-list-item></md-list>\n</md-menu-content></md-menu><md-button \nng-if=\"vm.OrderboxGlue.currentFilter.type===\'callbackFolderType\' && vm.notConsutlatn\" class=\"md-icon-button\" \naria-label=\"Przypisz..\" translate translate-attr-aria-label=\"MAIL.DETAILS.HEADER.ANSWER\" \nng-click=\"vm.assignConsultantDialog($event)\"><img class=\"icon\" src=\"assets/icons/orderbox/user.svg\"><md-tooltip><span \ntranslate=\"MAIL.DETAILS.HEADER.ASSIGN\">Przypisz</span></md-tooltip></md-button><md-button \nng-if=\"vm.OrderboxGlue.currentFilter.type!==\'callbackFolderType\'\" class=\"md-icon-button\" aria-label=\"Odpowiedz..\" \ntranslate translate-attr-aria-label=\"MAIL.DETAILS.HEADER.ANSWER\" ng-click=\"vm.replyDialog($event)\"><img class=\"icon\" \nsrc=\"assets/icons/orderbox/respond.svg\"><md-tooltip><span translate=\"MAIL.DETAILS.HEADER.ANSWER\">Odpowiedz</span>\n</md-tooltip></md-button><md-button \nng-if=\"!vm.OrderboxGlue.currentService.supervised && vm.OrderboxGlue.currentFilter.type!==\'callbackFolderType\'\" \nclass=\"md-icon-button\" aria-label=\"Przekieruj..\" translate translate-attr-aria-label=\"MAIL.DETAILS.HEADER.ANSWER\" \nng-click=\"vm.redirectToConsultant($event)\"><img class=\"icon\" src=\"assets/icons/orderbox/redirect_to_user.svg\">\n<md-tooltip><span translate=\"MAIL.DETAILS.HEADER.REDIRECTTOCONSULTANT\">Przekieruj</span></md-tooltip></md-button></div>\n</div></div><div class=\"service\" ng-if=\"vm.data.serviceInfo.serviceId\" ng-class=\"vm.data.serviceInfo.color\"></div>\n</div>");
$templateCache.put("app/main/contactcenter/reports/components/callback/callbackagregation/callbackagregation.html","<div id=\"simple-table\" class=\"page-layout carded fullwidth doc-page element-doc-page callbackReportList\"><p \nclass=\"breadcrambs_text\">Callback - agregacje</p><table class=\"reportsList\"><thead class=\"reportsList__thead\" \nstyle=\"background-color: #dcdcdc; top:0\"><tr ng-if=\"!vm.emptyResponse\"><th class=\"reportsList__thead__col\" \nng-click=\"vm.sortBy(\'id\')\" \nng-if=\"vm.SessionManager.getUserRoleId() === vm.authRolesConst.manager || vm.SessionManager.getUserRoleId() === vm.authRolesConst.admin\" \nstyle=\"color: #595959\">ID <span class=\"sortorder\" ng-show=\"vm.propertyName === \'id\'\" ng-class=\"{reverse:vm.reverse}\">\n</span></th><th ng-repeat=\"mc in vm.uniqMinutesColumn track by $index\" class=\"reportsList__thead__col\" \nstyle=\"color: #595959\">{{ mc.minutes }}min</th></tr></thead></table><callback-agregation-list \ncallback-agregation-list=\"vm.callbackAgregationList\" minutes-column=\"vm.minutesColumn\" class=\"callbackAgregationList\" \nms-scroll \nstyle=\"width: 100%;\r\n          height: 100vh;\r\n          display: block;\r\n          position: absolute;\r\n          top: 0;\r\n          left:0;\r\n          padding-top:106px\">\n</callback-agregation-list><div class=\"noData\" ng-if=\"vm.callbackAgregationListLength === 2\"><div class=\"noData__icon\">\n<img src=\"assets/icons/database.svg\" alt=\"\"><p>brak danych</p></div></div></div>");
$templateCache.put("app/main/contactcenter/reports/components/callback/callbacklist/callbacklist.html","<div ng-if=\"!vm.loading\" class=\"chartForReports\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"pt-8\"><md-button class=\"ph-16 aggregationButtons\" ng-repeat=\"type in vm.dateType\" \nng-click=\"vm.changeAgrType(type)\" ng-disabled=\"vm.currentAgrType.key == type.key\">{{type.text}}</md-button></div><div \nclass=\"pt-8\"><md-button ng-if=\"vm.SessionManager.getUserRoleId() !== vm.authRolesConst.consultant\" \nng-click=\"vm.downloadXLSX()\"><p class=\"text\">Exportuj</p></md-button></div></div><div class=\"wrapperChart pl-8 pr-8\">\n<div class=\"chart\"><nvd3 class=\"h-250 remove-x-lines\" id=\"showcase-fixedcolumns\" config=\"vm.mainChart.config\" \noptions=\"vm.mainChart.options\" data=\"vm.mainChart.data\"></nvd3></div></div></div><div><md-list class=\"report-table\">\n<md-list-item class=\"table-header md-2-line\"><div class=\"md-list-item-text\" layout=\"row\" \nlayout-align=\"space-between center\"><span flex=\"5\">Id</span> <span flex=\"20\">\n{{ \"REPORTS.CALLBACK.ORDER_GUID\" | translate }}</span> <span flex=\"5\">CC Id</span> <span flex=\"15\">\n{{ \"REPORTS.CALLBACK.BUYER\" | translate }}</span> <span flex=\"20\">{{ \"REPORTS.CALLBACK.BUYERMAIL\" | translate }}</span>\n <span flex=\"10\">{{ \"REPORTS.CALLBACK.MSISDN\" | translate }}</span> <span flex=\"5\">\n{{ \"REPORTS.CALLBACK.MINUTES\" | translate }}</span> <span flex=\"15\">{{ \"REPORTS.CALLBACK.MINUTESLEFT\" | translate }}\n</span> <span flex=\"5\">{{ \"REPORTS.CALLBACK.FORWARDS_NUMBER\" | translate }}</span></div></md-list-item><div \nclass=\"table-body\" ms-scroll><md-list-item class=\"md-2-line\" ng-repeat-start=\"callbackOrder in vm.callbackOrdersList\">\n<div ng-click=\"vm.showCallbackOrderDetails($index, callbackOrder.guid)\" class=\"md-list-item-text\" layout=\"row\" \nlayout-align=\"space-between center\"><span flex=\"5\">{{callbackOrder.id}}</span> <span flex=\"20\">{{callbackOrder.guid}}\n</span> <span flex=\"5\">{{callbackOrder.callCenterID}}</span> <span flex=\"15\">\n{{callbackOrder.buyerName + \" \" + callbackOrder.buyerSurename}}</span> <span flex=\"20\">{{callbackOrder.buyerEmail}}\n</span> <span flex=\"10\">{{callbackOrder.buyerMsisdn}}</span> <span flex=\"5\">{{callbackOrder.minutes}} min</span><span \nflex=\"15\"><span>{{callbackOrder.minutes - vm.minutesLeft(callbackOrder.minutesleft)}} / {{ callbackOrder.minutes }} min\n</span><div class=\"border\" style=\"overflow: hidden\" \nng-style=\"{\'border-color\': (callbackOrder.minutes > 31) ? \'#ff5252\' : (callbackOrder.minutes > 11 && callbackOrder.minutes < 31) ? \'#311b92\' : (callbackOrder.minutes > 5 && callbackOrder.minutes < 11) ? \'#0277bd\' : \'#4caf50\' }\">\n<span class=\"inside\" \nng-style=\"{\'width\': ((callbackOrder.minutes - vm.minutesLeft(callbackOrder.minutesleft)) / callbackOrder.minutes)*100+\'%\',\n                                                  \'background-color\': (callbackOrder.minutes > 31) ? \'#ff5252\' :\n                                                  (callbackOrder.minutes > 10 && callbackOrder.minutes < 31) ? \'#311b92\' :\n                                                  (callbackOrder.minutes > 5 && callbackOrder.minutes < 11) ? \'#0277bd\' : \'#4caf50\'}\">\n</span></div></span><span flex=\"5\">{{callbackOrder.countDetails}}</span></div></md-list-item><div ng-repeat-end \nng-if=\"vm.callbackOrderDetails\" class=\"forwardInfo\" \nng-class=\"{\'forwardInfo--showForward\': $index == vm.selectedCallback}\"><div class=\"forwardInfo__head\"><p \nclass=\"forwardInfo__head__col\"><strong>{{ \"REPORTS.CALLBACK.FORWARDS\" | translate }}</strong></p><p \nclass=\"forwardInfo__head__col\"><strong>{{ \"REPORTS.CALLBACK.ANSWERED\" | translate }}</strong></p><p \nclass=\"forwardInfo__head__col\"><strong>{{ \"REPORTS.CALLBACK.ANUMBER\" | translate }}</strong></p><p \nclass=\"forwardInfo__head__col\"><strong>{{ \"REPORTS.CALLBACK.BNUMBER\" | translate }}</strong></p><p \nclass=\"forwardInfo__head__col\"><strong>{{ \"REPORTS.CALLBACK.DURATION\" | translate }}</strong></p><p \nclass=\"forwardInfo__head__col\"><strong>{{\"REPORTS.CALLBACK.DISCONNECTED\" | translate }}</strong></p><p \nclass=\"forwardInfo__head__col\"><strong>{{\"REPORTS.CALLBACK.SERVICE_ID\" | translate }}</strong></p><p \nclass=\"forwardInfo__head__col\"><strong>{{ \"REPORTS.CALLBACK.LISTENING\" | translate }}</strong></p></div><div \nng-repeat=\"detail in vm.callbackOrderDetails\" class=\"forwardInfo__body\"><p><img src=\"{{detail.photoUrl}}\" alt=\"\"> <span\n ng-if=\"!detail.consultantFirstName\" style=\"color: #aaa\">brak danych</span><span ng-if=\"detail.consultantFirstName\">\n{{ detail.consultantID }} {{ detail.consultantFirstName + \" \" + detail.consultantLastName }} / {{detail.alias}}</span>\n</p><p>{{ detail.answered | date:\'yyyy-MM-dd HH:mm:ss\' }}</p><p>{{ detail.a_Number }}</p><p>{{ detail.b_Number }}</p>\n<p>{{ detail.duration ? detail.duration : \'00:00 \' | date: \'mm:ss\' }}</p><p>\n{{ detail.disconnected | date:\'yyyy-MM-dd HH:mm:ss\' }}</p><p>{{ detail.serviceID }}</p><p \nng-if=\"!detail.duration || !detail.recordPath\"><span class=\"play play--noRec\"><img \nsrc=\"assets/icons/reports/close-button.svg\" alt=\"\"></span></p><p ng-click=\"vm.playRecording(detail)\" \nstyle=\"text-align:center\" ng-if=\"detail.duration && detail.recordPath\"><span class=\"play\"><img \nng-if=\"vm.currentPlaying.guid != detail.guid || !vm.currentPlaying\" src=\"assets/icons/reports/play-button.svg\"> <img \nng-if=\"vm.currentPlaying.guid == detail.guid && vm.currentPlaying.isPlaying == true\" \nsrc=\"assets/icons/reports/pause-round-button.svg\"><md-tooltip md-direction=\"bottom\">play/pause</md-tooltip></span></p>\n</div></div></div><div ng-if=\"vm.reportPages && vm.reportPages.length>1\" class=\"paginator mt-5\" \nng-class=\"{\'report-sticky\': vm.summary.length >1 }\" layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"vm.setPage(0);\" ng-disabled=\"vm.pageNumber == 0\">{{ \"REPORTS.PAGER.FIRST\" | translate }}</md-button>\n<md-button ng-click=\"vm.setPage(vm.pageNumber - 1);\" ng-disabled=\"vm.pageNumber == 0\">\n{{ \"REPORTS.PAGER.PREVIOUS\" | translate }}</md-button><md-button \nng-if=\"page >= vm.pageNumber -1 && page <= vm.pageNumber +1\" ng-class=\"{\'current\': vm.pageNumber == page }\" \nng-repeat=\"page in vm.reportPages\" ng-click=\"vm.setPage(page);\" ng-disabled=\"vm.pageNumber == page\">{{page + 1}}\n</md-button><md-button ng-click=\"vm.setPage(vm.pageNumber + 1);\" \nng-disabled=\"vm.pageNumber == vm.reportPages[vm.reportPages.length-1]\">{{ \"REPORTS.PAGER.NEXT\" | translate }}\n</md-button><md-button ng-click=\"vm.setPage(vm.reportPages[vm.reportPages.length-1]);\" \nng-disabled=\"vm.pageNumber == vm.reportPages[vm.reportPages.length-1]\">{{ \"REPORTS.PAGER.LAST\" | translate }}\n</md-button></div></md-list></div><div class=\"noData\" ng-if=\"vm.callbackOrdersList.length === 0\"><div \nclass=\"noData__icon\"><img src=\"assets/icons/database.svg\" alt=\"\"><p>brak danych</p></div></div>");
$templateCache.put("app/main/contactcenter/reports/components/consultantChannelsActivity/activityAudit/activityAudit.html","<div class=\"report-container\"><md-list class=\"report-table\"><md-list-item class=\"table-header md-2-line\"><div \nclass=\"md-list-item-text\" layout=\"row\" layout-align=\"space-between center\"><span flex=\"20\" layout=\"row\" \nlayout-align=\"start center\"><span flex=\"15\"></span> <span flex=\"10\">ID</span> <span flex=\"75\">Imię Nazwisko/Alias\n</span> </span><span flex=\"5\">Data aktywacji</span> <span flex=\"5\">Data dezaktywacji</span> <span flex=\"5\">\nCzas zalogowania</span> <span flex=\"5\">Czas wylogowania</span> <span flex=\"3\">Aktywność procentowa</span> <span \nflex=\"3\">Aktywność proc. zespołu</span> <span flex=\"5\">Aktywność godzinowa</span> <span flex=\"5\">\nAktywność godz. zespołu</span> <span flex=\"5\">Start ost. przerwy</span> <span flex=\"5\">Stop ost. przerwy</span> <span \nflex=\"5\">Zamknięcie sesji</span> <span flex=\"5\">Suma przerw w min</span></div></md-list-item><div class=\"table-body\" \nms-scroll><md-list-item class=\"md-2-line\" ng-repeat=\"consultant in vm.activeDaily\"><div class=\"md-list-item-text\" \nlayout=\"row\" layout-align=\"space-between center\"><span flex=\"20\" layout=\"row\" layout-align=\"start center\"><div \nflex=\"15\"><img ng-src=\"{{vm.consultantList[consultant.consultantID].photoUrl}}\" \nsrc=\"assets/icons/communicator/user_avatar.svg\" class=\"md-avatar\"></div><span flex=\"10\">{{consultant.consultantID}}\n</span> <span flex=\"75\">\n{{vm.consultantList[consultant.consultantID].firstName}} {{vm.consultantList[consultant.consultantID].lastName}} {{ vm.consultantList[consultant.consultantID].alias ? \'/\'+ vm.consultantList[consultant.consultantID].alias :\'\'}}\n</span> </span><span flex=\"5\">{{consultant.start | date:\'yyyy-MM-dd HH:mm\'}}</span> <span flex=\"5\">\n{{consultant.stop | date:\'yyyy-MM-dd HH:mm\'}}</span> <span flex=\"5\">\n{{consultant.zalogowanie | date:\'yyyy-MM-dd HH:mm\'}}</span> <span flex=\"5\">\n{{consultant.wylogowanie | date:\'yyyy-MM-dd HH:mm\'}}</span> <span flex=\"5\">{{consultant.aktywnoscPrc}}%</span> <span \nflex=\"3\">{{consultant.aktywnoscPrcZ}}%</span> <span flex=\"3\">{{consultant.aktywnoscGodz}}</span> <span flex=\"5\">\n{{consultant.aktywnoscGodzZ}}</span> <span flex=\"5\">{{consultant.startOstatniejPrzerwy | date:\'yyyy-MM-dd HH:mm\'}}\n</span> <span flex=\"5\">{{consultant.stopOstatniejPrzerwy | date:\'yyyy-MM-dd HH:mm\'}}</span> <span flex=\"5\">\n{{consultant.zamkniecieSesji}}</span> <span flex=\"5\">{{consultant.sumaPRzerwMIN}} min</span></div></md-list-item></div>\n</md-list></div>");
$templateCache.put("app/main/contactcenter/reports/components/reportsessions/aggregation/sessionAggregation.html","<div class=\"report-container\"><div class=\"chartForReports\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"pt-8\"></div><div class=\"pt-8\"><md-button \nng-if=\"vm.SessionManager.getUserRoleId() !== vm.authRolesConst.consultant\" ng-click=\"vm.downloadXLSX()\"><p \nclass=\"text\">Exportuj</p></md-button></div></div><div class=\"wrapperChart\"><div class=\"chart\"><nvd3 \nclass=\"h-250 remove-x-lines\" id=\"showcase-fixedcolumns\" config=\"vm.mainChart.config\" options=\"vm.mainChart.options\" \ndata=\"vm.mainChart.data\"></nvd3></div></div></div><md-list class=\"report-table\"><md-list-item \nclass=\"table-header md-2-line\"><div class=\"md-list-item-text\" layout=\"row\" layout-align=\"space-between center\"><span \nflex=\"5\">Id</span> <span flex=\"10\">Kontakt</span> <span flex=\"5\">firstName</span> <span flex=\"10\">lastName</span> <span\n flex=\"10\" ng-if=\"vm.tagsColumn\">tags </span><span flex=\"10\">Wszystkie</span> <span flex=\"10\">Zak. klient</span> <span \nflex=\"10\">Zak. Konsultant</span></div></md-list-item><div class=\"table-body\" ms-scroll \nng-if=\"!vm.loading && (vm.report && vm.report.length > 0)\"><md-list-item class=\"md-2-line md-no-proxy\" \nng-repeat=\"message in vm.report\"><div class=\"md-list-item-text\" layout=\"row\" layout-align=\"space-between center\"><span \nflex=\"5\">{{message.consultantID}}</span><span flex=\"10\">{{message.login}}</span> <span flex=\"5\">{{message.firstName}}\n</span> <span flex=\"10\">{{message.lastName}}</span> <span flex=\"10\" ng-if=\"vm.tagsColumn\"><ta-multiselect \nng-if=\"message.tag\" flex custom-class=\"small white\" ng-disabled=\"true\" write-mode=\"false\" ng-model=\"message.tag\">\n</ta-multiselect></span><span flex=\"10\">{{message.countAll}}</span> <span flex=\"10\">{{message.endedByClient}}</span> \n<span flex=\"10\">{{message.endedByConsultant}}</span></div></md-list-item></div><div ng-if=\"vm.summary\" \nclass=\"report-summary\" ng-class=\"{\'report-sticky\': vm.summary.length >1 }\"><md-divider></md-divider><md-list-item \nclass=\"md-2-line md-no-proxy\" ng-repeat=\"summary in vm.summary\"><div class=\"md-list-item-text\" layout=\"row\" \nlayout-align=\"space-between center\"><span flex=\"5\"></span> <span flex=\"10\">Podsumowanie</span> <span flex=\"5\"></span> \n<span flex=\"10\"></span> <span flex=\"10\">{{summary.countAll }}</span> <span flex=\"10\">{{summary.endedByClient}}</span> \n<span flex=\"10\">{{summary.endedByConsultant}}</span></div></md-list-item><md-divider></md-divider></div><div \nng-if=\"vm.summaryPerTags\" class=\"report-summary\" ng-class=\"{\'report-sticky\': vm.summaryPerTags.length >1 }\">\n<md-divider></md-divider><md-list-item class=\"md-2-line md-no-proxy\" ng-repeat=\"summary in vm.summaryPerTags\"><div \nclass=\"md-list-item-text\" layout=\"row\" layout-align=\"space-between center\"><span flex=\"5\"></span> <span flex=\"10\"><p>\nPodsumowanie {{vm.tagsColumn ? \'po tagu\': \'\'}}</p></span><span flex=\"5\"></span> <span flex=\"10\"></span> <span \nng-if=\"vm.tagsColumn\" flex=\"10\"><ta-multiselect flex ng-if=\"summary.tag\" custom-class=\"small white\" ng-disabled=\"true\" \nwrite-mode=\"false\" ng-model=\"summary.tag\"></ta-multiselect></span><span \nng-if=\"vm.SessionManager.getUserRoleId() == vm.authRolesConst.admin\" flex=\"10\">{{summary.callCenterID}}</span> <span \nflex=\"10\">{{summary.countAll }}</span> <span flex=\"10\">{{summary.endedByClient}}</span> <span flex=\"10\">\n{{summary.endedByConsultant}}</span></div></md-list-item><md-divider></md-divider></div><div \nng-if=\"vm.reportPages && vm.reportPages.length>1\" class=\"paginator mt-5\" \nng-class=\"{\'report-sticky\': vm.summary.length >1 }\" layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"vm.setPage(0);\" ng-disabled=\"vm.pageNumber == 0\">{{ \"REPORTS.PAGER.FIRST\" | translate }}</md-button>\n<md-button ng-click=\"vm.setPage(vm.pageNumber - 1);\" ng-disabled=\"vm.pageNumber == 0\">\n{{ \"REPORTS.PAGER.PREVIOUS\" | translate }}</md-button>{{ vm.reportPages[vm.pageNumber - 1] > 0 ? \'...\':\'\'}}<md-button \nng-if=\"page >= vm.pageNumber -1 && page <= vm.pageNumber +1\" ng-class=\"{\'current\': vm.pageNumber == page }\" \nng-repeat=\"page in vm.reportPages\" ng-click=\"vm.setPage(page);\" ng-disabled=\"vm.pageNumber == page\">{{page + 1}}\n</md-button>{{vm.reportPages.length > vm.pageNumber + 2 ? \'...\':\'\'}}<md-button \nng-click=\"vm.setPage(vm.pageNumber + 1);\" ng-disabled=\"vm.pageNumber == vm.reportPages[vm.reportPages.length-1]\">\n{{ \"REPORTS.PAGER.NEXT\" | translate }}</md-button><md-button \nng-click=\"vm.setPage(vm.reportPages[vm.reportPages.length-1]);\" \nng-disabled=\"vm.pageNumber == vm.reportPages[vm.reportPages.length-1]\">{{ \"REPORTS.PAGER.LAST\" | translate }}\n</md-button></div></md-list></div><div class=\"noData\" ng-if=\"!vm.loading && (!vm.report && vm.report.length === 0)\">\n<div class=\"noData__icon\"><img src=\"assets/icons/database.svg\" alt=\"\"><p>brak danych</p></div></div>\n<md-progress-circular class=\"md-accent progressCircual\" md-diameter=\"100\" md-mode=\"indeterminate\" ng-if=\"vm.loading\">\n</md-progress-circular>");
$templateCache.put("app/main/contactcenter/reports/components/reportsessions/transcription/transcription.html","<div id=\"reportsSession\" class=\"reportsSession\"><div ng-click=\"vm.closeDialog()\" class=\"closeSessionDialog\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s24\"></md-icon></div><div class=\"reportsSession__header\"><p>session ID: <strong>\n{{ vm.sessionID }}</strong></p><ul style=\"display: flex\"><li ng-click=\"vm.showInfo()\" \nng-class=\"{active: vm.sessionInfo}\"><img src=\"assets/icons/info.svg\" alt=\"\"></li><li ng-click=\"vm.showTextarea()\" \nng-class=\"{active: vm.showWarrning}\"><img src=\"assets/icons/worker.svg\" alt=\"\"></li><li \nng-click=\"vm.toggleViewsTags()\" ng-class=\"{active: vm.showTags}\"><img src=\"assets/icons/hash_icon.svg\" alt=\"\" \nstyle=\"width: 40%\"></li><li ng-click=\"vm.printTranscription()\" ng-if=\"vm.reportsSessionArray.length > 0\"><img \nsrc=\"assets/icons/printer.svg\" alt=\"\"></li></ul></div><md-content ng-if=\"vm.showWarrning\"><div><form \nclass=\"formWarring\"><md-input-container class=\"md-block\"><label>Uwagi</label><textarea ng-model=\"vm.messageWarring\" \nrows=\"1\" md-select-on-focus></textarea><md-button class=\"sendToMagaresButton\" type=\"submit\" \nng-click=\"vm.sendMessage();\"><img src=\"assets/icons/communicator/send_msg.svg?\" alt=\"\"></md-button>\n</md-input-container></form></div></md-content><md-content ng-if=\"vm.sessionInfo\" class=\"sessionInfoContent\"><div \nng-repeat=\"(key, value) in vm.sessionDetails.session\" style=\"line-height: .6\"><p>{{key}}: <strong>\n{{ vm.sessionDetails.session[key] }}</strong></p></div><div \nng-if=\"vm.sessionDetails.categories&&vm.sessionDetails.categories.length>0\">Kategoryzacja</div><div \nng-repeat=\"item in vm.sessionDetails.categories\" style=\"line-height: .6\"><p>{{ item }}</p></div></md-content>\n<md-content ng-if=\"vm.showTags\" style=\"padding: 20px\"><ta-tags flex custom-class=\"medium black\" write-mode=\"true\" \nng-model=\"vm.msgTags\" force-reload=\"vm.forceReloadTags\" label=\"Wpisz tagi dla sesji\" \nsource-endpoint=\"\'getServiceTagsAll\'\" content-id=\"vm.reportsSessionArray[0].serviceId\" show-button=\"true\" \nfunction-autosave=\"vm.autoSaveTags\"></ta-tags></md-content><ul style=\"overflow: hidden; width: 100%;padding: 40px\" \nid=\"transcriptionSession\" ng-if=\"vm.reportsSessionArray.length > 0\"><li ng-repeat=\"t in vm.reportsSessionArray\" \nng-class=\"{ \'o\': t.direction == \'O\', \'a\': t.type ===\'A\' }\"><p class=\"name\" ng-if=\"t.direction == \'I\'\" \nstyle=\"color: black\"><strong>{{ t.userName }}</strong></p><p class=\"name\" ng-if=\"t.direction == \'O\'\" \nstyle=\"color: green\"><strong>{{ t.consultantName }}</strong></p><p class=\"name guid\">ID: {{ t.id }} <span>\n{{ t.insertionTime | date: \'dd-MM-yyyy HH:mm:ss\' }}</span></p><div ng-if=\"t.attachmentUrls\" \nng-repeat=\"i in vm.attachmentUrls(t)\" style=\"width: 80px; display: inline-block; vertical-align: top; margin: 10px\">\n<img ng-src=\"{{ i }}\" alt=\"attachment\"></div><p class=\"body\"><strong>{{ t.body }}</strong></p></li></ul><h1 \nstyle=\"text-align: center; margin: 50px\" ng-if=\"vm.reportsSessionArray.length === 0\">Brak transkrypcji w sesji</h1>\n</div>");
$templateCache.put("app/main/contactcenter/reports/components/reportsessions/reportstags/reportstags.html","<div class=\"report-container\"><div class=\"pt-8\"><md-button \nng-if=\"vm.SessionManager.getUserRoleId() !== vm.authRolesConst.consultant\" ng-click=\"vm.downloadXLSX()\"><p \nclass=\"text\">Exportuj</p></md-button></div><md-list class=\"report-table\"><md-list-item class=\"table-header md-2-line\">\n<div class=\"md-list-item-text\" layout=\"row\" layout-align=\"space-between center\"><span flex layout=\"row\" \nlayout-align=\"start center\"><span flex=\"10\"></span> <span flex=\"10\">ID</span> <span flex=\"30\">Imię Nazwisko/Alis</span>\n <span flex=\"20\">Tag</span> <span flex=\"10\">Ilość</span> <span flex=\"10\">Zak. klient.</span> <span flex=\"10\">\nZak. Konsult.</span> </span><span ng-if=\"	vm.SessionManager.getUserRoleId() == vm.authRolesConst.admin\" flex=\"5\">CC ID\n</span></div></md-list-item><div class=\"table-body\" ms-scroll><md-list-item class=\"md-2-line\" \nng-repeat=\"tag in vm.reports\"><div class=\"md-list-item-text\" layout=\"row\" layout-align=\"space-between center\"><span \nflex layout=\"row\" layout-align=\"start center\"><div flex=\"10\"><img ng-src=\"{{tag.photoUrl}}\" \nsrc=\"assets/icons/communicator/user_avatar.svg\" class=\"md-avatar\"></div><span flex=\"10\">{{tag.consultantID}}</span> \n<span flex=\"30\">{{tag.firstName}} {{ tag.lastName }} {{ tag.alias ? \'/\'+ tag.alias :\'\'}}</span> <span flex=\"20\">\n<ta-multiselect ng-if=\"tag.tag\" flex custom-class=\"small white\" ng-disabled=\"true\" write-mode=\"false\" \nng-model=\"tag.tag\"></ta-multiselect></span><span flex=\"10\">{{tag.countAll}}</span> <span flex=\"10\">\n{{tag.endedByClient}}</span> <span flex=\"10\">{{tag.endedByConsultant}}</span></span></div></md-list-item></div><div \nng-if=\"vm.summary\" class=\"report-summary\" ng-class=\"{\'report-sticky\': vm.summary.length >1 }\"><md-divider></md-divider>\n<md-list-item class=\"md-2-line\" ng-repeat=\"summary in vm.summary\"><div class=\"md-list-item-text\" layout=\"row\" \nlayout-align=\"space-between center\"><span flex layout=\"row\" layout-align=\"start center\"><span flex=\"20\"></span> <span \nflex=\"50\"><p>Podsumowanie {{vm.tagsColumn ? \'po tagu\': \'\'}}</p></span><span flex=\"10\">{{summary.countAll }}</span> \n<span flex=\"10\">{{summary.endedByClient}}</span> <span flex=\"10\">{{summary.endedByConsultant}}</span></span></div>\n</md-list-item><md-divider></md-divider></div><div ng-if=\"vm.summaryPerTags\" class=\"report-summary\" \nng-class=\"{\'report-sticky\': vm.summaryPerTags.length >1 }\"><md-divider></md-divider><md-list-item class=\"md-2-line\" \nng-repeat=\"summary in vm.summaryPerTags\"><div class=\"md-list-item-text\" layout=\"row\" \nlayout-align=\"space-between center\"><span flex layout=\"row\" layout-align=\"start center\"><span flex=\"20\"></span> <span \nflex=\"40\"><p>Podsumowanie {{vm.tagsColumn ? \'po tagu\': \'\'}}</p></span><span ng-if=\"vm.tagsColumn\" flex=\"20\">\n<ta-multiselect flex ng-if=\"summary.tag\" custom-class=\"small white\" ng-disabled=\"true\" write-mode=\"false\" \nng-model=\"summary.tag\"></ta-multiselect></span><span \nng-if=\"vm.SessionManager.getUserRoleId() == vm.authRolesConst.admin\" flex=\"10\">{{summary.callCenterID}}</span> <span \nflex=\"10\">{{summary.countAll }}</span> <span flex=\"10\">{{summary.endedByClient}}</span> <span flex=\"10\">\n{{summary.endedByConsultant}}</span></span></div></md-list-item><md-divider></md-divider></div><div \nng-if=\"vm.reportPages && vm.reportPages.length>1\" class=\"paginator mt-5\" \nng-class=\"{\'report-sticky\': vm.summary.length >1 }\" layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"vm.setPage(0);\" ng-disabled=\"vm.pageNumber == 0\">{{ \"REPORTS.PAGER.FIRST\" | translate }}</md-button>\n<md-button ng-click=\"vm.setPage(vm.pageNumber - 1);\" ng-disabled=\"vm.pageNumber == 0\">\n{{ \"REPORTS.PAGER.PREVIOUS\" | translate }}</md-button>{{ vm.reportPages[vm.pageNumber - 1] > 0 ? \'...\':\'\'}}<md-button \nng-if=\"page >= vm.pageNumber -1 && page <= vm.pageNumber +1\" ng-class=\"{\'current\': vm.pageNumber == page }\" \nng-repeat=\"page in vm.reportPages\" ng-click=\"vm.setPage(page);\" ng-disabled=\"vm.pageNumber == page\">{{page + 1}}\n</md-button>{{vm.reportPages.length > vm.pageNumber + 2 ? \'...\':\'\'}}<md-button \nng-click=\"vm.setPage(vm.pageNumber + 1);\" ng-disabled=\"vm.pageNumber == vm.reportPages[vm.reportPages.length-1]\">\n{{ \"REPORTS.PAGER.NEXT\" | translate }}</md-button><md-button \nng-click=\"vm.setPage(vm.reportPages[vm.reportPages.length-1]);\" \nng-disabled=\"vm.pageNumber == vm.reportPages[vm.reportPages.length-1]\">{{ \"REPORTS.PAGER.LAST\" | translate }}\n</md-button></div></md-list><div class=\"noData\" ng-if=\"vm.report && vm.report.length === 0\"><div class=\"noData__icon\">\n<img src=\"assets/icons/database.svg\" alt=\"\"><p>brak danych</p></div></div></div>");
$templateCache.put("app/main/contactcenter/reports/components/reportstatscalls/perconsultant/perconsultant.html","<div class=\"report-container\"><div class=\"chartForReports\"><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"button-row\"><div class=\"pt-8\"><md-button class=\"ph-16 aggregationButtons md-raised\" \nng-click=\"vm.changeChart(\'avgSeconds\')\" ng-disabled=\"vm.chartProp == \'avgSeconds\'\">Średnia</md-button><md-button \nclass=\"ph-16 aggregationButtons md-raised\" ng-click=\"vm.changeChart(\'seconds\')\" \nng-disabled=\"vm.chartProp == \'seconds\'\">Minuty</md-button><md-button class=\"ph-16 aggregationButtons md-raised\" \nng-click=\"vm.changeChart(\'count\')\" ng-disabled=\"vm.chartProp == \'count\'\">Ilość</md-button></div><md-button \nclass=\"aggregationButtons md-raised\" ng-if=\"vm.SessionManager.getUserRoleId() !== vm.authRolesConst.consultant\" \nng-click=\"vm.downloadXLSX()\"><p class=\"text\">Exportuj</p></md-button></div><div class=\"wrapperChart\"><div \nclass=\"chart\"><nvd3 class=\"remove-x-lines\" id=\"showcase-fixed columns\" config=\"vm.mainChart.config\" \noptions=\"vm.mainChart.options\" data=\"vm.mainChart.data\"></nvd3></div></div></div><md-list class=\"report-table\">\n<md-list-item class=\"table-header md-2-line\"><div class=\"md-list-item-text\" layout=\"row\" \nlayout-align=\"space-between center\"><span flex=\"35\" layout=\"row\" layout-align=\"start center\"><span flex=\"10\"></span> \n<span flex=\"20\">ID</span> <span flex=\"40\">Imię Nazwisko/Alias</span> <span ng-if=\"vm.tagsColumn\" flex=\"20\">Tag</span> \n</span><span ng-if=\"vm.SessionManager.getUserRoleId() == vm.authRolesConst.admin\" flex=\"5\">CC ID</span> <span flex=\"5\">\nIlość</span> <span flex=\"5\">Średnia</span> <span flex=\"10\">Minuty</span> <span flex=\"5\">>120s </span><span flex=\"5\">\n30s-120s </span><span flex=\"5\">15s-30s </span><span flex=\"5\">>15s</span></div></md-list-item><div class=\"table-body\" \nms-scroll><md-list-item class=\"md-2-line\" ng-repeat=\"consultant in vm.report\"><div class=\"md-list-item-text\" \nlayout=\"row\" layout-align=\"space-between center\"><span flex=\"35\" layout=\"row\" layout-align=\"start center\"><div \nflex=\"10\"><img ng-src=\"{{consultant.photoUrl}}\" src=\"assets/icons/communicator/user_avatar.svg\" class=\"md-avatar\">\n</div><span flex=\"20\">{{consultant.consultantID}}</span> <span flex=\"40\">\n{{consultant.consultantName}} {{ consultant.alias ? \'/\'+ consultant.alias :\'\'}}</span> <span ng-if=\"vm.tagsColumn\" \nflex=\"20\"><ta-multiselect flex ng-if=\"consultant.tag\" custom-class=\"small white\" ng-disabled=\"true\" write-mode=\"false\" \nng-model=\"consultant.tag\"></ta-multiselect></span></span><span \nng-if=\"vm.SessionManager.getUserRoleId() == vm.authRolesConst.admin\" flex=\"5\">{{consultant.callCenterID}}</span> <span \nflex=\"5\">{{consultant.count}}</span> <span flex=\"5\">{{consultant.avgminutes}}</span> <span flex=\"10\">\n{{consultant.minutes}}</span> <span flex=\"5\" style=\"color:green\">{{consultant.c_2min}}</span> <span flex=\"5\" \nstyle=\"color:lightgreen\">{{consultant.c_30_120}}</span> <span flex=\"5\" style=\"color:orange\">{{consultant.c_7_30}}\n</span> <span flex=\"5\" style=\"color:red\">{{consultant.c_7s}}</span></div></md-list-item></div><div ng-if=\"vm.summary\" \nclass=\"report-summary\" ng-class=\"{\'report-sticky\': vm.summary.length >1 }\"><md-divider></md-divider><md-list-item \nclass=\"md-2-line\" ng-repeat=\"summary in vm.summary\"><div class=\"md-list-item-text\" layout=\"row\" \nlayout-align=\"space-between center\"><span flex=\"35\" layout=\"row\" layout-align=\"start center\"><span flex=\"30\"></span> \n<span flex=\"40\"><p>Podsumowanie {{vm.tagsColumn ? \'po tagu\': \'\'}}</p></span><span ng-if=\"vm.tagsColumn\" flex=\"20\">\n<ta-multiselect flex ng-if=\"summary.tag\" custom-class=\"small white\" ng-disabled=\"true\" write-mode=\"false\" \nng-model=\"summary.tag\"></ta-multiselect></span></span><span \nng-if=\"vm.SessionManager.getUserRoleId() == vm.authRolesConst.admin\" flex=\"5\">{{summary.callCenterID}}</span> <span \nflex=\"5\">{{summary.count}}</span> <span flex=\"5\">{{summary.avgminutes}}</span> <span flex=\"10\">{{summary.minutes}}\n</span> <span flex=\"5\" style=\"color:green\">{{summary.c_2min}}</span> <span flex=\"5\" style=\"color:lightgreen\">\n{{summary.c_30_120}}</span> <span flex=\"5\" style=\"color:orange\">{{summary.c_7_30}}</span> <span flex=\"5\" \nstyle=\"color:red\">{{summary.c_7s}}</span></div></md-list-item><md-divider></md-divider></div><div \nng-if=\"vm.reportPages && vm.reportPages.length>1\" class=\"paginator mt-5\" \nng-class=\"{\'report-sticky\': vm.summary.length >1 }\" layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"vm.setPage(0);\" ng-disabled=\"vm.pageNumber == 0\">{{ \"REPORTS.PAGER.FIRST\" | translate }}</md-button>\n<md-button ng-click=\"vm.setPage(vm.pageNumber - 1);\" ng-disabled=\"vm.pageNumber == 0\">\n{{ \"REPORTS.PAGER.PREVIOUS\" | translate }}</md-button>{{ vm.reportPages[vm.pageNumber - 1] > 0 ? \'...\':\'\'}}<md-button \nng-if=\"page >= vm.pageNumber -1 && page <= vm.pageNumber +1\" ng-class=\"{\'current\': vm.pageNumber == page }\" \nng-repeat=\"page in vm.reportPages\" ng-click=\"vm.setPage(page);\" ng-disabled=\"vm.pageNumber == page\">{{page + 1}}\n</md-button>{{vm.reportPages.length > vm.pageNumber + 2 ? \'...\':\'\'}}<md-button \nng-click=\"vm.setPage(vm.pageNumber + 1);\" ng-disabled=\"vm.pageNumber == vm.reportPages[vm.reportPages.length-1]\">\n{{ \"REPORTS.PAGER.NEXT\" | translate }}</md-button><md-button \nng-click=\"vm.setPage(vm.reportPages[vm.reportPages.length-1]);\" \nng-disabled=\"vm.pageNumber == vm.reportPages[vm.reportPages.length-1]\">{{ \"REPORTS.PAGER.LAST\" | translate }}\n</md-button></div></md-list><div class=\"noData\" ng-if=\"vm.report && vm.report.length === 0\"><div class=\"noData__icon\">\n<img src=\"assets/icons/database.svg\" alt=\"\"><p>brak danych</p></div></div></div>");
$templateCache.put("app/main/contactcenter/reports/components/reportstatscalls/percontactcenter/percontactcenter.html","<div class=\"report-container\"><div class=\"chartForReports\"><div layout=\"row\" layout-align=\"end center\" \nclass=\"button-row\"><md-button class=\"aggregationButtons md-raised\" \nng-if=\"vm.SessionManager.getUserRoleId() !== vm.authRolesConst.consultant\" ng-click=\"vm.downloadXLSX()\"><p \nclass=\"text\">Exportuj</p></md-button></div><div class=\"wrapperChart\"><div class=\"chart\"><nvd3 class=\"remove-x-lines\" \nid=\"showcase-fixed columns\" config=\"vm.mainChart.config\" options=\"vm.mainChart.options\" data=\"vm.mainChart.data\">\n</nvd3></div></div></div><md-list class=\"report-table\"><md-list-item class=\"table-header md-2-line\"><div \nclass=\"md-list-item-text\" layout=\"row\" layout-align=\"space-between center\"><span flex=\"35\">Contact Center </span><span \nng-if=\"vm.tagsColumn\" flex=\"10\">Tag</span> <span flex=\"5\">Ilosć </span><span flex=\"5\">Średnia </span><span flex=\"5\">\nMinuty </span><span flex=\"5\">Moje </span><span flex=\"5\">Zlecone</span></div></md-list-item><div class=\"table-body\" \nms-scroll><md-list-item class=\"md-2-line\" ng-repeat=\"contactcenter in vm.report\"><div class=\"md-list-item-text\" \nlayout=\"row\" layout-align=\"space-between center\"><span flex=\"35\">{{contactcenter.contactcenter}} </span><span \nng-if=\"vm.tagsColumn\" flex=\"10\"><ta-multiselect flex ng-if=\"contactcenter.tag\" custom-class=\"small white\" \nng-disabled=\"true\" write-mode=\"false\" ng-model=\"contactcenter.tag\"></ta-multiselect></span><span flex=\"5\">\n{{contactcenter.quantity}} </span><span flex=\"5\">{{contactcenter.avgminutes}}</span> <span flex=\"5\">\n{{contactcenter.minutes}}</span> <span flex=\"5\">{{contactcenter.myminutes}} </span><span flex=\"5\">\n{{contactcenter.intminutes - contactcenter.myminutes}}</span></div></md-list-item></div><div ng-if=\"vm.summary\" \nclass=\"report-summary\" ng-class=\"{\'report-sticky\': vm.summary.length >1 }\"><md-divider></md-divider><md-list-item \nclass=\"md-2-line\" ng-repeat=\"summary in vm.summary\"><div class=\"md-list-item-text\" layout=\"row\" \nlayout-align=\"space-between center\"><span flex=\"35\"><p>Podsumowanie {{vm.tagsColumn ? \'po tagu\': \'\'}}</p></span><span \nng-if=\"vm.tagsColumn\" flex=\"10\"><ta-multiselect flex ng-if=\"summary.tag\" custom-class=\"small white\" ng-disabled=\"true\" \nwrite-mode=\"false\" ng-model=\"summary.tag\"></ta-multiselect></span><span flex=\"5\">{{summary.quantity}} </span><span \nflex=\"5\">{{summary.intavg}}</span> <span flex=\"5\">{{summary.intminutes}}</span> <span flex=\"5\">{{summary.myminutes}} \n</span><span flex=\"5\">{{summary.orderedminutes}}</span></div></md-list-item></div><md-divider></md-divider></md-list>\n</div><div class=\"noData\" ng-if=\"!vm.report ||vm.report === 0\"><div class=\"noData__icon\"><img \nsrc=\"assets/icons/database.svg\" alt=\"\"><p>brak danych</p></div></div>");
$templateCache.put("app/main/contactcenter/reports/components/reportstatscalls/perservice/perservice.html","<div class=\"report-container\"><div class=\"chartForReports\"><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"button-row\"><div ng-if=\"vm.SessionManager.getUserRoleId() != vm.authRolesConst.consultant\" class=\"pt-8\">\n<md-button class=\"ph-16 aggregationButtons md-raised\" ng-click=\"vm.changeChart(\'avgsecs\')\" \nng-disabled=\"vm.chartProp == \'avgsecs\'\">Średnia</md-button><md-button class=\"ph-16 aggregationButtons md-raised\" \nng-click=\"vm.changeChart(\'secs\')\" ng-disabled=\"vm.chartProp == \'secs\'\">Minuty</md-button><md-button \nclass=\"ph-16 aggregationButtons md-raised\" ng-click=\"vm.changeChart(\'quantity\')\" \nng-disabled=\"vm.chartProp == \'quantity\'\">Ilość</md-button></div><md-button class=\"aggregationButtons md-raised\" \nng-if=\"vm.SessionManager.getUserRoleId() !== vm.authRolesConst.consultant\" ng-click=\"vm.downloadXLSX()\"><p \nclass=\"text\">Exportuj</p></md-button></div><br><div class=\"wrapperChart\"><div class=\"chart\"><nvd3 \nclass=\"h-250 remove-x-lines\" width=\"100%\" id=\"showcase-fixed columns\" config=\"vm.mainChart.config\" \noptions=\"vm.mainChart.options\" data=\"vm.mainChart.data\"></nvd3></div></div></div><md-list class=\"report-table\">\n<md-list-item class=\"table-header md-2-line\"><div class=\"md-list-item-text\" layout=\"row\" \nlayout-align=\"space-between center\"><span flex=\"35\" layout=\"row\" layout-align=\"start center\"><span flex=\"20\">ID</span> \n<span ng-if=\"!vm.partnerColumn\" flex=\"40\">Nazwa serwisu</span> <span ng-if=\"vm.partnerColumn\" flex=\"40\">Partner</span> \n<span ng-if=\"vm.tagsColumn\" flex=\"20\">Tag</span> </span><span flex=\"5\">Ilość</span> <span flex=\"5\">Średnia</span> <span\n flex=\"10\">Minuty</span></div></md-list-item><div class=\"table-body\" ms-scroll><md-list-item class=\"md-2-line\" \nng-repeat=\"consultant in vm.report\"><div class=\"md-list-item-text\" layout=\"row\" layout-align=\"space-between center\">\n<span flex=\"35\" layout=\"row\" layout-align=\"start center\"><span flex=\"20\">{{consultant.id}}</span> <span \nng-if=\"!vm.partnerColumn\" flex=\"40\">{{consultant.serviceName}}</span> <span ng-if=\"vm.partnerColumn\" flex=\"40\">\n{{consultant.companyName}}</span> <span ng-if=\"vm.tagsColumn\" flex=\"20\"><ta-multiselect flex ng-if=\"consultant.tag\" \ncustom-class=\"small white\" ng-disabled=\"true\" write-mode=\"false\" ng-model=\"consultant.tag\"></ta-multiselect></span>\n</span><span flex=\"5\">{{consultant.quantity}}</span> <span flex=\"5\">{{consultant.avgminutes}}</span> <span flex=\"10\">\n{{consultant.minutes}}</span></div></md-list-item></div><div ng-if=\"vm.summary\" class=\"report-summary\" \nng-class=\"{\'report-sticky\': vm.summary.length >1 }\"><md-divider></md-divider><md-list-item class=\"md-2-line\" \nng-repeat=\"summary in vm.summary\"><div class=\"md-list-item-text\" layout=\"row\" layout-align=\"space-between center\"><span\n flex=\"35\" layout=\"row\" layout-align=\"start center\"><span flex=\"20\"></span> <span flex=\"40\"><p>\nPodsumowanie {{vm.tagsColumn ? \'po tagu\': \'\'}}</p></span><span ng-if=\"vm.tagsColumn\" flex=\"20\"><ta-multiselect flex \nng-if=\"summary.tag\" custom-class=\"small white\" ng-disabled=\"true\" write-mode=\"false\" ng-model=\"summary.tag\">\n</ta-multiselect></span></span><span flex=\"5\">{{summary.quantity}}</span> <span flex=\"5\">{{summary.avgminutes}}</span> \n<span flex=\"10\">{{summary.minutes}}</span></div></md-list-item><md-divider></md-divider></div><div \nng-if=\"vm.reportPages && vm.reportPages.length>1\" class=\"paginator mt-5\" \nng-class=\"{\'report-sticky\': vm.summary.length >1 }\" layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"vm.setPage(0);\" ng-disabled=\"vm.pageNumber == 0\">{{ \"REPORTS.PAGER.FIRST\" | translate }}</md-button>\n<md-button ng-click=\"vm.setPage(vm.pageNumber - 1);\" ng-disabled=\"vm.pageNumber == 0\">\n{{ \"REPORTS.PAGER.PREVIOUS\" | translate }}</md-button>{{ vm.reportPages[vm.pageNumber - 1] > 0 ? \'...\':\'\'}}<md-button \nng-if=\"page >= vm.pageNumber -1 && page <= vm.pageNumber +1\" ng-class=\"{\'current\': vm.pageNumber == page }\" \nng-repeat=\"page in vm.reportPages\" ng-click=\"vm.setPage(page);\" ng-disabled=\"vm.pageNumber == page\">{{page + 1}}\n</md-button>{{vm.reportPages.length > vm.pageNumber + 2 ? \'...\':\'\'}}<md-button \nng-click=\"vm.setPage(vm.pageNumber + 1);\" ng-disabled=\"vm.pageNumber == vm.reportPages[vm.reportPages.length-1]\">\n{{ \"REPORTS.PAGER.NEXT\" | translate }}</md-button><md-button \nng-click=\"vm.setPage(vm.reportPages[vm.reportPages.length-1]);\" \nng-disabled=\"vm.pageNumber == vm.reportPages[vm.reportPages.length-1]\">{{ \"REPORTS.PAGER.LAST\" | translate }}\n</md-button></div></md-list></div><div class=\"noData\" ng-if=\"vm.report && vm.report.length === 0\"><div \nclass=\"noData__icon\"><img src=\"assets/icons/database.svg\" alt=\"\"><p>brak danych</p></div></div>");
$templateCache.put("app/main/contactcenter/reports/components/reportstatssms/aggregation/aggregation.html","<div class=\"report-container\"><div class=\"chartForReports\"><div layout=\"row\" layout-align=\"end center\" \nclass=\"button-row\"><md-button class=\"aggregationButtons md-raised\" \nng-if=\"vm.SessionManager.getUserRoleId() !== vm.authRolesConst.consultant\" ng-click=\"vm.downloadXLSX()\"><p \nclass=\"text\">Exportuj</p></md-button></div><div class=\"wrapperChart\" flex=\"100\"><div class=\"chart\" flex=\"60\" \nstyle=\"border-right: 1px solid #e7e7e7\"><nvd3 class=\"h-400 pt-50 ph-20 remove-x-lines\" id=\"showcase-fixedcolumns\" \nconfig=\"vm.mainChart.config\" options=\"vm.mainChart.options\" data=\"vm.mainChart.data\"></nvd3></div><div class=\"chart\" \nflex=\"40\"><nvd3 class=\"h-400 pt-50 ph-20 remove-x-lines\" id=\"showcase-fixedcolumns\" config=\"vm.mainDonutChart.config\" \noptions=\"vm.mainDonutChart.options\" data=\"vm.mainDonutChart.data\"></nvd3></div></div></div><md-list \nclass=\"report-table\"><md-list-item class=\"table-header md-2-line\"><div class=\"md-list-item-text\" layout=\"row\" \nlayout-align=\"space-between center\"><span flex=\"35\" layout=\"row\" layout-align=\"start center\"><div flex=\"10\"></div><span\n flex=\"20\">Id</span> <span flex=\"40\">Konsultant</span> <span ng-if=\"vm.tagsColumn\" flex=\"20\">Tag</span> </span><span \nng-if=\"vm.SessionManager.getUserRoleId() === vm.authRolesConst.admin\" flex=\"5\">Contact Center </span><span flex=\"5\">\nData </span><span flex=\"5\">Typ wiadomości </span><span flex=\"5\">Ilość wiadomości</span></div></md-list-item><div \nclass=\"table-body\" ms-scroll><md-list-item class=\"md-2-line\" ng-repeat=\"consultant in vm.report\"><div \nclass=\"md-list-item-text\" layout=\"row\" layout-align=\"space-between center\"><span flex=\"35\" layout=\"row\" \nlayout-align=\"start center\"><div flex=\"10\"><img ng-src=\"{{consultant.photoUrl}}\" \nsrc=\"assets/icons/communicator/user_avatar.svg\" class=\"md-avatar\"></div><span flex=\"20\">{{consultant.consultantID}}\n</span> <span flex=\"40\">{{consultant.consultantName}} {{ consultant.alias ? \'/\'+ consultant.alias :\'\'}}</span> <span \nng-if=\"vm.tagsColumn\" flex=\"20\"><ta-multiselect flex ng-if=\"consultant.tag\" custom-class=\"small white\" \nng-disabled=\"true\" write-mode=\"false\" ng-model=\"consultant.tag\"></ta-multiselect></span></span><span \nng-if=\"vm.SessionManager.getUserRoleId() === vm.authRolesConst.admin\" flex=\"5\">{{ consultant.callCenterName }} </span>\n<span flex=\"5\">{{ consultant.date }} </span><span flex=\"5\">{{::vm.messageType(consultant.type)}}</span> <span flex=\"5\">\n{{ consultant.countMsg }}</span></div></md-list-item></div></md-list></div><div class=\"noData\" \nng-if=\"!vm.report ||vm.report === 0\"><div class=\"noData__icon\"><img src=\"assets/icons/database.svg\" alt=\"\"><p>\nbrak danych</p></div></div>");
$templateCache.put("app/main/contactcenter/components/issuetracker/components/bugzilla/issueDialog/bugzillaissuedialog.html","<md-dialog aria-label=\"%translate\" class=\"remove md-dialog-issue\"><md-toolbar class=\"remove__msg\"><div \nclass=\"md-toolbar-tools\"><h2 class=\"w-500\">%title</h2></div></md-toolbar><md-dialog-content class=\"scrollable\" \nms-scroll><div class=\"issueDialog\" ng-if=\"!vm.issueDialogParams.issueId\" \nng-include=\"\'app/main/contactcenter/components/issuetracker/components/bugzilla/issueDialog/createissue.html\'\"></div>\n<div class=\"issueDialog\" ng-if=\"vm.issueDialogParams.issueId\" \nng-include=\"\'app/main/contactcenter/components/issuetracker/components/bugzilla/issueDialog/editissue.html\'\"></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\" class=\"remove__buttons\">\n<md-button ng-click=\"vm.cancel()\" class=\"remove__buttons__no\" translate=\"%translate.NO\">%translate</md-button>\n<md-button ng-if=\"!vm.issueDialogParams.issueId\" ng-click=\"vm.answer()\" class=\"remove__buttons__yes\" \ntranslate=\"%translate.YES\">%translate</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/contactcenter/components/issuetracker/components/bugzilla/issueDialog/createissue.html","<div flex layout=\"column\" layout-align=\"space-between stretch\"><div flex layout=\"row\" class=\"h-80\"><md-input-container \nflex><label>{{\"ISSUE.CLASSIFICATION\" | translate}}</label><input ng-model=\"vm.issue.classification\" \nreadonly=\"readonly\" type=\"text\"></md-input-container></div><div flex layout=\"row\" class=\"h-80\"><md-input-container \nflex><label>{{\"ISSUE.PRODUCT\" | translate}}</label><md-select ng-model=\"vm.issue.product\" \nng-change=\"vm.getProductComponentsAndVersions(vm.issue.product)\"><md-option \nng-repeat=\"product in vm.products track by $index\" ng-value=\"product.name\">{{product.name}}</md-option></md-select>\n</md-input-container></div><div flex layout=\"row\" class=\"h-80\"><md-input-container flex><label>\n{{\"ISSUE.COMPONENT\" | translate}}</label><md-select ng-model=\"vm.issue.component\"><md-option \nng-repeat=\"component in vm.components\" ng-value=\"component.name\">{{component.name}}</md-option></md-select>\n</md-input-container></div><div flex layout=\"row\" class=\"h-80\"><md-input-container flex><label>\n{{\"ISSUE.VERSION\" | translate}}</label><md-select ng-model=\"vm.issue.version\"><md-option \nng-repeat=\"version in vm.versions\" ng-value=\"version.name\">{{version.name}}</md-option></md-select>\n</md-input-container></div><div flex layout=\"row\" class=\"h-80\"><md-input-container flex><label>\n{{\"ISSUE.TITLE\" | translate}}</label><input ng-model=\"vm.issue.summary\" type=\"text\"></md-input-container></div><div \nflex layout=\"row\"><md-input-container flex><label>{{\"ISSUE.DESC\" | translate}}</label><text-angular flex \nng-model=\"vm.issue.description\"></text-angular></md-input-container></div></div>");
$templateCache.put("app/main/contactcenter/components/issuetracker/components/bugzilla/issueDialog/editissue.html","<div flex layout=\"column\" layout-align=\"start stretch\" class=\"h-500\"><div flex layout=\"row\" class=\"h-80\">\n<md-input-container flex><label>{{\"ISSUE.TITLE\" | translate}}</label><input ng-model=\"vm.issue.summary\" \nng-disabled=\"true\" type=\"text\"></md-input-container></div><div flex layout=\"row\" class=\"h-80\"><md-input-container flex>\n<label>{{\"ISSUE.PRODUCT\" | translate}}</label><input ng-model=\"vm.issue.product\" ng-disabled=\"true\" type=\"text\">\n</md-input-container></div><div flex layout=\"row\" class=\"h-80\"><md-input-container flex><label>\n{{\"ISSUE.COMPONENT\" | translate}}</label><input ng-model=\"vm.issue.component\" ng-disabled=\"true\" type=\"text\">\n</md-input-container><md-input-container flex><label>{{\"ISSUE.VERSION\" | translate}}</label><input \nng-model=\"vm.issue.version\" ng-disabled=\"true\" type=\"text\"></md-input-container></div><div flex layout=\"row\" \nlayout-align=\"space-between center\" class=\"h-50\"><md-button class=\"md-button md-accent\" aria-label=\"comment mode On\" \nng-click=\"vm.commentMode = !vm.commentMode;\">{{!vm.commentMode && \"ISSUE.SHOW_COMM\" || \"ISSUE.SHOW_DESC\" | translate}}\n</md-button></div><div ng-if=\"!vm.commentMode\" flex layout=\"row\" class=\"h-100\"><md-input-container flex><label>\n{{\"ISSUE.DESC\" | translate}}</label><text-angular ng-model=\"vm.issue.description\" type=\"text\" ta-disabled=\"true\">\n</text-angular></md-input-container></div><div ng-if=\"vm.commentMode\" style=\"margin-bottom: 10px\"><attachment-list \nissue-id=\"vm.issueId\" message=\"vm.comment\" uploader=\"vm.uploader\"></attachment-list></div><div ng-if=\"vm.commentMode\" \nflex layout=\"row\" layout-align=\"space-between center\" class=\"h-50\"><md-input-container flex=\"80\" md-no-float><label>\n{{\"ISSUE.REPLY_PLACEHOLDER\" | translate}}</label><textarea msd-elastic ng-model=\"vm.comment\" aria-label=\"reply box\" \nrows=\"1\"></textarea></md-input-container><md-button class=\"md-icon-mini md-accent\" ng-disabled=\"!vm.comment\" \nng-click=\"vm.sendMessage()\" aria-label=\"button-label\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></div>\n<md-list ng-if=\"vm.commentMode\" flex layout=\"column\" layout-align=\"start stretch\" class=\"comment-content\"><md-list-item\n flex=\"100\" layout=\"row\" ng-repeat=\"comment in vm.issue.comments | orderBy:\'create\':true\" \nclass=\"md-padding message-row contact\"><img flex=\"10\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div \nflex=\"90\" class=\"bubble\"><div layout=\"row\"><div flex class=\"time secondary-text date-text\">\n{{comment.creation_time | altDate}}</div><span flex class=\"time secondary-text date-text\">{{comment.creator}}</span>\n</div><div layout=\"row\" flex layout-align=\"start start\"><i class=\"icon-message s20\"></i><div flex class=\"message\">\n{{comment.text}}</div></div></div></md-list-item></md-list></div>");
$templateCache.put("app/main/contactcenter/components/issuetracker/components/jira/issueDialog/createissue.html","<div flex layout=\"column\" layout-align=\"space-between stretch\"><div flex layout=\"row\" class=\"h-80\"><md-input-container \nflex><label>{{\"ISSUE.PROJECT\" | translate}}</label><md-select ng-model=\"vm.issue.fields.project\" \nng-change=\"vm.getIssueTypesForProject(vm.issue.fields.project.id)\"><md-option ng-repeat=\"project in vm.projects\" \nng-value=\"project\">{{project.key}}</md-option></md-select></md-input-container></div><div flex layout=\"row\" \nclass=\"h-80\"><md-input-container flex><label>{{\"ISSUE.TYPE\" | translate}}</label><md-select \nng-model=\"vm.issue.fields.issueType\"><md-option ng-repeat=\"type in vm.issueTypes\" ng-value=\"type\">{{type.name}}\n</md-option></md-select></md-input-container></div><div flex layout=\"row\" class=\"h-80\"><md-input-container flex><label>\n{{\"ISSUE.TITLE\" | translate}}</label><input ng-model=\"vm.issue.fields.summary\" type=\"text\"></md-input-container></div>\n<div flex layout=\"row\"><md-input-container flex><label>{{\"ISSUE.DESC\" | translate}}</label><text-angular flex \nng-model=\"vm.issue.fields.description\"></text-angular></md-input-container></div></div>");
$templateCache.put("app/main/contactcenter/components/issuetracker/components/jira/issueDialog/editissue.html","<div flex layout=\"column\" layout-align=\"start stretch\" class=\"h-500\"><div flex layout=\"row\" class=\"h-80\">\n<md-input-container flex><label>{{\"ISSUE.TITLE\" | translate}}</label><input ng-model=\"vm.issue.fields.summary\" \nng-disabled=\"true\" type=\"text\"></md-input-container></div><div flex layout=\"row\" class=\"h-80\"><md-input-container flex>\n<label>{{\"ISSUE.PROJECT\" | translate}}</label><input ng-model=\"vm.issue.fields.project.key\" ng-disabled=\"true\" \ntype=\"text\"></md-input-container><md-input-container flex><label>{{\"ISSUE.TYPE\" | translate}}</label><input \nng-model=\"vm.issue.fields.issuetype.name\" ng-disabled=\"true\" type=\"text\"></md-input-container></div><div flex \nlayout=\"row\" layout-align=\"space-between center\" class=\"h-50\"><md-button ng-show=\"!vm.commentMode\" \nclass=\"md-button md-accent\" aria-label=\"comment mode On\" ng-click=\"vm.commentMode = !vm.commentMode;\">\n{{\"ISSUE.SHOW_COMM\" | translate}}</md-button><md-button ng-show=\"vm.commentMode\" class=\"md-button md-accent\" \naria-label=\"comment mode On\" ng-click=\"vm.commentMode = !vm.commentMode;\">{{\"ISSUE.SHOW_DESC\" | translate}}</md-button>\n</div><div ng-if=\"!vm.commentMode\" flex layout=\"row\" class=\"h-100\"><md-input-container flex><label>\n{{\"ISSUE.DESC\" | translate}}</label><text-angular ng-model=\"vm.issue.renderedFields.description\" type=\"text\" \nta-disabled=\"true\"></text-angular></md-input-container></div><div ng-if=\"vm.commentMode\" style=\"margin-bottom: 10px\">\n<attachment-list issue-id=\"vm.issueId\" message=\"vm.comment\" uploader=\"vm.uploader\" update-message=\"vm.updateMessage()\">\n</attachment-list></div><div ng-if=\"vm.commentMode\" flex layout=\"row\" layout-align=\"space-between center\" class=\"h-50\">\n<md-input-container flex=\"80\" md-no-float><label>{{\"ISSUE.REPLY_PLACEHOLDER\" | translate}}</label><textarea \nmsd-elastic ng-model=\"vm.comment\" aria-label=\"reply box\" rows=\"1\"></textarea></md-input-container><md-button \nclass=\"md-icon-mini md-accent\" ng-disabled=\"!vm.comment\" ng-click=\"vm.sendMessage()\" aria-label=\"button-label\"><md-icon\n md-font-icon=\"icon-send\"></md-icon></md-button></div><md-list ng-if=\"vm.commentMode\" flex layout=\"column\" \nlayout-align=\"start stretch\" class=\"comment-content\"><md-list-item flex=\"100\" layout=\"row\" \nng-repeat=\"comment in vm.issue.fields.comment.comments | orderBy:\'create\':true\" class=\"md-padding message-row contact\">\n<img flex=\"10\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div flex=\"90\" class=\"bubble\"><div layout=\"row\">\n<div flex class=\"time secondary-text date-text\">{{comment.create | altDate}}</div><span flex \nclass=\"time secondary-text date-text\">{{comment.author.displayName}}</span></div><div layout=\"row\" flex \nlayout-align=\"start start\"><i class=\"icon-message s20\"></i><div flex class=\"message\">{{comment.body}}</div></div></div>\n</md-list-item></md-list></div>");
$templateCache.put("app/main/contactcenter/components/issuetracker/components/jira/issueDialog/jiraissuedialog.html","<md-dialog aria-label=\"%translate\" class=\"remove\"><md-toolbar class=\"remove__msg\"><div class=\"md-toolbar-tools\"><h2 \nclass=\"w-500\">%title</h2></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><div class=\"issueDialog\" \nng-if=\"!vm.issueDialogParams.issueId\" \nng-include=\"\'app/main/contactcenter/components/issuetracker/components/jira/issueDialog/createissue.html\'\"></div><div \nclass=\"issueDialog\" ng-if=\"vm.issueDialogParams.issueId\" \nng-include=\"\'app/main/contactcenter/components/issuetracker/components/jira/issueDialog/editissue.html\'\"></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\" class=\"remove__buttons\">\n<md-button ng-click=\"vm.cancel()\" class=\"remove__buttons__no\" translate=\"%translate.NO\">%translate</md-button>\n<md-button ng-if=\"!vm.issueDialogParams.issueId\" ng-click=\"vm.answer()\" class=\"remove__buttons__yes\" \ntranslate=\"%translate.YES\">%translate</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/contactcenter/dashboard/profilemanagement/components/issuetracker/bugzilla/bugzillaintegration.html","<div flex layout=\"column\" layout-align=\"space-between stretch\"><md-input-container flex><label>\n{{\"BUGZILLA.URL\" | translate}}</label><input ng-model=\"vm.config.serverUrl\" type=\"text\"></md-input-container>\n<md-input-container flex><label>{{\"BUGZILLA.APIKEY\" | translate}}</label><input ng-model=\"vm.config.apiKey\" \ntype=\"text\"></md-input-container></div>");
$templateCache.put("app/main/contactcenter/dashboard/profilemanagement/components/issuetracker/jira/jiracallback.html","<script type=\"text/javascript\">\n(function () {\n    \'use strict\';\n\n// Called sometime after postMessage is called\nfunction receiveMessage(event)\n{\n  // Do we trust the sender of this message?\n  // if (event.origin !== \"http://localhost:8080\")\n  //   return;\n\n  // event.source is window.opener\n  // event.data is \"hello there!\"\n\n  // Assuming you\'ve verified the origin of the received message (which\n  // you must do in any case), a convenient idiom for replying to a\n  // message is to call postMessage on event.source and provide\n  // event.origin as the targetOrigin.\n  event.source.postMessage(parseURLParams(document.URL),\n                           event.origin);\n}\n\nfunction parseURLParams(url) {\n    var queryStart = url.indexOf(\"?\") + 1,\n        queryEnd   = url.indexOf(\"#\") + 1 || url.length + 1,\n        query = url.slice(queryStart, queryEnd - 1),\n        pairs = query.replace(/\\+/g, \" \").split(\"&\"),\n        parms = {}, i, n, v, nv;\n\n    if (query === url || query === \"\") return;\n\n    for (i = 0; i < pairs.length; i++) {\n        nv = pairs[i].split(\"=\", 2);\n        n = decodeURIComponent(nv[0]);\n        v = decodeURIComponent(nv[1]);\n\n        if (!parms.hasOwnProperty(n)) parms[n] = [];\n        parms[n].push(nv.length === 2 ? v : null);\n    }\n    return parms;\n}\n\nwindow.addEventListener(\"message\", receiveMessage, false);\n  })();\n</script>");
$templateCache.put("app/main/contactcenter/dashboard/profilemanagement/components/issuetracker/jira/jiraintegration.html","<div layout=\"column\" layout-align=\"stretch space-between\" layout-fill><div \nlayout-gt-md=\"{{vm.columnOrder ? \'column\' : \'row\'}}\" layout-md=\"column\" layout-align=\"space-between stretch\" \nlayout-wrap><div ng-if=\"vm.SessionManager.getUserRoleId() === vm.authRolesConst.admin\" flex \nng-class=\"{\'mr-20\': !vm.columnOrder}\" layout=\"column\" layout-align=\"space-between stretch\"><md-input-container flex>\n<label>{{\"JIRA.URL\" | translate}}</label><input ng-model=\"vm.config.serverUrl\" type=\"text\"></md-input-container>\n<md-input-container flex><label>{{\"JIRA.PRIVATE_KEY\" | translate}}</label><input ng-model=\"vm.config.privateKey\" \ntype=\"text\"></md-input-container><md-input-container flex><label>{{\"JIRA.CONSUMER_KEY\" | translate}}</label><input \nng-model=\"vm.config.consumerKey\" type=\"text\"></md-input-container></div></div></div>");
$templateCache.put("app/main/contactcenter/dashboard/profilemanagement/components/userlist/template/useredit.html","<form name=\"Form1\" novalidate=\"novalidate\" autocomplete=\"off\"><dialog-component savefunc=\"vm.saveNewUser\" \nform-name=\"Form1\" dialog-title=\"vm.editedUser.newRecordMode ? \'USEREDIT.NEW_TITLE\':\'USEREDIT.EDIT_TITLE\'\"><header \nflex=\"100\" layout=\"column\" layout-align=\"space-between stretch\" layout-fill><md-input-container flex><md-switch \nng-model=\"vm.editedUser.isactive\" md-invert aria-label=\"IsActive\"><span translate=\"USEREDIT.ACTIVE\" \nstyle=\"color: #8f8f8f\">Aktywny</span></md-switch></md-input-container><avatar-cropper flex class=\"w-130 h-130\" \nlayout=\"row\" img-url=\"vm.editedUser.photoUrl\" file-upload-call=\"savePhoto2\" save-callback=\"vm.selectedFileChanged\" \ndude-name=\"vm.editedUser.firstName\" style=\"margin: 0 auto\"></avatar-cropper><span class=\"avatar-name text-center\">\n{{vm.editedUser.firstName + \' \' + vm.editedUser.lastName}}</span></header><content layout=\"column\" \nlayout-align=\"start stretch\" ms-scroll style=\"padding: 0\"><input type=\"text\" name=\"login\" style=\"height:0\"> <input \ntype=\"password\" name=\"password\" style=\"height:0\"><div flex layout=\"row\" layout-align=\"start center\" \nclass=\"descriptionHeader\" style=\"border-bottom: 1px solid rgba(0,0,0,.12);margin-bottom:10px\"><h3 flex \nclass=\"md-title\" translate=\"PROFILE.TITLE1\" md-truncate>Dane ogólne</h3></div><div class=\"pl-60 h-80 pr-25\" flex \nlayout=\"row\"><md-icon md-font-icon=\"icon-login\" style=\"color:#333\"></md-icon><md-input-container flex><label \ntranslate=\"USEREDIT.LOGIN\">Login</label><input ng-model=\"vm.editedUser.login\" type=\"text\" name=\"userLogin\" required \nng-disabled=\"!vm.editedUser.newRecordMode\"><div ng-messages=\"Form1.userLogin.$error\" role=\"alert\"><div \nng-message=\"required\" translate=\"USEREDIT.ERROR.REQUIRED\">Please enter a value for this field.</div></div>\n</md-input-container></div><div class=\"pl-60 h-80 pr-25\" flex layout=\"row\"><md-icon md-font-icon=\"icon-lock-outline\" \nstyle=\"color:#333\"></md-icon><md-input-container flex><label translate=\"USEREDIT.NEWPWD\">Hasło</label><input \nng-model=\"vm.editedUser.pwd\" type=\"password\" name=\"userPassword\" ng-required=\"{{vm.editedUser.newRecordMode}}\" \nautocomplete=\"off\"><div ng-messages=\"Form1.userPassword.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"USEREDIT.ERROR.REQUIRED\">Please enter a value for this field.</div></div></md-input-container></div><div \nclass=\"pl-60 h-80 pr-25\" flex layout=\"row\"><md-icon md-font-icon=\"icon-pencil\" style=\"color:#333\"></md-icon>\n<md-input-container flex><label translate=\"USEREDIT.NAME\">Imię</label><input ng-model=\"vm.editedUser.firstName\" \ntype=\"text\" required name=\"userName\"><div ng-messages=\"Form1.userName.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"USEREDIT.ERROR.REQUIRED\">Please enter a value for this field.</div></div></md-input-container></div><div \nclass=\"pl-85 h-80 pr-25\" flex layout=\"row\" style=\"color:#333\"><md-input-container flex class=\"instead-icon\"><label \ntranslate=\"USEREDIT.SURNAME\">Nazwisko</label><input ng-model=\"vm.editedUser.lastName\" type=\"text\" required \nname=\"userSurname\"><div ng-messages=\"Form1.userSurname.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"USEREDIT.ERROR.REQUIRED\">Please enter a value for this field.</div></div></md-input-container></div><div \nclass=\"pl-60 h-80 pr-25\" flex layout=\"row\" style=\"color:#333\"><md-icon md-font-icon=\"icon-email\" style=\"color:#333\">\n</md-icon><md-input-container flex><label translate=\"USEREDIT.EMAIL\">Email</label><input \nng-model=\"vm.editedUser.email\" name=\"userEmail\" required type=\"email\"><div ng-messages=\"Form1.userEmail.$error\" \nrole=\"alert\"><div ng-message=\"required\" translate=\"USEREDIT.ERROR.REQUIRED\">Please enter a value for this field.</div>\n<div ng-message=\"email\" translate=\"USEREDIT.ERROR.EMAIL\">This field must be a valid email address.</div></div>\nvm.consultantPromotion</md-input-container></div><div class=\"pl-60 h-80 pr-25\" flex layout=\"row\" style=\"color:#333\">\n<md-icon><img class=\"role-icon\" src=\"assets/icons/profilemanagement/maska.svg\" \nstyle=\"width:24px;height:24px;color:#333\"></md-icon><md-input-container flex><label translate=\"USEREDIT.ROLE\">Rola\n</label><md-select ng-model=\"vm.editedUser.roleID\" ng-change=\"vm.promotionSwitch()\" required><md-option \nng-disabled=\"true\"><em>None</em></md-option><md-option ng-repeat=\"role in vm.roleSource\" ng-value=\"role.value\" \nng-disabled=\"role.disabled\">{{role.name}}</md-option></md-select><div ng-if=\"vm.consultantPromotion\" role=\"alert\"><div \ntranslate=\"USEREDIT.PROMOTION\">Ten konsultant zostanie awansowany</div></div></md-input-container></div><div \nclass=\"pl-85 pr-25\" flex layout=\"row\" style=\"color:#333\"><md-input-container ng-if=\"vm.editedUser.newRecordMode\" flex \nclass=\"instead-icon\"><label translate=\"USEREDIT.CC\">Contact Center</label><md-select \nng-disabled=\"vm.editedUser.callCenterDisabled\" ng-model=\"vm.editedUser.callCenterID\" \nng-required=\"vm.editedUser.roleID===vm.authRolesConst.manager\"><md-option ng-disabled=\"true\"><em>None</em></md-option>\n<md-option ng-repeat=\"cc in vm.callcenters\" ng-value=\"cc.id\">{{cc.callCenterName}}</md-option></md-select>\n</md-input-container></div><settings-mailbox uid=\"vm.editedUser.id\" save-indicator=\"vm.saveMail\" resource=\"UsersRsc\" \ncolumn-order=\"true\" class=\"userListModal\"></settings-mailbox></content></dialog-component></form>");
$templateCache.put("app/main/contactcenter/dashboard/profilemanagement/components/userlist/template/userprofile.html","<main layout=\"column\" layout-align=\"center stretch\"><md-input-container flex><label translate=\"PROFILE.NAME\">Imię\n</label><input ng-disabled=\"true\" ng-model=\"vm.sidenavData.firstName\" type=\"text\"></md-input-container>\n<md-input-container flex><label translate=\"PROFILE.SURNAME\">Nazwisko</label><input ng-disabled=\"true\" \nng-model=\"vm.sidenavData.lastName\" type=\"text\"></md-input-container><md-input-container flex><label \ntranslate=\"PROFILE.ROLE\">Role</label><input ng-disabled=\"true\" ng-model=\"vm.sidenavData.role\" type=\"text\">\n</md-input-container><md-input-container flex style=\"width: 100%\"><label translate=\"PROFILE.EMAIL\">Email</label><input \nng-disabled=\"true\" ng-model=\"vm.sidenavData.email\" type=\"email\"></md-input-container></main>");
$templateCache.put("app/main/contactcenter/management/services/component/dialogs/point/point-dialog.html","<form id=\"point-dialog\" class=\"md-inline-form\" ng-cloak><md-toolbar class=\"md-accent md-hue-2\" layout-fill><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div flex=\"60\" layout=\"row\" \nlayout-align=\"end center\"><span class=\"title\" translate=\"MANAGEMENT.SERVICE.WIZ.STEPPOINT.POINTDIALOG.TITLE\">\nPunkt płatności</span></div><div flex=\"40\" layout=\"row\" layout-align=\"end start\"><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"MAIL.ASSIGN_DIALOG.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></div></md-toolbar><div layout=\"column\" class=\"p-20\" \nstyle=\"max-height: 50vh; height: 100%\"><div flex=\"100\" class=\"input-bar\" layout=\"row\" layout-fill \nlayout-align=\"space-between start\"><md-input-container flex><label translate=\"MANAGEMENT.SERVICE.WIZ.STEPPOINT.NAME\">\nNazwa</label><input ng-model=\"vm.paymentService.title\"></md-input-container></div><div flex=\"100\" class=\"input-bar\" \nlayout=\"row\" layout-fill layout-align=\"space-between start\"><md-input-container flex><label \ntranslate=\"MANAGEMENT.SERVICE.WIZ.STEPPOINT.DESC\">Opis</label><input ng-model=\"vm.paymentService.desc\">\n</md-input-container></div><div ng-if=\"vm.inserted\" flex=\"100\" class=\"input-bar\" layout=\"row\" layout-fill \nlayout-align=\"space-between start\"><md-input-container flex><label \ntranslate=\"MANAGEMENT.SERVICE.WIZ.STEPPOINT.PRICE_NET\">Netto</label><input type=\"number\" \nng-model=\"vm.paymentService.netPrice\"></md-input-container></div><div ng-if=\"vm.inserted\" flex=\"100\" class=\"input-bar\" \nlayout=\"row\" layout-fill layout-align=\"space-between start\"><md-input-container flex><label \ntranslate=\"MANAGEMENT.SERVICE.WIZ.STEPPOINT.PRICE_GROSS\">Brutto</label><input type=\"number\" \nng-model=\"vm.paymentService.grossPrice\"></md-input-container></div><div flex=\"100\" class=\"input-bar\" layout=\"row\" \nlayout-fill layout-align=\"space-between start\"><md-input-container flex><label \ntranslate=\"MANAGEMENT.SERVICE.WIZ.STEPPOINT.MINUTES\">Minuty</label><input type=\"number\" \nng-model=\"vm.paymentService.minutes\"></md-input-container></div><div flex=\"100\" class=\"input-bar\" layout=\"row\" \nlayout-fill layout-align=\"space-between start\"><md-input-container flex><md-switch \nng-model=\"vm.paymentService.requiredMsisdn\" md-invert aria-label=\"IsActive\"><span \ntranslate=\"MANAGEMENT.SERVICE.WIZ.STEPPOINT.REQUIRED_MSISDN\">Wymagany telefon</span></md-switch></md-input-container>\n</div><div flex=\"100\" class=\"input-bar\" layout=\"row\" layout-fill layout-align=\"start start\"><md-input-container flex>\n<md-switch ng-model=\"vm.paymentService.requiredEmail\" class=\"required-email\" md-invert aria-label=\"IsActive\"><span \ntranslate=\"MANAGEMENT.SERVICE.WIZ.STEPPOINT.REQUIRED_EMAIL\">Wymagany email</span></md-switch></md-input-container>\n</div></div><md-dialog-actions layout=\"row\"><div flex layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"vm.saveForm()\" aria-label=\"Save\"><img src=\"assets/icons/triple-view/zapisz.png\"></md-button></div>\n</md-dialog-actions></form>");
$templateCache.put("app/main/contactcenter/reports/components/callback/callbackagregation/callbackagregationlist/callbackagregationlist.html","<md-list-item ng-repeat=\"cb in vm.agregationList track by $index\" style=\"width: 100%; overflow: hidden\" \nng-if=\"vm.SessionManager.getUserRoleId() === vm.authRolesConst.manager || vm.SessionManager.getUserRoleId() === vm.authRolesConst.admin\">\n<p class=\"reportsList__tbody__col\">{{ cb.consultantID }}</p><p class=\"reportsList__tbody__col\" \nng-repeat=\"o in cb.value track by $index\">{{ o.orders }}</p></md-list-item><md-list-item \nng-repeat=\"cb in vm.ordersCount track by $index\" style=\"width: 100%; overflow: hidden\" \nng-if=\"vm.SessionManager.getUserRoleId() === vm.authRolesConst.consultant\" ng-show=\"$index == 0\"><p \nclass=\"reportsList__tbody__col\">{{ vm.userInfo.userId }}</p><p class=\"reportsList__tbody__col\" \nng-repeat=\"o in vm.ordersCount track by $index\">{{ o.orders }}</p></md-list-item>");
$templateCache.put("app/main/contactcenter/reports/components/callback/callbackperparams/callbackparamslist/callbackperparams.html","<div><div class=\"wrapperChart\" flex=\"100\" style=\"display: flex\"><div class=\"chart pv-20 ph-20\" flex=\"70\" \nstyle=\"border-right: 1px solid #e7e7e7\"><nvd3 class=\"h-400 remove-x-lines\" id=\"showcase-fixedcolumns\" \nconfig=\"vm.mainChart.config\" options=\"vm.mainChart.options\" data=\"vm.mainChart.data\"></nvd3></div><div \nclass=\"chart pv-20 ph-20\" flex=\"30\"><nvd3 class=\"h-400 remove-x-lines\" id=\"showcase-fixedcolumns\" \nconfig=\"vm.mainDonutChart.config\" options=\"vm.mainDonutChart.options\" data=\"vm.mainDonutChart.data\"></nvd3></div></div>\n<div><md-list class=\"report-table\"><md-list-item class=\"table-header md-2-line\"><div class=\"md-list-item-text\" \nlayout=\"row\" layout-align=\"space-between center\"><span flex=\"5\" ng-if=\"vm.showDayColumn\">\n{{ \"REPORTS.CALLBACK.AGRPERPARAM.DAY\" | translate }}</span> <span flex=\"15\">\n{{ \"REPORTS.CALLBACK.AGRPERPARAM.PARAMS\" | translate }}</span> <span flex=\"10\" \nng-repeat=\"columnLabel in vm.allOccurringDurations\">{{ columnLabel }} MIN</span></div></md-list-item><div \nclass=\"table-body\" ms-scroll><md-list-item class=\"md-2-line\" ng-repeat=\"callbackAgg in vm.callbackParamsAggregation\">\n<div class=\"md-list-item-text\" layout=\"row\" layout-align=\"space-between center\"><span flex=\"5\" \nng-if=\"vm.showDayColumn\">{{callbackAgg.day}}</span> <span flex=\"15\">\n{{callbackAgg.params != \'\' ? callbackAgg.params : \'nieprzypisany\'}}</span> <span flex=\"10\" \nng-repeat=\"item in callbackAgg.ValuesAgg track by $index\">{{item.ordersCount}} ({{item.netAmount}} zł)</span></div>\n</md-list-item></div><div ng-if=\"vm.reportPages && vm.reportPages.length>1\" class=\"paginator mt-5\" \nng-class=\"{\'report-sticky\': vm.summary.length > 1 }\" layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"vm.setPage(0);\" ng-disabled=\"vm.pageNumber == 0\">{{ \"REPORTS.PAGER.FIRST\" | translate }}</md-button>\n<md-button ng-click=\"vm.setPage(vm.pageNumber - 1);\" ng-disabled=\"vm.pageNumber == 0\">\n{{ \"REPORTS.PAGER.PREVIOUS\" | translate }}</md-button><md-button \nng-if=\"page >= vm.pageNumber -1 && page <= vm.pageNumber +1\" ng-class=\"{\'current\': vm.pageNumber == page }\" \nng-repeat=\"page in vm.reportPages\" ng-click=\"vm.setPage(page);\" ng-disabled=\"vm.pageNumber == page\">{{page + 1}}\n</md-button><md-button ng-click=\"vm.setPage(vm.pageNumber + 1);\" \nng-disabled=\"vm.pageNumber == vm.reportPages[vm.reportPages.length-1]\">{{ \"REPORTS.PAGER.NEXT\" | translate }}\n</md-button><md-button ng-click=\"vm.setPage(vm.reportPages[vm.reportPages.length-1]);\" \nng-disabled=\"vm.pageNumber == vm.reportPages[vm.reportPages.length-1]\">{{ \"REPORTS.PAGER.LAST\" | translate }}\n</md-button></div></md-list></div></div><div class=\"noData\" ng-if=\"vm.callbackParamsAggregation.length === 0\"><div \nclass=\"noData__icon\"><img src=\"assets/icons/database.svg\" alt=\"\"><p>Brak danych</p></div></div>");
$templateCache.put("app/main/contactcenter/reports/components/reportstatssms/aggregation/aggregationlist/aggregationList.html","<md-list-item class=\"contact-item md-white-bg smsAggregationList__tbody\" \nng-repeat=\"msgagr in vm.msgAggregationList track by $index\" \nng-class=\"{\'msgAggregationListAdmin\': vm.SessionManager.getUserRoleId() === vm.authRolesConst.admin}\" \nstyle=\"height: 35px; min-height:35px\"><p class=\"smsAggregationList__tbody__col\">{{ msgagr.consultantName }}</p><p \nclass=\"smsAggregationList__tbody__col\" ng-if=\"vm.SessionManager.getUserRoleId() === vm.authRolesConst.admin\">\n{{ msgagr.callCenterName }}</p><p class=\"smsAggregationList__tbody__col\">{{ msgagr.date }}</p><p \nclass=\"smsAggregationList__tbody__col\">{{ ::vm.messageType(msgagr.type) }}</p><p \nclass=\"smsAggregationList__tbody__col\">{{ msgagr.countMsg }}</p></md-list-item>");
$templateCache.put("app/main/contactcenter/management/services/component/simplewizzard/components/stepbasic/stepbasic.html","<div layout=\"column\" layout-align=\"space-around start\" flex=\"grow\"><div class=\"content\" layout=\"row\"><div flex=\"33\" \nlayout=\"column\" layout-align=\"start start\"><input style=\"display:none\" type=\"text\" id=\"serviceAvatar\" \nng-model=\"vm.service.photoUrl\" ng-change=\"vm.onUpdate()\"><md-input-container><label \ntranslate=\"MANAGEMENT.SERVICE.WIZ.STEPBASIC.SERVICE_NAME\">Nazwa Serwisu</label><input \nng-model=\"vm.service.serviceName\" debounce=\"1000\" required></md-input-container><md-input-container \nng-if=\"vm.service.type===\'E\'\"><label translate=\"MANAGEMENT.SERVICE.WIZ.STEPBASIC.SUBJECT_FILTER\">Filtry tematu</label>\n<input ng-model=\"vm.service.pattern\" debounce=\"1000\"></md-input-container><md-input-container><ta-tags \nlabel=\"MANAGEMENT.SERVICE.WIZ.STEPBASIC.TAGS\" write-mode=\"true\" ng-model=\"vm.service.tags\"></ta-tags>\n</md-input-container><div ng-if=\"vm.service.type===\'E\'\"><label class=\"custom-label\" \ntranslate=\"MANAGEMENT.SERVICE.WIZ.STEPBASIC.COLOR\">Kolor</label><ms-material-color-picker ms-model-type=\"class\" \nng-model=\"vm.service.color\"><md-button class=\"{{$selectedColor.class}}\">\n{{$selectedColor.class?$selectedColor.class:\'Wybierz kolor\'}}</md-button></ms-material-color-picker></div><div \nng-if=\"vm.service.type===\'C\'\"><md-input-container><label class=\"custom-label\" \ntranslate=\"MANAGEMENT.SERVICE.WIZ.STEPBASIC.COLOR_CHAT_MAIN\">Kolor chat głowny</label><md-select \nng-model=\"vm.service.chatMainColor\"><md-option ng-value=\"color\" ng-repeat=\"color in vm.chatAvalColors \"><div \nstyle=\"height: 20px;width: 250px\" ng-style=\"{\'background-color\':color}\"></div></md-option></md-select>\n</md-input-container><md-input-container><label class=\"custom-label\" \ntranslate=\"MANAGEMENT.SERVICE.WIZ.STEPBASIC.COLOR_CHAT_SECONDARY\">Kolor chat drugorzędny</label><md-select \nng-model=\"vm.service.chatSecondaryColor\"><md-option ng-value=\"color\" ng-repeat=\"color in vm.chatAvalColors \"><div \nstyle=\"height: 20px;width: 250px\" ng-style=\"{\'background-color\':color}\"></div></md-option></md-select>\n</md-input-container></div><md-input-container><label translate=\"MANAGEMENT.SERVICE.WIZ.STEPBASIC.DESCRIPTION\">Opis\n</label><textarea ng-model=\"vm.service.serviceDesc\" md-maxlength=\"255\"></textarea></md-input-container></div><div \nflex=\"33\"></div><div flex=\"33\" layout=\"column\" layout-align=\"start start\"><div layout=\"column\" \nlayout-align=\"start stretch\"><md-date-time-picker class=\"required\" layout=\"row\" \ndate-placeholder=\"{{\'MANAGEMENT.SERVICE.WIZ.STEPBASIC.START\' | translate}}\" layout-align=\"start center\" \ndate-model=\"vm.service.startDate\" required max-date=\"vm.service.stopDate\"></md-date-time-picker><md-date-time-picker \nclass=\"required\" layout=\"row\" date-placeholder=\"{{\'MANAGEMENT.SERVICE.WIZ.STEPBASIC.STOP\' | translate}}\" \nlayout-align=\"start center\" date-model=\"vm.service.stopDate\" required min-date=\"vm.service.startDate\">\n</md-date-time-picker><md-input-container><label class=\"custom-label\" \ntranslate=\"MANAGEMENT.SERVICE.WIZ.STEPBASIC.CHAT_BK\">Tło chatu</label><md-select \nng-model=\"vm.service.chatBackgroundURL\"><md-option ng-value=\"background.url\" \nng-repeat=\"background in vm.chatBsackground \">{{background.name}}</md-option></md-select></md-input-container><div \nstyle=\"height: 200px;background-image: url(\'{{vm.service.chatBackgroundURL}}\')\"></div></div></div></div></div>");
$templateCache.put("app/main/contactcenter/management/services/component/simplewizzard/components/stepmail/stepmail.html","<div layout=\"column\" layout-align=\"space-around start\" flex=\"grow\"><div layout=\"row\" class=\"padding-form service\" \nlayout-align=\"start center\"><avatar-letter flex-offset=\"30\" class=\"avatar\" name=\"vm.service.typename\"></avatar-letter>\n<div flex=\"95\" class=\"name\">{{vm.service.typename}}</div></div><div layout=\"column\" class=\"maillist\"><div \nlayout=\"column\"><div flex=\"100\" class=\"input-bar header-table\" layout=\"row\" layout-align=\"space-between center\"><div \nflex=\"80\" flex-offset=\"5\"><label translate=\"MANAGEMENT.SERVICE.WIZ.STEPMAIL.EMAIL_ADDRESS\">Adres email</label></div>\n<md-input-container class=\"search\" flex=\"20\" md-no-float layout=\"row\"><i class=\"fa fa-search\" aria-hidden=\"true\"></i> \n<input placeholder=\"Search for anyone\" type=\"text\" ng-model=\"vm.searchMail\" translate \ntranslate-attr-placeholder=\"TAHEADER.SEARCH\"></md-input-container></div><md-content ms-scroll \nclass=\"maillist-container scrollable-list\"><div \nng-repeat=\"item in vm.mailList | filter: vm.searchMail | orderBy: \'email\'\" ng-if=\"item.email.length>0\" \nclass=\"mail mail-item\" ng-class=\"item.id==vm.service.mailBoxId?\'selected-mail\':\'\'\" ng-click=\"vm.setMail(item)\"><div \nflex=\"100\" layout=\"row\" layout-align=\"start center\"><div flex=\"80\" flex-offset=\"5\">{{item.email}}</div><div flex=\"20\">\n</div></div></div></md-content></div></div></div>");
$templateCache.put("app/main/contactcenter/management/services/component/simplewizzard/components/stepnumber/stepnumber.html","<div layout=\"column\" layout-align=\"space-around start\" flex=\"grow\"><input pane-helper name=\"premiumNumber\" type=\"text\" \nng-model=\"vm.service.premiumNumber\" required style=\"display:none\"><div layout=\"column\" class=\"numberlist\"><div \nlayout=\"column\"><div flex=\"100\" class=\"input-bar header-table\" layout=\"row\" layout-align=\"space-between center\"><div \nflex=\"80\" flex-offset=\"5\"><label translate=\"MANAGEMENT.SERVICE.WIZ.STEPNUMBER.NUMBER_PHONE\">Numer telefonu</label>\n</div><md-input-container class=\"search\" flex=\"20\" md-no-float layout=\"row\"><i class=\"fa fa-search\" aria-hidden=\"true\">\n</i> <input placeholder=\"Search for anyone\" type=\"text\" ng-model=\"vm.searchNumber\" translate \ntranslate-attr-placeholder=\"TAHEADER.SEARCH\"></md-input-container></div><md-content ms-scroll \nclass=\"numberlist-container scrollable-list\"><div ng-repeat=\"item in vm.numberList | filter: vm.searchNumber\" \nclass=\"number number-item\" ng-class=\"{\'selected-number\': item.number==vm.service.premiumNumber }\" \nng-click=\"vm.setNumber(item)\"><div flex=\"100\" layout=\"row\" layout-align=\"start center\"><div flex=\"80\" flex-offset=\"5\">\n{{item.number}} {{item.prefix}}</div><div flex=\"20\"></div></div></div></md-content></div></div></div>");
$templateCache.put("app/main/contactcenter/management/services/component/simplewizzard/components/steptype/steptype.html","<div ng-cloak layout=\"column\" flex=\"grow\"><md-input-container><label style=\"margin-bottom: 30px\">Wybierz typ serwisu:\n</label><md-radio-group class=\"service-types\" ng-model=\"vm.service.type\" ng-change=\"vm.selectServiceType()\" \nng-disabled=\"vm.lockTypeChoose\" layout=\"row\" layout-align=\"start center\" required><md-radio-button \nng-if=\"!type.isHidden\" flex=\"33\" ng-repeat=\"type in vm.servicesType\" value=\"{{type.type}}\" class=\"service-type-btn\" \nng-class=\"{\'no-selection\': !vm.service.type , \'not-selected\': vm.service.type && vm.service.type!=type.type }\"><div \nlayout=\"column\" layout-align=\"center center\"><div><avatar-letter name=\"type.name\"></avatar-letter></div><span \nclass=\"title\">{{type.name}}</span></div></md-radio-button></md-radio-group></md-input-container></div>");
$templateCache.put("app/main/contactcenter/management/services/component/simplewizzard/components/templateconfig/templateconfig.html","<form-pane ng-repeat=\"stepConfig in vm.stepConfigs\" hide-content=\"stepConfig.disabledOnEdit && vm.service.serviceID\" \npane-icon=\"{{ stepConfig.label | wizzardicon}}\"><p-header><p translate=\"{{stepConfig.label}}\">{{stepConfig.label}}</p>\n</p-header><p-minified><p>{{stepConfig.minifiedValue}}</p></p-minified><p-content layout=\"column\" \nlayout-align=\"start stretch\"><dynamic-form flex ng-if=\"stepConfig\" form-config=\"stepConfig\" \nsettings=\"::stepConfig.notInConfig ? vm.specialFields : vm.service.slotsData\"></dynamic-form></p-content></form-pane>\n<form-pane ng-disabled=\"!vm.choosenTemplate\" pane-icon=\"/assets/icons/management/tools.svg\"><p-header><p>\nKonfiguracja Serwisu</p></p-header><p-minified></p-minified><p-content layout=\"column\" layout-align=\"start stretch\"><p \nng-if=\"vm.formConfig && vm.formConfig.length < 1\">Brak obowiązkowych pól do skonfigurowania</p><dynamic-form flex \nng-if=\"vm.formConfig\" form-config=\"vm.formConfig\" settings=\"vm.service.slotsData\"></dynamic-form></p-content>\n</form-pane><form-pane ng-if=\"vm.optionalFormConfig && vm.optionalFormConfig.length > 0\" \nng-disabled=\"!vm.choosenTemplate\" pane-icon=\"/assets/icons/management/choice.svg\"><p-header><p>Pola Opcjonalne</p>\n</p-header><p-minified></p-minified><p-content layout=\"column\" layout-align=\"start stretch\"><div layout=\"row\" \nlayout-align=\"space-around start\"><md-content flex=\"50\" ms-scroll layout=\"column\" layout-align=\"start stretch\" \nclass=\"numberlist-container scrollable-list ani-select-list\"><div ng-repeat=\"item in vm.optionalFormConfig\" \nclass=\"number number-item\" ng-class=\"{\'selected-number\': !item.hide }\" ng-click=\"vm.defaultFieldClick(item)\"><div \nflex=\"100\" layout=\"row\" layout-align=\"start center\"><div flex=\"80\" flex-offset=\"5\" translate=\"{{item.label}}\">\n{{item.label}}</div></div></div></md-content><md-divider></md-divider><md-content flex=\"50\" layout=\"column\" \nlayout-align=\"start stretch\"><dynamic-form flex ng-if=\"vm.optionalFormConfig\" form-config=\"vm.optionalFormConfig\" \nsettings=\"vm.service.slotsData\"></dynamic-form></md-content></div></p-content></form-pane>");}]);